
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
var $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $dca0ddb82b882518$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$0) {
                                control = x$0;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$1) {
                            control = x$1;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return fiber = $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1), fiber;
        case 11:
            return fiber = $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1), fiber;
        case 1:
            return fiber = $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0), fiber;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$2 = parentA.child; child$2;){
                if (child$2 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$2 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$2 = child$2.sibling;
            }
            if (!didFindChild) {
                for(child$2 = parentB.child; child$2;){
                    if (child$2 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$2 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$2 = child$2.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    fiber = nextRootInstance.nodeType;
    switch(fiber){
        case 9:
        case 11:
            nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance) : 0 : 0;
            break;
        default:
            if (fiber = 8 === fiber ? nextRootInstance.parentNode : nextRootInstance, nextRootInstance = fiber.tagName, fiber = fiber.namespaceURI) fiber = $dca0ddb82b882518$var$getOwnHostContext(fiber), nextRootInstance = $dca0ddb82b882518$var$getChildHostContextProd(fiber, nextRootInstance);
            else switch(nextRootInstance){
                case "svg":
                    nextRootInstance = 1;
                    break;
                case "math":
                    nextRootInstance = 2;
                    break;
                default:
                    nextRootInstance = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, nextRootInstance);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$onCommitRoot(root) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, root, void 0, 128 === (root.current.flags & 128));
    } catch (err) {}
}
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionLane = 128, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194176;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, warmLanes = root.warmLanes;
    root = 0 !== root.finishedLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = nonIdlePendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(warmLanes))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = pendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(warmLanes))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, warmLanes = wipLanes & -wipLanes, suspendedLanes >= warmLanes || 32 === suspendedLanes && 0 !== (warmLanes & 4194176)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
            return currentTime + 250;
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextTransitionLane() {
    var lane = $dca0ddb82b882518$var$nextTransitionLane;
    $dca0ddb82b882518$var$nextTransitionLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextTransitionLane & 4194176) && ($dca0ddb82b882518$var$nextTransitionLane = 128);
    return lane;
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194218;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node) {
    var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    node._valueTracker || (node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node));
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$283;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_418 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_418) {
            var $dca0ddb82b882518$var$element$jscomp$inline_419 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_419.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_418 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_419.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$283 = $dca0ddb82b882518$var$isSupported$jscomp$inline_418;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$283 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$283 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
function $dca0ddb82b882518$var$restoreSelection(priorSelectionInformation, containerInfo) {
    var curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(containerInfo);
    containerInfo = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== containerInfo && containerInfo && containerInfo.ownerDocument && $dca0ddb82b882518$var$containsNode(containerInfo.ownerDocument.documentElement, containerInfo)) {
        if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(containerInfo)) {
            if (priorSelectionInformation = priorSelectionRange.start, curFocusedElem = priorSelectionRange.end, void 0 === curFocusedElem && (curFocusedElem = priorSelectionInformation), "selectionStart" in containerInfo) containerInfo.selectionStart = priorSelectionInformation, containerInfo.selectionEnd = Math.min(curFocusedElem, containerInfo.value.length);
            else if (curFocusedElem = (priorSelectionInformation = containerInfo.ownerDocument || document) && priorSelectionInformation.defaultView || window, curFocusedElem.getSelection) {
                curFocusedElem = curFocusedElem.getSelection();
                var length = containerInfo.textContent.length, start = Math.min(priorSelectionRange.start, length);
                priorSelectionRange = void 0 === priorSelectionRange.end ? start : Math.min(priorSelectionRange.end, length);
                !curFocusedElem.extend && start > priorSelectionRange && (length = priorSelectionRange, priorSelectionRange = start, start = length);
                length = $dca0ddb82b882518$var$getNodeForCharacterOffset(containerInfo, start);
                var endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(containerInfo, priorSelectionRange);
                length && endMarker && (1 !== curFocusedElem.rangeCount || curFocusedElem.anchorNode !== length.node || curFocusedElem.anchorOffset !== length.offset || curFocusedElem.focusNode !== endMarker.node || curFocusedElem.focusOffset !== endMarker.offset) && (priorSelectionInformation = priorSelectionInformation.createRange(), priorSelectionInformation.setStart(length.node, length.offset), curFocusedElem.removeAllRanges(), start > priorSelectionRange ? (curFocusedElem.addRange(priorSelectionInformation), curFocusedElem.extend(endMarker.node, endMarker.offset)) : (priorSelectionInformation.setEnd(endMarker.node, endMarker.offset), curFocusedElem.addRange(priorSelectionInformation)));
            }
        }
        priorSelectionInformation = [];
        for(curFocusedElem = containerInfo; curFocusedElem = curFocusedElem.parentNode;)1 === curFocusedElem.nodeType && priorSelectionInformation.push({
            element: curFocusedElem,
            left: curFocusedElem.scrollLeft,
            top: curFocusedElem.scrollTop
        });
        "function" === typeof containerInfo.focus && containerInfo.focus();
        for(containerInfo = 0; containerInfo < priorSelectionInformation.length; containerInfo++)curFocusedElem = priorSelectionInformation[containerInfo], curFocusedElem.element.scrollLeft = curFocusedElem.left, curFocusedElem.element.scrollTop = curFocusedElem.top;
    }
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll scrollEnd toggle touchMove waiting wheel".split(" ");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    isHidden && null !== update && 3 === sourceFiber.tag && (parent = sourceFiber.stateNode, isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), parent = parent.hiddenUpdates, sourceFiber = parent[isHidden], null === sourceFiber ? parent[isHidden] = [
        update
    ] : sourceFiber.push(update), update.lane = lane | 536870912);
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {}, $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $dca0ddb82b882518$var$track(instance);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children), $dca0ddb82b882518$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 3:
        case 27:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        case 5:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var shouldClear = !1, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== fiber.tag && 27 !== fiber.tag) {
        if (JSCompiler_temp = 5 === fiber.tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && (shouldClear = !0);
    shouldClear && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === fiber.tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(shouldClear = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === shouldClear) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        shouldClear--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || shouldClear++;
                }
                fiber = fiber.nextSibling;
            }
            $dca0ddb82b882518$var$nextHydratableInstance = null;
        }
    } else $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$noop$3() {}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            if (thenableState === $dca0ddb82b882518$var$SuspenseException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    thenableState = thenable.reason;
                    if (thenableState === $dca0ddb82b882518$var$SuspenseException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
                    throw thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 33554434, lastPlacedIndex) : newIndex;
        newFiber.flags |= 33554434;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 33554434);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = fiber);
        }
    } else $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || "$!" === state.data)) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber$1.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber$1.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber$1.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber$1.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber$1.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber$1.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
var $dca0ddb82b882518$var$createFunctionComponentUpdateQueue;
$dca0ddb82b882518$var$createFunctionComponentUpdateQueue = function() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
};
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber$1;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber$1.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$54 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber$1.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber$1.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$54 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber$1, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushEffect(9, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 60) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$60) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$60);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber$1;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    currentStateHook = "object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then ? $dca0ddb82b882518$var$useThenable(currentStateHook) : currentStateHook;
    var actionQueueHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), actionQueue = actionQueueHook.queue, dispatch = actionQueue.dispatch;
    action !== actionQueueHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber$1.flags |= 2048, $dca0ddb82b882518$var$pushEffect(9, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), {
        destroy: void 0
    }, null));
    return [
        currentStateHook,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushEffect(tag, create, inst, deps) {
    tag = {
        tag: tag,
        create: create,
        inst: inst,
        deps: deps,
        next: null
    };
    create = $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue;
    null === create && (create = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue = create);
    inst = create.lastEffect;
    null === inst ? create.lastEffect = tag.next = tag : (deps = inst.next, inst.next = tag, tag.next = deps, create.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber$1.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushEffect(1 | hookFlags, create, {
        destroy: void 0
    }, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushEffect(hookFlags, create, inst, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber$1.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushEffect(1 | hookFlags, create, inst, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber$1.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber$1.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop$2() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop$2 : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$63 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$63 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$63, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$63, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber$1 || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber$1;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194176)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useCacheRefresh = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useMemoCache = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useHostTransitionStatus = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useFormState = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useActionState = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useOptimistic = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber$1, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 60) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushEffect(9, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = ":" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += ":";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = ":" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + ":";
        return hook.memoizedState = identifierPrefix;
    },
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1);
    }
};
$dca0ddb82b882518$var$HooksDispatcherOnMount.useMemoCache = $dca0ddb82b882518$var$useMemoCache;
$dca0ddb82b882518$var$HooksDispatcherOnMount.useHostTransitionStatus = $dca0ddb82b882518$var$useHostTransitionStatus;
$dca0ddb82b882518$var$HooksDispatcherOnMount.useFormState = $dca0ddb82b882518$var$mountActionState;
$dca0ddb82b882518$var$HooksDispatcherOnMount.useActionState = $dca0ddb82b882518$var$mountActionState;
$dca0ddb82b882518$var$HooksDispatcherOnMount.useOptimistic = function(passthrough) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    hook.memoizedState = hook.baseState = passthrough;
    var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
    };
    hook.queue = queue;
    hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, !0, queue);
    queue.dispatch = hook;
    return [
        passthrough,
        hook
    ];
};
var $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useCacheRefresh = $dca0ddb82b882518$var$updateRefresh;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useMemoCache = $dca0ddb82b882518$var$useMemoCache;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useHostTransitionStatus = $dca0ddb82b882518$var$useHostTransitionStatus;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useFormState = $dca0ddb82b882518$var$updateActionState;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useActionState = $dca0ddb82b882518$var$updateActionState;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useOptimistic = function(passthrough, reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
};
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useCacheRefresh = $dca0ddb82b882518$var$updateRefresh;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useMemoCache = $dca0ddb82b882518$var$useMemoCache;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useHostTransitionStatus = $dca0ddb82b882518$var$useHostTransitionStatus;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useFormState = $dca0ddb82b882518$var$rerenderActionState;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useActionState = $dca0ddb82b882518$var$rerenderActionState;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useOptimistic = function(passthrough, reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    hook.baseState = passthrough;
    return [
        passthrough,
        hook.queue.dispatch
    ];
};
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    isMounted: function(component) {
        return (component = component._reactInternals) ? $dca0ddb82b882518$var$getNearestMountedFiber(component) === component : !1;
    },
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$67 in Component)void 0 === newProps[propName$67] && (newProps[propName$67] = Component[propName$67]);
    }
    return newProps;
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $hPtJY && "function" === typeof $hPtJY.emit) {
        $hPtJY.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$68) {
        setTimeout(function() {
            throw e$68;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$69) {
        setTimeout(function() {
            throw e$69;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, nextIsDetached = 0 !== (workInProgress.stateNode._pendingVisibility & 2), prevState = null !== current ? current.memoizedState : null;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    if ("hidden" === nextProps.mode || nextIsDetached) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(nextIsDetached = 0; null !== nextChildren;)nextIsDetached = nextIsDetached | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = nextIsDetached & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 2097664);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 2097664;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($dca0ddb82b882518$var$isHydrating) {
                var nextInstance = $dca0ddb82b882518$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                            id: $dca0ddb82b882518$var$treeContextId,
                            overflow: $dca0ddb82b882518$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912
                    }, JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return "$!" === nextInstance.data ? workInProgress.lanes = 16 : workInProgress.lanes = 536870912, null;
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), "$!" === nextInstance.data) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp) {
                nextProps = renderLanes & -renderLanes;
                if (0 !== (nextProps & 42)) nextProps = 1;
                else switch(nextProps){
                    case 2:
                        nextProps = 1;
                        break;
                    case 8:
                        nextProps = 4;
                        break;
                    case 32:
                        nextProps = 16;
                        break;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        nextProps = 64;
                        break;
                    case 268435456:
                        nextProps = 134217728;
                        break;
                    default:
                        nextProps = 0;
                }
                nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps;
                if (0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            }
            "$?" === nextInstance.data || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 128, workInProgress.child = current.child, workInProgress = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, current), nextInstance._reactRetry = workInProgress, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextInstance.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && ($dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider, $dca0ddb82b882518$var$treeContextId = current.id, $dca0ddb82b882518$var$treeContextOverflow = current.overflow, $dca0ddb82b882518$var$treeContextProvider = workInProgress), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 31457280, null !== digest ? showFallback = $dca0ddb82b882518$var$createWorkInProgress(digest, showFallback) : (showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $dca0ddb82b882518$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    return $dca0ddb82b882518$var$createFiberFromOffscreen(offscreenProps, mode, 0, null);
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $dca0ddb82b882518$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $dca0ddb82b882518$var$shouldConstruct(lazyComponent) ? (current = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                var nextProps = workInProgress.pendingProps;
                init = workInProgress.memoizedState;
                lazyComponent = init.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                nextProps = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, nextProps);
                nextProps !== init.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                nextProps = nextState.element;
                if (init.isDehydrated) {
                    if (init = {
                        element: nextProps,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = init, workInProgress.memoizedState = init, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else if (nextProps !== lazyComponent) {
                        lazyComponent = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError(lazyComponent);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else for($dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(workInProgress.stateNode.containerInfo.firstChild), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !0, renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextProps, renderLanes), workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (nextProps === lazyComponent) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, lazyComponent[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(lazyComponent, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (lazyComponent = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild)), lazyComponent = workInProgress.pendingProps.children, null !== current || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes) : workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (init = lazyComponent = $dca0ddb82b882518$var$nextHydratableInstance) lazyComponent = $dca0ddb82b882518$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            nextProps = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = nextProps.children;
            $dca0ddb82b882518$var$shouldSetTextContent(init, nextProps) ? lazyComponent = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = init);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), init = $dca0ddb82b882518$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), lazyComponent = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? (init = $dca0ddb82b882518$var$peekCacheFromPool(), null === init && (init = $dca0ddb82b882518$var$workInProgressRoot, nextProps = $dca0ddb82b882518$var$createCache(), init.pooledCache = nextProps, nextProps.refCount++, null !== nextProps && (init.pooledCacheLanes |= renderLanes), init = nextProps), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, nextProps = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent)) : (lazyComponent = nextProps.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194176))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0;
                        try {
                            destroy();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            var instance = current.stateNode;
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = instance;
                    break;
                default:
                    instanceToUse = instance;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$112) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$112);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 27 !== fiber.tag && 18 !== fiber.tag;){
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? 8 === parent.nodeType ? parent.parentNode.insertBefore(node, before) : parent.insertBefore(node, before) : (8 === parent.nodeType ? (before = parent.parentNode, before.insertBefore(node, parent)) : (before = parent, before.appendChild(node)), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null, $dca0ddb82b882518$var$shouldFireAfterActiveInstanceBlur = !1;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
    resolvedPrevProps = $dca0ddb82b882518$var$shouldFireAfterActiveInstanceBlur;
    $dca0ddb82b882518$var$shouldFireAfterActiveInstanceBlur = !1;
    return resolvedPrevProps;
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$111) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$111);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                finishedRoot = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        finishedRoot = finishedWork.child.stateNode;
                        break;
                    case 1:
                        finishedRoot = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(flags, finishedRoot);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 26:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 22:
            prevProps = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!prevProps) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                var prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            flags & 512 && ("manual" === finishedWork.memoizedProps.mode ? $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return) : $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber = deletedFiber.stateNode;
            for(nearestMountedAncestor = deletedFiber.attributes; nearestMountedAncestor.length;)deletedFiber.removeAttributeNode(nearestMountedAncestor[0]);
            $dca0ddb82b882518$var$detachDeletedInstance(deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParent;
            var prevHostParentIsContainer$119 = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParentIsContainer;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer$119;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    finishedRoot = $dca0ddb82b882518$var$hostParent, prevHostParent = deletedFiber.stateNode, 8 === finishedRoot.nodeType ? finishedRoot.parentNode.removeChild(prevHostParent) : finishedRoot.removeChild(prevHostParent);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (nearestMountedAncestor = $dca0ddb82b882518$var$hostParent, deletedFiber = deletedFiber.stateNode, 8 === nearestMountedAncestor.nodeType ? $dca0ddb82b882518$var$clearSuspenseBoundary(nearestMountedAncestor.parentNode, deletedFiber) : 1 === nearestMountedAncestor.nodeType && $dca0ddb82b882518$var$clearSuspenseBoundary(nearestMountedAncestor, deletedFiber), $dca0ddb82b882518$var$retryIfBlockedOn(nearestMountedAncestor)) : $dca0ddb82b882518$var$clearSuspenseBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            if (flags & 4 && null === finishedWork.alternate) {
                hoistableRoot = finishedWork.stateNode;
                currentResource = finishedWork.memoizedProps;
                try {
                    for(var node = hoistableRoot.firstChild; node;){
                        var nextNode = node.nextSibling, nodeName = node.nodeName;
                        node[$dca0ddb82b882518$var$internalHoistableMarker] || "HEAD" === nodeName || "BODY" === nodeName || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node.rel.toLowerCase() || hoistableRoot.removeChild(node);
                        node = nextNode;
                    }
                    for(var type = finishedWork.type, attributes = hoistableRoot.attributes; attributes.length;)hoistableRoot.removeAttributeNode(attributes[0]);
                    $dca0ddb82b882518$var$setInitialProperties(hoistableRoot, type, currentResource);
                    hoistableRoot[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                    hoistableRoot[$dca0ddb82b882518$var$internalPropsKey] = currentResource;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            node = null !== finishedWork.memoizedState;
            nextNode = null !== current && null !== current.memoizedState;
            nodeName = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            type = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = nodeName || node;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = type || nextNode;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = type;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = nodeName;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            root = finishedWork.stateNode;
            root._current = finishedWork;
            root._visibility &= -3;
            root._visibility |= root._pendingVisibility & 2;
            if (flags & 8192 && (root._visibility = node ? root._visibility & -2 : root._visibility | 1, node && (root = $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden, null === current || nextNode || root || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), null === finishedWork.memoizedProps || "manual" !== finishedWork.memoizedProps.mode)) a: for(current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag || 27 === root.tag) {
                    if (null === current) {
                        nextNode = current = root;
                        try {
                            if (hoistableRoot = nextNode.stateNode, node) currentResource = hoistableRoot.style, "function" === typeof currentResource.setProperty ? currentResource.setProperty("display", "none", "important") : currentResource.display = "none";
                            else {
                                maybeNodes = nextNode.stateNode;
                                i = nextNode.memoizedProps.style;
                                var display = void 0 !== i && null !== i && i.hasOwnProperty("display") ? i.display : null;
                                maybeNodes.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        nextNode = root;
                        try {
                            nextNode.stateNode.nodeValue = node ? "" : nextNode.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            if (27 !== finishedWork.tag) {
                a: {
                    for(var parent = finishedWork.return; null !== parent;){
                        if ($dca0ddb82b882518$var$isHostParent(parent)) {
                            var JSCompiler_inline_result = parent;
                            break a;
                        }
                        parent = parent.return;
                    }
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
                }
                switch(JSCompiler_inline_result.tag){
                    case 27:
                        var parent$jscomp$0 = JSCompiler_inline_result.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                        $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0);
                        break;
                    case 5:
                        var parent$113 = JSCompiler_inline_result.stateNode;
                        JSCompiler_inline_result.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$113, ""), JSCompiler_inline_result.flags &= -33);
                        var before$114 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                        $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$114, parent$113);
                        break;
                    case 3:
                    case 4:
                        var parent$115 = JSCompiler_inline_result.stateNode.containerInfo, before$116 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                        $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$116, parent$115);
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
                }
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 26:
            case 27:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 26:
            case 27:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 4 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 4 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 4, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 4 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 4, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource($dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 4 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -5, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 4 && (i._visibility &= -5, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 31457280;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 31457282;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_OFFSCREEN_TYPE:
            return $dca0ddb82b882518$var$createFiberFromOffscreen(pendingProps, mode, lanes, key);
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_PROVIDER_TYPE:
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromOffscreen(pendingProps, mode, lanes, key) {
    pendingProps = $dca0ddb82b882518$var$createFiberImplClass(22, pendingProps, key, mode);
    pendingProps.elementType = $dca0ddb82b882518$var$REACT_OFFSCREEN_TYPE;
    pendingProps.lanes = lanes;
    var primaryChildInstance = {
        _visibility: 1,
        _pendingVisibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null,
        _current: null,
        detach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(456));
            if (0 === (primaryChildInstance._pendingVisibility & 2)) {
                var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility |= 2, $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        },
        attach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(456));
            if (0 !== (primaryChildInstance._pendingVisibility & 2)) {
                var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility &= -3, $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        }
    };
    pendingProps.stateNode = primaryChildInstance;
    return pendingProps;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        resource = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194176) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null !== $dca0ddb82b882518$var$shellBoundary : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || resource !== $dca0ddb82b882518$var$shellBoundary)) throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$131 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$131 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$131 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$131.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags & 31457280, subtreeFlags |= child$132.flags & 31457280, child$132.return = completedWork, child$132 = child$132.sibling;
    else for(child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags, subtreeFlags |= child$132.flags, child$132.return = completedWork, child$132 = child$132.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, null !== $dca0ddb82b882518$var$hydrationErrors && ($dca0ddb82b882518$var$queueRecoverableErrors($dca0ddb82b882518$var$hydrationErrors), $dca0ddb82b882518$var$hydrationErrors = null));
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== renderLanes ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else null !== $dca0ddb82b882518$var$hydrationErrors && ($dca0ddb82b882518$var$queueRecoverableErrors($dca0ddb82b882518$var$hydrationErrors), $dca0ddb82b882518$var$hydrationErrors = null), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$144 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$144 = newProps.memoizedState.cachePool.pool);
                cache$144 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$144 = type.rendering;
            if (null === cache$144) {
                if (newProps) $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$144 = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== cache$144) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                            current = cache$144.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(cache$144), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$144.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - type.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$144.sibling = workInProgress.child, workInProgress.child = cache$144) : (current = type.last, null !== current ? current.sibling = cache$144 : workInProgress.child = cache$144, type.last = cache$144);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $dca0ddb82b882518$var$now(), workInProgress.sibling = null, current = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$rootDoesHavePassiveEffects = !1, $dca0ddb82b882518$var$rootWithPendingPassiveEffects = null, $dca0ddb82b882518$var$pendingPassiveEffectsLanes = 0, $dca0ddb82b882518$var$pendingPassiveEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes) return $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes;
    if (null !== $dca0ddb82b882518$var$ReactSharedInternals.T) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $dca0ddb82b882518$var$requestTransitionLane();
    }
    return $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    0 === $dca0ddb82b882518$var$workInProgressDeferredLane && ($dca0ddb82b882518$var$workInProgressDeferredLane = 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && 2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 60) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else if (6 === exitStatus) $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
        else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && $dca0ddb82b882518$var$queueRecoverableErrors(renderWasConcurrent);
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                switch(exitStatus){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194176) === lanes) {
                            $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        }
                        break;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                shouldTimeSlice.finishedWork = forceSync;
                shouldTimeSlice.finishedLanes = lanes;
                if ((lanes & 62914560) === lanes && (renderWasConcurrent = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < renderWasConcurrent)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0)) break a;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, 2, -0, 0), renderWasConcurrent);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$queueRecoverableErrors(errors) {
    null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = errors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, errors);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var subtreeFlags = finishedWork.subtreeFlags;
    if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if ($dca0ddb82b882518$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $dca0ddb82b882518$var$noop
        }, $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork), finishedWork = $dca0ddb82b882518$var$waitForCommitToBeReady(), null !== finishedWork) {
            root.cancelPendingCommit = finishedWork($dca0ddb82b882518$var$commitRoot.bind(null, root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, 1, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    root.finishedWork = null;
    root.finishedLanes = 0;
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194176) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$164) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$164);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 === $dca0ddb82b882518$var$workInProgressSuspendedReason && $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : 1) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrent();
        break;
    } catch (thrownValue$166) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$166);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrent() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousUpdateLanePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$ReactSharedInternals.T = null, $dca0ddb82b882518$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, previousUpdateLanePriority, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    } finally{
        $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousUpdateLanePriority;
    }
}
function $dca0ddb82b882518$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, renderPriorityLevel, spawnedLane, updatedLanes, suspendedRetryLanes) {
    do $dca0ddb82b882518$var$flushPassiveEffects();
    while (null !== $dca0ddb82b882518$var$rootWithPendingPassiveEffects);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var finishedWork = root.finishedWork;
    didIncludeRenderPhaseUpdate = root.finishedLanes;
    if (null === finishedWork) return null;
    root.finishedWork = null;
    root.finishedLanes = 0;
    if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
    root.callbackNode = null;
    root.callbackPriority = 0;
    root.cancelPendingCommit = null;
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    remainingLanes |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
    $dca0ddb82b882518$var$markRootFinished(root, didIncludeRenderPhaseUpdate, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
    0 === (finishedWork.subtreeFlags & 10256) && 0 === (finishedWork.flags & 10256) || $dca0ddb82b882518$var$rootDoesHavePassiveEffects || ($dca0ddb82b882518$var$rootDoesHavePassiveEffects = !0, $dca0ddb82b882518$var$pendingPassiveEffectsRemainingLanes = remainingLanes, $dca0ddb82b882518$var$pendingPassiveTransitions = transitions, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
        $dca0ddb82b882518$var$flushPassiveEffects(!0);
        return null;
    }));
    transitions = 0 !== (finishedWork.flags & 15990);
    0 !== (finishedWork.subtreeFlags & 15990) || transitions ? (transitions = $dca0ddb82b882518$var$ReactSharedInternals.T, $dca0ddb82b882518$var$ReactSharedInternals.T = null, spawnedLane = $dca0ddb82b882518$var$ReactDOMSharedInternals.p, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, updatedLanes = $dca0ddb82b882518$var$executionContext, $dca0ddb82b882518$var$executionContext |= 4, $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root), $dca0ddb82b882518$var$restoreSelection($dca0ddb82b882518$var$selectionInformation, root.containerInfo), $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled, $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null, root.current = finishedWork, $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork), $dca0ddb82b882518$var$requestPaint(), $dca0ddb82b882518$var$executionContext = updatedLanes, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = spawnedLane, $dca0ddb82b882518$var$ReactSharedInternals.T = transitions) : root.current = finishedWork;
    $dca0ddb82b882518$var$rootDoesHavePassiveEffects ? ($dca0ddb82b882518$var$rootDoesHavePassiveEffects = !1, $dca0ddb82b882518$var$rootWithPendingPassiveEffects = root, $dca0ddb82b882518$var$pendingPassiveEffectsLanes = didIncludeRenderPhaseUpdate) : $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    remainingLanes = root.pendingLanes;
    0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
    $dca0ddb82b882518$var$onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
    if (null !== recoverableErrors) for(renderPriorityLevel = root.onRecoverableError, finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++)remainingLanes = recoverableErrors[finishedWork], renderPriorityLevel(remainingLanes.value, {
        componentStack: remainingLanes.stack
    });
    0 !== ($dca0ddb82b882518$var$pendingPassiveEffectsLanes & 3) && $dca0ddb82b882518$var$flushPassiveEffects();
    remainingLanes = root.pendingLanes;
    0 !== (didIncludeRenderPhaseUpdate & 4194218) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
    $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    return null;
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (null !== $dca0ddb82b882518$var$rootWithPendingPassiveEffects) {
        var root$170 = $dca0ddb82b882518$var$rootWithPendingPassiveEffects, remainingLanes = $dca0ddb82b882518$var$pendingPassiveEffectsRemainingLanes;
        $dca0ddb82b882518$var$pendingPassiveEffectsRemainingLanes = 0;
        var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingPassiveEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
        try {
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            if (null === $dca0ddb82b882518$var$rootWithPendingPassiveEffects) var JSCompiler_inline_result = !1;
            else {
                renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
                $dca0ddb82b882518$var$pendingPassiveTransitions = null;
                var root = $dca0ddb82b882518$var$rootWithPendingPassiveEffects, lanes = $dca0ddb82b882518$var$pendingPassiveEffectsLanes;
                $dca0ddb82b882518$var$rootWithPendingPassiveEffects = null;
                $dca0ddb82b882518$var$pendingPassiveEffectsLanes = 0;
                if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
                var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
                $dca0ddb82b882518$var$executionContext |= 4;
                $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root.current);
                $dca0ddb82b882518$var$commitPassiveMountOnFiber(root, root.current, lanes, renderPriority);
                $dca0ddb82b882518$var$executionContext = prevExecutionContext;
                $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
                if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
                    $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root);
                } catch (err) {}
                JSCompiler_inline_result = !0;
            }
            return JSCompiler_inline_result;
        } finally{
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root$170, remainingLanes);
        }
    }
    return !1;
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateTask($dca0ddb82b882518$var$processRootScheduleInMicrotask));
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$172 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$172;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$172.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$172.suspendedLanes, pingedLanes = root$172.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326677 ? JSCompiler_inline_result & 201326677 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$172, root$172 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$172, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                }
                root$172 = root$172.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane), $dca0ddb82b882518$var$currentEventTransitionLane = 0);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && 2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPassiveEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPassiveEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateTask(cb) {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, cb) : cb();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    0 === $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = $dca0ddb82b882518$var$claimNextTransitionLane());
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1439 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1439 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1439++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1440 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1439], $dca0ddb82b882518$var$domEventName$jscomp$inline_1441 = $dca0ddb82b882518$var$eventName$jscomp$inline_1440.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1442 = $dca0ddb82b882518$var$eventName$jscomp$inline_1440[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1440.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1441, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1442);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer || 8 === container.nodeType && container.parentNode === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if (3 === grandTag || 4 === grandTag) {
                    if (grandTag = nodeTag.stateNode.containerInfo, grandTag === targetContainer || 8 === grandTag.nodeType && grandTag.parentNode === targetContainer) return;
                }
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $dca0ddb82b882518$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $dca0ddb82b882518$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $dca0ddb82b882518$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase);
                                reactEventName = $dca0ddb82b882518$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        targetFiber = targetFiber.return;
    }
    return listeners;
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$noop$1() {}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$186 = props[hasSrc];
                if (null != propValue$186) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$186;
                        break;
                    case "type":
                        propValue = propValue$186;
                        break;
                    case "checked":
                        checked = propValue$186;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$186;
                        break;
                    case "value":
                        propKey = propValue$186;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$186;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$186) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$186, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$186 in props)props.hasOwnProperty(propValue$186) && (hasSrc = props[propValue$186], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$186, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$203 in nextProps){
                var propKey = nextProps[propKey$203];
                lastProp = lastProps[propKey$203];
                if (nextProps.hasOwnProperty(propKey$203) && (null != propKey || null != lastProp)) switch(propKey$203){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$203, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$203 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$203 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$203 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$203, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$203 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$203 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$203, propKey);
            return;
        case "option":
            for(var propKey$219 in lastProps)if (propKey$203 = lastProps[propKey$219], lastProps.hasOwnProperty(propKey$219) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$219)) switch(propKey$219){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$219, null, nextProps, propKey$203);
            }
            for(lastDefaultValue in nextProps)if (propKey$203 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$203 && "function" !== typeof propKey$203 && "symbol" !== typeof propKey$203;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$203, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$224 in lastProps)propKey$203 = lastProps[propKey$224], lastProps.hasOwnProperty(propKey$224) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$224) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$224, null, nextProps, propKey$203);
            for(checked in nextProps)if (propKey$203 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$203) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$203, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$229 in lastProps)propKey$203 = lastProps[propKey$229], lastProps.hasOwnProperty(propKey$229) && void 0 !== propKey$203 && !nextProps.hasOwnProperty(propKey$229) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$229, void 0, nextProps, propKey$203);
                for(defaultChecked in nextProps)propKey$203 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$203 === propKey || void 0 === propKey$203 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$203, nextProps, propKey);
                return;
            }
    }
    for(var propKey$234 in lastProps)propKey$203 = lastProps[propKey$234], lastProps.hasOwnProperty(propKey$234) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$234) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$234, null, nextProps, propKey$203);
    for(lastProp in nextProps)propKey$203 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$203 === propKey || null == propKey$203 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$203, nextProps, propKey);
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" !== node && "$?" !== node && "$!" !== node || depth++;
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
function $dca0ddb82b882518$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$242 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$243 = styles$242.get(type);
                resource$243 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$243 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$242.set(type, resource$243), (styles$242 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$242._p && (resource$243.instance = styles$242, resource$243.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$242 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$243.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$243;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$248 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$248) return resource.state.loading |= 4, resource.instance = instance$248, $dca0ddb82b882518$var$markNodeAsHoistable(instance$248), instance$248;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$248 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$248);
            var linkInstance = instance$248;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$248, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$248, props.precedence, hoistableRoot);
            return resource.instance = instance$248;
        case "script":
            instance$248 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$248))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$248)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $dca0ddb82b882518$var$suspendedState = null;
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $dca0ddb82b882518$var$waitForCommitToBeReady() {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $dca0ddb82b882518$var$requestUpdateLane(), root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        0 === root.tag && $dca0ddb82b882518$var$flushPassiveEffects();
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1686 = $acw62.version;
if ("19.0.0" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1686) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1686, "19.0.0"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2165 = {
    bundleType: 0,
    version: "19.0.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    findFiberByHostInstance: $dca0ddb82b882518$var$getClosestInstanceFromNode,
    reconcilerVersion: "19.0.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2166 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2166.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2166.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2166.inject($dca0ddb82b882518$var$internals$jscomp$inline_2165), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2166;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(8 === container.nodeType ? container.parentNode : container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    initialChildren.current.lanes = isStrictMode;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, isStrictMode);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $11c56e2ffb2d6006$export$8352ce38b91d0c62, (v) => $11c56e2ffb2d6006$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $11c56e2ffb2d6006$export$839f9183b0465a69, (v) => $11c56e2ffb2d6006$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $11c56e2ffb2d6006$export$4b844e58a3e414b4, (v) => $11c56e2ffb2d6006$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$8352ce38b91d0c62;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$839f9183b0465a69;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$4b844e58a3e414b4;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$requestHostCallback();
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostCallback() {
    $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
}
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$8352ce38b91d0c62 = function() {
    $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$requestHostCallback());
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$839f9183b0465a69 = function() {
    return $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$4b844e58a3e414b4 = function() {};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$requestHostCallback()));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "act", () => $72b03fdf46effee2$export$3ba232387fd5d6dd, (v) => $72b03fdf46effee2$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$3ba232387fd5d6dd;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray, $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$noop$1() {}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop$1, $72b03fdf46effee2$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $hPtJY && "function" === typeof $hPtJY.emit) {
        $hPtJY.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $72b03fdf46effee2$var$noop() {}
$72b03fdf46effee2$export$dca3b0875bd9a954 = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$3ba232387fd5d6dd = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, void 0, void 0, null, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.0.0";

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.0.0";

});



var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));


var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
function $a73ce425265b079e$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $a73ce425265b079e$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $a73ce425265b079e$var$_arrayLikeToArray$2(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $a73ce425265b079e$var$_unsupportedIterableToArray$2(r, a) {
    if (r) {
        if ("string" == typeof r) return $a73ce425265b079e$var$_arrayLikeToArray$2(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a73ce425265b079e$var$_arrayLikeToArray$2(r, a) : void 0;
    }
}
function $a73ce425265b079e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a73ce425265b079e$var$_slicedToArray(r, e) {
    return $a73ce425265b079e$var$_arrayWithHoles(r) || $a73ce425265b079e$var$_iterableToArrayLimit(r, e) || $a73ce425265b079e$var$_unsupportedIterableToArray$2(r, e) || $a73ce425265b079e$var$_nonIterableRest();
}
function $a73ce425265b079e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a73ce425265b079e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a73ce425265b079e$var$_typeof(o);
}
function $a73ce425265b079e$export$ce4ab0c55987d1ff() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (args) {
        var classes = [];
        for(var i = 0; i < args.length; i++){
            var className = args[i];
            if (!className) continue;
            var type = $a73ce425265b079e$var$_typeof(className);
            if (type === 'string' || type === 'number') classes.push(className);
            else if (type === 'object') {
                var _classes = Array.isArray(className) ? className : Object.entries(className).map(function(_ref) {
                    var _ref2 = $a73ce425265b079e$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                    return value ? key : null;
                });
                classes = _classes.length ? classes.concat(_classes.filter(function(c) {
                    return !!c;
                })) : classes;
            }
        }
        return classes.join(' ').trim();
    }
    return undefined;
}
function $a73ce425265b079e$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $a73ce425265b079e$var$_arrayLikeToArray$2(r);
}
function $a73ce425265b079e$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $a73ce425265b079e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a73ce425265b079e$var$_toConsumableArray(r) {
    return $a73ce425265b079e$var$_arrayWithoutHoles(r) || $a73ce425265b079e$var$_iterableToArray(r) || $a73ce425265b079e$var$_unsupportedIterableToArray$2(r) || $a73ce425265b079e$var$_nonIterableSpread();
}
function $a73ce425265b079e$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $a73ce425265b079e$var$toPrimitive(t, r) {
    if ("object" != $a73ce425265b079e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a73ce425265b079e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a73ce425265b079e$var$toPropertyKey(t) {
    var i = $a73ce425265b079e$var$toPrimitive(t, "string");
    return "symbol" == $a73ce425265b079e$var$_typeof(i) ? i : i + "";
}
function $a73ce425265b079e$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $a73ce425265b079e$var$toPropertyKey(o.key), o);
    }
}
function $a73ce425265b079e$var$_createClass(e, r, t) {
    return r && $a73ce425265b079e$var$_defineProperties(e.prototype, r), t && $a73ce425265b079e$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $a73ce425265b079e$var$_defineProperty(e, r, t) {
    return (r = $a73ce425265b079e$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a73ce425265b079e$var$_createForOfIteratorHelper$1(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $a73ce425265b079e$var$_unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $a73ce425265b079e$var$_unsupportedIterableToArray$1(r, a) {
    if (r) {
        if ("string" == typeof r) return $a73ce425265b079e$var$_arrayLikeToArray$1(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a73ce425265b079e$var$_arrayLikeToArray$1(r, a) : void 0;
    }
}
function $a73ce425265b079e$var$_arrayLikeToArray$1(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $a73ce425265b079e$export$ff8ccbac9225de62 = /*#__PURE__*/ function() {
    function DomHandler() {
        $a73ce425265b079e$var$_classCallCheck(this, DomHandler);
    }
    return $a73ce425265b079e$var$_createClass(DomHandler, null, [
        {
            key: "innerWidth",
            value: function innerWidth(el) {
                if (el) {
                    var width = el.offsetWidth;
                    var style = getComputedStyle(el);
                    width = width + (parseFloat(style.paddingLeft) + parseFloat(style.paddingRight));
                    return width;
                }
                return 0;
            }
        },
        {
            key: "width",
            value: function width(el) {
                if (el) {
                    var _width = el.offsetWidth;
                    var style = getComputedStyle(el);
                    _width = _width - (parseFloat(style.paddingLeft) + parseFloat(style.paddingRight));
                    return _width;
                }
                return 0;
            }
        },
        {
            key: "getBrowserLanguage",
            value: function getBrowserLanguage() {
                return navigator.userLanguage || navigator.languages && navigator.languages.length && navigator.languages[0] || navigator.language || navigator.browserLanguage || navigator.systemLanguage || 'en';
            }
        },
        {
            key: "getWindowScrollTop",
            value: function getWindowScrollTop() {
                var doc = document.documentElement;
                return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
            }
        },
        {
            key: "getWindowScrollLeft",
            value: function getWindowScrollLeft() {
                var doc = document.documentElement;
                return (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
            }
        },
        {
            key: "getOuterWidth",
            value: function getOuterWidth(el, margin) {
                if (el) {
                    var width = el.getBoundingClientRect().width || el.offsetWidth;
                    if (margin) {
                        var style = getComputedStyle(el);
                        width = width + (parseFloat(style.marginLeft) + parseFloat(style.marginRight));
                    }
                    return width;
                }
                return 0;
            }
        },
        {
            key: "getOuterHeight",
            value: function getOuterHeight(el, margin) {
                if (el) {
                    var height = el.getBoundingClientRect().height || el.offsetHeight;
                    if (margin) {
                        var style = getComputedStyle(el);
                        height = height + (parseFloat(style.marginTop) + parseFloat(style.marginBottom));
                    }
                    return height;
                }
                return 0;
            }
        },
        {
            key: "getClientHeight",
            value: function getClientHeight(el, margin) {
                if (el) {
                    var height = el.clientHeight;
                    if (margin) {
                        var style = getComputedStyle(el);
                        height = height + (parseFloat(style.marginTop) + parseFloat(style.marginBottom));
                    }
                    return height;
                }
                return 0;
            }
        },
        {
            key: "getClientWidth",
            value: function getClientWidth(el, margin) {
                if (el) {
                    var width = el.clientWidth;
                    if (margin) {
                        var style = getComputedStyle(el);
                        width = width + (parseFloat(style.marginLeft) + parseFloat(style.marginRight));
                    }
                    return width;
                }
                return 0;
            }
        },
        {
            key: "getViewport",
            value: function getViewport() {
                var win = window;
                var d = document;
                var e = d.documentElement;
                var g = d.getElementsByTagName('body')[0];
                var w = win.innerWidth || e.clientWidth || g.clientWidth;
                var h = win.innerHeight || e.clientHeight || g.clientHeight;
                return {
                    width: w,
                    height: h
                };
            }
        },
        {
            key: "getOffset",
            value: function getOffset(el) {
                if (el) {
                    var rect = el.getBoundingClientRect();
                    return {
                        top: rect.top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0),
                        left: rect.left + (window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0)
                    };
                }
                return {
                    top: 'auto',
                    left: 'auto'
                };
            }
        },
        {
            key: "index",
            value: function index(element) {
                if (element) {
                    var children = element.parentNode.childNodes;
                    var num = 0;
                    for(var i = 0; i < children.length; i++){
                        if (children[i] === element) return num;
                        if (children[i].nodeType === 1) num++;
                    }
                }
                return -1;
            }
        },
        {
            key: "addMultipleClasses",
            value: function addMultipleClasses(element, className) {
                if (element && className) {
                    if (element.classList) {
                        var styles = className.split(' ');
                        for(var i = 0; i < styles.length; i++)element.classList.add(styles[i]);
                    } else {
                        var _styles = className.split(' ');
                        for(var _i = 0; _i < _styles.length; _i++)element.className = element.className + (' ' + _styles[_i]);
                    }
                }
            }
        },
        {
            key: "removeMultipleClasses",
            value: function removeMultipleClasses(element, className) {
                if (element && className) {
                    if (element.classList) {
                        var styles = className.split(' ');
                        for(var i = 0; i < styles.length; i++)element.classList.remove(styles[i]);
                    } else {
                        var _styles2 = className.split(' ');
                        for(var _i2 = 0; _i2 < _styles2.length; _i2++)element.className = element.className.replace(new RegExp('(^|\\b)' + _styles2[_i2].split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                    }
                }
            }
        },
        {
            key: "addClass",
            value: function addClass(element, className) {
                if (element && className) {
                    if (element.classList) element.classList.add(className);
                    else element.className = element.className + (' ' + className);
                }
            }
        },
        {
            key: "removeClass",
            value: function removeClass(element, className) {
                if (element && className) {
                    if (element.classList) element.classList.remove(className);
                    else element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                }
            }
        },
        {
            key: "hasClass",
            value: function hasClass(element, className) {
                if (element) {
                    if (element.classList) return element.classList.contains(className);
                    return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
                }
                return false;
            }
        },
        {
            key: "addStyles",
            value: function addStyles(element) {
                var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (element) Object.entries(styles).forEach(function(_ref) {
                    var _ref2 = $a73ce425265b079e$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                    return element.style[key] = value;
                });
            }
        },
        {
            key: "find",
            value: function find(element, selector) {
                return element ? Array.from(element.querySelectorAll(selector)) : [];
            }
        },
        {
            key: "findSingle",
            value: function findSingle(element, selector) {
                if (element) return element.querySelector(selector);
                return null;
            }
        },
        {
            key: "setAttributes",
            value: function setAttributes(element) {
                var _this = this;
                var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (element) {
                    var _computedStyles = function computedStyles(rule, value) {
                        var _element$$attrs, _element$$attrs2;
                        var styles = element !== null && element !== void 0 && (_element$$attrs = element.$attrs) !== null && _element$$attrs !== void 0 && _element$$attrs[rule] ? [
                            element === null || element === void 0 || (_element$$attrs2 = element.$attrs) === null || _element$$attrs2 === void 0 ? void 0 : _element$$attrs2[rule]
                        ] : [];
                        return [
                            value
                        ].flat().reduce(function(cv, v) {
                            if (v !== null && v !== undefined) {
                                var type = $a73ce425265b079e$var$_typeof(v);
                                if (type === 'string' || type === 'number') cv.push(v);
                                else if (type === 'object') {
                                    var _cv = Array.isArray(v) ? _computedStyles(rule, v) : Object.entries(v).map(function(_ref3) {
                                        var _ref4 = $a73ce425265b079e$var$_slicedToArray(_ref3, 2), _k = _ref4[0], _v = _ref4[1];
                                        return rule === 'style' && (!!_v || _v === 0) ? "".concat(_k.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase(), ":").concat(_v) : _v ? _k : undefined;
                                    });
                                    cv = _cv.length ? cv.concat(_cv.filter(function(c) {
                                        return !!c;
                                    })) : cv;
                                }
                            }
                            return cv;
                        }, styles);
                    };
                    Object.entries(attributes).forEach(function(_ref5) {
                        var _ref6 = $a73ce425265b079e$var$_slicedToArray(_ref5, 2), key = _ref6[0], value = _ref6[1];
                        if (value !== undefined && value !== null) {
                            var matchedEvent = key.match(/^on(.+)/);
                            if (matchedEvent) element.addEventListener(matchedEvent[1].toLowerCase(), value);
                            else if (key === 'p-bind') _this.setAttributes(element, value);
                            else {
                                value = key === 'class' ? $a73ce425265b079e$var$_toConsumableArray(new Set(_computedStyles('class', value))).join(' ').trim() : key === 'style' ? _computedStyles('style', value).join(';').trim() : value;
                                element.$attrs = element.$attrs || {}, element.$attrs[key] = value;
                                element.setAttribute(key, value);
                            }
                        }
                    });
                }
            }
        },
        {
            key: "getAttribute",
            value: function getAttribute(element, name) {
                if (element) {
                    var value = element.getAttribute(name);
                    if (!isNaN(value)) return +value;
                    if (value === 'true' || value === 'false') return value === 'true';
                    return value;
                }
                return undefined;
            }
        },
        {
            key: "isAttributeEquals",
            value: function isAttributeEquals(element, name, value) {
                return element ? this.getAttribute(element, name) === value : false;
            }
        },
        {
            key: "isAttributeNotEquals",
            value: function isAttributeNotEquals(element, name, value) {
                return !this.isAttributeEquals(element, name, value);
            }
        },
        {
            key: "getHeight",
            value: function getHeight(el) {
                if (el) {
                    var height = el.offsetHeight;
                    var style = getComputedStyle(el);
                    height = height - (parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth));
                    return height;
                }
                return 0;
            }
        },
        {
            key: "getWidth",
            value: function getWidth(el) {
                if (el) {
                    var width = el.offsetWidth;
                    var style = getComputedStyle(el);
                    width = width - (parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth));
                    return width;
                }
                return 0;
            }
        },
        {
            key: "alignOverlay",
            value: function alignOverlay(overlay, target, appendTo) {
                var calculateMinWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
                if (overlay && target) {
                    if (appendTo === 'self') this.relativePosition(overlay, target);
                    else {
                        calculateMinWidth && (overlay.style.minWidth = DomHandler.getOuterWidth(target) + 'px');
                        this.absolutePosition(overlay, target);
                    }
                }
            }
        },
        {
            key: "absolutePosition",
            value: function absolutePosition(element, target) {
                var align = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'left';
                if (element && target) {
                    var elementDimensions = element.offsetParent ? {
                        width: element.offsetWidth,
                        height: element.offsetHeight
                    } : this.getHiddenElementDimensions(element);
                    var elementOuterHeight = elementDimensions.height;
                    var elementOuterWidth = elementDimensions.width;
                    var targetOuterHeight = target.offsetHeight;
                    var targetOuterWidth = target.offsetWidth;
                    var targetOffset = target.getBoundingClientRect();
                    var windowScrollTop = this.getWindowScrollTop();
                    var windowScrollLeft = this.getWindowScrollLeft();
                    var viewport = this.getViewport();
                    var top;
                    var left;
                    if (targetOffset.top + targetOuterHeight + elementOuterHeight > viewport.height) {
                        top = targetOffset.top + windowScrollTop - elementOuterHeight;
                        if (top < 0) top = windowScrollTop;
                        element.style.transformOrigin = 'bottom';
                    } else {
                        top = targetOuterHeight + targetOffset.top + windowScrollTop;
                        element.style.transformOrigin = 'top';
                    }
                    var targetOffsetPx = targetOffset.left;
                    var alignOffset = align === 'left' ? 0 : elementOuterWidth - targetOuterWidth;
                    if (targetOffsetPx + targetOuterWidth + elementOuterWidth > viewport.width) left = Math.max(0, targetOffsetPx + windowScrollLeft + targetOuterWidth - elementOuterWidth);
                    else left = targetOffsetPx - alignOffset + windowScrollLeft;
                    element.style.top = top + 'px';
                    element.style.left = left + 'px';
                }
            }
        },
        {
            key: "relativePosition",
            value: function relativePosition(element, target) {
                if (element && target) {
                    var elementDimensions = element.offsetParent ? {
                        width: element.offsetWidth,
                        height: element.offsetHeight
                    } : this.getHiddenElementDimensions(element);
                    var targetHeight = target.offsetHeight;
                    var targetOffset = target.getBoundingClientRect();
                    var viewport = this.getViewport();
                    var top;
                    var left;
                    if (targetOffset.top + targetHeight + elementDimensions.height > viewport.height) {
                        top = -1 * elementDimensions.height;
                        if (targetOffset.top + top < 0) top = -1 * targetOffset.top;
                        element.style.transformOrigin = 'bottom';
                    } else {
                        top = targetHeight;
                        element.style.transformOrigin = 'top';
                    }
                    if (elementDimensions.width > viewport.width) // element wider then viewport and cannot fit on screen (align at left side of viewport)
                    left = targetOffset.left * -1;
                    else if (targetOffset.left + elementDimensions.width > viewport.width) // element wider then viewport but can be fit on screen (align at right side of viewport)
                    left = (targetOffset.left + elementDimensions.width - viewport.width) * -1;
                    else // element fits on screen (align with target)
                    left = 0;
                    element.style.top = top + 'px';
                    element.style.left = left + 'px';
                }
            }
        },
        {
            key: "flipfitCollision",
            value: function flipfitCollision(element, target) {
                var _this2 = this;
                var my = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'left top';
                var at = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'left bottom';
                var callback = arguments.length > 4 ? arguments[4] : undefined;
                if (element && target) {
                    var targetOffset = target.getBoundingClientRect();
                    var viewport = this.getViewport();
                    var myArr = my.split(' ');
                    var atArr = at.split(' ');
                    var getPositionValue = function getPositionValue(arr, isOffset) {
                        return isOffset ? +arr.substring(arr.search(/(\+|-)/g)) || 0 : arr.substring(0, arr.search(/(\+|-)/g)) || arr;
                    };
                    var position = {
                        my: {
                            x: getPositionValue(myArr[0]),
                            y: getPositionValue(myArr[1] || myArr[0]),
                            offsetX: getPositionValue(myArr[0], true),
                            offsetY: getPositionValue(myArr[1] || myArr[0], true)
                        },
                        at: {
                            x: getPositionValue(atArr[0]),
                            y: getPositionValue(atArr[1] || atArr[0]),
                            offsetX: getPositionValue(atArr[0], true),
                            offsetY: getPositionValue(atArr[1] || atArr[0], true)
                        }
                    };
                    var myOffset = {
                        left: function left() {
                            var totalOffset = position.my.offsetX + position.at.offsetX;
                            return totalOffset + targetOffset.left + (position.my.x === 'left' ? 0 : -1 * (position.my.x === 'center' ? _this2.getOuterWidth(element) / 2 : _this2.getOuterWidth(element)));
                        },
                        top: function top() {
                            var totalOffset = position.my.offsetY + position.at.offsetY;
                            return totalOffset + targetOffset.top + (position.my.y === 'top' ? 0 : -1 * (position.my.y === 'center' ? _this2.getOuterHeight(element) / 2 : _this2.getOuterHeight(element)));
                        }
                    };
                    var alignWithAt = {
                        count: {
                            x: 0,
                            y: 0
                        },
                        left: function left() {
                            var left = myOffset.left();
                            var scrollLeft = DomHandler.getWindowScrollLeft();
                            element.style.left = left + scrollLeft + 'px';
                            if (this.count.x === 2) {
                                element.style.left = scrollLeft + 'px';
                                this.count.x = 0;
                            } else if (left < 0) {
                                this.count.x++;
                                position.my.x = 'left';
                                position.at.x = 'right';
                                position.my.offsetX *= -1;
                                position.at.offsetX *= -1;
                                this.right();
                            }
                        },
                        right: function right() {
                            var left = myOffset.left() + DomHandler.getOuterWidth(target);
                            var scrollLeft = DomHandler.getWindowScrollLeft();
                            element.style.left = left + scrollLeft + 'px';
                            if (this.count.x === 2) {
                                element.style.left = viewport.width - DomHandler.getOuterWidth(element) + scrollLeft + 'px';
                                this.count.x = 0;
                            } else if (left + DomHandler.getOuterWidth(element) > viewport.width) {
                                this.count.x++;
                                position.my.x = 'right';
                                position.at.x = 'left';
                                position.my.offsetX *= -1;
                                position.at.offsetX *= -1;
                                this.left();
                            }
                        },
                        top: function top() {
                            var top = myOffset.top();
                            var scrollTop = DomHandler.getWindowScrollTop();
                            element.style.top = top + scrollTop + 'px';
                            if (this.count.y === 2) {
                                element.style.left = scrollTop + 'px';
                                this.count.y = 0;
                            } else if (top < 0) {
                                this.count.y++;
                                position.my.y = 'top';
                                position.at.y = 'bottom';
                                position.my.offsetY *= -1;
                                position.at.offsetY *= -1;
                                this.bottom();
                            }
                        },
                        bottom: function bottom() {
                            var top = myOffset.top() + DomHandler.getOuterHeight(target);
                            var scrollTop = DomHandler.getWindowScrollTop();
                            element.style.top = top + scrollTop + 'px';
                            if (this.count.y === 2) {
                                element.style.left = viewport.height - DomHandler.getOuterHeight(element) + scrollTop + 'px';
                                this.count.y = 0;
                            } else if (top + DomHandler.getOuterHeight(target) > viewport.height) {
                                this.count.y++;
                                position.my.y = 'bottom';
                                position.at.y = 'top';
                                position.my.offsetY *= -1;
                                position.at.offsetY *= -1;
                                this.top();
                            }
                        },
                        center: function center(axis) {
                            if (axis === 'y') {
                                var top = myOffset.top() + DomHandler.getOuterHeight(target) / 2;
                                element.style.top = top + DomHandler.getWindowScrollTop() + 'px';
                                if (top < 0) this.bottom();
                                else if (top + DomHandler.getOuterHeight(target) > viewport.height) this.top();
                            } else {
                                var left = myOffset.left() + DomHandler.getOuterWidth(target) / 2;
                                element.style.left = left + DomHandler.getWindowScrollLeft() + 'px';
                                if (left < 0) this.left();
                                else if (left + DomHandler.getOuterWidth(element) > viewport.width) this.right();
                            }
                        }
                    };
                    alignWithAt[position.at.x]('x');
                    alignWithAt[position.at.y]('y');
                    if (this.isFunction(callback)) callback(position);
                }
            }
        },
        {
            key: "findCollisionPosition",
            value: function findCollisionPosition(position) {
                if (position) {
                    var isAxisY = position === 'top' || position === 'bottom';
                    var myXPosition = position === 'left' ? 'right' : 'left';
                    var myYPosition = position === 'top' ? 'bottom' : 'top';
                    if (isAxisY) return {
                        axis: 'y',
                        my: "center ".concat(myYPosition),
                        at: "center ".concat(position)
                    };
                    return {
                        axis: 'x',
                        my: "".concat(myXPosition, " center"),
                        at: "".concat(position, " center")
                    };
                }
            }
        },
        {
            key: "getParents",
            value: function getParents(element) {
                var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                return element.parentNode === null ? parents : this.getParents(element.parentNode, parents.concat([
                    element.parentNode
                ]));
            }
        },
        {
            key: "getScrollableParents",
            value: function getScrollableParents(element) {
                var hideOverlaysOnDocumentScrolling = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var scrollableParents = [];
                if (element) {
                    var parents = this.getParents(element);
                    var overflowRegex = /(auto|scroll)/;
                    var overflowCheck = function overflowCheck(node) {
                        var styleDeclaration = node ? getComputedStyle(node) : null;
                        return styleDeclaration && (overflowRegex.test(styleDeclaration.getPropertyValue('overflow')) || overflowRegex.test(styleDeclaration.getPropertyValue('overflow-x')) || overflowRegex.test(styleDeclaration.getPropertyValue('overflow-y')));
                    };
                    var addScrollableParent = function addScrollableParent(node) {
                        if (hideOverlaysOnDocumentScrolling) // nodeType 9 is for document element
                        scrollableParents.push(node.nodeName === 'BODY' || node.nodeName === 'HTML' || node.nodeType === 9 ? window : node);
                        else scrollableParents.push(node);
                    };
                    var _iterator = $a73ce425265b079e$var$_createForOfIteratorHelper$1(parents), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var parent = _step.value;
                            var scrollSelectors = parent.nodeType === 1 && parent.dataset.scrollselectors;
                            if (scrollSelectors) {
                                var selectors = scrollSelectors.split(',');
                                var _iterator2 = $a73ce425265b079e$var$_createForOfIteratorHelper$1(selectors), _step2;
                                try {
                                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                        var selector = _step2.value;
                                        var el = this.findSingle(parent, selector);
                                        if (el && overflowCheck(el)) addScrollableParent(el);
                                    }
                                } catch (err) {
                                    _iterator2.e(err);
                                } finally{
                                    _iterator2.f();
                                }
                            }
                            // BODY
                            if (parent.nodeType === 1 && overflowCheck(parent)) addScrollableParent(parent);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                // we should always at least have the body or window
                if (!scrollableParents.some(function(node) {
                    return node === document.body || node === window;
                })) scrollableParents.push(window);
                return scrollableParents;
            }
        },
        {
            key: "getHiddenElementOuterHeight",
            value: function getHiddenElementOuterHeight(element) {
                if (element) {
                    element.style.visibility = 'hidden';
                    element.style.display = 'block';
                    var elementHeight = element.offsetHeight;
                    element.style.display = 'none';
                    element.style.visibility = 'visible';
                    return elementHeight;
                }
                return 0;
            }
        },
        {
            key: "getHiddenElementOuterWidth",
            value: function getHiddenElementOuterWidth(element) {
                if (element) {
                    element.style.visibility = 'hidden';
                    element.style.display = 'block';
                    var elementWidth = element.offsetWidth;
                    element.style.display = 'none';
                    element.style.visibility = 'visible';
                    return elementWidth;
                }
                return 0;
            }
        },
        {
            key: "getHiddenElementDimensions",
            value: function getHiddenElementDimensions(element) {
                var dimensions = {};
                if (element) {
                    element.style.visibility = 'hidden';
                    element.style.display = 'block';
                    dimensions.width = element.offsetWidth;
                    dimensions.height = element.offsetHeight;
                    element.style.display = 'none';
                    element.style.visibility = 'visible';
                }
                return dimensions;
            }
        },
        {
            key: "fadeIn",
            value: function fadeIn(element, duration) {
                if (element) {
                    element.style.opacity = 0;
                    var last = +new Date();
                    var opacity = 0;
                    var _tick = function tick() {
                        opacity = +element.style.opacity + (new Date().getTime() - last) / duration;
                        element.style.opacity = opacity;
                        last = +new Date();
                        if (+opacity < 1) window.requestAnimationFrame && requestAnimationFrame(_tick) || setTimeout(_tick, 16);
                    };
                    _tick();
                }
            }
        },
        {
            key: "fadeOut",
            value: function fadeOut(element, duration) {
                if (element) {
                    var opacity = 1;
                    var interval = 50;
                    var gap = interval / duration;
                    var fading = setInterval(function() {
                        opacity = opacity - gap;
                        if (opacity <= 0) {
                            opacity = 0;
                            clearInterval(fading);
                        }
                        element.style.opacity = opacity;
                    }, interval);
                }
            }
        },
        {
            key: "getUserAgent",
            value: function getUserAgent() {
                return navigator.userAgent;
            }
        },
        {
            key: "isIOS",
            value: function isIOS() {
                return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            }
        },
        {
            key: "isAndroid",
            value: function isAndroid() {
                return /(android)/i.test(navigator.userAgent);
            }
        },
        {
            key: "isChrome",
            value: function isChrome() {
                return /(chrome)/i.test(navigator.userAgent);
            }
        },
        {
            key: "isClient",
            value: function isClient() {
                return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
            }
        },
        {
            key: "isTouchDevice",
            value: function isTouchDevice() {
                return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
            }
        },
        {
            key: "isFunction",
            value: function isFunction(obj) {
                return !!(obj && obj.constructor && obj.call && obj.apply);
            }
        },
        {
            key: "appendChild",
            value: function appendChild(element, target) {
                if (this.isElement(target)) target.appendChild(element);
                else if (target.el && target.el.nativeElement) target.el.nativeElement.appendChild(element);
                else throw new Error('Cannot append ' + target + ' to ' + element);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(element, target) {
                if (this.isElement(target)) target.removeChild(element);
                else if (target.el && target.el.nativeElement) target.el.nativeElement.removeChild(element);
                else throw new Error('Cannot remove ' + element + ' from ' + target);
            }
        },
        {
            key: "isElement",
            value: function isElement(obj) {
                return (typeof HTMLElement === "undefined" ? "undefined" : $a73ce425265b079e$var$_typeof(HTMLElement)) === 'object' ? obj instanceof HTMLElement : obj && $a73ce425265b079e$var$_typeof(obj) === 'object' && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === 'string';
            }
        },
        {
            key: "scrollInView",
            value: function scrollInView(container, item) {
                var borderTopValue = getComputedStyle(container).getPropertyValue('border-top-width');
                var borderTop = borderTopValue ? parseFloat(borderTopValue) : 0;
                var paddingTopValue = getComputedStyle(container).getPropertyValue('padding-top');
                var paddingTop = paddingTopValue ? parseFloat(paddingTopValue) : 0;
                var containerRect = container.getBoundingClientRect();
                var itemRect = item.getBoundingClientRect();
                var offset = itemRect.top + document.body.scrollTop - (containerRect.top + document.body.scrollTop) - borderTop - paddingTop;
                var scroll = container.scrollTop;
                var elementHeight = container.clientHeight;
                var itemHeight = this.getOuterHeight(item);
                if (offset < 0) container.scrollTop = scroll + offset;
                else if (offset + itemHeight > elementHeight) container.scrollTop = scroll + offset - elementHeight + itemHeight;
            }
        },
        {
            key: "clearSelection",
            value: function clearSelection() {
                if (window.getSelection) {
                    if (window.getSelection().empty) window.getSelection().empty();
                    else if (window.getSelection().removeAllRanges && window.getSelection().rangeCount > 0 && window.getSelection().getRangeAt(0).getClientRects().length > 0) window.getSelection().removeAllRanges();
                } else if (document.selection && document.selection.empty) try {
                    document.selection.empty();
                } catch (error) {
                //ignore IE bug
                }
            }
        },
        {
            key: "calculateScrollbarWidth",
            value: function calculateScrollbarWidth(el) {
                if (el) {
                    var style = getComputedStyle(el);
                    return el.offsetWidth - el.clientWidth - parseFloat(style.borderLeftWidth) - parseFloat(style.borderRightWidth);
                }
                if (this.calculatedScrollbarWidth != null) return this.calculatedScrollbarWidth;
                var scrollDiv = document.createElement('div');
                scrollDiv.className = 'p-scrollbar-measure';
                document.body.appendChild(scrollDiv);
                var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
                document.body.removeChild(scrollDiv);
                this.calculatedScrollbarWidth = scrollbarWidth;
                return scrollbarWidth;
            }
        },
        {
            key: "calculateBodyScrollbarWidth",
            value: function calculateBodyScrollbarWidth() {
                return window.innerWidth - document.documentElement.offsetWidth;
            }
        },
        {
            key: "getBrowser",
            value: function getBrowser() {
                if (!this.browser) {
                    var matched = this.resolveUserAgent();
                    this.browser = {};
                    if (matched.browser) {
                        this.browser[matched.browser] = true;
                        this.browser.version = matched.version;
                    }
                    if (this.browser.chrome) this.browser.webkit = true;
                    else if (this.browser.webkit) this.browser.safari = true;
                }
                return this.browser;
            }
        },
        {
            key: "resolveUserAgent",
            value: function resolveUserAgent() {
                var ua = navigator.userAgent.toLowerCase();
                var match = /(chrome)[ ]([\w.]+)/.exec(ua) || /(webkit)[ ]([\w.]+)/.exec(ua) || /(opera)(?:.*version|)[ ]([\w.]+)/.exec(ua) || /(msie) ([\w.]+)/.exec(ua) || ua.indexOf('compatible') < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) || [];
                return {
                    browser: match[1] || '',
                    version: match[2] || '0'
                };
            }
        },
        {
            key: "blockBodyScroll",
            value: function blockBodyScroll() {
                var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'p-overflow-hidden';
                /* PR Ref: https://github.com/primefaces/primereact/pull/4976
       * @todo This method is called several times after this PR. Refactors will be made to prevent this in future releases.
       */ var hasScrollbarWidth = !!document.body.style.getPropertyValue('--scrollbar-width');
                !hasScrollbarWidth && document.body.style.setProperty('--scrollbar-width', this.calculateBodyScrollbarWidth() + 'px');
                this.addClass(document.body, className);
            }
        },
        {
            key: "unblockBodyScroll",
            value: function unblockBodyScroll() {
                var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'p-overflow-hidden';
                document.body.style.removeProperty('--scrollbar-width');
                this.removeClass(document.body, className);
            }
        },
        {
            key: "isVisible",
            value: function isVisible(element) {
                // https://stackoverflow.com/a/59096915/502366 (in future use IntersectionObserver)
                return element && (element.clientHeight !== 0 || element.getClientRects().length !== 0 || getComputedStyle(element).display !== 'none');
            }
        },
        {
            key: "isExist",
            value: function isExist(element) {
                return !!(element !== null && typeof element !== 'undefined' && element.nodeName && element.parentNode);
            }
        },
        {
            key: "getFocusableElements",
            value: function getFocusableElements(element) {
                var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var focusableElements = DomHandler.find(element, "button:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])".concat(selector, ",\n                [href][clientHeight][clientWidth]:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector, ",\n                input:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector, ",\n                select:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector, ",\n                textarea:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector, ",\n                [tabIndex]:not([tabIndex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector, ",\n                [contenteditable]:not([tabIndex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector));
                var visibleFocusableElements = [];
                var _iterator3 = $a73ce425265b079e$var$_createForOfIteratorHelper$1(focusableElements), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var focusableElement = _step3.value;
                        if (getComputedStyle(focusableElement).display !== 'none' && getComputedStyle(focusableElement).visibility !== 'hidden') visibleFocusableElements.push(focusableElement);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                return visibleFocusableElements;
            }
        },
        {
            key: "getFirstFocusableElement",
            value: function getFirstFocusableElement(element, selector) {
                var focusableElements = DomHandler.getFocusableElements(element, selector);
                return focusableElements.length > 0 ? focusableElements[0] : null;
            }
        },
        {
            key: "getLastFocusableElement",
            value: function getLastFocusableElement(element, selector) {
                var focusableElements = DomHandler.getFocusableElements(element, selector);
                return focusableElements.length > 0 ? focusableElements[focusableElements.length - 1] : null;
            }
        },
        {
            key: "focus",
            value: function focus(el, scrollTo) {
                var preventScroll = scrollTo === undefined ? true : !scrollTo;
                el && document.activeElement !== el && el.focus({
                    preventScroll: preventScroll
                });
            }
        },
        {
            key: "focusFirstElement",
            value: function focusFirstElement(el, scrollTo) {
                if (!el) return;
                var firstFocusableElement = DomHandler.getFirstFocusableElement(el);
                firstFocusableElement && DomHandler.focus(firstFocusableElement, scrollTo);
                return firstFocusableElement;
            }
        },
        {
            key: "getCursorOffset",
            value: function getCursorOffset(el, prevText, nextText, currentText) {
                if (el) {
                    var style = getComputedStyle(el);
                    var ghostDiv = document.createElement('div');
                    ghostDiv.style.position = 'absolute';
                    ghostDiv.style.top = '0px';
                    ghostDiv.style.left = '0px';
                    ghostDiv.style.visibility = 'hidden';
                    ghostDiv.style.pointerEvents = 'none';
                    ghostDiv.style.overflow = style.overflow;
                    ghostDiv.style.width = style.width;
                    ghostDiv.style.height = style.height;
                    ghostDiv.style.padding = style.padding;
                    ghostDiv.style.border = style.border;
                    ghostDiv.style.overflowWrap = style.overflowWrap;
                    ghostDiv.style.whiteSpace = style.whiteSpace;
                    ghostDiv.style.lineHeight = style.lineHeight;
                    ghostDiv.innerHTML = prevText.replace(/\r\n|\r|\n/g, '<br />');
                    var ghostSpan = document.createElement('span');
                    ghostSpan.textContent = currentText;
                    ghostDiv.appendChild(ghostSpan);
                    var text = document.createTextNode(nextText);
                    ghostDiv.appendChild(text);
                    document.body.appendChild(ghostDiv);
                    var offsetLeft = ghostSpan.offsetLeft, offsetTop = ghostSpan.offsetTop, clientHeight = ghostSpan.clientHeight;
                    document.body.removeChild(ghostDiv);
                    return {
                        left: Math.abs(offsetLeft - el.scrollLeft),
                        top: Math.abs(offsetTop - el.scrollTop) + clientHeight
                    };
                }
                return {
                    top: 'auto',
                    left: 'auto'
                };
            }
        },
        {
            key: "invokeElementMethod",
            value: function invokeElementMethod(element, methodName, args) {
                element[methodName].apply(element, args);
            }
        },
        {
            key: "isClickable",
            value: function isClickable(element) {
                var targetNode = element.nodeName;
                var parentNode = element.parentElement && element.parentElement.nodeName;
                return targetNode === 'INPUT' || targetNode === 'TEXTAREA' || targetNode === 'BUTTON' || targetNode === 'A' || parentNode === 'INPUT' || parentNode === 'TEXTAREA' || parentNode === 'BUTTON' || parentNode === 'A' || this.hasClass(element, 'p-button') || this.hasClass(element.parentElement, 'p-button') || this.hasClass(element.parentElement, 'p-checkbox') || this.hasClass(element.parentElement, 'p-radiobutton');
            }
        },
        {
            key: "applyStyle",
            value: function applyStyle(element, style) {
                if (typeof style === 'string') element.style.cssText = style;
                else for(var prop in style)element.style[prop] = style[prop];
            }
        },
        {
            key: "exportCSV",
            value: function exportCSV(csv, filename) {
                var blob = new Blob([
                    csv
                ], {
                    type: 'application/csv;charset=utf-8;'
                });
                if (window.navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(blob, filename + '.csv');
                else {
                    var isDownloaded = DomHandler.saveAs({
                        name: filename + '.csv',
                        src: URL.createObjectURL(blob)
                    });
                    if (!isDownloaded) {
                        csv = 'data:text/csv;charset=utf-8,' + csv;
                        window.open(encodeURI(csv));
                    }
                }
            }
        },
        {
            key: "saveAs",
            value: function saveAs(file) {
                if (file) {
                    var link = document.createElement('a');
                    if (link.download !== undefined) {
                        var name = file.name, src = file.src;
                        link.setAttribute('href', src);
                        link.setAttribute('download', name);
                        link.style.display = 'none';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        return true;
                    }
                }
                return false;
            }
        },
        {
            key: "createInlineStyle",
            value: function createInlineStyle(nonce, styleContainer) {
                var styleElement = document.createElement('style');
                DomHandler.addNonce(styleElement, nonce);
                if (!styleContainer) styleContainer = document.head;
                styleContainer.appendChild(styleElement);
                return styleElement;
            }
        },
        {
            key: "removeInlineStyle",
            value: function removeInlineStyle(styleElement) {
                if (this.isExist(styleElement)) {
                    try {
                        styleElement.parentNode.removeChild(styleElement);
                    } catch (error) {
                    // style element may have already been removed in a fast refresh
                    }
                    styleElement = null;
                }
                return styleElement;
            }
        },
        {
            key: "addNonce",
            value: function addNonce(styleElement, nonce) {
                try {
                    if (!nonce) nonce = undefined;
                } catch (error) {
                // NOOP
                }
                nonce && styleElement.setAttribute('nonce', nonce);
            }
        },
        {
            key: "getTargetElement",
            value: function getTargetElement(target) {
                if (!target) return null;
                if (target === 'document') return document;
                else if (target === 'window') return window;
                else if ($a73ce425265b079e$var$_typeof(target) === 'object' && target.hasOwnProperty('current')) return this.isExist(target.current) ? target.current : null;
                var isFunction = function isFunction(obj) {
                    return !!(obj && obj.constructor && obj.call && obj.apply);
                };
                var element = isFunction(target) ? target() : target;
                return element && element.nodeType === 9 || this.isExist(element) ? element : null;
            }
        },
        {
            key: "getAttributeNames",
            value: function getAttributeNames(node) {
                var index;
                var rv;
                var attrs;
                rv = [];
                attrs = node.attributes;
                for(index = 0; index < attrs.length; ++index)rv.push(attrs[index].nodeName);
                rv.sort();
                return rv;
            }
        },
        {
            key: "isEqualElement",
            value: function isEqualElement(elm1, elm2) {
                var attrs1;
                var attrs2;
                var name;
                var node1;
                var node2;
                // Compare attributes without order sensitivity
                attrs1 = DomHandler.getAttributeNames(elm1);
                attrs2 = DomHandler.getAttributeNames(elm2);
                if (attrs1.join(',') !== attrs2.join(',')) // console.log("Found nodes with different sets of attributes; not equiv");
                return false;
                // ...and values
                // unless you want to compare DOM0 event handlers
                // (onclick="...")
                for(var index = 0; index < attrs1.length; ++index){
                    name = attrs1[index];
                    if (name === 'style') {
                        var astyle = elm1.style;
                        var bstyle = elm2.style;
                        var rexDigitsOnly = /^\d+$/;
                        for(var _i3 = 0, _Object$keys = Object.keys(astyle); _i3 < _Object$keys.length; _i3++){
                            var key = _Object$keys[_i3];
                            if (!rexDigitsOnly.test(key) && astyle[key] !== bstyle[key]) // Not equivalent, stop
                            //console.log("Found nodes with mis-matched values for attribute '" + name + "'; not equiv");
                            return false;
                        }
                    } else if (elm1.getAttribute(name) !== elm2.getAttribute(name)) // console.log("Found nodes with mis-matched values for attribute '" + name + "'; not equiv");
                    return false;
                }
                // Walk the children
                for(node1 = elm1.firstChild, node2 = elm2.firstChild; node1 && node2; node1 = node1.nextSibling, node2 = node2.nextSibling){
                    if (node1.nodeType !== node2.nodeType) // display("Found nodes of different types; not equiv");
                    return false;
                    if (node1.nodeType === 1) {
                        // Element
                        if (!DomHandler.isEqualElement(node1, node2)) return false;
                    } else if (node1.nodeValue !== node2.nodeValue) // console.log("Found nodes with mis-matched nodeValues; not equiv");
                    return false;
                }
                if (node1 || node2) // One of the elements had more nodes than the other
                // console.log("Found more children of one element than the other; not equivalent");
                return false;
                // Seem the same
                return true;
            }
        },
        {
            key: "hasCSSAnimation",
            value: function hasCSSAnimation(element) {
                if (element) {
                    var style = getComputedStyle(element);
                    var animationDuration = parseFloat(style.getPropertyValue('animation-duration') || '0');
                    return animationDuration > 0;
                }
                return false;
            }
        },
        {
            key: "hasCSSTransition",
            value: function hasCSSTransition(element) {
                if (element) {
                    var style = getComputedStyle(element);
                    var transitionDuration = parseFloat(style.getPropertyValue('transition-duration') || '0');
                    return transitionDuration > 0;
                }
                return false;
            }
        }
    ]);
}();
/**
 * All data- properties like data-test-id
 */ $a73ce425265b079e$var$_defineProperty($a73ce425265b079e$export$ff8ccbac9225de62, "DATA_PROPS", [
    'data-'
]);
/**
 * All ARIA properties like aria-label and focus-target for https://www.npmjs.com/package/@q42/floating-focus-a11y
 */ $a73ce425265b079e$var$_defineProperty($a73ce425265b079e$export$ff8ccbac9225de62, "ARIA_PROPS", [
    'aria',
    'focus-target'
]);
function $a73ce425265b079e$export$5087227eb54526() {
    var allHandlers = new Map();
    return {
        on: function on(type, handler) {
            var handlers = allHandlers.get(type);
            if (!handlers) handlers = [
                handler
            ];
            else handlers.push(handler);
            allHandlers.set(type, handlers);
        },
        off: function off(type, handler) {
            var handlers = allHandlers.get(type);
            handlers && handlers.splice(handlers.indexOf(handler) >>> 0, 1);
        },
        emit: function emit(type, evt) {
            var handlers = allHandlers.get(type);
            handlers && handlers.slice().forEach(function(handler) {
                return handler(evt);
            });
        }
    };
}
function $a73ce425265b079e$var$_extends() {
    return $a73ce425265b079e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a73ce425265b079e$var$_extends.apply(null, arguments);
}
function $a73ce425265b079e$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $a73ce425265b079e$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $a73ce425265b079e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $a73ce425265b079e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a73ce425265b079e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $a73ce425265b079e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $a73ce425265b079e$export$4855211e6b8ad895 = /*#__PURE__*/ function() {
    function ObjectUtils() {
        $a73ce425265b079e$var$_classCallCheck(this, ObjectUtils);
    }
    return $a73ce425265b079e$var$_createClass(ObjectUtils, null, [
        {
            key: "equals",
            value: function equals(obj1, obj2, field) {
                if (field && obj1 && $a73ce425265b079e$var$_typeof(obj1) === 'object' && obj2 && $a73ce425265b079e$var$_typeof(obj2) === 'object') return this.deepEquals(this.resolveFieldData(obj1, field), this.resolveFieldData(obj2, field));
                return this.deepEquals(obj1, obj2);
            }
        },
        {
            key: "deepEquals",
            value: function deepEquals(a, b) {
                if (a === b) return true;
                if (a && b && $a73ce425265b079e$var$_typeof(a) === 'object' && $a73ce425265b079e$var$_typeof(b) === 'object') {
                    var arrA = Array.isArray(a);
                    var arrB = Array.isArray(b);
                    var i;
                    var length;
                    var key;
                    if (arrA && arrB) {
                        length = a.length;
                        if (length !== b.length) return false;
                        for(i = length; i-- !== 0;){
                            if (!this.deepEquals(a[i], b[i])) return false;
                        }
                        return true;
                    }
                    if (arrA !== arrB) return false;
                    var dateA = a instanceof Date;
                    var dateB = b instanceof Date;
                    if (dateA !== dateB) return false;
                    if (dateA && dateB) return a.getTime() === b.getTime();
                    var regexpA = a instanceof RegExp;
                    var regexpB = b instanceof RegExp;
                    if (regexpA !== regexpB) return false;
                    if (regexpA && regexpB) return a.toString() === b.toString();
                    var keys = Object.keys(a);
                    length = keys.length;
                    if (length !== Object.keys(b).length) return false;
                    for(i = length; i-- !== 0;){
                        if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
                    }
                    for(i = length; i-- !== 0;){
                        key = keys[i];
                        if (!this.deepEquals(a[key], b[key])) return false;
                    }
                    return true;
                }
                /*eslint no-self-compare: "off"*/ return a !== a && b !== b;
            }
        },
        {
            key: "resolveFieldData",
            value: function resolveFieldData(data, field) {
                if (!data || !field) // short circuit if there is nothing to resolve
                return null;
                try {
                    var value = data[field];
                    if (this.isNotEmpty(value)) return value;
                } catch (_unused) {
                // Performance optimization: https://github.com/primefaces/primereact/issues/4797
                // do nothing and continue to other methods to resolve field data
                }
                if (Object.keys(data).length) {
                    if (this.isFunction(field)) return field(data);
                    else if (this.isNotEmpty(data[field])) return data[field];
                    else if (field.indexOf('.') === -1) return data[field];
                    var fields = field.split('.');
                    var _value = data;
                    for(var i = 0, len = fields.length; i < len; ++i){
                        if (_value == null) return null;
                        _value = _value[fields[i]];
                    }
                    return _value;
                }
                return null;
            }
        },
        {
            key: "findDiffKeys",
            value: function findDiffKeys(obj1, obj2) {
                if (!obj1 || !obj2) return {};
                return Object.keys(obj1).filter(function(key) {
                    return !obj2.hasOwnProperty(key);
                }).reduce(function(result, current) {
                    result[current] = obj1[current];
                    return result;
                }, {});
            }
        },
        {
            key: "reduceKeys",
            value: function reduceKeys(obj, startsWiths) {
                var result = {};
                if (!obj || !startsWiths || startsWiths.length === 0) return result;
                Object.keys(obj).filter(function(key) {
                    return startsWiths.some(function(value) {
                        return key.startsWith(value);
                    });
                }).forEach(function(key) {
                    result[key] = obj[key];
                    delete obj[key];
                });
                return result;
            }
        },
        {
            key: "reorderArray",
            value: function reorderArray(value, from, to) {
                if (value && from !== to) {
                    if (to >= value.length) {
                        to = to % value.length;
                        from = from % value.length;
                    }
                    value.splice(to, 0, value.splice(from, 1)[0]);
                }
            }
        },
        {
            key: "findIndexInList",
            value: function findIndexInList(value, list, dataKey) {
                var _this = this;
                if (list) return dataKey ? list.findIndex(function(item) {
                    return _this.equals(item, value, dataKey);
                }) : list.findIndex(function(item) {
                    return item === value;
                });
                return -1;
            }
        },
        {
            key: "getJSXElement",
            value: function getJSXElement(obj) {
                for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
                return this.isFunction(obj) ? obj.apply(void 0, params) : obj;
            }
        },
        {
            key: "getItemValue",
            value: function getItemValue(obj) {
                for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
                return this.isFunction(obj) ? obj.apply(void 0, params) : obj;
            }
        },
        {
            key: "getProp",
            value: function getProp(props) {
                var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var value = props ? props[prop] : undefined;
                return value === undefined ? defaultProps[prop] : value;
            }
        },
        {
            key: "getPropCaseInsensitive",
            value: function getPropCaseInsensitive(props, prop) {
                var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var fkey = this.toFlatCase(prop);
                for(var key in props){
                    if (props.hasOwnProperty(key) && this.toFlatCase(key) === fkey) return props[key];
                }
                for(var _key3 in defaultProps){
                    if (defaultProps.hasOwnProperty(_key3) && this.toFlatCase(_key3) === fkey) return defaultProps[_key3];
                }
                return undefined; // Property not found
            }
        },
        {
            key: "getMergedProps",
            value: function getMergedProps(props, defaultProps) {
                return Object.assign({}, defaultProps, props);
            }
        },
        {
            key: "getDiffProps",
            value: function getDiffProps(props, defaultProps) {
                return this.findDiffKeys(props, defaultProps);
            }
        },
        {
            key: "getPropValue",
            value: function getPropValue(obj) {
                for(var _len3 = arguments.length, params = new Array(_len3 > 1 ? _len3 - 1 : 0), _key4 = 1; _key4 < _len3; _key4++)params[_key4 - 1] = arguments[_key4];
                return this.isFunction(obj) ? obj.apply(void 0, params) : obj;
            }
        },
        {
            key: "getComponentProp",
            value: function getComponentProp(component) {
                var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.isNotEmpty(component) ? this.getProp(component.props, prop, defaultProps) : undefined;
            }
        },
        {
            key: "getComponentProps",
            value: function getComponentProps(component, defaultProps) {
                return this.isNotEmpty(component) ? this.getMergedProps(component.props, defaultProps) : undefined;
            }
        },
        {
            key: "getComponentDiffProps",
            value: function getComponentDiffProps(component, defaultProps) {
                return this.isNotEmpty(component) ? this.getDiffProps(component.props, defaultProps) : undefined;
            }
        },
        {
            key: "isValidChild",
            value: function isValidChild(child, type, validTypes) {
                /* eslint-disable */ if (child) {
                    var _child$type;
                    var childType = this.getComponentProp(child, '__TYPE') || (child.type ? child.type.displayName : undefined);
                    // for App Router in Next.js ^14,
                    if (!childType && child !== null && child !== void 0 && (_child$type = child.type) !== null && _child$type !== void 0 && (_child$type = _child$type._payload) !== null && _child$type !== void 0 && _child$type.value) childType = child.type._payload.value.find(function(v) {
                        return v === type;
                    });
                    var isValid = childType === type;
                    try {
                        var messageTypes;
                    } catch (error) {
                    // NOOP
                    }
                    return isValid;
                }
                return false;
            /* eslint-enable */ }
        },
        {
            key: "getRefElement",
            value: function getRefElement(ref) {
                if (ref) return $a73ce425265b079e$var$_typeof(ref) === 'object' && ref.hasOwnProperty('current') ? ref.current : ref;
                return null;
            }
        },
        {
            key: "combinedRefs",
            value: function combinedRefs(innerRef, forwardRef) {
                if (innerRef && forwardRef) {
                    if (typeof forwardRef === 'function') forwardRef(innerRef.current);
                    else forwardRef.current = innerRef.current;
                }
            }
        },
        {
            key: "removeAccents",
            value: function removeAccents(str) {
                if (str && str.search(/[\xC0-\xFF]/g) > -1) str = str.replace(/[\xC0-\xC5]/g, 'A').replace(/[\xC6]/g, 'AE').replace(/[\xC7]/g, 'C').replace(/[\xC8-\xCB]/g, 'E').replace(/[\xCC-\xCF]/g, 'I').replace(/[\xD0]/g, 'D').replace(/[\xD1]/g, 'N').replace(/[\xD2-\xD6\xD8]/g, 'O').replace(/[\xD9-\xDC]/g, 'U').replace(/[\xDD]/g, 'Y').replace(/[\xDE]/g, 'P').replace(/[\xE0-\xE5]/g, 'a').replace(/[\xE6]/g, 'ae').replace(/[\xE7]/g, 'c').replace(/[\xE8-\xEB]/g, 'e').replace(/[\xEC-\xEF]/g, 'i').replace(/[\xF1]/g, 'n').replace(/[\xF2-\xF6\xF8]/g, 'o').replace(/[\xF9-\xFC]/g, 'u').replace(/[\xFE]/g, 'p').replace(/[\xFD\xFF]/g, 'y');
                return str;
            }
        },
        {
            key: "toFlatCase",
            value: function toFlatCase(str) {
                // convert snake, kebab, camel and pascal cases to flat case
                return this.isNotEmpty(str) && this.isString(str) ? str.replace(/(-|_)/g, '').toLowerCase() : str;
            }
        },
        {
            key: "toCapitalCase",
            value: function toCapitalCase(str) {
                return this.isNotEmpty(str) && this.isString(str) ? str[0].toUpperCase() + str.slice(1) : str;
            }
        },
        {
            key: "trim",
            value: function trim(value) {
                // trim only if the value is actually a string
                return this.isNotEmpty(value) && this.isString(value) ? value.trim() : value;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty(value) {
                return value === null || value === undefined || value === '' || Array.isArray(value) && value.length === 0 || !(value instanceof Date) && $a73ce425265b079e$var$_typeof(value) === 'object' && Object.keys(value).length === 0;
            }
        },
        {
            key: "isNotEmpty",
            value: function isNotEmpty(value) {
                return !this.isEmpty(value);
            }
        },
        {
            key: "isFunction",
            value: function isFunction(value) {
                return !!(value && value.constructor && value.call && value.apply);
            }
        },
        {
            key: "isObject",
            value: function isObject(value) {
                return value !== null && value instanceof Object && value.constructor === Object;
            }
        },
        {
            key: "isDate",
            value: function isDate(value) {
                return value !== null && value instanceof Date && value.constructor === Date;
            }
        },
        {
            key: "isArray",
            value: function isArray(value) {
                return value !== null && Array.isArray(value);
            }
        },
        {
            key: "isString",
            value: function isString(value) {
                return value !== null && typeof value === 'string';
            }
        },
        {
            key: "isPrintableCharacter",
            value: function isPrintableCharacter() {
                var _char = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                return this.isNotEmpty(_char) && _char.length === 1 && _char.match(/\S| /);
            }
        },
        {
            key: "isLetter",
            value: function isLetter(_char2) {
                return /^[a-zA-Z\u00C0-\u017F]$/.test(_char2);
            }
        },
        {
            key: "isScalar",
            value: function isScalar(value) {
                return value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'bigint' || typeof value === 'boolean');
            }
        },
        {
            key: "findLast",
            value: function findLast(arr, callback) {
                var item;
                if (this.isNotEmpty(arr)) try {
                    item = arr.findLast(callback);
                } catch (_unused2) {
                    item = $a73ce425265b079e$var$_toConsumableArray(arr).reverse().find(callback);
                }
                return item;
            }
        },
        {
            key: "findLastIndex",
            value: function findLastIndex(arr, callback) {
                var index = -1;
                if (this.isNotEmpty(arr)) try {
                    index = arr.findLastIndex(callback);
                } catch (_unused3) {
                    index = arr.lastIndexOf($a73ce425265b079e$var$_toConsumableArray(arr).reverse().find(callback));
                }
                return index;
            }
        },
        {
            key: "sort",
            value: function sort(value1, value2) {
                var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                var comparator = arguments.length > 3 ? arguments[3] : undefined;
                var nullSortOrder = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
                var result = this.compare(value1, value2, comparator, order);
                var finalSortOrder = order;
                // nullSortOrder == 1 means Excel like sort nulls at bottom
                if (this.isEmpty(value1) || this.isEmpty(value2)) finalSortOrder = nullSortOrder === 1 ? order : nullSortOrder;
                return finalSortOrder * result;
            }
        },
        {
            key: "compare",
            value: function compare(value1, value2, comparator) {
                var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
                var result = -1;
                var emptyValue1 = this.isEmpty(value1);
                var emptyValue2 = this.isEmpty(value2);
                if (emptyValue1 && emptyValue2) result = 0;
                else if (emptyValue1) result = order;
                else if (emptyValue2) result = -order;
                else if (typeof value1 === 'string' && typeof value2 === 'string') result = comparator(value1, value2);
                else result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
                return result;
            }
        },
        {
            key: "localeComparator",
            value: function localeComparator(locale) {
                //performance gain using Int.Collator. It is not recommended to use localeCompare against large arrays.
                return new Intl.Collator(locale, {
                    numeric: true
                }).compare;
            }
        },
        {
            key: "findChildrenByKey",
            value: function findChildrenByKey(data, key) {
                var _iterator = $a73ce425265b079e$var$_createForOfIteratorHelper(data), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var item = _step.value;
                        if (item.key === key) return item.children || [];
                        else if (item.children) {
                            var result = this.findChildrenByKey(item.children, key);
                            if (result.length > 0) return result;
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return [];
            }
        },
        {
            key: "mutateFieldData",
            value: function mutateFieldData(data, field, value) {
                if ($a73ce425265b079e$var$_typeof(data) !== 'object' || typeof field !== 'string') // short circuit if there is nothing to resolve
                return;
                var fields = field.split('.');
                var obj = data;
                for(var i = 0, len = fields.length; i < len; ++i){
                    // Check if we are on the last field
                    if (i + 1 - len === 0) {
                        obj[fields[i]] = value;
                        break;
                    }
                    if (!obj[fields[i]]) obj[fields[i]] = {};
                    obj = obj[fields[i]];
                }
            }
        }
    ]);
}();
function $a73ce425265b079e$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a73ce425265b079e$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a73ce425265b079e$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $a73ce425265b079e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a73ce425265b079e$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a73ce425265b079e$export$7114f767f3d3c711 = /*#__PURE__*/ function() {
    function IconUtils() {
        $a73ce425265b079e$var$_classCallCheck(this, IconUtils);
    }
    return $a73ce425265b079e$var$_createClass(IconUtils, null, [
        {
            key: "getJSXIcon",
            value: function getJSXIcon(icon) {
                var iconProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var content = null;
                if (icon !== null) {
                    var iconType = $a73ce425265b079e$var$_typeof(icon);
                    var className = $a73ce425265b079e$export$ce4ab0c55987d1ff(iconProps.className, iconType === 'string' && icon);
                    content = /*#__PURE__*/ $acw62.createElement("span", $a73ce425265b079e$var$_extends({}, iconProps, {
                        className: className
                    }));
                    if (iconType !== 'string') {
                        var defaultContentOptions = $a73ce425265b079e$var$_objectSpread$2({
                            iconProps: iconProps,
                            element: content
                        }, options);
                        return $a73ce425265b079e$export$4855211e6b8ad895.getJSXElement(icon, defaultContentOptions);
                    }
                }
                return content;
            }
        }
    ]);
}();
function $a73ce425265b079e$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a73ce425265b079e$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a73ce425265b079e$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $a73ce425265b079e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a73ce425265b079e$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a73ce425265b079e$export$d99f0801a68bbcf1(el, options) {
    var defaultOptions = {
        mask: null,
        slotChar: '_',
        autoClear: true,
        unmask: false,
        readOnly: false,
        onComplete: null,
        onChange: null,
        onFocus: null,
        onBlur: null
    };
    options = $a73ce425265b079e$var$_objectSpread$1($a73ce425265b079e$var$_objectSpread$1({}, defaultOptions), options);
    var tests;
    var partialPosition;
    var len;
    var firstNonMaskPos;
    var defs;
    var androidChrome;
    var lastRequiredNonMaskPos;
    var oldVal;
    var focusText;
    var caretTimeoutId;
    var buffer;
    var defaultBuffer;
    var caret = function caret(first, last) {
        var range;
        var begin;
        var end;
        if (!el.offsetParent || el !== document.activeElement) return;
        if (typeof first === 'number') {
            begin = first;
            end = typeof last === 'number' ? last : begin;
            if (el.setSelectionRange) el.setSelectionRange(begin, end);
            else if (el.createTextRange) {
                range = el.createTextRange();
                range.collapse(true);
                range.moveEnd('character', end);
                range.moveStart('character', begin);
                range.select();
            }
        } else {
            if (el.setSelectionRange) {
                begin = el.selectionStart;
                end = el.selectionEnd;
            } else if (document.selection && document.selection.createRange) {
                range = document.selection.createRange();
                begin = 0 - range.duplicate().moveStart('character', -100000);
                end = begin + range.text.length;
            }
            return {
                begin: begin,
                end: end
            };
        }
    };
    var isCompleted = function isCompleted() {
        for(var i = firstNonMaskPos; i <= lastRequiredNonMaskPos; i++){
            if (tests[i] && buffer[i] === getPlaceholder(i)) return false;
        }
        return true;
    };
    var getPlaceholder = function getPlaceholder(i) {
        if (i < options.slotChar.length) return options.slotChar.charAt(i);
        return options.slotChar.charAt(0);
    };
    var getValue = function getValue() {
        return options.unmask ? getUnmaskedValue() : el && el.value;
    };
    var seekNext = function seekNext(pos) {
        while(++pos < len && !tests[pos]);
        return pos;
    };
    var seekPrev = function seekPrev(pos) {
        while(--pos >= 0 && !tests[pos]);
        return pos;
    };
    var shiftL = function shiftL(begin, end) {
        var i;
        var j;
        if (begin < 0) return;
        for(i = begin, j = seekNext(end); i < len; i++)if (tests[i]) {
            if (j < len && tests[i].test(buffer[j])) {
                buffer[i] = buffer[j];
                buffer[j] = getPlaceholder(j);
            } else break;
            j = seekNext(j);
        }
        writeBuffer();
        caret(Math.max(firstNonMaskPos, begin));
    };
    var shiftR = function shiftR(pos) {
        var i;
        var c;
        var j;
        var t;
        for(i = pos, c = getPlaceholder(pos); i < len; i++)if (tests[i]) {
            j = seekNext(i);
            t = buffer[i];
            buffer[i] = c;
            if (j < len && tests[j].test(t)) c = t;
            else break;
        }
    };
    var handleAndroidInput = function handleAndroidInput(e) {
        var curVal = el.value;
        var pos = caret();
        if (oldVal && oldVal.length && oldVal.length > curVal.length) {
            // a deletion or backspace happened
            checkVal(true);
            while(pos.begin > 0 && !tests[pos.begin - 1])pos.begin--;
            if (pos.begin === 0) while(pos.begin < firstNonMaskPos && !tests[pos.begin])pos.begin++;
            caret(pos.begin, pos.begin);
        } else {
            checkVal(true);
            while(pos.begin < len && !tests[pos.begin])pos.begin++;
            caret(pos.begin, pos.begin);
        }
        if (options.onComplete && isCompleted()) options.onComplete({
            originalEvent: e,
            value: getValue()
        });
    };
    var onBlur = function onBlur(e) {
        checkVal();
        options.onBlur && options.onBlur(e);
        updateModel(e);
        if (el.value !== focusText) {
            var event = document.createEvent('HTMLEvents');
            event.initEvent('change', true, false);
            el.dispatchEvent(event);
        }
    };
    var onKeyDown = function onKeyDown(e) {
        if (options.readOnly) return;
        var k = e.which || e.keyCode;
        var pos;
        var begin;
        var end;
        oldVal = el.value;
        //backspace, delete, and escape get special treatment
        if (k === 8 || k === 46 || $a73ce425265b079e$export$ff8ccbac9225de62.isIOS() && k === 127) {
            pos = caret();
            begin = pos.begin;
            end = pos.end;
            if (end - begin === 0) {
                begin = k !== 46 ? seekPrev(begin) : end = seekNext(begin - 1);
                end = k === 46 ? seekNext(end) : end;
            }
            clearBuffer(begin, end);
            shiftL(begin, end - 1);
            updateModel(e);
            e.preventDefault();
        } else if (k === 13) {
            // enter
            onBlur(e);
            updateModel(e);
        } else if (k === 27) {
            // escape
            el.value = focusText;
            caret(0, checkVal());
            updateModel(e);
            e.preventDefault();
        }
    };
    var onKeyPress = function onKeyPress(e) {
        if (options.readOnly) return;
        var k = e.which || e.keyCode;
        var pos = caret();
        var p;
        var c;
        var next;
        var completed;
        if (e.ctrlKey || e.altKey || e.metaKey || k < 32) //Ignore
        return;
        else if (k && k !== 13) {
            if (pos.end - pos.begin !== 0) {
                clearBuffer(pos.begin, pos.end);
                shiftL(pos.begin, pos.end - 1);
            }
            p = seekNext(pos.begin - 1);
            if (p < len) {
                c = String.fromCharCode(k);
                if (tests[p].test(c)) {
                    shiftR(p);
                    buffer[p] = c;
                    writeBuffer();
                    next = seekNext(p);
                    if ($a73ce425265b079e$export$ff8ccbac9225de62.isAndroid()) {
                        //Path for CSP Violation on FireFox OS 1.1
                        var proxy = function proxy() {
                            caret(next);
                        };
                        setTimeout(proxy, 0);
                    } else caret(next);
                    if (pos.begin <= lastRequiredNonMaskPos) completed = isCompleted();
                }
            }
            e.preventDefault();
        }
        updateModel(e);
        if (options.onComplete && completed) options.onComplete({
            originalEvent: e,
            value: getValue()
        });
    };
    var clearBuffer = function clearBuffer(start, end) {
        var i;
        for(i = start; i < end && i < len; i++)if (tests[i]) buffer[i] = getPlaceholder(i);
    };
    var writeBuffer = function writeBuffer() {
        el.value = buffer.join('');
    };
    var checkVal = function checkVal(allow) {
        //try to place characters where they belong
        var test = el.value;
        var lastMatch = -1;
        var i;
        var c;
        var pos;
        for(i = 0, pos = 0; i < len; i++)if (tests[i]) {
            buffer[i] = getPlaceholder(i);
            while(pos++ < test.length){
                c = test.charAt(pos - 1);
                if (tests[i].test(c)) {
                    buffer[i] = c;
                    lastMatch = i;
                    break;
                }
            }
            if (pos > test.length) {
                clearBuffer(i + 1, len);
                break;
            }
        } else {
            if (buffer[i] === test.charAt(pos)) pos++;
            if (i < partialPosition) lastMatch = i;
        }
        if (allow) writeBuffer();
        else if (lastMatch + 1 < partialPosition) {
            if (options.autoClear || buffer.join('') === defaultBuffer) {
                // Invalid value. Remove it and replace it with the
                // mask, which is the default behavior.
                if (el.value) el.value = '';
                clearBuffer(0, len);
            } else // Invalid value, but we opt to show the value to the
            // user and allow them to correct their mistake.
            writeBuffer();
        } else {
            writeBuffer();
            el.value = el.value.substring(0, lastMatch + 1);
        }
        return partialPosition ? i : firstNonMaskPos;
    };
    var onFocus = function onFocus(e) {
        if (options.readOnly) return;
        clearTimeout(caretTimeoutId);
        var pos;
        focusText = el.value;
        pos = checkVal();
        caretTimeoutId = setTimeout(function() {
            if (el !== document.activeElement) return;
            writeBuffer();
            if (pos === options.mask.replace('?', '').length) caret(0, pos);
            else caret(pos);
        }, 100);
        if (options.onFocus) options.onFocus(e);
    };
    var onInput = function onInput(event) {
        if (androidChrome) handleAndroidInput(event);
        else handleInputChange(event);
    };
    var handleInputChange = function handleInputChange(e) {
        if (options.readOnly) return;
        var pos = checkVal(true);
        caret(pos);
        updateModel(e);
        if (options.onComplete && isCompleted()) options.onComplete({
            originalEvent: e,
            value: getValue()
        });
    };
    var getUnmaskedValue = function getUnmaskedValue() {
        var unmaskedBuffer = [];
        for(var i = 0; i < buffer.length; i++){
            var c = buffer[i];
            if (tests[i] && c !== getPlaceholder(i)) unmaskedBuffer.push(c);
        }
        return unmaskedBuffer.join('');
    };
    var updateModel = function updateModel(e) {
        if (options.onChange) {
            var val = getValue();
            options.onChange({
                originalEvent: e,
                value: defaultBuffer !== val ? val : '',
                stopPropagation: function stopPropagation() {
                    e.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    e.preventDefault();
                },
                target: {
                    value: defaultBuffer !== val ? val : ''
                }
            });
        }
    };
    var bindEvents = function bindEvents() {
        el.addEventListener('focus', onFocus);
        el.addEventListener('blur', onBlur);
        el.addEventListener('keydown', onKeyDown);
        el.addEventListener('keypress', onKeyPress);
        el.addEventListener('input', onInput);
        el.addEventListener('paste', handleInputChange);
    };
    var unbindEvents = function unbindEvents() {
        el.removeEventListener('focus', onFocus);
        el.removeEventListener('blur', onBlur);
        el.removeEventListener('keydown', onKeyDown);
        el.removeEventListener('keypress', onKeyPress);
        el.removeEventListener('input', onInput);
        el.removeEventListener('paste', handleInputChange);
    };
    var init = function init() {
        tests = [];
        partialPosition = options.mask.length;
        len = options.mask.length;
        firstNonMaskPos = null;
        defs = {
            9: '[0-9]',
            a: '[A-Za-z]',
            '*': '[A-Za-z0-9]'
        };
        androidChrome = $a73ce425265b079e$export$ff8ccbac9225de62.isChrome() && $a73ce425265b079e$export$ff8ccbac9225de62.isAndroid();
        var maskTokens = options.mask.split('');
        for(var i = 0; i < maskTokens.length; i++){
            var c = maskTokens[i];
            if (c === '?') {
                len--;
                partialPosition = i;
            } else if (defs[c]) {
                tests.push(new RegExp(defs[c]));
                if (firstNonMaskPos === null) firstNonMaskPos = tests.length - 1;
                if (i < partialPosition) lastRequiredNonMaskPos = tests.length - 1;
            } else tests.push(null);
        }
        buffer = [];
        for(var _i = 0; _i < maskTokens.length; _i++){
            var _c = maskTokens[_i];
            if (_c !== '?') {
                if (defs[_c]) buffer.push(getPlaceholder(_i));
                else buffer.push(_c);
            }
        }
        defaultBuffer = buffer.join('');
    };
    if (el && options.mask) {
        init();
        bindEvents();
    }
    return {
        init: init,
        bindEvents: bindEvents,
        unbindEvents: unbindEvents,
        updateModel: updateModel,
        getValue: getValue
    };
}
function $a73ce425265b079e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a73ce425265b079e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a73ce425265b079e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a73ce425265b079e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a73ce425265b079e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Merges properties together taking an Array of props and merging into one single set of
 * properties. The options can contain a "classNameMergeFunction" which can be something
 * like Tailwind Merge for properly merging Tailwind classes.
 *
 * @param {object[]} props the array of object properties to merge
 * @param {*} options either empty or could contain a custom merge function like TailwindMerge
 * @returns the single properties value after merging
 */ function $a73ce425265b079e$export$9d1611c77c2fe928(props) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!props) return undefined;
    var isFunction = function isFunction(obj) {
        return typeof obj === 'function';
    };
    var classNameMergeFunction = options.classNameMergeFunction;
    var hasMergeFunction = isFunction(classNameMergeFunction);
    return props.reduce(function(merged, ps) {
        if (!ps) return merged;
        var _loop = function _loop() {
            var value = ps[key];
            if (key === 'style') merged.style = $a73ce425265b079e$var$_objectSpread($a73ce425265b079e$var$_objectSpread({}, merged.style), ps.style);
            else if (key === 'className') {
                var newClassName = '';
                if (hasMergeFunction) newClassName = classNameMergeFunction(merged.className, ps.className);
                else newClassName = [
                    merged.className,
                    ps.className
                ].join(' ').trim();
                merged.className = newClassName || undefined;
            } else if (isFunction(value)) {
                var existingFn = merged[key];
                merged[key] = existingFn ? function() {
                    existingFn.apply(void 0, arguments);
                    value.apply(void 0, arguments);
                } : value;
            } else merged[key] = value;
        };
        for(var key in ps)_loop();
        return merged;
    }, {});
}
var $a73ce425265b079e$var$lastId = 0;
function $a73ce425265b079e$export$d5d9b89141473caf() {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'pr_id_';
    $a73ce425265b079e$var$lastId++;
    return "".concat(prefix).concat($a73ce425265b079e$var$lastId);
}
function $a73ce425265b079e$var$handler() {
    var zIndexes = [];
    var generateZIndex = function generateZIndex(key, autoZIndex) {
        var baseZIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 999;
        var lastZIndex = getLastZIndex(key, autoZIndex, baseZIndex);
        var newZIndex = lastZIndex.value + (lastZIndex.key === key ? 0 : baseZIndex) + 1;
        zIndexes.push({
            key: key,
            value: newZIndex
        });
        return newZIndex;
    };
    var revertZIndex = function revertZIndex(zIndex) {
        zIndexes = zIndexes.filter(function(obj) {
            return obj.value !== zIndex;
        });
    };
    var getCurrentZIndex = function getCurrentZIndex(key, autoZIndex) {
        return getLastZIndex(key, autoZIndex).value;
    };
    var getLastZIndex = function getLastZIndex(key, autoZIndex) {
        var baseZIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        return $a73ce425265b079e$var$_toConsumableArray(zIndexes).reverse().find(function(obj) {
            return autoZIndex ? true : obj.key === key;
        }) || {
            key: key,
            value: baseZIndex
        };
    };
    var getZIndex = function getZIndex(el) {
        return el ? parseInt(el.style.zIndex, 10) || 0 : 0;
    };
    return {
        get: getZIndex,
        set: function set(key, el, autoZIndex, baseZIndex) {
            if (el) el.style.zIndex = String(generateZIndex(key, autoZIndex, baseZIndex));
        },
        clear: function clear(el) {
            if (el) {
                revertZIndex($a73ce425265b079e$export$832931caede8e4b9.get(el));
                el.style.zIndex = '';
            }
        },
        getCurrent: function getCurrent(key, autoZIndex) {
            return getCurrentZIndex(key, autoZIndex);
        }
    };
}
var $a73ce425265b079e$export$832931caede8e4b9 = $a73ce425265b079e$var$handler();



var $acw62 = parcelRequire("acw62");
'use client';
var $51b25b42ecc1a0c7$export$b9fbdf9129f67822 = Object.freeze({
    STARTS_WITH: 'startsWith',
    CONTAINS: 'contains',
    NOT_CONTAINS: 'notContains',
    ENDS_WITH: 'endsWith',
    EQUALS: 'equals',
    NOT_EQUALS: 'notEquals',
    IN: 'in',
    LESS_THAN: 'lt',
    LESS_THAN_OR_EQUAL_TO: 'lte',
    GREATER_THAN: 'gt',
    GREATER_THAN_OR_EQUAL_TO: 'gte',
    BETWEEN: 'between',
    DATE_IS: 'dateIs',
    DATE_IS_NOT: 'dateIsNot',
    DATE_BEFORE: 'dateBefore',
    DATE_AFTER: 'dateAfter',
    CUSTOM: 'custom'
});
var $51b25b42ecc1a0c7$export$9cc7a9d8d8c733ca = Object.freeze({
    AND: 'and',
    OR: 'or'
});
function $51b25b42ecc1a0c7$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $51b25b42ecc1a0c7$var$_unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $51b25b42ecc1a0c7$var$_unsupportedIterableToArray$1(r, a) {
    if (r) {
        if ("string" == typeof r) return $51b25b42ecc1a0c7$var$_arrayLikeToArray$1(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $51b25b42ecc1a0c7$var$_arrayLikeToArray$1(r, a) : void 0;
    }
}
function $51b25b42ecc1a0c7$var$_arrayLikeToArray$1(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $51b25b42ecc1a0c7$export$f4fb036b8adcc8c8 = {
    filter: function filter(value, fields, filterValue, filterMatchMode, filterLocale) {
        var filteredItems = [];
        if (!value) return filteredItems;
        var _iterator = $51b25b42ecc1a0c7$var$_createForOfIteratorHelper(value), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var item = _step.value;
                if (typeof item === 'string') {
                    if (this.filters[filterMatchMode](item, filterValue, filterLocale)) {
                        filteredItems.push(item);
                        continue;
                    }
                } else {
                    var _iterator2 = $51b25b42ecc1a0c7$var$_createForOfIteratorHelper(fields), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var field = _step2.value;
                            var fieldValue = (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(item, field);
                            if (this.filters[filterMatchMode](fieldValue, filterValue, filterLocale)) {
                                filteredItems.push(item);
                                break;
                            }
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return filteredItems;
    },
    filters: {
        startsWith: function startsWith(value, filter, filterLocale) {
            if (filter === undefined || filter === null || filter.trim() === '') return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, $a73ce425265b079e$export$4855211e6b8ad895).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, $a73ce425265b079e$export$4855211e6b8ad895).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.slice(0, filterValue.length) === filterValue;
        },
        contains: function contains(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === 'string' && filter.trim() === '') return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, $a73ce425265b079e$export$4855211e6b8ad895).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, $a73ce425265b079e$export$4855211e6b8ad895).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.indexOf(filterValue) !== -1;
        },
        notContains: function notContains(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === 'string' && filter.trim() === '') return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, $a73ce425265b079e$export$4855211e6b8ad895).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, $a73ce425265b079e$export$4855211e6b8ad895).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.indexOf(filterValue) === -1;
        },
        endsWith: function endsWith(value, filter, filterLocale) {
            if (filter === undefined || filter === null || filter.trim() === '') return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, $a73ce425265b079e$export$4855211e6b8ad895).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, $a73ce425265b079e$export$4855211e6b8ad895).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.indexOf(filterValue, stringValue.length - filterValue.length) !== -1;
        },
        equals: function equals(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === 'string' && filter.trim() === '') return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() === filter.getTime();
            return (0, $a73ce425265b079e$export$4855211e6b8ad895).removeAccents(value.toString()).toLocaleLowerCase(filterLocale) === (0, $a73ce425265b079e$export$4855211e6b8ad895).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
        },
        notEquals: function notEquals(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === 'string' && filter.trim() === '') return true;
            if (value === undefined || value === null) return true;
            if (value.getTime && filter.getTime) return value.getTime() !== filter.getTime();
            return (0, $a73ce425265b079e$export$4855211e6b8ad895).removeAccents(value.toString()).toLocaleLowerCase(filterLocale) !== (0, $a73ce425265b079e$export$4855211e6b8ad895).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
        },
        "in": function _in(value, filter) {
            if (filter === undefined || filter === null || filter.length === 0) return true;
            for(var i = 0; i < filter.length; i++){
                if ((0, $a73ce425265b079e$export$4855211e6b8ad895).equals(value, filter[i])) return true;
            }
            return false;
        },
        notIn: function notIn(value, filter) {
            if (filter === undefined || filter === null || filter.length === 0) return true;
            for(var i = 0; i < filter.length; i++){
                if ((0, $a73ce425265b079e$export$4855211e6b8ad895).equals(value, filter[i])) return false;
            }
            return true;
        },
        between: function between(value, filter) {
            if (filter == null || filter[0] == null || filter[1] == null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime) return filter[0].getTime() <= value.getTime() && value.getTime() <= filter[1].getTime();
            return filter[0] <= value && value <= filter[1];
        },
        lt: function lt(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() < filter.getTime();
            return value < filter;
        },
        lte: function lte(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() <= filter.getTime();
            return value <= filter;
        },
        gt: function gt(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() > filter.getTime();
            return value > filter;
        },
        gte: function gte(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() >= filter.getTime();
            return value >= filter;
        },
        dateIs: function dateIs(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.toDateString() === filter.toDateString();
        },
        dateIsNot: function dateIsNot(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.toDateString() !== filter.toDateString();
        },
        dateBefore: function dateBefore(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.getTime() < filter.getTime();
        },
        dateAfter: function dateAfter(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.getTime() > filter.getTime();
        }
    },
    register: function register(rule, fn) {
        this.filters[rule] = fn;
    }
};
function $51b25b42ecc1a0c7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $51b25b42ecc1a0c7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $51b25b42ecc1a0c7$var$_typeof(o);
}
function $51b25b42ecc1a0c7$var$toPrimitive(t, r) {
    if ("object" != $51b25b42ecc1a0c7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $51b25b42ecc1a0c7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $51b25b42ecc1a0c7$var$toPropertyKey(t) {
    var i = $51b25b42ecc1a0c7$var$toPrimitive(t, "string");
    return "symbol" == $51b25b42ecc1a0c7$var$_typeof(i) ? i : i + "";
}
function $51b25b42ecc1a0c7$var$_defineProperty(e, r, t) {
    return (r = $51b25b42ecc1a0c7$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $51b25b42ecc1a0c7$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $51b25b42ecc1a0c7$var$toPropertyKey(o.key), o);
    }
}
function $51b25b42ecc1a0c7$var$_createClass(e, r, t) {
    return r && $51b25b42ecc1a0c7$var$_defineProperties(e.prototype, r), t && $51b25b42ecc1a0c7$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $51b25b42ecc1a0c7$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
/**
 * @deprecated please use PrimeReactContext
 */ var $51b25b42ecc1a0c7$var$PrimeReact$1 = /*#__PURE__*/ $51b25b42ecc1a0c7$var$_createClass(function PrimeReact() {
    $51b25b42ecc1a0c7$var$_classCallCheck(this, PrimeReact);
});
$51b25b42ecc1a0c7$var$_defineProperty($51b25b42ecc1a0c7$var$PrimeReact$1, "ripple", false);
$51b25b42ecc1a0c7$var$_defineProperty($51b25b42ecc1a0c7$var$PrimeReact$1, "inputStyle", 'outlined');
$51b25b42ecc1a0c7$var$_defineProperty($51b25b42ecc1a0c7$var$PrimeReact$1, "locale", 'en');
$51b25b42ecc1a0c7$var$_defineProperty($51b25b42ecc1a0c7$var$PrimeReact$1, "appendTo", null);
$51b25b42ecc1a0c7$var$_defineProperty($51b25b42ecc1a0c7$var$PrimeReact$1, "cssTransition", true);
$51b25b42ecc1a0c7$var$_defineProperty($51b25b42ecc1a0c7$var$PrimeReact$1, "autoZIndex", true);
$51b25b42ecc1a0c7$var$_defineProperty($51b25b42ecc1a0c7$var$PrimeReact$1, "hideOverlaysOnDocumentScrolling", false);
$51b25b42ecc1a0c7$var$_defineProperty($51b25b42ecc1a0c7$var$PrimeReact$1, "nonce", null);
$51b25b42ecc1a0c7$var$_defineProperty($51b25b42ecc1a0c7$var$PrimeReact$1, "nullSortOrder", 1);
$51b25b42ecc1a0c7$var$_defineProperty($51b25b42ecc1a0c7$var$PrimeReact$1, "zIndex", {
    modal: 1100,
    overlay: 1000,
    menu: 1000,
    tooltip: 1100,
    toast: 1200
});
$51b25b42ecc1a0c7$var$_defineProperty($51b25b42ecc1a0c7$var$PrimeReact$1, "pt", undefined);
$51b25b42ecc1a0c7$var$_defineProperty($51b25b42ecc1a0c7$var$PrimeReact$1, "filterMatchModeOptions", {
    text: [
        $51b25b42ecc1a0c7$export$b9fbdf9129f67822.STARTS_WITH,
        $51b25b42ecc1a0c7$export$b9fbdf9129f67822.CONTAINS,
        $51b25b42ecc1a0c7$export$b9fbdf9129f67822.NOT_CONTAINS,
        $51b25b42ecc1a0c7$export$b9fbdf9129f67822.ENDS_WITH,
        $51b25b42ecc1a0c7$export$b9fbdf9129f67822.EQUALS,
        $51b25b42ecc1a0c7$export$b9fbdf9129f67822.NOT_EQUALS
    ],
    numeric: [
        $51b25b42ecc1a0c7$export$b9fbdf9129f67822.EQUALS,
        $51b25b42ecc1a0c7$export$b9fbdf9129f67822.NOT_EQUALS,
        $51b25b42ecc1a0c7$export$b9fbdf9129f67822.LESS_THAN,
        $51b25b42ecc1a0c7$export$b9fbdf9129f67822.LESS_THAN_OR_EQUAL_TO,
        $51b25b42ecc1a0c7$export$b9fbdf9129f67822.GREATER_THAN,
        $51b25b42ecc1a0c7$export$b9fbdf9129f67822.GREATER_THAN_OR_EQUAL_TO
    ],
    date: [
        $51b25b42ecc1a0c7$export$b9fbdf9129f67822.DATE_IS,
        $51b25b42ecc1a0c7$export$b9fbdf9129f67822.DATE_IS_NOT,
        $51b25b42ecc1a0c7$export$b9fbdf9129f67822.DATE_BEFORE,
        $51b25b42ecc1a0c7$export$b9fbdf9129f67822.DATE_AFTER
    ]
});
$51b25b42ecc1a0c7$var$_defineProperty($51b25b42ecc1a0c7$var$PrimeReact$1, "changeTheme", function(currentTheme, newTheme, linkElementId, callback) {
    var _linkElement$parentNo;
    var linkElement = document.getElementById(linkElementId);
    if (!linkElement) throw Error("Element with id ".concat(linkElementId, " not found."));
    var newThemeUrl = linkElement.getAttribute('href').replace(currentTheme, newTheme);
    var newLinkElement = document.createElement('link');
    newLinkElement.setAttribute('rel', 'stylesheet');
    newLinkElement.setAttribute('id', linkElementId);
    newLinkElement.setAttribute('href', newThemeUrl);
    newLinkElement.addEventListener('load', function() {
        if (callback) callback();
    });
    (_linkElement$parentNo = linkElement.parentNode) === null || _linkElement$parentNo === void 0 || _linkElement$parentNo.replaceChild(newLinkElement, linkElement);
});
function $51b25b42ecc1a0c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $51b25b42ecc1a0c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $51b25b42ecc1a0c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $51b25b42ecc1a0c7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $51b25b42ecc1a0c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $51b25b42ecc1a0c7$var$locales = {
    en: {
        accept: 'Yes',
        addRule: 'Add Rule',
        am: 'AM',
        apply: 'Apply',
        cancel: 'Cancel',
        choose: 'Choose',
        chooseDate: 'Choose Date',
        chooseMonth: 'Choose Month',
        chooseYear: 'Choose Year',
        clear: 'Clear',
        completed: 'Completed',
        contains: 'Contains',
        custom: 'Custom',
        dateAfter: 'Date is after',
        dateBefore: 'Date is before',
        dateFormat: 'mm/dd/yy',
        dateIs: 'Date is',
        dateIsNot: 'Date is not',
        dayNames: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ],
        dayNamesMin: [
            'Su',
            'Mo',
            'Tu',
            'We',
            'Th',
            'Fr',
            'Sa'
        ],
        dayNamesShort: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ],
        emptyFilterMessage: 'No results found',
        emptyMessage: 'No available options',
        emptySearchMessage: 'No results found',
        emptySelectionMessage: 'No selected item',
        endsWith: 'Ends with',
        equals: 'Equals',
        fileSizeTypes: [
            'B',
            'KB',
            'MB',
            'GB',
            'TB',
            'PB',
            'EB',
            'ZB',
            'YB'
        ],
        filter: 'Filter',
        firstDayOfWeek: 0,
        gt: 'Greater than',
        gte: 'Greater than or equal to',
        lt: 'Less than',
        lte: 'Less than or equal to',
        matchAll: 'Match All',
        matchAny: 'Match Any',
        medium: 'Medium',
        monthNames: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        monthNamesShort: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        nextDecade: 'Next Decade',
        nextHour: 'Next Hour',
        nextMinute: 'Next Minute',
        nextMonth: 'Next Month',
        nextSecond: 'Next Second',
        nextYear: 'Next Year',
        noFilter: 'No Filter',
        notContains: 'Not contains',
        notEquals: 'Not equals',
        now: 'Now',
        passwordPrompt: 'Enter a password',
        pending: 'Pending',
        pm: 'PM',
        prevDecade: 'Previous Decade',
        prevHour: 'Previous Hour',
        prevMinute: 'Previous Minute',
        prevMonth: 'Previous Month',
        prevSecond: 'Previous Second',
        prevYear: 'Previous Year',
        reject: 'No',
        removeRule: 'Remove Rule',
        searchMessage: '{0} results are available',
        selectionMessage: '{0} items selected',
        showMonthAfterYear: false,
        startsWith: 'Starts with',
        strong: 'Strong',
        today: 'Today',
        upload: 'Upload',
        weak: 'Weak',
        weekHeader: 'Wk',
        aria: {
            cancelEdit: 'Cancel Edit',
            close: 'Close',
            collapseRow: 'Row Collapsed',
            editRow: 'Edit Row',
            expandRow: 'Row Expanded',
            falseLabel: 'False',
            filterConstraint: 'Filter Constraint',
            filterOperator: 'Filter Operator',
            firstPageLabel: 'First Page',
            gridView: 'Grid View',
            hideFilterMenu: 'Hide Filter Menu',
            jumpToPageDropdownLabel: 'Jump to Page Dropdown',
            jumpToPageInputLabel: 'Jump to Page Input',
            lastPageLabel: 'Last Page',
            listView: 'List View',
            moveAllToSource: 'Move All to Source',
            moveAllToTarget: 'Move All to Target',
            moveBottom: 'Move Bottom',
            moveDown: 'Move Down',
            moveToSource: 'Move to Source',
            moveToTarget: 'Move to Target',
            moveTop: 'Move Top',
            moveUp: 'Move Up',
            navigation: 'Navigation',
            next: 'Next',
            nextPageLabel: 'Next Page',
            nullLabel: 'Not Selected',
            pageLabel: 'Page {page}',
            otpLabel: 'Please enter one time password character {0}',
            passwordHide: 'Hide Password',
            passwordShow: 'Show Password',
            previous: 'Previous',
            previousPageLabel: 'Previous Page',
            rotateLeft: 'Rotate Left',
            rotateRight: 'Rotate Right',
            rowsPerPageLabel: 'Rows per page',
            saveEdit: 'Save Edit',
            scrollTop: 'Scroll Top',
            selectAll: 'All items selected',
            selectRow: 'Row Selected',
            showFilterMenu: 'Show Filter Menu',
            slide: 'Slide',
            slideNumber: '{slideNumber}',
            star: '1 star',
            stars: '{star} stars',
            trueLabel: 'True',
            unselectAll: 'All items unselected',
            unselectRow: 'Row Unselected',
            zoomImage: 'Zoom Image',
            zoomIn: 'Zoom In',
            zoomOut: 'Zoom Out'
        }
    }
};
function $51b25b42ecc1a0c7$export$162ce11d62a1ca51(locale) {
    locale && ($51b25b42ecc1a0c7$var$PrimeReact$1.locale = locale);
    return {
        locale: $51b25b42ecc1a0c7$var$PrimeReact$1.locale,
        options: $51b25b42ecc1a0c7$var$locales[$51b25b42ecc1a0c7$var$PrimeReact$1.locale]
    };
}
function $51b25b42ecc1a0c7$export$3ab428da39598a54(locale, options) {
    if (locale.includes('__proto__') || locale.includes('prototype')) throw new Error('Unsafe locale detected');
    $51b25b42ecc1a0c7$var$locales[locale] = $51b25b42ecc1a0c7$var$_objectSpread($51b25b42ecc1a0c7$var$_objectSpread({}, $51b25b42ecc1a0c7$var$locales.en), options);
}
function $51b25b42ecc1a0c7$export$7cd3e26e5d06a8a9(key, value, locale) {
    if (key.includes('__proto__') || key.includes('prototype')) throw new Error('Unsafe key detected');
    $51b25b42ecc1a0c7$export$ef9c48731c26e22d(locale)[key] = value;
}
function $51b25b42ecc1a0c7$export$8024ed7ed764e4fc(options, locale) {
    if (locale.includes('__proto__') || locale.includes('prototype')) throw new Error('Unsafe locale detected');
    var _locale = locale || $51b25b42ecc1a0c7$var$PrimeReact$1.locale;
    $51b25b42ecc1a0c7$var$locales[_locale] = $51b25b42ecc1a0c7$var$_objectSpread($51b25b42ecc1a0c7$var$_objectSpread({}, $51b25b42ecc1a0c7$var$locales[_locale]), options);
}
function $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a(key, locale) {
    if (key.includes('__proto__') || key.includes('prototype')) throw new Error('Unsafe key detected');
    var _locale = locale || $51b25b42ecc1a0c7$var$PrimeReact$1.locale;
    try {
        return $51b25b42ecc1a0c7$export$ef9c48731c26e22d(_locale)[key];
    } catch (error) {
        throw new Error("The ".concat(key, " option is not found in the current locale('").concat(_locale, "')."));
    }
}
/**
 * Find an ARIA label in the locale by key.  If options are passed it will replace all options:
 * ```ts
 * const ariaValue = "Page {page}, User {user}, Role {role}";
 * const options = { page: 2, user: "John", role: "Admin" };
 * const result = ariaLabel('yourLabel', { page: 2, user: "John", role: "Admin" })
 * console.log(result); // Output: Page 2, User John, Role Admin
 * ```
 * @param {string} ariaKey key of the ARIA label to look up in locale.
 * @param {any} options JSON options like { page: 2, user: "John", role: "Admin" }
 * @returns the ARIA label with replaced values
 */ function $51b25b42ecc1a0c7$export$eb839c9fd3d638b9(ariaKey, options) {
    if (ariaKey.includes('__proto__') || ariaKey.includes('prototype')) throw new Error('Unsafe ariaKey detected');
    var _locale = $51b25b42ecc1a0c7$var$PrimeReact$1.locale;
    try {
        var _ariaLabel = $51b25b42ecc1a0c7$export$ef9c48731c26e22d(_locale).aria[ariaKey];
        if (_ariaLabel) {
            for(var key in options)if (options.hasOwnProperty(key)) _ariaLabel = _ariaLabel.replace("{".concat(key, "}"), options[key]);
        }
        return _ariaLabel;
    } catch (error) {
        throw new Error("The ".concat(ariaKey, " option is not found in the current locale('").concat(_locale, "')."));
    }
}
function $51b25b42ecc1a0c7$export$ef9c48731c26e22d(locale) {
    var _locale = locale || $51b25b42ecc1a0c7$var$PrimeReact$1.locale;
    if (_locale.includes('__proto__') || _locale.includes('prototype')) throw new Error('Unsafe locale detected');
    return $51b25b42ecc1a0c7$var$locales[_locale];
}
var $51b25b42ecc1a0c7$export$bb45678bd9ad9127 = Object.freeze({
    SUCCESS: 'success',
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error',
    SECONDARY: 'secondary',
    CONTRAST: 'contrast'
});
var $51b25b42ecc1a0c7$export$9daa7f1467519fd8 = Object.freeze({
    ADDRESS_BOOK: 'pi pi-address-book',
    ALIGN_CENTER: 'pi pi-align-center',
    ALIGN_JUSTIFY: 'pi pi-align-justify',
    ALIGN_LEFT: 'pi pi-align-left',
    ALIGN_RIGHT: 'pi pi-align-right',
    AMAZON: 'pi pi-amazon',
    ANDROID: 'pi pi-android',
    ANGLE_DOUBLE_DOWN: 'pi pi-angle-double-down',
    ANGLE_DOUBLE_LEFT: 'pi pi-angle-double-left',
    ANGLE_DOUBLE_RIGHT: 'pi pi-angle-double-right',
    ANGLE_DOUBLE_UP: 'pi pi-angle-double-up',
    ANGLE_DOWN: 'pi pi-angle-down',
    ANGLE_LEFT: 'pi pi-angle-left',
    ANGLE_RIGHT: 'pi pi-angle-right',
    ANGLE_UP: 'pi pi-angle-up',
    APPLE: 'pi pi-apple',
    ARROW_CIRCLE_DOWN: 'pi pi-arrow-circle-down',
    ARROW_CIRCLE_LEFT: 'pi pi-arrow-circle-left',
    ARROW_CIRCLE_RIGHT: 'pi pi-arrow-circle-right',
    ARROW_CIRCLE_UP: 'pi pi-arrow-circle-up',
    ARROW_DOWN_LEFT_AND_ARROW_UP_RIGHT_TO_CENTER: 'pi pi-arrow-down-left-and-arrow-up-right-to-center',
    ARROW_DOWN_LEFT: 'pi pi-arrow-down-left',
    ARROW_DOWN_RIGHT: 'pi pi-arrow-down-right',
    ARROW_DOWN: 'pi pi-arrow-down',
    ARROW_LEFT: 'pi pi-arrow-left',
    ARROW_RIGHT_ARROW_LEFT: 'pi pi-arrow-right-arrow-left',
    ARROW_RIGHT: 'pi pi-arrow-right',
    ARROW_UP_LEFT: 'pi pi-arrow-up-left',
    ARROW_UP_RIGHT_AND_ARROW_DOWN_LEFT_FROM_CENTER: 'pi pi-arrow-up-right-and-arrow-down-left-from-center',
    ARROW_UP_RIGHT: 'pi pi-arrow-up-right',
    ARROW_UP: 'pi pi-arrow-up',
    ARROWS_ALT: 'pi pi-arrows-alt',
    ARROWS_H: 'pi pi-arrows-h',
    ARROWS_V: 'pi pi-arrows-v',
    ASTERISK: 'pi pi-asterisk',
    AT: 'pi pi-at',
    BACKWARD: 'pi pi-backward',
    BAN: 'pi pi-ban',
    BARCODE: 'pi pi-barcode',
    BARS: 'pi pi-bars',
    BELL_SLASH: 'pi pi-bell-slash',
    BELL: 'pi pi-bell',
    BITCOIN: 'pi pi-bitcoin',
    BOLT: 'pi pi-bolt',
    BOOK: 'pi pi-book',
    BOOKMARK_FILL: 'pi pi-bookmark-fill',
    BOOKMARK: 'pi pi-bookmark',
    BOX: 'pi pi-box',
    BRIEFCASE: 'pi pi-briefcase',
    BUILDING_COLUMNS: 'pi pi-building-columns',
    BUILDING: 'pi pi-building',
    BULLSEYE: 'pi pi-bullseye',
    CALCULATOR: 'pi pi-calculator',
    CALENDAR_CLOCK: 'pi pi-calendar-clock',
    CALENDAR_MINUS: 'pi pi-calendar-minus',
    CALENDAR_PLUS: 'pi pi-calendar-plus',
    CALENDAR_TIMES: 'pi pi-calendar-times',
    CALENDAR: 'pi pi-calendar',
    CAMERA: 'pi pi-camera',
    CAR: 'pi pi-car',
    CARET_DOWN: 'pi pi-caret-down',
    CARET_LEFT: 'pi pi-caret-left',
    CARET_RIGHT: 'pi pi-caret-right',
    CARET_UP: 'pi pi-caret-up',
    CART_ARROW_DOWN: 'pi pi-cart-arrow-down',
    CART_MINUS: 'pi pi-cart-minus',
    CART_PLUS: 'pi pi-cart-plus',
    CHART_BAR: 'pi pi-chart-bar',
    CHART_LINE: 'pi pi-chart-line',
    CHART_PIE: 'pi pi-chart-pie',
    CHART_SCATTER: 'pi pi-chart-scatter',
    CHECK_CIRCLE: 'pi pi-check-circle',
    CHECK_SQUARE: 'pi pi-check-square',
    CHECK: 'pi pi-check',
    CHEVRON_CIRCLE_DOWN: 'pi pi-chevron-circle-down',
    CHEVRON_CIRCLE_LEFT: 'pi pi-chevron-circle-left',
    CHEVRON_CIRCLE_RIGHT: 'pi pi-chevron-circle-right',
    CHEVRON_CIRCLE_UP: 'pi pi-chevron-circle-up',
    CHEVRON_DOWN: 'pi pi-chevron-down',
    CHEVRON_LEFT: 'pi pi-chevron-left',
    CHEVRON_RIGHT: 'pi pi-chevron-right',
    CHEVRON_UP: 'pi pi-chevron-up',
    CIRCLE_FILL: 'pi pi-circle-fill',
    CIRCLE_OFF: 'pi pi-circle-off',
    CIRCLE_ON: 'pi pi-circle-on',
    CIRCLE: 'pi pi-circle',
    CLIPBOARD: 'pi pi-clipboard',
    CLOCK: 'pi pi-clock',
    CLONE: 'pi pi-clone',
    CLOUD_DOWNLOAD: 'pi pi-cloud-download',
    CLOUD_UPLOAD: 'pi pi-cloud-upload',
    CLOUD: 'pi pi-cloud',
    CODE: 'pi pi-code',
    COG: 'pi pi-cog',
    COMMENT: 'pi pi-comment',
    COMMENTS: 'pi pi-comments',
    COMPASS: 'pi pi-compass',
    COPY: 'pi pi-copy',
    CREDIT_CARD: 'pi pi-credit-card',
    CROWN: 'pi pi-crown',
    DATABASE: 'pi pi-database',
    DELETE_LEFT: 'pi pi-delete-left',
    DESKTOP: 'pi pi-desktop',
    DIRECTIONS_ALT: 'pi pi-directions-alt',
    DIRECTIONS: 'pi pi-directions',
    DISCORD: 'pi pi-discord',
    DOLLAR: 'pi pi-dollar',
    DOWNLOAD: 'pi pi-download',
    EJECT: 'pi pi-eject',
    ELLIPSIS_H: 'pi pi-ellipsis-h',
    ELLIPSIS_V: 'pi pi-ellipsis-v',
    ENVELOPE: 'pi pi-envelope',
    EQUALS: 'pi pi-equals',
    ERASER: 'pi pi-eraser',
    ETHEREUM: 'pi pi-ethereum',
    EURO: 'pi pi-euro',
    EXCLAMATION_CIRCLE: 'pi pi-exclamation-circle',
    EXCLAMATION_TRIANGLE: 'pi pi-exclamation-triangle',
    EXPAND: 'pi pi-expand',
    EXTERNAL_LINK: 'pi pi-external-link',
    EYE_SLASH: 'pi pi-eye-slash',
    EYE: 'pi pi-eye',
    FACE_SMILE: 'pi pi-face-smile',
    FACEBOOK: 'pi pi-facebook',
    FAST_BACKWARD: 'pi pi-fast-backward',
    FAST_FORWARD: 'pi pi-fast-forward',
    FILE_ARROW_UP: 'pi pi-file-arrow-up',
    FILE_CHECK: 'pi pi-file-check',
    FILE_EDIT: 'pi pi-file-edit',
    FILE_EXCEL: 'pi pi-file-excel',
    FILE_EXPORT: 'pi pi-file-export',
    FILE_IMPORT: 'pi pi-file-import',
    FILE_O: 'pi pi-file-o',
    FILE_PDF: 'pi pi-file-pdf',
    FILE_PLUS: 'pi pi-file-plus',
    FILE_WORD: 'pi pi-file-word',
    FILE: 'pi pi-file',
    FILTER_FILL: 'pi pi-filter-fill',
    FILTER_SLASH: 'pi pi-filter-slash',
    FILTER: 'pi pi-filter',
    FLAG_FILL: 'pi pi-flag-fill',
    FLAG: 'pi pi-flag',
    FOLDER_OPEN: 'pi pi-folder-open',
    FOLDER_PLUS: 'pi pi-folder-plus',
    FOLDER: 'pi pi-folder',
    FORWARD: 'pi pi-forward',
    GAUGE: 'pi pi-gauge',
    GIFT: 'pi pi-gift',
    GITHUB: 'pi pi-github',
    GLOBE: 'pi pi-globe',
    GOOGLE: 'pi pi-google',
    GRADUATION_CAP: 'pi pi-graduation-cap',
    HAMMER: 'pi pi-hammer',
    HASHTAG: 'pi pi-hashtag',
    HEADPHONES: 'pi pi-headphones',
    HEART_FILL: 'pi pi-heart-fill',
    HEART: 'pi pi-heart',
    HISTORY: 'pi pi-history',
    HOME: 'pi pi-home',
    HOURGLASS: 'pi pi-hourglass',
    ID_CARD: 'pi pi-id-card',
    IMAGE: 'pi pi-image',
    IMAGES: 'pi pi-images',
    INBOX: 'pi pi-inbox',
    INDIAN_RUPEE: 'pi pi-indian-rupee',
    INFO_CIRCLE: 'pi pi-info-circle',
    INFO: 'pi pi-info',
    INSTAGRAM: 'pi pi-instagram',
    KEY: 'pi pi-key',
    LANGUAGE: 'pi pi-language',
    LIGHTBULB: 'pi pi-lightbulb',
    LINK: 'pi pi-link',
    LINKEDIN: 'pi pi-linkedin',
    LIST_CHECK: 'pi pi-list-check',
    LIST: 'pi pi-list',
    LOCK_OPEN: 'pi pi-lock-open',
    LOCK: 'pi pi-lock',
    MAP_MARKER: 'pi pi-map-marker',
    MAP: 'pi pi-map',
    MARS: 'pi pi-mars',
    MEGAPHONE: 'pi pi-megaphone',
    MICROCHIP_AI: 'pi pi-microchip-ai',
    MICROCHIP: 'pi pi-microchip',
    MICROPHONE: 'pi pi-microphone',
    MICROSOFT: 'pi pi-microsoft',
    MINUS_CIRCLE: 'pi pi-minus-circle',
    MINUS: 'pi pi-minus',
    MOBILE: 'pi pi-mobile',
    MONEY_BILL: 'pi pi-money-bill',
    MOON: 'pi pi-moon',
    OBJECTS_COLUMN: 'pi pi-objects-column',
    PALETTE: 'pi pi-palette',
    PAPERCLIP: 'pi pi-paperclip',
    PAUSE_CIRCLE: 'pi pi-pause-circle',
    PAUSE: 'pi pi-pause',
    PAYPAL: 'pi pi-paypal',
    PEN_TO_SQUARE: 'pi pi-pen-to-square',
    PENCIL: 'pi pi-pencil',
    PERCENTAGE: 'pi pi-percentage',
    PHONE: 'pi pi-phone',
    PINTEREST: 'pi pi-pinterest',
    PLAY_CIRCLE: 'pi pi-play-circle',
    PLAY: 'pi pi-play',
    PLUS_CIRCLE: 'pi pi-plus-circle',
    PLUS: 'pi pi-plus',
    POUND: 'pi pi-pound',
    POWER_OFF: 'pi pi-power-off',
    PRIME: 'pi pi-prime',
    PRINT: 'pi pi-print',
    QRCODE: 'pi pi-qrcode',
    QUESTION_CIRCLE: 'pi pi-question-circle',
    QUESTION: 'pi pi-question',
    RECEIPT: 'pi pi-receipt',
    REDDIT: 'pi pi-reddit',
    REFRESH: 'pi pi-refresh',
    REPLAY: 'pi pi-replay',
    REPLY: 'pi pi-reply',
    SAVE: 'pi pi-save',
    SEARCH_MINUS: 'pi pi-search-minus',
    SEARCH_PLUS: 'pi pi-search-plus',
    SEARCH: 'pi pi-search',
    SEND: 'pi pi-send',
    SERVER: 'pi pi-server',
    SHARE_ALT: 'pi pi-share-alt',
    SHIELD: 'pi pi-shield',
    SHOP: 'pi pi-shop',
    SHOPPING_BAG: 'pi pi-shopping-bag',
    SHOPPING_CART: 'pi pi-shopping-cart',
    SIGN_IN: 'pi pi-sign-in',
    SIGN_OUT: 'pi pi-sign-out',
    SITEMAP: 'pi pi-sitemap',
    SLACK: 'pi pi-slack',
    SLIDERS_H: 'pi pi-sliders-h',
    SLIDERS_V: 'pi pi-sliders-v',
    SORT_ALPHA_DOWN_ALT: 'pi pi-sort-alpha-down-alt',
    SORT_ALPHA_DOWN: 'pi pi-sort-alpha-down',
    SORT_ALPHA_UP_ALT: 'pi pi-sort-alpha-up-alt',
    SORT_ALPHA_UP: 'pi pi-sort-alpha-up',
    SORT_ALT_SLASH: 'pi pi-sort-alt-slash',
    SORT_ALT: 'pi pi-sort-alt',
    SORT_AMOUNT_DOWN_ALT: 'pi pi-sort-amount-down-alt',
    SORT_AMOUNT_DOWN: 'pi pi-sort-amount-down',
    SORT_AMOUNT_UP_ALT: 'pi pi-sort-amount-up-alt',
    SORT_AMOUNT_UP: 'pi pi-sort-amount-up',
    SORT_DOWN_FILL: 'pi pi-sort-down-fill',
    SORT_DOWN: 'pi pi-sort-down',
    SORT_NUMERIC_DOWN_ALT: 'pi pi-sort-numeric-down-alt',
    SORT_NUMERIC_DOWN: 'pi pi-sort-numeric-down',
    SORT_NUMERIC_UP_ALT: 'pi pi-sort-numeric-up-alt',
    SORT_NUMERIC_UP: 'pi pi-sort-numeric-up',
    SORT_UP_FILL: 'pi pi-sort-up-fill',
    SORT_UP: 'pi pi-sort-up',
    SORT: 'pi pi-sort',
    SPARKLES: 'pi pi-sparkles',
    SPINNER_DOTTED: 'pi pi-spinner-dotted',
    SPINNER: 'pi pi-spinner',
    STAR_FILL: 'pi pi-star-fill',
    STAR_HALF_FILL: 'pi pi-star-half-fill',
    STAR_HALF: 'pi pi-star-half',
    STAR: 'pi pi-star',
    STEP_BACKWARD_ALT: 'pi pi-step-backward-alt',
    STEP_BACKWARD: 'pi pi-step-backward',
    STEP_FORWARD_ALT: 'pi pi-step-forward-alt',
    STEP_FORWARD: 'pi pi-step-forward',
    STOP_CIRCLE: 'pi pi-stop-circle',
    STOP: 'pi pi-stop',
    STOPWATCH: 'pi pi-stopwatch',
    SUN: 'pi pi-sun',
    SYNC: 'pi pi-sync',
    TABLE: 'pi pi-table',
    TABLET: 'pi pi-tablet',
    TAG: 'pi pi-tag',
    TAGS: 'pi pi-tags',
    TELEGRAM: 'pi pi-telegram',
    TH_LARGE: 'pi pi-th-large',
    THUMBS_DOWN_FILL: 'pi pi-thumbs-down-fill',
    THUMBS_DOWN: 'pi pi-thumbs-down',
    THUMBS_UP_FILL: 'pi pi-thumbs-up-fill',
    THUMBS_UP: 'pi pi-thumbs-up',
    THUMBTACK: 'pi pi-thumbtack',
    TICKET: 'pi pi-ticket',
    TIKTOK: 'pi pi-tiktok',
    TIMES_CIRCLE: 'pi pi-times-circle',
    TIMES: 'pi pi-times',
    TRASH: 'pi pi-trash',
    TROPHY: 'pi pi-trophy',
    TRUCK: 'pi pi-truck',
    TURKISH_LIRA: 'pi pi-turkish-lira',
    TWITCH: 'pi pi-twitch',
    TWITTER: 'pi pi-twitter',
    UNDO: 'pi pi-undo',
    UNLOCK: 'pi pi-unlock',
    UPLOAD: 'pi pi-upload',
    USER_EDIT: 'pi pi-user-edit',
    USER_MINUS: 'pi pi-user-minus',
    USER_PLUS: 'pi pi-user-plus',
    USER: 'pi pi-user',
    USERS: 'pi pi-users',
    VENUS: 'pi pi-venus',
    VERIFIED: 'pi pi-verified',
    VIDEO: 'pi pi-video',
    VIMEO: 'pi pi-vimeo',
    VOLUME_DOWN: 'pi pi-volume-down',
    VOLUME_OFF: 'pi pi-volume-off',
    VOLUME_UP: 'pi pi-volume-up',
    WALLET: 'pi pi-wallet',
    WAREHOUSE: 'pi pi-warehouse',
    WAVE_PULSE: 'pi pi-wave-pulse',
    WHATSAPP: 'pi pi-whatsapp',
    WIFI: 'pi pi-wifi',
    WINDOW_MAXIMIZE: 'pi pi-window-maximize',
    WINDOW_MINIMIZE: 'pi pi-window-minimize',
    WRENCH: 'pi pi-wrench',
    YOUTUBE: 'pi pi-youtube'
});
var $51b25b42ecc1a0c7$export$7ae723045d45777a = Object.freeze({
    DESC: -1,
    UNSORTED: 0,
    ASC: 1
});
function $51b25b42ecc1a0c7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $51b25b42ecc1a0c7$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $51b25b42ecc1a0c7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $51b25b42ecc1a0c7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $51b25b42ecc1a0c7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $51b25b42ecc1a0c7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $51b25b42ecc1a0c7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $51b25b42ecc1a0c7$var$_slicedToArray(r, e) {
    return $51b25b42ecc1a0c7$var$_arrayWithHoles(r) || $51b25b42ecc1a0c7$var$_iterableToArrayLimit(r, e) || $51b25b42ecc1a0c7$var$_unsupportedIterableToArray(r, e) || $51b25b42ecc1a0c7$var$_nonIterableRest();
}
var $51b25b42ecc1a0c7$export$43502877ff87a530 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext();
var $51b25b42ecc1a0c7$export$6a5b5c2279ff1e8d = function PrimeReactProvider(props) {
    var _props$value, _propsValue$ripple, _propsValue$inputStyl, _propsValue$locale, _propsValue$appendTo, _propsValue$styleCont, _propsValue$cssTransi, _propsValue$autoZInde, _propsValue$hideOverl, _propsValue$nonce, _propsValue$nullSortO, _propsValue$zIndex, _propsValue$ptOptions, _propsValue$pt, _propsValue$unstyled, _propsValue$filterMat;
    var propsValue = (_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : {};
    var _useState = (0, $acw62.useState)((_propsValue$ripple = propsValue.ripple) !== null && _propsValue$ripple !== void 0 ? _propsValue$ripple : false), _useState2 = $51b25b42ecc1a0c7$var$_slicedToArray(_useState, 2), ripple = _useState2[0], setRipple = _useState2[1];
    var _useState3 = (0, $acw62.useState)((_propsValue$inputStyl = propsValue.inputStyle) !== null && _propsValue$inputStyl !== void 0 ? _propsValue$inputStyl : 'outlined'), _useState4 = $51b25b42ecc1a0c7$var$_slicedToArray(_useState3, 2), inputStyle = _useState4[0], setInputStyle = _useState4[1];
    var _useState5 = (0, $acw62.useState)((_propsValue$locale = propsValue.locale) !== null && _propsValue$locale !== void 0 ? _propsValue$locale : 'en'), _useState6 = $51b25b42ecc1a0c7$var$_slicedToArray(_useState5, 2), locale = _useState6[0], setLocale = _useState6[1];
    var _useState7 = (0, $acw62.useState)((_propsValue$appendTo = propsValue.appendTo) !== null && _propsValue$appendTo !== void 0 ? _propsValue$appendTo : null), _useState8 = $51b25b42ecc1a0c7$var$_slicedToArray(_useState7, 2), appendTo = _useState8[0], setAppendTo = _useState8[1];
    var _useState9 = (0, $acw62.useState)((_propsValue$styleCont = propsValue.styleContainer) !== null && _propsValue$styleCont !== void 0 ? _propsValue$styleCont : null), _useState10 = $51b25b42ecc1a0c7$var$_slicedToArray(_useState9, 2), styleContainer = _useState10[0], setStyleContainer = _useState10[1];
    var _useState11 = (0, $acw62.useState)((_propsValue$cssTransi = propsValue.cssTransition) !== null && _propsValue$cssTransi !== void 0 ? _propsValue$cssTransi : true), _useState12 = $51b25b42ecc1a0c7$var$_slicedToArray(_useState11, 2), cssTransition = _useState12[0], setCssTransition = _useState12[1];
    var _useState13 = (0, $acw62.useState)((_propsValue$autoZInde = propsValue.autoZIndex) !== null && _propsValue$autoZInde !== void 0 ? _propsValue$autoZInde : true), _useState14 = $51b25b42ecc1a0c7$var$_slicedToArray(_useState13, 2), autoZIndex = _useState14[0], setAutoZIndex = _useState14[1];
    var _useState15 = (0, $acw62.useState)((_propsValue$hideOverl = propsValue.hideOverlaysOnDocumentScrolling) !== null && _propsValue$hideOverl !== void 0 ? _propsValue$hideOverl : false), _useState16 = $51b25b42ecc1a0c7$var$_slicedToArray(_useState15, 2), hideOverlaysOnDocumentScrolling = _useState16[0], setHideOverlaysOnDocumentScrolling = _useState16[1];
    var _useState17 = (0, $acw62.useState)((_propsValue$nonce = propsValue.nonce) !== null && _propsValue$nonce !== void 0 ? _propsValue$nonce : null), _useState18 = $51b25b42ecc1a0c7$var$_slicedToArray(_useState17, 2), nonce = _useState18[0], setNonce = _useState18[1];
    var _useState19 = (0, $acw62.useState)((_propsValue$nullSortO = propsValue.nullSortOrder) !== null && _propsValue$nullSortO !== void 0 ? _propsValue$nullSortO : 1), _useState20 = $51b25b42ecc1a0c7$var$_slicedToArray(_useState19, 2), nullSortOrder = _useState20[0], setNullSortOrder = _useState20[1];
    var _useState21 = (0, $acw62.useState)((_propsValue$zIndex = propsValue.zIndex) !== null && _propsValue$zIndex !== void 0 ? _propsValue$zIndex : {
        modal: 1100,
        overlay: 1000,
        menu: 1000,
        tooltip: 1100,
        toast: 1200
    }), _useState22 = $51b25b42ecc1a0c7$var$_slicedToArray(_useState21, 2), zIndex = _useState22[0], setZIndex = _useState22[1];
    var _useState23 = (0, $acw62.useState)((_propsValue$ptOptions = propsValue.ptOptions) !== null && _propsValue$ptOptions !== void 0 ? _propsValue$ptOptions : {
        mergeSections: true,
        mergeProps: true
    }), _useState24 = $51b25b42ecc1a0c7$var$_slicedToArray(_useState23, 2), ptOptions = _useState24[0], setPtOptions = _useState24[1];
    var _useState25 = (0, $acw62.useState)((_propsValue$pt = propsValue.pt) !== null && _propsValue$pt !== void 0 ? _propsValue$pt : undefined), _useState26 = $51b25b42ecc1a0c7$var$_slicedToArray(_useState25, 2), pt = _useState26[0], setPt = _useState26[1];
    var _useState27 = (0, $acw62.useState)((_propsValue$unstyled = propsValue.unstyled) !== null && _propsValue$unstyled !== void 0 ? _propsValue$unstyled : false), _useState28 = $51b25b42ecc1a0c7$var$_slicedToArray(_useState27, 2), unstyled = _useState28[0], setUnstyled = _useState28[1];
    var _useState29 = (0, $acw62.useState)((_propsValue$filterMat = propsValue.filterMatchModeOptions) !== null && _propsValue$filterMat !== void 0 ? _propsValue$filterMat : {
        text: [
            $51b25b42ecc1a0c7$export$b9fbdf9129f67822.STARTS_WITH,
            $51b25b42ecc1a0c7$export$b9fbdf9129f67822.CONTAINS,
            $51b25b42ecc1a0c7$export$b9fbdf9129f67822.NOT_CONTAINS,
            $51b25b42ecc1a0c7$export$b9fbdf9129f67822.ENDS_WITH,
            $51b25b42ecc1a0c7$export$b9fbdf9129f67822.EQUALS,
            $51b25b42ecc1a0c7$export$b9fbdf9129f67822.NOT_EQUALS
        ],
        numeric: [
            $51b25b42ecc1a0c7$export$b9fbdf9129f67822.EQUALS,
            $51b25b42ecc1a0c7$export$b9fbdf9129f67822.NOT_EQUALS,
            $51b25b42ecc1a0c7$export$b9fbdf9129f67822.LESS_THAN,
            $51b25b42ecc1a0c7$export$b9fbdf9129f67822.LESS_THAN_OR_EQUAL_TO,
            $51b25b42ecc1a0c7$export$b9fbdf9129f67822.GREATER_THAN,
            $51b25b42ecc1a0c7$export$b9fbdf9129f67822.GREATER_THAN_OR_EQUAL_TO
        ],
        date: [
            $51b25b42ecc1a0c7$export$b9fbdf9129f67822.DATE_IS,
            $51b25b42ecc1a0c7$export$b9fbdf9129f67822.DATE_IS_NOT,
            $51b25b42ecc1a0c7$export$b9fbdf9129f67822.DATE_BEFORE,
            $51b25b42ecc1a0c7$export$b9fbdf9129f67822.DATE_AFTER
        ]
    }), _useState30 = $51b25b42ecc1a0c7$var$_slicedToArray(_useState29, 2), filterMatchModeOptions = _useState30[0], setFilterMatchModeOptions = _useState30[1];
    var changeTheme = function changeTheme(currentTheme, newTheme, linkElementId, callback) {
        var _linkElement$parentNo;
        var linkElement = document.getElementById(linkElementId);
        if (!linkElement) throw Error("Element with id ".concat(linkElementId, " not found."));
        var newThemeUrl = linkElement.getAttribute('href').replace(currentTheme, newTheme);
        var newLinkElement = document.createElement('link');
        newLinkElement.setAttribute('rel', 'stylesheet');
        newLinkElement.setAttribute('id', linkElementId);
        newLinkElement.setAttribute('href', newThemeUrl);
        newLinkElement.addEventListener('load', function() {
            if (callback) callback();
        });
        (_linkElement$parentNo = linkElement.parentNode) === null || _linkElement$parentNo === void 0 || _linkElement$parentNo.replaceChild(newLinkElement, linkElement);
    };
    /**
   * @deprecated
   */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        $51b25b42ecc1a0c7$var$PrimeReact$1.ripple = ripple;
    }, [
        ripple
    ]);
    /**
   * @deprecated
   */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        $51b25b42ecc1a0c7$var$PrimeReact$1.inputStyle = inputStyle;
    }, [
        inputStyle
    ]);
    /**
   * @deprecated
   */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        $51b25b42ecc1a0c7$var$PrimeReact$1.locale = locale;
    }, [
        locale
    ]);
    var value = {
        changeTheme: changeTheme,
        ripple: ripple,
        setRipple: setRipple,
        inputStyle: inputStyle,
        setInputStyle: setInputStyle,
        locale: locale,
        setLocale: setLocale,
        appendTo: appendTo,
        setAppendTo: setAppendTo,
        styleContainer: styleContainer,
        setStyleContainer: setStyleContainer,
        cssTransition: cssTransition,
        setCssTransition: setCssTransition,
        autoZIndex: autoZIndex,
        setAutoZIndex: setAutoZIndex,
        hideOverlaysOnDocumentScrolling: hideOverlaysOnDocumentScrolling,
        setHideOverlaysOnDocumentScrolling: setHideOverlaysOnDocumentScrolling,
        nonce: nonce,
        setNonce: setNonce,
        nullSortOrder: nullSortOrder,
        setNullSortOrder: setNullSortOrder,
        zIndex: zIndex,
        setZIndex: setZIndex,
        ptOptions: ptOptions,
        setPtOptions: setPtOptions,
        pt: pt,
        setPt: setPt,
        filterMatchModeOptions: filterMatchModeOptions,
        setFilterMatchModeOptions: setFilterMatchModeOptions,
        unstyled: unstyled,
        setUnstyled: setUnstyled
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($51b25b42ecc1a0c7$export$43502877ff87a530.Provider, {
        value: value
    }, props.children);
};
var $51b25b42ecc1a0c7$export$2e2bcd8739ae039 = $51b25b42ecc1a0c7$var$PrimeReact$1;




var $acw62 = parcelRequire("acw62");


'use client';
function $fbdf1e36fa0a01d8$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $fbdf1e36fa0a01d8$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $fbdf1e36fa0a01d8$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $fbdf1e36fa0a01d8$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $fbdf1e36fa0a01d8$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $fbdf1e36fa0a01d8$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $fbdf1e36fa0a01d8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fbdf1e36fa0a01d8$var$_slicedToArray(r, e) {
    return $fbdf1e36fa0a01d8$var$_arrayWithHoles(r) || $fbdf1e36fa0a01d8$var$_iterableToArrayLimit(r, e) || $fbdf1e36fa0a01d8$var$_unsupportedIterableToArray(r, e) || $fbdf1e36fa0a01d8$var$_nonIterableRest();
}
var $fbdf1e36fa0a01d8$export$5cae361ad82dce8b = function usePrevious(newValue) {
    var ref = $acw62.useRef(null);
    $acw62.useEffect(function() {
        ref.current = newValue;
        return function() {
            ref.current = null;
        };
    }, [
        newValue
    ]);
    return ref.current;
};
/* eslint-disable */ var $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96 = function useUnmountEffect(fn) {
    return $acw62.useEffect(function() {
        return fn;
    }, []);
};
/* eslint-enable */ var $fbdf1e36fa0a01d8$export$7080b3e976bc91ab = function useEventListener(_ref) {
    var _ref$target = _ref.target, target = _ref$target === void 0 ? 'document' : _ref$target, type = _ref.type, listener = _ref.listener, options = _ref.options, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    var targetRef = $acw62.useRef(null);
    var listenerRef = $acw62.useRef(null);
    var prevListener = $fbdf1e36fa0a01d8$export$5cae361ad82dce8b(listener);
    var prevOptions = $fbdf1e36fa0a01d8$export$5cae361ad82dce8b(options);
    var bind = function bind() {
        var bindOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var bindTarget = bindOptions.target;
        if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(bindTarget)) {
            unbind();
            (bindOptions.when || when) && (targetRef.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getTargetElement(bindTarget));
        }
        if (!listenerRef.current && targetRef.current) {
            listenerRef.current = function(event) {
                return listener && listener(event);
            };
            targetRef.current.addEventListener(type, listenerRef.current, options);
        }
    };
    var unbind = function unbind() {
        if (listenerRef.current) {
            targetRef.current.removeEventListener(type, listenerRef.current, options);
            listenerRef.current = null;
        }
    };
    var dispose = function dispose() {
        unbind();
        // Prevent memory leak by releasing
        prevListener = null;
        prevOptions = null;
    };
    var updateTarget = $acw62.useCallback(function() {
        if (when) targetRef.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getTargetElement(target);
        else {
            unbind();
            targetRef.current = null;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        target,
        when
    ]);
    $acw62.useEffect(function() {
        updateTarget();
    }, [
        updateTarget
    ]);
    $acw62.useEffect(function() {
        var listenerChanged = "".concat(prevListener) !== "".concat(listener);
        var optionsChanged = prevOptions !== options;
        var listenerExists = listenerRef.current;
        if (listenerExists && (listenerChanged || optionsChanged)) {
            unbind();
            when && bind();
        } else if (!listenerExists) dispose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        listener,
        options,
        when
    ]);
    $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96(function() {
        dispose();
    });
    return [
        bind,
        unbind
    ];
};
var $fbdf1e36fa0a01d8$export$1896bab46732d207 = function useClickOutside(ref, callback) {
    var isOutsideClicked = function isOutsideClicked(event) {
        if (!ref.current || ref.current.contains(event.target)) return;
        callback(event);
    };
    var _useEventListener = $fbdf1e36fa0a01d8$export$7080b3e976bc91ab({
        type: 'mousedown',
        listener: isOutsideClicked
    }), _useEventListener2 = $fbdf1e36fa0a01d8$var$_slicedToArray(_useEventListener, 2), bindMouseDownListener = _useEventListener2[0], unbindMouseDownListener = _useEventListener2[1];
    var _useEventListener3 = $fbdf1e36fa0a01d8$export$7080b3e976bc91ab({
        type: 'touchstart',
        listener: isOutsideClicked
    }), _useEventListener4 = $fbdf1e36fa0a01d8$var$_slicedToArray(_useEventListener3, 2), bindTouchStartListener = _useEventListener4[0], unbindTouchStartListener = _useEventListener4[1];
    $acw62.useEffect(function() {
        if (!ref.current) return;
        bindMouseDownListener();
        bindTouchStartListener();
        return function() {
            unbindMouseDownListener();
            unbindTouchStartListener();
        };
    });
    return [
        ref,
        callback
    ];
};
var $fbdf1e36fa0a01d8$export$70c4067197c60e2d = function useCounter() {
    var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        step: 1
    };
    var _React$useState = $acw62.useState(initialValue), _React$useState2 = $fbdf1e36fa0a01d8$var$_slicedToArray(_React$useState, 2), count = _React$useState2[0], setCount = _React$useState2[1];
    var increment = function increment() {
        if (options.max && count >= options.max) return;
        setCount(count + options.step);
    };
    var decrement = function decrement() {
        if (options.min || options.min === 0 && count <= options.min) return null;
        setCount(count - options.step);
    };
    var reset = function reset() {
        setCount(0);
    };
    return {
        count: count,
        increment: increment,
        decrement: decrement,
        reset: reset
    };
};
var $fbdf1e36fa0a01d8$export$21805fee57372823 = function useDebounce(initialValue, delay) {
    var _React$useState = $acw62.useState(initialValue), _React$useState2 = $fbdf1e36fa0a01d8$var$_slicedToArray(_React$useState, 2), inputValue = _React$useState2[0], setInputValue = _React$useState2[1];
    var _React$useState3 = $acw62.useState(initialValue), _React$useState4 = $fbdf1e36fa0a01d8$var$_slicedToArray(_React$useState3, 2), debouncedValue = _React$useState4[0], setDebouncedValue = _React$useState4[1];
    var mountedRef = $acw62.useRef(false);
    var timeoutRef = $acw62.useRef(null);
    var cancelTimer = function cancelTimer() {
        return window.clearTimeout(timeoutRef.current);
    };
    $fbdf1e36fa0a01d8$export$51c44cea289ac0f6(function() {
        mountedRef.current = true;
    });
    $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96(function() {
        cancelTimer();
    });
    $acw62.useEffect(function() {
        if (!mountedRef.current) return;
        cancelTimer();
        timeoutRef.current = window.setTimeout(function() {
            setDebouncedValue(inputValue);
        }, delay);
    }, [
        inputValue,
        delay
    ]);
    return [
        inputValue,
        debouncedValue,
        setInputValue
    ];
};
var $fbdf1e36fa0a01d8$var$groupToDisplayedElements = {};
var $fbdf1e36fa0a01d8$export$6353a33119af9098 = function useDisplayOrder(group) {
    var isVisible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var _React$useState = $acw62.useState(function() {
        return (0, $a73ce425265b079e$export$d5d9b89141473caf)();
    }), _React$useState2 = $fbdf1e36fa0a01d8$var$_slicedToArray(_React$useState, 1), uid = _React$useState2[0];
    var _React$useState3 = $acw62.useState(0), _React$useState4 = $fbdf1e36fa0a01d8$var$_slicedToArray(_React$useState3, 2), displayOrder = _React$useState4[0], setDisplayOrder = _React$useState4[1];
    $acw62.useEffect(function() {
        if (isVisible) {
            if (!$fbdf1e36fa0a01d8$var$groupToDisplayedElements[group]) $fbdf1e36fa0a01d8$var$groupToDisplayedElements[group] = [];
            var newDisplayOrder = $fbdf1e36fa0a01d8$var$groupToDisplayedElements[group].push(uid);
            setDisplayOrder(newDisplayOrder);
            return function() {
                delete $fbdf1e36fa0a01d8$var$groupToDisplayedElements[group][newDisplayOrder - 1];
                // Reduce array length, by removing undefined elements at the end of array:
                var lastIndex = $fbdf1e36fa0a01d8$var$groupToDisplayedElements[group].length - 1;
                var lastOrder = (0, $a73ce425265b079e$export$4855211e6b8ad895).findLastIndex($fbdf1e36fa0a01d8$var$groupToDisplayedElements[group], function(el) {
                    return el !== undefined;
                });
                if (lastOrder !== lastIndex) $fbdf1e36fa0a01d8$var$groupToDisplayedElements[group].splice(lastOrder + 1);
                setDisplayOrder(undefined);
            };
        }
    }, [
        group,
        uid,
        isVisible
    ]);
    return displayOrder;
};
var $fbdf1e36fa0a01d8$var$TYPE_MAP = {
    ico: 'image/x-icon',
    png: 'image/png',
    svg: 'image/svg+xml',
    gif: 'image/gif'
};
var $fbdf1e36fa0a01d8$export$1252d0179ae6292b = function useFavicon() {
    var newIcon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var rel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'shortcut icon';
    $acw62.useLayoutEffect(function() {
        if (newIcon) {
            var linkElements = document.querySelectorAll("link[rel*='icon']");
            linkElements.forEach(function(linkEl) {
                document.head.removeChild(linkEl);
            });
            var link = document.createElement('link');
            link.setAttribute('type', $fbdf1e36fa0a01d8$var$TYPE_MAP[newIcon.split('.').pop()]);
            link.setAttribute('rel', rel);
            link.setAttribute('href', newIcon);
            document.head.appendChild(link);
        }
    }, [
        newIcon,
        rel
    ]);
};
function $fbdf1e36fa0a01d8$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $fbdf1e36fa0a01d8$var$_arrayLikeToArray(r);
}
function $fbdf1e36fa0a01d8$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $fbdf1e36fa0a01d8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fbdf1e36fa0a01d8$var$_toConsumableArray(r) {
    return $fbdf1e36fa0a01d8$var$_arrayWithoutHoles(r) || $fbdf1e36fa0a01d8$var$_iterableToArray(r) || $fbdf1e36fa0a01d8$var$_unsupportedIterableToArray(r) || $fbdf1e36fa0a01d8$var$_nonIterableSpread();
}
/**
 * Priorities of different components (bigger number handled first)
 */ var $fbdf1e36fa0a01d8$export$5153c70e1a2d4b71 = {
    SIDEBAR: 100,
    SLIDE_MENU: 200,
    DIALOG: 300,
    IMAGE: 400,
    MENU: 500,
    OVERLAY_PANEL: 600,
    PASSWORD: 700,
    CASCADE_SELECT: 800,
    SPLIT_BUTTON: 900,
    SPEED_DIAL: 1000,
    TOOLTIP: 1200
};
/**
 * Object, that manages global escape key handling logic
 */ var $fbdf1e36fa0a01d8$var$globalEscKeyHandlingLogic = {
    /**
   * Mapping from ESC_KEY_HANDLING_PRIORITY to array of related listeners, grouped by priority
   * @example
   * Map<{
   *     [ESC_KEY_HANDLING_PRIORITIES.SIDEBAR]: Map<{
   *         1: () => {...},
   *         2: () => {...}
   *     }>,
   *     [ESC_KEY_HANDLING_PRIORITIES.DIALOG]: Map<{
   *         1: () => {...},
   *         2: () => {...}
   *     }>
   * }>;
   */ escKeyListeners: new Map(),
    /**
   * Keydown handler (attached to any keydown)
   */ onGlobalKeyDown: function onGlobalKeyDown(event) {
        // Do nothing if not an "esc" key is pressed:
        if (event.code !== 'Escape') return;
        var escKeyListeners = $fbdf1e36fa0a01d8$var$globalEscKeyHandlingLogic.escKeyListeners;
        var maxPrimaryPriority = Math.max.apply(Math, $fbdf1e36fa0a01d8$var$_toConsumableArray(escKeyListeners.keys()));
        var theMostImportantEscHandlersSet = escKeyListeners.get(maxPrimaryPriority);
        var maxSecondaryPriority = Math.max.apply(Math, $fbdf1e36fa0a01d8$var$_toConsumableArray(theMostImportantEscHandlersSet.keys()));
        var theMostImportantEscHandler = theMostImportantEscHandlersSet.get(maxSecondaryPriority);
        theMostImportantEscHandler(event);
    },
    /**
   * Attach global keydown listener if there are any "esc" key handlers assigned,
   * otherwise detach.
   */ refreshGlobalKeyDownListener: function refreshGlobalKeyDownListener() {
        var document1 = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getTargetElement('document');
        if (this.escKeyListeners.size > 0) document1.addEventListener('keydown', this.onGlobalKeyDown);
        else document1.removeEventListener('keydown', this.onGlobalKeyDown);
    },
    /**
   * Add "Esc" key handler
   */ addListener: function addListener(callback, _ref) {
        var _this = this;
        var _ref2 = $fbdf1e36fa0a01d8$var$_slicedToArray(_ref, 2), primaryPriority = _ref2[0], secondaryPriority = _ref2[1];
        var escKeyListeners = this.escKeyListeners;
        if (!escKeyListeners.has(primaryPriority)) escKeyListeners.set(primaryPriority, new Map());
        var primaryPriorityListeners = escKeyListeners.get(primaryPriority);
        // To prevent unexpected override of callback:
        if (primaryPriorityListeners.has(secondaryPriority)) throw new Error("Unexpected: global esc key listener with priority [".concat(primaryPriority, ", ").concat(secondaryPriority, "] already exists."));
        primaryPriorityListeners.set(secondaryPriority, callback);
        this.refreshGlobalKeyDownListener();
        return function() {
            primaryPriorityListeners["delete"](secondaryPriority);
            if (primaryPriorityListeners.size === 0) escKeyListeners["delete"](primaryPriority);
            _this.refreshGlobalKeyDownListener();
        };
    }
};
var $fbdf1e36fa0a01d8$export$dee4359f392495ae = function useGlobalOnEscapeKey(_ref3) {
    var callback = _ref3.callback, when = _ref3.when, priority = _ref3.priority;
    (0, $acw62.useEffect)(function() {
        if (!when) return;
        return $fbdf1e36fa0a01d8$var$globalEscKeyHandlingLogic.addListener(callback, priority);
    }, [
        callback,
        when,
        priority
    ]);
};
var $fbdf1e36fa0a01d8$export$a7395f9832c00176 = function useIntersectionObserver(ref) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _React$useState = $acw62.useState(false), _React$useState2 = $fbdf1e36fa0a01d8$var$_slicedToArray(_React$useState, 2), isElementVisible = _React$useState2[0], setIsElementVisible = _React$useState2[1];
    $acw62.useEffect(function() {
        if (!ref.current) return;
        var observer = new IntersectionObserver(function(_ref) {
            var _ref2 = $fbdf1e36fa0a01d8$var$_slicedToArray(_ref, 1), entry = _ref2[0];
            setIsElementVisible(entry.isIntersecting);
        }, options);
        observer.observe(ref.current);
        return function() {
            observer.disconnect();
        };
    }, [
        options,
        ref
    ]);
    return isElementVisible;
};
/* eslint-disable */ var $fbdf1e36fa0a01d8$export$f4b266cd2aae9cb1 = function useInterval(fn) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var when = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var timeout = $acw62.useRef(null);
    var savedCallback = $acw62.useRef(null);
    var clear = $acw62.useCallback(function() {
        return clearInterval(timeout.current);
    }, [
        timeout.current
    ]);
    $acw62.useEffect(function() {
        savedCallback.current = fn;
    });
    $acw62.useEffect(function() {
        function callback() {
            savedCallback.current();
        }
        if (when) {
            timeout.current = setInterval(callback, delay);
            return clear;
        } else clear();
    }, [
        delay,
        when
    ]);
    $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96(function() {
        clear();
    });
    return [
        clear
    ];
};
/* eslint-enable */ var $fbdf1e36fa0a01d8$export$dd42f485803cd57d = function useMatchMedia(query) {
    var when = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var _React$useState = $acw62.useState(false), _React$useState2 = $fbdf1e36fa0a01d8$var$_slicedToArray(_React$useState, 2), matches = _React$useState2[0], setMatches = _React$useState2[1];
    var matchMedia = $acw62.useRef(null);
    var handleChange = function handleChange(e) {
        return setMatches(e.matches);
    };
    var bind = function bind() {
        return matchMedia.current && matchMedia.current.addEventListener('change', handleChange);
    };
    var unbind = function unbind() {
        return matchMedia.current && matchMedia.current.removeEventListener('change', handleChange) && (matchMedia.current = null);
    };
    $acw62.useEffect(function() {
        if (when) {
            matchMedia.current = window.matchMedia(query);
            setMatches(matchMedia.current.matches);
            bind();
        }
        return unbind;
    }, [
        query,
        when
    ]);
    return matches;
};
/* eslint-enable */ /**
 * Hook to merge properties including custom merge function for things like Tailwind merge.
 */ var $fbdf1e36fa0a01d8$export$9596428d77cc41ba = function useMergeProps() {
    var context = (0, $acw62.useContext)((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    return function() {
        for(var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++)props[_key] = arguments[_key];
        return (0, $a73ce425265b079e$export$9d1611c77c2fe928)(props, context === null || context === void 0 ? void 0 : context.ptOptions);
    };
};
/* eslint-disable */ /**
 * Custom hook to run a mount effect only once.
 * @param {*} fn the callback function
 * @returns the hook
 */ var $fbdf1e36fa0a01d8$export$51c44cea289ac0f6 = function useMountEffect(fn) {
    var mounted = $acw62.useRef(false);
    return $acw62.useEffect(function() {
        if (!mounted.current) {
            mounted.current = true;
            return fn && fn();
        }
    }, []);
};
/* eslint-enable */ function $fbdf1e36fa0a01d8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fbdf1e36fa0a01d8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fbdf1e36fa0a01d8$var$_typeof(o);
}
function $fbdf1e36fa0a01d8$var$toPrimitive(t, r) {
    if ("object" != $fbdf1e36fa0a01d8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $fbdf1e36fa0a01d8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $fbdf1e36fa0a01d8$var$toPropertyKey(t) {
    var i = $fbdf1e36fa0a01d8$var$toPrimitive(t, "string");
    return "symbol" == $fbdf1e36fa0a01d8$var$_typeof(i) ? i : i + "";
}
function $fbdf1e36fa0a01d8$var$_defineProperty(e, r, t) {
    return (r = $fbdf1e36fa0a01d8$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fbdf1e36fa0a01d8$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fbdf1e36fa0a01d8$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fbdf1e36fa0a01d8$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $fbdf1e36fa0a01d8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fbdf1e36fa0a01d8$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fbdf1e36fa0a01d8$export$70811b4970b0f258 = function useMouse() {
    var _React$useState = $acw62.useState({
        x: 0,
        y: 0
    }), _React$useState2 = $fbdf1e36fa0a01d8$var$_slicedToArray(_React$useState, 2), position = _React$useState2[0], setPosition = _React$useState2[1];
    var ref = $acw62.useRef(null);
    var handleMouseMove = $acw62.useCallback(function(event) {
        var x;
        var y;
        if (ref.current) {
            var rect = event.currentTarget.getBoundingClientRect();
            x = event.pageX - rect.left - (window.pageXOffset || window.scrollX);
            y = event.pageY - rect.top - (window.pageYOffset || window.scrollY);
        } else {
            x = event.clientX;
            y = event.clientY;
        }
        setPosition({
            x: Math.max(0, Math.round(x)),
            y: Math.max(0, Math.round(y))
        });
    }, []);
    var _useEventListener = $fbdf1e36fa0a01d8$export$7080b3e976bc91ab({
        target: ref,
        type: 'mousemove',
        listener: handleMouseMove
    }), _useEventListener2 = $fbdf1e36fa0a01d8$var$_slicedToArray(_useEventListener, 2), bindMouseMoveEventListener = _useEventListener2[0], unbindMouseMoveEventListener = _useEventListener2[1];
    var _useEventListener3 = $fbdf1e36fa0a01d8$export$7080b3e976bc91ab({
        type: 'mousemove',
        listener: handleMouseMove
    }), _useEventListener4 = $fbdf1e36fa0a01d8$var$_slicedToArray(_useEventListener3, 2), bindDocumentMoveEventListener = _useEventListener4[0], unbindDocumentMoveEventListener = _useEventListener4[1];
    var reset = function reset() {
        return setPosition({
            x: 0,
            y: 0
        });
    };
    $acw62.useEffect(function() {
        bindMouseMoveEventListener();
        if (!ref.current) bindDocumentMoveEventListener();
        return function() {
            unbindMouseMoveEventListener();
            // eslint-disable-next-line react-hooks/exhaustive-deps
            if (!ref.current) unbindDocumentMoveEventListener();
        };
    }, [
        bindDocumentMoveEventListener,
        bindMouseMoveEventListener,
        unbindDocumentMoveEventListener,
        unbindMouseMoveEventListener
    ]);
    return $fbdf1e36fa0a01d8$var$_objectSpread$1($fbdf1e36fa0a01d8$var$_objectSpread$1({
        ref: ref
    }, position), {}, {
        reset: reset
    });
};
function $fbdf1e36fa0a01d8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fbdf1e36fa0a01d8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fbdf1e36fa0a01d8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fbdf1e36fa0a01d8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fbdf1e36fa0a01d8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fbdf1e36fa0a01d8$export$36da96379f79f245(_ref) {
    var _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? 'both' : _ref$mode, _ref$initialValue = _ref.initialValue, initialValue = _ref$initialValue === void 0 ? {
        x: 0,
        y: 0
    } : _ref$initialValue;
    var _React$useState = $acw62.useState(initialValue), _React$useState2 = $fbdf1e36fa0a01d8$var$_slicedToArray(_React$useState, 2), positions = _React$useState2[0], setPositions = _React$useState2[1];
    var _React$useState3 = $acw62.useState(false), _React$useState4 = $fbdf1e36fa0a01d8$var$_slicedToArray(_React$useState3, 2), active = _React$useState4[0], setActive = _React$useState4[1];
    var isMounted = $acw62.useRef(false);
    var isSliding = $acw62.useRef(false);
    var ref = $acw62.useRef(null);
    var onMouseMove = function onMouseMove(event) {
        return updateMousePosition({
            x: event.clientX,
            y: event.clientY
        });
    };
    var handlePositionChange = function handlePositionChange(_ref2) {
        var clampedX = _ref2.clampedX, clampedY = _ref2.clampedY;
        if (mode === 'vertical') setPositions({
            y: 1 - clampedY
        });
        else if (mode === 'horizontal') setPositions({
            x: clampedX
        });
        else if (mode === 'both') setPositions({
            x: clampedX,
            y: clampedY
        });
    };
    var onMouseDown = function onMouseDown(event) {
        startScrubbing();
        event.preventDefault();
        onMouseMove(event);
    };
    var stopScrubbing = function stopScrubbing() {
        if (isSliding.current && isMounted.current) {
            isSliding.current = false;
            setActive(false);
            unbindListeners();
        }
    };
    var onTouchMove = function onTouchMove(event) {
        if (event.cancelable) event.preventDefault();
        updateMousePosition({
            x: event.changedTouches[0].clientX,
            y: event.changedTouches[0].clientY
        });
    };
    var onTouchStart = function onTouchStart(event) {
        if (event.cancelable) event.preventDefault();
        startScrubbing();
        onTouchMove(event);
    };
    var _useEventListener = $fbdf1e36fa0a01d8$export$7080b3e976bc91ab({
        type: 'mousemove',
        listener: onMouseMove
    }), _useEventListener2 = $fbdf1e36fa0a01d8$var$_slicedToArray(_useEventListener, 2), bindDocumentMouseMoveListener = _useEventListener2[0], unbindDocumentMouseMoveListener = _useEventListener2[1];
    var _useEventListener3 = $fbdf1e36fa0a01d8$export$7080b3e976bc91ab({
        type: 'mouseup',
        listener: stopScrubbing
    }), _useEventListener4 = $fbdf1e36fa0a01d8$var$_slicedToArray(_useEventListener3, 2), bindDocumentMouseUpListener = _useEventListener4[0], unbindDocumentMouseUpListener = _useEventListener4[1];
    var _useEventListener5 = $fbdf1e36fa0a01d8$export$7080b3e976bc91ab({
        type: 'touchmove',
        listener: onTouchMove
    }), _useEventListener6 = $fbdf1e36fa0a01d8$var$_slicedToArray(_useEventListener5, 2), bindDocumentTouchMoveListener = _useEventListener6[0], unbindDocumentTouchMoveListener = _useEventListener6[1];
    var _useEventListener7 = $fbdf1e36fa0a01d8$export$7080b3e976bc91ab({
        type: 'touchend',
        listener: stopScrubbing
    }), _useEventListener8 = $fbdf1e36fa0a01d8$var$_slicedToArray(_useEventListener7, 2), bindDocumentTouchEndListener = _useEventListener8[0], unbindDocumentTouchEndListener = _useEventListener8[1];
    var _useEventListener9 = $fbdf1e36fa0a01d8$export$7080b3e976bc91ab({
        target: ref,
        type: 'mousedown',
        listener: onMouseDown
    }), _useEventListener10 = $fbdf1e36fa0a01d8$var$_slicedToArray(_useEventListener9, 2), bindMouseDownListener = _useEventListener10[0], unbindMouseDownListener = _useEventListener10[1];
    var _useEventListener11 = $fbdf1e36fa0a01d8$export$7080b3e976bc91ab({
        target: ref,
        type: 'touchstart',
        listener: onTouchStart,
        options: {
            passive: false
        }
    }), _useEventListener12 = $fbdf1e36fa0a01d8$var$_slicedToArray(_useEventListener11, 2), bindTouchStartListener = _useEventListener12[0], unbindTouchStartListener = _useEventListener12[1];
    var clamp = function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
    };
    var clampPositions = function clampPositions(_ref3) {
        var x = _ref3.x, y = _ref3.y;
        return {
            clampedX: clamp(x, 0, 1),
            clampedY: clamp(y, 0, 1)
        };
    };
    var bindListeners = function bindListeners() {
        bindDocumentMouseMoveListener();
        bindDocumentMouseUpListener();
        bindDocumentTouchMoveListener();
        bindDocumentTouchEndListener();
    };
    var unbindListeners = function unbindListeners() {
        unbindDocumentMouseMoveListener();
        unbindDocumentMouseUpListener();
        unbindDocumentTouchMoveListener();
        unbindDocumentTouchEndListener();
    };
    var reset = function reset() {
        setPositions(initialValue);
    };
    $acw62.useEffect(function() {
        isMounted.current = true;
    }, []);
    var startScrubbing = function startScrubbing() {
        if (!isSliding.current && isMounted.current) {
            isSliding.current = true;
            setActive(true);
            bindListeners();
        }
    };
    var updateMousePosition = function updateMousePosition(_ref4) {
        var x = _ref4.x, y = _ref4.y;
        if (isSliding.current) {
            var rect = ref.current.getBoundingClientRect();
            var _clampPositions = clampPositions({
                x: (x - rect.left) / rect.width,
                y: (y - rect.top) / rect.height
            }), clampedX = _clampPositions.clampedX, clampedY = _clampPositions.clampedY;
            handlePositionChange({
                clampedX: clampedX,
                clampedY: clampedY
            });
        }
    };
    $acw62.useEffect(function() {
        if (ref.current) {
            bindMouseDownListener();
            bindTouchStartListener();
        }
        return function() {
            if (ref.current) {
                unbindMouseDownListener();
                unbindTouchStartListener();
            }
        };
    }, [
        bindMouseDownListener,
        bindTouchStartListener,
        positions,
        unbindMouseDownListener,
        unbindTouchStartListener
    ]);
    return $fbdf1e36fa0a01d8$var$_objectSpread($fbdf1e36fa0a01d8$var$_objectSpread({
        ref: ref
    }, positions), {}, {
        active: active,
        reset: reset
    });
}
var $fbdf1e36fa0a01d8$export$d04245b74d6bdcb8 = function useOverlayScrollListener(_ref) {
    var target = _ref.target, listener = _ref.listener, options = _ref.options, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var targetRef = $acw62.useRef(null);
    var listenerRef = $acw62.useRef(null);
    var scrollableParentsRef = $acw62.useRef([]);
    var prevListener = $fbdf1e36fa0a01d8$export$5cae361ad82dce8b(listener);
    var prevOptions = $fbdf1e36fa0a01d8$export$5cae361ad82dce8b(options);
    var bind = function bind() {
        var bindOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(bindOptions.target)) {
            unbind();
            (bindOptions.when || when) && (targetRef.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getTargetElement(bindOptions.target));
        }
        if (!listenerRef.current && targetRef.current) {
            var hideOnScroll = context ? context.hideOverlaysOnDocumentScrolling : (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).hideOverlaysOnDocumentScrolling;
            var nodes = scrollableParentsRef.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getScrollableParents(targetRef.current, hideOnScroll);
            listenerRef.current = function(event) {
                return listener && listener(event);
            };
            nodes.forEach(function(node) {
                return node.addEventListener('scroll', listenerRef.current, options);
            });
        }
    };
    var unbind = function unbind() {
        if (listenerRef.current) {
            var nodes = scrollableParentsRef.current;
            nodes.forEach(function(node) {
                return node.removeEventListener('scroll', listenerRef.current, options);
            });
            listenerRef.current = null;
        }
    };
    var dispose = function dispose() {
        unbind();
        // #5927 prevent memory leak by releasing
        scrollableParentsRef.current = null;
        prevListener = null;
        prevOptions = null;
    };
    var updateTarget = $acw62.useCallback(function() {
        if (when) targetRef.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getTargetElement(target);
        else {
            unbind();
            targetRef.current = null;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        target,
        when
    ]);
    $acw62.useEffect(function() {
        updateTarget();
    }, [
        updateTarget
    ]);
    $acw62.useEffect(function() {
        var listenerChanged = "".concat(prevListener) !== "".concat(listener);
        var optionsChanged = prevOptions !== options;
        var listenerExists = listenerRef.current;
        if (listenerExists && (listenerChanged || optionsChanged)) {
            unbind();
            when && bind();
        } else if (!listenerExists) dispose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        listener,
        options,
        when
    ]);
    $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96(function() {
        dispose();
    });
    return [
        bind,
        unbind
    ];
};
var $fbdf1e36fa0a01d8$export$158eb97be50d41ef = function useResizeListener(_ref) {
    var listener = _ref.listener, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return $fbdf1e36fa0a01d8$export$7080b3e976bc91ab({
        target: 'window',
        type: 'resize',
        listener: listener,
        when: when
    });
};
var $fbdf1e36fa0a01d8$export$2fef17345d27a5b4 = function useOverlayListener(_ref) {
    var target = _ref.target, overlay = _ref.overlay, _listener = _ref.listener, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when, _ref$type = _ref.type, type = _ref$type === void 0 ? 'click' : _ref$type;
    var targetRef = $acw62.useRef(null);
    var overlayRef = $acw62.useRef(null);
    /**
   * The parameters of the 'listener' method in the following event handlers;
   * @param {Event} event A click event of the document.
   * @param {string} options.type The custom type to detect event.
   * @param {boolean} options.valid It is controlled by PrimeReact. It is determined whether it is valid or not according to some custom validation.
   */ var _useEventListener = $fbdf1e36fa0a01d8$export$7080b3e976bc91ab({
        target: 'window',
        type: type,
        listener: function listener(event) {
            _listener && _listener(event, {
                type: 'outside',
                valid: event.which !== 3 && isOutsideClicked(event)
            });
        }
    }), _useEventListener2 = $fbdf1e36fa0a01d8$var$_slicedToArray(_useEventListener, 2), bindDocumentClickListener = _useEventListener2[0], unbindDocumentClickListener = _useEventListener2[1];
    var _useResizeListener = $fbdf1e36fa0a01d8$export$158eb97be50d41ef({
        target: 'window',
        listener: function listener(event) {
            _listener && _listener(event, {
                type: 'resize',
                valid: !(0, $a73ce425265b079e$export$ff8ccbac9225de62).isTouchDevice()
            });
        }
    }), _useResizeListener2 = $fbdf1e36fa0a01d8$var$_slicedToArray(_useResizeListener, 2), bindWindowResizeListener = _useResizeListener2[0], unbindWindowResizeListener = _useResizeListener2[1];
    var _useEventListener3 = $fbdf1e36fa0a01d8$export$7080b3e976bc91ab({
        target: 'window',
        type: 'orientationchange',
        listener: function listener(event) {
            _listener && _listener(event, {
                type: 'orientationchange',
                valid: true
            });
        }
    }), _useEventListener4 = $fbdf1e36fa0a01d8$var$_slicedToArray(_useEventListener3, 2), bindWindowOrientationChangeListener = _useEventListener4[0], unbindWindowOrientationChangeListener = _useEventListener4[1];
    var _useOverlayScrollList = $fbdf1e36fa0a01d8$export$d04245b74d6bdcb8({
        target: target,
        listener: function listener(event) {
            _listener && _listener(event, {
                type: 'scroll',
                valid: true
            });
        }
    }), _useOverlayScrollList2 = $fbdf1e36fa0a01d8$var$_slicedToArray(_useOverlayScrollList, 2), bindOverlayScrollListener = _useOverlayScrollList2[0], unbindOverlayScrollListener = _useOverlayScrollList2[1];
    var isOutsideClicked = function isOutsideClicked(event) {
        return targetRef.current && !(targetRef.current.isSameNode(event.target) || targetRef.current.contains(event.target) || overlayRef.current && overlayRef.current.contains(event.target));
    };
    var bind = function bind() {
        bindDocumentClickListener();
        bindWindowResizeListener();
        bindWindowOrientationChangeListener();
        bindOverlayScrollListener();
    };
    var unbind = function unbind() {
        unbindDocumentClickListener();
        unbindWindowResizeListener();
        unbindWindowOrientationChangeListener();
        unbindOverlayScrollListener();
    };
    $acw62.useEffect(function() {
        if (when) {
            targetRef.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getTargetElement(target);
            overlayRef.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getTargetElement(overlay);
        } else {
            unbind();
            targetRef.current = overlayRef.current = null;
        }
    }, [
        target,
        overlay,
        when
    ]);
    $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96(function() {
        unbind();
    });
    return [
        bind,
        unbind
    ];
};
/* eslint-enable */ /**
 * Hook to wrap around useState that stores the value in the browser local/session storage.
 *
 * @param {any} initialValue the initial value to store
 * @param {string} key the key to store the value in local/session storage
 * @param {string} storage either 'local' or 'session' for what type of storage
 * @returns a stateful value, and a function to update it.
 */ var $fbdf1e36fa0a01d8$export$95809329f49ea9f9 = function useStorage(initialValue, key) {
    var storage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'local';
    // Since the local storage API isn't available in server-rendering environments,
    // we check that typeof window !== 'undefined' to make SSR and SSG work properly.
    var storageAvailable = typeof window !== 'undefined';
    // subscribe to window storage event so changes in one tab to a stored value
    // are properly reflected in all tabs
    var _useEventListener = $fbdf1e36fa0a01d8$export$7080b3e976bc91ab({
        target: 'window',
        type: 'storage',
        listener: function listener(event) {
            var area = storage === 'local' ? window.localStorage : window.sessionStorage;
            if (event.storageArea === area && event.key === key) {
                var newValue = event.newValue ? JSON.parse(event.newValue) : undefined;
                setStoredValue(newValue);
            }
        }
    }), _useEventListener2 = $fbdf1e36fa0a01d8$var$_slicedToArray(_useEventListener, 2), bindWindowStorageListener = _useEventListener2[0], unbindWindowStorageListener = _useEventListener2[1];
    var _React$useState = $acw62.useState(initialValue), _React$useState2 = $fbdf1e36fa0a01d8$var$_slicedToArray(_React$useState, 2), storedValue = _React$useState2[0], setStoredValue = _React$useState2[1];
    var setValue = function setValue(value) {
        try {
            // Allow value to be a function so we have same API as useState
            var valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            if (storageAvailable) {
                var serializedValue = JSON.stringify(valueToStore);
                storage === 'local' ? window.localStorage.setItem(key, serializedValue) : window.sessionStorage.setItem(key, serializedValue);
            }
        } catch (error) {
            throw new Error("PrimeReact useStorage: Failed to serialize the value at key: ".concat(key));
        }
    };
    $acw62.useEffect(function() {
        if (!storageAvailable) setStoredValue(initialValue);
        try {
            var item = storage === 'local' ? window.localStorage.getItem(key) : window.sessionStorage.getItem(key);
            setStoredValue(item ? JSON.parse(item) : initialValue);
        } catch (error) {
            // If error also return initialValue
            setStoredValue(initialValue);
        }
        bindWindowStorageListener();
        return function() {
            return unbindWindowStorageListener();
        };
    }, []);
    return [
        storedValue,
        setValue
    ];
};
/**
 * Hook to wrap around useState that stores the value in the browser local storage.
 *
 * @param {any} initialValue the initial value to store
 * @param {string} key the key to store the value in local storage
 * @returns a stateful value, and a function to update it.
 */ var $fbdf1e36fa0a01d8$export$86e2cef2561044ac = function useLocalStorage(initialValue, key) {
    return $fbdf1e36fa0a01d8$export$95809329f49ea9f9(initialValue, key, 'local');
};
/**
 * Hook to wrap around useState that stores the value in the browser session storage.
 *
 * @param {any} initialValue the initial value to store
 * @param {string} key the key to store the value in session storage
 * @returns a stateful value, and a function to update it.
 */ var $fbdf1e36fa0a01d8$export$864b6828bd07eda6 = function useSessionStorage(initialValue, key) {
    return $fbdf1e36fa0a01d8$export$95809329f49ea9f9(initialValue, key, 'session');
};
/* eslint-enable */ var $fbdf1e36fa0a01d8$var$_id = 0;
var $fbdf1e36fa0a01d8$export$72c85e333541e7f = function useStyle(css) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _useState = (0, $acw62.useState)(false), _useState2 = $fbdf1e36fa0a01d8$var$_slicedToArray(_useState, 2), isLoaded = _useState2[0], setIsLoaded = _useState2[1];
    var styleRef = (0, $acw62.useRef)(null);
    var context = (0, $acw62.useContext)((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var defaultDocument = (0, $a73ce425265b079e$export$ff8ccbac9225de62).isClient() ? window.document : undefined;
    var _options$document = options.document, document1 = _options$document === void 0 ? defaultDocument : _options$document, _options$manual = options.manual, manual = _options$manual === void 0 ? false : _options$manual, _options$name = options.name, name = _options$name === void 0 ? "style_".concat(++$fbdf1e36fa0a01d8$var$_id) : _options$name, _options$id = options.id, id = _options$id === void 0 ? undefined : _options$id, _options$media = options.media, media = _options$media === void 0 ? undefined : _options$media;
    var getCurrentStyleRef = function getCurrentStyleRef(styleContainer) {
        var existingStyle = styleContainer.querySelector("style[data-primereact-style-id=\"".concat(name, "\"]"));
        if (existingStyle) return existingStyle;
        if (id !== undefined) {
            var existingElement = document1.getElementById(id);
            if (existingElement) return existingElement;
        }
        // finally if not found create the new style
        return document1.createElement('style');
    };
    var update = function update(newCSS) {
        isLoaded && css !== newCSS && (styleRef.current.textContent = newCSS);
    };
    var load = function load() {
        if (!document1 || isLoaded) return;
        var styleContainer = (context === null || context === void 0 ? void 0 : context.styleContainer) || document1.head;
        styleRef.current = getCurrentStyleRef(styleContainer);
        if (!styleRef.current.isConnected) {
            styleRef.current.type = 'text/css';
            if (id) styleRef.current.id = id;
            if (media) styleRef.current.media = media;
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).addNonce(styleRef.current, context && context.nonce || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).nonce);
            styleContainer.appendChild(styleRef.current);
            if (name) styleRef.current.setAttribute('data-primereact-style-id', name);
        }
        styleRef.current.textContent = css;
        setIsLoaded(true);
    };
    var unload = function unload() {
        if (!document1 || !styleRef.current) return;
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeInlineStyle(styleRef.current);
        setIsLoaded(false);
    };
    (0, $acw62.useEffect)(function() {
        if (!manual) load();
    // return () => {if (!manual) unload()}; /* @todo */
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        manual
    ]);
    return {
        id: id,
        name: name,
        update: update,
        unload: unload,
        load: load,
        isLoaded: isLoaded
    };
};
/* eslint-disable */ var $fbdf1e36fa0a01d8$export$d8e6abf214c9ec0f = function useTimeout(fn) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var when = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var timeout = $acw62.useRef(null);
    var savedCallback = $acw62.useRef(null);
    var clear = $acw62.useCallback(function() {
        return clearTimeout(timeout.current);
    }, [
        timeout.current
    ]);
    $acw62.useEffect(function() {
        savedCallback.current = fn;
    });
    $acw62.useEffect(function() {
        function callback() {
            savedCallback.current();
        }
        if (when) {
            timeout.current = setTimeout(callback, delay);
            return clear;
        } else clear();
    }, [
        delay,
        when
    ]);
    $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96(function() {
        clear();
    });
    return [
        clear
    ];
};
/* eslint-enable */ /* eslint-disable */ var $fbdf1e36fa0a01d8$export$496315a1608d9602 = function useUpdateEffect(fn, deps) {
    var mounted = $acw62.useRef(false);
    return $acw62.useEffect(function() {
        if (!mounted.current) {
            mounted.current = true;
            return;
        }
        return fn && fn();
    }, deps);
};



'use client';
function $b76d8eda63b3c134$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $b76d8eda63b3c134$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $b76d8eda63b3c134$var$_arrayLikeToArray(r);
}
function $b76d8eda63b3c134$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $b76d8eda63b3c134$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b76d8eda63b3c134$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b76d8eda63b3c134$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b76d8eda63b3c134$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b76d8eda63b3c134$var$_toConsumableArray(r) {
    return $b76d8eda63b3c134$var$_arrayWithoutHoles(r) || $b76d8eda63b3c134$var$_iterableToArray(r) || $b76d8eda63b3c134$var$_unsupportedIterableToArray(r) || $b76d8eda63b3c134$var$_nonIterableSpread();
}
function $b76d8eda63b3c134$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b76d8eda63b3c134$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b76d8eda63b3c134$var$_typeof(o);
}
function $b76d8eda63b3c134$var$toPrimitive(t, r) {
    if ("object" != $b76d8eda63b3c134$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b76d8eda63b3c134$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b76d8eda63b3c134$var$toPropertyKey(t) {
    var i = $b76d8eda63b3c134$var$toPrimitive(t, "string");
    return "symbol" == $b76d8eda63b3c134$var$_typeof(i) ? i : i + "";
}
function $b76d8eda63b3c134$var$_defineProperty(e, r, t) {
    return (r = $b76d8eda63b3c134$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $b76d8eda63b3c134$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b76d8eda63b3c134$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b76d8eda63b3c134$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b76d8eda63b3c134$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b76d8eda63b3c134$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b76d8eda63b3c134$var$baseStyle = "\n.p-hidden-accessible {\n    border: 0;\n    padding: 0;\n    margin: -1px;\n    position: absolute;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    clip-path: inset(50%);\n    white-space: nowrap;\n}\n\n.p-hidden-accessible input,\n.p-hidden-accessible select {\n    transform: scale(0);\n}\n\n.p-overflow-hidden {\n    overflow: hidden;\n    padding-right: var(--scrollbar-width);\n}\n";
var $b76d8eda63b3c134$var$buttonStyles = "\n.p-button {\n    margin: 0;\n    display: inline-flex;\n    cursor: pointer;\n    user-select: none;\n    align-items: center;\n    vertical-align: bottom;\n    text-align: center;\n    overflow: hidden;\n    position: relative;\n}\n\n.p-button-label {\n    flex: 1 1 auto;\n}\n\n.p-button-icon-right {\n    order: 1;\n}\n\n.p-button:disabled {\n    cursor: default;\n}\n\n.p-button-icon-only {\n    justify-content: center;\n}\n\n.p-button-icon-only .p-button-label {\n    visibility: hidden;\n    width: 0;\n    flex: 0 0 auto;\n}\n\n.p-button-vertical {\n    flex-direction: column;\n}\n\n.p-button-icon-bottom {\n    order: 2;\n}\n\n.p-button-group .p-button {\n    margin: 0;\n}\n\n.p-button-group .p-button:not(:last-child) {\n    border-right: 0 none;\n}\n\n.p-button-group .p-button:not(:first-of-type):not(:last-of-type) {\n    border-radius: 0;\n}\n\n.p-button-group .p-button:first-of-type {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.p-button-group .p-button:last-of-type {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.p-button-group .p-button:focus {\n    position: relative;\n    z-index: 1;\n}\n";
var $b76d8eda63b3c134$var$inputTextStyles = "\n.p-inputtext {\n    margin: 0;\n}\n\n.p-fluid .p-inputtext {\n    width: 100%;\n}\n\n/* InputGroup */\n.p-inputgroup {\n    display: flex;\n    align-items: stretch;\n    width: 100%;\n}\n\n.p-inputgroup-addon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.p-inputgroup .p-float-label {\n    display: flex;\n    align-items: stretch;\n    width: 100%;\n}\n\n.p-inputgroup .p-inputtext,\n.p-fluid .p-inputgroup .p-inputtext,\n.p-inputgroup .p-inputwrapper,\n.p-fluid .p-inputgroup .p-input {\n    flex: 1 1 auto;\n    width: 1%;\n}\n\n/* Floating Label */\n.p-float-label {\n    display: block;\n    position: relative;\n}\n\n.p-float-label label {\n    position: absolute;\n    pointer-events: none;\n    top: 50%;\n    margin-top: -0.5rem;\n    transition-property: all;\n    transition-timing-function: ease;\n    line-height: 1;\n}\n\n.p-float-label textarea ~ label,\n.p-float-label .p-mention ~ label {\n    top: 1rem;\n}\n\n.p-float-label input:focus ~ label,\n.p-float-label input:-webkit-autofill ~ label,\n.p-float-label input.p-filled ~ label,\n.p-float-label textarea:focus ~ label,\n.p-float-label textarea.p-filled ~ label,\n.p-float-label .p-inputwrapper-focus ~ label,\n.p-float-label .p-inputwrapper-filled ~ label,\n.p-float-label .p-tooltip-target-wrapper ~ label {\n    top: -0.75rem;\n    font-size: 12px;\n}\n\n.p-float-label .p-placeholder,\n.p-float-label input::placeholder,\n.p-float-label .p-inputtext::placeholder {\n    opacity: 0;\n    transition-property: all;\n    transition-timing-function: ease;\n}\n\n.p-float-label .p-focus .p-placeholder,\n.p-float-label input:focus::placeholder,\n.p-float-label .p-inputtext:focus::placeholder {\n    opacity: 1;\n    transition-property: all;\n    transition-timing-function: ease;\n}\n\n.p-input-icon-left,\n.p-input-icon-right {\n    position: relative;\n    display: inline-block;\n}\n\n.p-input-icon-left > i,\n.p-input-icon-right > i,\n.p-input-icon-left > svg,\n.p-input-icon-right > svg,\n.p-input-icon-left > .p-input-prefix,\n.p-input-icon-right > .p-input-suffix {\n    position: absolute;\n    top: 50%;\n    margin-top: -0.5rem;\n}\n\n.p-fluid .p-input-icon-left,\n.p-fluid .p-input-icon-right {\n    display: block;\n    width: 100%;\n}\n";
var $b76d8eda63b3c134$var$iconStyles = "\n.p-icon {\n    display: inline-block;\n}\n\n.p-icon-spin {\n    -webkit-animation: p-icon-spin 2s infinite linear;\n    animation: p-icon-spin 2s infinite linear;\n}\n\nsvg.p-icon {\n    pointer-events: auto;\n}\n\nsvg.p-icon g,\n.p-disabled svg.p-icon {\n    pointer-events: none;\n}\n\n@-webkit-keyframes p-icon-spin {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n    100% {\n        -webkit-transform: rotate(359deg);\n        transform: rotate(359deg);\n    }\n}\n\n@keyframes p-icon-spin {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n    100% {\n        -webkit-transform: rotate(359deg);\n        transform: rotate(359deg);\n    }\n}\n";
var $b76d8eda63b3c134$var$commonStyle = "\n@layer primereact {\n    .p-component, .p-component * {\n        box-sizing: border-box;\n    }\n\n    .p-hidden {\n        display: none;\n    }\n\n    .p-hidden-space {\n        visibility: hidden;\n    }\n\n    .p-reset {\n        margin: 0;\n        padding: 0;\n        border: 0;\n        outline: 0;\n        text-decoration: none;\n        font-size: 100%;\n        list-style: none;\n    }\n\n    .p-disabled, .p-disabled * {\n        cursor: default;\n        pointer-events: none;\n        user-select: none;\n    }\n\n    .p-component-overlay {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n    }\n\n    .p-unselectable-text {\n        user-select: none;\n    }\n\n    .p-scrollbar-measure {\n        width: 100px;\n        height: 100px;\n        overflow: scroll;\n        position: absolute;\n        top: -9999px;\n    }\n\n    @-webkit-keyframes p-fadein {\n      0%   { opacity: 0; }\n      100% { opacity: 1; }\n    }\n    @keyframes p-fadein {\n      0%   { opacity: 0; }\n      100% { opacity: 1; }\n    }\n\n    .p-link {\n        text-align: left;\n        background-color: transparent;\n        margin: 0;\n        padding: 0;\n        border: none;\n        cursor: pointer;\n        user-select: none;\n    }\n\n    .p-link:disabled {\n        cursor: default;\n    }\n\n    /* Non react overlay animations */\n    .p-connected-overlay {\n        opacity: 0;\n        transform: scaleY(0.8);\n        transition: transform .12s cubic-bezier(0, 0, 0.2, 1), opacity .12s cubic-bezier(0, 0, 0.2, 1);\n    }\n\n    .p-connected-overlay-visible {\n        opacity: 1;\n        transform: scaleY(1);\n    }\n\n    .p-connected-overlay-hidden {\n        opacity: 0;\n        transform: scaleY(1);\n        transition: opacity .1s linear;\n    }\n\n    /* React based overlay animations */\n    .p-connected-overlay-enter {\n        opacity: 0;\n        transform: scaleY(0.8);\n    }\n\n    .p-connected-overlay-enter-active {\n        opacity: 1;\n        transform: scaleY(1);\n        transition: transform .12s cubic-bezier(0, 0, 0.2, 1), opacity .12s cubic-bezier(0, 0, 0.2, 1);\n    }\n\n    .p-connected-overlay-enter-done {\n        transform: none;\n    }\n\n    .p-connected-overlay-exit {\n        opacity: 1;\n    }\n\n    .p-connected-overlay-exit-active {\n        opacity: 0;\n        transition: opacity .1s linear;\n    }\n\n    /* Toggleable Content */\n    .p-toggleable-content-enter {\n        max-height: 0;\n    }\n\n    .p-toggleable-content-enter-active {\n        overflow: hidden;\n        max-height: 1000px;\n        transition: max-height 1s ease-in-out;\n    }\n\n    .p-toggleable-content-enter-done {\n        transform: none;\n    }\n\n    .p-toggleable-content-exit {\n        max-height: 1000px;\n    }\n\n    .p-toggleable-content-exit-active {\n        overflow: hidden;\n        max-height: 0;\n        transition: max-height 0.45s cubic-bezier(0, 1, 0, 1);\n    }\n\n    .p-sr-only {\n        border: 0;\n        clip: rect(1px, 1px, 1px, 1px);\n        clip-path: inset(50%);\n        height: 1px;\n        margin: -1px;\n        overflow: hidden;\n        padding: 0;\n        position: absolute;\n        width: 1px;\n        word-wrap: normal;\n    }\n\n    /* @todo Refactor */\n    .p-menu .p-menuitem-link {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        text-decoration: none;\n        overflow: hidden;\n        position: relative;\n    }\n\n    ".concat($b76d8eda63b3c134$var$buttonStyles, "\n    ").concat($b76d8eda63b3c134$var$inputTextStyles, "\n    ").concat($b76d8eda63b3c134$var$iconStyles, "\n}\n");
var $b76d8eda63b3c134$export$425c3e0a21b857e8 = {
    cProps: undefined,
    cParams: undefined,
    cName: undefined,
    defaultProps: {
        pt: undefined,
        ptOptions: undefined,
        unstyled: false
    },
    context: {},
    globalCSS: undefined,
    classes: {},
    styles: '',
    extend: function extend() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var css = props.css;
        var defaultProps = $b76d8eda63b3c134$var$_objectSpread($b76d8eda63b3c134$var$_objectSpread({}, props.defaultProps), $b76d8eda63b3c134$export$425c3e0a21b857e8.defaultProps);
        var inlineStyles = {};
        var getProps = function getProps(props) {
            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            $b76d8eda63b3c134$export$425c3e0a21b857e8.context = context;
            $b76d8eda63b3c134$export$425c3e0a21b857e8.cProps = props;
            return (0, $a73ce425265b079e$export$4855211e6b8ad895).getMergedProps(props, defaultProps);
        };
        var getOtherProps = function getOtherProps(props) {
            return (0, $a73ce425265b079e$export$4855211e6b8ad895).getDiffProps(props, defaultProps);
        };
        var getPTValue = function getPTValue() {
            var _ComponentBase$contex;
            var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var searchInDefaultPT = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
            // obj either is the passthrough options or has a .pt property.
            if (obj.hasOwnProperty('pt') && obj.pt !== undefined) obj = obj.pt;
            var originalkey = key;
            var isNestedParam = /./g.test(originalkey) && !!params[originalkey.split('.')[0]];
            var fkey = isNestedParam ? (0, $a73ce425265b079e$export$4855211e6b8ad895).toFlatCase(originalkey.split('.')[1]) : (0, $a73ce425265b079e$export$4855211e6b8ad895).toFlatCase(originalkey);
            var hostName = params.hostName && (0, $a73ce425265b079e$export$4855211e6b8ad895).toFlatCase(params.hostName);
            var componentName = hostName || params.props && params.props.__TYPE && (0, $a73ce425265b079e$export$4855211e6b8ad895).toFlatCase(params.props.__TYPE) || '';
            var isTransition = fkey === 'transition';
            var datasetPrefix = 'data-pc-';
            var _getHostInstance = function getHostInstance(params) {
                return params !== null && params !== void 0 && params.props ? params.hostName ? params.props.__TYPE === params.hostName ? params.props : _getHostInstance(params.parent) : params.parent : undefined;
            };
            var getPropValue = function getPropValue(name) {
                var _params$props, _getHostInstance2;
                return ((_params$props = params.props) === null || _params$props === void 0 ? void 0 : _params$props[name]) || ((_getHostInstance2 = _getHostInstance(params)) === null || _getHostInstance2 === void 0 ? void 0 : _getHostInstance2[name]);
            };
            $b76d8eda63b3c134$export$425c3e0a21b857e8.cParams = params;
            $b76d8eda63b3c134$export$425c3e0a21b857e8.cName = componentName;
            var _ref = getPropValue('ptOptions') || $b76d8eda63b3c134$export$425c3e0a21b857e8.context.ptOptions || {}, _ref$mergeSections = _ref.mergeSections, mergeSections = _ref$mergeSections === void 0 ? true : _ref$mergeSections, _ref$mergeProps = _ref.mergeProps, useMergeProps = _ref$mergeProps === void 0 ? false : _ref$mergeProps;
            var getPTClassValue = function getPTClassValue() {
                var value = $b76d8eda63b3c134$var$_getOptionValue.apply(void 0, arguments);
                if (Array.isArray(value)) return {
                    className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff).apply(void 0, $b76d8eda63b3c134$var$_toConsumableArray(value))
                };
                if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isString(value)) return {
                    className: value
                };
                if (value !== null && value !== void 0 && value.hasOwnProperty('className') && Array.isArray(value.className)) return {
                    className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff).apply(void 0, $b76d8eda63b3c134$var$_toConsumableArray(value.className))
                };
                return value;
            };
            var globalPT = searchInDefaultPT ? isNestedParam ? $b76d8eda63b3c134$var$_useGlobalPT(getPTClassValue, originalkey, params) : $b76d8eda63b3c134$var$_useDefaultPT(getPTClassValue, originalkey, params) : undefined;
            var self = isNestedParam ? undefined : $b76d8eda63b3c134$var$_usePT($b76d8eda63b3c134$var$_getPT(obj, componentName), getPTClassValue, originalkey, params);
            var datasetProps = !isTransition && $b76d8eda63b3c134$var$_objectSpread($b76d8eda63b3c134$var$_objectSpread({}, fkey === 'root' && $b76d8eda63b3c134$var$_defineProperty({}, "".concat(datasetPrefix, "name"), params.props && params.props.__parentMetadata ? (0, $a73ce425265b079e$export$4855211e6b8ad895).toFlatCase(params.props.__TYPE) : componentName)), {}, $b76d8eda63b3c134$var$_defineProperty({}, "".concat(datasetPrefix, "section"), fkey));
            return mergeSections || !mergeSections && self ? useMergeProps ? (0, $a73ce425265b079e$export$9d1611c77c2fe928)([
                globalPT,
                self,
                Object.keys(datasetProps).length ? datasetProps : {}
            ], {
                classNameMergeFunction: (_ComponentBase$contex = $b76d8eda63b3c134$export$425c3e0a21b857e8.context.ptOptions) === null || _ComponentBase$contex === void 0 ? void 0 : _ComponentBase$contex.classNameMergeFunction
            }) : $b76d8eda63b3c134$var$_objectSpread($b76d8eda63b3c134$var$_objectSpread($b76d8eda63b3c134$var$_objectSpread({}, globalPT), self), Object.keys(datasetProps).length ? datasetProps : {}) : $b76d8eda63b3c134$var$_objectSpread($b76d8eda63b3c134$var$_objectSpread({}, self), Object.keys(datasetProps).length ? datasetProps : {});
        };
        var setMetaData = function setMetaData() {
            var metadata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var props = metadata.props, state = metadata.state;
            var ptm = function ptm() {
                var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return getPTValue((props || {}).pt, key, $b76d8eda63b3c134$var$_objectSpread($b76d8eda63b3c134$var$_objectSpread({}, metadata), params));
            };
            var ptmo = function ptmo() {
                var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return getPTValue(obj, key, params, false);
            };
            var isUnstyled = function isUnstyled() {
                return $b76d8eda63b3c134$export$425c3e0a21b857e8.context.unstyled || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).unstyled || props.unstyled;
            };
            var cx = function cx() {
                var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return !isUnstyled() ? $b76d8eda63b3c134$var$_getOptionValue(css && css.classes, key, $b76d8eda63b3c134$var$_objectSpread({
                    props: props,
                    state: state
                }, params)) : undefined;
            };
            var sx = function sx() {
                var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var when = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                if (when) {
                    var _ComponentBase$contex2;
                    var self = $b76d8eda63b3c134$var$_getOptionValue(css && css.inlineStyles, key, $b76d8eda63b3c134$var$_objectSpread({
                        props: props,
                        state: state
                    }, params));
                    var base = $b76d8eda63b3c134$var$_getOptionValue(inlineStyles, key, $b76d8eda63b3c134$var$_objectSpread({
                        props: props,
                        state: state
                    }, params));
                    return (0, $a73ce425265b079e$export$9d1611c77c2fe928)([
                        base,
                        self
                    ], {
                        classNameMergeFunction: (_ComponentBase$contex2 = $b76d8eda63b3c134$export$425c3e0a21b857e8.context.ptOptions) === null || _ComponentBase$contex2 === void 0 ? void 0 : _ComponentBase$contex2.classNameMergeFunction
                    });
                }
                return undefined;
            };
            return {
                ptm: ptm,
                ptmo: ptmo,
                sx: sx,
                cx: cx,
                isUnstyled: isUnstyled
            };
        };
        return $b76d8eda63b3c134$var$_objectSpread($b76d8eda63b3c134$var$_objectSpread({
            getProps: getProps,
            getOtherProps: getOtherProps,
            setMetaData: setMetaData
        }, props), {}, {
            defaultProps: defaultProps
        });
    }
};
var $b76d8eda63b3c134$var$_getOptionValue = function getOptionValue(obj) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var fKeys = String((0, $a73ce425265b079e$export$4855211e6b8ad895).toFlatCase(key)).split('.');
    var fKey = fKeys.shift();
    var matchedPTOption = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(obj) ? Object.keys(obj).find(function(k) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).toFlatCase(k) === fKey;
    }) : '';
    return fKey ? (0, $a73ce425265b079e$export$4855211e6b8ad895).isObject(obj) ? $b76d8eda63b3c134$var$_getOptionValue((0, $a73ce425265b079e$export$4855211e6b8ad895).getItemValue(obj[matchedPTOption], params), fKeys.join('.'), params) : undefined : (0, $a73ce425265b079e$export$4855211e6b8ad895).getItemValue(obj, params);
};
var $b76d8eda63b3c134$var$_getPT = function _getPT(pt) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var callback = arguments.length > 2 ? arguments[2] : undefined;
    var _usept = pt === null || pt === void 0 ? void 0 : pt._usept;
    var getValue = function getValue(value) {
        var _ref3;
        var checkSameKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var _value = callback ? callback(value) : value;
        var _key = (0, $a73ce425265b079e$export$4855211e6b8ad895).toFlatCase(key);
        return (_ref3 = checkSameKey ? _key !== $b76d8eda63b3c134$export$425c3e0a21b857e8.cName ? _value === null || _value === void 0 ? void 0 : _value[_key] : undefined : _value === null || _value === void 0 ? void 0 : _value[_key]) !== null && _ref3 !== void 0 ? _ref3 : _value;
    };
    return (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(_usept) ? {
        _usept: _usept,
        originalValue: getValue(pt.originalValue),
        value: getValue(pt.value)
    } : getValue(pt, true);
};
var $b76d8eda63b3c134$var$_usePT = function _usePT(pt, callback, key, params) {
    var fn = function fn(value) {
        return callback(value, key, params);
    };
    if (pt !== null && pt !== void 0 && pt.hasOwnProperty('_usept')) {
        var _ref4 = pt._usept || $b76d8eda63b3c134$export$425c3e0a21b857e8.context.ptOptions || {}, _ref4$mergeSections = _ref4.mergeSections, mergeSections = _ref4$mergeSections === void 0 ? true : _ref4$mergeSections, _ref4$mergeProps = _ref4.mergeProps, useMergeProps = _ref4$mergeProps === void 0 ? false : _ref4$mergeProps, classNameMergeFunction = _ref4.classNameMergeFunction;
        var originalValue = fn(pt.originalValue);
        var value = fn(pt.value);
        if (originalValue === undefined && value === undefined) return undefined;
        else if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isString(value)) return value;
        else if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isString(originalValue)) return originalValue;
        return mergeSections || !mergeSections && value ? useMergeProps ? (0, $a73ce425265b079e$export$9d1611c77c2fe928)([
            originalValue,
            value
        ], {
            classNameMergeFunction: classNameMergeFunction
        }) : $b76d8eda63b3c134$var$_objectSpread($b76d8eda63b3c134$var$_objectSpread({}, originalValue), value) : value;
    }
    return fn(pt);
};
var $b76d8eda63b3c134$var$getGlobalPT = function getGlobalPT() {
    return $b76d8eda63b3c134$var$_getPT($b76d8eda63b3c134$export$425c3e0a21b857e8.context.pt || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).pt, undefined, function(value) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getItemValue(value, $b76d8eda63b3c134$export$425c3e0a21b857e8.cParams);
    });
};
var $b76d8eda63b3c134$var$getDefaultPT = function getDefaultPT() {
    return $b76d8eda63b3c134$var$_getPT($b76d8eda63b3c134$export$425c3e0a21b857e8.context.pt || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).pt, undefined, function(value) {
        return $b76d8eda63b3c134$var$_getOptionValue(value, $b76d8eda63b3c134$export$425c3e0a21b857e8.cName, $b76d8eda63b3c134$export$425c3e0a21b857e8.cParams) || (0, $a73ce425265b079e$export$4855211e6b8ad895).getItemValue(value, $b76d8eda63b3c134$export$425c3e0a21b857e8.cParams);
    });
};
var $b76d8eda63b3c134$var$_useGlobalPT = function _useGlobalPT(callback, key, params) {
    return $b76d8eda63b3c134$var$_usePT($b76d8eda63b3c134$var$getGlobalPT(), callback, key, params);
};
var $b76d8eda63b3c134$var$_useDefaultPT = function _useDefaultPT(callback, key, params) {
    return $b76d8eda63b3c134$var$_usePT($b76d8eda63b3c134$var$getDefaultPT(), callback, key, params);
};
var $b76d8eda63b3c134$export$142583cb150b394 = function useHandleStyle(styles) {
    var config = arguments.length > 2 ? arguments[2] : undefined;
    var name = config.name, _config$styled = config.styled, styled = _config$styled === void 0 ? false : _config$styled, _config$hostName = config.hostName, hostName = _config$hostName === void 0 ? '' : _config$hostName;
    var globalCSS = $b76d8eda63b3c134$var$_useGlobalPT($b76d8eda63b3c134$var$_getOptionValue, 'global.css', $b76d8eda63b3c134$export$425c3e0a21b857e8.cParams);
    var componentName = (0, $a73ce425265b079e$export$4855211e6b8ad895).toFlatCase(name);
    var _useStyle = (0, $fbdf1e36fa0a01d8$export$72c85e333541e7f)($b76d8eda63b3c134$var$baseStyle, {
        name: 'base',
        manual: true
    }), loadBaseStyle = _useStyle.load;
    var _useStyle2 = (0, $fbdf1e36fa0a01d8$export$72c85e333541e7f)($b76d8eda63b3c134$var$commonStyle, {
        name: 'common',
        manual: true
    }), loadCommonStyle = _useStyle2.load;
    var _useStyle3 = (0, $fbdf1e36fa0a01d8$export$72c85e333541e7f)(globalCSS, {
        name: 'global',
        manual: true
    }), loadGlobalStyle = _useStyle3.load;
    var _useStyle4 = (0, $fbdf1e36fa0a01d8$export$72c85e333541e7f)(styles, {
        name: name,
        manual: true
    }), load = _useStyle4.load;
    var hook = function hook(hookName) {
        if (!hostName) {
            var selfHook = $b76d8eda63b3c134$var$_usePT($b76d8eda63b3c134$var$_getPT(($b76d8eda63b3c134$export$425c3e0a21b857e8.cProps || {}).pt, componentName), $b76d8eda63b3c134$var$_getOptionValue, "hooks.".concat(hookName));
            var defaultHook = $b76d8eda63b3c134$var$_useDefaultPT($b76d8eda63b3c134$var$_getOptionValue, "hooks.".concat(hookName));
            selfHook === null || selfHook === void 0 || selfHook();
            defaultHook === null || defaultHook === void 0 || defaultHook();
        }
    };
    hook('useMountEffect');
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        loadBaseStyle();
        loadGlobalStyle();
        loadCommonStyle();
        if (!styled) load();
    });
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        hook('useUpdateEffect');
    });
    (0, $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96)(function() {
        hook('useUnmountEffect');
    });
};




'use client';
function $2a0f230a4a316e4c$var$_extends() {
    return $2a0f230a4a316e4c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2a0f230a4a316e4c$var$_extends.apply(null, arguments);
}
function $2a0f230a4a316e4c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $2a0f230a4a316e4c$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $2a0f230a4a316e4c$var$_arrayLikeToArray(r);
}
function $2a0f230a4a316e4c$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $2a0f230a4a316e4c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2a0f230a4a316e4c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2a0f230a4a316e4c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $2a0f230a4a316e4c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2a0f230a4a316e4c$var$_toConsumableArray(r) {
    return $2a0f230a4a316e4c$var$_arrayWithoutHoles(r) || $2a0f230a4a316e4c$var$_iterableToArray(r) || $2a0f230a4a316e4c$var$_unsupportedIterableToArray(r) || $2a0f230a4a316e4c$var$_nonIterableSpread();
}
function $2a0f230a4a316e4c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2a0f230a4a316e4c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2a0f230a4a316e4c$var$_typeof(o);
}
function $2a0f230a4a316e4c$var$toPrimitive(t, r) {
    if ("object" != $2a0f230a4a316e4c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2a0f230a4a316e4c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2a0f230a4a316e4c$var$toPropertyKey(t) {
    var i = $2a0f230a4a316e4c$var$toPrimitive(t, "string");
    return "symbol" == $2a0f230a4a316e4c$var$_typeof(i) ? i : i + "";
}
function $2a0f230a4a316e4c$var$_defineProperty(e, r, t) {
    return (r = $2a0f230a4a316e4c$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2a0f230a4a316e4c$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $2a0f230a4a316e4c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2a0f230a4a316e4c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2a0f230a4a316e4c$var$_slicedToArray(r, e) {
    return $2a0f230a4a316e4c$var$_arrayWithHoles(r) || $2a0f230a4a316e4c$var$_iterableToArrayLimit(r, e) || $2a0f230a4a316e4c$var$_unsupportedIterableToArray(r, e) || $2a0f230a4a316e4c$var$_nonIterableRest();
}
var $2a0f230a4a316e4c$var$classes = {
    root: function root(_ref) {
        var props = _ref.props;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)("p-splitter p-component p-splitter-".concat(props.layout));
    },
    gutter: 'p-splitter-gutter',
    gutterHandler: 'p-splitter-gutter-handle',
    panel: {
        root: 'p-splitter-panel'
    }
};
var $2a0f230a4a316e4c$var$styles = "\n@layer primereact {\n    .p-splitter {\n        display: flex;\n        flex-wrap: nowrap;\n    }\n\n    .p-splitter-vertical {\n        flex-direction: column;\n    }\n\n    .p-splitter-panel {\n        flex-grow: 1;\n    }\n\n    .p-splitter-panel-nested {\n        display: flex;\n    }\n\n    .p-splitter-panel .p-splitter {\n        flex-grow: 1;\n        border: 0 none;\n    }\n\n    .p-splitter-gutter {\n        flex-grow: 0;\n        flex-shrink: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: col-resize;\n    }\n\n    .p-splitter-horizontal.p-splitter-resizing {\n        cursor: col-resize;\n        user-select: none;\n    }\n\n    .p-splitter-horizontal > .p-splitter-gutter > .p-splitter-gutter-handle {\n        height: 24px;\n        width: 100%;\n    }\n\n    .p-splitter-horizontal > .p-splitter-gutter {\n        cursor: col-resize;\n    }\n\n    .p-splitter-vertical.p-splitter-resizing {\n        cursor: row-resize;\n        user-select: none;\n    }\n\n    .p-splitter-vertical > .p-splitter-gutter {\n        cursor: row-resize;\n    }\n\n    .p-splitter-vertical > .p-splitter-gutter > .p-splitter-gutter-handle {\n        width: 24px;\n        height: 100%;\n    }\n}\n\n";
var $2a0f230a4a316e4c$var$SplitterBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'Splitter',
        className: null,
        gutterSize: 4,
        id: null,
        step: 5,
        layout: 'horizontal',
        onResizeEnd: null,
        stateKey: null,
        stateStorage: 'session',
        style: null,
        children: undefined
    },
    css: {
        classes: $2a0f230a4a316e4c$var$classes,
        styles: $2a0f230a4a316e4c$var$styles
    }
});
var $2a0f230a4a316e4c$var$SplitterPanelBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'SplitterPanel',
        className: null,
        minSize: null,
        size: null,
        style: null,
        children: undefined
    },
    getCProps: function getCProps(panel) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getComponentProps(panel, $2a0f230a4a316e4c$var$SplitterPanelBase.defaultProps);
    },
    getCOtherProps: function getCOtherProps(panel) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getComponentDiffProps(panel, $2a0f230a4a316e4c$var$SplitterPanelBase.defaultProps);
    },
    getCProp: function getCProp(panel, name) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getComponentProp(panel, name, $2a0f230a4a316e4c$var$SplitterPanelBase.defaultProps);
    }
});
function $2a0f230a4a316e4c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2a0f230a4a316e4c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2a0f230a4a316e4c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2a0f230a4a316e4c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2a0f230a4a316e4c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2a0f230a4a316e4c$export$ac6f1a226cadaf83 = function SplitterPanel() {};
var $2a0f230a4a316e4c$export$980082fdfafd21f8 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $2a0f230a4a316e4c$var$SplitterBase.getProps(inProps, context);
    var idState = $acw62.useRef('');
    var elementRef = $acw62.useRef(null);
    var gutterRef = $acw62.useRef();
    var gutterRefs = $acw62.useRef({});
    var size = $acw62.useRef(null);
    var dragging = $acw62.useRef(null);
    var startPos = $acw62.useRef(null);
    var prevPanelElement = $acw62.useRef(null);
    var nextPanelElement = $acw62.useRef(null);
    var prevPanelSize = $acw62.useRef(null);
    var prevSize = $acw62.useRef(null);
    var prevPanelSizeNew = $acw62.useRef(null);
    var nextPanelSize = $acw62.useRef(null);
    var nextPanelSizeNew = $acw62.useRef(null);
    var prevPanelIndex = $acw62.useRef(null);
    var timer = $acw62.useRef(null);
    var _React$useState = $acw62.useState([]), _React$useState2 = $2a0f230a4a316e4c$var$_slicedToArray(_React$useState, 2), panelSizes = _React$useState2[0], setPanelSizes = _React$useState2[1];
    var _React$useState3 = $acw62.useState(false), _React$useState4 = $2a0f230a4a316e4c$var$_slicedToArray(_React$useState3, 2), nested = _React$useState4[0], setNested = _React$useState4[1];
    var isStateful = props.stateKey != null;
    var childrenLength = props.children && props.children.length || 1;
    var panelSize = function panelSize(sizes, index) {
        return index in sizes ? sizes[index] : props.children && [].concat(props.children)[index].props.size || 100 / childrenLength;
    };
    var horizontal = props.layout === 'horizontal';
    var metaData = {
        props: props,
        state: {
            panelSizes: panelSizes,
            nested: (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(elementRef.current && elementRef.current.parentElement, 'data-p-splitter-panel-nested') === true
        }
    };
    var _SplitterBase$setMeta = $2a0f230a4a316e4c$var$SplitterBase.setMetaData($2a0f230a4a316e4c$var$_objectSpread({}, metaData)), ptm = _SplitterBase$setMeta.ptm, cx = _SplitterBase$setMeta.cx, isUnstyled = _SplitterBase$setMeta.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($2a0f230a4a316e4c$var$SplitterBase.css.styles, isUnstyled, {
        name: 'splitter'
    });
    var getPanelPT = function getPanelPT(key) {
        return ptm(key, {
            context: {
                nested: nested
            }
        });
    };
    var _useEventListener = (0, $fbdf1e36fa0a01d8$export$7080b3e976bc91ab)({
        type: 'mousemove',
        listener: function listener(event) {
            return onResize(event);
        }
    }), _useEventListener2 = $2a0f230a4a316e4c$var$_slicedToArray(_useEventListener, 2), bindDocumentMouseMoveListener = _useEventListener2[0], unbindDocumentMouseMoveListener = _useEventListener2[1];
    var _useEventListener3 = (0, $fbdf1e36fa0a01d8$export$7080b3e976bc91ab)({
        type: 'mouseup',
        listener: function listener(event) {
            onResizeEnd(event);
            unbindMouseListeners();
        }
    }), _useEventListener4 = $2a0f230a4a316e4c$var$_slicedToArray(_useEventListener3, 2), bindDocumentMouseUpListener = _useEventListener4[0], unbindDocumentMouseUpListener = _useEventListener4[1];
    var bindMouseListeners = function bindMouseListeners() {
        bindDocumentMouseMoveListener();
        bindDocumentMouseUpListener();
    };
    var unbindMouseListeners = function unbindMouseListeners() {
        unbindDocumentMouseMoveListener();
        unbindDocumentMouseUpListener();
    };
    var getPanelProp = function getPanelProp(panel, name) {
        return $2a0f230a4a316e4c$var$SplitterPanelBase.getCProp(panel, name);
    };
    var validateResize = function validateResize(newPrevPanelSize, newNextPanelSize) {
        if (newPrevPanelSize > 100 || newPrevPanelSize < 0) return false;
        if (newNextPanelSize > 100 || newNextPanelSize < 0) return false;
        if (props.children[prevPanelIndex.current].props && props.children[prevPanelIndex.current].props.minSize && props.children[prevPanelIndex.current].props.minSize > newPrevPanelSize) return false;
        if (props.children[prevPanelIndex.current + 1].props && props.children[prevPanelIndex.current + 1].props.minSize && props.children[prevPanelIndex.current + 1].props.minSize > newNextPanelSize) return false;
        return true;
    };
    var clear = function clear() {
        dragging.current = false;
        size.current = null;
        startPos.current = null;
        prevPanelElement.current = null;
        nextPanelElement.current = null;
        prevPanelSize.current = null;
        prevPanelSizeNew.current = null;
        nextPanelSize.current = null;
        nextPanelSizeNew.current = null;
        prevPanelIndex.current = null;
    };
    var getStorage = $acw62.useCallback(function() {
        switch(props.stateStorage){
            case 'local':
                return window.localStorage;
            case 'session':
                return window.sessionStorage;
            default:
                throw new Error(props.stateStorage + ' is not a valid value for the state storage, supported values are "local" and "session".');
        }
    }, [
        props.stateStorage
    ]);
    var saveState = function saveState(sizes) {
        if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isArray(sizes)) getStorage().setItem(props.stateKey, JSON.stringify(sizes));
    };
    var restoreState = $acw62.useCallback(function() {
        var stateString = getStorage().getItem(props.stateKey);
        if (stateString) setPanelSizes(JSON.parse(stateString));
    }, [
        getStorage,
        props.stateKey
    ]);
    var onResizeStart = function onResizeStart(event, index, isKeyDown) {
        var pageX = event.type === 'touchstart' ? event.touches[0].pageX : event.pageX;
        var pageY = event.type === 'touchstart' ? event.touches[0].pageY : event.pageY;
        gutterRef.current = gutterRefs.current[index];
        size.current = horizontal ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getWidth(elementRef.current) : (0, $a73ce425265b079e$export$ff8ccbac9225de62).getHeight(elementRef.current);
        dragging.current = true;
        startPos.current = horizontal ? pageX : pageY;
        prevPanelElement.current = gutterRef.current.previousElementSibling;
        nextPanelElement.current = gutterRef.current.nextElementSibling;
        if (isKeyDown) {
            prevPanelSize.current = horizontal ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(prevPanelElement.current, true) : (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterHeight(prevPanelElement.current, true);
            nextPanelSize.current = horizontal ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(nextPanelElement.current, true) : (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterHeight(nextPanelElement.current, true);
        } else {
            prevPanelSize.current = 100 * (horizontal ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(prevPanelElement.current, true) : (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterHeight(prevPanelElement.current, true)) / size.current;
            nextPanelSize.current = 100 * (horizontal ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(nextPanelElement.current, true) : (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterHeight(nextPanelElement.current, true)) / size.current;
        }
        prevPanelSizeNew.current = prevPanelSize.current;
        nextPanelSizeNew.current = nextPanelSize.current;
        prevPanelIndex.current = index;
        !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(gutterRef.current, 'p-splitter-gutter-resizing');
        gutterRef.current.setAttribute('data-p-splitter-gutter-resizing', true);
        !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(elementRef.current, 'p-splitter-resizing');
        elementRef.current.setAttribute('data-p-splitter-resizing', true);
    };
    var onResize = function onResize(event) {
        var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var isKeyDown = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var newPos;
        var newNextPanelSize;
        var newPrevPanelSize;
        var pageX = event.type === 'touchmove' ? event.touches[0].pageX : event.pageX;
        var pageY = event.type === 'touchmove' ? event.touches[0].pageY : event.pageY;
        if (isKeyDown) {
            if (horizontal) {
                newPrevPanelSize = 100 * (prevPanelSize.current + step) / size.current;
                newNextPanelSize = 100 * (nextPanelSize.current - step) / size.current;
            } else {
                newPrevPanelSize = 100 * (prevPanelSize.current - step) / size.current;
                newNextPanelSize = 100 * (nextPanelSize.current + step) / size.current;
            }
        } else {
            if (horizontal) newPos = pageX * 100 / size.current - startPos.current * 100 / size.current;
            else newPos = pageY * 100 / size.current - startPos.current * 100 / size.current;
            newPrevPanelSize = prevPanelSize.current + newPos;
            newNextPanelSize = nextPanelSize.current - newPos;
        }
        resizePanel(prevPanelIndex.current, newPrevPanelSize, newNextPanelSize);
    };
    var onResizeEnd = function onResizeEnd(event) {
        var sizes = $2a0f230a4a316e4c$var$_toConsumableArray(panelSizes);
        sizes[prevPanelIndex.current] = prevPanelSizeNew.current;
        sizes[prevPanelIndex.current + 1] = nextPanelSizeNew.current;
        if (props.onResizeEnd) props.onResizeEnd({
            originalEvent: event,
            sizes: sizes
        });
        if (isStateful) saveState(sizes);
        setPanelSizes(sizes);
        !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(gutterRef.current, 'p-splitter-gutter-resizing');
        gutterRefs.current && Object.keys(gutterRefs.current).forEach(function(key) {
            return gutterRefs.current[key].setAttribute('data-p-splitter-gutter-resizing', false);
        });
        !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(elementRef.current, 'p-splitter-resizing');
        elementRef.current.setAttribute('data-p-splitter-resizing', false);
        clear();
    };
    var onGutterKeyUp = function onGutterKeyUp() {
        clearTimer();
        onResizeEnd();
    };
    var onGutterKeyDown = function onGutterKeyDown(event, index) {
        var minSize = props.children[index].props && props.children[index].props.minSize || 0;
        switch(event.code){
            case 'ArrowLeft':
                if (horizontal) setTimer(event, index, props.step * -1);
                event.preventDefault();
                break;
            case 'ArrowRight':
                if (horizontal) setTimer(event, index, props.step);
                event.preventDefault();
                break;
            case 'ArrowDown':
                if (!horizontal) setTimer(event, index, props.step * -1);
                event.preventDefault();
                break;
            case 'ArrowUp':
                if (!horizontal) setTimer(event, index, props.step);
                event.preventDefault();
                break;
            case 'Home':
                resizePanel(index, 100 - minSize, minSize);
                event.preventDefault();
                break;
            case 'End':
                resizePanel(index, minSize, 100 - minSize);
                event.preventDefault();
                break;
            case 'NumpadEnter':
            case 'Enter':
                if (prevSize.current >= 100 - (minSize || 5)) resizePanel(index, minSize, 100 - minSize);
                else resizePanel(index, 100 - minSize, minSize);
                event.preventDefault();
                break;
        }
    };
    var resizePanel = function resizePanel(index, newPrevPanelSize, newNextPanelSize) {
        prevPanelIndex.current = index;
        gutterRef.current = gutterRefs.current[index];
        size.current = horizontal ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getWidth(elementRef.current) : (0, $a73ce425265b079e$export$ff8ccbac9225de62).getHeight(elementRef.current);
        prevPanelElement.current = gutterRef.current.previousElementSibling;
        nextPanelElement.current = gutterRef.current.nextElementSibling;
        if (validateResize(newPrevPanelSize, newNextPanelSize)) {
            prevPanelSizeNew.current = newPrevPanelSize;
            nextPanelSizeNew.current = newNextPanelSize;
            prevPanelElement.current.style.flexBasis = 'calc(' + newPrevPanelSize + '% - ' + (props.children.length - 1) * props.gutterSize + 'px)';
            nextPanelElement.current.style.flexBasis = 'calc(' + newNextPanelSize + '% - ' + (props.children.length - 1) * props.gutterSize + 'px)';
            prevSize.current = parseFloat(newPrevPanelSize).toFixed(4);
        }
    };
    var repeat = function repeat(event, index, step) {
        onResizeStart(event, index, true);
        onResize(event, step, true);
    };
    var setTimer = function setTimer(event, index, step) {
        if (!timer.current) timer.current = setInterval(function() {
            repeat(event, index, step);
        }, 40);
    };
    var clearTimer = function clearTimer() {
        if (timer.current) {
            clearInterval(timer.current);
            timer.current = null;
        }
    };
    var onGutterMouseDown = function onGutterMouseDown(event, index) {
        onResizeStart(event, index, false);
        bindMouseListeners();
    };
    var onGutterTouchStart = function onGutterTouchStart(event, index) {
        onResizeStart(event, index, false);
        window.addEventListener('touchmove', onGutterTouchMove, {
            passive: false,
            cancelable: false
        });
        window.addEventListener('touchend', _onGutterTouchEnd);
    };
    var onGutterTouchMove = function onGutterTouchMove(event) {
        onResize(event);
    };
    var _onGutterTouchEnd = function onGutterTouchEnd(event) {
        onResizeEnd(event);
        window.removeEventListener('touchmove', onGutterTouchMove);
        window.removeEventListener('touchend', _onGutterTouchEnd);
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        if (elementRef.current) idState.current = (0, $a73ce425265b079e$export$d5d9b89141473caf)();
    });
    $acw62.useEffect(function() {
        var panelElements = $2a0f230a4a316e4c$var$_toConsumableArray(elementRef.current.children).filter(function(child) {
            return (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(child, 'data-pc-section') === 'splitterpanel.root';
        });
        var _panelSizes = [];
        panelElements.map(function(panelElement, i) {
            prevSize.current = panelSize(panelSizes, 0);
            _panelSizes[i] = panelSize(panelSizes, i);
            if (panelElement.childNodes && (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty((0, $a73ce425265b079e$export$ff8ccbac9225de62).find(panelElement, "[data-pc-name='splitter']") && (0, $a73ce425265b079e$export$ff8ccbac9225de62).find(panelElement, "[data-pc-section='root']"))) {
                !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(panelElement, 'p-splitter-panel-nested');
                panelElement.setAttribute('data-p-splitter-panel-nested', true);
                setNested(true);
            }
        });
        setPanelSizes(_panelSizes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $acw62.useEffect(function() {
        if (isStateful) restoreState();
    }, [
        restoreState,
        isStateful
    ]);
    var createPanel = function createPanel(panel, index) {
        var panelId = getPanelProp(panel, 'id') || "".concat(idState.current, "_").concat(index);
        var panelClassName = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(getPanelProp(panel, 'className'), cx('panel.root'));
        var gutterProps = mergeProps({
            ref: function ref(el) {
                return gutterRefs.current[index] = el;
            },
            className: cx('gutter'),
            style: horizontal ? {
                width: props.gutterSize + 'px'
            } : {
                height: props.gutterSize + 'px'
            },
            onMouseDown: function onMouseDown(event) {
                return onGutterMouseDown(event, index);
            },
            onKeyDown: function onKeyDown(event) {
                return onGutterKeyDown(event, index);
            },
            onKeyUp: onGutterKeyUp,
            onTouchStart: function onTouchStart(event) {
                return onGutterTouchStart(event, index);
            },
            onTouchMove: function onTouchMove(event) {
                return onGutterTouchMove(event);
            },
            onTouchEnd: function onTouchEnd(event) {
                return _onGutterTouchEnd(event);
            },
            'data-p-splitter-gutter-resizing': false
        }, ptm('gutter'));
        var gutterHandlerProps = mergeProps({
            tabIndex: getPanelProp(panel, 'tabIndex') || 0,
            className: cx('gutterHandler'),
            role: 'separator',
            'aria-orientation': horizontal ? 'vertical' : 'horizontal',
            'aria-controls': panelId,
            'aria-label': getPanelProp(panel, 'aria-label'),
            'aria-labelledby': getPanelProp(panel, 'aria-labelledby'),
            'aria-valuenow': prevSize.current,
            'aria-valuetext': parseFloat(prevSize.current).toFixed(0) + '%',
            'aria-valuemin': getPanelProp(panel, 'minSize') || '0',
            'aria-valuemax': '100'
        }, ptm('gutterHandler'));
        var gutter = index !== props.children.length - 1 && /*#__PURE__*/ $acw62.createElement("div", gutterProps, /*#__PURE__*/ $acw62.createElement("div", gutterHandlerProps));
        var flexBasis = 'calc(' + panelSize(panelSizes, index) + '% - ' + (childrenLength - 1) * props.gutterSize + 'px)';
        var rootProps = mergeProps({
            key: index,
            id: panelId,
            className: panelClassName,
            style: $2a0f230a4a316e4c$var$_objectSpread($2a0f230a4a316e4c$var$_objectSpread({}, getPanelProp(panel, 'style')), {}, {
                flexBasis: flexBasis
            }),
            role: 'presentation',
            'data-p-splitter-panel-nested': false,
            onClick: getPanelProp(panel, 'onClick')
        }, getPanelPT('splitterpanel.root'));
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", rootProps, getPanelProp(panel, 'children')), gutter);
    };
    var createPanels = function createPanels() {
        return $acw62.Children.map(props.children, createPanel);
    };
    var rootProps = mergeProps({
        id: props.id,
        style: props.style,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root')),
        'data-p-splitter-resizing': false
    }, $2a0f230a4a316e4c$var$SplitterBase.getOtherProps(props), ptm('root'));
    var panels = createPanels();
    return /*#__PURE__*/ $acw62.createElement("div", $2a0f230a4a316e4c$var$_extends({
        ref: elementRef
    }, rootProps), panels);
}));
$2a0f230a4a316e4c$export$ac6f1a226cadaf83.displayName = 'SplitterPanel';
$2a0f230a4a316e4c$export$980082fdfafd21f8.displayName = 'Splitter';





var $acw62 = parcelRequire("acw62");
const $91fa2a3eb54dc801$export$fbffe46385bd9449 = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $91fa2a3eb54dc801$export$6bbcf3368996eea5 = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $91fa2a3eb54dc801$export$4d39aad5d54dcf1a = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $91fa2a3eb54dc801$export$c1a3e0cf67c968c4 = /*#__PURE__*/ (0, $acw62.createContext)(null);
class $91fa2a3eb54dc801$export$724f6b867059ef5f {
    constructor(name, icon, description = null){
        this.name = name;
        this.icon = icon;
        this.description = description;
        this.selection = null;
        this.propertyEditor = null;
    }
}
class $91fa2a3eb54dc801$export$9c1e06a8834623f1 {
    constructor(){
        this.tools = {};
    }
    addTool(tool) {
        if (!tool instanceof $91fa2a3eb54dc801$export$724f6b867059ef5f) throw new Error('Parameter must be instance of Tool');
        this.tools[tool.name] = tool;
    }
}
const $91fa2a3eb54dc801$export$88ae2e76299eaa00 = new $91fa2a3eb54dc801$export$9c1e06a8834623f1();
$91fa2a3eb54dc801$export$88ae2e76299eaa00.addTool(new $91fa2a3eb54dc801$export$724f6b867059ef5f('selectTool', 'fa-solid fa-arrow-pointer'));
$91fa2a3eb54dc801$export$88ae2e76299eaa00.addTool(new $91fa2a3eb54dc801$export$724f6b867059ef5f('stopsTool', 'fa-solid fa-location-dot', 'Przystanki i dworce'));
$91fa2a3eb54dc801$export$88ae2e76299eaa00.addTool(new $91fa2a3eb54dc801$export$724f6b867059ef5f('segmentsTool', 'fa-solid fa-route', 'Odcinki tras'));
$91fa2a3eb54dc801$export$88ae2e76299eaa00.addTool(new $91fa2a3eb54dc801$export$724f6b867059ef5f('routesTool', 'fa-solid fa-timeline', 'Linie komunikacyjne i wzory tras'));
$91fa2a3eb54dc801$export$88ae2e76299eaa00.addTool(new $91fa2a3eb54dc801$export$724f6b867059ef5f('calendarsTool', 'fa-solid fa-calendar-days', 'Kalendarze'));
$91fa2a3eb54dc801$export$88ae2e76299eaa00.addTool(new $91fa2a3eb54dc801$export$724f6b867059ef5f('tripsTool', 'fa-solid fa-road', 'Kursy'));
$91fa2a3eb54dc801$export$88ae2e76299eaa00.addTool(new $91fa2a3eb54dc801$export$724f6b867059ef5f('timetablesTool', 'fa-solid fa-table', "Rozk\u0142ady liniowe"));
function $91fa2a3eb54dc801$export$dc6be6741310efa6({ children: children }) {
    const [tool, dispatch] = (0, $acw62.useReducer)($91fa2a3eb54dc801$export$1317303d5a2678fb, {
        ...$91fa2a3eb54dc801$var$initialTool
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($91fa2a3eb54dc801$export$fbffe46385bd9449.Provider, {
        value: tool,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($91fa2a3eb54dc801$export$6bbcf3368996eea5.Provider, {
            value: dispatch,
            children: children
        })
    });
}
function $91fa2a3eb54dc801$export$1317303d5a2678fb(tool, action) {
    console.log('disp. tool:', tool);
    console.log('disp. action:', action);
    switch(action.type){
        case 'changed':
            return action.newTool;
        case 'editProperties':
            return {
            };
        default:
            throw Error('Unknown action: ' + action.type);
    }
}
const $91fa2a3eb54dc801$var$initialTool = $91fa2a3eb54dc801$export$88ae2e76299eaa00.tools['selectTool'];




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

'use client';
var $48a8663a5f44055b$export$a188ecdd443fe91a = {
    defaultProps: {
        __TYPE: 'IconBase',
        className: null,
        label: null,
        spin: false
    },
    getProps: function getProps(props) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getMergedProps(props, $48a8663a5f44055b$export$a188ecdd443fe91a.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getDiffProps(props, $48a8663a5f44055b$export$a188ecdd443fe91a.defaultProps);
    },
    getPTI: function getPTI(props) {
        var isLabelEmpty = (0, $a73ce425265b079e$export$4855211e6b8ad895).isEmpty(props.label);
        var otherProps = $48a8663a5f44055b$export$a188ecdd443fe91a.getOtherProps(props);
        var ptiProps = {
            className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-icon', {
                'p-icon-spin': props.spin
            }, props.className),
            role: !isLabelEmpty ? 'img' : undefined,
            'aria-label': !isLabelEmpty ? props.label : undefined,
            'aria-hidden': isLabelEmpty
        };
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getMergedProps(otherProps, ptiProps);
    }
};


'use client';
function $f693dcb2ccf8330b$var$_extends() {
    return $f693dcb2ccf8330b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f693dcb2ccf8330b$var$_extends.apply(null, arguments);
}
var $f693dcb2ccf8330b$export$fe708d541030d854 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $f693dcb2ccf8330b$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M6.99701 14C5.85441 13.999 4.72939 13.7186 3.72012 13.1832C2.71084 12.6478 1.84795 11.8737 1.20673 10.9284C0.565504 9.98305 0.165424 8.89526 0.041387 7.75989C-0.0826496 6.62453 0.073125 5.47607 0.495122 4.4147C0.917119 3.35333 1.59252 2.4113 2.46241 1.67077C3.33229 0.930247 4.37024 0.413729 5.4857 0.166275C6.60117 -0.0811796 7.76026 -0.0520535 8.86188 0.251112C9.9635 0.554278 10.9742 1.12227 11.8057 1.90555C11.915 2.01493 11.9764 2.16319 11.9764 2.31778C11.9764 2.47236 11.915 2.62062 11.8057 2.73C11.7521 2.78503 11.688 2.82877 11.6171 2.85864C11.5463 2.8885 11.4702 2.90389 11.3933 2.90389C11.3165 2.90389 11.2404 2.8885 11.1695 2.85864C11.0987 2.82877 11.0346 2.78503 10.9809 2.73C9.9998 1.81273 8.73246 1.26138 7.39226 1.16876C6.05206 1.07615 4.72086 1.44794 3.62279 2.22152C2.52471 2.99511 1.72683 4.12325 1.36345 5.41602C1.00008 6.70879 1.09342 8.08723 1.62775 9.31926C2.16209 10.5513 3.10478 11.5617 4.29713 12.1803C5.48947 12.7989 6.85865 12.988 8.17414 12.7157C9.48963 12.4435 10.6711 11.7264 11.5196 10.6854C12.3681 9.64432 12.8319 8.34282 12.8328 7C12.8328 6.84529 12.8943 6.69692 13.0038 6.58752C13.1132 6.47812 13.2616 6.41667 13.4164 6.41667C13.5712 6.41667 13.7196 6.47812 13.8291 6.58752C13.9385 6.69692 14 6.84529 14 7C14 8.85651 13.2622 10.637 11.9489 11.9497C10.6356 13.2625 8.85432 14 6.99701 14Z",
        fill: "currentColor"
    }));
}));
$f693dcb2ccf8330b$export$fe708d541030d854.displayName = 'SpinnerIcon';



var $acw62 = parcelRequire("acw62");




'use client';
function $8e3aa2f039797217$var$_extends() {
    return $8e3aa2f039797217$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8e3aa2f039797217$var$_extends.apply(null, arguments);
}
function $8e3aa2f039797217$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8e3aa2f039797217$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8e3aa2f039797217$var$_typeof(o);
}
function $8e3aa2f039797217$var$toPrimitive(t, r) {
    if ("object" != $8e3aa2f039797217$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8e3aa2f039797217$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8e3aa2f039797217$var$toPropertyKey(t) {
    var i = $8e3aa2f039797217$var$toPrimitive(t, "string");
    return "symbol" == $8e3aa2f039797217$var$_typeof(i) ? i : i + "";
}
function $8e3aa2f039797217$var$_defineProperty(e, r, t) {
    return (r = $8e3aa2f039797217$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8e3aa2f039797217$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $8e3aa2f039797217$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $8e3aa2f039797217$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $8e3aa2f039797217$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $8e3aa2f039797217$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $8e3aa2f039797217$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $8e3aa2f039797217$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8e3aa2f039797217$var$_slicedToArray(r, e) {
    return $8e3aa2f039797217$var$_arrayWithHoles(r) || $8e3aa2f039797217$var$_iterableToArrayLimit(r, e) || $8e3aa2f039797217$var$_unsupportedIterableToArray(r, e) || $8e3aa2f039797217$var$_nonIterableRest();
}
var $8e3aa2f039797217$var$styles = "\n@layer primereact {\n    .p-ripple {\n        overflow: hidden;\n        position: relative;\n    }\n    \n    .p-ink {\n        display: block;\n        position: absolute;\n        background: rgba(255, 255, 255, 0.5);\n        border-radius: 100%;\n        transform: scale(0);\n    }\n    \n    .p-ink-active {\n        animation: ripple 0.4s linear;\n    }\n    \n    .p-ripple-disabled .p-ink {\n        display: none;\n    }\n}\n\n@keyframes ripple {\n    100% {\n        opacity: 0;\n        transform: scale(2.5);\n    }\n}\n\n";
var $8e3aa2f039797217$var$classes = {
    root: 'p-ink'
};
var $8e3aa2f039797217$var$RippleBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'Ripple',
        children: undefined
    },
    css: {
        styles: $8e3aa2f039797217$var$styles,
        classes: $8e3aa2f039797217$var$classes
    },
    getProps: function getProps(props) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getMergedProps(props, $8e3aa2f039797217$var$RippleBase.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getDiffProps(props, $8e3aa2f039797217$var$RippleBase.defaultProps);
    }
});
function $8e3aa2f039797217$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8e3aa2f039797217$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8e3aa2f039797217$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8e3aa2f039797217$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8e3aa2f039797217$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8e3aa2f039797217$export$9e9146f7e027fdaa = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var _React$useState = $acw62.useState(false), _React$useState2 = $8e3aa2f039797217$var$_slicedToArray(_React$useState, 2), isMounted = _React$useState2[0], setMounted = _React$useState2[1];
    var inkRef = $acw62.useRef(null);
    var targetRef = $acw62.useRef(null);
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $8e3aa2f039797217$var$RippleBase.getProps(inProps, context);
    var isRippleActive = context && context.ripple || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).ripple;
    var metaData = {
        props: props
    };
    (0, $fbdf1e36fa0a01d8$export$72c85e333541e7f)($8e3aa2f039797217$var$RippleBase.css.styles, {
        name: 'ripple',
        manual: !isRippleActive
    });
    var _RippleBase$setMetaDa = $8e3aa2f039797217$var$RippleBase.setMetaData($8e3aa2f039797217$var$_objectSpread({}, metaData)), ptm = _RippleBase$setMetaDa.ptm, cx = _RippleBase$setMetaDa.cx;
    var getTarget = function getTarget() {
        return inkRef.current && inkRef.current.parentElement;
    };
    var bindEvents = function bindEvents() {
        if (targetRef.current) targetRef.current.addEventListener('pointerdown', onPointerDown);
    };
    var unbindEvents = function unbindEvents() {
        if (targetRef.current) targetRef.current.removeEventListener('pointerdown', onPointerDown);
    };
    var onPointerDown = function onPointerDown(event) {
        var offset = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOffset(targetRef.current);
        var offsetX = event.pageX - offset.left + document.body.scrollTop - (0, $a73ce425265b079e$export$ff8ccbac9225de62).getWidth(inkRef.current) / 2;
        var offsetY = event.pageY - offset.top + document.body.scrollLeft - (0, $a73ce425265b079e$export$ff8ccbac9225de62).getHeight(inkRef.current) / 2;
        activateRipple(offsetX, offsetY);
    };
    var activateRipple = function activateRipple(offsetX, offsetY) {
        if (!inkRef.current || getComputedStyle(inkRef.current, null).display === 'none') return;
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(inkRef.current, 'p-ink-active');
        setDimensions();
        inkRef.current.style.top = offsetY + 'px';
        inkRef.current.style.left = offsetX + 'px';
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(inkRef.current, 'p-ink-active');
    };
    var onAnimationEnd = function onAnimationEnd(event) {
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(event.currentTarget, 'p-ink-active');
    };
    var setDimensions = function setDimensions() {
        if (inkRef.current && !(0, $a73ce425265b079e$export$ff8ccbac9225de62).getHeight(inkRef.current) && !(0, $a73ce425265b079e$export$ff8ccbac9225de62).getWidth(inkRef.current)) {
            var d = Math.max((0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(targetRef.current), (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterHeight(targetRef.current));
            inkRef.current.style.height = d + 'px';
            inkRef.current.style.width = d + 'px';
        }
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            getInk: function getInk() {
                return inkRef.current;
            },
            getTarget: function getTarget() {
                return targetRef.current;
            }
        };
    });
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        // for App Router in Next.js ^14
        setMounted(true);
    });
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (isMounted && inkRef.current) {
            targetRef.current = getTarget();
            setDimensions();
            bindEvents();
        }
    }, [
        isMounted
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (inkRef.current && !targetRef.current) {
            targetRef.current = getTarget();
            setDimensions();
            bindEvents();
        }
    });
    (0, $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96)(function() {
        if (inkRef.current) {
            targetRef.current = null;
            unbindEvents();
        }
    });
    if (!isRippleActive) return null;
    var rootProps = mergeProps({
        'aria-hidden': true,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(cx('root'))
    }, $8e3aa2f039797217$var$RippleBase.getOtherProps(props), ptm('root'));
    return /*#__PURE__*/ $acw62.createElement("span", $8e3aa2f039797217$var$_extends({
        role: "presentation",
        ref: inkRef
    }, rootProps, {
        onAnimationEnd: onAnimationEnd
    }));
}));
$8e3aa2f039797217$export$9e9146f7e027fdaa.displayName = 'Ripple';



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");



'use client';
function $e7a3b5428092a192$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $e7a3b5428092a192$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e7a3b5428092a192$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $e7a3b5428092a192$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e7a3b5428092a192$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e7a3b5428092a192$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $e7a3b5428092a192$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e7a3b5428092a192$var$_slicedToArray(r, e) {
    return $e7a3b5428092a192$var$_arrayWithHoles(r) || $e7a3b5428092a192$var$_iterableToArrayLimit(r, e) || $e7a3b5428092a192$var$_unsupportedIterableToArray(r, e) || $e7a3b5428092a192$var$_nonIterableRest();
}
var $e7a3b5428092a192$var$PortalBase = {
    defaultProps: {
        __TYPE: 'Portal',
        element: null,
        appendTo: null,
        visible: false,
        onMounted: null,
        onUnmounted: null,
        children: undefined
    },
    getProps: function getProps(props) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getMergedProps(props, $e7a3b5428092a192$var$PortalBase.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getDiffProps(props, $e7a3b5428092a192$var$PortalBase.defaultProps);
    }
};
var $e7a3b5428092a192$export$602eac185826482c = /*#__PURE__*/ $acw62.memo(function(inProps) {
    var props = $e7a3b5428092a192$var$PortalBase.getProps(inProps);
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var _React$useState = $acw62.useState(props.visible && (0, $a73ce425265b079e$export$ff8ccbac9225de62).isClient()), _React$useState2 = $e7a3b5428092a192$var$_slicedToArray(_React$useState, 2), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        if ((0, $a73ce425265b079e$export$ff8ccbac9225de62).isClient() && !mountedState) {
            setMountedState(true);
            props.onMounted && props.onMounted();
        }
    });
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        props.onMounted && props.onMounted();
    }, [
        mountedState
    ]);
    (0, $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96)(function() {
        props.onUnmounted && props.onUnmounted();
    });
    var element = props.element || props.children;
    if (element && mountedState) {
        var appendTo = props.appendTo || context && context.appendTo || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).appendTo;
        if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isFunction(appendTo)) appendTo = appendTo();
        if (!appendTo) appendTo = document.body;
        return appendTo === 'self' ? element : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(element, appendTo);
    }
    return null;
});
$e7a3b5428092a192$export$602eac185826482c.displayName = 'Portal';



'use client';
function $b74dfa9f7ee9d9bc$var$_extends() {
    return $b74dfa9f7ee9d9bc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b74dfa9f7ee9d9bc$var$_extends.apply(null, arguments);
}
function $b74dfa9f7ee9d9bc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b74dfa9f7ee9d9bc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b74dfa9f7ee9d9bc$var$_typeof(o);
}
function $b74dfa9f7ee9d9bc$var$toPrimitive(t, r) {
    if ("object" != $b74dfa9f7ee9d9bc$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b74dfa9f7ee9d9bc$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b74dfa9f7ee9d9bc$var$toPropertyKey(t) {
    var i = $b74dfa9f7ee9d9bc$var$toPrimitive(t, "string");
    return "symbol" == $b74dfa9f7ee9d9bc$var$_typeof(i) ? i : i + "";
}
function $b74dfa9f7ee9d9bc$var$_defineProperty(e, r, t) {
    return (r = $b74dfa9f7ee9d9bc$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $b74dfa9f7ee9d9bc$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $b74dfa9f7ee9d9bc$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $b74dfa9f7ee9d9bc$var$_arrayLikeToArray(r);
}
function $b74dfa9f7ee9d9bc$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $b74dfa9f7ee9d9bc$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b74dfa9f7ee9d9bc$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b74dfa9f7ee9d9bc$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b74dfa9f7ee9d9bc$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b74dfa9f7ee9d9bc$var$_toConsumableArray(r) {
    return $b74dfa9f7ee9d9bc$var$_arrayWithoutHoles(r) || $b74dfa9f7ee9d9bc$var$_iterableToArray(r) || $b74dfa9f7ee9d9bc$var$_unsupportedIterableToArray(r) || $b74dfa9f7ee9d9bc$var$_nonIterableSpread();
}
function $b74dfa9f7ee9d9bc$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $b74dfa9f7ee9d9bc$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $b74dfa9f7ee9d9bc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b74dfa9f7ee9d9bc$var$_slicedToArray(r, e) {
    return $b74dfa9f7ee9d9bc$var$_arrayWithHoles(r) || $b74dfa9f7ee9d9bc$var$_iterableToArrayLimit(r, e) || $b74dfa9f7ee9d9bc$var$_unsupportedIterableToArray(r, e) || $b74dfa9f7ee9d9bc$var$_nonIterableRest();
}
var $b74dfa9f7ee9d9bc$var$classes = {
    root: function root(_ref) {
        var positionState = _ref.positionState, classNameState = _ref.classNameState;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-tooltip p-component', $b74dfa9f7ee9d9bc$var$_defineProperty({}, "p-tooltip-".concat(positionState), true), classNameState);
    },
    arrow: 'p-tooltip-arrow',
    text: 'p-tooltip-text'
};
var $b74dfa9f7ee9d9bc$var$inlineStyles = {
    arrow: function arrow(_ref2) {
        var context = _ref2.context;
        return {
            top: context.bottom ? '0' : context.right || context.left || !context.right && !context.left && !context.top && !context.bottom ? '50%' : null,
            bottom: context.top ? '0' : null,
            left: context.right || !context.right && !context.left && !context.top && !context.bottom ? '0' : context.top || context.bottom ? '50%' : null,
            right: context.left ? '0' : null
        };
    }
};
var $b74dfa9f7ee9d9bc$var$styles = "\n@layer primereact {\n    .p-tooltip {\n        position: absolute;\n        padding: .25em .5rem;\n        /* #3687: Tooltip prevent scrollbar flickering */\n        top: -9999px;\n        left: -9999px;\n    }\n    \n    .p-tooltip.p-tooltip-right,\n    .p-tooltip.p-tooltip-left {\n        padding: 0 .25rem;\n    }\n    \n    .p-tooltip.p-tooltip-top,\n    .p-tooltip.p-tooltip-bottom {\n        padding:.25em 0;\n    }\n    \n    .p-tooltip .p-tooltip-text {\n       white-space: pre-line;\n       word-break: break-word;\n    }\n    \n    .p-tooltip-arrow {\n        position: absolute;\n        width: 0;\n        height: 0;\n        border-color: transparent;\n        border-style: solid;\n    }\n    \n    .p-tooltip-right .p-tooltip-arrow {\n        top: 50%;\n        left: 0;\n        margin-top: -.25rem;\n        border-width: .25em .25em .25em 0;\n    }\n    \n    .p-tooltip-left .p-tooltip-arrow {\n        top: 50%;\n        right: 0;\n        margin-top: -.25rem;\n        border-width: .25em 0 .25em .25rem;\n    }\n    \n    .p-tooltip.p-tooltip-top {\n        padding: .25em 0;\n    }\n    \n    .p-tooltip-top .p-tooltip-arrow {\n        bottom: 0;\n        left: 50%;\n        margin-left: -.25rem;\n        border-width: .25em .25em 0;\n    }\n    \n    .p-tooltip-bottom .p-tooltip-arrow {\n        top: 0;\n        left: 50%;\n        margin-left: -.25rem;\n        border-width: 0 .25em .25rem;\n    }\n\n    .p-tooltip-target-wrapper {\n        display: inline-flex;\n    }\n}\n";
var $b74dfa9f7ee9d9bc$var$TooltipBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'Tooltip',
        appendTo: null,
        at: null,
        autoHide: true,
        autoZIndex: true,
        baseZIndex: 0,
        className: null,
        closeOnEscape: false,
        content: null,
        disabled: false,
        event: null,
        hideDelay: 0,
        hideEvent: 'mouseleave',
        id: null,
        mouseTrack: false,
        mouseTrackLeft: 5,
        mouseTrackTop: 5,
        my: null,
        onBeforeHide: null,
        onBeforeShow: null,
        onHide: null,
        onShow: null,
        position: 'right',
        showDelay: 0,
        showEvent: 'mouseenter',
        showOnDisabled: false,
        style: null,
        target: null,
        updateDelay: 0,
        children: undefined
    },
    css: {
        classes: $b74dfa9f7ee9d9bc$var$classes,
        styles: $b74dfa9f7ee9d9bc$var$styles,
        inlineStyles: $b74dfa9f7ee9d9bc$var$inlineStyles
    }
});
function $b74dfa9f7ee9d9bc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b74dfa9f7ee9d9bc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b74dfa9f7ee9d9bc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b74dfa9f7ee9d9bc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b74dfa9f7ee9d9bc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b74dfa9f7ee9d9bc$export$28c660c63b792dea = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $b74dfa9f7ee9d9bc$var$TooltipBase.getProps(inProps, context);
    var _React$useState = $acw62.useState(false), _React$useState2 = $b74dfa9f7ee9d9bc$var$_slicedToArray(_React$useState, 2), visibleState = _React$useState2[0], setVisibleState = _React$useState2[1];
    var _React$useState3 = $acw62.useState(props.position || 'right'), _React$useState4 = $b74dfa9f7ee9d9bc$var$_slicedToArray(_React$useState3, 2), positionState = _React$useState4[0], setPositionState = _React$useState4[1];
    var _React$useState5 = $acw62.useState(''), _React$useState6 = $b74dfa9f7ee9d9bc$var$_slicedToArray(_React$useState5, 2), classNameState = _React$useState6[0], setClassNameState = _React$useState6[1];
    var _React$useState7 = $acw62.useState(false), _React$useState8 = $b74dfa9f7ee9d9bc$var$_slicedToArray(_React$useState7, 2), multipleFocusEvents = _React$useState8[0], setMultipleFocusEvents = _React$useState8[1];
    var metaData = {
        props: props,
        state: {
            visible: visibleState,
            position: positionState,
            className: classNameState
        },
        context: {
            right: positionState === 'right',
            left: positionState === 'left',
            top: positionState === 'top',
            bottom: positionState === 'bottom'
        }
    };
    var _TooltipBase$setMetaD = $b74dfa9f7ee9d9bc$var$TooltipBase.setMetaData(metaData), ptm = _TooltipBase$setMetaD.ptm, cx = _TooltipBase$setMetaD.cx, sx = _TooltipBase$setMetaD.sx, isUnstyled = _TooltipBase$setMetaD.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($b74dfa9f7ee9d9bc$var$TooltipBase.css.styles, isUnstyled, {
        name: 'tooltip'
    });
    (0, $fbdf1e36fa0a01d8$export$dee4359f392495ae)({
        callback: function callback() {
            hide();
        },
        when: props.closeOnEscape,
        priority: [
            (0, $fbdf1e36fa0a01d8$export$5153c70e1a2d4b71).TOOLTIP,
            0
        ]
    });
    var elementRef = $acw62.useRef(null);
    var textRef = $acw62.useRef(null);
    var currentTargetRef = $acw62.useRef(null);
    var containerSize = $acw62.useRef(null);
    var allowHide = $acw62.useRef(true);
    var timeouts = $acw62.useRef({});
    var currentMouseEvent = $acw62.useRef(null);
    var _useResizeListener = (0, $fbdf1e36fa0a01d8$export$158eb97be50d41ef)({
        listener: function listener(event) {
            !(0, $a73ce425265b079e$export$ff8ccbac9225de62).isTouchDevice() && hide(event);
        }
    }), _useResizeListener2 = $b74dfa9f7ee9d9bc$var$_slicedToArray(_useResizeListener, 2), bindWindowResizeListener = _useResizeListener2[0], unbindWindowResizeListener = _useResizeListener2[1];
    var _useOverlayScrollList = (0, $fbdf1e36fa0a01d8$export$d04245b74d6bdcb8)({
        target: currentTargetRef.current,
        listener: function listener(event) {
            hide(event);
        },
        when: visibleState
    }), _useOverlayScrollList2 = $b74dfa9f7ee9d9bc$var$_slicedToArray(_useOverlayScrollList, 2), bindOverlayScrollListener = _useOverlayScrollList2[0], unbindOverlayScrollListener = _useOverlayScrollList2[1];
    var isTargetContentEmpty = function isTargetContentEmpty(target) {
        return !(props.content || getTargetOption(target, 'tooltip'));
    };
    var isContentEmpty = function isContentEmpty(target) {
        return !(props.content || getTargetOption(target, 'tooltip') || props.children);
    };
    var isMouseTrack = function isMouseTrack(target) {
        return getTargetOption(target, 'mousetrack') || props.mouseTrack;
    };
    var isDisabled = function isDisabled(target) {
        return getTargetOption(target, 'disabled') === 'true' || hasTargetOption(target, 'disabled') || props.disabled;
    };
    var isShowOnDisabled = function isShowOnDisabled(target) {
        return getTargetOption(target, 'showondisabled') || props.showOnDisabled;
    };
    var isAutoHide = function isAutoHide() {
        return getTargetOption(currentTargetRef.current, 'autohide') || props.autoHide;
    };
    var getTargetOption = function getTargetOption(target, option) {
        return hasTargetOption(target, "data-pr-".concat(option)) ? target.getAttribute("data-pr-".concat(option)) : null;
    };
    var hasTargetOption = function hasTargetOption(target, option) {
        return target && target.hasAttribute(option);
    };
    var getEvents = function getEvents(target) {
        var showEvents = [
            getTargetOption(target, 'showevent') || props.showEvent
        ];
        var hideEvents = [
            getTargetOption(target, 'hideevent') || props.hideEvent
        ];
        if (isMouseTrack(target)) {
            showEvents = [
                'mousemove'
            ];
            hideEvents = [
                'mouseleave'
            ];
        } else {
            var event = getTargetOption(target, 'event') || props.event;
            if (event === 'focus') {
                showEvents = [
                    'focus'
                ];
                hideEvents = [
                    'blur'
                ];
            }
            if (event === 'both') {
                showEvents = [
                    'focus',
                    'mouseenter'
                ];
                hideEvents = multipleFocusEvents ? [
                    'blur'
                ] : [
                    'mouseleave',
                    'blur'
                ];
            }
        }
        return {
            showEvents: showEvents,
            hideEvents: hideEvents
        };
    };
    var getPosition = function getPosition(target) {
        return getTargetOption(target, 'position') || positionState;
    };
    var getMouseTrackPosition = function getMouseTrackPosition(target) {
        var top = getTargetOption(target, 'mousetracktop') || props.mouseTrackTop;
        var left = getTargetOption(target, 'mousetrackleft') || props.mouseTrackLeft;
        return {
            top: top,
            left: left
        };
    };
    var updateText = function updateText(target, callback) {
        if (textRef.current) {
            var content = getTargetOption(target, 'tooltip') || props.content;
            if (content) {
                textRef.current.innerHTML = ''; // remove children
                textRef.current.appendChild(document.createTextNode(content));
                callback();
            } else if (props.children) callback();
        }
    };
    var updateTooltipState = function updateTooltipState(position) {
        updateText(currentTargetRef.current, function() {
            var _currentMouseEvent$cu = currentMouseEvent.current, x = _currentMouseEvent$cu.pageX, y = _currentMouseEvent$cu.pageY;
            if (props.autoZIndex && !(0, $a73ce425265b079e$export$832931caede8e4b9).get(elementRef.current)) (0, $a73ce425265b079e$export$832931caede8e4b9).set('tooltip', elementRef.current, context && context.autoZIndex || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).autoZIndex, props.baseZIndex || context && context.zIndex.tooltip || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).zIndex.tooltip);
            elementRef.current.style.left = '';
            elementRef.current.style.top = '';
            // GitHub #2695 disable pointer events when autohiding
            if (isAutoHide()) elementRef.current.style.pointerEvents = 'none';
            var mouseTrackCheck = isMouseTrack(currentTargetRef.current) || position === 'mouse';
            if (mouseTrackCheck && !containerSize.current || mouseTrackCheck) containerSize.current = {
                width: (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(elementRef.current),
                height: (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterHeight(elementRef.current)
            };
            align(currentTargetRef.current, {
                x: x,
                y: y
            }, position);
        });
    };
    var show = function show(e) {
        if (e.type && e.type === 'focus') setMultipleFocusEvents(true);
        currentTargetRef.current = e.currentTarget;
        var disabled = isDisabled(currentTargetRef.current);
        var empty = isContentEmpty(isShowOnDisabled(currentTargetRef.current) && disabled ? currentTargetRef.current.firstChild : currentTargetRef.current);
        if (empty || disabled) return;
        currentMouseEvent.current = e;
        if (visibleState) applyDelay('updateDelay', updateTooltipState);
        else {
            // #2653 give the callback a chance to return false and not continue with display
            var success = sendCallback(props.onBeforeShow, {
                originalEvent: e,
                target: currentTargetRef.current
            });
            if (success) applyDelay('showDelay', function() {
                setVisibleState(true);
                sendCallback(props.onShow, {
                    originalEvent: e,
                    target: currentTargetRef.current
                });
            });
        }
    };
    var hide = function hide(e) {
        if (e && e.type === 'blur') setMultipleFocusEvents(false);
        clearTimeouts();
        if (visibleState) {
            var success = sendCallback(props.onBeforeHide, {
                originalEvent: e,
                target: currentTargetRef.current
            });
            if (success) applyDelay('hideDelay', function() {
                if (!isAutoHide() && allowHide.current === false) return;
                (0, $a73ce425265b079e$export$832931caede8e4b9).clear(elementRef.current);
                (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(elementRef.current, 'p-tooltip-active');
                setVisibleState(false);
                sendCallback(props.onHide, {
                    originalEvent: e,
                    target: currentTargetRef.current
                });
            });
        }
    };
    var align = function align(target, coordinate, position) {
        var left = 0;
        var top = 0;
        var currentPosition = position || positionState;
        if ((isMouseTrack(target) || currentPosition == 'mouse') && coordinate) {
            var _containerSize = {
                width: (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(elementRef.current),
                height: (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterHeight(elementRef.current)
            };
            left = coordinate.x;
            top = coordinate.y;
            var _getMouseTrackPositio = getMouseTrackPosition(target), mouseTrackTop = _getMouseTrackPositio.top, mouseTrackLeft = _getMouseTrackPositio.left;
            switch(currentPosition){
                case 'left':
                    left = left - (_containerSize.width + mouseTrackLeft);
                    top = top - (_containerSize.height / 2 - mouseTrackTop);
                    break;
                case 'right':
                case 'mouse':
                    left = left + mouseTrackLeft;
                    top = top - (_containerSize.height / 2 - mouseTrackTop);
                    break;
                case 'top':
                    left = left - (_containerSize.width / 2 - mouseTrackLeft);
                    top = top - (_containerSize.height + mouseTrackTop);
                    break;
                case 'bottom':
                    left = left - (_containerSize.width / 2 - mouseTrackLeft);
                    top = top + mouseTrackTop;
                    break;
            }
            if (left <= 0 || containerSize.current.width > _containerSize.width) {
                elementRef.current.style.left = '0px';
                elementRef.current.style.right = window.innerWidth - _containerSize.width - left + 'px';
            } else {
                elementRef.current.style.right = '';
                elementRef.current.style.left = left + 'px';
            }
            elementRef.current.style.top = top + 'px';
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(elementRef.current, 'p-tooltip-active');
        } else {
            var pos = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findCollisionPosition(currentPosition);
            var my = getTargetOption(target, 'my') || props.my || pos.my;
            var at = getTargetOption(target, 'at') || props.at || pos.at;
            elementRef.current.style.padding = '0px';
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).flipfitCollision(elementRef.current, target, my, at, function(calculatedPosition) {
                var _calculatedPosition$a = calculatedPosition.at, atX = _calculatedPosition$a.x, atY = _calculatedPosition$a.y;
                var myX = calculatedPosition.my.x;
                var newPosition = props.at ? atX !== 'center' && atX !== myX ? atX : atY : calculatedPosition.at["".concat(pos.axis)];
                elementRef.current.style.padding = '';
                setPositionState(newPosition);
                updateContainerPosition(newPosition);
                (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(elementRef.current, 'p-tooltip-active');
            });
        }
    };
    var updateContainerPosition = function updateContainerPosition(position) {
        if (elementRef.current) {
            var style = getComputedStyle(elementRef.current);
            if (position === 'left') elementRef.current.style.left = parseFloat(style.left) - parseFloat(style.paddingLeft) * 2 + 'px';
            else if (position === 'top') elementRef.current.style.top = parseFloat(style.top) - parseFloat(style.paddingTop) * 2 + 'px';
        }
    };
    var _onMouseEnter = function onMouseEnter() {
        if (!isAutoHide()) allowHide.current = false;
    };
    var _onMouseLeave = function onMouseLeave(e) {
        if (!isAutoHide()) {
            allowHide.current = true;
            hide(e);
        }
    };
    var bindTargetEvent = function bindTargetEvent(target) {
        if (target) {
            var _getEvents = getEvents(target), showEvents = _getEvents.showEvents, hideEvents = _getEvents.hideEvents;
            var currentTarget = getTarget(target);
            showEvents.forEach(function(event) {
                return currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.addEventListener(event, show);
            });
            hideEvents.forEach(function(event) {
                return currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.addEventListener(event, hide);
            });
        }
    };
    var unbindTargetEvent = function unbindTargetEvent(target) {
        if (target) {
            var _getEvents2 = getEvents(target), showEvents = _getEvents2.showEvents, hideEvents = _getEvents2.hideEvents;
            var currentTarget = getTarget(target);
            showEvents.forEach(function(event) {
                return currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.removeEventListener(event, show);
            });
            hideEvents.forEach(function(event) {
                return currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.removeEventListener(event, hide);
            });
        }
    };
    var applyDelay = function applyDelay(delayProp, callback) {
        clearTimeouts();
        var delay = getTargetOption(currentTargetRef.current, delayProp.toLowerCase()) || props[delayProp];
        delay ? timeouts.current["".concat(delayProp)] = setTimeout(function() {
            return callback();
        }, delay) : callback();
    };
    var sendCallback = function sendCallback(callback) {
        if (callback) {
            for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
            var result = callback.apply(void 0, params);
            if (result === undefined) result = true;
            return result;
        }
        return true;
    };
    var clearTimeouts = function clearTimeouts() {
        Object.values(timeouts.current).forEach(function(t) {
            return clearTimeout(t);
        });
    };
    var getTarget = function getTarget(target) {
        if (target) {
            if (isShowOnDisabled(target)) {
                if (!target.hasWrapper) {
                    var wrapper = document.createElement('div');
                    var isInputElement = target.nodeName === 'INPUT';
                    if (isInputElement) (0, $a73ce425265b079e$export$ff8ccbac9225de62).addMultipleClasses(wrapper, 'p-tooltip-target-wrapper p-inputwrapper');
                    else (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(wrapper, 'p-tooltip-target-wrapper');
                    target.parentNode.insertBefore(wrapper, target);
                    wrapper.appendChild(target);
                    target.hasWrapper = true;
                    return wrapper;
                }
                return target.parentElement;
            } else if (target.hasWrapper) {
                var _target$parentElement;
                (_target$parentElement = target.parentElement).replaceWith.apply(_target$parentElement, $b74dfa9f7ee9d9bc$var$_toConsumableArray(target.parentElement.childNodes));
                delete target.hasWrapper;
            }
            return target;
        }
        return null;
    };
    var updateTargetEvents = function updateTargetEvents(target) {
        unloadTargetEvents(target);
        loadTargetEvents(target);
    };
    var loadTargetEvents = function loadTargetEvents(target) {
        setTargetEventOperations(target || props.target, bindTargetEvent);
    };
    var unloadTargetEvents = function unloadTargetEvents(target) {
        setTargetEventOperations(target || props.target, unbindTargetEvent);
    };
    var setTargetEventOperations = function setTargetEventOperations(target, operation) {
        target = (0, $a73ce425265b079e$export$4855211e6b8ad895).getRefElement(target);
        if (target) {
            if ((0, $a73ce425265b079e$export$ff8ccbac9225de62).isElement(target)) operation(target);
            else {
                var setEvent = function setEvent(target) {
                    var element = (0, $a73ce425265b079e$export$ff8ccbac9225de62).find(document, target);
                    element.forEach(function(el) {
                        operation(el);
                    });
                };
                if (target instanceof Array) target.forEach(function(t) {
                    setEvent(t);
                });
                else setEvent(target);
            }
        }
    };
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        if (visibleState && currentTargetRef.current && isDisabled(currentTargetRef.current)) hide();
    });
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        loadTargetEvents();
        return function() {
            unloadTargetEvents();
        };
    }, [
        show,
        hide,
        props.target
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (visibleState) {
            var position = getPosition(currentTargetRef.current);
            var classname = getTargetOption(currentTargetRef.current, 'classname');
            setPositionState(position);
            setClassNameState(classname);
            updateTooltipState(position);
            bindWindowResizeListener();
            bindOverlayScrollListener();
        } else {
            setPositionState(props.position || 'right');
            setClassNameState('');
            currentTargetRef.current = null;
            containerSize.current = null;
            allowHide.current = true;
        }
        return function() {
            unbindWindowResizeListener();
            unbindOverlayScrollListener();
        };
    }, [
        visibleState
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        var position = getPosition(currentTargetRef.current);
        if (visibleState && position !== 'mouse') applyDelay('updateDelay', function() {
            updateText(currentTargetRef.current, function() {
                align(currentTargetRef.current);
            });
        });
    }, [
        props.content
    ]);
    (0, $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96)(function() {
        hide();
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(elementRef.current);
    });
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            updateTargetEvents: updateTargetEvents,
            loadTargetEvents: loadTargetEvents,
            unloadTargetEvents: unloadTargetEvents,
            show: show,
            hide: hide,
            getElement: function getElement() {
                return elementRef.current;
            },
            getTarget: function getTarget() {
                return currentTargetRef.current;
            }
        };
    });
    var createElement = function createElement() {
        var empty = isTargetContentEmpty(currentTargetRef.current);
        var rootProps = mergeProps({
            id: props.id,
            className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root', {
                positionState: positionState,
                classNameState: classNameState
            })),
            style: props.style,
            role: 'tooltip',
            'aria-hidden': visibleState,
            onMouseEnter: function onMouseEnter(e) {
                return _onMouseEnter();
            },
            onMouseLeave: function onMouseLeave(e) {
                return _onMouseLeave(e);
            }
        }, $b74dfa9f7ee9d9bc$var$TooltipBase.getOtherProps(props), ptm('root'));
        var arrowProps = mergeProps({
            className: cx('arrow'),
            style: sx('arrow', $b74dfa9f7ee9d9bc$var$_objectSpread({}, metaData))
        }, ptm('arrow'));
        var textProps = mergeProps({
            className: cx('text')
        }, ptm('text'));
        return /*#__PURE__*/ $acw62.createElement("div", $b74dfa9f7ee9d9bc$var$_extends({
            ref: elementRef
        }, rootProps), /*#__PURE__*/ $acw62.createElement("div", arrowProps), /*#__PURE__*/ $acw62.createElement("div", $b74dfa9f7ee9d9bc$var$_extends({
            ref: textRef
        }, textProps), empty && props.children));
    };
    if (visibleState) {
        var element = createElement();
        return /*#__PURE__*/ $acw62.createElement((0, $e7a3b5428092a192$export$602eac185826482c), {
            element: element,
            appendTo: props.appendTo,
            visible: true
        });
    }
    return null;
}));
$b74dfa9f7ee9d9bc$export$28c660c63b792dea.displayName = 'Tooltip';


'use client';
function $5297d4b5b893f6cf$var$_extends() {
    return $5297d4b5b893f6cf$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5297d4b5b893f6cf$var$_extends.apply(null, arguments);
}
function $5297d4b5b893f6cf$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5297d4b5b893f6cf$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5297d4b5b893f6cf$var$_typeof(o);
}
function $5297d4b5b893f6cf$var$toPrimitive(t, r) {
    if ("object" != $5297d4b5b893f6cf$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5297d4b5b893f6cf$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $5297d4b5b893f6cf$var$toPropertyKey(t) {
    var i = $5297d4b5b893f6cf$var$toPrimitive(t, "string");
    return "symbol" == $5297d4b5b893f6cf$var$_typeof(i) ? i : i + "";
}
function $5297d4b5b893f6cf$var$_defineProperty(e, r, t) {
    return (r = $5297d4b5b893f6cf$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $5297d4b5b893f6cf$var$classes$1 = {
    root: function root(_ref) {
        var props = _ref.props;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-badge p-component', $5297d4b5b893f6cf$var$_defineProperty({
            'p-badge-no-gutter': (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.value) && String(props.value).length === 1,
            'p-badge-dot': (0, $a73ce425265b079e$export$4855211e6b8ad895).isEmpty(props.value),
            'p-badge-lg': props.size === 'large',
            'p-badge-xl': props.size === 'xlarge'
        }, "p-badge-".concat(props.severity), props.severity !== null));
    }
};
var $5297d4b5b893f6cf$var$styles = "\n@layer primereact {\n    .p-badge {\n        display: inline-block;\n        border-radius: 10px;\n        text-align: center;\n        padding: 0 .5rem;\n    }\n    \n    .p-overlay-badge {\n        position: relative;\n    }\n    \n    .p-overlay-badge .p-badge {\n        position: absolute;\n        top: 0;\n        right: 0;\n        transform: translate(50%,-50%);\n        transform-origin: 100% 0;\n        margin: 0;\n    }\n    \n    .p-badge-dot {\n        width: .5rem;\n        min-width: .5rem;\n        height: .5rem;\n        border-radius: 50%;\n        padding: 0;\n    }\n    \n    .p-badge-no-gutter {\n        padding: 0;\n        border-radius: 50%;\n    }\n}\n";
var $5297d4b5b893f6cf$var$BadgeBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'Badge',
        __parentMetadata: null,
        value: null,
        severity: null,
        size: null,
        style: null,
        className: null,
        children: undefined
    },
    css: {
        classes: $5297d4b5b893f6cf$var$classes$1,
        styles: $5297d4b5b893f6cf$var$styles
    }
});
function $5297d4b5b893f6cf$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5297d4b5b893f6cf$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5297d4b5b893f6cf$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $5297d4b5b893f6cf$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5297d4b5b893f6cf$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5297d4b5b893f6cf$var$Badge = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $5297d4b5b893f6cf$var$BadgeBase.getProps(inProps, context);
    var _BadgeBase$setMetaDat = $5297d4b5b893f6cf$var$BadgeBase.setMetaData($5297d4b5b893f6cf$var$_objectSpread$1({
        props: props
    }, props.__parentMetadata)), ptm = _BadgeBase$setMetaDat.ptm, cx = _BadgeBase$setMetaDat.cx, isUnstyled = _BadgeBase$setMetaDat.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($5297d4b5b893f6cf$var$BadgeBase.css.styles, isUnstyled, {
        name: 'badge'
    });
    var elementRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var rootProps = mergeProps({
        ref: elementRef,
        style: props.style,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root'))
    }, $5297d4b5b893f6cf$var$BadgeBase.getOtherProps(props), ptm('root'));
    return /*#__PURE__*/ $acw62.createElement("span", rootProps, props.value);
}));
$5297d4b5b893f6cf$var$Badge.displayName = 'Badge';
var $5297d4b5b893f6cf$var$classes = {
    icon: function icon(_ref) {
        var props = _ref.props;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-button-icon p-c', $5297d4b5b893f6cf$var$_defineProperty({}, "p-button-icon-".concat(props.iconPos), props.label));
    },
    loadingIcon: function loadingIcon(_ref2) {
        var props = _ref2.props, className = _ref2.className;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(className, {
            'p-button-loading-icon': props.loading
        });
    },
    label: 'p-button-label p-c',
    root: function root(_ref3) {
        var props = _ref3.props, size = _ref3.size, disabled = _ref3.disabled;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-button p-component', $5297d4b5b893f6cf$var$_defineProperty($5297d4b5b893f6cf$var$_defineProperty($5297d4b5b893f6cf$var$_defineProperty($5297d4b5b893f6cf$var$_defineProperty({
            'p-button-icon-only': (props.icon || props.loading) && !props.label && !props.children,
            'p-button-vertical': (props.iconPos === 'top' || props.iconPos === 'bottom') && props.label,
            'p-disabled': disabled,
            'p-button-loading': props.loading,
            'p-button-outlined': props.outlined,
            'p-button-raised': props.raised,
            'p-button-link': props.link,
            'p-button-text': props.text,
            'p-button-rounded': props.rounded,
            'p-button-loading-label-only': props.loading && !props.icon && props.label
        }, "p-button-loading-".concat(props.iconPos), props.loading && props.label), "p-button-".concat(size), size), "p-button-".concat(props.severity), props.severity), 'p-button-plain', props.plain));
    }
};
var $5297d4b5b893f6cf$var$ButtonBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'Button',
        __parentMetadata: null,
        badge: null,
        badgeClassName: null,
        className: null,
        children: undefined,
        disabled: false,
        icon: null,
        iconPos: 'left',
        label: null,
        link: false,
        loading: false,
        loadingIcon: null,
        outlined: false,
        plain: false,
        raised: false,
        rounded: false,
        severity: null,
        size: null,
        text: false,
        tooltip: null,
        tooltipOptions: null,
        visible: true
    },
    css: {
        classes: $5297d4b5b893f6cf$var$classes
    }
});
function $5297d4b5b893f6cf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5297d4b5b893f6cf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5297d4b5b893f6cf$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5297d4b5b893f6cf$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5297d4b5b893f6cf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5297d4b5b893f6cf$export$353f5b6fc5456de1 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $5297d4b5b893f6cf$var$ButtonBase.getProps(inProps, context);
    var disabled = props.disabled || props.loading;
    var metaData = $5297d4b5b893f6cf$var$_objectSpread($5297d4b5b893f6cf$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        context: {
            disabled: disabled
        }
    });
    var _ButtonBase$setMetaDa = $5297d4b5b893f6cf$var$ButtonBase.setMetaData(metaData), ptm = _ButtonBase$setMetaDa.ptm, cx = _ButtonBase$setMetaDa.cx, isUnstyled = _ButtonBase$setMetaDa.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($5297d4b5b893f6cf$var$ButtonBase.css.styles, isUnstyled, {
        name: 'button',
        styled: true
    });
    var elementRef = $acw62.useRef(ref);
    $acw62.useEffect(function() {
        (0, $a73ce425265b079e$export$4855211e6b8ad895).combinedRefs(elementRef, ref);
    }, [
        elementRef,
        ref
    ]);
    if (props.visible === false) return null;
    var createIcon = function createIcon() {
        var className = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-button-icon p-c', $5297d4b5b893f6cf$var$_defineProperty({}, "p-button-icon-".concat(props.iconPos), props.label));
        var iconsProps = mergeProps({
            className: cx('icon')
        }, ptm('icon'));
        className = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(className, {
            'p-button-loading-icon': props.loading
        });
        var loadingIconProps = mergeProps({
            className: cx('loadingIcon', {
                className: className
            })
        }, ptm('loadingIcon'));
        var icon = props.loading ? props.loadingIcon || /*#__PURE__*/ $acw62.createElement((0, $f693dcb2ccf8330b$export$fe708d541030d854), $5297d4b5b893f6cf$var$_extends({}, loadingIconProps, {
            spin: true
        })) : props.icon;
        return (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $5297d4b5b893f6cf$var$_objectSpread({}, iconsProps), {
            props: props
        });
    };
    var createLabel = function createLabel() {
        var labelProps = mergeProps({
            className: cx('label')
        }, ptm('label'));
        if (props.label) return /*#__PURE__*/ $acw62.createElement("span", labelProps, props.label);
        return !props.children && !props.label && /*#__PURE__*/ $acw62.createElement("span", $5297d4b5b893f6cf$var$_extends({}, labelProps, {
            dangerouslySetInnerHTML: {
                __html: '&nbsp;'
            }
        }));
    };
    var createBadge = function createBadge() {
        if (props.badge) {
            var badgeProps = mergeProps({
                className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.badgeClassName),
                value: props.badge,
                unstyled: props.unstyled,
                __parentMetadata: {
                    parent: metaData
                }
            }, ptm('badge'));
            return /*#__PURE__*/ $acw62.createElement($5297d4b5b893f6cf$var$Badge, badgeProps, props.badge);
        }
        return null;
    };
    var showTooltip = !disabled || props.tooltipOptions && props.tooltipOptions.showOnDisabled;
    var hasTooltip = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.tooltip) && showTooltip;
    var sizeMapping = {
        large: 'lg',
        small: 'sm'
    };
    var size = sizeMapping[props.size];
    var icon = createIcon();
    var label = createLabel();
    var badge = createBadge();
    var defaultAriaLabel = props.label ? props.label + (props.badge ? ' ' + props.badge : '') : props['aria-label'];
    var rootProps = mergeProps({
        ref: elementRef,
        'aria-label': defaultAriaLabel,
        'data-pc-autofocus': props.autoFocus,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root', {
            size: size,
            disabled: disabled
        })),
        disabled: disabled
    }, $5297d4b5b893f6cf$var$ButtonBase.getOtherProps(props), ptm('root'));
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("button", rootProps, icon, label, props.children, badge, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null)), hasTooltip && /*#__PURE__*/ $acw62.createElement((0, $b74dfa9f7ee9d9bc$export$28c660c63b792dea), $5297d4b5b893f6cf$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm('tooltip')
    }, props.tooltipOptions)));
}));
$5297d4b5b893f6cf$export$353f5b6fc5456de1.displayName = 'Button';



var $acw62 = parcelRequire("acw62");




'use client';
function $028ce6f6ddd144ee$var$_extends() {
    return $028ce6f6ddd144ee$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $028ce6f6ddd144ee$var$_extends.apply(null, arguments);
}
function $028ce6f6ddd144ee$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $028ce6f6ddd144ee$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $028ce6f6ddd144ee$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $028ce6f6ddd144ee$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $028ce6f6ddd144ee$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $028ce6f6ddd144ee$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $028ce6f6ddd144ee$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $028ce6f6ddd144ee$var$_slicedToArray(r, e) {
    return $028ce6f6ddd144ee$var$_arrayWithHoles(r) || $028ce6f6ddd144ee$var$_iterableToArrayLimit(r, e) || $028ce6f6ddd144ee$var$_unsupportedIterableToArray(r, e) || $028ce6f6ddd144ee$var$_nonIterableRest();
}
var $028ce6f6ddd144ee$var$ScrollPanelBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'ScrollPanel',
        id: null,
        style: null,
        className: null,
        children: undefined,
        step: 5
    },
    css: {
        classes: {
            root: 'p-scrollpanel p-component',
            wrapper: 'p-scrollpanel-wrapper',
            content: 'p-scrollpanel-content',
            barx: 'p-scrollpanel-bar p-scrollpanel-bar-x',
            bary: 'p-scrollpanel-bar p-scrollpanel-bar-y'
        },
        styles: "\n        @layer primereact {\n            .p-scrollpanel-wrapper {\n                overflow: hidden;\n                width: 100%;\n                height: 100%;\n                position: relative;\n                z-index: 1;\n                float: left;\n            }\n\n            .p-scrollpanel-content {\n                height: calc(100% + 18px);\n                width: calc(100% + 18px);\n                padding: 0 18px 18px 0;\n                position: relative;\n                overflow: auto;\n                box-sizing: border-box;\n            }\n\n            .p-scrollpanel-bar {\n                position: relative;\n                background: #c1c1c1;\n                border-radius: 3px;\n                z-index: 2;\n                cursor: pointer;\n                opacity: 0;\n                transition: opacity 0.25s linear;\n            }\n\n            .p-scrollpanel-bar-y {\n                width: 9px;\n                top: 0;\n            }\n\n            .p-scrollpanel-bar-x {\n                height: 9px;\n                bottom: 0;\n            }\n\n            .p-scrollpanel-hidden {\n                visibility: hidden;\n            }\n\n            .p-scrollpanel:hover .p-scrollpanel-bar,\n            .p-scrollpanel:active .p-scrollpanel-bar {\n                opacity: 1;\n            }\n\n            .p-scrollpanel-grabbed {\n                user-select: none;\n            }\n        }\n        "
    }
});
var $028ce6f6ddd144ee$export$9159ebcaf8f42267 = /*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $028ce6f6ddd144ee$var$ScrollPanelBase.getProps(inProps, context);
    var _React$useState = $acw62.useState(props.id), _React$useState2 = $028ce6f6ddd144ee$var$_slicedToArray(_React$useState, 2), idState = _React$useState2[0], setIdState = _React$useState2[1];
    var _React$useState3 = $acw62.useState('vertical'), _React$useState4 = $028ce6f6ddd144ee$var$_slicedToArray(_React$useState3, 2), orientationState = _React$useState4[0], setOrientationState = _React$useState4[1];
    var _ScrollPanelBase$setM = $028ce6f6ddd144ee$var$ScrollPanelBase.setMetaData({
        props: props
    }), ptm = _ScrollPanelBase$setM.ptm, cx = _ScrollPanelBase$setM.cx, isUnstyled = _ScrollPanelBase$setM.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($028ce6f6ddd144ee$var$ScrollPanelBase.css.styles, isUnstyled, {
        name: 'scrollpanel'
    });
    var containerRef = $acw62.useRef(null);
    var contentRef = $acw62.useRef(null);
    var xBarRef = $acw62.useRef(null);
    var yBarRef = $acw62.useRef(null);
    var _React$useState5 = $acw62.useState(0), _React$useState6 = $028ce6f6ddd144ee$var$_slicedToArray(_React$useState5, 2), lastScrollLeft = _React$useState6[0], setLastScrollLeft = _React$useState6[1];
    var _React$useState7 = $acw62.useState(0), _React$useState8 = $028ce6f6ddd144ee$var$_slicedToArray(_React$useState7, 2), lastScrollTop = _React$useState8[0], setLastScrollTop = _React$useState8[1];
    var isXBarClicked = $acw62.useRef(false);
    var isYBarClicked = $acw62.useRef(false);
    var lastPageX = $acw62.useRef(null);
    var lastPageY = $acw62.useRef(null);
    var scrollXRatio = $acw62.useRef(null);
    var scrollYRatio = $acw62.useRef(null);
    var frame = $acw62.useRef(null);
    var initialized = $acw62.useRef(false);
    var timer = $acw62.useRef(null);
    var contentId = idState + '_content';
    var calculateContainerHeight = function calculateContainerHeight() {
        var containerStyles = getComputedStyle(containerRef.current);
        var xBarStyles = getComputedStyle(xBarRef.current);
        var pureContainerHeight = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getHeight(containerRef.current) - parseInt(xBarStyles.height, 10);
        if (containerStyles['max-height'] !== 'none' && pureContainerHeight === 0) {
            if (contentRef.current.offsetHeight + parseInt(xBarStyles.height, 10) > parseInt(containerStyles['max-height'], 10)) containerRef.current.style.height = containerStyles['max-height'];
            else containerRef.current.style.height = contentRef.current.offsetHeight + parseFloat(containerStyles.paddingTop) + parseFloat(containerStyles.paddingBottom) + parseFloat(containerStyles.borderTopWidth) + parseFloat(containerStyles.borderBottomWidth) + 'px';
        }
    };
    var moveBar = function moveBar() {
        // horizontal scroll
        var totalWidth = contentRef.current.scrollWidth;
        var ownWidth = contentRef.current.clientWidth;
        var bottom = (containerRef.current.clientHeight - xBarRef.current.clientHeight) * -1;
        scrollXRatio.current = ownWidth / totalWidth;
        // vertical scroll
        var totalHeight = contentRef.current.scrollHeight;
        var ownHeight = contentRef.current.clientHeight;
        var right = (containerRef.current.clientWidth - yBarRef.current.clientWidth) * -1;
        scrollYRatio.current = ownHeight / totalHeight;
        frame.current = window.requestAnimationFrame(function() {
            if (scrollXRatio.current >= 1) (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(xBarRef.current, 'p-scrollpanel-hidden');
            else {
                (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(xBarRef.current, 'p-scrollpanel-hidden');
                (0, $a73ce425265b079e$export$ff8ccbac9225de62).applyStyle(xBarRef.current, {
                    width: Math.max(scrollXRatio.current * 100, 10) + '%',
                    left: contentRef.current.scrollLeft / totalWidth * 100 + '%',
                    bottom: bottom + 'px'
                });
            }
            if (scrollYRatio.current >= 1) (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(yBarRef.current, 'p-scrollpanel-hidden');
            else {
                (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(yBarRef.current, 'p-scrollpanel-hidden');
                (0, $a73ce425265b079e$export$ff8ccbac9225de62).applyStyle(yBarRef.current, {
                    height: Math.max(scrollYRatio.current * 100, 10) + '%',
                    top: 'calc(' + contentRef.current.scrollTop / totalHeight * 100 + '% - ' + xBarRef.current.clientHeight + 'px)',
                    right: right + 'px'
                });
            }
        });
    };
    var onFocus = function onFocus(event) {
        if (xBarRef.current.isSameNode(event.target)) setOrientationState('horizontal');
        else if (yBarRef.current.isSameNode(event.target)) setOrientationState('vertical');
    };
    var onBlur = function onBlur() {
        if (orientationState === 'horizontal') setOrientationState('vertical');
    };
    var onScroll = function onScroll(event) {
        if (lastScrollLeft !== event.target.scrollLeft) {
            setLastScrollLeft(event.target.scrollLeft);
            setOrientationState('horizontal');
        } else if (lastScrollTop !== event.target.scrollTop) {
            setLastScrollTop(event.target.scrollTop);
            setOrientationState('vertical');
        }
        moveBar();
    };
    var onYBarMouseDown = function onYBarMouseDown(event) {
        isYBarClicked.current = true;
        lastPageY.current = event.pageY;
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(yBarRef.current, 'p-scrollpanel-grabbed');
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(document.body, 'p-scrollpanel-grabbed');
        document.addEventListener('mousemove', onDocumentMouseMove);
        document.addEventListener('mouseup', _onDocumentMouseUp);
        event.preventDefault();
    };
    var onXBarMouseDown = function onXBarMouseDown(event) {
        isXBarClicked.current = true;
        lastPageX.current = event.pageX;
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(xBarRef.current, 'p-scrollpanel-grabbed');
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(document.body, 'p-scrollpanel-grabbed');
        document.addEventListener('mousemove', onDocumentMouseMove);
        document.addEventListener('mouseup', _onDocumentMouseUp);
        event.preventDefault();
    };
    var onDocumentMouseMove = function onDocumentMouseMove(event) {
        if (isXBarClicked.current) onMouseMoveForXBar(event);
        else if (isYBarClicked.current) onMouseMoveForYBar(event);
        else {
            onMouseMoveForXBar(event);
            onMouseMoveForYBar(event);
        }
    };
    var onMouseMoveForXBar = function onMouseMoveForXBar(event) {
        var deltaX = event.pageX - lastPageX.current;
        lastPageX.current = event.pageX;
        frame.current = window.requestAnimationFrame(function() {
            contentRef.current.scrollLeft += deltaX / scrollXRatio.current;
        });
    };
    var onMouseMoveForYBar = function onMouseMoveForYBar(event) {
        var deltaY = event.pageY - lastPageY.current;
        lastPageY.current = event.pageY;
        frame.current = window.requestAnimationFrame(function() {
            contentRef.current.scrollTop += deltaY / scrollYRatio.current;
        });
    };
    var _onDocumentMouseUp = function onDocumentMouseUp(event) {
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(yBarRef.current, 'p-scrollpanel-grabbed');
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(xBarRef.current, 'p-scrollpanel-grabbed');
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(document.body, 'p-scrollpanel-grabbed');
        document.removeEventListener('mousemove', onDocumentMouseMove);
        document.removeEventListener('mouseup', _onDocumentMouseUp);
        isXBarClicked.current = false;
        isYBarClicked.current = false;
    };
    var onKeyDown = function onKeyDown(event) {
        if (orientationState === 'vertical') switch(event.code){
            case 'ArrowDown':
                setTimer('scrollTop', props.step);
                event.preventDefault();
                break;
            case 'ArrowUp':
                setTimer('scrollTop', props.step * -1);
                event.preventDefault();
                break;
            case 'ArrowLeft':
            case 'ArrowRight':
                event.preventDefault();
                break;
        }
        else if (orientationState === 'horizontal') switch(event.code){
            case 'ArrowRight':
                setTimer('scrollLeft', props.step);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                setTimer('scrollLeft', props.step * -1);
                event.preventDefault();
                break;
            case 'ArrowDown':
            case 'ArrowUp':
                event.preventDefault();
                break;
        }
    };
    var onKeyUp = function onKeyUp() {
        clearTimer();
    };
    var repeat = function repeat(bar, step) {
        contentRef.current[bar] += step;
        moveBar();
    };
    var setTimer = function setTimer(bar, step) {
        clearTimer();
        timer.current = setTimeout(function() {
            repeat(bar, step);
        }, 40);
    };
    var clearTimer = function clearTimer() {
        if (timer.current) clearTimeout(timer.current);
    };
    var refresh = function refresh() {
        moveBar();
    };
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        if (!props.id) setIdState((0, $a73ce425265b079e$export$d5d9b89141473caf)());
        moveBar();
        window.addEventListener('resize', moveBar);
        calculateContainerHeight();
        initialized.current = true;
    });
    (0, $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96)(function() {
        if (initialized.current) window.removeEventListener('resize', moveBar);
        if (frame.current) window.cancelAnimationFrame(frame.current);
    });
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            refresh: refresh,
            getElement: function getElement() {
                return containerRef.current;
            },
            getContent: function getContent() {
                return contentRef.current;
            },
            getXBar: function getXBar() {
                return xBarRef.current;
            },
            getYBar: function getYBar() {
                return yBarRef.current;
            }
        };
    });
    var rootProps = mergeProps({
        id: props.id,
        ref: containerRef,
        style: props.style,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root'))
    }, $028ce6f6ddd144ee$var$ScrollPanelBase.getOtherProps(props), ptm('root'));
    var wrapperProps = mergeProps({
        className: cx('wrapper')
    }, ptm('wrapper'));
    var contentProps = mergeProps({
        className: cx('content'),
        onScroll: onScroll,
        onMouseEnter: moveBar
    }, ptm('content'));
    var barXProps = mergeProps({
        ref: xBarRef,
        role: 'scrollbar',
        className: cx('barx'),
        tabIndex: 0,
        'aria-valuenow': lastScrollTop,
        'aria-controls': contentId,
        'aria-orientation': 'horizontal',
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseDown: onXBarMouseDown
    }, ptm('barx'));
    var barYProps = mergeProps({
        ref: yBarRef,
        role: 'scrollbar',
        className: cx('bary'),
        tabIndex: 0,
        'aria-valuenow': lastScrollLeft,
        'aria-controls': contentId,
        'aria-orientation': 'vertical',
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseDown: onYBarMouseDown
    }, ptm('bary'));
    return /*#__PURE__*/ $acw62.createElement("div", rootProps, /*#__PURE__*/ $acw62.createElement("div", wrapperProps, /*#__PURE__*/ $acw62.createElement("div", $028ce6f6ddd144ee$var$_extends({
        ref: contentRef
    }, contentProps), props.children)), /*#__PURE__*/ $acw62.createElement("div", barXProps), /*#__PURE__*/ $acw62.createElement("div", barYProps));
});
$028ce6f6ddd144ee$export$9159ebcaf8f42267.displayName = 'ScrollPanel';



var $340986ac0d7e4aac$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $340986ac0d7e4aac$export$18a094aefa070634 = (obj, member, getter)=>{
    $340986ac0d7e4aac$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $340986ac0d7e4aac$export$addf369becd23283 = (obj, member, value1)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
};
var $340986ac0d7e4aac$export$42432efe6614d3b4 = (obj, member, value1, setter)=>{
    $340986ac0d7e4aac$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value1) : member.set(obj, value1);
    return value1;
};
var $340986ac0d7e4aac$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $340986ac0d7e4aac$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $340986ac0d7e4aac$export$18a094aefa070634(obj, member, getter);
        }
    });
var $340986ac0d7e4aac$export$fa92d15b718fce20 = (obj, member, method)=>{
    $340986ac0d7e4aac$var$__accessCheck(obj, member, "access private method");
    return method;
};



// src/utils.ts
var $002159551d1c4551$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $002159551d1c4551$export$8793edee2d425525() {}
function $002159551d1c4551$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $002159551d1c4551$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $002159551d1c4551$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $002159551d1c4551$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $002159551d1c4551$export$8c88ee6f2357230d(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function $002159551d1c4551$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $002159551d1c4551$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$002159551d1c4551$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $002159551d1c4551$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($002159551d1c4551$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $002159551d1c4551$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$002159551d1c4551$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $002159551d1c4551$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $002159551d1c4551$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $002159551d1c4551$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$002159551d1c4551$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $002159551d1c4551$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$002159551d1c4551$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $002159551d1c4551$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $002159551d1c4551$export$7a8558113332b71e(a) && $002159551d1c4551$export$7a8558113332b71e(b);
    if (array || $002159551d1c4551$export$53b83ca8eaab0383(a) && $002159551d1c4551$export$53b83ca8eaab0383(b)) {
        const aItems = array ? a : Object.keys(a);
        const aSize = aItems.length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            if ((!array && aItems.includes(key) || array) && a[key] === void 0 && b[key] === void 0) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $002159551d1c4551$export$77a71fc411098696(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $002159551d1c4551$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $002159551d1c4551$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $002159551d1c4551$export$53b83ca8eaab0383(o) {
    if (!$002159551d1c4551$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$002159551d1c4551$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $002159551d1c4551$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $002159551d1c4551$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
function $002159551d1c4551$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $002159551d1c4551$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $002159551d1c4551$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $002159551d1c4551$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $002159551d1c4551$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $002159551d1c4551$export$1aa5a89531b7670d = Symbol();
function $002159551d1c4551$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && (fetchOptions == null ? void 0 : fetchOptions.initialPromise)) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $002159551d1c4551$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}







// src/notifyManager.ts
function $798266f99c432533$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = (cb)=>setTimeout(cb, 0);
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $798266f99c432533$export$520687f44db6e1ab = $798266f99c432533$export$316a8efd03cd1458();





// src/subscribable.ts
var $46c0846a49a6d58e$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



var $1d15693d13279fb4$var$_focused, $1d15693d13279fb4$var$_cleanup, $1d15693d13279fb4$var$_setup;
var $1d15693d13279fb4$export$86f1af424b2ca4de = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $1d15693d13279fb4$var$_focused, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $1d15693d13279fb4$var$_cleanup, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $1d15693d13279fb4$var$_setup, void 0);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $1d15693d13279fb4$var$_setup, (onFocus)=>{
            if (!(0, $002159551d1c4551$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_cleanup)) this.setEventListener((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_cleanup)) == null || _a.call(this);
            (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $1d15693d13279fb4$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $1d15693d13279fb4$var$_setup, setup);
        (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_cleanup)) == null || _a.call(this);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $1d15693d13279fb4$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_focused) !== focused;
        if (changed) {
            (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $1d15693d13279fb4$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_focused) === "boolean") return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$1d15693d13279fb4$var$_focused = new WeakMap();
$1d15693d13279fb4$var$_cleanup = new WeakMap();
$1d15693d13279fb4$var$_setup = new WeakMap();
var $1d15693d13279fb4$export$6bf54661be5b02cf = new $1d15693d13279fb4$export$86f1af424b2ca4de();





var $9606ae1cfceeea19$var$_online, $9606ae1cfceeea19$var$_cleanup, $9606ae1cfceeea19$var$_setup;
var $9606ae1cfceeea19$export$58774fb55d5ff7fc = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $9606ae1cfceeea19$var$_online, true);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $9606ae1cfceeea19$var$_cleanup, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $9606ae1cfceeea19$var$_setup, void 0);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9606ae1cfceeea19$var$_setup, (onOnline)=>{
            if (!(0, $002159551d1c4551$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_cleanup)) this.setEventListener((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_cleanup)) == null || _a.call(this);
            (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9606ae1cfceeea19$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9606ae1cfceeea19$var$_setup, setup);
        (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_cleanup)) == null || _a.call(this);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9606ae1cfceeea19$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_online) !== online;
        if (changed) {
            (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9606ae1cfceeea19$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_online);
    }
};
$9606ae1cfceeea19$var$_online = new WeakMap();
$9606ae1cfceeea19$var$_cleanup = new WeakMap();
$9606ae1cfceeea19$var$_setup = new WeakMap();
var $9606ae1cfceeea19$export$b113e788b2dd3fdc = new $9606ae1cfceeea19$export$58774fb55d5ff7fc();



// src/thenable.ts
function $5a619d4c2df9bf12$export$d54630db02a12b72() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value: value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason: reason
        });
        reject(reason);
    };
    return thenable;
}



function $e19f6352d48643a1$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $e19f6352d48643a1$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $9606ae1cfceeea19$export$b113e788b2dd3fdc).isOnline() : true;
}
var $e19f6352d48643a1$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $e19f6352d48643a1$export$986cc6445c1d323(value) {
    return value instanceof $e19f6352d48643a1$export$a8430ed4188f35a9;
}
function $e19f6352d48643a1$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    const thenable = (0, $5a619d4c2df9bf12$export$d54630db02a12b72)();
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved) {
            reject(new $e19f6352d48643a1$export$a8430ed4188f35a9(cancelOptions));
            (_a = config.abort) == null || _a.call(config);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $1d15693d13279fb4$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $9606ae1cfceeea19$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$e19f6352d48643a1$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onSuccess) == null || _a.call(config, value);
            continueFn == null || continueFn();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onError) == null || _a.call(config, value);
            continueFn == null || continueFn();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                if (isResolved || canContinue()) continueResolve(value);
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved) return;
            const retry = config.retry ?? ((0, $002159551d1c4551$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $e19f6352d48643a1$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $002159551d1c4551$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        cancel: cancel,
        continue: ()=>{
            continueFn == null || continueFn();
            return thenable;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}




var $1cb0c2534af8594c$var$_gcTimeout;
var $1cb0c2534af8594c$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $1cb0c2534af8594c$var$_gcTimeout, void 0);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $002159551d1c4551$export$e539f754e934e270)(this.gcTime)) (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $1cb0c2534af8594c$var$_gcTimeout, setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $002159551d1c4551$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $1cb0c2534af8594c$var$_gcTimeout)) {
            clearTimeout((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $1cb0c2534af8594c$var$_gcTimeout));
            (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $1cb0c2534af8594c$var$_gcTimeout, void 0);
        }
    }
};
$1cb0c2534af8594c$var$_gcTimeout = new WeakMap();


var $9dc680c629ca4c63$var$_initialState, $9dc680c629ca4c63$var$_revertState, $9dc680c629ca4c63$var$_cache, $9dc680c629ca4c63$var$_retryer, $9dc680c629ca4c63$var$_defaultOptions, $9dc680c629ca4c63$var$_abortSignalConsumed, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn;
var $9dc680c629ca4c63$export$62297b13309008b2 = class extends (0, $1cb0c2534af8594c$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_dispatch);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_initialState, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_revertState, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_cache, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_retryer, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_defaultOptions, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_abortSignalConsumed, void 0);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_abortSignalConsumed, false);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_defaultOptions, config.defaultOptions);
        this.setOptions(config.options);
        this.observers = [];
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_cache, config.cache);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_initialState, $9dc680c629ca4c63$var$getDefaultState(this.options));
        this.state = config.state ?? (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        var _a;
        return (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null ? void 0 : _a.promise;
    }
    setOptions(options) {
        this.options = {
            ...(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $002159551d1c4551$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _a, _b;
        const promise = (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null ? void 0 : _a.promise;
        (_b = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null || _b.cancel(options);
        return promise ? promise.then((0, $002159551d1c4551$export$8793edee2d425525)).catch((0, $002159551d1c4551$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_initialState));
    }
    isActive() {
        return this.observers.some((observer)=>(0, $002159551d1c4551$export$8c88ee6f2357230d)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $002159551d1c4551$export$1aa5a89531b7670d) || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
    }
    isStale() {
        if (this.state.isInvalidated) return true;
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0;
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || this.state.data === void 0 || !(0, $002159551d1c4551$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) {
                    if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_abortSignalConsumed)) (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _a, _b, _c;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.data !== void 0 && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) {
                (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).continueRetry();
                return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $002159551d1c4551$export$c71c44209368a3bc)(this.options, fetchOptions);
            const queryFnContext = {
                queryKey: this.queryKey,
                meta: this.meta
            };
            addSignalProperty(queryFnContext);
            (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_a = this.options.behavior) == null || _a.onFetch(context, this);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_b = context.fetchOptions) == null ? void 0 : _b.meta)) (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_c = context.fetchOptions) == null ? void 0 : _c.meta
        });
        const onError = (error)=>{
            var _a2, _b2, _c2, _d;
            if (!((0, $e19f6352d48643a1$export$986cc6445c1d323)(error) && error.silent)) (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            if (!(0, $e19f6352d48643a1$export$986cc6445c1d323)(error)) {
                (_b2 = (_a2 = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).config).onError) == null || _b2.call(_a2, error, this);
                (_d = (_c2 = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).config).onSettled) == null || _d.call(_c2, this.state.data, error, this);
            }
            this.scheduleGc();
        };
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_retryer, (0, $e19f6352d48643a1$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions == null ? void 0 : fetchOptions.initialPromise,
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _a2, _b2, _c2, _d;
                if (data === void 0) {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                try {
                    this.setData(data);
                } catch (error) {
                    onError(error);
                    return;
                }
                (_b2 = (_a2 = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).config).onSuccess) == null || _b2.call(_a2, data, this);
                (_d = (_c2 = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).config).onSettled) == null || _d.call(_c2, data, this.state.error, this);
                this.scheduleGc();
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        }));
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).start();
    }
};
$9dc680c629ca4c63$var$_initialState = new WeakMap();
$9dc680c629ca4c63$var$_revertState = new WeakMap();
$9dc680c629ca4c63$var$_cache = new WeakMap();
$9dc680c629ca4c63$var$_retryer = new WeakMap();
$9dc680c629ca4c63$var$_defaultOptions = new WeakMap();
$9dc680c629ca4c63$var$_abortSignalConsumed = new WeakMap();
$9dc680c629ca4c63$var$_dispatch = new WeakSet();
$9dc680c629ca4c63$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...$9dc680c629ca4c63$export$f3df9013f2b58bce(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                    error: null,
                    isInvalidated: false,
                    status: "success",
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
            case "error":
                const error = action.error;
                if ((0, $e19f6352d48643a1$export$986cc6445c1d323)(error) && error.revert && (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_revertState)) return {
                    ...(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_revertState),
                    fetchStatus: "idle"
                };
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
        this.observers.forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $9dc680c629ca4c63$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $e19f6352d48643a1$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $9dc680c629ca4c63$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $c3b25629722ddda6$var$_queries;
var $c3b25629722ddda6$export$5dde0cd941da8468 = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $c3b25629722ddda6$var$_queries, void 0);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $c3b25629722ddda6$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $002159551d1c4551$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $9dc680c629ca4c63$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).has(query.queryHash)) {
            (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $002159551d1c4551$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $002159551d1c4551$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$c3b25629722ddda6$var$_queries = new WeakMap();








var $96f19558542b246f$var$_observers, $96f19558542b246f$var$_mutationCache, $96f19558542b246f$var$_retryer, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn;
var $96f19558542b246f$export$17b8b19c814bcf56 = class extends (0, $1cb0c2534af8594c$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $96f19558542b246f$var$_dispatch);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $96f19558542b246f$var$_observers, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $96f19558542b246f$var$_mutationCache, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $96f19558542b246f$var$_retryer, void 0);
        this.mutationId = config.mutationId;
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $96f19558542b246f$var$_mutationCache, config.mutationCache);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $96f19558542b246f$var$_observers, []);
        this.state = config.state || $96f19558542b246f$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_observers).includes(observer)) {
            (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $96f19558542b246f$var$_observers, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $96f19558542b246f$var$_retryer, (0, $e19f6352d48643a1$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables);
            },
            onFail: (failureCount, error)=>{
                (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).canRun(this)
        }));
        const restored = this.state.status === "pending";
        const isPaused = !(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_retryer).canStart();
        try {
            if (!restored) {
                (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                await ((_b = (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this));
                const context = await ((_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables));
                if (context !== this.state.context) (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_retryer).start();
            await ((_f = (_e = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this));
            await ((_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context));
            await ((_j = (_i = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this));
            await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context));
            (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_n = (_m = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).config).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, this));
                await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, error, variables, this.state.context));
                await ((_r = (_q = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, error, this.state.variables, this.state.context, this));
                await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, error, variables, this.state.context));
                throw error;
            } finally{
                (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "error",
                    error: error
                });
            }
        } finally{
            (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).runNext(this);
        }
    }
};
$96f19558542b246f$var$_observers = new WeakMap();
$96f19558542b246f$var$_mutationCache = new WeakMap();
$96f19558542b246f$var$_retryer = new WeakMap();
$96f19558542b246f$var$_dispatch = new WeakSet();
$96f19558542b246f$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $96f19558542b246f$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $faef27284cfa645e$var$_mutations, $faef27284cfa645e$var$_mutationId;
var $faef27284cfa645e$export$1fcfd9a244434844 = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $faef27284cfa645e$var$_mutations, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $faef27284cfa645e$var$_mutationId, void 0);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $faef27284cfa645e$var$_mutations, /* @__PURE__ */ new Map());
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $faef27284cfa645e$var$_mutationId, Date.now());
    }
    build(client, options, state) {
        const mutation = new (0, $96f19558542b246f$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++(0, $340986ac0d7e4aac$export$b1fe7cbb4502036b)(this, $faef27284cfa645e$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        const scope = $faef27284cfa645e$var$scopeFor(mutation);
        const mutations = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations).get(scope) ?? [];
        mutations.push(mutation);
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations).set(scope, mutations);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        var _a;
        const scope = $faef27284cfa645e$var$scopeFor(mutation);
        if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations).has(scope)) {
            const mutations = (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations).get(scope)) == null ? void 0 : _a.filter((x)=>x !== mutation);
            if (mutations) {
                if (mutations.length === 0) (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations).delete(scope);
                else (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations).set(scope, mutations);
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        var _a;
        const firstPendingMutation = (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations).get($faef27284cfa645e$var$scopeFor(mutation))) == null ? void 0 : _a.find((m)=>m.state.status === "pending");
        return !firstPendingMutation || firstPendingMutation === mutation;
    }
    runNext(mutation) {
        var _a;
        const foundMutation = (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations).get($faef27284cfa645e$var$scopeFor(mutation))) == null ? void 0 : _a.find((m)=>m !== mutation && m.state.isPaused);
        return (foundMutation == null ? void 0 : foundMutation.continue()) ?? Promise.resolve();
    }
    clear() {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return [
            ...(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations).values()
        ].flat();
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $002159551d1c4551$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $002159551d1c4551$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $002159551d1c4551$export$8793edee2d425525)))));
    }
};
$faef27284cfa645e$var$_mutations = new WeakMap();
$faef27284cfa645e$var$_mutationId = new WeakMap();
function $faef27284cfa645e$var$scopeFor(mutation) {
    var _a;
    return ((_a = mutation.options.scope) == null ? void 0 : _a.id) ?? String(mutation.mutationId);
}







function $45a641ae9a292711$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            var _a, _b, _c, _d, _e;
            const options = context.options;
            const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
            const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
            const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = (0, $002159551d1c4551$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $002159551d1c4551$export$8c6246b73dd61f4a) : (0, $002159551d1c4551$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $45a641ae9a292711$var$getPreviousPageParam : $45a641ae9a292711$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $45a641ae9a292711$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a2, _b2;
                return (_b2 = (_a2 = context.options).persister) == null ? void 0 : _b2.call(_a2, fetchFn, {
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $45a641ae9a292711$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $45a641ae9a292711$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return pages.length > 0 ? (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $45a641ae9a292711$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $45a641ae9a292711$var$getNextPageParam(options, data) != null;
}
function $45a641ae9a292711$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $45a641ae9a292711$var$getPreviousPageParam(options, data) != null;
}


var $f71a9ec256bb1e8c$var$_queryCache, $f71a9ec256bb1e8c$var$_mutationCache, $f71a9ec256bb1e8c$var$_defaultOptions, $f71a9ec256bb1e8c$var$_queryDefaults, $f71a9ec256bb1e8c$var$_mutationDefaults, $f71a9ec256bb1e8c$var$_mountCount, $f71a9ec256bb1e8c$var$_unsubscribeFocus, $f71a9ec256bb1e8c$var$_unsubscribeOnline;
var $f71a9ec256bb1e8c$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_queryCache, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_mutationCache, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_defaultOptions, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_queryDefaults, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_mutationDefaults, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_mountCount, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_unsubscribeFocus, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_unsubscribeOnline, void 0);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_queryCache, config.queryCache || new (0, $c3b25629722ddda6$export$5dde0cd941da8468)());
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_mutationCache, config.mutationCache || new (0, $faef27284cfa645e$export$1fcfd9a244434844)());
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_defaultOptions, config.defaultOptions || {});
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_mountCount, 0);
    }
    mount() {
        (0, $340986ac0d7e4aac$export$b1fe7cbb4502036b)(this, $f71a9ec256bb1e8c$var$_mountCount)._++;
        if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mountCount) !== 1) return;
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_unsubscribeFocus, (0, $1d15693d13279fb4$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).onFocus();
            }
        }));
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_unsubscribeOnline, (0, $9606ae1cfceeea19$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $340986ac0d7e4aac$export$b1fe7cbb4502036b)(this, $f71a9ec256bb1e8c$var$_mountCount)._--;
        if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mountCount) !== 0) return;
        (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_unsubscribeFocus, void 0);
        (_b = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    getQueryData(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $002159551d1c4551$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).get(defaultedOptions.queryHash);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $002159551d1c4551$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache);
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache);
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $002159551d1c4551$export$8793edee2d425525)).catch((0, $002159551d1c4551$export$8793edee2d425525));
    }
    invalidateQueries(filters, options = {}) {
        return (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if ((filters == null ? void 0 : filters.refetchType) === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (filters == null ? void 0 : filters.refetchType) ?? (filters == null ? void 0 : filters.type) ?? "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $002159551d1c4551$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $002159551d1c4551$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime((0, $002159551d1c4551$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $002159551d1c4551$export$8793edee2d425525)).catch((0, $002159551d1c4551$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $45a641ae9a292711$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $002159551d1c4551$export$8793edee2d425525)).catch((0, $002159551d1c4551$export$8793edee2d425525));
    }
    ensureInfiniteQueryData(options) {
        options.behavior = (0, $45a641ae9a292711$export$84470d1367601e8d)(options.pages);
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $9606ae1cfceeea19$export$b113e788b2dd3fdc).isOnline()) return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationCache).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache);
    }
    getMutationCache() {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryDefaults).set((0, $002159551d1c4551$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $002159551d1c4551$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationDefaults).set((0, $002159551d1c4551$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $002159551d1c4551$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_defaultOptions).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $002159551d1c4551$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $002159551d1c4551$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).clear();
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationCache).clear();
    }
};
$f71a9ec256bb1e8c$var$_queryCache = new WeakMap();
$f71a9ec256bb1e8c$var$_mutationCache = new WeakMap();
$f71a9ec256bb1e8c$var$_defaultOptions = new WeakMap();
$f71a9ec256bb1e8c$var$_queryDefaults = new WeakMap();
$f71a9ec256bb1e8c$var$_mutationDefaults = new WeakMap();
$f71a9ec256bb1e8c$var$_mountCount = new WeakMap();
$f71a9ec256bb1e8c$var$_unsubscribeFocus = new WeakMap();
$f71a9ec256bb1e8c$var$_unsubscribeOnline = new WeakMap();


var $acw62 = parcelRequire("acw62");





var $8ecfcf98cb47c0ad$var$_client, $8ecfcf98cb47c0ad$var$_currentResult, $8ecfcf98cb47c0ad$var$_currentMutation, $8ecfcf98cb47c0ad$var$_mutateOptions, $8ecfcf98cb47c0ad$var$_updateResult, $8ecfcf98cb47c0ad$var$updateResult_fn, $8ecfcf98cb47c0ad$var$_notify, $8ecfcf98cb47c0ad$var$notify_fn;
var $8ecfcf98cb47c0ad$export$d3c1860ee66f291a = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_updateResult);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_notify);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_client, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_currentResult, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_currentMutation, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_mutateOptions, void 0);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $8ecfcf98cb47c0ad$var$_client, client);
        this.setOptions(options);
        this.bindMethods();
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $8ecfcf98cb47c0ad$var$_updateResult, $8ecfcf98cb47c0ad$var$updateResult_fn).call(this);
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _a;
        const prevOptions = this.options;
        this.options = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_client).defaultMutationOptions(options);
        if (!(0, $002159551d1c4551$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_client).getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation),
            observer: this
        });
        if ((prevOptions == null ? void 0 : prevOptions.mutationKey) && this.options.mutationKey && (0, $002159551d1c4551$export$1e87d19d4aab5805)(prevOptions.mutationKey) !== (0, $002159551d1c4551$export$1e87d19d4aab5805)(this.options.mutationKey)) this.reset();
        else if (((_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null ? void 0 : _a.state.status) === "pending") (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation).setOptions(this.options);
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null || _a.removeObserver(this);
    }
    onMutationUpdate(action) {
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $8ecfcf98cb47c0ad$var$_updateResult, $8ecfcf98cb47c0ad$var$updateResult_fn).call(this);
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $8ecfcf98cb47c0ad$var$_notify, $8ecfcf98cb47c0ad$var$notify_fn).call(this, action);
    }
    getCurrentResult() {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentResult);
    }
    reset() {
        var _a;
        (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $8ecfcf98cb47c0ad$var$_currentMutation, void 0);
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $8ecfcf98cb47c0ad$var$_updateResult, $8ecfcf98cb47c0ad$var$updateResult_fn).call(this);
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $8ecfcf98cb47c0ad$var$_notify, $8ecfcf98cb47c0ad$var$notify_fn).call(this);
    }
    mutate(variables, options) {
        var _a;
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $8ecfcf98cb47c0ad$var$_mutateOptions, options);
        (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $8ecfcf98cb47c0ad$var$_currentMutation, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_client).getMutationCache().build((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_client), this.options));
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation).addObserver(this);
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation).execute(variables);
    }
};
$8ecfcf98cb47c0ad$var$_client = new WeakMap();
$8ecfcf98cb47c0ad$var$_currentResult = new WeakMap();
$8ecfcf98cb47c0ad$var$_currentMutation = new WeakMap();
$8ecfcf98cb47c0ad$var$_mutateOptions = new WeakMap();
$8ecfcf98cb47c0ad$var$_updateResult = new WeakSet();
$8ecfcf98cb47c0ad$var$updateResult_fn = function() {
    var _a;
    const state = ((_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null ? void 0 : _a.state) ?? (0, $96f19558542b246f$export$a1659b54bac3252a)();
    (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $8ecfcf98cb47c0ad$var$_currentResult, {
        ...state,
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    });
};
$8ecfcf98cb47c0ad$var$_notify = new WeakSet();
$8ecfcf98cb47c0ad$var$notify_fn = function(action) {
    (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_mutateOptions) && this.hasListeners()) {
            const variables = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentResult).variables;
            const context = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentResult).context;
            if ((action == null ? void 0 : action.type) === "success") {
                (_b = (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_mutateOptions)).onSuccess) == null || _b.call(_a, action.data, variables, context);
                (_d = (_c = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_mutateOptions)).onSettled) == null || _d.call(_c, action.data, null, variables, context);
            } else if ((action == null ? void 0 : action.type) === "error") {
                (_f = (_e = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_mutateOptions)).onError) == null || _f.call(_e, action.error, variables, context);
                (_h = (_g = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_mutateOptions)).onSettled) == null || _h.call(_g, void 0, action.error, variables, context);
            }
        }
        this.listeners.forEach((listener)=>{
            listener((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentResult));
        });
    });
};



var $acw62 = parcelRequire("acw62");

"use client";
var $aeeeb04cd6721116$export$da112d31b0149f31 = $acw62.createContext(void 0);
var $aeeeb04cd6721116$export$22e77b9572c4fded = (queryClient)=>{
    const client = $acw62.useContext($aeeeb04cd6721116$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $aeeeb04cd6721116$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $acw62.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($aeeeb04cd6721116$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};


// src/utils.ts
function $a478358a8235bfab$export$2072f68e6c3507cf(throwError, params) {
    if (typeof throwError === "function") return throwError(...params);
    return !!throwError;
}
function $a478358a8235bfab$export$8793edee2d425525() {}


"use client";
function $417dffbfea982a4c$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)(queryClient);
    const [observer] = $acw62.useState(()=>new (0, $8ecfcf98cb47c0ad$export$d3c1860ee66f291a)(client, options));
    $acw62.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>observer.subscribe((0, $798266f99c432533$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $acw62.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, $a478358a8235bfab$export$8793edee2d425525));
    }, [
        observer
    ]);
    if (result.error && (0, $a478358a8235bfab$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}








var $3aefa839a50a34b3$var$_client, $3aefa839a50a34b3$var$_currentQuery, $3aefa839a50a34b3$var$_currentQueryInitialState, $3aefa839a50a34b3$var$_currentResult, $3aefa839a50a34b3$var$_currentResultState, $3aefa839a50a34b3$var$_currentResultOptions, $3aefa839a50a34b3$var$_currentThenable, $3aefa839a50a34b3$var$_selectError, $3aefa839a50a34b3$var$_selectFn, $3aefa839a50a34b3$var$_selectResult, $3aefa839a50a34b3$var$_lastQueryWithDefinedData, $3aefa839a50a34b3$var$_staleTimeoutId, $3aefa839a50a34b3$var$_refetchIntervalId, $3aefa839a50a34b3$var$_currentRefetchInterval, $3aefa839a50a34b3$var$_trackedProps, $3aefa839a50a34b3$var$_executeFetch, $3aefa839a50a34b3$var$executeFetch_fn, $3aefa839a50a34b3$var$_updateStaleTimeout, $3aefa839a50a34b3$var$updateStaleTimeout_fn, $3aefa839a50a34b3$var$_computeRefetchInterval, $3aefa839a50a34b3$var$computeRefetchInterval_fn, $3aefa839a50a34b3$var$_updateRefetchInterval, $3aefa839a50a34b3$var$updateRefetchInterval_fn, $3aefa839a50a34b3$var$_updateTimers, $3aefa839a50a34b3$var$updateTimers_fn, $3aefa839a50a34b3$var$_clearStaleTimeout, $3aefa839a50a34b3$var$clearStaleTimeout_fn, $3aefa839a50a34b3$var$_clearRefetchInterval, $3aefa839a50a34b3$var$clearRefetchInterval_fn, $3aefa839a50a34b3$var$_updateQuery, $3aefa839a50a34b3$var$updateQuery_fn, $3aefa839a50a34b3$var$_notify, $3aefa839a50a34b3$var$notify_fn;
var $3aefa839a50a34b3$export$a06cf8c0066f0d4c = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_executeFetch);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_updateStaleTimeout);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_computeRefetchInterval);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_updateRefetchInterval);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_updateTimers);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_clearStaleTimeout);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_clearRefetchInterval);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_updateQuery);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_notify);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_client, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentQuery, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentQueryInitialState, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentResult, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentResultState, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentResultOptions, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentThenable, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_selectError, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_selectFn, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_selectResult, void 0);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_lastQueryWithDefinedData, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_staleTimeoutId, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_refetchIntervalId, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentRefetchInterval, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_client, client);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectError, null);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentThenable, (0, $5a619d4c2df9bf12$export$d54630db02a12b72)());
        if (!this.options.experimental_prefetchInRender) (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentThenable).reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).addObserver(this);
            if ($3aefa839a50a34b3$var$shouldFetchOnMount((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery), this.options)) (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_executeFetch, $3aefa839a50a34b3$var$executeFetch_fn).call(this);
            else this.updateResult();
            (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_updateTimers, $3aefa839a50a34b3$var$updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $3aefa839a50a34b3$var$shouldFetchOn((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $3aefa839a50a34b3$var$shouldFetchOn((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_clearStaleTimeout, $3aefa839a50a34b3$var$clearStaleTimeout_fn).call(this);
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_clearRefetchInterval, $3aefa839a50a34b3$var$clearRefetchInterval_fn).call(this);
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery);
        this.options = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $002159551d1c4551$export$8c88ee6f2357230d)(this.options.enabled, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_updateQuery, $3aefa839a50a34b3$var$updateQuery_fn).call(this);
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).setOptions(this.options);
        if (prevOptions._defaulted && !(0, $002159551d1c4551$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $3aefa839a50a34b3$var$shouldFetchOptionally((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery), prevQuery, this.options, prevOptions)) (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_executeFetch, $3aefa839a50a34b3$var$executeFetch_fn).call(this);
        this.updateResult(notifyOptions);
        if (mounted && ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery) !== prevQuery || (0, $002159551d1c4551$export$8c88ee6f2357230d)(this.options.enabled, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) !== (0, $002159551d1c4551$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) || (0, $002159551d1c4551$export$cb3145f011bda3ac)(this.options.staleTime, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) !== (0, $002159551d1c4551$export$cb3145f011bda3ac)(prevOptions.staleTime, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)))) (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_updateStaleTimeout, $3aefa839a50a34b3$var$updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_computeRefetchInterval, $3aefa839a50a34b3$var$computeRefetchInterval_fn).call(this);
        if (mounted && ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery) !== prevQuery || (0, $002159551d1c4551$export$8c88ee6f2357230d)(this.options.enabled, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) !== (0, $002159551d1c4551$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) || nextRefetchInterval !== (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentRefetchInterval))) (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_updateRefetchInterval, $3aefa839a50a34b3$var$updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).getQueryCache().build((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client), options);
        const result = this.createResult(query, options);
        if ($3aefa839a50a34b3$var$shouldAssignObserverCurrentProperties(this, result)) {
            (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResult, result);
            (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResultOptions, this.options);
            (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResultState, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult);
    }
    trackResult(result, onPropTracked) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackProp(key);
                    onPropTracked == null || onPropTracked(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    trackProp(key) {
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_trackedProps).add(key);
    }
    getCurrentQuery() {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).defaultQueryOptions(options);
        const query = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).getQueryCache().build((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client), defaultedOptions);
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_executeFetch, $3aefa839a50a34b3$var$executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult);
        const prevResultState = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResultState);
        const prevResultOptions = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQueryInitialState);
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $3aefa839a50a34b3$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $3aefa839a50a34b3$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $9dc680c629ca4c63$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        if (options.select && newState.data !== void 0) {
            if (prevResult && newState.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_selectFn)) data = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_selectResult);
            else try {
                (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectFn, options.select);
                data = options.select(newState.data);
                data = (0, $002159551d1c4551$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectResult, data);
                (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectError, null);
            } catch (selectError) {
                (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectError, selectError);
            }
        } else data = newState.data;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_lastQueryWithDefinedData)) : options.placeholderData;
                if (options.select && placeholderData !== void 0) try {
                    placeholderData = options.select(placeholderData);
                    (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectError, null);
                } catch (selectError) {
                    (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectError, selectError);
                }
            }
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $002159551d1c4551$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_selectError)) {
            error = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_selectError);
            data = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $3aefa839a50a34b3$var$isStale(query, options),
            refetch: this.refetch,
            promise: (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentThenable)
        };
        const nextResult = result;
        if (this.options.experimental_prefetchInRender) {
            const finalizeThenableIfPossible = (thenable)=>{
                if (nextResult.status === "error") thenable.reject(nextResult.error);
                else if (nextResult.data !== void 0) thenable.resolve(nextResult.data);
            };
            const recreateThenable = ()=>{
                const pending = (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentThenable, nextResult.promise = (0, $5a619d4c2df9bf12$export$d54630db02a12b72)());
                finalizeThenableIfPossible(pending);
            };
            const prevThenable = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentThenable);
            switch(prevThenable.status){
                case "pending":
                    if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                    break;
                case "fulfilled":
                    if (nextResult.status === "error" || nextResult.data !== prevThenable.value) recreateThenable();
                    break;
                case "rejected":
                    if (nextResult.status !== "error" || nextResult.error !== prevThenable.reason) recreateThenable();
                    break;
            }
        }
        return nextResult;
    }
    updateResult(notifyOptions) {
        const prevResult = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult);
        const nextResult = this.createResult((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery), this.options);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResultState, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).state);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResultOptions, this.options);
        if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResultState).data !== void 0) (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_lastQueryWithDefinedData, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery));
        if ((0, $002159551d1c4551$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResult, nextResult);
        const defaultNotifyOptions = {};
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_notify, $3aefa839a50a34b3$var$notify_fn).call(this, {
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_updateTimers, $3aefa839a50a34b3$var$updateTimers_fn).call(this);
    }
};
$3aefa839a50a34b3$var$_client = new WeakMap();
$3aefa839a50a34b3$var$_currentQuery = new WeakMap();
$3aefa839a50a34b3$var$_currentQueryInitialState = new WeakMap();
$3aefa839a50a34b3$var$_currentResult = new WeakMap();
$3aefa839a50a34b3$var$_currentResultState = new WeakMap();
$3aefa839a50a34b3$var$_currentResultOptions = new WeakMap();
$3aefa839a50a34b3$var$_currentThenable = new WeakMap();
$3aefa839a50a34b3$var$_selectError = new WeakMap();
$3aefa839a50a34b3$var$_selectFn = new WeakMap();
$3aefa839a50a34b3$var$_selectResult = new WeakMap();
$3aefa839a50a34b3$var$_lastQueryWithDefinedData = new WeakMap();
$3aefa839a50a34b3$var$_staleTimeoutId = new WeakMap();
$3aefa839a50a34b3$var$_refetchIntervalId = new WeakMap();
$3aefa839a50a34b3$var$_currentRefetchInterval = new WeakMap();
$3aefa839a50a34b3$var$_trackedProps = new WeakMap();
$3aefa839a50a34b3$var$_executeFetch = new WeakSet();
$3aefa839a50a34b3$var$executeFetch_fn = function(fetchOptions) {
    (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_updateQuery, $3aefa839a50a34b3$var$updateQuery_fn).call(this);
    let promise = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $002159551d1c4551$export$8793edee2d425525));
    return promise;
};
$3aefa839a50a34b3$var$_updateStaleTimeout = new WeakSet();
$3aefa839a50a34b3$var$updateStaleTimeout_fn = function() {
    (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_clearStaleTimeout, $3aefa839a50a34b3$var$clearStaleTimeout_fn).call(this);
    const staleTime = (0, $002159551d1c4551$export$cb3145f011bda3ac)(this.options.staleTime, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery));
    if ((0, $002159551d1c4551$export$6acf61af03e62db) || (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult).isStale || !(0, $002159551d1c4551$export$e539f754e934e270)(staleTime)) return;
    const time = (0, $002159551d1c4551$export$811b83d62bcf47f0)((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult).dataUpdatedAt, staleTime);
    const timeout = time + 1;
    (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_staleTimeoutId, setTimeout(()=>{
        if (!(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult).isStale) this.updateResult();
    }, timeout));
};
$3aefa839a50a34b3$var$_computeRefetchInterval = new WeakSet();
$3aefa839a50a34b3$var$computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) : this.options.refetchInterval) ?? false;
};
$3aefa839a50a34b3$var$_updateRefetchInterval = new WeakSet();
$3aefa839a50a34b3$var$updateRefetchInterval_fn = function(nextInterval) {
    (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_clearRefetchInterval, $3aefa839a50a34b3$var$clearRefetchInterval_fn).call(this);
    (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentRefetchInterval, nextInterval);
    if ((0, $002159551d1c4551$export$6acf61af03e62db) || (0, $002159551d1c4551$export$8c88ee6f2357230d)(this.options.enabled, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) === false || !(0, $002159551d1c4551$export$e539f754e934e270)((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentRefetchInterval)) || (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentRefetchInterval) === 0) return;
    (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_refetchIntervalId, setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $1d15693d13279fb4$export$6bf54661be5b02cf).isFocused()) (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_executeFetch, $3aefa839a50a34b3$var$executeFetch_fn).call(this);
    }, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentRefetchInterval)));
};
$3aefa839a50a34b3$var$_updateTimers = new WeakSet();
$3aefa839a50a34b3$var$updateTimers_fn = function() {
    (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_updateStaleTimeout, $3aefa839a50a34b3$var$updateStaleTimeout_fn).call(this);
    (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_updateRefetchInterval, $3aefa839a50a34b3$var$updateRefetchInterval_fn).call(this, (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_computeRefetchInterval, $3aefa839a50a34b3$var$computeRefetchInterval_fn).call(this));
};
$3aefa839a50a34b3$var$_clearStaleTimeout = new WeakSet();
$3aefa839a50a34b3$var$clearStaleTimeout_fn = function() {
    if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_staleTimeoutId)) {
        clearTimeout((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_staleTimeoutId));
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_staleTimeoutId, void 0);
    }
};
$3aefa839a50a34b3$var$_clearRefetchInterval = new WeakSet();
$3aefa839a50a34b3$var$clearRefetchInterval_fn = function() {
    if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_refetchIntervalId)) {
        clearInterval((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_refetchIntervalId));
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_refetchIntervalId, void 0);
    }
};
$3aefa839a50a34b3$var$_updateQuery = new WeakSet();
$3aefa839a50a34b3$var$updateQuery_fn = function() {
    const query = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).getQueryCache().build((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client), this.options);
    if (query === (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) return;
    const prevQuery = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery);
    (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentQuery, query);
    (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
$3aefa839a50a34b3$var$_notify = new WeakSet();
$3aefa839a50a34b3$var$notify_fn = function(notifyOptions) {
    (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult));
        });
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).getQueryCache().notify({
            query: (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function $3aefa839a50a34b3$var$shouldLoadOnMount(query, options) {
    return (0, $002159551d1c4551$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function $3aefa839a50a34b3$var$shouldFetchOnMount(query, options) {
    return $3aefa839a50a34b3$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $3aefa839a50a34b3$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $3aefa839a50a34b3$var$shouldFetchOn(query, options, field) {
    if ((0, $002159551d1c4551$export$8c88ee6f2357230d)(options.enabled, query) !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $3aefa839a50a34b3$var$isStale(query, options);
    }
    return false;
}
function $3aefa839a50a34b3$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $002159551d1c4551$export$8c88ee6f2357230d)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $3aefa839a50a34b3$var$isStale(query, options);
}
function $3aefa839a50a34b3$var$isStale(query, options) {
    return (0, $002159551d1c4551$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.isStaleByTime((0, $002159551d1c4551$export$cb3145f011bda3ac)(options.staleTime, query));
}
function $3aefa839a50a34b3$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $002159551d1c4551$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

"use client";
function $9f918c9537253956$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $9f918c9537253956$var$QueryErrorResetBoundaryContext = $acw62.createContext($9f918c9537253956$var$createValue());
var $9f918c9537253956$export$50dfac555130cafd = ()=>$acw62.useContext($9f918c9537253956$var$QueryErrorResetBoundaryContext);
var $9f918c9537253956$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $acw62.useState(()=>$9f918c9537253956$var$createValue());
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($9f918c9537253956$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};



var $acw62 = parcelRequire("acw62");

"use client";
var $00f18dc4257f8dfa$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError || options.experimental_prefetchInRender) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $00f18dc4257f8dfa$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $acw62.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $00f18dc4257f8dfa$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (0, $a478358a8235bfab$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]);
};



var $acw62 = parcelRequire("acw62");
"use client";
var $8a077a20b7040cef$var$IsRestoringContext = $acw62.createContext(false);
var $8a077a20b7040cef$export$4da0178d6b5f553 = ()=>$acw62.useContext($8a077a20b7040cef$var$IsRestoringContext);
var $8a077a20b7040cef$export$593807d4e94f9621 = $8a077a20b7040cef$var$IsRestoringContext.Provider;


// src/suspense.ts
var $6de503da57e511b5$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $6de503da57e511b5$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        if (defaultedOptions.staleTime === void 0) defaultedOptions.staleTime = 1e3;
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, 1e3);
    }
};
var $6de503da57e511b5$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $6de503da57e511b5$export$88d3586dfed64df9 = (defaultedOptions, result)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result.isPending;
var $6de503da57e511b5$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });



"use client";
function $1fa9088b80b7d036$export$fff0865807e996c5(options, Observer, queryClient) {
    var _a, _b, _c, _d, _e;
    const client = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)(queryClient);
    const isRestoring = (0, $8a077a20b7040cef$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $9f918c9537253956$export$50dfac555130cafd)();
    const defaultedOptions = client.defaultQueryOptions(options);
    (_b = (_a = client.getDefaultOptions().queries) == null ? void 0 : _a._experimental_beforeQuery) == null || _b.call(_a, defaultedOptions);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $6de503da57e511b5$export$274d2a1db5a20c09)(defaultedOptions);
    (0, $00f18dc4257f8dfa$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $00f18dc4257f8dfa$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    const [observer] = $acw62.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? (0, $a478358a8235bfab$export$8793edee2d425525) : observer.subscribe((0, $798266f99c432533$export$520687f44db6e1ab).batchCalls(onStoreChange));
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $acw62.useEffect(()=>{
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $6de503da57e511b5$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $6de503da57e511b5$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $00f18dc4257f8dfa$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash)
    })) throw result.error;
    (_d = (_c = client.getDefaultOptions().queries) == null ? void 0 : _c._experimental_afterQuery) == null || _d.call(_c, defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !(0, $002159551d1c4551$export$6acf61af03e62db) && (0, $6de503da57e511b5$export$e0a3f29513afe430)(result, isRestoring)) {
        const promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, $6de503da57e511b5$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary) : // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        (_e = client.getQueryCache().get(defaultedOptions.queryHash)) == null ? void 0 : _e.promise;
        promise == null || promise.catch((0, $a478358a8235bfab$export$8793edee2d425525)).finally(()=>{
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $82072f1c97bcdd9c$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $1fa9088b80b7d036$export$fff0865807e996c5)(options, (0, $3aefa839a50a34b3$export$a06cf8c0066f0d4c), queryClient);
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $7d6297100045faa6$export$83327a4f6aff409e = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $7d6297100045faa6$export$3c15e91bc2bcd54b = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $7d6297100045faa6$export$989d97b9739a56cc({ children: children }) {
    const [snapshot, dispatch] = (0, $acw62.useReducer)($7d6297100045faa6$export$946b7b719a362b2a, $7d6297100045faa6$var$initialSnapshot);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7d6297100045faa6$export$83327a4f6aff409e.Provider, {
        value: snapshot,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7d6297100045faa6$export$3c15e91bc2bcd54b.Provider, {
            value: dispatch,
            children: children
        })
    });
}
function $7d6297100045faa6$export$946b7b719a362b2a(snapshot, action) {
    console.log(action);
    switch(action.type){
        case 'changed':
            return action.selectedSnapshot;
        default:
            throw Error('Unknown action: ' + action.type);
    }
}
const $7d6297100045faa6$var$initialSnapshot = {
    'id': 1,
    'snap_name': "Baza domy\u015Blna",
    'snap_prefix': "830017",
    'snap_creation_date': '2024-02-25 00:43:50',
    'snap_modify_date': '2024-02-25 00:43:50',
    'snap_description': "Domy\u015Blna baza danych utworzona przez system KOMIN",
    'snap_status': 0,
    'snap_creator': 1
};


const $4529664c1ee19d35$var$apiURL = 'https://api.komin.transportkontent.pl';
const $4529664c1ee19d35$export$7c07b633a151f9c5 = new (0, $f71a9ec256bb1e8c$export$405d0624ed55a03f)();
function $4529664c1ee19d35$export$b48399ba0dc32743() {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'snapshots'
        ],
        queryFn: ()=>fetch($4529664c1ee19d35$var$apiURL).then((res)=>res.json())
    });
}
function $4529664c1ee19d35$export$c3a687f3d6e3fb65(resourceTable) {
    const snap = (0, $acw62.useContext)((0, $7d6297100045faa6$export$83327a4f6aff409e));
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'GTFS',
            snap,
            resourceTable
        ],
        queryFn: ()=>fetch($4529664c1ee19d35$var$apiURL + snap.snap_prefix + '/' + resourceTable).then((res)=>{
                return res.json();
            })
    });
}
function $4529664c1ee19d35$export$ac3dd26b67094cc3(resourceTable, resourceId, additionalResourceId = null) {
    const snap = (0, $acw62.useContext)((0, $7d6297100045faa6$export$83327a4f6aff409e));
    var resourceUrl = $4529664c1ee19d35$var$apiURL + snap.snap_prefix + '/' + resourceTable + '/' + encodeURIComponent(resourceId);
    if (additionalResourceId !== null) resourceUrl = resourceUrl + '/' + encodeURIComponent(additionalResourceId);
    console.log('res url', resourceUrl);
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'GTFS',
            snap,
            resourceTable,
            resourceId,
            additionalResourceId
        ],
        queryFn: ()=>fetch(resourceUrl).then((res)=>{
                return res.json();
            })
    });
}
function $4529664c1ee19d35$export$ac4094b3ba481216(resourceTable) {
    const snap = (0, $acw62.useContext)((0, $7d6297100045faa6$export$83327a4f6aff409e));
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (stopId)=>fetch($4529664c1ee19d35$var$apiURL + snap.snap_prefix + '/' + resourceTable + '/' + encodeURIComponent(stopId) + '/delete', {
                method: "GET",
                mode: 'cors',
                headers: {
                    "Content-type": "text/plain"
                }
            }).then(async (res)=>{
                if (res.ok == false) throw new Error(res.status + ' ' + res.statusText, {
                    cause: body
                });
            })
    });
}
function $4529664c1ee19d35$export$5ecbcf6a102ccf18() {
    const snap = (0, $acw62.useContext)((0, $7d6297100045faa6$export$83327a4f6aff409e));
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async (updatedItem)=>{
            console.log('resourceTable in mutationFn:', updatedItem.query.resourceTable, typeof updatedItem.query.resourceTable);
            console.log('debug mutation: ', updatedItem);
            const res = await fetch($4529664c1ee19d35$var$apiURL + snap.snap_prefix + '/' + updatedItem.query.resourceTable + '/' + encodeURIComponent(updatedItem.query.modified_id) + '/update', {
                method: "POST",
                body: JSON.stringify(updatedItem.fields),
                mode: 'cors',
                headers: {
                    "Content-type": "text/plain"
                }
            });
            const body1 = await res.json();
            if (res.ok == false) throw new Error(res.status + ' ' + res.statusText, {
                cause: body1
            });
        },
        onMutate: async (updatedItem)=>{
            console.log('resourceTable in onMutate:', updatedItem.query.resourceTable, typeof updatedItem.query.resourceTable);
            console.log('updatedItem', updatedItem);
            // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
            try {
                await $4529664c1ee19d35$export$7c07b633a151f9c5.cancelQueries({
                    queryKey: [
                        'GTFS',
                        snap,
                        updatedItem.query.resourceTable
                    ]
                });
            } catch (error) {
                console.error('Error in onMutate:', error);
            }
            // Snapshot the previous value
            const previousData = $4529664c1ee19d35$export$7c07b633a151f9c5.getQueryData([
                'GTFS',
                snap,
                updatedItem.query.resourceTable
            ]);
            console.log('optimisticQueryKey', [
                'GTFS',
                snap,
                updatedItem.query.resourceTable
            ]);
            // Optimistically update to the new value
            try {
                $4529664c1ee19d35$export$7c07b633a151f9c5.setQueryData([
                    'GTFS',
                    snap,
                    updatedItem.query.resourceTable
                ], (old)=>{
                    const newData = {
                        ...old
                    };
                    if (!newData[updatedItem.query.modified_id]) {
                        console.warn(`No entry for modified_id: ${updatedItem.query.modified_id}, creating one`);
                        newData[updatedItem.query.modified_id] = {}; // Tworzymy pusty obiekt dla tego ID
                    }
                    for (const [key, value] of Object.entries(updatedItem.fields))newData[updatedItem.query.modified_id][key] = value;
                    return newData;
                });
            } catch (error) {
                console.error('Error in onMutate setQueryData:', error);
            }
            // Return a context object with the snapshotted value
            console.log('previousData:', previousData);
            return previousData || {}; // Zwróć pusty obiekt, jeśli `previousData` jest `undefined`
        },
        // If the mutation fails,
        // use the context returned from onMutate to roll back
        onError: (err, updatedItem, context1)=>{
        //queryClient.setQueryData(['GTFS', snap, updatedItem.query.resourceTable], context.previousData);
        },
        // Always refetch after error or success:
        onSettled: (data, error, variables1, context1)=>{
            $4529664c1ee19d35$export$7c07b633a151f9c5.invalidateQueries({
                queryKey: [
                    'GTFS',
                    snap,
                    variables1.query.resourceTable,
                    variables1.query.modified_id
                ]
            });
            $4529664c1ee19d35$export$7c07b633a151f9c5.invalidateQueries({
                queryKey: [
                    'GTFS',
                    snap,
                    variables1.query.resourceTable
                ]
            });
            console.log('Invalidating query:', [
                'GTFS',
                snap,
                variables1.query.resourceTable,
                variables1.query.modified_id
            ]);
        }
    });
}
function $4529664c1ee19d35$export$79ad15b2529ad27b() {
    const snap = (0, $acw62.useContext)((0, $7d6297100045faa6$export$83327a4f6aff409e));
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async (queryData)=>{
            const res = await fetch($4529664c1ee19d35$var$apiURL + snap.snap_prefix + '/' + queryData.query.resourceTable + '/bulk/' + queryData.query.action, {
                method: "POST",
                body: JSON.stringify(queryData.fields),
                mode: 'cors',
                headers: {
                    "Content-type": "text/plain"
                }
            });
            if (res.ok == false) throw new Error(res.status + ' ' + res.statusText, {
                cause: body
            });
        },
        onError: (error)=>{
            // An error happened!
            console.log(`error:`, error, 'variables', variables, 'context', context);
        },
        onSuccess: (data, variables1, context1)=>{
            console.log(`success data:`, data, 'variables', variables1, 'context', context1);
            console.log('Invalidating query:', [
                'GTFS',
                snap,
                variables1.query.resourceTable
            ]);
            $4529664c1ee19d35$export$7c07b633a151f9c5.invalidateQueries({
                queryKey: [
                    'GTFS',
                    snap,
                    variables1.query.resourceTable
                ]
            });
        }
    });
}
function $4529664c1ee19d35$export$9ae21d5a231f960d(resourceTable) {
    const snap = (0, $acw62.useContext)((0, $7d6297100045faa6$export$83327a4f6aff409e));
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (newItem)=>fetch($4529664c1ee19d35$var$apiURL + snap.snap_prefix + '/' + resourceTable + '/new', {
                method: "POST",
                body: JSON.stringify(newItem.fields),
                mode: 'cors',
                headers: {
                    "Content-type": "text/plain"
                }
            }).then(async (res)=>{
                const body1 = await res.json();
                if (res.ok == false) throw new Error(res.status + ' ' + res.statusText, {
                    cause: body1
                });
            }),
        onSettled: ()=>{
            $4529664c1ee19d35$export$7c07b633a151f9c5.invalidateQueries({
                queryKey: [
                    'GTFS',
                    snap,
                    resourceTable
                ]
            });
        }
    });
}
function $4529664c1ee19d35$export$9f26b15dde9e2d17(resourceTable) {
    const snap = (0, $acw62.useContext)((0, $7d6297100045faa6$export$83327a4f6aff409e));
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            resourceTable,
            snap
        ],
        queryFn: ()=>fetch($4529664c1ee19d35$var$apiURL + snap.snap_prefix + '/' + resourceTable + '/newID').then((res)=>{
                return res.json();
            })
    });
}
function $4529664c1ee19d35$export$133314fb4acfa730(routeType, fromStopId, toStopId) {
    const snap = (0, $acw62.useContext)((0, $7d6297100045faa6$export$83327a4f6aff409e));
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'GTFS',
            snap,
            'segments',
            routeType,
            fromStopId,
            toStopId
        ],
        queryFn: ()=>fetch($4529664c1ee19d35$var$apiURL + snap.snap_prefix + '/segments/' + routeType + '/' + encodeURIComponent(fromStopId) + '/' + encodeURIComponent(toStopId)).then((res)=>{
                return res.json();
            })
    });
}
function $4529664c1ee19d35$export$fc8d7d30ebdb0ba0(routeType, fromStopId, toStopId) {
    const snap = (0, $acw62.useContext)((0, $7d6297100045faa6$export$83327a4f6aff409e));
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'GTFS',
            snap,
            'segments',
            routeType,
            fromStopId,
            toStopId,
            'shape'
        ],
        queryFn: ()=>fetch($4529664c1ee19d35$var$apiURL + snap.snap_prefix + '/segments/' + routeType + '/' + encodeURIComponent(fromStopId) + '/' + encodeURIComponent(toStopId) + '/shape').then((res)=>{
                return res.json();
            })
    });
}
function $4529664c1ee19d35$export$9b54cc4511b2d3c8() {
    const snap = (0, $acw62.useContext)((0, $7d6297100045faa6$export$83327a4f6aff409e));
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async (queryData)=>{
            const res = await fetch($4529664c1ee19d35$var$apiURL + snap.snap_prefix + '/segments/' + queryData.query.route_type + '/' + encodeURIComponent(queryData.query.from_stop_id) + '/' + encodeURIComponent(queryData.query.to_stop_id) + '/upsert', {
                method: "POST",
                body: JSON.stringify(queryData.fields),
                mode: 'cors',
                headers: {
                    "Content-type": "text/plain"
                }
            });
            if (res.ok == false) throw new Error(res.status + ' ' + res.statusText, {
                cause: body
            });
        },
        /*
    onError: (error) => {
      // An error happened!
      console.log(`error:`, error, 'variables', variables, 'context', context)
    },*/ onSuccess: (data, variables1, context1)=>{
            $4529664c1ee19d35$export$7c07b633a151f9c5.invalidateQueries({
                queryKey: [
                    'GTFS',
                    snap,
                    'segments'
                ]
            });
        }
    });
}
function $4529664c1ee19d35$export$fa0130ec6f853f52() {
    const snap = (0, $acw62.useContext)((0, $7d6297100045faa6$export$83327a4f6aff409e));
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'stopsData',
            snap
        ],
        queryFn: ()=>fetch($4529664c1ee19d35$var$apiURL + snap.snap_prefix + '/stops/').then((res)=>{
                return res.json();
            })
    });
}
function $4529664c1ee19d35$export$30fb63dac24961f6() {
    const snap = (0, $acw62.useContext)((0, $7d6297100045faa6$export$83327a4f6aff409e));
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'routesData',
            snap
        ],
        queryFn: ()=>fetch($4529664c1ee19d35$var$apiURL + snap.snap_prefix + '/routes/').then((res)=>{
                return res.json();
            })
    });
}
function $4529664c1ee19d35$export$74d773ccb689f83d(id) {
    const snap = (0, $acw62.useContext)((0, $7d6297100045faa6$export$83327a4f6aff409e));
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'stopsData',
            snap,
            id
        ],
        queryFn: ()=>fetch($4529664c1ee19d35$var$apiURL + snap.snap_prefix + '/stops/' + encodeURIComponent(id)).then((res)=>{
                return res.json();
            })
    });
}
function $4529664c1ee19d35$export$a60c7f0127bb920c() {
    const snap = (0, $acw62.useContext)((0, $7d6297100045faa6$export$83327a4f6aff409e));
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (updatedItem)=>fetch($4529664c1ee19d35$var$apiURL + snap.snap_prefix + '/stops/' + encodeURIComponent(updatedItem.query.modified_stop_id) + '/update', {
                method: "POST",
                body: JSON.stringify(updatedItem.fields),
                mode: 'cors',
                headers: {
                    "Content-type": "text/plain"
                }
            }).then(async (res)=>{
                const body1 = await res.json();
                if (res.ok == false) throw new Error(res.status + ' ' + res.statusText, {
                    cause: body1
                });
            }),
        onMutate: async (updatedItem)=>{
            console.log('OnMutate', updatedItem);
            // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
            await $4529664c1ee19d35$export$7c07b633a151f9c5.cancelQueries({
                queryKey: [
                    'GTFS',
                    snap,
                    'stops'
                ]
            });
            // Snapshot the previous value
            const previousStops = $4529664c1ee19d35$export$7c07b633a151f9c5.getQueryData([
                'GTFS',
                snap,
                'stops'
            ]);
            // Optimistically update to the new value
            $4529664c1ee19d35$export$7c07b633a151f9c5.setQueryData([
                'GTFS',
                snap,
                'stops'
            ], (old)=>{
                const newData = {
                    ...old
                };
                for (const [key, value] of Object.entries(updatedItem.fields))newData[updatedItem.query.modified_stop_id][key] = value;
                return newData;
            });
            // Return a context object with the snapshotted value
            return previousStops;
        },
        // If the mutation fails,
        // use the context returned from onMutate to roll back
        onError: (err, updatedItem, context1)=>{
            $4529664c1ee19d35$export$7c07b633a151f9c5.setQueryData([
                'GTFS',
                snap,
                'stops'
            ], context1.previousStops);
        },
        // Always refetch after error or success:
        onSettled: (data, error, variables1, context1)=>{
            console.log('settled:', data, error, variables1, context1);
            console.log('inwalidacja', [
                'GTFS',
                snap,
                'stops',
                variables1.query.modified_stop_id
            ]);
            $4529664c1ee19d35$export$7c07b633a151f9c5.invalidateQueries({
                queryKey: [
                    'GTFS',
                    snap,
                    'stops',
                    variables1.query.modified_stop_id
                ]
            });
            $4529664c1ee19d35$export$7c07b633a151f9c5.invalidateQueries({
                queryKey: [
                    'GTFS',
                    snap,
                    'stops'
                ]
            });
            $4529664c1ee19d35$export$7c07b633a151f9c5.invalidateQueries({
                queryKey: [
                    'stopsData'
                ]
            });
            $4529664c1ee19d35$export$7c07b633a151f9c5.invalidateQueries({
                queryKey: [
                    'stops',
                    snap
                ]
            });
        }
    });
}
function $4529664c1ee19d35$export$3aef3b03d18726d1() {
    const snap = (0, $acw62.useContext)((0, $7d6297100045faa6$export$83327a4f6aff409e));
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (newItem)=>fetch($4529664c1ee19d35$var$apiURL + snap.snap_prefix + '/stops/new', {
                method: "POST",
                body: JSON.stringify(newItem.fields),
                mode: 'cors',
                headers: {
                    "Content-type": "text/plain"
                }
            }).then(async (res)=>{
                const body1 = await res.json();
                if (res.ok == false) throw new Error(res.status + ' ' + res.statusText, {
                    cause: body1
                });
            }),
        onSettled: ()=>{
            $4529664c1ee19d35$export$7c07b633a151f9c5.invalidateQueries({
                queryKey: [
                    'stopsData'
                ]
            });
            $4529664c1ee19d35$export$7c07b633a151f9c5.invalidateQueries({
                queryKey: [
                    'stops',
                    snap
                ]
            });
        }
    });
}
function $4529664c1ee19d35$export$81e0e42a622ab49f() {
    const snap = (0, $acw62.useContext)((0, $7d6297100045faa6$export$83327a4f6aff409e));
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (stopId)=>fetch($4529664c1ee19d35$var$apiURL + snap.snap_prefix + '/stops/' + encodeURIComponent(stopId) + '/delete', {
                method: "GET",
                mode: 'cors',
                headers: {
                    "Content-type": "text/plain"
                }
            }).then(async (res)=>{
                if (res.ok == false) throw new Error(res.status + ' ' + res.statusText, {
                    cause: body
                });
            })
    });
}
function $4529664c1ee19d35$export$ba0b7c8dc6fc8d08() {
    const snap = (0, $acw62.useContext)((0, $7d6297100045faa6$export$83327a4f6aff409e));
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (newItem)=>fetch($4529664c1ee19d35$var$apiURL + snap.snap_prefix + '/routes/new', {
                method: "POST",
                body: JSON.stringify(newItem.fields),
                mode: 'cors',
                headers: {
                    "Content-type": "text/plain"
                }
            }).then(async (res)=>{
                const body1 = await res.json();
                if (res.ok == false) throw new Error(res.status + ' ' + res.statusText, {
                    cause: body1
                });
            }),
        onSettled: ()=>{
            $4529664c1ee19d35$export$7c07b633a151f9c5.invalidateQueries({
                queryKey: [
                    'GTFS',
                    snap,
                    'routes'
                ]
            });
        }
    });
} /* export function useMutateGtfsStop() {
  const snap = useContext(SnapshotContext);
 
  return useMutation({
    mutationFn: (updatedItem) => 
      fetch(apiURL + snap.snap_prefix + '/stops/' + updatedItem.query.modified_stop_id + '/update', {
        method: "POST",
        body: JSON.stringify(
          updatedItem.fields
        ),
        mode: 'cors',
        headers: {
          "Content-type": "text/plain"
        }        
      }).then( res => {
        if (res.ok) {
          queryClient.invalidateQueries({queryKey: ['stopsData']})
        } else {
          throw new Error(`Http error: ${res.status}`);
        }
      })
  });
} */ 




var $acw62 = parcelRequire("acw62");
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}


function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, o);
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);



var $acw62 = parcelRequire("acw62");
function $04540450bf60efa1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $acw62.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $acw62.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $04540450bf60efa1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $04540450bf60efa1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $04540450bf60efa1$export$fa71e2345c31d7a2(props, onExited) {
    return $04540450bf60efa1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $04540450bf60efa1$var$getProp(child, 'appear', props),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', props),
            exit: $04540450bf60efa1$var$getProp(child, 'exit', props)
        });
    });
}
function $04540450bf60efa1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $04540450bf60efa1$export$bbc8a025727ea824(nextProps.children);
    var children = $04540450bf60efa1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $acw62.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $acw62.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $acw62.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $e4ea38a8b431e8fc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $e4ea38a8b431e8fc$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $e4ea38a8b431e8fc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $04540450bf60efa1$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $04540450bf60efa1$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $04540450bf60efa1$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $e4ea38a8b431e8fc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$e4ea38a8b431e8fc$var$TransitionGroup.propTypes = {};
$e4ea38a8b431e8fc$var$TransitionGroup.defaultProps = $e4ea38a8b431e8fc$var$defaultProps;
var $e4ea38a8b431e8fc$export$2e2bcd8739ae039 = $e4ea38a8b431e8fc$var$TransitionGroup;





var $acw62 = parcelRequire("acw62");




/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $3c0eef4e7b8d3866$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $620ffe1c3bcccf8e$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $3c0eef4e7b8d3866$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}


function $c22b31c675df16bf$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $c22b31c675df16bf$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $c22b31c675df16bf$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $c22b31c675df16bf$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};




var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $0fef977f04119bf5$export$bb38bb9a1161268 = 'unmounted';
var $0fef977f04119bf5$export$84cbff306f539230 = 'exited';
var $0fef977f04119bf5$export$df38205c966be359 = 'entering';
var $0fef977f04119bf5$export$78e9e6e3e014d60a = 'entered';
var $0fef977f04119bf5$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $4c26e32a51d8c622$export$2e2bcd8739ae039);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;




var $ee2e736fe07a2c40$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $620ffe1c3bcccf8e$export$2e2bcd8739ae039)(node, c);
    });
};
var $ee2e736fe07a2c40$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $c22b31c675df16bf$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $ee2e736fe07a2c40$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $ee2e736fe07a2c40$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $ee2e736fe07a2c40$var$removeClass(node, baseClassName);
        if (activeClassName) $ee2e736fe07a2c40$var$removeClass(node, activeClassName);
        if (doneClassName) $ee2e736fe07a2c40$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0fef977f04119bf5$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ee2e736fe07a2c40$var$CSSTransition.defaultProps = {
    classNames: ''
};
$ee2e736fe07a2c40$var$CSSTransition.propTypes = {};
var $ee2e736fe07a2c40$export$2e2bcd8739ae039 = $ee2e736fe07a2c40$var$CSSTransition;





'use client';
function $17afce1b96f6eaec$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $17afce1b96f6eaec$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $17afce1b96f6eaec$var$_typeof(o);
}
function $17afce1b96f6eaec$var$toPrimitive(t, r) {
    if ("object" != $17afce1b96f6eaec$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $17afce1b96f6eaec$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $17afce1b96f6eaec$var$toPropertyKey(t) {
    var i = $17afce1b96f6eaec$var$toPrimitive(t, "string");
    return "symbol" == $17afce1b96f6eaec$var$_typeof(i) ? i : i + "";
}
function $17afce1b96f6eaec$var$_defineProperty(e, r, t) {
    return (r = $17afce1b96f6eaec$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $17afce1b96f6eaec$var$CSSTransitionBase = {
    defaultProps: {
        __TYPE: 'CSSTransition',
        children: undefined
    },
    getProps: function getProps(props) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getMergedProps(props, $17afce1b96f6eaec$var$CSSTransitionBase.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getDiffProps(props, $17afce1b96f6eaec$var$CSSTransitionBase.defaultProps);
    }
};
function $17afce1b96f6eaec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $17afce1b96f6eaec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $17afce1b96f6eaec$var$ownKeys(Object(t), !0).forEach(function(r) {
            $17afce1b96f6eaec$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $17afce1b96f6eaec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $17afce1b96f6eaec$export$a7a5590ad6d7af0 = /*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var props = $17afce1b96f6eaec$var$CSSTransitionBase.getProps(inProps);
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var disabled = props.disabled || props.options && props.options.disabled || context && !context.cssTransition || !(0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).cssTransition;
    var onEnter = function onEnter(node, isAppearing) {
        props.onEnter && props.onEnter(node, isAppearing); // component
        props.options && props.options.onEnter && props.options.onEnter(node, isAppearing); // user option
    };
    var onEntering = function onEntering(node, isAppearing) {
        props.onEntering && props.onEntering(node, isAppearing); // component
        props.options && props.options.onEntering && props.options.onEntering(node, isAppearing); // user option
    };
    var onEntered = function onEntered(node, isAppearing) {
        props.onEntered && props.onEntered(node, isAppearing); // component
        props.options && props.options.onEntered && props.options.onEntered(node, isAppearing); // user option
    };
    var onExit = function onExit(node) {
        props.onExit && props.onExit(node); // component
        props.options && props.options.onExit && props.options.onExit(node); // user option
    };
    var onExiting = function onExiting(node) {
        props.onExiting && props.onExiting(node); // component
        props.options && props.options.onExiting && props.options.onExiting(node); // user option
    };
    var onExited = function onExited(node) {
        props.onExited && props.onExited(node); // component
        props.options && props.options.onExited && props.options.onExited(node); // user option
    };
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (disabled) {
            // no animation
            var node = (0, $a73ce425265b079e$export$4855211e6b8ad895).getRefElement(props.nodeRef);
            if (props["in"]) {
                onEnter(node, true);
                onEntering(node, true);
                onEntered(node, true);
            } else {
                onExit(node);
                onExiting(node);
                onExited(node);
            }
        }
    }, [
        props["in"]
    ]);
    if (disabled) return props["in"] ? props.children : null;
    var immutableProps = {
        nodeRef: props.nodeRef,
        "in": props["in"],
        appear: props.appear,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited
    };
    var mutableProps = {
        classNames: props.classNames,
        timeout: props.timeout,
        unmountOnExit: props.unmountOnExit
    };
    var mergedProps = $17afce1b96f6eaec$var$_objectSpread($17afce1b96f6eaec$var$_objectSpread($17afce1b96f6eaec$var$_objectSpread({}, mutableProps), props.options || {}), immutableProps);
    return /*#__PURE__*/ $acw62.createElement((0, $ee2e736fe07a2c40$export$2e2bcd8739ae039), mergedProps, props.children);
});
$17afce1b96f6eaec$export$a7a5590ad6d7af0.displayName = 'CSSTransition';






var $acw62 = parcelRequire("acw62");

'use client';
function $ed79679a1c3e60de$var$_extends() {
    return $ed79679a1c3e60de$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ed79679a1c3e60de$var$_extends.apply(null, arguments);
}
var $ed79679a1c3e60de$export$7dd004358974b05d = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $ed79679a1c3e60de$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M4.86199 11.5948C4.78717 11.5923 4.71366 11.5745 4.64596 11.5426C4.57826 11.5107 4.51779 11.4652 4.46827 11.4091L0.753985 7.69483C0.683167 7.64891 0.623706 7.58751 0.580092 7.51525C0.536478 7.44299 0.509851 7.36177 0.502221 7.27771C0.49459 7.19366 0.506156 7.10897 0.536046 7.03004C0.565935 6.95111 0.613367 6.88 0.674759 6.82208C0.736151 6.76416 0.8099 6.72095 0.890436 6.69571C0.970973 6.67046 1.05619 6.66385 1.13966 6.67635C1.22313 6.68886 1.30266 6.72017 1.37226 6.76792C1.44186 6.81567 1.4997 6.8786 1.54141 6.95197L4.86199 10.2503L12.6397 2.49483C12.7444 2.42694 12.8689 2.39617 12.9932 2.40745C13.1174 2.41873 13.2343 2.47141 13.3251 2.55705C13.4159 2.64268 13.4753 2.75632 13.4938 2.87973C13.5123 3.00315 13.4888 3.1292 13.4271 3.23768L5.2557 11.4091C5.20618 11.4652 5.14571 11.5107 5.07801 11.5426C5.01031 11.5745 4.9368 11.5923 4.86199 11.5948Z",
        fill: "currentColor"
    }));
}));
$ed79679a1c3e60de$export$7dd004358974b05d.displayName = 'CheckIcon';



var $acw62 = parcelRequire("acw62");

'use client';
function $b5ef9f4da061dfbc$var$_extends() {
    return $b5ef9f4da061dfbc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b5ef9f4da061dfbc$var$_extends.apply(null, arguments);
}
var $b5ef9f4da061dfbc$export$b409b230b61d4724 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $b5ef9f4da061dfbc$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M13.4018 13.1893H0.598161C0.49329 13.189 0.390283 13.1615 0.299143 13.1097C0.208003 13.0578 0.131826 12.9832 0.0780112 12.8932C0.0268539 12.8015 0 12.6982 0 12.5931C0 12.4881 0.0268539 12.3848 0.0780112 12.293L6.47985 1.08982C6.53679 1.00399 6.61408 0.933574 6.70484 0.884867C6.7956 0.836159 6.897 0.810669 7 0.810669C7.103 0.810669 7.2044 0.836159 7.29516 0.884867C7.38592 0.933574 7.46321 1.00399 7.52015 1.08982L13.922 12.293C13.9731 12.3848 14 12.4881 14 12.5931C14 12.6982 13.9731 12.8015 13.922 12.8932C13.8682 12.9832 13.792 13.0578 13.7009 13.1097C13.6097 13.1615 13.5067 13.189 13.4018 13.1893ZM1.63046 11.989H12.3695L7 2.59425L1.63046 11.989Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M6.99996 8.78801C6.84143 8.78594 6.68997 8.72204 6.57787 8.60993C6.46576 8.49782 6.40186 8.34637 6.39979 8.18784V5.38703C6.39979 5.22786 6.46302 5.0752 6.57557 4.96265C6.68813 4.85009 6.84078 4.78686 6.99996 4.78686C7.15914 4.78686 7.31179 4.85009 7.42435 4.96265C7.5369 5.0752 7.60013 5.22786 7.60013 5.38703V8.18784C7.59806 8.34637 7.53416 8.49782 7.42205 8.60993C7.30995 8.72204 7.15849 8.78594 6.99996 8.78801Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M6.99996 11.1887C6.84143 11.1866 6.68997 11.1227 6.57787 11.0106C6.46576 10.8985 6.40186 10.7471 6.39979 10.5885V10.1884C6.39979 10.0292 6.46302 9.87658 6.57557 9.76403C6.68813 9.65147 6.84078 9.58824 6.99996 9.58824C7.15914 9.58824 7.31179 9.65147 7.42435 9.76403C7.5369 9.87658 7.60013 10.0292 7.60013 10.1884V10.5885C7.59806 10.7471 7.53416 10.8985 7.42205 11.0106C7.30995 11.1227 7.15849 11.1866 6.99996 11.1887Z",
        fill: "currentColor"
    }));
}));
$b5ef9f4da061dfbc$export$b409b230b61d4724.displayName = 'ExclamationTriangleIcon';



var $acw62 = parcelRequire("acw62");

'use client';
function $e4c55e6257866442$var$_extends() {
    return $e4c55e6257866442$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e4c55e6257866442$var$_extends.apply(null, arguments);
}
var $e4c55e6257866442$export$235e99e4cce237dc = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $e4c55e6257866442$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.11101 12.8203C4.26215 13.5895 5.61553 14 7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.61553 13.5895 4.26215 12.8203 3.11101C12.0511 1.95987 10.9579 1.06266 9.67879 0.532846C8.3997 0.00303296 6.99224 -0.13559 5.63437 0.134506C4.2765 0.404603 3.02922 1.07129 2.05026 2.05026C1.07129 3.02922 0.404603 4.2765 0.134506 5.63437C-0.13559 6.99224 0.00303296 8.3997 0.532846 9.67879C1.06266 10.9579 1.95987 12.0511 3.11101 12.8203ZM3.75918 2.14976C4.71846 1.50879 5.84628 1.16667 7 1.16667C8.5471 1.16667 10.0308 1.78125 11.1248 2.87521C12.2188 3.96918 12.8333 5.45291 12.8333 7C12.8333 8.15373 12.4912 9.28154 11.8502 10.2408C11.2093 11.2001 10.2982 11.9478 9.23232 12.3893C8.16642 12.8308 6.99353 12.9463 5.86198 12.7212C4.73042 12.4962 3.69102 11.9406 2.87521 11.1248C2.05941 10.309 1.50384 9.26958 1.27876 8.13803C1.05367 7.00647 1.16919 5.83358 1.61071 4.76768C2.05222 3.70178 2.79989 2.79074 3.75918 2.14976ZM7.00002 4.8611C6.84594 4.85908 6.69873 4.79698 6.58977 4.68801C6.48081 4.57905 6.4187 4.43185 6.41669 4.27776V3.88888C6.41669 3.73417 6.47815 3.58579 6.58754 3.4764C6.69694 3.367 6.84531 3.30554 7.00002 3.30554C7.15473 3.30554 7.3031 3.367 7.4125 3.4764C7.52189 3.58579 7.58335 3.73417 7.58335 3.88888V4.27776C7.58134 4.43185 7.51923 4.57905 7.41027 4.68801C7.30131 4.79698 7.1541 4.85908 7.00002 4.8611ZM7.00002 10.6945C6.84594 10.6925 6.69873 10.6304 6.58977 10.5214C6.48081 10.4124 6.4187 10.2652 6.41669 10.1111V6.22225C6.41669 6.06754 6.47815 5.91917 6.58754 5.80977C6.69694 5.70037 6.84531 5.63892 7.00002 5.63892C7.15473 5.63892 7.3031 5.70037 7.4125 5.80977C7.52189 5.91917 7.58335 6.06754 7.58335 6.22225V10.1111C7.58134 10.2652 7.51923 10.4124 7.41027 10.5214C7.30131 10.6304 7.1541 10.6925 7.00002 10.6945Z",
        fill: "currentColor"
    }));
}));
$e4c55e6257866442$export$235e99e4cce237dc.displayName = 'InfoCircleIcon';



var $acw62 = parcelRequire("acw62");

'use client';
function $2a5691e8eb30be5a$var$_extends() {
    return $2a5691e8eb30be5a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2a5691e8eb30be5a$var$_extends.apply(null, arguments);
}
var $2a5691e8eb30be5a$export$32edebbf2d9136cc = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $2a5691e8eb30be5a$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8.01186 7.00933L12.27 2.75116C12.341 2.68501 12.398 2.60524 12.4375 2.51661C12.4769 2.42798 12.4982 2.3323 12.4999 2.23529C12.5016 2.13827 12.4838 2.0419 12.4474 1.95194C12.4111 1.86197 12.357 1.78024 12.2884 1.71163C12.2198 1.64302 12.138 1.58893 12.0481 1.55259C11.9581 1.51625 11.8617 1.4984 11.7647 1.50011C11.6677 1.50182 11.572 1.52306 11.4834 1.56255C11.3948 1.60204 11.315 1.65898 11.2488 1.72997L6.99067 5.98814L2.7325 1.72997C2.59553 1.60234 2.41437 1.53286 2.22718 1.53616C2.03999 1.53946 1.8614 1.61529 1.72901 1.74767C1.59663 1.88006 1.5208 2.05865 1.5175 2.24584C1.5142 2.43303 1.58368 2.61419 1.71131 2.75116L5.96948 7.00933L1.71131 11.2675C1.576 11.403 1.5 11.5866 1.5 11.7781C1.5 11.9696 1.576 12.1532 1.71131 12.2887C1.84679 12.424 2.03043 12.5 2.2219 12.5C2.41338 12.5 2.59702 12.424 2.7325 12.2887L6.99067 8.03052L11.2488 12.2887C11.3843 12.424 11.568 12.5 11.7594 12.5C11.9509 12.5 12.1346 12.424 12.27 12.2887C12.4053 12.1532 12.4813 11.9696 12.4813 11.7781C12.4813 11.5866 12.4053 11.403 12.27 11.2675L8.01186 7.00933Z",
        fill: "currentColor"
    }));
}));
$2a5691e8eb30be5a$export$32edebbf2d9136cc.displayName = 'TimesIcon';



var $acw62 = parcelRequire("acw62");

'use client';
function $81bfb4f889b27300$var$_extends() {
    return $81bfb4f889b27300$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $81bfb4f889b27300$var$_extends.apply(null, arguments);
}
var $81bfb4f889b27300$export$4236c899190094ee = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $81bfb4f889b27300$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C5.61553 14 4.26215 13.5895 3.11101 12.8203C1.95987 12.0511 1.06266 10.9579 0.532846 9.67879C0.00303296 8.3997 -0.13559 6.99224 0.134506 5.63437C0.404603 4.2765 1.07129 3.02922 2.05026 2.05026C3.02922 1.07129 4.2765 0.404603 5.63437 0.134506C6.99224 -0.13559 8.3997 0.00303296 9.67879 0.532846C10.9579 1.06266 12.0511 1.95987 12.8203 3.11101C13.5895 4.26215 14 5.61553 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14ZM7 1.16667C5.84628 1.16667 4.71846 1.50879 3.75918 2.14976C2.79989 2.79074 2.05222 3.70178 1.61071 4.76768C1.16919 5.83358 1.05367 7.00647 1.27876 8.13803C1.50384 9.26958 2.05941 10.309 2.87521 11.1248C3.69102 11.9406 4.73042 12.4962 5.86198 12.7212C6.99353 12.9463 8.16642 12.8308 9.23232 12.3893C10.2982 11.9478 11.2093 11.2001 11.8502 10.2408C12.4912 9.28154 12.8333 8.15373 12.8333 7C12.8333 5.45291 12.2188 3.96918 11.1248 2.87521C10.0308 1.78125 8.5471 1.16667 7 1.16667ZM4.66662 9.91668C4.58998 9.91704 4.51404 9.90209 4.44325 9.87271C4.37246 9.84333 4.30826 9.8001 4.2544 9.74557C4.14516 9.6362 4.0838 9.48793 4.0838 9.33335C4.0838 9.17876 4.14516 9.0305 4.2544 8.92113L6.17553 7L4.25443 5.07891C4.15139 4.96832 4.09529 4.82207 4.09796 4.67094C4.10063 4.51982 4.16185 4.37563 4.26872 4.26876C4.3756 4.16188 4.51979 4.10066 4.67091 4.09799C4.82204 4.09532 4.96829 4.15142 5.07887 4.25446L6.99997 6.17556L8.92106 4.25446C9.03164 4.15142 9.1779 4.09532 9.32903 4.09799C9.48015 4.10066 9.62434 4.16188 9.73121 4.26876C9.83809 4.37563 9.89931 4.51982 9.90198 4.67094C9.90464 4.82207 9.84855 4.96832 9.74551 5.07891L7.82441 7L9.74554 8.92113C9.85478 9.0305 9.91614 9.17876 9.91614 9.33335C9.91614 9.48793 9.85478 9.6362 9.74554 9.74557C9.69168 9.8001 9.62748 9.84333 9.55669 9.87271C9.4859 9.90209 9.40996 9.91704 9.33332 9.91668C9.25668 9.91704 9.18073 9.90209 9.10995 9.87271C9.03916 9.84333 8.97495 9.8001 8.9211 9.74557L6.99997 7.82444L5.07884 9.74557C5.02499 9.8001 4.96078 9.84333 4.88999 9.87271C4.81921 9.90209 4.74326 9.91704 4.66662 9.91668Z",
        fill: "currentColor"
    }));
}));
$81bfb4f889b27300$export$4236c899190094ee.displayName = 'TimesCircleIcon';



'use client';
function $fe304f6df74368ab$var$_extends() {
    return $fe304f6df74368ab$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fe304f6df74368ab$var$_extends.apply(null, arguments);
}
function $fe304f6df74368ab$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $fe304f6df74368ab$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $fe304f6df74368ab$var$_arrayLikeToArray(r);
}
function $fe304f6df74368ab$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $fe304f6df74368ab$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $fe304f6df74368ab$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $fe304f6df74368ab$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $fe304f6df74368ab$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fe304f6df74368ab$var$_toConsumableArray(r) {
    return $fe304f6df74368ab$var$_arrayWithoutHoles(r) || $fe304f6df74368ab$var$_iterableToArray(r) || $fe304f6df74368ab$var$_unsupportedIterableToArray(r) || $fe304f6df74368ab$var$_nonIterableSpread();
}
function $fe304f6df74368ab$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $fe304f6df74368ab$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $fe304f6df74368ab$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fe304f6df74368ab$var$_slicedToArray(r, e) {
    return $fe304f6df74368ab$var$_arrayWithHoles(r) || $fe304f6df74368ab$var$_iterableToArrayLimit(r, e) || $fe304f6df74368ab$var$_unsupportedIterableToArray(r, e) || $fe304f6df74368ab$var$_nonIterableRest();
}
function $fe304f6df74368ab$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fe304f6df74368ab$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fe304f6df74368ab$var$_typeof(o);
}
function $fe304f6df74368ab$var$toPrimitive(t, r) {
    if ("object" != $fe304f6df74368ab$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $fe304f6df74368ab$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $fe304f6df74368ab$var$toPropertyKey(t) {
    var i = $fe304f6df74368ab$var$toPrimitive(t, "string");
    return "symbol" == $fe304f6df74368ab$var$_typeof(i) ? i : i + "";
}
function $fe304f6df74368ab$var$_defineProperty(e, r, t) {
    return (r = $fe304f6df74368ab$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $fe304f6df74368ab$var$styles = "\n@layer primereact {\n    .p-toast {\n        width: calc(100% - var(--toast-indent, 0px));\n        max-width: 25rem;\n    }\n    \n    .p-toast-message-icon {\n        flex-shrink: 0;\n    }\n    \n    .p-toast-message-content {\n        display: flex;\n        align-items: flex-start;\n    }\n    \n    .p-toast-message-text {\n        flex: 1 1 auto;\n    }\n    \n    .p-toast-summary {\n        overflow-wrap: anywhere;\n    }\n    \n    .p-toast-detail {\n        overflow-wrap: anywhere;\n    }\n    \n    .p-toast-top-center {\n        transform: translateX(-50%);\n    }\n    \n    .p-toast-bottom-center {\n        transform: translateX(-50%);\n    }\n    \n    .p-toast-center {\n        min-width: 20vw;\n        transform: translate(-50%, -50%);\n    }\n    \n    .p-toast-icon-close {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        overflow: hidden;\n        position: relative;\n    }\n    \n    .p-toast-icon-close.p-link {\n        cursor: pointer;\n    }\n    \n    /* Animations */\n    .p-toast-message-enter {\n        opacity: 0;\n        transform: translateY(50%);\n    }\n    \n    .p-toast-message-enter-active {\n        opacity: 1;\n        transform: translateY(0);\n        transition: transform 0.3s, opacity 0.3s;\n    }\n    \n    .p-toast-message-enter-done {\n        transform: none;\n    }\n    \n    .p-toast-message-exit {\n        opacity: 1;\n        max-height: 1000px;\n    }\n    \n    .p-toast .p-toast-message.p-toast-message-exit-active {\n        opacity: 0;\n        max-height: 0;\n        margin-bottom: 0;\n        overflow: hidden;\n        transition: max-height 0.45s cubic-bezier(0, 1, 0, 1), opacity 0.3s, margin-bottom 0.3s;\n    }\n}\n";
var $fe304f6df74368ab$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, context = _ref.context;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-toast p-component p-toast-' + props.position, props.className, {
            'p-input-filled': context && context.inputStyle === 'filled' || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).inputStyle === 'filled',
            'p-ripple-disabled': context && context.ripple === false || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).ripple === false
        });
    },
    message: {
        message: function message(_ref2) {
            var severity = _ref2.severity;
            return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-toast-message', $fe304f6df74368ab$var$_defineProperty({}, "p-toast-message-".concat(severity), severity));
        },
        content: 'p-toast-message-content',
        buttonicon: 'p-toast-icon-close-icon',
        closeButton: 'p-toast-icon-close p-link',
        icon: 'p-toast-message-icon',
        text: 'p-toast-message-text',
        summary: 'p-toast-summary',
        detail: 'p-toast-detail'
    },
    transition: 'p-toast-message'
};
var $fe304f6df74368ab$var$inlineStyles = {
    root: function root(_ref3) {
        var props = _ref3.props;
        return {
            position: 'fixed',
            top: props.position === 'top-right' || props.position === 'top-left' || props.position === 'top-center' ? '20px' : props.position === 'center' ? '50%' : null,
            right: (props.position === 'top-right' || props.position === 'bottom-right') && '20px',
            bottom: (props.position === 'bottom-left' || props.position === 'bottom-right' || props.position === 'bottom-center') && '20px',
            left: props.position === 'top-left' || props.position === 'bottom-left' ? '20px' : props.position === 'center' || props.position === 'top-center' || props.position === 'bottom-center' ? '50%' : null
        };
    }
};
var $fe304f6df74368ab$var$ToastBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'Toast',
        id: null,
        className: null,
        content: null,
        style: null,
        baseZIndex: 0,
        position: 'top-right',
        transitionOptions: null,
        appendTo: 'self',
        onClick: null,
        onRemove: null,
        onShow: null,
        onHide: null,
        onMouseEnter: null,
        onMouseLeave: null,
        children: undefined
    },
    css: {
        classes: $fe304f6df74368ab$var$classes,
        styles: $fe304f6df74368ab$var$styles,
        inlineStyles: $fe304f6df74368ab$var$inlineStyles
    }
});
function $fe304f6df74368ab$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $fe304f6df74368ab$var$toPropertyKey(o.key), o);
    }
}
function $fe304f6df74368ab$var$_createClass(e, r, t) {
    return r && $fe304f6df74368ab$var$_defineProperties(e.prototype, r), t && $fe304f6df74368ab$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $fe304f6df74368ab$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
var $fe304f6df74368ab$var$FilterMatchMode = Object.freeze({
    STARTS_WITH: 'startsWith',
    CONTAINS: 'contains',
    NOT_CONTAINS: 'notContains',
    ENDS_WITH: 'endsWith',
    EQUALS: 'equals',
    NOT_EQUALS: 'notEquals',
    IN: 'in',
    LESS_THAN: 'lt',
    LESS_THAN_OR_EQUAL_TO: 'lte',
    GREATER_THAN: 'gt',
    GREATER_THAN_OR_EQUAL_TO: 'gte',
    BETWEEN: 'between',
    DATE_IS: 'dateIs',
    DATE_IS_NOT: 'dateIsNot',
    DATE_BEFORE: 'dateBefore',
    DATE_AFTER: 'dateAfter',
    CUSTOM: 'custom'
});
/**
 * @deprecated please use PrimeReactContext
 */ var $fe304f6df74368ab$var$PrimeReact = /*#__PURE__*/ $fe304f6df74368ab$var$_createClass(function PrimeReact() {
    $fe304f6df74368ab$var$_classCallCheck(this, PrimeReact);
});
$fe304f6df74368ab$var$_defineProperty($fe304f6df74368ab$var$PrimeReact, "ripple", false);
$fe304f6df74368ab$var$_defineProperty($fe304f6df74368ab$var$PrimeReact, "inputStyle", 'outlined');
$fe304f6df74368ab$var$_defineProperty($fe304f6df74368ab$var$PrimeReact, "locale", 'en');
$fe304f6df74368ab$var$_defineProperty($fe304f6df74368ab$var$PrimeReact, "appendTo", null);
$fe304f6df74368ab$var$_defineProperty($fe304f6df74368ab$var$PrimeReact, "cssTransition", true);
$fe304f6df74368ab$var$_defineProperty($fe304f6df74368ab$var$PrimeReact, "autoZIndex", true);
$fe304f6df74368ab$var$_defineProperty($fe304f6df74368ab$var$PrimeReact, "hideOverlaysOnDocumentScrolling", false);
$fe304f6df74368ab$var$_defineProperty($fe304f6df74368ab$var$PrimeReact, "nonce", null);
$fe304f6df74368ab$var$_defineProperty($fe304f6df74368ab$var$PrimeReact, "nullSortOrder", 1);
$fe304f6df74368ab$var$_defineProperty($fe304f6df74368ab$var$PrimeReact, "zIndex", {
    modal: 1100,
    overlay: 1000,
    menu: 1000,
    tooltip: 1100,
    toast: 1200
});
$fe304f6df74368ab$var$_defineProperty($fe304f6df74368ab$var$PrimeReact, "pt", undefined);
$fe304f6df74368ab$var$_defineProperty($fe304f6df74368ab$var$PrimeReact, "filterMatchModeOptions", {
    text: [
        $fe304f6df74368ab$var$FilterMatchMode.STARTS_WITH,
        $fe304f6df74368ab$var$FilterMatchMode.CONTAINS,
        $fe304f6df74368ab$var$FilterMatchMode.NOT_CONTAINS,
        $fe304f6df74368ab$var$FilterMatchMode.ENDS_WITH,
        $fe304f6df74368ab$var$FilterMatchMode.EQUALS,
        $fe304f6df74368ab$var$FilterMatchMode.NOT_EQUALS
    ],
    numeric: [
        $fe304f6df74368ab$var$FilterMatchMode.EQUALS,
        $fe304f6df74368ab$var$FilterMatchMode.NOT_EQUALS,
        $fe304f6df74368ab$var$FilterMatchMode.LESS_THAN,
        $fe304f6df74368ab$var$FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
        $fe304f6df74368ab$var$FilterMatchMode.GREATER_THAN,
        $fe304f6df74368ab$var$FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
    ],
    date: [
        $fe304f6df74368ab$var$FilterMatchMode.DATE_IS,
        $fe304f6df74368ab$var$FilterMatchMode.DATE_IS_NOT,
        $fe304f6df74368ab$var$FilterMatchMode.DATE_BEFORE,
        $fe304f6df74368ab$var$FilterMatchMode.DATE_AFTER
    ]
});
$fe304f6df74368ab$var$_defineProperty($fe304f6df74368ab$var$PrimeReact, "changeTheme", function(currentTheme, newTheme, linkElementId, callback) {
    var _linkElement$parentNo;
    var linkElement = document.getElementById(linkElementId);
    if (!linkElement) throw Error("Element with id ".concat(linkElementId, " not found."));
    var newThemeUrl = linkElement.getAttribute('href').replace(currentTheme, newTheme);
    var newLinkElement = document.createElement('link');
    newLinkElement.setAttribute('rel', 'stylesheet');
    newLinkElement.setAttribute('id', linkElementId);
    newLinkElement.setAttribute('href', newThemeUrl);
    newLinkElement.addEventListener('load', function() {
        if (callback) callback();
    });
    (_linkElement$parentNo = linkElement.parentNode) === null || _linkElement$parentNo === void 0 || _linkElement$parentNo.replaceChild(newLinkElement, linkElement);
});
var $fe304f6df74368ab$var$locales = {
    en: {
        accept: 'Yes',
        addRule: 'Add Rule',
        am: 'AM',
        apply: 'Apply',
        cancel: 'Cancel',
        choose: 'Choose',
        chooseDate: 'Choose Date',
        chooseMonth: 'Choose Month',
        chooseYear: 'Choose Year',
        clear: 'Clear',
        completed: 'Completed',
        contains: 'Contains',
        custom: 'Custom',
        dateAfter: 'Date is after',
        dateBefore: 'Date is before',
        dateFormat: 'mm/dd/yy',
        dateIs: 'Date is',
        dateIsNot: 'Date is not',
        dayNames: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ],
        dayNamesMin: [
            'Su',
            'Mo',
            'Tu',
            'We',
            'Th',
            'Fr',
            'Sa'
        ],
        dayNamesShort: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ],
        emptyFilterMessage: 'No results found',
        emptyMessage: 'No available options',
        emptySearchMessage: 'No results found',
        emptySelectionMessage: 'No selected item',
        endsWith: 'Ends with',
        equals: 'Equals',
        fileSizeTypes: [
            'B',
            'KB',
            'MB',
            'GB',
            'TB',
            'PB',
            'EB',
            'ZB',
            'YB'
        ],
        filter: 'Filter',
        firstDayOfWeek: 0,
        gt: 'Greater than',
        gte: 'Greater than or equal to',
        lt: 'Less than',
        lte: 'Less than or equal to',
        matchAll: 'Match All',
        matchAny: 'Match Any',
        medium: 'Medium',
        monthNames: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        monthNamesShort: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        nextDecade: 'Next Decade',
        nextHour: 'Next Hour',
        nextMinute: 'Next Minute',
        nextMonth: 'Next Month',
        nextSecond: 'Next Second',
        nextYear: 'Next Year',
        noFilter: 'No Filter',
        notContains: 'Not contains',
        notEquals: 'Not equals',
        now: 'Now',
        passwordPrompt: 'Enter a password',
        pending: 'Pending',
        pm: 'PM',
        prevDecade: 'Previous Decade',
        prevHour: 'Previous Hour',
        prevMinute: 'Previous Minute',
        prevMonth: 'Previous Month',
        prevSecond: 'Previous Second',
        prevYear: 'Previous Year',
        reject: 'No',
        removeRule: 'Remove Rule',
        searchMessage: '{0} results are available',
        selectionMessage: '{0} items selected',
        showMonthAfterYear: false,
        startsWith: 'Starts with',
        strong: 'Strong',
        today: 'Today',
        upload: 'Upload',
        weak: 'Weak',
        weekHeader: 'Wk',
        aria: {
            cancelEdit: 'Cancel Edit',
            close: 'Close',
            collapseRow: 'Row Collapsed',
            editRow: 'Edit Row',
            expandRow: 'Row Expanded',
            falseLabel: 'False',
            filterConstraint: 'Filter Constraint',
            filterOperator: 'Filter Operator',
            firstPageLabel: 'First Page',
            gridView: 'Grid View',
            hideFilterMenu: 'Hide Filter Menu',
            jumpToPageDropdownLabel: 'Jump to Page Dropdown',
            jumpToPageInputLabel: 'Jump to Page Input',
            lastPageLabel: 'Last Page',
            listView: 'List View',
            moveAllToSource: 'Move All to Source',
            moveAllToTarget: 'Move All to Target',
            moveBottom: 'Move Bottom',
            moveDown: 'Move Down',
            moveToSource: 'Move to Source',
            moveToTarget: 'Move to Target',
            moveTop: 'Move Top',
            moveUp: 'Move Up',
            navigation: 'Navigation',
            next: 'Next',
            nextPageLabel: 'Next Page',
            nullLabel: 'Not Selected',
            pageLabel: 'Page {page}',
            otpLabel: 'Please enter one time password character {0}',
            passwordHide: 'Hide Password',
            passwordShow: 'Show Password',
            previous: 'Previous',
            previousPageLabel: 'Previous Page',
            rotateLeft: 'Rotate Left',
            rotateRight: 'Rotate Right',
            rowsPerPageLabel: 'Rows per page',
            saveEdit: 'Save Edit',
            scrollTop: 'Scroll Top',
            selectAll: 'All items selected',
            selectRow: 'Row Selected',
            showFilterMenu: 'Show Filter Menu',
            slide: 'Slide',
            slideNumber: '{slideNumber}',
            star: '1 star',
            stars: '{star} stars',
            trueLabel: 'True',
            unselectAll: 'All items unselected',
            unselectRow: 'Row Unselected',
            zoomImage: 'Zoom Image',
            zoomIn: 'Zoom In',
            zoomOut: 'Zoom Out'
        }
    }
};
function $fe304f6df74368ab$var$localeOption(key, locale) {
    if (key.includes('__proto__') || key.includes('prototype')) throw new Error('Unsafe key detected');
    var _locale = locale || $fe304f6df74368ab$var$PrimeReact.locale;
    try {
        return $fe304f6df74368ab$var$localeOptions(_locale)[key];
    } catch (error) {
        throw new Error("The ".concat(key, " option is not found in the current locale('").concat(_locale, "')."));
    }
}
function $fe304f6df74368ab$var$localeOptions(locale) {
    var _locale = locale || $fe304f6df74368ab$var$PrimeReact.locale;
    if (_locale.includes('__proto__') || _locale.includes('prototype')) throw new Error('Unsafe locale detected');
    return $fe304f6df74368ab$var$locales[_locale];
}
function $fe304f6df74368ab$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fe304f6df74368ab$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fe304f6df74368ab$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fe304f6df74368ab$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fe304f6df74368ab$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fe304f6df74368ab$var$ToastMessage = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var messageInfo = props.messageInfo, parentMetaData = props.metaData, _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx, index = props.index;
    var _messageInfo$message = messageInfo.message, severity = _messageInfo$message.severity, content = _messageInfo$message.content, summary = _messageInfo$message.summary, detail = _messageInfo$message.detail, closable = _messageInfo$message.closable, life = _messageInfo$message.life, sticky = _messageInfo$message.sticky, _className = _messageInfo$message.className, style = _messageInfo$message.style, _contentClassName = _messageInfo$message.contentClassName, contentStyle = _messageInfo$message.contentStyle, _icon = _messageInfo$message.icon, _closeIcon = _messageInfo$message.closeIcon, pt = _messageInfo$message.pt;
    var params = {
        index: index
    };
    var parentParams = $fe304f6df74368ab$var$_objectSpread($fe304f6df74368ab$var$_objectSpread({}, parentMetaData), params);
    var _React$useState = $acw62.useState(false), _React$useState2 = $fe304f6df74368ab$var$_slicedToArray(_React$useState, 2), focused = _React$useState2[0], setFocused = _React$useState2[1];
    var _useTimeout = (0, $fbdf1e36fa0a01d8$export$d8e6abf214c9ec0f)(function() {
        onClose();
    }, life || 3000, !sticky && !focused), _useTimeout2 = $fe304f6df74368ab$var$_slicedToArray(_useTimeout, 1), clearTimer = _useTimeout2[0];
    var getPTOptions = function getPTOptions(key, options) {
        return ptm(key, $fe304f6df74368ab$var$_objectSpread({
            hostName: props.hostName
        }, options));
    };
    var onClose = function onClose() {
        clearTimer();
        props.onClose && props.onClose(messageInfo);
    };
    var onClick = function onClick(event) {
        if (props.onClick && !((0, $a73ce425265b079e$export$ff8ccbac9225de62).hasClass(event.target, 'p-toast-icon-close') || (0, $a73ce425265b079e$export$ff8ccbac9225de62).hasClass(event.target, 'p-toast-icon-close-icon'))) props.onClick(messageInfo.message);
    };
    var onMouseEnter = function onMouseEnter(event) {
        props.onMouseEnter && props.onMouseEnter(event);
        // do not continue if the user has canceled the event
        if (event.defaultPrevented) return;
        // stop timer while user has focused message
        if (!sticky) {
            clearTimer();
            setFocused(true);
        }
    };
    var onMouseLeave = function onMouseLeave(event) {
        props.onMouseLeave && props.onMouseLeave(event);
        // do not continue if the user has canceled the event
        if (event.defaultPrevented) return;
        // restart timer when user has left message
        if (!sticky) setFocused(false);
    };
    var createCloseIcon = function createCloseIcon() {
        var buttonIconProps = mergeProps({
            className: cx('message.buttonicon')
        }, getPTOptions('buttonicon', parentParams), ptmo(pt, 'buttonicon', $fe304f6df74368ab$var$_objectSpread($fe304f6df74368ab$var$_objectSpread({}, params), {}, {
            hostName: props.hostName
        })));
        var icon = _closeIcon || /*#__PURE__*/ $acw62.createElement((0, $2a5691e8eb30be5a$export$32edebbf2d9136cc), buttonIconProps);
        var closeIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $fe304f6df74368ab$var$_objectSpread({}, buttonIconProps), {
            props: props
        });
        var ariaLabel = props.ariaCloseLabel || $fe304f6df74368ab$var$localeOption('close');
        var closeButtonProps = mergeProps({
            type: 'button',
            className: cx('message.closeButton'),
            onClick: onClose,
            'aria-label': ariaLabel
        }, getPTOptions('closeButton', parentParams), ptmo(pt, 'closeButton', $fe304f6df74368ab$var$_objectSpread($fe304f6df74368ab$var$_objectSpread({}, params), {}, {
            hostName: props.hostName
        })));
        if (closable !== false) return /*#__PURE__*/ $acw62.createElement("div", null, /*#__PURE__*/ $acw62.createElement("button", closeButtonProps, closeIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null)));
        return null;
    };
    var createMessage = function createMessage() {
        if (messageInfo) {
            var contentEl = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(content, {
                message: messageInfo.message,
                onClick: onClick,
                onClose: onClose
            });
            var iconProps = mergeProps({
                className: cx('message.icon')
            }, getPTOptions('icon', parentParams), ptmo(pt, 'icon', $fe304f6df74368ab$var$_objectSpread($fe304f6df74368ab$var$_objectSpread({}, params), {}, {
                hostName: props.hostName
            })));
            var icon = _icon;
            if (!_icon) switch(severity){
                case 'info':
                    icon = /*#__PURE__*/ $acw62.createElement((0, $e4c55e6257866442$export$235e99e4cce237dc), iconProps);
                    break;
                case 'warn':
                    icon = /*#__PURE__*/ $acw62.createElement((0, $b5ef9f4da061dfbc$export$b409b230b61d4724), iconProps);
                    break;
                case 'error':
                    icon = /*#__PURE__*/ $acw62.createElement((0, $81bfb4f889b27300$export$4236c899190094ee), iconProps);
                    break;
                case 'success':
                    icon = /*#__PURE__*/ $acw62.createElement((0, $ed79679a1c3e60de$export$7dd004358974b05d), iconProps);
                    break;
            }
            var messageIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $fe304f6df74368ab$var$_objectSpread({}, iconProps), {
                props: props
            });
            var textProps = mergeProps({
                className: cx('message.text')
            }, getPTOptions('text', parentParams), ptmo(pt, 'text', $fe304f6df74368ab$var$_objectSpread($fe304f6df74368ab$var$_objectSpread({}, params), {}, {
                hostName: props.hostName
            })));
            var summaryProps = mergeProps({
                className: cx('message.summary')
            }, getPTOptions('summary', parentParams), ptmo(pt, 'summary', $fe304f6df74368ab$var$_objectSpread($fe304f6df74368ab$var$_objectSpread({}, params), {}, {
                hostName: props.hostName
            })));
            var detailProps = mergeProps({
                className: cx('message.detail')
            }, getPTOptions('detail', parentParams), ptmo(pt, 'detail', $fe304f6df74368ab$var$_objectSpread($fe304f6df74368ab$var$_objectSpread({}, params), {}, {
                hostName: props.hostName
            })));
            return contentEl || /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, messageIcon, /*#__PURE__*/ $acw62.createElement("div", textProps, /*#__PURE__*/ $acw62.createElement("span", summaryProps, summary), detail && /*#__PURE__*/ $acw62.createElement("div", detailProps, detail)));
        }
        return null;
    };
    var message = createMessage();
    var closeIcon = createCloseIcon();
    var messageProps = mergeProps({
        ref: ref,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(_className, cx('message.message', {
            severity: severity
        })),
        style: style,
        role: 'alert',
        'aria-live': 'assertive',
        'aria-atomic': 'true',
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, getPTOptions('message', parentParams), ptmo(pt, 'root', $fe304f6df74368ab$var$_objectSpread($fe304f6df74368ab$var$_objectSpread({}, params), {}, {
        hostName: props.hostName
    })));
    var contentProps = mergeProps({
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(_contentClassName, cx('message.content')),
        style: contentStyle
    }, getPTOptions('content', parentParams), ptmo(pt, 'content', $fe304f6df74368ab$var$_objectSpread($fe304f6df74368ab$var$_objectSpread({}, params), {}, {
        hostName: props.hostName
    })));
    return /*#__PURE__*/ $acw62.createElement("div", messageProps, /*#__PURE__*/ $acw62.createElement("div", contentProps, message, closeIcon));
}));
$fe304f6df74368ab$var$ToastMessage.displayName = 'ToastMessage';
var $fe304f6df74368ab$var$messageIdx = 0;
var $fe304f6df74368ab$export$8d8dc7d5f743331b = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $fe304f6df74368ab$var$ToastBase.getProps(inProps, context);
    var _React$useState = $acw62.useState([]), _React$useState2 = $fe304f6df74368ab$var$_slicedToArray(_React$useState, 2), messagesState = _React$useState2[0], setMessagesState = _React$useState2[1];
    var containerRef = $acw62.useRef(null);
    var metaData = {
        props: props,
        state: {
            messages: messagesState
        }
    };
    var ptCallbacks = $fe304f6df74368ab$var$ToastBase.setMetaData(metaData);
    (0, $b76d8eda63b3c134$export$142583cb150b394)($fe304f6df74368ab$var$ToastBase.css.styles, ptCallbacks.isUnstyled, {
        name: 'toast'
    });
    var show = function show(messageInfo) {
        if (messageInfo) setMessagesState(function(prev) {
            return assignIdentifiers(prev, messageInfo, true);
        });
    };
    var assignIdentifiers = function assignIdentifiers(currentState, messageInfo, copy) {
        var messages;
        if (Array.isArray(messageInfo)) {
            var multipleMessages = messageInfo.reduce(function(acc, message) {
                acc.push({
                    _pId: $fe304f6df74368ab$var$messageIdx++,
                    message: message
                });
                return acc;
            }, []);
            if (copy) messages = currentState ? [].concat($fe304f6df74368ab$var$_toConsumableArray(currentState), $fe304f6df74368ab$var$_toConsumableArray(multipleMessages)) : multipleMessages;
            else messages = multipleMessages;
        } else {
            var message = {
                _pId: $fe304f6df74368ab$var$messageIdx++,
                message: messageInfo
            };
            if (copy) messages = currentState ? [].concat($fe304f6df74368ab$var$_toConsumableArray(currentState), [
                message
            ]) : [
                message
            ];
            else messages = [
                message
            ];
        }
        return messages;
    };
    var clear = function clear() {
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(containerRef.current);
        setMessagesState([]);
    };
    var replace = function replace(messageInfo) {
        setMessagesState(function(previousMessagesState) {
            return assignIdentifiers(previousMessagesState, messageInfo, false);
        });
    };
    var remove = function remove(messageInfo) {
        // allow removal by ID or by message equality
        var removeMessage = messageInfo._pId ? messageInfo._pId : messageInfo.message || messageInfo;
        setMessagesState(function(prev) {
            return prev.filter(function(msg) {
                return msg._pId !== messageInfo._pId && !(0, $a73ce425265b079e$export$4855211e6b8ad895).deepEquals(msg.message, removeMessage);
            });
        });
        props.onRemove && props.onRemove(messageInfo.message || removeMessage);
    };
    var onClose = function onClose(messageInfo) {
        remove(messageInfo);
    };
    var onEntered = function onEntered() {
        props.onShow && props.onShow();
    };
    var onExited = function onExited() {
        messagesState.length === 1 && (0, $a73ce425265b079e$export$832931caede8e4b9).clear(containerRef.current);
        props.onHide && props.onHide();
    };
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        (0, $a73ce425265b079e$export$832931caede8e4b9).set('toast', containerRef.current, context && context.autoZIndex || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).autoZIndex, props.baseZIndex || context && context.zIndex.toast || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).zIndex.toast);
    }, [
        messagesState,
        props.baseZIndex
    ]);
    (0, $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96)(function() {
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(containerRef.current);
    });
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            show: show,
            replace: replace,
            remove: remove,
            clear: clear,
            getElement: function getElement() {
                return containerRef.current;
            }
        };
    });
    var createElement = function createElement() {
        var rootProps = mergeProps({
            ref: containerRef,
            id: props.id,
            className: ptCallbacks.cx('root', {
                context: context
            }),
            style: ptCallbacks.sx('root')
        }, $fe304f6df74368ab$var$ToastBase.getOtherProps(props), ptCallbacks.ptm('root'));
        var transitionProps = mergeProps({
            classNames: ptCallbacks.cx('transition'),
            timeout: {
                enter: 300,
                exit: 300
            },
            options: props.transitionOptions,
            unmountOnExit: true,
            onEntered: onEntered,
            onExited: onExited
        }, ptCallbacks.ptm('transition'));
        return /*#__PURE__*/ $acw62.createElement("div", rootProps, /*#__PURE__*/ $acw62.createElement((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), null, messagesState && messagesState.map(function(messageInfo, index) {
            var messageRef = /*#__PURE__*/ $acw62.createRef();
            return /*#__PURE__*/ $acw62.createElement((0, $17afce1b96f6eaec$export$a7a5590ad6d7af0), $fe304f6df74368ab$var$_extends({
                nodeRef: messageRef,
                key: messageInfo._pId
            }, transitionProps), inProps.content ? (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(inProps.content, {
                message: messageInfo.message
            }) : /*#__PURE__*/ $acw62.createElement($fe304f6df74368ab$var$ToastMessage, {
                hostName: "Toast",
                ref: messageRef,
                messageInfo: messageInfo,
                index: index,
                onClick: props.onClick,
                onClose: onClose,
                onMouseEnter: props.onMouseEnter,
                onMouseLeave: props.onMouseLeave,
                closeIcon: props.closeIcon,
                ptCallbacks: ptCallbacks,
                metaData: metaData
            }));
        })));
    };
    var element = createElement();
    return /*#__PURE__*/ $acw62.createElement((0, $e7a3b5428092a192$export$602eac185826482c), {
        element: element,
        appendTo: props.appendTo
    });
}));
$fe304f6df74368ab$export$8d8dc7d5f743331b.displayName = 'Toast';



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");

'use client';
function $21d354b8e3c7a084$var$_extends() {
    return $21d354b8e3c7a084$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $21d354b8e3c7a084$var$_extends.apply(null, arguments);
}
var $21d354b8e3c7a084$export$e9bf06badb7c79be = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $21d354b8e3c7a084$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14H11.8C12.3835 14 12.9431 13.7682 13.3556 13.3556C13.7682 12.9431 14 12.3835 14 11.8V2.2C14 1.61652 13.7682 1.05694 13.3556 0.644365C12.9431 0.231785 12.3835 0 11.8 0H2.2C1.61652 0 1.05694 0.231785 0.644365 0.644365C0.231785 1.05694 0 1.61652 0 2.2V7C0 7.15913 0.063214 7.31174 0.175736 7.42426C0.288258 7.53679 0.44087 7.6 0.6 7.6C0.75913 7.6 0.911742 7.53679 1.02426 7.42426C1.13679 7.31174 1.2 7.15913 1.2 7V2.2C1.2 1.93478 1.30536 1.68043 1.49289 1.49289C1.68043 1.30536 1.93478 1.2 2.2 1.2H11.8C12.0652 1.2 12.3196 1.30536 12.5071 1.49289C12.6946 1.68043 12.8 1.93478 12.8 2.2V11.8C12.8 12.0652 12.6946 12.3196 12.5071 12.5071C12.3196 12.6946 12.0652 12.8 11.8 12.8H7C6.84087 12.8 6.68826 12.8632 6.57574 12.9757C6.46321 13.0883 6.4 13.2409 6.4 13.4C6.4 13.5591 6.46321 13.7117 6.57574 13.8243C6.68826 13.9368 6.84087 14 7 14ZM9.77805 7.42192C9.89013 7.534 10.0415 7.59788 10.2 7.59995C10.3585 7.59788 10.5099 7.534 10.622 7.42192C10.7341 7.30985 10.798 7.15844 10.8 6.99995V3.94242C10.8066 3.90505 10.8096 3.86689 10.8089 3.82843C10.8079 3.77159 10.7988 3.7157 10.7824 3.6623C10.756 3.55552 10.701 3.45698 10.622 3.37798C10.5099 3.2659 10.3585 3.20202 10.2 3.19995H7.00002C6.84089 3.19995 6.68828 3.26317 6.57576 3.37569C6.46324 3.48821 6.40002 3.64082 6.40002 3.79995C6.40002 3.95908 6.46324 4.11169 6.57576 4.22422C6.68828 4.33674 6.84089 4.39995 7.00002 4.39995H8.80006L6.19997 7.00005C6.10158 7.11005 6.04718 7.25246 6.04718 7.40005C6.04718 7.54763 6.10158 7.69004 6.19997 7.80005C6.30202 7.91645 6.44561 7.98824 6.59997 8.00005C6.75432 7.98824 6.89791 7.91645 6.99997 7.80005L9.60002 5.26841V6.99995C9.6021 7.15844 9.66598 7.30985 9.77805 7.42192ZM1.4 14H3.8C4.17066 13.9979 4.52553 13.8498 4.78763 13.5877C5.04973 13.3256 5.1979 12.9707 5.2 12.6V10.2C5.1979 9.82939 5.04973 9.47452 4.78763 9.21242C4.52553 8.95032 4.17066 8.80215 3.8 8.80005H1.4C1.02934 8.80215 0.674468 8.95032 0.412371 9.21242C0.150274 9.47452 0.00210008 9.82939 0 10.2V12.6C0.00210008 12.9707 0.150274 13.3256 0.412371 13.5877C0.674468 13.8498 1.02934 13.9979 1.4 14ZM1.25858 10.0586C1.29609 10.0211 1.34696 10 1.4 10H3.8C3.85304 10 3.90391 10.0211 3.94142 10.0586C3.97893 10.0961 4 10.147 4 10.2V12.6C4 12.6531 3.97893 12.704 3.94142 12.7415C3.90391 12.779 3.85304 12.8 3.8 12.8H1.4C1.34696 12.8 1.29609 12.779 1.25858 12.7415C1.22107 12.704 1.2 12.6531 1.2 12.6V10.2C1.2 10.147 1.22107 10.0961 1.25858 10.0586Z",
        fill: "currentColor"
    }));
}));
$21d354b8e3c7a084$export$e9bf06badb7c79be.displayName = 'WindowMaximizeIcon';



var $acw62 = parcelRequire("acw62");

'use client';
function $eebc8b4342d1eb1f$var$_extends() {
    return $eebc8b4342d1eb1f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $eebc8b4342d1eb1f$var$_extends.apply(null, arguments);
}
var $eebc8b4342d1eb1f$export$e1e96001ddb7b5e7 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $eebc8b4342d1eb1f$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.8 0H2.2C1.61652 0 1.05694 0.231785 0.644365 0.644365C0.231785 1.05694 0 1.61652 0 2.2V7C0 7.15913 0.063214 7.31174 0.175736 7.42426C0.288258 7.53679 0.44087 7.6 0.6 7.6C0.75913 7.6 0.911742 7.53679 1.02426 7.42426C1.13679 7.31174 1.2 7.15913 1.2 7V2.2C1.2 1.93478 1.30536 1.68043 1.49289 1.49289C1.68043 1.30536 1.93478 1.2 2.2 1.2H11.8C12.0652 1.2 12.3196 1.30536 12.5071 1.49289C12.6946 1.68043 12.8 1.93478 12.8 2.2V11.8C12.8 12.0652 12.6946 12.3196 12.5071 12.5071C12.3196 12.6946 12.0652 12.8 11.8 12.8H7C6.84087 12.8 6.68826 12.8632 6.57574 12.9757C6.46321 13.0883 6.4 13.2409 6.4 13.4C6.4 13.5591 6.46321 13.7117 6.57574 13.8243C6.68826 13.9368 6.84087 14 7 14H11.8C12.3835 14 12.9431 13.7682 13.3556 13.3556C13.7682 12.9431 14 12.3835 14 11.8V2.2C14 1.61652 13.7682 1.05694 13.3556 0.644365C12.9431 0.231785 12.3835 0 11.8 0ZM6.368 7.952C6.44137 7.98326 6.52025 7.99958 6.6 8H9.8C9.95913 8 10.1117 7.93678 10.2243 7.82426C10.3368 7.71174 10.4 7.55913 10.4 7.4C10.4 7.24087 10.3368 7.08826 10.2243 6.97574C10.1117 6.86321 9.95913 6.8 9.8 6.8H8.048L10.624 4.224C10.73 4.11026 10.7877 3.95982 10.7849 3.80438C10.7822 3.64894 10.7192 3.50063 10.6093 3.3907C10.4994 3.28077 10.3511 3.2178 10.1956 3.21506C10.0402 3.21232 9.88974 3.27002 9.776 3.376L7.2 5.952V4.2C7.2 4.04087 7.13679 3.88826 7.02426 3.77574C6.91174 3.66321 6.75913 3.6 6.6 3.6C6.44087 3.6 6.28826 3.66321 6.17574 3.77574C6.06321 3.88826 6 4.04087 6 4.2V7.4C6.00042 7.47975 6.01674 7.55862 6.048 7.632C6.07656 7.70442 6.11971 7.7702 6.17475 7.82524C6.2298 7.88029 6.29558 7.92344 6.368 7.952ZM1.4 8.80005H3.8C4.17066 8.80215 4.52553 8.95032 4.78763 9.21242C5.04973 9.47452 5.1979 9.82939 5.2 10.2V12.6C5.1979 12.9707 5.04973 13.3256 4.78763 13.5877C4.52553 13.8498 4.17066 13.9979 3.8 14H1.4C1.02934 13.9979 0.674468 13.8498 0.412371 13.5877C0.150274 13.3256 0.00210008 12.9707 0 12.6V10.2C0.00210008 9.82939 0.150274 9.47452 0.412371 9.21242C0.674468 8.95032 1.02934 8.80215 1.4 8.80005ZM3.94142 12.7415C3.97893 12.704 4 12.6531 4 12.6V10.2C4 10.147 3.97893 10.0961 3.94142 10.0586C3.90391 10.0211 3.85304 10 3.8 10H1.4C1.34696 10 1.29609 10.0211 1.25858 10.0586C1.22107 10.0961 1.2 10.147 1.2 10.2V12.6C1.2 12.6531 1.22107 12.704 1.25858 12.7415C1.29609 12.779 1.34696 12.8 1.4 12.8H3.8C3.85304 12.8 3.90391 12.779 3.94142 12.7415Z",
        fill: "currentColor"
    }));
}));
$eebc8b4342d1eb1f$export$e1e96001ddb7b5e7.displayName = 'WindowMinimizeIcon';




'use client';
function $a3c56f96c6f20f77$var$_extends() {
    return $a3c56f96c6f20f77$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a3c56f96c6f20f77$var$_extends.apply(null, arguments);
}
function $a3c56f96c6f20f77$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a3c56f96c6f20f77$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a3c56f96c6f20f77$var$_typeof(o);
}
function $a3c56f96c6f20f77$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $a3c56f96c6f20f77$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $a3c56f96c6f20f77$var$_arrayLikeToArray(r);
}
function $a3c56f96c6f20f77$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $a3c56f96c6f20f77$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $a3c56f96c6f20f77$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a3c56f96c6f20f77$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $a3c56f96c6f20f77$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a3c56f96c6f20f77$var$_toConsumableArray(r) {
    return $a3c56f96c6f20f77$var$_arrayWithoutHoles(r) || $a3c56f96c6f20f77$var$_iterableToArray(r) || $a3c56f96c6f20f77$var$_unsupportedIterableToArray(r) || $a3c56f96c6f20f77$var$_nonIterableSpread();
}
function $a3c56f96c6f20f77$var$toPrimitive(t, r) {
    if ("object" != $a3c56f96c6f20f77$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a3c56f96c6f20f77$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a3c56f96c6f20f77$var$toPropertyKey(t) {
    var i = $a3c56f96c6f20f77$var$toPrimitive(t, "string");
    return "symbol" == $a3c56f96c6f20f77$var$_typeof(i) ? i : i + "";
}
function $a3c56f96c6f20f77$var$_defineProperty(e, r, t) {
    return (r = $a3c56f96c6f20f77$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a3c56f96c6f20f77$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $a3c56f96c6f20f77$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $a3c56f96c6f20f77$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a3c56f96c6f20f77$var$_slicedToArray(r, e) {
    return $a3c56f96c6f20f77$var$_arrayWithHoles(r) || $a3c56f96c6f20f77$var$_iterableToArrayLimit(r, e) || $a3c56f96c6f20f77$var$_unsupportedIterableToArray(r, e) || $a3c56f96c6f20f77$var$_nonIterableRest();
}
var $a3c56f96c6f20f77$var$styles$1 = '';
var $a3c56f96c6f20f77$var$FocusTrapBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'FocusTrap',
        children: undefined
    },
    css: {
        styles: $a3c56f96c6f20f77$var$styles$1
    },
    getProps: function getProps(props) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getMergedProps(props, $a3c56f96c6f20f77$var$FocusTrapBase.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getDiffProps(props, $a3c56f96c6f20f77$var$FocusTrapBase.defaultProps);
    }
});
function $a3c56f96c6f20f77$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a3c56f96c6f20f77$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a3c56f96c6f20f77$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $a3c56f96c6f20f77$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a3c56f96c6f20f77$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a3c56f96c6f20f77$var$FocusTrap = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(inProps, ref) {
    var targetRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    var firstFocusableElementRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    var lastFocusableElementRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    var context = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $a3c56f96c6f20f77$var$FocusTrapBase.getProps(inProps, context);
    var metaData = {
        props: props
    };
    (0, $fbdf1e36fa0a01d8$export$72c85e333541e7f)($a3c56f96c6f20f77$var$FocusTrapBase.css.styles, {
        name: 'focustrap'
    });
    var _FocusTrapBase$setMet = $a3c56f96c6f20f77$var$FocusTrapBase.setMetaData($a3c56f96c6f20f77$var$_objectSpread$2({}, metaData));
    _FocusTrapBase$setMet.ptm;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, function() {
        return {
            props: props,
            getInk: function getInk() {
                return firstFocusableElementRef.current;
            },
            getTarget: function getTarget() {
                return targetRef.current;
            }
        };
    });
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        if (!props.disabled) {
            targetRef.current = getTarget();
            setAutoFocus(targetRef.current);
        }
    });
    var getTarget = function getTarget() {
        return firstFocusableElementRef.current && firstFocusableElementRef.current.parentElement;
    };
    /**
   * This method sets the auto focus on the first focusable element within the target element.
   * It first tries to find a focusable element using the autoFocusSelector. If no such element is found,
   * it then tries to find a focusable element using the firstFocusableSelector.
   * If the autoFocus prop is set to true and a focusable element is found, it sets the focus on that element.
   *
   * @param {HTMLElement} target - The target element within which to find a focusable element.
   */ var setAutoFocus = function setAutoFocus(target) {
        var _ref = props || {}, _ref$autoFocusSelecto = _ref.autoFocusSelector, autoFocusSelector = _ref$autoFocusSelecto === void 0 ? '' : _ref$autoFocusSelecto, _ref$firstFocusableSe = _ref.firstFocusableSelector, firstFocusableSelector = _ref$firstFocusableSe === void 0 ? '' : _ref$firstFocusableSe, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus;
        var defaultAutoFocusSelector = "".concat(getComputedSelector(autoFocusSelector));
        var computedAutoFocusSelector = "[autofocus]".concat(defaultAutoFocusSelector, ", [data-pc-autofocus='true']").concat(defaultAutoFocusSelector);
        var focusableElement = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getFirstFocusableElement(target, computedAutoFocusSelector);
        autoFocus && !focusableElement && (focusableElement = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getFirstFocusableElement(target, getComputedSelector(firstFocusableSelector)));
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(focusableElement);
    };
    var getComputedSelector = function getComputedSelector(selector) {
        return ":not(.p-hidden-focusable):not([data-p-hidden-focusable=\"true\"])".concat(selector !== null && selector !== void 0 ? selector : '');
    };
    var onFirstHiddenElementFocus = function onFirstHiddenElementFocus(event) {
        var _targetRef$current;
        var currentTarget = event.currentTarget, relatedTarget = event.relatedTarget;
        var focusableElement = relatedTarget === currentTarget.$_pfocustrap_lasthiddenfocusableelement || !((_targetRef$current = targetRef.current) !== null && _targetRef$current !== void 0 && _targetRef$current.contains(relatedTarget)) ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getFirstFocusableElement(currentTarget.parentElement, getComputedSelector(currentTarget.$_pfocustrap_focusableselector)) : currentTarget.$_pfocustrap_lasthiddenfocusableelement;
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(focusableElement);
    };
    var onLastHiddenElementFocus = function onLastHiddenElementFocus(event) {
        var _targetRef$current2;
        var currentTarget = event.currentTarget, relatedTarget = event.relatedTarget;
        var focusableElement = relatedTarget === currentTarget.$_pfocustrap_firsthiddenfocusableelement || !((_targetRef$current2 = targetRef.current) !== null && _targetRef$current2 !== void 0 && _targetRef$current2.contains(relatedTarget)) ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getLastFocusableElement(currentTarget.parentElement, getComputedSelector(currentTarget.$_pfocustrap_focusableselector)) : currentTarget.$_pfocustrap_firsthiddenfocusableelement;
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(focusableElement);
    };
    var createHiddenFocusableElements = function createHiddenFocusableElements() {
        var _ref2 = props || {}, _ref2$tabIndex = _ref2.tabIndex, tabIndex = _ref2$tabIndex === void 0 ? 0 : _ref2$tabIndex;
        var createFocusableElement = function createFocusableElement(onFocus, section) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                ref: section === 'firstfocusableelement' ? firstFocusableElementRef : lastFocusableElementRef,
                className: 'p-hidden-accessible p-hidden-focusable',
                tabIndex: tabIndex,
                role: 'presentation',
                "aria-hidden": true,
                "data-p-hidden-accessible": true,
                "data-p-hidden-focusable": true,
                onFocus: onFocus,
                "data-pc-section": section
            });
        };
        var firstFocusableElement = createFocusableElement(onFirstHiddenElementFocus, 'firstfocusableelement');
        var lastFocusableElement = createFocusableElement(onLastHiddenElementFocus, 'lastfocusableelement');
        if (firstFocusableElement.ref.current && lastFocusableElement.ref.current) {
            firstFocusableElement.ref.current.$_pfocustrap_lasthiddenfocusableelement = lastFocusableElement.ref.current;
            lastFocusableElement.ref.current.$_pfocustrap_firsthiddenfocusableelement = firstFocusableElement.ref.current;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, firstFocusableElement, props.children, lastFocusableElement);
    };
    return createHiddenFocusableElements();
}));
var $a3c56f96c6f20f77$var$FocusTrap$1 = $a3c56f96c6f20f77$var$FocusTrap;
function $a3c56f96c6f20f77$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a3c56f96c6f20f77$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a3c56f96c6f20f77$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $a3c56f96c6f20f77$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a3c56f96c6f20f77$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a3c56f96c6f20f77$var$classes = {
    closeButtonIcon: 'p-dialog-header-close-icon',
    closeButton: 'p-dialog-header-icon p-dialog-header-close p-link',
    maximizableIcon: 'p-dialog-header-maximize-icon',
    maximizableButton: 'p-dialog-header-icon p-dialog-header-maximize p-link',
    header: function header(_ref) {
        var props = _ref.props;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-dialog-header', props.headerClassName);
    },
    headerTitle: 'p-dialog-title',
    headerIcons: 'p-dialog-header-icons',
    content: function content(_ref2) {
        var props = _ref2.props;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-dialog-content', props.contentClassName);
    },
    footer: function footer(_ref3) {
        var props = _ref3.props;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-dialog-footer', props.footerClassName);
    },
    mask: function mask(_ref4) {
        var props = _ref4.props, maskVisibleState = _ref4.maskVisibleState;
        var positions = [
            'center',
            'left',
            'right',
            'top',
            'top-left',
            'top-right',
            'bottom',
            'bottom-left',
            'bottom-right'
        ];
        var pos = positions.find(function(item) {
            return item === props.position || item.replace('-', '') === props.position;
        });
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-dialog-mask', pos ? "p-dialog-".concat(pos) : '', {
            'p-component-overlay p-component-overlay-enter': props.modal,
            'p-dialog-visible': maskVisibleState,
            'p-dialog-draggable': props.draggable,
            'p-dialog-resizable': props.resizable
        }, props.maskClassName);
    },
    root: function root(_ref5) {
        var props = _ref5.props, maximized = _ref5.maximized, context = _ref5.context;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-dialog p-component', {
            'p-dialog-rtl': props.rtl,
            'p-dialog-maximized': maximized,
            'p-dialog-default': !maximized,
            'p-input-filled': context && context.inputStyle === 'filled' || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).inputStyle === 'filled',
            'p-ripple-disabled': context && context.ripple === false || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).ripple === false
        });
    },
    transition: 'p-dialog'
};
var $a3c56f96c6f20f77$var$styles = "\n@layer primereact {\n    .p-dialog-mask {\n        background-color: transparent;\n        transition-property: background-color;\n    }\n\n    .p-dialog-visible {\n        display: flex;\n    }\n\n    .p-dialog-mask.p-component-overlay {\n        pointer-events: auto;\n    }\n\n    .p-dialog {\n        display: flex;\n        flex-direction: column;\n        pointer-events: auto;\n        max-height: 90%;\n        transform: scale(1);\n        position: relative;\n    }\n\n    .p-dialog-content {\n        overflow-y: auto;\n        flex-grow: 1;\n    }\n\n    .p-dialog-header {\n        display: flex;\n        align-items: center;\n        flex-shrink: 0;\n    }\n\n    .p-dialog-footer {\n        flex-shrink: 0;\n    }\n\n    .p-dialog .p-dialog-header-icons {\n        display: flex;\n        align-items: center;\n        align-self: flex-start;\n        flex-shrink: 0;\n    }\n\n    .p-dialog .p-dialog-header-icon {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        overflow: hidden;\n        position: relative;\n    }\n\n    .p-dialog .p-dialog-title {\n        flex-grow: 1;\n    }\n\n    /* Fluid */\n    .p-fluid .p-dialog-footer .p-button {\n        width: auto;\n    }\n\n    /* Animation */\n    /* Center */\n    .p-dialog-enter {\n        opacity: 0;\n        transform: scale(0.7);\n    }\n\n    .p-dialog-enter-active {\n        opacity: 1;\n        transform: scale(1);\n        transition: all 150ms cubic-bezier(0, 0, 0.2, 1);\n    }\n\n    .p-dialog-enter-done {\n        transform: none;\n    }\n\n    .p-dialog-exit-active {\n        opacity: 0;\n        transform: scale(0.7);\n        transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);\n    }\n\n    /* Top, Bottom, Left, Right, Top* and Bottom* */\n    .p-dialog-top .p-dialog,\n    .p-dialog-bottom .p-dialog,\n    .p-dialog-left .p-dialog,\n    .p-dialog-right .p-dialog,\n    .p-dialog-top-left .p-dialog,\n    .p-dialog-top-right .p-dialog,\n    .p-dialog-bottom-left .p-dialog,\n    .p-dialog-bottom-right .p-dialog {\n        margin: 0.75em;\n    }\n\n    .p-dialog-top .p-dialog-enter,\n    .p-dialog-top .p-dialog-exit-active {\n        transform: translate3d(0px, -100%, 0px);\n    }\n\n    .p-dialog-bottom .p-dialog-enter,\n    .p-dialog-bottom .p-dialog-exit-active {\n        transform: translate3d(0px, 100%, 0px);\n    }\n\n    .p-dialog-left .p-dialog-enter,\n    .p-dialog-left .p-dialog-exit-active,\n    .p-dialog-top-left .p-dialog-enter,\n    .p-dialog-top-left .p-dialog-exit-active,\n    .p-dialog-bottom-left .p-dialog-enter,\n    .p-dialog-bottom-left .p-dialog-exit-active {\n        transform: translate3d(-100%, 0px, 0px);\n    }\n\n    .p-dialog-right .p-dialog-enter,\n    .p-dialog-right .p-dialog-exit-active,\n    .p-dialog-top-right .p-dialog-enter,\n    .p-dialog-top-right .p-dialog-exit-active,\n    .p-dialog-bottom-right .p-dialog-enter,\n    .p-dialog-bottom-right .p-dialog-exit-active {\n        transform: translate3d(100%, 0px, 0px);\n    }\n\n    .p-dialog-top .p-dialog-enter-active,\n    .p-dialog-bottom .p-dialog-enter-active,\n    .p-dialog-left .p-dialog-enter-active,\n    .p-dialog-top-left .p-dialog-enter-active,\n    .p-dialog-bottom-left .p-dialog-enter-active,\n    .p-dialog-right .p-dialog-enter-active,\n    .p-dialog-top-right .p-dialog-enter-active,\n    .p-dialog-bottom-right .p-dialog-enter-active {\n        transform: translate3d(0px, 0px, 0px);\n        transition: all 0.3s ease-out;\n    }\n\n    .p-dialog-top .p-dialog-exit-active,\n    .p-dialog-bottom .p-dialog-exit-active,\n    .p-dialog-left .p-dialog-exit-active,\n    .p-dialog-top-left .p-dialog-exit-active,\n    .p-dialog-bottom-left .p-dialog-exit-active,\n    .p-dialog-right .p-dialog-exit-active,\n    .p-dialog-top-right .p-dialog-exit-active,\n    .p-dialog-bottom-right .p-dialog-exit-active {\n        transition: all 0.3s ease-out;\n    }\n\n    /* Maximize */\n    .p-dialog-maximized {\n        transition: none;\n        transform: none;\n        margin: 0;\n        width: 100vw !important;\n        height: 100vh !important;\n        max-height: 100%;\n        top: 0px !important;\n        left: 0px !important;\n    }\n\n    .p-dialog-maximized .p-dialog-content {\n        flex-grow: 1;\n    }\n\n    .p-confirm-dialog .p-dialog-content {\n        display: flex;\n        align-items: center;\n    }\n\n    /* Resizable */\n    .p-dialog .p-resizable-handle {\n        position: absolute;\n        font-size: 0.1px;\n        display: block;\n        cursor: se-resize;\n        width: 12px;\n        height: 12px;\n        right: 1px;\n        bottom: 1px;\n    }\n\n    .p-dialog-draggable .p-dialog-header {\n        cursor: move;\n    }\n}\n";
var $a3c56f96c6f20f77$var$inlineStyles = {
    mask: function mask(_ref6) {
        var props = _ref6.props;
        return $a3c56f96c6f20f77$var$_objectSpread$1({
            position: 'fixed',
            height: '100%',
            width: '100%',
            left: 0,
            top: 0,
            display: 'flex',
            justifyContent: props.position === 'left' || props.position === 'top-left' || props.position === 'bottom-left' ? 'flex-start' : props.position === 'right' || props.position === 'top-right' || props.position === 'bottom-right' ? 'flex-end' : 'center',
            alignItems: props.position === 'top' || props.position === 'top-left' || props.position === 'top-right' ? 'flex-start' : props.position === 'bottom' || props.position === 'bottom-left' || props.position === 'bottom-right' ? 'flex-end' : 'center',
            pointerEvents: !props.modal && 'none'
        }, props.maskStyle);
    }
};
var $a3c56f96c6f20f77$var$DialogBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'Dialog',
        __parentMetadata: null,
        appendTo: null,
        ariaCloseIconLabel: null,
        baseZIndex: 0,
        blockScroll: false,
        breakpoints: null,
        className: null,
        closable: true,
        closeIcon: null,
        closeOnEscape: true,
        content: null,
        contentClassName: null,
        contentStyle: null,
        dismissableMask: false,
        draggable: true,
        focusOnShow: true,
        footer: null,
        footerClassName: null,
        header: null,
        headerClassName: null,
        headerStyle: null,
        icons: null,
        id: null,
        keepInViewport: true,
        maskClassName: null,
        maskStyle: null,
        maximizable: false,
        maximizeIcon: null,
        maximized: false,
        minX: 0,
        minY: 0,
        minimizeIcon: null,
        modal: true,
        onClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragStart: null,
        onHide: null,
        onMaskClick: null,
        onMaximize: null,
        onResize: null,
        onResizeEnd: null,
        onResizeStart: null,
        onShow: null,
        position: 'center',
        resizable: true,
        rtl: false,
        showHeader: true,
        style: null,
        transitionOptions: null,
        visible: false,
        children: undefined
    },
    css: {
        classes: $a3c56f96c6f20f77$var$classes,
        styles: $a3c56f96c6f20f77$var$styles,
        inlineStyles: $a3c56f96c6f20f77$var$inlineStyles
    }
});
function $a3c56f96c6f20f77$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a3c56f96c6f20f77$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a3c56f96c6f20f77$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a3c56f96c6f20f77$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a3c56f96c6f20f77$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a3c56f96c6f20f77$export$3ddf2d174ce01153 = /*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $a3c56f96c6f20f77$var$DialogBase.getProps(inProps, context);
    var uniqueId = props.id ? props.id : (0, $a73ce425265b079e$export$d5d9b89141473caf)();
    var _React$useState = $acw62.useState(uniqueId), _React$useState2 = $a3c56f96c6f20f77$var$_slicedToArray(_React$useState, 2), idState = _React$useState2[0];
    _React$useState2[1];
    var _React$useState3 = $acw62.useState(false), _React$useState4 = $a3c56f96c6f20f77$var$_slicedToArray(_React$useState3, 2), maskVisibleState = _React$useState4[0], setMaskVisibleState = _React$useState4[1];
    var _React$useState5 = $acw62.useState(false), _React$useState6 = $a3c56f96c6f20f77$var$_slicedToArray(_React$useState5, 2), visibleState = _React$useState6[0], setVisibleState = _React$useState6[1];
    var _React$useState7 = $acw62.useState(props.maximized), _React$useState8 = $a3c56f96c6f20f77$var$_slicedToArray(_React$useState7, 2), maximizedState = _React$useState8[0], setMaximizedState = _React$useState8[1];
    var dialogRef = $acw62.useRef(null);
    var maskRef = $acw62.useRef(null);
    var pointerRef = $acw62.useRef(null);
    var contentRef = $acw62.useRef(null);
    var headerRef = $acw62.useRef(null);
    var footerRef = $acw62.useRef(null);
    var closeRef = $acw62.useRef(null);
    var dragging = $acw62.useRef(false);
    var resizing = $acw62.useRef(false);
    var lastPageX = $acw62.useRef(null);
    var lastPageY = $acw62.useRef(null);
    var styleElement = $acw62.useRef(null);
    var attributeSelector = $acw62.useRef(uniqueId);
    var focusElementOnHide = $acw62.useRef(null);
    var maximized = props.onMaximize ? props.maximized : maximizedState;
    var shouldBlockScroll = visibleState && (props.blockScroll || props.maximizable && maximized);
    var isCloseOnEscape = props.closable && props.closeOnEscape && visibleState;
    var displayOrder = (0, $fbdf1e36fa0a01d8$export$6353a33119af9098)('dialog', isCloseOnEscape);
    var _DialogBase$setMetaDa = $a3c56f96c6f20f77$var$DialogBase.setMetaData($a3c56f96c6f20f77$var$_objectSpread($a3c56f96c6f20f77$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        state: {
            id: idState,
            maximized: maximized,
            containerVisible: maskVisibleState
        }
    })), ptm = _DialogBase$setMetaDa.ptm, cx = _DialogBase$setMetaDa.cx, sx = _DialogBase$setMetaDa.sx, isUnstyled = _DialogBase$setMetaDa.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($a3c56f96c6f20f77$var$DialogBase.css.styles, isUnstyled, {
        name: 'dialog'
    });
    (0, $fbdf1e36fa0a01d8$export$dee4359f392495ae)({
        callback: function callback(event) {
            onClose(event);
        },
        when: isCloseOnEscape && displayOrder,
        priority: [
            (0, $fbdf1e36fa0a01d8$export$5153c70e1a2d4b71).DIALOG,
            displayOrder
        ]
    });
    var _useEventListener = (0, $fbdf1e36fa0a01d8$export$7080b3e976bc91ab)({
        type: 'mousemove',
        target: function target() {
            return window.document;
        },
        listener: function listener(event) {
            return onResize(event);
        }
    }), _useEventListener2 = $a3c56f96c6f20f77$var$_slicedToArray(_useEventListener, 2), bindDocumentResizeListener = _useEventListener2[0], unbindDocumentResizeListener = _useEventListener2[1];
    var _useEventListener3 = (0, $fbdf1e36fa0a01d8$export$7080b3e976bc91ab)({
        type: 'mouseup',
        target: function target() {
            return window.document;
        },
        listener: function listener(event) {
            return onResizeEnd(event);
        }
    }), _useEventListener4 = $a3c56f96c6f20f77$var$_slicedToArray(_useEventListener3, 2), bindDocumentResizeEndListener = _useEventListener4[0], unbindDocumentResizEndListener = _useEventListener4[1];
    var _useEventListener5 = (0, $fbdf1e36fa0a01d8$export$7080b3e976bc91ab)({
        type: 'mousemove',
        target: function target() {
            return window.document;
        },
        listener: function listener(event) {
            return onDrag(event);
        }
    }), _useEventListener6 = $a3c56f96c6f20f77$var$_slicedToArray(_useEventListener5, 2), bindDocumentDragListener = _useEventListener6[0], unbindDocumentDragListener = _useEventListener6[1];
    var _useEventListener7 = (0, $fbdf1e36fa0a01d8$export$7080b3e976bc91ab)({
        type: 'mouseup',
        target: function target() {
            return window.document;
        },
        listener: function listener(event) {
            return onDragEnd(event);
        }
    }), _useEventListener8 = $a3c56f96c6f20f77$var$_slicedToArray(_useEventListener7, 2), bindDocumentDragEndListener = _useEventListener8[0], unbindDocumentDragEndListener = _useEventListener8[1];
    var onClose = function onClose(event) {
        props.onHide(event);
        event.preventDefault();
    };
    var focus = function focus() {
        var activeElement = document.activeElement;
        var isActiveElementInDialog = activeElement && dialogRef.current && dialogRef.current.contains(activeElement);
        if (!isActiveElementInDialog && props.closable && props.showHeader && closeRef.current) closeRef.current.focus();
    };
    var onDialogPointerDown = function onDialogPointerDown(event) {
        pointerRef.current = event.target;
        props.onPointerDown && props.onPointerDown(event);
    };
    var onMaskPointerUp = function onMaskPointerUp(event) {
        if (props.dismissableMask && props.modal && maskRef.current === event.target && !pointerRef.current) onClose(event);
        props.onMaskClick && props.onMaskClick(event);
        pointerRef.current = null;
    };
    var toggleMaximize = function toggleMaximize(event) {
        if (props.onMaximize) props.onMaximize({
            originalEvent: event,
            maximized: !maximized
        });
        else setMaximizedState(function(prevMaximized) {
            return !prevMaximized;
        });
        event.preventDefault();
    };
    var onDragStart = function onDragStart(event) {
        if ((0, $a73ce425265b079e$export$ff8ccbac9225de62).hasClass(event.target, 'p-dialog-header-icon') || (0, $a73ce425265b079e$export$ff8ccbac9225de62).hasClass(event.target.parentElement, 'p-dialog-header-icon')) return;
        if (props.draggable) {
            dragging.current = true;
            lastPageX.current = event.pageX;
            lastPageY.current = event.pageY;
            dialogRef.current.style.margin = '0';
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(document.body, 'p-unselectable-text');
            props.onDragStart && props.onDragStart(event);
        }
    };
    var onDrag = function onDrag(event) {
        if (dragging.current) {
            var width = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(dialogRef.current);
            var height = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterHeight(dialogRef.current);
            var deltaX = event.pageX - lastPageX.current;
            var deltaY = event.pageY - lastPageY.current;
            var offset = dialogRef.current.getBoundingClientRect();
            var leftPos = offset.left + deltaX;
            var topPos = offset.top + deltaY;
            var viewport = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getViewport();
            var computedStyle = getComputedStyle(dialogRef.current);
            var leftMargin = parseFloat(computedStyle.marginLeft);
            var topMargin = parseFloat(computedStyle.marginTop);
            dialogRef.current.style.position = 'fixed';
            if (props.keepInViewport) {
                if (leftPos >= props.minX && leftPos + width < viewport.width) {
                    lastPageX.current = event.pageX;
                    dialogRef.current.style.left = leftPos - leftMargin + 'px';
                }
                if (topPos >= props.minY && topPos + height < viewport.height) {
                    lastPageY.current = event.pageY;
                    dialogRef.current.style.top = topPos - topMargin + 'px';
                }
            } else {
                lastPageX.current = event.pageX;
                dialogRef.current.style.left = leftPos - leftMargin + 'px';
                lastPageY.current = event.pageY;
                dialogRef.current.style.top = topPos - topMargin + 'px';
            }
            props.onDrag && props.onDrag(event);
        }
    };
    var onDragEnd = function onDragEnd(event) {
        if (dragging.current) {
            dragging.current = false;
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(document.body, 'p-unselectable-text');
            props.onDragEnd && props.onDragEnd(event);
        }
    };
    var onResizeStart = function onResizeStart(event) {
        if (props.resizable) {
            resizing.current = true;
            lastPageX.current = event.pageX;
            lastPageY.current = event.pageY;
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(document.body, 'p-unselectable-text');
            props.onResizeStart && props.onResizeStart(event);
        }
    };
    var convertToPx = function convertToPx(value, property, viewport) {
        !viewport && (viewport = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getViewport());
        var val = parseInt(value);
        if (/^(\d+|(\.\d+))(\.\d+)?%$/.test(value)) return val * (viewport[property] / 100);
        return val;
    };
    var onResize = function onResize(event) {
        if (resizing.current) {
            var deltaX = event.pageX - lastPageX.current;
            var deltaY = event.pageY - lastPageY.current;
            var width = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(dialogRef.current);
            var height = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterHeight(dialogRef.current);
            var offset = dialogRef.current.getBoundingClientRect();
            var viewport = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getViewport();
            var hasBeenDragged = !parseInt(dialogRef.current.style.top) || !parseInt(dialogRef.current.style.left);
            var minWidth = convertToPx(dialogRef.current.style.minWidth, 'width', viewport);
            var minHeight = convertToPx(dialogRef.current.style.minHeight, 'height', viewport);
            var newWidth = width + deltaX;
            var newHeight = height + deltaY;
            if (hasBeenDragged) {
                newWidth = newWidth + deltaX;
                newHeight = newHeight + deltaY;
            }
            if ((!minWidth || newWidth > minWidth) && offset.left + newWidth < viewport.width) dialogRef.current.style.width = newWidth + 'px';
            if ((!minHeight || newHeight > minHeight) && offset.top + newHeight < viewport.height) dialogRef.current.style.height = newHeight + 'px';
            lastPageX.current = event.pageX;
            lastPageY.current = event.pageY;
            props.onResize && props.onResize(event);
        }
    };
    var onResizeEnd = function onResizeEnd(event) {
        if (resizing.current) {
            resizing.current = false;
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(document.body, 'p-unselectable-text');
            props.onResizeEnd && props.onResizeEnd(event);
        }
    };
    var resetPosition = function resetPosition() {
        dialogRef.current.style.position = '';
        dialogRef.current.style.left = '';
        dialogRef.current.style.top = '';
        dialogRef.current.style.margin = '';
    };
    var onEnter = function onEnter() {
        dialogRef.current.setAttribute(attributeSelector.current, '');
    };
    var onEntered = function onEntered() {
        props.onShow && props.onShow();
        if (props.focusOnShow) focus();
        enableDocumentSettings();
    };
    var onExiting = function onExiting() {
        if (props.modal) !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(maskRef.current, 'p-component-overlay-leave');
    };
    var onExited = function onExited() {
        dragging.current = false;
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(maskRef.current);
        setMaskVisibleState(false);
        disableDocumentSettings();
        // return focus to element before dialog was open
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(focusElementOnHide.current);
        focusElementOnHide.current = null;
    };
    var enableDocumentSettings = function enableDocumentSettings() {
        bindGlobalListeners();
    };
    var disableDocumentSettings = function disableDocumentSettings() {
        unbindGlobalListeners();
    };
    var updateScrollBlocker = function updateScrollBlocker() {
        // Scroll should be unblocked if there is at least one dialog that blocks scrolling:
        var isThereAnyDialogThatBlocksScrolling = document.primeDialogParams && document.primeDialogParams.some(function(i) {
            return i.hasBlockScroll;
        });
        if (isThereAnyDialogThatBlocksScrolling) (0, $a73ce425265b079e$export$ff8ccbac9225de62).blockBodyScroll();
        else (0, $a73ce425265b079e$export$ff8ccbac9225de62).unblockBodyScroll();
    };
    var updateGlobalDialogsRegistry = function updateGlobalDialogsRegistry(isMounted) {
        // Update current dialog info in global registry if it is mounted and visible:
        if (isMounted && visibleState) {
            var newParam = {
                id: idState,
                hasBlockScroll: shouldBlockScroll
            };
            // Create registry if not yet created:
            if (!document.primeDialogParams) document.primeDialogParams = [];
            var currentDialogIndexInRegistry = document.primeDialogParams.findIndex(function(dialogInRegistry) {
                return dialogInRegistry.id === idState;
            });
            if (currentDialogIndexInRegistry === -1) document.primeDialogParams = [].concat($a3c56f96c6f20f77$var$_toConsumableArray(document.primeDialogParams), [
                newParam
            ]);
            else document.primeDialogParams = document.primeDialogParams.toSpliced(currentDialogIndexInRegistry, 1, newParam);
        } else document.primeDialogParams = document.primeDialogParams && document.primeDialogParams.filter(function(param) {
            return param.id !== idState;
        });
        // Always update scroll blocker after dialog registry - this way we ensure that
        // p-overflow-hidden class is properly added/removed:
        updateScrollBlocker();
    };
    var bindGlobalListeners = function bindGlobalListeners() {
        if (props.draggable) {
            bindDocumentDragListener();
            bindDocumentDragEndListener();
        }
        if (props.resizable) {
            bindDocumentResizeListener();
            bindDocumentResizeEndListener();
        }
    };
    var unbindGlobalListeners = function unbindGlobalListeners() {
        unbindDocumentDragListener();
        unbindDocumentDragEndListener();
        unbindDocumentResizeListener();
        unbindDocumentResizEndListener();
    };
    var createStyle = function createStyle() {
        styleElement.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).createInlineStyle(context && context.nonce || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).nonce, context && context.styleContainer);
        var innerHTML = '';
        for(var breakpoint in props.breakpoints)innerHTML = innerHTML + "\n                @media screen and (max-width: ".concat(breakpoint, ") {\n                     [data-pc-name=\"dialog\"][").concat(attributeSelector.current, "] {\n                        width: ").concat(props.breakpoints[breakpoint], " !important;\n                    }\n                }\n            ");
        styleElement.current.innerHTML = innerHTML;
    };
    var destroyStyle = function destroyStyle() {
        styleElement.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeInlineStyle(styleElement.current);
    };
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        updateGlobalDialogsRegistry(true);
        if (props.visible) setMaskVisibleState(true);
    });
    $acw62.useEffect(function() {
        if (props.breakpoints) createStyle();
        return function() {
            destroyStyle();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.breakpoints
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (props.visible && !maskVisibleState) setMaskVisibleState(true);
        if (props.visible !== visibleState && maskVisibleState) setVisibleState(props.visible);
        if (props.visible) // Remember the focused element before we opened the dialog
        // so we can return focus to it once we close the dialog.
        focusElementOnHide.current = document.activeElement;
    }, [
        props.visible,
        maskVisibleState
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (maskVisibleState) {
            (0, $a73ce425265b079e$export$832931caede8e4b9).set('modal', maskRef.current, context && context.autoZIndex || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).autoZIndex, props.baseZIndex || context && context.zIndex.modal || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).zIndex.modal);
            setVisibleState(true);
        }
    }, [
        maskVisibleState
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        updateGlobalDialogsRegistry(true);
    }, [
        shouldBlockScroll,
        visibleState
    ]);
    (0, $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96)(function() {
        disableDocumentSettings();
        updateGlobalDialogsRegistry(false);
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeInlineStyle(styleElement.current);
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(maskRef.current);
    });
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            resetPosition: resetPosition,
            getElement: function getElement() {
                return dialogRef.current;
            },
            getMask: function getMask() {
                return maskRef.current;
            },
            getContent: function getContent() {
                return contentRef.current;
            },
            getHeader: function getHeader() {
                return headerRef.current;
            },
            getFooter: function getFooter() {
                return footerRef.current;
            },
            getCloseButton: function getCloseButton() {
                return closeRef.current;
            }
        };
    });
    var createCloseIcon = function createCloseIcon() {
        if (props.closable) {
            var labelAria = props.ariaCloseIconLabel || (0, $51b25b42ecc1a0c7$export$eb839c9fd3d638b9)('close');
            var closeButtonIconProps = mergeProps({
                className: cx('closeButtonIcon'),
                'aria-hidden': true
            }, ptm('closeButtonIcon'));
            var icon = props.closeIcon || /*#__PURE__*/ $acw62.createElement((0, $2a5691e8eb30be5a$export$32edebbf2d9136cc), closeButtonIconProps);
            var headerCloseIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $a3c56f96c6f20f77$var$_objectSpread({}, closeButtonIconProps), {
                props: props
            });
            var closeButtonProps = mergeProps({
                ref: closeRef,
                type: 'button',
                className: cx('closeButton'),
                'aria-label': labelAria,
                onClick: onClose,
                onKeyDown: function onKeyDown(ev) {
                    if (ev.key !== 'Escape') ev.stopPropagation();
                }
            }, ptm('closeButton'));
            return /*#__PURE__*/ $acw62.createElement("button", closeButtonProps, headerCloseIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
        }
        return null;
    };
    var createMaximizeIcon = function createMaximizeIcon() {
        var icon;
        var maximizableIconProps = mergeProps({
            className: cx('maximizableIcon')
        }, ptm('maximizableIcon'));
        if (!maximized) icon = props.maximizeIcon || /*#__PURE__*/ $acw62.createElement((0, $21d354b8e3c7a084$export$e9bf06badb7c79be), maximizableIconProps);
        else icon = props.minimizeIcon || /*#__PURE__*/ $acw62.createElement((0, $eebc8b4342d1eb1f$export$e1e96001ddb7b5e7), maximizableIconProps);
        var toggleIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, maximizableIconProps, {
            props: props
        });
        if (props.maximizable) {
            var maximizableButtonProps = mergeProps({
                type: 'button',
                className: cx('maximizableButton'),
                onClick: toggleMaximize
            }, ptm('maximizableButton'));
            return /*#__PURE__*/ $acw62.createElement("button", maximizableButtonProps, toggleIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
        }
        return null;
    };
    var createHeader = function createHeader() {
        if (props.showHeader) {
            var closeIcon = createCloseIcon();
            var maximizeIcon = createMaximizeIcon();
            var icons = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.icons, props);
            var header = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.header, props);
            var headerId = idState + '_header';
            var headerProps = mergeProps({
                ref: headerRef,
                style: props.headerStyle,
                className: cx('header'),
                onMouseDown: onDragStart
            }, ptm('header'));
            var headerTitleProps = mergeProps({
                id: headerId,
                className: cx('headerTitle')
            }, ptm('headerTitle'));
            var headerIconsProps = mergeProps({
                className: cx('headerIcons')
            }, ptm('headerIcons'));
            return /*#__PURE__*/ $acw62.createElement("div", headerProps, /*#__PURE__*/ $acw62.createElement("div", headerTitleProps, header), /*#__PURE__*/ $acw62.createElement("div", headerIconsProps, icons, maximizeIcon, closeIcon));
        }
        return null;
    };
    var createContent = function createContent() {
        var contentId = idState + '_content';
        var contentProps = mergeProps({
            id: contentId,
            ref: contentRef,
            style: props.contentStyle,
            className: cx('content')
        }, ptm('content'));
        return /*#__PURE__*/ $acw62.createElement("div", contentProps, props.children);
    };
    var createFooter = function createFooter() {
        var footer = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.footer, props);
        var footerProps = mergeProps({
            ref: footerRef,
            className: cx('footer')
        }, ptm('footer'));
        return footer && /*#__PURE__*/ $acw62.createElement("div", footerProps, footer);
    };
    var createResizer = function createResizer() {
        if (props.resizable) return /*#__PURE__*/ $acw62.createElement("span", {
            className: "p-resizable-handle",
            style: {
                zIndex: 90
            },
            onMouseDown: onResizeStart
        });
        return null;
    };
    var createTemplateElement = function createTemplateElement() {
        var _props$children;
        var messageProps = {
            header: props.header,
            content: props.message,
            message: props === null || props === void 0 || (_props$children = props.children) === null || _props$children === void 0 || (_props$children = _props$children[1]) === null || _props$children === void 0 || (_props$children = _props$children.props) === null || _props$children === void 0 ? void 0 : _props$children.children
        };
        var templateElementProps = {
            headerRef: headerRef,
            contentRef: contentRef,
            footerRef: footerRef,
            closeRef: closeRef,
            hide: onClose,
            message: messageProps
        };
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(inProps.content, templateElementProps);
    };
    var createElement = function createElement() {
        var header = createHeader();
        var content = createContent();
        var footer = createFooter();
        var resizer = createResizer();
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, header, content, footer, resizer);
    };
    var createDialog = function createDialog() {
        var headerId = idState + '_header';
        var contentId = idState + '_content';
        var transitionTimeout = {
            enter: props.position === 'center' ? 150 : 300,
            exit: props.position === 'center' ? 150 : 300
        };
        var maskProps = mergeProps({
            ref: maskRef,
            style: sx('mask'),
            className: cx('mask'),
            onPointerUp: onMaskPointerUp
        }, ptm('mask'));
        var rootProps = mergeProps({
            ref: dialogRef,
            id: idState,
            className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root', {
                props: props,
                maximized: maximized,
                context: context
            })),
            style: props.style,
            onClick: props.onClick,
            role: 'dialog',
            'aria-labelledby': headerId,
            'aria-describedby': contentId,
            'aria-modal': props.modal,
            onPointerDown: onDialogPointerDown
        }, $a3c56f96c6f20f77$var$DialogBase.getOtherProps(props), ptm('root'));
        var transitionProps = mergeProps({
            classNames: cx('transition'),
            timeout: transitionTimeout,
            "in": visibleState,
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: onEnter,
            onEntered: onEntered,
            onExiting: onExiting,
            onExited: onExited
        }, ptm('transition'));
        var contentElement = null;
        if (inProps !== null && inProps !== void 0 && inProps.content) contentElement = createTemplateElement();
        else contentElement = createElement();
        var rootElement = /*#__PURE__*/ $acw62.createElement("div", maskProps, /*#__PURE__*/ $acw62.createElement((0, $17afce1b96f6eaec$export$a7a5590ad6d7af0), $a3c56f96c6f20f77$var$_extends({
            nodeRef: dialogRef
        }, transitionProps), /*#__PURE__*/ $acw62.createElement("div", rootProps, /*#__PURE__*/ $acw62.createElement($a3c56f96c6f20f77$var$FocusTrap$1, {
            autoFocus: props.focusOnShow
        }, contentElement))));
        return /*#__PURE__*/ $acw62.createElement((0, $e7a3b5428092a192$export$602eac185826482c), {
            element: rootElement,
            appendTo: props.appendTo,
            visible: true
        });
    };
    return maskVisibleState && createDialog();
});
$a3c56f96c6f20f77$export$3ddf2d174ce01153.displayName = 'Dialog';




'use client';
var $8f8d568a0a544f71$export$dbec172f58a34ef1 = (0, $a73ce425265b079e$export$5087227eb54526)();




'use client';
function $5c19b288344d356a$var$_extends() {
    return $5c19b288344d356a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5c19b288344d356a$var$_extends.apply(null, arguments);
}
function $5c19b288344d356a$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $5c19b288344d356a$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $5c19b288344d356a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $5c19b288344d356a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5c19b288344d356a$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5c19b288344d356a$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5c19b288344d356a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5c19b288344d356a$var$_slicedToArray(r, e) {
    return $5c19b288344d356a$var$_arrayWithHoles(r) || $5c19b288344d356a$var$_iterableToArrayLimit(r, e) || $5c19b288344d356a$var$_unsupportedIterableToArray(r, e) || $5c19b288344d356a$var$_nonIterableRest();
}
function $5c19b288344d356a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5c19b288344d356a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5c19b288344d356a$var$_typeof(o);
}
function $5c19b288344d356a$var$toPrimitive(t, r) {
    if ("object" != $5c19b288344d356a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5c19b288344d356a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $5c19b288344d356a$var$toPropertyKey(t) {
    var i = $5c19b288344d356a$var$toPrimitive(t, "string");
    return "symbol" == $5c19b288344d356a$var$_typeof(i) ? i : i + "";
}
function $5c19b288344d356a$var$_defineProperty(e, r, t) {
    return (r = $5c19b288344d356a$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $5c19b288344d356a$var$classes = {
    root: 'p-confirm-dialog',
    message: 'p-confirm-dialog-message',
    icon: 'p-confirm-dialog-icon',
    acceptButton: 'p-confirm-dialog-accept',
    rejectButton: function rejectButton(_ref) {
        var getPropValue = _ref.getPropValue;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-confirm-dialog-reject', {
            'p-button-text': !getPropValue('rejectClassName')
        });
    }
};
var $5c19b288344d356a$var$ConfirmDialogBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'ConfirmDialog',
        accept: null,
        acceptClassName: null,
        acceptIcon: null,
        acceptLabel: null,
        appendTo: null,
        breakpoints: null,
        children: undefined,
        className: null,
        content: null,
        defaultFocus: 'accept',
        footer: null,
        icon: null,
        message: null,
        onHide: null,
        reject: null,
        rejectClassName: null,
        rejectIcon: null,
        rejectLabel: null,
        tagKey: undefined,
        visible: undefined
    },
    css: {
        classes: $5c19b288344d356a$var$classes
    }
});
function $5c19b288344d356a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5c19b288344d356a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5c19b288344d356a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5c19b288344d356a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5c19b288344d356a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5c19b288344d356a$export$8f50df58f957fd19 = function confirmDialog() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    props = $5c19b288344d356a$var$_objectSpread($5c19b288344d356a$var$_objectSpread({}, props), {
        visible: props.visible === undefined ? true : props.visible
    });
    props.visible && (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).emit('confirm-dialog', props);
    var show = function show() {
        var updatedProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).emit('confirm-dialog', $5c19b288344d356a$var$_objectSpread($5c19b288344d356a$var$_objectSpread($5c19b288344d356a$var$_objectSpread({}, props), updatedProps), {
            visible: true
        }));
    };
    var hide = function hide() {
        (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).emit('confirm-dialog', {
            visible: false
        });
    };
    return {
        show: show,
        hide: hide
    };
};
var $5c19b288344d356a$export$2cc85109a937009e = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $5c19b288344d356a$var$ConfirmDialogBase.getProps(inProps, context);
    var _React$useState = $acw62.useState(props.visible), _React$useState2 = $5c19b288344d356a$var$_slicedToArray(_React$useState, 2), visibleState = _React$useState2[0], setVisibleState = _React$useState2[1];
    var _React$useState3 = $acw62.useState(false), _React$useState4 = $5c19b288344d356a$var$_slicedToArray(_React$useState3, 2), reshowState = _React$useState4[0], setReshowState = _React$useState4[1];
    var confirmProps = $acw62.useRef(null);
    var isCallbackExecuting = $acw62.useRef(false);
    var focusElementOnHide = $acw62.useRef(null);
    var getCurrentProps = function getCurrentProps() {
        var group = props.group;
        if (confirmProps.current) group = confirmProps.current.group;
        return Object.assign({}, props, confirmProps.current, {
            group: group
        });
    };
    var getPropValue = function getPropValue(key) {
        return getCurrentProps()[key];
    };
    var callbackFromProp = function callbackFromProp(key) {
        for(var _len = arguments.length, param = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)param[_key - 1] = arguments[_key];
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getPropValue(getPropValue(key), param);
    };
    var acceptLabel = getPropValue('acceptLabel') || (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('accept');
    var rejectLabel = getPropValue('rejectLabel') || (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('reject');
    var metaData = {
        props: props,
        state: {
            visible: visibleState
        }
    };
    var _ConfirmDialogBase$se = $5c19b288344d356a$var$ConfirmDialogBase.setMetaData(metaData), ptm = _ConfirmDialogBase$se.ptm, cx = _ConfirmDialogBase$se.cx, isUnstyled = _ConfirmDialogBase$se.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($5c19b288344d356a$var$ConfirmDialogBase.css.styles, isUnstyled, {
        name: 'confirmdialog'
    });
    var accept = function accept() {
        if (!isCallbackExecuting.current) {
            isCallbackExecuting.current = true;
            callbackFromProp('accept');
            hide('accept');
        }
    };
    var reject = function reject() {
        if (!isCallbackExecuting.current) {
            isCallbackExecuting.current = true;
            callbackFromProp('reject');
            hide('reject');
        }
    };
    var show = function show() {
        var currentProps = getCurrentProps();
        if (currentProps.group === props.group) {
            setVisibleState(true);
            isCallbackExecuting.current = false;
            // Remember the focused element before we opened the dialog
            // so we can return focus to it once we close the dialog.
            focusElementOnHide.current = document.activeElement;
        }
    };
    var hide = function hide() {
        var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cancel';
        setVisibleState(false);
        callbackFromProp('onHide', {
            result: result
        });
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(focusElementOnHide.current);
        focusElementOnHide.current = null;
    };
    var confirm = function confirm(updatedProps) {
        if (updatedProps.tagKey === props.tagKey) {
            var isVisibleChanged = visibleState !== updatedProps.visible;
            var targetChanged = getPropValue('target') !== updatedProps.target;
            if (targetChanged && !props.target) {
                hide();
                confirmProps.current = updatedProps;
                setReshowState(true);
            } else if (isVisibleChanged) {
                confirmProps.current = updatedProps;
                updatedProps.visible ? show() : hide();
            }
        }
    };
    $acw62.useEffect(function() {
        props.visible ? show() : hide();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.visible
    ]);
    $acw62.useEffect(function() {
        if (!props.target && !props.message) (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).on('confirm-dialog', confirm);
        return function() {
            (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).off('confirm-dialog', confirm);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.target
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        reshowState && show();
    }, [
        reshowState
    ]);
    (0, $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96)(function() {
        (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).off('confirm-dialog', confirm);
    });
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            confirm: confirm
        };
    });
    var createFooter = function createFooter() {
        var defaultFocus = getPropValue('defaultFocus');
        var acceptClassName = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-confirm-dialog-accept', getPropValue('acceptClassName'));
        var rejectClassName = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-confirm-dialog-reject', {
            'p-button-text': !getPropValue('rejectClassName')
        }, getPropValue('rejectClassName'));
        var rejectButtonProps = mergeProps({
            label: rejectLabel,
            autoFocus: defaultFocus === 'reject',
            icon: getPropValue('rejectIcon'),
            className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(getPropValue('rejectClassName'), cx('rejectButton', {
                getPropValue: getPropValue
            })),
            onClick: reject,
            pt: ptm('rejectButton'),
            unstyled: props.unstyled,
            __parentMetadata: {
                parent: metaData
            }
        }, ptm('rejectButton'));
        var acceptButtonProps = mergeProps({
            label: acceptLabel,
            autoFocus: defaultFocus === undefined || defaultFocus === 'accept',
            icon: getPropValue('acceptIcon'),
            className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(getPropValue('acceptClassName'), cx('acceptButton')),
            onClick: accept,
            pt: ptm('acceptButton'),
            unstyled: props.unstyled,
            __parentMetadata: {
                parent: metaData
            }
        }, ptm('acceptButton'));
        var content = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), rejectButtonProps), /*#__PURE__*/ $acw62.createElement((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), acceptButtonProps));
        if (getPropValue('footer')) {
            var defaultContentOptions = {
                accept: accept,
                reject: reject,
                acceptClassName: acceptClassName,
                rejectClassName: rejectClassName,
                acceptLabel: acceptLabel,
                rejectLabel: rejectLabel,
                element: content,
                props: getCurrentProps()
            };
            return (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(getPropValue('footer'), defaultContentOptions);
        }
        return content;
    };
    var createElement = function createElement() {
        var currentProps = getCurrentProps();
        var message = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(getPropValue('message'), currentProps);
        var iconProps = mergeProps({
            className: cx('icon')
        }, ptm('icon'));
        var icon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(getPropValue('icon'), $5c19b288344d356a$var$_objectSpread({}, iconProps), {
            props: currentProps
        });
        var footer = createFooter();
        var messageProps = mergeProps({
            className: cx('message')
        }, ptm('message'));
        var rootProps = mergeProps({
            visible: visibleState,
            className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(getPropValue('className'), cx('root')),
            footer: footer,
            onHide: hide,
            breakpoints: getPropValue('breakpoints'),
            pt: currentProps.pt,
            unstyled: props.unstyled,
            appendTo: getPropValue('appendTo'),
            __parentMetadata: {
                parent: metaData
            }
        }, $5c19b288344d356a$var$ConfirmDialogBase.getOtherProps(currentProps));
        return /*#__PURE__*/ $acw62.createElement((0, $a3c56f96c6f20f77$export$3ddf2d174ce01153), $5c19b288344d356a$var$_extends({}, rootProps, {
            content: inProps === null || inProps === void 0 ? void 0 : inProps.content
        }), icon, /*#__PURE__*/ $acw62.createElement("span", messageProps, message));
    };
    var element = createElement();
    return /*#__PURE__*/ $acw62.createElement((0, $e7a3b5428092a192$export$602eac185826482c), {
        element: element,
        appendTo: getPropValue('appendTo')
    });
}));
$5c19b288344d356a$export$2cc85109a937009e.displayName = 'ConfirmDialog';



var $acw62 = parcelRequire("acw62");
const $bdccf6b6a87b04cc$export$a2200b96afd16271 = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $bdccf6b6a87b04cc$export$bf688221f59024e5({ children: children }) {
    const toast = (0, $acw62.useRef)(null);
    function handleOverlays(overlayType, overlayData) {
        switch(overlayType){
            case 'confirmDialog':
                (0, $5c19b288344d356a$export$8f50df58f957fd19)(overlayData);
                break;
            case 'toast':
                toast.current.show(overlayData);
                break;
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($bdccf6b6a87b04cc$export$a2200b96afd16271.Provider, {
        value: handleOverlays,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe304f6df74368ab$export$8d8dc7d5f743331b), {
                ref: toast,
                position: "top-left"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c19b288344d356a$export$2cc85109a937009e), {}),
            children
        ]
    });
}



var $acw62 = parcelRequire("acw62");




'use client';
var $3ec34a5c615255cb$var$classes = {
    root: 'p-progress-spinner',
    spinner: 'p-progress-spinner-svg',
    circle: 'p-progress-spinner-circle'
};
var $3ec34a5c615255cb$var$styles = "\n@layer primereact {\n    .p-progress-spinner {\n        position: relative;\n        margin: 0 auto;\n        width: 100px;\n        height: 100px;\n        display: inline-block;\n    }\n    \n    .p-progress-spinner::before {\n        content: '';\n        display: block;\n        padding-top: 100%;\n    }\n    \n    .p-progress-spinner-svg {\n        animation: p-progress-spinner-rotate 2s linear infinite;\n        height: 100%;\n        transform-origin: center center;\n        width: 100%;\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        margin: auto;\n    }\n    \n    .p-progress-spinner-circle {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: 0;\n        stroke: #d62d20;\n        animation: p-progress-spinner-dash 1.5s ease-in-out infinite, p-progress-spinner-color 6s ease-in-out infinite;\n        stroke-linecap: round;\n    }\n}\n\n@keyframes p-progress-spinner-rotate {\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes p-progress-spinner-dash {\n    0% {\n        stroke-dasharray: 1, 200;\n        stroke-dashoffset: 0;\n    }\n    50% {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: -35px;\n    }\n    100% {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: -124px;\n    }\n}\n\n@keyframes p-progress-spinner-color {\n    100%,\n    0% {\n        stroke: #d62d20;\n    }\n    40% {\n        stroke: #0057e7;\n    }\n    66% {\n        stroke: #008744;\n    }\n    80%,\n    90% {\n        stroke: #ffa700;\n    }\n}\n";
var $3ec34a5c615255cb$var$inlineStyles = {
    spinner: function spinner(_ref) {
        var props = _ref.props;
        return {
            animationDuration: props.animationDuration
        };
    }
};
var $3ec34a5c615255cb$var$ProgressSpinnerBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'ProgressSpinner',
        id: null,
        style: null,
        className: null,
        strokeWidth: '2',
        fill: 'none',
        animationDuration: '2s',
        children: undefined
    },
    css: {
        classes: $3ec34a5c615255cb$var$classes,
        styles: $3ec34a5c615255cb$var$styles,
        inlineStyles: $3ec34a5c615255cb$var$inlineStyles
    }
});
var $3ec34a5c615255cb$export$dcc7532e7120780d = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $3ec34a5c615255cb$var$ProgressSpinnerBase.getProps(inProps, context);
    var elementRef = $acw62.useRef(null);
    var _ProgressSpinnerBase$ = $3ec34a5c615255cb$var$ProgressSpinnerBase.setMetaData({
        props: props
    }), ptm = _ProgressSpinnerBase$.ptm, cx = _ProgressSpinnerBase$.cx, sx = _ProgressSpinnerBase$.sx, isUnstyled = _ProgressSpinnerBase$.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($3ec34a5c615255cb$var$ProgressSpinnerBase.css.styles, isUnstyled, {
        name: 'progressspinner'
    });
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var rootProps = mergeProps({
        id: props.id,
        ref: elementRef,
        style: props.style,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root')),
        role: 'progressbar',
        'aria-busy': true
    }, $3ec34a5c615255cb$var$ProgressSpinnerBase.getOtherProps(props), ptm('root'));
    var spinnerProps = mergeProps({
        className: cx('spinner'),
        viewBox: '25 25 50 50',
        style: sx('spinner')
    }, ptm('spinner'));
    var circleProps = mergeProps({
        className: cx('circle'),
        cx: '50',
        cy: '50',
        r: '20',
        fill: props.fill,
        strokeWidth: props.strokeWidth,
        strokeMiterlimit: '10'
    }, ptm('circle'));
    return /*#__PURE__*/ $acw62.createElement("div", rootProps, /*#__PURE__*/ $acw62.createElement("svg", spinnerProps, /*#__PURE__*/ $acw62.createElement("circle", circleProps)));
}));
$3ec34a5c615255cb$export$dcc7532e7120780d.displayName = 'ProgressSpinner';




function $5a79a81cc3b591c5$export$5d8a4b9af9ca5f5b({ platformCode: platformCode }) {
    const style = {
        padding: '.2rem',
        whiteSpace: 'nowrap',
        borderStyle: 'dotted',
        borderWidth: '1px',
        cursor: 'default',
        display: 'inline-block'
    };
    if (platformCode) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
        className: "text-xs text-300 ml-1",
        style: style,
        title: 'Stanowisko: ' + platformCode,
        children: platformCode
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
}




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

'use client';
function $d65f00df46eebcf8$var$_extends() {
    return $d65f00df46eebcf8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d65f00df46eebcf8$var$_extends.apply(null, arguments);
}
var $d65f00df46eebcf8$export$e45f9104ca1b1c90 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $d65f00df46eebcf8$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M3.58659 4.5007C3.68513 4.50023 3.78277 4.51945 3.87379 4.55723C3.9648 4.59501 4.04735 4.65058 4.11659 4.7207L7.11659 7.7207L10.1166 4.7207C10.2619 4.65055 10.4259 4.62911 10.5843 4.65956C10.7427 4.69002 10.8871 4.77074 10.996 4.88976C11.1049 5.00877 11.1726 5.15973 11.1889 5.32022C11.2052 5.48072 11.1693 5.6422 11.0866 5.7807L7.58659 9.2807C7.44597 9.42115 7.25534 9.50004 7.05659 9.50004C6.85784 9.50004 6.66722 9.42115 6.52659 9.2807L3.02659 5.7807C2.88614 5.64007 2.80725 5.44945 2.80725 5.2507C2.80725 5.05195 2.88614 4.86132 3.02659 4.7207C3.09932 4.64685 3.18675 4.58911 3.28322 4.55121C3.37969 4.51331 3.48305 4.4961 3.58659 4.5007Z",
        fill: "currentColor"
    }));
}));
$d65f00df46eebcf8$export$e45f9104ca1b1c90.displayName = 'AngleDownIcon';



var $acw62 = parcelRequire("acw62");

'use client';
function $05b405a2d2e65fb2$var$_extends() {
    return $05b405a2d2e65fb2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $05b405a2d2e65fb2$var$_extends.apply(null, arguments);
}
var $05b405a2d2e65fb2$export$60014705184d48db = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $05b405a2d2e65fb2$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M10.4134 9.49931C10.3148 9.49977 10.2172 9.48055 10.1262 9.44278C10.0352 9.405 9.95263 9.34942 9.88338 9.27931L6.88338 6.27931L3.88338 9.27931C3.73811 9.34946 3.57409 9.3709 3.41567 9.34044C3.25724 9.30999 3.11286 9.22926 3.00395 9.11025C2.89504 8.99124 2.82741 8.84028 2.8111 8.67978C2.79478 8.51928 2.83065 8.35781 2.91338 8.21931L6.41338 4.71931C6.55401 4.57886 6.74463 4.49997 6.94338 4.49997C7.14213 4.49997 7.33276 4.57886 7.47338 4.71931L10.9734 8.21931C11.1138 8.35994 11.1927 8.55056 11.1927 8.74931C11.1927 8.94806 11.1138 9.13868 10.9734 9.27931C10.9007 9.35315 10.8132 9.41089 10.7168 9.44879C10.6203 9.48669 10.5169 9.5039 10.4134 9.49931Z",
        fill: "currentColor"
    }));
}));
$05b405a2d2e65fb2$export$60014705184d48db.displayName = 'AngleUpIcon';



var $acw62 = parcelRequire("acw62");




'use client';
function $079ca477f881ab90$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $079ca477f881ab90$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $079ca477f881ab90$var$_arrayLikeToArray(r);
}
function $079ca477f881ab90$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $079ca477f881ab90$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $079ca477f881ab90$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $079ca477f881ab90$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $079ca477f881ab90$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $079ca477f881ab90$var$_toConsumableArray(r) {
    return $079ca477f881ab90$var$_arrayWithoutHoles(r) || $079ca477f881ab90$var$_iterableToArray(r) || $079ca477f881ab90$var$_unsupportedIterableToArray(r) || $079ca477f881ab90$var$_nonIterableSpread();
}
var $079ca477f881ab90$export$9dbdc44a13de1b0d = {
    /* eslint-disable */ DEFAULT_MASKS: {
        pint: /[\d]/,
        "int": /[\d\-]/,
        pnum: /[\d\.]/,
        money: /[\d\.\s,]/,
        num: /[\d\-\.]/,
        hex: /[0-9a-f]/i,
        email: /[a-z0-9_\.\-@]/i,
        alpha: /[a-z_]/i,
        alphanum: /[a-z0-9_]/i
    },
    /* eslint-enable */ getRegex: function getRegex(keyfilter) {
        return $079ca477f881ab90$export$9dbdc44a13de1b0d.DEFAULT_MASKS[keyfilter] ? $079ca477f881ab90$export$9dbdc44a13de1b0d.DEFAULT_MASKS[keyfilter] : keyfilter;
    },
    onBeforeInput: function onBeforeInput(e, keyfilter, validateOnly) {
        // android devices must use beforeinput https://stackoverflow.com/questions/36753548/keycode-on-android-is-always-229
        if (validateOnly || !(0, $a73ce425265b079e$export$ff8ccbac9225de62).isAndroid()) return;
        this.validateKey(e, e.data, keyfilter);
    },
    onKeyPress: function onKeyPress(e, keyfilter, validateOnly) {
        // non android devices use keydown
        if (validateOnly || (0, $a73ce425265b079e$export$ff8ccbac9225de62).isAndroid()) return;
        if (e.ctrlKey || e.altKey || e.metaKey) return;
        this.validateKey(e, e.key, keyfilter);
    },
    onPaste: function onPaste(e, keyfilter, validateOnly) {
        if (validateOnly) return;
        var regex = this.getRegex(keyfilter);
        var clipboard = e.clipboardData.getData('text');
        // loop over each letter pasted and if any fail prevent the paste
        $079ca477f881ab90$var$_toConsumableArray(clipboard).forEach(function(c) {
            if (!regex.test(c)) {
                e.preventDefault();
                return false;
            }
        });
    },
    validateKey: function validateKey(e, key, keyfilter) {
        if (key === null || key === undefined) return;
        // some AZERTY keys come in with 2 chars like ´ç if Dead key is pressed first
        var isPrintableKey = key.length <= 2;
        if (!isPrintableKey) return;
        var regex = this.getRegex(keyfilter);
        if (!regex.test(key)) e.preventDefault();
    },
    validate: function validate(e, keyfilter) {
        var value = e.target.value;
        var validatePattern = true;
        var regex = this.getRegex(keyfilter);
        if (value && !regex.test(value)) validatePattern = false;
        return validatePattern;
    }
};




'use client';
function $ab1a721814a59df6$var$_extends() {
    return $ab1a721814a59df6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ab1a721814a59df6$var$_extends.apply(null, arguments);
}
function $ab1a721814a59df6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ab1a721814a59df6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ab1a721814a59df6$var$_typeof(o);
}
function $ab1a721814a59df6$var$toPrimitive(t, r) {
    if ("object" != $ab1a721814a59df6$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ab1a721814a59df6$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ab1a721814a59df6$var$toPropertyKey(t) {
    var i = $ab1a721814a59df6$var$toPrimitive(t, "string");
    return "symbol" == $ab1a721814a59df6$var$_typeof(i) ? i : i + "";
}
function $ab1a721814a59df6$var$_defineProperty(e, r, t) {
    return (r = $ab1a721814a59df6$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $ab1a721814a59df6$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, isFilled = _ref.isFilled, context = _ref.context;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-inputtext p-component', {
            'p-disabled': props.disabled,
            'p-filled': isFilled,
            'p-invalid': props.invalid,
            'p-variant-filled': props.variant ? props.variant === 'filled' : context && context.inputStyle === 'filled'
        });
    }
};
var $ab1a721814a59df6$var$InputTextBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'InputText',
        __parentMetadata: null,
        children: undefined,
        className: null,
        invalid: false,
        variant: null,
        keyfilter: null,
        onBeforeInput: null,
        onInput: null,
        onKeyDown: null,
        onPaste: null,
        tooltip: null,
        tooltipOptions: null,
        validateOnly: false,
        iconPosition: null
    },
    css: {
        classes: $ab1a721814a59df6$var$classes
    }
});
function $ab1a721814a59df6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ab1a721814a59df6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ab1a721814a59df6$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ab1a721814a59df6$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ab1a721814a59df6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ab1a721814a59df6$export$7034fcb7d6351061 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $ab1a721814a59df6$var$InputTextBase.getProps(inProps, context);
    var _InputTextBase$setMet = $ab1a721814a59df6$var$InputTextBase.setMetaData($ab1a721814a59df6$var$_objectSpread($ab1a721814a59df6$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        context: {
            disabled: props.disabled,
            iconPosition: props.iconPosition
        }
    })), ptm = _InputTextBase$setMet.ptm, cx = _InputTextBase$setMet.cx, isUnstyled = _InputTextBase$setMet.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($ab1a721814a59df6$var$InputTextBase.css.styles, isUnstyled, {
        name: 'inputtext',
        styled: true
    });
    var elementRef = $acw62.useRef(ref);
    var onKeyDown = function onKeyDown(event) {
        props.onKeyDown && props.onKeyDown(event);
        if (props.keyfilter) (0, $079ca477f881ab90$export$9dbdc44a13de1b0d).onKeyPress(event, props.keyfilter, props.validateOnly);
    };
    var onBeforeInput = function onBeforeInput(event) {
        props.onBeforeInput && props.onBeforeInput(event);
        if (props.keyfilter) (0, $079ca477f881ab90$export$9dbdc44a13de1b0d).onBeforeInput(event, props.keyfilter, props.validateOnly);
    };
    var onInput = function onInput(event) {
        var target = event.target;
        var validatePattern = true;
        if (props.keyfilter && props.validateOnly) validatePattern = (0, $079ca477f881ab90$export$9dbdc44a13de1b0d).validate(event, props.keyfilter);
        props.onInput && props.onInput(event, validatePattern);
        // for uncontrolled changes
        (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(target.value) ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(target, 'p-filled') : (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(target, 'p-filled');
    };
    var onPaste = function onPaste(event) {
        props.onPaste && props.onPaste(event);
        if (props.keyfilter) (0, $079ca477f881ab90$export$9dbdc44a13de1b0d).onPaste(event, props.keyfilter, props.validateOnly);
    };
    $acw62.useEffect(function() {
        (0, $a73ce425265b079e$export$4855211e6b8ad895).combinedRefs(elementRef, ref);
    }, [
        elementRef,
        ref
    ]);
    var isFilled = $acw62.useMemo(function() {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.value) || (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.defaultValue);
    }, [
        props.value,
        props.defaultValue
    ]);
    var hasTooltip = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.tooltip);
    $acw62.useEffect(function() {
        if (isFilled) (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(elementRef.current, 'p-filled');
        else (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(elementRef.current, 'p-filled');
    }, [
        props.disabled,
        isFilled
    ]);
    var rootProps = mergeProps({
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root', {
            context: context,
            isFilled: isFilled
        })),
        onBeforeInput: onBeforeInput,
        onInput: onInput,
        onKeyDown: onKeyDown,
        onPaste: onPaste
    }, $ab1a721814a59df6$var$InputTextBase.getOtherProps(props), ptm('root'));
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("input", $ab1a721814a59df6$var$_extends({
        ref: elementRef
    }, rootProps)), hasTooltip && /*#__PURE__*/ $acw62.createElement((0, $b74dfa9f7ee9d9bc$export$28c660c63b792dea), $ab1a721814a59df6$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm('tooltip')
    }, props.tooltipOptions)));
}));
$ab1a721814a59df6$export$7034fcb7d6351061.displayName = 'InputText';





'use client';
function $df4bf6c8c7efd937$var$_extends() {
    return $df4bf6c8c7efd937$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $df4bf6c8c7efd937$var$_extends.apply(null, arguments);
}
function $df4bf6c8c7efd937$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $df4bf6c8c7efd937$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $df4bf6c8c7efd937$var$_arrayLikeToArray(r);
}
function $df4bf6c8c7efd937$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $df4bf6c8c7efd937$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $df4bf6c8c7efd937$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $df4bf6c8c7efd937$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $df4bf6c8c7efd937$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $df4bf6c8c7efd937$var$_toConsumableArray(r) {
    return $df4bf6c8c7efd937$var$_arrayWithoutHoles(r) || $df4bf6c8c7efd937$var$_iterableToArray(r) || $df4bf6c8c7efd937$var$_unsupportedIterableToArray(r) || $df4bf6c8c7efd937$var$_nonIterableSpread();
}
function $df4bf6c8c7efd937$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $df4bf6c8c7efd937$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $df4bf6c8c7efd937$var$_typeof(o);
}
function $df4bf6c8c7efd937$var$toPrimitive(t, r) {
    if ("object" != $df4bf6c8c7efd937$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $df4bf6c8c7efd937$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $df4bf6c8c7efd937$var$toPropertyKey(t) {
    var i = $df4bf6c8c7efd937$var$toPrimitive(t, "string");
    return "symbol" == $df4bf6c8c7efd937$var$_typeof(i) ? i : i + "";
}
function $df4bf6c8c7efd937$var$_defineProperty(e, r, t) {
    return (r = $df4bf6c8c7efd937$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $df4bf6c8c7efd937$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $df4bf6c8c7efd937$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $df4bf6c8c7efd937$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $df4bf6c8c7efd937$var$_slicedToArray(r, e) {
    return $df4bf6c8c7efd937$var$_arrayWithHoles(r) || $df4bf6c8c7efd937$var$_iterableToArrayLimit(r, e) || $df4bf6c8c7efd937$var$_unsupportedIterableToArray(r, e) || $df4bf6c8c7efd937$var$_nonIterableRest();
}
var $df4bf6c8c7efd937$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, focusedState = _ref.focusedState, stacked = _ref.stacked, horizontal = _ref.horizontal, vertical = _ref.vertical;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-inputnumber p-component p-inputwrapper', {
            'p-inputwrapper-filled': props.value != null && props.value.toString().length > 0,
            'p-inputwrapper-focus': focusedState,
            'p-inputnumber-buttons-stacked': stacked,
            'p-inputnumber-buttons-horizontal': horizontal,
            'p-inputnumber-buttons-vertical': vertical,
            'p-invalid': props.invalid
        });
    },
    input: function input(_ref2) {
        var props = _ref2.props, context = _ref2.context;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-inputnumber-input', {
            'p-variant-filled': props.variant ? props.variant === 'filled' : context && context.inputStyle === 'filled'
        });
    },
    buttonGroup: 'p-inputnumber-button-group',
    incrementButton: function incrementButton(_ref3) {
        var props = _ref3.props;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-inputnumber-button p-inputnumber-button-up p-button p-button-icon-only p-component', {
            'p-disabled': props.disabled
        });
    },
    incrementIcon: 'p-button-icon',
    decrementButton: function decrementButton(_ref4) {
        var props = _ref4.props;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-inputnumber-button p-inputnumber-button-down p-button p-button-icon-only p-component', {
            'p-disabled': props.disabled
        });
    },
    decrementIcon: 'p-button-icon'
};
var $df4bf6c8c7efd937$var$styles = "\n@layer primereact {\n    .p-inputnumber {\n        display: inline-flex;\n    }\n    \n    .p-inputnumber-button {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex: 0 0 auto;\n    }\n    \n    .p-inputnumber-buttons-stacked .p-button.p-inputnumber-button .p-button-label,\n    .p-inputnumber-buttons-horizontal .p-button.p-inputnumber-button .p-button-label {\n        display: none;\n    }\n    \n    .p-inputnumber-buttons-stacked .p-button.p-inputnumber-button-up {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n        padding: 0;\n    }\n    \n    .p-inputnumber-buttons-stacked .p-inputnumber-input {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n    }\n    \n    .p-inputnumber-buttons-stacked .p-button.p-inputnumber-button-down {\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;\n        border-bottom-left-radius: 0;\n        padding: 0;\n    }\n    \n    .p-inputnumber-buttons-stacked .p-inputnumber-button-group {\n        display: flex;\n        flex-direction: column;\n    }\n    \n    .p-inputnumber-buttons-stacked .p-inputnumber-button-group .p-button.p-inputnumber-button {\n        flex: 1 1 auto;\n    }\n    \n    .p-inputnumber-buttons-horizontal .p-button.p-inputnumber-button-up {\n        order: 3;\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n    \n    .p-inputnumber-buttons-horizontal .p-inputnumber-input {\n        order: 2;\n        border-radius: 0;\n    }\n    \n    .p-inputnumber-buttons-horizontal .p-button.p-inputnumber-button-down {\n        order: 1;\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n    }\n    \n    .p-inputnumber-buttons-vertical {\n        flex-direction: column;\n    }\n    \n    .p-inputnumber-buttons-vertical .p-button.p-inputnumber-button-up {\n        order: 1;\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n        width: 100%;\n    }\n    \n    .p-inputnumber-buttons-vertical .p-inputnumber-input {\n        order: 2;\n        border-radius: 0;\n        text-align: center;\n    }\n    \n    .p-inputnumber-buttons-vertical .p-button.p-inputnumber-button-down {\n        order: 3;\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;\n        width: 100%;\n    }\n    \n    .p-inputnumber-input {\n        flex: 1 1 auto;\n    }\n    \n    .p-fluid .p-inputnumber {\n        width: 100%;\n    }\n    \n    .p-fluid .p-inputnumber .p-inputnumber-input {\n        width: 1%;\n    }\n    \n    .p-fluid .p-inputnumber-buttons-vertical .p-inputnumber-input {\n        width: 100%;\n    }\n}\n";
var $df4bf6c8c7efd937$var$InputNumberBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'InputNumber',
        __parentMetadata: null,
        allowEmpty: true,
        ariaLabelledBy: null,
        autoFocus: false,
        buttonLayout: 'stacked',
        className: null,
        currency: undefined,
        currencyDisplay: undefined,
        decrementButtonClassName: null,
        decrementButtonIcon: null,
        disabled: false,
        format: true,
        id: null,
        incrementButtonClassName: null,
        incrementButtonIcon: null,
        inputClassName: null,
        inputId: null,
        inputMode: null,
        inputRef: null,
        inputStyle: null,
        invalid: false,
        variant: null,
        locale: undefined,
        localeMatcher: undefined,
        max: null,
        maxFractionDigits: undefined,
        maxLength: null,
        min: null,
        minFractionDigits: undefined,
        mode: 'decimal',
        name: null,
        onBlur: null,
        onChange: null,
        onFocus: null,
        onKeyDown: null,
        onKeyUp: null,
        onValueChange: null,
        pattern: null,
        placeholder: null,
        prefix: null,
        readOnly: false,
        required: false,
        roundingMode: undefined,
        showButtons: false,
        size: null,
        step: 1,
        style: null,
        suffix: null,
        tabIndex: null,
        tooltip: null,
        tooltipOptions: null,
        type: 'text',
        useGrouping: true,
        value: null,
        children: undefined
    },
    css: {
        classes: $df4bf6c8c7efd937$var$classes,
        styles: $df4bf6c8c7efd937$var$styles
    }
});
function $df4bf6c8c7efd937$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $df4bf6c8c7efd937$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $df4bf6c8c7efd937$var$ownKeys(Object(t), !0).forEach(function(r) {
            $df4bf6c8c7efd937$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $df4bf6c8c7efd937$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $df4bf6c8c7efd937$export$cf9581d419a141cf = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $df4bf6c8c7efd937$var$InputNumberBase.getProps(inProps, context);
    var _React$useState = $acw62.useState(false), _React$useState2 = $df4bf6c8c7efd937$var$_slicedToArray(_React$useState, 2), focusedState = _React$useState2[0], setFocusedState = _React$useState2[1];
    var metaData = $df4bf6c8c7efd937$var$_objectSpread($df4bf6c8c7efd937$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        state: {
            focused: focusedState
        }
    });
    var _InputNumberBase$setM = $df4bf6c8c7efd937$var$InputNumberBase.setMetaData(metaData), ptm = _InputNumberBase$setM.ptm, cx = _InputNumberBase$setM.cx, isUnstyled = _InputNumberBase$setM.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($df4bf6c8c7efd937$var$InputNumberBase.css.styles, isUnstyled, {
        name: 'inputnumber'
    });
    var elementRef = $acw62.useRef(null);
    var inputRef = $acw62.useRef(null);
    var timer = $acw62.useRef(null);
    var lastValue = $acw62.useRef(null);
    var numberFormat = $acw62.useRef(null);
    var groupChar = $acw62.useRef(null);
    var prefixChar = $acw62.useRef(null);
    var suffixChar = $acw62.useRef(null);
    var isSpecialChar = $acw62.useRef(null);
    var _numeral = $acw62.useRef(null);
    var _group = $acw62.useRef(null);
    var _minusSign = $acw62.useRef(null);
    var _currency = $acw62.useRef(null);
    var _decimal = $acw62.useRef(null);
    var _decimalSeparator = $acw62.useRef(null);
    var _suffix = $acw62.useRef(null);
    var _prefix = $acw62.useRef(null);
    var _index = $acw62.useRef(null);
    var isFocusedByClick = $acw62.useRef(false);
    var _locale = props.locale || context && context.locale || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).locale;
    var stacked = props.showButtons && props.buttonLayout === 'stacked';
    var horizontal = props.showButtons && props.buttonLayout === 'horizontal';
    var vertical = props.showButtons && props.buttonLayout === 'vertical';
    var inputMode = props.inputMode || (props.mode === 'decimal' && !props.minFractionDigits ? 'numeric' : 'decimal');
    var getOptions = function getOptions() {
        var _props$minFractionDig, _props$maxFractionDig;
        return {
            localeMatcher: props.localeMatcher,
            style: props.mode,
            currency: props.currency,
            currencyDisplay: props.currencyDisplay,
            useGrouping: props.useGrouping,
            minimumFractionDigits: (_props$minFractionDig = props.minFractionDigits) !== null && _props$minFractionDig !== void 0 ? _props$minFractionDig : undefined,
            maximumFractionDigits: (_props$maxFractionDig = props.maxFractionDigits) !== null && _props$maxFractionDig !== void 0 ? _props$maxFractionDig : undefined,
            roundingMode: props.roundingMode
        };
    };
    var constructParser = function constructParser() {
        numberFormat.current = new Intl.NumberFormat(_locale, getOptions());
        var numerals = $df4bf6c8c7efd937$var$_toConsumableArray(new Intl.NumberFormat(_locale, {
            useGrouping: false
        }).format(9876543210)).reverse();
        var index = new Map(numerals.map(function(d, i) {
            return [
                d,
                i
            ];
        }));
        _numeral.current = new RegExp("[".concat(numerals.join(''), "]"), 'g');
        _group.current = getGroupingExpression(); // regular expression /[,]/g, /[.]/g
        _minusSign.current = getMinusSignExpression(); // regular expression /[-]/g
        _currency.current = getCurrencyExpression(); // regular expression for currency (e.g. /[$]/g, /[€]/g, /[]/g and more)
        _decimal.current = getDecimalExpression(); // regular expression /[,]/g, /[.]/g, /[]/g
        _decimalSeparator.current = getDecimalSeparator(); // current decimal separator  '.', ','
        _suffix.current = getSuffixExpression(); // regular expression for suffix (e.g. /℃/g)
        _prefix.current = getPrefixExpression(); // regular expression for prefix (e.g. /\ days/g)
        _index.current = function(d) {
            return index.get(d);
        };
    };
    var escapeRegExp = function escapeRegExp(text) {
        return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    };
    /**
   * get decimal separator in current locale
   */ var getDecimalSeparator = function getDecimalSeparator() {
        return new Intl.NumberFormat(_locale, {
            useGrouping: false
        }).format(1.1).trim().replace(_numeral.current, '');
    };
    var getDecimalExpression = function getDecimalExpression() {
        var formatter = new Intl.NumberFormat(_locale, $df4bf6c8c7efd937$var$_objectSpread($df4bf6c8c7efd937$var$_objectSpread({}, getOptions()), {}, {
            useGrouping: false
        }));
        return new RegExp("[".concat(formatter.format(1.1).replace(_currency.current, '').trim().replace(_numeral.current, ''), "]"), 'g');
    };
    var getGroupingExpression = function getGroupingExpression() {
        var formatter = new Intl.NumberFormat(_locale, {
            useGrouping: true
        });
        groupChar.current = formatter.format(1000000).trim().replace(_numeral.current, '').charAt(0);
        return new RegExp("[".concat(groupChar.current, "]"), 'g');
    };
    var getMinusSignExpression = function getMinusSignExpression() {
        var formatter = new Intl.NumberFormat(_locale, {
            useGrouping: false
        });
        return new RegExp("[".concat(formatter.format(-1).trim().replace(_numeral.current, ''), "]"), 'g');
    };
    var getCurrencyExpression = function getCurrencyExpression() {
        if (props.currency) {
            var formatter = new Intl.NumberFormat(_locale, {
                style: 'currency',
                currency: props.currency,
                currencyDisplay: props.currencyDisplay,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
                roundingMode: props.roundingMode
            });
            return new RegExp("[".concat(formatter.format(1).replace(/\s/g, '').replace(_numeral.current, '').replace(_group.current, ''), "]"), 'g');
        }
        return new RegExp('[]', 'g');
    };
    var getPrefixExpression = function getPrefixExpression() {
        if (props.prefix) prefixChar.current = props.prefix;
        else {
            var formatter = new Intl.NumberFormat(_locale, {
                style: props.mode,
                currency: props.currency,
                currencyDisplay: props.currencyDisplay
            });
            prefixChar.current = formatter.format(1).split('1')[0];
        }
        return new RegExp("".concat(escapeRegExp(prefixChar.current || '')), 'g');
    };
    var getSuffixExpression = function getSuffixExpression() {
        if (props.suffix) suffixChar.current = props.suffix;
        else {
            var formatter = new Intl.NumberFormat(_locale, {
                style: props.mode,
                currency: props.currency,
                currencyDisplay: props.currencyDisplay,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
                roundingMode: props.roundingMode
            });
            suffixChar.current = formatter.format(1).split('1')[1];
        }
        return new RegExp("".concat(escapeRegExp(suffixChar.current || '')), 'g');
    };
    var formatValue = function formatValue(value) {
        if (value != null) {
            if (value === '-') // Minus sign
            return value;
            if (props.format) {
                var formatter = new Intl.NumberFormat(_locale, getOptions());
                var _formattedValue = formatter.format(value);
                if (props.prefix) _formattedValue = props.prefix + _formattedValue;
                if (props.suffix) _formattedValue = _formattedValue + props.suffix;
                return _formattedValue;
            }
            return value.toString();
        }
        return '';
    };
    var parseValue = function parseValue(text) {
        var filteredText = text.replace(_suffix.current, '').replace(_prefix.current, '').trim().replace(/\s/g, '').replace(_currency.current, '').replace(_group.current, '').replace(_minusSign.current, '-').replace(_decimal.current, '.').replace(_numeral.current, _index.current);
        if (filteredText) {
            if (filteredText === '-') // Minus sign
            return filteredText;
            var parsedValue = +filteredText;
            return isNaN(parsedValue) ? null : parsedValue;
        }
        return null;
    };
    var _repeat = function repeat(event, interval, dir) {
        var i = interval || 500;
        clearTimer();
        timer.current = setTimeout(function() {
            _repeat(event, 40, dir);
        }, i);
        spin(event, dir);
    };
    var spin = function spin(event, dir) {
        if (inputRef.current) {
            var step = props.step * dir;
            var currentValue = parseValue(inputRef.current.value) || 0;
            var newValue = validateValue(currentValue + step);
            if (props.maxLength && props.maxLength < formatValue(newValue).length) return;
            // #3913 onChange should be called before onValueChange
            handleOnChange(event, currentValue, newValue);
            // touch devices trigger the keyboard to display because of setSelectionRange
            !(0, $a73ce425265b079e$export$ff8ccbac9225de62).isTouchDevice() && updateInput(newValue, null, 'spin');
            updateModel(event, newValue);
        }
    };
    var onUpButtonMouseDown = function onUpButtonMouseDown(event) {
        if (!props.disabled && !props.readOnly) {
            if (!(0, $a73ce425265b079e$export$ff8ccbac9225de62).isTouchDevice()) (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current, props.autoFocus);
            _repeat(event, null, 1);
            event.preventDefault();
        }
    };
    var onUpButtonMouseUp = function onUpButtonMouseUp() {
        if (!props.disabled && !props.readOnly) clearTimer();
    };
    var onUpButtonMouseLeave = function onUpButtonMouseLeave() {
        if (!props.disabled && !props.readOnly) clearTimer();
    };
    var onUpButtonKeyUp = function onUpButtonKeyUp() {
        if (!props.disabled && !props.readOnly) clearTimer();
    };
    var onUpButtonKeyDown = function onUpButtonKeyDown(event) {
        if (!props.disabled && !props.readOnly && (event.keyCode === 32 || event.keyCode === 13)) _repeat(event, null, 1);
    };
    var onDownButtonMouseDown = function onDownButtonMouseDown(event) {
        if (!props.disabled && !props.readOnly) {
            if (!(0, $a73ce425265b079e$export$ff8ccbac9225de62).isTouchDevice()) (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current, props.autoFocus);
            _repeat(event, null, -1);
            event.preventDefault();
        }
    };
    var onDownButtonMouseUp = function onDownButtonMouseUp() {
        if (!props.disabled && !props.readOnly) clearTimer();
    };
    var onDownButtonMouseLeave = function onDownButtonMouseLeave() {
        if (!props.disabled && !props.readOnly) clearTimer();
    };
    var onDownButtonKeyUp = function onDownButtonKeyUp() {
        if (!props.disabled && !props.readOnly) clearTimer();
    };
    var onDownButtonKeyDown = function onDownButtonKeyDown(event) {
        if (!props.disabled && !props.readOnly && (event.keyCode === 32 || event.keyCode === 13)) _repeat(event, null, -1);
    };
    var onInput = function onInput(event) {
        if (props.disabled || props.readOnly) return;
        if (isSpecialChar.current) {
            event.target.value = lastValue.current;
            isSpecialChar.current = false;
        }
        if ((0, $a73ce425265b079e$export$ff8ccbac9225de62).isAndroid()) return;
        // #6324 Chrome is allowing accent-dead characters through...
        var inputType = event.nativeEvent.inputType;
        var data = event.nativeEvent.data;
        if (inputType === 'insertText' && /\D/.test(data)) event.target.value = lastValue.current;
    };
    var onInputAndroidKey = function onInputAndroidKey(event) {
        if (!(0, $a73ce425265b079e$export$ff8ccbac9225de62).isAndroid() || props.disabled || props.readOnly) return;
        if (props.onKeyUp) {
            props.onKeyUp(event);
            // do not continue if the user defined event wants to prevent
            if (event.defaultPrevented) return;
        }
        var code = event.which || event.keyCode;
        if (code !== 13) // to submit a form
        event.preventDefault();
        var _char = String.fromCharCode(code);
        var _isDecimalSign = isDecimalSign(_char);
        var _isMinusSign = isMinusSign(_char);
        if (48 <= code && code <= 57 || _isMinusSign || _isDecimalSign) insert(event, _char, {
            isDecimalSign: _isDecimalSign,
            isMinusSign: _isMinusSign
        });
        else updateValue(event, event.target.value, null, 'delete-single');
    };
    var onInputKeyDown = function onInputKeyDown(event) {
        if (props.disabled || props.readOnly) return;
        if (event.altKey || event.ctrlKey || event.metaKey) {
            // #7039 Treat cut as normal character
            if (event.key.toLowerCase() === 'x' && (event.ctrlKey || event.metaKey)) isSpecialChar.current = false;
            else isSpecialChar.current = true;
            return;
        }
        if (props.onKeyDown) {
            props.onKeyDown(event);
            // Do not continue if the user-defined event wants to prevent
            if (event.defaultPrevented) return;
        }
        lastValue.current = event.target.value;
        // Android is handled specially in onInputAndroidKey
        if ((0, $a73ce425265b079e$export$ff8ccbac9225de62).isAndroid()) return;
        var selectionStart = event.target.selectionStart;
        var selectionEnd = event.target.selectionEnd;
        var inputValue = event.target.value;
        var newValueStr = null;
        switch(event.code){
            //up
            case 'ArrowUp':
                spin(event, 1);
                event.preventDefault();
                break;
            //down
            case 'ArrowDown':
                spin(event, -1);
                event.preventDefault();
                break;
            //left
            case 'ArrowLeft':
                if (!isNumeralChar(inputValue.charAt(selectionStart - 1))) event.preventDefault();
                break;
            //right
            case 'ArrowRight':
                if (!isNumeralChar(inputValue.charAt(selectionStart))) event.preventDefault();
                break;
            //enter and tab
            case 'Tab':
            case 'Enter':
            case 'NumpadEnter':
                newValueStr = validateValue(parseValue(inputValue));
                inputRef.current.value = formatValue(newValueStr);
                inputRef.current.setAttribute('aria-valuenow', newValueStr);
                updateModel(event, newValueStr);
                break;
            //backspace
            case 'Backspace':
                event.preventDefault();
                if (selectionStart === selectionEnd) {
                    var deleteChar = inputValue.charAt(selectionStart - 1);
                    if (isNumeralChar(deleteChar)) {
                        var _getDecimalCharIndexe = getDecimalCharIndexes(inputValue), decimalCharIndex = _getDecimalCharIndexe.decimalCharIndex, decimalCharIndexWithoutPrefix = _getDecimalCharIndexe.decimalCharIndexWithoutPrefix;
                        var decimalLength = getDecimalLength(inputValue);
                        if (_group.current.test(deleteChar)) {
                            _group.current.lastIndex = 0;
                            newValueStr = inputValue.slice(0, selectionStart - 2) + inputValue.slice(selectionStart - 1);
                        } else if (_decimal.current.test(deleteChar)) {
                            _decimal.current.lastIndex = 0;
                            if (decimalLength) inputRef.current.setSelectionRange(selectionStart - 1, selectionStart - 1);
                            else newValueStr = inputValue.slice(0, selectionStart - 1) + inputValue.slice(selectionStart);
                        } else if (decimalCharIndex > 0 && selectionStart > decimalCharIndex) {
                            var insertedText = isDecimalMode() && (props.minFractionDigits || 0) < decimalLength ? '' : '0';
                            newValueStr = inputValue.slice(0, selectionStart - 1) + insertedText + inputValue.slice(selectionStart);
                        } else if (decimalCharIndexWithoutPrefix === 1) {
                            newValueStr = inputValue.slice(0, selectionStart - 1) + '0' + inputValue.slice(selectionStart);
                            newValueStr = parseValue(newValueStr) > 0 ? newValueStr : '';
                        } else newValueStr = inputValue.slice(0, selectionStart - 1) + inputValue.slice(selectionStart);
                    } else if (_currency.current.test(deleteChar)) {
                        var _getCharIndexes = getCharIndexes(inputValue), minusCharIndex = _getCharIndexes.minusCharIndex, currencyCharIndex = _getCharIndexes.currencyCharIndex;
                        if (minusCharIndex === currencyCharIndex - 1) newValueStr = inputValue.slice(0, minusCharIndex) + inputValue.slice(selectionStart);
                    }
                    updateValue(event, newValueStr, null, 'delete-single');
                } else {
                    newValueStr = deleteRange(inputValue, selectionStart, selectionEnd);
                    updateValue(event, newValueStr, null, 'delete-range');
                }
                break;
            // del
            case 'Delete':
                event.preventDefault();
                if (selectionStart === selectionEnd) {
                    var _deleteChar = inputValue.charAt(selectionStart);
                    var _getDecimalCharIndexe2 = getDecimalCharIndexes(inputValue), _decimalCharIndex = _getDecimalCharIndexe2.decimalCharIndex, _decimalCharIndexWithoutPrefix = _getDecimalCharIndexe2.decimalCharIndexWithoutPrefix;
                    if (isNumeralChar(_deleteChar)) {
                        var _decimalLength = getDecimalLength(inputValue);
                        if (_group.current.test(_deleteChar)) {
                            _group.current.lastIndex = 0;
                            newValueStr = inputValue.slice(0, selectionStart) + inputValue.slice(selectionStart + 2);
                        } else if (_decimal.current.test(_deleteChar)) {
                            _decimal.current.lastIndex = 0;
                            if (_decimalLength) inputRef.current.setSelectionRange(selectionStart + 1, selectionStart + 1);
                            else newValueStr = inputValue.slice(0, selectionStart) + inputValue.slice(selectionStart + 1);
                        } else if (_decimalCharIndex > 0 && selectionStart > _decimalCharIndex) {
                            var _insertedText = isDecimalMode() && (props.minFractionDigits || 0) < _decimalLength ? '' : '0';
                            newValueStr = inputValue.slice(0, selectionStart) + _insertedText + inputValue.slice(selectionStart + 1);
                        } else if (_decimalCharIndexWithoutPrefix === 1) {
                            newValueStr = inputValue.slice(0, selectionStart) + '0' + inputValue.slice(selectionStart + 1);
                            newValueStr = parseValue(newValueStr) > 0 ? newValueStr : '';
                        } else newValueStr = inputValue.slice(0, selectionStart) + inputValue.slice(selectionStart + 1);
                    }
                    updateValue(event, newValueStr, null, 'delete-back-single');
                } else {
                    newValueStr = deleteRange(inputValue, selectionStart, selectionEnd);
                    updateValue(event, newValueStr, null, 'delete-range');
                }
                break;
            case 'End':
                event.preventDefault();
                if (!(0, $a73ce425265b079e$export$4855211e6b8ad895).isEmpty(props.max)) updateModel(event, props.max);
                break;
            case 'Home':
                event.preventDefault();
                if (!(0, $a73ce425265b079e$export$4855211e6b8ad895).isEmpty(props.min)) updateModel(event, props.min);
                break;
            default:
                event.preventDefault();
                var _char2 = event.key;
                if (_char2) {
                    var _isDecimalSign = isDecimalSign(_char2);
                    var _isMinusSign = isMinusSign(_char2);
                    if (Number(_char2) >= 0 && Number(_char2) <= 9 || _isMinusSign || _isDecimalSign) insert(event, _char2, {
                        isDecimalSign: _isDecimalSign,
                        isMinusSign: _isMinusSign
                    });
                }
                break;
        }
    };
    var onPaste = function onPaste(event) {
        event.preventDefault();
        if (props.disabled || props.readOnly) return;
        var data = (event.clipboardData || window.clipboardData).getData('Text');
        if (data) {
            var filteredData = parseValue(data);
            if (filteredData != null) insert(event, filteredData.toString());
        }
    };
    var allowMinusSign = function allowMinusSign() {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).isEmpty(props.min) || props.min < 0;
    };
    var isMinusSign = function isMinusSign(_char3) {
        if (_minusSign.current.test(_char3) || _char3 === '-') {
            _minusSign.current.lastIndex = 0;
            return true;
        }
        return false;
    };
    var replaceDecimalSeparator = function replaceDecimalSeparator(val) {
        if (isFloat(val)) return val.toString().replace(/\.(?=[^.]*$)/, _decimalSeparator.current);
        return val;
    };
    var isDecimalSign = function isDecimalSign(_char4) {
        if (_decimal.current.test(_char4) || isFloat(_char4)) {
            _decimal.current.lastIndex = 0;
            return true;
        }
        return false;
    };
    var isDecimalMode = function isDecimalMode() {
        return props.mode === 'decimal';
    };
    var isFloat = function isFloat(val) {
        var formatter = new Intl.NumberFormat(_locale, getOptions());
        var parseVal = parseValue(formatter.format(val));
        if (parseVal === null) return false;
        return parseVal % 1 !== 0;
    };
    var getDecimalCharIndexes = function getDecimalCharIndexes(val) {
        var decimalCharIndex = val.search(_decimal.current);
        _decimal.current.lastIndex = 0;
        var filteredVal = val.replace(_prefix.current, '').trim().replace(/\s/g, '').replace(_currency.current, '');
        var decimalCharIndexWithoutPrefix = filteredVal.search(_decimal.current);
        _decimal.current.lastIndex = 0;
        return {
            decimalCharIndex: decimalCharIndex,
            decimalCharIndexWithoutPrefix: decimalCharIndexWithoutPrefix
        };
    };
    var getCharIndexes = function getCharIndexes(val) {
        var decimalCharIndex = val.search(_decimal.current);
        _decimal.current.lastIndex = 0;
        var minusCharIndex = val.search(_minusSign.current);
        _minusSign.current.lastIndex = 0;
        var suffixCharIndex = val.search(_suffix.current);
        _suffix.current.lastIndex = 0;
        var currencyCharIndex = val.search(_currency.current);
        if (currencyCharIndex === 0 && prefixChar.current && prefixChar.current.length > 1) currencyCharIndex = prefixChar.current.trim().length;
        _currency.current.lastIndex = 0;
        return {
            decimalCharIndex: decimalCharIndex,
            minusCharIndex: minusCharIndex,
            suffixCharIndex: suffixCharIndex,
            currencyCharIndex: currencyCharIndex
        };
    };
    var insert = function insert(event, text) {
        var sign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            isDecimalSign: false,
            isMinusSign: false
        };
        var minusCharIndexOnText = text.search(_minusSign.current);
        _minusSign.current.lastIndex = 0;
        if (!allowMinusSign() && minusCharIndexOnText !== -1) return;
        var selectionStart = inputRef.current.selectionStart;
        var selectionEnd = inputRef.current.selectionEnd;
        var inputValue = inputRef.current.value.trim();
        var _getCharIndexes2 = getCharIndexes(inputValue), decimalCharIndex = _getCharIndexes2.decimalCharIndex, minusCharIndex = _getCharIndexes2.minusCharIndex, suffixCharIndex = _getCharIndexes2.suffixCharIndex, currencyCharIndex = _getCharIndexes2.currencyCharIndex;
        var maxFractionDigits = numberFormat.current.resolvedOptions().maximumFractionDigits;
        var newValueStr;
        if (sign.isMinusSign) {
            var isNewMinusSign = minusCharIndex === -1;
            // #6522 - Selected negative value can't be overwritten with a minus ('-') symbol
            if (selectionStart === 0 || selectionStart === currencyCharIndex + 1) {
                newValueStr = inputValue;
                if (isNewMinusSign || selectionEnd !== 0) newValueStr = insertText(inputValue, text, 0, selectionEnd);
                updateValue(event, newValueStr, text, 'insert');
            }
        } else if (sign.isDecimalSign) {
            if (decimalCharIndex > 0 && selectionStart === decimalCharIndex) updateValue(event, inputValue, text, 'insert');
            else if (decimalCharIndex > selectionStart && decimalCharIndex < selectionEnd) {
                newValueStr = insertText(inputValue, text, selectionStart, selectionEnd);
                updateValue(event, newValueStr, text, 'insert');
            } else if (decimalCharIndex === -1 && (maxFractionDigits || props.maxFractionDigits)) {
                newValueStr = insertText(inputValue, text, selectionStart, selectionEnd);
                updateValue(event, newValueStr, text, 'insert');
            }
        } else {
            var operation = selectionStart !== selectionEnd ? 'range-insert' : 'insert';
            if (decimalCharIndex > 0 && selectionStart > decimalCharIndex) {
                if (selectionStart + text.length - (decimalCharIndex + 1) <= maxFractionDigits) {
                    var charIndex = currencyCharIndex >= selectionStart ? currencyCharIndex - 1 : suffixCharIndex >= selectionStart ? suffixCharIndex : inputValue.length;
                    newValueStr = inputValue.slice(0, selectionStart) + text + inputValue.slice(selectionStart + text.length, charIndex) + inputValue.slice(charIndex);
                    updateValue(event, newValueStr, text, operation);
                }
            } else {
                newValueStr = insertText(inputValue, text, selectionStart, selectionEnd);
                updateValue(event, newValueStr, text, operation);
            }
        }
    };
    var replaceSuffix = function replaceSuffix(value) {
        return value ? value.replace(_suffix.current, '').trim().replace(/\s/g, '').replace(_currency.current, '') : value;
    };
    var insertText = function insertText(value, text, start, end) {
        var textSplit = isDecimalSign(text) ? text : text.split(_decimal.current);
        if (textSplit.length === 2) {
            var decimalCharIndex = value.slice(start, end).search(_decimal.current);
            _decimal.current.lastIndex = 0;
            return decimalCharIndex > 0 ? value.slice(0, start) + formatValue(text) + replaceSuffix(value).slice(end) : value || formatValue(text);
        } else if (isDecimalSign(text) && value.length === 0) return formatValue('0.');
        else if (end - start === value.length) return formatValue(text);
        else if (start === 0) {
            var suffix = (0, $a73ce425265b079e$export$4855211e6b8ad895).isLetter(value[end]) ? end - 1 : end;
            return text + value.slice(suffix);
        } else if (end === value.length) return value.slice(0, start) + text;
        var selectionValue = value.slice(start, end);
        // Fix: if the suffix starts with a space, the input will be cleared after pasting
        var space = /\s$/.test(selectionValue) ? ' ' : '';
        return value.slice(0, start) + text + space + value.slice(end);
    };
    var deleteRange = function deleteRange(value, start, end) {
        var newValueStr;
        if (end - start === value.length) newValueStr = '';
        else if (start === 0) newValueStr = value.slice(end);
        else if (end === value.length) newValueStr = value.slice(0, start);
        else newValueStr = value.slice(0, start) + value.slice(end);
        return newValueStr;
    };
    var initCursor = function initCursor() {
        var selectionStart = inputRef.current.selectionStart;
        var inputValue = inputRef.current.value;
        var valueLength = inputValue.length;
        var index = null;
        // remove prefix
        var prefixLength = (prefixChar.current || '').length;
        inputValue = inputValue.replace(_prefix.current, '');
        selectionStart = selectionStart - prefixLength;
        var _char5 = inputValue.charAt(selectionStart);
        if (isNumeralChar(_char5)) return selectionStart + prefixLength;
        //left
        var i = selectionStart - 1;
        while(i >= 0){
            _char5 = inputValue.charAt(i);
            if (isNumeralChar(_char5)) {
                index = i + prefixLength;
                break;
            } else i--;
        }
        if (index !== null) inputRef.current.setSelectionRange(index + 1, index + 1);
        else {
            i = selectionStart;
            while(i < valueLength){
                _char5 = inputValue.charAt(i);
                if (isNumeralChar(_char5)) {
                    index = i + prefixLength;
                    break;
                } else i++;
            }
            if (index !== null) inputRef.current.setSelectionRange(index, index);
        }
        return index || 0;
    };
    var onInputPointerDown = function onInputPointerDown() {
        isFocusedByClick.current = true;
    };
    var onInputClick = function onInputClick() {
        initCursor();
    };
    var isNumeralChar = function isNumeralChar(_char6) {
        if (_char6.length === 1 && (_numeral.current.test(_char6) || _decimal.current.test(_char6) || _group.current.test(_char6) || _minusSign.current.test(_char6))) {
            resetRegex();
            return true;
        }
        return false;
    };
    var resetRegex = function resetRegex() {
        _numeral.current.lastIndex = 0;
        _decimal.current.lastIndex = 0;
        _group.current.lastIndex = 0;
        _minusSign.current.lastIndex = 0;
    };
    var updateValue = function updateValue(event, valueStr, insertedValueStr, operation) {
        var currentValue = inputRef.current.value;
        var newValue = null;
        if (valueStr != null) {
            newValue = evaluateEmpty(parseValue(valueStr));
            updateInput(newValue, insertedValueStr, operation, valueStr);
            handleOnChange(event, currentValue, newValue);
        }
    };
    var evaluateEmpty = function evaluateEmpty(newValue) {
        return !newValue && !props.allowEmpty ? props.min || 0 : newValue;
    };
    var handleOnChange = function handleOnChange(event, currentValue, newValue) {
        if (props.onChange && isValueChanged(currentValue, newValue)) props.onChange({
            originalEvent: event,
            value: newValue
        });
    };
    var isValueChanged = function isValueChanged(currentValue, newValue) {
        if (newValue === null && currentValue !== null) return true;
        if (newValue != null) {
            var parsedCurrentValue = typeof currentValue === 'string' ? parseValue(currentValue) : currentValue;
            return newValue !== parsedCurrentValue;
        }
        return false;
    };
    var validateValue = function validateValue(value) {
        if (value === '-') return null;
        return validateValueByLimit(value);
    };
    var validateValueByLimit = function validateValueByLimit(value) {
        if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isEmpty(value)) return null;
        if (props.min !== null && value < props.min) return props.min;
        if (props.max !== null && value > props.max) return props.max;
        return value;
    };
    var updateInput = function updateInput(value, insertedValueStr, operation, valueStr) {
        insertedValueStr = insertedValueStr || '';
        var inputEl = inputRef.current;
        var inputValue = inputEl.value;
        var newValue = formatValue(value);
        var currentLength = inputValue.length;
        if (newValue !== valueStr) newValue = concatValues(newValue, valueStr);
        if (currentLength === 0) {
            inputEl.value = newValue;
            inputEl.setSelectionRange(0, 0);
            var index = initCursor();
            var selectionEnd = index + insertedValueStr.length + (isDecimalSign(insertedValueStr) ? 1 : 0);
            inputEl.setSelectionRange(selectionEnd, selectionEnd);
        } else {
            var selectionStart = inputEl.selectionStart;
            var _selectionEnd = inputEl.selectionEnd;
            if (props.maxLength && props.maxLength < newValue.length) return;
            inputEl.value = newValue;
            var newLength = newValue.length;
            if (operation === 'range-insert') {
                var startValue = parseValue((inputValue || '').slice(0, selectionStart));
                var startValueStr = startValue !== null ? startValue.toString() : '';
                var startExpr = startValueStr.split('').join("(".concat(groupChar.current, ")?"));
                var sRegex = new RegExp(startExpr, 'g');
                sRegex.test(newValue);
                var tExpr = insertedValueStr.split('').join("(".concat(groupChar.current, ")?"));
                var tRegex = new RegExp(tExpr, 'g');
                tRegex.test(newValue.slice(sRegex.lastIndex));
                _selectionEnd = sRegex.lastIndex + tRegex.lastIndex;
                inputEl.setSelectionRange(_selectionEnd, _selectionEnd);
            } else if (newLength === currentLength) {
                if (operation === 'insert' || operation === 'delete-back-single') {
                    var newSelectionEnd = _selectionEnd;
                    if (insertedValueStr === '0') newSelectionEnd = _selectionEnd + 1;
                    else newSelectionEnd = newSelectionEnd + Number(isDecimalSign(value) || isDecimalSign(insertedValueStr));
                    inputEl.setSelectionRange(newSelectionEnd, newSelectionEnd);
                } else if (operation === 'delete-single') inputEl.setSelectionRange(_selectionEnd - 1, _selectionEnd - 1);
                else if (operation === 'delete-range' || operation === 'spin') inputEl.setSelectionRange(_selectionEnd, _selectionEnd);
            } else if (operation === 'delete-back-single') {
                var prevChar = inputValue.charAt(_selectionEnd - 1);
                var nextChar = inputValue.charAt(_selectionEnd);
                var diff = currentLength - newLength;
                var isGroupChar = _group.current.test(nextChar);
                if (isGroupChar && diff === 1) _selectionEnd = _selectionEnd + 1;
                else if (!isGroupChar && isNumeralChar(prevChar)) _selectionEnd = _selectionEnd + (-1 * diff + 1);
                _group.current.lastIndex = 0;
                inputEl.setSelectionRange(_selectionEnd, _selectionEnd);
            } else if (inputValue === '-' && operation === 'insert') {
                inputEl.setSelectionRange(0, 0);
                var _index2 = initCursor();
                var _selectionEnd2 = _index2 + insertedValueStr.length + 1;
                inputEl.setSelectionRange(_selectionEnd2, _selectionEnd2);
            } else {
                _selectionEnd = _selectionEnd + (newLength - currentLength);
                inputEl.setSelectionRange(_selectionEnd, _selectionEnd);
            }
        }
        inputEl.setAttribute('aria-valuenow', value);
    };
    var updateInputValue = function updateInputValue(newValue) {
        newValue = evaluateEmpty(newValue);
        var inputEl = inputRef.current;
        var value = inputEl.value;
        var _formattedValue = formattedValue(newValue);
        if (value !== _formattedValue) {
            inputEl.value = _formattedValue;
            inputEl.setAttribute('aria-valuenow', newValue);
        }
    };
    var formattedValue = function formattedValue(val) {
        return formatValue(evaluateEmpty(val));
    };
    var concatValues = function concatValues(val1, val2) {
        if (val1 && val2) {
            var decimalCharIndex = val2.search(_decimal.current);
            _decimal.current.lastIndex = 0;
            var newVal1 = replaceDecimalSeparator(val1).split(_decimal.current)[0].replace(_suffix.current, '').trim();
            return decimalCharIndex !== -1 ? newVal1 + val2.slice(decimalCharIndex) : val1;
        }
        return val1;
    };
    var getDecimalLength = function getDecimalLength(value) {
        if (value) {
            var valueSplit = value.split(_decimal.current);
            if (valueSplit.length === 2) return replaceSuffix(valueSplit[1]).length;
        }
        return 0;
    };
    var updateModel = function updateModel(event, value) {
        if (props.onValueChange) props.onValueChange({
            originalEvent: event,
            value: value,
            stopPropagation: function stopPropagation() {
                event === null || event === void 0 || event.stopPropagation();
            },
            preventDefault: function preventDefault() {
                event === null || event === void 0 || event.preventDefault();
            },
            target: {
                name: props.name,
                id: props.id,
                value: value
            }
        });
    };
    var onInputFocus = function onInputFocus(event) {
        setFocusedState(true);
        props.onFocus && props.onFocus(event);
        if ((props.suffix || props.currency || props.prefix) && inputRef.current && !isFocusedByClick.current) {
            // GitHub #1866,#5537
            var inputValue = inputRef.current.value;
            var prefixLength = (prefixChar.current || '').length;
            var suffixLength = (suffixChar.current || '').length;
            var end = inputValue.length === 0 ? 0 : inputValue.length - suffixLength;
            inputRef.current.setSelectionRange(prefixLength, end);
        }
    };
    var onInputBlur = function onInputBlur(event) {
        setFocusedState(false);
        isFocusedByClick.current = false;
        if (inputRef.current) {
            var currentValue = inputRef.current.value;
            if (isValueChanged(currentValue, props.value)) {
                var newValue = validateValue(parseValue(currentValue));
                updateInputValue(newValue);
                updateModel(event, newValue);
            }
        }
        props.onBlur && props.onBlur(event);
    };
    var clearTimer = function clearTimer() {
        if (timer.current) clearInterval(timer.current);
    };
    var changeValue = function changeValue() {
        var val = validateValueByLimit(props.value);
        updateInputValue(props.format ? val : replaceDecimalSeparator(val));
        var newValue = validateValue(props.value);
        if (props.value !== null && props.value !== newValue) updateModel(null, newValue);
    };
    var getFormatter = function getFormatter() {
        return numberFormat.current;
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            focus: function focus() {
                return (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current);
            },
            getFormatter: getFormatter,
            getElement: function getElement() {
                return elementRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            }
        };
    });
    $acw62.useEffect(function() {
        (0, $a73ce425265b079e$export$4855211e6b8ad895).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    (0, $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96)(function() {
        clearTimer();
    });
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        constructParser();
        var newValue = validateValue(props.value);
        if (props.value !== null && props.value !== newValue) updateModel(null, newValue);
    });
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        constructParser();
        changeValue();
    }, [
        _locale,
        props.locale,
        props.localeMatcher,
        props.mode,
        props.currency,
        props.currencyDisplay,
        props.useGrouping,
        props.minFractionDigits,
        props.maxFractionDigits,
        props.suffix,
        props.prefix
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        changeValue();
    }, [
        props.value
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        // #5245 prevent infinite loop
        if (props.disabled) clearTimer();
    }, [
        props.disabled
    ]);
    var createInputElement = function createInputElement() {
        var className = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.inputClassName, cx('input', {
            context: context
        }));
        var valueToRender = formattedValue(props.value);
        return /*#__PURE__*/ $acw62.createElement((0, $ab1a721814a59df6$export$7034fcb7d6351061), $df4bf6c8c7efd937$var$_extends({
            ref: inputRef,
            id: props.inputId,
            style: props.inputStyle,
            role: "spinbutton",
            className: className,
            defaultValue: valueToRender,
            type: props.type,
            size: props.size,
            tabIndex: props.tabIndex,
            inputMode: inputMode,
            maxLength: props.maxLength,
            disabled: props.disabled,
            required: props.required,
            pattern: props.pattern,
            placeholder: props.placeholder,
            readOnly: props.readOnly,
            name: props.name,
            autoFocus: props.autoFocus,
            onKeyDown: onInputKeyDown,
            onKeyPress: onInputAndroidKey,
            onInput: onInput,
            onClick: onInputClick,
            onPointerDown: onInputPointerDown,
            onBlur: onInputBlur,
            onFocus: onInputFocus,
            onPaste: onPaste,
            min: props.min,
            max: props.max,
            "aria-valuemin": props.min,
            "aria-valuemax": props.max,
            "aria-valuenow": props.value
        }, ariaProps, dataProps, {
            pt: ptm('input'),
            unstyled: props.unstyled,
            __parentMetadata: {
                parent: metaData
            }
        }));
    };
    var createUpButton = function createUpButton() {
        var incrementIconProps = mergeProps({
            className: cx('incrementIcon')
        }, ptm('incrementIcon'));
        var icon = props.incrementButtonIcon || /*#__PURE__*/ $acw62.createElement((0, $05b405a2d2e65fb2$export$60014705184d48db), incrementIconProps);
        var upButton = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $df4bf6c8c7efd937$var$_objectSpread({}, incrementIconProps), {
            props: props
        });
        var incrementButtonProps = mergeProps({
            type: 'button',
            className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.incrementButtonClassName, cx('incrementButton')),
            onPointerLeave: onUpButtonMouseLeave,
            onPointerDown: function onPointerDown(e) {
                return onUpButtonMouseDown(e);
            },
            onPointerUp: onUpButtonMouseUp,
            onKeyDown: function onKeyDown(e) {
                return onUpButtonKeyDown(e);
            },
            onKeyUp: onUpButtonKeyUp,
            disabled: props.disabled,
            tabIndex: -1,
            'aria-hidden': true
        }, ptm('incrementButton'));
        return /*#__PURE__*/ $acw62.createElement("button", incrementButtonProps, upButton, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
    };
    var createDownButton = function createDownButton() {
        var decrementIconProps = mergeProps({
            className: cx('decrementIcon')
        }, ptm('decrementIcon'));
        var icon = props.decrementButtonIcon || /*#__PURE__*/ $acw62.createElement((0, $d65f00df46eebcf8$export$e45f9104ca1b1c90), decrementIconProps);
        var downButton = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $df4bf6c8c7efd937$var$_objectSpread({}, decrementIconProps), {
            props: props
        });
        var decrementButtonProps = mergeProps({
            type: 'button',
            className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.decrementButtonClassName, cx('decrementButton')),
            onPointerLeave: onDownButtonMouseLeave,
            onPointerDown: function onPointerDown(e) {
                return onDownButtonMouseDown(e);
            },
            onPointerUp: onDownButtonMouseUp,
            onKeyDown: function onKeyDown(e) {
                return onDownButtonKeyDown(e);
            },
            onKeyUp: onDownButtonKeyUp,
            disabled: props.disabled,
            tabIndex: -1,
            'aria-hidden': true
        }, ptm('decrementButton'));
        return /*#__PURE__*/ $acw62.createElement("button", decrementButtonProps, downButton, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
    };
    var createButtonGroup = function createButtonGroup() {
        var upButton = props.showButtons && createUpButton();
        var downButton = props.showButtons && createDownButton();
        var buttonGroupProps = mergeProps({
            className: cx('buttonGroup')
        }, ptm('buttonGroup'));
        if (stacked) return /*#__PURE__*/ $acw62.createElement("span", buttonGroupProps, upButton, downButton);
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, upButton, downButton);
    };
    var hasTooltip = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.tooltip);
    var otherProps = $df4bf6c8c7efd937$var$InputNumberBase.getOtherProps(props);
    var dataProps = (0, $a73ce425265b079e$export$4855211e6b8ad895).reduceKeys(otherProps, (0, $a73ce425265b079e$export$ff8ccbac9225de62).DATA_PROPS);
    var ariaProps = (0, $a73ce425265b079e$export$4855211e6b8ad895).reduceKeys(otherProps, (0, $a73ce425265b079e$export$ff8ccbac9225de62).ARIA_PROPS);
    var inputElement = createInputElement();
    var buttonGroup = createButtonGroup();
    var rootProps = mergeProps({
        id: props.id,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root', {
            focusedState: focusedState,
            stacked: stacked,
            horizontal: horizontal,
            vertical: vertical
        })),
        style: props.style
    }, otherProps, ptm('root'));
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("span", $df4bf6c8c7efd937$var$_extends({
        ref: elementRef
    }, rootProps), inputElement, buttonGroup), hasTooltip && /*#__PURE__*/ $acw62.createElement((0, $b74dfa9f7ee9d9bc$export$28c660c63b792dea), $df4bf6c8c7efd937$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm('tooltip')
    }, props.tooltipOptions)));
}));
$df4bf6c8c7efd937$export$cf9581d419a141cf.displayName = 'InputNumber';




function $ca71958dfa0ca676$export$698e97a3b6a7bb69({ id: id, value: value, initialVal: initialVal, label: label, propertyName: propertyName, placeholder: placeholder, numeric: numeric, onDone: onDone, onChange: onChange, onClick: onClick, onCancel: onCancel, invalid: invalid, disabled: disabled, pending: pending, style: style, suffix: suffix }) {
    function handleKeyDown(e) {
        switch(e.key){
            case 'Enter':
                onDone(propertyName, value);
                break;
            case 'Escape':
                onCancel();
        }
    }
    const isDisabled = disabled ? true : false;
    const isInvalid = invalid ? true : false;
    const errorBody = invalid ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "text-xs text-red-500",
        children: invalid
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    const labelBody = label ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
        htmlFor: id + '-' + propertyName,
        children: label
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    const inputBody = numeric ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df4bf6c8c7efd937$export$cf9581d419a141cf), {
        inputId: id + '-' + propertyName,
        placeholder: placeholder,
        className: "p-inputtext-sm",
        name: propertyName,
        value: value,
        maxFractionDigits: 20,
        onKeyDown: handleKeyDown,
        onChange: (e)=>onChange(propertyName, e.value),
        onBlur: (e)=>onDone(propertyName, value),
        invalid: isInvalid,
        disabled: isDisabled,
        style: style,
        useGrouping: false,
        suffix: suffix
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab1a721814a59df6$export$7034fcb7d6351061), {
        id: id + '-' + propertyName,
        placeholder: placeholder,
        className: "p-inputtext-sm",
        name: propertyName,
        value: value,
        onChange: (e)=>onChange(propertyName, e.target.value),
        onKeyDown: handleKeyDown,
        onBlur: (e)=>onDone(propertyName, e.target.value),
        onClick: onClick,
        invalid: isInvalid,
        disabled: isDisabled,
        style: style
    });
    let buttonApperance = {};
    if (pending) buttonApperance = {
        className: "p-button-info",
        icon: "pi pi-spin pi-spinner"
    };
    else buttonApperance = {
        className: "p-button-success",
        icon: "pi pi-check"
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            labelBody,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "p-inputgroup flex-1",
                children: [
                    inputBody,
                    String(value) != String(initialVal) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                        icon: buttonApperance.icon,
                        className: buttonApperance.className,
                        size: "small",
                        disabled: pending
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                ]
            }),
            errorBody
        ]
    });
}




var $acw62 = parcelRequire("acw62");






'use client';
function $7bfc65f9b8b8a182$var$_extends() {
    return $7bfc65f9b8b8a182$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7bfc65f9b8b8a182$var$_extends.apply(null, arguments);
}
function $7bfc65f9b8b8a182$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7bfc65f9b8b8a182$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7bfc65f9b8b8a182$var$_typeof(o);
}
function $7bfc65f9b8b8a182$var$toPrimitive(t, r) {
    if ("object" != $7bfc65f9b8b8a182$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7bfc65f9b8b8a182$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $7bfc65f9b8b8a182$var$toPropertyKey(t) {
    var i = $7bfc65f9b8b8a182$var$toPrimitive(t, "string");
    return "symbol" == $7bfc65f9b8b8a182$var$_typeof(i) ? i : i + "";
}
function $7bfc65f9b8b8a182$var$_defineProperty(e, r, t) {
    return (r = $7bfc65f9b8b8a182$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7bfc65f9b8b8a182$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $7bfc65f9b8b8a182$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $7bfc65f9b8b8a182$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $7bfc65f9b8b8a182$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7bfc65f9b8b8a182$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7bfc65f9b8b8a182$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7bfc65f9b8b8a182$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7bfc65f9b8b8a182$var$_slicedToArray(r, e) {
    return $7bfc65f9b8b8a182$var$_arrayWithHoles(r) || $7bfc65f9b8b8a182$var$_iterableToArrayLimit(r, e) || $7bfc65f9b8b8a182$var$_unsupportedIterableToArray(r, e) || $7bfc65f9b8b8a182$var$_nonIterableRest();
}
var $7bfc65f9b8b8a182$var$classes$1 = {
    box: 'p-checkbox-box',
    input: 'p-checkbox-input',
    icon: 'p-checkbox-icon',
    root: function root(_ref) {
        var props = _ref.props, checked = _ref.checked, context = _ref.context;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-checkbox p-component', {
            'p-highlight': checked,
            'p-disabled': props.disabled,
            'p-invalid': props.invalid,
            'p-variant-filled': props.variant ? props.variant === 'filled' : context && context.inputStyle === 'filled'
        });
    }
};
var $7bfc65f9b8b8a182$var$CheckboxBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'Checkbox',
        autoFocus: false,
        checked: false,
        className: null,
        disabled: false,
        falseValue: false,
        icon: null,
        id: null,
        inputId: null,
        inputRef: null,
        invalid: false,
        variant: null,
        name: null,
        onChange: null,
        onContextMenu: null,
        onMouseDown: null,
        readOnly: false,
        required: false,
        style: null,
        tabIndex: null,
        tooltip: null,
        tooltipOptions: null,
        trueValue: true,
        value: null,
        children: undefined
    },
    css: {
        classes: $7bfc65f9b8b8a182$var$classes$1
    }
});
function $7bfc65f9b8b8a182$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7bfc65f9b8b8a182$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7bfc65f9b8b8a182$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $7bfc65f9b8b8a182$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7bfc65f9b8b8a182$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7bfc65f9b8b8a182$var$Checkbox = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $7bfc65f9b8b8a182$var$CheckboxBase.getProps(inProps, context);
    var _React$useState = $acw62.useState(false), _React$useState2 = $7bfc65f9b8b8a182$var$_slicedToArray(_React$useState, 2), focusedState = _React$useState2[0], setFocusedState = _React$useState2[1];
    var _CheckboxBase$setMeta = $7bfc65f9b8b8a182$var$CheckboxBase.setMetaData({
        props: props,
        state: {
            focused: focusedState
        },
        context: {
            checked: props.checked === props.trueValue,
            disabled: props.disabled
        }
    }), ptm = _CheckboxBase$setMeta.ptm, cx = _CheckboxBase$setMeta.cx, isUnstyled = _CheckboxBase$setMeta.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($7bfc65f9b8b8a182$var$CheckboxBase.css.styles, isUnstyled, {
        name: 'checkbox'
    });
    var elementRef = $acw62.useRef(null);
    var inputRef = $acw62.useRef(props.inputRef);
    var isChecked = function isChecked() {
        return props.checked === props.trueValue;
    };
    var _onChange = function onChange(event) {
        if (props.disabled || props.readonly) return;
        if (props.onChange) {
            var _props$onChange;
            var _checked = isChecked();
            var value = _checked ? props.falseValue : props.trueValue;
            var eventData = {
                originalEvent: event,
                value: props.value,
                checked: value,
                stopPropagation: function stopPropagation() {
                    event === null || event === void 0 || event.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event === null || event === void 0 || event.preventDefault();
                },
                target: {
                    type: 'checkbox',
                    name: props.name,
                    id: props.id,
                    value: props.value,
                    checked: value
                }
            };
            props === null || props === void 0 || (_props$onChange = props.onChange) === null || _props$onChange === void 0 || _props$onChange.call(props, eventData);
            // do not continue if the user defined click wants to prevent
            if (event.defaultPrevented) return;
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current);
        }
    };
    var _onFocus = function onFocus() {
        var _props$onFocus;
        setFocusedState(true);
        props === null || props === void 0 || (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props);
    };
    var _onBlur = function onBlur() {
        var _props$onBlur;
        setFocusedState(false);
        props === null || props === void 0 || (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 || _props$onBlur.call(props);
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            focus: function focus() {
                return (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            }
        };
    });
    $acw62.useEffect(function() {
        (0, $a73ce425265b079e$export$4855211e6b8ad895).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        inputRef.current.checked = isChecked();
    }, [
        props.checked,
        props.trueValue
    ]);
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        if (props.autoFocus) (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current, props.autoFocus);
    });
    var checked = isChecked();
    var hasTooltip = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.tooltip);
    var otherProps = $7bfc65f9b8b8a182$var$CheckboxBase.getOtherProps(props);
    var rootProps = mergeProps({
        id: props.id,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root', {
            checked: checked,
            context: context
        })),
        style: props.style,
        'data-p-highlight': checked,
        'data-p-disabled': props.disabled,
        onContextMenu: props.onContextMenu,
        onMouseDown: props.onMouseDown
    }, otherProps, ptm('root'));
    var createInputElement = function createInputElement() {
        var ariaProps = (0, $a73ce425265b079e$export$4855211e6b8ad895).reduceKeys(otherProps, (0, $a73ce425265b079e$export$ff8ccbac9225de62).ARIA_PROPS);
        var inputProps = mergeProps($7bfc65f9b8b8a182$var$_objectSpread$1({
            id: props.inputId,
            type: 'checkbox',
            className: cx('input'),
            name: props.name,
            tabIndex: props.tabIndex,
            onFocus: function onFocus(e) {
                return _onFocus();
            },
            onBlur: function onBlur(e) {
                return _onBlur();
            },
            onChange: function onChange(e) {
                return _onChange(e);
            },
            disabled: props.disabled,
            readOnly: props.readOnly,
            required: props.required,
            'aria-invalid': props.invalid,
            checked: checked
        }, ariaProps), ptm('input'));
        return /*#__PURE__*/ $acw62.createElement("input", $7bfc65f9b8b8a182$var$_extends({
            ref: inputRef
        }, inputProps));
    };
    var createBoxElement = function createBoxElement() {
        var iconProps = mergeProps({
            className: cx('icon')
        }, ptm('icon'));
        var boxProps = mergeProps({
            className: cx('box', {
                checked: checked
            }),
            'data-p-highlight': checked,
            'data-p-disabled': props.disabled
        }, ptm('box'));
        var icon = checked ? props.icon || /*#__PURE__*/ $acw62.createElement((0, $ed79679a1c3e60de$export$7dd004358974b05d), iconProps) : null;
        var checkboxIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $7bfc65f9b8b8a182$var$_objectSpread$1({}, iconProps), {
            props: props,
            checked: checked
        });
        return /*#__PURE__*/ $acw62.createElement("div", boxProps, checkboxIcon);
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", $7bfc65f9b8b8a182$var$_extends({
        ref: elementRef
    }, rootProps), createInputElement(), createBoxElement()), hasTooltip && /*#__PURE__*/ $acw62.createElement((0, $b74dfa9f7ee9d9bc$export$28c660c63b792dea), $7bfc65f9b8b8a182$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm('tooltip')
    }, props.tooltipOptions)));
}));
$7bfc65f9b8b8a182$var$Checkbox.displayName = 'Checkbox';
var $7bfc65f9b8b8a182$var$classes = {
    icon: function icon(_ref) {
        var _icon = _ref.icon;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-checkbox-icon p-c', $7bfc65f9b8b8a182$var$_defineProperty({}, "".concat(_icon), true));
    },
    root: function root(_ref2) {
        var props = _ref2.props;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-multistatecheckbox p-checkbox p-component', props.classNames);
    }
};
var $7bfc65f9b8b8a182$var$inlineStyles = {
    checkbox: function checkbox(_ref3) {
        var selectedOption = _ref3.selectedOption;
        return selectedOption && selectedOption.style;
    }
};
var $7bfc65f9b8b8a182$var$MultiStateCheckboxBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'MultiStateCheckbox',
        autoFocus: false,
        className: null,
        dataKey: null,
        disabled: false,
        empty: true,
        iconTemplate: null,
        id: null,
        onChange: null,
        optionIcon: null,
        optionLabel: null,
        optionValue: null,
        options: null,
        readOnly: false,
        style: null,
        tabIndex: '0',
        tooltip: null,
        tooltipOptions: null,
        value: null,
        children: undefined
    },
    css: {
        classes: $7bfc65f9b8b8a182$var$classes,
        inlineStyles: $7bfc65f9b8b8a182$var$inlineStyles
    }
});
function $7bfc65f9b8b8a182$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7bfc65f9b8b8a182$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7bfc65f9b8b8a182$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7bfc65f9b8b8a182$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7bfc65f9b8b8a182$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7bfc65f9b8b8a182$export$3e7df48dc47874c8 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $7bfc65f9b8b8a182$var$MultiStateCheckboxBase.getProps(inProps, context);
    var _React$useState = $acw62.useState(false), _React$useState2 = $7bfc65f9b8b8a182$var$_slicedToArray(_React$useState, 2), focusedState = _React$useState2[0], setFocusedState = _React$useState2[1];
    var elementRef = $acw62.useRef(null);
    var equalityKey = props.optionValue ? null : props.dataKey;
    var _MultiStateCheckboxBa = $7bfc65f9b8b8a182$var$MultiStateCheckboxBase.setMetaData({
        props: props,
        state: {
            focused: focusedState
        }
    }), ptm = _MultiStateCheckboxBa.ptm, cx = _MultiStateCheckboxBa.cx, sx = _MultiStateCheckboxBa.sx, isUnstyled = _MultiStateCheckboxBa.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($7bfc65f9b8b8a182$var$MultiStateCheckboxBase.css.styles, isUnstyled, {
        name: 'multistatecheckbox'
    });
    var onClick = function onClick(event) {
        if (!props.disabled && !props.readOnly) toggle(event);
    };
    var getOptionValue = function getOptionValue(option) {
        return props.optionValue ? (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(option, props.optionValue) : option;
    };
    var getOptionIcon = function getOptionIcon(option) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(option, props.optionIcon || 'icon');
    };
    var getOptionAriaLabel = function getOptionAriaLabel(option) {
        var ariaField = props.optionLabel || props.optionValue;
        return ariaField ? (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(option, ariaField) : option;
    };
    var findNextOption = function findNextOption() {
        if (props.options) return selectedOptionIndex === props.options.length - 1 ? props.empty ? null : props.options[0] : props.options[selectedOptionIndex + 1];
        return null;
    };
    var toggle = function toggle(event) {
        if (props.onChange) {
            var newValue = getOptionValue(findNextOption());
            props.onChange({
                originalEvent: event,
                value: newValue,
                stopPropagation: function stopPropagation() {
                    event === null || event === void 0 || event.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event === null || event === void 0 || event.preventDefault();
                },
                target: {
                    name: props.name,
                    id: props.id,
                    value: newValue
                }
            });
        }
    };
    var onFocus = function onFocus() {
        setFocusedState(true);
    };
    var onBlur = function onBlur() {
        setFocusedState(false);
    };
    var onKeyDown = function onKeyDown(e) {
        if (e.keyCode === 32) {
            toggle(e);
            e.preventDefault();
        }
    };
    var getSelectedOptionMap = function getSelectedOptionMap() {
        var option;
        var index;
        if (props.options) {
            index = props.options.findIndex(function(option) {
                return (0, $a73ce425265b079e$export$4855211e6b8ad895).equals(props.value, getOptionValue(option), equalityKey);
            });
            option = props.options[index];
        }
        return {
            option: option,
            index: index
        };
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            focus: function focus() {
                return (0, $a73ce425265b079e$export$ff8ccbac9225de62).focusFirstElement(elementRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        if (!props.empty && props.value === null) toggle();
        if (props.autoFocus) (0, $a73ce425265b079e$export$ff8ccbac9225de62).focusFirstElement(elementRef.current);
    });
    var createIcon = function createIcon() {
        var icon = selectedOption && getOptionIcon(selectedOption) || '';
        var className = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-checkbox-icon p-c', $7bfc65f9b8b8a182$var$_defineProperty({}, "".concat(icon), true));
        var iconProps = mergeProps({
            className: cx('icon', {
                icon: icon
            })
        }, ptm('icon'));
        var content = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $7bfc65f9b8b8a182$var$_objectSpread({}, iconProps), {
            props: props
        });
        if (props.iconTemplate) {
            var defaultOptions = {
                option: selectedOption,
                className: className,
                element: content,
                props: props
            };
            return (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.iconTemplate, defaultOptions);
        }
        return content;
    };
    var _getSelectedOptionMap = getSelectedOptionMap(), selectedOption = _getSelectedOptionMap.option, selectedOptionIndex = _getSelectedOptionMap.index;
    var hasTooltip = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.tooltip);
    var otherProps = $7bfc65f9b8b8a182$var$MultiStateCheckboxBase.getOtherProps(props);
    var ariaProps = (0, $a73ce425265b079e$export$4855211e6b8ad895).reduceKeys(otherProps, (0, $a73ce425265b079e$export$ff8ccbac9225de62).ARIA_PROPS);
    var icon = createIcon();
    var ariaValueLabel = selectedOption ? getOptionAriaLabel(selectedOption) : (0, $51b25b42ecc1a0c7$export$eb839c9fd3d638b9)('nullLabel');
    var ariaChecked = selectedOption ? 'true' : 'false';
    var rootProps = mergeProps({
        ref: elementRef,
        id: props.id,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root')),
        style: props.style,
        onClick: onClick
    }, $7bfc65f9b8b8a182$var$MultiStateCheckboxBase.getOtherProps(props), ptm('root'));
    var checkboxProps = mergeProps($7bfc65f9b8b8a182$var$_objectSpread({
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className),
        style: sx('checkbox', {
            selectedOption: selectedOption
        }),
        tabIndex: props.tabIndex,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        role: 'checkbox',
        'aria-checked': ariaChecked,
        onChange: onClick,
        checked: !!selectedOption,
        disabled: props === null || props === void 0 ? void 0 : props.disabled,
        icon: icon
    }, ariaProps), ptm('checkbox'));
    var srOnlyAriaProps = mergeProps({
        className: 'p-sr-only p-hidden-accessible',
        'aria-live': 'polite'
    }, ptm('srOnlyAria'));
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", rootProps, /*#__PURE__*/ $acw62.createElement($7bfc65f9b8b8a182$var$Checkbox, checkboxProps), focusedState && /*#__PURE__*/ $acw62.createElement("span", srOnlyAriaProps, ariaValueLabel)), hasTooltip && /*#__PURE__*/ $acw62.createElement((0, $b74dfa9f7ee9d9bc$export$28c660c63b792dea), $7bfc65f9b8b8a182$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm('tooltip')
    }, props.tooltipOptions)));
}));
$7bfc65f9b8b8a182$export$3e7df48dc47874c8.displayName = 'MultiStateCheckbox';



var $acw62 = parcelRequire("acw62");
function $e57b3bd447ef9f48$export$5a7805b3564d8676({ id: id, value: value, propertyName: propertyName, onDone: onDone }) {
    const [val, setVal] = (0, $acw62.useState)(value);
    const options = [
        {
            value: 1,
            icon: 'fa-brands fa-accessible-icon',
            label: "Dost\u0119pny dla os\xf3b na w\xf3zkach"
        },
        {
            value: 2,
            icon: 'fa-solid fa-ban',
            label: "Niedost\u0119pny dla os\xf3b na w\xf3zkach"
        }
    ];
    function findLabelbyValue(options, val) {
        let found = options.find((element)=>element.value === val);
        if (typeof found === "undefined") return "Informacja o dost\u0119pno\u015Bci dla w\xf3zk\xf3w";
        else return found['label'];
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bfc65f9b8b8a182$export$3e7df48dc47874c8), {
                value: val,
                options: options,
                onChange: (e)=>{
                    setVal(e.value);
                    onDone(propertyName, e.value);
                },
                optionValue: "value",
                optionLabel: "label",
                className: "mr-2",
                pt: {
                    checkbox: {
                        id: id + '-' + propertyName
                    }
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: id + '-' + propertyName,
                children: findLabelbyValue(options, val)
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

'use client';
function $2539671ba6368b77$var$_extends() {
    return $2539671ba6368b77$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2539671ba6368b77$var$_extends.apply(null, arguments);
}
var $2539671ba6368b77$export$4857d3f3f5f8319b = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $2539671ba6368b77$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z",
        fill: "currentColor"
    }));
}));
$2539671ba6368b77$export$4857d3f3f5f8319b.displayName = 'ChevronDownIcon';



var $acw62 = parcelRequire("acw62");

'use client';
function $a26a14ced485563c$var$_extends() {
    return $a26a14ced485563c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a26a14ced485563c$var$_extends.apply(null, arguments);
}
var $a26a14ced485563c$export$7f01a6cbee61a0f2 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $a26a14ced485563c$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M12.2097 10.4113C12.1057 10.4118 12.0027 10.3915 11.9067 10.3516C11.8107 10.3118 11.7237 10.2532 11.6506 10.1792L6.93602 5.46461L2.22139 10.1476C2.07272 10.244 1.89599 10.2877 1.71953 10.2717C1.54307 10.2556 1.3771 10.1808 1.24822 10.0593C1.11933 9.93766 1.035 9.77633 1.00874 9.6011C0.982477 9.42587 1.0158 9.2469 1.10338 9.09287L6.37701 3.81923C6.52533 3.6711 6.72639 3.58789 6.93602 3.58789C7.14565 3.58789 7.3467 3.6711 7.49502 3.81923L12.7687 9.09287C12.9168 9.24119 13 9.44225 13 9.65187C13 9.8615 12.9168 10.0626 12.7687 10.2109C12.616 10.3487 12.4151 10.4207 12.2097 10.4113Z",
        fill: "currentColor"
    }));
}));
$a26a14ced485563c$export$7f01a6cbee61a0f2.displayName = 'ChevronUpIcon';









var $acw62 = parcelRequire("acw62");

'use client';
function $dbb1fbeb3f53a92c$var$_extends() {
    return $dbb1fbeb3f53a92c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $dbb1fbeb3f53a92c$var$_extends.apply(null, arguments);
}
var $dbb1fbeb3f53a92c$export$82eafebb825fc23f = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $dbb1fbeb3f53a92c$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.67602 11.0265C3.6661 11.688 4.83011 12.0411 6.02086 12.0411C6.81149 12.0411 7.59438 11.8854 8.32483 11.5828C8.87005 11.357 9.37808 11.0526 9.83317 10.6803L12.9769 13.8241C13.0323 13.8801 13.0983 13.9245 13.171 13.9548C13.2438 13.985 13.3219 14.0003 13.4007 14C13.4795 14.0003 13.5575 13.985 13.6303 13.9548C13.7031 13.9245 13.7691 13.8801 13.8244 13.8241C13.9367 13.7116 13.9998 13.5592 13.9998 13.4003C13.9998 13.2414 13.9367 13.089 13.8244 12.9765L10.6807 9.8328C11.053 9.37773 11.3573 8.86972 11.5831 8.32452C11.8857 7.59408 12.0414 6.81119 12.0414 6.02056C12.0414 4.8298 11.6883 3.66579 11.0268 2.67572C10.3652 1.68564 9.42494 0.913972 8.32483 0.45829C7.22472 0.00260857 6.01418 -0.116618 4.84631 0.115686C3.67844 0.34799 2.60568 0.921393 1.76369 1.76338C0.921698 2.60537 0.348296 3.67813 0.115991 4.84601C-0.116313 6.01388 0.00291375 7.22441 0.458595 8.32452C0.914277 9.42464 1.68595 10.3649 2.67602 11.0265ZM3.35565 2.0158C4.14456 1.48867 5.07206 1.20731 6.02086 1.20731C7.29317 1.20731 8.51338 1.71274 9.41304 2.6124C10.3127 3.51206 10.8181 4.73226 10.8181 6.00457C10.8181 6.95337 10.5368 7.88088 10.0096 8.66978C9.48251 9.45868 8.73328 10.0736 7.85669 10.4367C6.98011 10.7997 6.01554 10.8947 5.08496 10.7096C4.15439 10.5245 3.2996 10.0676 2.62869 9.39674C1.95778 8.72583 1.50089 7.87104 1.31579 6.94046C1.13068 6.00989 1.22568 5.04532 1.58878 4.16874C1.95187 3.29215 2.56675 2.54292 3.35565 2.0158Z",
        fill: "currentColor"
    }));
}));
$dbb1fbeb3f53a92c$export$82eafebb825fc23f.displayName = 'SearchIcon';




var $acw62 = parcelRequire("acw62");





'use client';
function $50cb59e69476e4bf$var$_extends() {
    return $50cb59e69476e4bf$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $50cb59e69476e4bf$var$_extends.apply(null, arguments);
}
function $50cb59e69476e4bf$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $50cb59e69476e4bf$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $50cb59e69476e4bf$var$_typeof(o);
}
function $50cb59e69476e4bf$var$toPrimitive(t, r) {
    if ("object" != $50cb59e69476e4bf$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $50cb59e69476e4bf$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $50cb59e69476e4bf$var$toPropertyKey(t) {
    var i = $50cb59e69476e4bf$var$toPrimitive(t, "string");
    return "symbol" == $50cb59e69476e4bf$var$_typeof(i) ? i : i + "";
}
function $50cb59e69476e4bf$var$_defineProperty(e, r, t) {
    return (r = $50cb59e69476e4bf$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $50cb59e69476e4bf$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $50cb59e69476e4bf$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $50cb59e69476e4bf$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $50cb59e69476e4bf$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $50cb59e69476e4bf$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $50cb59e69476e4bf$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $50cb59e69476e4bf$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $50cb59e69476e4bf$var$_slicedToArray(r, e) {
    return $50cb59e69476e4bf$var$_arrayWithHoles(r) || $50cb59e69476e4bf$var$_iterableToArrayLimit(r, e) || $50cb59e69476e4bf$var$_unsupportedIterableToArray(r, e) || $50cb59e69476e4bf$var$_nonIterableRest();
}
var $50cb59e69476e4bf$var$styles = "\n.p-virtualscroller {\n    position: relative;\n    overflow: auto;\n    contain: strict;\n    transform: translateZ(0);\n    will-change: scroll-position;\n    outline: 0 none;\n}\n\n.p-virtualscroller-content {\n    position: absolute;\n    top: 0;\n    left: 0;\n    /*contain: content;*/\n    min-height: 100%;\n    min-width: 100%;\n    will-change: transform;\n}\n\n.p-virtualscroller-spacer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 1px;\n    width: 1px;\n    transform-origin: 0 0;\n    pointer-events: none;\n}\n\n.p-virtualscroller-loader {\n    position: sticky;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.p-virtualscroller-loader.p-component-overlay {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.p-virtualscroller-loading-icon {\n    font-size: 2rem;\n}\n\n.p-virtualscroller-horizontal > .p-virtualscroller-content {\n    display: flex;\n}\n\n/* Inline */\n.p-virtualscroller-inline .p-virtualscroller-content {\n    position: static;\n}\n";
var $50cb59e69476e4bf$var$VirtualScrollerBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'VirtualScroller',
        __parentMetadata: null,
        id: null,
        style: null,
        className: null,
        tabIndex: 0,
        items: null,
        itemSize: 0,
        scrollHeight: null,
        scrollWidth: null,
        orientation: 'vertical',
        step: 0,
        numToleratedItems: null,
        delay: 0,
        resizeDelay: 10,
        appendOnly: false,
        inline: false,
        lazy: false,
        disabled: false,
        loaderDisabled: false,
        loadingIcon: null,
        columns: null,
        loading: undefined,
        autoSize: false,
        showSpacer: true,
        showLoader: false,
        loadingTemplate: null,
        loaderIconTemplate: null,
        itemTemplate: null,
        contentTemplate: null,
        onScroll: null,
        onScrollIndexChange: null,
        onLazyLoad: null,
        children: undefined
    },
    css: {
        styles: $50cb59e69476e4bf$var$styles
    }
});
function $50cb59e69476e4bf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $50cb59e69476e4bf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $50cb59e69476e4bf$var$ownKeys(Object(t), !0).forEach(function(r) {
            $50cb59e69476e4bf$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $50cb59e69476e4bf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $50cb59e69476e4bf$export$fbd4ea7fe0fb889 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $50cb59e69476e4bf$var$VirtualScrollerBase.getProps(inProps, context);
    var prevProps = (0, $fbdf1e36fa0a01d8$export$5cae361ad82dce8b)(inProps) || {};
    var vertical = props.orientation === 'vertical';
    var horizontal = props.orientation === 'horizontal';
    var both = props.orientation === 'both';
    var _React$useState = $acw62.useState(both ? {
        rows: 0,
        cols: 0
    } : 0), _React$useState2 = $50cb59e69476e4bf$var$_slicedToArray(_React$useState, 2), firstState = _React$useState2[0], setFirstState = _React$useState2[1];
    var _React$useState3 = $acw62.useState(both ? {
        rows: 0,
        cols: 0
    } : 0), _React$useState4 = $50cb59e69476e4bf$var$_slicedToArray(_React$useState3, 2), lastState = _React$useState4[0], setLastState = _React$useState4[1];
    var _React$useState5 = $acw62.useState(0), _React$useState6 = $50cb59e69476e4bf$var$_slicedToArray(_React$useState5, 2), pageState = _React$useState6[0], setPageState = _React$useState6[1];
    var _React$useState7 = $acw62.useState(both ? {
        rows: 0,
        cols: 0
    } : 0), _React$useState8 = $50cb59e69476e4bf$var$_slicedToArray(_React$useState7, 2), numItemsInViewportState = _React$useState8[0], setNumItemsInViewportState = _React$useState8[1];
    var _React$useState9 = $acw62.useState(props.numToleratedItems), _React$useState10 = $50cb59e69476e4bf$var$_slicedToArray(_React$useState9, 2), numToleratedItemsState = _React$useState10[0], setNumToleratedItemsState = _React$useState10[1];
    var _React$useState11 = $acw62.useState(props.loading || false), _React$useState12 = $50cb59e69476e4bf$var$_slicedToArray(_React$useState11, 2), loadingState = _React$useState12[0], setLoadingState = _React$useState12[1];
    var _React$useState13 = $acw62.useState([]), _React$useState14 = $50cb59e69476e4bf$var$_slicedToArray(_React$useState13, 2), loaderArrState = _React$useState14[0], setLoaderArrState = _React$useState14[1];
    var _VirtualScrollerBase$ = $50cb59e69476e4bf$var$VirtualScrollerBase.setMetaData({
        props: props,
        state: {
            first: firstState,
            last: lastState,
            page: pageState,
            numItemsInViewport: numItemsInViewportState,
            numToleratedItems: numToleratedItemsState,
            loading: loadingState,
            loaderArr: loaderArrState
        }
    }), ptm = _VirtualScrollerBase$.ptm;
    (0, $fbdf1e36fa0a01d8$export$72c85e333541e7f)($50cb59e69476e4bf$var$VirtualScrollerBase.css.styles, {
        name: 'virtualscroller'
    });
    var elementRef = $acw62.useRef(null);
    var _contentRef = $acw62.useRef(null);
    var _spacerRef = $acw62.useRef(null);
    var _stickyRef = $acw62.useRef(null);
    var lastScrollPos = $acw62.useRef(both ? {
        top: 0,
        left: 0
    } : 0);
    var scrollTimeout = $acw62.useRef(null);
    var resizeTimeout = $acw62.useRef(null);
    var contentStyle = $acw62.useRef({});
    var spacerStyle = $acw62.useRef({});
    var defaultWidth = $acw62.useRef(null);
    var defaultHeight = $acw62.useRef(null);
    var defaultContentWidth = $acw62.useRef(null);
    var defaultContentHeight = $acw62.useRef(null);
    var isItemRangeChanged = $acw62.useRef(false);
    var lazyLoadState = $acw62.useRef(null);
    var _useResizeListener = (0, $fbdf1e36fa0a01d8$export$158eb97be50d41ef)({
        listener: function listener(event) {
            return onResize();
        },
        when: !props.disabled
    }), _useResizeListener2 = $50cb59e69476e4bf$var$_slicedToArray(_useResizeListener, 1), bindWindowResizeListener = _useResizeListener2[0];
    var _useEventListener = (0, $fbdf1e36fa0a01d8$export$7080b3e976bc91ab)({
        target: 'window',
        type: 'orientationchange',
        listener: function listener(event) {
            return onResize();
        },
        when: !props.disabled
    }), _useEventListener2 = $50cb59e69476e4bf$var$_slicedToArray(_useEventListener, 1), bindOrientationChangeListener = _useEventListener2[0];
    var getElementRef = function getElementRef() {
        return elementRef;
    };
    var getPageByFirst = function getPageByFirst(first) {
        return Math.floor((first + numToleratedItemsState * 4) / (props.step || 1));
    };
    var setContentElement = function setContentElement(element) {
        _contentRef.current = element || _contentRef.current || (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(elementRef.current, '.p-virtualscroller-content');
    };
    var isPageChanged = function isPageChanged(first) {
        return props.step ? pageState !== getPageByFirst(first) : true;
    };
    var scrollTo = function scrollTo(options) {
        lastScrollPos.current = both ? {
            top: 0,
            left: 0
        } : 0;
        elementRef.current && elementRef.current.scrollTo(options);
    };
    var scrollToIndex = function scrollToIndex(index) {
        var behavior = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'auto';
        var _calculateNumItems = calculateNumItems(), numToleratedItems = _calculateNumItems.numToleratedItems;
        var contentPos = getContentPosition();
        var calculateFirst = function calculateFirst() {
            var _index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var _numT = arguments.length > 1 ? arguments[1] : undefined;
            return _index <= _numT ? 0 : _index;
        };
        var calculateCoord = function calculateCoord(_first, _size, _cpos) {
            return _first * _size + _cpos;
        };
        var scrollToItem = function scrollToItem() {
            var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            return scrollTo({
                left: left,
                top: top,
                behavior: behavior
            });
        };
        var newFirst = both ? {
            rows: 0,
            cols: 0
        } : 0;
        var isRangeChanged = false;
        if (both) {
            newFirst = {
                rows: calculateFirst(index[0], numToleratedItems[0]),
                cols: calculateFirst(index[1], numToleratedItems[1])
            };
            scrollToItem(calculateCoord(newFirst.cols, props.itemSize[1], contentPos.left), calculateCoord(newFirst.rows, props.itemSize[0], contentPos.top));
            isRangeChanged = firstState.rows !== newFirst.rows || firstState.cols !== newFirst.cols;
        } else {
            newFirst = calculateFirst(index, numToleratedItems);
            horizontal ? scrollToItem(calculateCoord(newFirst, props.itemSize, contentPos.left), 0) : scrollToItem(0, calculateCoord(newFirst, props.itemSize, contentPos.top));
            isRangeChanged = firstState !== newFirst;
        }
        isItemRangeChanged.current = isRangeChanged;
        setFirstState(newFirst);
    };
    var scrollInView = function scrollInView(index, to) {
        var behavior = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'auto';
        if (to) {
            var _getRenderedRange = getRenderedRange(), first = _getRenderedRange.first, viewport = _getRenderedRange.viewport;
            var scrollToItem = function scrollToItem() {
                var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                return scrollTo({
                    left: left,
                    top: top,
                    behavior: behavior
                });
            };
            var isToStart = to === 'to-start';
            var isToEnd = to === 'to-end';
            if (isToStart) {
                if (both) {
                    if (viewport.first.rows - first.rows > index[0]) scrollToItem(viewport.first.cols * props.itemSize[1], (viewport.first.rows - 1) * props.itemSize[0]);
                    else if (viewport.first.cols - first.cols > index[1]) scrollToItem((viewport.first.cols - 1) * props.itemSize[1], viewport.first.rows * props.itemSize[0]);
                } else if (viewport.first - first > index) {
                    var pos = (viewport.first - 1) * props.itemSize;
                    horizontal ? scrollToItem(pos, 0) : scrollToItem(0, pos);
                }
            } else if (isToEnd) {
                if (both) {
                    if (viewport.last.rows - first.rows <= index[0] + 1) scrollToItem(viewport.first.cols * props.itemSize[1], (viewport.first.rows + 1) * props.itemSize[0]);
                    else if (viewport.last.cols - first.cols <= index[1] + 1) scrollToItem((viewport.first.cols + 1) * props.itemSize[1], viewport.first.rows * props.itemSize[0]);
                } else if (viewport.last - first <= index + 1) {
                    var _pos2 = (viewport.first + 1) * props.itemSize;
                    horizontal ? scrollToItem(_pos2, 0) : scrollToItem(0, _pos2);
                }
            }
        } else scrollToIndex(index, behavior);
    };
    var getRows = function getRows() {
        return loadingState ? props.loaderDisabled ? loaderArrState : [] : loadedItems();
    };
    var getColumns = function getColumns() {
        if (props.columns && both || horizontal) return loadingState && props.loaderDisabled ? both ? loaderArrState[0] : loaderArrState : props.columns.slice(both ? firstState.cols : firstState, both ? lastState.cols : lastState);
        return props.columns;
    };
    var getRenderedRange = function getRenderedRange() {
        var calculateFirstInViewport = function calculateFirstInViewport(_pos, _size) {
            return Math.floor(_pos / (_size || _pos));
        };
        var firstInViewport = firstState;
        var lastInViewport = 0;
        if (elementRef.current) {
            var _elementRef$current = elementRef.current, scrollTop = _elementRef$current.scrollTop, scrollLeft = _elementRef$current.scrollLeft;
            if (both) {
                firstInViewport = {
                    rows: calculateFirstInViewport(scrollTop, props.itemSize[0]),
                    cols: calculateFirstInViewport(scrollLeft, props.itemSize[1])
                };
                lastInViewport = {
                    rows: firstInViewport.rows + numItemsInViewportState.rows,
                    cols: firstInViewport.cols + numItemsInViewportState.cols
                };
            } else {
                var scrollPos = horizontal ? scrollLeft : scrollTop;
                firstInViewport = calculateFirstInViewport(scrollPos, props.itemSize);
                lastInViewport = firstInViewport + numItemsInViewportState;
            }
        }
        return {
            first: firstState,
            last: lastState,
            viewport: {
                first: firstInViewport,
                last: lastInViewport
            }
        };
    };
    var calculateNumItems = function calculateNumItems() {
        var contentPos = getContentPosition();
        var contentWidth = elementRef.current ? elementRef.current.offsetWidth - contentPos.left : 0;
        var contentHeight = elementRef.current ? elementRef.current.offsetHeight - contentPos.top : 0;
        var calculateNumItemsInViewport = function calculateNumItemsInViewport(_contentSize, _itemSize) {
            return Math.ceil(_contentSize / (_itemSize || _contentSize));
        };
        var calculateNumToleratedItems = function calculateNumToleratedItems(_numItems) {
            return Math.ceil(_numItems / 2);
        };
        var numItemsInViewport = both ? {
            rows: calculateNumItemsInViewport(contentHeight, props.itemSize[0]),
            cols: calculateNumItemsInViewport(contentWidth, props.itemSize[1])
        } : calculateNumItemsInViewport(horizontal ? contentWidth : contentHeight, props.itemSize);
        var numToleratedItems = numToleratedItemsState || (both ? [
            calculateNumToleratedItems(numItemsInViewport.rows),
            calculateNumToleratedItems(numItemsInViewport.cols)
        ] : calculateNumToleratedItems(numItemsInViewport));
        return {
            numItemsInViewport: numItemsInViewport,
            numToleratedItems: numToleratedItems
        };
    };
    var calculateOptions = function calculateOptions() {
        var _calculateNumItems2 = calculateNumItems(), numItemsInViewport = _calculateNumItems2.numItemsInViewport, numToleratedItems = _calculateNumItems2.numToleratedItems;
        var calculateLast = function calculateLast(_first, _num, _numT) {
            var _isCols = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            return getLast(_first + _num + (_first < _numT ? 2 : 3) * _numT, _isCols);
        };
        var last = both ? {
            rows: calculateLast(firstState.rows, numItemsInViewport.rows, numToleratedItems[0]),
            cols: calculateLast(firstState.cols, numItemsInViewport.cols, numToleratedItems[1], true)
        } : calculateLast(firstState, numItemsInViewport, numToleratedItems);
        setNumItemsInViewportState(numItemsInViewport);
        setNumToleratedItemsState(numToleratedItems);
        setLastState(last);
        if (props.showLoader) setLoaderArrState(both ? Array.from({
            length: numItemsInViewport.rows
        }).map(function() {
            return Array.from({
                length: numItemsInViewport.cols
            });
        }) : Array.from({
            length: numItemsInViewport
        }));
        if (props.lazy) Promise.resolve().then(function() {
            lazyLoadState.current = {
                first: props.step ? both ? {
                    rows: 0,
                    cols: firstState.cols
                } : 0 : firstState,
                last: Math.min(props.step ? props.step : last, (props.items || []).length)
            };
            props.onLazyLoad && props.onLazyLoad(lazyLoadState.current);
        });
    };
    var calculateAutoSize = function calculateAutoSize(loading) {
        if (props.autoSize && !loading) Promise.resolve().then(function() {
            if (_contentRef.current) {
                _contentRef.current.style.minHeight = _contentRef.current.style.minWidth = 'auto';
                _contentRef.current.style.position = 'relative';
                elementRef.current.style.contain = 'none';
                /*const [contentWidth, contentHeight] = [DomHandler.getWidth(contentRef.current), DomHandler.getHeight(contentRef.current)];
           contentWidth !== defaultContentWidth.current && (elementRef.current.style.width = '');
          contentHeight !== defaultContentHeight.current && (elementRef.current.style.height = '');*/ var _ref = [
                    (0, $a73ce425265b079e$export$ff8ccbac9225de62).getWidth(elementRef.current),
                    (0, $a73ce425265b079e$export$ff8ccbac9225de62).getHeight(elementRef.current)
                ], width = _ref[0], height = _ref[1];
                (both || horizontal) && (elementRef.current.style.width = (width < defaultWidth.current ? width : props.scrollWidth || defaultWidth.current) + 'px');
                (both || vertical) && (elementRef.current.style.height = (height < defaultHeight.current ? height : props.scrollHeight || defaultHeight.current) + 'px');
                _contentRef.current.style.minHeight = _contentRef.current.style.minWidth = '';
                _contentRef.current.style.position = '';
                elementRef.current.style.contain = '';
            }
        });
    };
    var getLast = function getLast() {
        var _ref2;
        var last = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var isCols = arguments.length > 1 ? arguments[1] : undefined;
        return props.items ? Math.min(isCols ? ((_ref2 = props.columns || props.items[0]) === null || _ref2 === void 0 ? void 0 : _ref2.length) || 0 : (props.items || []).length, last) : 0;
    };
    var getContentPosition = function getContentPosition() {
        if (_contentRef.current) {
            var style = getComputedStyle(_contentRef.current);
            var left = parseFloat(style.paddingLeft) + Math.max(parseFloat(style.left) || 0, 0);
            var right = parseFloat(style.paddingRight) + Math.max(parseFloat(style.right) || 0, 0);
            var top = parseFloat(style.paddingTop) + Math.max(parseFloat(style.top) || 0, 0);
            var bottom = parseFloat(style.paddingBottom) + Math.max(parseFloat(style.bottom) || 0, 0);
            return {
                left: left,
                right: right,
                top: top,
                bottom: bottom,
                x: left + right,
                y: top + bottom
            };
        }
        return {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            x: 0,
            y: 0
        };
    };
    var setSize = function setSize() {
        if (elementRef.current) {
            var parentElement = elementRef.current.parentElement;
            var width = props.scrollWidth || "".concat(elementRef.current.offsetWidth || parentElement.offsetWidth, "px");
            var height = props.scrollHeight || "".concat(elementRef.current.offsetHeight || parentElement.offsetHeight, "px");
            var setProp = function setProp(_name, _value) {
                return elementRef.current.style[_name] = _value;
            };
            if (both || horizontal) {
                setProp('height', height);
                setProp('width', width);
            } else setProp('height', height);
        }
    };
    var setSpacerSize = function setSpacerSize() {
        var items = props.items;
        if (items) {
            var contentPos = getContentPosition();
            var setProp = function setProp(_name, _value, _size) {
                var _cpos = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                return spacerStyle.current = $50cb59e69476e4bf$var$_objectSpread($50cb59e69476e4bf$var$_objectSpread({}, spacerStyle.current), $50cb59e69476e4bf$var$_defineProperty({}, "".concat(_name), (_value || []).length * _size + _cpos + 'px'));
            };
            if (both) {
                setProp('height', items, props.itemSize[0], contentPos.y);
                setProp('width', props.columns || items[1], props.itemSize[1], contentPos.x);
            } else horizontal ? setProp('width', props.columns || items, props.itemSize, contentPos.x) : setProp('height', items, props.itemSize, contentPos.y);
        }
    };
    var setContentPosition = function setContentPosition(pos) {
        if (_contentRef.current && !props.appendOnly) {
            var first = pos ? pos.first : firstState;
            var calculateTranslateVal = function calculateTranslateVal(_first, _size) {
                return _first * _size;
            };
            var setTransform = function setTransform() {
                var _x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var _y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                _stickyRef.current && (_stickyRef.current.style.top = "-".concat(_y, "px"));
                contentStyle.current = $50cb59e69476e4bf$var$_objectSpread($50cb59e69476e4bf$var$_objectSpread({}, contentStyle.current), {
                    transform: "translate3d(".concat(_x, "px, ").concat(_y, "px, 0)")
                });
            };
            if (both) setTransform(calculateTranslateVal(first.cols, props.itemSize[1]), calculateTranslateVal(first.rows, props.itemSize[0]));
            else {
                var translateVal = calculateTranslateVal(first, props.itemSize);
                horizontal ? setTransform(translateVal, 0) : setTransform(0, translateVal);
            }
        }
    };
    var onScrollPositionChange = function onScrollPositionChange(event) {
        var target = event.target;
        var contentPos = getContentPosition();
        var calculateScrollPos = function calculateScrollPos(_pos, _cpos) {
            return _pos ? _pos > _cpos ? _pos - _cpos : _pos : 0;
        };
        var calculateCurrentIndex = function calculateCurrentIndex(_pos, _size) {
            return Math.floor(_pos / (_size || _pos));
        };
        var calculateTriggerIndex = function calculateTriggerIndex(_currentIndex, _first, _last, _num, _numT, _isScrollDownOrRight) {
            return _currentIndex <= _numT ? _numT : _isScrollDownOrRight ? _last - _num - _numT : _first + _numT - 1;
        };
        var calculateFirst = function calculateFirst(_currentIndex, _triggerIndex, _first, _last, _num, _numT, _isScrollDownOrRight) {
            if (_currentIndex <= _numT) return 0;
            return Math.max(0, _isScrollDownOrRight ? _currentIndex < _triggerIndex ? _first : _currentIndex - _numT : _currentIndex > _triggerIndex ? _first : _currentIndex - 2 * _numT);
        };
        var calculateLast = function calculateLast(_currentIndex, _first, _last, _num, _numT, _isCols) {
            var lastValue = _first + _num + 2 * _numT;
            if (_currentIndex >= _numT) lastValue = lastValue + (_numT + 1);
            return getLast(lastValue, _isCols);
        };
        var scrollTop = calculateScrollPos(target.scrollTop, contentPos.top);
        var scrollLeft = calculateScrollPos(target.scrollLeft, contentPos.left);
        var newFirst = both ? {
            rows: 0,
            cols: 0
        } : 0;
        var newLast = lastState;
        var isRangeChanged = false;
        var newScrollPos = lastScrollPos.current;
        if (both) {
            var isScrollDown = lastScrollPos.current.top <= scrollTop;
            var isScrollRight = lastScrollPos.current.left <= scrollLeft;
            if (!props.appendOnly || props.appendOnly && (isScrollDown || isScrollRight)) {
                var currentIndex = {
                    rows: calculateCurrentIndex(scrollTop, props.itemSize[0]),
                    cols: calculateCurrentIndex(scrollLeft, props.itemSize[1])
                };
                var triggerIndex = {
                    rows: calculateTriggerIndex(currentIndex.rows, firstState.rows, lastState.rows, numItemsInViewportState.rows, numToleratedItemsState[0], isScrollDown),
                    cols: calculateTriggerIndex(currentIndex.cols, firstState.cols, lastState.cols, numItemsInViewportState.cols, numToleratedItemsState[1], isScrollRight)
                };
                newFirst = {
                    rows: calculateFirst(currentIndex.rows, triggerIndex.rows, firstState.rows, lastState.rows, numItemsInViewportState.rows, numToleratedItemsState[0], isScrollDown),
                    cols: calculateFirst(currentIndex.cols, triggerIndex.cols, firstState.cols, lastState.cols, numItemsInViewportState.cols, numToleratedItemsState[1], isScrollRight)
                };
                newLast = {
                    rows: calculateLast(currentIndex.rows, newFirst.rows, lastState.rows, numItemsInViewportState.rows, numToleratedItemsState[0]),
                    cols: calculateLast(currentIndex.cols, newFirst.cols, lastState.cols, numItemsInViewportState.cols, numToleratedItemsState[1], true)
                };
                isRangeChanged = newFirst.rows !== firstState.rows || newLast.rows !== lastState.rows || newFirst.cols !== firstState.cols || newLast.cols !== lastState.cols || isItemRangeChanged.current;
                newScrollPos = {
                    top: scrollTop,
                    left: scrollLeft
                };
            }
        } else {
            var scrollPos = horizontal ? scrollLeft : scrollTop;
            var isScrollDownOrRight = lastScrollPos.current <= scrollPos;
            if (!props.appendOnly || props.appendOnly && isScrollDownOrRight) {
                var _currentIndex2 = calculateCurrentIndex(scrollPos, props.itemSize);
                var _triggerIndex2 = calculateTriggerIndex(_currentIndex2, firstState, lastState, numItemsInViewportState, numToleratedItemsState, isScrollDownOrRight);
                newFirst = calculateFirst(_currentIndex2, _triggerIndex2, firstState, lastState, numItemsInViewportState, numToleratedItemsState, isScrollDownOrRight);
                newLast = calculateLast(_currentIndex2, newFirst, lastState, numItemsInViewportState, numToleratedItemsState);
                isRangeChanged = newFirst !== firstState || newLast !== lastState || isItemRangeChanged.current;
                newScrollPos = scrollPos;
            }
        }
        return {
            first: newFirst,
            last: newLast,
            isRangeChanged: isRangeChanged,
            scrollPos: newScrollPos
        };
    };
    var onScrollChange = function onScrollChange(event) {
        var _onScrollPositionChan = onScrollPositionChange(event), first = _onScrollPositionChan.first, last = _onScrollPositionChan.last, isRangeChanged = _onScrollPositionChan.isRangeChanged, scrollPos = _onScrollPositionChan.scrollPos;
        if (isRangeChanged) {
            var newState = {
                first: first,
                last: last
            };
            setContentPosition(newState);
            setFirstState(first);
            setLastState(last);
            lastScrollPos.current = scrollPos;
            props.onScrollIndexChange && props.onScrollIndexChange(newState);
            if (props.lazy && isPageChanged(first)) {
                var newLazyLoadState = {
                    first: props.step ? Math.min(getPageByFirst(first) * props.step, (props.items || []).length - props.step) : first,
                    last: Math.min(props.step ? (getPageByFirst(first) + 1) * props.step : last, (props.items || []).length)
                };
                var isLazyStateChanged = !lazyLoadState.current || lazyLoadState.current.first !== newLazyLoadState.first || lazyLoadState.current.last !== newLazyLoadState.last;
                isLazyStateChanged && props.onLazyLoad && props.onLazyLoad(newLazyLoadState);
                lazyLoadState.current = newLazyLoadState;
            }
        }
    };
    var _onScroll = function onScroll(event) {
        props.onScroll && props.onScroll(event);
        if (props.delay) {
            if (scrollTimeout.current) clearTimeout(scrollTimeout.current);
            if (isPageChanged(firstState)) {
                if (!loadingState && props.showLoader) {
                    var _onScrollPositionChan2 = onScrollPositionChange(event), isRangeChanged = _onScrollPositionChan2.isRangeChanged;
                    var changed = isRangeChanged || (props.step ? isPageChanged(firstState) : false);
                    changed && setLoadingState(true);
                }
                scrollTimeout.current = setTimeout(function() {
                    onScrollChange(event);
                    if (loadingState && props.showLoader && (!props.lazy || props.loading === undefined)) {
                        setLoadingState(false);
                        setPageState(getPageByFirst(firstState));
                    }
                }, props.delay);
            }
        } else onScrollChange(event);
    };
    var onResize = function onResize() {
        if (resizeTimeout.current) clearTimeout(resizeTimeout.current);
        resizeTimeout.current = setTimeout(function() {
            if (elementRef.current) {
                var _ref3 = [
                    (0, $a73ce425265b079e$export$ff8ccbac9225de62).getWidth(elementRef.current),
                    (0, $a73ce425265b079e$export$ff8ccbac9225de62).getHeight(elementRef.current)
                ], width = _ref3[0], height = _ref3[1];
                var isDiffWidth = width !== defaultWidth.current, isDiffHeight = height !== defaultHeight.current;
                var reinit = both ? isDiffWidth || isDiffHeight : horizontal ? isDiffWidth : vertical ? isDiffHeight : false;
                if (reinit) {
                    setNumToleratedItemsState(props.numToleratedItems);
                    defaultWidth.current = width;
                    defaultHeight.current = height;
                    defaultContentWidth.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getWidth(_contentRef.current);
                    defaultContentHeight.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getHeight(_contentRef.current);
                }
            }
        }, props.resizeDelay);
    };
    var getOptions = function getOptions(renderedIndex) {
        var count = (props.items || []).length;
        var index = both ? firstState.rows + renderedIndex : firstState + renderedIndex;
        return {
            index: index,
            count: count,
            first: index === 0,
            last: index === count - 1,
            even: index % 2 === 0,
            odd: index % 2 !== 0,
            props: props
        };
    };
    var loaderOptions = function loaderOptions(index, extOptions) {
        var count = loaderArrState.length || 0;
        return $50cb59e69476e4bf$var$_objectSpread({
            index: index,
            count: count,
            first: index === 0,
            last: index === count - 1,
            even: index % 2 === 0,
            odd: index % 2 !== 0,
            props: props
        }, extOptions);
    };
    var loadedItems = function loadedItems() {
        var items = props.items;
        if (items && !loadingState) {
            if (both) return items.slice(props.appendOnly ? 0 : firstState.rows, lastState.rows).map(function(item) {
                return props.columns ? item : item.slice(props.appendOnly ? 0 : firstState.cols, lastState.cols);
            });
            else if (horizontal && props.columns) return items;
            return items.slice(props.appendOnly ? 0 : firstState, lastState);
        }
        return [];
    };
    var viewInit = function viewInit() {
        if (elementRef.current && (0, $a73ce425265b079e$export$ff8ccbac9225de62).isVisible(elementRef.current)) {
            setContentElement(_contentRef.current);
            init();
            bindWindowResizeListener();
            bindOrientationChangeListener();
            defaultWidth.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getWidth(elementRef.current);
            defaultHeight.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getHeight(elementRef.current);
            defaultContentWidth.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getWidth(_contentRef.current);
            defaultContentHeight.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getHeight(_contentRef.current);
        }
    };
    var init = function init() {
        if (!props.disabled) {
            setSize();
            calculateOptions();
            setSpacerSize();
        }
    };
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        viewInit();
    });
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        init();
    }, [
        props.itemSize,
        props.scrollHeight,
        props.scrollWidth
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (props.numToleratedItems !== numToleratedItemsState) setNumToleratedItemsState(props.numToleratedItems);
    }, [
        props.numToleratedItems
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (props.numToleratedItems === numToleratedItemsState) init(); // reinit after resizing
    }, [
        numToleratedItemsState
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        // Check if the previous/current rows array exists
        var prevRowsExist = prevProps.items !== undefined && prevProps.items !== null;
        var currentRowsExist = props.items !== undefined && props.items !== null;
        // Get the length of the previous/current rows array, or 0 if it doesn't exist
        var prevRowsLength = prevRowsExist ? prevProps.items.length : 0;
        var currentRowsLength = currentRowsExist ? props.items.length : 0;
        // Check if the length of the rows arrays has changed
        var valuesChanged = prevRowsLength !== currentRowsLength;
        // If both is true, we also need to check the lengths of the first element (assuming it's a matrix)
        if (both && !valuesChanged) {
            // Get the length of the columns or 0
            var prevColumnsLength = prevRowsExist && prevProps.items.length > 0 ? prevProps.items[0].length : 0;
            var currentColumnsLength = currentRowsExist && props.items.length > 0 ? props.items[0].length : 0;
            // Check if the length of the columns has changed
            valuesChanged = prevColumnsLength !== currentColumnsLength;
        }
        // If the previous items array doesn't exist or if any values have changed, call the init function
        if (!prevRowsExist || valuesChanged) init();
        var loading = loadingState;
        if (props.lazy && prevProps.loading !== props.loading && props.loading !== loadingState) {
            setLoadingState(props.loading);
            loading = props.loading;
        }
        calculateAutoSize(loading);
    });
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        lastScrollPos.current = both ? {
            top: 0,
            left: 0
        } : 0;
    }, [
        props.orientation
    ]);
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElementRef: getElementRef,
            scrollTo: scrollTo,
            scrollToIndex: scrollToIndex,
            scrollInView: scrollInView,
            getRenderedRange: getRenderedRange
        };
    });
    var createLoaderItem = function createLoaderItem(index) {
        var extOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var options = loaderOptions(index, extOptions);
        var content = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.loadingTemplate, options);
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, {
            key: index
        }, content);
    };
    var createLoader = function createLoader() {
        var iconClassName = 'p-virtualscroller-loading-icon';
        var loadingIconProps = mergeProps({
            className: iconClassName
        }, ptm('loadingIcon'));
        var icon = props.loadingIcon || /*#__PURE__*/ $acw62.createElement((0, $f693dcb2ccf8330b$export$fe708d541030d854), $50cb59e69476e4bf$var$_extends({}, loadingIconProps, {
            spin: true
        }));
        var loadingIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $50cb59e69476e4bf$var$_objectSpread({}, loadingIconProps), {
            props: props
        });
        if (!props.loaderDisabled && props.showLoader && loadingState) {
            var _className = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-virtualscroller-loader', {
                'p-component-overlay': !props.loadingTemplate
            });
            var _content = loadingIcon;
            if (props.loadingTemplate) _content = loaderArrState.map(function(_, index) {
                return createLoaderItem(index, both && {
                    numCols: numItemsInViewportState.cols
                });
            });
            else if (props.loaderIconTemplate) {
                var defaultContentOptions = {
                    iconClassName: iconClassName,
                    element: _content,
                    props: props
                };
                _content = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.loaderIconTemplate, defaultContentOptions);
            }
            var loaderProps = mergeProps({
                className: _className
            }, ptm('loader'));
            return /*#__PURE__*/ $acw62.createElement("div", loaderProps, _content);
        }
        return null;
    };
    var createSpacer = function createSpacer() {
        if (props.showSpacer) {
            var spacerProps = mergeProps({
                ref: _spacerRef,
                style: spacerStyle.current,
                className: 'p-virtualscroller-spacer'
            }, ptm('spacer'));
            return /*#__PURE__*/ $acw62.createElement("div", spacerProps);
        }
        return null;
    };
    var createItem = function createItem(item, index) {
        var options = getOptions(index);
        var content = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.itemTemplate, item, options);
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, {
            key: options.index
        }, content);
    };
    var createItems = function createItems() {
        var items = loadedItems();
        return items.map(createItem);
    };
    var createContent = function createContent() {
        var items = createItems();
        var className = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-virtualscroller-content', {
            'p-virtualscroller-loading': loadingState
        });
        var contentProps = mergeProps({
            ref: _contentRef,
            style: contentStyle.current,
            className: className
        }, ptm('content'));
        var content = /*#__PURE__*/ $acw62.createElement("div", contentProps, items);
        if (props.contentTemplate) {
            var defaultOptions = {
                style: contentStyle.current,
                className: className,
                spacerStyle: spacerStyle.current,
                contentRef: function contentRef(el) {
                    return _contentRef.current = (0, $a73ce425265b079e$export$4855211e6b8ad895).getRefElement(el);
                },
                spacerRef: function spacerRef(el) {
                    return _spacerRef.current = (0, $a73ce425265b079e$export$4855211e6b8ad895).getRefElement(el);
                },
                stickyRef: function stickyRef(el) {
                    return _stickyRef.current = (0, $a73ce425265b079e$export$4855211e6b8ad895).getRefElement(el);
                },
                items: loadedItems(),
                getItemOptions: function getItemOptions(index) {
                    return getOptions(index);
                },
                children: items,
                element: content,
                props: props,
                loading: loadingState,
                getLoaderOptions: function getLoaderOptions(index, ext) {
                    return loaderOptions(index, ext);
                },
                loadingTemplate: props.loadingTemplate,
                itemSize: props.itemSize,
                rows: getRows(),
                columns: getColumns(),
                vertical: vertical,
                horizontal: horizontal,
                both: both
            };
            return (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.contentTemplate, defaultOptions);
        }
        return content;
    };
    if (props.disabled) {
        var _content2 = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.contentTemplate, {
            items: props.items,
            rows: props.items,
            columns: props.columns
        });
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, props.children, _content2);
    }
    var className = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-virtualscroller', {
        'p-virtualscroller-inline': props.inline,
        'p-virtualscroller-both p-both-scroll': both,
        'p-virtualscroller-horizontal p-horizontal-scroll': horizontal
    }, props.className);
    var loader = createLoader();
    var content = createContent();
    var spacer = createSpacer();
    var rootProps = mergeProps({
        ref: elementRef,
        className: className,
        tabIndex: props.tabIndex,
        style: props.style,
        onScroll: function onScroll(e) {
            return _onScroll(e);
        }
    }, $50cb59e69476e4bf$var$VirtualScrollerBase.getOtherProps(props), ptm('root'));
    return /*#__PURE__*/ $acw62.createElement("div", rootProps, content, spacer, loader);
}));
$50cb59e69476e4bf$export$fbd4ea7fe0fb889.displayName = 'VirtualScroller';





'use client';
function $ad3650ac53d907a7$var$_extends() {
    return $ad3650ac53d907a7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ad3650ac53d907a7$var$_extends.apply(null, arguments);
}
function $ad3650ac53d907a7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ad3650ac53d907a7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ad3650ac53d907a7$var$_typeof(o);
}
function $ad3650ac53d907a7$var$toPrimitive(t, r) {
    if ("object" != $ad3650ac53d907a7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ad3650ac53d907a7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ad3650ac53d907a7$var$toPropertyKey(t) {
    var i = $ad3650ac53d907a7$var$toPrimitive(t, "string");
    return "symbol" == $ad3650ac53d907a7$var$_typeof(i) ? i : i + "";
}
function $ad3650ac53d907a7$var$_defineProperty(e, r, t) {
    return (r = $ad3650ac53d907a7$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ad3650ac53d907a7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $ad3650ac53d907a7$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $ad3650ac53d907a7$var$_arrayLikeToArray$1(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $ad3650ac53d907a7$var$_unsupportedIterableToArray$1(r, a) {
    if (r) {
        if ("string" == typeof r) return $ad3650ac53d907a7$var$_arrayLikeToArray$1(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ad3650ac53d907a7$var$_arrayLikeToArray$1(r, a) : void 0;
    }
}
function $ad3650ac53d907a7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ad3650ac53d907a7$var$_slicedToArray(r, e) {
    return $ad3650ac53d907a7$var$_arrayWithHoles(r) || $ad3650ac53d907a7$var$_iterableToArrayLimit(r, e) || $ad3650ac53d907a7$var$_unsupportedIterableToArray$1(r, e) || $ad3650ac53d907a7$var$_nonIterableRest();
}
function $ad3650ac53d907a7$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ad3650ac53d907a7$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ad3650ac53d907a7$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $ad3650ac53d907a7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ad3650ac53d907a7$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ad3650ac53d907a7$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, focusedState = _ref.focusedState, overlayVisibleState = _ref.overlayVisibleState, context = _ref.context;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-dropdown p-component p-inputwrapper', {
            'p-disabled': props.disabled,
            'p-invalid': props.invalid,
            'p-focus': focusedState,
            'p-variant-filled': props.variant ? props.variant === 'filled' : context && context.inputStyle === 'filled',
            'p-dropdown-clearable': props.showClear && !props.disabled,
            'p-inputwrapper-filled': (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.value),
            'p-inputwrapper-focus': focusedState || overlayVisibleState
        });
    },
    input: function input(_ref2) {
        var props = _ref2.props, label = _ref2.label;
        return props.editable ? 'p-dropdown-label p-inputtext' : (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-dropdown-label p-inputtext', {
            'p-placeholder': label === null && props.placeholder,
            'p-dropdown-label-empty': label === null && !props.placeholder
        });
    },
    trigger: 'p-dropdown-trigger',
    emptyMessage: 'p-dropdown-empty-message',
    itemGroup: function itemGroup(_ref3) {
        var optionGroupLabel = _ref3.optionGroupLabel;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-dropdown-item-group', {
            'p-dropdown-item-empty': !optionGroupLabel || optionGroupLabel.length === 0
        });
    },
    itemGroupLabel: 'p-dropdown-item-group-label',
    dropdownIcon: 'p-dropdown-trigger-icon p-clickable',
    loadingIcon: 'p-dropdown-trigger-icon p-clickable',
    clearIcon: 'p-dropdown-clear-icon p-clickable',
    filterIcon: 'p-dropdown-filter-icon',
    filterClearIcon: 'p-dropdown-filter-clear-icon',
    filterContainer: function filterContainer(_ref4) {
        var clearIcon = _ref4.clearIcon;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-dropdown-filter-container', {
            'p-dropdown-clearable-filter': !!clearIcon
        });
    },
    filterInput: function filterInput(_ref5) {
        var props = _ref5.props, context = _ref5.context;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-dropdown-filter p-inputtext p-component', {
            'p-variant-filled': props.variant ? props.variant === 'filled' : context && context.inputStyle === 'filled'
        });
    },
    list: function list(_ref6) {
        var virtualScrollerOptions = _ref6.virtualScrollerOptions;
        return virtualScrollerOptions ? 'p-dropdown-items' : 'p-dropdown-items';
    },
    panel: function panel(_ref7) {
        var context = _ref7.context;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-dropdown-panel p-component', {
            'p-input-filled': context && context.inputStyle === 'filled' || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).inputStyle === 'filled',
            'p-ripple-disabled': context && context.ripple === false || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).ripple === false
        });
    },
    item: function item(_ref8) {
        var selected = _ref8.selected, disabled = _ref8.disabled, label = _ref8.label, index = _ref8.index, focusedOptionIndex = _ref8.focusedOptionIndex, highlightOnSelect = _ref8.highlightOnSelect;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-dropdown-item', {
            'p-highlight': selected && highlightOnSelect,
            'p-disabled': disabled,
            'p-focus': index === focusedOptionIndex,
            'p-dropdown-item-empty': !label || label.length === 0
        });
    },
    itemLabel: 'p-dropdown-item-label',
    checkIcon: 'p-dropdown-check-icon',
    blankIcon: 'p-dropdown-blank-icon',
    wrapper: 'p-dropdown-items-wrapper',
    header: 'p-dropdown-header',
    footer: 'p-dropdown-footer',
    transition: 'p-connected-overlay'
};
var $ad3650ac53d907a7$var$styles = "\n@layer primereact {\n    .p-dropdown {\n        display: inline-flex;\n        cursor: pointer;\n        position: relative;\n        user-select: none;\n    }\n    \n    .p-dropdown-trigger {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n    }\n    \n    .p-dropdown-label {\n        display: block;\n        white-space: nowrap;\n        overflow: hidden;\n        flex: 1 1 auto;\n        width: 1%;\n        text-overflow: ellipsis;\n        cursor: pointer;\n    }\n    \n    .p-dropdown-label-empty {\n        overflow: hidden;\n        visibility: hidden;\n    }\n    \n    input.p-dropdown-label  {\n        cursor: default;\n    }\n    \n    .p-dropdown .p-dropdown-panel {\n        min-width: 100%;\n    }\n    \n    .p-dropdown-panel {\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n    \n    .p-dropdown-items-wrapper {\n        overflow: auto;\n    }\n    \n    .p-dropdown-item {\n        cursor: pointer;\n        font-weight: normal;\n        white-space: nowrap;\n        position: relative;\n        overflow: hidden;\n    }\n    \n    .p-dropdown-items {\n        margin: 0;\n        padding: 0;\n        list-style-type: none;\n    }\n    \n    .p-dropdown-filter {\n        width: 100%;\n    }\n    \n    .p-dropdown-filter-container {\n        position: relative;\n    }\n    \n    .p-dropdown-clear-icon,\n    .p-dropdown-filter-icon,\n    .p-dropdown-filter-clear-icon {\n        position: absolute;\n        top: 50%;\n        margin-top: -.5rem;\n        right: 2rem;\n    }\n    \n    .p-fluid .p-dropdown {\n        display: flex;\n    }\n    \n    .p-fluid .p-dropdown .p-dropdown-label {\n        width: 1%;\n    }\n}\n";
var $ad3650ac53d907a7$var$inlineStyles = {
    wrapper: function wrapper(_ref9) {
        var props = _ref9.props;
        return {
            maxHeight: props.scrollHeight || 'auto'
        };
    },
    panel: function panel(_ref10) {
        var props = _ref10.props;
        return $ad3650ac53d907a7$var$_objectSpread$2({}, props.panelStyle);
    }
};
var $ad3650ac53d907a7$var$DropdownBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'Dropdown',
        __parentMetadata: null,
        appendTo: null,
        ariaLabel: null,
        ariaLabelledBy: null,
        autoFocus: false,
        children: undefined,
        className: null,
        clearIcon: null,
        dataKey: null,
        disabled: false,
        dropdownIcon: null,
        collapseIcon: null,
        editable: false,
        emptyFilterMessage: null,
        highlightOnSelect: true,
        checkmark: false,
        emptyMessage: null,
        filter: false,
        filterBy: null,
        filterClearIcon: null,
        filterIcon: null,
        filterInputAutoFocus: false,
        filterLocale: undefined,
        filterMatchMode: 'contains',
        filterPlaceholder: null,
        filterTemplate: null,
        focusInputRef: null,
        id: null,
        inputId: null,
        inputRef: null,
        invalid: false,
        variant: null,
        itemTemplate: null,
        loading: false,
        loadingIcon: null,
        maxLength: null,
        name: null,
        onBlur: null,
        onChange: null,
        onContextMenu: null,
        onFilter: null,
        onFocus: null,
        onHide: null,
        onMouseDown: null,
        onShow: null,
        optionDisabled: null,
        optionGroupChildren: 'items',
        selectOnFocus: false,
        focusOnHover: true,
        autoOptionFocus: false,
        optionGroupLabel: null,
        optionGroupTemplate: null,
        optionLabel: null,
        optionValue: null,
        options: null,
        panelClassName: null,
        panelFooterTemplate: null,
        panelStyle: null,
        placeholder: null,
        required: false,
        resetFilterOnHide: false,
        scrollHeight: '200px',
        showClear: false,
        showFilterClear: false,
        showOnFocus: false,
        style: null,
        tabIndex: null,
        tooltip: null,
        tooltipOptions: null,
        transitionOptions: null,
        value: null,
        valueTemplate: null,
        virtualScrollerOptions: null
    },
    css: {
        classes: $ad3650ac53d907a7$var$classes,
        styles: $ad3650ac53d907a7$var$styles,
        inlineStyles: $ad3650ac53d907a7$var$inlineStyles
    }
});
var $ad3650ac53d907a7$var$BlankIcon = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $ad3650ac53d907a7$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("rect", {
        width: "1",
        height: "1",
        fill: "currentColor",
        fillOpacity: "0"
    }));
}));
$ad3650ac53d907a7$var$BlankIcon.displayName = 'BlankIcon';
var $ad3650ac53d907a7$var$DropdownItem = /*#__PURE__*/ $acw62.memo(function(props) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var ptm = props.ptm, cx = props.cx, selected = props.selected, disabled = props.disabled, option = props.option, label = props.label, index = props.index, focusedOptionIndex = props.focusedOptionIndex, ariaSetSize = props.ariaSetSize, checkmark = props.checkmark, highlightOnSelect = props.highlightOnSelect, onInputKeyDown = props.onInputKeyDown;
    var getPTOptions = function getPTOptions(key) {
        return ptm(key, {
            context: {
                selected: selected,
                disabled: disabled,
                focused: index === focusedOptionIndex
            }
        });
    };
    var _onClick = function onClick(event, i) {
        if (props.onClick) props.onClick({
            originalEvent: event,
            option: option
        });
    };
    var content = props.template ? (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.template, props.option) : props.label;
    var itemProps = mergeProps({
        id: "dropdownItem_".concat(index),
        role: 'option',
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(option.className, cx('item', {
            selected: selected,
            disabled: disabled,
            label: label,
            index: index,
            focusedOptionIndex: focusedOptionIndex,
            highlightOnSelect: highlightOnSelect
        })),
        style: props.style,
        tabIndex: 0,
        onClick: function onClick(e) {
            return _onClick(e);
        },
        onKeyDown: function onKeyDown(e) {
            return onInputKeyDown(e);
        },
        onMouseMove: function onMouseMove(e) {
            return props === null || props === void 0 ? void 0 : props.onMouseMove(e, index);
        },
        'aria-setsize': ariaSetSize,
        'aria-posinset': index + 1,
        'aria-label': label,
        'aria-selected': selected,
        'data-p-highlight': selected,
        'data-p-focused': focusedOptionIndex === index,
        'data-p-disabled': disabled
    }, getPTOptions('item'));
    var itemGroupLabelProps = mergeProps({
        className: cx('itemLabel')
    }, getPTOptions('itemLabel'));
    var iconRenderer = function iconRenderer() {
        if (selected) {
            var checkIconProps = mergeProps({
                className: cx('checkIcon')
            }, getPTOptions('checkIcon'));
            return /*#__PURE__*/ $acw62.createElement((0, $ed79679a1c3e60de$export$7dd004358974b05d), checkIconProps);
        }
        var blankIconProps = mergeProps({
            className: cx('blankIcon')
        }, getPTOptions('blankIcon'));
        return /*#__PURE__*/ $acw62.createElement($ad3650ac53d907a7$var$BlankIcon, blankIconProps);
    };
    return /*#__PURE__*/ $acw62.createElement("li", $ad3650ac53d907a7$var$_extends({
        key: props.label
    }, itemProps), checkmark && iconRenderer(), /*#__PURE__*/ $acw62.createElement("span", itemGroupLabelProps, content), /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
});
$ad3650ac53d907a7$var$DropdownItem.displayName = 'DropdownItem';
function $ad3650ac53d907a7$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ad3650ac53d907a7$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ad3650ac53d907a7$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $ad3650ac53d907a7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ad3650ac53d907a7$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ad3650ac53d907a7$var$DropdownPanel = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var ptm = props.ptm, cx = props.cx, sx = props.sx;
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var filterInputRef = $acw62.useRef(null);
    var isEmptyFilter = !(props.visibleOptions && props.visibleOptions.length) && props.hasFilter;
    var ariaSetSize = props.visibleOptions ? props.visibleOptions.length : 0;
    var filterOptions = {
        filter: function filter(e) {
            return onFilterInputChange(e);
        },
        reset: function reset() {
            return props.resetFilter();
        }
    };
    var getPTOptions = function getPTOptions(key, options) {
        return ptm(key, $ad3650ac53d907a7$var$_objectSpread$1({
            hostName: props.hostName
        }, options));
    };
    var onEnter = function onEnter() {
        props.onEnter(function() {
            if (props.virtualScrollerRef.current) {
                var selectedIndex = props.getSelectedOptionIndex();
                if (selectedIndex !== -1) setTimeout(function() {
                    return props.virtualScrollerRef.current.scrollToIndex(selectedIndex);
                }, 0);
            }
        });
    };
    var onEntered = function onEntered() {
        props.onEntered(function() {
            if (props.filter && props.filterInputAutoFocus) (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(filterInputRef.current, false);
        });
    };
    var onFilterInputChange = function onFilterInputChange(event) {
        props.onFilterInputChange && props.onFilterInputChange(event);
    };
    var createFooter = function createFooter() {
        if (props.panelFooterTemplate) {
            var content = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.panelFooterTemplate, props, props.onOverlayHide);
            var footerProps = mergeProps({
                className: cx('footer')
            }, getPTOptions('footer'));
            return /*#__PURE__*/ $acw62.createElement("div", footerProps, content);
        }
        return null;
    };
    var changeFocusedItemOnHover = function changeFocusedItemOnHover(event, index) {
        if (props.focusOnHover) {
            var _props$changeFocusedO;
            props === null || props === void 0 || (_props$changeFocusedO = props.changeFocusedOptionIndex) === null || _props$changeFocusedO === void 0 || _props$changeFocusedO.call(props, event, index);
        }
    };
    var createEmptyMessage = function createEmptyMessage(emptyMessage, isFilter) {
        var message = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(emptyMessage, props) || (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)(isFilter ? 'emptyFilterMessage' : 'emptyMessage');
        var emptyMessageProps = mergeProps({
            className: cx('emptyMessage')
        }, getPTOptions('emptyMessage'));
        return /*#__PURE__*/ $acw62.createElement("li", emptyMessageProps, message);
    };
    var createItem = function createItem(option, index) {
        var scrollerOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var style = {
            height: scrollerOptions.props ? scrollerOptions.props.itemSize : undefined
        };
        style = $ad3650ac53d907a7$var$_objectSpread$1($ad3650ac53d907a7$var$_objectSpread$1({}, style), option.style);
        if (option.group && props.optionGroupLabel) {
            var optionGroupLabel = props.optionGroupLabel;
            var groupContent = props.optionGroupTemplate ? (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.optionGroupTemplate, option, index) : props.getOptionGroupLabel(option);
            var key = index + '_' + props.getOptionGroupRenderKey(option);
            var itemGroupProps = mergeProps({
                className: cx('itemGroup', {
                    optionGroupLabel: optionGroupLabel
                }),
                style: style,
                'data-p-highlight': props.selected
            }, getPTOptions('itemGroup'));
            var itemGroupLabelProps = mergeProps({
                className: cx('itemGroupLabel')
            }, getPTOptions('itemGroupLabel'));
            return /*#__PURE__*/ $acw62.createElement("li", $ad3650ac53d907a7$var$_extends({
                key: key
            }, itemGroupProps), /*#__PURE__*/ $acw62.createElement("span", itemGroupLabelProps, groupContent));
        }
        var optionKey = props.getOptionRenderKey(option) + '_' + index;
        var optionLabel = props.getOptionLabel(option);
        var disabled = props.isOptionDisabled(option);
        return /*#__PURE__*/ $acw62.createElement($ad3650ac53d907a7$var$DropdownItem, {
            key: optionKey,
            label: optionLabel,
            index: index,
            focusedOptionIndex: props.focusedOptionIndex,
            option: option,
            ariaSetSize: ariaSetSize,
            onInputKeyDown: props.onInputKeyDown,
            style: style,
            template: props.itemTemplate,
            selected: props.isSelected(option),
            highlightOnSelect: props.highlightOnSelect,
            disabled: disabled,
            onClick: props.onOptionClick,
            onMouseMove: changeFocusedItemOnHover,
            ptm: ptm,
            cx: cx,
            checkmark: props.checkmark
        });
    };
    var createItems = function createItems() {
        if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.visibleOptions)) return props.visibleOptions.map(createItem);
        else if (props.hasFilter) return createEmptyMessage(props.emptyFilterMessage, true);
        return createEmptyMessage(props.emptyMessage);
    };
    var createFilterClearIcon = function createFilterClearIcon() {
        if (props.showFilterClear && props.filterValue) {
            var ariaLabel = (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('clear');
            var clearIconProps = mergeProps({
                className: cx('filterClearIcon'),
                'aria-label': ariaLabel,
                onClick: function onClick() {
                    return props.onFilterClearIconClick(function() {
                        return (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(filterInputRef.current);
                    });
                }
            }, getPTOptions('filterClearIcon'));
            var icon = props.filterClearIcon || /*#__PURE__*/ $acw62.createElement((0, $2a5691e8eb30be5a$export$32edebbf2d9136cc), clearIconProps);
            var filterClearIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $ad3650ac53d907a7$var$_objectSpread$1({}, clearIconProps), {
                props: props
            });
            return filterClearIcon;
        }
        return null;
    };
    var createFilter = function createFilter() {
        if (props.filter) {
            var clearIcon = createFilterClearIcon();
            var filterIconProps = mergeProps({
                className: cx('filterIcon')
            }, getPTOptions('filterIcon'));
            var icon = props.filterIcon || /*#__PURE__*/ $acw62.createElement((0, $dbb1fbeb3f53a92c$export$82eafebb825fc23f), filterIconProps);
            var filterIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $ad3650ac53d907a7$var$_objectSpread$1({}, filterIconProps), {
                props: props
            });
            var filterContainerProps = mergeProps({
                className: cx('filterContainer', {
                    clearIcon: clearIcon
                })
            }, getPTOptions('filterContainer'));
            var filterInputProps = mergeProps({
                ref: filterInputRef,
                type: 'text',
                autoComplete: 'off',
                className: cx('filterInput', {
                    context: context
                }),
                placeholder: props.filterPlaceholder,
                onKeyDown: props.onFilterInputKeyDown,
                onChange: function onChange(e) {
                    return onFilterInputChange(e);
                },
                value: props.filterValue
            }, getPTOptions('filterInput'));
            var content = /*#__PURE__*/ $acw62.createElement("div", filterContainerProps, /*#__PURE__*/ $acw62.createElement("input", filterInputProps), clearIcon, filterIcon);
            if (props.filterTemplate) {
                var defaultContentOptions = {
                    className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-dropdown-filter-container', {
                        'p-dropdown-clearable-filter': !!clearIcon
                    }),
                    element: content,
                    filterOptions: filterOptions,
                    filterInputKeyDown: props.onFilterInputKeyDown,
                    filterInputChange: onFilterInputChange,
                    filterIconClassName: 'p-dropdown-filter-icon',
                    clearIcon: clearIcon,
                    props: props
                };
                content = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.filterTemplate, defaultContentOptions);
            }
            var headerProps = mergeProps({
                className: cx('header')
            }, getPTOptions('header'));
            return /*#__PURE__*/ $acw62.createElement("div", headerProps, content);
        }
        return null;
    };
    var createContent = function createContent() {
        if (props.virtualScrollerOptions) {
            var virtualScrollerProps = $ad3650ac53d907a7$var$_objectSpread$1($ad3650ac53d907a7$var$_objectSpread$1({}, props.virtualScrollerOptions), {
                style: $ad3650ac53d907a7$var$_objectSpread$1($ad3650ac53d907a7$var$_objectSpread$1({}, props.virtualScrollerOptions.style), {
                    height: props.scrollHeight
                }),
                className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-dropdown-items-wrapper', props.virtualScrollerOptions.className),
                items: props.visibleOptions,
                autoSize: true,
                onLazyLoad: function onLazyLoad(event) {
                    return props.virtualScrollerOptions.onLazyLoad($ad3650ac53d907a7$var$_objectSpread$1($ad3650ac53d907a7$var$_objectSpread$1({}, event), {
                        filter: props.filterValue
                    }));
                },
                itemTemplate: function itemTemplate(item, options) {
                    return item && createItem(item, options.index, options);
                },
                contentTemplate: function contentTemplate(options) {
                    var emptyMessage = props.hasFilter ? props.emptyFilterMessage : props.emptyMessage;
                    var content = isEmptyFilter ? createEmptyMessage(emptyMessage) : options.children;
                    var listProps = mergeProps({
                        ref: options.contentRef,
                        style: options.style,
                        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(options.className, cx('list', {
                            virtualScrollerProps: props.virtualScrollerOptions
                        })),
                        role: 'listbox'
                    }, getPTOptions('list'));
                    return /*#__PURE__*/ $acw62.createElement("ul", listProps, content);
                }
            });
            return /*#__PURE__*/ $acw62.createElement((0, $50cb59e69476e4bf$export$fbd4ea7fe0fb889), $ad3650ac53d907a7$var$_extends({
                ref: props.virtualScrollerRef
            }, virtualScrollerProps, {
                pt: ptm('virtualScroller')
            }));
        }
        var items = createItems();
        var wrapperProps = mergeProps({
            className: cx('wrapper'),
            style: sx('wrapper')
        }, getPTOptions('wrapper'));
        var listProps = mergeProps({
            className: cx('list'),
            role: 'listbox'
        }, getPTOptions('list'));
        return /*#__PURE__*/ $acw62.createElement("div", wrapperProps, /*#__PURE__*/ $acw62.createElement("ul", listProps, items));
    };
    var createElement = function createElement() {
        var filter = createFilter();
        var content = createContent();
        var footer = createFooter();
        var panelProps = mergeProps({
            className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.panelClassName, cx('panel', {
                context: context
            })),
            style: sx('panel'),
            onClick: props.onClick
        }, getPTOptions('panel'));
        var transitionProps = mergeProps({
            classNames: cx('transition'),
            "in": props["in"],
            timeout: {
                enter: 120,
                exit: 100
            },
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: onEnter,
            onEntered: onEntered,
            onExit: props.onExit,
            onExited: props.onExited
        }, getPTOptions('transition'));
        return /*#__PURE__*/ $acw62.createElement((0, $17afce1b96f6eaec$export$a7a5590ad6d7af0), $ad3650ac53d907a7$var$_extends({
            nodeRef: ref
        }, transitionProps), /*#__PURE__*/ $acw62.createElement("div", $ad3650ac53d907a7$var$_extends({
            ref: ref
        }, panelProps), props.firstFocusableElement, filter, content, footer, props.lastFocusableElement));
    };
    var element = createElement();
    return /*#__PURE__*/ $acw62.createElement((0, $e7a3b5428092a192$export$602eac185826482c), {
        element: element,
        appendTo: props.appendTo
    });
}));
$ad3650ac53d907a7$var$DropdownPanel.displayName = 'DropdownPanel';
function $ad3650ac53d907a7$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $ad3650ac53d907a7$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $ad3650ac53d907a7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $ad3650ac53d907a7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ad3650ac53d907a7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $ad3650ac53d907a7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $ad3650ac53d907a7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ad3650ac53d907a7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ad3650ac53d907a7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ad3650ac53d907a7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ad3650ac53d907a7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ad3650ac53d907a7$export$931cbfb6bfb85fc = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $ad3650ac53d907a7$var$DropdownBase.getProps(inProps, context);
    var _React$useState = $acw62.useState(''), _React$useState2 = $ad3650ac53d907a7$var$_slicedToArray(_React$useState, 2), filterState = _React$useState2[0], setFilterState = _React$useState2[1];
    var _React$useState3 = $acw62.useState(false), _React$useState4 = $ad3650ac53d907a7$var$_slicedToArray(_React$useState3, 2), focusedState = _React$useState4[0], setFocusedState = _React$useState4[1];
    var _React$useState5 = $acw62.useState(-1), _React$useState6 = $ad3650ac53d907a7$var$_slicedToArray(_React$useState5, 2), focusedOptionIndex = _React$useState6[0], setFocusedOptionIndex = _React$useState6[1];
    var _React$useState7 = $acw62.useState(false), _React$useState8 = $ad3650ac53d907a7$var$_slicedToArray(_React$useState7, 2), overlayVisibleState = _React$useState8[0], setOverlayVisibleState = _React$useState8[1];
    var clickedRef = $acw62.useRef(false);
    var elementRef = $acw62.useRef(null);
    var overlayRef = $acw62.useRef(null);
    var firstHiddenFocusableElementOnOverlay = $acw62.useRef(null);
    var lastHiddenFocusableElementOnOverlay = $acw62.useRef(null);
    var inputRef = $acw62.useRef(props.inputRef);
    var focusInputRef = $acw62.useRef(props.focusInputRef);
    var virtualScrollerRef = $acw62.useRef(null);
    var searchTimeout = $acw62.useRef(null);
    var searchValue = $acw62.useRef(null);
    var isLazy = props.virtualScrollerOptions && props.virtualScrollerOptions.lazy;
    var hasFilter = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(filterState);
    var appendTo = props.appendTo || context && context.appendTo || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).appendTo;
    var _DropdownBase$setMeta = $ad3650ac53d907a7$var$DropdownBase.setMetaData($ad3650ac53d907a7$var$_objectSpread($ad3650ac53d907a7$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        state: {
            filter: filterState,
            focused: focusedState,
            overlayVisible: overlayVisibleState
        }
    })), ptm = _DropdownBase$setMeta.ptm, cx = _DropdownBase$setMeta.cx, sx = _DropdownBase$setMeta.sx, isUnstyled = _DropdownBase$setMeta.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($ad3650ac53d907a7$var$DropdownBase.css.styles, isUnstyled, {
        name: 'dropdown'
    });
    var _useOverlayListener = (0, $fbdf1e36fa0a01d8$export$2fef17345d27a5b4)({
        target: elementRef,
        overlay: overlayRef,
        listener: function listener(event, _ref) {
            var type = _ref.type, valid = _ref.valid;
            if (valid) type === 'outside' ? !isClearClicked(event) && hide() : hide();
        },
        when: overlayVisibleState
    }), _useOverlayListener2 = $ad3650ac53d907a7$var$_slicedToArray(_useOverlayListener, 2), bindOverlayListener = _useOverlayListener2[0], unbindOverlayListener = _useOverlayListener2[1];
    var flatOptions = function flatOptions(options) {
        return (options || []).reduce(function(result, option, index) {
            result.push($ad3650ac53d907a7$var$_objectSpread($ad3650ac53d907a7$var$_objectSpread({}, option), {}, {
                group: true,
                index: index
            }));
            var optionGroupChildren = getOptionGroupChildren(option);
            optionGroupChildren && optionGroupChildren.forEach(function(o) {
                return result.push(o);
            });
            return result;
        }, []);
    };
    var getVisibleOptions = function getVisibleOptions() {
        var options = props.optionGroupLabel ? flatOptions(props.options) : props.options;
        if (hasFilter && !isLazy) {
            var filterValue = filterState.trim().toLocaleLowerCase(props.filterLocale);
            var searchFields = props.filterBy ? props.filterBy.split(',') : [
                props.optionLabel || 'label'
            ];
            if (props.optionGroupLabel) {
                var filteredGroups = [];
                var _iterator = $ad3650ac53d907a7$var$_createForOfIteratorHelper(props.options), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var optgroup = _step.value;
                        var filteredSubOptions = (0, $51b25b42ecc1a0c7$export$f4fb036b8adcc8c8).filter(getOptionGroupChildren(optgroup), searchFields, filterValue, props.filterMatchMode, props.filterLocale);
                        if (filteredSubOptions && filteredSubOptions.length) filteredGroups.push($ad3650ac53d907a7$var$_objectSpread($ad3650ac53d907a7$var$_objectSpread({}, optgroup), $ad3650ac53d907a7$var$_defineProperty({}, "".concat(props.optionGroupChildren), filteredSubOptions)));
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return flatOptions(filteredGroups);
            }
            return (0, $51b25b42ecc1a0c7$export$f4fb036b8adcc8c8).filter(options, searchFields, filterValue, props.filterMatchMode, props.filterLocale);
        }
        return options;
    };
    var onFirstHiddenFocus = function onFirstHiddenFocus(event) {
        var focusableEl = event.relatedTarget === focusInputRef.current ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getFirstFocusableElement(overlayRef.current, ':not([data-p-hidden-focusable="true"])') : focusInputRef.current;
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(focusableEl);
    };
    var onLastHiddenFocus = function onLastHiddenFocus(event) {
        var focusableEl = event.relatedTarget === focusInputRef.current ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getLastFocusableElement(overlayRef.current, ':not([data-p-hidden-focusable="true"])') : focusInputRef.current;
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(focusableEl);
    };
    var isClearClicked = function isClearClicked(event) {
        return (0, $a73ce425265b079e$export$ff8ccbac9225de62).isAttributeEquals(event.target, 'data-pc-section', 'clearicon') || (0, $a73ce425265b079e$export$ff8ccbac9225de62).isAttributeEquals(event.target.parentElement || event.target, 'data-pc-section', 'filterclearicon');
    };
    var _onClick = function onClick(event) {
        if (props.disabled || props.loading) return;
        props.onClick && props.onClick(event);
        // do not continue if the user defined click wants to prevent it
        if (event.defaultPrevented) return;
        if (isClearClicked(event) || event.target.tagName === 'INPUT') return;
        else if (!overlayRef.current || !(overlayRef.current && overlayRef.current.contains(event.target))) {
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(focusInputRef.current);
            overlayVisibleState ? hide() : show();
        }
        event.preventDefault();
        clickedRef.current = true;
    };
    var onInputFocus = function onInputFocus(event) {
        if (props.showOnFocus && !overlayVisibleState) show();
        setFocusedState(true);
        props.onFocus && props.onFocus(event);
    };
    var onInputBlur = function onInputBlur(event) {
        setFocusedState(false);
        if (props.onBlur) setTimeout(function() {
            var currentValue = inputRef.current ? inputRef.current.value : undefined;
            props.onBlur({
                originalEvent: event.originalEvent,
                value: currentValue,
                stopPropagation: function stopPropagation() {
                    event.originalEvent.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event.originalEvent.preventDefault();
                },
                target: {
                    name: props.name,
                    id: props.id,
                    value: currentValue
                }
            });
        }, 200);
    };
    var onOptionSelect = function onOptionSelect(event, option) {
        var isHide = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        selectItem({
            originalEvent: event,
            option: option
        });
        isHide && hide();
    };
    var onPanelClick = function onPanelClick(event) {
        (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).emit('overlay-click', {
            originalEvent: event,
            target: elementRef.current
        });
    };
    var onInputKeyDown = function onInputKeyDown(event) {
        if (props.disabled) {
            event.preventDefault();
            return;
        }
        var metaKey = event.metaKey || event.ctrlKey;
        var code = (0, $a73ce425265b079e$export$ff8ccbac9225de62).isAndroid() ? event.key : event.code;
        switch(code){
            case 'ArrowDown':
                onArrowDownKey(event);
                break;
            case 'ArrowUp':
                onArrowUpKey(event);
                break;
            case 'ArrowLeft':
            case 'ArrowRight':
                onArrowLeftKey(event, props.editable);
                break;
            case 'Home':
                onHomeKey(event);
                break;
            case 'End':
                onEndKey(event);
                break;
            case 'PageDown':
                onPageDownKey(event);
                break;
            case 'PageUp':
                onPageUpKey(event);
                break;
            case 'Space':
                onSpaceKey(event, props.editable);
                break;
            case 'NumpadEnter':
            case 'Enter':
                onEnterKey(event);
                break;
            case 'Escape':
                onEscapeKey(event);
                break;
            case 'Tab':
                onTabKey(event);
                break;
            case 'Backspace':
                onBackspaceKey(event, props.editable);
                break;
            case 'ShiftLeft':
            case 'ShiftRight':
                break;
            default:
                if (!metaKey && (0, $a73ce425265b079e$export$4855211e6b8ad895).isPrintableCharacter(event.key)) {
                    !overlayVisibleState && !props.editable && show();
                    !props.editable && searchOptions(event, event.key);
                }
                break;
        }
        clickedRef.current = false;
    };
    var onFilterInputKeyDown = function onFilterInputKeyDown(event) {
        switch(event.code){
            case 'ArrowDown':
                onArrowDownKey(event);
                break;
            case 'ArrowUp':
                onArrowUpKey(event);
                break;
            case 'ArrowLeft':
            case 'ArrowRight':
                onArrowLeftKey(event, true);
                break;
            case 'Escape':
            case 'Enter':
            case 'NumpadEnter':
                onEnterKey(event);
                event.preventDefault();
                break;
        }
    };
    var hasFocusableElements = function hasFocusableElements() {
        return (0, $a73ce425265b079e$export$ff8ccbac9225de62).getFocusableElements(overlayRef.current, ':not([data-p-hidden-focusable="true"])').length > 0;
    };
    var isOptionMatched = function isOptionMatched(option) {
        var _getOptionLabel;
        return isValidOption(option) && ((_getOptionLabel = getOptionLabel(option)) === null || _getOptionLabel === void 0 ? void 0 : _getOptionLabel.toLocaleLowerCase(props.filterLocale).startsWith(searchValue.current.toLocaleLowerCase(props.filterLocale)));
    };
    var isValidOption = function isValidOption(option) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(option) && !(isOptionDisabled(option) || isOptionGroup(option));
    };
    var hasSelectedOption = function hasSelectedOption() {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.value);
    };
    var isValidSelectedOption = function isValidSelectedOption(option) {
        return isValidOption(option) && isSelected(option);
    };
    var findSelectedOptionIndex = function findSelectedOptionIndex() {
        return hasSelectedOption ? visibleOptions.findIndex(function(option) {
            return isValidSelectedOption(option);
        }) : -1;
    };
    var findFirstFocusedOptionIndex = function findFirstFocusedOptionIndex() {
        var selectedIndex = findSelectedOptionIndex();
        return selectedIndex < 0 ? findFirstOptionIndex() : selectedIndex;
    };
    var searchOptions = function searchOptions(event, _char) {
        searchValue.current = (searchValue.current || '') + _char;
        var optionIndex = -1;
        var matched = false;
        if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(searchValue.current)) {
            if (focusedOptionIndex !== -1) {
                optionIndex = visibleOptions.slice(focusedOptionIndex).findIndex(function(option) {
                    return isOptionMatched(option);
                });
                optionIndex = optionIndex === -1 ? visibleOptions.slice(0, focusedOptionIndex).findIndex(function(option) {
                    return isOptionMatched(option);
                }) : optionIndex + focusedOptionIndex;
            } else optionIndex = visibleOptions.findIndex(function(option) {
                return isOptionMatched(option);
            });
            if (optionIndex !== -1) matched = true;
            if (optionIndex === -1 && focusedOptionIndex === -1) optionIndex = findFirstFocusedOptionIndex();
            if (optionIndex !== -1) changeFocusedOptionIndex(event, optionIndex);
        }
        if (searchTimeout.current) clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(function() {
            searchValue.current = '';
            searchTimeout.current = null;
        }, 500);
        return matched;
    };
    var findLastFocusedOptionIndex = function findLastFocusedOptionIndex() {
        var selectedIndex = findSelectedOptionIndex();
        return selectedIndex < 0 ? findLastOptionIndex() : selectedIndex;
    };
    var findFirstOptionIndex = function findFirstOptionIndex() {
        return visibleOptions.findIndex(function(option) {
            return isValidOption(option);
        });
    };
    var findLastOptionIndex = function findLastOptionIndex() {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).findLastIndex(visibleOptions, function(option) {
            return isValidOption(option);
        });
    };
    var findNextOptionIndex = function findNextOptionIndex(index) {
        var matchedOptionIndex = index < visibleOptions.length - 1 ? visibleOptions.slice(index + 1).findIndex(function(option) {
            return isValidOption(option);
        }) : -1;
        return matchedOptionIndex > -1 ? matchedOptionIndex + index + 1 : index;
    };
    var findPrevOptionIndex = function findPrevOptionIndex(index) {
        var matchedOptionIndex = index > 0 ? (0, $a73ce425265b079e$export$4855211e6b8ad895).findLastIndex(visibleOptions.slice(0, index), function(option) {
            return isValidOption(option);
        }) : -1;
        return matchedOptionIndex > -1 ? matchedOptionIndex : index;
    };
    var changeFocusedOptionIndex = function changeFocusedOptionIndex(event, index) {
        if (focusedOptionIndex !== index) {
            setFocusedOptionIndex(index);
            focusOnItem(index);
            if (props.selectOnFocus) onOptionSelect(event, visibleOptions[index], false);
        }
    };
    var focusOnItem = function focusOnItem(index) {
        var focusedItem = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(overlayRef.current, "li[id=\"dropdownItem_".concat(index, "\"]"));
        focusedItem && focusedItem.focus();
    };
    var onArrowDownKey = function onArrowDownKey(event) {
        if (!overlayVisibleState) {
            show();
            props.editable && changeFocusedOptionIndex(event, findSelectedOptionIndex());
        } else {
            var optionIndex = focusedOptionIndex !== -1 ? findNextOptionIndex(focusedOptionIndex) : clickedRef.current ? findFirstOptionIndex() : findFirstFocusedOptionIndex();
            changeFocusedOptionIndex(event, optionIndex);
        }
        event.preventDefault();
    };
    var onArrowUpKey = function onArrowUpKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (event.altKey && !pressedInInputText) {
            if (focusedOptionIndex !== -1) onOptionSelect(event, visibleOptions[focusedOptionIndex]);
            state.overlayVisible && hide();
            event.preventDefault();
        } else {
            var optionIndex = focusedOptionIndex !== -1 ? findPrevOptionIndex(focusedOptionIndex) : clickedRef.current ? findLastOptionIndex() : findLastFocusedOptionIndex();
            changeFocusedOptionIndex(event, optionIndex);
            !overlayVisibleState && show();
            event.preventDefault();
        }
    };
    var onArrowLeftKey = function onArrowLeftKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        pressedInInputText && setFocusedOptionIndex(-1);
    };
    var onHomeKey = function onHomeKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (pressedInInputText) {
            event.currentTarget.setSelectionRange(0, 0);
            setFocusedOptionIndex(-1);
        } else {
            changeFocusedOptionIndex(event, findFirstOptionIndex());
            !overlayVisibleState && show();
        }
        event.preventDefault();
    };
    var onEndKey = function onEndKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (pressedInInputText) {
            var target = event.currentTarget;
            var len = target.value.length;
            target.setSelectionRange(len, len);
            setFocusedOptionIndex(-1);
        } else {
            changeFocusedOptionIndex(event, findLastOptionIndex());
            !overlayVisibleState && show();
        }
        event.preventDefault();
    };
    var onPageUpKey = function onPageUpKey(event) {
        event.preventDefault();
    };
    var onPageDownKey = function onPageDownKey(event) {
        event.preventDefault();
    };
    var onSpaceKey = function onSpaceKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        !pressedInInputText && onEnterKey(event);
    };
    var onEnterKey = function onEnterKey(event) {
        if (!overlayVisibleState) {
            setFocusedOptionIndex(-1);
            onArrowDownKey(event);
        } else {
            if (focusedOptionIndex !== -1) onOptionSelect(event, visibleOptions[focusedOptionIndex]);
            hide();
        }
        event.preventDefault();
    };
    var onEscapeKey = function onEscapeKey(event) {
        overlayVisibleState && hide();
        event.preventDefault();
    };
    var onTabKey = function onTabKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (!pressedInInputText) {
            if (overlayVisibleState && !hasFocusableElements()) {
                (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(firstHiddenFocusableElementOnOverlay.current);
                event.preventDefault();
            } else {
                if (focusedOptionIndex !== -1) onOptionSelect(event, visibleOptions[focusedOptionIndex]);
                overlayVisibleState && hide();
            }
        }
    };
    var onBackspaceKey = function onBackspaceKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (event && pressedInInputText) !overlayVisibleState && show();
    };
    var onEditableInputChange = function onEditableInputChange(event) {
        !overlayVisibleState && show();
        var searchIndex = null;
        if (event.target.value && visibleOptions) searchIndex = visibleOptions.findIndex(function(item) {
            return getOptionLabel(item).toLocaleLowerCase().startsWith(event.target.value.toLocaleLowerCase());
        });
        setFocusedOptionIndex(searchIndex);
        if (props.onChange) props.onChange({
            originalEvent: event.originalEvent,
            value: event.target.value,
            stopPropagation: function stopPropagation() {
                event.originalEvent.stopPropagation();
            },
            preventDefault: function preventDefault() {
                event.originalEvent.preventDefault();
            },
            target: {
                name: props.name,
                id: props.id,
                value: event.target.value
            }
        });
    };
    var onEditableInputFocus = function onEditableInputFocus(event) {
        setFocusedState(true);
        hide();
        props.onFocus && props.onFocus(event);
    };
    var onOptionClick = function onOptionClick(event) {
        var option = event.option;
        if (!option.disabled) {
            selectItem(event);
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(focusInputRef.current);
        }
        hide();
    };
    var onFilterInputChange = function onFilterInputChange(event) {
        var filter = event.target.value;
        setFilterState(filter);
        if (props.onFilter) props.onFilter({
            originalEvent: event,
            filter: filter
        });
    };
    var onFilterClearIconClick = function onFilterClearIconClick(callback) {
        resetFilter(callback);
    };
    var resetFilter = function resetFilter(callback) {
        setFilterState('');
        props.onFilter && props.onFilter({
            filter: ''
        });
        callback && callback();
    };
    var clear = function clear(event) {
        if (props.onChange) props.onChange({
            originalEvent: event,
            value: undefined,
            stopPropagation: function stopPropagation() {
                event === null || event === void 0 || event.stopPropagation();
            },
            preventDefault: function preventDefault() {
                event === null || event === void 0 || event.preventDefault();
            },
            target: {
                name: props.name,
                id: props.id,
                value: undefined
            }
        });
        if (props.filter) resetFilter();
        updateEditableLabel();
    };
    var selectItem = function selectItem(event) {
        if (selectedOption !== event.option) {
            updateEditableLabel(event.option);
            setFocusedOptionIndex(-1);
            var optionValue = getOptionValue(event.option);
            var selectedOptionIndex = findOptionIndexInList(event.option, visibleOptions);
            if (props.onChange) props.onChange({
                originalEvent: event.originalEvent,
                value: optionValue,
                stopPropagation: function stopPropagation() {
                    event.originalEvent.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event.originalEvent.preventDefault();
                },
                target: {
                    name: props.name,
                    id: props.id,
                    value: optionValue
                }
            });
            changeFocusedOptionIndex(event.originalEvent, selectedOptionIndex);
        }
    };
    var getSelectedOptionIndex = function getSelectedOptionIndex(options) {
        options = options || visibleOptions;
        if (options) {
            if (props.optionGroupLabel) for(var i = 0; i < options.length; i++){
                var selectedOptionIndex = findOptionIndexInList(props.value, getOptionGroupChildren(options[i]));
                if (selectedOptionIndex !== -1) return {
                    group: i,
                    option: selectedOptionIndex
                };
            }
            else return findOptionIndexInList(props.value, options);
        }
        return -1;
    };
    var equalityKey = function equalityKey() {
        return props.optionValue ? null : props.dataKey;
    };
    var findOptionIndexInList = function findOptionIndexInList(value, list) {
        var key = equalityKey();
        return list.findIndex(function(item) {
            return (0, $a73ce425265b079e$export$4855211e6b8ad895).equals(value, getOptionValue(item), key);
        });
    };
    var isSelected = function isSelected(option) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).equals(props.value, getOptionValue(option), equalityKey());
    };
    var show = function show() {
        setFocusedOptionIndex(focusedOptionIndex !== -1 ? focusedOptionIndex : props.autoOptionFocus ? findFirstFocusedOptionIndex() : props.editable ? -1 : findSelectedOptionIndex());
        setOverlayVisibleState(true);
    };
    var hide = function hide() {
        setOverlayVisibleState(false);
        clickedRef.current = false;
    };
    var onFocus = function onFocus() {
        if (props.editable && !overlayVisibleState && clickedRef.current === false) (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current);
    };
    var onOverlayEnter = function onOverlayEnter(callback) {
        (0, $a73ce425265b079e$export$832931caede8e4b9).set('overlay', overlayRef.current, context && context.autoZIndex || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).autoZIndex, context && context.zIndex.overlay || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).zIndex.overlay);
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).addStyles(overlayRef.current, {
            position: 'absolute',
            top: '0',
            left: '0'
        });
        alignOverlay();
        callback && callback();
    };
    var onOverlayEntered = function onOverlayEntered(callback) {
        callback && callback();
        bindOverlayListener();
        props.onShow && props.onShow();
    };
    var onOverlayExit = function onOverlayExit() {
        unbindOverlayListener();
    };
    var onOverlayExited = function onOverlayExited() {
        if (props.filter && props.resetFilterOnHide) resetFilter();
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(overlayRef.current);
        props.onHide && props.onHide();
    };
    var alignOverlay = function alignOverlay() {
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).alignOverlay(overlayRef.current, inputRef.current.parentElement, props.appendTo || context && context.appendTo || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).appendTo);
    };
    var scrollInView = function scrollInView() {
        var focusedItem = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(overlayRef.current, 'li[data-p-focused="true"]');
        if (focusedItem && focusedItem.scrollIntoView) focusedItem.scrollIntoView({
            block: 'nearest',
            inline: 'nearest'
        });
        else {
            var highlightItem = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(overlayRef.current, 'li[data-p-highlight="true"]');
            if (highlightItem && highlightItem.scrollIntoView) highlightItem.scrollIntoView({
                block: 'nearest',
                inline: 'nearest'
            });
        }
    };
    var updateEditableLabel = function updateEditableLabel(option) {
        if (inputRef.current) {
            inputRef.current.value = option ? getOptionLabel(option) : props.value || '';
            // #1413 NVDA screenreader
            if (focusInputRef.current) focusInputRef.current.value = inputRef.current.value;
        }
    };
    var getOptionLabel = function getOptionLabel(option) {
        if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isScalar(option)) return "".concat(option);
        var optionLabel = props.optionLabel ? (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(option, props.optionLabel) : option['label'];
        return "".concat(optionLabel);
    };
    var getOptionValue = function getOptionValue(option) {
        if (props.useOptionAsValue) return option;
        var optionValue = props.optionValue ? (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(option, props.optionValue) : option ? option['value'] : (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(option, 'value');
        return props.optionValue || (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(optionValue) ? optionValue : option;
    };
    var getOptionRenderKey = function getOptionRenderKey(option) {
        return props.dataKey ? (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(option, props.dataKey) : getOptionLabel(option);
    };
    var isOptionGroup = function isOptionGroup(option) {
        return props.optionGroupLabel && option.group;
    };
    var isOptionDisabled = function isOptionDisabled(option) {
        if (props.optionDisabled) return (0, $a73ce425265b079e$export$4855211e6b8ad895).isFunction(props.optionDisabled) ? props.optionDisabled(option) : (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(option, props.optionDisabled);
        return option && option.disabled !== undefined ? option.disabled : false;
    };
    var getOptionGroupRenderKey = function getOptionGroupRenderKey(optionGroup) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(optionGroup, props.optionGroupLabel);
    };
    var getOptionGroupLabel = function getOptionGroupLabel(optionGroup) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(optionGroup, props.optionGroupLabel);
    };
    var getOptionGroupChildren = function getOptionGroupChildren(optionGroup) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(optionGroup, props.optionGroupChildren);
    };
    var updateInputField = function updateInputField() {
        if (props.editable && inputRef.current) {
            var label = selectedOption ? getOptionLabel(selectedOption) : null;
            var value = label || props.value || '';
            inputRef.current.value = value;
            // #1413 NVDA screenreader
            if (focusInputRef.current) focusInputRef.current.value = value;
        }
    };
    var getSelectedOption = function getSelectedOption() {
        var index = getSelectedOptionIndex(props.options);
        return index !== -1 ? props.optionGroupLabel ? getOptionGroupChildren(props.options[index.group])[index.option] : props.options[index] : null;
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            show: show,
            hide: hide,
            clear: clear,
            focus: function focus() {
                return (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(focusInputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getOverlay: function getOverlay() {
                return overlayRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            },
            getFocusInput: function getFocusInput() {
                return focusInputRef.current;
            },
            getVirtualScroller: function getVirtualScroller() {
                return virtualScrollerRef.current;
            }
        };
    });
    $acw62.useEffect(function() {
        (0, $a73ce425265b079e$export$4855211e6b8ad895).combinedRefs(inputRef, props.inputRef);
        (0, $a73ce425265b079e$export$4855211e6b8ad895).combinedRefs(focusInputRef, props.focusInputRef);
    }, [
        inputRef,
        props.inputRef,
        focusInputRef,
        props.focusInputRef
    ]);
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        if (props.autoFocus) (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(focusInputRef.current, props.autoFocus);
        alignOverlay();
    });
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (overlayVisibleState && (props.value || focusedOptionIndex >= 0)) scrollInView();
    }, [
        overlayVisibleState,
        props.value,
        focusedOptionIndex
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (overlayVisibleState && filterState && props.filter) alignOverlay();
    }, [
        overlayVisibleState,
        filterState,
        props.filter
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        virtualScrollerRef.current && virtualScrollerRef.current.scrollInView(0);
    }, [
        filterState
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (filterState && (!props.options || props.options.length === 0)) setFilterState('');
        updateInputField();
        if (inputRef.current) inputRef.current.selectedIndex = 1;
    });
    (0, $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96)(function() {
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(overlayRef.current);
    });
    var createHiddenSelect = function createHiddenSelect() {
        var option = {
            value: '',
            label: props.placeholder
        };
        if (selectedOption) {
            var optionValue = getOptionValue(selectedOption);
            option = {
                value: $ad3650ac53d907a7$var$_typeof(optionValue) === 'object' ? props.options.findIndex(function(o) {
                    return o === optionValue;
                }) : optionValue,
                label: getOptionLabel(selectedOption)
            };
        }
        var hiddenSelectedMessageProps = mergeProps({
            className: 'p-hidden-accessible p-dropdown-hidden-select'
        }, ptm('hiddenSelectedMessage'));
        var selectProps = mergeProps({
            ref: inputRef,
            required: props.required,
            defaultValue: option.value,
            name: props.name,
            tabIndex: -1,
            'aria-hidden': 'true'
        }, ptm('select'));
        var optionProps = mergeProps({
            value: option.value
        }, ptm('option'));
        return /*#__PURE__*/ $acw62.createElement("div", hiddenSelectedMessageProps, /*#__PURE__*/ $acw62.createElement("select", selectProps, /*#__PURE__*/ $acw62.createElement("option", optionProps, option.label)));
    };
    var createKeyboardHelper = function createKeyboardHelper() {
        var value = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(selectedOption) ? getOptionLabel(selectedOption) : null;
        if (props.editable) value = value || props.value || '';
        var hiddenSelectedMessageProps = mergeProps({
            className: 'p-hidden-accessible'
        }, ptm('hiddenSelectedMessage'));
        var inputProps = mergeProps($ad3650ac53d907a7$var$_objectSpread({
            ref: focusInputRef,
            id: props.inputId,
            defaultValue: value,
            type: 'text',
            readOnly: true,
            'aria-haspopup': 'listbox',
            onFocus: onInputFocus,
            onBlur: onInputBlur,
            onKeyDown: onInputKeyDown,
            disabled: props.disabled,
            tabIndex: !props.disabled ? props.tabIndex || 0 : -1
        }, ariaProps), ptm('input'));
        return /*#__PURE__*/ $acw62.createElement("div", hiddenSelectedMessageProps, /*#__PURE__*/ $acw62.createElement("input", inputProps));
    };
    var createLabel = function createLabel() {
        var label = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(selectedOption) ? getOptionLabel(selectedOption) : null;
        if (props.editable) {
            var value = label || props.value || '';
            var _inputProps = mergeProps($ad3650ac53d907a7$var$_objectSpread({
                ref: inputRef,
                type: 'text',
                defaultValue: value,
                className: cx('input', {
                    label: label
                }),
                disabled: props.disabled,
                placeholder: props.placeholder,
                maxLength: props.maxLength,
                onInput: onEditableInputChange,
                onFocus: onEditableInputFocus,
                onKeyDown: onInputKeyDown,
                onBlur: onInputBlur,
                tabIndex: !props.disabled ? props.tabIndex || 0 : -1,
                'aria-haspopup': 'listbox'
            }, ariaProps), ptm('input'));
            return /*#__PURE__*/ $acw62.createElement("input", _inputProps);
        }
        var content = props.valueTemplate ? (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.valueTemplate, selectedOption, props) : label || props.placeholder || props.emptyMessage || /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, "\xA0");
        var inputProps = mergeProps({
            ref: inputRef,
            className: cx('input', {
                label: label
            }),
            tabIndex: '-1'
        }, ptm('input'));
        return /*#__PURE__*/ $acw62.createElement("span", inputProps, content);
    };
    var onClearIconKeyDown = function onClearIconKeyDown(event) {
        if (event.key === 'Enter' || event.code === 'Space') {
            clear(event);
            event.preventDefault();
        }
    };
    var createClearIcon = function createClearIcon() {
        if (props.value != null && props.showClear && !props.disabled && !(0, $a73ce425265b079e$export$4855211e6b8ad895).isEmpty(props.options)) {
            var clearIconProps = mergeProps({
                className: cx('clearIcon'),
                onPointerUp: clear,
                tabIndex: props.tabIndex || '0',
                onKeyDown: onClearIconKeyDown,
                'aria-label': (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('clear')
            }, ptm('clearIcon'));
            var icon = props.clearIcon || /*#__PURE__*/ $acw62.createElement((0, $2a5691e8eb30be5a$export$32edebbf2d9136cc), clearIconProps);
            return (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $ad3650ac53d907a7$var$_objectSpread({}, clearIconProps), {
                props: props
            });
        }
        return null;
    };
    var createLoadingIcon = function createLoadingIcon() {
        var loadingIconProps = mergeProps({
            className: cx('loadingIcon'),
            'data-pr-overlay-visible': overlayVisibleState
        }, ptm('loadingIcon'));
        var icon = props.loadingIcon || /*#__PURE__*/ $acw62.createElement((0, $f693dcb2ccf8330b$export$fe708d541030d854), {
            spin: true
        });
        var loadingIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $ad3650ac53d907a7$var$_objectSpread({}, loadingIconProps), {
            props: props
        });
        var ariaLabel = props.placeholder || props.ariaLabel;
        var loadingButtonProps = mergeProps({
            className: cx('trigger'),
            role: 'button',
            'aria-haspopup': 'listbox',
            'aria-expanded': overlayVisibleState,
            'aria-label': ariaLabel
        }, ptm('trigger'));
        return /*#__PURE__*/ $acw62.createElement("div", loadingButtonProps, loadingIcon);
    };
    var createDropdownIcon = function createDropdownIcon() {
        var dropdownIconProps = mergeProps({
            className: cx('dropdownIcon'),
            'data-pr-overlay-visible': overlayVisibleState
        }, ptm('dropdownIcon'));
        var icon = !overlayVisibleState ? props.dropdownIcon || /*#__PURE__*/ $acw62.createElement((0, $2539671ba6368b77$export$4857d3f3f5f8319b), dropdownIconProps) : props.collapseIcon || /*#__PURE__*/ $acw62.createElement((0, $a26a14ced485563c$export$7f01a6cbee61a0f2), dropdownIconProps);
        var dropdownIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $ad3650ac53d907a7$var$_objectSpread({}, dropdownIconProps), {
            props: props
        });
        var ariaLabel = props.placeholder || props.ariaLabel;
        var triggerProps = mergeProps({
            className: cx('trigger'),
            role: 'button',
            'aria-haspopup': 'listbox',
            'aria-expanded': overlayVisibleState,
            'aria-label': ariaLabel
        }, ptm('trigger'));
        return /*#__PURE__*/ $acw62.createElement("div", triggerProps, dropdownIcon);
    };
    var visibleOptions = getVisibleOptions();
    var selectedOption = getSelectedOption();
    var hasTooltip = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.tooltip);
    var otherProps = $ad3650ac53d907a7$var$DropdownBase.getOtherProps(props);
    var ariaProps = (0, $a73ce425265b079e$export$4855211e6b8ad895).reduceKeys(otherProps, (0, $a73ce425265b079e$export$ff8ccbac9225de62).ARIA_PROPS);
    var hiddenSelect = createHiddenSelect();
    var keyboardHelper = createKeyboardHelper();
    var labelElement = createLabel();
    var dropdownIcon = props.loading ? createLoadingIcon() : createDropdownIcon();
    var clearIcon = createClearIcon();
    var rootProps = mergeProps({
        id: props.id,
        ref: elementRef,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root', {
            context: context,
            focusedState: focusedState,
            overlayVisibleState: overlayVisibleState
        })),
        style: props.style,
        onClick: function onClick(e) {
            return _onClick(e);
        },
        onMouseDown: props.onMouseDown,
        onContextMenu: props.onContextMenu,
        onFocus: onFocus,
        'data-p-disabled': props.disabled,
        'data-p-focus': focusedState,
        'aria-activedescendant': focusedState ? "dropdownItem_".concat(focusedOptionIndex) : undefined
    }, otherProps, ptm('root'));
    var firstHiddenFocusableElementProps = mergeProps({
        ref: firstHiddenFocusableElementOnOverlay,
        role: 'presentation',
        'aria-hidden': 'true',
        className: 'p-hidden-accessible p-hidden-focusable',
        tabIndex: '0',
        onFocus: onFirstHiddenFocus,
        'data-p-hidden-accessible': true,
        'data-p-hidden-focusable': true
    }, ptm('hiddenFirstFocusableEl'));
    var lastHiddenFocusableElementProps = mergeProps({
        ref: lastHiddenFocusableElementOnOverlay,
        role: 'presentation',
        'aria-hidden': 'true',
        className: 'p-hidden-accessible p-hidden-focusable',
        tabIndex: '0',
        onFocus: onLastHiddenFocus,
        'data-p-hidden-accessible': true,
        'data-p-hidden-focusable': true
    }, ptm('hiddenLastFocusableEl'));
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", rootProps, keyboardHelper, hiddenSelect, labelElement, clearIcon, dropdownIcon, /*#__PURE__*/ $acw62.createElement($ad3650ac53d907a7$var$DropdownPanel, $ad3650ac53d907a7$var$_extends({
        hostName: "Dropdown",
        ref: overlayRef,
        visibleOptions: visibleOptions,
        virtualScrollerRef: virtualScrollerRef
    }, props, {
        appendTo: appendTo,
        cx: cx,
        filterValue: filterState,
        focusedOptionIndex: focusedOptionIndex,
        getOptionGroupChildren: getOptionGroupChildren,
        getOptionGroupLabel: getOptionGroupLabel,
        getOptionGroupRenderKey: getOptionGroupRenderKey,
        getOptionLabel: getOptionLabel,
        getOptionRenderKey: getOptionRenderKey,
        getSelectedOptionIndex: getSelectedOptionIndex,
        hasFilter: hasFilter,
        "in": overlayVisibleState,
        isOptionDisabled: isOptionDisabled,
        isSelected: isSelected,
        onClick: onPanelClick,
        onEnter: onOverlayEnter,
        onEntered: onOverlayEntered,
        onExit: onOverlayExit,
        onExited: onOverlayExited,
        onFilterClearIconClick: onFilterClearIconClick,
        onFilterInputChange: onFilterInputChange,
        onFilterInputKeyDown: onFilterInputKeyDown,
        onOptionClick: onOptionClick,
        onInputKeyDown: onInputKeyDown,
        ptm: ptm,
        resetFilter: resetFilter,
        changeFocusedOptionIndex: changeFocusedOptionIndex,
        firstFocusableElement: /*#__PURE__*/ $acw62.createElement("span", firstHiddenFocusableElementProps),
        lastFocusableElement: /*#__PURE__*/ $acw62.createElement("span", lastHiddenFocusableElementProps),
        sx: sx
    }))), hasTooltip && /*#__PURE__*/ $acw62.createElement((0, $b74dfa9f7ee9d9bc$export$28c660c63b792dea), $ad3650ac53d907a7$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm('tooltip')
    }, props.tooltipOptions)));
}));
$ad3650ac53d907a7$export$931cbfb6bfb85fc.displayName = 'Dropdown';



var $acw62 = parcelRequire("acw62");
function $193f2811aaebee8a$export$260594f1c0239dfe({ propertyName: propertyName, initialVal: initialVal, label: label, id: id, options: options, onDone: onDone, itemTemplate: itemTemplate, valueTemplate: valueTemplate, showClear: showClear, filter: filter, filterBy: filterBy, filterInputAutoFocus: filterInputAutoFocus, optionValue: optionValue, optionLabel: optionLabel = 'name' }) {
    const [selectedOption, setSelectedOption] = (0, $acw62.useState)(initialVal);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: id + '-' + propertyName,
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad3650ac53d907a7$export$931cbfb6bfb85fc), {
                value: selectedOption,
                inputId: id + '-' + propertyName,
                onChange: (e)=>{
                    setSelectedOption(e.value);
                    onDone(propertyName, e.value);
                },
                options: options,
                placeholder: "(prosz\u0119 wybra\u0107)",
                className: "w-full",
                itemTemplate: itemTemplate,
                valueTemplate: valueTemplate,
                showClear: showClear,
                filter: filter,
                filterBy: filterBy,
                filterInputAutoFocus: filterInputAutoFocus,
                optionLabel: optionLabel,
                optionValue: optionValue,
                style: {
                    maxWidth: '437.25px'
                }
            })
        ]
    });
}






var $acw62 = parcelRequire("acw62");
function $1aa42f680c61ccaa$export$f2e335d0f285264e({ propertyName: propertyName, initialVal: initialVal, label: label, id: id, options: options, onDone: onDone }) {
    const [selectedOption, setSelectedOption] = (0, $acw62.useState)(initialVal);
    const stopTemplate = (option)=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex align-items-center",
            children: [
                "\uD83D\uDE8F ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-200 text-xs ml-1 mr-2",
                    children: option.stop_id
                }),
                " ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mr-2",
                    children: option.stop_name
                }),
                " ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a79a81cc3b591c5$export$5d8a4b9af9ca5f5b), {
                    platformCode: option.platform_code
                })
            ]
        });
    };
    const selectedStopTemplate = (option, props)=>{
        if (option) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex align-items-center",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-200 text-xs ml-1 mr-2",
                    children: option.stop_id
                }),
                " ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mr-2",
                    children: option.stop_name
                }),
                " ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a79a81cc3b591c5$export$5d8a4b9af9ca5f5b), {
                    platformCode: option.platform_code
                })
            ]
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            children: props.placeholder
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: id + '-' + propertyName,
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad3650ac53d907a7$export$931cbfb6bfb85fc), {
                filter: true,
                showClear: true,
                value: selectedOption,
                inputId: id + '-' + propertyName,
                onChange: (e)=>{
                    setSelectedOption(e.value);
                    onDone(propertyName, e.value);
                },
                options: options,
                itemTemplate: stopTemplate,
                valueTemplate: selectedStopTemplate,
                optionLabel: "stop_name",
                optionValue: "stop_id",
                filterBy: "stop_name,stop_id,stop_code,platform_code",
                placeholder: "(prosz\u0119 wybra\u0107)",
                virtualScrollerOptions: {
                    itemSize: 38
                },
                className: "w-full"
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");






'use client';
function $3deef212c81ef57f$var$_extends() {
    return $3deef212c81ef57f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3deef212c81ef57f$var$_extends.apply(null, arguments);
}
function $3deef212c81ef57f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $3deef212c81ef57f$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $3deef212c81ef57f$var$_arrayLikeToArray(r);
}
function $3deef212c81ef57f$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $3deef212c81ef57f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3deef212c81ef57f$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3deef212c81ef57f$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $3deef212c81ef57f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3deef212c81ef57f$var$_toConsumableArray(r) {
    return $3deef212c81ef57f$var$_arrayWithoutHoles(r) || $3deef212c81ef57f$var$_iterableToArray(r) || $3deef212c81ef57f$var$_unsupportedIterableToArray(r) || $3deef212c81ef57f$var$_nonIterableSpread();
}
function $3deef212c81ef57f$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $3deef212c81ef57f$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3deef212c81ef57f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3deef212c81ef57f$var$_slicedToArray(r, e) {
    return $3deef212c81ef57f$var$_arrayWithHoles(r) || $3deef212c81ef57f$var$_iterableToArrayLimit(r, e) || $3deef212c81ef57f$var$_unsupportedIterableToArray(r, e) || $3deef212c81ef57f$var$_nonIterableRest();
}
var $3deef212c81ef57f$var$classes = {
    root: function root(_ref) {
        var props = _ref.props;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-selectbutton p-button-group p-component', {
            'p-invalid': props.invalid
        });
    },
    button: function button(_ref2) {
        var props = _ref2.itemProps, focusedState = _ref2.focusedState;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-button p-component', {
            'p-highlight': props.selected,
            'p-disabled': props.disabled,
            'p-focus': focusedState
        });
    },
    label: 'p-button-label p-c'
};
var $3deef212c81ef57f$var$SelectButtonBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'SelectButton',
        id: null,
        value: null,
        options: null,
        optionLabel: null,
        optionValue: null,
        optionDisabled: null,
        tabIndex: null,
        multiple: false,
        invalid: false,
        unselectable: true,
        allowEmpty: true,
        disabled: false,
        style: null,
        className: null,
        dataKey: null,
        tooltip: null,
        tooltipOptions: null,
        itemTemplate: null,
        onChange: null,
        children: undefined
    },
    css: {
        classes: $3deef212c81ef57f$var$classes
    }
});
var $3deef212c81ef57f$var$SelectButtonItem = /*#__PURE__*/ $acw62.memo(function(props) {
    var _React$useState = $acw62.useState(false), _React$useState2 = $3deef212c81ef57f$var$_slicedToArray(_React$useState, 2), focusedState = _React$useState2[0], setFocusedState = _React$useState2[1];
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var ptm = props.ptm, cx = props.cx;
    var getPTOptions = function getPTOptions(key) {
        return ptm(key, {
            hostName: props.hostName,
            context: {
                selected: props.selected,
                disabled: props.disabled,
                option: props.option
            }
        });
    };
    var _onClick = function onClick(event, index) {
        props.setFocusedIndex(index);
        if (props.onClick) props.onClick({
            originalEvent: event,
            option: props.option
        });
    };
    var onFocus = function onFocus() {
        setFocusedState(true);
    };
    var onBlur = function onBlur() {
        setFocusedState(false);
    };
    var _onKeyDown = function onKeyDown(event, index) {
        switch(event.code){
            case 'Space':
                _onClick(event, index);
                event.preventDefault();
                break;
            case 'ArrowDown':
            case 'ArrowRight':
                changeTabIndexes(event, 'next');
                event.preventDefault();
                break;
            case 'ArrowUp':
            case 'ArrowLeft':
                changeTabIndexes(event, 'prev');
                event.preventDefault();
                break;
        }
    };
    var changeTabIndexes = function changeTabIndexes(event, direction) {
        var firstTabableChild;
        var index;
        for(var i = 0; i <= props.elementRef.current.children.length - 1; i++)if (props.elementRef.current.children[i].getAttribute('tabindex') === '0') firstTabableChild = {
            elem: props.elementRef.current.children[i],
            index: i
        };
        if (direction === 'prev') {
            if (firstTabableChild.index === 0) index = props.elementRef.current.children.length - 1;
            else index = firstTabableChild.index - 1;
        } else if (firstTabableChild.index === props.elementRef.current.children.length - 1) index = 0;
        else index = firstTabableChild.index + 1;
        props.setFocusedIndex(index);
        props.elementRef.current.children[index].focus();
    };
    var createContent = function createContent() {
        var labelProps = mergeProps({
            className: cx('label')
        }, getPTOptions('label'));
        return props.template ? (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.template, props.option) : /*#__PURE__*/ $acw62.createElement("span", labelProps, props.label);
    };
    var content = createContent();
    var buttonProps = mergeProps({
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('button', {
            itemProps: props,
            focusedState: focusedState
        })),
        role: 'button',
        'aria-label': props.label,
        'aria-pressed': props.selected,
        onClick: function onClick(event) {
            return _onClick(event, props.index);
        },
        onKeyDown: function onKeyDown(event) {
            return _onKeyDown(event, props.index);
        },
        tabIndex: props.tabIndex,
        'aria-disabled': props.disabled,
        onFocus: onFocus,
        onBlur: onBlur
    }, getPTOptions('button'));
    return /*#__PURE__*/ $acw62.createElement("div", buttonProps, content, !props.disabled && /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
});
$3deef212c81ef57f$var$SelectButtonItem.displayName = 'SelectButtonItem';
var $3deef212c81ef57f$export$115094ee16241d93 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $3deef212c81ef57f$var$SelectButtonBase.getProps(inProps, context);
    var _React$useState = $acw62.useState(0), _React$useState2 = $3deef212c81ef57f$var$_slicedToArray(_React$useState, 2), focusedIndex = _React$useState2[0], setFocusedIndex = _React$useState2[1];
    var elementRef = $acw62.useRef(null);
    var _SelectButtonBase$set = $3deef212c81ef57f$var$SelectButtonBase.setMetaData({
        props: props
    }), ptm = _SelectButtonBase$set.ptm, cx = _SelectButtonBase$set.cx, isUnstyled = _SelectButtonBase$set.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($3deef212c81ef57f$var$SelectButtonBase.css.styles, isUnstyled, {
        name: 'selectbutton',
        styled: true
    });
    var onOptionClick = function onOptionClick(event) {
        if (props.disabled || isOptionDisabled(event.option)) return;
        var selected = isSelected(event.option);
        if (selected && !(props.unselectable && props.allowEmpty)) return;
        var optionValue = getOptionValue(event.option);
        var newValue;
        if (props.multiple) {
            var currentValue = props.value ? $3deef212c81ef57f$var$_toConsumableArray(props.value) : [];
            newValue = selected ? currentValue.filter(function(val) {
                return !(0, $a73ce425265b079e$export$4855211e6b8ad895).equals(val, optionValue, props.dataKey);
            }) : [].concat($3deef212c81ef57f$var$_toConsumableArray(currentValue), [
                optionValue
            ]);
        } else newValue = selected ? null : optionValue;
        if (props.onChange) props.onChange({
            originalEvent: event.originalEvent,
            value: newValue,
            stopPropagation: function stopPropagation() {
                event.originalEvent.stopPropagation();
            },
            preventDefault: function preventDefault() {
                event.originalEvent.preventDefault();
            },
            target: {
                name: props.name,
                id: props.id,
                value: newValue
            }
        });
    };
    var getOptionLabel = function getOptionLabel(option) {
        return props.optionLabel ? (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(option, props.optionLabel) : option && option.label !== undefined ? option.label : option;
    };
    var getOptionValue = function getOptionValue(option) {
        return props.optionValue ? (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(option, props.optionValue) : option && option.value !== undefined ? option.value : option;
    };
    var isOptionDisabled = function isOptionDisabled(option) {
        if (props.optionDisabled) return (0, $a73ce425265b079e$export$4855211e6b8ad895).isFunction(props.optionDisabled) ? props.optionDisabled(option) : (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(option, props.optionDisabled);
        return option && option.disabled !== undefined ? option.disabled : false;
    };
    var isSelected = function isSelected(option) {
        var optionValue = getOptionValue(option);
        if (props.multiple) {
            if (props.value && props.value.length) return props.value.some(function(val) {
                return (0, $a73ce425265b079e$export$4855211e6b8ad895).equals(val, optionValue, props.dataKey);
            });
        } else return (0, $a73ce425265b079e$export$4855211e6b8ad895).equals(props.value, optionValue, props.dataKey);
        return false;
    };
    var createItems = function createItems() {
        if (props.options && props.options.length) return props.options.map(function(option, index) {
            var isDisabled = props.disabled || isOptionDisabled(option);
            var optionLabel = getOptionLabel(option);
            var tabIndex = props.disabled || index !== focusedIndex ? '-1' : '0';
            var selected = isSelected(option);
            var key = optionLabel + '_' + index;
            return /*#__PURE__*/ $acw62.createElement($3deef212c81ef57f$var$SelectButtonItem, {
                hostName: "SelectButton",
                key: key,
                label: optionLabel,
                className: option.className,
                option: option,
                setFocusedIndex: setFocusedIndex,
                onClick: onOptionClick,
                template: props.itemTemplate,
                selected: selected,
                tabIndex: tabIndex,
                index: index,
                disabled: isDisabled,
                ptm: ptm,
                cx: cx,
                elementRef: elementRef
            });
        });
        return null;
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            focus: function focus() {
                return (0, $a73ce425265b079e$export$ff8ccbac9225de62).focusFirstElement(elementRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var hasTooltip = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.tooltip);
    var items = createItems();
    var rootProps = mergeProps({
        ref: elementRef,
        id: props.id,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root')),
        style: props.style,
        role: 'group'
    }, $3deef212c81ef57f$var$SelectButtonBase.getOtherProps(props), ptm('root'));
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", rootProps, items, props.children), hasTooltip && /*#__PURE__*/ $acw62.createElement((0, $b74dfa9f7ee9d9bc$export$28c660c63b792dea), $3deef212c81ef57f$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm('tooltip')
    }, props.tooltipOptions)));
}));
$3deef212c81ef57f$export$115094ee16241d93.displayName = 'SelectButton';



var $acw62 = parcelRequire("acw62");
function $bb72469920eab510$export$17c974d806bdef7f({ propertyName: propertyName, initialVal: initialVal, label: label, id: id, options: options, onDone: onDone, optionValue: optionValue, optionLabel: optionLabel }) {
    const [value, setValue] = (0, $acw62.useState)(initialVal ? initialVal : 0);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "w-full mb-2",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                    htmlFor: id + '-' + propertyName,
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "w-full flex flex-row justify-content-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3deef212c81ef57f$export$115094ee16241d93), {
                    id: id + '-' + propertyName,
                    pt: {
                        button: {
                            className: 'px-3 py-2'
                        }
                    },
                    value: value,
                    options: options,
                    optionValue: optionValue,
                    optionLabel: optionLabel,
                    onChange: (e)=>{
                        setValue(e.value);
                        onDone(propertyName, e.value);
                    }
                })
            })
        ]
    });
}


function $ae224ec83d154ed8$export$a68282c78c73c3fe({ selectedItem: selectedItem }) {
    const { isPending: isPending, error: error, data: data, dataUpdatedAt: dataUpdatedAt } = (0, $4529664c1ee19d35$export$ac3dd26b67094cc3)('stops', selectedItem.stop_id);
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const dispatch = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$6bbcf3368996eea5));
    function handleExit() {
        dispatch({
            type: 'changed',
            newTool: {
                ...tool,
                propertyEditor: null,
                selection: null // odznacz przystanek
            }
        });
        return true;
    }
    if (isPending || !data) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec34a5c615255cb$export$dcc7532e7120780d), {
        className: "flex justify-content-center"
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                className: "fa-solid fa-face-frown fa-5x"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            "Wyst\u0105pi\u0142 b\u0142\u0105d \u0142adowania przystank\xf3w: ",
            error.message
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "p-3 relative",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                icon: "pi pi-times",
                rounded: true,
                text: true,
                severity: "danger",
                "aria-label": "Cancel",
                className: "absolute top-0 right-0",
                onClick: handleExit
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pb-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "fa-solid fa-pen-to-square mr-2"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-200 text-sm",
                        children: data.stop_id
                    }),
                    " ",
                    data.stop_name,
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a79a81cc3b591c5$export$5d8a4b9af9ca5f5b), {
                        platformCode: data.platform_code
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $028ce6f6ddd144ee$export$9159ebcaf8f42267), {
                style: {
                    width: '100%',
                    height: '80vh'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ae224ec83d154ed8$export$c1c1730cb04fe448, {
                    inputValues: data,
                    dataUpdatedAt: dataUpdatedAt
                })
            })
        ]
    });
}
function $ae224ec83d154ed8$export$c1c1730cb04fe448({ inputValues: inputValues, dataUpdatedAt: dataUpdatedAt }) {
    const id = (0, $acw62.useId)();
    const modifyStop = (0, $4529664c1ee19d35$export$a60c7f0127bb920c)();
    const deleteStop = (0, $4529664c1ee19d35$export$81e0e42a622ab49f)();
    const snap = (0, $acw62.useContext)((0, $7d6297100045faa6$export$83327a4f6aff409e));
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const dispatch = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$6bbcf3368996eea5));
    const [isMutationPending, setIsMutationPending] = (0, $acw62.useState)(false);
    const [modifiedValues, setModifiedValues] = (0, $acw62.useState)(inputValues);
    const [validationErrors, setValidationErrors] = (0, $acw62.useState)({
        stop_id: false,
        stop_name: false
    });
    const locationTypeOptions = [
        {
            name: 'Przystanek lub stanowisko (peron)',
            value: 0
        },
        {
            name: 'Stacja lub dworzec',
            value: 1
        },
        {
            name: "Wej\u015Bcie lub wyj\u015Bcie ze stacji",
            value: 2
        },
        {
            name: "Miejsce odprawy (cz\u0119\u015B\u0107 peronu)",
            value: 4
        }
    ];
    const { data: stopsList } = (0, $4529664c1ee19d35$export$c3a687f3d6e3fb65)('stops');
    const previousUpdate = (0, $acw62.useRef)(dataUpdatedAt);
    const handleOverlays = (0, $acw62.useContext)((0, $bdccf6b6a87b04cc$export$a2200b96afd16271));
    function handleInput(propertyName, value) {
        let newValues = {
            ...modifiedValues
        };
        newValues[propertyName] = value;
        setModifiedValues(newValues);
    }
    async function handleInputDone(propertyName, value) {
        if (value === inputValues[propertyName]) return; // Nie wysyłamy zmian na serwer, jeżeli nowa wartość jest taka jak już zapisana do serwera.
        const data = {
            query: {
                modified_stop_id: inputValues.stop_id
            },
            fields: {}
        };
        data.fields[propertyName] = value;
        setIsMutationPending(true);
        try {
            // próbujemy przeprowadzić mutację
            const asyncMutation = await modifyStop.mutateAsync(data);
            // dalej wykona się tylko, jeżeli pobranie danych nastąpiło bez błędów
            // wykasuj ewentualne istniejące błędy walidacji z UI, skoro wszystko poszło ok
            if (validationErrors[propertyName]) {
                let updatedValidationErrors = {
                    ...validationErrors
                };
                updatedValidationErrors[propertyName] = false;
                setValidationErrors({
                    ...updatedValidationErrors
                });
            }
        } catch (error) {
            const errorCode = error.message.slice(0, 3);
            if (errorCode == '422') {
                //obsługa błędów walidacji
                let updatedValidationErrors = {
                    ...validationErrors
                };
                updatedValidationErrors[propertyName] = Object.values(error.cause.validation[propertyName]).join(', ');
                setValidationErrors({
                    ...updatedValidationErrors
                });
            } else //obsługa pozostałych błędów
            handleOverlays('toast', {
                severity: "error",
                summary: "B\u0142\u0105d " + errorCode,
                detail: typeof error.cause === 'undefined' || typeof error.cause.message === 'undefined' ? "Wyst\u0105pi\u0142 b\u0142\u0105d. Czynno\u015B\u0107 nie mog\u0142a zosta\u0107 zako\u0144czona powodzeniem. " + error.message : error.cause.message
            });
        } finally{
            setIsMutationPending(false);
        }
    }
    function handleInputCancel() {
        setModifiedValues(inputValues);
    }
    function handleClickDelete() {
        async function accept() {
            try {
                //próbujemy usunąć przystanek
                const asyncMutation = await deleteStop.mutateAsync(inputValues.stop_id);
                // to wykona się tylko, jeżeli nam się udało
                dispatch({
                    type: 'changed',
                    newTool: {
                        ...tool,
                        propertyEditor: null,
                        selection: null // odznacz przystanek
                    }
                });
                handleOverlays('toast', {
                    summary: "Przystanek zosta\u0142 usuni\u0119ty",
                    severity: 'success'
                });
            } catch (error) {
                // Obługa błędów
                console.log(error);
                const errorCode = error.message.slice(0, 3);
                handleOverlays('toast', {
                    severity: "error",
                    summary: "B\u0142\u0105d " + errorCode,
                    detail: typeof error.cause === 'undefined' || typeof error.cause.message === 'undefined' ? "Wyst\u0105pi\u0142 b\u0142\u0105d. Czynno\u015B\u0107 nie mog\u0142a zosta\u0107 zako\u0144czona powodzeniem." : error.cause.message
                });
            } finally{
                // musimy być pewni, że inwalidacja zapytań nastąpi PO zakończeniu operacji
                // dlatego następuje tutaj, a nie w Queries.js
                (0, $4529664c1ee19d35$export$7c07b633a151f9c5).invalidateQueries({
                    queryKey: [
                        'GTFS',
                        snap,
                        'stops',
                        inputValues.stop_id
                    ]
                });
                (0, $4529664c1ee19d35$export$7c07b633a151f9c5).invalidateQueries({
                    queryKey: [
                        'stopsData'
                    ]
                });
                (0, $4529664c1ee19d35$export$7c07b633a151f9c5).invalidateQueries({
                    queryKey: [
                        'stops',
                        snap
                    ]
                });
            }
        }
        handleOverlays('confirmDialog', {
            message: "Przystanek zniknie z rozk\u0142adu jazdy wszystkich linii. Operacja jest nieodwracalna.",
            header: "Usun\u0105\u0107 przystanek " + inputValues.stop_id + ' ' + inputValues.stop_name + '?',
            icon: 'pi pi-info-circle',
            style: {
                width: '500px '
            },
            breakpoints: {
                '960px': '100vw'
            },
            defaultFocus: 'reject',
            acceptLabel: "Usu\u0144",
            acceptClassName: 'p-button-danger',
            acceptIcon: 'fa-solid fa-trash',
            rejectLabel: 'Anuluj',
            accept: accept
        });
    }
    if (dataUpdatedAt > previousUpdate.current) {
        previousUpdate.current = dataUpdatedAt;
        setModifiedValues(inputValues);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "formgrid grid",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                    propertyName: "stop_id",
                    label: "ID przystanku",
                    id: id,
                    value: modifiedValues.stop_id,
                    initialVal: inputValues.stop_id,
                    onDone: handleInputDone,
                    onChange: handleInput,
                    onCancel: handleInputCancel,
                    invalid: validationErrors.stop_id,
                    disabled: false,
                    pending: isMutationPending
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                    propertyName: "stop_code",
                    label: "Publiczny nr przyst.",
                    id: id,
                    value: modifiedValues.stop_code,
                    initialVal: inputValues.stop_code,
                    onDone: handleInputDone,
                    onChange: handleInput,
                    onCancel: handleInputCancel,
                    pending: isMutationPending
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-8",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                    propertyName: "stop_name",
                    label: "Nazwa przystanku",
                    id: id,
                    value: modifiedValues.stop_name,
                    initialVal: inputValues.stop_name,
                    onChange: handleInput,
                    onDone: handleInputDone,
                    onCancel: handleInputCancel,
                    invalid: validationErrors.stop_name,
                    pending: isMutationPending
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                    propertyName: "platform_code",
                    label: "Nr stan.",
                    id: id,
                    value: modifiedValues.platform_code,
                    initialVal: inputValues.platform_code,
                    onDone: handleInputDone,
                    onChange: handleInput,
                    onCancel: handleInputCancel,
                    pending: isMutationPending
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-12",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                    propertyName: "tts_stop_name",
                    label: "Nazwa przystanku dla lektora",
                    id: id,
                    value: modifiedValues.tts_stop_name,
                    initialVal: inputValues.tts_stop_name,
                    placeholder: inputValues.stop_name,
                    onDone: handleInputDone,
                    onChange: handleInput,
                    onCancel: handleInputCancel,
                    pending: isMutationPending
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                    numeric: true,
                    propertyName: "stop_lat",
                    initialVal: inputValues.stop_lat,
                    label: "Szer. geo. s\u0142upka",
                    id: id,
                    value: modifiedValues.stop_lat,
                    onDone: handleInputDone,
                    onChange: handleInput,
                    onCancel: handleInputCancel,
                    pending: isMutationPending
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                    numeric: true,
                    propertyName: "stop_lon",
                    initialVal: inputValues.stop_lon,
                    label: "D\u0142ugo\u015B\u0107 geo. s\u0142upka",
                    id: id,
                    value: modifiedValues.stop_lon,
                    onDone: handleInputDone,
                    onChange: handleInput,
                    onCancel: handleInputCancel,
                    pending: isMutationPending
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                    propertyName: "zone_id",
                    initialVal: inputValues.zone_id,
                    label: "Strefa taryfowa",
                    id: id,
                    value: modifiedValues.zone_id,
                    onDone: handleInputDone,
                    onChange: handleInput,
                    onCancel: handleInputCancel,
                    pending: isMutationPending
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-8",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                    propertyName: "stop_url",
                    initialVal: inputValues.stop_url,
                    label: "Link do informacji dla pasa\u017Cer\xf3w",
                    value: modifiedValues.stop_url,
                    id: id,
                    onDone: handleInputDone,
                    onChange: handleInput,
                    onCancel: handleInputCancel,
                    pending: isMutationPending
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb72469920eab510$export$17c974d806bdef7f), {
                id: id,
                propertyName: "wheelchair_boarding",
                initialVal: inputValues.wheelchair_boarding,
                label: "Dost\u0119pno\u015B\u0107 dla w\xf3zk\xf3w:",
                options: [
                    {
                        label: 'Brak info',
                        value: 0
                    },
                    {
                        label: "Dost\u0119pny",
                        value: 1
                    },
                    {
                        label: "Niedost\u0119pny",
                        value: 2
                    }
                ],
                optionValue: "value",
                onDone: handleInputDone
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-12 mt-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $193f2811aaebee8a$export$260594f1c0239dfe), {
                    propertyName: "location_type",
                    initialVal: inputValues.location_type,
                    label: "Charakter przystanku",
                    options: locationTypeOptions,
                    onDone: handleInputDone
                })
            }),
            // Todo: zrobić filtrowanie opcji dla kompotentu StopIdPropertyDropdown
            // tak, żeby w razie location_type=0, 2 lub 3 w opcjach znajodowały się
            // tylko przystanki o location_type=1 (stacje), a w przypadku location_type=4
            // znajdowały się przystanku location_type=0 (perony)
            inputValues.location_type !== 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-12",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1aa42f680c61ccaa$export$f2e335d0f285264e), {
                    propertyName: "parent_station",
                    initialVal: inputValues.parent_station,
                    label: "Przystanek nadrz\u0119dny",
                    options: Object.values(stopsList),
                    onDone: handleInputDone
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-12 mt-5",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                    severity: "danger",
                    onClick: handleClickDelete,
                    icon: "fa-solid fa-trash",
                    label: "Usu\u0144 przystanek",
                    outlined: true
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




'use client';
function $844f2af056435114$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $844f2af056435114$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $844f2af056435114$var$_typeof(o);
}
function $844f2af056435114$var$toPrimitive(t, r) {
    if ("object" != $844f2af056435114$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $844f2af056435114$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $844f2af056435114$var$toPropertyKey(t) {
    var i = $844f2af056435114$var$toPrimitive(t, "string");
    return "symbol" == $844f2af056435114$var$_typeof(i) ? i : i + "";
}
function $844f2af056435114$var$_defineProperty(e, r, t) {
    return (r = $844f2af056435114$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $844f2af056435114$var$classes = {
    root: function root(_ref) {
        var props = _ref.props;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-skeleton p-component', {
            'p-skeleton-circle': props.shape === 'circle',
            'p-skeleton-none': props.animation === 'none'
        });
    }
};
var $844f2af056435114$var$styles = "\n@layer primereact {\n    .p-skeleton {\n        position: relative;\n        overflow: hidden;\n    }\n    \n    .p-skeleton::after {\n        content: \"\";\n        animation: p-skeleton-animation 1.2s infinite;\n        height: 100%;\n        left: 0;\n        position: absolute;\n        right: 0;\n        top: 0;\n        transform: translateX(-100%);\n        z-index: 1;\n    }\n    \n    .p-skeleton-circle {\n        border-radius: 50%;\n    }\n    \n    .p-skeleton-none::after {\n        animation: none;\n    }\n}\n\n@keyframes p-skeleton-animation {\n    from {\n        transform: translateX(-100%);\n    }\n    to {\n        transform: translateX(100%);\n    }\n}\n";
var $844f2af056435114$var$inlineStyles = {
    root: {
        position: 'relative'
    }
};
var $844f2af056435114$var$SkeletonBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'Skeleton',
        shape: 'rectangle',
        size: null,
        width: '100%',
        height: '1rem',
        borderRadius: null,
        animation: 'wave',
        style: null,
        className: null
    },
    css: {
        classes: $844f2af056435114$var$classes,
        inlineStyles: $844f2af056435114$var$inlineStyles,
        styles: $844f2af056435114$var$styles
    }
});
function $844f2af056435114$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $844f2af056435114$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $844f2af056435114$var$ownKeys(Object(t), !0).forEach(function(r) {
            $844f2af056435114$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $844f2af056435114$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $844f2af056435114$export$8f31e4c4a37b8e9c = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $844f2af056435114$var$SkeletonBase.getProps(inProps, context);
    var _SkeletonBase$setMeta = $844f2af056435114$var$SkeletonBase.setMetaData({
        props: props
    }), ptm = _SkeletonBase$setMeta.ptm, cx = _SkeletonBase$setMeta.cx, sx = _SkeletonBase$setMeta.sx, isUnstyled = _SkeletonBase$setMeta.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($844f2af056435114$var$SkeletonBase.css.styles, isUnstyled, {
        name: 'skeleton'
    });
    var elementRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var style = props.size ? {
        width: props.size,
        height: props.size,
        borderRadius: props.borderRadius
    } : {
        width: props.width,
        height: props.height,
        borderRadius: props.borderRadius
    };
    var rootProps = mergeProps({
        ref: elementRef,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root')),
        style: $844f2af056435114$var$_objectSpread($844f2af056435114$var$_objectSpread({}, style), sx('root')),
        'aria-hidden': true
    }, $844f2af056435114$var$SkeletonBase.getOtherProps(props), ptm('root'));
    return /*#__PURE__*/ $acw62.createElement("div", rootProps);
}));
$844f2af056435114$export$8f31e4c4a37b8e9c.displayName = 'Skeleton';









var $acw62 = parcelRequire("acw62");




'use client';
function $45c16dffa139fd58$var$_extends() {
    return $45c16dffa139fd58$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $45c16dffa139fd58$var$_extends.apply(null, arguments);
}
function $45c16dffa139fd58$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $45c16dffa139fd58$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $45c16dffa139fd58$var$_typeof(o);
}
function $45c16dffa139fd58$var$toPrimitive(t, r) {
    if ("object" != $45c16dffa139fd58$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $45c16dffa139fd58$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $45c16dffa139fd58$var$toPropertyKey(t) {
    var i = $45c16dffa139fd58$var$toPrimitive(t, "string");
    return "symbol" == $45c16dffa139fd58$var$_typeof(i) ? i : i + "";
}
function $45c16dffa139fd58$var$_defineProperty(e, r, t) {
    return (r = $45c16dffa139fd58$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $45c16dffa139fd58$var$classes = {
    root: function root(_ref) {
        var props = _ref.props;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-icon-field', {
            'p-icon-field-right': props.iconPosition === 'right',
            'p-icon-field-left': props.iconPosition === 'left'
        });
    }
};
var $45c16dffa139fd58$var$IconFieldBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'IconField',
        __parentMetadata: null,
        children: undefined,
        className: null,
        iconPosition: 'right'
    },
    css: {
        classes: $45c16dffa139fd58$var$classes
    }
});
function $45c16dffa139fd58$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $45c16dffa139fd58$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $45c16dffa139fd58$var$ownKeys(Object(t), !0).forEach(function(r) {
            $45c16dffa139fd58$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $45c16dffa139fd58$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $45c16dffa139fd58$export$abf6ae16d7844889 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(inProps, ref) {
    var elementRef = (0, $acw62.useRef)(ref);
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = (0, $acw62.useContext)((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $45c16dffa139fd58$var$IconFieldBase.getProps(inProps, context);
    var _IconFieldBase$setMet = $45c16dffa139fd58$var$IconFieldBase.setMetaData($45c16dffa139fd58$var$_objectSpread($45c16dffa139fd58$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        context: {
            iconPosition: props.iconPosition
        }
    })), ptm = _IconFieldBase$setMet.ptm, cx = _IconFieldBase$setMet.cx;
    var rootProps = mergeProps({
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root', {
            iconPosition: props.iconPosition
        }))
    }, $45c16dffa139fd58$var$IconFieldBase.getOtherProps(props), ptm('root'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $45c16dffa139fd58$var$_extends({}, rootProps, {
        ref: elementRef
    }), (0, $acw62.Children).map(props.children, function(child, index) {
        return /*#__PURE__*/ (0, $acw62.cloneElement)(child, {
            iconPosition: props.iconPosition
        });
    }));
}));
$45c16dffa139fd58$export$abf6ae16d7844889.displayName = 'IconField';



var $acw62 = parcelRequire("acw62");




'use client';
function $f352c61993d637af$var$_extends() {
    return $f352c61993d637af$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f352c61993d637af$var$_extends.apply(null, arguments);
}
function $f352c61993d637af$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f352c61993d637af$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f352c61993d637af$var$_typeof(o);
}
function $f352c61993d637af$var$toPrimitive(t, r) {
    if ("object" != $f352c61993d637af$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f352c61993d637af$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f352c61993d637af$var$toPropertyKey(t) {
    var i = $f352c61993d637af$var$toPrimitive(t, "string");
    return "symbol" == $f352c61993d637af$var$_typeof(i) ? i : i + "";
}
function $f352c61993d637af$var$_defineProperty(e, r, t) {
    return (r = $f352c61993d637af$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $f352c61993d637af$var$classes = {
    root: 'p-input-icon'
};
var $f352c61993d637af$var$InputIconBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'InputIcon',
        __parentMetadata: null,
        className: null,
        iconPosition: null
    },
    css: {
        classes: $f352c61993d637af$var$classes
    }
});
function $f352c61993d637af$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f352c61993d637af$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f352c61993d637af$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f352c61993d637af$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f352c61993d637af$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f352c61993d637af$export$f8fea9f50a4bfae6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(inProps, ref) {
    var elementRef = (0, $acw62.useRef)(ref);
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = (0, $acw62.useContext)((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $f352c61993d637af$var$InputIconBase.getProps(inProps, context);
    var _InputIconBase$setMet = $f352c61993d637af$var$InputIconBase.setMetaData($f352c61993d637af$var$_objectSpread($f352c61993d637af$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        context: {
            iconPosition: props.iconPosition
        }
    })), ptm = _InputIconBase$setMet.ptm, cx = _InputIconBase$setMet.cx;
    var rootProps = mergeProps({
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root'))
    }, $f352c61993d637af$var$InputIconBase.getOtherProps(props), ptm('root'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", $f352c61993d637af$var$_extends({}, rootProps, {
        ref: elementRef
    }), props.children));
}));
$f352c61993d637af$export$f8fea9f50a4bfae6.displayName = 'InputIcon';



function $39fba10236e696df$export$e310308e1c9f886({ filterText: filterText, onFilterTextChange: onFilterTextChange, placeholder: placeholder }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $45c16dffa139fd58$export$abf6ae16d7844889), {
            iconPosition: "left",
            className: "m-0 p-0",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f352c61993d637af$export$f8fea9f50a4bfae6), {
                    className: "pi pi-search",
                    children: " "
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab1a721814a59df6$export$7034fcb7d6351061), {
                    value: filterText,
                    onChange: (e)=>onFilterTextChange(e.target.value),
                    placeholder: placeholder,
                    className: "w-full"
                })
            ]
        })
    });
}



var $acw62 = parcelRequire("acw62");
var $0a06c4d6833722ed$exports = {};
/**
 * MapLibre GL JS
 * @license 3-Clause BSD. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v5.3.1/LICENSE.txt
 */ (function(global, factory) {
    $0a06c4d6833722ed$exports = factory();
})($0a06c4d6833722ed$exports, function() {
    'use strict';
    /* eslint-disable */ var maplibregl = {};
    var modules = {};
    function define(moduleName, _dependencies, moduleFactory) {
        modules[moduleName] = moduleFactory;
        // to get the list of modules see generated dist/maplibre-gl-dev.js file (look for `define(` calls)
        if (moduleName !== 'index') return;
        // we assume that when an index module is initializing then other modules are loaded already
        var workerBundleString = 'var sharedModule = {}; (' + modules.shared + ')(sharedModule); (' + modules.worker + ')(sharedModule);';
        var sharedModule = {};
        // the order of arguments of a module factory depends on rollup (it decides who is whose dependency)
        // to check the correct order, see dist/maplibre-gl-dev.js file (look for `define(` calls)
        // we assume that for our 3 chunks it will generate 3 modules and their order is predefined like the following
        modules.shared(sharedModule);
        modules.index(maplibregl, sharedModule);
        if (typeof window !== 'undefined') maplibregl.setWorkerUrl(window.URL.createObjectURL(new Blob([
            workerBundleString
        ], {
            type: 'text/javascript'
        })));
        return maplibregl;
    }
    define("shared", [
        "exports"
    ], function(t) {
        "use strict";
        function e(t, e, r, n) {
            return new (r || (r = Promise))(function(i, s) {
                function a(t) {
                    try {
                        l(n.next(t));
                    } catch (t) {
                        s(t);
                    }
                }
                function o(t) {
                    try {
                        l(n.throw(t));
                    } catch (t) {
                        s(t);
                    }
                }
                function l(t) {
                    var e;
                    t.done ? i(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                        t(e);
                    })).then(a, o);
                }
                l((n = n.apply(t, e || [])).next());
            });
        }
        function r(t) {
            return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
        }
        var n, i;
        function s() {
            if (i) return n;
            function t(t, e) {
                this.x = t, this.y = e;
            }
            return i = 1, n = t, t.prototype = {
                clone: function() {
                    return new t(this.x, this.y);
                },
                add: function(t) {
                    return this.clone()._add(t);
                },
                sub: function(t) {
                    return this.clone()._sub(t);
                },
                multByPoint: function(t) {
                    return this.clone()._multByPoint(t);
                },
                divByPoint: function(t) {
                    return this.clone()._divByPoint(t);
                },
                mult: function(t) {
                    return this.clone()._mult(t);
                },
                div: function(t) {
                    return this.clone()._div(t);
                },
                rotate: function(t) {
                    return this.clone()._rotate(t);
                },
                rotateAround: function(t, e) {
                    return this.clone()._rotateAround(t, e);
                },
                matMult: function(t) {
                    return this.clone()._matMult(t);
                },
                unit: function() {
                    return this.clone()._unit();
                },
                perp: function() {
                    return this.clone()._perp();
                },
                round: function() {
                    return this.clone()._round();
                },
                mag: function() {
                    return Math.sqrt(this.x * this.x + this.y * this.y);
                },
                equals: function(t) {
                    return this.x === t.x && this.y === t.y;
                },
                dist: function(t) {
                    return Math.sqrt(this.distSqr(t));
                },
                distSqr: function(t) {
                    var e = t.x - this.x, r = t.y - this.y;
                    return e * e + r * r;
                },
                angle: function() {
                    return Math.atan2(this.y, this.x);
                },
                angleTo: function(t) {
                    return Math.atan2(this.y - t.y, this.x - t.x);
                },
                angleWith: function(t) {
                    return this.angleWithSep(t.x, t.y);
                },
                angleWithSep: function(t, e) {
                    return Math.atan2(this.x * e - this.y * t, this.x * t + this.y * e);
                },
                _matMult: function(t) {
                    var e = t[2] * this.x + t[3] * this.y;
                    return this.x = t[0] * this.x + t[1] * this.y, this.y = e, this;
                },
                _add: function(t) {
                    return this.x += t.x, this.y += t.y, this;
                },
                _sub: function(t) {
                    return this.x -= t.x, this.y -= t.y, this;
                },
                _mult: function(t) {
                    return this.x *= t, this.y *= t, this;
                },
                _div: function(t) {
                    return this.x /= t, this.y /= t, this;
                },
                _multByPoint: function(t) {
                    return this.x *= t.x, this.y *= t.y, this;
                },
                _divByPoint: function(t) {
                    return this.x /= t.x, this.y /= t.y, this;
                },
                _unit: function() {
                    return this._div(this.mag()), this;
                },
                _perp: function() {
                    var t = this.y;
                    return this.y = this.x, this.x = -t, this;
                },
                _rotate: function(t) {
                    var e = Math.cos(t), r = Math.sin(t), n = r * this.x + e * this.y;
                    return this.x = e * this.x - r * this.y, this.y = n, this;
                },
                _rotateAround: function(t, e) {
                    var r = Math.cos(t), n = Math.sin(t), i = e.y + n * (this.x - e.x) + r * (this.y - e.y);
                    return this.x = e.x + r * (this.x - e.x) - n * (this.y - e.y), this.y = i, this;
                },
                _round: function() {
                    return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
                }
            }, t.convert = function(e) {
                return e instanceof t ? e : Array.isArray(e) ? new t(e[0], e[1]) : e;
            }, n;
        }
        "function" == typeof SuppressedError && SuppressedError;
        var a, o, l = r(s()), u = function() {
            if (o) return a;
            function t(t, e, r, n) {
                this.cx = 3 * t, this.bx = 3 * (r - t) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e, this.by = 3 * (n - e) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t, this.p1y = e, this.p2x = r, this.p2y = n;
            }
            return o = 1, a = t, t.prototype = {
                sampleCurveX: function(t) {
                    return ((this.ax * t + this.bx) * t + this.cx) * t;
                },
                sampleCurveY: function(t) {
                    return ((this.ay * t + this.by) * t + this.cy) * t;
                },
                sampleCurveDerivativeX: function(t) {
                    return (3 * this.ax * t + 2 * this.bx) * t + this.cx;
                },
                solveCurveX: function(t, e) {
                    if (void 0 === e && (e = 1e-6), t < 0) return 0;
                    if (t > 1) return 1;
                    for(var r = t, n = 0; n < 8; n++){
                        var i = this.sampleCurveX(r) - t;
                        if (Math.abs(i) < e) return r;
                        var s = this.sampleCurveDerivativeX(r);
                        if (Math.abs(s) < 1e-6) break;
                        r -= i / s;
                    }
                    var a = 0, o = 1;
                    for(r = t, n = 0; n < 20 && (i = this.sampleCurveX(r), !(Math.abs(i - t) < e)); n++)t > i ? a = r : o = r, r = .5 * (o - a) + a;
                    return r;
                },
                solve: function(t, e) {
                    return this.sampleCurveY(this.solveCurveX(t, e));
                }
            }, a;
        }(), c = r(u);
        let h, p;
        function f() {
            return null == h && (h = "undefined" != typeof OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof createImageBitmap), h;
        }
        function d() {
            if (null == p && (p = !1, f())) {
                const t = 5, e = new OffscreenCanvas(t, t).getContext("2d", {
                    willReadFrequently: !0
                });
                if (e) {
                    for(let r = 0; r < t * t; r++){
                        const n = 4 * r;
                        e.fillStyle = `rgb(${n},${n + 1},${n + 2})`, e.fillRect(r % t, Math.floor(r / t), 1, 1);
                    }
                    const r = e.getImageData(0, 0, t, t).data;
                    for(let e = 0; e < t * t * 4; e++)if (e % 4 != 3 && r[e] !== e) {
                        p = !0;
                        break;
                    }
                }
            }
            return p || !1;
        }
        var y, m = 1e-6, g = "undefined" != typeof Float32Array ? Float32Array : Array;
        function x() {
            var t = new g(9);
            return g != Float32Array && (t[1] = 0, t[2] = 0, t[3] = 0, t[5] = 0, t[6] = 0, t[7] = 0), t[0] = 1, t[4] = 1, t[8] = 1, t;
        }
        function v(t) {
            return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
        }
        function b() {
            var t = new g(3);
            return g != Float32Array && (t[0] = 0, t[1] = 0, t[2] = 0), t;
        }
        function w(t, e, r) {
            var n = new g(3);
            return n[0] = t, n[1] = e, n[2] = r, n;
        }
        function _(t, e, r) {
            var n = e[0], i = e[1], s = e[2], a = e[3];
            return t[0] = r[0] * n + r[4] * i + r[8] * s + r[12] * a, t[1] = r[1] * n + r[5] * i + r[9] * s + r[13] * a, t[2] = r[2] * n + r[6] * i + r[10] * s + r[14] * a, t[3] = r[3] * n + r[7] * i + r[11] * s + r[15] * a, t;
        }
        function S() {
            var t = new g(4);
            return g != Float32Array && (t[0] = 0, t[1] = 0, t[2] = 0), t[3] = 1, t;
        }
        function A() {
            var t = new g(2);
            return g != Float32Array && (t[0] = 0, t[1] = 0), t;
        }
        function k(t, e) {
            var r = new g(2);
            return r[0] = t, r[1] = e, r;
        }
        Math.hypot || (Math.hypot = function() {
            for(var t = 0, e = arguments.length; e--;)t += arguments[e] * arguments[e];
            return Math.sqrt(t);
        }), b(), y = new g(4), g != Float32Array && (y[0] = 0, y[1] = 0, y[2] = 0, y[3] = 0), b(), w(1, 0, 0), w(0, 1, 0), S(), S(), x(), A();
        const M = 8192;
        function I(t, e, r) {
            return e * (M / (t.tileSize * Math.pow(2, r - t.tileID.overscaledZ)));
        }
        function z(t, e) {
            return (t % e + e) % e;
        }
        function P(t, e, r) {
            return t * (1 - r) + e * r;
        }
        function C(t) {
            if (t <= 0) return 0;
            if (t >= 1) return 1;
            const e = t * t, r = e * t;
            return 4 * (t < .5 ? r : 3 * (t - e) + r - .75);
        }
        function B(t, e, r, n) {
            const i = new c(t, e, r, n);
            return (t)=>i.solve(t);
        }
        const V = B(.25, .1, .25, 1);
        function E(t, e, r) {
            return Math.min(r, Math.max(e, t));
        }
        function T(t, e, r) {
            const n = r - e, i = ((t - e) % n + n) % n + e;
            return i === e ? r : i;
        }
        function F(t, ...e) {
            for (const r of e)for(const e in r)t[e] = r[e];
            return t;
        }
        let $ = 1;
        function L(t, e, r) {
            const n = {};
            for(const r in t)n[r] = e.call(this, t[r], r, t);
            return n;
        }
        function O(t, e, r) {
            const n = {};
            for(const r in t)e.call(this, t[r], r, t) && (n[r] = t[r]);
            return n;
        }
        function D(t) {
            return Array.isArray(t) ? t.map(D) : "object" == typeof t && t ? L(t, D) : t;
        }
        const R = {};
        function j(t) {
            R[t] || ("undefined" != typeof console && console.warn(t), R[t] = !0);
        }
        function N(t, e, r) {
            return (r.y - t.y) * (e.x - t.x) > (e.y - t.y) * (r.x - t.x);
        }
        function U(t) {
            return "undefined" != typeof WorkerGlobalScope && void 0 !== t && t instanceof WorkerGlobalScope;
        }
        let q = null;
        function G(t) {
            return "undefined" != typeof ImageBitmap && t instanceof ImageBitmap;
        }
        const Z = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
        function K(t, r, n, i, s) {
            return e(this, void 0, void 0, function*() {
                if ("undefined" == typeof VideoFrame) throw new Error("VideoFrame not supported");
                const e = new VideoFrame(t, {
                    timestamp: 0
                });
                try {
                    const a = null == e ? void 0 : e.format;
                    if (!a || !a.startsWith("BGR") && !a.startsWith("RGB")) throw new Error(`Unrecognized format ${a}`);
                    const o = a.startsWith("BGR"), l = new Uint8ClampedArray(i * s * 4);
                    if (yield e.copyTo(l, function(t, e, r, n, i) {
                        const s = 4 * Math.max(1, 0), a = (Math.max(0, r) - r) * n * 4 + s, o = 4 * n, l = Math.max(0, e), u = Math.max(0, r);
                        return {
                            rect: {
                                x: l,
                                y: u,
                                width: Math.min(t.width, e + n) - l,
                                height: Math.min(t.height, r + i) - u
                            },
                            layout: [
                                {
                                    offset: a,
                                    stride: o
                                }
                            ]
                        };
                    }(t, r, n, i, s)), o) for(let t = 0; t < l.length; t += 4){
                        const e = l[t];
                        l[t] = l[t + 2], l[t + 2] = e;
                    }
                    return l;
                } finally{
                    e.close();
                }
            });
        }
        let X, H;
        function Y(t, e, r, n) {
            return t.addEventListener(e, r, n), {
                unsubscribe: ()=>{
                    t.removeEventListener(e, r, n);
                }
            };
        }
        function J(t) {
            return t / Math.PI * 180;
        }
        const W = {
            touchstart: !0,
            touchmove: !0,
            touchmoveWindow: !0,
            touchend: !0,
            touchcancel: !0
        }, Q = {
            dblclick: !0,
            click: !0,
            mouseover: !0,
            mouseout: !0,
            mousedown: !0,
            mousemove: !0,
            mousemoveWindow: !0,
            mouseup: !0,
            mouseupWindow: !0,
            contextmenu: !0,
            wheel: !0
        }, tt = "AbortError";
        function et() {
            return new Error(tt);
        }
        const rt = {
            MAX_PARALLEL_IMAGE_REQUESTS: 16,
            MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME: 8,
            MAX_TILE_CACHE_ZOOM_LEVELS: 5,
            REGISTERED_PROTOCOLS: {},
            WORKER_URL: ""
        };
        function nt(t) {
            return rt.REGISTERED_PROTOCOLS[t.substring(0, t.indexOf("://"))];
        }
        const it = "global-dispatcher";
        class st extends Error {
            constructor(t, e, r, n){
                super(`AJAXError: ${e} (${t}): ${r}`), this.status = t, this.statusText = e, this.url = r, this.body = n;
            }
        }
        const at = ()=>U(self) ? self.worker && self.worker.referrer : ("blob:" === window.location.protocol ? window.parent : window).location.href, ot = function(t, r) {
            if (/:\/\//.test(t.url) && !/^https?:|^file:/.test(t.url)) {
                const e = nt(t.url);
                if (e) return e(t, r);
                if (U(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({
                    type: "GR",
                    data: t,
                    targetMapId: it
                }, r);
            }
            if (!(/^file:/.test(n = t.url) || /^file:/.test(at()) && !/^\w+:/.test(n))) {
                if (fetch && Request && AbortController && Object.prototype.hasOwnProperty.call(Request.prototype, "signal")) return function(t, r) {
                    return e(this, void 0, void 0, function*() {
                        const e = new Request(t.url, {
                            method: t.method || "GET",
                            body: t.body,
                            credentials: t.credentials,
                            headers: t.headers,
                            cache: t.cache,
                            referrer: at(),
                            signal: r.signal
                        });
                        let n, i;
                        "json" !== t.type || e.headers.has("Accept") || e.headers.set("Accept", "application/json");
                        try {
                            n = yield fetch(e);
                        } catch (e) {
                            throw new st(0, e.message, t.url, new Blob);
                        }
                        if (!n.ok) {
                            const e = yield n.blob();
                            throw new st(n.status, n.statusText, t.url, e);
                        }
                        i = "arrayBuffer" === t.type || "image" === t.type ? n.arrayBuffer() : "json" === t.type ? n.json() : n.text();
                        const s = yield i;
                        if (r.signal.aborted) throw et();
                        return {
                            data: s,
                            cacheControl: n.headers.get("Cache-Control"),
                            expires: n.headers.get("Expires")
                        };
                    });
                }(t, r);
                if (U(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({
                    type: "GR",
                    data: t,
                    mustQueue: !0,
                    targetMapId: it
                }, r);
            }
            var n;
            return function(t, e) {
                return new Promise((r, n)=>{
                    var i;
                    const s = new XMLHttpRequest;
                    s.open(t.method || "GET", t.url, !0), "arrayBuffer" !== t.type && "image" !== t.type || (s.responseType = "arraybuffer");
                    for(const e in t.headers)s.setRequestHeader(e, t.headers[e]);
                    "json" === t.type && (s.responseType = "text", (null === (i = t.headers) || void 0 === i ? void 0 : i.Accept) || s.setRequestHeader("Accept", "application/json")), s.withCredentials = "include" === t.credentials, s.onerror = ()=>{
                        n(new Error(s.statusText));
                    }, s.onload = ()=>{
                        if (!e.signal.aborted) {
                            if ((s.status >= 200 && s.status < 300 || 0 === s.status) && null !== s.response) {
                                let e = s.response;
                                if ("json" === t.type) try {
                                    e = JSON.parse(s.response);
                                } catch (t) {
                                    return void n(t);
                                }
                                r({
                                    data: e,
                                    cacheControl: s.getResponseHeader("Cache-Control"),
                                    expires: s.getResponseHeader("Expires")
                                });
                            } else {
                                const e = new Blob([
                                    s.response
                                ], {
                                    type: s.getResponseHeader("Content-Type")
                                });
                                n(new st(s.status, s.statusText, t.url, e));
                            }
                        }
                    }, e.signal.addEventListener("abort", ()=>{
                        s.abort(), n(et());
                    }), s.send(t.body);
                });
            }(t, r);
        };
        function lt(t) {
            if (!t || t.indexOf("://") <= 0 || 0 === t.indexOf("data:image/") || 0 === t.indexOf("blob:")) return !0;
            const e = new URL(t), r = window.location;
            return e.protocol === r.protocol && e.host === r.host;
        }
        function ut(t, e, r) {
            r[t] && -1 !== r[t].indexOf(e) || (r[t] = r[t] || [], r[t].push(e));
        }
        function ct(t, e, r) {
            if (r && r[t]) {
                const n = r[t].indexOf(e);
                -1 !== n && r[t].splice(n, 1);
            }
        }
        class ht {
            constructor(t, e = {}){
                F(this, e), this.type = t;
            }
        }
        class pt extends ht {
            constructor(t, e = {}){
                super("error", F({
                    error: t
                }, e));
            }
        }
        class ft {
            on(t, e) {
                return this._listeners = this._listeners || {}, ut(t, e, this._listeners), {
                    unsubscribe: ()=>{
                        this.off(t, e);
                    }
                };
            }
            off(t, e) {
                return ct(t, e, this._listeners), ct(t, e, this._oneTimeListeners), this;
            }
            once(t, e) {
                return e ? (this._oneTimeListeners = this._oneTimeListeners || {}, ut(t, e, this._oneTimeListeners), this) : new Promise((e)=>this.once(t, e));
            }
            fire(t, e) {
                "string" == typeof t && (t = new ht(t, e || {}));
                const r = t.type;
                if (this.listens(r)) {
                    t.target = this;
                    const e = this._listeners && this._listeners[r] ? this._listeners[r].slice() : [];
                    for (const r of e)r.call(this, t);
                    const n = this._oneTimeListeners && this._oneTimeListeners[r] ? this._oneTimeListeners[r].slice() : [];
                    for (const e of n)ct(r, e, this._oneTimeListeners), e.call(this, t);
                    const i = this._eventedParent;
                    i && (F(t, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), i.fire(t));
                } else t instanceof pt && console.error(t.error);
                return this;
            }
            listens(t) {
                return this._listeners && this._listeners[t] && this._listeners[t].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t] && this._oneTimeListeners[t].length > 0 || this._eventedParent && this._eventedParent.listens(t);
            }
            setEventedParent(t, e) {
                return this._eventedParent = t, this._eventedParentData = e, this;
            }
        }
        var dt = {
            $version: 8,
            $root: {
                version: {
                    required: !0,
                    type: "enum",
                    values: [
                        8
                    ]
                },
                name: {
                    type: "string"
                },
                metadata: {
                    type: "*"
                },
                center: {
                    type: "array",
                    value: "number"
                },
                centerAltitude: {
                    type: "number"
                },
                zoom: {
                    type: "number"
                },
                bearing: {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees"
                },
                pitch: {
                    type: "number",
                    default: 0,
                    units: "degrees"
                },
                roll: {
                    type: "number",
                    default: 0,
                    units: "degrees"
                },
                light: {
                    type: "light"
                },
                sky: {
                    type: "sky"
                },
                projection: {
                    type: "projection"
                },
                terrain: {
                    type: "terrain"
                },
                sources: {
                    required: !0,
                    type: "sources"
                },
                sprite: {
                    type: "sprite"
                },
                glyphs: {
                    type: "string"
                },
                transition: {
                    type: "transition"
                },
                layers: {
                    required: !0,
                    type: "array",
                    value: "layer"
                }
            },
            sources: {
                "*": {
                    type: "source"
                }
            },
            source: [
                "source_vector",
                "source_raster",
                "source_raster_dem",
                "source_geojson",
                "source_video",
                "source_image"
            ],
            source_vector: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        vector: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                attribution: {
                    type: "string"
                },
                promoteId: {
                    type: "promoteId"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_raster: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        raster: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                attribution: {
                    type: "string"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_raster_dem: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        "raster-dem": {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                attribution: {
                    type: "string"
                },
                encoding: {
                    type: "enum",
                    values: {
                        terrarium: {},
                        mapbox: {},
                        custom: {}
                    },
                    default: "mapbox"
                },
                redFactor: {
                    type: "number",
                    default: 1
                },
                blueFactor: {
                    type: "number",
                    default: 1
                },
                greenFactor: {
                    type: "number",
                    default: 1
                },
                baseShift: {
                    type: "number",
                    default: 0
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_geojson: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        geojson: {}
                    }
                },
                data: {
                    required: !0,
                    type: "*"
                },
                maxzoom: {
                    type: "number",
                    default: 18
                },
                attribution: {
                    type: "string"
                },
                buffer: {
                    type: "number",
                    default: 128,
                    maximum: 512,
                    minimum: 0
                },
                filter: {
                    type: "*"
                },
                tolerance: {
                    type: "number",
                    default: .375
                },
                cluster: {
                    type: "boolean",
                    default: !1
                },
                clusterRadius: {
                    type: "number",
                    default: 50,
                    minimum: 0
                },
                clusterMaxZoom: {
                    type: "number"
                },
                clusterMinPoints: {
                    type: "number"
                },
                clusterProperties: {
                    type: "*"
                },
                lineMetrics: {
                    type: "boolean",
                    default: !1
                },
                generateId: {
                    type: "boolean",
                    default: !1
                },
                promoteId: {
                    type: "promoteId"
                }
            },
            source_video: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        video: {}
                    }
                },
                urls: {
                    required: !0,
                    type: "array",
                    value: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            source_image: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        image: {}
                    }
                },
                url: {
                    required: !0,
                    type: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            layer: {
                id: {
                    type: "string",
                    required: !0
                },
                type: {
                    type: "enum",
                    values: {
                        fill: {},
                        line: {},
                        symbol: {},
                        circle: {},
                        heatmap: {},
                        "fill-extrusion": {},
                        raster: {},
                        hillshade: {},
                        background: {}
                    },
                    required: !0
                },
                metadata: {
                    type: "*"
                },
                source: {
                    type: "string"
                },
                "source-layer": {
                    type: "string"
                },
                minzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                maxzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                filter: {
                    type: "filter"
                },
                layout: {
                    type: "layout"
                },
                paint: {
                    type: "paint"
                }
            },
            layout: [
                "layout_fill",
                "layout_line",
                "layout_circle",
                "layout_heatmap",
                "layout_fill-extrusion",
                "layout_symbol",
                "layout_raster",
                "layout_hillshade",
                "layout_background"
            ],
            layout_background: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_fill: {
                "fill-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_circle: {
                "circle-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_heatmap: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            "layout_fill-extrusion": {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_line: {
                "line-cap": {
                    type: "enum",
                    values: {
                        butt: {},
                        round: {},
                        square: {}
                    },
                    default: "butt",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-join": {
                    type: "enum",
                    values: {
                        bevel: {},
                        round: {},
                        miter: {}
                    },
                    default: "miter",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-miter-limit": {
                    type: "number",
                    default: 2,
                    requires: [
                        {
                            "line-join": "miter"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-round-limit": {
                    type: "number",
                    default: 1.05,
                    requires: [
                        {
                            "line-join": "round"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_symbol: {
                "symbol-placement": {
                    type: "enum",
                    values: {
                        point: {},
                        line: {},
                        "line-center": {}
                    },
                    default: "point",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-spacing": {
                    type: "number",
                    default: 250,
                    minimum: 1,
                    units: "pixels",
                    requires: [
                        {
                            "symbol-placement": "line"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-avoid-edges": {
                    type: "boolean",
                    default: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "symbol-z-order": {
                    type: "enum",
                    values: {
                        auto: {},
                        "viewport-y": {},
                        source: {}
                    },
                    default: "auto",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        {
                            "!": "icon-overlap"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-overlap": {
                    type: "enum",
                    values: {
                        never: {},
                        always: {},
                        cooperative: {}
                    },
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-size": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    units: "factor of the original icon size",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-text-fit": {
                    type: "enum",
                    values: {
                        none: {},
                        width: {},
                        height: {},
                        both: {}
                    },
                    default: "none",
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-text-fit-padding": {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        0,
                        0,
                        0,
                        0
                    ],
                    units: "pixels",
                    requires: [
                        "icon-image",
                        "text-field",
                        {
                            "icon-text-fit": [
                                "both",
                                "width",
                                "height"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-image": {
                    type: "resolvedImage",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-padding": {
                    type: "padding",
                    default: [
                        2
                    ],
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-keep-upright": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        {
                            "icon-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-offset": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        "viewport-glyph": {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-field": {
                    type: "formatted",
                    default: "",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-font": {
                    type: "array",
                    value: "string",
                    default: [
                        "Open Sans Regular",
                        "Arial Unicode MS Regular"
                    ],
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-size": {
                    type: "number",
                    default: 16,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-width": {
                    type: "number",
                    default: 10,
                    minimum: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-line-height": {
                    type: "number",
                    default: 1.2,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-letter-spacing": {
                    type: "number",
                    default: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-justify": {
                    type: "enum",
                    values: {
                        auto: {},
                        left: {},
                        center: {},
                        right: {}
                    },
                    default: "center",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-radial-offset": {
                    type: "number",
                    units: "ems",
                    default: 0,
                    requires: [
                        "text-field"
                    ],
                    "property-type": "data-driven",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    }
                },
                "text-variable-anchor": {
                    type: "array",
                    value: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-variable-anchor-offset": {
                    type: "variableAnchorOffsetCollection",
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "text-field",
                        {
                            "!": "text-variable-anchor"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-angle": {
                    type: "number",
                    default: 45,
                    units: "degrees",
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-writing-mode": {
                    type: "array",
                    value: "enum",
                    values: {
                        horizontal: {},
                        vertical: {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-padding": {
                    type: "number",
                    default: 2,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-keep-upright": {
                    type: "boolean",
                    default: !0,
                    requires: [
                        "text-field",
                        {
                            "text-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-transform": {
                    type: "enum",
                    values: {
                        none: {},
                        uppercase: {},
                        lowercase: {}
                    },
                    default: "none",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-offset": {
                    type: "array",
                    value: "number",
                    units: "ems",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "text-field",
                        {
                            "!": "text-radial-offset"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field",
                        {
                            "!": "text-overlap"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-overlap": {
                    type: "enum",
                    values: {
                        never: {},
                        always: {},
                        cooperative: {}
                    },
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field",
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_raster: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_hillshade: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            filter: {
                type: "array",
                value: "*"
            },
            filter_operator: {
                type: "enum",
                values: {
                    "==": {},
                    "!=": {},
                    ">": {},
                    ">=": {},
                    "<": {},
                    "<=": {},
                    in: {},
                    "!in": {},
                    all: {},
                    any: {},
                    none: {},
                    has: {},
                    "!has": {}
                }
            },
            geometry_type: {
                type: "enum",
                values: {
                    Point: {},
                    LineString: {},
                    Polygon: {}
                }
            },
            function: {
                expression: {
                    type: "expression"
                },
                stops: {
                    type: "array",
                    value: "function_stop"
                },
                base: {
                    type: "number",
                    default: 1,
                    minimum: 0
                },
                property: {
                    type: "string",
                    default: "$zoom"
                },
                type: {
                    type: "enum",
                    values: {
                        identity: {},
                        exponential: {},
                        interval: {},
                        categorical: {}
                    },
                    default: "exponential"
                },
                colorSpace: {
                    type: "enum",
                    values: {
                        rgb: {},
                        lab: {},
                        hcl: {}
                    },
                    default: "rgb"
                },
                default: {
                    type: "*",
                    required: !1
                }
            },
            function_stop: {
                type: "array",
                minimum: 0,
                maximum: 24,
                value: [
                    "number",
                    "color"
                ],
                length: 2
            },
            expression: {
                type: "array",
                value: "*",
                minimum: 1
            },
            light: {
                anchor: {
                    type: "enum",
                    default: "viewport",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    "property-type": "data-constant",
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                position: {
                    type: "array",
                    default: [
                        1.15,
                        210,
                        30
                    ],
                    length: 3,
                    value: "number",
                    "property-type": "data-constant",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                color: {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#ffffff",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                intensity: {
                    type: "number",
                    "property-type": "data-constant",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                }
            },
            sky: {
                "sky-color": {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#88C6FC",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "horizon-color": {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#ffffff",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "fog-color": {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#ffffff",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "fog-ground-blend": {
                    type: "number",
                    "property-type": "data-constant",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "horizon-fog-blend": {
                    type: "number",
                    "property-type": "data-constant",
                    default: .8,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "sky-horizon-blend": {
                    type: "number",
                    "property-type": "data-constant",
                    default: .8,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "atmosphere-blend": {
                    type: "number",
                    "property-type": "data-constant",
                    default: .8,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                }
            },
            terrain: {
                source: {
                    type: "string",
                    required: !0
                },
                exaggeration: {
                    type: "number",
                    minimum: 0,
                    default: 1
                }
            },
            projection: {
                type: {
                    type: "projectionDefinition",
                    default: "mercator",
                    "property-type": "data-constant",
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    }
                }
            },
            paint: [
                "paint_fill",
                "paint_line",
                "paint_circle",
                "paint_heatmap",
                "paint_fill-extrusion",
                "paint_symbol",
                "paint_raster",
                "paint_hillshade",
                "paint_background"
            ],
            paint_fill: {
                "fill-antialias": {
                    type: "boolean",
                    default: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-outline-color": {
                    type: "color",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        },
                        {
                            "fill-antialias": !0
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                }
            },
            "paint_fill-extrusion": {
                "fill-extrusion-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-extrusion-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-extrusion-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "fill-extrusion-height": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-base": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    requires: [
                        "fill-extrusion-height"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-vertical-gradient": {
                    type: "boolean",
                    default: !0,
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_line: {
                "line-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "line-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-width": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-gap-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-offset": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-dasharray": {
                    type: "array",
                    value: "number",
                    minimum: 0,
                    transition: !0,
                    units: "line widths",
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "cross-faded"
                },
                "line-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "line-gradient": {
                    type: "color",
                    transition: !1,
                    requires: [
                        {
                            "!": "line-dasharray"
                        },
                        {
                            "!": "line-pattern"
                        },
                        {
                            source: "geojson",
                            has: {
                                lineMetrics: !0
                            }
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "line-progress"
                        ]
                    },
                    "property-type": "color-ramp"
                }
            },
            paint_circle: {
                "circle-radius": {
                    type: "number",
                    default: 5,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-blur": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "circle-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-scale": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-stroke-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                }
            },
            paint_heatmap: {
                "heatmap-radius": {
                    type: "number",
                    default: 30,
                    minimum: 1,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-weight": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-intensity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "heatmap-color": {
                    type: "color",
                    default: [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "heatmap-density"
                        ],
                        0,
                        "rgba(0, 0, 255, 0)",
                        .1,
                        "royalblue",
                        .3,
                        "cyan",
                        .5,
                        "lime",
                        .7,
                        "yellow",
                        1,
                        "red"
                    ],
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "heatmap-density"
                        ]
                    },
                    "property-type": "color-ramp"
                },
                "heatmap-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_symbol: {
                "icon-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "icon-image",
                        "icon-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    overridable: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "text-field",
                        "text-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_raster: {
                "raster-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-hue-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    transition: !0,
                    units: "degrees",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-min": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-max": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-saturation": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-contrast": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-resampling": {
                    type: "enum",
                    values: {
                        linear: {},
                        nearest: {}
                    },
                    default: "linear",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-fade-duration": {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    transition: !1,
                    units: "milliseconds",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_hillshade: {
                "hillshade-illumination-direction": {
                    type: "number",
                    default: 335,
                    minimum: 0,
                    maximum: 359,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-illumination-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-exaggeration": {
                    type: "number",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-shadow-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-highlight-color": {
                    type: "color",
                    default: "#FFFFFF",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-accent-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_background: {
                "background-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "background-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "background-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "cross-faded"
                },
                "background-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            transition: {
                duration: {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    units: "milliseconds"
                },
                delay: {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "milliseconds"
                }
            },
            "property-type": {
                "data-driven": {
                    type: "property-type"
                },
                "cross-faded": {
                    type: "property-type"
                },
                "cross-faded-data-driven": {
                    type: "property-type"
                },
                "color-ramp": {
                    type: "property-type"
                },
                "data-constant": {
                    type: "property-type"
                },
                constant: {
                    type: "property-type"
                }
            },
            promoteId: {
                "*": {
                    type: "string"
                }
            }
        };
        const yt = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ];
        function mt(t, e) {
            const r = {};
            for(const e in t)"ref" !== e && (r[e] = t[e]);
            return yt.forEach((t)=>{
                t in e && (r[t] = e[t]);
            }), r;
        }
        function gt(t, e) {
            if (Array.isArray(t)) {
                if (!Array.isArray(e) || t.length !== e.length) return !1;
                for(let r = 0; r < t.length; r++)if (!gt(t[r], e[r])) return !1;
                return !0;
            }
            if ("object" == typeof t && null !== t && null !== e) {
                if ("object" != typeof e) return !1;
                if (Object.keys(t).length !== Object.keys(e).length) return !1;
                for(const r in t)if (!gt(t[r], e[r])) return !1;
                return !0;
            }
            return t === e;
        }
        function xt(t, e) {
            t.push(e);
        }
        function vt(t, e, r) {
            xt(r, {
                command: "addSource",
                args: [
                    t,
                    e[t]
                ]
            });
        }
        function bt(t, e, r) {
            xt(e, {
                command: "removeSource",
                args: [
                    t
                ]
            }), r[t] = !0;
        }
        function wt(t, e, r, n) {
            bt(t, r, n), vt(t, e, r);
        }
        function _t(t, e, r) {
            let n;
            for(n in t[r])if (Object.prototype.hasOwnProperty.call(t[r], n) && "data" !== n && !gt(t[r][n], e[r][n])) return !1;
            for(n in e[r])if (Object.prototype.hasOwnProperty.call(e[r], n) && "data" !== n && !gt(t[r][n], e[r][n])) return !1;
            return !0;
        }
        function St(t, e, r, n, i, s) {
            t = t || {}, e = e || {};
            for(const a in t)Object.prototype.hasOwnProperty.call(t, a) && (gt(t[a], e[a]) || r.push({
                command: s,
                args: [
                    n,
                    a,
                    e[a],
                    i
                ]
            }));
            for(const a in e)Object.prototype.hasOwnProperty.call(e, a) && !Object.prototype.hasOwnProperty.call(t, a) && (gt(t[a], e[a]) || r.push({
                command: s,
                args: [
                    n,
                    a,
                    e[a],
                    i
                ]
            }));
        }
        function At(t) {
            return t.id;
        }
        function kt(t, e) {
            return t[e.id] = e, t;
        }
        class Mt {
            constructor(t, e, r, n){
                this.message = (t ? `${t}: ` : "") + r, n && (this.identifier = n), null != e && e.__line__ && (this.line = e.__line__);
            }
        }
        function It(t, ...e) {
            for (const r of e)for(const e in r)t[e] = r[e];
            return t;
        }
        class zt extends Error {
            constructor(t, e){
                super(e), this.message = e, this.key = t;
            }
        }
        class Pt {
            constructor(t, e = []){
                this.parent = t, this.bindings = {};
                for (const [t, r] of e)this.bindings[t] = r;
            }
            concat(t) {
                return new Pt(this, t);
            }
            get(t) {
                if (this.bindings[t]) return this.bindings[t];
                if (this.parent) return this.parent.get(t);
                throw new Error(`${t} not found in scope.`);
            }
            has(t) {
                return !!this.bindings[t] || !!this.parent && this.parent.has(t);
            }
        }
        const Ct = {
            kind: "null"
        }, Bt = {
            kind: "number"
        }, Vt = {
            kind: "string"
        }, Et = {
            kind: "boolean"
        }, Tt = {
            kind: "color"
        }, Ft = {
            kind: "projectionDefinition"
        }, $t = {
            kind: "object"
        }, Lt = {
            kind: "value"
        }, Ot = {
            kind: "collator"
        }, Dt = {
            kind: "formatted"
        }, Rt = {
            kind: "padding"
        }, jt = {
            kind: "resolvedImage"
        }, Nt = {
            kind: "variableAnchorOffsetCollection"
        };
        function Ut(t, e) {
            return {
                kind: "array",
                itemType: t,
                N: e
            };
        }
        function qt(t) {
            if ("array" === t.kind) {
                const e = qt(t.itemType);
                return "number" == typeof t.N ? `array<${e}, ${t.N}>` : "value" === t.itemType.kind ? "array" : `array<${e}>`;
            }
            return t.kind;
        }
        const Gt = [
            Ct,
            Bt,
            Vt,
            Et,
            Tt,
            Ft,
            Dt,
            $t,
            Ut(Lt),
            Rt,
            jt,
            Nt
        ];
        function Zt(t, e) {
            if ("error" === e.kind) return null;
            if ("array" === t.kind) {
                if ("array" === e.kind && (0 === e.N && "value" === e.itemType.kind || !Zt(t.itemType, e.itemType)) && ("number" != typeof t.N || t.N === e.N)) return null;
            } else {
                if (t.kind === e.kind) return null;
                if ("value" === t.kind) {
                    for (const t of Gt)if (!Zt(t, e)) return null;
                }
            }
            return `Expected ${qt(t)} but found ${qt(e)} instead.`;
        }
        function Kt(t, e) {
            return e.some((e)=>e.kind === t.kind);
        }
        function Xt(t, e) {
            return e.some((e)=>"null" === e ? null === t : "array" === e ? Array.isArray(t) : "object" === e ? t && !Array.isArray(t) && "object" == typeof t : e === typeof t);
        }
        function Ht(t, e) {
            return "array" === t.kind && "array" === e.kind ? t.itemType.kind === e.itemType.kind && "number" == typeof t.N : t.kind === e.kind;
        }
        const Yt = .96422, Jt = .82521, Wt = 4 / 29, Qt = 6 / 29, te = 3 * Qt * Qt, ee = Qt * Qt * Qt, re = Math.PI / 180, ne = 180 / Math.PI;
        function ie(t) {
            return (t %= 360) < 0 && (t += 360), t;
        }
        function se([t, e, r, n]) {
            let i, s;
            const a = oe((.2225045 * (t = ae(t)) + .7168786 * (e = ae(e)) + .0606169 * (r = ae(r))) / 1);
            t === e && e === r ? i = s = a : (i = oe((.4360747 * t + .3850649 * e + .1430804 * r) / Yt), s = oe((.0139322 * t + .0971045 * e + .7141733 * r) / Jt));
            const o = 116 * a - 16;
            return [
                o < 0 ? 0 : o,
                500 * (i - a),
                200 * (a - s),
                n
            ];
        }
        function ae(t) {
            return t <= .04045 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4);
        }
        function oe(t) {
            return t > ee ? Math.pow(t, 1 / 3) : t / te + Wt;
        }
        function le([t, e, r, n]) {
            let i = (t + 16) / 116, s = isNaN(e) ? i : i + e / 500, a = isNaN(r) ? i : i - r / 200;
            return i = 1 * ce(i), s = Yt * ce(s), a = Jt * ce(a), [
                ue(3.1338561 * s - 1.6168667 * i - .4906146 * a),
                ue(-0.9787684 * s + 1.9161415 * i + .033454 * a),
                ue(.0719453 * s - .2289914 * i + 1.4052427 * a),
                n
            ];
        }
        function ue(t) {
            return (t = t <= .00304 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - .055) < 0 ? 0 : t > 1 ? 1 : t;
        }
        function ce(t) {
            return t > Qt ? t * t * t : te * (t - Wt);
        }
        function he(t) {
            return parseInt(t.padEnd(2, t), 16) / 255;
        }
        function pe(t, e) {
            return fe(e ? t / 100 : t, 0, 1);
        }
        function fe(t, e, r) {
            return Math.min(Math.max(e, t), r);
        }
        function de(t) {
            return !t.some(Number.isNaN);
        }
        const ye = {
            aliceblue: [
                240,
                248,
                255
            ],
            antiquewhite: [
                250,
                235,
                215
            ],
            aqua: [
                0,
                255,
                255
            ],
            aquamarine: [
                127,
                255,
                212
            ],
            azure: [
                240,
                255,
                255
            ],
            beige: [
                245,
                245,
                220
            ],
            bisque: [
                255,
                228,
                196
            ],
            black: [
                0,
                0,
                0
            ],
            blanchedalmond: [
                255,
                235,
                205
            ],
            blue: [
                0,
                0,
                255
            ],
            blueviolet: [
                138,
                43,
                226
            ],
            brown: [
                165,
                42,
                42
            ],
            burlywood: [
                222,
                184,
                135
            ],
            cadetblue: [
                95,
                158,
                160
            ],
            chartreuse: [
                127,
                255,
                0
            ],
            chocolate: [
                210,
                105,
                30
            ],
            coral: [
                255,
                127,
                80
            ],
            cornflowerblue: [
                100,
                149,
                237
            ],
            cornsilk: [
                255,
                248,
                220
            ],
            crimson: [
                220,
                20,
                60
            ],
            cyan: [
                0,
                255,
                255
            ],
            darkblue: [
                0,
                0,
                139
            ],
            darkcyan: [
                0,
                139,
                139
            ],
            darkgoldenrod: [
                184,
                134,
                11
            ],
            darkgray: [
                169,
                169,
                169
            ],
            darkgreen: [
                0,
                100,
                0
            ],
            darkgrey: [
                169,
                169,
                169
            ],
            darkkhaki: [
                189,
                183,
                107
            ],
            darkmagenta: [
                139,
                0,
                139
            ],
            darkolivegreen: [
                85,
                107,
                47
            ],
            darkorange: [
                255,
                140,
                0
            ],
            darkorchid: [
                153,
                50,
                204
            ],
            darkred: [
                139,
                0,
                0
            ],
            darksalmon: [
                233,
                150,
                122
            ],
            darkseagreen: [
                143,
                188,
                143
            ],
            darkslateblue: [
                72,
                61,
                139
            ],
            darkslategray: [
                47,
                79,
                79
            ],
            darkslategrey: [
                47,
                79,
                79
            ],
            darkturquoise: [
                0,
                206,
                209
            ],
            darkviolet: [
                148,
                0,
                211
            ],
            deeppink: [
                255,
                20,
                147
            ],
            deepskyblue: [
                0,
                191,
                255
            ],
            dimgray: [
                105,
                105,
                105
            ],
            dimgrey: [
                105,
                105,
                105
            ],
            dodgerblue: [
                30,
                144,
                255
            ],
            firebrick: [
                178,
                34,
                34
            ],
            floralwhite: [
                255,
                250,
                240
            ],
            forestgreen: [
                34,
                139,
                34
            ],
            fuchsia: [
                255,
                0,
                255
            ],
            gainsboro: [
                220,
                220,
                220
            ],
            ghostwhite: [
                248,
                248,
                255
            ],
            gold: [
                255,
                215,
                0
            ],
            goldenrod: [
                218,
                165,
                32
            ],
            gray: [
                128,
                128,
                128
            ],
            green: [
                0,
                128,
                0
            ],
            greenyellow: [
                173,
                255,
                47
            ],
            grey: [
                128,
                128,
                128
            ],
            honeydew: [
                240,
                255,
                240
            ],
            hotpink: [
                255,
                105,
                180
            ],
            indianred: [
                205,
                92,
                92
            ],
            indigo: [
                75,
                0,
                130
            ],
            ivory: [
                255,
                255,
                240
            ],
            khaki: [
                240,
                230,
                140
            ],
            lavender: [
                230,
                230,
                250
            ],
            lavenderblush: [
                255,
                240,
                245
            ],
            lawngreen: [
                124,
                252,
                0
            ],
            lemonchiffon: [
                255,
                250,
                205
            ],
            lightblue: [
                173,
                216,
                230
            ],
            lightcoral: [
                240,
                128,
                128
            ],
            lightcyan: [
                224,
                255,
                255
            ],
            lightgoldenrodyellow: [
                250,
                250,
                210
            ],
            lightgray: [
                211,
                211,
                211
            ],
            lightgreen: [
                144,
                238,
                144
            ],
            lightgrey: [
                211,
                211,
                211
            ],
            lightpink: [
                255,
                182,
                193
            ],
            lightsalmon: [
                255,
                160,
                122
            ],
            lightseagreen: [
                32,
                178,
                170
            ],
            lightskyblue: [
                135,
                206,
                250
            ],
            lightslategray: [
                119,
                136,
                153
            ],
            lightslategrey: [
                119,
                136,
                153
            ],
            lightsteelblue: [
                176,
                196,
                222
            ],
            lightyellow: [
                255,
                255,
                224
            ],
            lime: [
                0,
                255,
                0
            ],
            limegreen: [
                50,
                205,
                50
            ],
            linen: [
                250,
                240,
                230
            ],
            magenta: [
                255,
                0,
                255
            ],
            maroon: [
                128,
                0,
                0
            ],
            mediumaquamarine: [
                102,
                205,
                170
            ],
            mediumblue: [
                0,
                0,
                205
            ],
            mediumorchid: [
                186,
                85,
                211
            ],
            mediumpurple: [
                147,
                112,
                219
            ],
            mediumseagreen: [
                60,
                179,
                113
            ],
            mediumslateblue: [
                123,
                104,
                238
            ],
            mediumspringgreen: [
                0,
                250,
                154
            ],
            mediumturquoise: [
                72,
                209,
                204
            ],
            mediumvioletred: [
                199,
                21,
                133
            ],
            midnightblue: [
                25,
                25,
                112
            ],
            mintcream: [
                245,
                255,
                250
            ],
            mistyrose: [
                255,
                228,
                225
            ],
            moccasin: [
                255,
                228,
                181
            ],
            navajowhite: [
                255,
                222,
                173
            ],
            navy: [
                0,
                0,
                128
            ],
            oldlace: [
                253,
                245,
                230
            ],
            olive: [
                128,
                128,
                0
            ],
            olivedrab: [
                107,
                142,
                35
            ],
            orange: [
                255,
                165,
                0
            ],
            orangered: [
                255,
                69,
                0
            ],
            orchid: [
                218,
                112,
                214
            ],
            palegoldenrod: [
                238,
                232,
                170
            ],
            palegreen: [
                152,
                251,
                152
            ],
            paleturquoise: [
                175,
                238,
                238
            ],
            palevioletred: [
                219,
                112,
                147
            ],
            papayawhip: [
                255,
                239,
                213
            ],
            peachpuff: [
                255,
                218,
                185
            ],
            peru: [
                205,
                133,
                63
            ],
            pink: [
                255,
                192,
                203
            ],
            plum: [
                221,
                160,
                221
            ],
            powderblue: [
                176,
                224,
                230
            ],
            purple: [
                128,
                0,
                128
            ],
            rebeccapurple: [
                102,
                51,
                153
            ],
            red: [
                255,
                0,
                0
            ],
            rosybrown: [
                188,
                143,
                143
            ],
            royalblue: [
                65,
                105,
                225
            ],
            saddlebrown: [
                139,
                69,
                19
            ],
            salmon: [
                250,
                128,
                114
            ],
            sandybrown: [
                244,
                164,
                96
            ],
            seagreen: [
                46,
                139,
                87
            ],
            seashell: [
                255,
                245,
                238
            ],
            sienna: [
                160,
                82,
                45
            ],
            silver: [
                192,
                192,
                192
            ],
            skyblue: [
                135,
                206,
                235
            ],
            slateblue: [
                106,
                90,
                205
            ],
            slategray: [
                112,
                128,
                144
            ],
            slategrey: [
                112,
                128,
                144
            ],
            snow: [
                255,
                250,
                250
            ],
            springgreen: [
                0,
                255,
                127
            ],
            steelblue: [
                70,
                130,
                180
            ],
            tan: [
                210,
                180,
                140
            ],
            teal: [
                0,
                128,
                128
            ],
            thistle: [
                216,
                191,
                216
            ],
            tomato: [
                255,
                99,
                71
            ],
            turquoise: [
                64,
                224,
                208
            ],
            violet: [
                238,
                130,
                238
            ],
            wheat: [
                245,
                222,
                179
            ],
            white: [
                255,
                255,
                255
            ],
            whitesmoke: [
                245,
                245,
                245
            ],
            yellow: [
                255,
                255,
                0
            ],
            yellowgreen: [
                154,
                205,
                50
            ]
        };
        function me(t, e, r) {
            return t + r * (e - t);
        }
        function ge(t, e, r) {
            return t.map((t, n)=>me(t, e[n], r));
        }
        class xe {
            constructor(t, e, r, n = 1, i = !0){
                this.r = t, this.g = e, this.b = r, this.a = n, i || (this.r *= n, this.g *= n, this.b *= n, n || this.overwriteGetter("rgb", [
                    t,
                    e,
                    r,
                    n
                ]));
            }
            static parse(t) {
                if (t instanceof xe) return t;
                if ("string" != typeof t) return;
                const e = function(t) {
                    if ("transparent" === (t = t.toLowerCase().trim())) return [
                        0,
                        0,
                        0,
                        0
                    ];
                    const e = ye[t];
                    if (e) {
                        const [t, r, n] = e;
                        return [
                            t / 255,
                            r / 255,
                            n / 255,
                            1
                        ];
                    }
                    if (t.startsWith("#") && /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(t)) {
                        const e = t.length < 6 ? 1 : 2;
                        let r = 1;
                        return [
                            he(t.slice(r, r += e)),
                            he(t.slice(r, r += e)),
                            he(t.slice(r, r += e)),
                            he(t.slice(r, r + e) || "ff")
                        ];
                    }
                    if (t.startsWith("rgb")) {
                        const e = t.match(/^rgba?\(\s*([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                        if (e) {
                            const [t, r, n, i, s, a, o, l, u, c, h, p] = e, f = [
                                i || " ",
                                o || " ",
                                c
                            ].join("");
                            if ("  " === f || "  /" === f || ",," === f || ",,," === f) {
                                const t = [
                                    n,
                                    a,
                                    u
                                ].join(""), e = "%%%" === t ? 100 : "" === t ? 255 : 0;
                                if (e) {
                                    const t = [
                                        fe(+r / e, 0, 1),
                                        fe(+s / e, 0, 1),
                                        fe(+l / e, 0, 1),
                                        h ? pe(+h, p) : 1
                                    ];
                                    if (de(t)) return t;
                                }
                            }
                            return;
                        }
                    }
                    const r = t.match(/^hsla?\(\s*([\de.+-]+)(?:deg)?(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                    if (r) {
                        const [t, e, n, i, s, a, o, l, u] = r, c = [
                            n || " ",
                            s || " ",
                            o
                        ].join("");
                        if ("  " === c || "  /" === c || ",," === c || ",,," === c) {
                            const t = [
                                +e,
                                fe(+i, 0, 100),
                                fe(+a, 0, 100),
                                l ? pe(+l, u) : 1
                            ];
                            if (de(t)) return function([t, e, r, n]) {
                                function i(n) {
                                    const i = (n + t / 30) % 12, s = e * Math.min(r, 1 - r);
                                    return r - s * Math.max(-1, Math.min(i - 3, 9 - i, 1));
                                }
                                return t = ie(t), e /= 100, r /= 100, [
                                    i(0),
                                    i(8),
                                    i(4),
                                    n
                                ];
                            }(t);
                        }
                    }
                }(t);
                return e ? new xe(...e, !1) : void 0;
            }
            get rgb() {
                const { r: t, g: e, b: r, a: n } = this, i = n || 1 / 0;
                return this.overwriteGetter("rgb", [
                    t / i,
                    e / i,
                    r / i,
                    n
                ]);
            }
            get hcl() {
                return this.overwriteGetter("hcl", function(t) {
                    const [e, r, n, i] = se(t), s = Math.sqrt(r * r + n * n);
                    return [
                        Math.round(1e4 * s) ? ie(Math.atan2(n, r) * ne) : NaN,
                        s,
                        e,
                        i
                    ];
                }(this.rgb));
            }
            get lab() {
                return this.overwriteGetter("lab", se(this.rgb));
            }
            overwriteGetter(t, e) {
                return Object.defineProperty(this, t, {
                    value: e
                }), e;
            }
            toString() {
                const [t, e, r, n] = this.rgb;
                return `rgba(${[
                    t,
                    e,
                    r
                ].map((t)=>Math.round(255 * t)).join(",")},${n})`;
            }
            static interpolate(t, e, r, n = "rgb") {
                switch(n){
                    case "rgb":
                        {
                            const [n, i, s, a] = ge(t.rgb, e.rgb, r);
                            return new xe(n, i, s, a, !1);
                        }
                    case "hcl":
                        {
                            const [n, i, s, a] = t.hcl, [o, l, u, c] = e.hcl;
                            let h, p;
                            if (isNaN(n) || isNaN(o)) isNaN(n) ? isNaN(o) ? h = NaN : (h = o, 1 !== s && 0 !== s || (p = l)) : (h = n, 1 !== u && 0 !== u || (p = i));
                            else {
                                let t = o - n;
                                o > n && t > 180 ? t -= 360 : o < n && n - o > 180 && (t += 360), h = n + r * t;
                            }
                            const [f, d, y, m] = function([t, e, r, n]) {
                                return t = isNaN(t) ? 0 : t * re, le([
                                    r,
                                    Math.cos(t) * e,
                                    Math.sin(t) * e,
                                    n
                                ]);
                            }([
                                h,
                                null != p ? p : me(i, l, r),
                                me(s, u, r),
                                me(a, c, r)
                            ]);
                            return new xe(f, d, y, m, !1);
                        }
                    case "lab":
                        {
                            const [n, i, s, a] = le(ge(t.lab, e.lab, r));
                            return new xe(n, i, s, a, !1);
                        }
                }
            }
        }
        xe.black = new xe(0, 0, 0, 1), xe.white = new xe(1, 1, 1, 1), xe.transparent = new xe(0, 0, 0, 0), xe.red = new xe(1, 0, 0, 1);
        class ve {
            constructor(t, e, r){
                this.sensitivity = t ? e ? "variant" : "case" : e ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                    sensitivity: this.sensitivity,
                    usage: "search"
                });
            }
            compare(t, e) {
                return this.collator.compare(t, e);
            }
            resolvedLocale() {
                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
            }
        }
        const be = [
            "bottom",
            "center",
            "top"
        ];
        class we {
            constructor(t, e, r, n, i, s){
                this.text = t, this.image = e, this.scale = r, this.fontStack = n, this.textColor = i, this.verticalAlign = s;
            }
        }
        class _e {
            constructor(t){
                this.sections = t;
            }
            static fromString(t) {
                return new _e([
                    new we(t, null, null, null, null, null)
                ]);
            }
            isEmpty() {
                return 0 === this.sections.length || !this.sections.some((t)=>0 !== t.text.length || t.image && 0 !== t.image.name.length);
            }
            static factory(t) {
                return t instanceof _e ? t : _e.fromString(t);
            }
            toString() {
                return 0 === this.sections.length ? "" : this.sections.map((t)=>t.text).join("");
            }
        }
        class Se {
            constructor(t){
                this.values = t.slice();
            }
            static parse(t) {
                if (t instanceof Se) return t;
                if ("number" == typeof t) return new Se([
                    t,
                    t,
                    t,
                    t
                ]);
                if (Array.isArray(t) && !(t.length < 1 || t.length > 4)) {
                    for (const e of t)if ("number" != typeof e) return;
                    switch(t.length){
                        case 1:
                            t = [
                                t[0],
                                t[0],
                                t[0],
                                t[0]
                            ];
                            break;
                        case 2:
                            t = [
                                t[0],
                                t[1],
                                t[0],
                                t[1]
                            ];
                            break;
                        case 3:
                            t = [
                                t[0],
                                t[1],
                                t[2],
                                t[1]
                            ];
                    }
                    return new Se(t);
                }
            }
            toString() {
                return JSON.stringify(this.values);
            }
            static interpolate(t, e, r) {
                return new Se(ge(t.values, e.values, r));
            }
        }
        class Ae {
            constructor(t){
                this.name = "ExpressionEvaluationError", this.message = t;
            }
            toJSON() {
                return this.message;
            }
        }
        const ke = new Set([
            "center",
            "left",
            "right",
            "top",
            "bottom",
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right"
        ]);
        class Me {
            constructor(t){
                this.values = t.slice();
            }
            static parse(t) {
                if (t instanceof Me) return t;
                if (Array.isArray(t) && !(t.length < 1) && t.length % 2 == 0) {
                    for(let e = 0; e < t.length; e += 2){
                        const r = t[e], n = t[e + 1];
                        if ("string" != typeof r || !ke.has(r)) return;
                        if (!Array.isArray(n) || 2 !== n.length || "number" != typeof n[0] || "number" != typeof n[1]) return;
                    }
                    return new Me(t);
                }
            }
            toString() {
                return JSON.stringify(this.values);
            }
            static interpolate(t, e, r) {
                const n = t.values, i = e.values;
                if (n.length !== i.length) throw new Ae(`Cannot interpolate values of different length. from: ${t.toString()}, to: ${e.toString()}`);
                const s = [];
                for(let t = 0; t < n.length; t += 2){
                    if (n[t] !== i[t]) throw new Ae(`Cannot interpolate values containing mismatched anchors. from[${t}]: ${n[t]}, to[${t}]: ${i[t]}`);
                    s.push(n[t]);
                    const [e, a] = n[t + 1], [o, l] = i[t + 1];
                    s.push([
                        me(e, o, r),
                        me(a, l, r)
                    ]);
                }
                return new Me(s);
            }
        }
        class Ie {
            constructor(t){
                this.name = t.name, this.available = t.available;
            }
            toString() {
                return this.name;
            }
            static fromString(t) {
                return t ? new Ie({
                    name: t,
                    available: !1
                }) : null;
            }
        }
        class ze {
            constructor(t, e, r){
                this.from = t, this.to = e, this.transition = r;
            }
            static interpolate(t, e, r) {
                return new ze(t, e, r);
            }
            static parse(t) {
                return t instanceof ze ? t : Array.isArray(t) && 3 === t.length && "string" == typeof t[0] && "string" == typeof t[1] && "number" == typeof t[2] ? new ze(t[0], t[1], t[2]) : "object" == typeof t && "string" == typeof t.from && "string" == typeof t.to && "number" == typeof t.transition ? new ze(t.from, t.to, t.transition) : "string" == typeof t ? new ze(t, t, 1) : void 0;
            }
        }
        function Pe(t, e, r, n) {
            return "number" == typeof t && t >= 0 && t <= 255 && "number" == typeof e && e >= 0 && e <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid rgba value [${[
                t,
                e,
                r,
                n
            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n ? [
                t,
                e,
                r,
                n
            ] : [
                t,
                e,
                r
            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
        }
        function Ce(t) {
            if (null === t || "string" == typeof t || "boolean" == typeof t || "number" == typeof t || t instanceof ze || t instanceof xe || t instanceof ve || t instanceof _e || t instanceof Se || t instanceof Me || t instanceof Ie) return !0;
            if (Array.isArray(t)) {
                for (const e of t)if (!Ce(e)) return !1;
                return !0;
            }
            if ("object" == typeof t) {
                for(const e in t)if (!Ce(t[e])) return !1;
                return !0;
            }
            return !1;
        }
        function Be(t) {
            if (null === t) return Ct;
            if ("string" == typeof t) return Vt;
            if ("boolean" == typeof t) return Et;
            if ("number" == typeof t) return Bt;
            if (t instanceof xe) return Tt;
            if (t instanceof ze) return Ft;
            if (t instanceof ve) return Ot;
            if (t instanceof _e) return Dt;
            if (t instanceof Se) return Rt;
            if (t instanceof Me) return Nt;
            if (t instanceof Ie) return jt;
            if (Array.isArray(t)) {
                const e = t.length;
                let r;
                for (const e of t){
                    const t = Be(e);
                    if (r) {
                        if (r === t) continue;
                        r = Lt;
                        break;
                    }
                    r = t;
                }
                return Ut(r || Lt, e);
            }
            return $t;
        }
        function Ve(t) {
            const e = typeof t;
            return null === t ? "" : "string" === e || "number" === e || "boolean" === e ? String(t) : t instanceof xe || t instanceof ze || t instanceof _e || t instanceof Se || t instanceof Me || t instanceof Ie ? t.toString() : JSON.stringify(t);
        }
        class Ee {
            constructor(t, e){
                this.type = t, this.value = e;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error(`'literal' expression requires exactly one argument, but found ${t.length - 1} instead.`);
                if (!Ce(t[1])) return e.error("invalid value");
                const r = t[1];
                let n = Be(r);
                const i = e.expectedType;
                return "array" !== n.kind || 0 !== n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (n = i), new Ee(n, r);
            }
            evaluate() {
                return this.value;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
        }
        const Te = {
            string: Vt,
            number: Bt,
            boolean: Et,
            object: $t
        };
        class Fe {
            constructor(t, e){
                this.type = t, this.args = e;
            }
            static parse(t, e) {
                if (t.length < 2) return e.error("Expected at least one argument.");
                let r, n = 1;
                const i = t[0];
                if ("array" === i) {
                    let i, s;
                    if (t.length > 2) {
                        const r = t[1];
                        if ("string" != typeof r || !(r in Te) || "object" === r) return e.error('The item type argument of "array" must be one of string, number, boolean', 1);
                        i = Te[r], n++;
                    } else i = Lt;
                    if (t.length > 3) {
                        if (null !== t[2] && ("number" != typeof t[2] || t[2] < 0 || t[2] !== Math.floor(t[2]))) return e.error('The length argument to "array" must be a positive integer literal', 2);
                        s = t[2], n++;
                    }
                    r = Ut(i, s);
                } else {
                    if (!Te[i]) throw new Error(`Types doesn't contain name = ${i}`);
                    r = Te[i];
                }
                const s = [];
                for(; n < t.length; n++){
                    const r = e.parse(t[n], n, Lt);
                    if (!r) return null;
                    s.push(r);
                }
                return new Fe(r, s);
            }
            evaluate(t) {
                for(let e = 0; e < this.args.length; e++){
                    const r = this.args[e].evaluate(t);
                    if (!Zt(this.type, Be(r))) return r;
                    if (e === this.args.length - 1) throw new Ae(`Expected value to be of type ${qt(this.type)}, but found ${qt(Be(r))} instead.`);
                }
                throw new Error;
            }
            eachChild(t) {
                this.args.forEach(t);
            }
            outputDefined() {
                return this.args.every((t)=>t.outputDefined());
            }
        }
        const $e = {
            "to-boolean": Et,
            "to-color": Tt,
            "to-number": Bt,
            "to-string": Vt
        };
        class Le {
            constructor(t, e){
                this.type = t, this.args = e;
            }
            static parse(t, e) {
                if (t.length < 2) return e.error("Expected at least one argument.");
                const r = t[0];
                if (!$e[r]) throw new Error(`Can't parse ${r} as it is not part of the known types`);
                if (("to-boolean" === r || "to-string" === r) && 2 !== t.length) return e.error("Expected one argument.");
                const n = $e[r], i = [];
                for(let r = 1; r < t.length; r++){
                    const n = e.parse(t[r], r, Lt);
                    if (!n) return null;
                    i.push(n);
                }
                return new Le(n, i);
            }
            evaluate(t) {
                switch(this.type.kind){
                    case "boolean":
                        return Boolean(this.args[0].evaluate(t));
                    case "color":
                        {
                            let e, r;
                            for (const n of this.args){
                                if (e = n.evaluate(t), r = null, e instanceof xe) return e;
                                if ("string" == typeof e) {
                                    const r = t.parseColor(e);
                                    if (r) return r;
                                } else if (Array.isArray(e) && (r = e.length < 3 || e.length > 4 ? `Invalid rgba value ${JSON.stringify(e)}: expected an array containing either three or four numeric values.` : Pe(e[0], e[1], e[2], e[3]), !r)) return new xe(e[0] / 255, e[1] / 255, e[2] / 255, e[3]);
                            }
                            throw new Ae(r || `Could not parse color from value '${"string" == typeof e ? e : JSON.stringify(e)}'`);
                        }
                    case "padding":
                        {
                            let e;
                            for (const r of this.args){
                                e = r.evaluate(t);
                                const n = Se.parse(e);
                                if (n) return n;
                            }
                            throw new Ae(`Could not parse padding from value '${"string" == typeof e ? e : JSON.stringify(e)}'`);
                        }
                    case "variableAnchorOffsetCollection":
                        {
                            let e;
                            for (const r of this.args){
                                e = r.evaluate(t);
                                const n = Me.parse(e);
                                if (n) return n;
                            }
                            throw new Ae(`Could not parse variableAnchorOffsetCollection from value '${"string" == typeof e ? e : JSON.stringify(e)}'`);
                        }
                    case "number":
                        {
                            let e = null;
                            for (const r of this.args){
                                if (e = r.evaluate(t), null === e) return 0;
                                const n = Number(e);
                                if (!isNaN(n)) return n;
                            }
                            throw new Ae(`Could not convert ${JSON.stringify(e)} to number.`);
                        }
                    case "formatted":
                        return _e.fromString(Ve(this.args[0].evaluate(t)));
                    case "resolvedImage":
                        return Ie.fromString(Ve(this.args[0].evaluate(t)));
                    case "projectionDefinition":
                        return this.args[0].evaluate(t);
                    default:
                        return Ve(this.args[0].evaluate(t));
                }
            }
            eachChild(t) {
                this.args.forEach(t);
            }
            outputDefined() {
                return this.args.every((t)=>t.outputDefined());
            }
        }
        const Oe = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        class De {
            constructor(){
                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null;
            }
            id() {
                return this.feature && "id" in this.feature ? this.feature.id : null;
            }
            geometryType() {
                return this.feature ? "number" == typeof this.feature.type ? Oe[this.feature.type] : this.feature.type : null;
            }
            geometry() {
                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
            }
            canonicalID() {
                return this.canonical;
            }
            properties() {
                return this.feature && this.feature.properties || {};
            }
            parseColor(t) {
                let e = this._parseColorCache[t];
                return e || (e = this._parseColorCache[t] = xe.parse(t)), e;
            }
        }
        class Re {
            constructor(t, e, r = [], n, i = new Pt, s = []){
                this.registry = t, this.path = r, this.key = r.map((t)=>`[${t}]`).join(""), this.scope = i, this.errors = s, this.expectedType = n, this._isConstant = e;
            }
            parse(t, e, r, n, i = {}) {
                return e ? this.concat(e, r, n)._parse(t, i) : this._parse(t, i);
            }
            _parse(t, e) {
                function r(t, e, r) {
                    return "assert" === r ? new Fe(e, [
                        t
                    ]) : "coerce" === r ? new Le(e, [
                        t
                    ]) : t;
                }
                if (null !== t && "string" != typeof t && "boolean" != typeof t && "number" != typeof t || (t = [
                    "literal",
                    t
                ]), Array.isArray(t)) {
                    if (0 === t.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                    const n = t[0];
                    if ("string" != typeof n) return this.error(`Expression name must be a string, but found ${typeof n} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
                    const i = this.registry[n];
                    if (i) {
                        let n = i.parse(t, this);
                        if (!n) return null;
                        if (this.expectedType) {
                            const t = this.expectedType, i = n.type;
                            if ("string" !== t.kind && "number" !== t.kind && "boolean" !== t.kind && "object" !== t.kind && "array" !== t.kind || "value" !== i.kind) {
                                if ("projectionDefinition" !== t.kind || "string" !== i.kind && "array" !== i.kind) {
                                    if ("color" !== t.kind && "formatted" !== t.kind && "resolvedImage" !== t.kind || "value" !== i.kind && "string" !== i.kind) {
                                        if ("padding" !== t.kind || "value" !== i.kind && "number" !== i.kind && "array" !== i.kind) {
                                            if ("variableAnchorOffsetCollection" !== t.kind || "value" !== i.kind && "array" !== i.kind) {
                                                if (this.checkSubtype(t, i)) return null;
                                            } else n = r(n, t, e.typeAnnotation || "coerce");
                                        } else n = r(n, t, e.typeAnnotation || "coerce");
                                    } else n = r(n, t, e.typeAnnotation || "coerce");
                                } else n = r(n, t, e.typeAnnotation || "coerce");
                            } else n = r(n, t, e.typeAnnotation || "assert");
                        }
                        if (!(n instanceof Ee) && "resolvedImage" !== n.type.kind && this._isConstant(n)) {
                            const t = new De;
                            try {
                                n = new Ee(n.type, n.evaluate(t));
                            } catch (t) {
                                return this.error(t.message), null;
                            }
                        }
                        return n;
                    }
                    return this.error(`Unknown expression "${n}". If you wanted a literal array, use ["literal", [...]].`, 0);
                }
                return this.error(void 0 === t ? "'undefined' value invalid. Use null instead." : "object" == typeof t ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof t} instead.`);
            }
            concat(t, e, r) {
                const n = "number" == typeof t ? this.path.concat(t) : this.path, i = r ? this.scope.concat(r) : this.scope;
                return new Re(this.registry, this._isConstant, n, e || null, i, this.errors);
            }
            error(t, ...e) {
                const r = `${this.key}${e.map((t)=>`[${t}]`).join("")}`;
                this.errors.push(new zt(r, t));
            }
            checkSubtype(t, e) {
                const r = Zt(t, e);
                return r && this.error(r), r;
            }
        }
        class je {
            constructor(t, e){
                this.type = e.type, this.bindings = [].concat(t), this.result = e;
            }
            evaluate(t) {
                return this.result.evaluate(t);
            }
            eachChild(t) {
                for (const e of this.bindings)t(e[1]);
                t(this.result);
            }
            static parse(t, e) {
                if (t.length < 4) return e.error(`Expected at least 3 arguments, but found ${t.length - 1} instead.`);
                const r = [];
                for(let n = 1; n < t.length - 1; n += 2){
                    const i = t[n];
                    if ("string" != typeof i) return e.error(`Expected string, but found ${typeof i} instead.`, n);
                    if (/[^a-zA-Z0-9_]/.test(i)) return e.error("Variable names must contain only alphanumeric characters or '_'.", n);
                    const s = e.parse(t[n + 1], n + 1);
                    if (!s) return null;
                    r.push([
                        i,
                        s
                    ]);
                }
                const n = e.parse(t[t.length - 1], t.length - 1, e.expectedType, r);
                return n ? new je(r, n) : null;
            }
            outputDefined() {
                return this.result.outputDefined();
            }
        }
        class Ne {
            constructor(t, e){
                this.type = e.type, this.name = t, this.boundExpression = e;
            }
            static parse(t, e) {
                if (2 !== t.length || "string" != typeof t[1]) return e.error("'var' expression requires exactly one string literal argument.");
                const r = t[1];
                return e.scope.has(r) ? new Ne(r, e.scope.get(r)) : e.error(`Unknown variable "${r}". Make sure "${r}" has been bound in an enclosing "let" expression before using it.`, 1);
            }
            evaluate(t) {
                return this.boundExpression.evaluate(t);
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
        }
        class Ue {
            constructor(t, e, r){
                this.type = t, this.index = e, this.input = r;
            }
            static parse(t, e) {
                if (3 !== t.length) return e.error(`Expected 2 arguments, but found ${t.length - 1} instead.`);
                const r = e.parse(t[1], 1, Bt), n = e.parse(t[2], 2, Ut(e.expectedType || Lt));
                return r && n ? new Ue(n.type.itemType, r, n) : null;
            }
            evaluate(t) {
                const e = this.index.evaluate(t), r = this.input.evaluate(t);
                if (e < 0) throw new Ae(`Array index out of bounds: ${e} < 0.`);
                if (e >= r.length) throw new Ae(`Array index out of bounds: ${e} > ${r.length - 1}.`);
                if (e !== Math.floor(e)) throw new Ae(`Array index must be an integer, but found ${e} instead.`);
                return r[e];
            }
            eachChild(t) {
                t(this.index), t(this.input);
            }
            outputDefined() {
                return !1;
            }
        }
        class qe {
            constructor(t, e){
                this.type = Et, this.needle = t, this.haystack = e;
            }
            static parse(t, e) {
                if (3 !== t.length) return e.error(`Expected 2 arguments, but found ${t.length - 1} instead.`);
                const r = e.parse(t[1], 1, Lt), n = e.parse(t[2], 2, Lt);
                return r && n ? Kt(r.type, [
                    Et,
                    Vt,
                    Bt,
                    Ct,
                    Lt
                ]) ? new qe(r, n) : e.error(`Expected first argument to be of type boolean, string, number or null, but found ${qt(r.type)} instead`) : null;
            }
            evaluate(t) {
                const e = this.needle.evaluate(t), r = this.haystack.evaluate(t);
                if (!r) return !1;
                if (!Xt(e, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new Ae(`Expected first argument to be of type boolean, string, number or null, but found ${qt(Be(e))} instead.`);
                if (!Xt(r, [
                    "string",
                    "array"
                ])) throw new Ae(`Expected second argument to be of type array or string, but found ${qt(Be(r))} instead.`);
                return r.indexOf(e) >= 0;
            }
            eachChild(t) {
                t(this.needle), t(this.haystack);
            }
            outputDefined() {
                return !0;
            }
        }
        class Ge {
            constructor(t, e, r){
                this.type = Bt, this.needle = t, this.haystack = e, this.fromIndex = r;
            }
            static parse(t, e) {
                if (t.length <= 2 || t.length >= 5) return e.error(`Expected 3 or 4 arguments, but found ${t.length - 1} instead.`);
                const r = e.parse(t[1], 1, Lt), n = e.parse(t[2], 2, Lt);
                if (!r || !n) return null;
                if (!Kt(r.type, [
                    Et,
                    Vt,
                    Bt,
                    Ct,
                    Lt
                ])) return e.error(`Expected first argument to be of type boolean, string, number or null, but found ${qt(r.type)} instead`);
                if (4 === t.length) {
                    const i = e.parse(t[3], 3, Bt);
                    return i ? new Ge(r, n, i) : null;
                }
                return new Ge(r, n);
            }
            evaluate(t) {
                const e = this.needle.evaluate(t), r = this.haystack.evaluate(t);
                if (!Xt(e, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new Ae(`Expected first argument to be of type boolean, string, number or null, but found ${qt(Be(e))} instead.`);
                let n;
                if (this.fromIndex && (n = this.fromIndex.evaluate(t)), Xt(r, [
                    "string"
                ])) {
                    const t = r.indexOf(e, n);
                    return -1 === t ? -1 : [
                        ...r.slice(0, t)
                    ].length;
                }
                if (Xt(r, [
                    "array"
                ])) return r.indexOf(e, n);
                throw new Ae(`Expected second argument to be of type array or string, but found ${qt(Be(r))} instead.`);
            }
            eachChild(t) {
                t(this.needle), t(this.haystack), this.fromIndex && t(this.fromIndex);
            }
            outputDefined() {
                return !1;
            }
        }
        class Ze {
            constructor(t, e, r, n, i, s){
                this.inputType = t, this.type = e, this.input = r, this.cases = n, this.outputs = i, this.otherwise = s;
            }
            static parse(t, e) {
                if (t.length < 5) return e.error(`Expected at least 4 arguments, but found only ${t.length - 1}.`);
                if (t.length % 2 != 1) return e.error("Expected an even number of arguments.");
                let r, n;
                e.expectedType && "value" !== e.expectedType.kind && (n = e.expectedType);
                const i = {}, s = [];
                for(let a = 2; a < t.length - 1; a += 2){
                    let o = t[a];
                    const l = t[a + 1];
                    Array.isArray(o) || (o = [
                        o
                    ]);
                    const u = e.concat(a);
                    if (0 === o.length) return u.error("Expected at least one branch label.");
                    for (const t of o){
                        if ("number" != typeof t && "string" != typeof t) return u.error("Branch labels must be numbers or strings.");
                        if ("number" == typeof t && Math.abs(t) > Number.MAX_SAFE_INTEGER) return u.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                        if ("number" == typeof t && Math.floor(t) !== t) return u.error("Numeric branch labels must be integer values.");
                        if (r) {
                            if (u.checkSubtype(r, Be(t))) return null;
                        } else r = Be(t);
                        if (void 0 !== i[String(t)]) return u.error("Branch labels must be unique.");
                        i[String(t)] = s.length;
                    }
                    const c = e.parse(l, a, n);
                    if (!c) return null;
                    n = n || c.type, s.push(c);
                }
                const a = e.parse(t[1], 1, Lt);
                if (!a) return null;
                const o = e.parse(t[t.length - 1], t.length - 1, n);
                return o ? "value" !== a.type.kind && e.concat(1).checkSubtype(r, a.type) ? null : new Ze(r, n, a, i, s, o) : null;
            }
            evaluate(t) {
                const e = this.input.evaluate(t);
                return (Be(e) === this.inputType && this.outputs[this.cases[e]] || this.otherwise).evaluate(t);
            }
            eachChild(t) {
                t(this.input), this.outputs.forEach(t), t(this.otherwise);
            }
            outputDefined() {
                return this.outputs.every((t)=>t.outputDefined()) && this.otherwise.outputDefined();
            }
        }
        class Ke {
            constructor(t, e, r){
                this.type = t, this.branches = e, this.otherwise = r;
            }
            static parse(t, e) {
                if (t.length < 4) return e.error(`Expected at least 3 arguments, but found only ${t.length - 1}.`);
                if (t.length % 2 != 0) return e.error("Expected an odd number of arguments.");
                let r;
                e.expectedType && "value" !== e.expectedType.kind && (r = e.expectedType);
                const n = [];
                for(let i = 1; i < t.length - 1; i += 2){
                    const s = e.parse(t[i], i, Et);
                    if (!s) return null;
                    const a = e.parse(t[i + 1], i + 1, r);
                    if (!a) return null;
                    n.push([
                        s,
                        a
                    ]), r = r || a.type;
                }
                const i = e.parse(t[t.length - 1], t.length - 1, r);
                if (!i) return null;
                if (!r) throw new Error("Can't infer output type");
                return new Ke(r, n, i);
            }
            evaluate(t) {
                for (const [e, r] of this.branches)if (e.evaluate(t)) return r.evaluate(t);
                return this.otherwise.evaluate(t);
            }
            eachChild(t) {
                for (const [e, r] of this.branches)t(e), t(r);
                t(this.otherwise);
            }
            outputDefined() {
                return this.branches.every(([t, e])=>e.outputDefined()) && this.otherwise.outputDefined();
            }
        }
        class Xe {
            constructor(t, e, r, n){
                this.type = t, this.input = e, this.beginIndex = r, this.endIndex = n;
            }
            static parse(t, e) {
                if (t.length <= 2 || t.length >= 5) return e.error(`Expected 3 or 4 arguments, but found ${t.length - 1} instead.`);
                const r = e.parse(t[1], 1, Lt), n = e.parse(t[2], 2, Bt);
                if (!r || !n) return null;
                if (!Kt(r.type, [
                    Ut(Lt),
                    Vt,
                    Lt
                ])) return e.error(`Expected first argument to be of type array or string, but found ${qt(r.type)} instead`);
                if (4 === t.length) {
                    const i = e.parse(t[3], 3, Bt);
                    return i ? new Xe(r.type, r, n, i) : null;
                }
                return new Xe(r.type, r, n);
            }
            evaluate(t) {
                const e = this.input.evaluate(t), r = this.beginIndex.evaluate(t);
                let n;
                if (this.endIndex && (n = this.endIndex.evaluate(t)), Xt(e, [
                    "string"
                ])) return [
                    ...e
                ].slice(r, n).join("");
                if (Xt(e, [
                    "array"
                ])) return e.slice(r, n);
                throw new Ae(`Expected first argument to be of type array or string, but found ${qt(Be(e))} instead.`);
            }
            eachChild(t) {
                t(this.input), t(this.beginIndex), this.endIndex && t(this.endIndex);
            }
            outputDefined() {
                return !1;
            }
        }
        function He(t, e) {
            const r = t.length - 1;
            let n, i, s = 0, a = r, o = 0;
            for(; s <= a;)if (o = Math.floor((s + a) / 2), n = t[o], i = t[o + 1], n <= e) {
                if (o === r || e < i) return o;
                s = o + 1;
            } else {
                if (!(n > e)) throw new Ae("Input is not a number.");
                a = o - 1;
            }
            return 0;
        }
        class Ye {
            constructor(t, e, r){
                this.type = t, this.input = e, this.labels = [], this.outputs = [];
                for (const [t, e] of r)this.labels.push(t), this.outputs.push(e);
            }
            static parse(t, e) {
                if (t.length - 1 < 4) return e.error(`Expected at least 4 arguments, but found only ${t.length - 1}.`);
                if ((t.length - 1) % 2 != 0) return e.error("Expected an even number of arguments.");
                const r = e.parse(t[1], 1, Bt);
                if (!r) return null;
                const n = [];
                let i = null;
                e.expectedType && "value" !== e.expectedType.kind && (i = e.expectedType);
                for(let r = 1; r < t.length; r += 2){
                    const s = 1 === r ? -1 / 0 : t[r], a = t[r + 1], o = r, l = r + 1;
                    if ("number" != typeof s) return e.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', o);
                    if (n.length && n[n.length - 1][0] >= s) return e.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', o);
                    const u = e.parse(a, l, i);
                    if (!u) return null;
                    i = i || u.type, n.push([
                        s,
                        u
                    ]);
                }
                return new Ye(i, r, n);
            }
            evaluate(t) {
                const e = this.labels, r = this.outputs;
                if (1 === e.length) return r[0].evaluate(t);
                const n = this.input.evaluate(t);
                if (n <= e[0]) return r[0].evaluate(t);
                const i = e.length;
                return n >= e[i - 1] ? r[i - 1].evaluate(t) : r[He(e, n)].evaluate(t);
            }
            eachChild(t) {
                t(this.input);
                for (const e of this.outputs)t(e);
            }
            outputDefined() {
                return this.outputs.every((t)=>t.outputDefined());
            }
        }
        function Je(t) {
            return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
        }
        var We, Qe, tr = function() {
            if (Qe) return We;
            function t(t, e, r, n) {
                this.cx = 3 * t, this.bx = 3 * (r - t) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e, this.by = 3 * (n - e) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t, this.p1y = e, this.p2x = r, this.p2y = n;
            }
            return Qe = 1, We = t, t.prototype = {
                sampleCurveX: function(t) {
                    return ((this.ax * t + this.bx) * t + this.cx) * t;
                },
                sampleCurveY: function(t) {
                    return ((this.ay * t + this.by) * t + this.cy) * t;
                },
                sampleCurveDerivativeX: function(t) {
                    return (3 * this.ax * t + 2 * this.bx) * t + this.cx;
                },
                solveCurveX: function(t, e) {
                    if (void 0 === e && (e = 1e-6), t < 0) return 0;
                    if (t > 1) return 1;
                    for(var r = t, n = 0; n < 8; n++){
                        var i = this.sampleCurveX(r) - t;
                        if (Math.abs(i) < e) return r;
                        var s = this.sampleCurveDerivativeX(r);
                        if (Math.abs(s) < 1e-6) break;
                        r -= i / s;
                    }
                    var a = 0, o = 1;
                    for(r = t, n = 0; n < 20 && (i = this.sampleCurveX(r), !(Math.abs(i - t) < e)); n++)t > i ? a = r : o = r, r = .5 * (o - a) + a;
                    return r;
                },
                solve: function(t, e) {
                    return this.sampleCurveY(this.solveCurveX(t, e));
                }
            }, We;
        }(), er = Je(tr);
        class rr {
            constructor(t, e, r, n, i){
                this.type = t, this.operator = e, this.interpolation = r, this.input = n, this.labels = [], this.outputs = [];
                for (const [t, e] of i)this.labels.push(t), this.outputs.push(e);
            }
            static interpolationFactor(t, e, r, n) {
                let i = 0;
                if ("exponential" === t.name) i = nr(e, t.base, r, n);
                else if ("linear" === t.name) i = nr(e, 1, r, n);
                else if ("cubic-bezier" === t.name) {
                    const s = t.controlPoints;
                    i = new er(s[0], s[1], s[2], s[3]).solve(nr(e, 1, r, n));
                }
                return i;
            }
            static parse(t, e) {
                let [r, n, i, ...s] = t;
                if (!Array.isArray(n) || 0 === n.length) return e.error("Expected an interpolation type expression.", 1);
                if ("linear" === n[0]) n = {
                    name: "linear"
                };
                else if ("exponential" === n[0]) {
                    const t = n[1];
                    if ("number" != typeof t) return e.error("Exponential interpolation requires a numeric base.", 1, 1);
                    n = {
                        name: "exponential",
                        base: t
                    };
                } else {
                    if ("cubic-bezier" !== n[0]) return e.error(`Unknown interpolation type ${String(n[0])}`, 1, 0);
                    {
                        const t = n.slice(1);
                        if (4 !== t.length || t.some((t)=>"number" != typeof t || t < 0 || t > 1)) return e.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                        n = {
                            name: "cubic-bezier",
                            controlPoints: t
                        };
                    }
                }
                if (t.length - 1 < 4) return e.error(`Expected at least 4 arguments, but found only ${t.length - 1}.`);
                if ((t.length - 1) % 2 != 0) return e.error("Expected an even number of arguments.");
                if (i = e.parse(i, 2, Bt), !i) return null;
                const a = [];
                let o = null;
                "interpolate-hcl" === r || "interpolate-lab" === r ? o = Tt : e.expectedType && "value" !== e.expectedType.kind && (o = e.expectedType);
                for(let t = 0; t < s.length; t += 2){
                    const r = s[t], n = s[t + 1], i = t + 3, l = t + 4;
                    if ("number" != typeof r) return e.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i);
                    if (a.length && a[a.length - 1][0] >= r) return e.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i);
                    const u = e.parse(n, l, o);
                    if (!u) return null;
                    o = o || u.type, a.push([
                        r,
                        u
                    ]);
                }
                return Ht(o, Bt) || Ht(o, Ft) || Ht(o, Tt) || Ht(o, Rt) || Ht(o, Nt) || Ht(o, Ut(Bt)) ? new rr(o, r, n, i, a) : e.error(`Type ${qt(o)} is not interpolatable.`);
            }
            evaluate(t) {
                const e = this.labels, r = this.outputs;
                if (1 === e.length) return r[0].evaluate(t);
                const n = this.input.evaluate(t);
                if (n <= e[0]) return r[0].evaluate(t);
                const i = e.length;
                if (n >= e[i - 1]) return r[i - 1].evaluate(t);
                const s = He(e, n), a = rr.interpolationFactor(this.interpolation, n, e[s], e[s + 1]), o = r[s].evaluate(t), l = r[s + 1].evaluate(t);
                switch(this.operator){
                    case "interpolate":
                        switch(this.type.kind){
                            case "number":
                                return me(o, l, a);
                            case "color":
                                return xe.interpolate(o, l, a);
                            case "padding":
                                return Se.interpolate(o, l, a);
                            case "variableAnchorOffsetCollection":
                                return Me.interpolate(o, l, a);
                            case "array":
                                return ge(o, l, a);
                            case "projectionDefinition":
                                return ze.interpolate(o, l, a);
                        }
                    case "interpolate-hcl":
                        return xe.interpolate(o, l, a, "hcl");
                    case "interpolate-lab":
                        return xe.interpolate(o, l, a, "lab");
                }
            }
            eachChild(t) {
                t(this.input);
                for (const e of this.outputs)t(e);
            }
            outputDefined() {
                return this.outputs.every((t)=>t.outputDefined());
            }
        }
        function nr(t, e, r, n) {
            const i = n - r, s = t - r;
            return 0 === i ? 0 : 1 === e ? s / i : (Math.pow(e, s) - 1) / (Math.pow(e, i) - 1);
        }
        const ir = {
            color: xe.interpolate,
            number: me,
            padding: Se.interpolate,
            variableAnchorOffsetCollection: Me.interpolate,
            array: ge
        };
        class sr {
            constructor(t, e){
                this.type = t, this.args = e;
            }
            static parse(t, e) {
                if (t.length < 2) return e.error("Expected at least one argument.");
                let r = null;
                const n = e.expectedType;
                n && "value" !== n.kind && (r = n);
                const i = [];
                for (const n of t.slice(1)){
                    const t = e.parse(n, 1 + i.length, r, void 0, {
                        typeAnnotation: "omit"
                    });
                    if (!t) return null;
                    r = r || t.type, i.push(t);
                }
                if (!r) throw new Error("No output type");
                const s = n && i.some((t)=>Zt(n, t.type));
                return new sr(s ? Lt : r, i);
            }
            evaluate(t) {
                let e, r = null, n = 0;
                for (const i of this.args)if (n++, r = i.evaluate(t), r && r instanceof Ie && !r.available && (e || (e = r.name), r = null, n === this.args.length && (r = e)), null !== r) break;
                return r;
            }
            eachChild(t) {
                this.args.forEach(t);
            }
            outputDefined() {
                return this.args.every((t)=>t.outputDefined());
            }
        }
        function ar(t, e) {
            return "==" === t || "!=" === t ? "boolean" === e.kind || "string" === e.kind || "number" === e.kind || "null" === e.kind || "value" === e.kind : "string" === e.kind || "number" === e.kind || "value" === e.kind;
        }
        function or(t, e, r, n) {
            return 0 === n.compare(e, r);
        }
        function lr(t, e, r) {
            const n = "==" !== t && "!=" !== t;
            return class i {
                constructor(t, e, r){
                    this.type = Et, this.lhs = t, this.rhs = e, this.collator = r, this.hasUntypedArgument = "value" === t.type.kind || "value" === e.type.kind;
                }
                static parse(t, e) {
                    if (3 !== t.length && 4 !== t.length) return e.error("Expected two or three arguments.");
                    const r = t[0];
                    let s = e.parse(t[1], 1, Lt);
                    if (!s) return null;
                    if (!ar(r, s.type)) return e.concat(1).error(`"${r}" comparisons are not supported for type '${qt(s.type)}'.`);
                    let a = e.parse(t[2], 2, Lt);
                    if (!a) return null;
                    if (!ar(r, a.type)) return e.concat(2).error(`"${r}" comparisons are not supported for type '${qt(a.type)}'.`);
                    if (s.type.kind !== a.type.kind && "value" !== s.type.kind && "value" !== a.type.kind) return e.error(`Cannot compare types '${qt(s.type)}' and '${qt(a.type)}'.`);
                    n && ("value" === s.type.kind && "value" !== a.type.kind ? s = new Fe(a.type, [
                        s
                    ]) : "value" !== s.type.kind && "value" === a.type.kind && (a = new Fe(s.type, [
                        a
                    ])));
                    let o = null;
                    if (4 === t.length) {
                        if ("string" !== s.type.kind && "string" !== a.type.kind && "value" !== s.type.kind && "value" !== a.type.kind) return e.error("Cannot use collator to compare non-string types.");
                        if (o = e.parse(t[3], 3, Ot), !o) return null;
                    }
                    return new i(s, a, o);
                }
                evaluate(i) {
                    const s = this.lhs.evaluate(i), a = this.rhs.evaluate(i);
                    if (n && this.hasUntypedArgument) {
                        const e = Be(s), r = Be(a);
                        if (e.kind !== r.kind || "string" !== e.kind && "number" !== e.kind) throw new Ae(`Expected arguments for "${t}" to be (string, string) or (number, number), but found (${e.kind}, ${r.kind}) instead.`);
                    }
                    if (this.collator && !n && this.hasUntypedArgument) {
                        const t = Be(s), r = Be(a);
                        if ("string" !== t.kind || "string" !== r.kind) return e(i, s, a);
                    }
                    return this.collator ? r(i, s, a, this.collator.evaluate(i)) : e(i, s, a);
                }
                eachChild(t) {
                    t(this.lhs), t(this.rhs), this.collator && t(this.collator);
                }
                outputDefined() {
                    return !0;
                }
            };
        }
        const ur = lr("==", function(t, e, r) {
            return e === r;
        }, or), cr = lr("!=", function(t, e, r) {
            return e !== r;
        }, function(t, e, r, n) {
            return !or(0, e, r, n);
        }), hr = lr("<", function(t, e, r) {
            return e < r;
        }, function(t, e, r, n) {
            return n.compare(e, r) < 0;
        }), pr = lr(">", function(t, e, r) {
            return e > r;
        }, function(t, e, r, n) {
            return n.compare(e, r) > 0;
        }), fr = lr("<=", function(t, e, r) {
            return e <= r;
        }, function(t, e, r, n) {
            return n.compare(e, r) <= 0;
        }), dr = lr(">=", function(t, e, r) {
            return e >= r;
        }, function(t, e, r, n) {
            return n.compare(e, r) >= 0;
        });
        class yr {
            constructor(t, e, r){
                this.type = Ot, this.locale = r, this.caseSensitive = t, this.diacriticSensitive = e;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error("Expected one argument.");
                const r = t[1];
                if ("object" != typeof r || Array.isArray(r)) return e.error("Collator options argument must be an object.");
                const n = e.parse(void 0 !== r["case-sensitive"] && r["case-sensitive"], 1, Et);
                if (!n) return null;
                const i = e.parse(void 0 !== r["diacritic-sensitive"] && r["diacritic-sensitive"], 1, Et);
                if (!i) return null;
                let s = null;
                return r.locale && (s = e.parse(r.locale, 1, Vt), !s) ? null : new yr(n, i, s);
            }
            evaluate(t) {
                return new ve(this.caseSensitive.evaluate(t), this.diacriticSensitive.evaluate(t), this.locale ? this.locale.evaluate(t) : null);
            }
            eachChild(t) {
                t(this.caseSensitive), t(this.diacriticSensitive), this.locale && t(this.locale);
            }
            outputDefined() {
                return !1;
            }
        }
        class mr {
            constructor(t, e, r, n, i){
                this.type = Vt, this.number = t, this.locale = e, this.currency = r, this.minFractionDigits = n, this.maxFractionDigits = i;
            }
            static parse(t, e) {
                if (3 !== t.length) return e.error("Expected two arguments.");
                const r = e.parse(t[1], 1, Bt);
                if (!r) return null;
                const n = t[2];
                if ("object" != typeof n || Array.isArray(n)) return e.error("NumberFormat options argument must be an object.");
                let i = null;
                if (n.locale && (i = e.parse(n.locale, 1, Vt), !i)) return null;
                let s = null;
                if (n.currency && (s = e.parse(n.currency, 1, Vt), !s)) return null;
                let a = null;
                if (n["min-fraction-digits"] && (a = e.parse(n["min-fraction-digits"], 1, Bt), !a)) return null;
                let o = null;
                return n["max-fraction-digits"] && (o = e.parse(n["max-fraction-digits"], 1, Bt), !o) ? null : new mr(r, i, s, a, o);
            }
            evaluate(t) {
                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t) : [], {
                    style: this.currency ? "currency" : "decimal",
                    currency: this.currency ? this.currency.evaluate(t) : void 0,
                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t) : void 0,
                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t) : void 0
                }).format(this.number.evaluate(t));
            }
            eachChild(t) {
                t(this.number), this.locale && t(this.locale), this.currency && t(this.currency), this.minFractionDigits && t(this.minFractionDigits), this.maxFractionDigits && t(this.maxFractionDigits);
            }
            outputDefined() {
                return !1;
            }
        }
        class gr {
            constructor(t){
                this.type = Dt, this.sections = t;
            }
            static parse(t, e) {
                if (t.length < 2) return e.error("Expected at least one argument.");
                const r = t[1];
                if (!Array.isArray(r) && "object" == typeof r) return e.error("First argument must be an image or text section.");
                const n = [];
                let i = !1;
                for(let r = 1; r <= t.length - 1; ++r){
                    const s = t[r];
                    if (i && "object" == typeof s && !Array.isArray(s)) {
                        i = !1;
                        let t = null;
                        if (s["font-scale"] && (t = e.parse(s["font-scale"], 1, Bt), !t)) return null;
                        let r = null;
                        if (s["text-font"] && (r = e.parse(s["text-font"], 1, Ut(Vt)), !r)) return null;
                        let a = null;
                        if (s["text-color"] && (a = e.parse(s["text-color"], 1, Tt), !a)) return null;
                        let o = null;
                        if (s["vertical-align"]) {
                            if ("string" == typeof s["vertical-align"] && !be.includes(s["vertical-align"])) return e.error(`'vertical-align' must be one of: 'bottom', 'center', 'top' but found '${s["vertical-align"]}' instead.`);
                            if (o = e.parse(s["vertical-align"], 1, Vt), !o) return null;
                        }
                        const l = n[n.length - 1];
                        l.scale = t, l.font = r, l.textColor = a, l.verticalAlign = o;
                    } else {
                        const s = e.parse(t[r], 1, Lt);
                        if (!s) return null;
                        const a = s.type.kind;
                        if ("string" !== a && "value" !== a && "null" !== a && "resolvedImage" !== a) return e.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                        i = !0, n.push({
                            content: s,
                            scale: null,
                            font: null,
                            textColor: null,
                            verticalAlign: null
                        });
                    }
                }
                return new gr(n);
            }
            evaluate(t) {
                return new _e(this.sections.map((e)=>{
                    const r = e.content.evaluate(t);
                    return Be(r) === jt ? new we("", r, null, null, null, e.verticalAlign ? e.verticalAlign.evaluate(t) : null) : new we(Ve(r), null, e.scale ? e.scale.evaluate(t) : null, e.font ? e.font.evaluate(t).join(",") : null, e.textColor ? e.textColor.evaluate(t) : null, e.verticalAlign ? e.verticalAlign.evaluate(t) : null);
                }));
            }
            eachChild(t) {
                for (const e of this.sections)t(e.content), e.scale && t(e.scale), e.font && t(e.font), e.textColor && t(e.textColor), e.verticalAlign && t(e.verticalAlign);
            }
            outputDefined() {
                return !1;
            }
        }
        class xr {
            constructor(t){
                this.type = jt, this.input = t;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error("Expected two arguments.");
                const r = e.parse(t[1], 1, Vt);
                return r ? new xr(r) : e.error("No image name provided.");
            }
            evaluate(t) {
                const e = this.input.evaluate(t), r = Ie.fromString(e);
                return r && t.availableImages && (r.available = t.availableImages.indexOf(e) > -1), r;
            }
            eachChild(t) {
                t(this.input);
            }
            outputDefined() {
                return !1;
            }
        }
        class vr {
            constructor(t){
                this.type = Bt, this.input = t;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error(`Expected 1 argument, but found ${t.length - 1} instead.`);
                const r = e.parse(t[1], 1);
                return r ? "array" !== r.type.kind && "string" !== r.type.kind && "value" !== r.type.kind ? e.error(`Expected argument of type string or array, but found ${qt(r.type)} instead.`) : new vr(r) : null;
            }
            evaluate(t) {
                const e = this.input.evaluate(t);
                if ("string" == typeof e) return [
                    ...e
                ].length;
                if (Array.isArray(e)) return e.length;
                throw new Ae(`Expected value to be of type string or array, but found ${qt(Be(e))} instead.`);
            }
            eachChild(t) {
                t(this.input);
            }
            outputDefined() {
                return !1;
            }
        }
        const br = 8192;
        function wr(t, e) {
            const r = (180 + t[0]) / 360, n = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t[1] * Math.PI / 360))) / 360, i = Math.pow(2, e.z);
            return [
                Math.round(r * i * br),
                Math.round(n * i * br)
            ];
        }
        function _r(t, e) {
            const r = Math.pow(2, e.z);
            var n, i;
            return [
                (i = (t[0] / br + e.x) / r, 360 * i - 180),
                (n = (t[1] / br + e.y) / r, 360 / Math.PI * Math.atan(Math.exp((180 - 360 * n) * Math.PI / 180)) - 90)
            ];
        }
        function Sr(t, e) {
            t[0] = Math.min(t[0], e[0]), t[1] = Math.min(t[1], e[1]), t[2] = Math.max(t[2], e[0]), t[3] = Math.max(t[3], e[1]);
        }
        function Ar(t, e) {
            return !(t[0] <= e[0] || t[2] >= e[2] || t[1] <= e[1] || t[3] >= e[3]);
        }
        function kr(t, e, r) {
            const n = t[0] - e[0], i = t[1] - e[1], s = t[0] - r[0], a = t[1] - r[1];
            return n * a - s * i == 0 && n * s <= 0 && i * a <= 0;
        }
        function Mr(t, e, r, n) {
            var i, s;
            return 0 != (i = [
                n[0] - r[0],
                n[1] - r[1]
            ])[0] * (s = [
                e[0] - t[0],
                e[1] - t[1]
            ])[1] - i[1] * s[0] && !(!Vr(t, e, r, n) || !Vr(r, n, t, e));
        }
        function Ir(t, e, r) {
            for (const n of r)for(let r = 0; r < n.length - 1; ++r)if (Mr(t, e, n[r], n[r + 1])) return !0;
            return !1;
        }
        function zr(t, e, r = !1) {
            let n = !1;
            for (const o of e)for(let e = 0; e < o.length - 1; e++){
                if (kr(t, o[e], o[e + 1])) return r;
                (s = o[e])[1] > (i = t)[1] != (a = o[e + 1])[1] > i[1] && i[0] < (a[0] - s[0]) * (i[1] - s[1]) / (a[1] - s[1]) + s[0] && (n = !n);
            }
            var i, s, a;
            return n;
        }
        function Pr(t, e) {
            for (const r of e)if (zr(t, r)) return !0;
            return !1;
        }
        function Cr(t, e) {
            for (const r of t)if (!zr(r, e)) return !1;
            for(let r = 0; r < t.length - 1; ++r)if (Ir(t[r], t[r + 1], e)) return !1;
            return !0;
        }
        function Br(t, e) {
            for (const r of e)if (Cr(t, r)) return !0;
            return !1;
        }
        function Vr(t, e, r, n) {
            const i = n[0] - r[0], s = n[1] - r[1], a = (t[0] - r[0]) * s - i * (t[1] - r[1]), o = (e[0] - r[0]) * s - i * (e[1] - r[1]);
            return a > 0 && o < 0 || a < 0 && o > 0;
        }
        function Er(t, e, r) {
            const n = [];
            for(let i = 0; i < t.length; i++){
                const s = [];
                for(let n = 0; n < t[i].length; n++){
                    const a = wr(t[i][n], r);
                    Sr(e, a), s.push(a);
                }
                n.push(s);
            }
            return n;
        }
        function Tr(t, e, r) {
            const n = [];
            for(let i = 0; i < t.length; i++){
                const s = Er(t[i], e, r);
                n.push(s);
            }
            return n;
        }
        function Fr(t, e, r, n) {
            if (t[0] < r[0] || t[0] > r[2]) {
                const e = .5 * n;
                let i = t[0] - r[0] > e ? -n : r[0] - t[0] > e ? n : 0;
                0 === i && (i = t[0] - r[2] > e ? -n : r[2] - t[0] > e ? n : 0), t[0] += i;
            }
            Sr(e, t);
        }
        function $r(t, e, r, n) {
            const i = Math.pow(2, n.z) * br, s = [
                n.x * br,
                n.y * br
            ], a = [];
            for (const n of t)for (const t of n){
                const n = [
                    t.x + s[0],
                    t.y + s[1]
                ];
                Fr(n, e, r, i), a.push(n);
            }
            return a;
        }
        function Lr(t, e, r, n) {
            const i = Math.pow(2, n.z) * br, s = [
                n.x * br,
                n.y * br
            ], a = [];
            for (const r of t){
                const t = [];
                for (const n of r){
                    const r = [
                        n.x + s[0],
                        n.y + s[1]
                    ];
                    Sr(e, r), t.push(r);
                }
                a.push(t);
            }
            if (e[2] - e[0] <= i / 2) {
                (o = e)[0] = o[1] = 1 / 0, o[2] = o[3] = -1 / 0;
                for (const t of a)for (const n of t)Fr(n, e, r, i);
            }
            var o;
            return a;
        }
        class Or {
            constructor(t, e){
                this.type = Et, this.geojson = t, this.geometries = e;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error(`'within' expression requires exactly one argument, but found ${t.length - 1} instead.`);
                if (Ce(t[1])) {
                    const e = t[1];
                    if ("FeatureCollection" === e.type) {
                        const t = [];
                        for (const r of e.features){
                            const { type: e, coordinates: n } = r.geometry;
                            "Polygon" === e && t.push(n), "MultiPolygon" === e && t.push(...n);
                        }
                        if (t.length) return new Or(e, {
                            type: "MultiPolygon",
                            coordinates: t
                        });
                    } else if ("Feature" === e.type) {
                        const t = e.geometry.type;
                        if ("Polygon" === t || "MultiPolygon" === t) return new Or(e, e.geometry);
                    } else if ("Polygon" === e.type || "MultiPolygon" === e.type) return new Or(e, e);
                }
                return e.error("'within' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(t) {
                if (null != t.geometry() && null != t.canonicalID()) {
                    if ("Point" === t.geometryType()) return function(t, e) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t.canonicalID();
                        if ("Polygon" === e.type) {
                            const s = Er(e.coordinates, n, i), a = $r(t.geometry(), r, n, i);
                            if (!Ar(r, n)) return !1;
                            for (const t of a)if (!zr(t, s)) return !1;
                        }
                        if ("MultiPolygon" === e.type) {
                            const s = Tr(e.coordinates, n, i), a = $r(t.geometry(), r, n, i);
                            if (!Ar(r, n)) return !1;
                            for (const t of a)if (!Pr(t, s)) return !1;
                        }
                        return !0;
                    }(t, this.geometries);
                    if ("LineString" === t.geometryType()) return function(t, e) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t.canonicalID();
                        if ("Polygon" === e.type) {
                            const s = Er(e.coordinates, n, i), a = Lr(t.geometry(), r, n, i);
                            if (!Ar(r, n)) return !1;
                            for (const t of a)if (!Cr(t, s)) return !1;
                        }
                        if ("MultiPolygon" === e.type) {
                            const s = Tr(e.coordinates, n, i), a = Lr(t.geometry(), r, n, i);
                            if (!Ar(r, n)) return !1;
                            for (const t of a)if (!Br(t, s)) return !1;
                        }
                        return !0;
                    }(t, this.geometries);
                }
                return !1;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
        }
        let Dr = class {
            constructor(t = [], e = (t, e)=>t < e ? -1 : t > e ? 1 : 0){
                if (this.data = t, this.length = this.data.length, this.compare = e, this.length > 0) for(let t = (this.length >> 1) - 1; t >= 0; t--)this._down(t);
            }
            push(t) {
                this.data.push(t), this._up(this.length++);
            }
            pop() {
                if (0 === this.length) return;
                const t = this.data[0], e = this.data.pop();
                return --this.length > 0 && (this.data[0] = e, this._down(0)), t;
            }
            peek() {
                return this.data[0];
            }
            _up(t) {
                const { data: e, compare: r } = this, n = e[t];
                for(; t > 0;){
                    const i = t - 1 >> 1, s = e[i];
                    if (r(n, s) >= 0) break;
                    e[t] = s, t = i;
                }
                e[t] = n;
            }
            _down(t) {
                const { data: e, compare: r } = this, n = this.length >> 1, i = e[t];
                for(; t < n;){
                    let n = 1 + (t << 1);
                    const s = n + 1;
                    if (s < this.length && r(e[s], e[n]) < 0 && (n = s), r(e[n], i) >= 0) break;
                    e[t] = e[n], t = n;
                }
                e[t] = i;
            }
        };
        function Rr(t, e, r = 0, n = t.length - 1, i = Nr) {
            for(; n > r;){
                if (n - r > 600) {
                    const s = n - r + 1, a = e - r + 1, o = Math.log(s), l = .5 * Math.exp(2 * o / 3), u = .5 * Math.sqrt(o * l * (s - l) / s) * (a - s / 2 < 0 ? -1 : 1);
                    Rr(t, e, Math.max(r, Math.floor(e - a * l / s + u)), Math.min(n, Math.floor(e + (s - a) * l / s + u)), i);
                }
                const s = t[e];
                let a = r, o = n;
                for(jr(t, r, e), i(t[n], s) > 0 && jr(t, r, n); a < o;){
                    for(jr(t, a, o), a++, o--; i(t[a], s) < 0;)a++;
                    for(; i(t[o], s) > 0;)o--;
                }
                0 === i(t[r], s) ? jr(t, r, o) : (o++, jr(t, o, n)), o <= e && (r = o + 1), e <= o && (n = o - 1);
            }
        }
        function jr(t, e, r) {
            const n = t[e];
            t[e] = t[r], t[r] = n;
        }
        function Nr(t, e) {
            return t < e ? -1 : t > e ? 1 : 0;
        }
        function Ur(t, e) {
            if (t.length <= 1) return [
                t
            ];
            const r = [];
            let n, i;
            for (const e of t){
                const t = Gr(e);
                0 !== t && (e.area = Math.abs(t), void 0 === i && (i = t < 0), i === t < 0 ? (n && r.push(n), n = [
                    e
                ]) : n.push(e));
            }
            if (n && r.push(n), e > 1) for(let t = 0; t < r.length; t++)r[t].length <= e || (Rr(r[t], e, 1, r[t].length - 1, qr), r[t] = r[t].slice(0, e));
            return r;
        }
        function qr(t, e) {
            return e.area - t.area;
        }
        function Gr(t) {
            let e = 0;
            for(let r, n, i = 0, s = t.length, a = s - 1; i < s; a = i++)r = t[i], n = t[a], e += (n.x - r.x) * (r.y + n.y);
            return e;
        }
        const Zr = 1 / 298.257223563, Kr = Zr * (2 - Zr), Xr = Math.PI / 180;
        class Hr {
            constructor(t){
                const e = 6378.137 * Xr * 1e3, r = Math.cos(t * Xr), n = 1 / (1 - Kr * (1 - r * r)), i = Math.sqrt(n);
                this.kx = e * i * r, this.ky = e * i * n * (1 - Kr);
            }
            distance(t, e) {
                const r = this.wrap(t[0] - e[0]) * this.kx, n = (t[1] - e[1]) * this.ky;
                return Math.sqrt(r * r + n * n);
            }
            pointOnLine(t, e) {
                let r, n, i, s, a = 1 / 0;
                for(let o = 0; o < t.length - 1; o++){
                    let l = t[o][0], u = t[o][1], c = this.wrap(t[o + 1][0] - l) * this.kx, h = (t[o + 1][1] - u) * this.ky, p = 0;
                    0 === c && 0 === h || (p = (this.wrap(e[0] - l) * this.kx * c + (e[1] - u) * this.ky * h) / (c * c + h * h), p > 1 ? (l = t[o + 1][0], u = t[o + 1][1]) : p > 0 && (l += c / this.kx * p, u += h / this.ky * p)), c = this.wrap(e[0] - l) * this.kx, h = (e[1] - u) * this.ky;
                    const f = c * c + h * h;
                    f < a && (a = f, r = l, n = u, i = o, s = p);
                }
                return {
                    point: [
                        r,
                        n
                    ],
                    index: i,
                    t: Math.max(0, Math.min(1, s))
                };
            }
            wrap(t) {
                for(; t < -180;)t += 360;
                for(; t > 180;)t -= 360;
                return t;
            }
        }
        function Yr(t, e) {
            return e[0] - t[0];
        }
        function Jr(t) {
            return t[1] - t[0] + 1;
        }
        function Wr(t, e) {
            return t[1] >= t[0] && t[1] < e;
        }
        function Qr(t, e) {
            if (t[0] > t[1]) return [
                null,
                null
            ];
            const r = Jr(t);
            if (e) {
                if (2 === r) return [
                    t,
                    null
                ];
                const e = Math.floor(r / 2);
                return [
                    [
                        t[0],
                        t[0] + e
                    ],
                    [
                        t[0] + e,
                        t[1]
                    ]
                ];
            }
            if (1 === r) return [
                t,
                null
            ];
            const n = Math.floor(r / 2) - 1;
            return [
                [
                    t[0],
                    t[0] + n
                ],
                [
                    t[0] + n + 1,
                    t[1]
                ]
            ];
        }
        function tn(t, e) {
            if (!Wr(e, t.length)) return [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            const r = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            for(let n = e[0]; n <= e[1]; ++n)Sr(r, t[n]);
            return r;
        }
        function en(t) {
            const e = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            for (const r of t)for (const t of r)Sr(e, t);
            return e;
        }
        function rn(t) {
            return t[0] !== -1 / 0 && t[1] !== -1 / 0 && t[2] !== 1 / 0 && t[3] !== 1 / 0;
        }
        function nn(t, e, r) {
            if (!rn(t) || !rn(e)) return NaN;
            let n = 0, i = 0;
            return t[2] < e[0] && (n = e[0] - t[2]), t[0] > e[2] && (n = t[0] - e[2]), t[1] > e[3] && (i = t[1] - e[3]), t[3] < e[1] && (i = e[1] - t[3]), r.distance([
                0,
                0
            ], [
                n,
                i
            ]);
        }
        function sn(t, e, r) {
            const n = r.pointOnLine(e, t);
            return r.distance(t, n.point);
        }
        function an(t, e, r, n, i) {
            const s = Math.min(sn(t, [
                r,
                n
            ], i), sn(e, [
                r,
                n
            ], i)), a = Math.min(sn(r, [
                t,
                e
            ], i), sn(n, [
                t,
                e
            ], i));
            return Math.min(s, a);
        }
        function on(t, e, r, n, i) {
            if (!Wr(e, t.length) || !Wr(n, r.length)) return 1 / 0;
            let s = 1 / 0;
            for(let a = e[0]; a < e[1]; ++a){
                const e = t[a], o = t[a + 1];
                for(let t = n[0]; t < n[1]; ++t){
                    const n = r[t], a = r[t + 1];
                    if (Mr(e, o, n, a)) return 0;
                    s = Math.min(s, an(e, o, n, a, i));
                }
            }
            return s;
        }
        function ln(t, e, r, n, i) {
            if (!Wr(e, t.length) || !Wr(n, r.length)) return NaN;
            let s = 1 / 0;
            for(let a = e[0]; a <= e[1]; ++a)for(let e = n[0]; e <= n[1]; ++e)if (s = Math.min(s, i.distance(t[a], r[e])), 0 === s) return s;
            return s;
        }
        function un(t, e, r) {
            if (zr(t, e, !0)) return 0;
            let n = 1 / 0;
            for (const i of e){
                const e = i[0], s = i[i.length - 1];
                if (e !== s && (n = Math.min(n, sn(t, [
                    s,
                    e
                ], r)), 0 === n)) return n;
                const a = r.pointOnLine(i, t);
                if (n = Math.min(n, r.distance(t, a.point)), 0 === n) return n;
            }
            return n;
        }
        function cn(t, e, r, n) {
            if (!Wr(e, t.length)) return NaN;
            for(let n = e[0]; n <= e[1]; ++n)if (zr(t[n], r, !0)) return 0;
            let i = 1 / 0;
            for(let s = e[0]; s < e[1]; ++s){
                const e = t[s], a = t[s + 1];
                for (const t of r)for(let r = 0, s = t.length, o = s - 1; r < s; o = r++){
                    const s = t[o], l = t[r];
                    if (Mr(e, a, s, l)) return 0;
                    i = Math.min(i, an(e, a, s, l, n));
                }
            }
            return i;
        }
        function hn(t, e) {
            for (const r of t)for (const t of r)if (zr(t, e, !0)) return !0;
            return !1;
        }
        function pn(t, e, r, n = 1 / 0) {
            const i = en(t), s = en(e);
            if (n !== 1 / 0 && nn(i, s, r) >= n) return n;
            if (Ar(i, s)) {
                if (hn(t, e)) return 0;
            } else if (hn(e, t)) return 0;
            let a = 1 / 0;
            for (const n of t)for(let t = 0, i = n.length, s = i - 1; t < i; s = t++){
                const i = n[s], o = n[t];
                for (const t of e)for(let e = 0, n = t.length, s = n - 1; e < n; s = e++){
                    const n = t[s], l = t[e];
                    if (Mr(i, o, n, l)) return 0;
                    a = Math.min(a, an(i, o, n, l, r));
                }
            }
            return a;
        }
        function fn(t, e, r, n, i, s) {
            if (!s) return;
            const a = nn(tn(n, s), i, r);
            a < e && t.push([
                a,
                s,
                [
                    0,
                    0
                ]
            ]);
        }
        function dn(t, e, r, n, i, s, a) {
            if (!s || !a) return;
            const o = nn(tn(n, s), tn(i, a), r);
            o < e && t.push([
                o,
                s,
                a
            ]);
        }
        function yn(t, e, r, n, i = 1 / 0) {
            let s = Math.min(n.distance(t[0], r[0][0]), i);
            if (0 === s) return s;
            const a = new Dr([
                [
                    0,
                    [
                        0,
                        t.length - 1
                    ],
                    [
                        0,
                        0
                    ]
                ]
            ], Yr), o = en(r);
            for(; a.length > 0;){
                const i = a.pop();
                if (i[0] >= s) continue;
                const l = i[1], u = e ? 50 : 100;
                if (Jr(l) <= u) {
                    if (!Wr(l, t.length)) return NaN;
                    if (e) {
                        const e = cn(t, l, r, n);
                        if (isNaN(e) || 0 === e) return e;
                        s = Math.min(s, e);
                    } else for(let e = l[0]; e <= l[1]; ++e){
                        const i = un(t[e], r, n);
                        if (s = Math.min(s, i), 0 === s) return 0;
                    }
                } else {
                    const r = Qr(l, e);
                    fn(a, s, n, t, o, r[0]), fn(a, s, n, t, o, r[1]);
                }
            }
            return s;
        }
        function mn(t, e, r, n, i, s = 1 / 0) {
            let a = Math.min(s, i.distance(t[0], r[0]));
            if (0 === a) return a;
            const o = new Dr([
                [
                    0,
                    [
                        0,
                        t.length - 1
                    ],
                    [
                        0,
                        r.length - 1
                    ]
                ]
            ], Yr);
            for(; o.length > 0;){
                const s = o.pop();
                if (s[0] >= a) continue;
                const l = s[1], u = s[2], c = e ? 50 : 100, h = n ? 50 : 100;
                if (Jr(l) <= c && Jr(u) <= h) {
                    if (!Wr(l, t.length) && Wr(u, r.length)) return NaN;
                    let s;
                    if (e && n) s = on(t, l, r, u, i), a = Math.min(a, s);
                    else if (e && !n) {
                        const e = t.slice(l[0], l[1] + 1);
                        for(let t = u[0]; t <= u[1]; ++t)if (s = sn(r[t], e, i), a = Math.min(a, s), 0 === a) return a;
                    } else if (!e && n) {
                        const e = r.slice(u[0], u[1] + 1);
                        for(let r = l[0]; r <= l[1]; ++r)if (s = sn(t[r], e, i), a = Math.min(a, s), 0 === a) return a;
                    } else s = ln(t, l, r, u, i), a = Math.min(a, s);
                } else {
                    const s = Qr(l, e), c = Qr(u, n);
                    dn(o, a, i, t, r, s[0], c[0]), dn(o, a, i, t, r, s[0], c[1]), dn(o, a, i, t, r, s[1], c[0]), dn(o, a, i, t, r, s[1], c[1]);
                }
            }
            return a;
        }
        function gn(t) {
            return "MultiPolygon" === t.type ? t.coordinates.map((t)=>({
                    type: "Polygon",
                    coordinates: t
                })) : "MultiLineString" === t.type ? t.coordinates.map((t)=>({
                    type: "LineString",
                    coordinates: t
                })) : "MultiPoint" === t.type ? t.coordinates.map((t)=>({
                    type: "Point",
                    coordinates: t
                })) : [
                t
            ];
        }
        class xn {
            constructor(t, e){
                this.type = Bt, this.geojson = t, this.geometries = e;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error(`'distance' expression requires exactly one argument, but found ${t.length - 1} instead.`);
                if (Ce(t[1])) {
                    const e = t[1];
                    if ("FeatureCollection" === e.type) return new xn(e, e.features.map((t)=>gn(t.geometry)).flat());
                    if ("Feature" === e.type) return new xn(e, gn(e.geometry));
                    if ("type" in e && "coordinates" in e) return new xn(e, gn(e));
                }
                return e.error("'distance' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(t) {
                if (null != t.geometry() && null != t.canonicalID()) {
                    if ("Point" === t.geometryType()) return function(t, e) {
                        const r = t.geometry(), n = r.flat().map((e)=>_r([
                                e.x,
                                e.y
                            ], t.canonical));
                        if (0 === r.length) return NaN;
                        const i = new Hr(n[0][1]);
                        let s = 1 / 0;
                        for (const t of e){
                            switch(t.type){
                                case "Point":
                                    s = Math.min(s, mn(n, !1, [
                                        t.coordinates
                                    ], !1, i, s));
                                    break;
                                case "LineString":
                                    s = Math.min(s, mn(n, !1, t.coordinates, !0, i, s));
                                    break;
                                case "Polygon":
                                    s = Math.min(s, yn(n, !1, t.coordinates, i, s));
                            }
                            if (0 === s) return s;
                        }
                        return s;
                    }(t, this.geometries);
                    if ("LineString" === t.geometryType()) return function(t, e) {
                        const r = t.geometry(), n = r.flat().map((e)=>_r([
                                e.x,
                                e.y
                            ], t.canonical));
                        if (0 === r.length) return NaN;
                        const i = new Hr(n[0][1]);
                        let s = 1 / 0;
                        for (const t of e){
                            switch(t.type){
                                case "Point":
                                    s = Math.min(s, mn(n, !0, [
                                        t.coordinates
                                    ], !1, i, s));
                                    break;
                                case "LineString":
                                    s = Math.min(s, mn(n, !0, t.coordinates, !0, i, s));
                                    break;
                                case "Polygon":
                                    s = Math.min(s, yn(n, !0, t.coordinates, i, s));
                            }
                            if (0 === s) return s;
                        }
                        return s;
                    }(t, this.geometries);
                    if ("Polygon" === t.geometryType()) return function(t, e) {
                        const r = t.geometry();
                        if (0 === r.length || 0 === r[0].length) return NaN;
                        const n = Ur(r, 0).map((e)=>e.map((e)=>e.map((e)=>_r([
                                        e.x,
                                        e.y
                                    ], t.canonical)))), i = new Hr(n[0][0][0][1]);
                        let s = 1 / 0;
                        for (const t of e)for (const e of n){
                            switch(t.type){
                                case "Point":
                                    s = Math.min(s, yn([
                                        t.coordinates
                                    ], !1, e, i, s));
                                    break;
                                case "LineString":
                                    s = Math.min(s, yn(t.coordinates, !0, e, i, s));
                                    break;
                                case "Polygon":
                                    s = Math.min(s, pn(e, t.coordinates, i, s));
                            }
                            if (0 === s) return s;
                        }
                        return s;
                    }(t, this.geometries);
                }
                return NaN;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
        }
        const vn = {
            "==": ur,
            "!=": cr,
            ">": pr,
            "<": hr,
            ">=": dr,
            "<=": fr,
            array: Fe,
            at: Ue,
            boolean: Fe,
            case: Ke,
            coalesce: sr,
            collator: yr,
            format: gr,
            image: xr,
            in: qe,
            "index-of": Ge,
            interpolate: rr,
            "interpolate-hcl": rr,
            "interpolate-lab": rr,
            length: vr,
            let: je,
            literal: Ee,
            match: Ze,
            number: Fe,
            "number-format": mr,
            object: Fe,
            slice: Xe,
            step: Ye,
            string: Fe,
            "to-boolean": Le,
            "to-color": Le,
            "to-number": Le,
            "to-string": Le,
            var: Ne,
            within: Or,
            distance: xn
        };
        class bn {
            constructor(t, e, r, n){
                this.name = t, this.type = e, this._evaluate = r, this.args = n;
            }
            evaluate(t) {
                return this._evaluate(t, this.args);
            }
            eachChild(t) {
                this.args.forEach(t);
            }
            outputDefined() {
                return !1;
            }
            static parse(t, e) {
                const r = t[0], n = bn.definitions[r];
                if (!n) return e.error(`Unknown expression "${r}". If you wanted a literal array, use ["literal", [...]].`, 0);
                const i = Array.isArray(n) ? n[0] : n.type, s = Array.isArray(n) ? [
                    [
                        n[1],
                        n[2]
                    ]
                ] : n.overloads, a = s.filter(([e])=>!Array.isArray(e) || e.length === t.length - 1);
                let o = null;
                for (const [n, s] of a){
                    o = new Re(e.registry, kn, e.path, null, e.scope);
                    const a = [];
                    let l = !1;
                    for(let e = 1; e < t.length; e++){
                        const r = t[e], i = Array.isArray(n) ? n[e - 1] : n.type, s = o.parse(r, 1 + a.length, i);
                        if (!s) {
                            l = !0;
                            break;
                        }
                        a.push(s);
                    }
                    if (!l) {
                        if (Array.isArray(n) && n.length !== a.length) o.error(`Expected ${n.length} arguments, but found ${a.length} instead.`);
                        else {
                            for(let t = 0; t < a.length; t++){
                                const e = Array.isArray(n) ? n[t] : n.type, r = a[t];
                                o.concat(t + 1).checkSubtype(e, r.type);
                            }
                            if (0 === o.errors.length) return new bn(r, i, s, a);
                        }
                    }
                }
                if (1 === a.length) e.errors.push(...o.errors);
                else {
                    const r = (a.length ? a : s).map(([t])=>{
                        var e;
                        return e = t, Array.isArray(e) ? `(${e.map(qt).join(", ")})` : `(${qt(e.type)}...)`;
                    }).join(" | "), n = [];
                    for(let r = 1; r < t.length; r++){
                        const i = e.parse(t[r], 1 + n.length);
                        if (!i) return null;
                        n.push(qt(i.type));
                    }
                    e.error(`Expected arguments of type ${r}, but found (${n.join(", ")}) instead.`);
                }
                return null;
            }
            static register(t, e) {
                bn.definitions = e;
                for(const r in e)t[r] = bn;
            }
        }
        function wn(t, [e, r, n, i]) {
            e = e.evaluate(t), r = r.evaluate(t), n = n.evaluate(t);
            const s = i ? i.evaluate(t) : 1, a = Pe(e, r, n, s);
            if (a) throw new Ae(a);
            return new xe(e / 255, r / 255, n / 255, s, !1);
        }
        function _n(t, e) {
            return t in e;
        }
        function Sn(t, e) {
            const r = e[t];
            return void 0 === r ? null : r;
        }
        function An(t) {
            return {
                type: t
            };
        }
        function kn(t) {
            if (t instanceof Ne) return kn(t.boundExpression);
            if (t instanceof bn && "error" === t.name) return !1;
            if (t instanceof yr) return !1;
            if (t instanceof Or) return !1;
            if (t instanceof xn) return !1;
            const e = t instanceof Le || t instanceof Fe;
            let r = !0;
            return t.eachChild((t)=>{
                r = e ? r && kn(t) : r && t instanceof Ee;
            }), !!r && Mn(t) && zn(t, [
                "zoom",
                "heatmap-density",
                "line-progress",
                "accumulated",
                "is-supported-script"
            ]);
        }
        function Mn(t) {
            if (t instanceof bn) {
                if ("get" === t.name && 1 === t.args.length) return !1;
                if ("feature-state" === t.name) return !1;
                if ("has" === t.name && 1 === t.args.length) return !1;
                if ("properties" === t.name || "geometry-type" === t.name || "id" === t.name) return !1;
                if (/^filter-/.test(t.name)) return !1;
            }
            if (t instanceof Or) return !1;
            if (t instanceof xn) return !1;
            let e = !0;
            return t.eachChild((t)=>{
                e && !Mn(t) && (e = !1);
            }), e;
        }
        function In(t) {
            if (t instanceof bn && "feature-state" === t.name) return !1;
            let e = !0;
            return t.eachChild((t)=>{
                e && !In(t) && (e = !1);
            }), e;
        }
        function zn(t, e) {
            if (t instanceof bn && e.indexOf(t.name) >= 0) return !1;
            let r = !0;
            return t.eachChild((t)=>{
                r && !zn(t, e) && (r = !1);
            }), r;
        }
        function Pn(t) {
            return {
                result: "success",
                value: t
            };
        }
        function Cn(t) {
            return {
                result: "error",
                value: t
            };
        }
        function Bn(t) {
            return "data-driven" === t["property-type"] || "cross-faded-data-driven" === t["property-type"];
        }
        function Vn(t) {
            return !!t.expression && t.expression.parameters.indexOf("zoom") > -1;
        }
        function En(t) {
            return !!t.expression && t.expression.interpolated;
        }
        function Tn(t) {
            return t instanceof Number ? "number" : t instanceof String ? "string" : t instanceof Boolean ? "boolean" : Array.isArray(t) ? "array" : null === t ? "null" : typeof t;
        }
        function Fn(t) {
            return "object" == typeof t && null !== t && !Array.isArray(t);
        }
        function $n(t) {
            return t;
        }
        function Ln(t, e) {
            const r = "color" === e.type, n = t.stops && "object" == typeof t.stops[0][0], i = n || !(n || void 0 !== t.property), s = t.type || (En(e) ? "exponential" : "interval");
            if (r || "padding" === e.type) {
                const n = r ? xe.parse : Se.parse;
                (t = It({}, t)).stops && (t.stops = t.stops.map((t)=>[
                        t[0],
                        n(t[1])
                    ])), t.default = n(t.default ? t.default : e.default);
            }
            if (t.colorSpace && "rgb" !== (a = t.colorSpace) && "hcl" !== a && "lab" !== a) throw new Error(`Unknown color space: "${t.colorSpace}"`);
            var a;
            let o, l, u;
            if ("exponential" === s) o = jn;
            else if ("interval" === s) o = Rn;
            else if ("categorical" === s) {
                o = Dn, l = Object.create(null);
                for (const e of t.stops)l[e[0]] = e[1];
                u = typeof t.stops[0][0];
            } else {
                if ("identity" !== s) throw new Error(`Unknown function type "${s}"`);
                o = Nn;
            }
            if (n) {
                const r = {}, n = [];
                for(let e = 0; e < t.stops.length; e++){
                    const i = t.stops[e], s = i[0].zoom;
                    void 0 === r[s] && (r[s] = {
                        zoom: s,
                        type: t.type,
                        property: t.property,
                        default: t.default,
                        stops: []
                    }, n.push(s)), r[s].stops.push([
                        i[0].value,
                        i[1]
                    ]);
                }
                const i = [];
                for (const t of n)i.push([
                    r[t].zoom,
                    Ln(r[t], e)
                ]);
                const s = {
                    name: "linear"
                };
                return {
                    kind: "composite",
                    interpolationType: s,
                    interpolationFactor: rr.interpolationFactor.bind(void 0, s),
                    zoomStops: i.map((t)=>t[0]),
                    evaluate: ({ zoom: r }, n)=>jn({
                            stops: i,
                            base: t.base
                        }, e, r).evaluate(r, n)
                };
            }
            if (i) {
                const r = "exponential" === s ? {
                    name: "exponential",
                    base: void 0 !== t.base ? t.base : 1
                } : null;
                return {
                    kind: "camera",
                    interpolationType: r,
                    interpolationFactor: rr.interpolationFactor.bind(void 0, r),
                    zoomStops: t.stops.map((t)=>t[0]),
                    evaluate: ({ zoom: r })=>o(t, e, r, l, u)
                };
            }
            return {
                kind: "source",
                evaluate (r, n) {
                    const i = n && n.properties ? n.properties[t.property] : void 0;
                    return void 0 === i ? On(t.default, e.default) : o(t, e, i, l, u);
                }
            };
        }
        function On(t, e, r) {
            return void 0 !== t ? t : void 0 !== e ? e : void 0 !== r ? r : void 0;
        }
        function Dn(t, e, r, n, i) {
            return On(typeof r === i ? n[r] : void 0, t.default, e.default);
        }
        function Rn(t, e, r) {
            if ("number" !== Tn(r)) return On(t.default, e.default);
            const n = t.stops.length;
            if (1 === n) return t.stops[0][1];
            if (r <= t.stops[0][0]) return t.stops[0][1];
            if (r >= t.stops[n - 1][0]) return t.stops[n - 1][1];
            const i = He(t.stops.map((t)=>t[0]), r);
            return t.stops[i][1];
        }
        function jn(t, e, r) {
            const n = void 0 !== t.base ? t.base : 1;
            if ("number" !== Tn(r)) return On(t.default, e.default);
            const i = t.stops.length;
            if (1 === i) return t.stops[0][1];
            if (r <= t.stops[0][0]) return t.stops[0][1];
            if (r >= t.stops[i - 1][0]) return t.stops[i - 1][1];
            const s = He(t.stops.map((t)=>t[0]), r), a = function(t, e, r, n) {
                const i = n - r, s = t - r;
                return 0 === i ? 0 : 1 === e ? s / i : (Math.pow(e, s) - 1) / (Math.pow(e, i) - 1);
            }(r, n, t.stops[s][0], t.stops[s + 1][0]), o = t.stops[s][1], l = t.stops[s + 1][1], u = ir[e.type] || $n;
            return "function" == typeof o.evaluate ? {
                evaluate (...e) {
                    const r = o.evaluate.apply(void 0, e), n = l.evaluate.apply(void 0, e);
                    if (void 0 !== r && void 0 !== n) return u(r, n, a, t.colorSpace);
                }
            } : u(o, l, a, t.colorSpace);
        }
        function Nn(t, e, r) {
            switch(e.type){
                case "color":
                    r = xe.parse(r);
                    break;
                case "formatted":
                    r = _e.fromString(r.toString());
                    break;
                case "resolvedImage":
                    r = Ie.fromString(r.toString());
                    break;
                case "padding":
                    r = Se.parse(r);
                    break;
                default:
                    Tn(r) === e.type || "enum" === e.type && e.values[r] || (r = void 0);
            }
            return On(r, t.default, e.default);
        }
        bn.register(vn, {
            error: [
                {
                    kind: "error"
                },
                [
                    Vt
                ],
                (t, [e])=>{
                    throw new Ae(e.evaluate(t));
                }
            ],
            typeof: [
                Vt,
                [
                    Lt
                ],
                (t, [e])=>qt(Be(e.evaluate(t)))
            ],
            "to-rgba": [
                Ut(Bt, 4),
                [
                    Tt
                ],
                (t, [e])=>{
                    const [r, n, i, s] = e.evaluate(t).rgb;
                    return [
                        255 * r,
                        255 * n,
                        255 * i,
                        s
                    ];
                }
            ],
            rgb: [
                Tt,
                [
                    Bt,
                    Bt,
                    Bt
                ],
                wn
            ],
            rgba: [
                Tt,
                [
                    Bt,
                    Bt,
                    Bt,
                    Bt
                ],
                wn
            ],
            has: {
                type: Et,
                overloads: [
                    [
                        [
                            Vt
                        ],
                        (t, [e])=>_n(e.evaluate(t), t.properties())
                    ],
                    [
                        [
                            Vt,
                            $t
                        ],
                        (t, [e, r])=>_n(e.evaluate(t), r.evaluate(t))
                    ]
                ]
            },
            get: {
                type: Lt,
                overloads: [
                    [
                        [
                            Vt
                        ],
                        (t, [e])=>Sn(e.evaluate(t), t.properties())
                    ],
                    [
                        [
                            Vt,
                            $t
                        ],
                        (t, [e, r])=>Sn(e.evaluate(t), r.evaluate(t))
                    ]
                ]
            },
            "feature-state": [
                Lt,
                [
                    Vt
                ],
                (t, [e])=>Sn(e.evaluate(t), t.featureState || {})
            ],
            properties: [
                $t,
                [],
                (t)=>t.properties()
            ],
            "geometry-type": [
                Vt,
                [],
                (t)=>t.geometryType()
            ],
            id: [
                Lt,
                [],
                (t)=>t.id()
            ],
            zoom: [
                Bt,
                [],
                (t)=>t.globals.zoom
            ],
            "heatmap-density": [
                Bt,
                [],
                (t)=>t.globals.heatmapDensity || 0
            ],
            "line-progress": [
                Bt,
                [],
                (t)=>t.globals.lineProgress || 0
            ],
            accumulated: [
                Lt,
                [],
                (t)=>void 0 === t.globals.accumulated ? null : t.globals.accumulated
            ],
            "+": [
                Bt,
                An(Bt),
                (t, e)=>{
                    let r = 0;
                    for (const n of e)r += n.evaluate(t);
                    return r;
                }
            ],
            "*": [
                Bt,
                An(Bt),
                (t, e)=>{
                    let r = 1;
                    for (const n of e)r *= n.evaluate(t);
                    return r;
                }
            ],
            "-": {
                type: Bt,
                overloads: [
                    [
                        [
                            Bt,
                            Bt
                        ],
                        (t, [e, r])=>e.evaluate(t) - r.evaluate(t)
                    ],
                    [
                        [
                            Bt
                        ],
                        (t, [e])=>-e.evaluate(t)
                    ]
                ]
            },
            "/": [
                Bt,
                [
                    Bt,
                    Bt
                ],
                (t, [e, r])=>e.evaluate(t) / r.evaluate(t)
            ],
            "%": [
                Bt,
                [
                    Bt,
                    Bt
                ],
                (t, [e, r])=>e.evaluate(t) % r.evaluate(t)
            ],
            ln2: [
                Bt,
                [],
                ()=>Math.LN2
            ],
            pi: [
                Bt,
                [],
                ()=>Math.PI
            ],
            e: [
                Bt,
                [],
                ()=>Math.E
            ],
            "^": [
                Bt,
                [
                    Bt,
                    Bt
                ],
                (t, [e, r])=>Math.pow(e.evaluate(t), r.evaluate(t))
            ],
            sqrt: [
                Bt,
                [
                    Bt
                ],
                (t, [e])=>Math.sqrt(e.evaluate(t))
            ],
            log10: [
                Bt,
                [
                    Bt
                ],
                (t, [e])=>Math.log(e.evaluate(t)) / Math.LN10
            ],
            ln: [
                Bt,
                [
                    Bt
                ],
                (t, [e])=>Math.log(e.evaluate(t))
            ],
            log2: [
                Bt,
                [
                    Bt
                ],
                (t, [e])=>Math.log(e.evaluate(t)) / Math.LN2
            ],
            sin: [
                Bt,
                [
                    Bt
                ],
                (t, [e])=>Math.sin(e.evaluate(t))
            ],
            cos: [
                Bt,
                [
                    Bt
                ],
                (t, [e])=>Math.cos(e.evaluate(t))
            ],
            tan: [
                Bt,
                [
                    Bt
                ],
                (t, [e])=>Math.tan(e.evaluate(t))
            ],
            asin: [
                Bt,
                [
                    Bt
                ],
                (t, [e])=>Math.asin(e.evaluate(t))
            ],
            acos: [
                Bt,
                [
                    Bt
                ],
                (t, [e])=>Math.acos(e.evaluate(t))
            ],
            atan: [
                Bt,
                [
                    Bt
                ],
                (t, [e])=>Math.atan(e.evaluate(t))
            ],
            min: [
                Bt,
                An(Bt),
                (t, e)=>Math.min(...e.map((e)=>e.evaluate(t)))
            ],
            max: [
                Bt,
                An(Bt),
                (t, e)=>Math.max(...e.map((e)=>e.evaluate(t)))
            ],
            abs: [
                Bt,
                [
                    Bt
                ],
                (t, [e])=>Math.abs(e.evaluate(t))
            ],
            round: [
                Bt,
                [
                    Bt
                ],
                (t, [e])=>{
                    const r = e.evaluate(t);
                    return r < 0 ? -Math.round(-r) : Math.round(r);
                }
            ],
            floor: [
                Bt,
                [
                    Bt
                ],
                (t, [e])=>Math.floor(e.evaluate(t))
            ],
            ceil: [
                Bt,
                [
                    Bt
                ],
                (t, [e])=>Math.ceil(e.evaluate(t))
            ],
            "filter-==": [
                Et,
                [
                    Vt,
                    Lt
                ],
                (t, [e, r])=>t.properties()[e.value] === r.value
            ],
            "filter-id-==": [
                Et,
                [
                    Lt
                ],
                (t, [e])=>t.id() === e.value
            ],
            "filter-type-==": [
                Et,
                [
                    Vt
                ],
                (t, [e])=>t.geometryType() === e.value
            ],
            "filter-<": [
                Et,
                [
                    Vt,
                    Lt
                ],
                (t, [e, r])=>{
                    const n = t.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n < i;
                }
            ],
            "filter-id-<": [
                Et,
                [
                    Lt
                ],
                (t, [e])=>{
                    const r = t.id(), n = e.value;
                    return typeof r == typeof n && r < n;
                }
            ],
            "filter->": [
                Et,
                [
                    Vt,
                    Lt
                ],
                (t, [e, r])=>{
                    const n = t.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n > i;
                }
            ],
            "filter-id->": [
                Et,
                [
                    Lt
                ],
                (t, [e])=>{
                    const r = t.id(), n = e.value;
                    return typeof r == typeof n && r > n;
                }
            ],
            "filter-<=": [
                Et,
                [
                    Vt,
                    Lt
                ],
                (t, [e, r])=>{
                    const n = t.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n <= i;
                }
            ],
            "filter-id-<=": [
                Et,
                [
                    Lt
                ],
                (t, [e])=>{
                    const r = t.id(), n = e.value;
                    return typeof r == typeof n && r <= n;
                }
            ],
            "filter->=": [
                Et,
                [
                    Vt,
                    Lt
                ],
                (t, [e, r])=>{
                    const n = t.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n >= i;
                }
            ],
            "filter-id->=": [
                Et,
                [
                    Lt
                ],
                (t, [e])=>{
                    const r = t.id(), n = e.value;
                    return typeof r == typeof n && r >= n;
                }
            ],
            "filter-has": [
                Et,
                [
                    Lt
                ],
                (t, [e])=>e.value in t.properties()
            ],
            "filter-has-id": [
                Et,
                [],
                (t)=>null !== t.id() && void 0 !== t.id()
            ],
            "filter-type-in": [
                Et,
                [
                    Ut(Vt)
                ],
                (t, [e])=>e.value.indexOf(t.geometryType()) >= 0
            ],
            "filter-id-in": [
                Et,
                [
                    Ut(Lt)
                ],
                (t, [e])=>e.value.indexOf(t.id()) >= 0
            ],
            "filter-in-small": [
                Et,
                [
                    Vt,
                    Ut(Lt)
                ],
                (t, [e, r])=>r.value.indexOf(t.properties()[e.value]) >= 0
            ],
            "filter-in-large": [
                Et,
                [
                    Vt,
                    Ut(Lt)
                ],
                (t, [e, r])=>(function(t, e, r, n) {
                        for(; r <= n;){
                            const i = r + n >> 1;
                            if (e[i] === t) return !0;
                            e[i] > t ? n = i - 1 : r = i + 1;
                        }
                        return !1;
                    })(t.properties()[e.value], r.value, 0, r.value.length - 1)
            ],
            all: {
                type: Et,
                overloads: [
                    [
                        [
                            Et,
                            Et
                        ],
                        (t, [e, r])=>e.evaluate(t) && r.evaluate(t)
                    ],
                    [
                        An(Et),
                        (t, e)=>{
                            for (const r of e)if (!r.evaluate(t)) return !1;
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: Et,
                overloads: [
                    [
                        [
                            Et,
                            Et
                        ],
                        (t, [e, r])=>e.evaluate(t) || r.evaluate(t)
                    ],
                    [
                        An(Et),
                        (t, e)=>{
                            for (const r of e)if (r.evaluate(t)) return !0;
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                Et,
                [
                    Et
                ],
                (t, [e])=>!e.evaluate(t)
            ],
            "is-supported-script": [
                Et,
                [
                    Vt
                ],
                (t, [e])=>{
                    const r = t.globals && t.globals.isSupportedScript;
                    return !r || r(e.evaluate(t));
                }
            ],
            upcase: [
                Vt,
                [
                    Vt
                ],
                (t, [e])=>e.evaluate(t).toUpperCase()
            ],
            downcase: [
                Vt,
                [
                    Vt
                ],
                (t, [e])=>e.evaluate(t).toLowerCase()
            ],
            concat: [
                Vt,
                An(Lt),
                (t, e)=>e.map((e)=>Ve(e.evaluate(t))).join("")
            ],
            "resolved-locale": [
                Vt,
                [
                    Ot
                ],
                (t, [e])=>e.evaluate(t).resolvedLocale()
            ]
        });
        class Un {
            constructor(t, e){
                var r;
                this.expression = t, this._warningHistory = {}, this._evaluator = new De, this._defaultValue = e ? "color" === (r = e).type && Fn(r.default) ? new xe(0, 0, 0, 0) : "color" === r.type ? xe.parse(r.default) || null : "padding" === r.type ? Se.parse(r.default) || null : "variableAnchorOffsetCollection" === r.type ? Me.parse(r.default) || null : "projectionDefinition" === r.type ? ze.parse(r.default) || null : void 0 === r.default ? null : r.default : null, this._enumValues = e && "enum" === e.type ? e.values : null;
            }
            evaluateWithoutErrorHandling(t, e, r, n, i, s) {
                return this._evaluator.globals = t, this._evaluator.feature = e, this._evaluator.featureState = r, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s, this.expression.evaluate(this._evaluator);
            }
            evaluate(t, e, r, n, i, s) {
                this._evaluator.globals = t, this._evaluator.feature = e || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s || null;
                try {
                    const t = this.expression.evaluate(this._evaluator);
                    if (null == t || "number" == typeof t && t != t) return this._defaultValue;
                    if (this._enumValues && !(t in this._enumValues)) throw new Ae(`Expected value to be one of ${Object.keys(this._enumValues).map((t)=>JSON.stringify(t)).join(", ")}, but found ${JSON.stringify(t)} instead.`);
                    return t;
                } catch (t) {
                    return this._warningHistory[t.message] || (this._warningHistory[t.message] = !0, "undefined" != typeof console && console.warn(t.message)), this._defaultValue;
                }
            }
        }
        function qn(t) {
            return Array.isArray(t) && t.length > 0 && "string" == typeof t[0] && t[0] in vn;
        }
        function Gn(t, e) {
            const r = new Re(vn, kn, [], e ? function(t) {
                const e = {
                    color: Tt,
                    string: Vt,
                    number: Bt,
                    enum: Vt,
                    boolean: Et,
                    formatted: Dt,
                    padding: Rt,
                    projectionDefinition: Ft,
                    resolvedImage: jt,
                    variableAnchorOffsetCollection: Nt
                };
                return "array" === t.type ? Ut(e[t.value] || Lt, t.length) : e[t.type];
            }(e) : void 0), n = r.parse(t, void 0, void 0, void 0, e && "string" === e.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return n ? Pn(new Un(n, e)) : Cn(r.errors);
        }
        class Zn {
            constructor(t, e){
                this.kind = t, this._styleExpression = e, this.isStateDependent = "constant" !== t && !In(e.expression);
            }
            evaluateWithoutErrorHandling(t, e, r, n, i, s) {
                return this._styleExpression.evaluateWithoutErrorHandling(t, e, r, n, i, s);
            }
            evaluate(t, e, r, n, i, s) {
                return this._styleExpression.evaluate(t, e, r, n, i, s);
            }
        }
        class Kn {
            constructor(t, e, r, n){
                this.kind = t, this.zoomStops = r, this._styleExpression = e, this.isStateDependent = "camera" !== t && !In(e.expression), this.interpolationType = n;
            }
            evaluateWithoutErrorHandling(t, e, r, n, i, s) {
                return this._styleExpression.evaluateWithoutErrorHandling(t, e, r, n, i, s);
            }
            evaluate(t, e, r, n, i, s) {
                return this._styleExpression.evaluate(t, e, r, n, i, s);
            }
            interpolationFactor(t, e, r) {
                return this.interpolationType ? rr.interpolationFactor(this.interpolationType, t, e, r) : 0;
            }
        }
        function Xn(t, e) {
            const r = Gn(t, e);
            if ("error" === r.result) return r;
            const n = r.value.expression, i = Mn(n);
            if (!i && !Bn(e)) return Cn([
                new zt("", "data expressions not supported")
            ]);
            const s = zn(n, [
                "zoom"
            ]);
            if (!s && !Vn(e)) return Cn([
                new zt("", "zoom expressions not supported")
            ]);
            const a = Yn(n);
            return a || s ? a instanceof zt ? Cn([
                a
            ]) : a instanceof rr && !En(e) ? Cn([
                new zt("", '"interpolate" expressions cannot be used with this property')
            ]) : Pn(a ? new Kn(i ? "camera" : "composite", r.value, a.labels, a instanceof rr ? a.interpolation : void 0) : new Zn(i ? "constant" : "source", r.value)) : Cn([
                new zt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
            ]);
        }
        class Hn {
            constructor(t, e){
                this._parameters = t, this._specification = e, It(this, Ln(this._parameters, this._specification));
            }
            static deserialize(t) {
                return new Hn(t._parameters, t._specification);
            }
            static serialize(t) {
                return {
                    _parameters: t._parameters,
                    _specification: t._specification
                };
            }
        }
        function Yn(t) {
            let e = null;
            if (t instanceof je) e = Yn(t.result);
            else if (t instanceof sr) {
                for (const r of t.args)if (e = Yn(r), e) break;
            } else (t instanceof Ye || t instanceof rr) && t.input instanceof bn && "zoom" === t.input.name && (e = t);
            return e instanceof zt || t.eachChild((t)=>{
                const r = Yn(t);
                r instanceof zt ? e = r : !e && r ? e = new zt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : e && r && e !== r && (e = new zt("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
            }), e;
        }
        function Jn(t) {
            if (!0 === t || !1 === t) return !0;
            if (!Array.isArray(t) || 0 === t.length) return !1;
            switch(t[0]){
                case "has":
                    return t.length >= 2 && "$id" !== t[1] && "$type" !== t[1];
                case "in":
                    return t.length >= 3 && ("string" != typeof t[1] || Array.isArray(t[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== t.length || Array.isArray(t[1]) || Array.isArray(t[2]);
                case "any":
                case "all":
                    for (const e of t.slice(1))if (!Jn(e) && "boolean" != typeof e) return !1;
                    return !0;
                default:
                    return !0;
            }
        }
        const Wn = {
            type: "boolean",
            default: !1,
            transition: !1,
            "property-type": "data-driven",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            }
        };
        function Qn(t) {
            if (null == t) return {
                filter: ()=>!0,
                needGeometry: !1
            };
            Jn(t) || (t = ri(t));
            const e = Gn(t, Wn);
            if ("error" === e.result) throw new Error(e.value.map((t)=>`${t.key}: ${t.message}`).join(", "));
            return {
                filter: (t, r, n)=>e.value.evaluate(t, r, {}, n),
                needGeometry: ei(t)
            };
        }
        function ti(t, e) {
            return t < e ? -1 : t > e ? 1 : 0;
        }
        function ei(t) {
            if (!Array.isArray(t)) return !1;
            if ("within" === t[0] || "distance" === t[0]) return !0;
            for(let e = 1; e < t.length; e++)if (ei(t[e])) return !0;
            return !1;
        }
        function ri(t) {
            if (!t) return !0;
            const e = t[0];
            var r;
            return t.length <= 1 ? "any" !== e : "==" === e ? ni(t[1], t[2], "==") : "!=" === e ? ai(ni(t[1], t[2], "==")) : "<" === e || ">" === e || "<=" === e || ">=" === e ? ni(t[1], t[2], e) : "any" === e ? (r = t.slice(1), [
                "any"
            ].concat(r.map(ri))) : "all" === e ? [
                "all"
            ].concat(t.slice(1).map(ri)) : "none" === e ? [
                "all"
            ].concat(t.slice(1).map(ri).map(ai)) : "in" === e ? ii(t[1], t.slice(2)) : "!in" === e ? ai(ii(t[1], t.slice(2))) : "has" === e ? si(t[1]) : "!has" !== e || ai(si(t[1]));
        }
        function ni(t, e, r) {
            switch(t){
                case "$type":
                    return [
                        `filter-type-${r}`,
                        e
                    ];
                case "$id":
                    return [
                        `filter-id-${r}`,
                        e
                    ];
                default:
                    return [
                        `filter-${r}`,
                        t,
                        e
                    ];
            }
        }
        function ii(t, e) {
            if (0 === e.length) return !1;
            switch(t){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            e
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            e
                        ]
                    ];
                default:
                    return e.length > 200 && !e.some((t)=>typeof t != typeof e[0]) ? [
                        "filter-in-large",
                        t,
                        [
                            "literal",
                            e.sort(ti)
                        ]
                    ] : [
                        "filter-in-small",
                        t,
                        [
                            "literal",
                            e
                        ]
                    ];
            }
        }
        function si(t) {
            switch(t){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        t
                    ];
            }
        }
        function ai(t) {
            return [
                "!",
                t
            ];
        }
        function oi(t) {
            const e = typeof t;
            if ("number" === e || "boolean" === e || "string" === e || null == t) return JSON.stringify(t);
            if (Array.isArray(t)) {
                let e = "[";
                for (const r of t)e += `${oi(r)},`;
                return `${e}]`;
            }
            const r = Object.keys(t).sort();
            let n = "{";
            for(let e = 0; e < r.length; e++)n += `${JSON.stringify(r[e])}:${oi(t[r[e]])},`;
            return `${n}}`;
        }
        function li(t) {
            let e = "";
            for (const r of yt)e += `/${oi(t[r])}`;
            return e;
        }
        function ui(t) {
            const e = t.value;
            return e ? [
                new Mt(t.key, e, "constants have been deprecated as of v8")
            ] : [];
        }
        function ci(t) {
            return t instanceof Number || t instanceof String || t instanceof Boolean ? t.valueOf() : t;
        }
        function hi(t) {
            if (Array.isArray(t)) return t.map(hi);
            if (t instanceof Object && !(t instanceof Number || t instanceof String || t instanceof Boolean)) {
                const e = {};
                for(const r in t)e[r] = hi(t[r]);
                return e;
            }
            return ci(t);
        }
        function pi(t) {
            const e = t.key, r = t.value, n = t.valueSpec || {}, i = t.objectElementValidators || {}, s = t.style, a = t.styleSpec, o = t.validateSpec;
            let l = [];
            const u = Tn(r);
            if ("object" !== u) return [
                new Mt(e, r, `object expected, ${u} found`)
            ];
            for(const t in r){
                const u = t.split(".")[0], c = n[u] || n["*"];
                let h;
                if (i[u]) h = i[u];
                else if (n[u]) h = o;
                else if (i["*"]) h = i["*"];
                else {
                    if (!n["*"]) {
                        l.push(new Mt(e, r[t], `unknown property "${t}"`));
                        continue;
                    }
                    h = o;
                }
                l = l.concat(h({
                    key: (e ? `${e}.` : e) + t,
                    value: r[t],
                    valueSpec: c,
                    style: s,
                    styleSpec: a,
                    object: r,
                    objectKey: t,
                    validateSpec: o
                }, r));
            }
            for(const t in n)i[t] || n[t].required && void 0 === n[t].default && void 0 === r[t] && l.push(new Mt(e, r, `missing required property "${t}"`));
            return l;
        }
        function fi(t) {
            const e = t.value, r = t.valueSpec, n = t.style, i = t.styleSpec, s = t.key, a = t.arrayElementValidator || t.validateSpec;
            if ("array" !== Tn(e)) return [
                new Mt(s, e, `array expected, ${Tn(e)} found`)
            ];
            if (r.length && e.length !== r.length) return [
                new Mt(s, e, `array length ${r.length} expected, length ${e.length} found`)
            ];
            if (r["min-length"] && e.length < r["min-length"]) return [
                new Mt(s, e, `array length at least ${r["min-length"]} expected, length ${e.length} found`)
            ];
            let o = {
                type: r.value,
                values: r.values
            };
            i.$version < 7 && (o.function = r.function), "object" === Tn(r.value) && (o = r.value);
            let l = [];
            for(let r = 0; r < e.length; r++)l = l.concat(a({
                array: e,
                arrayIndex: r,
                value: e[r],
                valueSpec: o,
                validateSpec: t.validateSpec,
                style: n,
                styleSpec: i,
                key: `${s}[${r}]`
            }));
            return l;
        }
        function di(t) {
            const e = t.key, r = t.value, n = t.valueSpec;
            let i = Tn(r);
            return "number" === i && r != r && (i = "NaN"), "number" !== i ? [
                new Mt(e, r, `number expected, ${i} found`)
            ] : "minimum" in n && r < n.minimum ? [
                new Mt(e, r, `${r} is less than the minimum value ${n.minimum}`)
            ] : "maximum" in n && r > n.maximum ? [
                new Mt(e, r, `${r} is greater than the maximum value ${n.maximum}`)
            ] : [];
        }
        function yi(t) {
            const e = t.valueSpec, r = ci(t.value.type);
            let n, i, s, a = {};
            const o = "categorical" !== r && void 0 === t.value.property, l = !o, u = "array" === Tn(t.value.stops) && "array" === Tn(t.value.stops[0]) && "object" === Tn(t.value.stops[0][0]), c = pi({
                key: t.key,
                value: t.value,
                valueSpec: t.styleSpec.function,
                validateSpec: t.validateSpec,
                style: t.style,
                styleSpec: t.styleSpec,
                objectElementValidators: {
                    stops: function(t) {
                        if ("identity" === r) return [
                            new Mt(t.key, t.value, 'identity function may not have a "stops" property')
                        ];
                        let e = [];
                        const n = t.value;
                        return e = e.concat(fi({
                            key: t.key,
                            value: n,
                            valueSpec: t.valueSpec,
                            validateSpec: t.validateSpec,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            arrayElementValidator: h
                        })), "array" === Tn(n) && 0 === n.length && e.push(new Mt(t.key, n, "array must have at least one stop")), e;
                    },
                    default: function(t) {
                        return t.validateSpec({
                            key: t.key,
                            value: t.value,
                            valueSpec: e,
                            validateSpec: t.validateSpec,
                            style: t.style,
                            styleSpec: t.styleSpec
                        });
                    }
                }
            });
            return "identity" === r && o && c.push(new Mt(t.key, t.value, 'missing required property "property"')), "identity" === r || t.value.stops || c.push(new Mt(t.key, t.value, 'missing required property "stops"')), "exponential" === r && t.valueSpec.expression && !En(t.valueSpec) && c.push(new Mt(t.key, t.value, "exponential functions not supported")), t.styleSpec.$version >= 8 && (l && !Bn(t.valueSpec) ? c.push(new Mt(t.key, t.value, "property functions not supported")) : o && !Vn(t.valueSpec) && c.push(new Mt(t.key, t.value, "zoom functions not supported"))), "categorical" !== r && !u || void 0 !== t.value.property || c.push(new Mt(t.key, t.value, '"property" property is required')), c;
            function h(t) {
                let r = [];
                const n = t.value, o = t.key;
                if ("array" !== Tn(n)) return [
                    new Mt(o, n, `array expected, ${Tn(n)} found`)
                ];
                if (2 !== n.length) return [
                    new Mt(o, n, `array length 2 expected, length ${n.length} found`)
                ];
                if (u) {
                    if ("object" !== Tn(n[0])) return [
                        new Mt(o, n, `object expected, ${Tn(n[0])} found`)
                    ];
                    if (void 0 === n[0].zoom) return [
                        new Mt(o, n, "object stop key must have zoom")
                    ];
                    if (void 0 === n[0].value) return [
                        new Mt(o, n, "object stop key must have value")
                    ];
                    if (s && s > ci(n[0].zoom)) return [
                        new Mt(o, n[0].zoom, "stop zoom values must appear in ascending order")
                    ];
                    ci(n[0].zoom) !== s && (s = ci(n[0].zoom), i = void 0, a = {}), r = r.concat(pi({
                        key: `${o}[0]`,
                        value: n[0],
                        valueSpec: {
                            zoom: {}
                        },
                        validateSpec: t.validateSpec,
                        style: t.style,
                        styleSpec: t.styleSpec,
                        objectElementValidators: {
                            zoom: di,
                            value: p
                        }
                    }));
                } else r = r.concat(p({
                    key: `${o}[0]`,
                    value: n[0],
                    validateSpec: t.validateSpec,
                    style: t.style,
                    styleSpec: t.styleSpec
                }, n));
                return qn(hi(n[1])) ? r.concat([
                    new Mt(`${o}[1]`, n[1], "expressions are not allowed in function stops.")
                ]) : r.concat(t.validateSpec({
                    key: `${o}[1]`,
                    value: n[1],
                    valueSpec: e,
                    validateSpec: t.validateSpec,
                    style: t.style,
                    styleSpec: t.styleSpec
                }));
            }
            function p(t, s) {
                const o = Tn(t.value), l = ci(t.value), u = null !== t.value ? t.value : s;
                if (n) {
                    if (o !== n) return [
                        new Mt(t.key, u, `${o} stop domain type must match previous stop domain type ${n}`)
                    ];
                } else n = o;
                if ("number" !== o && "string" !== o && "boolean" !== o) return [
                    new Mt(t.key, u, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== o && "categorical" !== r) {
                    let n = `number expected, ${o} found`;
                    return Bn(e) && void 0 === r && (n += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new Mt(t.key, u, n)
                    ];
                }
                return "categorical" !== r || "number" !== o || isFinite(l) && Math.floor(l) === l ? "categorical" !== r && "number" === o && void 0 !== i && l < i ? [
                    new Mt(t.key, u, "stop domain values must appear in ascending order")
                ] : (i = l, "categorical" === r && l in a ? [
                    new Mt(t.key, u, "stop domain values must be unique")
                ] : (a[l] = !0, [])) : [
                    new Mt(t.key, u, `integer expected, found ${l}`)
                ];
            }
        }
        function mi(t) {
            const e = ("property" === t.expressionContext ? Xn : Gn)(hi(t.value), t.valueSpec);
            if ("error" === e.result) return e.value.map((e)=>new Mt(`${t.key}${e.key}`, t.value, e.message));
            const r = e.value.expression || e.value._styleExpression.expression;
            if ("property" === t.expressionContext && "text-font" === t.propertyKey && !r.outputDefined()) return [
                new Mt(t.key, t.value, `Invalid data expression for "${t.propertyKey}". Output values must be contained as literals within the expression.`)
            ];
            if ("property" === t.expressionContext && "layout" === t.propertyType && !In(r)) return [
                new Mt(t.key, t.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === t.expressionContext && !In(r)) return [
                new Mt(t.key, t.value, '"feature-state" data expressions are not supported with filters.')
            ];
            if (t.expressionContext && 0 === t.expressionContext.indexOf("cluster")) {
                if (!zn(r, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new Mt(t.key, t.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === t.expressionContext && !Mn(r)) return [
                    new Mt(t.key, t.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function gi(t) {
            const e = t.key, r = t.value, n = t.valueSpec, i = [];
            return Array.isArray(n.values) ? -1 === n.values.indexOf(ci(r)) && i.push(new Mt(e, r, `expected one of [${n.values.join(", ")}], ${JSON.stringify(r)} found`)) : -1 === Object.keys(n.values).indexOf(ci(r)) && i.push(new Mt(e, r, `expected one of [${Object.keys(n.values).join(", ")}], ${JSON.stringify(r)} found`)), i;
        }
        function xi(t) {
            return Jn(hi(t.value)) ? mi(It({}, t, {
                expressionContext: "filter",
                valueSpec: {
                    value: "boolean"
                }
            })) : vi(t);
        }
        function vi(t) {
            const e = t.value, r = t.key;
            if ("array" !== Tn(e)) return [
                new Mt(r, e, `array expected, ${Tn(e)} found`)
            ];
            const n = t.styleSpec;
            let i, s = [];
            if (e.length < 1) return [
                new Mt(r, e, "filter array must have at least 1 element")
            ];
            switch(s = s.concat(gi({
                key: `${r}[0]`,
                value: e[0],
                valueSpec: n.filter_operator,
                style: t.style,
                styleSpec: t.styleSpec
            })), ci(e[0])){
                case "<":
                case "<=":
                case ">":
                case ">=":
                    e.length >= 2 && "$type" === ci(e[1]) && s.push(new Mt(r, e, `"$type" cannot be use with operator "${e[0]}"`));
                case "==":
                case "!=":
                    3 !== e.length && s.push(new Mt(r, e, `filter array for operator "${e[0]}" must have 3 elements`));
                case "in":
                case "!in":
                    e.length >= 2 && (i = Tn(e[1]), "string" !== i && s.push(new Mt(`${r}[1]`, e[1], `string expected, ${i} found`)));
                    for(let a = 2; a < e.length; a++)i = Tn(e[a]), "$type" === ci(e[1]) ? s = s.concat(gi({
                        key: `${r}[${a}]`,
                        value: e[a],
                        valueSpec: n.geometry_type,
                        style: t.style,
                        styleSpec: t.styleSpec
                    })) : "string" !== i && "number" !== i && "boolean" !== i && s.push(new Mt(`${r}[${a}]`, e[a], `string, number, or boolean expected, ${i} found`));
                    break;
                case "any":
                case "all":
                case "none":
                    for(let n = 1; n < e.length; n++)s = s.concat(vi({
                        key: `${r}[${n}]`,
                        value: e[n],
                        style: t.style,
                        styleSpec: t.styleSpec
                    }));
                    break;
                case "has":
                case "!has":
                    i = Tn(e[1]), 2 !== e.length ? s.push(new Mt(r, e, `filter array for "${e[0]}" operator must have 2 elements`)) : "string" !== i && s.push(new Mt(`${r}[1]`, e[1], `string expected, ${i} found`));
            }
            return s;
        }
        function bi(t, e) {
            const r = t.key, n = t.validateSpec, i = t.style, s = t.styleSpec, a = t.value, o = t.objectKey, l = s[`${e}_${t.layerType}`];
            if (!l) return [];
            const u = o.match(/^(.*)-transition$/);
            if ("paint" === e && u && l[u[1]] && l[u[1]].transition) return n({
                key: r,
                value: a,
                valueSpec: s.transition,
                style: i,
                styleSpec: s
            });
            const c = t.valueSpec || l[o];
            if (!c) return [
                new Mt(r, a, `unknown property "${o}"`)
            ];
            let h;
            if ("string" === Tn(a) && Bn(c) && !c.tokens && (h = /^{([^}]+)}$/.exec(a))) return [
                new Mt(r, a, `"${o}" does not support interpolation syntax\nUse an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(h[1])} }\`.`)
            ];
            const p = [];
            return "symbol" === t.layerType && ("text-field" === o && i && !i.glyphs && p.push(new Mt(r, a, 'use of "text-field" requires a style "glyphs" property')), "text-font" === o && Fn(hi(a)) && "identity" === ci(a.type) && p.push(new Mt(r, a, '"text-font" does not support identity functions'))), p.concat(n({
                key: t.key,
                value: a,
                valueSpec: c,
                style: i,
                styleSpec: s,
                expressionContext: "property",
                propertyType: e,
                propertyKey: o
            }));
        }
        function wi(t) {
            return bi(t, "paint");
        }
        function _i(t) {
            return bi(t, "layout");
        }
        function Si(t) {
            let e = [];
            const r = t.value, n = t.key, i = t.style, s = t.styleSpec;
            r.type || r.ref || e.push(new Mt(n, r, 'either "type" or "ref" is required'));
            let a = ci(r.type);
            const o = ci(r.ref);
            if (r.id) {
                const s = ci(r.id);
                for(let a = 0; a < t.arrayIndex; a++){
                    const t = i.layers[a];
                    ci(t.id) === s && e.push(new Mt(n, r.id, `duplicate layer id "${r.id}", previously used at line ${t.id.__line__}`));
                }
            }
            if ("ref" in r) {
                let t;
                [
                    "type",
                    "source",
                    "source-layer",
                    "filter",
                    "layout"
                ].forEach((t)=>{
                    t in r && e.push(new Mt(n, r[t], `"${t}" is prohibited for ref layers`));
                }), i.layers.forEach((e)=>{
                    ci(e.id) === o && (t = e);
                }), t ? t.ref ? e.push(new Mt(n, r.ref, "ref cannot reference another ref layer")) : a = ci(t.type) : e.push(new Mt(n, r.ref, `ref layer "${o}" not found`));
            } else if ("background" !== a) {
                if (r.source) {
                    const t = i.sources && i.sources[r.source], s = t && ci(t.type);
                    t ? "vector" === s && "raster" === a ? e.push(new Mt(n, r.source, `layer "${r.id}" requires a raster source`)) : "raster-dem" !== s && "hillshade" === a ? e.push(new Mt(n, r.source, `layer "${r.id}" requires a raster-dem source`)) : "raster" === s && "raster" !== a ? e.push(new Mt(n, r.source, `layer "${r.id}" requires a vector source`)) : "vector" !== s || r["source-layer"] ? "raster-dem" === s && "hillshade" !== a ? e.push(new Mt(n, r.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "line" !== a || !r.paint || !r.paint["line-gradient"] || "geojson" === s && t.lineMetrics || e.push(new Mt(n, r, `layer "${r.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : e.push(new Mt(n, r, `layer "${r.id}" must specify a "source-layer"`)) : e.push(new Mt(n, r.source, `source "${r.source}" not found`));
                } else e.push(new Mt(n, r, 'missing required property "source"'));
            }
            return e = e.concat(pi({
                key: n,
                value: r,
                valueSpec: s.layer,
                style: t.style,
                styleSpec: t.styleSpec,
                validateSpec: t.validateSpec,
                objectElementValidators: {
                    "*": ()=>[],
                    type: ()=>t.validateSpec({
                            key: `${n}.type`,
                            value: r.type,
                            valueSpec: s.layer.type,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            validateSpec: t.validateSpec,
                            object: r,
                            objectKey: "type"
                        }),
                    filter: xi,
                    layout: (t)=>pi({
                            layer: r,
                            key: t.key,
                            value: t.value,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            validateSpec: t.validateSpec,
                            objectElementValidators: {
                                "*": (t)=>_i(It({
                                        layerType: a
                                    }, t))
                            }
                        }),
                    paint: (t)=>pi({
                            layer: r,
                            key: t.key,
                            value: t.value,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            validateSpec: t.validateSpec,
                            objectElementValidators: {
                                "*": (t)=>wi(It({
                                        layerType: a
                                    }, t))
                            }
                        })
                }
            })), e;
        }
        function Ai(t) {
            const e = t.value, r = t.key, n = Tn(e);
            return "string" !== n ? [
                new Mt(r, e, `string expected, ${n} found`)
            ] : [];
        }
        const ki = {
            promoteId: function({ key: t, value: e }) {
                if ("string" === Tn(e)) return Ai({
                    key: t,
                    value: e
                });
                {
                    const r = [];
                    for(const n in e)r.push(...Ai({
                        key: `${t}.${n}`,
                        value: e[n]
                    }));
                    return r;
                }
            }
        };
        function Mi(t) {
            const e = t.value, r = t.key, n = t.styleSpec, i = t.style, s = t.validateSpec;
            if (!e.type) return [
                new Mt(r, e, '"type" is required')
            ];
            const a = ci(e.type);
            let o;
            switch(a){
                case "vector":
                case "raster":
                    return o = pi({
                        key: r,
                        value: e,
                        valueSpec: n[`source_${a.replace("-", "_")}`],
                        style: t.style,
                        styleSpec: n,
                        objectElementValidators: ki,
                        validateSpec: s
                    }), o;
                case "raster-dem":
                    return o = function(t) {
                        var e;
                        const r = null !== (e = t.sourceName) && void 0 !== e ? e : "", n = t.value, i = t.styleSpec, s = i.source_raster_dem, a = t.style;
                        let o = [];
                        const l = Tn(n);
                        if (void 0 === n) return o;
                        if ("object" !== l) return o.push(new Mt("source_raster_dem", n, `object expected, ${l} found`)), o;
                        const u = "custom" === ci(n.encoding), c = [
                            "redFactor",
                            "greenFactor",
                            "blueFactor",
                            "baseShift"
                        ], h = t.value.encoding ? `"${t.value.encoding}"` : "Default";
                        for(const e in n)!u && c.includes(e) ? o.push(new Mt(e, n[e], `In "${r}": "${e}" is only valid when "encoding" is set to "custom". ${h} encoding found`)) : s[e] ? o = o.concat(t.validateSpec({
                            key: e,
                            value: n[e],
                            valueSpec: s[e],
                            validateSpec: t.validateSpec,
                            style: a,
                            styleSpec: i
                        })) : o.push(new Mt(e, n[e], `unknown property "${e}"`));
                        return o;
                    }({
                        sourceName: r,
                        value: e,
                        style: t.style,
                        styleSpec: n,
                        validateSpec: s
                    }), o;
                case "geojson":
                    if (o = pi({
                        key: r,
                        value: e,
                        valueSpec: n.source_geojson,
                        style: i,
                        styleSpec: n,
                        validateSpec: s,
                        objectElementValidators: ki
                    }), e.cluster) for(const t in e.clusterProperties){
                        const [n, i] = e.clusterProperties[t], s = "string" == typeof n ? [
                            n,
                            [
                                "accumulated"
                            ],
                            [
                                "get",
                                t
                            ]
                        ] : n;
                        o.push(...mi({
                            key: `${r}.${t}.map`,
                            value: i,
                            expressionContext: "cluster-map"
                        })), o.push(...mi({
                            key: `${r}.${t}.reduce`,
                            value: s,
                            expressionContext: "cluster-reduce"
                        }));
                    }
                    return o;
                case "video":
                    return pi({
                        key: r,
                        value: e,
                        valueSpec: n.source_video,
                        style: i,
                        validateSpec: s,
                        styleSpec: n
                    });
                case "image":
                    return pi({
                        key: r,
                        value: e,
                        valueSpec: n.source_image,
                        style: i,
                        validateSpec: s,
                        styleSpec: n
                    });
                case "canvas":
                    return [
                        new Mt(r, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return gi({
                        key: `${r}.type`,
                        value: e.type,
                        valueSpec: {
                            values: [
                                "vector",
                                "raster",
                                "raster-dem",
                                "geojson",
                                "video",
                                "image"
                            ]
                        }
                    });
            }
        }
        function Ii(t) {
            const e = t.value, r = t.styleSpec, n = r.light, i = t.style;
            let s = [];
            const a = Tn(e);
            if (void 0 === e) return s;
            if ("object" !== a) return s = s.concat([
                new Mt("light", e, `object expected, ${a} found`)
            ]), s;
            for(const a in e){
                const o = a.match(/^(.*)-transition$/);
                s = s.concat(o && n[o[1]] && n[o[1]].transition ? t.validateSpec({
                    key: a,
                    value: e[a],
                    valueSpec: r.transition,
                    validateSpec: t.validateSpec,
                    style: i,
                    styleSpec: r
                }) : n[a] ? t.validateSpec({
                    key: a,
                    value: e[a],
                    valueSpec: n[a],
                    validateSpec: t.validateSpec,
                    style: i,
                    styleSpec: r
                }) : [
                    new Mt(a, e[a], `unknown property "${a}"`)
                ]);
            }
            return s;
        }
        function zi(t) {
            const e = t.value, r = t.styleSpec, n = r.sky, i = t.style, s = Tn(e);
            if (void 0 === e) return [];
            if ("object" !== s) return [
                new Mt("sky", e, `object expected, ${s} found`)
            ];
            let a = [];
            for(const s in e)a = a.concat(n[s] ? t.validateSpec({
                key: s,
                value: e[s],
                valueSpec: n[s],
                style: i,
                styleSpec: r
            }) : [
                new Mt(s, e[s], `unknown property "${s}"`)
            ]);
            return a;
        }
        function Pi(t) {
            const e = t.value, r = t.styleSpec, n = r.terrain, i = t.style;
            let s = [];
            const a = Tn(e);
            if (void 0 === e) return s;
            if ("object" !== a) return s = s.concat([
                new Mt("terrain", e, `object expected, ${a} found`)
            ]), s;
            for(const a in e)s = s.concat(n[a] ? t.validateSpec({
                key: a,
                value: e[a],
                valueSpec: n[a],
                validateSpec: t.validateSpec,
                style: i,
                styleSpec: r
            }) : [
                new Mt(a, e[a], `unknown property "${a}"`)
            ]);
            return s;
        }
        function Ci(t) {
            let e = [];
            const r = t.value, n = t.key;
            if (Array.isArray(r)) {
                const i = [], s = [];
                for(const a in r)r[a].id && i.includes(r[a].id) && e.push(new Mt(n, r, `all the sprites' ids must be unique, but ${r[a].id} is duplicated`)), i.push(r[a].id), r[a].url && s.includes(r[a].url) && e.push(new Mt(n, r, `all the sprites' URLs must be unique, but ${r[a].url} is duplicated`)), s.push(r[a].url), e = e.concat(pi({
                    key: `${n}[${a}]`,
                    value: r[a],
                    valueSpec: {
                        id: {
                            type: "string",
                            required: !0
                        },
                        url: {
                            type: "string",
                            required: !0
                        }
                    },
                    validateSpec: t.validateSpec
                }));
                return e;
            }
            return Ai({
                key: n,
                value: r
            });
        }
        const Bi = {
            "*": ()=>[],
            array: fi,
            boolean: function(t) {
                const e = t.value, r = t.key, n = Tn(e);
                return "boolean" !== n ? [
                    new Mt(r, e, `boolean expected, ${n} found`)
                ] : [];
            },
            number: di,
            color: function(t) {
                const e = t.key, r = t.value, n = Tn(r);
                return "string" !== n ? [
                    new Mt(e, r, `color expected, ${n} found`)
                ] : xe.parse(String(r)) ? [] : [
                    new Mt(e, r, `color expected, "${r}" found`)
                ];
            },
            constants: ui,
            enum: gi,
            filter: xi,
            function: yi,
            layer: Si,
            object: pi,
            source: Mi,
            light: Ii,
            sky: zi,
            terrain: Pi,
            projection: function(t) {
                const e = t.value, r = t.styleSpec, n = r.projection, i = t.style, s = Tn(e);
                if (void 0 === e) return [];
                if ("object" !== s) return [
                    new Mt("projection", e, `object expected, ${s} found`)
                ];
                let a = [];
                for(const s in e)a = a.concat(n[s] ? t.validateSpec({
                    key: s,
                    value: e[s],
                    valueSpec: n[s],
                    style: i,
                    styleSpec: r
                }) : [
                    new Mt(s, e[s], `unknown property "${s}"`)
                ]);
                return a;
            },
            projectionDefinition: function(t) {
                const e = t.key;
                let r = t.value;
                r = r instanceof String ? r.valueOf() : r;
                const n = Tn(r);
                return "array" !== n || function(t) {
                    return Array.isArray(t) && 3 === t.length && "string" == typeof t[0] && "string" == typeof t[1] && "number" == typeof t[2];
                }(r) || function(t) {
                    return !![
                        "interpolate",
                        "step",
                        "literal"
                    ].includes(t[0]);
                }(r) ? [
                    "array",
                    "string"
                ].includes(n) ? [] : [
                    new Mt(e, r, `projection expected, invalid type "${n}" found`)
                ] : [
                    new Mt(e, r, `projection expected, invalid array ${JSON.stringify(r)} found`)
                ];
            },
            string: Ai,
            formatted: function(t) {
                return 0 === Ai(t).length ? [] : mi(t);
            },
            resolvedImage: function(t) {
                return 0 === Ai(t).length ? [] : mi(t);
            },
            padding: function(t) {
                const e = t.key, r = t.value;
                if ("array" === Tn(r)) {
                    if (r.length < 1 || r.length > 4) return [
                        new Mt(e, r, `padding requires 1 to 4 values; ${r.length} values found`)
                    ];
                    const n = {
                        type: "number"
                    };
                    let i = [];
                    for(let s = 0; s < r.length; s++)i = i.concat(t.validateSpec({
                        key: `${e}[${s}]`,
                        value: r[s],
                        validateSpec: t.validateSpec,
                        valueSpec: n
                    }));
                    return i;
                }
                return di({
                    key: e,
                    value: r,
                    valueSpec: {}
                });
            },
            variableAnchorOffsetCollection: function(t) {
                const e = t.key, r = t.value, n = Tn(r), i = t.styleSpec;
                if ("array" !== n || r.length < 1 || r.length % 2 != 0) return [
                    new Mt(e, r, "variableAnchorOffsetCollection requires a non-empty array of even length")
                ];
                let s = [];
                for(let n = 0; n < r.length; n += 2)s = s.concat(gi({
                    key: `${e}[${n}]`,
                    value: r[n],
                    valueSpec: i.layout_symbol["text-anchor"]
                })), s = s.concat(fi({
                    key: `${e}[${n + 1}]`,
                    value: r[n + 1],
                    valueSpec: {
                        length: 2,
                        value: "number"
                    },
                    validateSpec: t.validateSpec,
                    style: t.style,
                    styleSpec: i
                }));
                return s;
            },
            sprite: Ci
        };
        function Vi(t) {
            const e = t.value, r = t.valueSpec, n = t.styleSpec;
            return t.validateSpec = Vi, r.expression && Fn(ci(e)) ? yi(t) : r.expression && qn(hi(e)) ? mi(t) : r.type && Bi[r.type] ? Bi[r.type](t) : pi(It({}, t, {
                valueSpec: r.type ? n[r.type] : r
            }));
        }
        function Ei(t) {
            const e = t.value, r = t.key, n = Ai(t);
            return n.length || (-1 === e.indexOf("{fontstack}") && n.push(new Mt(r, e, '"glyphs" url must include a "{fontstack}" token')), -1 === e.indexOf("{range}") && n.push(new Mt(r, e, '"glyphs" url must include a "{range}" token'))), n;
        }
        function Ti(t, e = dt) {
            let r = [];
            return r = r.concat(Vi({
                key: "",
                value: t,
                valueSpec: e.$root,
                styleSpec: e,
                style: t,
                validateSpec: Vi,
                objectElementValidators: {
                    glyphs: Ei,
                    "*": ()=>[]
                }
            })), t.constants && (r = r.concat(ui({
                key: "constants",
                value: t.constants
            }))), $i(r);
        }
        function Fi(t) {
            return function(e) {
                return t({
                    ...e,
                    validateSpec: Vi
                });
            };
        }
        function $i(t) {
            return [].concat(t).sort((t, e)=>t.line - e.line);
        }
        function Li(t) {
            return function(...e) {
                return $i(t.apply(this, e));
            };
        }
        Ti.source = Li(Fi(Mi)), Ti.sprite = Li(Fi(Ci)), Ti.glyphs = Li(Fi(Ei)), Ti.light = Li(Fi(Ii)), Ti.sky = Li(Fi(zi)), Ti.terrain = Li(Fi(Pi)), Ti.layer = Li(Fi(Si)), Ti.filter = Li(Fi(xi)), Ti.paintProperty = Li(Fi(wi)), Ti.layoutProperty = Li(Fi(_i));
        const Oi = Ti, Di = Oi.light, Ri = Oi.sky, ji = Oi.paintProperty, Ni = Oi.layoutProperty;
        function Ui(t, e) {
            let r = !1;
            if (e && e.length) for (const n of e)t.fire(new pt(new Error(n.message))), r = !0;
            return r;
        }
        class qi {
            constructor(t, e, r){
                const n = this.cells = [];
                if (t instanceof ArrayBuffer) {
                    this.arrayBuffer = t;
                    const i = new Int32Array(this.arrayBuffer);
                    t = i[0], this.d = (e = i[1]) + 2 * (r = i[2]);
                    for(let t = 0; t < this.d * this.d; t++){
                        const e = i[3 + t], r = i[3 + t + 1];
                        n.push(e === r ? null : i.subarray(e, r));
                    }
                    const s = i[3 + n.length + 1];
                    this.keys = i.subarray(i[3 + n.length], s), this.bboxes = i.subarray(s), this.insert = this._insertReadonly;
                } else {
                    this.d = e + 2 * r;
                    for(let t = 0; t < this.d * this.d; t++)n.push([]);
                    this.keys = [], this.bboxes = [];
                }
                this.n = e, this.extent = t, this.padding = r, this.scale = e / t, this.uid = 0;
                const i = r / e * t;
                this.min = -i, this.max = t + i;
            }
            insert(t, e, r, n, i) {
                this._forEachCell(e, r, n, i, this._insertCell, this.uid++, void 0, void 0), this.keys.push(t), this.bboxes.push(e), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
            }
            _insertReadonly() {
                throw new Error("Cannot insert into a GridIndex created from an ArrayBuffer.");
            }
            _insertCell(t, e, r, n, i, s) {
                this.cells[i].push(s);
            }
            query(t, e, r, n, i) {
                const s = this.min, a = this.max;
                if (t <= s && e <= s && a <= r && a <= n && !i) return Array.prototype.slice.call(this.keys);
                {
                    const s = [];
                    return this._forEachCell(t, e, r, n, this._queryCell, s, {}, i), s;
                }
            }
            _queryCell(t, e, r, n, i, s, a, o) {
                const l = this.cells[i];
                if (null !== l) {
                    const i = this.keys, u = this.bboxes;
                    for(let c = 0; c < l.length; c++){
                        const h = l[c];
                        if (void 0 === a[h]) {
                            const l = 4 * h;
                            (o ? o(u[l + 0], u[l + 1], u[l + 2], u[l + 3]) : t <= u[l + 2] && e <= u[l + 3] && r >= u[l + 0] && n >= u[l + 1]) ? (a[h] = !0, s.push(i[h])) : a[h] = !1;
                        }
                    }
                }
            }
            _forEachCell(t, e, r, n, i, s, a, o) {
                const l = this._convertToCellCoord(t), u = this._convertToCellCoord(e), c = this._convertToCellCoord(r), h = this._convertToCellCoord(n);
                for(let p = l; p <= c; p++)for(let l = u; l <= h; l++){
                    const u = this.d * l + p;
                    if ((!o || o(this._convertFromCellCoord(p), this._convertFromCellCoord(l), this._convertFromCellCoord(p + 1), this._convertFromCellCoord(l + 1))) && i.call(this, t, e, r, n, u, s, a, o)) return;
                }
            }
            _convertFromCellCoord(t) {
                return (t - this.padding) / this.scale;
            }
            _convertToCellCoord(t) {
                return Math.max(0, Math.min(this.d - 1, Math.floor(t * this.scale) + this.padding));
            }
            toArrayBuffer() {
                if (this.arrayBuffer) return this.arrayBuffer;
                const t = this.cells, e = 3 + this.cells.length + 1 + 1;
                let r = 0;
                for(let t = 0; t < this.cells.length; t++)r += this.cells[t].length;
                const n = new Int32Array(e + r + this.keys.length + this.bboxes.length);
                n[0] = this.extent, n[1] = this.n, n[2] = this.padding;
                let i = e;
                for(let e = 0; e < t.length; e++){
                    const r = t[e];
                    n[3 + e] = i, n.set(r, i), i += r.length;
                }
                return n[3 + t.length] = i, n.set(this.keys, i), i += this.keys.length, n[3 + t.length + 1] = i, n.set(this.bboxes, i), i += this.bboxes.length, n.buffer;
            }
            static serialize(t, e) {
                const r = t.toArrayBuffer();
                return e && e.push(r), {
                    buffer: r
                };
            }
            static deserialize(t) {
                return new qi(t.buffer);
            }
        }
        const Gi = {};
        function Zi(t, e, r = {}) {
            if (Gi[t]) throw new Error(`${t} is already registered.`);
            Object.defineProperty(e, "_classRegistryKey", {
                value: t,
                writeable: !1
            }), Gi[t] = {
                klass: e,
                omit: r.omit || [],
                shallow: r.shallow || []
            };
        }
        Zi("Object", Object), Zi("TransferableGridIndex", qi), Zi("Color", xe), Zi("Error", Error), Zi("AJAXError", st), Zi("ResolvedImage", Ie), Zi("StylePropertyFunction", Hn), Zi("StyleExpression", Un, {
            omit: [
                "_evaluator"
            ]
        }), Zi("ZoomDependentExpression", Kn), Zi("ZoomConstantExpression", Zn), Zi("CompoundExpression", bn, {
            omit: [
                "_evaluate"
            ]
        });
        for(const t in vn)vn[t]._classRegistryKey || Zi(`Expression_${t}`, vn[t]);
        function Ki(t) {
            return t && "undefined" != typeof ArrayBuffer && (t instanceof ArrayBuffer || t.constructor && "ArrayBuffer" === t.constructor.name);
        }
        function Xi(t) {
            return t.$name || t.constructor._classRegistryKey;
        }
        function Hi(t) {
            return !function(t) {
                if (null === t || "object" != typeof t) return !1;
                const e = Xi(t);
                return !(!e || "Object" === e);
            }(t) && (null == t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || t instanceof Boolean || t instanceof Number || t instanceof String || t instanceof Date || t instanceof RegExp || t instanceof Blob || t instanceof Error || Ki(t) || G(t) || ArrayBuffer.isView(t) || t instanceof ImageData);
        }
        function Yi(t, e) {
            if (Hi(t)) return (Ki(t) || G(t)) && e && e.push(t), ArrayBuffer.isView(t) && e && e.push(t.buffer), t instanceof ImageData && e && e.push(t.data.buffer), t;
            if (Array.isArray(t)) {
                const r = [];
                for (const n of t)r.push(Yi(n, e));
                return r;
            }
            if ("object" != typeof t) throw new Error("can't serialize object of type " + typeof t);
            const r = Xi(t);
            if (!r) throw new Error(`can't serialize object of unregistered class ${t.constructor.name}`);
            if (!Gi[r]) throw new Error(`${r} is not registered.`);
            const { klass: n } = Gi[r], i = n.serialize ? n.serialize(t, e) : {};
            if (n.serialize) {
                if (e && i === e[e.length - 1]) throw new Error("statically serialized object won't survive transfer of $name property");
            } else {
                for(const n in t){
                    if (!t.hasOwnProperty(n)) continue;
                    if (Gi[r].omit.indexOf(n) >= 0) continue;
                    const s = t[n];
                    i[n] = Gi[r].shallow.indexOf(n) >= 0 ? s : Yi(s, e);
                }
                t instanceof Error && (i.message = t.message);
            }
            if (i.$name) throw new Error("$name property is reserved for worker serialization logic.");
            return "Object" !== r && (i.$name = r), i;
        }
        function Ji(t) {
            if (Hi(t)) return t;
            if (Array.isArray(t)) return t.map(Ji);
            if ("object" != typeof t) throw new Error("can't deserialize object of type " + typeof t);
            const e = Xi(t) || "Object";
            if (!Gi[e]) throw new Error(`can't deserialize unregistered class ${e}`);
            const { klass: r } = Gi[e];
            if (!r) throw new Error(`can't deserialize unregistered class ${e}`);
            if (r.deserialize) return r.deserialize(t);
            const n = Object.create(r.prototype);
            for (const r of Object.keys(t)){
                if ("$name" === r) continue;
                const i = t[r];
                n[r] = Gi[e].shallow.indexOf(r) >= 0 ? i : Ji(i);
            }
            return n;
        }
        class Wi {
            constructor(){
                this.first = !0;
            }
            update(t, e) {
                const r = Math.floor(t);
                return this.first ? (this.first = !1, this.lastIntegerZoom = r, this.lastIntegerZoomTime = 0, this.lastZoom = t, this.lastFloorZoom = r, !0) : (this.lastFloorZoom > r ? (this.lastIntegerZoom = r + 1, this.lastIntegerZoomTime = e) : this.lastFloorZoom < r && (this.lastIntegerZoom = r, this.lastIntegerZoomTime = e), t !== this.lastZoom && (this.lastZoom = t, this.lastFloorZoom = r, !0));
            }
        }
        const Qi = {
            "Latin-1 Supplement": (t)=>t >= 128 && t <= 255,
            "Hangul Jamo": (t)=>t >= 4352 && t <= 4607,
            Khmer: (t)=>t >= 6016 && t <= 6143,
            "General Punctuation": (t)=>t >= 8192 && t <= 8303,
            "Letterlike Symbols": (t)=>t >= 8448 && t <= 8527,
            "Number Forms": (t)=>t >= 8528 && t <= 8591,
            "Miscellaneous Technical": (t)=>t >= 8960 && t <= 9215,
            "Control Pictures": (t)=>t >= 9216 && t <= 9279,
            "Optical Character Recognition": (t)=>t >= 9280 && t <= 9311,
            "Enclosed Alphanumerics": (t)=>t >= 9312 && t <= 9471,
            "Geometric Shapes": (t)=>t >= 9632 && t <= 9727,
            "Miscellaneous Symbols": (t)=>t >= 9728 && t <= 9983,
            "Miscellaneous Symbols and Arrows": (t)=>t >= 11008 && t <= 11263,
            "Ideographic Description Characters": (t)=>t >= 12272 && t <= 12287,
            "CJK Symbols and Punctuation": (t)=>t >= 12288 && t <= 12351,
            Hiragana: (t)=>t >= 12352 && t <= 12447,
            Katakana: (t)=>t >= 12448 && t <= 12543,
            Kanbun: (t)=>t >= 12688 && t <= 12703,
            "CJK Strokes": (t)=>t >= 12736 && t <= 12783,
            "Enclosed CJK Letters and Months": (t)=>t >= 12800 && t <= 13055,
            "CJK Compatibility": (t)=>t >= 13056 && t <= 13311,
            "Yijing Hexagram Symbols": (t)=>t >= 19904 && t <= 19967,
            "CJK Unified Ideographs": (t)=>t >= 19968 && t <= 40959,
            "Hangul Syllables": (t)=>t >= 44032 && t <= 55215,
            "Private Use Area": (t)=>t >= 57344 && t <= 63743,
            "Vertical Forms": (t)=>t >= 65040 && t <= 65055,
            "CJK Compatibility Forms": (t)=>t >= 65072 && t <= 65103,
            "Small Form Variants": (t)=>t >= 65104 && t <= 65135,
            "Halfwidth and Fullwidth Forms": (t)=>t >= 65280 && t <= 65519
        };
        function ts(t) {
            for (const e of t)if (as(e.charCodeAt(0))) return !0;
            return !1;
        }
        function es(t) {
            for (const e of t)if (!is(e.charCodeAt(0))) return !1;
            return !0;
        }
        function rs(t) {
            const e = t.map((t)=>{
                try {
                    return new RegExp(`\\p{sc=${t}}`, "u").source;
                } catch (t) {
                    return null;
                }
            }).filter((t)=>t);
            return new RegExp(e.join("|"), "u");
        }
        const ns = rs([
            "Arab",
            "Dupl",
            "Mong",
            "Ougr",
            "Syrc"
        ]);
        function is(t) {
            return !ns.test(String.fromCodePoint(t));
        }
        const ss = rs([
            "Bopo",
            "Hani",
            "Hira",
            "Kana",
            "Kits",
            "Nshu",
            "Tang",
            "Yiii"
        ]);
        function as(t) {
            return !(746 !== t && 747 !== t && (t < 4352 || !(Qi["CJK Compatibility Forms"](t) && !(t >= 65097 && t <= 65103) || Qi["CJK Compatibility"](t) || Qi["CJK Strokes"](t) || !(!Qi["CJK Symbols and Punctuation"](t) || t >= 12296 && t <= 12305 || t >= 12308 && t <= 12319 || 12336 === t) || Qi["Enclosed CJK Letters and Months"](t) || Qi["Ideographic Description Characters"](t) || Qi.Kanbun(t) || Qi.Katakana(t) && 12540 !== t || !(!Qi["Halfwidth and Fullwidth Forms"](t) || 65288 === t || 65289 === t || 65293 === t || t >= 65306 && t <= 65310 || 65339 === t || 65341 === t || 65343 === t || t >= 65371 && t <= 65503 || 65507 === t || t >= 65512 && t <= 65519) || !(!Qi["Small Form Variants"](t) || t >= 65112 && t <= 65118 || t >= 65123 && t <= 65126) || Qi["Vertical Forms"](t) || Qi["Yijing Hexagram Symbols"](t) || /\p{sc=Cans}/u.test(String.fromCodePoint(t)) || /\p{sc=Hang}/u.test(String.fromCodePoint(t)) || ss.test(String.fromCodePoint(t)))));
        }
        function os(t) {
            return !(as(t) || function(t) {
                return !!(Qi["Latin-1 Supplement"](t) && (167 === t || 169 === t || 174 === t || 177 === t || 188 === t || 189 === t || 190 === t || 215 === t || 247 === t) || Qi["General Punctuation"](t) && (8214 === t || 8224 === t || 8225 === t || 8240 === t || 8241 === t || 8251 === t || 8252 === t || 8258 === t || 8263 === t || 8264 === t || 8265 === t || 8273 === t) || Qi["Letterlike Symbols"](t) || Qi["Number Forms"](t) || Qi["Miscellaneous Technical"](t) && (t >= 8960 && t <= 8967 || t >= 8972 && t <= 8991 || t >= 8996 && t <= 9e3 || 9003 === t || t >= 9085 && t <= 9114 || t >= 9150 && t <= 9165 || 9167 === t || t >= 9169 && t <= 9179 || t >= 9186 && t <= 9215) || Qi["Control Pictures"](t) && 9251 !== t || Qi["Optical Character Recognition"](t) || Qi["Enclosed Alphanumerics"](t) || Qi["Geometric Shapes"](t) || Qi["Miscellaneous Symbols"](t) && !(t >= 9754 && t <= 9759) || Qi["Miscellaneous Symbols and Arrows"](t) && (t >= 11026 && t <= 11055 || t >= 11088 && t <= 11097 || t >= 11192 && t <= 11243) || Qi["CJK Symbols and Punctuation"](t) || Qi.Katakana(t) || Qi["Private Use Area"](t) || Qi["CJK Compatibility Forms"](t) || Qi["Small Form Variants"](t) || Qi["Halfwidth and Fullwidth Forms"](t) || 8734 === t || 8756 === t || 8757 === t || t >= 9984 && t <= 10087 || t >= 10102 && t <= 10131 || 65532 === t || 65533 === t);
            }(t));
        }
        const ls = rs([
            "Adlm",
            "Arab",
            "Armi",
            "Avst",
            "Chrs",
            "Cprt",
            "Egyp",
            "Elym",
            "Gara",
            "Hatr",
            "Hebr",
            "Hung",
            "Khar",
            "Lydi",
            "Mand",
            "Mani",
            "Mend",
            "Merc",
            "Mero",
            "Narb",
            "Nbat",
            "Nkoo",
            "Orkh",
            "Palm",
            "Phli",
            "Phlp",
            "Phnx",
            "Prti",
            "Rohg",
            "Samr",
            "Sarb",
            "Sogo",
            "Syrc",
            "Thaa",
            "Todr",
            "Yezi"
        ]);
        function us(t) {
            return ls.test(String.fromCodePoint(t));
        }
        function cs(t, e) {
            return !(!e && us(t) || t >= 2304 && t <= 3583 || t >= 3840 && t <= 4255 || Qi.Khmer(t));
        }
        function hs(t) {
            for (const e of t)if (us(e.charCodeAt(0))) return !0;
            return !1;
        }
        const ps = new class {
            constructor(){
                this.TIMEOUT = 5e3, this.applyArabicShaping = null, this.processBidirectionalText = null, this.processStyledBidirectionalText = null, this.pluginStatus = "unavailable", this.pluginURL = null, this.loadScriptResolve = ()=>{};
            }
            setState(t) {
                this.pluginStatus = t.pluginStatus, this.pluginURL = t.pluginURL;
            }
            getState() {
                return {
                    pluginStatus: this.pluginStatus,
                    pluginURL: this.pluginURL
                };
            }
            setMethods(t) {
                if (ps.isParsed()) throw new Error("RTL text plugin already registered.");
                this.applyArabicShaping = t.applyArabicShaping, this.processBidirectionalText = t.processBidirectionalText, this.processStyledBidirectionalText = t.processStyledBidirectionalText, this.loadScriptResolve();
            }
            isParsed() {
                return null != this.applyArabicShaping && null != this.processBidirectionalText && null != this.processStyledBidirectionalText;
            }
            getRTLTextPluginStatus() {
                return this.pluginStatus;
            }
            syncState(t, r) {
                return e(this, void 0, void 0, function*() {
                    if (this.isParsed()) return this.getState();
                    if ("loading" !== t.pluginStatus) return this.setState(t), t;
                    const e = t.pluginURL, n = new Promise((t)=>{
                        this.loadScriptResolve = t;
                    });
                    r(e);
                    const i = new Promise((t)=>setTimeout(()=>t(), this.TIMEOUT));
                    if (yield Promise.race([
                        n,
                        i
                    ]), this.isParsed()) {
                        const t = {
                            pluginStatus: "loaded",
                            pluginURL: e
                        };
                        return this.setState(t), t;
                    }
                    throw this.setState({
                        pluginStatus: "error",
                        pluginURL: ""
                    }), new Error(`RTL Text Plugin failed to import scripts from ${e}`);
                });
            }
        };
        class fs {
            constructor(t, e){
                this.zoom = t, e ? (this.now = e.now, this.fadeDuration = e.fadeDuration, this.zoomHistory = e.zoomHistory, this.transition = e.transition) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new Wi, this.transition = {});
            }
            isSupportedScript(t) {
                return function(t, e) {
                    for (const r of t)if (!cs(r.charCodeAt(0), e)) return !1;
                    return !0;
                }(t, "loaded" === ps.getRTLTextPluginStatus());
            }
            crossFadingFactor() {
                return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
            }
            getCrossfadeParameters() {
                const t = this.zoom, e = t - Math.floor(t), r = this.crossFadingFactor();
                return t > this.zoomHistory.lastIntegerZoom ? {
                    fromScale: 2,
                    toScale: 1,
                    t: e + (1 - e) * r
                } : {
                    fromScale: .5,
                    toScale: 1,
                    t: 1 - (1 - r) * e
                };
            }
        }
        class ds {
            constructor(t, e){
                this.property = t, this.value = e, this.expression = function(t, e) {
                    if (Fn(t)) return new Hn(t, e);
                    if (qn(t)) {
                        const r = Xn(t, e);
                        if ("error" === r.result) throw new Error(r.value.map((t)=>`${t.key}: ${t.message}`).join(", "));
                        return r.value;
                    }
                    {
                        let r = t;
                        return "color" === e.type && "string" == typeof t ? r = xe.parse(t) : "padding" !== e.type || "number" != typeof t && !Array.isArray(t) ? "variableAnchorOffsetCollection" === e.type && Array.isArray(t) ? r = Me.parse(t) : "projectionDefinition" === e.type && "string" == typeof t && (r = ze.parse(t)) : r = Se.parse(t), {
                            kind: "constant",
                            evaluate: ()=>r
                        };
                    }
                }(void 0 === e ? t.specification.default : e, t.specification);
            }
            isDataDriven() {
                return "source" === this.expression.kind || "composite" === this.expression.kind;
            }
            possiblyEvaluate(t, e, r) {
                return this.property.possiblyEvaluate(this, t, e, r);
            }
        }
        class ys {
            constructor(t){
                this.property = t, this.value = new ds(t, void 0);
            }
            transitioned(t, e) {
                return new gs(this.property, this.value, e, F({}, t.transition, this.transition), t.now);
            }
            untransitioned() {
                return new gs(this.property, this.value, null, {}, 0);
            }
        }
        class ms {
            constructor(t){
                this._properties = t, this._values = Object.create(t.defaultTransitionablePropertyValues);
            }
            getValue(t) {
                return D(this._values[t].value.value);
            }
            setValue(t, e) {
                Object.prototype.hasOwnProperty.call(this._values, t) || (this._values[t] = new ys(this._values[t].property)), this._values[t].value = new ds(this._values[t].property, null === e ? void 0 : D(e));
            }
            getTransition(t) {
                return D(this._values[t].transition);
            }
            setTransition(t, e) {
                Object.prototype.hasOwnProperty.call(this._values, t) || (this._values[t] = new ys(this._values[t].property)), this._values[t].transition = D(e) || void 0;
            }
            serialize() {
                const t = {};
                for (const e of Object.keys(this._values)){
                    const r = this.getValue(e);
                    void 0 !== r && (t[e] = r);
                    const n = this.getTransition(e);
                    void 0 !== n && (t[`${e}-transition`] = n);
                }
                return t;
            }
            transitioned(t, e) {
                const r = new xs(this._properties);
                for (const n of Object.keys(this._values))r._values[n] = this._values[n].transitioned(t, e._values[n]);
                return r;
            }
            untransitioned() {
                const t = new xs(this._properties);
                for (const e of Object.keys(this._values))t._values[e] = this._values[e].untransitioned();
                return t;
            }
        }
        class gs {
            constructor(t, e, r, n, i){
                this.property = t, this.value = e, this.begin = i + n.delay || 0, this.end = this.begin + n.duration || 0, t.specification.transition && (n.delay || n.duration) && (this.prior = r);
            }
            possiblyEvaluate(t, e, r) {
                const n = t.now || 0, i = this.value.possiblyEvaluate(t, e, r), s = this.prior;
                if (s) {
                    if (n > this.end) return this.prior = null, i;
                    if (this.value.isDataDriven()) return this.prior = null, i;
                    if (n < this.begin) return s.possiblyEvaluate(t, e, r);
                    {
                        const a = (n - this.begin) / (this.end - this.begin);
                        return this.property.interpolate(s.possiblyEvaluate(t, e, r), i, C(a));
                    }
                }
                return i;
            }
        }
        class xs {
            constructor(t){
                this._properties = t, this._values = Object.create(t.defaultTransitioningPropertyValues);
            }
            possiblyEvaluate(t, e, r) {
                const n = new ws(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t, e, r);
                return n;
            }
            hasTransition() {
                for (const t of Object.keys(this._values))if (this._values[t].prior) return !0;
                return !1;
            }
        }
        class vs {
            constructor(t){
                this._properties = t, this._values = Object.create(t.defaultPropertyValues);
            }
            hasValue(t) {
                return void 0 !== this._values[t].value;
            }
            getValue(t) {
                return D(this._values[t].value);
            }
            setValue(t, e) {
                this._values[t] = new ds(this._values[t].property, null === e ? void 0 : D(e));
            }
            serialize() {
                const t = {};
                for (const e of Object.keys(this._values)){
                    const r = this.getValue(e);
                    void 0 !== r && (t[e] = r);
                }
                return t;
            }
            possiblyEvaluate(t, e, r) {
                const n = new ws(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t, e, r);
                return n;
            }
        }
        class bs {
            constructor(t, e, r){
                this.property = t, this.value = e, this.parameters = r;
            }
            isConstant() {
                return "constant" === this.value.kind;
            }
            constantOr(t) {
                return "constant" === this.value.kind ? this.value.value : t;
            }
            evaluate(t, e, r, n) {
                return this.property.evaluate(this.value, this.parameters, t, e, r, n);
            }
        }
        class ws {
            constructor(t){
                this._properties = t, this._values = Object.create(t.defaultPossiblyEvaluatedValues);
            }
            get(t) {
                return this._values[t];
            }
        }
        class _s {
            constructor(t){
                this.specification = t;
            }
            possiblyEvaluate(t, e) {
                if (t.isDataDriven()) throw new Error("Value should not be data driven");
                return t.expression.evaluate(e);
            }
            interpolate(t, e, r) {
                const n = ir[this.specification.type];
                return n ? n(t, e, r) : t;
            }
        }
        class Ss {
            constructor(t, e){
                this.specification = t, this.overrides = e;
            }
            possiblyEvaluate(t, e, r, n) {
                return new bs(this, "constant" === t.expression.kind || "camera" === t.expression.kind ? {
                    kind: "constant",
                    value: t.expression.evaluate(e, null, {}, r, n)
                } : t.expression, e);
            }
            interpolate(t, e, r) {
                if ("constant" !== t.value.kind || "constant" !== e.value.kind) return t;
                if (void 0 === t.value.value || void 0 === e.value.value) return new bs(this, {
                    kind: "constant",
                    value: void 0
                }, t.parameters);
                const n = ir[this.specification.type];
                if (n) {
                    const i = n(t.value.value, e.value.value, r);
                    return new bs(this, {
                        kind: "constant",
                        value: i
                    }, t.parameters);
                }
                return t;
            }
            evaluate(t, e, r, n, i, s) {
                return "constant" === t.kind ? t.value : t.evaluate(e, r, n, i, s);
            }
        }
        class As extends Ss {
            possiblyEvaluate(t, e, r, n) {
                if (void 0 === t.value) return new bs(this, {
                    kind: "constant",
                    value: void 0
                }, e);
                if ("constant" === t.expression.kind) {
                    const i = t.expression.evaluate(e, null, {}, r, n), s = "resolvedImage" === t.property.specification.type && "string" != typeof i ? i.name : i, a = this._calculate(s, s, s, e);
                    return new bs(this, {
                        kind: "constant",
                        value: a
                    }, e);
                }
                if ("camera" === t.expression.kind) {
                    const r = this._calculate(t.expression.evaluate({
                        zoom: e.zoom - 1
                    }), t.expression.evaluate({
                        zoom: e.zoom
                    }), t.expression.evaluate({
                        zoom: e.zoom + 1
                    }), e);
                    return new bs(this, {
                        kind: "constant",
                        value: r
                    }, e);
                }
                return new bs(this, t.expression, e);
            }
            evaluate(t, e, r, n, i, s) {
                if ("source" === t.kind) {
                    const a = t.evaluate(e, r, n, i, s);
                    return this._calculate(a, a, a, e);
                }
                return "composite" === t.kind ? this._calculate(t.evaluate({
                    zoom: Math.floor(e.zoom) - 1
                }, r, n), t.evaluate({
                    zoom: Math.floor(e.zoom)
                }, r, n), t.evaluate({
                    zoom: Math.floor(e.zoom) + 1
                }, r, n), e) : t.value;
            }
            _calculate(t, e, r, n) {
                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                    from: t,
                    to: e
                } : {
                    from: r,
                    to: e
                };
            }
            interpolate(t) {
                return t;
            }
        }
        class ks {
            constructor(t){
                this.specification = t;
            }
            possiblyEvaluate(t, e, r, n) {
                if (void 0 !== t.value) {
                    if ("constant" === t.expression.kind) {
                        const i = t.expression.evaluate(e, null, {}, r, n);
                        return this._calculate(i, i, i, e);
                    }
                    return this._calculate(t.expression.evaluate(new fs(Math.floor(e.zoom - 1), e)), t.expression.evaluate(new fs(Math.floor(e.zoom), e)), t.expression.evaluate(new fs(Math.floor(e.zoom + 1), e)), e);
                }
            }
            _calculate(t, e, r, n) {
                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                    from: t,
                    to: e
                } : {
                    from: r,
                    to: e
                };
            }
            interpolate(t) {
                return t;
            }
        }
        class Ms {
            constructor(t){
                this.specification = t;
            }
            possiblyEvaluate(t, e, r, n) {
                return !!t.expression.evaluate(e, null, {}, r, n);
            }
            interpolate() {
                return !1;
            }
        }
        class Is {
            constructor(t){
                this.properties = t, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                for(const e in t){
                    const r = t[e];
                    r.specification.overridable && this.overridableProperties.push(e);
                    const n = this.defaultPropertyValues[e] = new ds(r, void 0), i = this.defaultTransitionablePropertyValues[e] = new ys(r);
                    this.defaultTransitioningPropertyValues[e] = i.untransitioned(), this.defaultPossiblyEvaluatedValues[e] = n.possiblyEvaluate({});
                }
            }
        }
        Zi("DataDrivenProperty", Ss), Zi("DataConstantProperty", _s), Zi("CrossFadedDataDrivenProperty", As), Zi("CrossFadedProperty", ks), Zi("ColorRampProperty", Ms);
        const zs = "-transition";
        class Ps extends ft {
            constructor(t, e){
                if (super(), this.id = t.id, this.type = t.type, this._featureFilter = {
                    filter: ()=>!0,
                    needGeometry: !1
                }, "custom" !== t.type && (this.metadata = t.metadata, this.minzoom = t.minzoom, this.maxzoom = t.maxzoom, "background" !== t.type && (this.source = t.source, this.sourceLayer = t["source-layer"], this.filter = t.filter), e.layout && (this._unevaluatedLayout = new vs(e.layout)), e.paint)) {
                    this._transitionablePaint = new ms(e.paint);
                    for(const e in t.paint)this.setPaintProperty(e, t.paint[e], {
                        validate: !1
                    });
                    for(const e in t.layout)this.setLayoutProperty(e, t.layout[e], {
                        validate: !1
                    });
                    this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new ws(e.paint);
                }
            }
            getCrossfadeParameters() {
                return this._crossfadeParameters;
            }
            getLayoutProperty(t) {
                return "visibility" === t ? this.visibility : this._unevaluatedLayout.getValue(t);
            }
            setLayoutProperty(t, e, r = {}) {
                null != e && this._validate(Ni, `layers.${this.id}.layout.${t}`, t, e, r) || ("visibility" !== t ? this._unevaluatedLayout.setValue(t, e) : this.visibility = e);
            }
            getPaintProperty(t) {
                return t.endsWith(zs) ? this._transitionablePaint.getTransition(t.slice(0, -11)) : this._transitionablePaint.getValue(t);
            }
            setPaintProperty(t, e, r = {}) {
                if (null != e && this._validate(ji, `layers.${this.id}.paint.${t}`, t, e, r)) return !1;
                if (t.endsWith(zs)) return this._transitionablePaint.setTransition(t.slice(0, -11), e || void 0), !1;
                {
                    const r = this._transitionablePaint._values[t], n = "cross-faded-data-driven" === r.property.specification["property-type"], i = r.value.isDataDriven(), s = r.value;
                    this._transitionablePaint.setValue(t, e), this._handleSpecialPaintPropertyUpdate(t);
                    const a = this._transitionablePaint._values[t].value;
                    return a.isDataDriven() || i || n || this._handleOverridablePaintPropertyUpdate(t, s, a);
                }
            }
            _handleSpecialPaintPropertyUpdate(t) {}
            _handleOverridablePaintPropertyUpdate(t, e, r) {
                return !1;
            }
            isHidden(t) {
                return !!(this.minzoom && t < this.minzoom) || !!(this.maxzoom && t >= this.maxzoom) || "none" === this.visibility;
            }
            updateTransitions(t) {
                this._transitioningPaint = this._transitionablePaint.transitioned(t, this._transitioningPaint);
            }
            hasTransition() {
                return this._transitioningPaint.hasTransition();
            }
            recalculate(t, e) {
                t.getCrossfadeParameters && (this._crossfadeParameters = t.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t, void 0, e)), this.paint = this._transitioningPaint.possiblyEvaluate(t, void 0, e);
            }
            serialize() {
                const t = {
                    id: this.id,
                    type: this.type,
                    source: this.source,
                    "source-layer": this.sourceLayer,
                    metadata: this.metadata,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    filter: this.filter,
                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                };
                return this.visibility && (t.layout = t.layout || {}, t.layout.visibility = this.visibility), O(t, (t, e)=>!(void 0 === t || "layout" === e && !Object.keys(t).length || "paint" === e && !Object.keys(t).length));
            }
            _validate(t, e, r, n, i = {}) {
                return (!i || !1 !== i.validate) && Ui(this, t.call(Oi, {
                    key: e,
                    layerType: this.type,
                    objectKey: r,
                    value: n,
                    styleSpec: dt,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    }
                }));
            }
            is3D() {
                return !1;
            }
            isTileClipped() {
                return !1;
            }
            hasOffscreenPass() {
                return !1;
            }
            resize() {}
            isStateDependent() {
                for(const t in this.paint._values){
                    const e = this.paint.get(t);
                    if (e instanceof bs && Bn(e.property.specification) && ("source" === e.value.kind || "composite" === e.value.kind) && e.value.isStateDependent) return !0;
                }
                return !1;
            }
        }
        const Cs = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        };
        class Bs {
            constructor(t, e){
                this._structArray = t, this._pos1 = e * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
            }
        }
        class Vs {
            constructor(){
                this.isTransferred = !1, this.capacity = -1, this.resize(0);
            }
            static serialize(t, e) {
                return t._trim(), e && (t.isTransferred = !0, e.push(t.arrayBuffer)), {
                    length: t.length,
                    arrayBuffer: t.arrayBuffer
                };
            }
            static deserialize(t) {
                const e = Object.create(this.prototype);
                return e.arrayBuffer = t.arrayBuffer, e.length = t.length, e.capacity = t.arrayBuffer.byteLength / e.bytesPerElement, e._refreshViews(), e;
            }
            _trim() {
                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
            }
            clear() {
                this.length = 0;
            }
            resize(t) {
                this.reserve(t), this.length = t;
            }
            reserve(t) {
                if (t > this.capacity) {
                    this.capacity = Math.max(t, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                    const e = this.uint8;
                    this._refreshViews(), e && this.uint8.set(e);
                }
            }
            _refreshViews() {
                throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
            }
        }
        function Es(t, e = 1) {
            let r = 0, n = 0;
            return {
                members: t.map((t)=>{
                    const i = Cs[t.type].BYTES_PER_ELEMENT, s = r = Ts(r, Math.max(e, i)), a = t.components || 1;
                    return n = Math.max(n, i), r += i * a, {
                        name: t.name,
                        type: t.type,
                        components: a,
                        offset: s
                    };
                }),
                size: Ts(r, Math.max(n, e)),
                alignment: e
            };
        }
        function Ts(t, e) {
            return Math.ceil(t / e) * e;
        }
        class Fs extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t, e);
            }
            emplace(t, e, r) {
                const n = 2 * t;
                return this.int16[n + 0] = e, this.int16[n + 1] = r, t;
            }
        }
        Fs.prototype.bytesPerElement = 4, Zi("StructArrayLayout2i4", Fs);
        class $s extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e, r);
            }
            emplace(t, e, r, n) {
                const i = 3 * t;
                return this.int16[i + 0] = e, this.int16[i + 1] = r, this.int16[i + 2] = n, t;
            }
        }
        $s.prototype.bytesPerElement = 6, Zi("StructArrayLayout3i6", $s);
        class Ls extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t, e, r, n);
            }
            emplace(t, e, r, n, i) {
                const s = 4 * t;
                return this.int16[s + 0] = e, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, t;
            }
        }
        Ls.prototype.bytesPerElement = 8, Zi("StructArrayLayout4i8", Ls);
        class Os extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t, e, r, n, i, s);
            }
            emplace(t, e, r, n, i, s, a) {
                const o = 6 * t;
                return this.int16[o + 0] = e, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = s, this.int16[o + 5] = a, t;
            }
        }
        Os.prototype.bytesPerElement = 12, Zi("StructArrayLayout2i4i12", Os);
        class Ds extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t, e, r, n, i, s);
            }
            emplace(t, e, r, n, i, s, a) {
                const o = 4 * t, l = 8 * t;
                return this.int16[o + 0] = e, this.int16[o + 1] = r, this.uint8[l + 4] = n, this.uint8[l + 5] = i, this.uint8[l + 6] = s, this.uint8[l + 7] = a, t;
            }
        }
        Ds.prototype.bytesPerElement = 8, Zi("StructArrayLayout2i4ub8", Ds);
        class Rs extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t, e);
            }
            emplace(t, e, r) {
                const n = 2 * t;
                return this.float32[n + 0] = e, this.float32[n + 1] = r, t;
            }
        }
        Rs.prototype.bytesPerElement = 8, Zi("StructArrayLayout2f8", Rs);
        class js extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, s, a, o, l, u) {
                const c = this.length;
                return this.resize(c + 1), this.emplace(c, t, e, r, n, i, s, a, o, l, u);
            }
            emplace(t, e, r, n, i, s, a, o, l, u, c) {
                const h = 10 * t;
                return this.uint16[h + 0] = e, this.uint16[h + 1] = r, this.uint16[h + 2] = n, this.uint16[h + 3] = i, this.uint16[h + 4] = s, this.uint16[h + 5] = a, this.uint16[h + 6] = o, this.uint16[h + 7] = l, this.uint16[h + 8] = u, this.uint16[h + 9] = c, t;
            }
        }
        js.prototype.bytesPerElement = 20, Zi("StructArrayLayout10ui20", js);
        class Ns extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, s, a, o, l, u, c, h) {
                const p = this.length;
                return this.resize(p + 1), this.emplace(p, t, e, r, n, i, s, a, o, l, u, c, h);
            }
            emplace(t, e, r, n, i, s, a, o, l, u, c, h, p) {
                const f = 12 * t;
                return this.int16[f + 0] = e, this.int16[f + 1] = r, this.int16[f + 2] = n, this.int16[f + 3] = i, this.uint16[f + 4] = s, this.uint16[f + 5] = a, this.uint16[f + 6] = o, this.uint16[f + 7] = l, this.int16[f + 8] = u, this.int16[f + 9] = c, this.int16[f + 10] = h, this.int16[f + 11] = p, t;
            }
        }
        Ns.prototype.bytesPerElement = 24, Zi("StructArrayLayout4i4ui4i24", Ns);
        class Us extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e, r);
            }
            emplace(t, e, r, n) {
                const i = 3 * t;
                return this.float32[i + 0] = e, this.float32[i + 1] = r, this.float32[i + 2] = n, t;
            }
        }
        Us.prototype.bytesPerElement = 12, Zi("StructArrayLayout3f12", Us);
        class qs extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t);
            }
            emplace(t, e) {
                return this.uint32[1 * t + 0] = e, t;
            }
        }
        qs.prototype.bytesPerElement = 4, Zi("StructArrayLayout1ul4", qs);
        class Gs extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, s, a, o, l) {
                const u = this.length;
                return this.resize(u + 1), this.emplace(u, t, e, r, n, i, s, a, o, l);
            }
            emplace(t, e, r, n, i, s, a, o, l, u) {
                const c = 10 * t, h = 5 * t;
                return this.int16[c + 0] = e, this.int16[c + 1] = r, this.int16[c + 2] = n, this.int16[c + 3] = i, this.int16[c + 4] = s, this.int16[c + 5] = a, this.uint32[h + 3] = o, this.uint16[c + 8] = l, this.uint16[c + 9] = u, t;
            }
        }
        Gs.prototype.bytesPerElement = 20, Zi("StructArrayLayout6i1ul2ui20", Gs);
        class Zs extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t, e, r, n, i, s);
            }
            emplace(t, e, r, n, i, s, a) {
                const o = 6 * t;
                return this.int16[o + 0] = e, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = s, this.int16[o + 5] = a, t;
            }
        }
        Zs.prototype.bytesPerElement = 12, Zi("StructArrayLayout2i2i2i12", Zs);
        class Ks extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t, e, r, n, i);
            }
            emplace(t, e, r, n, i, s) {
                const a = 4 * t, o = 8 * t;
                return this.float32[a + 0] = e, this.float32[a + 1] = r, this.float32[a + 2] = n, this.int16[o + 6] = i, this.int16[o + 7] = s, t;
            }
        }
        Ks.prototype.bytesPerElement = 16, Zi("StructArrayLayout2f1f2i16", Ks);
        class Xs extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t, e, r, n, i, s);
            }
            emplace(t, e, r, n, i, s, a) {
                const o = 16 * t, l = 4 * t, u = 8 * t;
                return this.uint8[o + 0] = e, this.uint8[o + 1] = r, this.float32[l + 1] = n, this.float32[l + 2] = i, this.int16[u + 6] = s, this.int16[u + 7] = a, t;
            }
        }
        Xs.prototype.bytesPerElement = 16, Zi("StructArrayLayout2ub2f2i16", Xs);
        class Hs extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e, r);
            }
            emplace(t, e, r, n) {
                const i = 3 * t;
                return this.uint16[i + 0] = e, this.uint16[i + 1] = r, this.uint16[i + 2] = n, t;
            }
        }
        Hs.prototype.bytesPerElement = 6, Zi("StructArrayLayout3ui6", Hs);
        class Ys extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m) {
                const g = this.length;
                return this.resize(g + 1), this.emplace(g, t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m);
            }
            emplace(t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g) {
                const x = 24 * t, v = 12 * t, b = 48 * t;
                return this.int16[x + 0] = e, this.int16[x + 1] = r, this.uint16[x + 2] = n, this.uint16[x + 3] = i, this.uint32[v + 2] = s, this.uint32[v + 3] = a, this.uint32[v + 4] = o, this.uint16[x + 10] = l, this.uint16[x + 11] = u, this.uint16[x + 12] = c, this.float32[v + 7] = h, this.float32[v + 8] = p, this.uint8[b + 36] = f, this.uint8[b + 37] = d, this.uint8[b + 38] = y, this.uint32[v + 10] = m, this.int16[x + 22] = g, t;
            }
        }
        Ys.prototype.bytesPerElement = 48, Zi("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", Ys);
        class Js extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, S, A, k, M, I) {
                const z = this.length;
                return this.resize(z + 1), this.emplace(z, t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, S, A, k, M, I);
            }
            emplace(t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, S, A, k, M, I, z) {
                const P = 32 * t, C = 16 * t;
                return this.int16[P + 0] = e, this.int16[P + 1] = r, this.int16[P + 2] = n, this.int16[P + 3] = i, this.int16[P + 4] = s, this.int16[P + 5] = a, this.int16[P + 6] = o, this.int16[P + 7] = l, this.uint16[P + 8] = u, this.uint16[P + 9] = c, this.uint16[P + 10] = h, this.uint16[P + 11] = p, this.uint16[P + 12] = f, this.uint16[P + 13] = d, this.uint16[P + 14] = y, this.uint16[P + 15] = m, this.uint16[P + 16] = g, this.uint16[P + 17] = x, this.uint16[P + 18] = v, this.uint16[P + 19] = b, this.uint16[P + 20] = w, this.uint16[P + 21] = _, this.uint16[P + 22] = S, this.uint32[C + 12] = A, this.float32[C + 13] = k, this.float32[C + 14] = M, this.uint16[P + 30] = I, this.uint16[P + 31] = z, t;
            }
        }
        Js.prototype.bytesPerElement = 64, Zi("StructArrayLayout8i15ui1ul2f2ui64", Js);
        class Ws extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t);
            }
            emplace(t, e) {
                return this.float32[1 * t + 0] = e, t;
            }
        }
        Ws.prototype.bytesPerElement = 4, Zi("StructArrayLayout1f4", Ws);
        class Qs extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e, r);
            }
            emplace(t, e, r, n) {
                const i = 3 * t;
                return this.uint16[6 * t + 0] = e, this.float32[i + 1] = r, this.float32[i + 2] = n, t;
            }
        }
        Qs.prototype.bytesPerElement = 12, Zi("StructArrayLayout1ui2f12", Qs);
        class ta extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e, r);
            }
            emplace(t, e, r, n) {
                const i = 4 * t;
                return this.uint32[2 * t + 0] = e, this.uint16[i + 2] = r, this.uint16[i + 3] = n, t;
            }
        }
        ta.prototype.bytesPerElement = 8, Zi("StructArrayLayout1ul2ui8", ta);
        class ea extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t, e);
            }
            emplace(t, e, r) {
                const n = 2 * t;
                return this.uint16[n + 0] = e, this.uint16[n + 1] = r, t;
            }
        }
        ea.prototype.bytesPerElement = 4, Zi("StructArrayLayout2ui4", ea);
        class ra extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t);
            }
            emplace(t, e) {
                return this.uint16[1 * t + 0] = e, t;
            }
        }
        ra.prototype.bytesPerElement = 2, Zi("StructArrayLayout1ui2", ra);
        class na extends Vs {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t, e, r, n);
            }
            emplace(t, e, r, n, i) {
                const s = 4 * t;
                return this.float32[s + 0] = e, this.float32[s + 1] = r, this.float32[s + 2] = n, this.float32[s + 3] = i, t;
            }
        }
        na.prototype.bytesPerElement = 16, Zi("StructArrayLayout4f16", na);
        class ia extends Bs {
            get anchorPointX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorPointY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get x1() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get y1() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get x2() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get y2() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 3];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get anchorPoint() {
                return new l(this.anchorPointX, this.anchorPointY);
            }
        }
        ia.prototype.size = 20;
        class sa extends Gs {
            get(t) {
                return new ia(this, t);
            }
        }
        Zi("CollisionBoxArray", sa);
        class aa extends Bs {
            get anchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get glyphStartIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get numGlyphs() {
                return this._structArray.uint16[this._pos2 + 3];
            }
            get vertexStartIndex() {
                return this._structArray.uint32[this._pos4 + 2];
            }
            get lineStartIndex() {
                return this._structArray.uint32[this._pos4 + 3];
            }
            get lineLength() {
                return this._structArray.uint32[this._pos4 + 4];
            }
            get segment() {
                return this._structArray.uint16[this._pos2 + 10];
            }
            get lowerSize() {
                return this._structArray.uint16[this._pos2 + 11];
            }
            get upperSize() {
                return this._structArray.uint16[this._pos2 + 12];
            }
            get lineOffsetX() {
                return this._structArray.float32[this._pos4 + 7];
            }
            get lineOffsetY() {
                return this._structArray.float32[this._pos4 + 8];
            }
            get writingMode() {
                return this._structArray.uint8[this._pos1 + 36];
            }
            get placedOrientation() {
                return this._structArray.uint8[this._pos1 + 37];
            }
            set placedOrientation(t) {
                this._structArray.uint8[this._pos1 + 37] = t;
            }
            get hidden() {
                return this._structArray.uint8[this._pos1 + 38];
            }
            set hidden(t) {
                this._structArray.uint8[this._pos1 + 38] = t;
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 10];
            }
            set crossTileID(t) {
                this._structArray.uint32[this._pos4 + 10] = t;
            }
            get associatedIconIndex() {
                return this._structArray.int16[this._pos2 + 22];
            }
        }
        aa.prototype.size = 48;
        class oa extends Ys {
            get(t) {
                return new aa(this, t);
            }
        }
        Zi("PlacedSymbolArray", oa);
        class la extends Bs {
            get anchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get rightJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get centerJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get leftJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get verticalPlacedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get placedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 6];
            }
            get verticalPlacedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 7];
            }
            get key() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get textBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get textBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 10];
            }
            get verticalTextBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 11];
            }
            get verticalTextBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 12];
            }
            get iconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 13];
            }
            get iconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 14];
            }
            get verticalIconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 15];
            }
            get verticalIconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get featureIndex() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get numHorizontalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get numVerticalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 19];
            }
            get numIconVertices() {
                return this._structArray.uint16[this._pos2 + 20];
            }
            get numVerticalIconVertices() {
                return this._structArray.uint16[this._pos2 + 21];
            }
            get useRuntimeCollisionCircles() {
                return this._structArray.uint16[this._pos2 + 22];
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 12];
            }
            set crossTileID(t) {
                this._structArray.uint32[this._pos4 + 12] = t;
            }
            get textBoxScale() {
                return this._structArray.float32[this._pos4 + 13];
            }
            get collisionCircleDiameter() {
                return this._structArray.float32[this._pos4 + 14];
            }
            get textAnchorOffsetStartIndex() {
                return this._structArray.uint16[this._pos2 + 30];
            }
            get textAnchorOffsetEndIndex() {
                return this._structArray.uint16[this._pos2 + 31];
            }
        }
        la.prototype.size = 64;
        class ua extends Js {
            get(t) {
                return new la(this, t);
            }
        }
        Zi("SymbolInstanceArray", ua);
        class ca extends Ws {
            getoffsetX(t) {
                return this.float32[1 * t + 0];
            }
        }
        Zi("GlyphOffsetArray", ca);
        class ha extends $s {
            getx(t) {
                return this.int16[3 * t + 0];
            }
            gety(t) {
                return this.int16[3 * t + 1];
            }
            gettileUnitDistanceFromAnchor(t) {
                return this.int16[3 * t + 2];
            }
        }
        Zi("SymbolLineVertexArray", ha);
        class pa extends Bs {
            get textAnchor() {
                return this._structArray.uint16[this._pos2 + 0];
            }
            get textOffset0() {
                return this._structArray.float32[this._pos4 + 1];
            }
            get textOffset1() {
                return this._structArray.float32[this._pos4 + 2];
            }
        }
        pa.prototype.size = 12;
        class fa extends Qs {
            get(t) {
                return new pa(this, t);
            }
        }
        Zi("TextAnchorOffsetArray", fa);
        class da extends Bs {
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 0];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 3];
            }
        }
        da.prototype.size = 8;
        class ya extends ta {
            get(t) {
                return new da(this, t);
            }
        }
        Zi("FeatureIndexArray", ya);
        class ma extends Fs {
        }
        class ga extends Fs {
        }
        class xa extends Fs {
        }
        class va extends Os {
        }
        class ba extends Ds {
        }
        class wa extends Rs {
        }
        class _a extends js {
        }
        class Sa extends Ns {
        }
        class Aa extends Us {
        }
        class ka extends qs {
        }
        class Ma extends Zs {
        }
        class Ia extends Xs {
        }
        class za extends Hs {
        }
        class Pa extends ea {
        }
        const Ca = Es([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: Ba } = Ca;
        class Va {
            constructor(t = []){
                this._forceNewSegmentOnNextPrepare = !1, this.segments = t;
            }
            prepareSegment(t, e, r, n) {
                const i = this.segments[this.segments.length - 1];
                return t > Va.MAX_VERTEX_ARRAY_LENGTH && j(`Max vertices per segment is ${Va.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t}. Consider using the \`fillLargeMeshArrays\` function if you require meshes with more than ${Va.MAX_VERTEX_ARRAY_LENGTH} vertices.`), this._forceNewSegmentOnNextPrepare || !i || i.vertexLength + t > Va.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== n ? this.createNewSegment(e, r, n) : i;
            }
            createNewSegment(t, e, r) {
                const n = {
                    vertexOffset: t.length,
                    primitiveOffset: e.length,
                    vertexLength: 0,
                    primitiveLength: 0,
                    vaos: {}
                };
                return void 0 !== r && (n.sortKey = r), this._forceNewSegmentOnNextPrepare = !1, this.segments.push(n), n;
            }
            getOrCreateLatestSegment(t, e, r) {
                return this.prepareSegment(0, t, e, r);
            }
            forceNewSegmentOnNextPrepare() {
                this._forceNewSegmentOnNextPrepare = !0;
            }
            get() {
                return this.segments;
            }
            destroy() {
                for (const t of this.segments)for(const e in t.vaos)t.vaos[e].destroy();
            }
            static simpleSegment(t, e, r, n) {
                return new Va([
                    {
                        vertexOffset: t,
                        primitiveOffset: e,
                        vertexLength: r,
                        primitiveLength: n,
                        vaos: {},
                        sortKey: 0
                    }
                ]);
            }
        }
        function Ea(t, e) {
            return 256 * (t = E(Math.floor(t), 0, 255)) + E(Math.floor(e), 0, 255);
        }
        Va.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, Zi("SegmentVector", Va);
        const Ta = Es([
            {
                name: "a_pattern_from",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pattern_to",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_from",
                components: 1,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_to",
                components: 1,
                type: "Uint16"
            }
        ]);
        var Fa, $a, La, Oa = {
            exports: {}
        }, Da = {
            exports: {}
        }, Ra = {
            exports: {}
        }, ja = function() {
            if (La) return Oa.exports;
            La = 1;
            var t = (Fa || (Fa = 1, Da.exports = function(t, e) {
                var r, n, i, s, a, o, l, u;
                for(n = t.length - (r = 3 & t.length), i = e, a = 3432918353, o = 461845907, u = 0; u < n;)l = 255 & t.charCodeAt(u) | (255 & t.charCodeAt(++u)) << 8 | (255 & t.charCodeAt(++u)) << 16 | (255 & t.charCodeAt(++u)) << 24, ++u, i = 27492 + (65535 & (s = 5 * (65535 & (i = (i ^= l = (65535 & (l = (l = (65535 & l) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (s >>> 16) & 65535) << 16);
                switch(l = 0, r){
                    case 3:
                        l ^= (255 & t.charCodeAt(u + 2)) << 16;
                    case 2:
                        l ^= (255 & t.charCodeAt(u + 1)) << 8;
                    case 1:
                        i ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & t.charCodeAt(u))) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295;
                }
                return i ^= t.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
            }), Da.exports), e = ($a || ($a = 1, Ra.exports = function(t, e) {
                for(var r, n = t.length, i = e ^ n, s = 0; n >= 4;)r = 1540483477 * (65535 & (r = 255 & t.charCodeAt(s) | (255 & t.charCodeAt(++s)) << 8 | (255 & t.charCodeAt(++s)) << 16 | (255 & t.charCodeAt(++s)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), n -= 4, ++s;
                switch(n){
                    case 3:
                        i ^= (255 & t.charCodeAt(s + 2)) << 16;
                    case 2:
                        i ^= (255 & t.charCodeAt(s + 1)) << 8;
                    case 1:
                        i = 1540483477 * (65535 & (i ^= 255 & t.charCodeAt(s))) + ((1540483477 * (i >>> 16) & 65535) << 16);
                }
                return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
            }), Ra.exports);
            return Oa.exports = t, Oa.exports.murmur3 = t, Oa.exports.murmur2 = e, Oa.exports;
        }(), Na = r(ja);
        class Ua {
            constructor(){
                this.ids = [], this.positions = [], this.indexed = !1;
            }
            add(t, e, r, n) {
                this.ids.push(qa(t)), this.positions.push(e, r, n);
            }
            getPositions(t) {
                if (!this.indexed) throw new Error("Trying to get index, but feature positions are not indexed");
                const e = qa(t);
                let r = 0, n = this.ids.length - 1;
                for(; r < n;){
                    const t = r + n >> 1;
                    this.ids[t] >= e ? n = t : r = t + 1;
                }
                const i = [];
                for(; this.ids[r] === e;)i.push({
                    index: this.positions[3 * r],
                    start: this.positions[3 * r + 1],
                    end: this.positions[3 * r + 2]
                }), r++;
                return i;
            }
            static serialize(t, e) {
                const r = new Float64Array(t.ids), n = new Uint32Array(t.positions);
                return Ga(r, n, 0, r.length - 1), e && e.push(r.buffer, n.buffer), {
                    ids: r,
                    positions: n
                };
            }
            static deserialize(t) {
                const e = new Ua;
                return e.ids = t.ids, e.positions = t.positions, e.indexed = !0, e;
            }
        }
        function qa(t) {
            const e = +t;
            return !isNaN(e) && e <= Number.MAX_SAFE_INTEGER ? e : Na(String(t));
        }
        function Ga(t, e, r, n) {
            for(; r < n;){
                const i = t[r + n >> 1];
                let s = r - 1, a = n + 1;
                for(;;){
                    do s++;
                    while (t[s] < i);
                    do a--;
                    while (t[a] > i);
                    if (s >= a) break;
                    Za(t, s, a), Za(e, 3 * s, 3 * a), Za(e, 3 * s + 1, 3 * a + 1), Za(e, 3 * s + 2, 3 * a + 2);
                }
                a - r < n - a ? (Ga(t, e, r, a), r = a + 1) : (Ga(t, e, a + 1, n), n = a);
            }
        }
        function Za(t, e, r) {
            const n = t[e];
            t[e] = t[r], t[r] = n;
        }
        Zi("FeaturePositionMap", Ua);
        class Ka {
            constructor(t, e){
                this.gl = t.gl, this.location = e;
            }
        }
        class Xa extends Ka {
            constructor(t, e){
                super(t, e), this.current = 0;
            }
            set(t) {
                this.current !== t && (this.current = t, this.gl.uniform1f(this.location, t));
            }
        }
        class Ha extends Ka {
            constructor(t, e){
                super(t, e), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            set(t) {
                t[0] === this.current[0] && t[1] === this.current[1] && t[2] === this.current[2] && t[3] === this.current[3] || (this.current = t, this.gl.uniform4f(this.location, t[0], t[1], t[2], t[3]));
            }
        }
        class Ya extends Ka {
            constructor(t, e){
                super(t, e), this.current = xe.transparent;
            }
            set(t) {
                t.r === this.current.r && t.g === this.current.g && t.b === this.current.b && t.a === this.current.a || (this.current = t, this.gl.uniform4f(this.location, t.r, t.g, t.b, t.a));
            }
        }
        const Ja = new Float32Array(16);
        function Wa(t) {
            return [
                Ea(255 * t.r, 255 * t.g),
                Ea(255 * t.b, 255 * t.a)
            ];
        }
        class Qa {
            constructor(t, e, r){
                this.value = t, this.uniformNames = e.map((t)=>`u_${t}`), this.type = r;
            }
            setUniform(t, e, r) {
                t.set(r.constantOr(this.value));
            }
            getBinding(t, e, r) {
                return "color" === this.type ? new Ya(t, e) : new Xa(t, e);
            }
        }
        class to {
            constructor(t, e){
                this.uniformNames = e.map((t)=>`u_${t}`), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
            }
            setConstantPatternPositions(t, e) {
                this.pixelRatioFrom = e.pixelRatio, this.pixelRatioTo = t.pixelRatio, this.patternFrom = e.tlbr, this.patternTo = t.tlbr;
            }
            setUniform(t, e, r, n) {
                const i = "u_pattern_to" === n ? this.patternTo : "u_pattern_from" === n ? this.patternFrom : "u_pixel_ratio_to" === n ? this.pixelRatioTo : "u_pixel_ratio_from" === n ? this.pixelRatioFrom : null;
                i && t.set(i);
            }
            getBinding(t, e, r) {
                return "u_pattern" === r.substr(0, 9) ? new Ha(t, e) : new Xa(t, e);
            }
        }
        class eo {
            constructor(t, e, r, n){
                this.expression = t, this.type = r, this.maxValue = 0, this.paintVertexAttributes = e.map((t)=>({
                        name: `a_${t}`,
                        type: "Float32",
                        components: "color" === r ? 2 : 1,
                        offset: 0
                    })), this.paintVertexArray = new n;
            }
            populatePaintArray(t, e, r, n, i) {
                const s = this.paintVertexArray.length, a = this.expression.evaluate(new fs(0), e, {}, n, [], i);
                this.paintVertexArray.resize(t), this._setPaintValue(s, t, a);
            }
            updatePaintArray(t, e, r, n) {
                const i = this.expression.evaluate({
                    zoom: 0
                }, r, n);
                this._setPaintValue(t, e, i);
            }
            _setPaintValue(t, e, r) {
                if ("color" === this.type) {
                    const n = Wa(r);
                    for(let r = t; r < e; r++)this.paintVertexArray.emplace(r, n[0], n[1]);
                } else {
                    for(let n = t; n < e; n++)this.paintVertexArray.emplace(n, r);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r));
                }
            }
            upload(t) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
        }
        class ro {
            constructor(t, e, r, n, i, s){
                this.expression = t, this.uniformNames = e.map((t)=>`u_${t}_t`), this.type = r, this.useIntegerZoom = n, this.zoom = i, this.maxValue = 0, this.paintVertexAttributes = e.map((t)=>({
                        name: `a_${t}`,
                        type: "Float32",
                        components: "color" === r ? 4 : 2,
                        offset: 0
                    })), this.paintVertexArray = new s;
            }
            populatePaintArray(t, e, r, n, i) {
                const s = this.expression.evaluate(new fs(this.zoom), e, {}, n, [], i), a = this.expression.evaluate(new fs(this.zoom + 1), e, {}, n, [], i), o = this.paintVertexArray.length;
                this.paintVertexArray.resize(t), this._setPaintValue(o, t, s, a);
            }
            updatePaintArray(t, e, r, n) {
                const i = this.expression.evaluate({
                    zoom: this.zoom
                }, r, n), s = this.expression.evaluate({
                    zoom: this.zoom + 1
                }, r, n);
                this._setPaintValue(t, e, i, s);
            }
            _setPaintValue(t, e, r, n) {
                if ("color" === this.type) {
                    const i = Wa(r), s = Wa(n);
                    for(let r = t; r < e; r++)this.paintVertexArray.emplace(r, i[0], i[1], s[0], s[1]);
                } else {
                    for(let i = t; i < e; i++)this.paintVertexArray.emplace(i, r, n);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
                }
            }
            upload(t) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            setUniform(t, e) {
                const r = this.useIntegerZoom ? Math.floor(e.zoom) : e.zoom, n = E(this.expression.interpolationFactor(r, this.zoom, this.zoom + 1), 0, 1);
                t.set(n);
            }
            getBinding(t, e, r) {
                return new Xa(t, e);
            }
        }
        class no {
            constructor(t, e, r, n, i, s){
                this.expression = t, this.type = e, this.useIntegerZoom = r, this.zoom = n, this.layerId = s, this.zoomInPaintVertexArray = new i, this.zoomOutPaintVertexArray = new i;
            }
            populatePaintArray(t, e, r) {
                const n = this.zoomInPaintVertexArray.length;
                this.zoomInPaintVertexArray.resize(t), this.zoomOutPaintVertexArray.resize(t), this._setPaintValues(n, t, e.patterns && e.patterns[this.layerId], r);
            }
            updatePaintArray(t, e, r, n, i) {
                this._setPaintValues(t, e, r.patterns && r.patterns[this.layerId], i);
            }
            _setPaintValues(t, e, r, n) {
                if (!n || !r) return;
                const { min: i, mid: s, max: a } = r, o = n[i], l = n[s], u = n[a];
                if (o && l && u) for(let r = t; r < e; r++)this.zoomInPaintVertexArray.emplace(r, l.tl[0], l.tl[1], l.br[0], l.br[1], o.tl[0], o.tl[1], o.br[0], o.br[1], l.pixelRatio, o.pixelRatio), this.zoomOutPaintVertexArray.emplace(r, l.tl[0], l.tl[1], l.br[0], l.br[1], u.tl[0], u.tl[1], u.br[0], u.br[1], l.pixelRatio, u.pixelRatio);
            }
            upload(t) {
                this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer && (this.zoomInPaintVertexBuffer = t.createVertexBuffer(this.zoomInPaintVertexArray, Ta.members, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = t.createVertexBuffer(this.zoomOutPaintVertexArray, Ta.members, this.expression.isStateDependent));
            }
            destroy() {
                this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
            }
        }
        class io {
            constructor(t, e, r){
                this.binders = {}, this._buffers = [];
                const n = [];
                for(const i in t.paint._values){
                    if (!r(i)) continue;
                    const s = t.paint.get(i);
                    if (!(s instanceof bs && Bn(s.property.specification))) continue;
                    const a = ao(i, t.type), o = s.value, l = s.property.specification.type, u = s.property.useIntegerZoom, c = s.property.specification["property-type"], h = "cross-faded" === c || "cross-faded-data-driven" === c;
                    if ("constant" === o.kind) this.binders[i] = h ? new to(o.value, a) : new Qa(o.value, a, l), n.push(`/u_${i}`);
                    else if ("source" === o.kind || h) {
                        const r = oo(i, l, "source");
                        this.binders[i] = h ? new no(o, l, u, e, r, t.id) : new eo(o, a, l, r), n.push(`/a_${i}`);
                    } else {
                        const t = oo(i, l, "composite");
                        this.binders[i] = new ro(o, a, l, u, e, t), n.push(`/z_${i}`);
                    }
                }
                this.cacheKey = n.sort().join("");
            }
            getMaxValue(t) {
                const e = this.binders[t];
                return e instanceof eo || e instanceof ro ? e.maxValue : 0;
            }
            populatePaintArrays(t, e, r, n, i) {
                for(const s in this.binders){
                    const a = this.binders[s];
                    (a instanceof eo || a instanceof ro || a instanceof no) && a.populatePaintArray(t, e, r, n, i);
                }
            }
            setConstantPatternPositions(t, e) {
                for(const r in this.binders){
                    const n = this.binders[r];
                    n instanceof to && n.setConstantPatternPositions(t, e);
                }
            }
            updatePaintArrays(t, e, r, n, i) {
                let s = !1;
                for(const a in t){
                    const o = e.getPositions(a);
                    for (const e of o){
                        const o = r.feature(e.index);
                        for(const r in this.binders){
                            const l = this.binders[r];
                            if ((l instanceof eo || l instanceof ro || l instanceof no) && !0 === l.expression.isStateDependent) {
                                const u = n.paint.get(r);
                                l.expression = u.value, l.updatePaintArray(e.start, e.end, o, t[a], i), s = !0;
                            }
                        }
                    }
                }
                return s;
            }
            defines() {
                const t = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    (r instanceof Qa || r instanceof to) && t.push(...r.uniformNames.map((t)=>`#define HAS_UNIFORM_${t}`));
                }
                return t;
            }
            getBinderAttributes() {
                const t = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    if (r instanceof eo || r instanceof ro) for(let e = 0; e < r.paintVertexAttributes.length; e++)t.push(r.paintVertexAttributes[e].name);
                    else if (r instanceof no) for(let e = 0; e < Ta.members.length; e++)t.push(Ta.members[e].name);
                }
                return t;
            }
            getBinderUniforms() {
                const t = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    if (r instanceof Qa || r instanceof to || r instanceof ro) for (const e of r.uniformNames)t.push(e);
                }
                return t;
            }
            getPaintVertexBuffers() {
                return this._buffers;
            }
            getUniforms(t, e) {
                const r = [];
                for(const n in this.binders){
                    const i = this.binders[n];
                    if (i instanceof Qa || i instanceof to || i instanceof ro) {
                        for (const s of i.uniformNames)if (e[s]) {
                            const a = i.getBinding(t, e[s], s);
                            r.push({
                                name: s,
                                property: n,
                                binding: a
                            });
                        }
                    }
                }
                return r;
            }
            setUniforms(t, e, r, n) {
                for (const { name: t, property: i, binding: s } of e)this.binders[i].setUniform(s, n, r.get(i), t);
            }
            updatePaintBuffers(t) {
                this._buffers = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    if (t && r instanceof no) {
                        const e = 2 === t.fromScale ? r.zoomInPaintVertexBuffer : r.zoomOutPaintVertexBuffer;
                        e && this._buffers.push(e);
                    } else (r instanceof eo || r instanceof ro) && r.paintVertexBuffer && this._buffers.push(r.paintVertexBuffer);
                }
            }
            upload(t) {
                for(const e in this.binders){
                    const r = this.binders[e];
                    (r instanceof eo || r instanceof ro || r instanceof no) && r.upload(t);
                }
                this.updatePaintBuffers();
            }
            destroy() {
                for(const t in this.binders){
                    const e = this.binders[t];
                    (e instanceof eo || e instanceof ro || e instanceof no) && e.destroy();
                }
            }
        }
        class so {
            constructor(t, e, r = ()=>!0){
                this.programConfigurations = {};
                for (const n of t)this.programConfigurations[n.id] = new io(n, e, r);
                this.needsUpload = !1, this._featureMap = new Ua, this._bufferOffset = 0;
            }
            populatePaintArrays(t, e, r, n, i, s) {
                for(const r in this.programConfigurations)this.programConfigurations[r].populatePaintArrays(t, e, n, i, s);
                void 0 !== e.id && this._featureMap.add(e.id, r, this._bufferOffset, t), this._bufferOffset = t, this.needsUpload = !0;
            }
            updatePaintArrays(t, e, r, n) {
                for (const i of r)this.needsUpload = this.programConfigurations[i.id].updatePaintArrays(t, this._featureMap, e, i, n) || this.needsUpload;
            }
            get(t) {
                return this.programConfigurations[t];
            }
            upload(t) {
                if (this.needsUpload) {
                    for(const e in this.programConfigurations)this.programConfigurations[e].upload(t);
                    this.needsUpload = !1;
                }
            }
            destroy() {
                for(const t in this.programConfigurations)this.programConfigurations[t].destroy();
            }
        }
        function ao(t, e) {
            return ({
                "text-opacity": [
                    "opacity"
                ],
                "icon-opacity": [
                    "opacity"
                ],
                "text-color": [
                    "fill_color"
                ],
                "icon-color": [
                    "fill_color"
                ],
                "text-halo-color": [
                    "halo_color"
                ],
                "icon-halo-color": [
                    "halo_color"
                ],
                "text-halo-blur": [
                    "halo_blur"
                ],
                "icon-halo-blur": [
                    "halo_blur"
                ],
                "text-halo-width": [
                    "halo_width"
                ],
                "icon-halo-width": [
                    "halo_width"
                ],
                "line-gap-width": [
                    "gapwidth"
                ],
                "line-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-extrusion-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ]
            })[t] || [
                t.replace(`${e}-`, "").replace(/-/g, "_")
            ];
        }
        function oo(t, e, r) {
            const n = {
                color: {
                    source: Rs,
                    composite: na
                },
                number: {
                    source: Ws,
                    composite: Rs
                }
            }, i = function(t) {
                return ({
                    "line-pattern": {
                        source: _a,
                        composite: _a
                    },
                    "fill-pattern": {
                        source: _a,
                        composite: _a
                    },
                    "fill-extrusion-pattern": {
                        source: _a,
                        composite: _a
                    }
                })[t];
            }(t);
            return i && i[r] || n[e][r];
        }
        Zi("ConstantBinder", Qa), Zi("CrossFadedConstantBinder", to), Zi("SourceExpressionBinder", eo), Zi("CrossFadedCompositeBinder", no), Zi("CompositeExpressionBinder", ro), Zi("ProgramConfiguration", io, {
            omit: [
                "_buffers"
            ]
        }), Zi("ProgramConfigurationSet", so);
        const lo = Math.pow(2, 14) - 1, uo = -lo - 1;
        function co(t) {
            const e = M / t.extent, r = t.loadGeometry();
            for(let t = 0; t < r.length; t++){
                const n = r[t];
                for(let t = 0; t < n.length; t++){
                    const r = n[t], i = Math.round(r.x * e), s = Math.round(r.y * e);
                    r.x = E(i, uo, lo), r.y = E(s, uo, lo), (i < r.x || i > r.x + 1 || s < r.y || s > r.y + 1) && j("Geometry exceeds allowed extent, reduce your vector tile buffer size");
                }
            }
            return r;
        }
        function ho(t, e) {
            return {
                type: t.type,
                id: t.id,
                properties: t.properties,
                geometry: e ? co(t) : []
            };
        }
        const po = -32768;
        function fo(t, e, r, n, i) {
            t.emplaceBack(po + 8 * e + n, po + 8 * r + i);
        }
        class yo {
            constructor(t){
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = t.index, this.hasPattern = !1, this.layoutVertexArray = new ga, this.indexArray = new za, this.segments = new Va, this.programConfigurations = new so(t.layers, t.zoom), this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id);
            }
            populate(t, e, r) {
                const n = this.layers[0], i = [];
                let s = null, a = !1, o = "heatmap" === n.type;
                if ("circle" === n.type) {
                    const t = n;
                    s = t.layout.get("circle-sort-key"), a = !s.isConstant(), o = o || "map" === t.paint.get("circle-pitch-alignment");
                }
                const l = o ? e.subdivisionGranularity.circle : 1;
                for (const { feature: e, id: n, index: o, sourceLayerIndex: l } of t){
                    const t = this.layers[0]._featureFilter.needGeometry, u = ho(e, t);
                    if (!this.layers[0]._featureFilter.filter(new fs(this.zoom), u, r)) continue;
                    const c = a ? s.evaluate(u, {}, r) : void 0, h = {
                        id: n,
                        properties: e.properties,
                        type: e.type,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: t ? u.geometry : co(e),
                        patterns: {},
                        sortKey: c
                    };
                    i.push(h);
                }
                a && i.sort((t, e)=>t.sortKey - e.sortKey);
                for (const n of i){
                    const { geometry: i, index: s, sourceLayerIndex: a } = n, o = t[s].feature;
                    this.addFeature(n, i, s, r, l), e.featureIndex.insert(o, i, s, a, this.index);
                }
            }
            update(t, e, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e, this.stateDependentLayers, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t) {
                this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, Ba), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            addFeature(t, e, r, n, i = 1) {
                let s;
                switch(i){
                    case 1:
                        s = [
                            0,
                            7
                        ];
                        break;
                    case 3:
                        s = [
                            0,
                            2,
                            5,
                            7
                        ];
                        break;
                    case 5:
                        s = [
                            0,
                            1,
                            3,
                            4,
                            6,
                            7
                        ];
                        break;
                    case 7:
                        s = [
                            0,
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7
                        ];
                        break;
                    default:
                        throw new Error(`Invalid circle bucket granularity: ${i}; valid values are 1, 3, 5, 7.`);
                }
                const a = s.length;
                for (const r of e)for (const e of r){
                    const r = e.x, n = e.y;
                    if (r < 0 || r >= M || n < 0 || n >= M) continue;
                    const i = this.segments.prepareSegment(a * a, this.layoutVertexArray, this.indexArray, t.sortKey), o = i.vertexLength;
                    for(let t = 0; t < a; t++)for(let e = 0; e < a; e++)fo(this.layoutVertexArray, r, n, s[e], s[t]);
                    for(let t = 0; t < a - 1; t++)for(let e = 0; e < a - 1; e++){
                        const r = o + t * a + e, n = o + (t + 1) * a + e;
                        this.indexArray.emplaceBack(r, n + 1, r + 1), this.indexArray.emplaceBack(r, n, n + 1);
                    }
                    i.vertexLength += a * a, i.primitiveLength += (a - 1) * (a - 1) * 2;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, {}, n);
            }
        }
        function mo(t, e) {
            for(let r = 0; r < t.length; r++)if (ko(e, t[r])) return !0;
            for(let r = 0; r < e.length; r++)if (ko(t, e[r])) return !0;
            return !!bo(t, e);
        }
        function go(t, e, r) {
            return !!ko(t, e) || !!_o(e, t, r);
        }
        function xo(t, e) {
            if (1 === t.length) return Ao(e, t[0]);
            for(let r = 0; r < e.length; r++){
                const n = e[r];
                for(let e = 0; e < n.length; e++)if (ko(t, n[e])) return !0;
            }
            for(let r = 0; r < t.length; r++)if (Ao(e, t[r])) return !0;
            for(let r = 0; r < e.length; r++)if (bo(t, e[r])) return !0;
            return !1;
        }
        function vo(t, e, r) {
            if (t.length > 1) {
                if (bo(t, e)) return !0;
                for(let n = 0; n < e.length; n++)if (_o(e[n], t, r)) return !0;
            }
            for(let n = 0; n < t.length; n++)if (_o(t[n], e, r)) return !0;
            return !1;
        }
        function bo(t, e) {
            if (0 === t.length || 0 === e.length) return !1;
            for(let r = 0; r < t.length - 1; r++){
                const n = t[r], i = t[r + 1];
                for(let t = 0; t < e.length - 1; t++)if (wo(n, i, e[t], e[t + 1])) return !0;
            }
            return !1;
        }
        function wo(t, e, r, n) {
            return N(t, r, n) !== N(e, r, n) && N(t, e, r) !== N(t, e, n);
        }
        function _o(t, e, r) {
            const n = r * r;
            if (1 === e.length) return t.distSqr(e[0]) < n;
            for(let r = 1; r < e.length; r++)if (So(t, e[r - 1], e[r]) < n) return !0;
            return !1;
        }
        function So(t, e, r) {
            const n = e.distSqr(r);
            if (0 === n) return t.distSqr(e);
            const i = ((t.x - e.x) * (r.x - e.x) + (t.y - e.y) * (r.y - e.y)) / n;
            return t.distSqr(i < 0 ? e : i > 1 ? r : r.sub(e)._mult(i)._add(e));
        }
        function Ao(t, e) {
            for(let r = 0; r < t.length; r++)if (ko(t[r], e)) return !0;
            return !1;
        }
        function ko(t, e) {
            let r = !1;
            for(let n = 0, i = t.length - 1; n < t.length; i = n++){
                const s = t[n], a = t[i];
                s.y > e.y != a.y > e.y && e.x < (a.x - s.x) * (e.y - s.y) / (a.y - s.y) + s.x && (r = !r);
            }
            return r;
        }
        function Mo(t, e, r) {
            const n = r[0], i = r[2];
            if (t.x < n.x && e.x < n.x || t.x > i.x && e.x > i.x || t.y < n.y && e.y < n.y || t.y > i.y && e.y > i.y) return !1;
            const s = N(t, e, r[0]);
            return s !== N(t, e, r[1]) || s !== N(t, e, r[2]) || s !== N(t, e, r[3]);
        }
        function Io(t, e, r) {
            const n = e.paint.get(t).value;
            return "constant" === n.kind ? n.value : r.programConfigurations.get(e.id).getMaxValue(t);
        }
        function zo(t) {
            return Math.sqrt(t[0] * t[0] + t[1] * t[1]);
        }
        function Po(t, e, r, n, i) {
            if (!e[0] && !e[1]) return t;
            const s = l.convert(e)._mult(i);
            "viewport" === r && s._rotate(-n);
            const a = [];
            for(let e = 0; e < t.length; e++)a.push(t[e].sub(s));
            return a;
        }
        let Co, Bo;
        Zi("CircleBucket", yo, {
            omit: [
                "layers"
            ]
        });
        var Vo = {
            get paint () {
                return Bo = Bo || new Is({
                    "circle-radius": new Ss(dt.paint_circle["circle-radius"]),
                    "circle-color": new Ss(dt.paint_circle["circle-color"]),
                    "circle-blur": new Ss(dt.paint_circle["circle-blur"]),
                    "circle-opacity": new Ss(dt.paint_circle["circle-opacity"]),
                    "circle-translate": new _s(dt.paint_circle["circle-translate"]),
                    "circle-translate-anchor": new _s(dt.paint_circle["circle-translate-anchor"]),
                    "circle-pitch-scale": new _s(dt.paint_circle["circle-pitch-scale"]),
                    "circle-pitch-alignment": new _s(dt.paint_circle["circle-pitch-alignment"]),
                    "circle-stroke-width": new Ss(dt.paint_circle["circle-stroke-width"]),
                    "circle-stroke-color": new Ss(dt.paint_circle["circle-stroke-color"]),
                    "circle-stroke-opacity": new Ss(dt.paint_circle["circle-stroke-opacity"])
                });
            },
            get layout () {
                return Co = Co || new Is({
                    "circle-sort-key": new Ss(dt.layout_circle["circle-sort-key"])
                });
            }
        };
        class Eo extends Ps {
            constructor(t){
                super(t, Vo);
            }
            createBucket(t) {
                return new yo(t);
            }
            queryRadius(t) {
                const e = t;
                return Io("circle-radius", this, e) + Io("circle-stroke-width", this, e) + zo(this.paint.get("circle-translate"));
            }
            queryIntersectsFeature({ queryGeometry: t, feature: e, featureState: r, geometry: n, transform: i, pixelsToTileUnits: s, unwrappedTileID: a, getElevation: o }) {
                const l = Po(t, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), -i.bearingInRadians, s), u = this.paint.get("circle-radius").evaluate(e, r) + this.paint.get("circle-stroke-width").evaluate(e, r), c = "map" === this.paint.get("circle-pitch-alignment"), h = c ? l : function(t, e, r, n) {
                    return t.map((t)=>To(t, e, r, n));
                }(l, i, a, o), p = c ? u * s : u;
                for (const t of n)for (const e of t){
                    const t = c ? e : To(e, i, a, o);
                    let r = p;
                    const n = i.projectTileCoordinates(e.x, e.y, a, o).signedDistanceFromCamera;
                    if ("viewport" === this.paint.get("circle-pitch-scale") && "map" === this.paint.get("circle-pitch-alignment") ? r *= n / i.cameraToCenterDistance : "map" === this.paint.get("circle-pitch-scale") && "viewport" === this.paint.get("circle-pitch-alignment") && (r *= i.cameraToCenterDistance / n), go(h, t, r)) return !0;
                }
                return !1;
            }
        }
        function To(t, e, r, n) {
            const i = e.projectTileCoordinates(t.x, t.y, r, n).point;
            return new l((.5 * i.x + .5) * e.width, (.5 * -i.y + .5) * e.height);
        }
        class Fo extends yo {
        }
        let $o;
        Zi("HeatmapBucket", Fo, {
            omit: [
                "layers"
            ]
        });
        var Lo = {
            get paint () {
                return $o = $o || new Is({
                    "heatmap-radius": new Ss(dt.paint_heatmap["heatmap-radius"]),
                    "heatmap-weight": new Ss(dt.paint_heatmap["heatmap-weight"]),
                    "heatmap-intensity": new _s(dt.paint_heatmap["heatmap-intensity"]),
                    "heatmap-color": new Ms(dt.paint_heatmap["heatmap-color"]),
                    "heatmap-opacity": new _s(dt.paint_heatmap["heatmap-opacity"])
                });
            }
        };
        function Oo(t, { width: e, height: r }, n, i) {
            if (i) {
                if (i instanceof Uint8ClampedArray) i = new Uint8Array(i.buffer);
                else if (i.length !== e * r * n) throw new RangeError(`mismatched image size. expected: ${i.length} but got: ${e * r * n}`);
            } else i = new Uint8Array(e * r * n);
            return t.width = e, t.height = r, t.data = i, t;
        }
        function Do(t, { width: e, height: r }, n) {
            if (e === t.width && r === t.height) return;
            const i = Oo({}, {
                width: e,
                height: r
            }, n);
            Ro(t, i, {
                x: 0,
                y: 0
            }, {
                x: 0,
                y: 0
            }, {
                width: Math.min(t.width, e),
                height: Math.min(t.height, r)
            }, n), t.width = e, t.height = r, t.data = i.data;
        }
        function Ro(t, e, r, n, i, s) {
            if (0 === i.width || 0 === i.height) return e;
            if (i.width > t.width || i.height > t.height || r.x > t.width - i.width || r.y > t.height - i.height) throw new RangeError("out of range source coordinates for image copy");
            if (i.width > e.width || i.height > e.height || n.x > e.width - i.width || n.y > e.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
            const a = t.data, o = e.data;
            if (a === o) throw new Error("srcData equals dstData, so image is already copied");
            for(let l = 0; l < i.height; l++){
                const u = ((r.y + l) * t.width + r.x) * s, c = ((n.y + l) * e.width + n.x) * s;
                for(let t = 0; t < i.width * s; t++)o[c + t] = a[u + t];
            }
            return e;
        }
        class jo {
            constructor(t, e){
                Oo(this, t, 1, e);
            }
            resize(t) {
                Do(this, t, 1);
            }
            clone() {
                return new jo({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t, e, r, n, i) {
                Ro(t, e, r, n, i, 1);
            }
        }
        class No {
            constructor(t, e){
                Oo(this, t, 4, e);
            }
            resize(t) {
                Do(this, t, 4);
            }
            replace(t, e) {
                e ? this.data.set(t) : this.data = t instanceof Uint8ClampedArray ? new Uint8Array(t.buffer) : t;
            }
            clone() {
                return new No({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t, e, r, n, i) {
                Ro(t, e, r, n, i, 4);
            }
        }
        function Uo(t) {
            const e = {}, r = t.resolution || 256, n = t.clips ? t.clips.length : 1, i = t.image || new No({
                width: r,
                height: n
            });
            if (Math.log(r) / Math.LN2 % 1 != 0) throw new Error(`width is not a power of 2 - ${r}`);
            const s = (r, n, s)=>{
                e[t.evaluationKey] = s;
                const a = t.expression.evaluate(e);
                i.data[r + n + 0] = Math.floor(255 * a.r / a.a), i.data[r + n + 1] = Math.floor(255 * a.g / a.a), i.data[r + n + 2] = Math.floor(255 * a.b / a.a), i.data[r + n + 3] = Math.floor(255 * a.a);
            };
            if (t.clips) for(let e = 0, i = 0; e < n; ++e, i += 4 * r)for(let n = 0, a = 0; n < r; n++, a += 4){
                const o = n / (r - 1), { start: l, end: u } = t.clips[e];
                s(i, a, l * (1 - o) + u * o);
            }
            else for(let t = 0, e = 0; t < r; t++, e += 4)s(0, e, t / (r - 1));
            return i;
        }
        Zi("AlphaImage", jo), Zi("RGBAImage", No);
        const qo = "big-fb";
        class Go extends Ps {
            createBucket(t) {
                return new Fo(t);
            }
            constructor(t){
                super(t, Lo), this.heatmapFbos = new Map, this._updateColorRamp();
            }
            _handleSpecialPaintPropertyUpdate(t) {
                "heatmap-color" === t && this._updateColorRamp();
            }
            _updateColorRamp() {
                this.colorRamp = Uo({
                    expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                    evaluationKey: "heatmapDensity",
                    image: this.colorRamp
                }), this.colorRampTexture = null;
            }
            resize() {
                this.heatmapFbos.has(qo) && this.heatmapFbos.delete(qo);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                return !1;
            }
            hasOffscreenPass() {
                return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
            }
        }
        let Zo;
        var Ko = {
            get paint () {
                return Zo = Zo || new Is({
                    "hillshade-illumination-direction": new _s(dt.paint_hillshade["hillshade-illumination-direction"]),
                    "hillshade-illumination-anchor": new _s(dt.paint_hillshade["hillshade-illumination-anchor"]),
                    "hillshade-exaggeration": new _s(dt.paint_hillshade["hillshade-exaggeration"]),
                    "hillshade-shadow-color": new _s(dt.paint_hillshade["hillshade-shadow-color"]),
                    "hillshade-highlight-color": new _s(dt.paint_hillshade["hillshade-highlight-color"]),
                    "hillshade-accent-color": new _s(dt.paint_hillshade["hillshade-accent-color"])
                });
            }
        };
        class Xo extends Ps {
            constructor(t){
                super(t, Ko);
            }
            hasOffscreenPass() {
                return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
            }
        }
        const Ho = Es([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: Yo } = Ho;
        function Jo(t, e, r) {
            const n = r.patternDependencies;
            let i = !1;
            for (const r of e){
                const e = r.paint.get(`${t}-pattern`);
                e.isConstant() || (i = !0);
                const s = e.constantOr(null);
                s && (i = !0, n[s.to] = !0, n[s.from] = !0);
            }
            return i;
        }
        function Wo(t, e, r, n, i) {
            const s = i.patternDependencies;
            for (const a of e){
                const e = a.paint.get(`${t}-pattern`).value;
                if ("constant" !== e.kind) {
                    let t = e.evaluate({
                        zoom: n - 1
                    }, r, {}, i.availableImages), o = e.evaluate({
                        zoom: n
                    }, r, {}, i.availableImages), l = e.evaluate({
                        zoom: n + 1
                    }, r, {}, i.availableImages);
                    t = t && t.name ? t.name : t, o = o && o.name ? o.name : o, l = l && l.name ? l.name : l, s[t] = !0, s[o] = !0, s[l] = !0, r.patterns[a.id] = {
                        min: t,
                        mid: o,
                        max: l
                    };
                }
            }
            return r;
        }
        function Qo(t, e, r, n, i) {
            let s;
            if (i === function(t, e, r, n) {
                let i = 0;
                for(let s = e, a = r - n; s < r; s += n)i += (t[a] - t[s]) * (t[s + 1] + t[a + 1]), a = s;
                return i;
            }(t, e, r, n) > 0) for(let i = e; i < r; i += n)s = wl(i / n | 0, t[i], t[i + 1], s);
            else for(let i = r - n; i >= e; i -= n)s = wl(i / n | 0, t[i], t[i + 1], s);
            return s && yl(s, s.next) && (_l(s), s = s.next), s;
        }
        function tl(t, e) {
            if (!t) return t;
            e || (e = t);
            let r, n = t;
            do if (r = !1, n.steiner || !yl(n, n.next) && 0 !== dl(n.prev, n, n.next)) n = n.next;
            else {
                if (_l(n), n = e = n.prev, n === n.next) break;
                r = !0;
            }
            while (r || n !== e);
            return e;
        }
        function el(t, e, r, n, i, s, a) {
            if (!t) return;
            !a && s && function(t, e, r, n) {
                let i = t;
                do 0 === i.z && (i.z = ul(i.x, i.y, e, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                while (i !== t);
                i.prevZ.nextZ = null, i.prevZ = null, function(t) {
                    let e, r = 1;
                    do {
                        let n, i = t;
                        t = null;
                        let s = null;
                        for(e = 0; i;){
                            e++;
                            let a = i, o = 0;
                            for(let t = 0; t < r && (o++, a = a.nextZ, a); t++);
                            let l = r;
                            for(; o > 0 || l > 0 && a;)0 !== o && (0 === l || !a || i.z <= a.z) ? (n = i, i = i.nextZ, o--) : (n = a, a = a.nextZ, l--), s ? s.nextZ = n : t = n, n.prevZ = s, s = n;
                            i = a;
                        }
                        s.nextZ = null, r *= 2;
                    }while (e > 1);
                }(i);
            }(t, n, i, s);
            let o = t;
            for(; t.prev !== t.next;){
                const l = t.prev, u = t.next;
                if (s ? nl(t, n, i, s) : rl(t)) e.push(l.i, t.i, u.i), _l(t), t = u.next, o = u.next;
                else if ((t = u) === o) {
                    a ? 1 === a ? el(t = il(tl(t), e), e, r, n, i, s, 2) : 2 === a && sl(t, e, r, n, i, s) : el(tl(t), e, r, n, i, s, 1);
                    break;
                }
            }
        }
        function rl(t) {
            const e = t.prev, r = t, n = t.next;
            if (dl(e, r, n) >= 0) return !1;
            const i = e.x, s = r.x, a = n.x, o = e.y, l = r.y, u = n.y, c = Math.min(i, s, a), h = Math.min(o, l, u), p = Math.max(i, s, a), f = Math.max(o, l, u);
            let d = n.next;
            for(; d !== e;){
                if (d.x >= c && d.x <= p && d.y >= h && d.y <= f && pl(i, o, s, l, a, u, d.x, d.y) && dl(d.prev, d, d.next) >= 0) return !1;
                d = d.next;
            }
            return !0;
        }
        function nl(t, e, r, n) {
            const i = t.prev, s = t, a = t.next;
            if (dl(i, s, a) >= 0) return !1;
            const o = i.x, l = s.x, u = a.x, c = i.y, h = s.y, p = a.y, f = Math.min(o, l, u), d = Math.min(c, h, p), y = Math.max(o, l, u), m = Math.max(c, h, p), g = ul(f, d, e, r, n), x = ul(y, m, e, r, n);
            let v = t.prevZ, b = t.nextZ;
            for(; v && v.z >= g && b && b.z <= x;){
                if (v.x >= f && v.x <= y && v.y >= d && v.y <= m && v !== i && v !== a && pl(o, c, l, h, u, p, v.x, v.y) && dl(v.prev, v, v.next) >= 0) return !1;
                if (v = v.prevZ, b.x >= f && b.x <= y && b.y >= d && b.y <= m && b !== i && b !== a && pl(o, c, l, h, u, p, b.x, b.y) && dl(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            for(; v && v.z >= g;){
                if (v.x >= f && v.x <= y && v.y >= d && v.y <= m && v !== i && v !== a && pl(o, c, l, h, u, p, v.x, v.y) && dl(v.prev, v, v.next) >= 0) return !1;
                v = v.prevZ;
            }
            for(; b && b.z <= x;){
                if (b.x >= f && b.x <= y && b.y >= d && b.y <= m && b !== i && b !== a && pl(o, c, l, h, u, p, b.x, b.y) && dl(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            return !0;
        }
        function il(t, e) {
            let r = t;
            do {
                const n = r.prev, i = r.next.next;
                !yl(n, i) && ml(n, r, r.next, i) && vl(n, i) && vl(i, n) && (e.push(n.i, r.i, i.i), _l(r), _l(r.next), r = t = i), r = r.next;
            }while (r !== t);
            return tl(r);
        }
        function sl(t, e, r, n, i, s) {
            let a = t;
            do {
                let t = a.next.next;
                for(; t !== a.prev;){
                    if (a.i !== t.i && fl(a, t)) {
                        let o = bl(a, t);
                        return a = tl(a, a.next), o = tl(o, o.next), el(a, e, r, n, i, s, 0), void el(o, e, r, n, i, s, 0);
                    }
                    t = t.next;
                }
                a = a.next;
            }while (a !== t);
        }
        function al(t, e) {
            let r = t.x - e.x;
            return 0 === r && (r = t.y - e.y, 0 === r) && (r = (t.next.y - t.y) / (t.next.x - t.x) - (e.next.y - e.y) / (e.next.x - e.x)), r;
        }
        function ol(t, e) {
            const r = function(t, e) {
                let r = e;
                const n = t.x, i = t.y;
                let s, a = -1 / 0;
                if (yl(t, r)) return r;
                do {
                    if (yl(t, r.next)) return r.next;
                    if (i <= r.y && i >= r.next.y && r.next.y !== r.y) {
                        const t = r.x + (i - r.y) * (r.next.x - r.x) / (r.next.y - r.y);
                        if (t <= n && t > a && (a = t, s = r.x < r.next.x ? r : r.next, t === n)) return s;
                    }
                    r = r.next;
                }while (r !== e);
                if (!s) return null;
                const o = s, l = s.x, u = s.y;
                let c = 1 / 0;
                r = s;
                do {
                    if (n >= r.x && r.x >= l && n !== r.x && hl(i < u ? n : a, i, l, u, i < u ? a : n, i, r.x, r.y)) {
                        const e = Math.abs(i - r.y) / (n - r.x);
                        vl(r, t) && (e < c || e === c && (r.x > s.x || r.x === s.x && ll(s, r))) && (s = r, c = e);
                    }
                    r = r.next;
                }while (r !== o);
                return s;
            }(t, e);
            if (!r) return e;
            const n = bl(r, t);
            return tl(n, n.next), tl(r, r.next);
        }
        function ll(t, e) {
            return dl(t.prev, t, e.prev) < 0 && dl(e.next, t, t.next) < 0;
        }
        function ul(t, e, r, n, i) {
            return (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - r) * i | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - n) * i | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
        }
        function cl(t) {
            let e = t, r = t;
            do (e.x < r.x || e.x === r.x && e.y < r.y) && (r = e), e = e.next;
            while (e !== t);
            return r;
        }
        function hl(t, e, r, n, i, s, a, o) {
            return (i - a) * (e - o) >= (t - a) * (s - o) && (t - a) * (n - o) >= (r - a) * (e - o) && (r - a) * (s - o) >= (i - a) * (n - o);
        }
        function pl(t, e, r, n, i, s, a, o) {
            return !(t === a && e === o) && hl(t, e, r, n, i, s, a, o);
        }
        function fl(t, e) {
            return t.next.i !== e.i && t.prev.i !== e.i && !function(t, e) {
                let r = t;
                do {
                    if (r.i !== t.i && r.next.i !== t.i && r.i !== e.i && r.next.i !== e.i && ml(r, r.next, t, e)) return !0;
                    r = r.next;
                }while (r !== t);
                return !1;
            }(t, e) && (vl(t, e) && vl(e, t) && function(t, e) {
                let r = t, n = !1;
                const i = (t.x + e.x) / 2, s = (t.y + e.y) / 2;
                do r.y > s != r.next.y > s && r.next.y !== r.y && i < (r.next.x - r.x) * (s - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                while (r !== t);
                return n;
            }(t, e) && (dl(t.prev, t, e.prev) || dl(t, e.prev, e)) || yl(t, e) && dl(t.prev, t, t.next) > 0 && dl(e.prev, e, e.next) > 0);
        }
        function dl(t, e, r) {
            return (e.y - t.y) * (r.x - e.x) - (e.x - t.x) * (r.y - e.y);
        }
        function yl(t, e) {
            return t.x === e.x && t.y === e.y;
        }
        function ml(t, e, r, n) {
            const i = xl(dl(t, e, r)), s = xl(dl(t, e, n)), a = xl(dl(r, n, t)), o = xl(dl(r, n, e));
            return i !== s && a !== o || !(0 !== i || !gl(t, r, e)) || !(0 !== s || !gl(t, n, e)) || !(0 !== a || !gl(r, t, n)) || !(0 !== o || !gl(r, e, n));
        }
        function gl(t, e, r) {
            return e.x <= Math.max(t.x, r.x) && e.x >= Math.min(t.x, r.x) && e.y <= Math.max(t.y, r.y) && e.y >= Math.min(t.y, r.y);
        }
        function xl(t) {
            return t > 0 ? 1 : t < 0 ? -1 : 0;
        }
        function vl(t, e) {
            return dl(t.prev, t, t.next) < 0 ? dl(t, e, t.next) >= 0 && dl(t, t.prev, e) >= 0 : dl(t, e, t.prev) < 0 || dl(t, t.next, e) < 0;
        }
        function bl(t, e) {
            const r = Sl(t.i, t.x, t.y), n = Sl(e.i, e.x, e.y), i = t.next, s = e.prev;
            return t.next = e, e.prev = t, r.next = i, i.prev = r, n.next = r, r.prev = n, s.next = n, n.prev = s, n;
        }
        function wl(t, e, r, n) {
            const i = Sl(t, e, r);
            return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
        }
        function _l(t) {
            t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), t.nextZ && (t.nextZ.prevZ = t.prevZ);
        }
        function Sl(t, e, r) {
            return {
                i: t,
                x: e,
                y: r,
                prev: null,
                next: null,
                z: 0,
                prevZ: null,
                nextZ: null,
                steiner: !1
            };
        }
        class Al {
            constructor(t, e){
                if (e > t) throw new Error("Min granularity must not be greater than base granularity.");
                this._baseZoomGranularity = t, this._minGranularity = e;
            }
            getGranularityForZoomLevel(t) {
                return Math.max(Math.floor(this._baseZoomGranularity / (1 << t)), this._minGranularity, 1);
            }
        }
        class kl {
            constructor(t){
                this.fill = t.fill, this.line = t.line, this.tile = t.tile, this.stencil = t.stencil, this.circle = t.circle;
            }
        }
        kl.noSubdivision = new kl({
            fill: new Al(0, 0),
            line: new Al(0, 0),
            tile: new Al(0, 0),
            stencil: new Al(0, 0),
            circle: 1
        }), Zi("SubdivisionGranularityExpression", Al), Zi("SubdivisionGranularitySetting", kl);
        const Ml = -32768, Il = 32767;
        class zl {
            constructor(t, e){
                this._vertexBuffer = [], this._vertexDictionary = new Map, this._used = !1, this._granularity = t, this._granularityCellSize = M / t, this._canonical = e;
            }
            _getKey(t, e) {
                return (t += 32768) << 16 | (e += 32768) << 0;
            }
            _vertexToIndex(t, e) {
                if (t < -32768 || e < -32768 || t > 32767 || e > 32767) throw new Error("Vertex coordinates are out of signed 16 bit integer range.");
                const r = 0 | Math.round(t), n = 0 | Math.round(e), i = this._getKey(r, n);
                if (this._vertexDictionary.has(i)) return this._vertexDictionary.get(i);
                const s = this._vertexBuffer.length / 2;
                return this._vertexDictionary.set(i, s), this._vertexBuffer.push(r, n), s;
            }
            _subdivideTrianglesScanline(t) {
                if (this._granularity < 2) return function(t, e) {
                    const r = [];
                    for(let n = 0; n < e.length; n += 3){
                        const i = e[n], s = e[n + 1], a = e[n + 2], o = t[2 * i], l = t[2 * i + 1];
                        (t[2 * s] - o) * (t[2 * a + 1] - l) - (t[2 * s + 1] - l) * (t[2 * a] - o) > 0 ? (r.push(i), r.push(a), r.push(s)) : (r.push(i), r.push(s), r.push(a));
                    }
                    return r;
                }(this._vertexBuffer, t);
                const e = [], r = t.length;
                for(let n = 0; n < r; n += 3){
                    const r = [
                        t[n + 0],
                        t[n + 1],
                        t[n + 2]
                    ], i = [
                        this._vertexBuffer[2 * t[n + 0] + 0],
                        this._vertexBuffer[2 * t[n + 0] + 1],
                        this._vertexBuffer[2 * t[n + 1] + 0],
                        this._vertexBuffer[2 * t[n + 1] + 1],
                        this._vertexBuffer[2 * t[n + 2] + 0],
                        this._vertexBuffer[2 * t[n + 2] + 1]
                    ];
                    let s = 1 / 0, a = 1 / 0, o = -1 / 0, l = -1 / 0;
                    for(let t = 0; t < 3; t++){
                        const e = i[2 * t], r = i[2 * t + 1];
                        s = Math.min(s, e), o = Math.max(o, e), a = Math.min(a, r), l = Math.max(l, r);
                    }
                    if (s === o || a === l) continue;
                    const u = Math.floor(s / this._granularityCellSize), c = Math.ceil(o / this._granularityCellSize), h = Math.floor(a / this._granularityCellSize), p = Math.ceil(l / this._granularityCellSize);
                    if (u !== c || h !== p) for(let t = h; t < p; t++){
                        const n = this._scanlineGenerateVertexRingForCellRow(t, i, r);
                        Bl(this._vertexBuffer, n, e);
                    }
                    else e.push(...r);
                }
                return e;
            }
            _scanlineGenerateVertexRingForCellRow(t, e, r) {
                const n = t * this._granularityCellSize, i = n + this._granularityCellSize, s = [];
                for(let t = 0; t < 3; t++){
                    const a = e[2 * t], o = e[2 * t + 1], l = e[2 * (t + 1) % 6], u = e[(2 * (t + 1) + 1) % 6], c = e[2 * (t + 2) % 6], h = e[(2 * (t + 2) + 1) % 6], p = l - a, f = u - o, d = 0 === p, y = 0 === f, m = (n - o) / f, g = (i - o) / f, x = Math.min(m, g), v = Math.max(m, g);
                    if (!y && (x >= 1 || v <= 0) || y && (o < n || o > i)) {
                        u >= n && u <= i && s.push(r[(t + 1) % 3]);
                        continue;
                    }
                    !y && x > 0 && s.push(this._vertexToIndex(a + p * x, o + f * x));
                    const b = a + p * Math.max(x, 0), w = a + p * Math.min(v, 1);
                    d || this._generateIntraEdgeVertices(s, a, o, l, u, b, w), !y && v < 1 && s.push(this._vertexToIndex(a + p * v, o + f * v)), (y || u >= n && u <= i) && s.push(r[(t + 1) % 3]), !y && (u <= n || u >= i) && this._generateInterEdgeVertices(s, a, o, l, u, c, h, w, n, i);
                }
                return s;
            }
            _generateIntraEdgeVertices(t, e, r, n, i, s, a) {
                const o = n - e, l = i - r, u = 0 === l, c = u ? Math.min(e, n) : Math.min(s, a), h = u ? Math.max(e, n) : Math.max(s, a), p = Math.floor(c / this._granularityCellSize) + 1, f = Math.ceil(h / this._granularityCellSize) - 1;
                if (u ? e < n : s < a) for(let n = p; n <= f; n++){
                    const i = n * this._granularityCellSize;
                    t.push(this._vertexToIndex(i, r + l * (i - e) / o));
                }
                else for(let n = f; n >= p; n--){
                    const i = n * this._granularityCellSize;
                    t.push(this._vertexToIndex(i, r + l * (i - e) / o));
                }
            }
            _generateInterEdgeVertices(t, e, r, n, i, s, a, o, l, u) {
                const c = i - r, h = s - n, p = a - i, f = (l - i) / p, d = (u - i) / p, y = Math.min(f, d), m = Math.max(f, d), g = n + h * y;
                let x = Math.floor(Math.min(g, o) / this._granularityCellSize) + 1, v = Math.ceil(Math.max(g, o) / this._granularityCellSize) - 1, b = o < g;
                const w = 0 === p;
                if (w && (a === l || a === u)) return;
                if (w || y >= 1 || m <= 0) {
                    const t = r - a, n = s + (e - s) * Math.min((l - a) / t, (u - a) / t);
                    x = Math.floor(Math.min(n, o) / this._granularityCellSize) + 1, v = Math.ceil(Math.max(n, o) / this._granularityCellSize) - 1, b = o < n;
                }
                const _ = c > 0 ? u : l;
                if (b) for(let e = x; e <= v; e++)t.push(this._vertexToIndex(e * this._granularityCellSize, _));
                else for(let e = v; e >= x; e--)t.push(this._vertexToIndex(e * this._granularityCellSize, _));
            }
            _generateOutline(t) {
                const e = [];
                for (const r of t){
                    const t = Cl(r, this._granularity, !0), n = this._pointArrayToIndices(t), i = [];
                    for(let t = 1; t < n.length; t++)i.push(n[t - 1]), i.push(n[t]);
                    e.push(i);
                }
                return e;
            }
            _handlePoles(t) {
                let e = !1, r = !1;
                this._canonical && (0 === this._canonical.y && (e = !0), this._canonical.y === (1 << this._canonical.z) - 1 && (r = !0)), (e || r) && this._fillPoles(t, e, r);
            }
            _ensureNoPoleVertices() {
                const t = this._vertexBuffer;
                for(let e = 0; e < t.length; e += 2){
                    const r = t[e + 1];
                    r === Ml && (t[e + 1] = -32767), r === Il && (t[e + 1] = 32766);
                }
            }
            _generatePoleQuad(t, e, r, n, i, s) {
                n > i != (s === Ml) ? (t.push(e), t.push(r), t.push(this._vertexToIndex(n, s)), t.push(r), t.push(this._vertexToIndex(i, s)), t.push(this._vertexToIndex(n, s))) : (t.push(r), t.push(e), t.push(this._vertexToIndex(n, s)), t.push(this._vertexToIndex(i, s)), t.push(r), t.push(this._vertexToIndex(n, s)));
            }
            _fillPoles(t, e, r) {
                const n = this._vertexBuffer, i = M, s = t.length;
                for(let a = 2; a < s; a += 3){
                    const s = t[a - 2], o = t[a - 1], l = t[a], u = n[2 * s], c = n[2 * s + 1], h = n[2 * o], p = n[2 * o + 1], f = n[2 * l], d = n[2 * l + 1];
                    e && (0 === c && 0 === p && this._generatePoleQuad(t, s, o, u, h, Ml), 0 === p && 0 === d && this._generatePoleQuad(t, o, l, h, f, Ml), 0 === d && 0 === c && this._generatePoleQuad(t, l, s, f, u, Ml)), r && (c === i && p === i && this._generatePoleQuad(t, s, o, u, h, Il), p === i && d === i && this._generatePoleQuad(t, o, l, h, f, Il), d === i && c === i && this._generatePoleQuad(t, l, s, f, u, Il));
                }
            }
            _initializeVertices(t) {
                for(let e = 0; e < t.length; e += 2)this._vertexToIndex(t[e], t[e + 1]);
            }
            subdividePolygonInternal(t, e) {
                if (this._used) throw new Error("Subdivision: multiple use not allowed.");
                this._used = !0;
                const { flattened: r, holeIndices: n } = function(t) {
                    const e = [], r = [];
                    for (const n of t)if (0 !== n.length) {
                        n !== t[0] && e.push(r.length / 2);
                        for(let t = 0; t < n.length; t++)r.push(n[t].x), r.push(n[t].y);
                    }
                    return {
                        flattened: r,
                        holeIndices: e
                    };
                }(t);
                let i;
                this._initializeVertices(r);
                try {
                    const t = function(t, e, r = 2) {
                        const n = e && e.length, i = n ? e[0] * r : t.length;
                        let s = Qo(t, 0, i, r, !0);
                        const a = [];
                        if (!s || s.next === s.prev) return a;
                        let o, l, u;
                        if (n && (s = function(t, e, r, n) {
                            const i = [];
                            for(let r = 0, s = e.length; r < s; r++){
                                const a = Qo(t, e[r] * n, r < s - 1 ? e[r + 1] * n : t.length, n, !1);
                                a === a.next && (a.steiner = !0), i.push(cl(a));
                            }
                            i.sort(al);
                            for(let t = 0; t < i.length; t++)r = ol(i[t], r);
                            return r;
                        }(t, e, s, r)), t.length > 80 * r) {
                            o = 1 / 0, l = 1 / 0;
                            let e = -1 / 0, n = -1 / 0;
                            for(let s = r; s < i; s += r){
                                const r = t[s], i = t[s + 1];
                                r < o && (o = r), i < l && (l = i), r > e && (e = r), i > n && (n = i);
                            }
                            u = Math.max(e - o, n - l), u = 0 !== u ? 32767 / u : 0;
                        }
                        return el(s, a, r, o, l, u, 0), a;
                    }(r, n), e = this._convertIndices(r, t);
                    i = this._subdivideTrianglesScanline(e);
                } catch (t) {
                    console.error(t);
                }
                let s = [];
                return e && (s = this._generateOutline(t)), this._ensureNoPoleVertices(), this._handlePoles(i), {
                    verticesFlattened: this._vertexBuffer,
                    indicesTriangles: i,
                    indicesLineList: s
                };
            }
            _convertIndices(t, e) {
                const r = [];
                for(let n = 0; n < e.length; n++)r.push(this._vertexToIndex(t[2 * e[n]], t[2 * e[n] + 1]));
                return r;
            }
            _pointArrayToIndices(t) {
                const e = [];
                for(let r = 0; r < t.length; r++){
                    const n = t[r];
                    e.push(this._vertexToIndex(n.x, n.y));
                }
                return e;
            }
        }
        function Pl(t, e, r, n = !0) {
            return new zl(r, e).subdividePolygonInternal(t, n);
        }
        function Cl(t, e, r = !1) {
            if (!t || t.length < 1) return [];
            if (t.length < 2) return [];
            const n = t[0], i = t[t.length - 1], s = r && (n.x !== i.x || n.y !== i.y);
            if (e < 2) return s ? [
                ...t,
                t[0]
            ] : [
                ...t
            ];
            const a = Math.floor(M / e), o = [];
            o.push(new l(t[0].x, t[0].y));
            const u = t.length, c = s ? u : u - 1;
            for(let e = 0; e < c; e++){
                const r = t[e], n = e < u - 1 ? t[e + 1] : t[0], i = r.x, s = r.y, c = n.x, h = n.y, p = i !== c, f = s !== h;
                if (!p && !f) continue;
                const d = c - i, y = h - s, m = Math.abs(d), g = Math.abs(y);
                let x = i, v = s;
                for(;;){
                    const t = d > 0 ? (Math.floor(x / a) + 1) * a : (Math.ceil(x / a) - 1) * a, e = y > 0 ? (Math.floor(v / a) + 1) * a : (Math.ceil(v / a) - 1) * a, r = Math.abs(x - t), n = Math.abs(v - e), i = Math.abs(x - c), s = Math.abs(v - h), u = p ? r / m : Number.POSITIVE_INFINITY, b = f ? n / g : Number.POSITIVE_INFINITY;
                    if ((i <= r || !p) && (s <= n || !f)) break;
                    if (u < b && p || !f) {
                        x = t, v += y * u;
                        const e = new l(x, Math.round(v));
                        o[o.length - 1].x === e.x && o[o.length - 1].y === e.y || o.push(e);
                    } else {
                        x += d * b, v = e;
                        const t = new l(Math.round(x), v);
                        o[o.length - 1].x === t.x && o[o.length - 1].y === t.y || o.push(t);
                    }
                }
                const b = new l(c, h);
                o[o.length - 1].x === b.x && o[o.length - 1].y === b.y || o.push(b);
            }
            return o;
        }
        function Bl(t, e, r) {
            if (0 === e.length) throw new Error("Subdivision vertex ring is empty.");
            let n = 0, i = t[2 * e[0]];
            for(let r = 1; r < e.length; r++){
                const s = t[2 * e[r]];
                s < i && (i = s, n = r);
            }
            const s = e.length;
            let a = n, o = (a + 1) % s;
            for(;;){
                const n = a - 1 >= 0 ? a - 1 : s - 1, i = (o + 1) % s, l = t[2 * e[n]], u = t[2 * e[i]], c = t[2 * e[a]], h = t[2 * e[a] + 1], p = t[2 * e[o] + 1];
                let f = !1;
                if (l < u) f = !0;
                else if (l > u) f = !1;
                else {
                    const r = p - h, s = -(t[2 * e[o]] - c), a = h < p ? 1 : -1;
                    ((l - c) * r + (t[2 * e[n] + 1] - h) * s) * a > ((u - c) * r + (t[2 * e[i] + 1] - h) * s) * a && (f = !0);
                }
                if (f) {
                    const t = e[n], i = e[a], l = e[o];
                    t !== i && t !== l && i !== l && r.push(l, i, t), a--, a < 0 && (a = s - 1);
                } else {
                    const t = e[i], n = e[a], l = e[o];
                    t !== n && t !== l && n !== l && r.push(l, n, t), o++, o >= s && (o = 0);
                }
                if (n === i) break;
            }
        }
        function Vl(t, e, r, n, i, s, a, o, l) {
            const u = i.length / 2, c = a && o && l;
            if (u < Va.MAX_VERTEX_ARRAY_LENGTH) {
                const h = e.prepareSegment(u, r, n), p = h.vertexLength;
                for(let t = 0; t < s.length; t += 3)n.emplaceBack(p + s[t], p + s[t + 1], p + s[t + 2]);
                let f, d;
                h.vertexLength += u, h.primitiveLength += s.length / 3, c && (d = a.prepareSegment(u, r, o), f = d.vertexLength, d.vertexLength += u);
                for(let e = 0; e < i.length; e += 2)t(i[e], i[e + 1]);
                if (c) for(let t = 0; t < l.length; t++){
                    const e = l[t];
                    for(let t = 1; t < e.length; t += 2)o.emplaceBack(f + e[t - 1], f + e[t]);
                    d.primitiveLength += e.length / 2;
                }
            } else !function(t, e, r, n, i, s) {
                const a = [];
                for(let t = 0; t < n.length / 2; t++)a.push(-1);
                const o = {
                    count: 0
                };
                let l = 0, u = t.getOrCreateLatestSegment(e, r), c = u.vertexLength;
                for(let h = 2; h < i.length; h += 3){
                    const p = i[h - 2], f = i[h - 1], d = i[h];
                    let y = a[p] < l, m = a[f] < l, g = a[d] < l;
                    u.vertexLength + ((y ? 1 : 0) + (m ? 1 : 0) + (g ? 1 : 0)) > Va.MAX_VERTEX_ARRAY_LENGTH && (u = t.createNewSegment(e, r), l = o.count, y = !0, m = !0, g = !0, c = 0);
                    const x = El(a, n, s, o, p, y, u), v = El(a, n, s, o, f, m, u), b = El(a, n, s, o, d, g, u);
                    r.emplaceBack(c + x - l, c + v - l, c + b - l), u.primitiveLength++;
                }
            }(e, r, n, i, s, t), c && function(t, e, r, n, i, s) {
                const a = [];
                for(let t = 0; t < n.length / 2; t++)a.push(-1);
                const o = {
                    count: 0
                };
                let l = 0, u = t.getOrCreateLatestSegment(e, r), c = u.vertexLength;
                for(let h = 0; h < i.length; h++){
                    const p = i[h];
                    for(let f = 1; f < i[h].length; f += 2){
                        const i = p[f - 1], h = p[f];
                        let d = a[i] < l, y = a[h] < l;
                        u.vertexLength + ((d ? 1 : 0) + (y ? 1 : 0)) > Va.MAX_VERTEX_ARRAY_LENGTH && (u = t.createNewSegment(e, r), l = o.count, d = !0, y = !0, c = 0);
                        const m = El(a, n, s, o, i, d, u), g = El(a, n, s, o, h, y, u);
                        r.emplaceBack(c + m - l, c + g - l), u.primitiveLength++;
                    }
                }
            }(a, r, o, i, l, t), e.forceNewSegmentOnNextPrepare(), null == a || a.forceNewSegmentOnNextPrepare();
        }
        function El(t, e, r, n, i, s, a) {
            if (s) {
                const s = n.count;
                return r(e[2 * i], e[2 * i + 1]), t[i] = n.count, n.count++, a.vertexLength++, s;
            }
            return t[i];
        }
        class Tl {
            constructor(t){
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = t.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new xa, this.indexArray = new za, this.indexArray2 = new Pa, this.programConfigurations = new so(t.layers, t.zoom), this.segments = new Va, this.segments2 = new Va, this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id);
            }
            populate(t, e, r) {
                this.hasPattern = Jo("fill", this.layers, e);
                const n = this.layers[0].layout.get("fill-sort-key"), i = !n.isConstant(), s = [];
                for (const { feature: a, id: o, index: l, sourceLayerIndex: u } of t){
                    const t = this.layers[0]._featureFilter.needGeometry, c = ho(a, t);
                    if (!this.layers[0]._featureFilter.filter(new fs(this.zoom), c, r)) continue;
                    const h = i ? n.evaluate(c, {}, r, e.availableImages) : void 0, p = {
                        id: o,
                        properties: a.properties,
                        type: a.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: t ? c.geometry : co(a),
                        patterns: {},
                        sortKey: h
                    };
                    s.push(p);
                }
                i && s.sort((t, e)=>t.sortKey - e.sortKey);
                for (const n of s){
                    const { geometry: i, index: s, sourceLayerIndex: a } = n;
                    if (this.hasPattern) {
                        const t = Wo("fill", this.layers, n, this.zoom, e);
                        this.patternFeatures.push(t);
                    } else this.addFeature(n, i, s, r, {}, e.subdivisionGranularity);
                    e.featureIndex.insert(t[s].feature, i, s, a, this.index);
                }
            }
            update(t, e, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e, this.stateDependentLayers, r);
            }
            addFeatures(t, e, r) {
                for (const n of this.patternFeatures)this.addFeature(n, n.geometry, n.index, e, r, t.subdivisionGranularity);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t) {
                this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, Yo), this.indexBuffer = t.createIndexBuffer(this.indexArray), this.indexBuffer2 = t.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
            }
            addFeature(t, e, r, n, i, s) {
                for (const t of Ur(e, 500)){
                    const e = Pl(t, n, s.fill.getGranularityForZoomLevel(n.z)), r = this.layoutVertexArray;
                    Vl((t, e)=>{
                        r.emplaceBack(t, e);
                    }, this.segments, this.layoutVertexArray, this.indexArray, e.verticesFlattened, e.indicesTriangles, this.segments2, this.indexArray2, e.indicesLineList);
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, i, n);
            }
        }
        let Fl, $l;
        Zi("FillBucket", Tl, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        var Ll = {
            get paint () {
                return $l = $l || new Is({
                    "fill-antialias": new _s(dt.paint_fill["fill-antialias"]),
                    "fill-opacity": new Ss(dt.paint_fill["fill-opacity"]),
                    "fill-color": new Ss(dt.paint_fill["fill-color"]),
                    "fill-outline-color": new Ss(dt.paint_fill["fill-outline-color"]),
                    "fill-translate": new _s(dt.paint_fill["fill-translate"]),
                    "fill-translate-anchor": new _s(dt.paint_fill["fill-translate-anchor"]),
                    "fill-pattern": new As(dt.paint_fill["fill-pattern"])
                });
            },
            get layout () {
                return Fl = Fl || new Is({
                    "fill-sort-key": new Ss(dt.layout_fill["fill-sort-key"])
                });
            }
        };
        class Ol extends Ps {
            constructor(t){
                super(t, Ll);
            }
            recalculate(t, e) {
                super.recalculate(t, e);
                const r = this.paint._values["fill-outline-color"];
                "constant" === r.value.kind && void 0 === r.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
            }
            createBucket(t) {
                return new Tl(t);
            }
            queryRadius() {
                return zo(this.paint.get("fill-translate"));
            }
            queryIntersectsFeature({ queryGeometry: t, geometry: e, transform: r, pixelsToTileUnits: n }) {
                return xo(Po(t, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), -r.bearingInRadians, n), e);
            }
            isTileClipped() {
                return !0;
            }
        }
        const Dl = Es([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_normal_ed",
                components: 4,
                type: "Int16"
            }
        ], 4), Rl = Es([
            {
                name: "a_centroid",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: jl } = Dl;
        var Nl, Ul, ql, Gl, Zl, Kl, Xl, Hl = {};
        function Yl() {
            if (Ul) return Nl;
            Ul = 1;
            var t = s();
            function e(t, e, n, i, s) {
                this.properties = {}, this.extent = n, this.type = 0, this._pbf = t, this._geometry = -1, this._keys = i, this._values = s, t.readFields(r, this, e);
            }
            function r(t, e, r) {
                1 == t ? e.id = r.readVarint() : 2 == t ? function(t, e) {
                    for(var r = t.readVarint() + t.pos; t.pos < r;){
                        var n = e._keys[t.readVarint()], i = e._values[t.readVarint()];
                        e.properties[n] = i;
                    }
                }(r, e) : 3 == t ? e.type = r.readVarint() : 4 == t && (e._geometry = r.pos);
            }
            function n(t) {
                for(var e, r, n = 0, i = 0, s = t.length, a = s - 1; i < s; a = i++)n += ((r = t[a]).x - (e = t[i]).x) * (e.y + r.y);
                return n;
            }
            return Nl = e, e.types = [
                "Unknown",
                "Point",
                "LineString",
                "Polygon"
            ], e.prototype.loadGeometry = function() {
                var e = this._pbf;
                e.pos = this._geometry;
                for(var r, n = e.readVarint() + e.pos, i = 1, s = 0, a = 0, o = 0, l = []; e.pos < n;){
                    if (s <= 0) {
                        var u = e.readVarint();
                        i = 7 & u, s = u >> 3;
                    }
                    if (s--, 1 === i || 2 === i) a += e.readSVarint(), o += e.readSVarint(), 1 === i && (r && l.push(r), r = []), r.push(new t(a, o));
                    else {
                        if (7 !== i) throw new Error("unknown command " + i);
                        r && r.push(r[0].clone());
                    }
                }
                return r && l.push(r), l;
            }, e.prototype.bbox = function() {
                var t = this._pbf;
                t.pos = this._geometry;
                for(var e = t.readVarint() + t.pos, r = 1, n = 0, i = 0, s = 0, a = 1 / 0, o = -1 / 0, l = 1 / 0, u = -1 / 0; t.pos < e;){
                    if (n <= 0) {
                        var c = t.readVarint();
                        r = 7 & c, n = c >> 3;
                    }
                    if (n--, 1 === r || 2 === r) (i += t.readSVarint()) < a && (a = i), i > o && (o = i), (s += t.readSVarint()) < l && (l = s), s > u && (u = s);
                    else if (7 !== r) throw new Error("unknown command " + r);
                }
                return [
                    a,
                    l,
                    o,
                    u
                ];
            }, e.prototype.toGeoJSON = function(t, r, i) {
                var s, a, o = this.extent * Math.pow(2, i), l = this.extent * t, u = this.extent * r, c = this.loadGeometry(), h = e.types[this.type];
                function p(t) {
                    for(var e = 0; e < t.length; e++){
                        var r = t[e];
                        t[e] = [
                            360 * (r.x + l) / o - 180,
                            360 / Math.PI * Math.atan(Math.exp((180 - 360 * (r.y + u) / o) * Math.PI / 180)) - 90
                        ];
                    }
                }
                switch(this.type){
                    case 1:
                        var f = [];
                        for(s = 0; s < c.length; s++)f[s] = c[s][0];
                        p(c = f);
                        break;
                    case 2:
                        for(s = 0; s < c.length; s++)p(c[s]);
                        break;
                    case 3:
                        for(c = function(t) {
                            var e = t.length;
                            if (e <= 1) return [
                                t
                            ];
                            for(var r, i, s = [], a = 0; a < e; a++){
                                var o = n(t[a]);
                                0 !== o && (void 0 === i && (i = o < 0), i === o < 0 ? (r && s.push(r), r = [
                                    t[a]
                                ]) : r.push(t[a]));
                            }
                            return r && s.push(r), s;
                        }(c), s = 0; s < c.length; s++)for(a = 0; a < c[s].length; a++)p(c[s][a]);
                }
                1 === c.length ? c = c[0] : h = "Multi" + h;
                var d = {
                    type: "Feature",
                    geometry: {
                        type: h,
                        coordinates: c
                    },
                    properties: this.properties
                };
                return "id" in this && (d.id = this.id), d;
            }, Nl;
        }
        function Jl() {
            if (Gl) return ql;
            Gl = 1;
            var t = Yl();
            function e(t, e) {
                this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t, this._keys = [], this._values = [], this._features = [], t.readFields(r, this, e), this.length = this._features.length;
            }
            function r(t, e, r) {
                15 === t ? e.version = r.readVarint() : 1 === t ? e.name = r.readString() : 5 === t ? e.extent = r.readVarint() : 2 === t ? e._features.push(r.pos) : 3 === t ? e._keys.push(r.readString()) : 4 === t && e._values.push(function(t) {
                    for(var e = null, r = t.readVarint() + t.pos; t.pos < r;){
                        var n = t.readVarint() >> 3;
                        e = 1 === n ? t.readString() : 2 === n ? t.readFloat() : 3 === n ? t.readDouble() : 4 === n ? t.readVarint64() : 5 === n ? t.readVarint() : 6 === n ? t.readSVarint() : 7 === n ? t.readBoolean() : null;
                    }
                    return e;
                }(r));
            }
            return ql = e, e.prototype.feature = function(e) {
                if (e < 0 || e >= this._features.length) throw new Error("feature index out of bounds");
                this._pbf.pos = this._features[e];
                var r = this._pbf.readVarint() + this._pbf.pos;
                return new t(this._pbf, r, this.extent, this._keys, this._values);
            }, ql;
        }
        function Wl() {
            return Xl || (Xl = 1, Hl.VectorTile = function() {
                if (Kl) return Zl;
                Kl = 1;
                var t = Jl();
                function e(e, r, n) {
                    if (3 === e) {
                        var i = new t(n, n.readVarint() + n.pos);
                        i.length && (r[i.name] = i);
                    }
                }
                return Zl = function(t, r) {
                    this.layers = t.readFields(e, {}, r);
                }, Zl;
            }(), Hl.VectorTileFeature = Yl(), Hl.VectorTileLayer = Jl()), Hl;
        }
        var Ql = r(Wl());
        const tu = Ql.VectorTileFeature.types, eu = Math.pow(2, 13);
        function ru(t, e, r, n, i, s, a, o) {
            t.emplaceBack(e, r, 2 * Math.floor(n * eu) + a, i * eu * 2, s * eu * 2, Math.round(o));
        }
        class nu {
            constructor(t){
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = t.index, this.hasPattern = !1, this.layoutVertexArray = new va, this.centroidVertexArray = new ma, this.indexArray = new za, this.programConfigurations = new so(t.layers, t.zoom), this.segments = new Va, this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id);
            }
            populate(t, e, r) {
                this.features = [], this.hasPattern = Jo("fill-extrusion", this.layers, e);
                for (const { feature: n, id: i, index: s, sourceLayerIndex: a } of t){
                    const t = this.layers[0]._featureFilter.needGeometry, o = ho(n, t);
                    if (!this.layers[0]._featureFilter.filter(new fs(this.zoom), o, r)) continue;
                    const l = {
                        id: i,
                        sourceLayerIndex: a,
                        index: s,
                        geometry: t ? o.geometry : co(n),
                        properties: n.properties,
                        type: n.type,
                        patterns: {}
                    };
                    this.hasPattern ? this.features.push(Wo("fill-extrusion", this.layers, l, this.zoom, e)) : this.addFeature(l, l.geometry, s, r, {}, e.subdivisionGranularity), e.featureIndex.insert(n, l.geometry, s, a, this.index, !0);
                }
            }
            addFeatures(t, e, r) {
                for (const n of this.features){
                    const { geometry: i } = n;
                    this.addFeature(n, i, n.index, e, r, t.subdivisionGranularity);
                }
            }
            update(t, e, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e, this.stateDependentLayers, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.centroidVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t) {
                this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, jl), this.centroidVertexBuffer = t.createVertexBuffer(this.centroidVertexArray, Rl.members, !0), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.centroidVertexBuffer.destroy());
            }
            addFeature(t, e, r, n, i, s) {
                for (const r of Ur(e, 500)){
                    const e = {
                        x: 0,
                        y: 0,
                        sampleCount: 0
                    }, i = this.layoutVertexArray.length;
                    this.processPolygon(e, n, t, r, s);
                    const a = this.layoutVertexArray.length - i, o = Math.floor(e.x / e.sampleCount), l = Math.floor(e.y / e.sampleCount);
                    for(let t = 0; t < a; t++)this.centroidVertexArray.emplaceBack(o, l);
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, i, n);
            }
            processPolygon(t, e, r, n, i) {
                if (n.length < 1) return;
                if (au(n[0])) return;
                for (const e of n)0 !== e.length && iu(t, e);
                const s = {
                    segment: this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray)
                }, a = i.fill.getGranularityForZoomLevel(e.z), o = "Polygon" === tu[r.type];
                for (const t of n){
                    if (0 === t.length) continue;
                    if (au(t)) continue;
                    const e = Cl(t, a, o);
                    this._generateSideFaces(e, s);
                }
                if (!o) return;
                const l = Pl(n, e, a, !1), u = this.layoutVertexArray;
                Vl((t, e)=>{
                    ru(u, t, e, 0, 0, 1, 1, 0);
                }, this.segments, this.layoutVertexArray, this.indexArray, l.verticesFlattened, l.indicesTriangles);
            }
            _generateSideFaces(t, e) {
                let r = 0;
                for(let n = 1; n < t.length; n++){
                    const i = t[n], s = t[n - 1];
                    if (su(i, s)) continue;
                    e.segment.vertexLength + 4 > Va.MAX_VERTEX_ARRAY_LENGTH && (e.segment = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                    const a = i.sub(s)._perp()._unit(), o = s.dist(i);
                    r + o > 32768 && (r = 0), ru(this.layoutVertexArray, i.x, i.y, a.x, a.y, 0, 0, r), ru(this.layoutVertexArray, i.x, i.y, a.x, a.y, 0, 1, r), r += o, ru(this.layoutVertexArray, s.x, s.y, a.x, a.y, 0, 0, r), ru(this.layoutVertexArray, s.x, s.y, a.x, a.y, 0, 1, r);
                    const l = e.segment.vertexLength;
                    this.indexArray.emplaceBack(l, l + 2, l + 1), this.indexArray.emplaceBack(l + 1, l + 2, l + 3), e.segment.vertexLength += 4, e.segment.primitiveLength += 2;
                }
            }
        }
        function iu(t, e) {
            for(let r = 0; r < e.length; r++){
                const n = e[r];
                r === e.length - 1 && e[0].x === n.x && e[0].y === n.y || (t.x += n.x, t.y += n.y, t.sampleCount++);
            }
        }
        function su(t, e) {
            return t.x === e.x && (t.x < 0 || t.x > M) || t.y === e.y && (t.y < 0 || t.y > M);
        }
        function au(t) {
            return t.every((t)=>t.x < 0) || t.every((t)=>t.x > M) || t.every((t)=>t.y < 0) || t.every((t)=>t.y > M);
        }
        let ou;
        Zi("FillExtrusionBucket", nu, {
            omit: [
                "layers",
                "features"
            ]
        });
        var lu = {
            get paint () {
                return ou = ou || new Is({
                    "fill-extrusion-opacity": new _s(dt["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                    "fill-extrusion-color": new Ss(dt["paint_fill-extrusion"]["fill-extrusion-color"]),
                    "fill-extrusion-translate": new _s(dt["paint_fill-extrusion"]["fill-extrusion-translate"]),
                    "fill-extrusion-translate-anchor": new _s(dt["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                    "fill-extrusion-pattern": new As(dt["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                    "fill-extrusion-height": new Ss(dt["paint_fill-extrusion"]["fill-extrusion-height"]),
                    "fill-extrusion-base": new Ss(dt["paint_fill-extrusion"]["fill-extrusion-base"]),
                    "fill-extrusion-vertical-gradient": new _s(dt["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
                });
            }
        };
        class uu extends Ps {
            constructor(t){
                super(t, lu);
            }
            createBucket(t) {
                return new nu(t);
            }
            queryRadius() {
                return zo(this.paint.get("fill-extrusion-translate"));
            }
            is3D() {
                return !0;
            }
            queryIntersectsFeature({ queryGeometry: t, feature: e, featureState: r, geometry: n, transform: i, pixelsToTileUnits: s, pixelPosMatrix: a }) {
                const o = Po(t, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), -i.bearingInRadians, s), u = this.paint.get("fill-extrusion-height").evaluate(e, r), c = this.paint.get("fill-extrusion-base").evaluate(e, r), h = function(t, e, r) {
                    const n = [];
                    for (const r of t){
                        const t = [
                            r.x,
                            r.y,
                            0,
                            1
                        ];
                        _(t, t, e), n.push(new l(t[0] / t[3], t[1] / t[3]));
                    }
                    return n;
                }(o, a), p = function(t, e, r, n) {
                    const i = [], s = [], a = n[8] * e, o = n[9] * e, u = n[10] * e, c = n[11] * e, h = n[8] * r, p = n[9] * r, f = n[10] * r, d = n[11] * r;
                    for (const e of t){
                        const t = [], r = [];
                        for (const i of e){
                            const e = i.x, s = i.y, y = n[0] * e + n[4] * s + n[12], m = n[1] * e + n[5] * s + n[13], g = n[2] * e + n[6] * s + n[14], x = n[3] * e + n[7] * s + n[15], v = g + u, b = x + c, w = y + h, _ = m + p, S = g + f, A = x + d, k = new l((y + a) / b, (m + o) / b);
                            k.z = v / b, t.push(k);
                            const M = new l(w / A, _ / A);
                            M.z = S / A, r.push(M);
                        }
                        i.push(t), s.push(r);
                    }
                    return [
                        i,
                        s
                    ];
                }(n, c, u, a);
                return function(t, e, r) {
                    let n = 1 / 0;
                    xo(r, e) && (n = hu(r, e[0]));
                    for(let i = 0; i < e.length; i++){
                        const s = e[i], a = t[i];
                        for(let t = 0; t < s.length - 1; t++){
                            const e = s[t], i = [
                                e,
                                s[t + 1],
                                a[t + 1],
                                a[t],
                                e
                            ];
                            mo(r, i) && (n = Math.min(n, hu(r, i)));
                        }
                    }
                    return n !== 1 / 0 && n;
                }(p[0], p[1], h);
            }
        }
        function cu(t, e) {
            return t.x * e.x + t.y * e.y;
        }
        function hu(t, e) {
            if (1 === t.length) {
                let r = 0;
                const n = e[r++];
                let i;
                for(; !i || n.equals(i);)if (i = e[r++], !i) return 1 / 0;
                for(; r < e.length; r++){
                    const s = e[r], a = t[0], o = i.sub(n), l = s.sub(n), u = a.sub(n), c = cu(o, o), h = cu(o, l), p = cu(l, l), f = cu(u, o), d = cu(u, l), y = c * p - h * h, m = (p * f - h * d) / y, g = (c * d - h * f) / y, x = n.z * (1 - m - g) + i.z * m + s.z * g;
                    if (isFinite(x)) return x;
                }
                return 1 / 0;
            }
            {
                let t = 1 / 0;
                for (const r of e)t = Math.min(t, r.z);
                return t;
            }
        }
        const pu = Es([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            }
        ], 4), { members: fu } = pu, du = Es([
            {
                name: "a_uv_x",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_split_index",
                components: 1,
                type: "Float32"
            }
        ]), { members: yu } = du, mu = Ql.VectorTileFeature.types, gu = Math.cos(Math.PI / 180 * 37.5), xu = Math.pow(2, 14) / .5;
        class vu {
            constructor(t){
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = t.index, this.hasPattern = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((t)=>{
                    this.gradients[t.id] = {};
                }), this.layoutVertexArray = new ba, this.layoutVertexArray2 = new wa, this.indexArray = new za, this.programConfigurations = new so(t.layers, t.zoom), this.segments = new Va, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id);
            }
            populate(t, e, r) {
                this.hasPattern = Jo("line", this.layers, e);
                const n = this.layers[0].layout.get("line-sort-key"), i = !n.isConstant(), s = [];
                for (const { feature: e, id: a, index: o, sourceLayerIndex: l } of t){
                    const t = this.layers[0]._featureFilter.needGeometry, u = ho(e, t);
                    if (!this.layers[0]._featureFilter.filter(new fs(this.zoom), u, r)) continue;
                    const c = i ? n.evaluate(u, {}, r) : void 0, h = {
                        id: a,
                        properties: e.properties,
                        type: e.type,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: t ? u.geometry : co(e),
                        patterns: {},
                        sortKey: c
                    };
                    s.push(h);
                }
                i && s.sort((t, e)=>t.sortKey - e.sortKey);
                for (const n of s){
                    const { geometry: i, index: s, sourceLayerIndex: a } = n;
                    if (this.hasPattern) {
                        const t = Wo("line", this.layers, n, this.zoom, e);
                        this.patternFeatures.push(t);
                    } else this.addFeature(n, i, s, r, {}, e.subdivisionGranularity);
                    e.featureIndex.insert(t[s].feature, i, s, a, this.index);
                }
            }
            update(t, e, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e, this.stateDependentLayers, r);
            }
            addFeatures(t, e, r) {
                for (const n of this.patternFeatures)this.addFeature(n, n.geometry, n.index, e, r, t.subdivisionGranularity);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t) {
                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t.createVertexBuffer(this.layoutVertexArray2, yu)), this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, fu), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            lineFeatureClips(t) {
                if (t.properties && Object.prototype.hasOwnProperty.call(t.properties, "mapbox_clip_start") && Object.prototype.hasOwnProperty.call(t.properties, "mapbox_clip_end")) return {
                    start: +t.properties.mapbox_clip_start,
                    end: +t.properties.mapbox_clip_end
                };
            }
            addFeature(t, e, r, n, i, s) {
                const a = this.layers[0].layout, o = a.get("line-join").evaluate(t, {}), l = a.get("line-cap"), u = a.get("line-miter-limit"), c = a.get("line-round-limit");
                this.lineClips = this.lineFeatureClips(t);
                for (const r of e)this.addLine(r, t, o, l, u, c, n, s);
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, i, n);
            }
            addLine(t, e, r, n, i, s, a, o) {
                if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, t = Cl(t, a ? o.line.getGranularityForZoomLevel(a.z) : 1), this.lineClips) {
                    this.lineClipsArray.push(this.lineClips);
                    for(let e = 0; e < t.length - 1; e++)this.totalDistance += t[e].dist(t[e + 1]);
                    this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                }
                const l = "Polygon" === mu[e.type];
                let u = t.length;
                for(; u >= 2 && t[u - 1].equals(t[u - 2]);)u--;
                let c = 0;
                for(; c < u - 1 && t[c].equals(t[c + 1]);)c++;
                if (u < (l ? 3 : 2)) return;
                "bevel" === r && (i = 1.05);
                const h = this.overscaling <= 16 ? 15 * M / (512 * this.overscaling) : 0, p = this.segments.prepareSegment(10 * u, this.layoutVertexArray, this.indexArray);
                let f, d, y, m, g;
                this.e1 = this.e2 = -1, l && (f = t[u - 2], g = t[c].sub(f)._unit()._perp());
                for(let e = c; e < u; e++){
                    if (y = e === u - 1 ? l ? t[c + 1] : void 0 : t[e + 1], y && t[e].equals(y)) continue;
                    g && (m = g), f && (d = f), f = t[e], g = y ? y.sub(f)._unit()._perp() : m, m = m || g;
                    let a = m.add(g);
                    0 === a.x && 0 === a.y || a._unit();
                    const o = m.x * g.x + m.y * g.y, x = a.x * g.x + a.y * g.y, v = 0 !== x ? 1 / x : 1 / 0, b = 2 * Math.sqrt(2 - 2 * x), w = x < gu && d && y, _ = m.x * g.y - m.y * g.x > 0;
                    if (w && e > c) {
                        const t = f.dist(d);
                        if (t > 2 * h) {
                            const e = f.sub(f.sub(d)._mult(h / t)._round());
                            this.updateDistance(d, e), this.addCurrentVertex(e, m, 0, 0, p), d = e;
                        }
                    }
                    const S = d && y;
                    let A = S ? r : l ? "butt" : n;
                    if (S && "round" === A && (v < s ? A = "miter" : v <= 2 && (A = "fakeround")), "miter" === A && v > i && (A = "bevel"), "bevel" === A && (v > 2 && (A = "flipbevel"), v < i && (A = "miter")), d && this.updateDistance(d, f), "miter" === A) a._mult(v), this.addCurrentVertex(f, a, 0, 0, p);
                    else if ("flipbevel" === A) {
                        if (v > 100) a = g.mult(-1);
                        else {
                            const t = v * m.add(g).mag() / m.sub(g).mag();
                            a._perp()._mult(t * (_ ? -1 : 1));
                        }
                        this.addCurrentVertex(f, a, 0, 0, p), this.addCurrentVertex(f, a.mult(-1), 0, 0, p);
                    } else if ("bevel" === A || "fakeround" === A) {
                        const t = -Math.sqrt(v * v - 1), e = _ ? t : 0, r = _ ? 0 : t;
                        if (d && this.addCurrentVertex(f, m, e, r, p), "fakeround" === A) {
                            const t = Math.round(180 * b / Math.PI / 20);
                            for(let e = 1; e < t; e++){
                                let r = e / t;
                                if (.5 !== r) {
                                    const t = r - .5;
                                    r += r * t * (r - 1) * ((1.0904 + o * (o * (3.55645 - 1.43519 * o) - 3.2452)) * t * t + (.848013 + o * (.215638 * o - 1.06021)));
                                }
                                const n = g.sub(m)._mult(r)._add(m)._unit()._mult(_ ? -1 : 1);
                                this.addHalfVertex(f, n.x, n.y, !1, _, 0, p);
                            }
                        }
                        y && this.addCurrentVertex(f, g, -e, -r, p);
                    } else if ("butt" === A) this.addCurrentVertex(f, a, 0, 0, p);
                    else if ("square" === A) {
                        const t = d ? 1 : -1;
                        this.addCurrentVertex(f, a, t, t, p);
                    } else "round" === A && (d && (this.addCurrentVertex(f, m, 0, 0, p), this.addCurrentVertex(f, m, 1, 1, p, !0)), y && (this.addCurrentVertex(f, g, -1, -1, p, !0), this.addCurrentVertex(f, g, 0, 0, p)));
                    if (w && e < u - 1) {
                        const t = f.dist(y);
                        if (t > 2 * h) {
                            const e = f.add(y.sub(f)._mult(h / t)._round());
                            this.updateDistance(f, e), this.addCurrentVertex(e, g, 0, 0, p), f = e;
                        }
                    }
                }
            }
            addCurrentVertex(t, e, r, n, i, s = !1) {
                const a = e.y * n - e.x, o = -e.y - e.x * n;
                this.addHalfVertex(t, e.x + e.y * r, e.y - e.x * r, s, !1, r, i), this.addHalfVertex(t, a, o, s, !0, -n, i), this.distance > xu / 2 && 0 === this.totalDistance && (this.distance = 0, this.updateScaledDistance(), this.addCurrentVertex(t, e, r, n, i, s));
            }
            addHalfVertex({ x: t, y: e }, r, n, i, s, a, o) {
                const l = .5 * (this.lineClips ? this.scaledDistance * (xu - 1) : this.scaledDistance);
                this.layoutVertexArray.emplaceBack((t << 1) + (i ? 1 : 0), (e << 1) + (s ? 1 : 0), Math.round(63 * r) + 128, Math.round(63 * n) + 128, 1 + (0 === a ? 0 : a < 0 ? -1 : 1) | (63 & l) << 2, l >> 6), this.lineClips && this.layoutVertexArray2.emplaceBack((this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start), this.lineClipsArray.length);
                const u = o.vertexLength++;
                this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, u, this.e2), o.primitiveLength++), s ? this.e2 = u : this.e1 = u;
            }
            updateScaledDistance() {
                this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
            }
            updateDistance(t, e) {
                this.distance += t.dist(e), this.updateScaledDistance();
            }
        }
        let bu, wu;
        Zi("LineBucket", vu, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        var _u = {
            get paint () {
                return wu = wu || new Is({
                    "line-opacity": new Ss(dt.paint_line["line-opacity"]),
                    "line-color": new Ss(dt.paint_line["line-color"]),
                    "line-translate": new _s(dt.paint_line["line-translate"]),
                    "line-translate-anchor": new _s(dt.paint_line["line-translate-anchor"]),
                    "line-width": new Ss(dt.paint_line["line-width"]),
                    "line-gap-width": new Ss(dt.paint_line["line-gap-width"]),
                    "line-offset": new Ss(dt.paint_line["line-offset"]),
                    "line-blur": new Ss(dt.paint_line["line-blur"]),
                    "line-dasharray": new ks(dt.paint_line["line-dasharray"]),
                    "line-pattern": new As(dt.paint_line["line-pattern"]),
                    "line-gradient": new Ms(dt.paint_line["line-gradient"])
                });
            },
            get layout () {
                return bu = bu || new Is({
                    "line-cap": new _s(dt.layout_line["line-cap"]),
                    "line-join": new Ss(dt.layout_line["line-join"]),
                    "line-miter-limit": new _s(dt.layout_line["line-miter-limit"]),
                    "line-round-limit": new _s(dt.layout_line["line-round-limit"]),
                    "line-sort-key": new Ss(dt.layout_line["line-sort-key"])
                });
            }
        };
        class Su extends Ss {
            possiblyEvaluate(t, e) {
                return e = new fs(Math.floor(e.zoom), {
                    now: e.now,
                    fadeDuration: e.fadeDuration,
                    zoomHistory: e.zoomHistory,
                    transition: e.transition
                }), super.possiblyEvaluate(t, e);
            }
            evaluate(t, e, r, n) {
                return e = F({}, e, {
                    zoom: Math.floor(e.zoom)
                }), super.evaluate(t, e, r, n);
            }
        }
        let Au;
        class ku extends Ps {
            constructor(t){
                super(t, _u), this.gradientVersion = 0, Au || (Au = new Su(_u.paint.properties["line-width"].specification), Au.useIntegerZoom = !0);
            }
            _handleSpecialPaintPropertyUpdate(t) {
                if ("line-gradient" === t) {
                    const t = this.gradientExpression();
                    this.stepInterpolant = !!function(t) {
                        return void 0 !== t._styleExpression;
                    }(t) && t._styleExpression.expression instanceof Ye, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                }
            }
            gradientExpression() {
                return this._transitionablePaint._values["line-gradient"].value.expression;
            }
            recalculate(t, e) {
                super.recalculate(t, e), this.paint._values["line-floorwidth"] = Au.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, t);
            }
            createBucket(t) {
                return new vu(t);
            }
            queryRadius(t) {
                const e = t, r = Mu(Io("line-width", this, e), Io("line-gap-width", this, e)), n = Io("line-offset", this, e);
                return r / 2 + Math.abs(n) + zo(this.paint.get("line-translate"));
            }
            queryIntersectsFeature({ queryGeometry: t, feature: e, featureState: r, geometry: n, transform: i, pixelsToTileUnits: s }) {
                const a = Po(t, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), -i.bearingInRadians, s), o = s / 2 * Mu(this.paint.get("line-width").evaluate(e, r), this.paint.get("line-gap-width").evaluate(e, r)), u = this.paint.get("line-offset").evaluate(e, r);
                return u && (n = function(t, e) {
                    const r = [];
                    for(let n = 0; n < t.length; n++){
                        const i = t[n], s = [];
                        for(let t = 0; t < i.length; t++){
                            const r = i[t - 1], n = i[t], a = i[t + 1], o = 0 === t ? new l(0, 0) : n.sub(r)._unit()._perp(), u = t === i.length - 1 ? new l(0, 0) : a.sub(n)._unit()._perp(), c = o._add(u)._unit(), h = c.x * u.x + c.y * u.y;
                            0 !== h && c._mult(1 / h), s.push(c._mult(e)._add(n));
                        }
                        r.push(s);
                    }
                    return r;
                }(n, u * s)), function(t, e, r) {
                    for(let n = 0; n < e.length; n++){
                        const i = e[n];
                        if (t.length >= 3) {
                            for(let e = 0; e < i.length; e++)if (ko(t, i[e])) return !0;
                        }
                        if (vo(t, i, r)) return !0;
                    }
                    return !1;
                }(a, n, o);
            }
            isTileClipped() {
                return !0;
            }
        }
        function Mu(t, e) {
            return e > 0 ? e + 2 * t : t;
        }
        const Iu = Es([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), zu = Es([
            {
                name: "a_projected_pos",
                components: 3,
                type: "Float32"
            }
        ], 4);
        Es([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4);
        const Pu = Es([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_box_real",
                components: 2,
                type: "Int16"
            }
        ]);
        Es([
            {
                type: "Int16",
                name: "anchorPointX"
            },
            {
                type: "Int16",
                name: "anchorPointY"
            },
            {
                type: "Int16",
                name: "x1"
            },
            {
                type: "Int16",
                name: "y1"
            },
            {
                type: "Int16",
                name: "x2"
            },
            {
                type: "Int16",
                name: "y2"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]);
        const Cu = Es([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4), Bu = Es([
            {
                name: "a_pos",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        function Vu(t, e, r) {
            return t.sections.forEach((t)=>{
                t.text = function(t, e, r) {
                    const n = e.layout.get("text-transform").evaluate(r, {});
                    return "uppercase" === n ? t = t.toLocaleUpperCase() : "lowercase" === n && (t = t.toLocaleLowerCase()), ps.applyArabicShaping && (t = ps.applyArabicShaping(t)), t;
                }(t.text, e, r);
            }), t;
        }
        Es([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), Es([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            }
        ]), Es([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                name: "textBoxScale"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            },
            {
                type: "Uint16",
                name: "textAnchorOffsetStartIndex"
            },
            {
                type: "Uint16",
                name: "textAnchorOffsetEndIndex"
            }
        ]), Es([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), Es([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            },
            {
                type: "Int16",
                name: "tileUnitDistanceFromAnchor"
            }
        ]), Es([
            {
                type: "Uint16",
                name: "textAnchor"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            }
        ]);
        const Eu = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42"
        };
        var Tu, Fu, $u, Lu = 24, Ou = {};
        function Du() {
            return Tu || (Tu = 1, Ou.read = function(t, e, r, n, i) {
                var s, a, o = 8 * i - n - 1, l = (1 << o) - 1, u = l >> 1, c = -7, h = r ? i - 1 : 0, p = r ? -1 : 1, f = t[e + h];
                for(h += p, s = f & (1 << -c) - 1, f >>= -c, c += o; c > 0; s = 256 * s + t[e + h], h += p, c -= 8);
                for(a = s & (1 << -c) - 1, s >>= -c, c += n; c > 0; a = 256 * a + t[e + h], h += p, c -= 8);
                if (0 === s) s = 1 - u;
                else {
                    if (s === l) return a ? NaN : 1 / 0 * (f ? -1 : 1);
                    a += Math.pow(2, n), s -= u;
                }
                return (f ? -1 : 1) * a * Math.pow(2, s - n);
            }, Ou.write = function(t, e, r, n, i, s) {
                var a, o, l, u = 8 * s - i - 1, c = (1 << u) - 1, h = c >> 1, p = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = n ? 0 : s - 1, d = n ? 1 : -1, y = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;
                for(e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (o = isNaN(e) ? 1 : 0, a = c) : (a = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -a)) < 1 && (a--, l *= 2), (e += a + h >= 1 ? p / l : p * Math.pow(2, 1 - h)) * l >= 2 && (a++, l /= 2), a + h >= c ? (o = 0, a = c) : a + h >= 1 ? (o = (e * l - 1) * Math.pow(2, i), a += h) : (o = e * Math.pow(2, h - 1) * Math.pow(2, i), a = 0)); i >= 8; t[r + f] = 255 & o, f += d, o /= 256, i -= 8);
                for(a = a << i | o, u += i; u > 0; t[r + f] = 255 & a, f += d, a /= 256, u -= 8);
                t[r + f - d] |= 128 * y;
            }), Ou;
        }
        function Ru() {
            if ($u) return Fu;
            $u = 1, Fu = e;
            var t = Du();
            function e(t) {
                this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t) ? t : new Uint8Array(t || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
            }
            e.Varint = 0, e.Fixed64 = 1, e.Bytes = 2, e.Fixed32 = 5;
            var r = 4294967296, n = 1 / r, i = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
            function s(t) {
                return t.type === e.Bytes ? t.readVarint() + t.pos : t.pos + 1;
            }
            function a(t, e, r) {
                return r ? 4294967296 * e + (t >>> 0) : 4294967296 * (e >>> 0) + (t >>> 0);
            }
            function o(t, e, r) {
                var n = e <= 16383 ? 1 : e <= 2097151 ? 2 : e <= 268435455 ? 3 : Math.floor(Math.log(e) / (7 * Math.LN2));
                r.realloc(n);
                for(var i = r.pos - 1; i >= t; i--)r.buf[i + n] = r.buf[i];
            }
            function l(t, e) {
                for(var r = 0; r < t.length; r++)e.writeVarint(t[r]);
            }
            function u(t, e) {
                for(var r = 0; r < t.length; r++)e.writeSVarint(t[r]);
            }
            function c(t, e) {
                for(var r = 0; r < t.length; r++)e.writeFloat(t[r]);
            }
            function h(t, e) {
                for(var r = 0; r < t.length; r++)e.writeDouble(t[r]);
            }
            function p(t, e) {
                for(var r = 0; r < t.length; r++)e.writeBoolean(t[r]);
            }
            function f(t, e) {
                for(var r = 0; r < t.length; r++)e.writeFixed32(t[r]);
            }
            function d(t, e) {
                for(var r = 0; r < t.length; r++)e.writeSFixed32(t[r]);
            }
            function y(t, e) {
                for(var r = 0; r < t.length; r++)e.writeFixed64(t[r]);
            }
            function m(t, e) {
                for(var r = 0; r < t.length; r++)e.writeSFixed64(t[r]);
            }
            function g(t, e) {
                return (t[e] | t[e + 1] << 8 | t[e + 2] << 16) + 16777216 * t[e + 3];
            }
            function x(t, e, r) {
                t[r] = e, t[r + 1] = e >>> 8, t[r + 2] = e >>> 16, t[r + 3] = e >>> 24;
            }
            function v(t, e) {
                return (t[e] | t[e + 1] << 8 | t[e + 2] << 16) + (t[e + 3] << 24);
            }
            return e.prototype = {
                destroy: function() {
                    this.buf = null;
                },
                readFields: function(t, e, r) {
                    for(r = r || this.length; this.pos < r;){
                        var n = this.readVarint(), i = n >> 3, s = this.pos;
                        this.type = 7 & n, t(i, e, this), this.pos === s && this.skip(n);
                    }
                    return e;
                },
                readMessage: function(t, e) {
                    return this.readFields(t, e, this.readVarint() + this.pos);
                },
                readFixed32: function() {
                    var t = g(this.buf, this.pos);
                    return this.pos += 4, t;
                },
                readSFixed32: function() {
                    var t = v(this.buf, this.pos);
                    return this.pos += 4, t;
                },
                readFixed64: function() {
                    var t = g(this.buf, this.pos) + g(this.buf, this.pos + 4) * r;
                    return this.pos += 8, t;
                },
                readSFixed64: function() {
                    var t = g(this.buf, this.pos) + v(this.buf, this.pos + 4) * r;
                    return this.pos += 8, t;
                },
                readFloat: function() {
                    var e = t.read(this.buf, this.pos, !0, 23, 4);
                    return this.pos += 4, e;
                },
                readDouble: function() {
                    var e = t.read(this.buf, this.pos, !0, 52, 8);
                    return this.pos += 8, e;
                },
                readVarint: function(t) {
                    var e, r, n = this.buf;
                    return e = 127 & (r = n[this.pos++]), r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 7, r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 14, r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 21, r < 128 ? e : function(t, e, r) {
                        var n, i, s = r.buf;
                        if (n = (112 & (i = s[r.pos++])) >> 4, i < 128) return a(t, n, e);
                        if (n |= (127 & (i = s[r.pos++])) << 3, i < 128) return a(t, n, e);
                        if (n |= (127 & (i = s[r.pos++])) << 10, i < 128) return a(t, n, e);
                        if (n |= (127 & (i = s[r.pos++])) << 17, i < 128) return a(t, n, e);
                        if (n |= (127 & (i = s[r.pos++])) << 24, i < 128) return a(t, n, e);
                        if (n |= (1 & (i = s[r.pos++])) << 31, i < 128) return a(t, n, e);
                        throw new Error("Expected varint not more than 10 bytes");
                    }(e |= (15 & (r = n[this.pos])) << 28, t, this))));
                },
                readVarint64: function() {
                    return this.readVarint(!0);
                },
                readSVarint: function() {
                    var t = this.readVarint();
                    return t % 2 == 1 ? (t + 1) / -2 : t / 2;
                },
                readBoolean: function() {
                    return Boolean(this.readVarint());
                },
                readString: function() {
                    var t = this.readVarint() + this.pos, e = this.pos;
                    return this.pos = t, t - e >= 12 && i ? function(t, e, r) {
                        return i.decode(t.subarray(e, r));
                    }(this.buf, e, t) : function(t, e, r) {
                        for(var n = "", i = e; i < r;){
                            var s, a, o, l = t[i], u = null, c = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                            if (i + c > r) break;
                            1 === c ? l < 128 && (u = l) : 2 === c ? 128 == (192 & (s = t[i + 1])) && (u = (31 & l) << 6 | 63 & s) <= 127 && (u = null) : 3 === c ? (a = t[i + 2], 128 == (192 & (s = t[i + 1])) && 128 == (192 & a) && ((u = (15 & l) << 12 | (63 & s) << 6 | 63 & a) <= 2047 || u >= 55296 && u <= 57343) && (u = null)) : 4 === c && (a = t[i + 2], o = t[i + 3], 128 == (192 & (s = t[i + 1])) && 128 == (192 & a) && 128 == (192 & o) && ((u = (15 & l) << 18 | (63 & s) << 12 | (63 & a) << 6 | 63 & o) <= 65535 || u >= 1114112) && (u = null)), null === u ? (u = 65533, c = 1) : u > 65535 && (u -= 65536, n += String.fromCharCode(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n += String.fromCharCode(u), i += c;
                        }
                        return n;
                    }(this.buf, e, t);
                },
                readBytes: function() {
                    var t = this.readVarint() + this.pos, e = this.buf.subarray(this.pos, t);
                    return this.pos = t, e;
                },
                readPackedVarint: function(t, r) {
                    if (this.type !== e.Bytes) return t.push(this.readVarint(r));
                    var n = s(this);
                    for(t = t || []; this.pos < n;)t.push(this.readVarint(r));
                    return t;
                },
                readPackedSVarint: function(t) {
                    if (this.type !== e.Bytes) return t.push(this.readSVarint());
                    var r = s(this);
                    for(t = t || []; this.pos < r;)t.push(this.readSVarint());
                    return t;
                },
                readPackedBoolean: function(t) {
                    if (this.type !== e.Bytes) return t.push(this.readBoolean());
                    var r = s(this);
                    for(t = t || []; this.pos < r;)t.push(this.readBoolean());
                    return t;
                },
                readPackedFloat: function(t) {
                    if (this.type !== e.Bytes) return t.push(this.readFloat());
                    var r = s(this);
                    for(t = t || []; this.pos < r;)t.push(this.readFloat());
                    return t;
                },
                readPackedDouble: function(t) {
                    if (this.type !== e.Bytes) return t.push(this.readDouble());
                    var r = s(this);
                    for(t = t || []; this.pos < r;)t.push(this.readDouble());
                    return t;
                },
                readPackedFixed32: function(t) {
                    if (this.type !== e.Bytes) return t.push(this.readFixed32());
                    var r = s(this);
                    for(t = t || []; this.pos < r;)t.push(this.readFixed32());
                    return t;
                },
                readPackedSFixed32: function(t) {
                    if (this.type !== e.Bytes) return t.push(this.readSFixed32());
                    var r = s(this);
                    for(t = t || []; this.pos < r;)t.push(this.readSFixed32());
                    return t;
                },
                readPackedFixed64: function(t) {
                    if (this.type !== e.Bytes) return t.push(this.readFixed64());
                    var r = s(this);
                    for(t = t || []; this.pos < r;)t.push(this.readFixed64());
                    return t;
                },
                readPackedSFixed64: function(t) {
                    if (this.type !== e.Bytes) return t.push(this.readSFixed64());
                    var r = s(this);
                    for(t = t || []; this.pos < r;)t.push(this.readSFixed64());
                    return t;
                },
                skip: function(t) {
                    var r = 7 & t;
                    if (r === e.Varint) for(; this.buf[this.pos++] > 127;);
                    else if (r === e.Bytes) this.pos = this.readVarint() + this.pos;
                    else if (r === e.Fixed32) this.pos += 4;
                    else {
                        if (r !== e.Fixed64) throw new Error("Unimplemented type: " + r);
                        this.pos += 8;
                    }
                },
                writeTag: function(t, e) {
                    this.writeVarint(t << 3 | e);
                },
                realloc: function(t) {
                    for(var e = this.length || 16; e < this.pos + t;)e *= 2;
                    if (e !== this.length) {
                        var r = new Uint8Array(e);
                        r.set(this.buf), this.buf = r, this.length = e;
                    }
                },
                finish: function() {
                    return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
                },
                writeFixed32: function(t) {
                    this.realloc(4), x(this.buf, t, this.pos), this.pos += 4;
                },
                writeSFixed32: function(t) {
                    this.realloc(4), x(this.buf, t, this.pos), this.pos += 4;
                },
                writeFixed64: function(t) {
                    this.realloc(8), x(this.buf, -1 & t, this.pos), x(this.buf, Math.floor(t * n), this.pos + 4), this.pos += 8;
                },
                writeSFixed64: function(t) {
                    this.realloc(8), x(this.buf, -1 & t, this.pos), x(this.buf, Math.floor(t * n), this.pos + 4), this.pos += 8;
                },
                writeVarint: function(t) {
                    (t = +t || 0) > 268435455 || t < 0 ? function(t, e) {
                        var r, n;
                        if (t >= 0 ? (r = t % 4294967296 | 0, n = t / 4294967296 | 0) : (n = ~(-t / 4294967296), 4294967295 ^ (r = ~(-t % 4294967296)) ? r = r + 1 | 0 : (r = 0, n = n + 1 | 0)), t >= 0x10000000000000000 || t < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                        e.realloc(10), function(t, e, r) {
                            r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos++] = 127 & t | 128, r.buf[r.pos] = 127 & (t >>>= 7);
                        }(r, 0, e), function(t, e) {
                            var r = (7 & t) << 4;
                            e.buf[e.pos++] |= r | ((t >>>= 3) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t)))));
                        }(n, e);
                    }(t, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = 127 & (t >>>= 7) | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = 127 & (t >>>= 7) | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = t >>> 7 & 127))));
                },
                writeSVarint: function(t) {
                    this.writeVarint(t < 0 ? 2 * -t - 1 : 2 * t);
                },
                writeBoolean: function(t) {
                    this.writeVarint(Boolean(t));
                },
                writeString: function(t) {
                    t = String(t), this.realloc(4 * t.length), this.pos++;
                    var e = this.pos;
                    this.pos = function(t, e, r) {
                        for(var n, i, s = 0; s < e.length; s++){
                            if ((n = e.charCodeAt(s)) > 55295 && n < 57344) {
                                if (!i) {
                                    n > 56319 || s + 1 === e.length ? (t[r++] = 239, t[r++] = 191, t[r++] = 189) : i = n;
                                    continue;
                                }
                                if (n < 56320) {
                                    t[r++] = 239, t[r++] = 191, t[r++] = 189, i = n;
                                    continue;
                                }
                                n = i - 55296 << 10 | n - 56320 | 65536, i = null;
                            } else i && (t[r++] = 239, t[r++] = 191, t[r++] = 189, i = null);
                            n < 128 ? t[r++] = n : (n < 2048 ? t[r++] = n >> 6 | 192 : (n < 65536 ? t[r++] = n >> 12 | 224 : (t[r++] = n >> 18 | 240, t[r++] = n >> 12 & 63 | 128), t[r++] = n >> 6 & 63 | 128), t[r++] = 63 & n | 128);
                        }
                        return r;
                    }(this.buf, t, this.pos);
                    var r = this.pos - e;
                    r >= 128 && o(e, r, this), this.pos = e - 1, this.writeVarint(r), this.pos += r;
                },
                writeFloat: function(e) {
                    this.realloc(4), t.write(this.buf, e, this.pos, !0, 23, 4), this.pos += 4;
                },
                writeDouble: function(e) {
                    this.realloc(8), t.write(this.buf, e, this.pos, !0, 52, 8), this.pos += 8;
                },
                writeBytes: function(t) {
                    var e = t.length;
                    this.writeVarint(e), this.realloc(e);
                    for(var r = 0; r < e; r++)this.buf[this.pos++] = t[r];
                },
                writeRawMessage: function(t, e) {
                    this.pos++;
                    var r = this.pos;
                    t(e, this);
                    var n = this.pos - r;
                    n >= 128 && o(r, n, this), this.pos = r - 1, this.writeVarint(n), this.pos += n;
                },
                writeMessage: function(t, r, n) {
                    this.writeTag(t, e.Bytes), this.writeRawMessage(r, n);
                },
                writePackedVarint: function(t, e) {
                    e.length && this.writeMessage(t, l, e);
                },
                writePackedSVarint: function(t, e) {
                    e.length && this.writeMessage(t, u, e);
                },
                writePackedBoolean: function(t, e) {
                    e.length && this.writeMessage(t, p, e);
                },
                writePackedFloat: function(t, e) {
                    e.length && this.writeMessage(t, c, e);
                },
                writePackedDouble: function(t, e) {
                    e.length && this.writeMessage(t, h, e);
                },
                writePackedFixed32: function(t, e) {
                    e.length && this.writeMessage(t, f, e);
                },
                writePackedSFixed32: function(t, e) {
                    e.length && this.writeMessage(t, d, e);
                },
                writePackedFixed64: function(t, e) {
                    e.length && this.writeMessage(t, y, e);
                },
                writePackedSFixed64: function(t, e) {
                    e.length && this.writeMessage(t, m, e);
                },
                writeBytesField: function(t, r) {
                    this.writeTag(t, e.Bytes), this.writeBytes(r);
                },
                writeFixed32Field: function(t, r) {
                    this.writeTag(t, e.Fixed32), this.writeFixed32(r);
                },
                writeSFixed32Field: function(t, r) {
                    this.writeTag(t, e.Fixed32), this.writeSFixed32(r);
                },
                writeFixed64Field: function(t, r) {
                    this.writeTag(t, e.Fixed64), this.writeFixed64(r);
                },
                writeSFixed64Field: function(t, r) {
                    this.writeTag(t, e.Fixed64), this.writeSFixed64(r);
                },
                writeVarintField: function(t, r) {
                    this.writeTag(t, e.Varint), this.writeVarint(r);
                },
                writeSVarintField: function(t, r) {
                    this.writeTag(t, e.Varint), this.writeSVarint(r);
                },
                writeStringField: function(t, r) {
                    this.writeTag(t, e.Bytes), this.writeString(r);
                },
                writeFloatField: function(t, r) {
                    this.writeTag(t, e.Fixed32), this.writeFloat(r);
                },
                writeDoubleField: function(t, r) {
                    this.writeTag(t, e.Fixed64), this.writeDouble(r);
                },
                writeBooleanField: function(t, e) {
                    this.writeVarintField(t, Boolean(e));
                }
            }, Fu;
        }
        var ju = r(Ru());
        const Nu = 3;
        function Uu(t, e, r) {
            1 === t && r.readMessage(qu, e);
        }
        function qu(t, e, r) {
            if (3 === t) {
                const { id: t, bitmap: n, width: i, height: s, left: a, top: o, advance: l } = r.readMessage(Gu, {});
                e.push({
                    id: t,
                    bitmap: new jo({
                        width: i + 2 * Nu,
                        height: s + 2 * Nu
                    }, n),
                    metrics: {
                        width: i,
                        height: s,
                        left: a,
                        top: o,
                        advance: l
                    }
                });
            }
        }
        function Gu(t, e, r) {
            1 === t ? e.id = r.readVarint() : 2 === t ? e.bitmap = r.readBytes() : 3 === t ? e.width = r.readVarint() : 4 === t ? e.height = r.readVarint() : 5 === t ? e.left = r.readSVarint() : 6 === t ? e.top = r.readSVarint() : 7 === t && (e.advance = r.readVarint());
        }
        const Zu = Nu;
        function Ku(t) {
            let e = 0, r = 0;
            for (const n of t)e += n.w * n.h, r = Math.max(r, n.w);
            t.sort((t, e)=>e.h - t.h);
            const n = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(e / .95)), r),
                    h: 1 / 0
                }
            ];
            let i = 0, s = 0;
            for (const e of t)for(let t = n.length - 1; t >= 0; t--){
                const r = n[t];
                if (!(e.w > r.w || e.h > r.h)) {
                    if (e.x = r.x, e.y = r.y, s = Math.max(s, e.y + e.h), i = Math.max(i, e.x + e.w), e.w === r.w && e.h === r.h) {
                        const e = n.pop();
                        t < n.length && (n[t] = e);
                    } else e.h === r.h ? (r.x += e.w, r.w -= e.w) : e.w === r.w ? (r.y += e.h, r.h -= e.h) : (n.push({
                        x: r.x + e.w,
                        y: r.y,
                        w: r.w - e.w,
                        h: e.h
                    }), r.y += e.h, r.h -= e.h);
                    break;
                }
            }
            return {
                w: i,
                h: s,
                fill: e / (i * s) || 0
            };
        }
        const Xu = 1;
        class Hu {
            constructor(t, { pixelRatio: e, version: r, stretchX: n, stretchY: i, content: s, textFitWidth: a, textFitHeight: o }){
                this.paddedRect = t, this.pixelRatio = e, this.stretchX = n, this.stretchY = i, this.content = s, this.version = r, this.textFitWidth = a, this.textFitHeight = o;
            }
            get tl() {
                return [
                    this.paddedRect.x + Xu,
                    this.paddedRect.y + Xu
                ];
            }
            get br() {
                return [
                    this.paddedRect.x + this.paddedRect.w - Xu,
                    this.paddedRect.y + this.paddedRect.h - Xu
                ];
            }
            get tlbr() {
                return this.tl.concat(this.br);
            }
            get displaySize() {
                return [
                    (this.paddedRect.w - 2 * Xu) / this.pixelRatio,
                    (this.paddedRect.h - 2 * Xu) / this.pixelRatio
                ];
            }
        }
        class Yu {
            constructor(t, e){
                const r = {}, n = {};
                this.haveRenderCallbacks = [];
                const i = [];
                this.addImages(t, r, i), this.addImages(e, n, i);
                const { w: s, h: a } = Ku(i), o = new No({
                    width: s || 1,
                    height: a || 1
                });
                for(const e in t){
                    const n = t[e], i = r[e].paddedRect;
                    No.copy(n.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: i.x + Xu,
                        y: i.y + Xu
                    }, n.data);
                }
                for(const t in e){
                    const r = e[t], i = n[t].paddedRect, s = i.x + Xu, a = i.y + Xu, l = r.data.width, u = r.data.height;
                    No.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: a
                    }, r.data), No.copy(r.data, o, {
                        x: 0,
                        y: u - 1
                    }, {
                        x: s,
                        y: a - 1
                    }, {
                        width: l,
                        height: 1
                    }), No.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: a + u
                    }, {
                        width: l,
                        height: 1
                    }), No.copy(r.data, o, {
                        x: l - 1,
                        y: 0
                    }, {
                        x: s - 1,
                        y: a
                    }, {
                        width: 1,
                        height: u
                    }), No.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: s + l,
                        y: a
                    }, {
                        width: 1,
                        height: u
                    });
                }
                this.image = o, this.iconPositions = r, this.patternPositions = n;
            }
            addImages(t, e, r) {
                for(const n in t){
                    const i = t[n], s = {
                        x: 0,
                        y: 0,
                        w: i.data.width + 2 * Xu,
                        h: i.data.height + 2 * Xu
                    };
                    r.push(s), e[n] = new Hu(s, i), i.hasRenderCallback && this.haveRenderCallbacks.push(n);
                }
            }
            patchUpdatedImages(t, e) {
                t.dispatchRenderCallbacks(this.haveRenderCallbacks);
                for(const r in t.updatedImages)this.patchUpdatedImage(this.iconPositions[r], t.getImage(r), e), this.patchUpdatedImage(this.patternPositions[r], t.getImage(r), e);
            }
            patchUpdatedImage(t, e, r) {
                if (!t || !e) return;
                if (t.version === e.version) return;
                t.version = e.version;
                const [n, i] = t.tl;
                r.update(e.data, void 0, {
                    x: n,
                    y: i
                });
            }
        }
        var Ju;
        Zi("ImagePosition", Hu), Zi("ImageAtlas", Yu), t.ah = void 0, (Ju = t.ah || (t.ah = {}))[Ju.none = 0] = "none", Ju[Ju.horizontal = 1] = "horizontal", Ju[Ju.vertical = 2] = "vertical", Ju[Ju.horizontalOnly = 3] = "horizontalOnly";
        const Wu = -17;
        class Qu {
            constructor(){
                this.scale = 1, this.fontStack = "", this.imageName = null, this.verticalAlign = "bottom";
            }
            static forText(t, e, r) {
                const n = new Qu;
                return n.scale = t || 1, n.fontStack = e, n.verticalAlign = r || "bottom", n;
            }
            static forImage(t, e) {
                const r = new Qu;
                return r.imageName = t, r.verticalAlign = e || "bottom", r;
            }
        }
        class tc {
            constructor(){
                this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
            }
            static fromFeature(t, e) {
                const r = new tc;
                for(let n = 0; n < t.sections.length; n++){
                    const i = t.sections[n];
                    i.image ? r.addImageSection(i) : r.addTextSection(i, e);
                }
                return r;
            }
            length() {
                return this.text.length;
            }
            getSection(t) {
                return this.sections[this.sectionIndex[t]];
            }
            getSectionIndex(t) {
                return this.sectionIndex[t];
            }
            getCharCode(t) {
                return this.text.charCodeAt(t);
            }
            verticalizePunctuation() {
                this.text = function(t) {
                    let e = "";
                    for(let r = 0; r < t.length; r++){
                        const n = t.charCodeAt(r + 1) || null, i = t.charCodeAt(r - 1) || null;
                        e += n && os(n) && !Eu[t[r + 1]] || i && os(i) && !Eu[t[r - 1]] || !Eu[t[r]] ? t[r] : Eu[t[r]];
                    }
                    return e;
                }(this.text);
            }
            trim() {
                let t = 0;
                for(let e = 0; e < this.text.length && rc[this.text.charCodeAt(e)]; e++)t++;
                let e = this.text.length;
                for(let r = this.text.length - 1; r >= 0 && r >= t && rc[this.text.charCodeAt(r)]; r--)e--;
                this.text = this.text.substring(t, e), this.sectionIndex = this.sectionIndex.slice(t, e);
            }
            substring(t, e) {
                const r = new tc;
                return r.text = this.text.substring(t, e), r.sectionIndex = this.sectionIndex.slice(t, e), r.sections = this.sections, r;
            }
            toString() {
                return this.text;
            }
            getMaxScale() {
                return this.sectionIndex.reduce((t, e)=>Math.max(t, this.sections[e].scale), 0);
            }
            getMaxImageSize(t) {
                let e = 0, r = 0;
                for(let n = 0; n < this.length(); n++){
                    const i = this.getSection(n);
                    if (i.imageName) {
                        const n = t[i.imageName];
                        if (!n) continue;
                        const s = n.displaySize;
                        e = Math.max(e, s[0]), r = Math.max(r, s[1]);
                    }
                }
                return {
                    maxImageWidth: e,
                    maxImageHeight: r
                };
            }
            addTextSection(t, e) {
                this.text += t.text, this.sections.push(Qu.forText(t.scale, t.fontStack || e, t.verticalAlign));
                const r = this.sections.length - 1;
                for(let e = 0; e < t.text.length; ++e)this.sectionIndex.push(r);
            }
            addImageSection(t) {
                const e = t.image ? t.image.name : "";
                if (0 === e.length) return void j("Can't add FormattedSection with an empty image.");
                const r = this.getNextImageSectionCharCode();
                r ? (this.text += String.fromCharCode(r), this.sections.push(Qu.forImage(e, t.verticalAlign)), this.sectionIndex.push(this.sections.length - 1)) : j("Reached maximum number of images 6401");
            }
            getNextImageSectionCharCode() {
                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
            }
        }
        function ec(e, r, n, i, s, a, o, l, u, c, h, p, f, d, y) {
            const m = tc.fromFeature(e, s);
            let g;
            p === t.ah.vertical && m.verticalizePunctuation();
            const { processBidirectionalText: x, processStyledBidirectionalText: v } = ps;
            if (x && 1 === m.sections.length) {
                g = [];
                const t = x(m.toString(), cc(m, c, a, r, i, d));
                for (const e of t){
                    const t = new tc;
                    t.text = e, t.sections = m.sections;
                    for(let r = 0; r < e.length; r++)t.sectionIndex.push(0);
                    g.push(t);
                }
            } else if (v) {
                g = [];
                const t = v(m.text, m.sectionIndex, cc(m, c, a, r, i, d));
                for (const e of t){
                    const t = new tc;
                    t.text = e[0], t.sectionIndex = e[1], t.sections = m.sections, g.push(t);
                }
            } else g = function(t, e) {
                const r = [], n = t.text;
                let i = 0;
                for (const n of e)r.push(t.substring(i, n)), i = n;
                return i < n.length && r.push(t.substring(i, n.length)), r;
            }(m, cc(m, c, a, r, i, d));
            const b = [], w = {
                positionedLines: b,
                text: m.toString(),
                top: h[1],
                bottom: h[1],
                left: h[0],
                right: h[0],
                writingMode: p,
                iconsInText: !1,
                verticalizable: !1
            };
            return function(t, e, r, n, i, s, a, o, l, u, c, h) {
                let p = 0, f = 0, d = 0, y = 0;
                const m = "right" === o ? 1 : "left" === o ? 0 : .5, g = Lu / h;
                let x = 0;
                for (const a of i){
                    a.trim();
                    const i = a.getMaxScale(), o = {
                        positionedGlyphs: [],
                        lineOffset: 0
                    };
                    t.positionedLines[x] = o;
                    const h = o.positionedGlyphs;
                    let v = 0;
                    if (!a.length()) {
                        f += s, ++x;
                        continue;
                    }
                    const b = pc(n, a, g);
                    for(let s = 0; s < a.length(); s++){
                        const o = a.getSection(s), d = a.getSectionIndex(s), y = a.getCharCode(s), m = dc(l, c, y);
                        let x;
                        if (o.imageName) {
                            if (t.iconsInText = !0, o.scale = o.scale * g, x = mc(o, m, i, b, n), !x) continue;
                            v = Math.max(v, x.imageOffset);
                        } else if (x = yc(o, y, m, b, e, r), !x) continue;
                        const { rect: w, metrics: _, baselineOffset: S } = x;
                        h.push({
                            glyph: y,
                            imageName: o.imageName,
                            x: p,
                            y: f + S + Wu,
                            vertical: m,
                            scale: o.scale,
                            fontStack: o.fontStack,
                            sectionIndex: d,
                            metrics: _,
                            rect: w
                        }), m ? (t.verticalizable = !0, p += (o.imageName ? _.advance : Lu) * o.scale + u) : p += _.advance * o.scale + u;
                    }
                    0 !== h.length && (d = Math.max(p - u, d), gc(h, 0, h.length - 1, m)), p = 0, o.lineOffset = Math.max(v, (i - 1) * Lu);
                    const w = s * i + v;
                    f += w, y = Math.max(w, y), ++x;
                }
                const { horizontalAlign: v, verticalAlign: b } = hc(a);
                (function(t, e, r, n, i, s, a, o, l) {
                    const u = (e - r) * i;
                    let c = 0;
                    c = s !== a ? -o * n - Wu : -n * l * a + .5 * a;
                    for (const e of t)for (const t of e.positionedGlyphs)t.x += u, t.y += c;
                })(t.positionedLines, m, v, b, d, y, s, f, i.length), t.top += -b * f, t.bottom = t.top + f, t.left += -v * d, t.right = t.left + d;
            }(w, r, n, i, g, o, l, u, p, c, f, y), !function(t) {
                for (const e of t)if (0 !== e.positionedGlyphs.length) return !1;
                return !0;
            }(b) && w;
        }
        const rc = {
            9: !0,
            10: !0,
            11: !0,
            12: !0,
            13: !0,
            32: !0
        }, nc = {
            10: !0,
            32: !0,
            38: !0,
            41: !0,
            43: !0,
            45: !0,
            47: !0,
            173: !0,
            183: !0,
            8203: !0,
            8208: !0,
            8211: !0,
            8231: !0
        }, ic = {
            40: !0
        };
        function sc(t, e, r, n, i, s) {
            if (e.imageName) {
                const t = n[e.imageName];
                return t ? t.displaySize[0] * e.scale * Lu / s + i : 0;
            }
            {
                const n = r[e.fontStack], s = n && n[t];
                return s ? s.metrics.advance * e.scale + i : 0;
            }
        }
        function ac(t, e, r, n) {
            const i = Math.pow(t - e, 2);
            return n ? t < e ? i / 2 : 2 * i : i + Math.abs(r) * r;
        }
        function oc(t, e, r) {
            let n = 0;
            return 10 === t && (n -= 1e4), r && (n += 150), 40 !== t && 65288 !== t || (n += 50), 41 !== e && 65289 !== e || (n += 50), n;
        }
        function lc(t, e, r, n, i, s) {
            let a = null, o = ac(e, r, i, s);
            for (const t of n){
                const n = ac(e - t.x, r, i, s) + t.badness;
                n <= o && (a = t, o = n);
            }
            return {
                index: t,
                x: e,
                priorBreak: a,
                badness: o
            };
        }
        function uc(t) {
            return t ? uc(t.priorBreak).concat(t.index) : [];
        }
        function cc(t, e, r, n, i, s) {
            if (!t) return [];
            const a = [], o = function(t, e, r, n, i, s) {
                let a = 0;
                for(let r = 0; r < t.length(); r++){
                    const o = t.getSection(r);
                    a += sc(t.getCharCode(r), o, n, i, e, s);
                }
                return a / Math.max(1, Math.ceil(a / r));
            }(t, e, r, n, i, s), l = t.text.indexOf("\u200B") >= 0;
            let u = 0;
            for(let r = 0; r < t.length(); r++){
                const h = t.getSection(r), p = t.getCharCode(r);
                if (rc[p] || (u += sc(p, h, n, i, e, s)), r < t.length() - 1) {
                    const e = !((c = p) < 11904) && (!!Qi["CJK Compatibility Forms"](c) || !!Qi["CJK Compatibility"](c) || !!Qi["CJK Strokes"](c) || !!Qi["CJK Symbols and Punctuation"](c) || !!Qi["Enclosed CJK Letters and Months"](c) || !!Qi["Halfwidth and Fullwidth Forms"](c) || !!Qi["Ideographic Description Characters"](c) || !!Qi["Vertical Forms"](c) || ss.test(String.fromCodePoint(c)));
                    (nc[p] || e || h.imageName || r !== t.length() - 2 && ic[t.getCharCode(r + 1)]) && a.push(lc(r + 1, u, o, a, oc(p, t.getCharCode(r + 1), e && l), !1));
                }
            }
            var c;
            return uc(lc(t.length(), u, o, a, 0, !0));
        }
        function hc(t) {
            let e = .5, r = .5;
            switch(t){
                case "right":
                case "top-right":
                case "bottom-right":
                    e = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    e = 0;
            }
            switch(t){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    r = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    r = 0;
            }
            return {
                horizontalAlign: e,
                verticalAlign: r
            };
        }
        function pc(t, e, r) {
            const n = e.getMaxScale() * Lu, { maxImageWidth: i, maxImageHeight: s } = e.getMaxImageSize(t), a = Math.max(n, s * r);
            return {
                verticalLineContentWidth: Math.max(n, i * r),
                horizontalLineContentHeight: a
            };
        }
        function fc(t) {
            switch(t){
                case "top":
                    return 0;
                case "center":
                    return .5;
                default:
                    return 1;
            }
        }
        function dc(e, r, n) {
            var i;
            return !(e === t.ah.horizontal || !r && !as(n) || r && (rc[n] || (i = n, /\p{sc=Arab}/u.test(String.fromCodePoint(i)))));
        }
        function yc(t, e, r, n, i, s) {
            const a = s[t.fontStack], o = function(t, e, r, n) {
                if (t && t.rect) return t;
                const i = e[r.fontStack], s = i && i[n];
                return s ? {
                    rect: null,
                    metrics: s.metrics
                } : null;
            }(a && a[e], i, t, e);
            if (null === o) return null;
            let l;
            if (r) l = n.verticalLineContentWidth - t.scale * Lu;
            else {
                const e = fc(t.verticalAlign);
                l = (n.horizontalLineContentHeight - t.scale * Lu) * e;
            }
            return {
                rect: o.rect,
                metrics: o.metrics,
                baselineOffset: l
            };
        }
        function mc(t, e, r, n, i) {
            const s = i[t.imageName];
            if (!s) return null;
            const a = s.paddedRect, o = s.displaySize, l = {
                width: o[0],
                height: o[1],
                left: Xu,
                top: -3,
                advance: e ? o[1] : o[0]
            };
            let u;
            if (e) u = n.verticalLineContentWidth - o[1] * t.scale;
            else {
                const e = fc(t.verticalAlign);
                u = (n.horizontalLineContentHeight - o[1] * t.scale) * e;
            }
            return {
                rect: a,
                metrics: l,
                baselineOffset: u,
                imageOffset: (e ? o[0] : o[1]) * t.scale - Lu * r
            };
        }
        function gc(t, e, r, n) {
            if (0 === n) return;
            const i = t[r], s = (t[r].x + i.metrics.advance * i.scale) * n;
            for(let n = e; n <= r; n++)t[n].x -= s;
        }
        function xc(t, e, r) {
            const { horizontalAlign: n, verticalAlign: i } = hc(r), s = e[0] - t.displaySize[0] * n, a = e[1] - t.displaySize[1] * i;
            return {
                image: t,
                top: a,
                bottom: a + t.displaySize[1],
                left: s,
                right: s + t.displaySize[0]
            };
        }
        function vc(t) {
            var e, r;
            let n = t.left, i = t.top, s = t.right - n, a = t.bottom - i;
            const o = null !== (e = t.image.textFitWidth) && void 0 !== e ? e : "stretchOrShrink", l = null !== (r = t.image.textFitHeight) && void 0 !== r ? r : "stretchOrShrink", u = (t.image.content[2] - t.image.content[0]) / (t.image.content[3] - t.image.content[1]);
            if ("proportional" === l) {
                if ("stretchOnly" === o && s / a < u || "proportional" === o) {
                    const t = Math.ceil(a * u);
                    n *= t / s, s = t;
                }
            } else if ("proportional" === o && "stretchOnly" === l && 0 !== u && s / a > u) {
                const t = Math.ceil(s / u);
                i *= t / a, a = t;
            }
            return {
                x1: n,
                y1: i,
                x2: n + s,
                y2: i + a
            };
        }
        function bc(t, e, r, n, i, s) {
            const a = t.image;
            let o;
            if (a.content) {
                const t = a.content, e = a.pixelRatio || 1;
                o = [
                    t[0] / e,
                    t[1] / e,
                    a.displaySize[0] - t[2] / e,
                    a.displaySize[1] - t[3] / e
                ];
            }
            const l = e.left * s, u = e.right * s;
            let c, h, p, f;
            "width" === r || "both" === r ? (f = i[0] + l - n[3], h = i[0] + u + n[1]) : (f = i[0] + (l + u - a.displaySize[0]) / 2, h = f + a.displaySize[0]);
            const d = e.top * s, y = e.bottom * s;
            return "height" === r || "both" === r ? (c = i[1] + d - n[0], p = i[1] + y + n[2]) : (c = i[1] + (d + y - a.displaySize[1]) / 2, p = c + a.displaySize[1]), {
                image: a,
                top: c,
                right: h,
                bottom: p,
                left: f,
                collisionPadding: o
            };
        }
        const wc = 255, _c = 128, Sc = wc * _c;
        function Ac(t, e) {
            const { expression: r } = e;
            if ("constant" === r.kind) return {
                kind: "constant",
                layoutSize: r.evaluate(new fs(t + 1))
            };
            if ("source" === r.kind) return {
                kind: "source"
            };
            {
                const { zoomStops: e, interpolationType: n } = r;
                let i = 0;
                for(; i < e.length && e[i] <= t;)i++;
                i = Math.max(0, i - 1);
                let s = i;
                for(; s < e.length && e[s] < t + 1;)s++;
                s = Math.min(e.length - 1, s);
                const a = e[i], o = e[s];
                return "composite" === r.kind ? {
                    kind: "composite",
                    minZoom: a,
                    maxZoom: o,
                    interpolationType: n
                } : {
                    kind: "camera",
                    minZoom: a,
                    maxZoom: o,
                    minSize: r.evaluate(new fs(a)),
                    maxSize: r.evaluate(new fs(o)),
                    interpolationType: n
                };
            }
        }
        function kc(t, e, r) {
            let n = "never";
            const i = t.get(e);
            return i ? n = i : t.get(r) && (n = "always"), n;
        }
        const Mc = Ql.VectorTileFeature.types, Ic = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function zc(t, e, r, n, i, s, a, o, l, u, c, h, p) {
            const f = o ? Math.min(Sc, Math.round(o[0])) : 0, d = o ? Math.min(Sc, Math.round(o[1])) : 0;
            t.emplaceBack(e, r, Math.round(32 * n), Math.round(32 * i), s, a, (f << 1) + (l ? 1 : 0), d, 16 * u, 16 * c, 256 * h, 256 * p);
        }
        function Pc(t, e, r) {
            t.emplaceBack(e.x, e.y, r), t.emplaceBack(e.x, e.y, r), t.emplaceBack(e.x, e.y, r), t.emplaceBack(e.x, e.y, r);
        }
        function Cc(t) {
            for (const e of t.sections)if (hs(e.text)) return !0;
            return !1;
        }
        class Bc {
            constructor(t){
                this.layoutVertexArray = new Sa, this.indexArray = new za, this.programConfigurations = t, this.segments = new Va, this.dynamicLayoutVertexArray = new Aa, this.opacityVertexArray = new ka, this.hasVisibleVertices = !1, this.placedSymbolArray = new oa;
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
            }
            upload(t, e, r, n) {
                this.isEmpty() || (r && (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, Iu.members), this.indexBuffer = t.createIndexBuffer(this.indexArray, e), this.dynamicLayoutVertexBuffer = t.createVertexBuffer(this.dynamicLayoutVertexArray, zu.members, !0), this.opacityVertexBuffer = t.createVertexBuffer(this.opacityVertexArray, Ic, !0), this.opacityVertexBuffer.itemSize = 1), (r || n) && this.programConfigurations.upload(t));
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
            }
        }
        Zi("SymbolBuffers", Bc);
        class Vc {
            constructor(t, e, r){
                this.layoutVertexArray = new t, this.layoutAttributes = e, this.indexArray = new r, this.segments = new Va, this.collisionVertexArray = new Ia;
            }
            upload(t) {
                this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t.createVertexBuffer(this.collisionVertexArray, Pu.members, !0);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
            }
        }
        Zi("CollisionBuffers", Vc);
        class Ec {
            constructor(e){
                this.collisionBoxArray = e.collisionBoxArray, this.zoom = e.zoom, this.overscaling = e.overscaling, this.layers = e.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = e.index, this.pixelRatio = e.pixelRatio, this.sourceLayerIndex = e.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [];
                const r = this.layers[0]._unevaluatedLayout._values;
                this.textSizeData = Ac(this.zoom, r["text-size"]), this.iconSizeData = Ac(this.zoom, r["icon-size"]);
                const n = this.layers[0].layout, i = n.get("symbol-sort-key"), s = n.get("symbol-z-order");
                this.canOverlap = "never" !== kc(n, "text-overlap", "text-allow-overlap") || "never" !== kc(n, "icon-overlap", "icon-allow-overlap") || n.get("text-ignore-placement") || n.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== s && !i.isConstant(), this.sortFeaturesByY = ("viewport-y" === s || "auto" === s && !this.sortFeaturesByKey) && this.canOverlap, "point" === n.get("symbol-placement") && (this.writingModes = n.get("text-writing-mode").map((e)=>t.ah[e])), this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id), this.sourceID = e.sourceID;
            }
            createArrays() {
                this.text = new Bc(new so(this.layers, this.zoom, (t)=>/^text/.test(t))), this.icon = new Bc(new so(this.layers, this.zoom, (t)=>/^icon/.test(t))), this.glyphOffsetArray = new ca, this.lineVertexArray = new ha, this.symbolInstances = new ua, this.textAnchorOffsets = new fa;
            }
            calculateGlyphDependencies(t, e, r, n, i) {
                for(let s = 0; s < t.length; s++)if (e[t.charCodeAt(s)] = !0, (r || n) && i) {
                    const r = Eu[t.charAt(s)];
                    r && (e[r.charCodeAt(0)] = !0);
                }
            }
            populate(e, r, n) {
                const i = this.layers[0], s = i.layout, a = s.get("text-font"), o = s.get("text-field"), l = s.get("icon-image"), u = ("constant" !== o.value.kind || o.value.value instanceof _e && !o.value.value.isEmpty() || o.value.value.toString().length > 0) && ("constant" !== a.value.kind || a.value.value.length > 0), c = "constant" !== l.value.kind || !!l.value.value || Object.keys(l.parameters).length > 0, h = s.get("symbol-sort-key");
                if (this.features = [], !u && !c) return;
                const p = r.iconDependencies, f = r.glyphDependencies, d = r.availableImages, y = new fs(this.zoom);
                for (const { feature: r, id: o, index: l, sourceLayerIndex: m } of e){
                    const e = i._featureFilter.needGeometry, g = ho(r, e);
                    if (!i._featureFilter.filter(y, g, n)) continue;
                    let x, v;
                    if (e || (g.geometry = co(r)), u) {
                        const t = i.getValueAndResolveTokens("text-field", g, n, d), e = _e.factory(t), r = this.hasRTLText = this.hasRTLText || Cc(e);
                        (!r || "unavailable" === ps.getRTLTextPluginStatus() || r && ps.isParsed()) && (x = Vu(e, i, g));
                    }
                    if (c) {
                        const t = i.getValueAndResolveTokens("icon-image", g, n, d);
                        v = t instanceof Ie ? t : Ie.fromString(t);
                    }
                    if (!x && !v) continue;
                    const b = this.sortFeaturesByKey ? h.evaluate(g, {}, n) : void 0;
                    if (this.features.push({
                        id: o,
                        text: x,
                        icon: v,
                        index: l,
                        sourceLayerIndex: m,
                        geometry: g.geometry,
                        properties: r.properties,
                        type: Mc[r.type],
                        sortKey: b
                    }), v && (p[v.name] = !0), x) {
                        const e = a.evaluate(g, {}, n).join(","), r = "viewport" !== s.get("text-rotation-alignment") && "point" !== s.get("symbol-placement");
                        this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(t.ah.vertical) >= 0;
                        for (const t of x.sections)if (t.image) p[t.image.name] = !0;
                        else {
                            const n = ts(x.toString()), i = t.fontStack || e, s = f[i] = f[i] || {};
                            this.calculateGlyphDependencies(t.text, s, r, this.allowVerticalPlacement, n);
                        }
                    }
                }
                "line" === s.get("symbol-placement") && (this.features = function(t) {
                    const e = {}, r = {}, n = [];
                    let i = 0;
                    function s(e) {
                        n.push(t[e]), i++;
                    }
                    function a(t, e, i) {
                        const s = r[t];
                        return delete r[t], r[e] = s, n[s].geometry[0].pop(), n[s].geometry[0] = n[s].geometry[0].concat(i[0]), s;
                    }
                    function o(t, r, i) {
                        const s = e[r];
                        return delete e[r], e[t] = s, n[s].geometry[0].shift(), n[s].geometry[0] = i[0].concat(n[s].geometry[0]), s;
                    }
                    function l(t, e, r) {
                        const n = r ? e[0][e[0].length - 1] : e[0][0];
                        return `${t}:${n.x}:${n.y}`;
                    }
                    for(let u = 0; u < t.length; u++){
                        const c = t[u], h = c.geometry, p = c.text ? c.text.toString() : null;
                        if (!p) {
                            s(u);
                            continue;
                        }
                        const f = l(p, h), d = l(p, h, !0);
                        if (f in r && d in e && r[f] !== e[d]) {
                            const t = o(f, d, h), i = a(f, d, n[t].geometry);
                            delete e[f], delete r[d], r[l(p, n[i].geometry, !0)] = i, n[t].geometry = null;
                        } else f in r ? a(f, d, h) : d in e ? o(f, d, h) : (s(u), e[f] = i - 1, r[d] = i - 1);
                    }
                    return n.filter((t)=>t.geometry);
                }(this.features)), this.sortFeaturesByKey && this.features.sort((t, e)=>t.sortKey - e.sortKey);
            }
            update(t, e, r) {
                this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(t, e, this.layers, r), this.icon.programConfigurations.updatePaintArrays(t, e, this.layers, r));
            }
            isEmpty() {
                return 0 === this.symbolInstances.length && !this.hasRTLText;
            }
            uploadPending() {
                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
            }
            upload(t) {
                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t), this.iconCollisionBox.upload(t)), this.text.upload(t, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(t, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
            }
            destroyDebugData() {
                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
            }
            destroy() {
                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
            }
            addToLineVertexArray(t, e) {
                const r = this.lineVertexArray.length;
                if (void 0 !== t.segment) {
                    let r = t.dist(e[t.segment + 1]), n = t.dist(e[t.segment]);
                    const i = {};
                    for(let n = t.segment + 1; n < e.length; n++)i[n] = {
                        x: e[n].x,
                        y: e[n].y,
                        tileUnitDistanceFromAnchor: r
                    }, n < e.length - 1 && (r += e[n + 1].dist(e[n]));
                    for(let r = t.segment || 0; r >= 0; r--)i[r] = {
                        x: e[r].x,
                        y: e[r].y,
                        tileUnitDistanceFromAnchor: n
                    }, r > 0 && (n += e[r - 1].dist(e[r]));
                    for(let t = 0; t < e.length; t++){
                        const e = i[t];
                        this.lineVertexArray.emplaceBack(e.x, e.y, e.tileUnitDistanceFromAnchor);
                    }
                }
                return {
                    lineStartIndex: r,
                    lineLength: this.lineVertexArray.length - r
                };
            }
            addSymbols(e, r, n, i, s, a, o, l, u, c, h, p) {
                const f = e.indexArray, d = e.layoutVertexArray, y = e.segments.prepareSegment(4 * r.length, d, f, this.canOverlap ? a.sortKey : void 0), m = this.glyphOffsetArray.length, g = y.vertexLength, x = this.allowVerticalPlacement && o === t.ah.vertical ? Math.PI / 2 : 0, v = a.text && a.text.sections;
                for(let t = 0; t < r.length; t++){
                    const { tl: i, tr: s, bl: o, br: u, tex: c, pixelOffsetTL: h, pixelOffsetBR: m, minFontScaleX: g, minFontScaleY: b, glyphOffset: w, isSDF: _, sectionIndex: S } = r[t], A = y.vertexLength, k = w[1];
                    zc(d, l.x, l.y, i.x, k + i.y, c.x, c.y, n, _, h.x, h.y, g, b), zc(d, l.x, l.y, s.x, k + s.y, c.x + c.w, c.y, n, _, m.x, h.y, g, b), zc(d, l.x, l.y, o.x, k + o.y, c.x, c.y + c.h, n, _, h.x, m.y, g, b), zc(d, l.x, l.y, u.x, k + u.y, c.x + c.w, c.y + c.h, n, _, m.x, m.y, g, b), Pc(e.dynamicLayoutVertexArray, l, x), f.emplaceBack(A, A + 2, A + 1), f.emplaceBack(A + 1, A + 2, A + 3), y.vertexLength += 4, y.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(w[0]), t !== r.length - 1 && S === r[t + 1].sectionIndex || e.programConfigurations.populatePaintArrays(d.length, a, a.index, {}, p, v && v[S]);
                }
                e.placedSymbolArray.emplaceBack(l.x, l.y, m, this.glyphOffsetArray.length - m, g, u, c, l.segment, n ? n[0] : 0, n ? n[1] : 0, i[0], i[1], o, 0, !1, 0, h);
            }
            _addCollisionDebugVertex(t, e, r, n, i, s) {
                return e.emplaceBack(0, 0), t.emplaceBack(r.x, r.y, n, i, Math.round(s.x), Math.round(s.y));
            }
            addCollisionDebugVertices(t, e, r, n, i, s, a) {
                const o = i.segments.prepareSegment(4, i.layoutVertexArray, i.indexArray), u = o.vertexLength, c = i.layoutVertexArray, h = i.collisionVertexArray, p = a.anchorX, f = a.anchorY;
                this._addCollisionDebugVertex(c, h, s, p, f, new l(t, e)), this._addCollisionDebugVertex(c, h, s, p, f, new l(r, e)), this._addCollisionDebugVertex(c, h, s, p, f, new l(r, n)), this._addCollisionDebugVertex(c, h, s, p, f, new l(t, n)), o.vertexLength += 4;
                const d = i.indexArray;
                d.emplaceBack(u, u + 1), d.emplaceBack(u + 1, u + 2), d.emplaceBack(u + 2, u + 3), d.emplaceBack(u + 3, u), o.primitiveLength += 4;
            }
            addDebugCollisionBoxes(t, e, r, n) {
                for(let i = t; i < e; i++){
                    const t = this.collisionBoxArray.get(i);
                    this.addCollisionDebugVertices(t.x1, t.y1, t.x2, t.y2, n ? this.textCollisionBox : this.iconCollisionBox, t.anchorPoint, r);
                }
            }
            generateCollisionDebugBuffers() {
                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new Vc(Ma, Cu.members, Pa), this.iconCollisionBox = new Vc(Ma, Cu.members, Pa);
                for(let t = 0; t < this.symbolInstances.length; t++){
                    const e = this.symbolInstances.get(t);
                    this.addDebugCollisionBoxes(e.textBoxStartIndex, e.textBoxEndIndex, e, !0), this.addDebugCollisionBoxes(e.verticalTextBoxStartIndex, e.verticalTextBoxEndIndex, e, !0), this.addDebugCollisionBoxes(e.iconBoxStartIndex, e.iconBoxEndIndex, e, !1), this.addDebugCollisionBoxes(e.verticalIconBoxStartIndex, e.verticalIconBoxEndIndex, e, !1);
                }
            }
            _deserializeCollisionBoxesForSymbol(t, e, r, n, i, s, a, o, l) {
                const u = {};
                for(let n = e; n < r; n++){
                    const e = t.get(n);
                    u.textBox = {
                        x1: e.x1,
                        y1: e.y1,
                        x2: e.x2,
                        y2: e.y2,
                        anchorPointX: e.anchorPointX,
                        anchorPointY: e.anchorPointY
                    }, u.textFeatureIndex = e.featureIndex;
                    break;
                }
                for(let e = n; e < i; e++){
                    const r = t.get(e);
                    u.verticalTextBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        anchorPointX: r.anchorPointX,
                        anchorPointY: r.anchorPointY
                    }, u.verticalTextFeatureIndex = r.featureIndex;
                    break;
                }
                for(let e = s; e < a; e++){
                    const r = t.get(e);
                    u.iconBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        anchorPointX: r.anchorPointX,
                        anchorPointY: r.anchorPointY
                    }, u.iconFeatureIndex = r.featureIndex;
                    break;
                }
                for(let e = o; e < l; e++){
                    const r = t.get(e);
                    u.verticalIconBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        anchorPointX: r.anchorPointX,
                        anchorPointY: r.anchorPointY
                    }, u.verticalIconFeatureIndex = r.featureIndex;
                    break;
                }
                return u;
            }
            deserializeCollisionBoxes(t) {
                this.collisionArrays = [];
                for(let e = 0; e < this.symbolInstances.length; e++){
                    const r = this.symbolInstances.get(e);
                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t, r.textBoxStartIndex, r.textBoxEndIndex, r.verticalTextBoxStartIndex, r.verticalTextBoxEndIndex, r.iconBoxStartIndex, r.iconBoxEndIndex, r.verticalIconBoxStartIndex, r.verticalIconBoxEndIndex));
                }
            }
            hasTextData() {
                return this.text.segments.get().length > 0;
            }
            hasIconData() {
                return this.icon.segments.get().length > 0;
            }
            hasDebugData() {
                return this.textCollisionBox && this.iconCollisionBox;
            }
            hasTextCollisionBoxData() {
                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
            }
            hasIconCollisionBoxData() {
                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
            }
            addIndicesForPlacedSymbol(t, e) {
                const r = t.placedSymbolArray.get(e), n = r.vertexStartIndex + 4 * r.numGlyphs;
                for(let e = r.vertexStartIndex; e < n; e += 4)t.indexArray.emplaceBack(e, e + 2, e + 1), t.indexArray.emplaceBack(e + 1, e + 2, e + 3);
            }
            getSortedSymbolIndexes(t) {
                if (this.sortedAngle === t && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                const e = Math.sin(t), r = Math.cos(t), n = [], i = [], s = [];
                for(let t = 0; t < this.symbolInstances.length; ++t){
                    s.push(t);
                    const a = this.symbolInstances.get(t);
                    n.push(0 | Math.round(e * a.anchorX + r * a.anchorY)), i.push(a.featureIndex);
                }
                return s.sort((t, e)=>n[t] - n[e] || i[e] - i[t]), s;
            }
            addToSortKeyRanges(t, e) {
                const r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                r && r.sortKey === e ? r.symbolInstanceEnd = t + 1 : this.sortKeyRanges.push({
                    sortKey: e,
                    symbolInstanceStart: t,
                    symbolInstanceEnd: t + 1
                });
            }
            sortFeatures(t) {
                if (this.sortFeaturesByY && this.sortedAngle !== t && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                    this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t), this.sortedAngle = t, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                    for (const t of this.symbolInstanceIndexes){
                        const e = this.symbolInstances.get(t);
                        this.featureSortOrder.push(e.featureIndex), [
                            e.rightJustifiedTextSymbolIndex,
                            e.centerJustifiedTextSymbolIndex,
                            e.leftJustifiedTextSymbolIndex
                        ].forEach((t, e, r)=>{
                            t >= 0 && r.indexOf(t) === e && this.addIndicesForPlacedSymbol(this.text, t);
                        }), e.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, e.verticalPlacedTextSymbolIndex), e.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e.placedIconSymbolIndex), e.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e.verticalPlacedIconSymbolIndex);
                    }
                    this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                }
            }
        }
        let Tc, Fc;
        Zi("SymbolBucket", Ec, {
            omit: [
                "layers",
                "collisionBoxArray",
                "features",
                "compareText"
            ]
        }), Ec.MAX_GLYPHS = 65535, Ec.addDynamicAttributes = Pc;
        var $c = {
            get paint () {
                return Fc = Fc || new Is({
                    "icon-opacity": new Ss(dt.paint_symbol["icon-opacity"]),
                    "icon-color": new Ss(dt.paint_symbol["icon-color"]),
                    "icon-halo-color": new Ss(dt.paint_symbol["icon-halo-color"]),
                    "icon-halo-width": new Ss(dt.paint_symbol["icon-halo-width"]),
                    "icon-halo-blur": new Ss(dt.paint_symbol["icon-halo-blur"]),
                    "icon-translate": new _s(dt.paint_symbol["icon-translate"]),
                    "icon-translate-anchor": new _s(dt.paint_symbol["icon-translate-anchor"]),
                    "text-opacity": new Ss(dt.paint_symbol["text-opacity"]),
                    "text-color": new Ss(dt.paint_symbol["text-color"], {
                        runtimeType: Tt,
                        getOverride: (t)=>t.textColor,
                        hasOverride: (t)=>!!t.textColor
                    }),
                    "text-halo-color": new Ss(dt.paint_symbol["text-halo-color"]),
                    "text-halo-width": new Ss(dt.paint_symbol["text-halo-width"]),
                    "text-halo-blur": new Ss(dt.paint_symbol["text-halo-blur"]),
                    "text-translate": new _s(dt.paint_symbol["text-translate"]),
                    "text-translate-anchor": new _s(dt.paint_symbol["text-translate-anchor"])
                });
            },
            get layout () {
                return Tc = Tc || new Is({
                    "symbol-placement": new _s(dt.layout_symbol["symbol-placement"]),
                    "symbol-spacing": new _s(dt.layout_symbol["symbol-spacing"]),
                    "symbol-avoid-edges": new _s(dt.layout_symbol["symbol-avoid-edges"]),
                    "symbol-sort-key": new Ss(dt.layout_symbol["symbol-sort-key"]),
                    "symbol-z-order": new _s(dt.layout_symbol["symbol-z-order"]),
                    "icon-allow-overlap": new _s(dt.layout_symbol["icon-allow-overlap"]),
                    "icon-overlap": new _s(dt.layout_symbol["icon-overlap"]),
                    "icon-ignore-placement": new _s(dt.layout_symbol["icon-ignore-placement"]),
                    "icon-optional": new _s(dt.layout_symbol["icon-optional"]),
                    "icon-rotation-alignment": new _s(dt.layout_symbol["icon-rotation-alignment"]),
                    "icon-size": new Ss(dt.layout_symbol["icon-size"]),
                    "icon-text-fit": new _s(dt.layout_symbol["icon-text-fit"]),
                    "icon-text-fit-padding": new _s(dt.layout_symbol["icon-text-fit-padding"]),
                    "icon-image": new Ss(dt.layout_symbol["icon-image"]),
                    "icon-rotate": new Ss(dt.layout_symbol["icon-rotate"]),
                    "icon-padding": new Ss(dt.layout_symbol["icon-padding"]),
                    "icon-keep-upright": new _s(dt.layout_symbol["icon-keep-upright"]),
                    "icon-offset": new Ss(dt.layout_symbol["icon-offset"]),
                    "icon-anchor": new Ss(dt.layout_symbol["icon-anchor"]),
                    "icon-pitch-alignment": new _s(dt.layout_symbol["icon-pitch-alignment"]),
                    "text-pitch-alignment": new _s(dt.layout_symbol["text-pitch-alignment"]),
                    "text-rotation-alignment": new _s(dt.layout_symbol["text-rotation-alignment"]),
                    "text-field": new Ss(dt.layout_symbol["text-field"]),
                    "text-font": new Ss(dt.layout_symbol["text-font"]),
                    "text-size": new Ss(dt.layout_symbol["text-size"]),
                    "text-max-width": new Ss(dt.layout_symbol["text-max-width"]),
                    "text-line-height": new _s(dt.layout_symbol["text-line-height"]),
                    "text-letter-spacing": new Ss(dt.layout_symbol["text-letter-spacing"]),
                    "text-justify": new Ss(dt.layout_symbol["text-justify"]),
                    "text-radial-offset": new Ss(dt.layout_symbol["text-radial-offset"]),
                    "text-variable-anchor": new _s(dt.layout_symbol["text-variable-anchor"]),
                    "text-variable-anchor-offset": new Ss(dt.layout_symbol["text-variable-anchor-offset"]),
                    "text-anchor": new Ss(dt.layout_symbol["text-anchor"]),
                    "text-max-angle": new _s(dt.layout_symbol["text-max-angle"]),
                    "text-writing-mode": new _s(dt.layout_symbol["text-writing-mode"]),
                    "text-rotate": new Ss(dt.layout_symbol["text-rotate"]),
                    "text-padding": new _s(dt.layout_symbol["text-padding"]),
                    "text-keep-upright": new _s(dt.layout_symbol["text-keep-upright"]),
                    "text-transform": new Ss(dt.layout_symbol["text-transform"]),
                    "text-offset": new Ss(dt.layout_symbol["text-offset"]),
                    "text-allow-overlap": new _s(dt.layout_symbol["text-allow-overlap"]),
                    "text-overlap": new _s(dt.layout_symbol["text-overlap"]),
                    "text-ignore-placement": new _s(dt.layout_symbol["text-ignore-placement"]),
                    "text-optional": new _s(dt.layout_symbol["text-optional"])
                });
            }
        };
        class Lc {
            constructor(t){
                if (void 0 === t.property.overrides) throw new Error("overrides must be provided to instantiate FormatSectionOverride class");
                this.type = t.property.overrides ? t.property.overrides.runtimeType : Ct, this.defaultValue = t;
            }
            evaluate(t) {
                if (t.formattedSection) {
                    const e = this.defaultValue.property.overrides;
                    if (e && e.hasOverride(t.formattedSection)) return e.getOverride(t.formattedSection);
                }
                return t.feature && t.featureState ? this.defaultValue.evaluate(t.feature, t.featureState) : this.defaultValue.property.specification.default;
            }
            eachChild(t) {
                this.defaultValue.isConstant() || t(this.defaultValue.value._styleExpression.expression);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return null;
            }
        }
        Zi("FormatSectionOverride", Lc, {
            omit: [
                "defaultValue"
            ]
        });
        class Oc extends Ps {
            constructor(t){
                super(t, $c);
            }
            recalculate(t, e) {
                if (super.recalculate(t, e), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = "map" === this.layout.get("text-rotation-alignment") ? "map" : "viewport"), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), "point" === this.layout.get("symbol-placement")) {
                    const t = this.layout.get("text-writing-mode");
                    if (t) {
                        const e = [];
                        for (const r of t)e.indexOf(r) < 0 && e.push(r);
                        this.layout._values["text-writing-mode"] = e;
                    } else this.layout._values["text-writing-mode"] = [
                        "horizontal"
                    ];
                }
                this._setPaintOverrides();
            }
            getValueAndResolveTokens(t, e, r, n) {
                const i = this.layout.get(t).evaluate(e, {}, r, n), s = this._unevaluatedLayout._values[t];
                return s.isDataDriven() || qn(s.value) || !i ? i : function(t, e) {
                    return e.replace(/{([^{}]+)}/g, (e, r)=>t && r in t ? String(t[r]) : "");
                }(e.properties, i);
            }
            createBucket(t) {
                return new Ec(t);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                throw new Error("Should take a different path in FeatureIndex");
            }
            _setPaintOverrides() {
                for (const t of $c.paint.overridableProperties){
                    if (!Oc.hasPaintOverride(this.layout, t)) continue;
                    const e = this.paint.get(t), r = new Lc(e), n = new Un(r, e.property.specification);
                    let i = null;
                    i = "constant" === e.value.kind || "source" === e.value.kind ? new Zn("source", n) : new Kn("composite", n, e.value.zoomStops), this.paint._values[t] = new bs(e.property, i, e.parameters);
                }
            }
            _handleOverridablePaintPropertyUpdate(t, e, r) {
                return !(!this.layout || e.isDataDriven() || r.isDataDriven()) && Oc.hasPaintOverride(this.layout, t);
            }
            static hasPaintOverride(t, e) {
                const r = t.get("text-field"), n = $c.paint.properties[e];
                let i = !1;
                const s = (t)=>{
                    for (const e of t)if (n.overrides && n.overrides.hasOverride(e)) return void (i = !0);
                };
                if ("constant" === r.value.kind && r.value.value instanceof _e) s(r.value.value.sections);
                else if ("source" === r.value.kind) {
                    const t = (e)=>{
                        i || (e instanceof Ee && Be(e.value) === Dt ? s(e.value.sections) : e instanceof gr ? s(e.sections) : e.eachChild(t));
                    }, e = r.value;
                    e._styleExpression && t(e._styleExpression.expression);
                }
                return i;
            }
        }
        let Dc;
        var Rc = {
            get paint () {
                return Dc = Dc || new Is({
                    "background-color": new _s(dt.paint_background["background-color"]),
                    "background-pattern": new ks(dt.paint_background["background-pattern"]),
                    "background-opacity": new _s(dt.paint_background["background-opacity"])
                });
            }
        };
        class jc extends Ps {
            constructor(t){
                super(t, Rc);
            }
        }
        let Nc;
        var Uc = {
            get paint () {
                return Nc = Nc || new Is({
                    "raster-opacity": new _s(dt.paint_raster["raster-opacity"]),
                    "raster-hue-rotate": new _s(dt.paint_raster["raster-hue-rotate"]),
                    "raster-brightness-min": new _s(dt.paint_raster["raster-brightness-min"]),
                    "raster-brightness-max": new _s(dt.paint_raster["raster-brightness-max"]),
                    "raster-saturation": new _s(dt.paint_raster["raster-saturation"]),
                    "raster-contrast": new _s(dt.paint_raster["raster-contrast"]),
                    "raster-resampling": new _s(dt.paint_raster["raster-resampling"]),
                    "raster-fade-duration": new _s(dt.paint_raster["raster-fade-duration"])
                });
            }
        };
        class qc extends Ps {
            constructor(t){
                super(t, Uc);
            }
        }
        class Gc extends Ps {
            constructor(t){
                super(t, {}), this.onAdd = (t)=>{
                    this.implementation.onAdd && this.implementation.onAdd(t, t.painter.context.gl);
                }, this.onRemove = (t)=>{
                    this.implementation.onRemove && this.implementation.onRemove(t, t.painter.context.gl);
                }, this.implementation = t;
            }
            is3D() {
                return "3d" === this.implementation.renderingMode;
            }
            hasOffscreenPass() {
                return void 0 !== this.implementation.prerender;
            }
            recalculate() {}
            updateTransitions() {}
            hasTransition() {
                return !1;
            }
            serialize() {
                throw new Error("Custom layers cannot be serialized");
            }
        }
        class Zc {
            constructor(t){
                this._methodToThrottle = t, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                    this._triggered = !1, this._methodToThrottle();
                });
            }
            trigger() {
                this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                    this._triggered = !1, this._methodToThrottle();
                }, 0));
            }
            remove() {
                delete this._channel, this._methodToThrottle = ()=>{};
            }
        }
        const Kc = {
            once: !0
        }, Xc = 6371008.8;
        class Hc {
            constructor(t, e){
                if (isNaN(t) || isNaN(e)) throw new Error(`Invalid LngLat object: (${t}, ${e})`);
                if (this.lng = +t, this.lat = +e, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
            }
            wrap() {
                return new Hc(T(this.lng, -180, 180), this.lat);
            }
            toArray() {
                return [
                    this.lng,
                    this.lat
                ];
            }
            toString() {
                return `LngLat(${this.lng}, ${this.lat})`;
            }
            distanceTo(t) {
                const e = Math.PI / 180, r = this.lat * e, n = t.lat * e, i = Math.sin(r) * Math.sin(n) + Math.cos(r) * Math.cos(n) * Math.cos((t.lng - this.lng) * e);
                return Xc * Math.acos(Math.min(i, 1));
            }
            static convert(t) {
                if (t instanceof Hc) return t;
                if (Array.isArray(t) && (2 === t.length || 3 === t.length)) return new Hc(Number(t[0]), Number(t[1]));
                if (!Array.isArray(t) && "object" == typeof t && null !== t) return new Hc(Number("lng" in t ? t.lng : t.lon), Number(t.lat));
                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
            }
        }
        const Yc = 2 * Math.PI * Xc;
        function Jc(t) {
            return Yc * Math.cos(t * Math.PI / 180);
        }
        function Wc(t) {
            return (180 + t) / 360;
        }
        function Qc(t) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t * Math.PI / 360))) / 360;
        }
        function th(t, e) {
            return t / Jc(e);
        }
        function eh(t) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t) * Math.PI / 180)) - 90;
        }
        function rh(t, e) {
            return t * Jc(eh(e));
        }
        class nh {
            constructor(t, e, r = 0){
                this.x = +t, this.y = +e, this.z = +r;
            }
            static fromLngLat(t, e = 0) {
                const r = Hc.convert(t);
                return new nh(Wc(r.lng), Qc(r.lat), th(e, r.lat));
            }
            toLngLat() {
                return new Hc(360 * this.x - 180, eh(this.y));
            }
            toAltitude() {
                return rh(this.z, this.y);
            }
            meterInMercatorCoordinateUnits() {
                var t;
                return 1 / Yc * (t = eh(this.y), 1 / Math.cos(t * Math.PI / 180));
            }
        }
        function ih(t, e, r) {
            var n = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r);
            return [
                t * n - 2 * Math.PI * 6378137 / 2,
                e * n - 2 * Math.PI * 6378137 / 2
            ];
        }
        class sh {
            constructor(t, e, r){
                if (!function(t, e, r) {
                    return !(t < 0 || t > 25 || r < 0 || r >= Math.pow(2, t) || e < 0 || e >= Math.pow(2, t));
                }(t, e, r)) throw new Error(`x=${e}, y=${r}, z=${t} outside of bounds. 0<=x<${Math.pow(2, t)}, 0<=y<${Math.pow(2, t)} 0<=z<=25 `);
                this.z = t, this.x = e, this.y = r, this.key = lh(0, t, t, e, r);
            }
            equals(t) {
                return this.z === t.z && this.x === t.x && this.y === t.y;
            }
            url(t, e, r) {
                const n = (s = this.y, a = this.z, o = ih(256 * (i = this.x), 256 * (s = Math.pow(2, a) - s - 1), a), l = ih(256 * (i + 1), 256 * (s + 1), a), o[0] + "," + o[1] + "," + l[0] + "," + l[1]);
                var i, s, a, o, l;
                const u = function(t, e, r) {
                    let n, i = "";
                    for(let s = t; s > 0; s--)n = 1 << s - 1, i += (e & n ? 1 : 0) + (r & n ? 2 : 0);
                    return i;
                }(this.z, this.x, this.y);
                return t[(this.x + this.y) % t.length].replace(/{prefix}/g, (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === r ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace(/{ratio}/g, e > 1 ? "@2x" : "").replace(/{quadkey}/g, u).replace(/{bbox-epsg-3857}/g, n);
            }
            isChildOf(t) {
                const e = this.z - t.z;
                return e > 0 && t.x === this.x >> e && t.y === this.y >> e;
            }
            getTilePoint(t) {
                const e = Math.pow(2, this.z);
                return new l((t.x * e - this.x) * M, (t.y * e - this.y) * M);
            }
            toString() {
                return `${this.z}/${this.x}/${this.y}`;
            }
        }
        class ah {
            constructor(t, e){
                this.wrap = t, this.canonical = e, this.key = lh(t, e.z, e.z, e.x, e.y);
            }
        }
        class oh {
            constructor(t, e, r, n, i){
                if (this.terrainRttPosMatrix32f = null, t < r) throw new Error(`overscaledZ should be >= z; overscaledZ = ${t}; z = ${r}`);
                this.overscaledZ = t, this.wrap = e, this.canonical = new sh(r, +n, +i), this.key = lh(e, t, r, n, i);
            }
            clone() {
                return new oh(this.overscaledZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            equals(t) {
                return this.overscaledZ === t.overscaledZ && this.wrap === t.wrap && this.canonical.equals(t.canonical);
            }
            scaledTo(t) {
                if (t > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${t}; overscaledZ = ${this.overscaledZ}`);
                const e = this.canonical.z - t;
                return t > this.canonical.z ? new oh(t, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new oh(t, this.wrap, t, this.canonical.x >> e, this.canonical.y >> e);
            }
            calculateScaledKey(t, e) {
                if (t > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${t}; overscaledZ = ${this.overscaledZ}`);
                const r = this.canonical.z - t;
                return t > this.canonical.z ? lh(this.wrap * +e, t, this.canonical.z, this.canonical.x, this.canonical.y) : lh(this.wrap * +e, t, t, this.canonical.x >> r, this.canonical.y >> r);
            }
            isChildOf(t) {
                if (t.wrap !== this.wrap) return !1;
                const e = this.canonical.z - t.canonical.z;
                return 0 === t.overscaledZ || t.overscaledZ < this.overscaledZ && t.canonical.x === this.canonical.x >> e && t.canonical.y === this.canonical.y >> e;
            }
            children(t) {
                if (this.overscaledZ >= t) return [
                    new oh(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                ];
                const e = this.canonical.z + 1, r = 2 * this.canonical.x, n = 2 * this.canonical.y;
                return [
                    new oh(e, this.wrap, e, r, n),
                    new oh(e, this.wrap, e, r + 1, n),
                    new oh(e, this.wrap, e, r, n + 1),
                    new oh(e, this.wrap, e, r + 1, n + 1)
                ];
            }
            isLessThan(t) {
                return this.wrap < t.wrap || !(this.wrap > t.wrap) && (this.overscaledZ < t.overscaledZ || !(this.overscaledZ > t.overscaledZ) && (this.canonical.x < t.canonical.x || !(this.canonical.x > t.canonical.x) && this.canonical.y < t.canonical.y));
            }
            wrapped() {
                return new oh(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            unwrapTo(t) {
                return new oh(this.overscaledZ, t, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            overscaleFactor() {
                return Math.pow(2, this.overscaledZ - this.canonical.z);
            }
            toUnwrapped() {
                return new ah(this.wrap, this.canonical);
            }
            toString() {
                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
            }
            getTilePoint(t) {
                return this.canonical.getTilePoint(new nh(t.x - this.wrap, t.y));
            }
        }
        function lh(t, e, r, n, i) {
            (t *= 2) < 0 && (t = -1 * t - 1);
            const s = 1 << r;
            return (s * s * t + s * i + n).toString(36) + r.toString(36) + e.toString(36);
        }
        Zi("CanonicalTileID", sh), Zi("OverscaledTileID", oh, {
            omit: [
                "terrainRttPosMatrix32f"
            ]
        });
        class uh {
            constructor(t, e, r, n = 1, i = 1, s = 1, a = 0){
                if (this.uid = t, e.height !== e.width) throw new RangeError("DEM tiles must be square");
                if (r && ![
                    "mapbox",
                    "terrarium",
                    "custom"
                ].includes(r)) return void j(`"${r}" is not a valid encoding type. Valid types include "mapbox", "terrarium" and "custom".`);
                this.stride = e.height;
                const o = this.dim = e.height - 2;
                switch(this.data = new Uint32Array(e.data.buffer), r){
                    case "terrarium":
                        this.redFactor = 256, this.greenFactor = 1, this.blueFactor = 1 / 256, this.baseShift = 32768;
                        break;
                    case "custom":
                        this.redFactor = n, this.greenFactor = i, this.blueFactor = s, this.baseShift = a;
                        break;
                    default:
                        this.redFactor = 6553.6, this.greenFactor = 25.6, this.blueFactor = .1, this.baseShift = 1e4;
                }
                for(let t = 0; t < o; t++)this.data[this._idx(-1, t)] = this.data[this._idx(0, t)], this.data[this._idx(o, t)] = this.data[this._idx(o - 1, t)], this.data[this._idx(t, -1)] = this.data[this._idx(t, 0)], this.data[this._idx(t, o)] = this.data[this._idx(t, o - 1)];
                this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(o, -1)] = this.data[this._idx(o - 1, 0)], this.data[this._idx(-1, o)] = this.data[this._idx(0, o - 1)], this.data[this._idx(o, o)] = this.data[this._idx(o - 1, o - 1)], this.min = Number.MAX_SAFE_INTEGER, this.max = Number.MIN_SAFE_INTEGER;
                for(let t = 0; t < o; t++)for(let e = 0; e < o; e++){
                    const r = this.get(t, e);
                    r > this.max && (this.max = r), r < this.min && (this.min = r);
                }
            }
            get(t, e) {
                const r = new Uint8Array(this.data.buffer), n = 4 * this._idx(t, e);
                return this.unpack(r[n], r[n + 1], r[n + 2]);
            }
            getUnpackVector() {
                return [
                    this.redFactor,
                    this.greenFactor,
                    this.blueFactor,
                    this.baseShift
                ];
            }
            _idx(t, e) {
                if (t < -1 || t >= this.dim + 1 || e < -1 || e >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                return (e + 1) * this.stride + (t + 1);
            }
            unpack(t, e, r) {
                return t * this.redFactor + e * this.greenFactor + r * this.blueFactor - this.baseShift;
            }
            getPixels() {
                return new No({
                    width: this.stride,
                    height: this.stride
                }, new Uint8Array(this.data.buffer));
            }
            backfillBorder(t, e, r) {
                if (this.dim !== t.dim) throw new Error("dem dimension mismatch");
                let n = e * this.dim, i = e * this.dim + this.dim, s = r * this.dim, a = r * this.dim + this.dim;
                switch(e){
                    case -1:
                        n = i - 1;
                        break;
                    case 1:
                        i = n + 1;
                }
                switch(r){
                    case -1:
                        s = a - 1;
                        break;
                    case 1:
                        a = s + 1;
                }
                const o = -e * this.dim, l = -r * this.dim;
                for(let e = s; e < a; e++)for(let r = n; r < i; r++)this.data[this._idx(r, e)] = t.data[this._idx(r + o, e + l)];
            }
        }
        Zi("DEMData", uh);
        class ch {
            constructor(t){
                this._stringToNumber = {}, this._numberToString = [];
                for(let e = 0; e < t.length; e++){
                    const r = t[e];
                    this._stringToNumber[r] = e, this._numberToString[e] = r;
                }
            }
            encode(t) {
                return this._stringToNumber[t];
            }
            decode(t) {
                if (t >= this._numberToString.length) throw new Error(`Out of bounds. Index requested n=${t} can't be >= this._numberToString.length ${this._numberToString.length}`);
                return this._numberToString[t];
            }
        }
        class hh {
            constructor(t, e, r, n, i){
                this.type = "Feature", this._vectorTileFeature = t, t._z = e, t._x = r, t._y = n, this.properties = t.properties, this.id = i;
            }
            get geometry() {
                return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry), this._geometry;
            }
            set geometry(t) {
                this._geometry = t;
            }
            toJSON() {
                const t = {
                    geometry: this.geometry
                };
                for(const e in this)"_geometry" !== e && "_vectorTileFeature" !== e && (t[e] = this[e]);
                return t;
            }
        }
        class ph {
            constructor(t, e){
                this.tileID = t, this.x = t.canonical.x, this.y = t.canonical.y, this.z = t.canonical.z, this.grid = new qi(M, 16, 0), this.grid3D = new qi(M, 16, 0), this.featureIndexArray = new ya, this.promoteId = e;
            }
            insert(t, e, r, n, i, s) {
                const a = this.featureIndexArray.length;
                this.featureIndexArray.emplaceBack(r, n, i);
                const o = s ? this.grid3D : this.grid;
                for(let t = 0; t < e.length; t++){
                    const r = e[t], n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ];
                    for(let t = 0; t < r.length; t++){
                        const e = r[t];
                        n[0] = Math.min(n[0], e.x), n[1] = Math.min(n[1], e.y), n[2] = Math.max(n[2], e.x), n[3] = Math.max(n[3], e.y);
                    }
                    n[0] < M && n[1] < M && n[2] >= 0 && n[3] >= 0 && o.insert(a, n[0], n[1], n[2], n[3]);
                }
            }
            loadVTLayers() {
                return this.vtLayers || (this.vtLayers = new Ql.VectorTile(new ju(this.rawTileData)).layers, this.sourceLayerCoder = new ch(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                    "_geojsonTileLayer"
                ])), this.vtLayers;
            }
            query(t, e, r, n) {
                this.loadVTLayers();
                const i = t.params, s = M / t.tileSize / t.scale, a = Qn(i.filter), o = t.queryGeometry, u = t.queryPadding * s, c = dh(o), h = this.grid.query(c.minX - u, c.minY - u, c.maxX + u, c.maxY + u), p = dh(t.cameraQueryGeometry), f = this.grid3D.query(p.minX - u, p.minY - u, p.maxX + u, p.maxY + u, (e, r, n, i)=>(function(t, e, r, n, i) {
                        for (const s of t)if (e <= s.x && r <= s.y && n >= s.x && i >= s.y) return !0;
                        const s = [
                            new l(e, r),
                            new l(e, i),
                            new l(n, i),
                            new l(n, r)
                        ];
                        if (t.length > 2) {
                            for (const e of s)if (ko(t, e)) return !0;
                        }
                        for(let e = 0; e < t.length - 1; e++)if (Mo(t[e], t[e + 1], s)) return !0;
                        return !1;
                    })(t.cameraQueryGeometry, e - u, r - u, n + u, i + u));
                for (const t of f)h.push(t);
                h.sort(yh);
                const d = {};
                let y;
                for(let l = 0; l < h.length; l++){
                    const u = h[l];
                    if (u === y) continue;
                    y = u;
                    const c = this.featureIndexArray.get(u);
                    let p = null;
                    this.loadMatchingFeature(d, c.bucketIndex, c.sourceLayerIndex, c.featureIndex, a, i.layers, i.availableImages, e, r, n, (e, r, n)=>(p || (p = co(e)), r.queryIntersectsFeature({
                            queryGeometry: o,
                            feature: e,
                            featureState: n,
                            geometry: p,
                            zoom: this.z,
                            transform: t.transform,
                            pixelsToTileUnits: s,
                            pixelPosMatrix: t.pixelPosMatrix,
                            unwrappedTileID: this.tileID.toUnwrapped(),
                            getElevation: t.getElevation
                        })));
                }
                return d;
            }
            loadMatchingFeature(t, e, r, n, i, s, a, o, l, u, c) {
                const h = this.bucketLayerIDs[e];
                if (s && !h.some((t)=>s.has(t))) return;
                const p = this.sourceLayerCoder.decode(r), f = this.vtLayers[p].feature(n);
                if (i.needGeometry) {
                    const t = ho(f, !0);
                    if (!i.filter(new fs(this.tileID.overscaledZ), t, this.tileID.canonical)) return;
                } else if (!i.filter(new fs(this.tileID.overscaledZ), f)) return;
                const d = this.getId(f, p);
                for(let e = 0; e < h.length; e++){
                    const r = h[e];
                    if (s && !s.has(r)) continue;
                    const i = o[r];
                    if (!i) continue;
                    let p = {};
                    d && u && (p = u.getState(i.sourceLayer || "_geojsonTileLayer", d));
                    const y = F({}, l[r]);
                    y.paint = fh(y.paint, i.paint, f, p, a), y.layout = fh(y.layout, i.layout, f, p, a);
                    const m = !c || c(f, i, p);
                    if (!m) continue;
                    const g = new hh(f, this.z, this.x, this.y, d);
                    g.layer = y;
                    let x = t[r];
                    void 0 === x && (x = t[r] = []), x.push({
                        featureIndex: n,
                        feature: g,
                        intersectionZ: m
                    });
                }
            }
            lookupSymbolFeatures(t, e, r, n, i, s, a, o) {
                const l = {};
                this.loadVTLayers();
                const u = Qn(i);
                for (const i of t)this.loadMatchingFeature(l, r, n, i, u, s, a, o, e);
                return l;
            }
            hasLayer(t) {
                for (const e of this.bucketLayerIDs)for (const r of e)if (t === r) return !0;
                return !1;
            }
            getId(t, e) {
                var r;
                let n = t.id;
                return this.promoteId && (n = t.properties["string" == typeof this.promoteId ? this.promoteId : this.promoteId[e]], "boolean" == typeof n && (n = Number(n)), void 0 === n && (null === (r = t.properties) || void 0 === r ? void 0 : r.cluster) && this.promoteId && (n = Number(t.properties.cluster_id))), n;
            }
        }
        function fh(t, e, r, n, i) {
            return L(t, (t, s)=>{
                const a = e instanceof ws ? e.get(s) : null;
                return a && a.evaluate ? a.evaluate(r, n, i) : a;
            });
        }
        function dh(t) {
            let e = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
            for (const s of t)e = Math.min(e, s.x), r = Math.min(r, s.y), n = Math.max(n, s.x), i = Math.max(i, s.y);
            return {
                minX: e,
                minY: r,
                maxX: n,
                maxY: i
            };
        }
        function yh(t, e) {
            return e - t;
        }
        function mh(t, e, r, n, i) {
            const s = [];
            for(let a = 0; a < t.length; a++){
                const o = t[a];
                let u;
                for(let t = 0; t < o.length - 1; t++){
                    let a = o[t], c = o[t + 1];
                    a.x < e && c.x < e || (a.x < e ? a = new l(e, a.y + (e - a.x) / (c.x - a.x) * (c.y - a.y))._round() : c.x < e && (c = new l(e, a.y + (e - a.x) / (c.x - a.x) * (c.y - a.y))._round()), a.y < r && c.y < r || (a.y < r ? a = new l(a.x + (r - a.y) / (c.y - a.y) * (c.x - a.x), r)._round() : c.y < r && (c = new l(a.x + (r - a.y) / (c.y - a.y) * (c.x - a.x), r)._round()), a.x >= n && c.x >= n || (a.x >= n ? a = new l(n, a.y + (n - a.x) / (c.x - a.x) * (c.y - a.y))._round() : c.x >= n && (c = new l(n, a.y + (n - a.x) / (c.x - a.x) * (c.y - a.y))._round()), a.y >= i && c.y >= i || (a.y >= i ? a = new l(a.x + (i - a.y) / (c.y - a.y) * (c.x - a.x), i)._round() : c.y >= i && (c = new l(a.x + (i - a.y) / (c.y - a.y) * (c.x - a.x), i)._round()), u && a.equals(u[u.length - 1]) || (u = [
                        a
                    ], s.push(u)), u.push(c)))));
                }
            }
            return s;
        }
        Zi("FeatureIndex", ph, {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        });
        class gh extends l {
            constructor(t, e, r, n){
                super(t, e), this.angle = r, void 0 !== n && (this.segment = n);
            }
            clone() {
                return new gh(this.x, this.y, this.angle, this.segment);
            }
        }
        function xh(t, e, r, n, i) {
            if (void 0 === e.segment || 0 === r) return !0;
            let s = e, a = e.segment + 1, o = 0;
            for(; o > -r / 2;){
                if (a--, a < 0) return !1;
                o -= t[a].dist(s), s = t[a];
            }
            o += t[a].dist(t[a + 1]), a++;
            const l = [];
            let u = 0;
            for(; o < r / 2;){
                const e = t[a], r = t[a + 1];
                if (!r) return !1;
                let s = t[a - 1].angleTo(e) - e.angleTo(r);
                for(s = Math.abs((s + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                    distance: o,
                    angleDelta: s
                }), u += s; o - l[0].distance > n;)u -= l.shift().angleDelta;
                if (u > i) return !1;
                a++, o += e.dist(r);
            }
            return !0;
        }
        function vh(t) {
            let e = 0;
            for(let r = 0; r < t.length - 1; r++)e += t[r].dist(t[r + 1]);
            return e;
        }
        function bh(t, e, r) {
            return t ? .6 * e * r : 0;
        }
        function wh(t, e) {
            return Math.max(t ? t.right - t.left : 0, e ? e.right - e.left : 0);
        }
        function _h(t, e, r, n, i, s) {
            const a = bh(r, i, s), o = wh(r, n) * s;
            let l = 0;
            const u = vh(t) / 2;
            for(let r = 0; r < t.length - 1; r++){
                const n = t[r], i = t[r + 1], s = n.dist(i);
                if (l + s > u) {
                    const c = (u - l) / s, h = ir.number(n.x, i.x, c), p = ir.number(n.y, i.y, c), f = new gh(h, p, i.angleTo(n), r);
                    return f._round(), !a || xh(t, f, o, a, e) ? f : void 0;
                }
                l += s;
            }
        }
        function Sh(t, e, r, n, i, s, a, o, l) {
            const u = bh(n, s, a), c = wh(n, i), h = c * a, p = 0 === t[0].x || t[0].x === l || 0 === t[0].y || t[0].y === l;
            return e - h < e / 4 && (e = h + e / 4), Ah(t, p ? e / 2 * o % e : (c / 2 + 2 * s) * a * o % e, e, u, r, h, p, !1, l);
        }
        function Ah(t, e, r, n, i, s, a, o, l) {
            const u = s / 2, c = vh(t);
            let h = 0, p = e - r, f = [];
            for(let e = 0; e < t.length - 1; e++){
                const a = t[e], o = t[e + 1], d = a.dist(o), y = o.angleTo(a);
                for(; p + r < h + d;){
                    p += r;
                    const m = (p - h) / d, g = ir.number(a.x, o.x, m), x = ir.number(a.y, o.y, m);
                    if (g >= 0 && g < l && x >= 0 && x < l && p - u >= 0 && p + u <= c) {
                        const r = new gh(g, x, y, e);
                        r._round(), n && !xh(t, r, s, n, i) || f.push(r);
                    }
                }
                h += d;
            }
            return o || f.length || a || (f = Ah(t, h / 2, r, n, i, s, a, !0, l)), f;
        }
        Zi("Anchor", gh);
        const kh = Xu;
        function Mh(t, e, r, n) {
            const i = [], s = t.image, a = s.pixelRatio, o = s.paddedRect.w - 2 * kh, u = s.paddedRect.h - 2 * kh;
            let c = {
                x1: t.left,
                y1: t.top,
                x2: t.right,
                y2: t.bottom
            };
            const h = s.stretchX || [
                [
                    0,
                    o
                ]
            ], p = s.stretchY || [
                [
                    0,
                    u
                ]
            ], f = (t, e)=>t + e[1] - e[0], d = h.reduce(f, 0), y = p.reduce(f, 0), m = o - d, g = u - y;
            let x = 0, v = d, b = 0, w = y, _ = 0, S = m, A = 0, k = g;
            if (s.content && n) {
                const e = s.content, r = e[2] - e[0], n = e[3] - e[1];
                (s.textFitWidth || s.textFitHeight) && (c = vc(t)), x = Ih(h, 0, e[0]), b = Ih(p, 0, e[1]), v = Ih(h, e[0], e[2]), w = Ih(p, e[1], e[3]), _ = e[0] - x, A = e[1] - b, S = r - v, k = n - w;
            }
            const M = c.x1, I = c.y1, z = c.x2 - M, P = c.y2 - I, C = (t, n, i, o)=>{
                const u = Ph(t.stretch - x, v, z, M), c = Ch(t.fixed - _, S, t.stretch, d), h = Ph(n.stretch - b, w, P, I), p = Ch(n.fixed - A, k, n.stretch, y), f = Ph(i.stretch - x, v, z, M), m = Ch(i.fixed - _, S, i.stretch, d), g = Ph(o.stretch - b, w, P, I), C = Ch(o.fixed - A, k, o.stretch, y), B = new l(u, h), V = new l(f, h), E = new l(f, g), T = new l(u, g), F = new l(c / a, p / a), $ = new l(m / a, C / a), L = e * Math.PI / 180;
                if (L) {
                    const t = Math.sin(L), e = Math.cos(L), r = [
                        e,
                        -t,
                        t,
                        e
                    ];
                    B._matMult(r), V._matMult(r), T._matMult(r), E._matMult(r);
                }
                const O = t.stretch + t.fixed, D = n.stretch + n.fixed;
                return {
                    tl: B,
                    tr: V,
                    bl: T,
                    br: E,
                    tex: {
                        x: s.paddedRect.x + kh + O,
                        y: s.paddedRect.y + kh + D,
                        w: i.stretch + i.fixed - O,
                        h: o.stretch + o.fixed - D
                    },
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: F,
                    pixelOffsetBR: $,
                    minFontScaleX: S / a / z,
                    minFontScaleY: k / a / P,
                    isSDF: r
                };
            };
            if (n && (s.stretchX || s.stretchY)) {
                const t = zh(h, m, d), e = zh(p, g, y);
                for(let r = 0; r < t.length - 1; r++){
                    const n = t[r], s = t[r + 1];
                    for(let t = 0; t < e.length - 1; t++)i.push(C(n, e[t], s, e[t + 1]));
                }
            } else i.push(C({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: o + 1
            }, {
                fixed: 0,
                stretch: u + 1
            }));
            return i;
        }
        function Ih(t, e, r) {
            let n = 0;
            for (const i of t)n += Math.max(e, Math.min(r, i[1])) - Math.max(e, Math.min(r, i[0]));
            return n;
        }
        function zh(t, e, r) {
            const n = [
                {
                    fixed: -1,
                    stretch: 0
                }
            ];
            for (const [e, r] of t){
                const t = n[n.length - 1];
                n.push({
                    fixed: e - t.stretch,
                    stretch: t.stretch
                }), n.push({
                    fixed: e - t.stretch,
                    stretch: t.stretch + (r - e)
                });
            }
            return n.push({
                fixed: e + kh,
                stretch: r
            }), n;
        }
        function Ph(t, e, r, n) {
            return t / e * r + n;
        }
        function Ch(t, e, r, n) {
            return t - e * r / n;
        }
        class Bh {
            constructor(t, e, r, n, i, s, a, o, u, c){
                var h;
                if (this.boxStartIndex = t.length, u) {
                    let t = s.top, e = s.bottom;
                    const r = s.collisionPadding;
                    r && (t -= r[1], e += r[3]);
                    let n = e - t;
                    n > 0 && (n = Math.max(10, n), this.circleDiameter = n);
                } else {
                    const u = (null === (h = s.image) || void 0 === h ? void 0 : h.content) && (s.image.textFitWidth || s.image.textFitHeight) ? vc(s) : {
                        x1: s.left,
                        y1: s.top,
                        x2: s.right,
                        y2: s.bottom
                    };
                    u.y1 = u.y1 * a - o[0], u.y2 = u.y2 * a + o[2], u.x1 = u.x1 * a - o[3], u.x2 = u.x2 * a + o[1];
                    const p = s.collisionPadding;
                    if (p && (u.x1 -= p[0] * a, u.y1 -= p[1] * a, u.x2 += p[2] * a, u.y2 += p[3] * a), c) {
                        const t = new l(u.x1, u.y1), e = new l(u.x2, u.y1), r = new l(u.x1, u.y2), n = new l(u.x2, u.y2), i = c * Math.PI / 180;
                        t._rotate(i), e._rotate(i), r._rotate(i), n._rotate(i), u.x1 = Math.min(t.x, e.x, r.x, n.x), u.x2 = Math.max(t.x, e.x, r.x, n.x), u.y1 = Math.min(t.y, e.y, r.y, n.y), u.y2 = Math.max(t.y, e.y, r.y, n.y);
                    }
                    t.emplaceBack(e.x, e.y, u.x1, u.y1, u.x2, u.y2, r, n, i);
                }
                this.boxEndIndex = t.length;
            }
        }
        class Vh {
            constructor(t = [], e = (t, e)=>t < e ? -1 : t > e ? 1 : 0){
                if (this.data = t, this.length = this.data.length, this.compare = e, this.length > 0) for(let t = (this.length >> 1) - 1; t >= 0; t--)this._down(t);
            }
            push(t) {
                this.data.push(t), this._up(this.length++);
            }
            pop() {
                if (0 === this.length) return;
                const t = this.data[0], e = this.data.pop();
                return --this.length > 0 && (this.data[0] = e, this._down(0)), t;
            }
            peek() {
                return this.data[0];
            }
            _up(t) {
                const { data: e, compare: r } = this, n = e[t];
                for(; t > 0;){
                    const i = t - 1 >> 1, s = e[i];
                    if (r(n, s) >= 0) break;
                    e[t] = s, t = i;
                }
                e[t] = n;
            }
            _down(t) {
                const { data: e, compare: r } = this, n = this.length >> 1, i = e[t];
                for(; t < n;){
                    let n = 1 + (t << 1);
                    const s = n + 1;
                    if (s < this.length && r(e[s], e[n]) < 0 && (n = s), r(e[n], i) >= 0) break;
                    e[t] = e[n], t = n;
                }
                e[t] = i;
            }
        }
        function Eh(t, e = 1, r = !1) {
            let n = 1 / 0, i = 1 / 0, s = -1 / 0, a = -1 / 0;
            const o = t[0];
            for(let t = 0; t < o.length; t++){
                const e = o[t];
                (!t || e.x < n) && (n = e.x), (!t || e.y < i) && (i = e.y), (!t || e.x > s) && (s = e.x), (!t || e.y > a) && (a = e.y);
            }
            const u = Math.min(s - n, a - i);
            let c = u / 2;
            const h = new Vh([], Th);
            if (0 === u) return new l(n, i);
            for(let e = n; e < s; e += u)for(let r = i; r < a; r += u)h.push(new Fh(e + c, r + c, c, t));
            let p = function(t) {
                let e = 0, r = 0, n = 0;
                const i = t[0];
                for(let t = 0, s = i.length, a = s - 1; t < s; a = t++){
                    const s = i[t], o = i[a], l = s.x * o.y - o.x * s.y;
                    r += (s.x + o.x) * l, n += (s.y + o.y) * l, e += 3 * l;
                }
                return new Fh(r / e, n / e, 0, t);
            }(t), f = h.length;
            for(; h.length;){
                const n = h.pop();
                (n.d > p.d || !p.d) && (p = n, r && console.log("found best %d after %d probes", Math.round(1e4 * n.d) / 1e4, f)), n.max - p.d <= e || (c = n.h / 2, h.push(new Fh(n.p.x - c, n.p.y - c, c, t)), h.push(new Fh(n.p.x + c, n.p.y - c, c, t)), h.push(new Fh(n.p.x - c, n.p.y + c, c, t)), h.push(new Fh(n.p.x + c, n.p.y + c, c, t)), f += 4);
            }
            return r && (console.log(`num probes: ${f}`), console.log(`best distance: ${p.d}`)), p.p;
        }
        function Th(t, e) {
            return e.max - t.max;
        }
        function Fh(t, e, r, n) {
            this.p = new l(t, e), this.h = r, this.d = function(t, e) {
                let r = !1, n = 1 / 0;
                for(let i = 0; i < e.length; i++){
                    const s = e[i];
                    for(let e = 0, i = s.length, a = i - 1; e < i; a = e++){
                        const i = s[e], o = s[a];
                        i.y > t.y != o.y > t.y && t.x < (o.x - i.x) * (t.y - i.y) / (o.y - i.y) + i.x && (r = !r), n = Math.min(n, So(t, i, o));
                    }
                }
                return (r ? 1 : -1) * Math.sqrt(n);
            }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
        }
        var $h;
        t.ay = void 0, ($h = t.ay || (t.ay = {}))[$h.center = 1] = "center", $h[$h.left = 2] = "left", $h[$h.right = 3] = "right", $h[$h.top = 4] = "top", $h[$h.bottom = 5] = "bottom", $h[$h["top-left"] = 6] = "top-left", $h[$h["top-right"] = 7] = "top-right", $h[$h["bottom-left"] = 8] = "bottom-left", $h[$h["bottom-right"] = 9] = "bottom-right";
        const Lh = 7, Oh = Number.POSITIVE_INFINITY;
        function Dh(t, e) {
            return e[1] !== Oh ? function(t, e, r) {
                let n = 0, i = 0;
                switch(e = Math.abs(e), r = Math.abs(r), t){
                    case "top-right":
                    case "top-left":
                    case "top":
                        i = r - Lh;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        i = -r + Lh;
                }
                switch(t){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        n = -e;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        n = e;
                }
                return [
                    n,
                    i
                ];
            }(t, e[0], e[1]) : function(t, e) {
                let r = 0, n = 0;
                e < 0 && (e = 0);
                const i = e / Math.SQRT2;
                switch(t){
                    case "top-right":
                    case "top-left":
                        n = i - Lh;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        n = -i + Lh;
                        break;
                    case "bottom":
                        n = -e + Lh;
                        break;
                    case "top":
                        n = e - Lh;
                }
                switch(t){
                    case "top-right":
                    case "bottom-right":
                        r = -i;
                        break;
                    case "top-left":
                    case "bottom-left":
                        r = i;
                        break;
                    case "left":
                        r = e;
                        break;
                    case "right":
                        r = -e;
                }
                return [
                    r,
                    n
                ];
            }(t, e[0]);
        }
        function Rh(t, e, r) {
            var n;
            const i = t.layout, s = null === (n = i.get("text-variable-anchor-offset")) || void 0 === n ? void 0 : n.evaluate(e, {}, r);
            if (s) {
                const t = s.values, e = [];
                for(let r = 0; r < t.length; r += 2){
                    const n = e[r] = t[r], i = t[r + 1].map((t)=>t * Lu);
                    n.startsWith("top") ? i[1] -= Lh : n.startsWith("bottom") && (i[1] += Lh), e[r + 1] = i;
                }
                return new Me(e);
            }
            const a = i.get("text-variable-anchor");
            if (a) {
                let n;
                n = void 0 !== t._unevaluatedLayout.getValue("text-radial-offset") ? [
                    i.get("text-radial-offset").evaluate(e, {}, r) * Lu,
                    Oh
                ] : i.get("text-offset").evaluate(e, {}, r).map((t)=>t * Lu);
                const s = [];
                for (const t of a)s.push(t, Dh(t, n));
                return new Me(s);
            }
            return null;
        }
        function jh(t) {
            switch(t){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }
        function Nh(e, r, n, i, s, a, o, l, u, c, h, p) {
            let f = a.textMaxSize.evaluate(r, {});
            void 0 === f && (f = o);
            const d = e.layers[0].layout, y = d.get("icon-offset").evaluate(r, {}, h), m = qh(n.horizontal), g = o / 24, x = e.tilePixelRatio * g, v = e.tilePixelRatio * f / 24, b = e.tilePixelRatio * l, w = e.tilePixelRatio * d.get("symbol-spacing"), _ = d.get("text-padding") * e.tilePixelRatio, S = function(t, e, r, n = 1) {
                const i = t.get("icon-padding").evaluate(e, {}, r), s = i && i.values;
                return [
                    s[0] * n,
                    s[1] * n,
                    s[2] * n,
                    s[3] * n
                ];
            }(d, r, h, e.tilePixelRatio), A = d.get("text-max-angle") / 180 * Math.PI, k = "viewport" !== d.get("text-rotation-alignment") && "point" !== d.get("symbol-placement"), I = "map" === d.get("icon-rotation-alignment") && "point" !== d.get("symbol-placement"), z = d.get("symbol-placement"), P = w / 2, C = d.get("icon-text-fit");
            let B;
            i && "none" !== C && (e.allowVerticalPlacement && n.vertical && (B = bc(i, n.vertical, C, d.get("icon-text-fit-padding"), y, g)), m && (i = bc(i, m, C, d.get("icon-text-fit-padding"), y, g)));
            const V = h ? p.line.getGranularityForZoomLevel(h.z) : 1, E = (l, p)=>{
                p.x < 0 || p.x >= M || p.y < 0 || p.y >= M || function(e, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, S, A, k) {
                    const M = e.addToLineVertexArray(r, n);
                    let I, z, P, C, B = 0, V = 0, E = 0, T = 0, F = -1, $ = -1;
                    const L = {};
                    let O = Na("");
                    if (e.allowVerticalPlacement && i.vertical) {
                        const t = l.layout.get("text-rotate").evaluate(w, {}, A) + 90;
                        P = new Bh(u, r, c, h, p, i.vertical, f, d, y, t), o && (C = new Bh(u, r, c, h, p, o, g, x, y, t));
                    }
                    if (s) {
                        const n = l.layout.get("icon-rotate").evaluate(w, {}), i = "none" !== l.layout.get("icon-text-fit"), a = Mh(s, n, S, i), f = o ? Mh(o, n, S, i) : void 0;
                        z = new Bh(u, r, c, h, p, s, g, x, !1, n), B = 4 * a.length;
                        const d = e.iconSizeData;
                        let y = null;
                        "source" === d.kind ? (y = [
                            _c * l.layout.get("icon-size").evaluate(w, {})
                        ], y[0] > Sc && j(`${e.layerIds[0]}: Value for "icon-size" is >= ${wc}. Reduce your "icon-size".`)) : "composite" === d.kind && (y = [
                            _c * _.compositeIconSizes[0].evaluate(w, {}, A),
                            _c * _.compositeIconSizes[1].evaluate(w, {}, A)
                        ], (y[0] > Sc || y[1] > Sc) && j(`${e.layerIds[0]}: Value for "icon-size" is >= ${wc}. Reduce your "icon-size".`)), e.addSymbols(e.icon, a, y, b, v, w, t.ah.none, r, M.lineStartIndex, M.lineLength, -1, A), F = e.icon.placedSymbolArray.length - 1, f && (V = 4 * f.length, e.addSymbols(e.icon, f, y, b, v, w, t.ah.vertical, r, M.lineStartIndex, M.lineLength, -1, A), $ = e.icon.placedSymbolArray.length - 1);
                    }
                    const D = Object.keys(i.horizontal);
                    for (const n of D){
                        const s = i.horizontal[n];
                        if (!I) {
                            O = Na(s.text);
                            const t = l.layout.get("text-rotate").evaluate(w, {}, A);
                            I = new Bh(u, r, c, h, p, s, f, d, y, t);
                        }
                        const o = 1 === s.positionedLines.length;
                        if (E += Uh(e, r, s, a, l, y, w, m, M, i.vertical ? t.ah.horizontal : t.ah.horizontalOnly, o ? D : [
                            n
                        ], L, F, _, A), o) break;
                    }
                    i.vertical && (T += Uh(e, r, i.vertical, a, l, y, w, m, M, t.ah.vertical, [
                        "vertical"
                    ], L, $, _, A));
                    const R = I ? I.boxStartIndex : e.collisionBoxArray.length, N = I ? I.boxEndIndex : e.collisionBoxArray.length, U = P ? P.boxStartIndex : e.collisionBoxArray.length, q = P ? P.boxEndIndex : e.collisionBoxArray.length, G = z ? z.boxStartIndex : e.collisionBoxArray.length, Z = z ? z.boxEndIndex : e.collisionBoxArray.length, K = C ? C.boxStartIndex : e.collisionBoxArray.length, X = C ? C.boxEndIndex : e.collisionBoxArray.length;
                    let H = -1;
                    const Y = (t, e)=>t && t.circleDiameter ? Math.max(t.circleDiameter, e) : e;
                    H = Y(I, H), H = Y(P, H), H = Y(z, H), H = Y(C, H);
                    const J = H > -1 ? 1 : 0;
                    J && (H *= k / Lu), e.glyphOffsetArray.length >= Ec.MAX_GLYPHS && j("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== w.sortKey && e.addToSortKeyRanges(e.symbolInstances.length, w.sortKey);
                    const W = Rh(l, w, A), [Q, tt] = function(e, r) {
                        const n = e.length, i = null == r ? void 0 : r.values;
                        if ((null == i ? void 0 : i.length) > 0) for(let r = 0; r < i.length; r += 2){
                            const n = i[r + 1];
                            e.emplaceBack(t.ay[i[r]], n[0], n[1]);
                        }
                        return [
                            n,
                            e.length
                        ];
                    }(e.textAnchorOffsets, W);
                    e.symbolInstances.emplaceBack(r.x, r.y, L.right >= 0 ? L.right : -1, L.center >= 0 ? L.center : -1, L.left >= 0 ? L.left : -1, L.vertical || -1, F, $, O, R, N, U, q, G, Z, K, X, c, E, T, B, V, J, 0, f, H, Q, tt);
                }(e, p, l, n, i, s, B, e.layers[0], e.collisionBoxArray, r.index, r.sourceLayerIndex, e.index, x, [
                    _,
                    _,
                    _,
                    _
                ], k, u, b, S, I, y, r, a, c, h, o);
            };
            if ("line" === z) for (const t of mh(r.geometry, 0, 0, M, M)){
                const r = Cl(t, V), s = Sh(r, w, A, n.vertical || m, i, 24, v, e.overscaling, M);
                for (const t of s)m && Gh(e, m.text, P, t) || E(r, t);
            }
            else if ("line-center" === z) {
                for (const t of r.geometry)if (t.length > 1) {
                    const e = Cl(t, V), r = _h(e, A, n.vertical || m, i, 24, v);
                    r && E(e, r);
                }
            } else if ("Polygon" === r.type) for (const t of Ur(r.geometry, 0)){
                const e = Eh(t, 16);
                E(Cl(t[0], V, !0), new gh(e.x, e.y, 0));
            }
            else if ("LineString" === r.type) for (const t of r.geometry){
                const e = Cl(t, V);
                E(e, new gh(e[0].x, e[0].y, 0));
            }
            else if ("Point" === r.type) for (const t of r.geometry)for (const e of t)E([
                e
            ], new gh(e.x, e.y, 0));
        }
        function Uh(t, e, r, n, i, s, a, o, u, c, h, p, f, d, y) {
            const m = function(t, e, r, n, i, s, a, o) {
                const u = n.layout.get("text-rotate").evaluate(s, {}) * Math.PI / 180, c = [];
                for (const t of e.positionedLines)for (const n of t.positionedGlyphs){
                    if (!n.rect) continue;
                    const s = n.rect || {};
                    let h = Zu + 1, p = !0, f = 1, d = 0;
                    const y = (i || o) && n.vertical, m = n.metrics.advance * n.scale / 2;
                    if (o && e.verticalizable && (d = t.lineOffset / 2 - (n.imageName ? -(Lu - n.metrics.width * n.scale) / 2 : (n.scale - 1) * Lu)), n.imageName) {
                        const t = a[n.imageName];
                        p = t.sdf, f = t.pixelRatio, h = Xu / f;
                    }
                    const g = i ? [
                        n.x + m,
                        n.y
                    ] : [
                        0,
                        0
                    ];
                    let x = i ? [
                        0,
                        0
                    ] : [
                        n.x + m + r[0],
                        n.y + r[1] - d
                    ], v = [
                        0,
                        0
                    ];
                    y && (v = x, x = [
                        0,
                        0
                    ]);
                    const b = n.metrics.isDoubleResolution ? 2 : 1, w = (n.metrics.left - h) * n.scale - m + x[0], _ = (-n.metrics.top - h) * n.scale + x[1], S = w + s.w / b * n.scale / f, A = _ + s.h / b * n.scale / f, k = new l(w, _), M = new l(S, _), I = new l(w, A), z = new l(S, A);
                    if (y) {
                        const t = new l(-m, m - Wu), e = -Math.PI / 2, r = Lu / 2 - m, i = new l(5 - Wu - r, -(n.imageName ? r : 0)), s = new l(...v);
                        k._rotateAround(e, t)._add(i)._add(s), M._rotateAround(e, t)._add(i)._add(s), I._rotateAround(e, t)._add(i)._add(s), z._rotateAround(e, t)._add(i)._add(s);
                    }
                    if (u) {
                        const t = Math.sin(u), e = Math.cos(u), r = [
                            e,
                            -t,
                            t,
                            e
                        ];
                        k._matMult(r), M._matMult(r), I._matMult(r), z._matMult(r);
                    }
                    const P = new l(0, 0), C = new l(0, 0);
                    c.push({
                        tl: k,
                        tr: M,
                        bl: I,
                        br: z,
                        tex: s,
                        writingMode: e.writingMode,
                        glyphOffset: g,
                        sectionIndex: n.sectionIndex,
                        isSDF: p,
                        pixelOffsetTL: P,
                        pixelOffsetBR: C,
                        minFontScaleX: 0,
                        minFontScaleY: 0
                    });
                }
                return c;
            }(0, r, o, i, s, a, n, t.allowVerticalPlacement), g = t.textSizeData;
            let x = null;
            "source" === g.kind ? (x = [
                _c * i.layout.get("text-size").evaluate(a, {})
            ], x[0] > Sc && j(`${t.layerIds[0]}: Value for "text-size" is >= ${wc}. Reduce your "text-size".`)) : "composite" === g.kind && (x = [
                _c * d.compositeTextSizes[0].evaluate(a, {}, y),
                _c * d.compositeTextSizes[1].evaluate(a, {}, y)
            ], (x[0] > Sc || x[1] > Sc) && j(`${t.layerIds[0]}: Value for "text-size" is >= ${wc}. Reduce your "text-size".`)), t.addSymbols(t.text, m, x, o, s, a, c, e, u.lineStartIndex, u.lineLength, f, y);
            for (const e of h)p[e] = t.text.placedSymbolArray.length - 1;
            return 4 * m.length;
        }
        function qh(t) {
            for(const e in t)return t[e];
            return null;
        }
        function Gh(t, e, r, n) {
            const i = t.compareText;
            if (e in i) {
                const t = i[e];
                for(let e = t.length - 1; e >= 0; e--)if (n.dist(t[e]) < r) return !0;
            } else i[e] = [];
            return i[e].push(n), !1;
        }
        const Zh = [
            Int8Array,
            Uint8Array,
            Uint8ClampedArray,
            Int16Array,
            Uint16Array,
            Int32Array,
            Uint32Array,
            Float32Array,
            Float64Array
        ];
        class Kh {
            static from(t) {
                if (!(t instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
                const [e, r] = new Uint8Array(t, 0, 2);
                if (219 !== e) throw new Error("Data does not appear to be in a KDBush format.");
                const n = r >> 4;
                if (1 !== n) throw new Error(`Got v${n} data when expected v1.`);
                const i = Zh[15 & r];
                if (!i) throw new Error("Unrecognized array type.");
                const [s] = new Uint16Array(t, 2, 1), [a] = new Uint32Array(t, 4, 1);
                return new Kh(a, s, i, t);
            }
            constructor(t, e = 64, r = Float64Array, n){
                if (isNaN(t) || t < 0) throw new Error(`Unpexpected numItems value: ${t}.`);
                this.numItems = +t, this.nodeSize = Math.min(Math.max(+e, 2), 65535), this.ArrayType = r, this.IndexArrayType = t < 65536 ? Uint16Array : Uint32Array;
                const i = Zh.indexOf(this.ArrayType), s = 2 * t * this.ArrayType.BYTES_PER_ELEMENT, a = t * this.IndexArrayType.BYTES_PER_ELEMENT, o = (8 - a % 8) % 8;
                if (i < 0) throw new Error(`Unexpected typed array class: ${r}.`);
                n && n instanceof ArrayBuffer ? (this.data = n, this.ids = new this.IndexArrayType(this.data, 8, t), this.coords = new this.ArrayType(this.data, 8 + a + o, 2 * t), this._pos = 2 * t, this._finished = !0) : (this.data = new ArrayBuffer(8 + s + a + o), this.ids = new this.IndexArrayType(this.data, 8, t), this.coords = new this.ArrayType(this.data, 8 + a + o, 2 * t), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([
                    219,
                    16 + i
                ]), new Uint16Array(this.data, 2, 1)[0] = e, new Uint32Array(this.data, 4, 1)[0] = t);
            }
            add(t, e) {
                const r = this._pos >> 1;
                return this.ids[r] = r, this.coords[this._pos++] = t, this.coords[this._pos++] = e, r;
            }
            finish() {
                const t = this._pos >> 1;
                if (t !== this.numItems) throw new Error(`Added ${t} items when expected ${this.numItems}.`);
                return Xh(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
            }
            range(t, e, r, n) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: i, coords: s, nodeSize: a } = this, o = [
                    0,
                    i.length - 1,
                    0
                ], l = [];
                for(; o.length;){
                    const u = o.pop() || 0, c = o.pop() || 0, h = o.pop() || 0;
                    if (c - h <= a) {
                        for(let a = h; a <= c; a++){
                            const o = s[2 * a], u = s[2 * a + 1];
                            o >= t && o <= r && u >= e && u <= n && l.push(i[a]);
                        }
                        continue;
                    }
                    const p = h + c >> 1, f = s[2 * p], d = s[2 * p + 1];
                    f >= t && f <= r && d >= e && d <= n && l.push(i[p]), (0 === u ? t <= f : e <= d) && (o.push(h), o.push(p - 1), o.push(1 - u)), (0 === u ? r >= f : n >= d) && (o.push(p + 1), o.push(c), o.push(1 - u));
                }
                return l;
            }
            within(t, e, r) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: n, coords: i, nodeSize: s } = this, a = [
                    0,
                    n.length - 1,
                    0
                ], o = [], l = r * r;
                for(; a.length;){
                    const u = a.pop() || 0, c = a.pop() || 0, h = a.pop() || 0;
                    if (c - h <= s) {
                        for(let r = h; r <= c; r++)Wh(i[2 * r], i[2 * r + 1], t, e) <= l && o.push(n[r]);
                        continue;
                    }
                    const p = h + c >> 1, f = i[2 * p], d = i[2 * p + 1];
                    Wh(f, d, t, e) <= l && o.push(n[p]), (0 === u ? t - r <= f : e - r <= d) && (a.push(h), a.push(p - 1), a.push(1 - u)), (0 === u ? t + r >= f : e + r >= d) && (a.push(p + 1), a.push(c), a.push(1 - u));
                }
                return o;
            }
        }
        function Xh(t, e, r, n, i, s) {
            if (i - n <= r) return;
            const a = n + i >> 1;
            Hh(t, e, a, n, i, s), Xh(t, e, r, n, a - 1, 1 - s), Xh(t, e, r, a + 1, i, 1 - s);
        }
        function Hh(t, e, r, n, i, s) {
            for(; i > n;){
                if (i - n > 600) {
                    const a = i - n + 1, o = r - n + 1, l = Math.log(a), u = .5 * Math.exp(2 * l / 3), c = .5 * Math.sqrt(l * u * (a - u) / a) * (o - a / 2 < 0 ? -1 : 1);
                    Hh(t, e, r, Math.max(n, Math.floor(r - o * u / a + c)), Math.min(i, Math.floor(r + (a - o) * u / a + c)), s);
                }
                const a = e[2 * r + s];
                let o = n, l = i;
                for(Yh(t, e, n, r), e[2 * i + s] > a && Yh(t, e, n, i); o < l;){
                    for(Yh(t, e, o, l), o++, l--; e[2 * o + s] < a;)o++;
                    for(; e[2 * l + s] > a;)l--;
                }
                e[2 * n + s] === a ? Yh(t, e, n, l) : (l++, Yh(t, e, l, i)), l <= r && (n = l + 1), r <= l && (i = l - 1);
            }
        }
        function Yh(t, e, r, n) {
            Jh(t, r, n), Jh(e, 2 * r, 2 * n), Jh(e, 2 * r + 1, 2 * n + 1);
        }
        function Jh(t, e, r) {
            const n = t[e];
            t[e] = t[r], t[r] = n;
        }
        function Wh(t, e, r, n) {
            const i = t - r, s = e - n;
            return i * i + s * s;
        }
        var Qh;
        t.ck = void 0, (Qh = t.ck || (t.ck = {})).create = "create", Qh.load = "load", Qh.fullLoad = "fullLoad";
        let tp = null, ep = [];
        const rp = 1e3 / 60, np = "loadTime", ip = "fullLoadTime", sp = {
            mark (t) {
                performance.mark(t);
            },
            frame (t) {
                const e = t;
                null != tp && ep.push(e - tp), tp = e;
            },
            clearMetrics () {
                tp = null, ep = [], performance.clearMeasures(np), performance.clearMeasures(ip);
                for(const e in t.ck)performance.clearMarks(t.ck[e]);
            },
            getPerformanceMetrics () {
                performance.measure(np, t.ck.create, t.ck.load), performance.measure(ip, t.ck.create, t.ck.fullLoad);
                const e = performance.getEntriesByName(np)[0].duration, r = performance.getEntriesByName(ip)[0].duration, n = ep.length, i = 1 / (ep.reduce((t, e)=>t + e, 0) / n / 1e3), s = ep.filter((t)=>t > rp).reduce((t, e)=>t + (e - rp) / rp, 0);
                return {
                    loadTime: e,
                    fullLoadTime: r,
                    fps: i,
                    percentDroppedFrames: s / (n + s) * 100,
                    totalFrames: n
                };
            }
        };
        t.$ = nh, t.A = g, t.B = ir, t.C = fs, t.D = _s, t.E = ft, t.F = Ri, t.G = function(t) {
            if (null == q) {
                const e = t.navigator ? t.navigator.userAgent : null;
                q = !!t.safari || !(!e || !(/\b(iPad|iPhone|iPod)\b/.test(e) || e.match("Safari") && !e.match("Chrome")));
            }
            return q;
        }, t.H = class {
            constructor(t, e){
                this.target = t, this.mapId = e, this.resolveRejects = {}, this.tasks = {}, this.taskQueue = [], this.abortControllers = {}, this.messageHandlers = {}, this.invoker = new Zc(()=>this.process()), this.subscription = Y(this.target, "message", (t)=>this.receive(t), !1), this.globalScope = U(self) ? t : window;
            }
            registerMessageHandler(t, e) {
                this.messageHandlers[t] = e;
            }
            sendAsync(t, e) {
                return new Promise((r, n)=>{
                    const i = Math.round(1e18 * Math.random()).toString(36).substring(0, 10), s = e ? Y(e.signal, "abort", ()=>{
                        null == s || s.unsubscribe(), delete this.resolveRejects[i];
                        const e = {
                            id: i,
                            type: "<cancel>",
                            origin: location.origin,
                            targetMapId: t.targetMapId,
                            sourceMapId: this.mapId
                        };
                        this.target.postMessage(e);
                    }, Kc) : null;
                    this.resolveRejects[i] = {
                        resolve: (t)=>{
                            null == s || s.unsubscribe(), r(t);
                        },
                        reject: (t)=>{
                            null == s || s.unsubscribe(), n(t);
                        }
                    };
                    const a = [], o = Object.assign(Object.assign({}, t), {
                        id: i,
                        sourceMapId: this.mapId,
                        origin: location.origin,
                        data: Yi(t.data, a)
                    });
                    this.target.postMessage(o, {
                        transfer: a
                    });
                });
            }
            receive(t) {
                const e = t.data, r = e.id;
                if (!("file://" !== e.origin && "file://" !== location.origin && "resource://android" !== e.origin && "resource://android" !== location.origin && e.origin !== location.origin || e.targetMapId && this.mapId !== e.targetMapId)) {
                    if ("<cancel>" === e.type) {
                        delete this.tasks[r];
                        const t = this.abortControllers[r];
                        return delete this.abortControllers[r], void (t && t.abort());
                    }
                    if (U(self) || e.mustQueue) return this.tasks[r] = e, this.taskQueue.push(r), void this.invoker.trigger();
                    this.processTask(r, e);
                }
            }
            process() {
                if (0 === this.taskQueue.length) return;
                const t = this.taskQueue.shift(), e = this.tasks[t];
                delete this.tasks[t], this.taskQueue.length > 0 && this.invoker.trigger(), e && this.processTask(t, e);
            }
            processTask(t, r) {
                return e(this, void 0, void 0, function*() {
                    if ("<response>" === r.type) {
                        const e = this.resolveRejects[t];
                        if (delete this.resolveRejects[t], !e) return;
                        return void (r.error ? e.reject(Ji(r.error)) : e.resolve(Ji(r.data)));
                    }
                    if (!this.messageHandlers[r.type]) return void this.completeTask(t, new Error(`Could not find a registered handler for ${r.type}, map ID: ${this.mapId}, available handlers: ${Object.keys(this.messageHandlers).join(", ")}`));
                    const e = Ji(r.data), n = new AbortController;
                    this.abortControllers[t] = n;
                    try {
                        const i = yield this.messageHandlers[r.type](r.sourceMapId, e, n);
                        this.completeTask(t, null, i);
                    } catch (e) {
                        this.completeTask(t, e);
                    }
                });
            }
            completeTask(t, e, r) {
                const n = [];
                delete this.abortControllers[t];
                const i = {
                    id: t,
                    type: "<response>",
                    sourceMapId: this.mapId,
                    origin: location.origin,
                    error: e ? Yi(e) : null,
                    data: Yi(r, n)
                };
                this.target.postMessage(i, {
                    transfer: n
                });
            }
            remove() {
                this.invoker.remove(), this.subscription.unsubscribe();
            }
        }, t.I = Hu, t.J = it, t.K = function() {
            var t = new g(16);
            return g != Float32Array && (t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0), t[0] = 1, t[5] = 1, t[10] = 1, t[15] = 1, t;
        }, t.L = function(t, e, r) {
            var n, i, s, a, o, l, u, c, h, p, f, d, y = r[0], m = r[1], g = r[2];
            return e === t ? (t[12] = e[0] * y + e[4] * m + e[8] * g + e[12], t[13] = e[1] * y + e[5] * m + e[9] * g + e[13], t[14] = e[2] * y + e[6] * m + e[10] * g + e[14], t[15] = e[3] * y + e[7] * m + e[11] * g + e[15]) : (i = e[1], s = e[2], a = e[3], o = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = e[9], f = e[10], d = e[11], t[0] = n = e[0], t[1] = i, t[2] = s, t[3] = a, t[4] = o, t[5] = l, t[6] = u, t[7] = c, t[8] = h, t[9] = p, t[10] = f, t[11] = d, t[12] = n * y + o * m + h * g + e[12], t[13] = i * y + l * m + p * g + e[13], t[14] = s * y + u * m + f * g + e[14], t[15] = a * y + c * m + d * g + e[15]), t;
        }, t.M = function(t, e, r) {
            var n = r[0], i = r[1], s = r[2];
            return t[0] = e[0] * n, t[1] = e[1] * n, t[2] = e[2] * n, t[3] = e[3] * n, t[4] = e[4] * i, t[5] = e[5] * i, t[6] = e[6] * i, t[7] = e[7] * i, t[8] = e[8] * s, t[9] = e[9] * s, t[10] = e[10] * s, t[11] = e[11] * s, t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
        }, t.N = function(t, e, r) {
            var n = e[0], i = e[1], s = e[2], a = e[3], o = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = e[9], f = e[10], d = e[11], y = e[12], m = e[13], g = e[14], x = e[15], v = r[0], b = r[1], w = r[2], _ = r[3];
            return t[0] = v * n + b * o + w * h + _ * y, t[1] = v * i + b * l + w * p + _ * m, t[2] = v * s + b * u + w * f + _ * g, t[3] = v * a + b * c + w * d + _ * x, t[4] = (v = r[4]) * n + (b = r[5]) * o + (w = r[6]) * h + (_ = r[7]) * y, t[5] = v * i + b * l + w * p + _ * m, t[6] = v * s + b * u + w * f + _ * g, t[7] = v * a + b * c + w * d + _ * x, t[8] = (v = r[8]) * n + (b = r[9]) * o + (w = r[10]) * h + (_ = r[11]) * y, t[9] = v * i + b * l + w * p + _ * m, t[10] = v * s + b * u + w * f + _ * g, t[11] = v * a + b * c + w * d + _ * x, t[12] = (v = r[12]) * n + (b = r[13]) * o + (w = r[14]) * h + (_ = r[15]) * y, t[13] = v * i + b * l + w * p + _ * m, t[14] = v * s + b * u + w * f + _ * g, t[15] = v * a + b * c + w * d + _ * x, t;
        }, t.O = function(t, e) {
            const r = {};
            for(let n = 0; n < e.length; n++){
                const i = e[n];
                i in t && (r[i] = t[i]);
            }
            return r;
        }, t.P = l, t.Q = Hc, t.R = No, t.S = Qc, t.T = ms, t.U = Wc, t.V = f, t.W = d, t.X = K, t.Y = oh, t.Z = M, t._ = e, t.a = rt, t.a$ = function(t, e, r) {
            var n = Math.sin(r), i = Math.cos(r), s = e[4], a = e[5], o = e[6], l = e[7], u = e[8], c = e[9], h = e[10], p = e[11];
            return e !== t && (t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[4] = s * i + u * n, t[5] = a * i + c * n, t[6] = o * i + h * n, t[7] = l * i + p * n, t[8] = u * i - s * n, t[9] = c * i - a * n, t[10] = h * i - o * n, t[11] = p * i - l * n, t;
        }, t.a0 = 25, t.a1 = sh, t.a2 = (t)=>{
            const e = window.document.createElement("video");
            return e.muted = !0, new Promise((r)=>{
                e.onloadstart = ()=>{
                    r(e);
                };
                for (const r of t){
                    const t = window.document.createElement("source");
                    lt(r) || (e.crossOrigin = "Anonymous"), t.src = r, e.appendChild(t);
                }
            });
        }, t.a3 = Mt, t.a4 = function() {
            return $++;
        }, t.a5 = sa, t.a6 = Ec, t.a7 = Qn, t.a8 = ho, t.a9 = hh, t.aA = jh, t.aB = hc, t.aC = Kh, t.aD = Es, t.aE = kl, t.aF = ma, t.aG = Va, t.aH = za, t.aI = function(t) {
            return Math.pow(2, t);
        }, t.aJ = 85.051129, t.aK = th, t.aL = T, t.aM = J, t.aN = rh, t.aO = function(t, e, r) {
            return t[0] = e[0] * r, t[1] = e[1] * r, t[2] = e[2] * r, t;
        }, t.aP = function(t, e, r) {
            return t[0] = e[0] + r[0], t[1] = e[1] + r[1], t[2] = e[2] + r[2], t;
        }, t.aQ = function(t) {
            var e = new g(3);
            return e[0] = t[0], e[1] = t[1], e[2] = t[2], e;
        }, t.aR = function(t, e, r) {
            return t[0] = e[0] * r[0], t[1] = e[1] * r[1], t[2] = e[2] * r[2], t[3] = e[3] * r[3], t;
        }, t.aS = function(t, e, r) {
            return t[0] = e[0] - r[0], t[1] = e[1] - r[1], t[2] = e[2] - r[2], t;
        }, t.aT = function(t, e) {
            var r = e[0], n = e[1], i = e[2], s = r * r + n * n + i * i;
            return s > 0 && (s = 1 / Math.sqrt(s)), t[0] = e[0] * s, t[1] = e[1] * s, t[2] = e[2] * s, t;
        }, t.aU = function(t, e, r) {
            var n = e[0], i = e[1], s = e[2], a = r[0], o = r[1], l = r[2];
            return t[0] = i * l - s * o, t[1] = s * a - n * l, t[2] = n * o - i * a, t;
        }, t.aV = function(t, e) {
            return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
        }, t.aW = ah, t.aX = lh, t.aY = function(t, e, r, n, i) {
            var s, a = 1 / Math.tan(e / 2);
            return t[0] = a / r, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = a, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[11] = -1, t[12] = 0, t[13] = 0, t[15] = 0, null != i && i !== 1 / 0 ? (t[10] = (i + n) * (s = 1 / (n - i)), t[14] = 2 * i * n * s) : (t[10] = -1, t[14] = -2 * n), t;
        }, t.aZ = function(t) {
            var e = new g(16);
            return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
        }, t.a_ = function(t, e, r) {
            var n = Math.sin(r), i = Math.cos(r), s = e[0], a = e[1], o = e[2], l = e[3], u = e[4], c = e[5], h = e[6], p = e[7];
            return e !== t && (t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[0] = s * i + u * n, t[1] = a * i + c * n, t[2] = o * i + h * n, t[3] = l * i + p * n, t[4] = u * i - s * n, t[5] = c * i - a * n, t[6] = h * i - o * n, t[7] = p * i - l * n, t;
        }, t.aa = function(t) {
            const e = {};
            if (t.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (t, r, n, i)=>{
                const s = n || i;
                return e[r] = !s || s.toLowerCase(), "";
            }), e["max-age"]) {
                const t = parseInt(e["max-age"], 10);
                isNaN(t) ? delete e["max-age"] : e["max-age"] = t;
            }
            return e;
        }, t.ab = function(t) {
            return Math.log(t) / Math.LN2;
        }, t.ac = function(t) {
            var e = t[0], r = t[1];
            return e * e + r * r;
        }, t.ad = function(t) {
            return t * Math.PI / 180;
        }, t.ae = E, t.af = function(t, e) {
            const r = [];
            for(const n in t)n in e || r.push(n);
            return r;
        }, t.ag = function(t, e) {
            let r = 0, n = 0;
            if ("constant" === t.kind) n = t.layoutSize;
            else if ("source" !== t.kind) {
                const { interpolationType: i, minZoom: s, maxZoom: a } = t, o = i ? E(rr.interpolationFactor(i, e, s, a), 0, 1) : 0;
                "camera" === t.kind ? n = ir.number(t.minSize, t.maxSize, o) : r = o;
            }
            return {
                uSizeT: r,
                uSize: n
            };
        }, t.ai = function(t, { uSize: e, uSizeT: r }, { lowerSize: n, upperSize: i }) {
            return "source" === t.kind ? n / _c : "composite" === t.kind ? ir.number(n / _c, i / _c, r) : e;
        }, t.aj = function(t, e) {
            var r = e[0], n = e[1], i = e[2], s = e[3], a = e[4], o = e[5], l = e[6], u = e[7], c = e[8], h = e[9], p = e[10], f = e[11], d = e[12], y = e[13], m = e[14], g = e[15], x = r * o - n * a, v = r * l - i * a, b = r * u - s * a, w = n * l - i * o, _ = n * u - s * o, S = i * u - s * l, A = c * y - h * d, k = c * m - p * d, M = c * g - f * d, I = h * m - p * y, z = h * g - f * y, P = p * g - f * m, C = x * P - v * z + b * I + w * M - _ * k + S * A;
            return C ? (t[0] = (o * P - l * z + u * I) * (C = 1 / C), t[1] = (i * z - n * P - s * I) * C, t[2] = (y * S - m * _ + g * w) * C, t[3] = (p * _ - h * S - f * w) * C, t[4] = (l * M - a * P - u * k) * C, t[5] = (r * P - i * M + s * k) * C, t[6] = (m * b - d * S - g * v) * C, t[7] = (c * S - p * b + f * v) * C, t[8] = (a * z - o * M + u * A) * C, t[9] = (n * M - r * z - s * A) * C, t[10] = (d * _ - y * b + g * x) * C, t[11] = (h * b - c * _ - f * x) * C, t[12] = (o * k - a * I - l * A) * C, t[13] = (r * I - n * k + i * A) * C, t[14] = (y * v - d * w - m * x) * C, t[15] = (c * w - h * v + p * x) * C, t) : null;
        }, t.ak = A, t.al = function(t) {
            return Math.hypot(t[0], t[1]);
        }, t.am = function(t) {
            return t[0] = 0, t[1] = 0, t;
        }, t.an = function(t, e, r) {
            return t[0] = e[0] * r, t[1] = e[1] * r, t;
        }, t.ao = Pc, t.ap = _, t.aq = function(t, e, r, n) {
            const i = e.y - t.y, s = e.x - t.x, a = n.y - r.y, o = n.x - r.x, u = a * s - o * i;
            if (0 === u) return null;
            const c = (o * (t.y - r.y) - a * (t.x - r.x)) / u;
            return new l(t.x + c * s, t.y + c * i);
        }, t.ar = mh, t.as = mo, t.at = v, t.au = function(t) {
            let e = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
            for (const s of t)e = Math.min(e, s.x), r = Math.min(r, s.y), n = Math.max(n, s.x), i = Math.max(i, s.y);
            return [
                e,
                r,
                n,
                i
            ];
        }, t.av = Lu, t.aw = I, t.ax = function(t, e, r, n, i = !1) {
            if (!r[0] && !r[1]) return [
                0,
                0
            ];
            const s = i ? "map" === n ? -t.bearingInRadians : 0 : "viewport" === n ? t.bearingInRadians : 0;
            if (s) {
                const t = Math.sin(s), e = Math.cos(s);
                r = [
                    r[0] * e - r[1] * t,
                    r[0] * t + r[1] * e
                ];
            }
            return [
                i ? r[0] : I(e, r[0], t.zoom),
                i ? r[1] : I(e, r[1], t.zoom)
            ];
        }, t.az = kc, t.b = G, t.b$ = (t)=>"symbol" === t.type, t.b0 = function() {
            const t = new Float32Array(16);
            return v(t), t;
        }, t.b1 = function() {
            const t = new Float64Array(16);
            return v(t), t;
        }, t.b2 = function() {
            return new Float64Array(16);
        }, t.b3 = function(t, e, r) {
            const n = new Float64Array(4);
            return function(t, e, r, n) {
                var i = .5 * Math.PI / 180;
                e *= i, r *= i, n *= i;
                var s = Math.sin(e), a = Math.cos(e), o = Math.sin(r), l = Math.cos(r), u = Math.sin(n), c = Math.cos(n);
                t[0] = s * l * c - a * o * u, t[1] = a * o * c + s * l * u, t[2] = a * l * u - s * o * c, t[3] = a * l * c + s * o * u;
            }(n, t, e - 90, r), n;
        }, t.b4 = function(t, e, r, n) {
            var i, s, a, o, l, u = e[0], c = e[1], h = e[2], p = e[3], f = r[0], d = r[1], y = r[2], g = r[3];
            return (s = u * f + c * d + h * y + p * g) < 0 && (s = -s, f = -f, d = -d, y = -y, g = -g), 1 - s > m ? (i = Math.acos(s), a = Math.sin(i), o = Math.sin((1 - n) * i) / a, l = Math.sin(n * i) / a) : (o = 1 - n, l = n), t[0] = o * u + l * f, t[1] = o * c + l * d, t[2] = o * h + l * y, t[3] = o * p + l * g, t;
        }, t.b5 = function(t) {
            const e = new Float64Array(9);
            var r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v;
            h = (i = (n = t)[0]) * (l = i + i), p = (s = n[1]) * l, d = (a = n[2]) * l, y = a * (u = s + s), g = (o = n[3]) * l, x = o * u, v = o * (c = a + a), (r = e)[0] = 1 - (f = s * u) - (m = a * c), r[3] = p - v, r[6] = d + x, r[1] = p + v, r[4] = 1 - h - m, r[7] = y - g, r[2] = d - x, r[5] = y + g, r[8] = 1 - h - f;
            const b = J(-Math.asin(E(e[2], -1, 1)));
            let w, _;
            return Math.hypot(e[5], e[8]) < .001 ? (w = 0, _ = -J(Math.atan2(e[3], e[4]))) : (w = J(0 === e[5] && 0 === e[8] ? 0 : Math.atan2(e[5], e[8])), _ = J(0 === e[1] && 0 === e[0] ? 0 : Math.atan2(e[1], e[0]))), {
                roll: w,
                pitch: b + 90,
                bearing: _
            };
        }, t.b6 = function(t, e) {
            return t.roll == e.roll && t.pitch == e.pitch && t.bearing == e.bearing;
        }, t.b7 = xe, t.b8 = Xa, t.b9 = Ml, t.bA = function(t, e) {
            if (!t) return [
                {
                    command: "setStyle",
                    args: [
                        e
                    ]
                }
            ];
            let r = [];
            try {
                if (!gt(t.version, e.version)) return [
                    {
                        command: "setStyle",
                        args: [
                            e
                        ]
                    }
                ];
                gt(t.center, e.center) || r.push({
                    command: "setCenter",
                    args: [
                        e.center
                    ]
                }), gt(t.centerAltitude, e.centerAltitude) || r.push({
                    command: "setCenterAltitude",
                    args: [
                        e.centerAltitude
                    ]
                }), gt(t.zoom, e.zoom) || r.push({
                    command: "setZoom",
                    args: [
                        e.zoom
                    ]
                }), gt(t.bearing, e.bearing) || r.push({
                    command: "setBearing",
                    args: [
                        e.bearing
                    ]
                }), gt(t.pitch, e.pitch) || r.push({
                    command: "setPitch",
                    args: [
                        e.pitch
                    ]
                }), gt(t.roll, e.roll) || r.push({
                    command: "setRoll",
                    args: [
                        e.roll
                    ]
                }), gt(t.sprite, e.sprite) || r.push({
                    command: "setSprite",
                    args: [
                        e.sprite
                    ]
                }), gt(t.glyphs, e.glyphs) || r.push({
                    command: "setGlyphs",
                    args: [
                        e.glyphs
                    ]
                }), gt(t.transition, e.transition) || r.push({
                    command: "setTransition",
                    args: [
                        e.transition
                    ]
                }), gt(t.light, e.light) || r.push({
                    command: "setLight",
                    args: [
                        e.light
                    ]
                }), gt(t.terrain, e.terrain) || r.push({
                    command: "setTerrain",
                    args: [
                        e.terrain
                    ]
                }), gt(t.sky, e.sky) || r.push({
                    command: "setSky",
                    args: [
                        e.sky
                    ]
                }), gt(t.projection, e.projection) || r.push({
                    command: "setProjection",
                    args: [
                        e.projection
                    ]
                });
                const n = {}, i = [];
                !function(t, e, r, n) {
                    let i;
                    for(i in e = e || {}, t = t || {})Object.prototype.hasOwnProperty.call(t, i) && (Object.prototype.hasOwnProperty.call(e, i) || bt(i, r, n));
                    for(i in e)Object.prototype.hasOwnProperty.call(e, i) && (Object.prototype.hasOwnProperty.call(t, i) ? gt(t[i], e[i]) || ("geojson" === t[i].type && "geojson" === e[i].type && _t(t, e, i) ? xt(r, {
                        command: "setGeoJSONSourceData",
                        args: [
                            i,
                            e[i].data
                        ]
                    }) : wt(i, e, r, n)) : vt(i, e, r));
                }(t.sources, e.sources, i, n);
                const s = [];
                t.layers && t.layers.forEach((t)=>{
                    "source" in t && n[t.source] ? r.push({
                        command: "removeLayer",
                        args: [
                            t.id
                        ]
                    }) : s.push(t);
                }), r = r.concat(i), function(t, e, r) {
                    e = e || [];
                    const n = (t = t || []).map(At), i = e.map(At), s = t.reduce(kt, {}), a = e.reduce(kt, {}), o = n.slice(), l = Object.create(null);
                    let u, c, h, p, f;
                    for(let t = 0, e = 0; t < n.length; t++)u = n[t], Object.prototype.hasOwnProperty.call(a, u) ? e++ : (xt(r, {
                        command: "removeLayer",
                        args: [
                            u
                        ]
                    }), o.splice(o.indexOf(u, e), 1));
                    for(let t = 0, e = 0; t < i.length; t++)u = i[i.length - 1 - t], o[o.length - 1 - t] !== u && (Object.prototype.hasOwnProperty.call(s, u) ? (xt(r, {
                        command: "removeLayer",
                        args: [
                            u
                        ]
                    }), o.splice(o.lastIndexOf(u, o.length - e), 1)) : e++, p = o[o.length - t], xt(r, {
                        command: "addLayer",
                        args: [
                            a[u],
                            p
                        ]
                    }), o.splice(o.length - t, 0, u), l[u] = !0);
                    for(let t = 0; t < i.length; t++)if (u = i[t], c = s[u], h = a[u], !l[u] && !gt(c, h)) {
                        if (gt(c.source, h.source) && gt(c["source-layer"], h["source-layer"]) && gt(c.type, h.type)) {
                            for(f in St(c.layout, h.layout, r, u, null, "setLayoutProperty"), St(c.paint, h.paint, r, u, null, "setPaintProperty"), gt(c.filter, h.filter) || xt(r, {
                                command: "setFilter",
                                args: [
                                    u,
                                    h.filter
                                ]
                            }), gt(c.minzoom, h.minzoom) && gt(c.maxzoom, h.maxzoom) || xt(r, {
                                command: "setLayerZoomRange",
                                args: [
                                    u,
                                    h.minzoom,
                                    h.maxzoom
                                ]
                            }), c)Object.prototype.hasOwnProperty.call(c, f) && "layout" !== f && "paint" !== f && "filter" !== f && "metadata" !== f && "minzoom" !== f && "maxzoom" !== f && (0 === f.indexOf("paint.") ? St(c[f], h[f], r, u, f.slice(6), "setPaintProperty") : gt(c[f], h[f]) || xt(r, {
                                command: "setLayerProperty",
                                args: [
                                    u,
                                    f,
                                    h[f]
                                ]
                            }));
                            for(f in h)Object.prototype.hasOwnProperty.call(h, f) && !Object.prototype.hasOwnProperty.call(c, f) && "layout" !== f && "paint" !== f && "filter" !== f && "metadata" !== f && "minzoom" !== f && "maxzoom" !== f && (0 === f.indexOf("paint.") ? St(c[f], h[f], r, u, f.slice(6), "setPaintProperty") : gt(c[f], h[f]) || xt(r, {
                                command: "setLayerProperty",
                                args: [
                                    u,
                                    f,
                                    h[f]
                                ]
                            }));
                        } else xt(r, {
                            command: "removeLayer",
                            args: [
                                u
                            ]
                        }), p = o[o.lastIndexOf(u) + 1], xt(r, {
                            command: "addLayer",
                            args: [
                                h,
                                p
                            ]
                        });
                    }
                }(s, e.layers, r);
            } catch (t) {
                console.warn("Unable to compute style diff:", t), r = [
                    {
                        command: "setStyle",
                        args: [
                            e
                        ]
                    }
                ];
            }
            return r;
        }, t.bB = function(t) {
            const e = [], r = t.id;
            return void 0 === r && e.push({
                message: `layers.${r}: missing required property "id"`
            }), void 0 === t.render && e.push({
                message: `layers.${r}: missing required method "render"`
            }), t.renderingMode && "2d" !== t.renderingMode && "3d" !== t.renderingMode && e.push({
                message: `layers.${r}: property "renderingMode" must be either "2d" or "3d"`
            }), e;
        }, t.bC = function t(e, r) {
            if (Array.isArray(e)) {
                if (!Array.isArray(r) || e.length !== r.length) return !1;
                for(let n = 0; n < e.length; n++)if (!t(e[n], r[n])) return !1;
                return !0;
            }
            if ("object" == typeof e && null !== e && null !== r) {
                if ("object" != typeof r) return !1;
                if (Object.keys(e).length !== Object.keys(r).length) return !1;
                for(const n in e)if (!t(e[n], r[n])) return !1;
                return !0;
            }
            return e === r;
        }, t.bD = L, t.bE = O, t.bF = class extends Ka {
            constructor(t, e){
                super(t, e), this.current = 0;
            }
            set(t) {
                this.current !== t && (this.current = t, this.gl.uniform1i(this.location, t));
            }
        }, t.bG = Ya, t.bH = class extends Ka {
            constructor(t, e){
                super(t, e), this.current = Ja;
            }
            set(t) {
                if (t[12] !== this.current[12] || t[0] !== this.current[0]) return this.current = t, void this.gl.uniformMatrix4fv(this.location, !1, t);
                for(let e = 1; e < 16; e++)if (t[e] !== this.current[e]) {
                    this.current = t, this.gl.uniformMatrix4fv(this.location, !1, t);
                    break;
                }
            }
        }, t.bI = Ha, t.bJ = class extends Ka {
            constructor(t, e){
                super(t, e), this.current = [
                    0,
                    0,
                    0
                ];
            }
            set(t) {
                t[0] === this.current[0] && t[1] === this.current[1] && t[2] === this.current[2] || (this.current = t, this.gl.uniform3f(this.location, t[0], t[1], t[2]));
            }
        }, t.bK = class extends Ka {
            constructor(t, e){
                super(t, e), this.current = [
                    0,
                    0
                ];
            }
            set(t) {
                t[0] === this.current[0] && t[1] === this.current[1] || (this.current = t, this.gl.uniform2f(this.location, t[0], t[1]));
            }
        }, t.bL = x, t.bM = function(t, e) {
            var r = Math.sin(e), n = Math.cos(e);
            return t[0] = n, t[1] = r, t[2] = 0, t[3] = -r, t[4] = n, t[5] = 0, t[6] = 0, t[7] = 0, t[8] = 1, t;
        }, t.bN = function(t, e, r) {
            var n = e[0], i = e[1], s = e[2];
            return t[0] = n * r[0] + i * r[3] + s * r[6], t[1] = n * r[1] + i * r[4] + s * r[7], t[2] = n * r[2] + i * r[5] + s * r[8], t;
        }, t.bO = function(t, e, r, n, i, s, a) {
            var o = 1 / (e - r), l = 1 / (n - i), u = 1 / (s - a);
            return t[0] = -2 * o, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = -2 * l, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 2 * u, t[11] = 0, t[12] = (e + r) * o, t[13] = (i + n) * l, t[14] = (a + s) * u, t[15] = 1, t;
        }, t.bP = class extends Ks {
        }, t.bQ = Bu, t.bR = class extends Hs {
        }, t.bS = qo, t.bT = function(t) {
            return t <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t) / Math.LN2));
        }, t.bU = Uo, t.bV = function(t, e, r) {
            var n = e[0], i = e[1], s = e[2], a = r[3] * n + r[7] * i + r[11] * s + r[15];
            return t[0] = (r[0] * n + r[4] * i + r[8] * s + r[12]) / (a = a || 1), t[1] = (r[1] * n + r[5] * i + r[9] * s + r[13]) / a, t[2] = (r[2] * n + r[6] * i + r[10] * s + r[14]) / a, t;
        }, t.bW = class extends Ls {
        }, t.bX = class extends ra {
        }, t.bY = function(t, e) {
            return t[0] === e[0] && t[1] === e[1] && t[2] === e[2] && t[3] === e[3] && t[4] === e[4] && t[5] === e[5] && t[6] === e[6] && t[7] === e[7] && t[8] === e[8] && t[9] === e[9] && t[10] === e[10] && t[11] === e[11] && t[12] === e[12] && t[13] === e[13] && t[14] === e[14] && t[15] === e[15];
        }, t.bZ = function(t, e) {
            var r = t[0], n = t[1], i = t[2], s = t[3], a = t[4], o = t[5], l = t[6], u = t[7], c = t[8], h = t[9], p = t[10], f = t[11], d = t[12], y = t[13], g = t[14], x = t[15], v = e[0], b = e[1], w = e[2], _ = e[3], S = e[4], A = e[5], k = e[6], M = e[7], I = e[8], z = e[9], P = e[10], C = e[11], B = e[12], V = e[13], E = e[14], T = e[15];
            return Math.abs(r - v) <= m * Math.max(1, Math.abs(r), Math.abs(v)) && Math.abs(n - b) <= m * Math.max(1, Math.abs(n), Math.abs(b)) && Math.abs(i - w) <= m * Math.max(1, Math.abs(i), Math.abs(w)) && Math.abs(s - _) <= m * Math.max(1, Math.abs(s), Math.abs(_)) && Math.abs(a - S) <= m * Math.max(1, Math.abs(a), Math.abs(S)) && Math.abs(o - A) <= m * Math.max(1, Math.abs(o), Math.abs(A)) && Math.abs(l - k) <= m * Math.max(1, Math.abs(l), Math.abs(k)) && Math.abs(u - M) <= m * Math.max(1, Math.abs(u), Math.abs(M)) && Math.abs(c - I) <= m * Math.max(1, Math.abs(c), Math.abs(I)) && Math.abs(h - z) <= m * Math.max(1, Math.abs(h), Math.abs(z)) && Math.abs(p - P) <= m * Math.max(1, Math.abs(p), Math.abs(P)) && Math.abs(f - C) <= m * Math.max(1, Math.abs(f), Math.abs(C)) && Math.abs(d - B) <= m * Math.max(1, Math.abs(d), Math.abs(B)) && Math.abs(y - V) <= m * Math.max(1, Math.abs(y), Math.abs(V)) && Math.abs(g - E) <= m * Math.max(1, Math.abs(g), Math.abs(E)) && Math.abs(x - T) <= m * Math.max(1, Math.abs(x), Math.abs(T));
        }, t.b_ = function(t, e) {
            return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
        }, t.ba = Il, t.bb = Al, t.bc = P, t.bd = C, t.be = ze, t.bf = function(t, e, r, n, i) {
            return P(n, i, E((t - e) / (r - e), 0, 1));
        }, t.bg = z, t.bh = function() {
            return new Float64Array(4);
        }, t.bi = function() {
            return new Float64Array(3);
        }, t.bj = function(t, e, r, n) {
            var i = [], s = [];
            return i[0] = e[0] - r[0], i[1] = e[1] - r[1], i[2] = e[2] - r[2], s[0] = i[0] * Math.cos(n) - i[1] * Math.sin(n), s[1] = i[0] * Math.sin(n) + i[1] * Math.cos(n), s[2] = i[2], t[0] = s[0] + r[0], t[1] = s[1] + r[1], t[2] = s[2] + r[2], t;
        }, t.bk = function(t, e, r, n) {
            var i = [], s = [];
            return i[0] = e[0] - r[0], i[1] = e[1] - r[1], i[2] = e[2] - r[2], s[0] = i[0], s[1] = i[1] * Math.cos(n) - i[2] * Math.sin(n), s[2] = i[1] * Math.sin(n) + i[2] * Math.cos(n), t[0] = s[0] + r[0], t[1] = s[1] + r[1], t[2] = s[2] + r[2], t;
        }, t.bl = function(t, e, r, n) {
            var i = [], s = [];
            return i[0] = e[0] - r[0], i[1] = e[1] - r[1], i[2] = e[2] - r[2], s[0] = i[2] * Math.sin(n) + i[0] * Math.cos(n), s[1] = i[1], s[2] = i[2] * Math.cos(n) - i[0] * Math.sin(n), t[0] = s[0] + r[0], t[1] = s[1] + r[1], t[2] = s[2] + r[2], t;
        }, t.bm = function(t, e, r) {
            var n = Math.sin(r), i = Math.cos(r), s = e[0], a = e[1], o = e[2], l = e[3], u = e[8], c = e[9], h = e[10], p = e[11];
            return e !== t && (t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[0] = s * i - u * n, t[1] = a * i - c * n, t[2] = o * i - h * n, t[3] = l * i - p * n, t[8] = s * n + u * i, t[9] = a * n + c * i, t[10] = o * n + h * i, t[11] = l * n + p * i, t;
        }, t.bn = function(t, e) {
            const r = z(t, 360), n = z(e, 360), i = n - r, s = n > r ? i - 360 : i + 360;
            return Math.abs(i) < Math.abs(s) ? i : s;
        }, t.bo = function(t) {
            return t[0] = 0, t[1] = 0, t[2] = 0, t;
        }, t.bp = function(t, e, r, n) {
            const i = Math.sqrt(t * t + e * e), s = Math.sqrt(r * r + n * n);
            t /= i, e /= i, r /= s, n /= s;
            const a = Math.acos(t * r + e * n);
            return -e * r + t * n > 0 ? a : -a;
        }, t.bq = function(t, e) {
            return t[0] * e[0] + t[1] * e[1] + t[2] * e[2] + t[3];
        }, t.br = Xc, t.bs = function(t, e) {
            const r = z(t, 2 * Math.PI), n = z(e, 2 * Math.PI);
            return Math.min(Math.abs(r - n), Math.abs(r - n + 2 * Math.PI), Math.abs(r - n - 2 * Math.PI));
        }, t.bt = function(t) {
            return Math.hypot(t[0], t[1], t[2]);
        }, t.bu = function() {
            const t = {}, e = dt.$version;
            for(const r in dt.$root){
                const n = dt.$root[r];
                if (n.required) {
                    let i = null;
                    i = "version" === r ? e : "array" === n.type ? [] : {}, null != i && (t[r] = i);
                }
            }
            return t;
        }, t.bv = Wi, t.bw = at, t.bx = function(t) {
            t = t.slice();
            const e = Object.create(null);
            for(let r = 0; r < t.length; r++)e[t[r].id] = t[r];
            for(let r = 0; r < t.length; r++)"ref" in t[r] && (t[r] = mt(t[r], e[t[r].ref]));
            return t;
        }, t.by = function(t) {
            if ("custom" === t.type) return new Gc(t);
            switch(t.type){
                case "background":
                    return new jc(t);
                case "circle":
                    return new Eo(t);
                case "fill":
                    return new Ol(t);
                case "fill-extrusion":
                    return new uu(t);
                case "heatmap":
                    return new Go(t);
                case "hillshade":
                    return new Xo(t);
                case "line":
                    return new ku(t);
                case "raster":
                    return new qc(t);
                case "symbol":
                    return new Oc(t);
            }
        }, t.bz = D, t.c = et, t.c0 = (t)=>"circle" === t.type, t.c1 = (t)=>"heatmap" === t.type, t.c2 = (t)=>"line" === t.type, t.c3 = (t)=>"fill" === t.type, t.c4 = (t)=>"fill-extrusion" === t.type, t.c5 = (t)=>"hillshade" === t.type, t.c6 = (t)=>"raster" === t.type, t.c7 = (t)=>"background" === t.type, t.c8 = (t)=>"custom" === t.type, t.c9 = B, t.cA = class {
            constructor(t){
                this._marks = {
                    start: [
                        t.url,
                        "start"
                    ].join("#"),
                    end: [
                        t.url,
                        "end"
                    ].join("#"),
                    measure: t.url.toString()
                }, performance.mark(this._marks.start);
            }
            finish() {
                performance.mark(this._marks.end);
                let t = performance.getEntriesByName(this._marks.measure);
                return 0 === t.length && (performance.measure(this._marks.measure, this._marks.start, this._marks.end), t = performance.getEntriesByName(this._marks.measure), performance.clearMarks(this._marks.start), performance.clearMarks(this._marks.end), performance.clearMeasures(this._marks.measure)), t;
            }
        }, t.cB = function(t, r, n, i, s) {
            return e(this, void 0, void 0, function*() {
                if (d()) try {
                    return yield K(t, r, n, i, s);
                } catch (t) {}
                return function(t, e, r, n, i) {
                    const s = t.width, a = t.height;
                    X && H || (X = new OffscreenCanvas(s, a), H = X.getContext("2d", {
                        willReadFrequently: !0
                    })), X.width = s, X.height = a, H.drawImage(t, 0, 0, s, a);
                    const o = H.getImageData(e, r, n, i);
                    return H.clearRect(0, 0, s, a), o.data;
                }(t, r, n, i, s);
            });
        }, t.cC = uh, t.cD = r, t.cE = s, t.cF = Wl, t.cG = Ru, t.cH = Gn, t.cI = ps, t.ca = function(t, e, r) {
            const n = k(e.x - r.x, e.y - r.y), i = k(t.x - r.x, t.y - r.y);
            var s, a;
            return J(Math.atan2(n[0] * i[1] - n[1] * i[0], (s = n)[0] * (a = i)[0] + s[1] * a[1]));
        }, t.cb = V, t.cc = function(t, e) {
            return Q[e] && (t instanceof MouseEvent || t instanceof WheelEvent);
        }, t.cd = function(t, e) {
            return W[e] && "touches" in t;
        }, t.ce = function(t) {
            return W[t] || Q[t];
        }, t.cf = function(t, e, r) {
            var n = e[0], i = e[1];
            return t[0] = r[0] * n + r[4] * i + r[12], t[1] = r[1] * n + r[5] * i + r[13], t;
        }, t.cg = function(t, e) {
            const { x: r, y: n } = nh.fromLngLat(e);
            return !(t < 0 || t > 25 || n < 0 || n >= 1 || r < 0 || r >= 1);
        }, t.ch = function(t, e) {
            return t[0] = e[0], t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = e[1], t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = e[2], t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
        }, t.ci = class extends $s {
        }, t.cj = sp, t.cl = function(t) {
            return t.message === tt;
        }, t.cm = st, t.cn = function(t, e) {
            rt.REGISTERED_PROTOCOLS[t] = e;
        }, t.co = function(t) {
            delete rt.REGISTERED_PROTOCOLS[t];
        }, t.cp = function(t, e) {
            const r = {};
            for(let n = 0; n < t.length; n++){
                const i = e && e[t[n].id] || li(t[n]);
                e && (e[t[n].id] = i);
                let s = r[i];
                s || (s = r[i] = []), s.push(t[n]);
            }
            const n = [];
            for(const t in r)n.push(r[t]);
            return n;
        }, t.cq = Zi, t.cr = ch, t.cs = ph, t.ct = Yu, t.cu = function(e) {
            e.bucket.createArrays(), e.bucket.tilePixelRatio = M / (512 * e.bucket.overscaling), e.bucket.compareText = {}, e.bucket.iconsNeedLinear = !1;
            const r = e.bucket.layers[0], n = r.layout, i = r._unevaluatedLayout._values, s = {
                layoutIconSize: i["icon-size"].possiblyEvaluate(new fs(e.bucket.zoom + 1), e.canonical),
                layoutTextSize: i["text-size"].possiblyEvaluate(new fs(e.bucket.zoom + 1), e.canonical),
                textMaxSize: i["text-size"].possiblyEvaluate(new fs(18))
            };
            if ("composite" === e.bucket.textSizeData.kind) {
                const { minZoom: t, maxZoom: r } = e.bucket.textSizeData;
                s.compositeTextSizes = [
                    i["text-size"].possiblyEvaluate(new fs(t), e.canonical),
                    i["text-size"].possiblyEvaluate(new fs(r), e.canonical)
                ];
            }
            if ("composite" === e.bucket.iconSizeData.kind) {
                const { minZoom: t, maxZoom: r } = e.bucket.iconSizeData;
                s.compositeIconSizes = [
                    i["icon-size"].possiblyEvaluate(new fs(t), e.canonical),
                    i["icon-size"].possiblyEvaluate(new fs(r), e.canonical)
                ];
            }
            const a = n.get("text-line-height") * Lu, o = "viewport" !== n.get("text-rotation-alignment") && "point" !== n.get("symbol-placement"), l = n.get("text-keep-upright"), u = n.get("text-size");
            for (const i of e.bucket.features){
                const c = n.get("text-font").evaluate(i, {}, e.canonical).join(","), h = u.evaluate(i, {}, e.canonical), p = s.layoutTextSize.evaluate(i, {}, e.canonical), f = s.layoutIconSize.evaluate(i, {}, e.canonical), d = {
                    horizontal: {},
                    vertical: void 0
                }, y = i.text;
                let m, g = [
                    0,
                    0
                ];
                if (y) {
                    const s = y.toString(), u = n.get("text-letter-spacing").evaluate(i, {}, e.canonical) * Lu, f = es(s) ? u : 0, m = n.get("text-anchor").evaluate(i, {}, e.canonical), x = Rh(r, i, e.canonical);
                    if (!x) {
                        const t = n.get("text-radial-offset").evaluate(i, {}, e.canonical);
                        g = t ? Dh(m, [
                            t * Lu,
                            Oh
                        ]) : n.get("text-offset").evaluate(i, {}, e.canonical).map((t)=>t * Lu);
                    }
                    let v = o ? "center" : n.get("text-justify").evaluate(i, {}, e.canonical);
                    const b = "point" === n.get("symbol-placement") ? n.get("text-max-width").evaluate(i, {}, e.canonical) * Lu : 1 / 0, w = ()=>{
                        e.bucket.allowVerticalPlacement && ts(s) && (d.vertical = ec(y, e.glyphMap, e.glyphPositions, e.imagePositions, c, b, a, m, "left", f, g, t.ah.vertical, !0, p, h));
                    };
                    if (!o && x) {
                        const r = new Set;
                        if ("auto" === v) for(let t = 0; t < x.values.length; t += 2)r.add(jh(x.values[t]));
                        else r.add(v);
                        let n = !1;
                        for (const i of r)if (!d.horizontal[i]) {
                            if (n) d.horizontal[i] = d.horizontal[0];
                            else {
                                const r = ec(y, e.glyphMap, e.glyphPositions, e.imagePositions, c, b, a, "center", i, f, g, t.ah.horizontal, !1, p, h);
                                r && (d.horizontal[i] = r, n = 1 === r.positionedLines.length);
                            }
                        }
                        w();
                    } else {
                        "auto" === v && (v = jh(m));
                        const r = ec(y, e.glyphMap, e.glyphPositions, e.imagePositions, c, b, a, m, v, f, g, t.ah.horizontal, !1, p, h);
                        r && (d.horizontal[v] = r), w(), ts(s) && o && l && (d.vertical = ec(y, e.glyphMap, e.glyphPositions, e.imagePositions, c, b, a, m, v, f, g, t.ah.vertical, !1, p, h));
                    }
                }
                let x = !1;
                if (i.icon && i.icon.name) {
                    const t = e.imageMap[i.icon.name];
                    t && (m = xc(e.imagePositions[i.icon.name], n.get("icon-offset").evaluate(i, {}, e.canonical), n.get("icon-anchor").evaluate(i, {}, e.canonical)), x = !!t.sdf, void 0 === e.bucket.sdfIcons ? e.bucket.sdfIcons = x : e.bucket.sdfIcons !== x && j("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (t.pixelRatio !== e.bucket.pixelRatio || 0 !== n.get("icon-rotate").constantOr(1)) && (e.bucket.iconsNeedLinear = !0));
                }
                const v = qh(d.horizontal) || d.vertical;
                e.bucket.iconsInText = !!v && v.iconsInText, (v || m) && Nh(e.bucket, i, d, m, e.imageMap, s, p, f, g, x, e.canonical, e.subdivisionGranularity);
            }
            e.showCollisionBoxes && e.bucket.generateCollisionDebugBuffers();
        }, t.cv = vu, t.cw = Tl, t.cx = nu, t.cy = Ql, t.cz = ju, t.d = lt, t.e = F, t.f = (t)=>e(void 0, void 0, void 0, function*() {
                if (0 === t.byteLength) return createImageBitmap(new ImageData(1, 1));
                const e = new Blob([
                    new Uint8Array(t)
                ], {
                    type: "image/png"
                });
                try {
                    return createImageBitmap(e);
                } catch (t) {
                    throw new Error(`Could not load image because of ${t.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`);
                }
            }), t.g = nt, t.h = (t)=>new Promise((e, r)=>{
                const n = new Image;
                n.onload = ()=>{
                    e(n), URL.revokeObjectURL(n.src), n.onload = null, window.requestAnimationFrame(()=>{
                        n.src = Z;
                    });
                }, n.onerror = ()=>r(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                const i = new Blob([
                    new Uint8Array(t)
                ], {
                    type: "image/png"
                });
                n.src = t.byteLength ? URL.createObjectURL(i) : Z;
            }), t.i = U, t.j = (t, e)=>ot(F(t, {
                type: "json"
            }), e), t.k = pt, t.l = ht, t.m = ot, t.n = (t, e)=>ot(F(t, {
                type: "arrayBuffer"
            }), e), t.o = function(t) {
            return new ju(t).readFields(Uu, []);
        }, t.p = Ku, t.q = jo, t.r = Is, t.s = Y, t.t = Di, t.u = Qi, t.v = dt, t.w = j, t.x = Ui, t.y = Oi, t.z = function([t, e, r]) {
            return e += 90, e *= Math.PI / 180, r *= Math.PI / 180, {
                x: t * Math.cos(e) * Math.sin(r),
                y: t * Math.sin(e) * Math.sin(r),
                z: t * Math.cos(r)
            };
        };
    });
    define("worker", [
        "./shared"
    ], function(e) {
        "use strict";
        class t {
            constructor(e){
                this.keyCache = {}, e && this.replace(e);
            }
            replace(e) {
                this._layerConfigs = {}, this._layers = {}, this.update(e, []);
            }
            update(t, o) {
                for (const o of t){
                    this._layerConfigs[o.id] = o;
                    const t = this._layers[o.id] = e.by(o);
                    t._featureFilter = e.a7(t.filter), this.keyCache[o.id] && delete this.keyCache[o.id];
                }
                for (const e of o)delete this.keyCache[e], delete this._layerConfigs[e], delete this._layers[e];
                this.familiesBySource = {};
                const i = e.cp(Object.values(this._layerConfigs), this.keyCache);
                for (const e of i){
                    const t = e.map((e)=>this._layers[e.id]), o = t[0];
                    if ("none" === o.visibility) continue;
                    const i = o.source || "";
                    let r = this.familiesBySource[i];
                    r || (r = this.familiesBySource[i] = {});
                    const s = o.sourceLayer || "_geojsonTileLayer";
                    let n = r[s];
                    n || (n = r[s] = []), n.push(t);
                }
            }
        }
        class o {
            constructor(t){
                const o = {}, i = [];
                for(const e in t){
                    const r = t[e], s = o[e] = {};
                    for(const e in r){
                        const t = r[+e];
                        if (!t || 0 === t.bitmap.width || 0 === t.bitmap.height) continue;
                        const o = {
                            x: 0,
                            y: 0,
                            w: t.bitmap.width + 2,
                            h: t.bitmap.height + 2
                        };
                        i.push(o), s[e] = {
                            rect: o,
                            metrics: t.metrics
                        };
                    }
                }
                const { w: r, h: s } = e.p(i), n = new e.q({
                    width: r || 1,
                    height: s || 1
                });
                for(const i in t){
                    const r = t[i];
                    for(const t in r){
                        const s = r[+t];
                        if (!s || 0 === s.bitmap.width || 0 === s.bitmap.height) continue;
                        const a = o[i][t].rect;
                        e.q.copy(s.bitmap, n, {
                            x: 0,
                            y: 0
                        }, {
                            x: a.x + 1,
                            y: a.y + 1
                        }, s.bitmap);
                    }
                }
                this.image = n, this.positions = o;
            }
        }
        e.cq("GlyphAtlas", o);
        class i {
            constructor(t){
                this.tileID = new e.Y(t.tileID.overscaledZ, t.tileID.wrap, t.tileID.canonical.z, t.tileID.canonical.x, t.tileID.canonical.y), this.uid = t.uid, this.zoom = t.zoom, this.pixelRatio = t.pixelRatio, this.tileSize = t.tileSize, this.source = t.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t.showCollisionBoxes, this.collectResourceTiming = !!t.collectResourceTiming, this.returnDependencies = !!t.returnDependencies, this.promoteId = t.promoteId, this.inFlightDependencies = [];
            }
            parse(t, i, s, n, a) {
                return e._(this, void 0, void 0, function*() {
                    this.status = "parsing", this.data = t, this.collisionBoxArray = new e.a5;
                    const l = new e.cr(Object.keys(t.layers).sort()), c = new e.cs(this.tileID, this.promoteId);
                    c.bucketLayerIDs = [];
                    const u = {}, h = {
                        featureIndex: c,
                        iconDependencies: {},
                        patternDependencies: {},
                        glyphDependencies: {},
                        availableImages: s,
                        subdivisionGranularity: a
                    }, d = i.familiesBySource[this.source];
                    for(const o in d){
                        const i = t.layers[o];
                        if (!i) continue;
                        1 === i.version && e.w(`Vector tile source "${this.source}" layer "${o}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                        const n = l.encode(o), a = [];
                        for(let e = 0; e < i.length; e++){
                            const t = i.feature(e), r = c.getId(t, o);
                            a.push({
                                feature: t,
                                id: r,
                                index: e,
                                sourceLayerIndex: n
                            });
                        }
                        for (const t of d[o]){
                            const o = t[0];
                            o.source !== this.source && e.w(`layer.source = ${o.source} does not equal this.source = ${this.source}`), o.minzoom && this.zoom < Math.floor(o.minzoom) || o.maxzoom && this.zoom >= o.maxzoom || "none" !== o.visibility && (r(t, this.zoom, s), (u[o.id] = o.createBucket({
                                index: c.bucketLayerIDs.length,
                                layers: t,
                                zoom: this.zoom,
                                pixelRatio: this.pixelRatio,
                                overscaling: this.overscaling,
                                collisionBoxArray: this.collisionBoxArray,
                                sourceLayerIndex: n,
                                sourceID: this.source
                            })).populate(a, h, this.tileID.canonical), c.bucketLayerIDs.push(t.map((e)=>e.id)));
                        }
                    }
                    const f = e.bD(h.glyphDependencies, (e)=>Object.keys(e).map(Number));
                    this.inFlightDependencies.forEach((e)=>null == e ? void 0 : e.abort()), this.inFlightDependencies = [];
                    let g = Promise.resolve({});
                    if (Object.keys(f).length) {
                        const e = new AbortController;
                        this.inFlightDependencies.push(e), g = n.sendAsync({
                            type: "GG",
                            data: {
                                stacks: f,
                                source: this.source,
                                tileID: this.tileID,
                                type: "glyphs"
                            }
                        }, e);
                    }
                    const p = Object.keys(h.iconDependencies);
                    let m = Promise.resolve({});
                    if (p.length) {
                        const e = new AbortController;
                        this.inFlightDependencies.push(e), m = n.sendAsync({
                            type: "GI",
                            data: {
                                icons: p,
                                source: this.source,
                                tileID: this.tileID,
                                type: "icons"
                            }
                        }, e);
                    }
                    const y = Object.keys(h.patternDependencies);
                    let v = Promise.resolve({});
                    if (y.length) {
                        const e = new AbortController;
                        this.inFlightDependencies.push(e), v = n.sendAsync({
                            type: "GI",
                            data: {
                                icons: y,
                                source: this.source,
                                tileID: this.tileID,
                                type: "patterns"
                            }
                        }, e);
                    }
                    const [w, x, _] = yield Promise.all([
                        g,
                        m,
                        v
                    ]), b = new o(w), M = new e.ct(x, _);
                    for(const t in u){
                        const o = u[t];
                        o instanceof e.a6 ? (r(o.layers, this.zoom, s), e.cu({
                            bucket: o,
                            glyphMap: w,
                            glyphPositions: b.positions,
                            imageMap: x,
                            imagePositions: M.iconPositions,
                            showCollisionBoxes: this.showCollisionBoxes,
                            canonical: this.tileID.canonical,
                            subdivisionGranularity: h.subdivisionGranularity
                        })) : o.hasPattern && (o instanceof e.cv || o instanceof e.cw || o instanceof e.cx) && (r(o.layers, this.zoom, s), o.addFeatures(h, this.tileID.canonical, M.patternPositions));
                    }
                    return this.status = "done", {
                        buckets: Object.values(u).filter((e)=>!e.isEmpty()),
                        featureIndex: c,
                        collisionBoxArray: this.collisionBoxArray,
                        glyphAtlasImage: b.image,
                        imageAtlas: M,
                        glyphMap: this.returnDependencies ? w : null,
                        iconMap: this.returnDependencies ? x : null,
                        glyphPositions: this.returnDependencies ? b.positions : null
                    };
                });
            }
        }
        function r(t, o, i) {
            const r = new e.C(o);
            for (const e of t)e.recalculate(r, i);
        }
        class s {
            constructor(e, t, o){
                this.actor = e, this.layerIndex = t, this.availableImages = o, this.fetching = {}, this.loading = {}, this.loaded = {};
            }
            loadVectorTile(t, o) {
                return e._(this, void 0, void 0, function*() {
                    const i = yield e.n(t.request, o);
                    try {
                        return {
                            vectorTile: new e.cy.VectorTile(new e.cz(i.data)),
                            rawData: i.data,
                            cacheControl: i.cacheControl,
                            expires: i.expires
                        };
                    } catch (e) {
                        const o = new Uint8Array(i.data);
                        let r = `Unable to parse the tile at ${t.request.url}, `;
                        throw r += 31 === o[0] && 139 === o[1] ? "please make sure the data is not gzipped and that you have configured the relevant header in the server" : `got error: ${e.message}`, new Error(r);
                    }
                });
            }
            loadTile(t) {
                return e._(this, void 0, void 0, function*() {
                    const o = t.uid, r = !!(t && t.request && t.request.collectResourceTiming) && new e.cA(t.request), s = new i(t);
                    this.loading[o] = s;
                    const n = new AbortController;
                    s.abort = n;
                    try {
                        const i = yield this.loadVectorTile(t, n);
                        if (delete this.loading[o], !i) return null;
                        const a = i.rawData, l = {};
                        i.expires && (l.expires = i.expires), i.cacheControl && (l.cacheControl = i.cacheControl);
                        const c = {};
                        if (r) {
                            const e = r.finish();
                            e && (c.resourceTiming = JSON.parse(JSON.stringify(e)));
                        }
                        s.vectorTile = i.vectorTile;
                        const u = s.parse(i.vectorTile, this.layerIndex, this.availableImages, this.actor, t.subdivisionGranularity);
                        this.loaded[o] = s, this.fetching[o] = {
                            rawTileData: a,
                            cacheControl: l,
                            resourceTiming: c
                        };
                        try {
                            const t = yield u;
                            return e.e({
                                rawTileData: a.slice(0)
                            }, t, l, c);
                        } finally{
                            delete this.fetching[o];
                        }
                    } catch (e) {
                        throw delete this.loading[o], s.status = "done", this.loaded[o] = s, e;
                    }
                });
            }
            reloadTile(t) {
                return e._(this, void 0, void 0, function*() {
                    const o = t.uid;
                    if (!this.loaded || !this.loaded[o]) throw new Error("Should not be trying to reload a tile that was never loaded or has been removed");
                    const i = this.loaded[o];
                    if (i.showCollisionBoxes = t.showCollisionBoxes, "parsing" === i.status) {
                        const r = yield i.parse(i.vectorTile, this.layerIndex, this.availableImages, this.actor, t.subdivisionGranularity);
                        let s;
                        if (this.fetching[o]) {
                            const { rawTileData: t, cacheControl: i, resourceTiming: n } = this.fetching[o];
                            delete this.fetching[o], s = e.e({
                                rawTileData: t.slice(0)
                            }, r, i, n);
                        } else s = r;
                        return s;
                    }
                    if ("done" === i.status && i.vectorTile) return i.parse(i.vectorTile, this.layerIndex, this.availableImages, this.actor, t.subdivisionGranularity);
                });
            }
            abortTile(t) {
                return e._(this, void 0, void 0, function*() {
                    const e = this.loading, o = t.uid;
                    e && e[o] && e[o].abort && (e[o].abort.abort(), delete e[o]);
                });
            }
            removeTile(t) {
                return e._(this, void 0, void 0, function*() {
                    this.loaded && this.loaded[t.uid] && delete this.loaded[t.uid];
                });
            }
        }
        class n {
            constructor(){
                this.loaded = {};
            }
            loadTile(t) {
                return e._(this, void 0, void 0, function*() {
                    const { uid: o, encoding: i, rawImageData: r, redFactor: s, greenFactor: n, blueFactor: a, baseShift: l } = t, c = r.width + 2, u = r.height + 2, h = e.b(r) ? new e.R({
                        width: c,
                        height: u
                    }, (yield e.cB(r, -1, -1, c, u))) : r, d = new e.cC(o, h, i, s, n, a, l);
                    return this.loaded = this.loaded || {}, this.loaded[o] = d, d;
                });
            }
            removeTile(e) {
                const t = this.loaded, o = e.uid;
                t && t[o] && delete t[o];
            }
        }
        var a, l, c = function() {
            if (l) return a;
            function e(e, o) {
                if (0 !== e.length) {
                    t(e[0], o);
                    for(var i = 1; i < e.length; i++)t(e[i], !o);
                }
            }
            function t(e, t) {
                for(var o = 0, i = 0, r = 0, s = e.length, n = s - 1; r < s; n = r++){
                    var a = (e[r][0] - e[n][0]) * (e[n][1] + e[r][1]), l = o + a;
                    i += Math.abs(o) >= Math.abs(a) ? o - l + a : a - l + o, o = l;
                }
                o + i >= 0 != !!t && e.reverse();
            }
            return l = 1, a = function t(o, i) {
                var r, s = o && o.type;
                if ("FeatureCollection" === s) for(r = 0; r < o.features.length; r++)t(o.features[r], i);
                else if ("GeometryCollection" === s) for(r = 0; r < o.geometries.length; r++)t(o.geometries[r], i);
                else if ("Feature" === s) t(o.geometry, i);
                else if ("Polygon" === s) e(o.coordinates, i);
                else if ("MultiPolygon" === s) for(r = 0; r < o.coordinates.length; r++)e(o.coordinates[r], i);
                return o;
            };
        }(), u = e.cD(c);
        const h = e.cy.VectorTileFeature.prototype.toGeoJSON;
        class d {
            constructor(t){
                this._feature = t, this.extent = e.Z, this.type = t.type, this.properties = t.tags, "id" in t && !isNaN(t.id) && (this.id = parseInt(t.id, 10));
            }
            loadGeometry() {
                if (1 === this._feature.type) {
                    const t = [];
                    for (const o of this._feature.geometry)t.push([
                        new e.P(o[0], o[1])
                    ]);
                    return t;
                }
                {
                    const t = [];
                    for (const o of this._feature.geometry){
                        const i = [];
                        for (const t of o)i.push(new e.P(t[0], t[1]));
                        t.push(i);
                    }
                    return t;
                }
            }
            toGeoJSON(e, t, o) {
                return h.call(this, e, t, o);
            }
        }
        class f {
            constructor(t){
                this.layers = {
                    _geojsonTileLayer: this
                }, this.name = "_geojsonTileLayer", this.extent = e.Z, this.length = t.length, this._features = t;
            }
            feature(e) {
                return new d(this._features[e]);
            }
        }
        var g, p, m, y = {
            exports: {}
        }, v = function() {
            if (m) return y.exports;
            m = 1;
            var t = e.cG(), o = function() {
                if (p) return g;
                p = 1;
                var t = e.cE(), o = e.cF().VectorTileFeature;
                function i(e, t) {
                    this.options = t || {}, this.features = e, this.length = e.length;
                }
                function r(e, t) {
                    this.id = "number" == typeof e.id ? e.id : void 0, this.type = e.type, this.rawGeometry = 1 === e.type ? [
                        e.geometry
                    ] : e.geometry, this.properties = e.tags, this.extent = t || 4096;
                }
                return g = i, i.prototype.feature = function(e) {
                    return new r(this.features[e], this.options.extent);
                }, r.prototype.loadGeometry = function() {
                    var e = this.rawGeometry;
                    this.geometry = [];
                    for(var o = 0; o < e.length; o++){
                        for(var i = e[o], r = [], s = 0; s < i.length; s++)r.push(new t(i[s][0], i[s][1]));
                        this.geometry.push(r);
                    }
                    return this.geometry;
                }, r.prototype.bbox = function() {
                    this.geometry || this.loadGeometry();
                    for(var e = this.geometry, t = 1 / 0, o = -1 / 0, i = 1 / 0, r = -1 / 0, s = 0; s < e.length; s++)for(var n = e[s], a = 0; a < n.length; a++){
                        var l = n[a];
                        t = Math.min(t, l.x), o = Math.max(o, l.x), i = Math.min(i, l.y), r = Math.max(r, l.y);
                    }
                    return [
                        t,
                        i,
                        o,
                        r
                    ];
                }, r.prototype.toGeoJSON = o.prototype.toGeoJSON, g;
            }();
            function i(e) {
                var o = new t;
                return function(e, t) {
                    for(var o in e.layers)t.writeMessage(3, r, e.layers[o]);
                }(e, o), o.finish();
            }
            function r(e, t) {
                var o;
                t.writeVarintField(15, e.version || 1), t.writeStringField(1, e.name || ""), t.writeVarintField(5, e.extent || 4096);
                var i = {
                    keys: [],
                    values: [],
                    keycache: {},
                    valuecache: {}
                };
                for(o = 0; o < e.length; o++)i.feature = e.feature(o), t.writeMessage(2, s, i);
                var r = i.keys;
                for(o = 0; o < r.length; o++)t.writeStringField(3, r[o]);
                var n = i.values;
                for(o = 0; o < n.length; o++)t.writeMessage(4, u, n[o]);
            }
            function s(e, t) {
                var o = e.feature;
                void 0 !== o.id && t.writeVarintField(1, o.id), t.writeMessage(2, n, e), t.writeVarintField(3, o.type), t.writeMessage(4, c, o);
            }
            function n(e, t) {
                var o = e.feature, i = e.keys, r = e.values, s = e.keycache, n = e.valuecache;
                for(var a in o.properties){
                    var l = o.properties[a], c = s[a];
                    if (null !== l) {
                        void 0 === c && (i.push(a), s[a] = c = i.length - 1), t.writeVarint(c);
                        var u = typeof l;
                        "string" !== u && "boolean" !== u && "number" !== u && (l = JSON.stringify(l));
                        var h = u + ":" + l, d = n[h];
                        void 0 === d && (r.push(l), n[h] = d = r.length - 1), t.writeVarint(d);
                    }
                }
            }
            function a(e, t) {
                return (t << 3) + (7 & e);
            }
            function l(e) {
                return e << 1 ^ e >> 31;
            }
            function c(e, t) {
                for(var o = e.loadGeometry(), i = e.type, r = 0, s = 0, n = o.length, c = 0; c < n; c++){
                    var u = o[c], h = 1;
                    1 === i && (h = u.length), t.writeVarint(a(1, h));
                    for(var d = 3 === i ? u.length - 1 : u.length, f = 0; f < d; f++){
                        1 === f && 1 !== i && t.writeVarint(a(2, d - 1));
                        var g = u[f].x - r, p = u[f].y - s;
                        t.writeVarint(l(g)), t.writeVarint(l(p)), r += g, s += p;
                    }
                    3 === i && t.writeVarint(a(7, 1));
                }
            }
            function u(e, t) {
                var o = typeof e;
                "string" === o ? t.writeStringField(1, e) : "boolean" === o ? t.writeBooleanField(7, e) : "number" === o && (e % 1 != 0 ? t.writeDoubleField(3, e) : e < 0 ? t.writeSVarintField(6, e) : t.writeVarintField(5, e));
            }
            return y.exports = i, y.exports.fromVectorTileJs = i, y.exports.fromGeojsonVt = function(e, t) {
                t = t || {};
                var r = {};
                for(var s in e)r[s] = new o(e[s].features, t), r[s].name = s, r[s].version = t.version, r[s].extent = t.extent;
                return i({
                    layers: r
                });
            }, y.exports.GeoJSONWrapper = o, y.exports;
        }(), w = e.cD(v);
        const x = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: (e)=>e
        }, _ = Math.fround || (b = new Float32Array(1), (e)=>(b[0] = +e, b[0]));
        var b;
        const M = 3, S = 5, I = 6;
        class P {
            constructor(e){
                this.options = Object.assign(Object.create(x), e), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
            }
            load(e) {
                const { log: t, minZoom: o, maxZoom: i } = this.options;
                t && console.time("total time");
                const r = `prepare ${e.length} points`;
                t && console.time(r), this.points = e;
                const s = [];
                for(let t = 0; t < e.length; t++){
                    const o = e[t];
                    if (!o.geometry) continue;
                    const [i, r] = o.geometry.coordinates, n = _(D(i)), a = _(C(r));
                    s.push(n, a, 1 / 0, t, -1, 1), this.options.reduce && s.push(0);
                }
                let n = this.trees[i + 1] = this._createTree(s);
                t && console.timeEnd(r);
                for(let e = i; e >= o; e--){
                    const o = +Date.now();
                    n = this.trees[e] = this._createTree(this._cluster(n, e)), t && console.log("z%d: %d clusters in %dms", e, n.numItems, +Date.now() - o);
                }
                return t && console.timeEnd("total time"), this;
            }
            getClusters(e, t) {
                let o = ((e[0] + 180) % 360 + 360) % 360 - 180;
                const i = Math.max(-90, Math.min(90, e[1]));
                let r = 180 === e[2] ? 180 : ((e[2] + 180) % 360 + 360) % 360 - 180;
                const s = Math.max(-90, Math.min(90, e[3]));
                if (e[2] - e[0] >= 360) o = -180, r = 180;
                else if (o > r) {
                    const e = this.getClusters([
                        o,
                        i,
                        180,
                        s
                    ], t), n = this.getClusters([
                        -180,
                        i,
                        r,
                        s
                    ], t);
                    return e.concat(n);
                }
                const n = this.trees[this._limitZoom(t)], a = n.range(D(o), C(s), D(r), C(i)), l = n.data, c = [];
                for (const e of a){
                    const t = this.stride * e;
                    c.push(l[t + S] > 1 ? k(l, t, this.clusterProps) : this.points[l[t + M]]);
                }
                return c;
            }
            getChildren(e) {
                const t = this._getOriginId(e), o = this._getOriginZoom(e), i = "No cluster with the specified id.", r = this.trees[o];
                if (!r) throw new Error(i);
                const s = r.data;
                if (t * this.stride >= s.length) throw new Error(i);
                const n = this.options.radius / (this.options.extent * Math.pow(2, o - 1)), a = r.within(s[t * this.stride], s[t * this.stride + 1], n), l = [];
                for (const t of a){
                    const o = t * this.stride;
                    s[o + 4] === e && l.push(s[o + S] > 1 ? k(s, o, this.clusterProps) : this.points[s[o + M]]);
                }
                if (0 === l.length) throw new Error(i);
                return l;
            }
            getLeaves(e, t, o) {
                const i = [];
                return this._appendLeaves(i, e, t = t || 10, o = o || 0, 0), i;
            }
            getTile(e, t, o) {
                const i = this.trees[this._limitZoom(e)], r = Math.pow(2, e), { extent: s, radius: n } = this.options, a = n / s, l = (o - a) / r, c = (o + 1 + a) / r, u = {
                    features: []
                };
                return this._addTileFeatures(i.range((t - a) / r, l, (t + 1 + a) / r, c), i.data, t, o, r, u), 0 === t && this._addTileFeatures(i.range(1 - a / r, l, 1, c), i.data, r, o, r, u), t === r - 1 && this._addTileFeatures(i.range(0, l, a / r, c), i.data, -1, o, r, u), u.features.length ? u : null;
            }
            getClusterExpansionZoom(e) {
                let t = this._getOriginZoom(e) - 1;
                for(; t <= this.options.maxZoom;){
                    const o = this.getChildren(e);
                    if (t++, 1 !== o.length) break;
                    e = o[0].properties.cluster_id;
                }
                return t;
            }
            _appendLeaves(e, t, o, i, r) {
                const s = this.getChildren(t);
                for (const t of s){
                    const s = t.properties;
                    if (s && s.cluster ? r + s.point_count <= i ? r += s.point_count : r = this._appendLeaves(e, s.cluster_id, o, i, r) : r < i ? r++ : e.push(t), e.length === o) break;
                }
                return r;
            }
            _createTree(t) {
                const o = new e.aC(t.length / this.stride | 0, this.options.nodeSize, Float32Array);
                for(let e = 0; e < t.length; e += this.stride)o.add(t[e], t[e + 1]);
                return o.finish(), o.data = t, o;
            }
            _addTileFeatures(e, t, o, i, r, s) {
                for (const n of e){
                    const e = n * this.stride, a = t[e + S] > 1;
                    let l, c, u;
                    if (a) l = T(t, e, this.clusterProps), c = t[e], u = t[e + 1];
                    else {
                        const o = this.points[t[e + M]];
                        l = o.properties;
                        const [i, r] = o.geometry.coordinates;
                        c = D(i), u = C(r);
                    }
                    const h = {
                        type: 1,
                        geometry: [
                            [
                                Math.round(this.options.extent * (c * r - o)),
                                Math.round(this.options.extent * (u * r - i))
                            ]
                        ],
                        tags: l
                    };
                    let d;
                    d = a || this.options.generateId ? t[e + M] : this.points[t[e + M]].id, void 0 !== d && (h.id = d), s.features.push(h);
                }
            }
            _limitZoom(e) {
                return Math.max(this.options.minZoom, Math.min(Math.floor(+e), this.options.maxZoom + 1));
            }
            _cluster(e, t) {
                const { radius: o, extent: i, reduce: r, minPoints: s } = this.options, n = o / (i * Math.pow(2, t)), a = e.data, l = [], c = this.stride;
                for(let o = 0; o < a.length; o += c){
                    if (a[o + 2] <= t) continue;
                    a[o + 2] = t;
                    const i = a[o], u = a[o + 1], h = e.within(a[o], a[o + 1], n), d = a[o + S];
                    let f = d;
                    for (const e of h){
                        const o = e * c;
                        a[o + 2] > t && (f += a[o + S]);
                    }
                    if (f > d && f >= s) {
                        let e, s = i * d, n = u * d, g = -1;
                        const p = ((o / c | 0) << 5) + (t + 1) + this.points.length;
                        for (const i of h){
                            const l = i * c;
                            if (a[l + 2] <= t) continue;
                            a[l + 2] = t;
                            const u = a[l + S];
                            s += a[l] * u, n += a[l + 1] * u, a[l + 4] = p, r && (e || (e = this._map(a, o, !0), g = this.clusterProps.length, this.clusterProps.push(e)), r(e, this._map(a, l)));
                        }
                        a[o + 4] = p, l.push(s / f, n / f, 1 / 0, p, -1, f), r && l.push(g);
                    } else {
                        for(let e = 0; e < c; e++)l.push(a[o + e]);
                        if (f > 1) for (const e of h){
                            const o = e * c;
                            if (!(a[o + 2] <= t)) {
                                a[o + 2] = t;
                                for(let e = 0; e < c; e++)l.push(a[o + e]);
                            }
                        }
                    }
                }
                return l;
            }
            _getOriginId(e) {
                return e - this.points.length >> 5;
            }
            _getOriginZoom(e) {
                return (e - this.points.length) % 32;
            }
            _map(e, t, o) {
                if (e[t + S] > 1) {
                    const i = this.clusterProps[e[t + I]];
                    return o ? Object.assign({}, i) : i;
                }
                const i = this.points[e[t + M]].properties, r = this.options.map(i);
                return o && r === i ? Object.assign({}, r) : r;
            }
        }
        function k(e, t, o) {
            var i;
            return {
                type: "Feature",
                id: e[t + M],
                properties: T(e, t, o),
                geometry: {
                    type: "Point",
                    coordinates: [
                        (i = e[t], 360 * (i - .5)),
                        O(e[t + 1])
                    ]
                }
            };
        }
        function T(e, t, o) {
            const i = e[t + S], r = i >= 1e4 ? `${Math.round(i / 1e3)}k` : i >= 1e3 ? Math.round(i / 100) / 10 + "k" : i, s = e[t + I], n = -1 === s ? {} : Object.assign({}, o[s]);
            return Object.assign(n, {
                cluster: !0,
                cluster_id: e[t + M],
                point_count: i,
                point_count_abbreviated: r
            });
        }
        function D(e) {
            return e / 360 + .5;
        }
        function C(e) {
            const t = Math.sin(e * Math.PI / 180), o = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
            return o < 0 ? 0 : o > 1 ? 1 : o;
        }
        function O(e) {
            const t = (180 - 360 * e) * Math.PI / 180;
            return 360 * Math.atan(Math.exp(t)) / Math.PI - 90;
        }
        function L(e, t, o, i) {
            let r = i;
            const s = t + (o - t >> 1);
            let n, a = o - t;
            const l = e[t], c = e[t + 1], u = e[o], h = e[o + 1];
            for(let i = t + 3; i < o; i += 3){
                const t = F(e[i], e[i + 1], l, c, u, h);
                if (t > r) n = i, r = t;
                else if (t === r) {
                    const e = Math.abs(i - s);
                    e < a && (n = i, a = e);
                }
            }
            r > i && (n - t > 3 && L(e, t, n, i), e[n + 2] = r, o - n > 3 && L(e, n, o, i));
        }
        function F(e, t, o, i, r, s) {
            let n = r - o, a = s - i;
            if (0 !== n || 0 !== a) {
                const l = ((e - o) * n + (t - i) * a) / (n * n + a * a);
                l > 1 ? (o = r, i = s) : l > 0 && (o += n * l, i += a * l);
            }
            return n = e - o, a = t - i, n * n + a * a;
        }
        function G(e, t, o, i) {
            const r = {
                id: null == e ? null : e,
                type: t,
                geometry: o,
                tags: i,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            };
            if ("Point" === t || "MultiPoint" === t || "LineString" === t) z(r, o);
            else if ("Polygon" === t) z(r, o[0]);
            else if ("MultiLineString" === t) for (const e of o)z(r, e);
            else if ("MultiPolygon" === t) for (const e of o)z(r, e[0]);
            return r;
        }
        function z(e, t) {
            for(let o = 0; o < t.length; o += 3)e.minX = Math.min(e.minX, t[o]), e.minY = Math.min(e.minY, t[o + 1]), e.maxX = Math.max(e.maxX, t[o]), e.maxY = Math.max(e.maxY, t[o + 1]);
        }
        function A(e, t, o, i) {
            if (!t.geometry) return;
            const r = t.geometry.coordinates;
            if (r && 0 === r.length) return;
            const s = t.geometry.type, n = Math.pow(o.tolerance / ((1 << o.maxZoom) * o.extent), 2);
            let a = [], l = t.id;
            if (o.promoteId ? l = t.properties[o.promoteId] : o.generateId && (l = i || 0), "Point" === s) j(r, a);
            else if ("MultiPoint" === s) for (const e of r)j(e, a);
            else if ("LineString" === s) E(r, a, n, !1);
            else if ("MultiLineString" === s) {
                if (o.lineMetrics) {
                    for (const o of r)a = [], E(o, a, n, !1), e.push(G(l, "LineString", a, t.properties));
                    return;
                }
                Z(r, a, n, !1);
            } else if ("Polygon" === s) Z(r, a, n, !0);
            else {
                if ("MultiPolygon" !== s) {
                    if ("GeometryCollection" === s) {
                        for (const r of t.geometry.geometries)A(e, {
                            id: l,
                            geometry: r,
                            properties: t.properties
                        }, o, i);
                        return;
                    }
                    throw new Error("Input data is not a valid GeoJSON object.");
                }
                for (const e of r){
                    const t = [];
                    Z(e, t, n, !0), a.push(t);
                }
            }
            e.push(G(l, s, a, t.properties));
        }
        function j(e, t) {
            t.push(N(e[0]), J(e[1]), 0);
        }
        function E(e, t, o, i) {
            let r, s, n = 0;
            for(let o = 0; o < e.length; o++){
                const a = N(e[o][0]), l = J(e[o][1]);
                t.push(a, l, 0), o > 0 && (n += i ? (r * l - a * s) / 2 : Math.sqrt(Math.pow(a - r, 2) + Math.pow(l - s, 2))), r = a, s = l;
            }
            const a = t.length - 3;
            t[2] = 1, L(t, 0, a, o), t[a + 2] = 1, t.size = Math.abs(n), t.start = 0, t.end = t.size;
        }
        function Z(e, t, o, i) {
            for(let r = 0; r < e.length; r++){
                const s = [];
                E(e[r], s, o, i), t.push(s);
            }
        }
        function N(e) {
            return e / 360 + .5;
        }
        function J(e) {
            const t = Math.sin(e * Math.PI / 180), o = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
            return o < 0 ? 0 : o > 1 ? 1 : o;
        }
        function W(e, t, o, i, r, s, n, a) {
            if (i /= t, s >= (o /= t) && n < i) return e;
            if (n < o || s >= i) return null;
            const l = [];
            for (const t of e){
                const e = t.geometry;
                let s = t.type;
                const n = 0 === r ? t.minX : t.minY, c = 0 === r ? t.maxX : t.maxY;
                if (n >= o && c < i) {
                    l.push(t);
                    continue;
                }
                if (c < o || n >= i) continue;
                let u = [];
                if ("Point" === s || "MultiPoint" === s) R(e, u, o, i, r);
                else if ("LineString" === s) Y(e, u, o, i, r, !1, a.lineMetrics);
                else if ("MultiLineString" === s) H(e, u, o, i, r, !1);
                else if ("Polygon" === s) H(e, u, o, i, r, !0);
                else if ("MultiPolygon" === s) for (const t of e){
                    const e = [];
                    H(t, e, o, i, r, !0), e.length && u.push(e);
                }
                if (u.length) {
                    if (a.lineMetrics && "LineString" === s) {
                        for (const e of u)l.push(G(t.id, s, e, t.tags));
                        continue;
                    }
                    "LineString" !== s && "MultiLineString" !== s || (1 === u.length ? (s = "LineString", u = u[0]) : s = "MultiLineString"), "Point" !== s && "MultiPoint" !== s || (s = 3 === u.length ? "Point" : "MultiPoint"), l.push(G(t.id, s, u, t.tags));
                }
            }
            return l.length ? l : null;
        }
        function R(e, t, o, i, r) {
            for(let s = 0; s < e.length; s += 3){
                const n = e[s + r];
                n >= o && n <= i && V(t, e[s], e[s + 1], e[s + 2]);
            }
        }
        function Y(e, t, o, i, r, s, n) {
            let a = q(e);
            const l = 0 === r ? X : B;
            let c, u, h = e.start;
            for(let d = 0; d < e.length - 3; d += 3){
                const f = e[d], g = e[d + 1], p = e[d + 2], m = e[d + 3], y = e[d + 4], v = 0 === r ? f : g, w = 0 === r ? m : y;
                let x = !1;
                n && (c = Math.sqrt(Math.pow(f - m, 2) + Math.pow(g - y, 2))), v < o ? w > o && (u = l(a, f, g, m, y, o), n && (a.start = h + c * u)) : v > i ? w < i && (u = l(a, f, g, m, y, i), n && (a.start = h + c * u)) : V(a, f, g, p), w < o && v >= o && (u = l(a, f, g, m, y, o), x = !0), w > i && v <= i && (u = l(a, f, g, m, y, i), x = !0), !s && x && (n && (a.end = h + c * u), t.push(a), a = q(e)), n && (h += c);
            }
            let d = e.length - 3;
            const f = e[d], g = e[d + 1], p = 0 === r ? f : g;
            p >= o && p <= i && V(a, f, g, e[d + 2]), d = a.length - 3, s && d >= 3 && (a[d] !== a[0] || a[d + 1] !== a[1]) && V(a, a[0], a[1], a[2]), a.length && t.push(a);
        }
        function q(e) {
            const t = [];
            return t.size = e.size, t.start = e.start, t.end = e.end, t;
        }
        function H(e, t, o, i, r, s) {
            for (const n of e)Y(n, t, o, i, r, s, !1);
        }
        function V(e, t, o, i) {
            e.push(t, o, i);
        }
        function X(e, t, o, i, r, s) {
            const n = (s - t) / (i - t);
            return V(e, s, o + (r - o) * n, 1), n;
        }
        function B(e, t, o, i, r, s) {
            const n = (s - o) / (r - o);
            return V(e, t + (i - t) * n, s, 1), n;
        }
        function $(e, t) {
            const o = [];
            for(let i = 0; i < e.length; i++){
                const r = e[i], s = r.type;
                let n;
                if ("Point" === s || "MultiPoint" === s || "LineString" === s) n = U(r.geometry, t);
                else if ("MultiLineString" === s || "Polygon" === s) {
                    n = [];
                    for (const e of r.geometry)n.push(U(e, t));
                } else if ("MultiPolygon" === s) {
                    n = [];
                    for (const e of r.geometry){
                        const o = [];
                        for (const i of e)o.push(U(i, t));
                        n.push(o);
                    }
                }
                o.push(G(r.id, s, n, r.tags));
            }
            return o;
        }
        function U(e, t) {
            const o = [];
            o.size = e.size, void 0 !== e.start && (o.start = e.start, o.end = e.end);
            for(let i = 0; i < e.length; i += 3)o.push(e[i] + t, e[i + 1], e[i + 2]);
            return o;
        }
        function K(e, t) {
            if (e.transformed) return e;
            const o = 1 << e.z, i = e.x, r = e.y;
            for (const s of e.features){
                const e = s.geometry, n = s.type;
                if (s.geometry = [], 1 === n) for(let n = 0; n < e.length; n += 2)s.geometry.push(Q(e[n], e[n + 1], t, o, i, r));
                else for(let n = 0; n < e.length; n++){
                    const a = [];
                    for(let s = 0; s < e[n].length; s += 2)a.push(Q(e[n][s], e[n][s + 1], t, o, i, r));
                    s.geometry.push(a);
                }
            }
            return e.transformed = !0, e;
        }
        function Q(e, t, o, i, r, s) {
            return [
                Math.round(o * (e * i - r)),
                Math.round(o * (t * i - s))
            ];
        }
        function ee(e, t, o, i, r) {
            const s = t === r.maxZoom ? 0 : r.tolerance / ((1 << t) * r.extent), n = {
                features: [],
                numPoints: 0,
                numSimplified: 0,
                numFeatures: e.length,
                source: null,
                x: o,
                y: i,
                z: t,
                transformed: !1,
                minX: 2,
                minY: 1,
                maxX: -1,
                maxY: 0
            };
            for (const t of e)te(n, t, s, r);
            return n;
        }
        function te(e, t, o, i) {
            const r = t.geometry, s = t.type, n = [];
            if (e.minX = Math.min(e.minX, t.minX), e.minY = Math.min(e.minY, t.minY), e.maxX = Math.max(e.maxX, t.maxX), e.maxY = Math.max(e.maxY, t.maxY), "Point" === s || "MultiPoint" === s) for(let t = 0; t < r.length; t += 3)n.push(r[t], r[t + 1]), e.numPoints++, e.numSimplified++;
            else if ("LineString" === s) oe(n, r, e, o, !1, !1);
            else if ("MultiLineString" === s || "Polygon" === s) for(let t = 0; t < r.length; t++)oe(n, r[t], e, o, "Polygon" === s, 0 === t);
            else if ("MultiPolygon" === s) for(let t = 0; t < r.length; t++){
                const i = r[t];
                for(let t = 0; t < i.length; t++)oe(n, i[t], e, o, !0, 0 === t);
            }
            if (n.length) {
                let o = t.tags || null;
                if ("LineString" === s && i.lineMetrics) {
                    o = {};
                    for(const e in t.tags)o[e] = t.tags[e];
                    o.mapbox_clip_start = r.start / r.size, o.mapbox_clip_end = r.end / r.size;
                }
                const a = {
                    geometry: n,
                    type: "Polygon" === s || "MultiPolygon" === s ? 3 : "LineString" === s || "MultiLineString" === s ? 2 : 1,
                    tags: o
                };
                null !== t.id && (a.id = t.id), e.features.push(a);
            }
        }
        function oe(e, t, o, i, r, s) {
            const n = i * i;
            if (i > 0 && t.size < (r ? n : i)) return void (o.numPoints += t.length / 3);
            const a = [];
            for(let e = 0; e < t.length; e += 3)(0 === i || t[e + 2] > n) && (o.numSimplified++, a.push(t[e], t[e + 1])), o.numPoints++;
            r && function(e, t) {
                let o = 0;
                for(let t = 0, i = e.length, r = i - 2; t < i; r = t, t += 2)o += (e[t] - e[r]) * (e[t + 1] + e[r + 1]);
                if (o > 0 === t) for(let t = 0, o = e.length; t < o / 2; t += 2){
                    const i = e[t], r = e[t + 1];
                    e[t] = e[o - 2 - t], e[t + 1] = e[o - 1 - t], e[o - 2 - t] = i, e[o - 1 - t] = r;
                }
            }(a, s), e.push(a);
        }
        const ie = {
            maxZoom: 14,
            indexMaxZoom: 5,
            indexMaxPoints: 1e5,
            tolerance: 3,
            extent: 4096,
            buffer: 64,
            lineMetrics: !1,
            promoteId: null,
            generateId: !1,
            debug: 0
        };
        class re {
            constructor(e, t){
                const o = (t = this.options = function(e, t) {
                    for(const o in t)e[o] = t[o];
                    return e;
                }(Object.create(ie), t)).debug;
                if (o && console.time("preprocess data"), t.maxZoom < 0 || t.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                if (t.promoteId && t.generateId) throw new Error("promoteId and generateId cannot be used together.");
                let i = function(e, t) {
                    const o = [];
                    if ("FeatureCollection" === e.type) for(let i = 0; i < e.features.length; i++)A(o, e.features[i], t, i);
                    else A(o, "Feature" === e.type ? e : {
                        geometry: e
                    }, t);
                    return o;
                }(e, t);
                this.tiles = {}, this.tileCoords = [], o && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t.indexMaxZoom, t.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), i = function(e, t) {
                    const o = t.buffer / t.extent;
                    let i = e;
                    const r = W(e, 1, -1 - o, o, 0, -1, 2, t), s = W(e, 1, 1 - o, 2 + o, 0, -1, 2, t);
                    return (r || s) && (i = W(e, 1, -o, 1 + o, 0, -1, 2, t) || [], r && (i = $(r, 1).concat(i)), s && (i = i.concat($(s, -1)))), i;
                }(i, t), i.length && this.splitTile(i, 0, 0, 0), o && (i.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
            }
            splitTile(e, t, o, i, r, s, n) {
                const a = [
                    e,
                    t,
                    o,
                    i
                ], l = this.options, c = l.debug;
                for(; a.length;){
                    i = a.pop(), o = a.pop(), t = a.pop(), e = a.pop();
                    const u = 1 << t, h = se(t, o, i);
                    let d = this.tiles[h];
                    if (!d && (c > 1 && console.time("creation"), d = this.tiles[h] = ee(e, t, o, i, l), this.tileCoords.push({
                        z: t,
                        x: o,
                        y: i
                    }), c)) {
                        c > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t, o, i, d.numFeatures, d.numPoints, d.numSimplified), console.timeEnd("creation"));
                        const e = `z${t}`;
                        this.stats[e] = (this.stats[e] || 0) + 1, this.total++;
                    }
                    if (d.source = e, null == r) {
                        if (t === l.indexMaxZoom || d.numPoints <= l.indexMaxPoints) continue;
                    } else {
                        if (t === l.maxZoom || t === r) continue;
                        if (null != r) {
                            const e = r - t;
                            if (o !== s >> e || i !== n >> e) continue;
                        }
                    }
                    if (d.source = null, 0 === e.length) continue;
                    c > 1 && console.time("clipping");
                    const f = .5 * l.buffer / l.extent, g = .5 - f, p = .5 + f, m = 1 + f;
                    let y = null, v = null, w = null, x = null, _ = W(e, u, o - f, o + p, 0, d.minX, d.maxX, l), b = W(e, u, o + g, o + m, 0, d.minX, d.maxX, l);
                    e = null, _ && (y = W(_, u, i - f, i + p, 1, d.minY, d.maxY, l), v = W(_, u, i + g, i + m, 1, d.minY, d.maxY, l), _ = null), b && (w = W(b, u, i - f, i + p, 1, d.minY, d.maxY, l), x = W(b, u, i + g, i + m, 1, d.minY, d.maxY, l), b = null), c > 1 && console.timeEnd("clipping"), a.push(y || [], t + 1, 2 * o, 2 * i), a.push(v || [], t + 1, 2 * o, 2 * i + 1), a.push(w || [], t + 1, 2 * o + 1, 2 * i), a.push(x || [], t + 1, 2 * o + 1, 2 * i + 1);
                }
            }
            getTile(e, t, o) {
                e = +e, t = +t, o = +o;
                const i = this.options, { extent: r, debug: s } = i;
                if (e < 0 || e > 24) return null;
                const n = 1 << e, a = se(e, t = t + n & n - 1, o);
                if (this.tiles[a]) return K(this.tiles[a], r);
                s > 1 && console.log("drilling down to z%d-%d-%d", e, t, o);
                let l, c = e, u = t, h = o;
                for(; !l && c > 0;)c--, u >>= 1, h >>= 1, l = this.tiles[se(c, u, h)];
                return l && l.source ? (s > 1 && (console.log("found parent tile z%d-%d-%d", c, u, h), console.time("drilling down")), this.splitTile(l.source, c, u, h, e, t, o), s > 1 && console.timeEnd("drilling down"), this.tiles[a] ? K(this.tiles[a], r) : null) : null;
            }
        }
        function se(e, t, o) {
            return 32 * ((1 << e) * o + t) + e;
        }
        function ne(e, t) {
            return t ? e.properties[t] : e.id;
        }
        function ae(e, t) {
            if (null == e) return !0;
            if ("Feature" === e.type) return null != ne(e, t);
            if ("FeatureCollection" === e.type) {
                const o = new Set;
                for (const i of e.features){
                    const e = ne(i, t);
                    if (null == e) return !1;
                    if (o.has(e)) return !1;
                    o.add(e);
                }
                return !0;
            }
            return !1;
        }
        function le(e, t) {
            const o = new Map;
            if (null == e) ;
            else if ("Feature" === e.type) o.set(ne(e, t), e);
            else for (const i of e.features)o.set(ne(i, t), i);
            return o;
        }
        class ce extends s {
            constructor(){
                super(...arguments), this._dataUpdateable = new Map;
            }
            loadVectorTile(t, o) {
                return e._(this, void 0, void 0, function*() {
                    const e = t.tileID.canonical;
                    if (!this._geoJSONIndex) throw new Error("Unable to parse the data into a cluster or geojson");
                    const o = this._geoJSONIndex.getTile(e.z, e.x, e.y);
                    if (!o) return null;
                    const i = new f(o.features);
                    let r = w(i);
                    return 0 === r.byteOffset && r.byteLength === r.buffer.byteLength || (r = new Uint8Array(r)), {
                        vectorTile: i,
                        rawData: r.buffer
                    };
                });
            }
            loadData(t) {
                return e._(this, void 0, void 0, function*() {
                    var o;
                    null === (o = this._pendingRequest) || void 0 === o || o.abort();
                    const i = !!(t && t.request && t.request.collectResourceTiming) && new e.cA(t.request);
                    this._pendingRequest = new AbortController;
                    try {
                        this._pendingData = this.loadAndProcessGeoJSON(t, this._pendingRequest), this._geoJSONIndex = t.cluster ? new P(function({ superclusterOptions: t, clusterProperties: o }) {
                            if (!o || !t) return t;
                            const i = {}, r = {}, s = {
                                accumulated: null,
                                zoom: 0
                            }, n = {
                                properties: null
                            }, a = Object.keys(o);
                            for (const t of a){
                                const [s, n] = o[t], a = e.cH(n), l = e.cH("string" == typeof s ? [
                                    s,
                                    [
                                        "accumulated"
                                    ],
                                    [
                                        "get",
                                        t
                                    ]
                                ] : s);
                                i[t] = a.value, r[t] = l.value;
                            }
                            return t.map = (e)=>{
                                n.properties = e;
                                const t = {};
                                for (const e of a)t[e] = i[e].evaluate(s, n);
                                return t;
                            }, t.reduce = (e, t)=>{
                                n.properties = t;
                                for (const t of a)s.accumulated = e[t], e[t] = r[t].evaluate(s, n);
                            }, t;
                        }(t)).load((yield this._pendingData).features) : (r = yield this._pendingData, new re(r, t.geojsonVtOptions)), this.loaded = {};
                        const o = {};
                        if (i) {
                            const e = i.finish();
                            e && (o.resourceTiming = {}, o.resourceTiming[t.source] = JSON.parse(JSON.stringify(e)));
                        }
                        return o;
                    } catch (t) {
                        if (delete this._pendingRequest, e.cl(t)) return {
                            abandoned: !0
                        };
                        throw t;
                    }
                    var r;
                });
            }
            getData() {
                return e._(this, void 0, void 0, function*() {
                    return this._pendingData;
                });
            }
            reloadTile(e) {
                const t = this.loaded;
                return t && t[e.uid] ? super.reloadTile(e) : this.loadTile(e);
            }
            loadAndProcessGeoJSON(t, o) {
                return e._(this, void 0, void 0, function*() {
                    let i = yield this.loadGeoJSON(t, o);
                    if (delete this._pendingRequest, "object" != typeof i) throw new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`);
                    if (u(i, !0), t.filter) {
                        const o = e.cH(t.filter, {
                            type: "boolean",
                            "property-type": "data-driven",
                            overridable: !1,
                            transition: !1
                        });
                        if ("error" === o.result) throw new Error(o.value.map((e)=>`${e.key}: ${e.message}`).join(", "));
                        const r = i.features.filter((e)=>o.value.evaluate({
                                zoom: 0
                            }, e));
                        i = {
                            type: "FeatureCollection",
                            features: r
                        };
                    }
                    return i;
                });
            }
            loadGeoJSON(t, o) {
                return e._(this, void 0, void 0, function*() {
                    const { promoteId: i } = t;
                    if (t.request) {
                        const r = yield e.j(t.request, o);
                        return this._dataUpdateable = ae(r.data, i) ? le(r.data, i) : void 0, r.data;
                    }
                    if ("string" == typeof t.data) try {
                        const e = JSON.parse(t.data);
                        return this._dataUpdateable = ae(e, i) ? le(e, i) : void 0, e;
                    } catch (e) {
                        throw new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`);
                    }
                    if (!t.dataDiff) throw new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`);
                    if (!this._dataUpdateable) throw new Error(`Cannot update existing geojson data in ${t.source}`);
                    return function(e, t, o) {
                        var i, r, s, n;
                        if (t.removeAll && e.clear(), t.remove) for (const o of t.remove)e.delete(o);
                        if (t.add) for (const i of t.add){
                            const t = ne(i, o);
                            null != t && e.set(t, i);
                        }
                        if (t.update) for (const o of t.update){
                            let t = e.get(o.id);
                            if (null == t) continue;
                            const a = !o.removeAllProperties && ((null === (i = o.removeProperties) || void 0 === i ? void 0 : i.length) > 0 || (null === (r = o.addOrUpdateProperties) || void 0 === r ? void 0 : r.length) > 0);
                            if ((o.newGeometry || o.removeAllProperties || a) && (t = Object.assign({}, t), e.set(o.id, t), a && (t.properties = Object.assign({}, t.properties))), o.newGeometry && (t.geometry = o.newGeometry), o.removeAllProperties) t.properties = {};
                            else if ((null === (s = o.removeProperties) || void 0 === s ? void 0 : s.length) > 0) for (const e of o.removeProperties)Object.prototype.hasOwnProperty.call(t.properties, e) && delete t.properties[e];
                            if ((null === (n = o.addOrUpdateProperties) || void 0 === n ? void 0 : n.length) > 0) for (const { key: e, value: i } of o.addOrUpdateProperties)t.properties[e] = i;
                        }
                    }(this._dataUpdateable, t.dataDiff, i), {
                        type: "FeatureCollection",
                        features: Array.from(this._dataUpdateable.values())
                    };
                });
            }
            removeSource(t) {
                return e._(this, void 0, void 0, function*() {
                    this._pendingRequest && this._pendingRequest.abort();
                });
            }
            getClusterExpansionZoom(e) {
                return this._geoJSONIndex.getClusterExpansionZoom(e.clusterId);
            }
            getClusterChildren(e) {
                return this._geoJSONIndex.getChildren(e.clusterId);
            }
            getClusterLeaves(e) {
                return this._geoJSONIndex.getLeaves(e.clusterId, e.limit, e.offset);
            }
        }
        class ue {
            constructor(t){
                this.self = t, this.actor = new e.H(t), this.layerIndexes = {}, this.availableImages = {}, this.workerSources = {}, this.demWorkerSources = {}, this.externalWorkerSourceTypes = {}, this.self.registerWorkerSource = (e, t)=>{
                    if (this.externalWorkerSourceTypes[e]) throw new Error(`Worker source with name "${e}" already registered.`);
                    this.externalWorkerSourceTypes[e] = t;
                }, this.self.addProtocol = e.cn, this.self.removeProtocol = e.co, this.self.registerRTLTextPlugin = (t)=>{
                    e.cI.setMethods(t);
                }, this.actor.registerMessageHandler("LDT", (e, t)=>this._getDEMWorkerSource(e, t.source).loadTile(t)), this.actor.registerMessageHandler("RDT", (t, o)=>e._(this, void 0, void 0, function*() {
                        this._getDEMWorkerSource(t, o.source).removeTile(o);
                    })), this.actor.registerMessageHandler("GCEZ", (t, o)=>e._(this, void 0, void 0, function*() {
                        return this._getWorkerSource(t, o.type, o.source).getClusterExpansionZoom(o);
                    })), this.actor.registerMessageHandler("GCC", (t, o)=>e._(this, void 0, void 0, function*() {
                        return this._getWorkerSource(t, o.type, o.source).getClusterChildren(o);
                    })), this.actor.registerMessageHandler("GCL", (t, o)=>e._(this, void 0, void 0, function*() {
                        return this._getWorkerSource(t, o.type, o.source).getClusterLeaves(o);
                    })), this.actor.registerMessageHandler("LD", (e, t)=>this._getWorkerSource(e, t.type, t.source).loadData(t)), this.actor.registerMessageHandler("GD", (e, t)=>this._getWorkerSource(e, t.type, t.source).getData()), this.actor.registerMessageHandler("LT", (e, t)=>this._getWorkerSource(e, t.type, t.source).loadTile(t)), this.actor.registerMessageHandler("RT", (e, t)=>this._getWorkerSource(e, t.type, t.source).reloadTile(t)), this.actor.registerMessageHandler("AT", (e, t)=>this._getWorkerSource(e, t.type, t.source).abortTile(t)), this.actor.registerMessageHandler("RMT", (e, t)=>this._getWorkerSource(e, t.type, t.source).removeTile(t)), this.actor.registerMessageHandler("RS", (t, o)=>e._(this, void 0, void 0, function*() {
                        if (!this.workerSources[t] || !this.workerSources[t][o.type] || !this.workerSources[t][o.type][o.source]) return;
                        const e = this.workerSources[t][o.type][o.source];
                        delete this.workerSources[t][o.type][o.source], void 0 !== e.removeSource && e.removeSource(o);
                    })), this.actor.registerMessageHandler("RM", (t)=>e._(this, void 0, void 0, function*() {
                        delete this.layerIndexes[t], delete this.availableImages[t], delete this.workerSources[t], delete this.demWorkerSources[t];
                    })), this.actor.registerMessageHandler("SR", (t, o)=>e._(this, void 0, void 0, function*() {
                        this.referrer = o;
                    })), this.actor.registerMessageHandler("SRPS", (e, t)=>this._syncRTLPluginState(e, t)), this.actor.registerMessageHandler("IS", (t, o)=>e._(this, void 0, void 0, function*() {
                        this.self.importScripts(o);
                    })), this.actor.registerMessageHandler("SI", (e, t)=>this._setImages(e, t)), this.actor.registerMessageHandler("UL", (t, o)=>e._(this, void 0, void 0, function*() {
                        this._getLayerIndex(t).update(o.layers, o.removedIds);
                    })), this.actor.registerMessageHandler("SL", (t, o)=>e._(this, void 0, void 0, function*() {
                        this._getLayerIndex(t).replace(o);
                    }));
            }
            _setImages(t, o) {
                return e._(this, void 0, void 0, function*() {
                    this.availableImages[t] = o;
                    for(const e in this.workerSources[t]){
                        const i = this.workerSources[t][e];
                        for(const e in i)i[e].availableImages = o;
                    }
                });
            }
            _syncRTLPluginState(t, o) {
                return e._(this, void 0, void 0, function*() {
                    return yield e.cI.syncState(o, this.self.importScripts);
                });
            }
            _getAvailableImages(e) {
                let t = this.availableImages[e];
                return t || (t = []), t;
            }
            _getLayerIndex(e) {
                let o = this.layerIndexes[e];
                return o || (o = this.layerIndexes[e] = new t), o;
            }
            _getWorkerSource(e, t, o) {
                if (this.workerSources[e] || (this.workerSources[e] = {}), this.workerSources[e][t] || (this.workerSources[e][t] = {}), !this.workerSources[e][t][o]) {
                    const i = {
                        sendAsync: (t, o)=>(t.targetMapId = e, this.actor.sendAsync(t, o))
                    };
                    switch(t){
                        case "vector":
                            this.workerSources[e][t][o] = new s(i, this._getLayerIndex(e), this._getAvailableImages(e));
                            break;
                        case "geojson":
                            this.workerSources[e][t][o] = new ce(i, this._getLayerIndex(e), this._getAvailableImages(e));
                            break;
                        default:
                            this.workerSources[e][t][o] = new this.externalWorkerSourceTypes[t](i, this._getLayerIndex(e), this._getAvailableImages(e));
                    }
                }
                return this.workerSources[e][t][o];
            }
            _getDEMWorkerSource(e, t) {
                return this.demWorkerSources[e] || (this.demWorkerSources[e] = {}), this.demWorkerSources[e][t] || (this.demWorkerSources[e][t] = new n), this.demWorkerSources[e][t];
            }
        }
        return e.i(self) && (self.worker = new ue(self)), ue;
    });
    define("index", [
        "exports",
        "./shared"
    ], function(e, t) {
        "use strict";
        var i = "5.3.1";
        function r() {
            var e = new t.A(4);
            return t.A != Float32Array && (e[1] = 0, e[2] = 0), e[0] = 1, e[3] = 1, e;
        }
        let o, a;
        const s = {
            now: "undefined" != typeof performance && performance && performance.now ? performance.now.bind(performance) : Date.now.bind(Date),
            frame (e, i, r) {
                const o = requestAnimationFrame((e)=>{
                    a(), i(e);
                }), { unsubscribe: a } = t.s(e.signal, "abort", ()=>{
                    a(), cancelAnimationFrame(o), r(t.c());
                }, !1);
            },
            frameAsync (e) {
                return new Promise((t, i)=>{
                    this.frame(e, t, i);
                });
            },
            getImageData (e, t = 0) {
                return this.getImageCanvasContext(e).getImageData(-t, -t, e.width + 2 * t, e.height + 2 * t);
            },
            getImageCanvasContext (e) {
                const t = window.document.createElement("canvas"), i = t.getContext("2d", {
                    willReadFrequently: !0
                });
                if (!i) throw new Error("failed to create canvas 2d context");
                return t.width = e.width, t.height = e.height, i.drawImage(e, 0, 0, e.width, e.height), i;
            },
            resolveURL: (e)=>(o || (o = document.createElement("a")), o.href = e, o.href),
            hardwareConcurrency: "undefined" != typeof navigator && navigator.hardwareConcurrency || 4,
            get prefersReducedMotion () {
                return !!matchMedia && (null == a && (a = matchMedia("(prefers-reduced-motion: reduce)")), a.matches);
            }
        };
        class n {
            static testProp(e) {
                if (!n.docStyle) return e[0];
                for(let t = 0; t < e.length; t++)if (e[t] in n.docStyle) return e[t];
                return e[0];
            }
            static create(e, t, i) {
                const r = window.document.createElement(e);
                return void 0 !== t && (r.className = t), i && i.appendChild(r), r;
            }
            static createNS(e, t) {
                return window.document.createElementNS(e, t);
            }
            static disableDrag() {
                n.docStyle && n.selectProp && (n.userSelect = n.docStyle[n.selectProp], n.docStyle[n.selectProp] = "none");
            }
            static enableDrag() {
                n.docStyle && n.selectProp && (n.docStyle[n.selectProp] = n.userSelect);
            }
            static setTransform(e, t) {
                e.style[n.transformProp] = t;
            }
            static addEventListener(e, t, i, r = {}) {
                e.addEventListener(t, i, "passive" in r ? r : r.capture);
            }
            static removeEventListener(e, t, i, r = {}) {
                e.removeEventListener(t, i, "passive" in r ? r : r.capture);
            }
            static suppressClickInternal(e) {
                e.preventDefault(), e.stopPropagation(), window.removeEventListener("click", n.suppressClickInternal, !0);
            }
            static suppressClick() {
                window.addEventListener("click", n.suppressClickInternal, !0), window.setTimeout(()=>{
                    window.removeEventListener("click", n.suppressClickInternal, !0);
                }, 0);
            }
            static getScale(e) {
                const t = e.getBoundingClientRect();
                return {
                    x: t.width / e.offsetWidth || 1,
                    y: t.height / e.offsetHeight || 1,
                    boundingClientRect: t
                };
            }
            static getPoint(e, i, r) {
                const o = i.boundingClientRect;
                return new t.P((r.clientX - o.left) / i.x - e.clientLeft, (r.clientY - o.top) / i.y - e.clientTop);
            }
            static mousePos(e, t) {
                const i = n.getScale(e);
                return n.getPoint(e, i, t);
            }
            static touchPos(e, t) {
                const i = [], r = n.getScale(e);
                for(let o = 0; o < t.length; o++)i.push(n.getPoint(e, r, t[o]));
                return i;
            }
            static mouseButton(e) {
                return e.button;
            }
            static remove(e) {
                e.parentNode && e.parentNode.removeChild(e);
            }
            static sanitize(e) {
                const t = (new DOMParser).parseFromString(e, "text/html").body || document.createElement("body"), i = t.querySelectorAll("script");
                for (const e of i)e.remove();
                return n.clean(t), t.innerHTML;
            }
            static isPossiblyDangerous(e, t) {
                const i = t.replace(/\s+/g, "").toLowerCase();
                return !(![
                    "src",
                    "href",
                    "xlink:href"
                ].includes(e) || !i.includes("javascript:") && !i.includes("data:")) || !!e.startsWith("on") || void 0;
            }
            static clean(e) {
                const t = e.children;
                for (const e of t)n.removeAttributes(e), n.clean(e);
            }
            static removeAttributes(e) {
                for (const { name: t, value: i } of e.attributes)n.isPossiblyDangerous(t, i) && e.removeAttribute(t);
            }
        }
        n.docStyle = "undefined" != typeof window && window.document && window.document.documentElement.style, n.selectProp = n.testProp([
            "userSelect",
            "MozUserSelect",
            "WebkitUserSelect",
            "msUserSelect"
        ]), n.transformProp = n.testProp([
            "transform",
            "WebkitTransform"
        ]);
        const l = {
            supported: !1,
            testSupport: function(e) {
                !u && h && (d ? _(e) : c = e);
            }
        };
        let c, h, u = !1, d = !1;
        function _(e) {
            const t = e.createTexture();
            e.bindTexture(e.TEXTURE_2D, t);
            try {
                if (e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.RGBA, e.UNSIGNED_BYTE, h), e.isContextLost()) return;
                l.supported = !0;
            } catch (e) {}
            e.deleteTexture(t), u = !0;
        }
        var p;
        "undefined" != typeof document && (h = document.createElement("img"), h.onload = ()=>{
            c && _(c), c = null, d = !0;
        }, h.onerror = ()=>{
            u = !0, c = null;
        }, h.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA="), function(e) {
            let i, r, o, a;
            e.resetRequestQueue = ()=>{
                i = [], r = 0, o = 0, a = {};
            }, e.addThrottleControl = (e)=>{
                const t = o++;
                return a[t] = e, t;
            }, e.removeThrottleControl = (e)=>{
                delete a[e], n();
            }, e.getImage = (e, r, o = !0)=>new Promise((a, s)=>{
                    l.supported && (e.headers || (e.headers = {}), e.headers.accept = "image/webp,*/*"), t.e(e, {
                        type: "image"
                    }), i.push({
                        abortController: r,
                        requestParameters: e,
                        supportImageRefresh: o,
                        state: "queued",
                        onError: (e)=>{
                            s(e);
                        },
                        onSuccess: (e)=>{
                            a(e);
                        }
                    }), n();
                });
            const s = (e)=>t._(this, void 0, void 0, function*() {
                    e.state = "running";
                    const { requestParameters: i, supportImageRefresh: o, onError: a, onSuccess: s, abortController: l } = e, h = !1 === o && !t.i(self) && !t.g(i.url) && (!i.headers || Object.keys(i.headers).reduce((e, t)=>e && "accept" === t, !0));
                    r++;
                    const u = h ? c(i, l) : t.m(i, l);
                    try {
                        const i = yield u;
                        delete e.abortController, e.state = "completed", i.data instanceof HTMLImageElement || t.b(i.data) ? s(i) : i.data && s({
                            data: yield (d = i.data, "function" == typeof createImageBitmap ? t.f(d) : t.h(d)),
                            cacheControl: i.cacheControl,
                            expires: i.expires
                        });
                    } catch (t) {
                        delete e.abortController, a(t);
                    } finally{
                        r--, n();
                    }
                    var d;
                }), n = ()=>{
                const e = (()=>{
                    for (const e of Object.keys(a))if (a[e]()) return !0;
                    return !1;
                })() ? t.a.MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME : t.a.MAX_PARALLEL_IMAGE_REQUESTS;
                for(let t = r; t < e && i.length > 0; t++){
                    const e = i.shift();
                    e.abortController.signal.aborted ? t-- : s(e);
                }
            }, c = (e, i)=>new Promise((r, o)=>{
                    const a = new Image, s = e.url, n = e.credentials;
                    n && "include" === n ? a.crossOrigin = "use-credentials" : (n && "same-origin" === n || !t.d(s)) && (a.crossOrigin = "anonymous"), i.signal.addEventListener("abort", ()=>{
                        a.src = "", o(t.c());
                    }), a.fetchPriority = "high", a.onload = ()=>{
                        a.onerror = a.onload = null, r({
                            data: a
                        });
                    }, a.onerror = ()=>{
                        a.onerror = a.onload = null, i.signal.aborted || o(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                    }, a.src = s;
                });
        }(p || (p = {})), p.resetRequestQueue();
        class m {
            constructor(e){
                this._transformRequestFn = e;
            }
            transformRequest(e, t) {
                return this._transformRequestFn && this._transformRequestFn(e, t) || {
                    url: e
                };
            }
            setTransformRequest(e) {
                this._transformRequestFn = e;
            }
        }
        function f(e) {
            const t = [];
            if ("string" == typeof e) t.push({
                id: "default",
                url: e
            });
            else if (e && e.length > 0) {
                const i = [];
                for (const { id: r, url: o } of e){
                    const e = `${r}${o}`;
                    -1 === i.indexOf(e) && (i.push(e), t.push({
                        id: r,
                        url: o
                    }));
                }
            }
            return t;
        }
        function g(e, t, i) {
            try {
                const r = new URL(e);
                return r.pathname += `${t}${i}`, r.toString();
            } catch (t) {
                throw new Error(`Invalid sprite URL "${e}", must be absolute. Modify style specification directly or use TransformStyleFunction to correct the issue dynamically`);
            }
        }
        class v {
            constructor(e, t, i, r){
                this.context = e, this.format = i, this.texture = e.gl.createTexture(), this.update(t, r);
            }
            update(e, i, r) {
                const { width: o, height: a } = e, s = !(this.size && this.size[0] === o && this.size[1] === a || r), { context: n } = this, { gl: l } = n;
                if (this.useMipmap = Boolean(i && i.useMipmap), l.bindTexture(l.TEXTURE_2D, this.texture), n.pixelStoreUnpackFlipY.set(!1), n.pixelStoreUnpack.set(1), n.pixelStoreUnpackPremultiplyAlpha.set(this.format === l.RGBA && (!i || !1 !== i.premultiply)), s) this.size = [
                    o,
                    a
                ], e instanceof HTMLImageElement || e instanceof HTMLCanvasElement || e instanceof HTMLVideoElement || e instanceof ImageData || t.b(e) ? l.texImage2D(l.TEXTURE_2D, 0, this.format, this.format, l.UNSIGNED_BYTE, e) : l.texImage2D(l.TEXTURE_2D, 0, this.format, o, a, 0, this.format, l.UNSIGNED_BYTE, e.data);
                else {
                    const { x: i, y: s } = r || {
                        x: 0,
                        y: 0
                    };
                    e instanceof HTMLImageElement || e instanceof HTMLCanvasElement || e instanceof HTMLVideoElement || e instanceof ImageData || t.b(e) ? l.texSubImage2D(l.TEXTURE_2D, 0, i, s, l.RGBA, l.UNSIGNED_BYTE, e) : l.texSubImage2D(l.TEXTURE_2D, 0, i, s, o, a, l.RGBA, l.UNSIGNED_BYTE, e.data);
                }
                this.useMipmap && this.isSizePowerOfTwo() && l.generateMipmap(l.TEXTURE_2D), n.pixelStoreUnpackFlipY.setDefault(), n.pixelStoreUnpack.setDefault(), n.pixelStoreUnpackPremultiplyAlpha.setDefault();
            }
            bind(e, t, i) {
                const { context: r } = this, { gl: o } = r;
                o.bindTexture(o.TEXTURE_2D, this.texture), i !== o.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (i = o.LINEAR), e !== this.filter && (o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MAG_FILTER, e), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MIN_FILTER, i || e), this.filter = e), t !== this.wrap && (o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_S, t), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_T, t), this.wrap = t);
            }
            isSizePowerOfTwo() {
                return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
            }
            destroy() {
                const { gl: e } = this.context;
                e.deleteTexture(this.texture), this.texture = null;
            }
        }
        function x(e) {
            const { userImage: t } = e;
            return !!(t && t.render && t.render()) && (e.data.replace(new Uint8Array(t.data.buffer)), !0);
        }
        class b extends t.E {
            constructor(){
                super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.patterns = {}, this.atlasImage = new t.R({
                    width: 1,
                    height: 1
                }), this.dirty = !0;
            }
            isLoaded() {
                return this.loaded;
            }
            setLoaded(e) {
                if (this.loaded !== e && (this.loaded = e, e)) {
                    for (const { ids: e, promiseResolve: t } of this.requestors)t(this._getImagesForIds(e));
                    this.requestors = [];
                }
            }
            getImage(e) {
                const i = this.images[e];
                if (i && !i.data && i.spriteData) {
                    const e = i.spriteData;
                    i.data = new t.R({
                        width: e.width,
                        height: e.height
                    }, e.context.getImageData(e.x, e.y, e.width, e.height).data), i.spriteData = null;
                }
                return i;
            }
            addImage(e, t) {
                if (this.images[e]) throw new Error(`Image id ${e} already exist, use updateImage instead`);
                this._validate(e, t) && (this.images[e] = t);
            }
            _validate(e, i) {
                let r = !0;
                const o = i.data || i.spriteData;
                return this._validateStretch(i.stretchX, o && o.width) || (this.fire(new t.k(new Error(`Image "${e}" has invalid "stretchX" value`))), r = !1), this._validateStretch(i.stretchY, o && o.height) || (this.fire(new t.k(new Error(`Image "${e}" has invalid "stretchY" value`))), r = !1), this._validateContent(i.content, i) || (this.fire(new t.k(new Error(`Image "${e}" has invalid "content" value`))), r = !1), r;
            }
            _validateStretch(e, t) {
                if (!e) return !0;
                let i = 0;
                for (const r of e){
                    if (r[0] < i || r[1] < r[0] || t < r[1]) return !1;
                    i = r[1];
                }
                return !0;
            }
            _validateContent(e, t) {
                if (!e) return !0;
                if (4 !== e.length) return !1;
                const i = t.spriteData, r = i && i.width || t.data.width, o = i && i.height || t.data.height;
                return !(e[0] < 0 || r < e[0] || e[1] < 0 || o < e[1] || e[2] < 0 || r < e[2] || e[3] < 0 || o < e[3] || e[2] < e[0] || e[3] < e[1]);
            }
            updateImage(e, t, i = !0) {
                const r = this.getImage(e);
                if (i && (r.data.width !== t.data.width || r.data.height !== t.data.height)) throw new Error(`size mismatch between old image (${r.data.width}x${r.data.height}) and new image (${t.data.width}x${t.data.height}).`);
                t.version = r.version + 1, this.images[e] = t, this.updatedImages[e] = !0;
            }
            removeImage(e) {
                const t = this.images[e];
                delete this.images[e], delete this.patterns[e], t.userImage && t.userImage.onRemove && t.userImage.onRemove();
            }
            listImages() {
                return Object.keys(this.images);
            }
            getImages(e) {
                return new Promise((t, i)=>{
                    let r = !0;
                    if (!this.isLoaded()) for (const t of e)this.images[t] || (r = !1);
                    this.isLoaded() || r ? t(this._getImagesForIds(e)) : this.requestors.push({
                        ids: e,
                        promiseResolve: t
                    });
                });
            }
            _getImagesForIds(e) {
                const i = {};
                for (const r of e){
                    let e = this.getImage(r);
                    e || (this.fire(new t.l("styleimagemissing", {
                        id: r
                    })), e = this.getImage(r)), e ? i[r] = {
                        data: e.data.clone(),
                        pixelRatio: e.pixelRatio,
                        sdf: e.sdf,
                        version: e.version,
                        stretchX: e.stretchX,
                        stretchY: e.stretchY,
                        content: e.content,
                        textFitWidth: e.textFitWidth,
                        textFitHeight: e.textFitHeight,
                        hasRenderCallback: Boolean(e.userImage && e.userImage.render)
                    } : t.w(`Image "${r}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                }
                return i;
            }
            getPixelSize() {
                const { width: e, height: t } = this.atlasImage;
                return {
                    width: e,
                    height: t
                };
            }
            getPattern(e) {
                const i = this.patterns[e], r = this.getImage(e);
                if (!r) return null;
                if (i && i.position.version === r.version) return i.position;
                if (i) i.position.version = r.version;
                else {
                    const i = {
                        w: r.data.width + 2,
                        h: r.data.height + 2,
                        x: 0,
                        y: 0
                    }, o = new t.I(i, r);
                    this.patterns[e] = {
                        bin: i,
                        position: o
                    };
                }
                return this._updatePatternAtlas(), this.patterns[e].position;
            }
            bind(e) {
                const t = e.gl;
                this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new v(e, this.atlasImage, t.RGBA), this.atlasTexture.bind(t.LINEAR, t.CLAMP_TO_EDGE);
            }
            _updatePatternAtlas() {
                const e = [];
                for(const t in this.patterns)e.push(this.patterns[t].bin);
                const { w: i, h: r } = t.p(e), o = this.atlasImage;
                o.resize({
                    width: i || 1,
                    height: r || 1
                });
                for(const e in this.patterns){
                    const { bin: i } = this.patterns[e], r = i.x + 1, a = i.y + 1, s = this.getImage(e).data, n = s.width, l = s.height;
                    t.R.copy(s, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: r,
                        y: a
                    }, {
                        width: n,
                        height: l
                    }), t.R.copy(s, o, {
                        x: 0,
                        y: l - 1
                    }, {
                        x: r,
                        y: a - 1
                    }, {
                        width: n,
                        height: 1
                    }), t.R.copy(s, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: r,
                        y: a + l
                    }, {
                        width: n,
                        height: 1
                    }), t.R.copy(s, o, {
                        x: n - 1,
                        y: 0
                    }, {
                        x: r - 1,
                        y: a
                    }, {
                        width: 1,
                        height: l
                    }), t.R.copy(s, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: r + n,
                        y: a
                    }, {
                        width: 1,
                        height: l
                    });
                }
                this.dirty = !0;
            }
            beginFrame() {
                this.callbackDispatchedThisFrame = {};
            }
            dispatchRenderCallbacks(e) {
                for (const i of e){
                    if (this.callbackDispatchedThisFrame[i]) continue;
                    this.callbackDispatchedThisFrame[i] = !0;
                    const e = this.getImage(i);
                    e || t.w(`Image with ID: "${i}" was not found`), x(e) && this.updateImage(i, e);
                }
            }
        }
        const y = 1e20;
        function w(e, t, i, r, o, a, s, n, l) {
            for(let c = t; c < t + r; c++)T(e, i * a + c, a, o, s, n, l);
            for(let c = i; c < i + o; c++)T(e, c * a + t, 1, r, s, n, l);
        }
        function T(e, t, i, r, o, a, s) {
            a[0] = 0, s[0] = -100000000000000000000, s[1] = y, o[0] = e[t];
            for(let n = 1, l = 0, c = 0; n < r; n++){
                o[n] = e[t + n * i];
                const r = n * n;
                do {
                    const e = a[l];
                    c = (o[n] - o[e] + r - e * e) / (n - e) / 2;
                }while (c <= s[l] && --l > -1);
                l++, a[l] = n, s[l] = c, s[l + 1] = y;
            }
            for(let n = 0, l = 0; n < r; n++){
                for(; s[l + 1] < n;)l++;
                const r = a[l], c = n - r;
                e[t + n * i] = o[r] + c * c;
            }
        }
        class P {
            constructor(e, t){
                this.requestManager = e, this.localIdeographFontFamily = t, this.entries = {};
            }
            setURL(e) {
                this.url = e;
            }
            getGlyphs(e) {
                return t._(this, void 0, void 0, function*() {
                    const t = [];
                    for(const i in e)for (const r of e[i])t.push(this._getAndCacheGlyphsPromise(i, r));
                    const i = yield Promise.all(t), r = {};
                    for (const { stack: e, id: t, glyph: o } of i)r[e] || (r[e] = {}), r[e][t] = o && {
                        id: o.id,
                        bitmap: o.bitmap.clone(),
                        metrics: o.metrics
                    };
                    return r;
                });
            }
            _getAndCacheGlyphsPromise(e, i) {
                return t._(this, void 0, void 0, function*() {
                    let t = this.entries[e];
                    t || (t = this.entries[e] = {
                        glyphs: {},
                        requests: {},
                        ranges: {}
                    });
                    let r = t.glyphs[i];
                    if (void 0 !== r) return {
                        stack: e,
                        id: i,
                        glyph: r
                    };
                    if (r = this._tinySDF(t, e, i), r) return t.glyphs[i] = r, {
                        stack: e,
                        id: i,
                        glyph: r
                    };
                    const o = Math.floor(i / 256);
                    if (256 * o > 65535) throw new Error("glyphs > 65535 not supported");
                    if (t.ranges[o]) return {
                        stack: e,
                        id: i,
                        glyph: r
                    };
                    if (!this.url) throw new Error("glyphsUrl is not set");
                    if (!t.requests[o]) {
                        const i = P.loadGlyphRange(e, o, this.url, this.requestManager);
                        t.requests[o] = i;
                    }
                    const a = yield t.requests[o];
                    for(const e in a)this._doesCharSupportLocalGlyph(+e) || (t.glyphs[+e] = a[+e]);
                    return t.ranges[o] = !0, {
                        stack: e,
                        id: i,
                        glyph: a[i] || null
                    };
                });
            }
            _doesCharSupportLocalGlyph(e) {
                return !!this.localIdeographFontFamily && (/\p{Ideo}|\p{sc=Hang}|\p{sc=Hira}|\p{sc=Kana}/u.test(String.fromCodePoint(e)) || t.u["CJK Unified Ideographs"](e) || t.u["Hangul Syllables"](e) || t.u.Hiragana(e) || t.u.Katakana(e) || t.u["CJK Symbols and Punctuation"](e) || t.u["Halfwidth and Fullwidth Forms"](e));
            }
            _tinySDF(e, i, r) {
                const o = this.localIdeographFontFamily;
                if (!o) return;
                if (!this._doesCharSupportLocalGlyph(r)) return;
                let a = e.tinySDF;
                if (!a) {
                    let t = "400";
                    /bold/i.test(i) ? t = "900" : /medium/i.test(i) ? t = "500" : /light/i.test(i) && (t = "200"), a = e.tinySDF = new P.TinySDF({
                        fontSize: 48,
                        buffer: 6,
                        radius: 16,
                        cutoff: .25,
                        fontFamily: o,
                        fontWeight: t
                    });
                }
                const s = a.draw(String.fromCharCode(r));
                return {
                    id: r,
                    bitmap: new t.q({
                        width: s.width || 60,
                        height: s.height || 60
                    }, s.data),
                    metrics: {
                        width: s.glyphWidth / 2 || 24,
                        height: s.glyphHeight / 2 || 24,
                        left: s.glyphLeft / 2 + .5 || 0,
                        top: s.glyphTop / 2 - 27.5 || -8,
                        advance: s.glyphAdvance / 2 || 24,
                        isDoubleResolution: !0
                    }
                };
            }
        }
        P.loadGlyphRange = function(e, i, r, o) {
            return t._(this, void 0, void 0, function*() {
                const a = 256 * i, s = a + 255, n = o.transformRequest(r.replace("{fontstack}", e).replace("{range}", `${a}-${s}`), "Glyphs"), l = yield t.n(n, new AbortController);
                if (!l || !l.data) throw new Error(`Could not load glyph range. range: ${i}, ${a}-${s}`);
                const c = {};
                for (const e of t.o(l.data))c[e.id] = e;
                return c;
            });
        }, P.TinySDF = class {
            constructor({ fontSize: e = 24, buffer: t = 3, radius: i = 8, cutoff: r = .25, fontFamily: o = "sans-serif", fontWeight: a = "normal", fontStyle: s = "normal" } = {}){
                this.buffer = t, this.cutoff = r, this.radius = i;
                const n = this.size = e + 4 * t, l = this._createCanvas(n), c = this.ctx = l.getContext("2d", {
                    willReadFrequently: !0
                });
                c.font = `${s} ${a} ${e}px ${o}`, c.textBaseline = "alphabetic", c.textAlign = "left", c.fillStyle = "black", this.gridOuter = new Float64Array(n * n), this.gridInner = new Float64Array(n * n), this.f = new Float64Array(n), this.z = new Float64Array(n + 1), this.v = new Uint16Array(n);
            }
            _createCanvas(e) {
                const t = document.createElement("canvas");
                return t.width = t.height = e, t;
            }
            draw(e) {
                const { width: t, actualBoundingBoxAscent: i, actualBoundingBoxDescent: r, actualBoundingBoxLeft: o, actualBoundingBoxRight: a } = this.ctx.measureText(e), s = Math.ceil(i), n = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(a - o))), l = Math.min(this.size - this.buffer, s + Math.ceil(r)), c = n + 2 * this.buffer, h = l + 2 * this.buffer, u = Math.max(c * h, 0), d = new Uint8ClampedArray(u), _ = {
                    data: d,
                    width: c,
                    height: h,
                    glyphWidth: n,
                    glyphHeight: l,
                    glyphTop: s,
                    glyphLeft: 0,
                    glyphAdvance: t
                };
                if (0 === n || 0 === l) return _;
                const { ctx: p, buffer: m, gridInner: f, gridOuter: g } = this;
                p.clearRect(m, m, n, l), p.fillText(e, m, m + s);
                const v = p.getImageData(m, m, n, l);
                g.fill(y, 0, u), f.fill(0, 0, u);
                for(let e = 0; e < l; e++)for(let t = 0; t < n; t++){
                    const i = v.data[4 * (e * n + t) + 3] / 255;
                    if (0 === i) continue;
                    const r = (e + m) * c + t + m;
                    if (1 === i) g[r] = 0, f[r] = y;
                    else {
                        const e = .5 - i;
                        g[r] = e > 0 ? e * e : 0, f[r] = e < 0 ? e * e : 0;
                    }
                }
                w(g, 0, 0, c, h, c, this.f, this.v, this.z), w(f, m, m, n, l, c, this.f, this.v, this.z);
                for(let e = 0; e < u; e++){
                    const t = Math.sqrt(g[e]) - Math.sqrt(f[e]);
                    d[e] = Math.round(255 - 255 * (t / this.radius + this.cutoff));
                }
                return _;
            }
        };
        class C {
            constructor(){
                this.specification = t.v.light.position;
            }
            possiblyEvaluate(e, i) {
                return t.z(e.expression.evaluate(i));
            }
            interpolate(e, i, r) {
                return {
                    x: t.B.number(e.x, i.x, r),
                    y: t.B.number(e.y, i.y, r),
                    z: t.B.number(e.z, i.z, r)
                };
            }
        }
        let I;
        class M extends t.E {
            constructor(e){
                super(), I = I || new t.r({
                    anchor: new t.D(t.v.light.anchor),
                    position: new C,
                    color: new t.D(t.v.light.color),
                    intensity: new t.D(t.v.light.intensity)
                }), this._transitionable = new t.T(I), this.setLight(e), this._transitioning = this._transitionable.untransitioned();
            }
            getLight() {
                return this._transitionable.serialize();
            }
            setLight(e, i = {}) {
                if (!this._validate(t.t, e, i)) for(const t in e){
                    const i = e[t];
                    t.endsWith("-transition") ? this._transitionable.setTransition(t.slice(0, -11), i) : this._transitionable.setValue(t, i);
                }
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            _validate(e, i, r) {
                return (!r || !1 !== r.validate) && t.x(this, e.call(t.y, {
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: t.v
                }));
            }
        }
        const E = new t.r({
            "sky-color": new t.D(t.v.sky["sky-color"]),
            "horizon-color": new t.D(t.v.sky["horizon-color"]),
            "fog-color": new t.D(t.v.sky["fog-color"]),
            "fog-ground-blend": new t.D(t.v.sky["fog-ground-blend"]),
            "horizon-fog-blend": new t.D(t.v.sky["horizon-fog-blend"]),
            "sky-horizon-blend": new t.D(t.v.sky["sky-horizon-blend"]),
            "atmosphere-blend": new t.D(t.v.sky["atmosphere-blend"])
        });
        class S extends t.E {
            constructor(e){
                super(), this._transitionable = new t.T(E), this.setSky(e), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new t.C(0));
            }
            setSky(e, i = {}) {
                if (!this._validate(t.F, e, i)) {
                    e || (e = {
                        "sky-color": "transparent",
                        "horizon-color": "transparent",
                        "fog-color": "transparent",
                        "fog-ground-blend": 1,
                        "atmosphere-blend": 0
                    });
                    for(const t in e){
                        const i = e[t];
                        t.endsWith("-transition") ? this._transitionable.setTransition(t.slice(0, -11), i) : this._transitionable.setValue(t, i);
                    }
                }
            }
            getSky() {
                return this._transitionable.serialize();
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            _validate(e, i, r = {}) {
                return !1 !== (null == r ? void 0 : r.validate) && t.x(this, e.call(t.y, t.e({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: t.v
                })));
            }
            calculateFogBlendOpacity(e) {
                return e < 60 ? 0 : e < 70 ? (e - 60) / 10 : 1;
            }
        }
        class R {
            constructor(e, t){
                this.width = e, this.height = t, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
            }
            getDash(e, t) {
                const i = e.join(",") + String(t);
                return this.dashEntry[i] || (this.dashEntry[i] = this.addDash(e, t)), this.dashEntry[i];
            }
            getDashRanges(e, t, i) {
                const r = [];
                let o = e.length % 2 == 1 ? -e[e.length - 1] * i : 0, a = e[0] * i, s = !0;
                r.push({
                    left: o,
                    right: a,
                    isDash: s,
                    zeroLength: 0 === e[0]
                });
                let n = e[0];
                for(let t = 1; t < e.length; t++){
                    s = !s;
                    const l = e[t];
                    o = n * i, n += l, a = n * i, r.push({
                        left: o,
                        right: a,
                        isDash: s,
                        zeroLength: 0 === l
                    });
                }
                return r;
            }
            addRoundDash(e, t, i) {
                const r = t / 2;
                for(let t = -i; t <= i; t++){
                    const o = this.width * (this.nextRow + i + t);
                    let a = 0, s = e[a];
                    for(let n = 0; n < this.width; n++){
                        n / s.right > 1 && (s = e[++a]);
                        const l = Math.abs(n - s.left), c = Math.abs(n - s.right), h = Math.min(l, c);
                        let u;
                        const d = t / i * (r + 1);
                        if (s.isDash) {
                            const e = r - Math.abs(d);
                            u = Math.sqrt(h * h + e * e);
                        } else u = r - Math.sqrt(h * h + d * d);
                        this.data[o + n] = Math.max(0, Math.min(255, u + 128));
                    }
                }
            }
            addRegularDash(e) {
                for(let t = e.length - 1; t >= 0; --t){
                    const i = e[t], r = e[t + 1];
                    i.zeroLength ? e.splice(t, 1) : r && r.isDash === i.isDash && (r.left = i.left, e.splice(t, 1));
                }
                const t = e[0], i = e[e.length - 1];
                t.isDash === i.isDash && (t.left = i.left - this.width, i.right = t.right + this.width);
                const r = this.width * this.nextRow;
                let o = 0, a = e[o];
                for(let t = 0; t < this.width; t++){
                    t / a.right > 1 && (a = e[++o]);
                    const i = Math.abs(t - a.left), s = Math.abs(t - a.right), n = Math.min(i, s);
                    this.data[r + t] = Math.max(0, Math.min(255, (a.isDash ? n : -n) + 128));
                }
            }
            addDash(e, i) {
                const r = i ? 7 : 0, o = 2 * r + 1;
                if (this.nextRow + o > this.height) return t.w("LineAtlas out of space"), null;
                let a = 0;
                for(let t = 0; t < e.length; t++)a += e[t];
                if (0 !== a) {
                    const t = this.width / a, o = this.getDashRanges(e, this.width, t);
                    i ? this.addRoundDash(o, t, r) : this.addRegularDash(o);
                }
                const s = {
                    y: (this.nextRow + r + .5) / this.height,
                    height: 2 * r / this.height,
                    width: a
                };
                return this.nextRow += o, this.dirty = !0, s;
            }
            bind(e) {
                const t = e.gl;
                this.texture ? (t.bindTexture(t.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, t.texSubImage2D(t.TEXTURE_2D, 0, 0, 0, this.width, this.height, t.ALPHA, t.UNSIGNED_BYTE, this.data))) : (this.texture = t.createTexture(), t.bindTexture(t.TEXTURE_2D, this.texture), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.REPEAT), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.REPEAT), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.LINEAR), t.texImage2D(t.TEXTURE_2D, 0, t.ALPHA, this.width, this.height, 0, t.ALPHA, t.UNSIGNED_BYTE, this.data));
            }
        }
        const D = "maplibre_preloaded_worker_pool";
        class z {
            constructor(){
                this.active = {};
            }
            acquire(e) {
                if (!this.workers) for(this.workers = []; this.workers.length < z.workerCount;)this.workers.push(new Worker(t.a.WORKER_URL));
                return this.active[e] = !0, this.workers.slice();
            }
            release(e) {
                delete this.active[e], 0 === this.numActive() && (this.workers.forEach((e)=>{
                    e.terminate();
                }), this.workers = null);
            }
            isPreloaded() {
                return !!this.active[D];
            }
            numActive() {
                return Object.keys(this.active).length;
            }
        }
        const A = Math.floor(s.hardwareConcurrency / 2);
        let L, k;
        function F() {
            return L || (L = new z), L;
        }
        z.workerCount = t.G(globalThis) ? Math.max(Math.min(A, 3), 1) : 1;
        class B {
            constructor(e, i){
                this.workerPool = e, this.actors = [], this.currentActor = 0, this.id = i;
                const r = this.workerPool.acquire(i);
                for(let e = 0; e < r.length; e++){
                    const o = new t.H(r[e], i);
                    o.name = `Worker ${e}`, this.actors.push(o);
                }
                if (!this.actors.length) throw new Error("No actors found");
            }
            broadcast(e, t) {
                const i = [];
                for (const r of this.actors)i.push(r.sendAsync({
                    type: e,
                    data: t
                }));
                return Promise.all(i);
            }
            getActor() {
                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
            }
            remove(e = !0) {
                this.actors.forEach((e)=>{
                    e.remove();
                }), this.actors = [], e && this.workerPool.release(this.id);
            }
            registerMessageHandler(e, t) {
                for (const i of this.actors)i.registerMessageHandler(e, t);
            }
        }
        function O() {
            return k || (k = new B(F(), t.J), k.registerMessageHandler("GR", (e, i, r)=>t.m(i, r))), k;
        }
        function j(e, i) {
            const r = t.K();
            return t.L(r, r, [
                1,
                1,
                0
            ]), t.M(r, r, [
                .5 * e.width,
                .5 * e.height,
                1
            ]), e.calculatePosMatrix ? t.N(r, r, e.calculatePosMatrix(i.toUnwrapped())) : r;
        }
        function Z(e, t, i, r, o, a, s) {
            var n;
            const l = function(e, t, i) {
                if (e) for (const r of e){
                    const e = t[r];
                    if (e && e.source === i && "fill-extrusion" === e.type) return !0;
                }
                else for(const e in t){
                    const r = t[e];
                    if (r.source === i && "fill-extrusion" === r.type) return !0;
                }
                return !1;
            }(null !== (n = null == o ? void 0 : o.layers) && void 0 !== n ? n : null, t, e.id), c = a.maxPitchScaleFactor(), h = e.tilesIn(r, c, l);
            h.sort(N);
            const u = [];
            for (const r of h)u.push({
                wrappedTileID: r.tileID.wrapped().key,
                queryResults: r.tile.queryRenderedFeatures(t, i, e._state, r.queryGeometry, r.cameraQueryGeometry, r.scale, o, a, c, j(e.transform, r.tileID), s ? (e, t)=>s(r.tileID, e, t) : void 0)
            });
            return function(e, t) {
                for(const i in e)for (const r of e[i])G(r, t);
                return e;
            }(function(e) {
                const t = {}, i = {};
                for (const r of e){
                    const e = r.queryResults, o = r.wrappedTileID, a = i[o] = i[o] || {};
                    for(const i in e){
                        const r = e[i], o = a[i] = a[i] || {}, s = t[i] = t[i] || [];
                        for (const e of r)o[e.featureIndex] || (o[e.featureIndex] = !0, s.push(e));
                    }
                }
                return t;
            }(u), e);
        }
        function N(e, t) {
            const i = e.tileID, r = t.tileID;
            return i.overscaledZ - r.overscaledZ || i.canonical.y - r.canonical.y || i.wrap - r.wrap || i.canonical.x - r.canonical.x;
        }
        function G(e, t) {
            const i = e.feature, r = t.getFeatureState(i.layer["source-layer"], i.id);
            i.source = i.layer.source, i.layer["source-layer"] && (i.sourceLayer = i.layer["source-layer"]), i.state = r;
        }
        function U(e, i, r) {
            return t._(this, void 0, void 0, function*() {
                let o = e;
                if (e.url ? o = (yield t.j(i.transformRequest(e.url, "Source"), r)).data : yield s.frameAsync(r), !o) return null;
                const a = t.O(t.e(o, e), [
                    "tiles",
                    "minzoom",
                    "maxzoom",
                    "attribution",
                    "bounds",
                    "scheme",
                    "tileSize",
                    "encoding"
                ]);
                return "vector_layers" in o && o.vector_layers && (a.vectorLayerIds = o.vector_layers.map((e)=>e.id)), a;
            });
        }
        class V {
            constructor(e, t){
                e && (t ? this.setSouthWest(e).setNorthEast(t) : Array.isArray(e) && (4 === e.length ? this.setSouthWest([
                    e[0],
                    e[1]
                ]).setNorthEast([
                    e[2],
                    e[3]
                ]) : this.setSouthWest(e[0]).setNorthEast(e[1])));
            }
            setNorthEast(e) {
                return this._ne = e instanceof t.Q ? new t.Q(e.lng, e.lat) : t.Q.convert(e), this;
            }
            setSouthWest(e) {
                return this._sw = e instanceof t.Q ? new t.Q(e.lng, e.lat) : t.Q.convert(e), this;
            }
            extend(e) {
                const i = this._sw, r = this._ne;
                let o, a;
                if (e instanceof t.Q) o = e, a = e;
                else {
                    if (!(e instanceof V)) return Array.isArray(e) ? 4 === e.length || e.every(Array.isArray) ? this.extend(V.convert(e)) : this.extend(t.Q.convert(e)) : e && ("lng" in e || "lon" in e) && "lat" in e ? this.extend(t.Q.convert(e)) : this;
                    if (o = e._sw, a = e._ne, !o || !a) return this;
                }
                return i || r ? (i.lng = Math.min(o.lng, i.lng), i.lat = Math.min(o.lat, i.lat), r.lng = Math.max(a.lng, r.lng), r.lat = Math.max(a.lat, r.lat)) : (this._sw = new t.Q(o.lng, o.lat), this._ne = new t.Q(a.lng, a.lat)), this;
            }
            getCenter() {
                return new t.Q((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
            }
            getSouthWest() {
                return this._sw;
            }
            getNorthEast() {
                return this._ne;
            }
            getNorthWest() {
                return new t.Q(this.getWest(), this.getNorth());
            }
            getSouthEast() {
                return new t.Q(this.getEast(), this.getSouth());
            }
            getWest() {
                return this._sw.lng;
            }
            getSouth() {
                return this._sw.lat;
            }
            getEast() {
                return this._ne.lng;
            }
            getNorth() {
                return this._ne.lat;
            }
            toArray() {
                return [
                    this._sw.toArray(),
                    this._ne.toArray()
                ];
            }
            toString() {
                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
            }
            isEmpty() {
                return !(this._sw && this._ne);
            }
            contains(e) {
                const { lng: i, lat: r } = t.Q.convert(e);
                let o = this._sw.lng <= i && i <= this._ne.lng;
                return this._sw.lng > this._ne.lng && (o = this._sw.lng >= i && i >= this._ne.lng), this._sw.lat <= r && r <= this._ne.lat && o;
            }
            static convert(e) {
                return e instanceof V ? e : e ? new V(e) : e;
            }
            static fromLngLat(e, i = 0) {
                const r = 360 * i / 40075017, o = r / Math.cos(Math.PI / 180 * e.lat);
                return new V(new t.Q(e.lng - o, e.lat - r), new t.Q(e.lng + o, e.lat + r));
            }
            adjustAntiMeridian() {
                const e = new t.Q(this._sw.lng, this._sw.lat), i = new t.Q(this._ne.lng, this._ne.lat);
                return new V(e, e.lng > i.lng ? new t.Q(i.lng + 360, i.lat) : i);
            }
        }
        class q {
            constructor(e, t, i){
                this.bounds = V.convert(this.validateBounds(e)), this.minzoom = t || 0, this.maxzoom = i || 24;
            }
            validateBounds(e) {
                return Array.isArray(e) && 4 === e.length ? [
                    Math.max(-180, e[0]),
                    Math.max(-90, e[1]),
                    Math.min(180, e[2]),
                    Math.min(90, e[3])
                ] : [
                    -180,
                    -90,
                    180,
                    90
                ];
            }
            contains(e) {
                const i = Math.pow(2, e.z), r = Math.floor(t.U(this.bounds.getWest()) * i), o = Math.floor(t.S(this.bounds.getNorth()) * i), a = Math.ceil(t.U(this.bounds.getEast()) * i), s = Math.ceil(t.S(this.bounds.getSouth()) * i);
                return e.x >= r && e.x < a && e.y >= o && e.y < s;
            }
        }
        class W extends t.E {
            constructor(e, i, r, o){
                if (super(), this.id = e, this.dispatcher = r, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, t.e(this, t.O(i, [
                    "url",
                    "scheme",
                    "tileSize",
                    "promoteId"
                ])), this._options = t.e({
                    type: "vector"
                }, i), this._collectResourceTiming = i.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                this.setEventedParent(o);
            }
            load() {
                return t._(this, void 0, void 0, function*() {
                    this._loaded = !1, this.fire(new t.l("dataloading", {
                        dataType: "source"
                    })), this._tileJSONRequest = new AbortController;
                    try {
                        const e = yield U(this._options, this.map._requestManager, this._tileJSONRequest);
                        this._tileJSONRequest = null, this._loaded = !0, this.map.style.sourceCaches[this.id].clearTiles(), e && (t.e(this, e), e.bounds && (this.tileBounds = new q(e.bounds, this.minzoom, this.maxzoom)), this.fire(new t.l("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new t.l("data", {
                            dataType: "source",
                            sourceDataType: "content"
                        })));
                    } catch (e) {
                        this._tileJSONRequest = null, this.fire(new t.k(e));
                    }
                });
            }
            loaded() {
                return this._loaded;
            }
            hasTile(e) {
                return !this.tileBounds || this.tileBounds.contains(e.canonical);
            }
            onAdd(e) {
                this.map = e, this.load();
            }
            setSourceProperty(e) {
                this._tileJSONRequest && this._tileJSONRequest.abort(), e(), this.load();
            }
            setTiles(e) {
                return this.setSourceProperty(()=>{
                    this._options.tiles = e;
                }), this;
            }
            setUrl(e) {
                return this.setSourceProperty(()=>{
                    this.url = e, this._options.url = e;
                }), this;
            }
            onRemove() {
                this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null);
            }
            serialize() {
                return t.e({}, this._options);
            }
            loadTile(e) {
                return t._(this, void 0, void 0, function*() {
                    const t = e.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), i = {
                        request: this.map._requestManager.transformRequest(t, "Tile"),
                        uid: e.uid,
                        tileID: e.tileID,
                        zoom: e.tileID.overscaledZ,
                        tileSize: this.tileSize * e.tileID.overscaleFactor(),
                        type: this.type,
                        source: this.id,
                        pixelRatio: this.map.getPixelRatio(),
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        promoteId: this.promoteId,
                        subdivisionGranularity: this.map.style.projection.subdivisionGranularity
                    };
                    i.request.collectResourceTiming = this._collectResourceTiming;
                    let r = "RT";
                    if (e.actor && "expired" !== e.state) {
                        if ("loading" === e.state) return new Promise((t, i)=>{
                            e.reloadPromise = {
                                resolve: t,
                                reject: i
                            };
                        });
                    } else e.actor = this.dispatcher.getActor(), r = "LT";
                    e.abortController = new AbortController;
                    try {
                        const t = yield e.actor.sendAsync({
                            type: r,
                            data: i
                        }, e.abortController);
                        if (delete e.abortController, e.aborted) return;
                        this._afterTileLoadWorkerResponse(e, t);
                    } catch (t) {
                        if (delete e.abortController, e.aborted) return;
                        if (t && 404 !== t.status) throw t;
                        this._afterTileLoadWorkerResponse(e, null);
                    }
                });
            }
            _afterTileLoadWorkerResponse(e, t) {
                if (t && t.resourceTiming && (e.resourceTiming = t.resourceTiming), t && this.map._refreshExpiredTiles && e.setExpiryData(t), e.loadVectorData(t, this.map.painter), e.reloadPromise) {
                    const t = e.reloadPromise;
                    e.reloadPromise = null, this.loadTile(e).then(t.resolve).catch(t.reject);
                }
            }
            abortTile(e) {
                return t._(this, void 0, void 0, function*() {
                    e.abortController && (e.abortController.abort(), delete e.abortController), e.actor && (yield e.actor.sendAsync({
                        type: "AT",
                        data: {
                            uid: e.uid,
                            type: this.type,
                            source: this.id
                        }
                    }));
                });
            }
            unloadTile(e) {
                return t._(this, void 0, void 0, function*() {
                    e.unloadVectorData(), e.actor && (yield e.actor.sendAsync({
                        type: "RMT",
                        data: {
                            uid: e.uid,
                            type: this.type,
                            source: this.id
                        }
                    }));
                });
            }
            hasTransition() {
                return !1;
            }
        }
        class $ extends t.E {
            constructor(e, i, r, o){
                super(), this.id = e, this.dispatcher = r, this.setEventedParent(o), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = t.e({
                    type: "raster"
                }, i), t.e(this, t.O(i, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
            }
            load() {
                return t._(this, arguments, void 0, function*(e = !1) {
                    this._loaded = !1, this.fire(new t.l("dataloading", {
                        dataType: "source"
                    })), this._tileJSONRequest = new AbortController;
                    try {
                        const i = yield U(this._options, this.map._requestManager, this._tileJSONRequest);
                        this._tileJSONRequest = null, this._loaded = !0, i && (t.e(this, i), i.bounds && (this.tileBounds = new q(i.bounds, this.minzoom, this.maxzoom)), this.fire(new t.l("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new t.l("data", {
                            dataType: "source",
                            sourceDataType: "content",
                            sourceDataChanged: e
                        })));
                    } catch (e) {
                        this._tileJSONRequest = null, this.fire(new t.k(e));
                    }
                });
            }
            loaded() {
                return this._loaded;
            }
            onAdd(e) {
                this.map = e, this.load();
            }
            onRemove() {
                this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null);
            }
            setSourceProperty(e) {
                this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null), e(), this.load(!0);
            }
            setTiles(e) {
                return this.setSourceProperty(()=>{
                    this._options.tiles = e;
                }), this;
            }
            setUrl(e) {
                return this.setSourceProperty(()=>{
                    this.url = e, this._options.url = e;
                }), this;
            }
            serialize() {
                return t.e({}, this._options);
            }
            hasTile(e) {
                return !this.tileBounds || this.tileBounds.contains(e.canonical);
            }
            loadTile(e) {
                return t._(this, void 0, void 0, function*() {
                    const t = e.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
                    e.abortController = new AbortController;
                    try {
                        const i = yield p.getImage(this.map._requestManager.transformRequest(t, "Tile"), e.abortController, this.map._refreshExpiredTiles);
                        if (delete e.abortController, e.aborted) return void (e.state = "unloaded");
                        if (i && i.data) {
                            this.map._refreshExpiredTiles && i.cacheControl && i.expires && e.setExpiryData({
                                cacheControl: i.cacheControl,
                                expires: i.expires
                            });
                            const t = this.map.painter.context, r = t.gl, o = i.data;
                            e.texture = this.map.painter.getTileTexture(o.width), e.texture ? e.texture.update(o, {
                                useMipmap: !0
                            }) : (e.texture = new v(t, o, r.RGBA, {
                                useMipmap: !0
                            }), e.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE, r.LINEAR_MIPMAP_NEAREST)), e.state = "loaded";
                        }
                    } catch (t) {
                        if (delete e.abortController, e.aborted) e.state = "unloaded";
                        else if (t) throw e.state = "errored", t;
                    }
                });
            }
            abortTile(e) {
                return t._(this, void 0, void 0, function*() {
                    e.abortController && (e.abortController.abort(), delete e.abortController);
                });
            }
            unloadTile(e) {
                return t._(this, void 0, void 0, function*() {
                    e.texture && this.map.painter.saveTileTexture(e.texture);
                });
            }
            hasTransition() {
                return !1;
            }
        }
        class H extends $ {
            constructor(e, i, r, o){
                super(e, i, r, o), this.type = "raster-dem", this.maxzoom = 22, this._options = t.e({
                    type: "raster-dem"
                }, i), this.encoding = i.encoding || "mapbox", this.redFactor = i.redFactor, this.greenFactor = i.greenFactor, this.blueFactor = i.blueFactor, this.baseShift = i.baseShift;
            }
            loadTile(e) {
                return t._(this, void 0, void 0, function*() {
                    const i = e.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), r = this.map._requestManager.transformRequest(i, "Tile");
                    e.neighboringTiles = this._getNeighboringTiles(e.tileID), e.abortController = new AbortController;
                    try {
                        const i = yield p.getImage(r, e.abortController, this.map._refreshExpiredTiles);
                        if (delete e.abortController, e.aborted) return void (e.state = "unloaded");
                        if (i && i.data) {
                            const r = i.data;
                            this.map._refreshExpiredTiles && i.cacheControl && i.expires && e.setExpiryData({
                                cacheControl: i.cacheControl,
                                expires: i.expires
                            });
                            const o = t.b(r) && t.V() ? r : yield this.readImageNow(r), a = {
                                type: this.type,
                                uid: e.uid,
                                source: this.id,
                                rawImageData: o,
                                encoding: this.encoding,
                                redFactor: this.redFactor,
                                greenFactor: this.greenFactor,
                                blueFactor: this.blueFactor,
                                baseShift: this.baseShift
                            };
                            if (!e.actor || "expired" === e.state) {
                                e.actor = this.dispatcher.getActor();
                                const t = yield e.actor.sendAsync({
                                    type: "LDT",
                                    data: a
                                });
                                e.dem = t, e.needsHillshadePrepare = !0, e.needsTerrainPrepare = !0, e.state = "loaded";
                            }
                        }
                    } catch (t) {
                        if (delete e.abortController, e.aborted) e.state = "unloaded";
                        else if (t) throw e.state = "errored", t;
                    }
                });
            }
            readImageNow(e) {
                return t._(this, void 0, void 0, function*() {
                    if ("undefined" != typeof VideoFrame && t.W()) {
                        const i = e.width + 2, r = e.height + 2;
                        try {
                            return new t.R({
                                width: i,
                                height: r
                            }, (yield t.X(e, -1, -1, i, r)));
                        } catch (e) {}
                    }
                    return s.getImageData(e, 1);
                });
            }
            _getNeighboringTiles(e) {
                const i = e.canonical, r = Math.pow(2, i.z), o = (i.x - 1 + r) % r, a = 0 === i.x ? e.wrap - 1 : e.wrap, s = (i.x + 1 + r) % r, n = i.x + 1 === r ? e.wrap + 1 : e.wrap, l = {};
                return l[new t.Y(e.overscaledZ, a, i.z, o, i.y).key] = {
                    backfilled: !1
                }, l[new t.Y(e.overscaledZ, n, i.z, s, i.y).key] = {
                    backfilled: !1
                }, i.y > 0 && (l[new t.Y(e.overscaledZ, a, i.z, o, i.y - 1).key] = {
                    backfilled: !1
                }, l[new t.Y(e.overscaledZ, e.wrap, i.z, i.x, i.y - 1).key] = {
                    backfilled: !1
                }, l[new t.Y(e.overscaledZ, n, i.z, s, i.y - 1).key] = {
                    backfilled: !1
                }), i.y + 1 < r && (l[new t.Y(e.overscaledZ, a, i.z, o, i.y + 1).key] = {
                    backfilled: !1
                }, l[new t.Y(e.overscaledZ, e.wrap, i.z, i.x, i.y + 1).key] = {
                    backfilled: !1
                }, l[new t.Y(e.overscaledZ, n, i.z, s, i.y + 1).key] = {
                    backfilled: !1
                }), l;
            }
            unloadTile(e) {
                return t._(this, void 0, void 0, function*() {
                    e.demTexture && this.map.painter.saveTileTexture(e.demTexture), e.fbo && (e.fbo.destroy(), delete e.fbo), e.dem && delete e.dem, delete e.neighboringTiles, e.state = "unloaded", e.actor && (yield e.actor.sendAsync({
                        type: "RDT",
                        data: {
                            type: this.type,
                            uid: e.uid,
                            source: this.id
                        }
                    }));
                });
            }
        }
        class K extends t.E {
            constructor(e, i, r, o){
                super(), this.id = e, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._pendingLoads = 0, this.actor = r.getActor(), this.setEventedParent(o), this._data = i.data, this._options = t.e({}, i), this._collectResourceTiming = i.collectResourceTiming, void 0 !== i.maxzoom && (this.maxzoom = i.maxzoom), i.type && (this.type = i.type), i.attribution && (this.attribution = i.attribution), this.promoteId = i.promoteId, void 0 !== i.clusterMaxZoom && this.maxzoom <= i.clusterMaxZoom && t.w(`The maxzoom value "${this.maxzoom}" is expected to be greater than the clusterMaxZoom value "${i.clusterMaxZoom}".`), this.workerOptions = t.e({
                    source: this.id,
                    cluster: i.cluster || !1,
                    geojsonVtOptions: {
                        buffer: this._pixelsToTileUnits(void 0 !== i.buffer ? i.buffer : 128),
                        tolerance: this._pixelsToTileUnits(void 0 !== i.tolerance ? i.tolerance : .375),
                        extent: t.Z,
                        maxZoom: this.maxzoom,
                        lineMetrics: i.lineMetrics || !1,
                        generateId: i.generateId || !1
                    },
                    superclusterOptions: {
                        maxZoom: void 0 !== i.clusterMaxZoom ? i.clusterMaxZoom : this.maxzoom - 1,
                        minPoints: Math.max(2, i.clusterMinPoints || 2),
                        extent: t.Z,
                        radius: this._pixelsToTileUnits(i.clusterRadius || 50),
                        log: !1,
                        generateId: i.generateId || !1
                    },
                    clusterProperties: i.clusterProperties,
                    filter: i.filter
                }, i.workerOptions), "string" == typeof this.promoteId && (this.workerOptions.promoteId = this.promoteId);
            }
            _pixelsToTileUnits(e) {
                return e * (t.Z / this.tileSize);
            }
            load() {
                return t._(this, void 0, void 0, function*() {
                    yield this._updateWorkerData();
                });
            }
            onAdd(e) {
                this.map = e, this.load();
            }
            setData(e) {
                return this._data = e, this._updateWorkerData(), this;
            }
            updateData(e) {
                return this._updateWorkerData(e), this;
            }
            getData() {
                return t._(this, void 0, void 0, function*() {
                    const e = t.e({
                        type: this.type
                    }, this.workerOptions);
                    return this.actor.sendAsync({
                        type: "GD",
                        data: e
                    });
                });
            }
            getCoordinatesFromGeometry(e) {
                return "GeometryCollection" === e.type ? e.geometries.map((e)=>e.coordinates).flat(1 / 0) : e.coordinates.flat(1 / 0);
            }
            getBounds() {
                return t._(this, void 0, void 0, function*() {
                    const e = new V, t = yield this.getData();
                    let i;
                    switch(t.type){
                        case "FeatureCollection":
                            i = t.features.map((e)=>this.getCoordinatesFromGeometry(e.geometry)).flat(1 / 0);
                            break;
                        case "Feature":
                            i = this.getCoordinatesFromGeometry(t.geometry);
                            break;
                        default:
                            i = this.getCoordinatesFromGeometry(t);
                    }
                    if (0 == i.length) return e;
                    for(let t = 0; t < i.length - 1; t += 2)e.extend([
                        i[t],
                        i[t + 1]
                    ]);
                    return e;
                });
            }
            setClusterOptions(e) {
                return this.workerOptions.cluster = e.cluster, e && (void 0 !== e.clusterRadius && (this.workerOptions.superclusterOptions.radius = this._pixelsToTileUnits(e.clusterRadius)), void 0 !== e.clusterMaxZoom && (this.workerOptions.superclusterOptions.maxZoom = e.clusterMaxZoom)), this._updateWorkerData(), this;
            }
            getClusterExpansionZoom(e) {
                return this.actor.sendAsync({
                    type: "GCEZ",
                    data: {
                        type: this.type,
                        clusterId: e,
                        source: this.id
                    }
                });
            }
            getClusterChildren(e) {
                return this.actor.sendAsync({
                    type: "GCC",
                    data: {
                        type: this.type,
                        clusterId: e,
                        source: this.id
                    }
                });
            }
            getClusterLeaves(e, t, i) {
                return this.actor.sendAsync({
                    type: "GCL",
                    data: {
                        type: this.type,
                        source: this.id,
                        clusterId: e,
                        limit: t,
                        offset: i
                    }
                });
            }
            _updateWorkerData(e) {
                return t._(this, void 0, void 0, function*() {
                    const i = t.e({
                        type: this.type
                    }, this.workerOptions);
                    e ? i.dataDiff = e : "string" == typeof this._data ? (i.request = this.map._requestManager.transformRequest(s.resolveURL(this._data), "Source"), i.request.collectResourceTiming = this._collectResourceTiming) : i.data = JSON.stringify(this._data), this._pendingLoads++, this.fire(new t.l("dataloading", {
                        dataType: "source"
                    }));
                    try {
                        const e = yield this.actor.sendAsync({
                            type: "LD",
                            data: i
                        });
                        if (this._pendingLoads--, this._removed || e.abandoned) return void this.fire(new t.l("dataabort", {
                            dataType: "source"
                        }));
                        let r = null;
                        e.resourceTiming && e.resourceTiming[this.id] && (r = e.resourceTiming[this.id].slice(0));
                        const o = {
                            dataType: "source"
                        };
                        this._collectResourceTiming && r && r.length > 0 && t.e(o, {
                            resourceTiming: r
                        }), this.fire(new t.l("data", Object.assign(Object.assign({}, o), {
                            sourceDataType: "metadata"
                        }))), this.fire(new t.l("data", Object.assign(Object.assign({}, o), {
                            sourceDataType: "content"
                        })));
                    } catch (e) {
                        if (this._pendingLoads--, this._removed) return void this.fire(new t.l("dataabort", {
                            dataType: "source"
                        }));
                        this.fire(new t.k(e));
                    }
                });
            }
            loaded() {
                return 0 === this._pendingLoads;
            }
            loadTile(e) {
                return t._(this, void 0, void 0, function*() {
                    const t = e.actor ? "RT" : "LT";
                    e.actor = this.actor;
                    const i = {
                        type: this.type,
                        uid: e.uid,
                        tileID: e.tileID,
                        zoom: e.tileID.overscaledZ,
                        maxZoom: this.maxzoom,
                        tileSize: this.tileSize,
                        source: this.id,
                        pixelRatio: this.map.getPixelRatio(),
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        promoteId: this.promoteId,
                        subdivisionGranularity: this.map.style.projection.subdivisionGranularity
                    };
                    e.abortController = new AbortController;
                    const r = yield this.actor.sendAsync({
                        type: t,
                        data: i
                    }, e.abortController);
                    delete e.abortController, e.unloadVectorData(), e.aborted || e.loadVectorData(r, this.map.painter, "RT" === t);
                });
            }
            abortTile(e) {
                return t._(this, void 0, void 0, function*() {
                    e.abortController && (e.abortController.abort(), delete e.abortController), e.aborted = !0;
                });
            }
            unloadTile(e) {
                return t._(this, void 0, void 0, function*() {
                    e.unloadVectorData(), yield this.actor.sendAsync({
                        type: "RMT",
                        data: {
                            uid: e.uid,
                            type: this.type,
                            source: this.id
                        }
                    });
                });
            }
            onRemove() {
                this._removed = !0, this.actor.sendAsync({
                    type: "RS",
                    data: {
                        type: this.type,
                        source: this.id
                    }
                });
            }
            serialize() {
                return t.e({}, this._options, {
                    type: this.type,
                    data: this._data
                });
            }
            hasTransition() {
                return !1;
            }
        }
        class X extends t.E {
            constructor(e, t, i, r){
                super(), this.flippedWindingOrder = !1, this.id = e, this.dispatcher = i, this.coordinates = t.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(r), this.options = t;
            }
            load(e) {
                return t._(this, void 0, void 0, function*() {
                    this._loaded = !1, this.fire(new t.l("dataloading", {
                        dataType: "source"
                    })), this.url = this.options.url, this._request = new AbortController;
                    try {
                        const t = yield p.getImage(this.map._requestManager.transformRequest(this.url, "Image"), this._request);
                        this._request = null, this._loaded = !0, t && t.data && (this.image = t.data, e && (this.coordinates = e), this._finishLoading());
                    } catch (e) {
                        this._request = null, this._loaded = !0, this.fire(new t.k(e));
                    }
                });
            }
            loaded() {
                return this._loaded;
            }
            updateImage(e) {
                return e.url ? (this._request && (this._request.abort(), this._request = null), this.options.url = e.url, this.load(e.coordinates).finally(()=>{
                    this.texture = null;
                }), this) : this;
            }
            _finishLoading() {
                this.map && (this.setCoordinates(this.coordinates), this.fire(new t.l("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                })));
            }
            onAdd(e) {
                this.map = e, this.load();
            }
            onRemove() {
                this._request && (this._request.abort(), this._request = null);
            }
            setCoordinates(e) {
                this.coordinates = e;
                const i = e.map(t.$.fromLngLat);
                var r;
                return this.tileID = function(e) {
                    let i = 1 / 0, r = 1 / 0, o = -1 / 0, a = -1 / 0;
                    for (const t of e)i = Math.min(i, t.x), r = Math.min(r, t.y), o = Math.max(o, t.x), a = Math.max(a, t.y);
                    const s = Math.max(o - i, a - r), n = Math.max(0, Math.floor(-Math.log(s) / Math.LN2)), l = Math.pow(2, n);
                    return new t.a1(n, Math.floor((i + o) / 2 * l), Math.floor((r + a) / 2 * l));
                }(i), this.terrainTileRanges = this._getOverlappingTileRanges(i), this.minzoom = this.maxzoom = this.tileID.z, this.tileCoords = i.map((e)=>this.tileID.getTilePoint(e)._round()), this.flippedWindingOrder = ((r = this.tileCoords)[1].x - r[0].x) * (r[2].y - r[0].y) - (r[1].y - r[0].y) * (r[2].x - r[0].x) < 0, this.fire(new t.l("data", {
                    dataType: "source",
                    sourceDataType: "content"
                })), this;
            }
            prepare() {
                if (0 === Object.keys(this.tiles).length || !this.image) return;
                const e = this.map.painter.context, i = e.gl;
                this.texture || (this.texture = new v(e, this.image, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE));
                let r = !1;
                for(const e in this.tiles){
                    const t = this.tiles[e];
                    "loaded" !== t.state && (t.state = "loaded", t.texture = this.texture, r = !0);
                }
                r && this.fire(new t.l("data", {
                    dataType: "source",
                    sourceDataType: "idle",
                    sourceId: this.id
                }));
            }
            loadTile(e) {
                return t._(this, void 0, void 0, function*() {
                    this.tileID && this.tileID.equals(e.tileID.canonical) ? (this.tiles[String(e.tileID.wrap)] = e, e.buckets = {}) : e.state = "errored";
                });
            }
            serialize() {
                return {
                    type: "image",
                    url: this.options.url,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return !1;
            }
            _getOverlappingTileRanges(e) {
                let i = 1 / 0, r = 1 / 0, o = -1 / 0, a = -1 / 0;
                for (const t of e)i = Math.min(i, t.x), r = Math.min(r, t.y), o = Math.max(o, t.x), a = Math.max(a, t.y);
                const s = {};
                for(let e = 0; e <= t.a0; e++){
                    const t = Math.pow(2, e), n = Math.floor(i * t), l = Math.floor(r * t), c = Math.floor(o * t), h = Math.floor(a * t);
                    s[e] = {
                        minTileX: n,
                        minTileY: l,
                        maxTileX: c,
                        maxTileY: h
                    };
                }
                return s;
            }
        }
        class Q extends X {
            constructor(e, t, i, r){
                super(e, t, i, r), this.roundZoom = !0, this.type = "video", this.options = t;
            }
            load() {
                return t._(this, void 0, void 0, function*() {
                    this._loaded = !1;
                    const e = this.options;
                    this.urls = [];
                    for (const t of e.urls)this.urls.push(this.map._requestManager.transformRequest(t, "Source").url);
                    try {
                        const e = yield t.a2(this.urls);
                        if (this._loaded = !0, !e) return;
                        this.video = e, this.video.loop = !0, this.video.addEventListener("playing", ()=>{
                            this.map.triggerRepaint();
                        }), this.map && this.video.play(), this._finishLoading();
                    } catch (e) {
                        this.fire(new t.k(e));
                    }
                });
            }
            pause() {
                this.video && this.video.pause();
            }
            play() {
                this.video && this.video.play();
            }
            seek(e) {
                if (this.video) {
                    const i = this.video.seekable;
                    e < i.start(0) || e > i.end(0) ? this.fire(new t.k(new t.a3(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i.start(0)} and ${i.end(0)}-second mark.`))) : this.video.currentTime = e;
                }
            }
            getVideo() {
                return this.video;
            }
            onAdd(e) {
                this.map || (this.map = e, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
            }
            prepare() {
                if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                const e = this.map.painter.context, i = e.gl;
                this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new v(e, this.video, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE));
                let r = !1;
                for(const e in this.tiles){
                    const t = this.tiles[e];
                    "loaded" !== t.state && (t.state = "loaded", t.texture = this.texture, r = !0);
                }
                r && this.fire(new t.l("data", {
                    dataType: "source",
                    sourceDataType: "idle",
                    sourceId: this.id
                }));
            }
            serialize() {
                return {
                    type: "video",
                    urls: this.urls,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return this.video && !this.video.paused;
            }
        }
        class Y extends X {
            constructor(e, i, r, o){
                super(e, i, r, o), i.coordinates ? Array.isArray(i.coordinates) && 4 === i.coordinates.length && !i.coordinates.some((e)=>!Array.isArray(e) || 2 !== e.length || e.some((e)=>"number" != typeof e)) || this.fire(new t.k(new t.a3(`sources.${e}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new t.k(new t.a3(`sources.${e}`, null, 'missing required property "coordinates"'))), i.animate && "boolean" != typeof i.animate && this.fire(new t.k(new t.a3(`sources.${e}`, null, 'optional "animate" property must be a boolean value'))), i.canvas ? "string" == typeof i.canvas || i.canvas instanceof HTMLCanvasElement || this.fire(new t.k(new t.a3(`sources.${e}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new t.k(new t.a3(`sources.${e}`, null, 'missing required property "canvas"'))), this.options = i, this.animate = void 0 === i.animate || i.animate;
            }
            load() {
                return t._(this, void 0, void 0, function*() {
                    this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new t.k(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                        this._playing = !0, this.map.triggerRepaint();
                    }, this.pause = function() {
                        this._playing && (this.prepare(), this._playing = !1);
                    }, this._finishLoading());
                });
            }
            getCanvas() {
                return this.canvas;
            }
            onAdd(e) {
                this.map = e, this.load(), this.canvas && this.animate && this.play();
            }
            onRemove() {
                this.pause();
            }
            prepare() {
                let e = !1;
                if (this.canvas.width !== this.width && (this.width = this.canvas.width, e = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, e = !0), this._hasInvalidDimensions()) return;
                if (0 === Object.keys(this.tiles).length) return;
                const i = this.map.painter.context, r = i.gl;
                this.texture ? (e || this._playing) && this.texture.update(this.canvas, {
                    premultiply: !0
                }) : this.texture = new v(i, this.canvas, r.RGBA, {
                    premultiply: !0
                });
                let o = !1;
                for(const e in this.tiles){
                    const t = this.tiles[e];
                    "loaded" !== t.state && (t.state = "loaded", t.texture = this.texture, o = !0);
                }
                o && this.fire(new t.l("data", {
                    dataType: "source",
                    sourceDataType: "idle",
                    sourceId: this.id
                }));
            }
            serialize() {
                return {
                    type: "canvas",
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return this._playing;
            }
            _hasInvalidDimensions() {
                for (const e of [
                    this.canvas.width,
                    this.canvas.height
                ])if (isNaN(e) || e <= 0) return !0;
                return !1;
            }
        }
        const J = {}, ee = (e)=>{
            switch(e){
                case "geojson":
                    return K;
                case "image":
                    return X;
                case "raster":
                    return $;
                case "raster-dem":
                    return H;
                case "vector":
                    return W;
                case "video":
                    return Q;
                case "canvas":
                    return Y;
            }
            return J[e];
        }, te = "RTLPluginLoaded";
        class ie extends t.E {
            constructor(){
                super(...arguments), this.status = "unavailable", this.url = null, this.dispatcher = O();
            }
            _syncState(e) {
                return this.status = e, this.dispatcher.broadcast("SRPS", {
                    pluginStatus: e,
                    pluginURL: this.url
                }).catch((e)=>{
                    throw this.status = "error", e;
                });
            }
            getRTLTextPluginStatus() {
                return this.status;
            }
            clearRTLTextPlugin() {
                this.status = "unavailable", this.url = null;
            }
            setRTLTextPlugin(e) {
                return t._(this, arguments, void 0, function*(e, t = !1) {
                    if (this.url) throw new Error("setRTLTextPlugin cannot be called multiple times.");
                    if (this.url = s.resolveURL(e), !this.url) throw new Error(`requested url ${e} is invalid`);
                    if ("unavailable" === this.status) {
                        if (!t) return this._requestImport();
                        this.status = "deferred", this._syncState(this.status);
                    } else if ("requested" === this.status) return this._requestImport();
                });
            }
            _requestImport() {
                return t._(this, void 0, void 0, function*() {
                    yield this._syncState("loading"), this.status = "loaded", this.fire(new t.l(te));
                });
            }
            lazyLoad() {
                "unavailable" === this.status ? this.status = "requested" : "deferred" === this.status && this._requestImport();
            }
        }
        let re = null;
        function oe() {
            return re || (re = new ie), re;
        }
        class ae {
            constructor(e, i){
                this.timeAdded = 0, this.fadeEndTime = 0, this.tileID = e, this.uid = t.a4(), this.uses = 0, this.tileSize = i, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.rtt = [], this.rttCoords = {}, this.expiredRequestCount = 0, this.state = "loading";
            }
            registerFadeDuration(e) {
                const t = e + this.timeAdded;
                t < this.fadeEndTime || (this.fadeEndTime = t);
            }
            wasRequested() {
                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
            }
            clearTextures(e) {
                this.demTexture && e.saveTileTexture(this.demTexture), this.demTexture = null;
            }
            loadVectorData(e, i, r) {
                if (this.hasData() && this.unloadVectorData(), this.state = "loaded", e) {
                    e.featureIndex && (this.latestFeatureIndex = e.featureIndex, e.rawTileData ? (this.latestRawTileData = e.rawTileData, this.latestFeatureIndex.rawTileData = e.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = e.collisionBoxArray, this.buckets = function(e, t) {
                        const i = {};
                        if (!t) return i;
                        for (const r of e){
                            const e = r.layerIds.map((e)=>t.getLayer(e)).filter(Boolean);
                            if (0 !== e.length) {
                                r.layers = e, r.stateDependentLayerIds && (r.stateDependentLayers = r.stateDependentLayerIds.map((t)=>e.filter((e)=>e.id === t)[0]));
                                for (const t of e)i[t.id] = r;
                            }
                        }
                        return i;
                    }(e.buckets, null == i ? void 0 : i.style), this.hasSymbolBuckets = !1;
                    for(const e in this.buckets){
                        const i = this.buckets[e];
                        if (i instanceof t.a6) {
                            if (this.hasSymbolBuckets = !0, !r) break;
                            i.justReloaded = !0;
                        }
                    }
                    if (this.hasRTLText = !1, this.hasSymbolBuckets) for(const e in this.buckets){
                        const i = this.buckets[e];
                        if (i instanceof t.a6 && i.hasRTLText) {
                            this.hasRTLText = !0, oe().lazyLoad();
                            break;
                        }
                    }
                    this.queryPadding = 0;
                    for(const e in this.buckets){
                        const t = this.buckets[e];
                        this.queryPadding = Math.max(this.queryPadding, i.style.getLayer(e).queryRadius(t));
                    }
                    e.imageAtlas && (this.imageAtlas = e.imageAtlas), e.glyphAtlasImage && (this.glyphAtlasImage = e.glyphAtlasImage);
                } else this.collisionBoxArray = new t.a5;
            }
            unloadVectorData() {
                for(const e in this.buckets)this.buckets[e].destroy();
                this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.imageAtlas && (this.imageAtlas = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.latestFeatureIndex = null, this.state = "unloaded";
            }
            getBucket(e) {
                return this.buckets[e.id];
            }
            upload(e) {
                for(const t in this.buckets){
                    const i = this.buckets[t];
                    i.uploadPending() && i.upload(e);
                }
                const t = e.gl;
                this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new v(e, this.imageAtlas.image, t.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new v(e, this.glyphAtlasImage, t.ALPHA), this.glyphAtlasImage = null);
            }
            prepare(e) {
                this.imageAtlas && this.imageAtlas.patchUpdatedImages(e, this.imageAtlasTexture);
            }
            queryRenderedFeatures(e, t, i, r, o, a, s, n, l, c, h) {
                return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
                    queryGeometry: r,
                    cameraQueryGeometry: o,
                    scale: a,
                    tileSize: this.tileSize,
                    pixelPosMatrix: c,
                    transform: n,
                    params: s,
                    queryPadding: this.queryPadding * l,
                    getElevation: h
                }, e, t, i) : {};
            }
            querySourceFeatures(e, i) {
                const r = this.latestFeatureIndex;
                if (!r || !r.rawTileData) return;
                const o = r.loadVTLayers(), a = i && i.sourceLayer ? i.sourceLayer : "", s = o._geojsonTileLayer || o[a];
                if (!s) return;
                const n = t.a7(i && i.filter), { z: l, x: c, y: h } = this.tileID.canonical, u = {
                    z: l,
                    x: c,
                    y: h
                };
                for(let i = 0; i < s.length; i++){
                    const o = s.feature(i);
                    if (n.needGeometry) {
                        const e = t.a8(o, !0);
                        if (!n.filter(new t.C(this.tileID.overscaledZ), e, this.tileID.canonical)) continue;
                    } else if (!n.filter(new t.C(this.tileID.overscaledZ), o)) continue;
                    const d = r.getId(o, a), _ = new t.a9(o, l, c, h, d);
                    _.tile = u, e.push(_);
                }
            }
            hasData() {
                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
            }
            patternsLoaded() {
                return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
            }
            setExpiryData(e) {
                const i = this.expirationTime;
                if (e.cacheControl) {
                    const i = t.aa(e.cacheControl);
                    i["max-age"] && (this.expirationTime = Date.now() + 1e3 * i["max-age"]);
                } else e.expires && (this.expirationTime = new Date(e.expires).getTime());
                if (this.expirationTime) {
                    const e = Date.now();
                    let t = !1;
                    if (this.expirationTime > e) t = !1;
                    else if (i) {
                        if (this.expirationTime < i) t = !0;
                        else {
                            const r = this.expirationTime - i;
                            r ? this.expirationTime = e + Math.max(r, 3e4) : t = !0;
                        }
                    } else t = !0;
                    t ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                }
            }
            getExpiryTimeout() {
                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
            }
            setFeatureState(e, t) {
                if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData || 0 === Object.keys(e).length) return;
                const i = this.latestFeatureIndex.loadVTLayers();
                for(const r in this.buckets){
                    if (!t.style.hasLayer(r)) continue;
                    const o = this.buckets[r], a = o.layers[0].sourceLayer || "_geojsonTileLayer", s = i[a], n = e[a];
                    if (!s || !n || 0 === Object.keys(n).length) continue;
                    o.update(n, s, this.imageAtlas && this.imageAtlas.patternPositions || {});
                    const l = t && t.style && t.style.getLayer(r);
                    l && (this.queryPadding = Math.max(this.queryPadding, l.queryRadius(o)));
                }
            }
            holdingForFade() {
                return void 0 !== this.symbolFadeHoldUntil;
            }
            symbolFadeFinished() {
                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < s.now();
            }
            clearFadeHold() {
                this.symbolFadeHoldUntil = void 0;
            }
            setHoldDuration(e) {
                this.symbolFadeHoldUntil = s.now() + e;
            }
            setDependencies(e, t) {
                const i = {};
                for (const e of t)i[e] = !0;
                this.dependencies[e] = i;
            }
            hasDependency(e, t) {
                for (const i of e){
                    const e = this.dependencies[i];
                    if (e) {
                        for (const i of t)if (e[i]) return !0;
                    }
                }
                return !1;
            }
        }
        class se {
            constructor(e, t){
                this.max = e, this.onRemove = t, this.reset();
            }
            reset() {
                for(const e in this.data)for (const t of this.data[e])t.timeout && clearTimeout(t.timeout), this.onRemove(t.value);
                return this.data = {}, this.order = [], this;
            }
            add(e, t, i) {
                const r = e.wrapped().key;
                void 0 === this.data[r] && (this.data[r] = []);
                const o = {
                    value: t,
                    timeout: void 0
                };
                if (void 0 !== i && (o.timeout = setTimeout(()=>{
                    this.remove(e, o);
                }, i)), this.data[r].push(o), this.order.push(r), this.order.length > this.max) {
                    const e = this._getAndRemoveByKey(this.order[0]);
                    e && this.onRemove(e);
                }
                return this;
            }
            has(e) {
                return e.wrapped().key in this.data;
            }
            getAndRemove(e) {
                return this.has(e) ? this._getAndRemoveByKey(e.wrapped().key) : null;
            }
            _getAndRemoveByKey(e) {
                const t = this.data[e].shift();
                return t.timeout && clearTimeout(t.timeout), 0 === this.data[e].length && delete this.data[e], this.order.splice(this.order.indexOf(e), 1), t.value;
            }
            getByKey(e) {
                const t = this.data[e];
                return t ? t[0].value : null;
            }
            get(e) {
                return this.has(e) ? this.data[e.wrapped().key][0].value : null;
            }
            remove(e, t) {
                if (!this.has(e)) return this;
                const i = e.wrapped().key, r = void 0 === t ? 0 : this.data[i].indexOf(t), o = this.data[i][r];
                return this.data[i].splice(r, 1), o.timeout && clearTimeout(o.timeout), 0 === this.data[i].length && delete this.data[i], this.onRemove(o.value), this.order.splice(this.order.indexOf(i), 1), this;
            }
            setMaxSize(e) {
                for(this.max = e; this.order.length > this.max;){
                    const e = this._getAndRemoveByKey(this.order[0]);
                    e && this.onRemove(e);
                }
                return this;
            }
            filter(e) {
                const t = [];
                for(const i in this.data)for (const r of this.data[i])e(r.value) || t.push(r);
                for (const e of t)this.remove(e.value.tileID, e);
            }
        }
        class ne {
            constructor(){
                this.state = {}, this.stateChanges = {}, this.deletedStates = {};
            }
            updateState(e, i, r) {
                const o = String(i);
                if (this.stateChanges[e] = this.stateChanges[e] || {}, this.stateChanges[e][o] = this.stateChanges[e][o] || {}, t.e(this.stateChanges[e][o], r), null === this.deletedStates[e]) {
                    this.deletedStates[e] = {};
                    for(const t in this.state[e])t !== o && (this.deletedStates[e][t] = null);
                } else if (this.deletedStates[e] && null === this.deletedStates[e][o]) {
                    this.deletedStates[e][o] = {};
                    for(const t in this.state[e][o])r[t] || (this.deletedStates[e][o][t] = null);
                } else for(const t in r)this.deletedStates[e] && this.deletedStates[e][o] && null === this.deletedStates[e][o][t] && delete this.deletedStates[e][o][t];
            }
            removeFeatureState(e, t, i) {
                if (null === this.deletedStates[e]) return;
                const r = String(t);
                if (this.deletedStates[e] = this.deletedStates[e] || {}, i && void 0 !== t) null !== this.deletedStates[e][r] && (this.deletedStates[e][r] = this.deletedStates[e][r] || {}, this.deletedStates[e][r][i] = null);
                else if (void 0 !== t) {
                    if (this.stateChanges[e] && this.stateChanges[e][r]) for(i in this.deletedStates[e][r] = {}, this.stateChanges[e][r])this.deletedStates[e][r][i] = null;
                    else this.deletedStates[e][r] = null;
                } else this.deletedStates[e] = null;
            }
            getState(e, i) {
                const r = String(i), o = t.e({}, (this.state[e] || {})[r], (this.stateChanges[e] || {})[r]);
                if (null === this.deletedStates[e]) return {};
                if (this.deletedStates[e]) {
                    const t = this.deletedStates[e][i];
                    if (null === t) return {};
                    for(const e in t)delete o[e];
                }
                return o;
            }
            initializeTileState(e, t) {
                e.setFeatureState(this.state, t);
            }
            coalesceChanges(e, i) {
                const r = {};
                for(const e in this.stateChanges){
                    this.state[e] = this.state[e] || {};
                    const i = {};
                    for(const r in this.stateChanges[e])this.state[e][r] || (this.state[e][r] = {}), t.e(this.state[e][r], this.stateChanges[e][r]), i[r] = this.state[e][r];
                    r[e] = i;
                }
                for(const e in this.deletedStates){
                    this.state[e] = this.state[e] || {};
                    const i = {};
                    if (null === this.deletedStates[e]) for(const t in this.state[e])i[t] = {}, this.state[e][t] = {};
                    else for(const t in this.deletedStates[e]){
                        if (null === this.deletedStates[e][t]) this.state[e][t] = {};
                        else for (const i of Object.keys(this.deletedStates[e][t]))delete this.state[e][t][i];
                        i[t] = this.state[e][t];
                    }
                    r[e] = r[e] || {}, t.e(r[e], i);
                }
                if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(r).length) for(const t in e)e[t].setFeatureState(r, i);
            }
        }
        function le(e, t, i) {
            const r = t.intersectsFrustum(e);
            if (!i) return r;
            const o = t.intersectsPlane(i);
            return 0 === r || 0 === o ? 0 : 2 === r && 2 === o ? 2 : 1;
        }
        function ce(e, i, r, o, a) {
            let s = e;
            const n = Math.atan(i / r), l = Math.hypot(i, r);
            return s = e + t.ab(o / l / Math.max(.5, Math.cos(t.ad(a / 2)))), s += 1 * t.ab(Math.cos(n)) / 2, s += t.ae(e - s, -0, 0), s;
        }
        function he(e, i) {
            const r = (i.roundZoom ? Math.round : Math.floor)(e.zoom + t.ab(e.tileSize / i.tileSize));
            return Math.max(0, r);
        }
        function ue(e, i) {
            const r = e.getCameraFrustum(), o = e.getClippingPlane(), a = e.screenPointToMercatorCoordinate(e.getCameraPoint()), s = t.$.fromLngLat(e.center, e.elevation);
            a.z = s.z + Math.cos(e.pitchInRadians) * e.cameraToCenterDistance / e.worldSize;
            const n = e.getCoveringTilesDetailsProvider(), l = n.allowVariableZoom(e, i), c = he(e, i), h = i.minzoom || 0, u = void 0 !== i.maxzoom ? i.maxzoom : e.maxZoom, d = Math.min(Math.max(0, c), u), _ = Math.pow(2, d), p = [
                _ * a.x,
                _ * a.y,
                0
            ], m = [
                _ * s.x,
                _ * s.y,
                0
            ], f = Math.hypot(s.x - a.x, s.y - a.y), g = Math.abs(s.z - a.z), v = Math.hypot(f, g), x = (e)=>({
                    zoom: 0,
                    x: 0,
                    y: 0,
                    wrap: e,
                    fullyVisible: !1
                }), b = [], y = [];
            if (e.renderWorldCopies && n.allowWorldCopies()) for(let e = 1; e <= 3; e++)b.push(x(-e)), b.push(x(e));
            for(b.push(x(0)); b.length > 0;){
                const _ = b.pop(), f = _.x, x = _.y;
                let w = _.fullyVisible;
                const T = {
                    x: f,
                    y: x,
                    z: _.zoom
                }, P = n.getTileAABB(T, _.wrap, e.elevation, i);
                if (!w) {
                    const e = le(r, P, o);
                    if (0 === e) continue;
                    w = 2 === e;
                }
                const C = n.distanceToTile2d(a.x, a.y, T, P);
                let I = c;
                l && (I = (i.calculateTileZoom || ce)(e.zoom + t.ab(e.tileSize / i.tileSize), C, g, v, e.fov)), I = (i.roundZoom ? Math.round : Math.floor)(I), I = Math.max(0, I);
                const M = Math.min(I, u);
                if (_.wrap = n.getWrap(s, T, _.wrap), _.zoom >= M) {
                    if (_.zoom < h) continue;
                    const e = d - _.zoom, r = p[0] - .5 - (f << e), o = p[1] - .5 - (x << e), a = i.reparseOverscaled ? Math.max(_.zoom, I) : _.zoom;
                    y.push({
                        tileID: new t.Y(_.zoom === u ? a : _.zoom, _.wrap, _.zoom, f, x),
                        distanceSq: t.ac([
                            m[0] - .5 - f,
                            m[1] - .5 - x
                        ]),
                        tileDistanceToCamera: Math.sqrt(r * r + o * o)
                    });
                } else for(let e = 0; e < 4; e++)b.push({
                    zoom: _.zoom + 1,
                    x: (f << 1) + e % 2,
                    y: (x << 1) + (e >> 1),
                    wrap: _.wrap,
                    fullyVisible: w
                });
            }
            return y.sort((e, t)=>e.distanceSq - t.distanceSq).map((e)=>e.tileID);
        }
        class de extends t.E {
            constructor(e, t, i){
                super(), this.id = e, this.dispatcher = i, this.on("data", (e)=>this._dataHandler(e)), this.on("dataloading", ()=>{
                    this._sourceErrored = !1;
                }), this.on("error", ()=>{
                    this._sourceErrored = this._source.loaded();
                }), this._source = ((e, t, i, r)=>{
                    const o = new (ee(t.type))(e, t, i, r);
                    if (o.id !== e) throw new Error(`Expected Source id to be ${e} instead of ${o.id}`);
                    return o;
                })(e, t, i, this), this._tiles = {}, this._cache = new se(0, (e)=>this._unloadTile(e)), this._timers = {}, this._cacheTimers = {}, this._maxTileCacheSize = null, this._maxTileCacheZoomLevels = null, this._loadedParentTiles = {}, this._coveredTiles = {}, this._state = new ne, this._didEmitContent = !1, this._updated = !1;
            }
            onAdd(e) {
                this.map = e, this._maxTileCacheSize = e ? e._maxTileCacheSize : null, this._maxTileCacheZoomLevels = e ? e._maxTileCacheZoomLevels : null, this._source && this._source.onAdd && this._source.onAdd(e);
            }
            onRemove(e) {
                this.clearTiles(), this._source && this._source.onRemove && this._source.onRemove(e);
            }
            loaded() {
                if (this._sourceErrored) return !0;
                if (!this._sourceLoaded) return !1;
                if (!this._source.loaded()) return !1;
                if (!(void 0 === this.used && void 0 === this.usedForTerrain || this.used || this.usedForTerrain)) return !0;
                if (!this._updated) return !1;
                for(const e in this._tiles){
                    const t = this._tiles[e];
                    if ("loaded" !== t.state && "errored" !== t.state) return !1;
                }
                return !0;
            }
            getSource() {
                return this._source;
            }
            pause() {
                this._paused = !0;
            }
            resume() {
                if (!this._paused) return;
                const e = this._shouldReloadOnResume;
                this._paused = !1, this._shouldReloadOnResume = !1, e && this.reload(), this.transform && this.update(this.transform, this.terrain);
            }
            _loadTile(e, i, r) {
                return t._(this, void 0, void 0, function*() {
                    try {
                        yield this._source.loadTile(e), this._tileLoaded(e, i, r);
                    } catch (i) {
                        e.state = "errored", 404 !== i.status ? this._source.fire(new t.k(i, {
                            tile: e
                        })) : this.update(this.transform, this.terrain);
                    }
                });
            }
            _unloadTile(e) {
                this._source.unloadTile && this._source.unloadTile(e);
            }
            _abortTile(e) {
                this._source.abortTile && this._source.abortTile(e), this._source.fire(new t.l("dataabort", {
                    tile: e,
                    coord: e.tileID,
                    dataType: "source"
                }));
            }
            serialize() {
                return this._source.serialize();
            }
            prepare(e) {
                this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
                for(const t in this._tiles){
                    const i = this._tiles[t];
                    i.upload(e), i.prepare(this.map.style.imageManager);
                }
            }
            getIds() {
                return Object.values(this._tiles).map((e)=>e.tileID).sort(_e).map((e)=>e.key);
            }
            getRenderableIds(e) {
                const i = [];
                for(const t in this._tiles)this._isIdRenderable(t, e) && i.push(this._tiles[t]);
                return e ? i.sort((e, i)=>{
                    const r = e.tileID, o = i.tileID, a = new t.P(r.canonical.x, r.canonical.y)._rotate(-this.transform.bearingInRadians), s = new t.P(o.canonical.x, o.canonical.y)._rotate(-this.transform.bearingInRadians);
                    return r.overscaledZ - o.overscaledZ || s.y - a.y || s.x - a.x;
                }).map((e)=>e.tileID.key) : i.map((e)=>e.tileID).sort(_e).map((e)=>e.key);
            }
            hasRenderableParent(e) {
                const t = this.findLoadedParent(e, 0);
                return !!t && this._isIdRenderable(t.tileID.key);
            }
            _isIdRenderable(e, t) {
                return this._tiles[e] && this._tiles[e].hasData() && !this._coveredTiles[e] && (t || !this._tiles[e].holdingForFade());
            }
            reload(e) {
                if (this._paused) this._shouldReloadOnResume = !0;
                else {
                    this._cache.reset();
                    for(const t in this._tiles)(e || "errored" !== this._tiles[t].state) && this._reloadTile(t, "reloading");
                }
            }
            _reloadTile(e, i) {
                return t._(this, void 0, void 0, function*() {
                    const t = this._tiles[e];
                    t && ("loading" !== t.state && (t.state = i), yield this._loadTile(t, e, i));
                });
            }
            _tileLoaded(e, i, r) {
                e.timeAdded = s.now(), "expired" === r && (e.refreshedUponExpiration = !0), this._setTileReloadTimer(i, e), "raster-dem" === this.getSource().type && e.dem && this._backfillDEM(e), this._state.initializeTileState(e, this.map ? this.map.painter : null), e.aborted || this._source.fire(new t.l("data", {
                    dataType: "source",
                    tile: e,
                    coord: e.tileID
                }));
            }
            _backfillDEM(e) {
                const t = this.getRenderableIds();
                for(let r = 0; r < t.length; r++){
                    const o = t[r];
                    if (e.neighboringTiles && e.neighboringTiles[o]) {
                        const t = this.getTileByID(o);
                        i(e, t), i(t, e);
                    }
                }
                function i(e, t) {
                    e.needsHillshadePrepare = !0, e.needsTerrainPrepare = !0;
                    let i = t.tileID.canonical.x - e.tileID.canonical.x;
                    const r = t.tileID.canonical.y - e.tileID.canonical.y, o = Math.pow(2, e.tileID.canonical.z), a = t.tileID.key;
                    0 === i && 0 === r || Math.abs(r) > 1 || (Math.abs(i) > 1 && (1 === Math.abs(i + o) ? i += o : 1 === Math.abs(i - o) && (i -= o)), t.dem && e.dem && (e.dem.backfillBorder(t.dem, i, r), e.neighboringTiles && e.neighboringTiles[a] && (e.neighboringTiles[a].backfilled = !0)));
                }
            }
            getTile(e) {
                return this.getTileByID(e.key);
            }
            getTileByID(e) {
                return this._tiles[e];
            }
            _retainLoadedChildren(e, t, i, r) {
                for(const o in this._tiles){
                    let a = this._tiles[o];
                    if (r[o] || !a.hasData() || a.tileID.overscaledZ <= t || a.tileID.overscaledZ > i) continue;
                    let s = a.tileID;
                    for(; a && a.tileID.overscaledZ > t + 1;){
                        const e = a.tileID.scaledTo(a.tileID.overscaledZ - 1);
                        a = this._tiles[e.key], a && a.hasData() && (s = e);
                    }
                    let n = s;
                    for(; n.overscaledZ > t;)if (n = n.scaledTo(n.overscaledZ - 1), e[n.key] || e[n.canonical.key]) {
                        r[s.key] = s;
                        break;
                    }
                }
            }
            findLoadedParent(e, t) {
                if (e.key in this._loadedParentTiles) {
                    const i = this._loadedParentTiles[e.key];
                    return i && i.tileID.overscaledZ >= t ? i : null;
                }
                for(let i = e.overscaledZ - 1; i >= t; i--){
                    const t = e.scaledTo(i), r = this._getLoadedTile(t);
                    if (r) return r;
                }
            }
            findLoadedSibling(e) {
                return this._getLoadedTile(e);
            }
            _getLoadedTile(e) {
                const t = this._tiles[e.key];
                return t && t.hasData() ? t : this._cache.getByKey(e.wrapped().key);
            }
            updateCacheSize(e) {
                const i = Math.ceil(e.width / this._source.tileSize) + 1, r = Math.ceil(e.height / this._source.tileSize) + 1, o = Math.floor(i * r * (null === this._maxTileCacheZoomLevels ? t.a.MAX_TILE_CACHE_ZOOM_LEVELS : this._maxTileCacheZoomLevels)), a = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, o) : o;
                this._cache.setMaxSize(a);
            }
            handleWrapJump(e) {
                const t = Math.round((e - (void 0 === this._prevLng ? e : this._prevLng)) / 360);
                if (this._prevLng = e, t) {
                    const e = {};
                    for(const i in this._tiles){
                        const r = this._tiles[i];
                        r.tileID = r.tileID.unwrapTo(r.tileID.wrap + t), e[r.tileID.key] = r;
                    }
                    this._tiles = e;
                    for(const e in this._timers)clearTimeout(this._timers[e]), delete this._timers[e];
                    for(const e in this._tiles)this._setTileReloadTimer(e, this._tiles[e]);
                }
            }
            _updateCoveredAndRetainedTiles(e, t, i, r, o, a) {
                const n = {}, l = {}, c = Object.keys(e), h = s.now();
                for (const i of c){
                    const r = e[i], o = this._tiles[i];
                    if (!o || 0 !== o.fadeEndTime && o.fadeEndTime <= h) continue;
                    const a = this.findLoadedParent(r, t), s = this.findLoadedSibling(r), c = a || s || null;
                    c && (this._addTile(c.tileID), n[c.tileID.key] = c.tileID), l[i] = r;
                }
                this._retainLoadedChildren(l, r, i, e);
                for(const t in n)e[t] || (this._coveredTiles[t] = !0, e[t] = n[t]);
                if (a) {
                    const t = {}, i = {};
                    for (const e of o)this._tiles[e.key].hasData() ? t[e.key] = e : i[e.key] = e;
                    for(const r in i){
                        const o = i[r].children(this._source.maxzoom);
                        this._tiles[o[0].key] && this._tiles[o[1].key] && this._tiles[o[2].key] && this._tiles[o[3].key] && (t[o[0].key] = e[o[0].key] = o[0], t[o[1].key] = e[o[1].key] = o[1], t[o[2].key] = e[o[2].key] = o[2], t[o[3].key] = e[o[3].key] = o[3], delete i[r]);
                    }
                    for(const r in i){
                        const o = i[r], a = this.findLoadedParent(o, this._source.minzoom), s = this.findLoadedSibling(o), n = a || s || null;
                        if (n) {
                            t[n.tileID.key] = e[n.tileID.key] = n.tileID;
                            for(const e in t)t[e].isChildOf(n.tileID) && delete t[e];
                        }
                    }
                    for(const e in this._tiles)t[e] || (this._coveredTiles[e] = !0);
                }
            }
            update(e, i) {
                if (!this._sourceLoaded || this._paused) return;
                let r;
                this.transform = e, this.terrain = i, this.updateCacheSize(e), this.handleWrapJump(this.transform.center.lng), this._coveredTiles = {}, this.used || this.usedForTerrain ? this._source.tileID ? r = e.getVisibleUnwrappedCoordinates(this._source.tileID).map((e)=>new t.Y(e.canonical.z, e.wrap, e.canonical.z, e.canonical.x, e.canonical.y)) : (r = ue(e, {
                    tileSize: this.usedForTerrain ? this.tileSize : this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: this._source.maxzoom,
                    roundZoom: !this.usedForTerrain && this._source.roundZoom,
                    reparseOverscaled: this._source.reparseOverscaled,
                    terrain: i,
                    calculateTileZoom: this._source.calculateTileZoom
                }), this._source.hasTile && (r = r.filter((e)=>this._source.hasTile(e)))) : r = [];
                const o = he(e, this._source), a = Math.max(o - de.maxOverzooming, this._source.minzoom), s = Math.max(o + de.maxUnderzooming, this._source.minzoom);
                if (this.usedForTerrain) {
                    const e = {};
                    for (const t of r)if (t.canonical.z > this._source.minzoom) {
                        const i = t.scaledTo(t.canonical.z - 1);
                        e[i.key] = i;
                        const r = t.scaledTo(Math.max(this._source.minzoom, Math.min(t.canonical.z, 5)));
                        e[r.key] = r;
                    }
                    r = r.concat(Object.values(e));
                }
                const n = 0 === r.length && !this._updated && this._didEmitContent;
                this._updated = !0, n && this.fire(new t.l("data", {
                    sourceDataType: "idle",
                    dataType: "source",
                    sourceId: this.id
                }));
                const l = this._updateRetainedTiles(r, o);
                pe(this._source.type) && this._updateCoveredAndRetainedTiles(l, a, s, o, r, i);
                for(const e in l)this._tiles[e].clearFadeHold();
                const c = t.af(this._tiles, l);
                for (const e of c){
                    const t = this._tiles[e];
                    t.hasSymbolBuckets && !t.holdingForFade() ? t.setHoldDuration(this.map._fadeDuration) : t.hasSymbolBuckets && !t.symbolFadeFinished() || this._removeTile(e);
                }
                this._updateLoadedParentTileCache(), this._updateLoadedSiblingTileCache();
            }
            releaseSymbolFadeTiles() {
                for(const e in this._tiles)this._tiles[e].holdingForFade() && this._removeTile(e);
            }
            _updateRetainedTiles(e, t) {
                var i;
                const r = {}, o = {}, a = Math.max(t - de.maxOverzooming, this._source.minzoom), s = Math.max(t + de.maxUnderzooming, this._source.minzoom), n = {};
                for (const i of e){
                    const e = this._addTile(i);
                    r[i.key] = i, e.hasData() || t < this._source.maxzoom && (n[i.key] = i);
                }
                this._retainLoadedChildren(n, t, s, r);
                for (const s of e){
                    let e = this._tiles[s.key];
                    if (e.hasData()) continue;
                    if (t + 1 > this._source.maxzoom) {
                        const e = s.children(this._source.maxzoom)[0], t = this.getTile(e);
                        if (t && t.hasData()) {
                            r[e.key] = e;
                            continue;
                        }
                    } else {
                        const e = s.children(this._source.maxzoom);
                        if (r[e[0].key] && r[e[1].key] && r[e[2].key] && r[e[3].key]) continue;
                    }
                    let n = e.wasRequested();
                    for(let t = s.overscaledZ - 1; t >= a; --t){
                        const a = s.scaledTo(t);
                        if (o[a.key]) break;
                        if (o[a.key] = !0, e = this.getTile(a), !e && n && (e = this._addTile(a)), e) {
                            const t = e.hasData();
                            if ((t || !(null === (i = this.map) || void 0 === i ? void 0 : i.cancelPendingTileRequestsWhileZooming) || n) && (r[a.key] = a), n = e.wasRequested(), t) break;
                        }
                    }
                }
                return r;
            }
            _updateLoadedParentTileCache() {
                this._loadedParentTiles = {};
                for(const e in this._tiles){
                    const t = [];
                    let i, r = this._tiles[e].tileID;
                    for(; r.overscaledZ > 0;){
                        if (r.key in this._loadedParentTiles) {
                            i = this._loadedParentTiles[r.key];
                            break;
                        }
                        t.push(r.key);
                        const e = r.scaledTo(r.overscaledZ - 1);
                        if (i = this._getLoadedTile(e), i) break;
                        r = e;
                    }
                    for (const e of t)this._loadedParentTiles[e] = i;
                }
            }
            _updateLoadedSiblingTileCache() {
                this._loadedSiblingTiles = {};
                for(const e in this._tiles){
                    const t = this._tiles[e].tileID, i = this._getLoadedTile(t);
                    this._loadedSiblingTiles[t.key] = i;
                }
            }
            _addTile(e) {
                let i = this._tiles[e.key];
                if (i) return i;
                i = this._cache.getAndRemove(e), i && (this._setTileReloadTimer(e.key, i), i.tileID = e, this._state.initializeTileState(i, this.map ? this.map.painter : null), this._cacheTimers[e.key] && (clearTimeout(this._cacheTimers[e.key]), delete this._cacheTimers[e.key], this._setTileReloadTimer(e.key, i)));
                const r = i;
                return i || (i = new ae(e, this._source.tileSize * e.overscaleFactor()), this._loadTile(i, e.key, i.state)), i.uses++, this._tiles[e.key] = i, r || this._source.fire(new t.l("dataloading", {
                    tile: i,
                    coord: i.tileID,
                    dataType: "source"
                })), i;
            }
            _setTileReloadTimer(e, t) {
                e in this._timers && (clearTimeout(this._timers[e]), delete this._timers[e]);
                const i = t.getExpiryTimeout();
                i && (this._timers[e] = setTimeout(()=>{
                    this._reloadTile(e, "expired"), delete this._timers[e];
                }, i));
            }
            _removeTile(e) {
                const t = this._tiles[e];
                t && (t.uses--, delete this._tiles[e], this._timers[e] && (clearTimeout(this._timers[e]), delete this._timers[e]), t.uses > 0 || (t.hasData() && "reloading" !== t.state ? this._cache.add(t.tileID, t, t.getExpiryTimeout()) : (t.aborted = !0, this._abortTile(t), this._unloadTile(t))));
            }
            _dataHandler(e) {
                const t = e.sourceDataType;
                "source" === e.dataType && "metadata" === t && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && "source" === e.dataType && "content" === t && (this.reload(e.sourceDataChanged), this.transform && this.update(this.transform, this.terrain), this._didEmitContent = !0);
            }
            clearTiles() {
                this._shouldReloadOnResume = !1, this._paused = !1;
                for(const e in this._tiles)this._removeTile(e);
                this._cache.reset();
            }
            tilesIn(e, i, r) {
                const o = [], a = this.transform;
                if (!a) return o;
                const s = r ? a.getCameraQueryGeometry(e) : e, n = e.map((e)=>a.screenPointToMercatorCoordinate(e, this.terrain)), l = s.map((e)=>a.screenPointToMercatorCoordinate(e, this.terrain)), c = this.getIds();
                let h = 1 / 0, u = 1 / 0, d = -1 / 0, _ = -1 / 0;
                for (const e of l)h = Math.min(h, e.x), u = Math.min(u, e.y), d = Math.max(d, e.x), _ = Math.max(_, e.y);
                for(let e = 0; e < c.length; e++){
                    const r = this._tiles[c[e]];
                    if (r.holdingForFade()) continue;
                    const s = r.tileID, p = Math.pow(2, a.zoom - r.tileID.overscaledZ), m = i * r.queryPadding * t.Z / r.tileSize / p, f = [
                        s.getTilePoint(new t.$(h, u)),
                        s.getTilePoint(new t.$(d, _))
                    ];
                    if (f[0].x - m < t.Z && f[0].y - m < t.Z && f[1].x + m >= 0 && f[1].y + m >= 0) {
                        const e = n.map((e)=>s.getTilePoint(e)), t = l.map((e)=>s.getTilePoint(e));
                        o.push({
                            tile: r,
                            tileID: s,
                            queryGeometry: e,
                            cameraQueryGeometry: t,
                            scale: p
                        });
                    }
                }
                return o;
            }
            getVisibleCoordinates(e) {
                const t = this.getRenderableIds(e).map((e)=>this._tiles[e].tileID);
                return this.transform && this.transform.populateCache(t), t;
            }
            hasTransition() {
                if (this._source.hasTransition()) return !0;
                if (pe(this._source.type)) {
                    const e = s.now();
                    for(const t in this._tiles)if (this._tiles[t].fadeEndTime >= e) return !0;
                }
                return !1;
            }
            setFeatureState(e, t, i) {
                this._state.updateState(e = e || "_geojsonTileLayer", t, i);
            }
            removeFeatureState(e, t, i) {
                this._state.removeFeatureState(e = e || "_geojsonTileLayer", t, i);
            }
            getFeatureState(e, t) {
                return this._state.getState(e = e || "_geojsonTileLayer", t);
            }
            setDependencies(e, t, i) {
                const r = this._tiles[e];
                r && r.setDependencies(t, i);
            }
            reloadTilesForDependencies(e, t) {
                for(const i in this._tiles)this._tiles[i].hasDependency(e, t) && this._reloadTile(i, "reloading");
                this._cache.filter((i)=>!i.hasDependency(e, t));
            }
        }
        function _e(e, t) {
            const i = Math.abs(2 * e.wrap) - +(e.wrap < 0), r = Math.abs(2 * t.wrap) - +(t.wrap < 0);
            return e.overscaledZ - t.overscaledZ || r - i || t.canonical.y - e.canonical.y || t.canonical.x - e.canonical.x;
        }
        function pe(e) {
            return "raster" === e || "image" === e || "video" === e;
        }
        de.maxOverzooming = 10, de.maxUnderzooming = 3;
        class me {
            constructor(e, t){
                this.reset(e, t);
            }
            reset(e, t) {
                this.points = e || [], this._distances = [
                    0
                ];
                for(let e = 1; e < this.points.length; e++)this._distances[e] = this._distances[e - 1] + this.points[e].dist(this.points[e - 1]);
                this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
            }
            lerp(e) {
                if (1 === this.points.length) return this.points[0];
                e = t.ae(e, 0, 1);
                let i = 1, r = this._distances[i];
                const o = e * this.paddedLength + this.padding;
                for(; r < o && i < this._distances.length;)r = this._distances[++i];
                const a = i - 1, s = this._distances[a], n = r - s, l = n > 0 ? (o - s) / n : 0;
                return this.points[a].mult(1 - l).add(this.points[i].mult(l));
            }
        }
        function fe(e, t) {
            let i = !0;
            return "always" === e || "never" !== e && "never" !== t || (i = !1), i;
        }
        class ge {
            constructor(e, t, i){
                const r = this.boxCells = [], o = this.circleCells = [];
                this.xCellCount = Math.ceil(e / i), this.yCellCount = Math.ceil(t / i);
                for(let e = 0; e < this.xCellCount * this.yCellCount; e++)r.push([]), o.push([]);
                this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e, this.height = t, this.xScale = this.xCellCount / e, this.yScale = this.yCellCount / t, this.boxUid = 0, this.circleUid = 0;
            }
            keysLength() {
                return this.boxKeys.length + this.circleKeys.length;
            }
            insert(e, t, i, r, o) {
                this._forEachCell(t, i, r, o, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e), this.bboxes.push(t), this.bboxes.push(i), this.bboxes.push(r), this.bboxes.push(o);
            }
            insertCircle(e, t, i, r) {
                this._forEachCell(t - r, i - r, t + r, i + r, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e), this.circles.push(t), this.circles.push(i), this.circles.push(r);
            }
            _insertBoxCell(e, t, i, r, o, a) {
                this.boxCells[o].push(a);
            }
            _insertCircleCell(e, t, i, r, o, a) {
                this.circleCells[o].push(a);
            }
            _query(e, t, i, r, o, a, s) {
                if (i < 0 || e > this.width || r < 0 || t > this.height) return [];
                const n = [];
                if (e <= 0 && t <= 0 && this.width <= i && this.height <= r) {
                    if (o) return [
                        {
                            key: null,
                            x1: e,
                            y1: t,
                            x2: i,
                            y2: r
                        }
                    ];
                    for(let e = 0; e < this.boxKeys.length; e++)n.push({
                        key: this.boxKeys[e],
                        x1: this.bboxes[4 * e],
                        y1: this.bboxes[4 * e + 1],
                        x2: this.bboxes[4 * e + 2],
                        y2: this.bboxes[4 * e + 3]
                    });
                    for(let e = 0; e < this.circleKeys.length; e++){
                        const t = this.circles[3 * e], i = this.circles[3 * e + 1], r = this.circles[3 * e + 2];
                        n.push({
                            key: this.circleKeys[e],
                            x1: t - r,
                            y1: i - r,
                            x2: t + r,
                            y2: i + r
                        });
                    }
                } else this._forEachCell(e, t, i, r, this._queryCell, n, {
                    hitTest: o,
                    overlapMode: a,
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, s);
                return n;
            }
            query(e, t, i, r) {
                return this._query(e, t, i, r, !1, null);
            }
            hitTest(e, t, i, r, o, a) {
                return this._query(e, t, i, r, !0, o, a).length > 0;
            }
            hitTestCircle(e, t, i, r, o) {
                const a = e - i, s = e + i, n = t - i, l = t + i;
                if (s < 0 || a > this.width || l < 0 || n > this.height) return !1;
                const c = [];
                return this._forEachCell(a, n, s, l, this._queryCellCircle, c, {
                    hitTest: !0,
                    overlapMode: r,
                    circle: {
                        x: e,
                        y: t,
                        radius: i
                    },
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, o), c.length > 0;
            }
            _queryCell(e, t, i, r, o, a, s, n) {
                const { seenUids: l, hitTest: c, overlapMode: h } = s, u = this.boxCells[o];
                if (null !== u) {
                    const o = this.bboxes;
                    for (const s of u)if (!l.box[s]) {
                        l.box[s] = !0;
                        const u = 4 * s, d = this.boxKeys[s];
                        if (e <= o[u + 2] && t <= o[u + 3] && i >= o[u + 0] && r >= o[u + 1] && (!n || n(d)) && (!c || !fe(h, d.overlapMode)) && (a.push({
                            key: d,
                            x1: o[u],
                            y1: o[u + 1],
                            x2: o[u + 2],
                            y2: o[u + 3]
                        }), c)) return !0;
                    }
                }
                const d = this.circleCells[o];
                if (null !== d) {
                    const o = this.circles;
                    for (const s of d)if (!l.circle[s]) {
                        l.circle[s] = !0;
                        const u = 3 * s, d = this.circleKeys[s];
                        if (this._circleAndRectCollide(o[u], o[u + 1], o[u + 2], e, t, i, r) && (!n || n(d)) && (!c || !fe(h, d.overlapMode))) {
                            const e = o[u], t = o[u + 1], i = o[u + 2];
                            if (a.push({
                                key: d,
                                x1: e - i,
                                y1: t - i,
                                x2: e + i,
                                y2: t + i
                            }), c) return !0;
                        }
                    }
                }
                return !1;
            }
            _queryCellCircle(e, t, i, r, o, a, s, n) {
                const { circle: l, seenUids: c, overlapMode: h } = s, u = this.boxCells[o];
                if (null !== u) {
                    const e = this.bboxes;
                    for (const t of u)if (!c.box[t]) {
                        c.box[t] = !0;
                        const i = 4 * t, r = this.boxKeys[t];
                        if (this._circleAndRectCollide(l.x, l.y, l.radius, e[i + 0], e[i + 1], e[i + 2], e[i + 3]) && (!n || n(r)) && !fe(h, r.overlapMode)) return a.push(!0), !0;
                    }
                }
                const d = this.circleCells[o];
                if (null !== d) {
                    const e = this.circles;
                    for (const t of d)if (!c.circle[t]) {
                        c.circle[t] = !0;
                        const i = 3 * t, r = this.circleKeys[t];
                        if (this._circlesCollide(e[i], e[i + 1], e[i + 2], l.x, l.y, l.radius) && (!n || n(r)) && !fe(h, r.overlapMode)) return a.push(!0), !0;
                    }
                }
            }
            _forEachCell(e, t, i, r, o, a, s, n) {
                const l = this._convertToXCellCoord(e), c = this._convertToYCellCoord(t), h = this._convertToXCellCoord(i), u = this._convertToYCellCoord(r);
                for(let d = l; d <= h; d++)for(let l = c; l <= u; l++)if (o.call(this, e, t, i, r, this.xCellCount * l + d, a, s, n)) return;
            }
            _convertToXCellCoord(e) {
                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e * this.xScale)));
            }
            _convertToYCellCoord(e) {
                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e * this.yScale)));
            }
            _circlesCollide(e, t, i, r, o, a) {
                const s = r - e, n = o - t, l = i + a;
                return l * l > s * s + n * n;
            }
            _circleAndRectCollide(e, t, i, r, o, a, s) {
                const n = (a - r) / 2, l = Math.abs(e - (r + n));
                if (l > n + i) return !1;
                const c = (s - o) / 2, h = Math.abs(t - (o + c));
                if (h > c + i) return !1;
                if (l <= n || h <= c) return !0;
                const u = l - n, d = h - c;
                return u * u + d * d <= i * i;
            }
        }
        function ve(e, i, o) {
            const a = t.K();
            if (!e) {
                const { vecSouth: e, vecEast: t } = be(i), o = r();
                o[0] = t[0], o[1] = t[1], o[2] = e[0], o[3] = e[1], s = o, (d = (l = (n = o)[0]) * (u = n[3]) - (h = n[2]) * (c = n[1])) && (s[0] = u * (d = 1 / d), s[1] = -c * d, s[2] = -h * d, s[3] = l * d), a[0] = o[0], a[1] = o[1], a[4] = o[2], a[5] = o[3];
            }
            var s, n, l, c, h, u, d;
            return t.M(a, a, [
                1 / o,
                1 / o,
                1
            ]), a;
        }
        function xe(e, i, r, o) {
            if (e) {
                const e = t.K();
                if (!i) {
                    const { vecSouth: t, vecEast: i } = be(r);
                    e[0] = i[0], e[1] = i[1], e[4] = t[0], e[5] = t[1];
                }
                return t.M(e, e, [
                    o,
                    o,
                    1
                ]), e;
            }
            return r.pixelsToClipSpaceMatrix;
        }
        function be(e) {
            const i = Math.cos(e.rollInRadians), r = Math.sin(e.rollInRadians), o = Math.cos(e.pitchInRadians), a = Math.cos(e.bearingInRadians), s = Math.sin(e.bearingInRadians), n = t.ak();
            n[0] = -a * o * r - s * i, n[1] = -s * o * r + a * i;
            const l = t.al(n);
            l < 1e-9 ? t.am(n) : t.an(n, n, 1 / l);
            const c = t.ak();
            c[0] = a * o * i - s * r, c[1] = s * o * i + a * r;
            const h = t.al(c);
            return h < 1e-9 ? t.am(c) : t.an(c, c, 1 / h), {
                vecEast: c,
                vecSouth: n
            };
        }
        function ye(e, i, r, o) {
            let a;
            o ? (a = [
                e,
                i,
                o(e, i),
                1
            ], t.ap(a, a, r)) : (a = [
                e,
                i,
                0,
                1
            ], Oe(a, a, r));
            const s = a[3];
            return {
                point: new t.P(a[0] / s, a[1] / s),
                signedDistanceFromCamera: s,
                isOccluded: !1
            };
        }
        function we(e, t) {
            return .5 + e / t * .5;
        }
        function Te(e, t) {
            return e.x >= -t[0] && e.x <= t[0] && e.y >= -t[1] && e.y <= t[1];
        }
        function Pe(e, i, r, o, a, s, n, l, c, h, u, d, _) {
            const p = r ? e.textSizeData : e.iconSizeData, m = t.ag(p, i.transform.zoom), f = [
                256 / i.width * 2 + 1,
                256 / i.height * 2 + 1
            ], g = r ? e.text.dynamicLayoutVertexArray : e.icon.dynamicLayoutVertexArray;
            g.clear();
            const v = e.lineVertexArray, x = r ? e.text.placedSymbolArray : e.icon.placedSymbolArray, b = i.transform.width / i.transform.height;
            let y = !1;
            for(let r = 0; r < x.length; r++){
                const w = x.get(r);
                if (w.hidden || w.writingMode === t.ah.vertical && !y) {
                    Be(w.numGlyphs, g);
                    continue;
                }
                y = !1;
                const T = new t.P(w.anchorX, w.anchorY), P = {
                    getElevation: _,
                    pitchedLabelPlaneMatrix: o,
                    lineVertexArray: v,
                    pitchWithMap: s,
                    projectionCache: {
                        projections: {},
                        offsets: {},
                        cachedAnchorPoint: void 0,
                        anyProjectionOccluded: !1
                    },
                    transform: i.transform,
                    tileAnchorPoint: T,
                    unwrappedTileID: c,
                    width: h,
                    height: u,
                    translation: d
                }, C = ze(w.anchorX, w.anchorY, P);
                if (!Te(C.point, f)) {
                    Be(w.numGlyphs, g);
                    continue;
                }
                const I = we(i.transform.cameraToCenterDistance, C.signedDistanceFromCamera), M = t.ai(p, m, w), E = s ? M * i.transform.getPitchedTextCorrection(w.anchorX, w.anchorY, c) / I : M * I, S = Me({
                    projectionContext: P,
                    pitchedLabelPlaneMatrixInverse: a,
                    symbol: w,
                    fontSize: E,
                    flip: !1,
                    keepUpright: n,
                    glyphOffsetArray: e.glyphOffsetArray,
                    dynamicLayoutVertexArray: g,
                    aspectRatio: b,
                    rotateToLine: l
                });
                y = S.useVertical, (S.notEnoughRoom || y || S.needsFlipping && Me({
                    projectionContext: P,
                    pitchedLabelPlaneMatrixInverse: a,
                    symbol: w,
                    fontSize: E,
                    flip: !0,
                    keepUpright: n,
                    glyphOffsetArray: e.glyphOffsetArray,
                    dynamicLayoutVertexArray: g,
                    aspectRatio: b,
                    rotateToLine: l
                }).notEnoughRoom) && Be(w.numGlyphs, g);
            }
            r ? e.text.dynamicLayoutVertexBuffer.updateData(g) : e.icon.dynamicLayoutVertexBuffer.updateData(g);
        }
        function Ce(e, t, i, r, o, a, s, n) {
            const l = a.glyphStartIndex + a.numGlyphs, c = a.lineStartIndex, h = a.lineStartIndex + a.lineLength, u = t.getoffsetX(a.glyphStartIndex), d = t.getoffsetX(l - 1), _ = ke(e * u, i, r, o, a.segment, c, h, n, s);
            if (!_) return null;
            const p = ke(e * d, i, r, o, a.segment, c, h, n, s);
            return p ? n.projectionCache.anyProjectionOccluded ? null : {
                first: _,
                last: p
            } : null;
        }
        function Ie(e, i, r, o) {
            return e === t.ah.horizontal && Math.abs(r.y - i.y) > Math.abs(r.x - i.x) * o ? {
                useVertical: !0
            } : (e === t.ah.vertical ? i.y < r.y : i.x > r.x) ? {
                needsFlipping: !0
            } : null;
        }
        function Me(e) {
            const { projectionContext: i, pitchedLabelPlaneMatrixInverse: r, symbol: o, fontSize: a, flip: s, keepUpright: n, glyphOffsetArray: l, dynamicLayoutVertexArray: c, aspectRatio: h, rotateToLine: u } = e, d = a / 24, _ = o.lineOffsetX * d, p = o.lineOffsetY * d;
            let m;
            if (o.numGlyphs > 1) {
                const e = o.glyphStartIndex + o.numGlyphs, t = o.lineStartIndex, a = o.lineStartIndex + o.lineLength, c = Ce(d, l, _, p, s, o, u, i);
                if (!c) return {
                    notEnoughRoom: !0
                };
                const f = De(c.first.point.x, c.first.point.y, i, r), g = De(c.last.point.x, c.last.point.y, i, r);
                if (n && !s) {
                    const e = Ie(o.writingMode, f, g, h);
                    if (e) return e;
                }
                m = [
                    c.first
                ];
                for(let r = o.glyphStartIndex + 1; r < e - 1; r++)m.push(ke(d * l.getoffsetX(r), _, p, s, o.segment, t, a, i, u));
                m.push(c.last);
            } else {
                if (n && !s) {
                    const e = Re(i.tileAnchorPoint.x, i.tileAnchorPoint.y, i).point, a = o.lineStartIndex + o.segment + 1, s = new t.P(i.lineVertexArray.getx(a), i.lineVertexArray.gety(a)), n = Re(s.x, s.y, i), l = n.signedDistanceFromCamera > 0 ? n.point : Ee(i.tileAnchorPoint, s, e, 1, i), c = De(e.x, e.y, i, r), u = De(l.x, l.y, i, r), d = Ie(o.writingMode, c, u, h);
                    if (d) return d;
                }
                const e = ke(d * l.getoffsetX(o.glyphStartIndex), _, p, s, o.segment, o.lineStartIndex, o.lineStartIndex + o.lineLength, i, u);
                if (!e || i.projectionCache.anyProjectionOccluded) return {
                    notEnoughRoom: !0
                };
                m = [
                    e
                ];
            }
            for (const e of m)t.ao(c, e.point, e.angle);
            return {};
        }
        function Ee(e, t, i, r, o) {
            const a = e.add(e.sub(t)._unit()), s = Re(a.x, a.y, o).point, n = i.sub(s);
            return i.add(n._mult(r / n.mag()));
        }
        function Se(e, i, r) {
            const o = i.projectionCache;
            if (o.projections[e]) return o.projections[e];
            const a = new t.P(i.lineVertexArray.getx(e), i.lineVertexArray.gety(e)), s = Re(a.x, a.y, i);
            if (s.signedDistanceFromCamera > 0) return o.projections[e] = s.point, o.anyProjectionOccluded = o.anyProjectionOccluded || s.isOccluded, s.point;
            const n = e - r.direction;
            return Ee(0 === r.distanceFromAnchor ? i.tileAnchorPoint : new t.P(i.lineVertexArray.getx(n), i.lineVertexArray.gety(n)), a, r.previousVertex, r.absOffsetX - r.distanceFromAnchor + 1, i);
        }
        function Re(e, t, i) {
            const r = e + i.translation[0], o = t + i.translation[1];
            let a;
            return i.pitchWithMap ? (a = ye(r, o, i.pitchedLabelPlaneMatrix, i.getElevation), a.isOccluded = !1) : (a = i.transform.projectTileCoordinates(r, o, i.unwrappedTileID, i.getElevation), a.point.x = (.5 * a.point.x + .5) * i.width, a.point.y = (.5 * -a.point.y + .5) * i.height), a;
        }
        function De(e, i, r, o) {
            if (r.pitchWithMap) {
                const a = [
                    e,
                    i,
                    0,
                    1
                ];
                return t.ap(a, a, o), r.transform.projectTileCoordinates(a[0] / a[3], a[1] / a[3], r.unwrappedTileID, r.getElevation).point;
            }
            return {
                x: e / r.width * 2 - 1,
                y: i / r.height * 2 - 1
            };
        }
        function ze(e, t, i) {
            return i.transform.projectTileCoordinates(e, t, i.unwrappedTileID, i.getElevation);
        }
        function Ae(e, t, i) {
            return e._unit()._perp()._mult(t * i);
        }
        function Le(e, i, r, o, a, s, n, l, c) {
            if (l.projectionCache.offsets[e]) return l.projectionCache.offsets[e];
            const h = r.add(i);
            if (e + c.direction < o || e + c.direction >= a) return l.projectionCache.offsets[e] = h, h;
            const u = Se(e + c.direction, l, c), d = Ae(u.sub(r), n, c.direction), _ = r.add(d), p = u.add(d);
            return l.projectionCache.offsets[e] = t.aq(s, h, _, p) || h, l.projectionCache.offsets[e];
        }
        function ke(e, t, i, r, o, a, s, n, l) {
            const c = r ? e - t : e + t;
            let h = c > 0 ? 1 : -1, u = 0;
            r && (h *= -1, u = Math.PI), h < 0 && (u += Math.PI);
            let d, _ = h > 0 ? a + o : a + o + 1;
            n.projectionCache.cachedAnchorPoint ? d = n.projectionCache.cachedAnchorPoint : (d = Re(n.tileAnchorPoint.x, n.tileAnchorPoint.y, n).point, n.projectionCache.cachedAnchorPoint = d);
            let p, m, f = d, g = d, v = 0, x = 0;
            const b = Math.abs(c), y = [];
            let w;
            for(; v + x <= b;){
                if (_ += h, _ < a || _ >= s) return null;
                v += x, g = f, m = p;
                const e = {
                    absOffsetX: b,
                    direction: h,
                    distanceFromAnchor: v,
                    previousVertex: g
                };
                if (f = Se(_, n, e), 0 === i) y.push(g), w = f.sub(g);
                else {
                    let t;
                    const r = f.sub(g);
                    t = 0 === r.mag() ? Ae(Se(_ + h, n, e).sub(f), i, h) : Ae(r, i, h), m || (m = g.add(t)), p = Le(_, t, f, a, s, m, i, n, e), y.push(m), w = p.sub(m);
                }
                x = w.mag();
            }
            const T = w._mult((b - v) / x)._add(m || g), P = u + Math.atan2(f.y - g.y, f.x - g.x);
            return y.push(T), {
                point: T,
                angle: l ? P : 0,
                path: y
            };
        }
        const Fe = new Float32Array([
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0
        ]);
        function Be(e, t) {
            for(let i = 0; i < e; i++){
                const e = t.length;
                t.resize(e + 4), t.float32.set(Fe, 3 * e);
            }
        }
        function Oe(e, t, i) {
            const r = t[0], o = t[1];
            return e[0] = i[0] * r + i[4] * o + i[12], e[1] = i[1] * r + i[5] * o + i[13], e[3] = i[3] * r + i[7] * o + i[15], e;
        }
        const je = 100;
        class Ze {
            constructor(e, t = new ge(e.width + 200, e.height + 200, 25), i = new ge(e.width + 200, e.height + 200, 25)){
                this.transform = e, this.grid = t, this.ignoredGrid = i, this.pitchFactor = Math.cos(e.pitch * Math.PI / 180) * e.cameraToCenterDistance, this.screenRightBoundary = e.width + je, this.screenBottomBoundary = e.height + je, this.gridRightBoundary = e.width + 200, this.gridBottomBoundary = e.height + 200, this.perspectiveRatioCutoff = .6;
            }
            placeCollisionBox(e, t, i, r, o, a, s, n, l, c, h, u) {
                const d = this.projectAndGetPerspectiveRatio(e.anchorPointX + n[0], e.anchorPointY + n[1], o, c, u), _ = i * d.perspectiveRatio;
                let p;
                if (a || s) p = this._projectCollisionBox(e, _, r, o, a, s, n, d, c, h, u);
                else {
                    const t = d.x + (h ? h.x * _ : 0), i = d.y + (h ? h.y * _ : 0);
                    p = {
                        allPointsOccluded: !1,
                        box: [
                            t + e.x1 * _,
                            i + e.y1 * _,
                            t + e.x2 * _,
                            i + e.y2 * _
                        ]
                    };
                }
                const [m, f, g, v] = p.box, x = a ? p.allPointsOccluded : d.isOccluded;
                let b = x;
                return b || (b = d.perspectiveRatio < this.perspectiveRatioCutoff), b || (b = !this.isInsideGrid(m, f, g, v)), b || "always" !== t && this.grid.hitTest(m, f, g, v, t, l) ? {
                    box: [
                        m,
                        f,
                        g,
                        v
                    ],
                    placeable: !1,
                    offscreen: !1,
                    occluded: x
                } : {
                    box: [
                        m,
                        f,
                        g,
                        v
                    ],
                    placeable: !0,
                    offscreen: this.isOffscreen(m, f, g, v),
                    occluded: x
                };
            }
            placeCollisionCircles(e, i, r, o, a, s, n, l, c, h, u, d, _, p) {
                const m = [], f = new t.P(i.anchorX, i.anchorY), g = this.getPerspectiveRatio(f.x, f.y, s, p), v = (c ? a * this.transform.getPitchedTextCorrection(i.anchorX, i.anchorY, s) / g : a * g) / t.av, x = {
                    getElevation: p,
                    pitchedLabelPlaneMatrix: n,
                    lineVertexArray: r,
                    pitchWithMap: c,
                    projectionCache: {
                        projections: {},
                        offsets: {},
                        cachedAnchorPoint: void 0,
                        anyProjectionOccluded: !1
                    },
                    transform: this.transform,
                    tileAnchorPoint: f,
                    unwrappedTileID: s,
                    width: this.transform.width,
                    height: this.transform.height,
                    translation: _
                }, b = Ce(v, o, i.lineOffsetX * v, i.lineOffsetY * v, !1, i, !1, x);
                let y = !1, w = !1, T = !0;
                if (b) {
                    const i = .5 * u * g + d, r = new t.P(-100, -100), o = new t.P(this.screenRightBoundary, this.screenBottomBoundary), a = new me, s = b.first, n = b.last;
                    let _ = [];
                    for(let e = s.path.length - 1; e >= 1; e--)_.push(s.path[e]);
                    for(let e = 1; e < n.path.length; e++)_.push(n.path[e]);
                    const p = 2.5 * i;
                    if (c) {
                        const e = this.projectPathToScreenSpace(_, x);
                        _ = e.some((e)=>e.signedDistanceFromCamera <= 0) ? [] : e.map((e)=>e.point);
                    }
                    let f = [];
                    if (_.length > 0) {
                        const e = _[0].clone(), i = _[0].clone();
                        for(let t = 1; t < _.length; t++)e.x = Math.min(e.x, _[t].x), e.y = Math.min(e.y, _[t].y), i.x = Math.max(i.x, _[t].x), i.y = Math.max(i.y, _[t].y);
                        f = e.x >= r.x && i.x <= o.x && e.y >= r.y && i.y <= o.y ? [
                            _
                        ] : i.x < r.x || e.x > o.x || i.y < r.y || e.y > o.y ? [] : t.ar([
                            _
                        ], r.x, r.y, o.x, o.y);
                    }
                    for (const t of f){
                        a.reset(t, .25 * i);
                        let r = 0;
                        r = a.length <= .5 * i ? 1 : Math.ceil(a.paddedLength / p) + 1;
                        for(let t = 0; t < r; t++){
                            const o = t / Math.max(r - 1, 1), s = a.lerp(o), n = s.x + je, c = s.y + je;
                            m.push(n, c, i, 0);
                            const u = n - i, d = c - i, _ = n + i, p = c + i;
                            if (T = T && this.isOffscreen(u, d, _, p), w = w || this.isInsideGrid(u, d, _, p), "always" !== e && this.grid.hitTestCircle(n, c, i, e, h) && (y = !0, !l)) return {
                                circles: [],
                                offscreen: !1,
                                collisionDetected: y
                            };
                        }
                    }
                }
                return {
                    circles: !l && y || !w || g < this.perspectiveRatioCutoff ? [] : m,
                    offscreen: T,
                    collisionDetected: y
                };
            }
            projectPathToScreenSpace(e, i) {
                const r = function(e, i) {
                    const r = t.K();
                    return t.aj(r, i.pitchedLabelPlaneMatrix), e.map((e)=>{
                        const t = ye(e.x, e.y, r, i.getElevation), o = i.transform.projectTileCoordinates(t.point.x, t.point.y, i.unwrappedTileID, i.getElevation);
                        return o.point.x = (.5 * o.point.x + .5) * i.width, o.point.y = (.5 * -o.point.y + .5) * i.height, o;
                    });
                }(e, i);
                return function(e) {
                    let t = 0, i = 0, r = 0, o = 0;
                    for(let a = 0; a < e.length; a++)e[a].isOccluded ? (r = a + 1, o = 0) : (o++, o > i && (i = o, t = r));
                    return e.slice(t, t + i);
                }(r);
            }
            queryRenderedSymbols(e) {
                if (0 === e.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                const i = [];
                let r = 1 / 0, o = 1 / 0, a = -1 / 0, s = -1 / 0;
                for (const n of e){
                    const e = new t.P(n.x + je, n.y + je);
                    r = Math.min(r, e.x), o = Math.min(o, e.y), a = Math.max(a, e.x), s = Math.max(s, e.y), i.push(e);
                }
                const n = this.grid.query(r, o, a, s).concat(this.ignoredGrid.query(r, o, a, s)), l = {}, c = {};
                for (const e of n){
                    const r = e.key;
                    if (void 0 === l[r.bucketInstanceId] && (l[r.bucketInstanceId] = {}), l[r.bucketInstanceId][r.featureIndex]) continue;
                    const o = [
                        new t.P(e.x1, e.y1),
                        new t.P(e.x2, e.y1),
                        new t.P(e.x2, e.y2),
                        new t.P(e.x1, e.y2)
                    ];
                    t.as(i, o) && (l[r.bucketInstanceId][r.featureIndex] = !0, void 0 === c[r.bucketInstanceId] && (c[r.bucketInstanceId] = []), c[r.bucketInstanceId].push(r.featureIndex));
                }
                return c;
            }
            insertCollisionBox(e, t, i, r, o, a) {
                (i ? this.ignoredGrid : this.grid).insert({
                    bucketInstanceId: r,
                    featureIndex: o,
                    collisionGroupID: a,
                    overlapMode: t
                }, e[0], e[1], e[2], e[3]);
            }
            insertCollisionCircles(e, t, i, r, o, a) {
                const s = i ? this.ignoredGrid : this.grid, n = {
                    bucketInstanceId: r,
                    featureIndex: o,
                    collisionGroupID: a,
                    overlapMode: t
                };
                for(let t = 0; t < e.length; t += 4)s.insertCircle(n, e[t], e[t + 1], e[t + 2]);
            }
            projectAndGetPerspectiveRatio(e, i, r, o, a) {
                if (a) {
                    let r;
                    o ? (r = [
                        e,
                        i,
                        o(e, i),
                        1
                    ], t.ap(r, r, a)) : (r = [
                        e,
                        i,
                        0,
                        1
                    ], Oe(r, r, a));
                    const s = r[3];
                    return {
                        x: (r[0] / s + 1) / 2 * this.transform.width + je,
                        y: (-r[1] / s + 1) / 2 * this.transform.height + je,
                        perspectiveRatio: .5 + this.transform.cameraToCenterDistance / s * .5,
                        isOccluded: !1,
                        signedDistanceFromCamera: s
                    };
                }
                {
                    const t = this.transform.projectTileCoordinates(e, i, r, o);
                    return {
                        x: (t.point.x + 1) / 2 * this.transform.width + je,
                        y: (1 - t.point.y) / 2 * this.transform.height + je,
                        perspectiveRatio: .5 + this.transform.cameraToCenterDistance / t.signedDistanceFromCamera * .5,
                        isOccluded: t.isOccluded,
                        signedDistanceFromCamera: t.signedDistanceFromCamera
                    };
                }
            }
            getPerspectiveRatio(e, t, i, r) {
                const o = this.transform.projectTileCoordinates(e, t, i, r);
                return .5 + this.transform.cameraToCenterDistance / o.signedDistanceFromCamera * .5;
            }
            isOffscreen(e, t, i, r) {
                return i < je || e >= this.screenRightBoundary || r < je || t > this.screenBottomBoundary;
            }
            isInsideGrid(e, t, i, r) {
                return i >= 0 && e < this.gridRightBoundary && r >= 0 && t < this.gridBottomBoundary;
            }
            getViewportMatrix() {
                const e = t.at([]);
                return t.L(e, e, [
                    -100,
                    -100,
                    0
                ]), e;
            }
            _projectCollisionBox(e, i, r, o, a, s, n, l, c, h, u) {
                let d = 1, _ = 0, p = 0, m = 1;
                const f = e.anchorPointX + n[0], g = e.anchorPointY + n[1];
                if (s && !a) {
                    const e = this.projectAndGetPerspectiveRatio(f + 1, g, o, c, u), t = e.x - l.x, i = Math.atan((e.y - l.y) / t) + (t < 0 ? Math.PI : 0), r = Math.sin(i), a = Math.cos(i);
                    d = a, _ = r, p = -r, m = a;
                } else if (!s && a) {
                    const e = be(this.transform);
                    d = e.vecEast[0], _ = e.vecEast[1], p = e.vecSouth[0], m = e.vecSouth[1];
                }
                let v = l.x, x = l.y, b = i;
                a && (v = f, x = g, b = Math.pow(2, -(this.transform.zoom - r.overscaledZ)), b *= this.transform.getPitchedTextCorrection(f, g, o), h || (b *= t.ae(.5 + l.signedDistanceFromCamera / this.transform.cameraToCenterDistance * .5, 0, 4))), h && (v += d * h.x * b + p * h.y * b, x += _ * h.x * b + m * h.y * b);
                const y = e.x1 * b, w = e.x2 * b, T = (y + w) / 2, P = e.y1 * b, C = e.y2 * b, I = (P + C) / 2, M = [
                    {
                        offsetX: y,
                        offsetY: P
                    },
                    {
                        offsetX: T,
                        offsetY: P
                    },
                    {
                        offsetX: w,
                        offsetY: P
                    },
                    {
                        offsetX: w,
                        offsetY: I
                    },
                    {
                        offsetX: w,
                        offsetY: C
                    },
                    {
                        offsetX: T,
                        offsetY: C
                    },
                    {
                        offsetX: y,
                        offsetY: C
                    },
                    {
                        offsetX: y,
                        offsetY: I
                    }
                ];
                let E = [];
                for (const { offsetX: e, offsetY: i } of M)E.push(new t.P(v + d * e + p * i, x + _ * e + m * i));
                let S = !1;
                if (a) {
                    const e = E.map((e)=>this.projectAndGetPerspectiveRatio(e.x, e.y, o, c, u));
                    S = e.some((e)=>!e.isOccluded), E = e.map((e)=>new t.P(e.x, e.y));
                } else S = !0;
                return {
                    box: t.au(E),
                    allPointsOccluded: !S
                };
            }
        }
        class Ne {
            constructor(e, t, i, r){
                this.opacity = e ? Math.max(0, Math.min(1, e.opacity + (e.placed ? t : -t))) : r && i ? 1 : 0, this.placed = i;
            }
            isHidden() {
                return 0 === this.opacity && !this.placed;
            }
        }
        class Ge {
            constructor(e, t, i, r, o){
                this.text = new Ne(e ? e.text : null, t, i, o), this.icon = new Ne(e ? e.icon : null, t, r, o);
            }
            isHidden() {
                return this.text.isHidden() && this.icon.isHidden();
            }
        }
        class Ue {
            constructor(e, t, i){
                this.text = e, this.icon = t, this.skipFade = i;
            }
        }
        class Ve {
            constructor(e, t, i, r, o){
                this.bucketInstanceId = e, this.featureIndex = t, this.sourceLayerIndex = i, this.bucketIndex = r, this.tileID = o;
            }
        }
        class qe {
            constructor(e){
                this.crossSourceCollisions = e, this.maxGroupID = 0, this.collisionGroups = {};
            }
            get(e) {
                if (this.crossSourceCollisions) return {
                    ID: 0,
                    predicate: null
                };
                if (!this.collisionGroups[e]) {
                    const t = ++this.maxGroupID;
                    this.collisionGroups[e] = {
                        ID: t,
                        predicate: (e)=>e.collisionGroupID === t
                    };
                }
                return this.collisionGroups[e];
            }
        }
        function We(e, i, r, o, a) {
            const { horizontalAlign: s, verticalAlign: n } = t.aB(e);
            return new t.P(-(s - .5) * i + o[0] * a, -(n - .5) * r + o[1] * a);
        }
        class $e {
            constructor(e, t, i, r, o){
                this.transform = e.clone(), this.terrain = t, this.collisionIndex = new Ze(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = i, this.retainedQueryData = {}, this.collisionGroups = new qe(r), this.collisionCircleArrays = {}, this.collisionBoxArrays = new Map, this.prevPlacement = o, o && (o.prevPlacement = void 0), this.placedOrientations = {};
            }
            _getTerrainElevationFunc(e) {
                const t = this.terrain;
                return t ? (i, r)=>t.getElevation(e, i, r) : null;
            }
            getBucketParts(e, i, r, o) {
                const a = r.getBucket(i), s = r.latestFeatureIndex;
                if (!a || !s || i.id !== a.layerIds[0]) return;
                const n = r.collisionBoxArray, l = a.layers[0].layout, c = a.layers[0].paint, h = Math.pow(2, this.transform.zoom - r.tileID.overscaledZ), u = r.tileSize / t.Z, d = r.tileID.toUnwrapped(), _ = "map" === l.get("text-rotation-alignment"), p = t.aw(r, 1, this.transform.zoom), m = t.ax(this.collisionIndex.transform, r, c.get("text-translate"), c.get("text-translate-anchor")), f = t.ax(this.collisionIndex.transform, r, c.get("icon-translate"), c.get("icon-translate-anchor")), g = ve(_, this.transform, p);
                this.retainedQueryData[a.bucketInstanceId] = new Ve(a.bucketInstanceId, s, a.sourceLayerIndex, a.index, r.tileID);
                const v = {
                    bucket: a,
                    layout: l,
                    translationText: m,
                    translationIcon: f,
                    unwrappedTileID: d,
                    pitchedLabelPlaneMatrix: g,
                    scale: h,
                    textPixelRatio: u,
                    holdingForFade: r.holdingForFade(),
                    collisionBoxArray: n,
                    partiallyEvaluatedTextSize: t.ag(a.textSizeData, this.transform.zoom),
                    collisionGroup: this.collisionGroups.get(a.sourceID)
                };
                if (o) for (const t of a.sortKeyRanges){
                    const { sortKey: i, symbolInstanceStart: r, symbolInstanceEnd: o } = t;
                    e.push({
                        sortKey: i,
                        symbolInstanceStart: r,
                        symbolInstanceEnd: o,
                        parameters: v
                    });
                }
                else e.push({
                    symbolInstanceStart: 0,
                    symbolInstanceEnd: a.symbolInstances.length,
                    parameters: v
                });
            }
            attemptAnchorPlacement(e, i, r, o, a, s, n, l, c, h, u, d, _, p, m, f, g, v, x, b) {
                const y = t.ay[e.textAnchor], w = [
                    e.textOffset0,
                    e.textOffset1
                ], T = We(y, r, o, w, a), P = this.collisionIndex.placeCollisionBox(i, d, l, c, h, n, s, f, u.predicate, x, T, b);
                if ((!v || this.collisionIndex.placeCollisionBox(v, d, l, c, h, n, s, g, u.predicate, x, T, b).placeable) && P.placeable) {
                    let e;
                    if (this.prevPlacement && this.prevPlacement.variableOffsets[_.crossTileID] && this.prevPlacement.placements[_.crossTileID] && this.prevPlacement.placements[_.crossTileID].text && (e = this.prevPlacement.variableOffsets[_.crossTileID].anchor), 0 === _.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                    return this.variableOffsets[_.crossTileID] = {
                        textOffset: w,
                        width: r,
                        height: o,
                        anchor: y,
                        textBoxScale: a,
                        prevAnchor: e
                    }, this.markUsedJustification(p, y, _, m), p.allowVerticalPlacement && (this.markUsedOrientation(p, m, _), this.placedOrientations[_.crossTileID] = m), {
                        shift: T,
                        placedGlyphBoxes: P
                    };
                }
            }
            placeLayerBucketPart(e, i, r) {
                const { bucket: o, layout: a, translationText: s, translationIcon: n, unwrappedTileID: l, pitchedLabelPlaneMatrix: c, textPixelRatio: h, holdingForFade: u, collisionBoxArray: d, partiallyEvaluatedTextSize: _, collisionGroup: p } = e.parameters, m = a.get("text-optional"), f = a.get("icon-optional"), g = t.az(a, "text-overlap", "text-allow-overlap"), v = "always" === g, x = t.az(a, "icon-overlap", "icon-allow-overlap"), b = "always" === x, y = "map" === a.get("text-rotation-alignment"), w = "map" === a.get("text-pitch-alignment"), T = "none" !== a.get("icon-text-fit"), P = "viewport-y" === a.get("symbol-z-order"), C = v && (b || !o.hasIconData() || f), I = b && (v || !o.hasTextData() || m);
                !o.collisionArrays && d && o.deserializeCollisionBoxes(d);
                const M = this.retainedQueryData[o.bucketInstanceId].tileID, E = this._getTerrainElevationFunc(M), S = this.transform.getFastPathSimpleProjectionMatrix(M), R = (e, d, b)=>{
                    var P, R;
                    if (i[e.crossTileID]) return;
                    if (u) return void (this.placements[e.crossTileID] = new Ue(!1, !1, !1));
                    let D = !1, z = !1, A = !0, L = null, k = {
                        box: null,
                        placeable: !1,
                        offscreen: null,
                        occluded: !1
                    }, F = {
                        placeable: !1
                    }, B = null, O = null, j = null, Z = 0, N = 0, G = 0;
                    d.textFeatureIndex ? Z = d.textFeatureIndex : e.useRuntimeCollisionCircles && (Z = e.featureIndex), d.verticalTextFeatureIndex && (N = d.verticalTextFeatureIndex);
                    const U = d.textBox;
                    if (U) {
                        const i = (i)=>{
                            let r = t.ah.horizontal;
                            if (o.allowVerticalPlacement && !i && this.prevPlacement) {
                                const t = this.prevPlacement.placedOrientations[e.crossTileID];
                                t && (this.placedOrientations[e.crossTileID] = t, r = t, this.markUsedOrientation(o, r, e));
                            }
                            return r;
                        }, a = (i, r)=>{
                            if (o.allowVerticalPlacement && e.numVerticalGlyphVertices > 0 && d.verticalTextBox) {
                                for (const e of o.writingModes)if (e === t.ah.vertical ? (k = r(), F = k) : k = i(), k && k.placeable) break;
                            } else k = i();
                        }, c = e.textAnchorOffsetStartIndex, u = e.textAnchorOffsetEndIndex;
                        if (u === c) {
                            const r = (t, i)=>{
                                const r = this.collisionIndex.placeCollisionBox(t, g, h, M, l, w, y, s, p.predicate, E, void 0, S);
                                return r && r.placeable && (this.markUsedOrientation(o, i, e), this.placedOrientations[e.crossTileID] = i), r;
                            };
                            a(()=>r(U, t.ah.horizontal), ()=>{
                                const i = d.verticalTextBox;
                                return o.allowVerticalPlacement && e.numVerticalGlyphVertices > 0 && i ? r(i, t.ah.vertical) : {
                                    box: null,
                                    offscreen: null
                                };
                            }), i(k && k.placeable);
                        } else {
                            let _ = t.ay[null === (R = null === (P = this.prevPlacement) || void 0 === P ? void 0 : P.variableOffsets[e.crossTileID]) || void 0 === R ? void 0 : R.anchor];
                            const m = (t, i, a)=>{
                                const d = t.x2 - t.x1, m = t.y2 - t.y1, f = e.textBoxScale, v = T && "never" === x ? i : null;
                                let b = null, P = "never" === g ? 1 : 2, C = "never";
                                _ && P++;
                                for(let i = 0; i < P; i++){
                                    for(let i = c; i < u; i++){
                                        const r = o.textAnchorOffsets.get(i);
                                        if (_ && r.textAnchor !== _) continue;
                                        const c = this.attemptAnchorPlacement(r, t, d, m, f, y, w, h, M, l, p, C, e, o, a, s, n, v, E);
                                        if (c && (b = c.placedGlyphBoxes, b && b.placeable)) return D = !0, L = c.shift, b;
                                    }
                                    _ ? _ = null : C = g;
                                }
                                return r && !b && (b = {
                                    box: this.collisionIndex.placeCollisionBox(U, "always", h, M, l, w, y, s, p.predicate, E, void 0, S).box,
                                    offscreen: !1,
                                    placeable: !1,
                                    occluded: !1
                                }), b;
                            };
                            a(()=>m(U, d.iconBox, t.ah.horizontal), ()=>{
                                const i = d.verticalTextBox;
                                return o.allowVerticalPlacement && (!k || !k.placeable) && e.numVerticalGlyphVertices > 0 && i ? m(i, d.verticalIconBox, t.ah.vertical) : {
                                    box: null,
                                    occluded: !0,
                                    offscreen: null
                                };
                            }), k && (D = k.placeable, A = k.offscreen);
                            const f = i(k && k.placeable);
                            if (!D && this.prevPlacement) {
                                const t = this.prevPlacement.variableOffsets[e.crossTileID];
                                t && (this.variableOffsets[e.crossTileID] = t, this.markUsedJustification(o, t.anchor, e, f));
                            }
                        }
                    }
                    if (B = k, D = B && B.placeable, A = B && B.offscreen, e.useRuntimeCollisionCircles) {
                        const i = o.text.placedSymbolArray.get(e.centerJustifiedTextSymbolIndex), n = t.ai(o.textSizeData, _, i), h = a.get("text-padding");
                        O = this.collisionIndex.placeCollisionCircles(g, i, o.lineVertexArray, o.glyphOffsetArray, n, l, c, r, w, p.predicate, e.collisionCircleDiameter, h, s, E), O.circles.length && O.collisionDetected && !r && t.w("Collisions detected, but collision boxes are not shown"), D = v || O.circles.length > 0 && !O.collisionDetected, A = A && O.offscreen;
                    }
                    if (d.iconFeatureIndex && (G = d.iconFeatureIndex), d.iconBox) {
                        const e = (e)=>this.collisionIndex.placeCollisionBox(e, x, h, M, l, w, y, n, p.predicate, E, T && L ? L : void 0, S);
                        F && F.placeable && d.verticalIconBox ? (j = e(d.verticalIconBox), z = j.placeable) : (j = e(d.iconBox), z = j.placeable), A = A && j.offscreen;
                    }
                    const V = m || 0 === e.numHorizontalGlyphVertices && 0 === e.numVerticalGlyphVertices, q = f || 0 === e.numIconVertices;
                    V || q ? q ? V || (z = z && D) : D = z && D : z = D = z && D;
                    const W = z && j.placeable;
                    if (D && B.placeable && this.collisionIndex.insertCollisionBox(B.box, g, a.get("text-ignore-placement"), o.bucketInstanceId, F && F.placeable && N ? N : Z, p.ID), W && this.collisionIndex.insertCollisionBox(j.box, x, a.get("icon-ignore-placement"), o.bucketInstanceId, G, p.ID), O && D && this.collisionIndex.insertCollisionCircles(O.circles, g, a.get("text-ignore-placement"), o.bucketInstanceId, Z, p.ID), r && this.storeCollisionData(o.bucketInstanceId, b, d, B, j, O), 0 === e.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                    if (0 === o.bucketInstanceId) throw new Error("bucket.bucketInstanceId can't be 0");
                    this.placements[e.crossTileID] = new Ue((D || C) && !(null == B ? void 0 : B.occluded), (z || I) && !(null == j ? void 0 : j.occluded), A || o.justReloaded), i[e.crossTileID] = !0;
                };
                if (P) {
                    if (0 !== e.symbolInstanceStart) throw new Error("bucket.bucketInstanceId should be 0");
                    const t = o.getSortedSymbolIndexes(-this.transform.bearingInRadians);
                    for(let e = t.length - 1; e >= 0; --e){
                        const i = t[e];
                        R(o.symbolInstances.get(i), o.collisionArrays[i], i);
                    }
                } else for(let t = e.symbolInstanceStart; t < e.symbolInstanceEnd; t++)R(o.symbolInstances.get(t), o.collisionArrays[t], t);
                o.justReloaded = !1;
            }
            storeCollisionData(e, t, i, r, o, a) {
                if (i.textBox || i.iconBox) {
                    let a, s;
                    this.collisionBoxArrays.has(e) ? a = this.collisionBoxArrays.get(e) : (a = new Map, this.collisionBoxArrays.set(e, a)), a.has(t) ? s = a.get(t) : (s = {
                        text: null,
                        icon: null
                    }, a.set(t, s)), i.textBox && (s.text = r.box), i.iconBox && (s.icon = o.box);
                }
                if (a) {
                    let t = this.collisionCircleArrays[e];
                    void 0 === t && (t = this.collisionCircleArrays[e] = []);
                    for(let e = 0; e < a.circles.length; e += 4)t.push(a.circles[e + 0] - je), t.push(a.circles[e + 1] - je), t.push(a.circles[e + 2]), t.push(a.collisionDetected ? 1 : 0);
                }
            }
            markUsedJustification(e, i, r, o) {
                let a;
                a = o === t.ah.vertical ? r.verticalPlacedTextSymbolIndex : ({
                    left: r.leftJustifiedTextSymbolIndex,
                    center: r.centerJustifiedTextSymbolIndex,
                    right: r.rightJustifiedTextSymbolIndex
                })[t.aA(i)];
                const s = [
                    r.leftJustifiedTextSymbolIndex,
                    r.centerJustifiedTextSymbolIndex,
                    r.rightJustifiedTextSymbolIndex,
                    r.verticalPlacedTextSymbolIndex
                ];
                for (const t of s)t >= 0 && (e.text.placedSymbolArray.get(t).crossTileID = a >= 0 && t !== a ? 0 : r.crossTileID);
            }
            markUsedOrientation(e, i, r) {
                const o = i === t.ah.horizontal || i === t.ah.horizontalOnly ? i : 0, a = i === t.ah.vertical ? i : 0, s = [
                    r.leftJustifiedTextSymbolIndex,
                    r.centerJustifiedTextSymbolIndex,
                    r.rightJustifiedTextSymbolIndex
                ];
                for (const t of s)e.text.placedSymbolArray.get(t).placedOrientation = o;
                r.verticalPlacedTextSymbolIndex && (e.text.placedSymbolArray.get(r.verticalPlacedTextSymbolIndex).placedOrientation = a);
            }
            commit(e) {
                this.commitTime = e, this.zoomAtLastRecencyCheck = this.transform.zoom;
                const t = this.prevPlacement;
                let i = !1;
                this.prevZoomAdjustment = t ? t.zoomAdjustment(this.transform.zoom) : 0;
                const r = t ? t.symbolFadeChange(e) : 1, o = t ? t.opacities : {}, a = t ? t.variableOffsets : {}, s = t ? t.placedOrientations : {};
                for(const e in this.placements){
                    const t = this.placements[e], a = o[e];
                    a ? (this.opacities[e] = new Ge(a, r, t.text, t.icon), i = i || t.text !== a.text.placed || t.icon !== a.icon.placed) : (this.opacities[e] = new Ge(null, r, t.text, t.icon, t.skipFade), i = i || t.text || t.icon);
                }
                for(const e in o){
                    const t = o[e];
                    if (!this.opacities[e]) {
                        const o = new Ge(t, r, !1, !1);
                        o.isHidden() || (this.opacities[e] = o, i = i || t.text.placed || t.icon.placed);
                    }
                }
                for(const e in a)this.variableOffsets[e] || !this.opacities[e] || this.opacities[e].isHidden() || (this.variableOffsets[e] = a[e]);
                for(const e in s)this.placedOrientations[e] || !this.opacities[e] || this.opacities[e].isHidden() || (this.placedOrientations[e] = s[e]);
                if (t && void 0 === t.lastPlacementChangeTime) throw new Error("Last placement time for previous placement is not defined");
                i ? this.lastPlacementChangeTime = e : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = t ? t.lastPlacementChangeTime : e);
            }
            updateLayerOpacities(e, t) {
                const i = {};
                for (const r of t){
                    const t = r.getBucket(e);
                    t && r.latestFeatureIndex && e.id === t.layerIds[0] && this.updateBucketOpacities(t, r.tileID, i, r.collisionBoxArray);
                }
            }
            updateBucketOpacities(e, i, r, o) {
                e.hasTextData() && (e.text.opacityVertexArray.clear(), e.text.hasVisibleVertices = !1), e.hasIconData() && (e.icon.opacityVertexArray.clear(), e.icon.hasVisibleVertices = !1), e.hasIconCollisionBoxData() && e.iconCollisionBox.collisionVertexArray.clear(), e.hasTextCollisionBoxData() && e.textCollisionBox.collisionVertexArray.clear();
                const a = e.layers[0], s = a.layout, n = new Ge(null, 0, !1, !1, !0), l = s.get("text-allow-overlap"), c = s.get("icon-allow-overlap"), h = a._unevaluatedLayout.hasValue("text-variable-anchor") || a._unevaluatedLayout.hasValue("text-variable-anchor-offset"), u = "map" === s.get("text-rotation-alignment"), d = "map" === s.get("text-pitch-alignment"), _ = "none" !== s.get("icon-text-fit"), p = new Ge(null, 0, l && (c || !e.hasIconData() || s.get("icon-optional")), c && (l || !e.hasTextData() || s.get("text-optional")), !0);
                !e.collisionArrays && o && (e.hasIconCollisionBoxData() || e.hasTextCollisionBoxData()) && e.deserializeCollisionBoxes(o);
                const m = (e, t, i)=>{
                    for(let r = 0; r < t / 4; r++)e.opacityVertexArray.emplaceBack(i);
                    e.hasVisibleVertices = e.hasVisibleVertices || i !== rt;
                }, f = this.collisionBoxArrays.get(e.bucketInstanceId);
                for(let i = 0; i < e.symbolInstances.length; i++){
                    const o = e.symbolInstances.get(i), { numHorizontalGlyphVertices: a, numVerticalGlyphVertices: s, crossTileID: l } = o;
                    let c = this.opacities[l];
                    r[l] ? c = n : c || (c = p, this.opacities[l] = c), r[l] = !0;
                    const g = o.numIconVertices > 0, v = this.placedOrientations[o.crossTileID], x = v === t.ah.vertical, b = v === t.ah.horizontal || v === t.ah.horizontalOnly;
                    if (a > 0 || s > 0) {
                        const t = it(c.text);
                        m(e.text, a, x ? rt : t), m(e.text, s, b ? rt : t);
                        const i = c.text.isHidden();
                        [
                            o.rightJustifiedTextSymbolIndex,
                            o.centerJustifiedTextSymbolIndex,
                            o.leftJustifiedTextSymbolIndex
                        ].forEach((t)=>{
                            t >= 0 && (e.text.placedSymbolArray.get(t).hidden = i || x ? 1 : 0);
                        }), o.verticalPlacedTextSymbolIndex >= 0 && (e.text.placedSymbolArray.get(o.verticalPlacedTextSymbolIndex).hidden = i || b ? 1 : 0);
                        const r = this.variableOffsets[o.crossTileID];
                        r && this.markUsedJustification(e, r.anchor, o, v);
                        const n = this.placedOrientations[o.crossTileID];
                        n && (this.markUsedJustification(e, "left", o, n), this.markUsedOrientation(e, n, o));
                    }
                    if (g) {
                        const t = it(c.icon), i = !(_ && o.verticalPlacedIconSymbolIndex && x);
                        o.placedIconSymbolIndex >= 0 && (m(e.icon, o.numIconVertices, i ? t : rt), e.icon.placedSymbolArray.get(o.placedIconSymbolIndex).hidden = c.icon.isHidden()), o.verticalPlacedIconSymbolIndex >= 0 && (m(e.icon, o.numVerticalIconVertices, i ? rt : t), e.icon.placedSymbolArray.get(o.verticalPlacedIconSymbolIndex).hidden = c.icon.isHidden());
                    }
                    const y = f && f.has(i) ? f.get(i) : {
                        text: null,
                        icon: null
                    };
                    if (e.hasIconCollisionBoxData() || e.hasTextCollisionBoxData()) {
                        const r = e.collisionArrays[i];
                        if (r) {
                            let i = new t.P(0, 0);
                            if (r.textBox || r.verticalTextBox) {
                                let t = !0;
                                if (h) {
                                    const e = this.variableOffsets[l];
                                    e ? (i = We(e.anchor, e.width, e.height, e.textOffset, e.textBoxScale), u && i._rotate(d ? -this.transform.bearingInRadians : this.transform.bearingInRadians)) : t = !1;
                                }
                                if (r.textBox || r.verticalTextBox) {
                                    let o;
                                    r.textBox && (o = x), r.verticalTextBox && (o = b), He(e.textCollisionBox.collisionVertexArray, c.text.placed, !t || o, y.text, i.x, i.y);
                                }
                            }
                            if (r.iconBox || r.verticalIconBox) {
                                const t = Boolean(!b && r.verticalIconBox);
                                let o;
                                r.iconBox && (o = t), r.verticalIconBox && (o = !t), He(e.iconCollisionBox.collisionVertexArray, c.icon.placed, o, y.icon, _ ? i.x : 0, _ ? i.y : 0);
                            }
                        }
                    }
                }
                if (e.sortFeatures(-this.transform.bearingInRadians), this.retainedQueryData[e.bucketInstanceId] && (this.retainedQueryData[e.bucketInstanceId].featureSortOrder = e.featureSortOrder), e.hasTextData() && e.text.opacityVertexBuffer && e.text.opacityVertexBuffer.updateData(e.text.opacityVertexArray), e.hasIconData() && e.icon.opacityVertexBuffer && e.icon.opacityVertexBuffer.updateData(e.icon.opacityVertexArray), e.hasIconCollisionBoxData() && e.iconCollisionBox.collisionVertexBuffer && e.iconCollisionBox.collisionVertexBuffer.updateData(e.iconCollisionBox.collisionVertexArray), e.hasTextCollisionBoxData() && e.textCollisionBox.collisionVertexBuffer && e.textCollisionBox.collisionVertexBuffer.updateData(e.textCollisionBox.collisionVertexArray), e.text.opacityVertexArray.length !== e.text.layoutVertexArray.length / 4) throw new Error(`bucket.text.opacityVertexArray.length (= ${e.text.opacityVertexArray.length}) !== bucket.text.layoutVertexArray.length (= ${e.text.layoutVertexArray.length}) / 4`);
                if (e.icon.opacityVertexArray.length !== e.icon.layoutVertexArray.length / 4) throw new Error(`bucket.icon.opacityVertexArray.length (= ${e.icon.opacityVertexArray.length}) !== bucket.icon.layoutVertexArray.length (= ${e.icon.layoutVertexArray.length}) / 4`);
                e.bucketInstanceId in this.collisionCircleArrays && (e.collisionCircleArray = this.collisionCircleArrays[e.bucketInstanceId], delete this.collisionCircleArrays[e.bucketInstanceId]);
            }
            symbolFadeChange(e) {
                return 0 === this.fadeDuration ? 1 : (e - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
            }
            zoomAdjustment(e) {
                return Math.max(0, (this.transform.zoom - e) / 1.5);
            }
            hasTransitions(e) {
                return this.stale || e - this.lastPlacementChangeTime < this.fadeDuration;
            }
            stillRecent(e, t) {
                const i = this.zoomAtLastRecencyCheck === t ? 1 - this.zoomAdjustment(t) : 1;
                return this.zoomAtLastRecencyCheck = t, this.commitTime + this.fadeDuration * i > e;
            }
            setStale() {
                this.stale = !0;
            }
        }
        function He(e, t, i, r, o, a) {
            r && 0 !== r.length || (r = [
                0,
                0,
                0,
                0
            ]);
            const s = r[0] - je, n = r[1] - je, l = r[2] - je, c = r[3] - je;
            e.emplaceBack(t ? 1 : 0, i ? 1 : 0, o || 0, a || 0, s, n), e.emplaceBack(t ? 1 : 0, i ? 1 : 0, o || 0, a || 0, l, n), e.emplaceBack(t ? 1 : 0, i ? 1 : 0, o || 0, a || 0, l, c), e.emplaceBack(t ? 1 : 0, i ? 1 : 0, o || 0, a || 0, s, c);
        }
        const Ke = Math.pow(2, 25), Xe = Math.pow(2, 24), Qe = Math.pow(2, 17), Ye = Math.pow(2, 16), Je = Math.pow(2, 9), et = Math.pow(2, 8), tt = Math.pow(2, 1);
        function it(e) {
            if (0 === e.opacity && !e.placed) return 0;
            if (1 === e.opacity && e.placed) return 4294967295;
            const t = e.placed ? 1 : 0, i = Math.floor(127 * e.opacity);
            return i * Ke + t * Xe + i * Qe + t * Ye + i * Je + t * et + i * tt + t;
        }
        const rt = 0;
        class ot {
            constructor(e){
                this._sortAcrossTiles = "viewport-y" !== e.layout.get("symbol-z-order") && !e.layout.get("symbol-sort-key").isConstant(), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
            }
            continuePlacement(e, t, i, r, o) {
                const a = this._bucketParts;
                for(; this._currentTileIndex < e.length;)if (t.getBucketParts(a, r, e[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, o()) return !0;
                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, a.sort((e, t)=>e.sortKey - t.sortKey)); this._currentPartIndex < a.length;)if (t.placeLayerBucketPart(a[this._currentPartIndex], this._seenCrossTileIDs, i), this._currentPartIndex++, o()) return !0;
                return !1;
            }
        }
        class at {
            constructor(e, t, i, r, o, a, s, n){
                this.placement = new $e(e, t, a, s, n), this._currentPlacementIndex = i.length - 1, this._forceFullPlacement = r, this._showCollisionBoxes = o, this._done = !1;
            }
            isDone() {
                return this._done;
            }
            continuePlacement(e, t, i) {
                const r = s.now(), o = ()=>!this._forceFullPlacement && s.now() - r > 2;
                for(; this._currentPlacementIndex >= 0;){
                    const r = t[e[this._currentPlacementIndex]], a = this.placement.collisionIndex.transform.zoom;
                    if ("symbol" === r.type && (!r.minzoom || r.minzoom <= a) && (!r.maxzoom || r.maxzoom > a)) {
                        if (this._inProgressLayer || (this._inProgressLayer = new ot(r)), this._inProgressLayer.continuePlacement(i[r.source], this.placement, this._showCollisionBoxes, r, o)) return;
                        delete this._inProgressLayer;
                    }
                    this._currentPlacementIndex--;
                }
                this._done = !0;
            }
            commit(e) {
                return this.placement.commit(e), this.placement;
            }
        }
        const st = 512 / t.Z / 2;
        class nt {
            constructor(e, i, r){
                this.tileID = e, this.bucketInstanceId = r, this._symbolsByKey = {};
                const o = new Map;
                for(let e = 0; e < i.length; e++){
                    const t = i.get(e), r = t.key, a = o.get(r);
                    a ? a.push(t) : o.set(r, [
                        t
                    ]);
                }
                for (const [e, i] of o){
                    const r = {
                        positions: i.map((e)=>({
                                x: Math.floor(e.anchorX * st),
                                y: Math.floor(e.anchorY * st)
                            })),
                        crossTileIDs: i.map((e)=>e.crossTileID)
                    };
                    if (r.positions.length > 128) {
                        const e = new t.aC(r.positions.length, 16, Uint16Array);
                        for (const { x: t, y: i } of r.positions)e.add(t, i);
                        e.finish(), delete r.positions, r.index = e;
                    }
                    this._symbolsByKey[e] = r;
                }
            }
            getScaledCoordinates(e, i) {
                const { x: r, y: o, z: a } = this.tileID.canonical, { x: s, y: n, z: l } = i.canonical, c = st / Math.pow(2, l - a), h = (n * t.Z + e.anchorY) * c, u = o * t.Z * st;
                return {
                    x: Math.floor((s * t.Z + e.anchorX) * c - r * t.Z * st),
                    y: Math.floor(h - u)
                };
            }
            findMatches(e, t, i) {
                const r = this.tileID.canonical.z < t.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - t.canonical.z);
                for(let o = 0; o < e.length; o++){
                    const a = e.get(o);
                    if (a.crossTileID) continue;
                    const s = this._symbolsByKey[a.key];
                    if (!s) continue;
                    const n = this.getScaledCoordinates(a, t);
                    if (s.index) {
                        const e = s.index.range(n.x - r, n.y - r, n.x + r, n.y + r).sort();
                        for (const t of e){
                            const e = s.crossTileIDs[t];
                            if (!i[e]) {
                                i[e] = !0, a.crossTileID = e;
                                break;
                            }
                        }
                    } else if (s.positions) for(let e = 0; e < s.positions.length; e++){
                        const t = s.positions[e], o = s.crossTileIDs[e];
                        if (Math.abs(t.x - n.x) <= r && Math.abs(t.y - n.y) <= r && !i[o]) {
                            i[o] = !0, a.crossTileID = o;
                            break;
                        }
                    }
                }
            }
            getCrossTileIDsLists() {
                return Object.values(this._symbolsByKey).map(({ crossTileIDs: e })=>e);
            }
        }
        class lt {
            constructor(){
                this.maxCrossTileID = 0;
            }
            generate() {
                return ++this.maxCrossTileID;
            }
        }
        class ct {
            constructor(){
                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
            }
            handleWrapJump(e) {
                const t = Math.round((e - this.lng) / 360);
                if (0 !== t) for(const e in this.indexes){
                    const i = this.indexes[e], r = {};
                    for(const e in i){
                        const o = i[e];
                        o.tileID = o.tileID.unwrapTo(o.tileID.wrap + t), r[o.tileID.key] = o;
                    }
                    this.indexes[e] = r;
                }
                this.lng = e;
            }
            addBucket(e, t, i) {
                if (this.indexes[e.overscaledZ] && this.indexes[e.overscaledZ][e.key]) {
                    if (this.indexes[e.overscaledZ][e.key].bucketInstanceId === t.bucketInstanceId) return !1;
                    this.removeBucketCrossTileIDs(e.overscaledZ, this.indexes[e.overscaledZ][e.key]);
                }
                for(let e = 0; e < t.symbolInstances.length; e++)t.symbolInstances.get(e).crossTileID = 0;
                this.usedCrossTileIDs[e.overscaledZ] || (this.usedCrossTileIDs[e.overscaledZ] = {});
                const r = this.usedCrossTileIDs[e.overscaledZ];
                for(const i in this.indexes){
                    const o = this.indexes[i];
                    if (Number(i) > e.overscaledZ) for(const i in o){
                        const a = o[i];
                        a.tileID.isChildOf(e) && a.findMatches(t.symbolInstances, e, r);
                    }
                    else {
                        const a = o[e.scaledTo(Number(i)).key];
                        a && a.findMatches(t.symbolInstances, e, r);
                    }
                }
                for(let e = 0; e < t.symbolInstances.length; e++){
                    const o = t.symbolInstances.get(e);
                    o.crossTileID || (o.crossTileID = i.generate(), r[o.crossTileID] = !0);
                }
                return void 0 === this.indexes[e.overscaledZ] && (this.indexes[e.overscaledZ] = {}), this.indexes[e.overscaledZ][e.key] = new nt(e, t.symbolInstances, t.bucketInstanceId), !0;
            }
            removeBucketCrossTileIDs(e, t) {
                for (const i of t.getCrossTileIDsLists())for (const t of i)delete this.usedCrossTileIDs[e][t];
            }
            removeStaleBuckets(e) {
                let t = !1;
                for(const i in this.indexes){
                    const r = this.indexes[i];
                    for(const o in r)e[r[o].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, r[o]), delete r[o], t = !0);
                }
                return t;
            }
        }
        class ht {
            constructor(){
                this.layerIndexes = {}, this.crossTileIDs = new lt, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
            }
            addLayer(e, t, i) {
                let r = this.layerIndexes[e.id];
                void 0 === r && (r = this.layerIndexes[e.id] = new ct);
                let o = !1;
                const a = {};
                r.handleWrapJump(i);
                for (const i of t){
                    const t = i.getBucket(e);
                    t && e.id === t.layerIds[0] && (t.bucketInstanceId || (t.bucketInstanceId = ++this.maxBucketInstanceId), r.addBucket(i.tileID, t, this.crossTileIDs) && (o = !0), a[t.bucketInstanceId] = !0);
                }
                return r.removeStaleBuckets(a) && (o = !0), o;
            }
            pruneUnusedLayers(e) {
                const t = {};
                e.forEach((e)=>{
                    t[e] = !0;
                });
                for(const e in this.layerIndexes)t[e] || delete this.layerIndexes[e];
            }
        }
        var ut = "void main() {fragColor=vec4(1.0);}";
        const dt = {
            prelude: _t("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nout highp vec4 fragColor;", "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}mat3 rotationMatrixFromAxisAngle(vec3 u,float angle) {float c=cos(angle);float s=sin(angle);float c2=1.0-c;return mat3(u.x*u.x*c2+      c,u.x*u.y*c2-u.z*s,u.x*u.z*c2+u.y*s,u.y*u.x*c2+u.z*s,u.y*u.y*c2+    c,u.y*u.z*c2-u.x*s,u.z*u.x*c2-u.y*s,u.z*u.y*c2+u.x*s,u.z*u.z*c2+    c\n);}\n#ifdef TERRAIN3D\nuniform sampler2D u_terrain;uniform float u_terrain_dim;uniform mat4 u_terrain_matrix;uniform vec4 u_terrain_unpack;uniform float u_terrain_exaggeration;uniform highp sampler2D u_depth;\n#endif\nconst highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitShifts=vec4(1.)/bitSh;highp float unpack(highp vec4 color) {return dot(color,bitShifts);}highp float depthOpacity(vec3 frag) {\n#ifdef TERRAIN3D\nhighp float d=unpack(texture(u_depth,frag.xy*0.5+0.5))+0.0001-frag.z;return 1.0-max(0.0,min(1.0,-d*500.0));\n#else\nreturn 1.0;\n#endif\n}float calculate_visibility(vec4 pos) {\n#ifdef TERRAIN3D\nvec3 frag=pos.xyz/pos.w;highp float d=depthOpacity(frag);if (d > 0.95) return 1.0;return (d+depthOpacity(frag+vec3(0.0,0.01,0.0)))/2.0;\n#else\nreturn 1.0;\n#endif\n}float ele(vec2 pos) {\n#ifdef TERRAIN3D\nvec4 rgb=(texture(u_terrain,pos)*255.0)*u_terrain_unpack;return rgb.r+rgb.g+rgb.b-u_terrain_unpack.a;\n#else\nreturn 0.0;\n#endif\n}float get_elevation(vec2 pos) {\n#ifdef TERRAIN3D\n#ifdef GLOBE\nif ((pos.y <-32767.5) || (pos.y > 32766.5)) {return 0.0;}\n#endif\nvec2 coord=(u_terrain_matrix*vec4(pos,0.0,1.0)).xy*u_terrain_dim+1.0;vec2 f=fract(coord);vec2 c=(floor(coord)+0.5)/(u_terrain_dim+2.0);float d=1.0/(u_terrain_dim+2.0);float tl=ele(c);float tr=ele(c+vec2(d,0.0));float bl=ele(c+vec2(0.0,d));float br=ele(c+vec2(d,d));float elevation=mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);return elevation*u_terrain_exaggeration;\n#else\nreturn 0.0;\n#endif\n}const float PI=3.141592653589793;uniform mat4 u_projection_matrix;"),
            projectionMercator: _t("", "float projectLineThickness(float tileY) {return 1.0;}float projectCircleRadius(float tileY) {return 1.0;}vec4 projectTile(vec2 p) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);return result;}vec4 projectTile(vec2 p,vec2 rawPos) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);if (rawPos.y <-32767.5 || rawPos.y > 32766.5) {result.z=-10000000.0;}return result;}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_projection_matrix*vec4(posInTile,elevation,1.0);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {return projectTileWithElevation(posInTile,elevation);}"),
            projectionGlobe: _t("", "#define GLOBE_RADIUS 6371008.8\nuniform highp vec4 u_projection_tile_mercator_coords;uniform highp vec4 u_projection_clipping_plane;uniform highp float u_projection_transition;uniform mat4 u_projection_fallback_matrix;vec3 globeRotateVector(vec3 vec,vec2 angles) {vec3 axisRight=vec3(vec.z,0.0,-vec.x);vec3 axisUp=cross(axisRight,vec);axisRight=normalize(axisRight);axisUp=normalize(axisUp);vec2 t=tan(angles);return normalize(vec+axisRight*t.x+axisUp*t.y);}mat3 globeGetRotationMatrix(vec3 spherePos) {vec3 axisRight=vec3(spherePos.z,0.0,-spherePos.x);vec3 axisDown=cross(axisRight,spherePos);axisRight=normalize(axisRight);axisDown=normalize(axisDown);return mat3(axisRight,axisDown,spherePos\n);}float circumferenceRatioAtTileY(float tileY) {float mercator_pos_y=u_projection_tile_mercator_coords.y+u_projection_tile_mercator_coords.w*tileY;float spherical_y=2.0*atan(exp(PI-(mercator_pos_y*PI*2.0)))-PI*0.5;return cos(spherical_y);}float projectLineThickness(float tileY) {float thickness=1.0/circumferenceRatioAtTileY(tileY); \nif (u_projection_transition < 0.999) {return mix(1.0,thickness,u_projection_transition);} else {return thickness;}}vec3 projectToSphere(vec2 translatedPos,vec2 rawPos) {vec2 mercator_pos=u_projection_tile_mercator_coords.xy+u_projection_tile_mercator_coords.zw*translatedPos;vec2 spherical;spherical.x=mercator_pos.x*PI*2.0+PI;spherical.y=2.0*atan(exp(PI-(mercator_pos.y*PI*2.0)))-PI*0.5;float len=cos(spherical.y);vec3 pos=vec3(sin(spherical.x)*len,sin(spherical.y),cos(spherical.x)*len\n);if (rawPos.y <-32767.5) {pos=vec3(0.0,1.0,0.0);}if (rawPos.y > 32766.5) {pos=vec3(0.0,-1.0,0.0);}return pos;}vec3 projectToSphere(vec2 posInTile) {return projectToSphere(posInTile,vec2(0.0,0.0));}float globeComputeClippingZ(vec3 spherePos) {return (1.0-(dot(spherePos,u_projection_clipping_plane.xyz)+u_projection_clipping_plane.w));}vec4 interpolateProjection(vec2 posInTile,vec3 spherePos,float elevation) {vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);globePosition.z=globeComputeClippingZ(elevatedPos)*globePosition.w;if (u_projection_transition > 0.999) {return globePosition;}vec4 flatPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);const float z_globeness_threshold=0.2;vec4 result=globePosition;result.z=mix(0.0,globePosition.z,clamp((u_projection_transition-z_globeness_threshold)/(1.0-z_globeness_threshold),0.0,1.0));result.xyw=mix(flatPosition.xyw,globePosition.xyw,u_projection_transition);if ((posInTile.y <-32767.5) || (posInTile.y > 32766.5)) {result=globePosition;const float poles_hidden_anim_percentage=0.02;result.z=mix(globePosition.z,100.0,pow(max((1.0-u_projection_transition)/poles_hidden_anim_percentage,0.0),8.0));}return result;}vec4 interpolateProjectionFor3D(vec2 posInTile,vec3 spherePos,float elevation) {vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);if (u_projection_transition > 0.999) {return globePosition;}vec4 fallbackPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);return mix(fallbackPosition,globePosition,u_projection_transition);}vec4 projectTile(vec2 posInTile) {return interpolateProjection(posInTile,projectToSphere(posInTile),0.0);}vec4 projectTile(vec2 posInTile,vec2 rawPos) {return interpolateProjection(posInTile,projectToSphere(posInTile,rawPos),0.0);}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return interpolateProjection(posInTile,projectToSphere(posInTile),elevation);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {vec3 spherePos=projectToSphere(posInTile,posInTile);return interpolateProjectionFor3D(posInTile,spherePos,elevation);}"),
            background: _t("uniform vec4 u_color;uniform float u_opacity;void main() {fragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}"),
            backgroundPattern: _t("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);fragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;void main() {gl_Position=projectTile(a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"),
            circle: _t("in vec3 v_data;in float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);float antialiased_blur=v_data.z;float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));fragColor=v_visibility*opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);const float epsilon=0.5/255.0;if (fragColor.r < epsilon && fragColor.g < epsilon && fragColor.b < epsilon && fragColor.a < epsilon) {discard;}\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform highp float u_globe_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;uniform vec2 u_translate;in vec2 a_pos;out vec3 v_data;out float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 pos_raw=a_pos+32768.0;vec2 extrude=vec2(mod(pos_raw,8.0)/7.0*2.0-1.0);vec2 circle_center=floor(pos_raw/8.0)+u_translate;float ele=get_elevation(circle_center);v_visibility=calculate_visibility(projectTileWithElevation(circle_center,ele));if (u_pitch_with_map) {\n#ifdef GLOBE\nvec3 center_vector=projectToSphere(circle_center);\n#endif\nfloat angle_scale=u_globe_extrude_scale;vec2 corner_position=circle_center;if (u_scale_with_map) {angle_scale*=(radius+stroke_width);corner_position+=extrude*u_extrude_scale*(radius+stroke_width);} else {\n#ifdef GLOBE\nvec4 projected_center=interpolateProjection(circle_center,center_vector,ele);\n#else\nvec4 projected_center=projectTileWithElevation(circle_center,ele);\n#endif\ncorner_position+=extrude*u_extrude_scale*(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);angle_scale*=(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);}\n#ifdef GLOBE\nvec2 angles=extrude*angle_scale;vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(corner_position,corner_vector,ele);\n#else\ngl_Position=projectTileWithElevation(corner_position,ele);\n#endif\n} else {gl_Position=projectTileWithElevation(circle_center,ele);if (gl_Position.z/gl_Position.w > 1.0) {gl_Position.xy=vec2(10000.0);}if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}float antialiasblur=-max(1.0/u_device_pixel_ratio/(radius+stroke_width),blur);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"),
            clippingMask: _t(ut, "in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}"),
            heatmap: _t("uniform highp float u_intensity;in vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);fragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;uniform highp float u_globe_extrude_scale;in vec2 a_pos;out vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 pos_raw=a_pos+32768.0;vec2 unscaled_extrude=vec2(mod(pos_raw,8.0)/7.0*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 circle_center=floor(pos_raw/8.0);\n#ifdef GLOBE\nvec2 angles=v_extrude*radius*u_globe_extrude_scale;vec3 center_vector=projectToSphere(circle_center);vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(circle_center+extrude,corner_vector,0.0);\n#else\ngl_Position=projectTileFor3D(circle_center+extrude,get_elevation(circle_center));\n#endif\n}"),
            heatmapTexture: _t("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));fragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(0.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),
            collisionBox: _t("in float v_placed;in float v_notUsed;void main() {float alpha=0.5;fragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {fragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {fragColor*=.1;}}", "in vec2 a_anchor_pos;in vec2 a_placed;in vec2 a_box_real;uniform vec2 u_pixel_extrude_scale;out float v_placed;out float v_notUsed;void main() {gl_Position=projectTileWithElevation(a_anchor_pos,get_elevation(a_anchor_pos));gl_Position.xy=((a_box_real+0.5)*u_pixel_extrude_scale*2.0-1.0)*vec2(1.0,-1.0)*gl_Position.w;if (gl_Position.z/gl_Position.w < 1.1) {gl_Position.z=0.5;}v_placed=a_placed.x;v_notUsed=a_placed.y;}"),
            collisionCircle: _t("in float v_radius;in vec2 v_extrude;in float v_collision;void main() {float alpha=0.5;float stroke_radius=0.9;float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);fragColor=color*alpha*opacity_t;}", "in vec2 a_pos;in float a_radius;in vec2 a_flags;uniform vec2 u_viewport_size;out float v_radius;out vec2 v_extrude;out float v_collision;void main() {float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_collision=collision;gl_Position=vec4((a_pos/u_viewport_size*2.0-1.0)*vec2(1.0,-1.0),0.0,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
            debug: _t("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);fragColor=mix(u_color,overlay_color,overlay_color.a);}", "in vec2 a_pos;out vec2 v_uv;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=projectTileWithElevation(a_pos*u_overlay_scale,get_elevation(a_pos));}"),
            depth: _t(ut, "in vec2 a_pos;void main() {\n#ifdef GLOBE\ngl_Position=projectTileFor3D(a_pos,0.0);\n#else\ngl_Position=u_projection_matrix*vec4(a_pos,0.0,1.0);\n#endif\n}"),
            fill: _t("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nfragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_fill_translate;in vec2 a_pos;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=projectTile(a_pos+u_fill_translate,a_pos);}"),
            fillOutline: _t("in vec2 v_pos;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);fragColor=outline_color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_world;uniform vec2 u_fill_translate;in vec2 a_pos;out vec2 v_pos;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n}"),
            fillOutlinePattern: _t("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;in vec2 v_pos_a;in vec2 v_pos_b;in vec2 v_pos;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);fragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;out vec2 v_pos;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n}"),
            fillPattern: _t("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);fragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"),
            fillExtrusion: _t("in vec4 v_color;void main() {fragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;in vec2 a_pos;in vec4 a_normal_ed;\n#ifdef TERRAIN3D\nin vec2 a_centroid;\n#endif\nout vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;\n#ifdef GLOBE\nvec3 spherePos=projectToSphere(posInTile,a_pos);gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);\n#else\ngl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);\n#endif\nfloat colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;vec3 normalForLighting=normal/16384.0;float directional=clamp(dot(normalForLighting,u_lightpos),0.0,1.0);\n#ifdef GLOBE\nmat3 rotMatrix=globeGetRotationMatrix(spherePos);normalForLighting=rotMatrix*normalForLighting;directional=mix(directional,clamp(dot(normalForLighting,u_lightpos_globe),0.0,1.0),u_projection_transition);\n#endif\ndirectional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"),
            fillExtrusionPattern: _t("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;in vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);fragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;in vec2 a_pos;in vec4 a_normal_ed;\n#ifdef TERRAIN3D\nin vec2 a_centroid;\n#endif\n#ifdef GLOBE\nout vec3 v_sphere_pos;\n#endif\nout vec2 v_pos_a;out vec2 v_pos_b;out vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;\n#ifdef GLOBE\nvec3 spherePos=projectToSphere(posInTile,a_pos);vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);v_sphere_pos=elevatedPos;gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);\n#else\ngl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);\n#endif\nvec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,elevation*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"),
            hillshadePrepare: _t("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/pow(2.0,exaggeration+(19.2562-u_zoom));fragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
            hillshade: _t("uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);fragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=projectTile(a_pos,a_pos);v_pos=a_pos/8192.0;if (a_pos.y <-32767.5) {v_pos.y=0.0;}if (a_pos.y > 32766.5) {v_pos.y=1.0;}}"),
            line: _t("uniform lowp float u_device_pixel_ratio;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp float v_linesofar;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
            lineGradient: _t("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;in highp vec2 v_uv;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture(u_image,v_uv);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;in float a_uv_x;in float a_split_index;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec2 v_uv;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
            linePattern: _t("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;in vec2 v_normal;in vec2 v_width2;in float v_linesofar;in float v_gamma_scale;in float v_width;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture(u_image,pos_a),texture(u_image,pos_b),u_fade);fragColor=color*alpha*opacity;\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nin vec2 a_pos_normal;in vec4 a_data;uniform vec2 u_translation;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out float v_linesofar;out float v_gamma_scale;out float v_width;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}"),
            lineSDF: _t("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;in vec2 v_normal;in vec2 v_width2;in vec2 v_tex_a;in vec2 v_tex_b;in float v_gamma_scale;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture(u_image,v_tex_a).a;float sdfdist_b=texture(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nin vec2 a_pos_normal;in vec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;out vec2 v_normal;out vec2 v_width2;out vec2 v_tex_a;out vec2 v_tex_b;out float v_gamma_scale;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}"),
            raster: _t("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;in vec2 v_pos0;in vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture(u_image0,v_pos0);vec4 color1=texture(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);fragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;uniform vec4 u_coords_top;uniform vec4 u_coords_bottom;in vec2 a_pos;out vec2 v_pos0;out vec2 v_pos1;void main() {vec2 fractionalPos=a_pos/8192.0;vec2 position=mix(mix(u_coords_top.xy,u_coords_top.zw,fractionalPos.x),mix(u_coords_bottom.xy,u_coords_bottom.zw,fractionalPos.x),fractionalPos.y);gl_Position=projectTile(position,position);v_pos0=((fractionalPos-0.5)/u_buffer_scale)+0.5;\n#ifdef GLOBE\nif (a_pos.y <-32767.5) {v_pos0.y=0.0;}if (a_pos.y > 32766.5) {v_pos0.y=1.0;}\n#endif\nv_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"),
            symbolIcon: _t("uniform sampler2D u_texture;in vec2 v_tex;in float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;fragColor=texture(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec4 a_pos_offset;in vec4 a_data;in vec4 a_pixeloffset;in vec3 a_projected_pos;in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;out vec2 v_tex;out float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}gl_Position=finalPos;v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float visibility=calculate_visibility(projectedPoint);v_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));}"),
            symbolSDF: _t("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;in vec2 v_data0;in vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float inner_edge=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);inner_edge=inner_edge+gamma*gamma_scale;}lowp float dist=texture(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(inner_edge-gamma_scaled,inner_edge+gamma_scaled,dist);if (u_is_halo) {lowp float halo_edge=(6.0-halo_width/fontScale)/SDF_PX;alpha=min(smoothstep(halo_edge-gamma_scaled,halo_edge+gamma_scaled,dist),1.0-alpha);}fragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec4 a_pos_offset;in vec4 a_data;in vec4 a_pixeloffset;in vec3 a_projected_pos;in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_translation;uniform float u_pitched_scale;out vec2 v_data0;out vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}"),
            symbolTextAndIcon: _t("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;in vec4 v_data0;in vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;fragColor=texture(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);fragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec4 a_pos_offset;in vec4 a_data;in vec3 a_projected_pos;in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;out vec4 v_data0;out vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map && !u_is_along_line) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}"),
            terrain: _t("uniform sampler2D u_texture;uniform vec4 u_fog_color;uniform vec4 u_horizon_color;uniform float u_fog_ground_blend;uniform float u_fog_ground_blend_opacity;uniform float u_horizon_fog_blend;uniform bool u_is_globe_mode;in vec2 v_texture_pos;in float v_fog_depth;const float gamma=2.2;vec4 gammaToLinear(vec4 color) {return pow(color,vec4(gamma));}vec4 linearToGamma(vec4 color) {return pow(color,vec4(1.0/gamma));}void main() {vec4 surface_color=texture(u_texture,vec2(v_texture_pos.x,1.0-v_texture_pos.y));if (!u_is_globe_mode && v_fog_depth > u_fog_ground_blend) {vec4 surface_color_linear=gammaToLinear(surface_color);float blend_color=smoothstep(0.0,1.0,max((v_fog_depth-u_horizon_fog_blend)/(1.0-u_horizon_fog_blend),0.0));vec4 fog_horizon_color_linear=mix(gammaToLinear(u_fog_color),gammaToLinear(u_horizon_color),blend_color);float factor_fog=max(v_fog_depth-u_fog_ground_blend,0.0)/(1.0-u_fog_ground_blend);fragColor=linearToGamma(mix(surface_color_linear,fog_horizon_color_linear,pow(factor_fog,2.0)*u_fog_ground_blend_opacity));} else {fragColor=surface_color;}}", "in vec3 a_pos3d;uniform mat4 u_fog_matrix;uniform float u_ele_delta;out vec2 v_texture_pos;out float v_fog_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=projectTileFor3D(a_pos3d.xy,get_elevation(a_pos3d.xy)-ele_delta);vec4 pos=u_fog_matrix*vec4(a_pos3d.xy,ele,1.0);v_fog_depth=pos.z/pos.w*0.5+0.5;}"),
            terrainDepth: _t("in float v_depth;const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitMsk=vec4(0.,vec3(1./256.0));highp vec4 pack(highp float value) {highp vec4 comp=fract(value*bitSh);comp-=comp.xxyz*bitMsk;return comp;}void main() {fragColor=pack(v_depth);}", "in vec3 a_pos3d;uniform float u_ele_delta;out float v_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);v_depth=gl_Position.z/gl_Position.w;}"),
            terrainCoords: _t("precision mediump float;uniform sampler2D u_texture;uniform float u_terrain_coords_id;in vec2 v_texture_pos;void main() {vec4 rgba=texture(u_texture,v_texture_pos);fragColor=vec4(rgba.r,rgba.g,rgba.b,u_terrain_coords_id);}", "in vec3 a_pos3d;uniform float u_ele_delta;out vec2 v_texture_pos;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);}"),
            projectionErrorMeasurement: _t("in vec4 v_output_error_encoded;void main() {fragColor=v_output_error_encoded;}", "in vec2 a_pos;uniform highp float u_input;uniform highp float u_output_expected;out vec4 v_output_error_encoded;void main() {float real_output=2.0*atan(exp(PI-(u_input*PI*2.0)))-PI*0.5;float error=real_output-u_output_expected;float abs_error=abs(error)*128.0;v_output_error_encoded.x=min(floor(abs_error*256.0),255.0)/255.0;abs_error-=v_output_error_encoded.x;v_output_error_encoded.y=min(floor(abs_error*65536.0),255.0)/255.0;abs_error-=v_output_error_encoded.x/255.0;v_output_error_encoded.z=min(floor(abs_error*16777216.0),255.0)/255.0;v_output_error_encoded.w=error >=0.0 ? 1.0 : 0.0;gl_Position=vec4(a_pos,0.0,1.0);}"),
            atmosphere: _t("in vec3 view_direction;uniform vec3 u_sun_pos;uniform vec3 u_globe_position;uniform float u_globe_radius;uniform float u_atmosphere_blend;/**Shader use from https:*Made some change to adapt to MapLibre Globe geometry*/const float PI=3.141592653589793;const int iSteps=5;const int jSteps=3;/*radius of the planet*/const float EARTH_RADIUS=6371e3;/*radius of the atmosphere*/const float ATMOS_RADIUS=6471e3;vec2 rsi(vec3 r0,vec3 rd,float sr) {float a=dot(rd,rd);float b=2.0*dot(rd,r0);float c=dot(r0,r0)-(sr*sr);float d=(b*b)-4.0*a*c;if (d < 0.0) return vec2(1e5,-1e5);return vec2((-b-sqrt(d))/(2.0*a),(-b+sqrt(d))/(2.0*a));}vec4 atmosphere(vec3 r,vec3 r0,vec3 pSun,float iSun,float rPlanet,float rAtmos,vec3 kRlh,float kMie,float shRlh,float shMie,float g) {pSun=normalize(pSun);r=normalize(r);vec2 p=rsi(r0,r,rAtmos);if (p.x > p.y) {return vec4(0.0,0.0,0.0,1.0);}if (p.x < 0.0) {p.x=0.0;}vec3 pos=r0+r*p.x;vec2 p2=rsi(r0,r,rPlanet);if (p2.x <=p2.y && p2.x > 0.0) {p.y=min(p.y,p2.x);}float iStepSize=(p.y-p.x)/float(iSteps);float iTime=p.x+iStepSize*0.5;vec3 totalRlh=vec3(0,0,0);vec3 totalMie=vec3(0,0,0);float iOdRlh=0.0;float iOdMie=0.0;float mu=dot(r,pSun);float mumu=mu*mu;float gg=g*g;float pRlh=3.0/(16.0*PI)*(1.0+mumu);float pMie=3.0/(8.0*PI)*((1.0-gg)*(mumu+1.0))/(pow(1.0+gg-2.0*mu*g,1.5)*(2.0+gg));for (int i=0; i < iSteps; i++) {vec3 iPos=r0+r*iTime;float iHeight=length(iPos)-rPlanet;float odStepRlh=exp(-iHeight/shRlh)*iStepSize;float odStepMie=exp(-iHeight/shMie)*iStepSize;iOdRlh+=odStepRlh;iOdMie+=odStepMie;float jStepSize=rsi(iPos,pSun,rAtmos).y/float(jSteps);float jTime=jStepSize*0.5;float jOdRlh=0.0;float jOdMie=0.0;for (int j=0; j < jSteps; j++) {vec3 jPos=iPos+pSun*jTime;float jHeight=length(jPos)-rPlanet;jOdRlh+=exp(-jHeight/shRlh)*jStepSize;jOdMie+=exp(-jHeight/shMie)*jStepSize;jTime+=jStepSize;}vec3 attn=exp(-(kMie*(iOdMie+jOdMie)+kRlh*(iOdRlh+jOdRlh)));totalRlh+=odStepRlh*attn;totalMie+=odStepMie*attn;iTime+=iStepSize;}float opacity=exp(-(length(kRlh)*length(totalRlh)+kMie*length(totalMie)));vec3 color=iSun*(pRlh*kRlh*totalRlh+pMie*kMie*totalMie);return vec4(color,opacity);}void main() {vec3 scale_camera_pos=-u_globe_position*EARTH_RADIUS/u_globe_radius;vec4 color=atmosphere(normalize(view_direction),scale_camera_pos,u_sun_pos,22.0,EARTH_RADIUS,ATMOS_RADIUS,vec3(5.5e-6,13.0e-6,22.4e-6),21e-6,8e3,1.2e3,0.758\n);color.rgb=1.0-exp(-1.0*color.rgb);color=pow(color,vec4(1.0/2.2));fragColor=vec4(color.rgb,1.0-color.a)*u_atmosphere_blend;}", "in vec2 a_pos;uniform mat4 u_inv_proj_matrix;out vec3 view_direction;void main() {view_direction=(u_inv_proj_matrix*vec4(a_pos,0.0,1.0)).xyz;gl_Position=vec4(a_pos,0.0,1.0);}"),
            sky: _t("uniform vec4 u_sky_color;uniform vec4 u_horizon_color;uniform vec2 u_horizon;uniform vec2 u_horizon_normal;uniform float u_sky_horizon_blend;uniform float u_sky_blend;void main() {float x=gl_FragCoord.x;float y=gl_FragCoord.y;float blend=(y-u_horizon.y)*u_horizon_normal.y+(x-u_horizon.x)*u_horizon_normal.x;if (blend > 0.0) {if (blend < u_sky_horizon_blend) {fragColor=mix(u_sky_color,u_horizon_color,pow(1.0-blend/u_sky_horizon_blend,2.0));} else {fragColor=u_sky_color;}}fragColor=mix(fragColor,vec4(vec3(0.0),0.0),u_sky_blend);}", "in vec2 a_pos;void main() {gl_Position=vec4(a_pos,1.0,1.0);}")
        };
        function _t(e, t) {
            const i = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, r = t.match(/in ([\w]+) ([\w]+)/g), o = e.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), a = t.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), s = a ? a.concat(o) : o, n = {};
            return {
                fragmentSource: e = e.replace(i, (e, t, i, r, o)=>(n[o] = !0, "define" === t ? `\n#ifndef HAS_UNIFORM_u_${o}\nin ${i} ${r} ${o};\n#else\nuniform ${i} ${r} u_${o};\n#endif\n` : `\n#ifdef HAS_UNIFORM_u_${o}\n    ${i} ${r} ${o} = u_${o};\n#endif\n`)),
                vertexSource: t = t.replace(i, (e, t, i, r, o)=>{
                    const a = "float" === r ? "vec2" : "vec4", s = o.match(/color/) ? "color" : a;
                    return n[o] ? "define" === t ? `\n#ifndef HAS_UNIFORM_u_${o}\nuniform lowp float u_${o}_t;\nin ${i} ${a} a_${o};\nout ${i} ${r} ${o};\n#else\nuniform ${i} ${r} u_${o};\n#endif\n` : "vec4" === s ? `\n#ifndef HAS_UNIFORM_u_${o}\n    ${o} = a_${o};\n#else\n    ${i} ${r} ${o} = u_${o};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${o}\n    ${o} = unpack_mix_${s}(a_${o}, u_${o}_t);\n#else\n    ${i} ${r} ${o} = u_${o};\n#endif\n` : "define" === t ? `\n#ifndef HAS_UNIFORM_u_${o}\nuniform lowp float u_${o}_t;\nin ${i} ${a} a_${o};\n#else\nuniform ${i} ${r} u_${o};\n#endif\n` : "vec4" === s ? `\n#ifndef HAS_UNIFORM_u_${o}\n    ${i} ${r} ${o} = a_${o};\n#else\n    ${i} ${r} ${o} = u_${o};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${o}\n    ${i} ${r} ${o} = unpack_mix_${s}(a_${o}, u_${o}_t);\n#else\n    ${i} ${r} ${o} = u_${o};\n#endif\n`;
                }),
                staticAttributes: r,
                staticUniforms: s
            };
        }
        class pt {
            constructor(e, t, i){
                this.vertexBuffer = e, this.indexBuffer = t, this.segments = i;
            }
            destroy() {
                this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.vertexBuffer = null, this.indexBuffer = null, this.segments = null;
            }
        }
        var mt = t.aD([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]);
        const ft = "#define PROJECTION_MERCATOR", gt = "mercator";
        class vt {
            constructor(){
                this._cachedMesh = null;
            }
            get name() {
                return "mercator";
            }
            get useSubdivision() {
                return !1;
            }
            get shaderVariantName() {
                return gt;
            }
            get shaderDefine() {
                return ft;
            }
            get shaderPreludeCode() {
                return dt.projectionMercator;
            }
            get vertexShaderPreludeCode() {
                return dt.projectionMercator.vertexSource;
            }
            get subdivisionGranularity() {
                return t.aE.noSubdivision;
            }
            get useGlobeControls() {
                return !1;
            }
            get transitionState() {
                return 0;
            }
            get latitudeErrorCorrectionRadians() {
                return 0;
            }
            destroy() {}
            updateGPUdependent(e) {}
            getMeshFromTileID(e, i, r, o, a) {
                if (this._cachedMesh) return this._cachedMesh;
                const s = new t.aF;
                s.emplaceBack(0, 0), s.emplaceBack(t.Z, 0), s.emplaceBack(0, t.Z), s.emplaceBack(t.Z, t.Z);
                const n = e.createVertexBuffer(s, mt.members), l = t.aG.simpleSegment(0, 0, 4, 2), c = new t.aH;
                c.emplaceBack(1, 0, 2), c.emplaceBack(1, 2, 3);
                const h = e.createIndexBuffer(c);
                return this._cachedMesh = new pt(n, h, l), this._cachedMesh;
            }
            recalculate() {}
            hasTransition() {
                return !1;
            }
            setErrorQueryLatitudeDegrees(e) {}
        }
        function xt(e, i) {
            const r = t.ae(i.lat, -85.051129, t.aJ);
            return new t.P(t.U(i.lng) * e, t.S(r) * e);
        }
        function bt(e, i) {
            return new t.$(i.x / e, i.y / e).toLngLat();
        }
        function yt(e) {
            return e.cameraToCenterDistance * Math.min(.85 * Math.tan(t.ad(90 - e.pitch)), Math.tan(t.ad(89.25 - e.pitch)));
        }
        function wt(e, i) {
            const r = e.canonical, o = i / t.aI(r.z), a = r.x + Math.pow(2, r.z) * e.wrap, s = t.at(new Float64Array(16));
            return t.L(s, s, [
                a * o,
                r.y * o,
                0
            ]), t.M(s, s, [
                o / t.Z,
                o / t.Z,
                1
            ]), s;
        }
        function Tt(e, i, r, o, a) {
            const s = t.$.fromLngLat(e, i), n = a * t.aK(1, e.lat), l = n * Math.cos(t.ad(r)), c = Math.sqrt(n * n - l * l), h = c * Math.sin(t.ad(-o)), u = c * Math.cos(t.ad(-o));
            return new t.$(s.x + h, s.y + u, s.z + l);
        }
        class Pt {
            constructor(e = 0, t = 0, i = 0, r = 0){
                if (isNaN(e) || e < 0 || isNaN(t) || t < 0 || isNaN(i) || i < 0 || isNaN(r) || r < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                this.top = e, this.bottom = t, this.left = i, this.right = r;
            }
            interpolate(e, i, r) {
                return null != i.top && null != e.top && (this.top = t.B.number(e.top, i.top, r)), null != i.bottom && null != e.bottom && (this.bottom = t.B.number(e.bottom, i.bottom, r)), null != i.left && null != e.left && (this.left = t.B.number(e.left, i.left, r)), null != i.right && null != e.right && (this.right = t.B.number(e.right, i.right, r)), this;
            }
            getCenter(e, i) {
                const r = t.ae((this.left + e - this.right) / 2, 0, e), o = t.ae((this.top + i - this.bottom) / 2, 0, i);
                return new t.P(r, o);
            }
            equals(e) {
                return this.top === e.top && this.bottom === e.bottom && this.left === e.left && this.right === e.right;
            }
            clone() {
                return new Pt(this.top, this.bottom, this.left, this.right);
            }
            toJSON() {
                return {
                    top: this.top,
                    bottom: this.bottom,
                    left: this.left,
                    right: this.right
                };
            }
        }
        function Ct(e, t) {
            if (!e.renderWorldCopies || e.lngRange) return;
            const i = t.lng - e.center.lng;
            t.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
        }
        function It(e) {
            return Math.max(0, Math.floor(e));
        }
        class Mt {
            constructor(e, i, r, o, a, s){
                this._callbacks = e, this._tileSize = 512, this._renderWorldCopies = void 0 === s || !!s, this._minZoom = i || 0, this._maxZoom = r || 22, this._minPitch = null == o ? 0 : o, this._maxPitch = null == a ? 60 : a, this.setMaxBounds(), this._width = 0, this._height = 0, this._center = new t.Q(0, 0), this._elevation = 0, this._zoom = 0, this._tileZoom = It(this._zoom), this._scale = t.aI(this._zoom), this._bearingInRadians = 0, this._fovInRadians = .6435011087932844, this._pitchInRadians = 0, this._rollInRadians = 0, this._unmodified = !0, this._edgeInsets = new Pt, this._minElevationForCurrentTile = 0, this._autoCalculateNearFarZ = !0;
            }
            apply(e, i, r) {
                this._latRange = e.latRange, this._lngRange = e.lngRange, this._width = e.width, this._height = e.height, this._center = e.center, this._elevation = e.elevation, this._minElevationForCurrentTile = e.minElevationForCurrentTile, this._zoom = e.zoom, this._tileZoom = It(this._zoom), this._scale = t.aI(this._zoom), this._bearingInRadians = e.bearingInRadians, this._fovInRadians = e.fovInRadians, this._pitchInRadians = e.pitchInRadians, this._rollInRadians = e.rollInRadians, this._unmodified = e.unmodified, this._edgeInsets = new Pt(e.padding.top, e.padding.bottom, e.padding.left, e.padding.right), this._minZoom = e.minZoom, this._maxZoom = e.maxZoom, this._minPitch = e.minPitch, this._maxPitch = e.maxPitch, this._renderWorldCopies = e.renderWorldCopies, this._cameraToCenterDistance = e.cameraToCenterDistance, this._nearZ = e.nearZ, this._farZ = e.farZ, this._autoCalculateNearFarZ = !r && e.autoCalculateNearFarZ, i && this._constrain(), this._calcMatrices();
            }
            get pixelsToClipSpaceMatrix() {
                return this._pixelsToClipSpaceMatrix;
            }
            get clipSpaceToPixelsMatrix() {
                return this._clipSpaceToPixelsMatrix;
            }
            get minElevationForCurrentTile() {
                return this._minElevationForCurrentTile;
            }
            setMinElevationForCurrentTile(e) {
                this._minElevationForCurrentTile = e;
            }
            get tileSize() {
                return this._tileSize;
            }
            get tileZoom() {
                return this._tileZoom;
            }
            get scale() {
                return this._scale;
            }
            get width() {
                return this._width;
            }
            get height() {
                return this._height;
            }
            get bearingInRadians() {
                return this._bearingInRadians;
            }
            get lngRange() {
                return this._lngRange;
            }
            get latRange() {
                return this._latRange;
            }
            get pixelsToGLUnits() {
                return this._pixelsToGLUnits;
            }
            get minZoom() {
                return this._minZoom;
            }
            setMinZoom(e) {
                this._minZoom !== e && (this._minZoom = e, this.setZoom(this.getConstrained(this._center, this.zoom).zoom));
            }
            get maxZoom() {
                return this._maxZoom;
            }
            setMaxZoom(e) {
                this._maxZoom !== e && (this._maxZoom = e, this.setZoom(this.getConstrained(this._center, this.zoom).zoom));
            }
            get minPitch() {
                return this._minPitch;
            }
            setMinPitch(e) {
                this._minPitch !== e && (this._minPitch = e, this.setPitch(Math.max(this.pitch, e)));
            }
            get maxPitch() {
                return this._maxPitch;
            }
            setMaxPitch(e) {
                this._maxPitch !== e && (this._maxPitch = e, this.setPitch(Math.min(this.pitch, e)));
            }
            get renderWorldCopies() {
                return this._renderWorldCopies;
            }
            setRenderWorldCopies(e) {
                void 0 === e ? e = !0 : null === e && (e = !1), this._renderWorldCopies = e;
            }
            get worldSize() {
                return this._tileSize * this._scale;
            }
            get centerOffset() {
                return this.centerPoint._sub(this.size._div(2));
            }
            get size() {
                return new t.P(this._width, this._height);
            }
            get bearing() {
                return this._bearingInRadians / Math.PI * 180;
            }
            setBearing(e) {
                const i = t.aL(e, -180, 180) * Math.PI / 180;
                var o, a, s, n, l, c, h, u, d;
                this._bearingInRadians !== i && (this._unmodified = !1, this._bearingInRadians = i, this._calcMatrices(), this._rotationMatrix = r(), o = this._rotationMatrix, s = -this._bearingInRadians, n = (a = this._rotationMatrix)[0], l = a[1], c = a[2], h = a[3], u = Math.sin(s), d = Math.cos(s), o[0] = n * d + c * u, o[1] = l * d + h * u, o[2] = n * -u + c * d, o[3] = l * -u + h * d);
            }
            get rotationMatrix() {
                return this._rotationMatrix;
            }
            get pitchInRadians() {
                return this._pitchInRadians;
            }
            get pitch() {
                return this._pitchInRadians / Math.PI * 180;
            }
            setPitch(e) {
                const i = t.ae(e, this.minPitch, this.maxPitch) / 180 * Math.PI;
                this._pitchInRadians !== i && (this._unmodified = !1, this._pitchInRadians = i, this._calcMatrices());
            }
            get rollInRadians() {
                return this._rollInRadians;
            }
            get roll() {
                return this._rollInRadians / Math.PI * 180;
            }
            setRoll(e) {
                const t = e / 180 * Math.PI;
                this._rollInRadians !== t && (this._unmodified = !1, this._rollInRadians = t, this._calcMatrices());
            }
            get fovInRadians() {
                return this._fovInRadians;
            }
            get fov() {
                return t.aM(this._fovInRadians);
            }
            setFov(e) {
                e = t.ae(e, .1, 150), this.fov !== e && (this._unmodified = !1, this._fovInRadians = t.ad(e), this._calcMatrices());
            }
            get zoom() {
                return this._zoom;
            }
            setZoom(e) {
                const i = this.getConstrained(this._center, e).zoom;
                this._zoom !== i && (this._unmodified = !1, this._zoom = i, this._tileZoom = Math.max(0, Math.floor(i)), this._scale = t.aI(i), this._constrain(), this._calcMatrices());
            }
            get center() {
                return this._center;
            }
            setCenter(e) {
                e.lat === this._center.lat && e.lng === this._center.lng || (this._unmodified = !1, this._center = e, this._constrain(), this._calcMatrices());
            }
            get elevation() {
                return this._elevation;
            }
            setElevation(e) {
                e !== this._elevation && (this._elevation = e, this._constrain(), this._calcMatrices());
            }
            get padding() {
                return this._edgeInsets.toJSON();
            }
            setPadding(e) {
                this._edgeInsets.equals(e) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, e, 1), this._calcMatrices());
            }
            get centerPoint() {
                return this._edgeInsets.getCenter(this._width, this._height);
            }
            get pixelsPerMeter() {
                return this._pixelPerMeter;
            }
            get unmodified() {
                return this._unmodified;
            }
            get cameraToCenterDistance() {
                return this._cameraToCenterDistance;
            }
            get nearZ() {
                return this._nearZ;
            }
            get farZ() {
                return this._farZ;
            }
            get autoCalculateNearFarZ() {
                return this._autoCalculateNearFarZ;
            }
            overrideNearFarZ(e, t) {
                this._autoCalculateNearFarZ = !1, this._nearZ = e, this._farZ = t, this._calcMatrices();
            }
            clearNearFarZOverride() {
                this._autoCalculateNearFarZ = !0, this._calcMatrices();
            }
            isPaddingEqual(e) {
                return this._edgeInsets.equals(e);
            }
            interpolatePadding(e, t, i) {
                this._unmodified = !1, this._edgeInsets.interpolate(e, t, i), this._constrain(), this._calcMatrices();
            }
            resize(e, t, i = !0) {
                this._width = e, this._height = t, i && this._constrain(), this._calcMatrices();
            }
            getMaxBounds() {
                return this._latRange && 2 === this._latRange.length && this._lngRange && 2 === this._lngRange.length ? new V([
                    this._lngRange[0],
                    this._latRange[0]
                ], [
                    this._lngRange[1],
                    this._latRange[1]
                ]) : null;
            }
            setMaxBounds(e) {
                e ? (this._lngRange = [
                    e.getWest(),
                    e.getEast()
                ], this._latRange = [
                    e.getSouth(),
                    e.getNorth()
                ], this._constrain()) : (this._lngRange = null, this._latRange = [
                    -85.051129,
                    t.aJ
                ]);
            }
            getConstrained(e, t) {
                return this._callbacks.getConstrained(e, t);
            }
            getCameraQueryGeometry(e, i) {
                if (1 === i.length) return [
                    i[0],
                    e
                ];
                {
                    let r = e.x, o = e.y, a = e.x, s = e.y;
                    for (const e of i)r = Math.min(r, e.x), o = Math.min(o, e.y), a = Math.max(a, e.x), s = Math.max(s, e.y);
                    return [
                        new t.P(r, o),
                        new t.P(a, o),
                        new t.P(a, s),
                        new t.P(r, s),
                        new t.P(r, o)
                    ];
                }
            }
            _constrain() {
                if (!this.center || !this._width || !this._height || this._constraining) return;
                this._constraining = !0;
                const e = this._unmodified, { center: t, zoom: i } = this.getConstrained(this.center, this.zoom);
                this.setCenter(t), this.setZoom(i), this._unmodified = e, this._constraining = !1;
            }
            _calcMatrices() {
                if (this._width && this._height) {
                    this._pixelsToGLUnits = [
                        2 / this._width,
                        -2 / this._height
                    ];
                    let e = t.at(new Float64Array(16));
                    t.M(e, e, [
                        this._width / 2,
                        -this._height / 2,
                        1
                    ]), t.L(e, e, [
                        1,
                        -1,
                        0
                    ]), this._clipSpaceToPixelsMatrix = e, e = t.at(new Float64Array(16)), t.M(e, e, [
                        1,
                        -1,
                        1
                    ]), t.L(e, e, [
                        -1,
                        -1,
                        0
                    ]), t.M(e, e, [
                        2 / this._width,
                        2 / this._height,
                        1
                    ]), this._pixelsToClipSpaceMatrix = e, this._cameraToCenterDistance = .5 / Math.tan(this.fovInRadians / 2) * this._height;
                }
                this._callbacks.calcMatrices();
            }
            calculateCenterFromCameraLngLatAlt(e, i, r, o) {
                const a = void 0 !== r ? r : this.bearing, s = o = void 0 !== o ? o : this.pitch, n = t.$.fromLngLat(e, i), l = -Math.cos(t.ad(s)), c = Math.sin(t.ad(s)), h = c * Math.sin(t.ad(a)), u = -c * Math.cos(t.ad(a));
                let d = this.elevation;
                const _ = i - d;
                let p;
                l * _ >= 0 || Math.abs(l) < .1 ? (p = 1e4, d = i + p * l) : p = -_ / l;
                let m, f, g = t.aN(1, n.y), v = 0;
                do {
                    if (v += 1, v > 10) break;
                    f = p / g, m = new t.$(n.x + h * f, n.y + u * f), g = 1 / m.meterInMercatorCoordinateUnits();
                }while (Math.abs(p - f * g) > 1e-12);
                return {
                    center: m.toLngLat(),
                    elevation: d,
                    zoom: t.ab(this.height / 2 / Math.tan(this.fovInRadians / 2) / f / this.tileSize)
                };
            }
            recalculateZoomAndCenter(e) {
                if (this.elevation - e == 0) return;
                const i = t.aK(1, this.center.lat) * this.worldSize, r = this.cameraToCenterDistance / i, o = t.$.fromLngLat(this.center, this.elevation), a = Tt(this.center, this.elevation, this.pitch, this.bearing, r);
                this._elevation = e;
                const s = this.calculateCenterFromCameraLngLatAlt(a.toLngLat(), t.aN(a.z, o.y), this.bearing, this.pitch);
                this._elevation = s.elevation, this._center = s.center, this.setZoom(s.zoom);
            }
            getCameraPoint() {
                const e = Math.tan(this.pitchInRadians) * (this.cameraToCenterDistance || 1);
                return this.centerPoint.add(new t.P(e * Math.sin(this.rollInRadians), e * Math.cos(this.rollInRadians)));
            }
            getCameraAltitude() {
                return Math.cos(this.pitchInRadians) * this._cameraToCenterDistance / this._pixelPerMeter + this.elevation;
            }
            getCameraLngLat() {
                const e = t.aK(1, this.center.lat) * this.worldSize;
                return Tt(this.center, this.elevation, this.pitch, this.bearing, this.cameraToCenterDistance / e).toLngLat();
            }
            getMercatorTileCoordinates(e) {
                if (!e) return [
                    0,
                    0,
                    1,
                    1
                ];
                const i = e.canonical.z >= 0 ? 1 << e.canonical.z : Math.pow(2, e.canonical.z);
                return [
                    e.canonical.x / i,
                    e.canonical.y / i,
                    1 / i / t.Z,
                    1 / i / t.Z
                ];
            }
        }
        class Et {
            constructor(e, i){
                this.min = e, this.max = i, this.center = t.aO([], t.aP([], this.min, this.max), .5);
            }
            quadrant(e) {
                const i = [
                    e % 2 == 0,
                    e < 2
                ], r = t.aQ(this.min), o = t.aQ(this.max);
                for(let e = 0; e < i.length; e++)r[e] = i[e] ? this.min[e] : this.center[e], o[e] = i[e] ? this.center[e] : this.max[e];
                return o[2] = this.max[2], new Et(r, o);
            }
            distanceX(e) {
                return Math.max(Math.min(this.max[0], e[0]), this.min[0]) - e[0];
            }
            distanceY(e) {
                return Math.max(Math.min(this.max[1], e[1]), this.min[1]) - e[1];
            }
            intersectsFrustum(e) {
                let t = !0;
                for(let i = 0; i < e.planes.length; i++){
                    const r = this.intersectsPlane(e.planes[i]);
                    if (0 === r) return 0;
                    1 === r && (t = !1);
                }
                return t ? 2 : e.aabb.min[0] > this.max[0] || e.aabb.min[1] > this.max[1] || e.aabb.min[2] > this.max[2] || e.aabb.max[0] < this.min[0] || e.aabb.max[1] < this.min[1] || e.aabb.max[2] < this.min[2] ? 0 : 1;
            }
            intersectsPlane(e) {
                let t = e[3], i = e[3];
                for(let r = 0; r < 3; r++)e[r] > 0 ? (t += e[r] * this.min[r], i += e[r] * this.max[r]) : (i += e[r] * this.min[r], t += e[r] * this.max[r]);
                return t >= 0 ? 2 : i < 0 ? 0 : 1;
            }
        }
        class St {
            distanceToTile2d(e, t, i, r) {
                const o = r.distanceX([
                    e,
                    t
                ]), a = r.distanceY([
                    e,
                    t
                ]);
                return Math.hypot(o, a);
            }
            getWrap(e, t, i) {
                return i;
            }
            getTileAABB(e, i, r, o) {
                var a, s;
                let n = r, l = r;
                if (o.terrain) {
                    const c = new t.Y(e.z, i, e.z, e.x, e.y), h = o.terrain.getMinMaxElevation(c);
                    n = null !== (a = h.minElevation) && void 0 !== a ? a : r, l = null !== (s = h.maxElevation) && void 0 !== s ? s : r;
                }
                const c = 1 << e.z;
                return new Et([
                    i + e.x / c,
                    e.y / c,
                    n
                ], [
                    i + (e.x + 1) / c,
                    (e.y + 1) / c,
                    l
                ]);
            }
            allowVariableZoom(e, i) {
                const r = e.fov * (Math.abs(Math.cos(e.rollInRadians)) * e.height + Math.abs(Math.sin(e.rollInRadians)) * e.width) / e.height, o = t.ae(78.5 - r / 2, 0, 60);
                return !!i.terrain || e.pitch > o;
            }
            allowWorldCopies() {
                return !0;
            }
            recalculateCache() {}
        }
        class Rt {
            constructor(e, t, i){
                this.points = e, this.planes = t, this.aabb = i;
            }
            static fromInvProjectionMatrix(e, i = 1, r = 0) {
                const o = Math.pow(2, r), a = [
                    [
                        -1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        -1,
                        1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        1,
                        1
                    ]
                ].map((r)=>{
                    const a = 1 / (r = t.ap([], r, e))[3] / i * o;
                    return t.aR(r, r, [
                        a,
                        a,
                        1 / r[3],
                        a
                    ]);
                }), s = [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        6,
                        5,
                        4
                    ],
                    [
                        0,
                        3,
                        7
                    ],
                    [
                        2,
                        1,
                        5
                    ],
                    [
                        3,
                        2,
                        6
                    ],
                    [
                        0,
                        4,
                        5
                    ]
                ].map((e)=>{
                    const i = t.aS([], a[e[0]], a[e[1]]), r = t.aS([], a[e[2]], a[e[1]]), o = t.aT([], t.aU([], i, r)), s = -t.aV(o, a[e[1]]);
                    return o.concat(s);
                }), n = [
                    Number.POSITIVE_INFINITY,
                    Number.POSITIVE_INFINITY,
                    Number.POSITIVE_INFINITY
                ], l = [
                    Number.NEGATIVE_INFINITY,
                    Number.NEGATIVE_INFINITY,
                    Number.NEGATIVE_INFINITY
                ];
                for (const e of a)for(let t = 0; t < 3; t++)n[t] = Math.min(n[t], e[t]), l[t] = Math.max(l[t], e[t]);
                return new Rt(a, s, new Et(n, l));
            }
        }
        class Dt {
            get pixelsToClipSpaceMatrix() {
                return this._helper.pixelsToClipSpaceMatrix;
            }
            get clipSpaceToPixelsMatrix() {
                return this._helper.clipSpaceToPixelsMatrix;
            }
            get pixelsToGLUnits() {
                return this._helper.pixelsToGLUnits;
            }
            get centerOffset() {
                return this._helper.centerOffset;
            }
            get size() {
                return this._helper.size;
            }
            get rotationMatrix() {
                return this._helper.rotationMatrix;
            }
            get centerPoint() {
                return this._helper.centerPoint;
            }
            get pixelsPerMeter() {
                return this._helper.pixelsPerMeter;
            }
            setMinZoom(e) {
                this._helper.setMinZoom(e);
            }
            setMaxZoom(e) {
                this._helper.setMaxZoom(e);
            }
            setMinPitch(e) {
                this._helper.setMinPitch(e);
            }
            setMaxPitch(e) {
                this._helper.setMaxPitch(e);
            }
            setRenderWorldCopies(e) {
                this._helper.setRenderWorldCopies(e);
            }
            setBearing(e) {
                this._helper.setBearing(e);
            }
            setPitch(e) {
                this._helper.setPitch(e);
            }
            setRoll(e) {
                this._helper.setRoll(e);
            }
            setFov(e) {
                this._helper.setFov(e);
            }
            setZoom(e) {
                this._helper.setZoom(e);
            }
            setCenter(e) {
                this._helper.setCenter(e);
            }
            setElevation(e) {
                this._helper.setElevation(e);
            }
            setMinElevationForCurrentTile(e) {
                this._helper.setMinElevationForCurrentTile(e);
            }
            setPadding(e) {
                this._helper.setPadding(e);
            }
            interpolatePadding(e, t, i) {
                return this._helper.interpolatePadding(e, t, i);
            }
            isPaddingEqual(e) {
                return this._helper.isPaddingEqual(e);
            }
            resize(e, t, i = !0) {
                this._helper.resize(e, t, i);
            }
            getMaxBounds() {
                return this._helper.getMaxBounds();
            }
            setMaxBounds(e) {
                this._helper.setMaxBounds(e);
            }
            overrideNearFarZ(e, t) {
                this._helper.overrideNearFarZ(e, t);
            }
            clearNearFarZOverride() {
                this._helper.clearNearFarZOverride();
            }
            getCameraQueryGeometry(e) {
                return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e);
            }
            get tileSize() {
                return this._helper.tileSize;
            }
            get tileZoom() {
                return this._helper.tileZoom;
            }
            get scale() {
                return this._helper.scale;
            }
            get worldSize() {
                return this._helper.worldSize;
            }
            get width() {
                return this._helper.width;
            }
            get height() {
                return this._helper.height;
            }
            get lngRange() {
                return this._helper.lngRange;
            }
            get latRange() {
                return this._helper.latRange;
            }
            get minZoom() {
                return this._helper.minZoom;
            }
            get maxZoom() {
                return this._helper.maxZoom;
            }
            get zoom() {
                return this._helper.zoom;
            }
            get center() {
                return this._helper.center;
            }
            get minPitch() {
                return this._helper.minPitch;
            }
            get maxPitch() {
                return this._helper.maxPitch;
            }
            get pitch() {
                return this._helper.pitch;
            }
            get pitchInRadians() {
                return this._helper.pitchInRadians;
            }
            get roll() {
                return this._helper.roll;
            }
            get rollInRadians() {
                return this._helper.rollInRadians;
            }
            get bearing() {
                return this._helper.bearing;
            }
            get bearingInRadians() {
                return this._helper.bearingInRadians;
            }
            get fov() {
                return this._helper.fov;
            }
            get fovInRadians() {
                return this._helper.fovInRadians;
            }
            get elevation() {
                return this._helper.elevation;
            }
            get minElevationForCurrentTile() {
                return this._helper.minElevationForCurrentTile;
            }
            get padding() {
                return this._helper.padding;
            }
            get unmodified() {
                return this._helper.unmodified;
            }
            get renderWorldCopies() {
                return this._helper.renderWorldCopies;
            }
            get cameraToCenterDistance() {
                return this._helper.cameraToCenterDistance;
            }
            get nearZ() {
                return this._helper.nearZ;
            }
            get farZ() {
                return this._helper.farZ;
            }
            get autoCalculateNearFarZ() {
                return this._helper.autoCalculateNearFarZ;
            }
            setTransitionState(e, t) {}
            constructor(e, t, i, r, o){
                this._posMatrixCache = new Map, this._alignedPosMatrixCache = new Map, this._fogMatrixCacheF32 = new Map, this._helper = new Mt({
                    calcMatrices: ()=>{
                        this._calcMatrices();
                    },
                    getConstrained: (e, t)=>this.getConstrained(e, t)
                }, e, t, i, r, o), this._coveringTilesDetailsProvider = new St;
            }
            clone() {
                const e = new Dt;
                return e.apply(this), e;
            }
            apply(e, t, i) {
                this._helper.apply(e, t, i);
            }
            get cameraPosition() {
                return this._cameraPosition;
            }
            get projectionMatrix() {
                return this._projectionMatrix;
            }
            get modelViewProjectionMatrix() {
                return this._viewProjMatrix;
            }
            get inverseProjectionMatrix() {
                return this._invProjMatrix;
            }
            get mercatorMatrix() {
                return this._mercatorMatrix;
            }
            getVisibleUnwrappedCoordinates(e) {
                const i = [
                    new t.aW(0, e)
                ];
                if (this._helper._renderWorldCopies) {
                    const r = this.screenPointToMercatorCoordinate(new t.P(0, 0)), o = this.screenPointToMercatorCoordinate(new t.P(this._helper._width, 0)), a = this.screenPointToMercatorCoordinate(new t.P(this._helper._width, this._helper._height)), s = this.screenPointToMercatorCoordinate(new t.P(0, this._helper._height)), n = Math.floor(Math.min(r.x, o.x, a.x, s.x)), l = Math.floor(Math.max(r.x, o.x, a.x, s.x)), c = 1;
                    for(let r = n - c; r <= l + c; r++)0 !== r && i.push(new t.aW(r, e));
                }
                return i;
            }
            getCameraFrustum() {
                return Rt.fromInvProjectionMatrix(this._invViewProjMatrix, this.worldSize);
            }
            getClippingPlane() {
                return null;
            }
            getCoveringTilesDetailsProvider() {
                return this._coveringTilesDetailsProvider;
            }
            recalculateZoomAndCenter(e) {
                const t = this.screenPointToLocation(this.centerPoint, e), i = e ? e.getElevationForLngLatZoom(t, this._helper._tileZoom) : 0;
                this._helper.recalculateZoomAndCenter(i);
            }
            setLocationAtPoint(e, i) {
                const r = t.aK(this.elevation, this.center.lat), o = this.screenPointToMercatorCoordinateAtZ(i, r), a = this.screenPointToMercatorCoordinateAtZ(this.centerPoint, r), s = t.$.fromLngLat(e), n = new t.$(s.x - (o.x - a.x), s.y - (o.y - a.y));
                this.setCenter(null == n ? void 0 : n.toLngLat()), this._helper._renderWorldCopies && this.setCenter(this.center.wrap());
            }
            locationToScreenPoint(e, i) {
                return i ? this.coordinatePoint(t.$.fromLngLat(e), i.getElevationForLngLatZoom(e, this._helper._tileZoom), this._pixelMatrix3D) : this.coordinatePoint(t.$.fromLngLat(e));
            }
            screenPointToLocation(e, t) {
                var i;
                return null === (i = this.screenPointToMercatorCoordinate(e, t)) || void 0 === i ? void 0 : i.toLngLat();
            }
            screenPointToMercatorCoordinate(e, t) {
                if (t) {
                    const i = t.pointCoordinate(e);
                    if (null != i) return i;
                }
                return this.screenPointToMercatorCoordinateAtZ(e);
            }
            screenPointToMercatorCoordinateAtZ(e, i) {
                const r = i || 0, o = [
                    e.x,
                    e.y,
                    0,
                    1
                ], a = [
                    e.x,
                    e.y,
                    1,
                    1
                ];
                t.ap(o, o, this._pixelMatrixInverse), t.ap(a, a, this._pixelMatrixInverse);
                const s = o[3], n = a[3], l = o[1] / s, c = a[1] / n, h = o[2] / s, u = a[2] / n, d = h === u ? 0 : (r - h) / (u - h);
                return new t.$(t.B.number(o[0] / s, a[0] / n, d) / this.worldSize, t.B.number(l, c, d) / this.worldSize, r);
            }
            coordinatePoint(e, i = 0, r = this._pixelMatrix) {
                const o = [
                    e.x * this.worldSize,
                    e.y * this.worldSize,
                    i,
                    1
                ];
                return t.ap(o, o, r), new t.P(o[0] / o[3], o[1] / o[3]);
            }
            getBounds() {
                const e = Math.max(0, this._helper._height / 2 - yt(this));
                return (new V).extend(this.screenPointToLocation(new t.P(0, e))).extend(this.screenPointToLocation(new t.P(this._helper._width, e))).extend(this.screenPointToLocation(new t.P(this._helper._width, this._helper._height))).extend(this.screenPointToLocation(new t.P(0, this._helper._height)));
            }
            isPointOnMapSurface(e, t) {
                return t ? null != t.pointCoordinate(e) : e.y > this.height / 2 - yt(this);
            }
            calculatePosMatrix(e, i = !1, r) {
                var o;
                const a = null !== (o = e.key) && void 0 !== o ? o : t.aX(e.wrap, e.canonical.z, e.canonical.z, e.canonical.x, e.canonical.y), s = i ? this._alignedPosMatrixCache : this._posMatrixCache;
                if (s.has(a)) {
                    const e = s.get(a);
                    return r ? e.f32 : e.f64;
                }
                const n = wt(e, this.worldSize);
                t.N(n, i ? this._alignedProjMatrix : this._viewProjMatrix, n);
                const l = {
                    f64: n,
                    f32: new Float32Array(n)
                };
                return s.set(a, l), r ? l.f32 : l.f64;
            }
            calculateFogMatrix(e) {
                const i = e.key, r = this._fogMatrixCacheF32;
                if (r.has(i)) return r.get(i);
                const o = wt(e, this.worldSize);
                return t.N(o, this._fogMatrix, o), r.set(i, new Float32Array(o)), r.get(i);
            }
            getConstrained(e, i) {
                i = t.ae(+i, this.minZoom, this.maxZoom);
                const r = {
                    center: new t.Q(e.lng, e.lat),
                    zoom: i
                };
                let o = this._helper._lngRange;
                this._helper._renderWorldCopies || null !== o || (o = [
                    -179.9999999999,
                    180 - 1e-10
                ]);
                const a = this.tileSize * t.aI(r.zoom);
                let s = 0, n = a, l = 0, c = a, h = 0, u = 0;
                const { x: d, y: _ } = this.size;
                if (this._helper._latRange) {
                    const e = this._helper._latRange;
                    s = t.S(e[1]) * a, n = t.S(e[0]) * a, n - s < _ && (h = _ / (n - s));
                }
                o && (l = t.aL(t.U(o[0]) * a, 0, a), c = t.aL(t.U(o[1]) * a, 0, a), c < l && (c += a), c - l < d && (u = d / (c - l)));
                const { x: p, y: m } = xt(a, e);
                let f, g;
                const v = Math.max(u || 0, h || 0);
                if (v) {
                    const e = new t.P(u ? (c + l) / 2 : p, h ? (n + s) / 2 : m);
                    return r.center = bt(a, e).wrap(), r.zoom += t.ab(v), r;
                }
                if (this._helper._latRange) {
                    const e = _ / 2;
                    m - e < s && (g = s + e), m + e > n && (g = n - e);
                }
                if (o) {
                    const e = (l + c) / 2;
                    let i = p;
                    this._helper._renderWorldCopies && (i = t.aL(p, e - a / 2, e + a / 2));
                    const r = d / 2;
                    i - r < l && (f = l + r), i + r > c && (f = c - r);
                }
                if (void 0 !== f || void 0 !== g) {
                    const e = new t.P(null != f ? f : p, null != g ? g : m);
                    r.center = bt(a, e).wrap();
                }
                return r;
            }
            calculateCenterFromCameraLngLatAlt(e, t, i, r) {
                return this._helper.calculateCenterFromCameraLngLatAlt(e, t, i, r);
            }
            _calculateNearFarZIfNeeded(e, i, r) {
                if (!this._helper.autoCalculateNearFarZ) return;
                const o = Math.min(this.elevation, this.minElevationForCurrentTile, this.getCameraAltitude() - 100), a = e - o * this._helper._pixelPerMeter / Math.cos(i), s = o < 0 ? a : e, n = Math.PI / 2 + this.pitchInRadians, l = t.ad(this.fov) * (Math.abs(Math.cos(t.ad(this.roll))) * this.height + Math.abs(Math.sin(t.ad(this.roll))) * this.width) / this.height * (.5 + r.y / this.height), c = Math.sin(l) * s / Math.sin(t.ae(Math.PI - n - l, .01, Math.PI - .01)), h = yt(this), u = Math.atan(h / this._helper.cameraToCenterDistance), d = t.ad(.75), _ = u > d ? 2 * u * (.5 + r.y / (2 * h)) : d, p = Math.sin(_) * s / Math.sin(t.ae(Math.PI - n - _, .01, Math.PI - .01)), m = Math.min(c, p);
                this._helper._farZ = 1.01 * (Math.cos(Math.PI / 2 - i) * m + s), this._helper._nearZ = this._helper._height / 50;
            }
            _calcMatrices() {
                if (!this._helper._height) return;
                const e = this.centerOffset, i = xt(this.worldSize, this.center), r = i.x, o = i.y;
                this._helper._pixelPerMeter = t.aK(1, this.center.lat) * this.worldSize;
                const a = t.ad(Math.min(this.pitch, 89.25)), s = Math.max(this._helper.cameraToCenterDistance / 2, this._helper.cameraToCenterDistance + this._helper._elevation * this._helper._pixelPerMeter / Math.cos(a));
                let n;
                this._calculateNearFarZIfNeeded(s, a, e), n = new Float64Array(16), t.aY(n, this.fovInRadians, this._helper._width / this._helper._height, this._helper._nearZ, this._helper._farZ), this._invProjMatrix = new Float64Array(16), t.aj(this._invProjMatrix, n), n[8] = 2 * -e.x / this._helper._width, n[9] = 2 * e.y / this._helper._height, this._projectionMatrix = t.aZ(n), t.M(n, n, [
                    1,
                    -1,
                    1
                ]), t.L(n, n, [
                    0,
                    0,
                    -this._helper.cameraToCenterDistance
                ]), t.a_(n, n, -this.rollInRadians), t.a$(n, n, this.pitchInRadians), t.a_(n, n, -this.bearingInRadians), t.L(n, n, [
                    -r,
                    -o,
                    0
                ]), this._mercatorMatrix = t.M([], n, [
                    this.worldSize,
                    this.worldSize,
                    this.worldSize
                ]), t.M(n, n, [
                    1,
                    1,
                    this._helper._pixelPerMeter
                ]), this._pixelMatrix = t.N(new Float64Array(16), this.clipSpaceToPixelsMatrix, n), t.L(n, n, [
                    0,
                    0,
                    -this.elevation
                ]), this._viewProjMatrix = n, this._invViewProjMatrix = t.aj([], n);
                const l = [
                    0,
                    0,
                    -1,
                    1
                ];
                t.ap(l, l, this._invViewProjMatrix), this._cameraPosition = [
                    l[0] / l[3],
                    l[1] / l[3],
                    l[2] / l[3]
                ], this._fogMatrix = new Float64Array(16), t.aY(this._fogMatrix, this.fovInRadians, this.width / this.height, s, this._helper._farZ), this._fogMatrix[8] = 2 * -e.x / this.width, this._fogMatrix[9] = 2 * e.y / this.height, t.M(this._fogMatrix, this._fogMatrix, [
                    1,
                    -1,
                    1
                ]), t.L(this._fogMatrix, this._fogMatrix, [
                    0,
                    0,
                    -this.cameraToCenterDistance
                ]), t.a_(this._fogMatrix, this._fogMatrix, -this.rollInRadians), t.a$(this._fogMatrix, this._fogMatrix, this.pitchInRadians), t.a_(this._fogMatrix, this._fogMatrix, -this.bearingInRadians), t.L(this._fogMatrix, this._fogMatrix, [
                    -r,
                    -o,
                    0
                ]), t.M(this._fogMatrix, this._fogMatrix, [
                    1,
                    1,
                    this._helper._pixelPerMeter
                ]), t.L(this._fogMatrix, this._fogMatrix, [
                    0,
                    0,
                    -this.elevation
                ]), this._pixelMatrix3D = t.N(new Float64Array(16), this.clipSpaceToPixelsMatrix, n);
                const c = this._helper._width % 2 / 2, h = this._helper._height % 2 / 2, u = Math.cos(this.bearingInRadians), d = Math.sin(-this.bearingInRadians), _ = r - Math.round(r) + u * c + d * h, p = o - Math.round(o) + u * h + d * c, m = new Float64Array(n);
                if (t.L(m, m, [
                    _ > .5 ? _ - 1 : _,
                    p > .5 ? p - 1 : p,
                    0
                ]), this._alignedProjMatrix = m, n = t.aj(new Float64Array(16), this._pixelMatrix), !n) throw new Error("failed to invert matrix");
                this._pixelMatrixInverse = n, this._clearMatrixCaches();
            }
            _clearMatrixCaches() {
                this._posMatrixCache.clear(), this._alignedPosMatrixCache.clear(), this._fogMatrixCacheF32.clear();
            }
            maxPitchScaleFactor() {
                if (!this._pixelMatrixInverse) return 1;
                const e = this.screenPointToMercatorCoordinate(new t.P(0, 0)), i = [
                    e.x * this.worldSize,
                    e.y * this.worldSize,
                    0,
                    1
                ];
                return t.ap(i, i, this._pixelMatrix)[3] / this._helper.cameraToCenterDistance;
            }
            getCameraPoint() {
                return this._helper.getCameraPoint();
            }
            getCameraAltitude() {
                return this._helper.getCameraAltitude();
            }
            getCameraLngLat() {
                const e = t.aK(1, this.center.lat) * this.worldSize;
                return Tt(this.center, this.elevation, this.pitch, this.bearing, this._helper.cameraToCenterDistance / e).toLngLat();
            }
            lngLatToCameraDepth(e, i) {
                const r = t.$.fromLngLat(e), o = [
                    r.x * this.worldSize,
                    r.y * this.worldSize,
                    i,
                    1
                ];
                return t.ap(o, o, this._viewProjMatrix), o[2] / o[3];
            }
            getProjectionData(e) {
                const { overscaledTileID: i, aligned: r, applyTerrainMatrix: o } = e, a = this._helper.getMercatorTileCoordinates(i), s = i ? this.calculatePosMatrix(i, r, !0) : null;
                let n;
                return n = i && i.terrainRttPosMatrix32f && o ? i.terrainRttPosMatrix32f : s || t.b0(), {
                    mainMatrix: n,
                    tileMercatorCoords: a,
                    clippingPlane: [
                        0,
                        0,
                        0,
                        0
                    ],
                    projectionTransition: 0,
                    fallbackMatrix: n
                };
            }
            isLocationOccluded(e) {
                return !1;
            }
            getPixelScale() {
                return 1;
            }
            getCircleRadiusCorrection() {
                return 1;
            }
            getPitchedTextCorrection(e, t, i) {
                return 1;
            }
            transformLightDirection(e) {
                return t.aQ(e);
            }
            getRayDirectionFromPixel(e) {
                throw new Error("Not implemented.");
            }
            projectTileCoordinates(e, i, r, o) {
                const a = this.calculatePosMatrix(r);
                let s;
                o ? (s = [
                    e,
                    i,
                    o(e, i),
                    1
                ], t.ap(s, s, a)) : (s = [
                    e,
                    i,
                    0,
                    1
                ], Oe(s, s, a));
                const n = s[3];
                return {
                    point: new t.P(s[0] / n, s[1] / n),
                    signedDistanceFromCamera: n,
                    isOccluded: !1
                };
            }
            populateCache(e) {
                for (const t of e)this.calculatePosMatrix(t);
            }
            getMatrixForModel(e, i) {
                const r = t.$.fromLngLat(e, i), o = r.meterInMercatorCoordinateUnits(), a = t.b1();
                return t.L(a, a, [
                    r.x,
                    r.y,
                    r.z
                ]), t.a_(a, a, Math.PI), t.a$(a, a, Math.PI / 2), t.M(a, a, [
                    -o,
                    o,
                    o
                ]), a;
            }
            getProjectionDataForCustomLayer(e = !0) {
                const i = new t.Y(0, 0, 0, 0, 0), r = this.getProjectionData({
                    overscaledTileID: i,
                    applyGlobeMatrix: e
                }), o = wt(i, this.worldSize);
                t.N(o, this._viewProjMatrix, o), r.tileMercatorCoords = [
                    0,
                    0,
                    1,
                    1
                ];
                const a = [
                    t.Z,
                    t.Z,
                    this.worldSize / this._helper.pixelsPerMeter
                ], s = t.b2();
                return t.M(s, o, a), r.fallbackMatrix = s, r.mainMatrix = s, r;
            }
            getFastPathSimpleProjectionMatrix(e) {
                return this.calculatePosMatrix(e);
            }
        }
        function zt() {
            t.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
        }
        function At(e) {
            if (e.useSlerp) {
                if (e.k < 1) {
                    const i = t.b3(e.startEulerAngles.roll, e.startEulerAngles.pitch, e.startEulerAngles.bearing), r = t.b3(e.endEulerAngles.roll, e.endEulerAngles.pitch, e.endEulerAngles.bearing), o = new Float64Array(4);
                    t.b4(o, i, r, e.k);
                    const a = t.b5(o);
                    e.tr.setRoll(a.roll), e.tr.setPitch(a.pitch), e.tr.setBearing(a.bearing);
                } else e.tr.setRoll(e.endEulerAngles.roll), e.tr.setPitch(e.endEulerAngles.pitch), e.tr.setBearing(e.endEulerAngles.bearing);
            } else e.tr.setRoll(t.B.number(e.startEulerAngles.roll, e.endEulerAngles.roll, e.k)), e.tr.setPitch(t.B.number(e.startEulerAngles.pitch, e.endEulerAngles.pitch, e.k)), e.tr.setBearing(t.B.number(e.startEulerAngles.bearing, e.endEulerAngles.bearing, e.k));
        }
        function Lt(e, i, r, o, a) {
            const s = a.padding, n = xt(a.worldSize, r.getNorthWest()), l = xt(a.worldSize, r.getNorthEast()), c = xt(a.worldSize, r.getSouthEast()), h = xt(a.worldSize, r.getSouthWest()), u = t.ad(-o), d = n.rotate(u), _ = l.rotate(u), p = c.rotate(u), m = h.rotate(u), f = new t.P(Math.max(d.x, _.x, m.x, p.x), Math.max(d.y, _.y, m.y, p.y)), g = new t.P(Math.min(d.x, _.x, m.x, p.x), Math.min(d.y, _.y, m.y, p.y)), v = f.sub(g), x = (a.width - (s.left + s.right + i.left + i.right)) / v.x, b = (a.height - (s.top + s.bottom + i.top + i.bottom)) / v.y;
            if (b < 0 || x < 0) return void zt();
            const y = Math.min(t.ab(a.scale * Math.min(x, b)), e.maxZoom), w = t.P.convert(e.offset), T = new t.P((i.left - i.right) / 2, (i.top - i.bottom) / 2).rotate(t.ad(o)), P = w.add(T).mult(a.scale / t.aI(y));
            return {
                center: bt(a.worldSize, n.add(c).div(2).sub(P)),
                zoom: y,
                bearing: o
            };
        }
        class kt {
            get useGlobeControls() {
                return !1;
            }
            handlePanInertia(e, t) {
                return {
                    easingOffset: e,
                    easingCenter: t.center
                };
            }
            handleMapControlsRollPitchBearingZoom(e, t) {
                e.bearingDelta && t.setBearing(t.bearing + e.bearingDelta), e.pitchDelta && t.setPitch(t.pitch + e.pitchDelta), e.rollDelta && t.setRoll(t.roll + e.rollDelta), e.zoomDelta && t.setZoom(t.zoom + e.zoomDelta);
            }
            handleMapControlsPan(e, t, i) {
                e.around.distSqr(t.centerPoint) < .01 || t.setLocationAtPoint(i, e.around);
            }
            cameraForBoxAndBearing(e, t, i, r, o) {
                return Lt(e, t, i, r, o);
            }
            handleJumpToCenterZoom(e, i) {
                e.zoom !== (void 0 !== i.zoom ? +i.zoom : e.zoom) && e.setZoom(+i.zoom), void 0 !== i.center && e.setCenter(t.Q.convert(i.center));
            }
            handleEaseTo(e, i) {
                const r = e.zoom, o = e.padding, a = {
                    roll: e.roll,
                    pitch: e.pitch,
                    bearing: e.bearing
                }, s = {
                    roll: void 0 === i.roll ? e.roll : i.roll,
                    pitch: void 0 === i.pitch ? e.pitch : i.pitch,
                    bearing: void 0 === i.bearing ? e.bearing : i.bearing
                }, n = void 0 !== i.zoom, l = !e.isPaddingEqual(i.padding);
                let c = !1;
                const h = n ? +i.zoom : e.zoom;
                let u = e.centerPoint.add(i.offsetAsPoint);
                const d = e.screenPointToLocation(u), { center: _, zoom: p } = e.getConstrained(t.Q.convert(i.center || d), null != h ? h : r);
                Ct(e, _);
                const m = xt(e.worldSize, d), f = xt(e.worldSize, _).sub(m), g = t.aI(p - r);
                return c = p !== r, {
                    easeFunc: (n)=>{
                        if (c && e.setZoom(t.B.number(r, p, n)), t.b6(a, s) || At({
                            startEulerAngles: a,
                            endEulerAngles: s,
                            tr: e,
                            k: n,
                            useSlerp: a.roll != s.roll
                        }), l && (e.interpolatePadding(o, i.padding, n), u = e.centerPoint.add(i.offsetAsPoint)), i.around) e.setLocationAtPoint(i.around, i.aroundPoint);
                        else {
                            const i = t.aI(e.zoom - r), o = p > r ? Math.min(2, g) : Math.max(.5, g), a = Math.pow(o, 1 - n), s = bt(e.worldSize, m.add(f.mult(n * a)).mult(i));
                            e.setLocationAtPoint(e.renderWorldCopies ? s.wrap() : s, u);
                        }
                    },
                    isZooming: c,
                    elevationCenter: _
                };
            }
            handleFlyTo(e, i) {
                const r = void 0 !== i.zoom, o = e.zoom, a = e.getConstrained(t.Q.convert(i.center || i.locationAtOffset), r ? +i.zoom : o), s = a.center, n = a.zoom;
                Ct(e, s);
                const l = xt(e.worldSize, i.locationAtOffset), c = xt(e.worldSize, s).sub(l), h = c.mag(), u = t.aI(n - o);
                let d;
                if (void 0 !== i.minZoom) {
                    const r = Math.min(+i.minZoom, o, n), a = e.getConstrained(s, r).zoom;
                    d = t.aI(a - o);
                }
                return {
                    easeFunc: (i, r, a, h)=>{
                        e.setZoom(1 === i ? n : o + t.ab(r));
                        const u = 1 === i ? s : bt(e.worldSize, l.add(c.mult(a)).mult(r));
                        e.setLocationAtPoint(e.renderWorldCopies ? u.wrap() : u, h);
                    },
                    scaleOfZoom: u,
                    targetCenter: s,
                    scaleOfMinZoom: d,
                    pixelPathLength: h
                };
            }
        }
        class Ft {
            constructor(e, t, i){
                this.blendFunction = e, this.blendColor = t, this.mask = i;
            }
        }
        Ft.Replace = [
            1,
            0
        ], Ft.disabled = new Ft(Ft.Replace, t.b7.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), Ft.unblended = new Ft(Ft.Replace, t.b7.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Ft.alphaBlended = new Ft([
            1,
            771
        ], t.b7.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        const Bt = 2305;
        class Ot {
            constructor(e, t, i){
                this.enable = e, this.mode = t, this.frontFace = i;
            }
        }
        Ot.disabled = new Ot(!1, 1029, Bt), Ot.backCCW = new Ot(!0, 1029, Bt), Ot.frontCCW = new Ot(!0, 1028, Bt);
        class jt {
            constructor(e, t, i){
                this.func = e, this.mask = t, this.range = i;
            }
        }
        jt.ReadOnly = !1, jt.ReadWrite = !0, jt.disabled = new jt(519, jt.ReadOnly, [
            0,
            1
        ]);
        const Zt = 7680;
        class Nt {
            constructor(e, t, i, r, o, a){
                this.test = e, this.ref = t, this.mask = i, this.fail = r, this.depthFail = o, this.pass = a;
            }
        }
        Nt.disabled = new Nt({
            func: 519,
            mask: 0
        }, 0, 0, Zt, Zt, Zt);
        const Gt = new WeakMap;
        function Ut(e) {
            var t;
            if (Gt.has(e)) return Gt.get(e);
            {
                const i = null === (t = e.getParameter(e.VERSION)) || void 0 === t ? void 0 : t.startsWith("WebGL 2.0");
                return Gt.set(e, i), i;
            }
        }
        class Vt {
            get awaitingQuery() {
                return !!this._readbackQueue;
            }
            constructor(e){
                this._readbackWaitFrames = 4, this._measureWaitFrames = 6, this._texWidth = 1, this._texHeight = 1, this._measuredError = 0, this._updateCount = 0, this._lastReadbackFrame = -1000, this._readbackQueue = null, this._cachedRenderContext = e;
                const i = e.context, r = i.gl;
                this._texFormat = r.RGBA, this._texType = r.UNSIGNED_BYTE;
                const o = new t.aF;
                o.emplaceBack(-1, -1), o.emplaceBack(2, -1), o.emplaceBack(-1, 2);
                const a = new t.aH;
                a.emplaceBack(0, 1, 2), this._fullscreenTriangle = new pt(i.createVertexBuffer(o, mt.members), i.createIndexBuffer(a), t.aG.simpleSegment(0, 0, o.length, a.length)), this._resultBuffer = new Uint8Array(4), i.activeTexture.set(r.TEXTURE1);
                const s = r.createTexture();
                r.bindTexture(r.TEXTURE_2D, s), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, r.NEAREST), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, r.NEAREST), r.texImage2D(r.TEXTURE_2D, 0, this._texFormat, this._texWidth, this._texHeight, 0, this._texFormat, this._texType, null), this._fbo = i.createFramebuffer(this._texWidth, this._texHeight, !1, !1), this._fbo.colorAttachment.set(s), Ut(r) && (this._pbo = r.createBuffer(), r.bindBuffer(r.PIXEL_PACK_BUFFER, this._pbo), r.bufferData(r.PIXEL_PACK_BUFFER, 4, r.STREAM_READ), r.bindBuffer(r.PIXEL_PACK_BUFFER, null));
            }
            destroy() {
                const e = this._cachedRenderContext.context.gl;
                this._fullscreenTriangle.destroy(), this._fbo.destroy(), e.deleteBuffer(this._pbo), this._fullscreenTriangle = null, this._fbo = null, this._pbo = null, this._resultBuffer = null;
            }
            updateErrorLoop(e, t) {
                const i = this._updateCount;
                return this._readbackQueue ? i >= this._readbackQueue.frameNumberIssued + this._readbackWaitFrames && this._tryReadback() : i >= this._lastReadbackFrame + this._measureWaitFrames && this._renderErrorTexture(e, t), this._updateCount++, this._measuredError;
            }
            _bindFramebuffer() {
                const e = this._cachedRenderContext.context, t = e.gl;
                e.activeTexture.set(t.TEXTURE1), t.bindTexture(t.TEXTURE_2D, this._fbo.colorAttachment.get()), e.bindFramebuffer.set(this._fbo.framebuffer);
            }
            _renderErrorTexture(e, i) {
                const r = this._cachedRenderContext.context, o = r.gl;
                if (this._bindFramebuffer(), r.viewport.set([
                    0,
                    0,
                    this._texWidth,
                    this._texHeight
                ]), r.clear({
                    color: t.b7.transparent
                }), this._cachedRenderContext.useProgram("projectionErrorMeasurement").draw(r, o.TRIANGLES, jt.disabled, Nt.disabled, Ft.unblended, Ot.disabled, ((e, t)=>({
                        u_input: e,
                        u_output_expected: t
                    }))(e, i), null, null, "$clipping", this._fullscreenTriangle.vertexBuffer, this._fullscreenTriangle.indexBuffer, this._fullscreenTriangle.segments), this._pbo && Ut(o)) {
                    o.bindBuffer(o.PIXEL_PACK_BUFFER, this._pbo), o.readBuffer(o.COLOR_ATTACHMENT0), o.readPixels(0, 0, this._texWidth, this._texHeight, this._texFormat, this._texType, 0), o.bindBuffer(o.PIXEL_PACK_BUFFER, null);
                    const e = o.fenceSync(o.SYNC_GPU_COMMANDS_COMPLETE, 0);
                    o.flush(), this._readbackQueue = {
                        frameNumberIssued: this._updateCount,
                        sync: e
                    };
                } else this._readbackQueue = {
                    frameNumberIssued: this._updateCount,
                    sync: null
                };
            }
            _tryReadback() {
                const e = this._cachedRenderContext.context.gl;
                if (this._pbo && this._readbackQueue && Ut(e)) {
                    const i = e.clientWaitSync(this._readbackQueue.sync, 0, 0);
                    if (i === e.WAIT_FAILED) return t.w("WebGL2 clientWaitSync failed."), this._readbackQueue = null, void (this._lastReadbackFrame = this._updateCount);
                    if (i === e.TIMEOUT_EXPIRED) return;
                    e.bindBuffer(e.PIXEL_PACK_BUFFER, this._pbo), e.getBufferSubData(e.PIXEL_PACK_BUFFER, 0, this._resultBuffer, 0, 4), e.bindBuffer(e.PIXEL_PACK_BUFFER, null);
                } else this._bindFramebuffer(), e.readPixels(0, 0, this._texWidth, this._texHeight, this._texFormat, this._texType, this._resultBuffer);
                this._readbackQueue = null, this._measuredError = Vt._parseRGBA8float(this._resultBuffer), this._lastReadbackFrame = this._updateCount;
            }
            static _parseRGBA8float(e) {
                let t = 0;
                return t += e[0] / 256, t += e[1] / 65536, t += e[2] / 16777216, e[3] < 127 && (t = -t), t / 128;
            }
        }
        const qt = t.Z / 128;
        function Wt(e, i) {
            const r = void 0 !== e.granularity ? Math.max(e.granularity, 1) : 1, o = r + (e.generateBorders ? 2 : 0), a = r + (e.extendToNorthPole || e.generateBorders ? 1 : 0) + (e.extendToSouthPole || e.generateBorders ? 1 : 0), s = o + 1, n = a + 1, l = e.generateBorders ? -1 : 0, c = e.generateBorders || e.extendToNorthPole ? -1 : 0, h = r + (e.generateBorders ? 1 : 0), u = r + (e.generateBorders || e.extendToSouthPole ? 1 : 0), d = s * n, _ = o * a * 6, p = s * n > 65536;
            if (p && "16bit" === i) throw new Error("Granularity is too large and meshes would not fit inside 16 bit vertex indices.");
            const m = p || "32bit" === i, f = new Int16Array(2 * d);
            let g = 0;
            for(let i = c; i <= u; i++)for(let o = l; o <= h; o++){
                let a = o / r * t.Z;
                -1 === o && (a = -64), o === r + 1 && (a = t.Z + qt);
                let s = i / r * t.Z;
                -1 === i && (s = e.extendToNorthPole ? t.b9 : -64), i === r + 1 && (s = e.extendToSouthPole ? t.ba : t.Z + qt), f[g++] = a, f[g++] = s;
            }
            const v = m ? new Uint32Array(_) : new Uint16Array(_);
            let x = 0;
            for(let e = 0; e < a; e++)for(let t = 0; t < o; t++){
                const i = t + 1 + e * s, r = t + (e + 1) * s, o = t + 1 + (e + 1) * s;
                v[x++] = t + e * s, v[x++] = r, v[x++] = i, v[x++] = i, v[x++] = r, v[x++] = o;
            }
            return {
                vertices: f.buffer.slice(0),
                indices: v.buffer.slice(0),
                uses32bitIndices: m
            };
        }
        const $t = new t.aE({
            fill: new t.bb(128, 2),
            line: new t.bb(512, 0),
            tile: new t.bb(128, 32),
            stencil: new t.bb(128, 1),
            circle: 3
        });
        class Ht {
            constructor(){
                this._tileMeshCache = {}, this._errorCorrectionUsable = 0, this._errorMeasurementLastValue = 0, this._errorCorrectionPreviousValue = 0, this._errorMeasurementLastChangeTime = -1000;
            }
            get name() {
                return "vertical-perspective";
            }
            get transitionState() {
                return 1;
            }
            get useSubdivision() {
                return !0;
            }
            get shaderVariantName() {
                return "globe";
            }
            get shaderDefine() {
                return "#define GLOBE";
            }
            get shaderPreludeCode() {
                return dt.projectionGlobe;
            }
            get vertexShaderPreludeCode() {
                return dt.projectionMercator.vertexSource;
            }
            get subdivisionGranularity() {
                return $t;
            }
            get useGlobeControls() {
                return !0;
            }
            get latitudeErrorCorrectionRadians() {
                return this._errorCorrectionUsable;
            }
            destroy() {
                this._errorMeasurement && this._errorMeasurement.destroy();
            }
            updateGPUdependent(e) {
                this._errorMeasurement || (this._errorMeasurement = new Vt(e));
                const i = t.S(this._errorQueryLatitudeDegrees), r = 2 * Math.atan(Math.exp(Math.PI - i * Math.PI * 2)) - .5 * Math.PI, o = this._errorMeasurement.updateErrorLoop(i, r), a = s.now();
                o !== this._errorMeasurementLastValue && (this._errorCorrectionPreviousValue = this._errorCorrectionUsable, this._errorMeasurementLastValue = o, this._errorMeasurementLastChangeTime = a);
                const n = Math.min(Math.max((a - this._errorMeasurementLastChangeTime) / 1e3 / .5, 0), 1);
                this._errorCorrectionUsable = t.bc(this._errorCorrectionPreviousValue, -this._errorMeasurementLastValue, t.bd(n));
            }
            _getMeshKey(e) {
                return `${e.granularity.toString(36)}_${e.generateBorders ? "b" : ""}${e.extendToNorthPole ? "n" : ""}${e.extendToSouthPole ? "s" : ""}`;
            }
            getMeshFromTileID(e, t, i, r, o) {
                const a = ("stencil" === o ? $t.stencil : $t.tile).getGranularityForZoomLevel(t.z);
                return this._getMesh(e, {
                    granularity: a,
                    generateBorders: i,
                    extendToNorthPole: 0 === t.y && r,
                    extendToSouthPole: t.y === (1 << t.z) - 1 && r
                });
            }
            _getMesh(e, i) {
                const r = this._getMeshKey(i);
                if (r in this._tileMeshCache) return this._tileMeshCache[r];
                const o = function(e, i) {
                    const r = Wt(i, "16bit"), o = t.aF.deserialize({
                        arrayBuffer: r.vertices,
                        length: r.vertices.byteLength / 2 / 2
                    }), a = t.aH.deserialize({
                        arrayBuffer: r.indices,
                        length: r.indices.byteLength / 2 / 3
                    });
                    return new pt(e.createVertexBuffer(o, mt.members), e.createIndexBuffer(a), t.aG.simpleSegment(0, 0, o.length, a.length));
                }(e, i);
                return this._tileMeshCache[r] = o, o;
            }
            recalculate(e) {}
            hasTransition() {
                const e = s.now();
                let t = !1;
                return t = t || (e - this._errorMeasurementLastChangeTime) / 1e3 < .7, t = t || this._errorMeasurement && this._errorMeasurement.awaitingQuery, t;
            }
            setErrorQueryLatitudeDegrees(e) {
                this._errorQueryLatitudeDegrees = e;
            }
        }
        const Kt = new t.r({
            type: new t.D(t.v.projection.type)
        });
        class Xt extends t.E {
            constructor(e){
                super(), this._transitionable = new t.T(Kt), this.setProjection(e), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new t.C(0)), this._mercatorProjection = new vt, this._verticalPerspectiveProjection = new Ht;
            }
            get transitionState() {
                const e = this.properties.get("type");
                if ("string" == typeof e && "mercator" === e) return 0;
                if ("string" == typeof e && "vertical-perspective" === e) return 1;
                if (e instanceof t.be) {
                    if ("vertical-perspective" === e.from && "mercator" === e.to) return 1 - e.transition;
                    if ("mercator" === e.from && "vertical-perspective" === e.to) return e.transition;
                }
                return 1;
            }
            get useGlobeRendering() {
                return this.transitionState > 0;
            }
            get latitudeErrorCorrectionRadians() {
                return this._verticalPerspectiveProjection.latitudeErrorCorrectionRadians;
            }
            get currentProjection() {
                return this.useGlobeRendering ? this._verticalPerspectiveProjection : this._mercatorProjection;
            }
            get name() {
                return "globe";
            }
            get useSubdivision() {
                return this.currentProjection.useSubdivision;
            }
            get shaderVariantName() {
                return this.currentProjection.shaderVariantName;
            }
            get shaderDefine() {
                return this.currentProjection.shaderDefine;
            }
            get shaderPreludeCode() {
                return this.currentProjection.shaderPreludeCode;
            }
            get vertexShaderPreludeCode() {
                return this.currentProjection.vertexShaderPreludeCode;
            }
            get subdivisionGranularity() {
                return this.currentProjection.subdivisionGranularity;
            }
            get useGlobeControls() {
                return this.transitionState > 0;
            }
            destroy() {
                this._mercatorProjection.destroy(), this._verticalPerspectiveProjection.destroy();
            }
            updateGPUdependent(e) {
                this._mercatorProjection.updateGPUdependent(e), this._verticalPerspectiveProjection.updateGPUdependent(e);
            }
            getMeshFromTileID(e, t, i, r, o) {
                return this.currentProjection.getMeshFromTileID(e, t, i, r, o);
            }
            setProjection(e) {
                this._transitionable.setValue("type", (null == e ? void 0 : e.type) || "mercator");
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition() || this.currentProjection.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            setErrorQueryLatitudeDegrees(e) {
                this._verticalPerspectiveProjection.setErrorQueryLatitudeDegrees(e), this._mercatorProjection.setErrorQueryLatitudeDegrees(e);
            }
        }
        function Qt(e) {
            const t = ei(e.worldSize, e.center.lat);
            return 2 * Math.PI * t;
        }
        function Yt(e, i, r, o, a) {
            const s = 1 / (1 << a), n = i / t.Z * s + o * s, l = t.bg((e / t.Z * s + r * s) * Math.PI * 2 + Math.PI, 2 * Math.PI), c = 2 * Math.atan(Math.exp(Math.PI - n * Math.PI * 2)) - .5 * Math.PI, h = Math.cos(c), u = new Float64Array(3);
            return u[0] = Math.sin(l) * h, u[1] = Math.sin(c), u[2] = Math.cos(l) * h, u;
        }
        function Jt(e) {
            return function(e, t) {
                const i = Math.cos(t), r = new Float64Array(3);
                return r[0] = Math.sin(e) * i, r[1] = Math.sin(t), r[2] = Math.cos(e) * i, r;
            }(e.lng * Math.PI / 180, e.lat * Math.PI / 180);
        }
        function ei(e, t) {
            return e / (2 * Math.PI) / Math.cos(t * Math.PI / 180);
        }
        function ti(e) {
            const i = Math.asin(e[1]) / Math.PI * 180, r = Math.sqrt(e[0] * e[0] + e[2] * e[2]);
            if (r > 1e-6) {
                const o = e[0] / r, a = Math.acos(e[2] / r), s = (o > 0 ? a : -a) / Math.PI * 180;
                return new t.Q(t.aL(s, -180, 180), i);
            }
            return new t.Q(0, i);
        }
        function ii(e) {
            return Math.cos(e * Math.PI / 180);
        }
        function ri(e, i) {
            const r = ii(e), o = ii(i);
            return t.ab(o / r);
        }
        function oi(e, i) {
            const r = e.rotate(i.bearingInRadians), o = i.zoom + ri(i.center.lat, 0), a = t.bc(1 / ii(i.center.lat), 1 / ii(Math.min(Math.abs(i.center.lat), 60)), t.bf(o, 7, 3, 0, 1)), s = 360 / Qt({
                worldSize: i.worldSize,
                center: {
                    lat: i.center.lat
                }
            });
            return new t.Q(i.center.lng - r.x * s * a, t.ae(i.center.lat + r.y * s, -85.051129, t.aJ));
        }
        function ai(e) {
            const t = .5 * e, i = Math.sin(t), r = Math.cos(t);
            return Math.log(i + r) - Math.log(r - i);
        }
        function si(e, i, r, o) {
            const a = e.lat + r * o;
            if (Math.abs(r) > 1) {
                const s = (Math.sign(e.lat + r) !== Math.sign(e.lat) ? -Math.abs(e.lat) : Math.abs(e.lat)) * Math.PI / 180, n = Math.abs(e.lat + r) * Math.PI / 180, l = ai(s + o * (n - s)), c = ai(s), h = ai(n);
                return new t.Q(e.lng + i * ((l - c) / (h - c)), a);
            }
            return new t.Q(e.lng + i * o, a);
        }
        class ni {
            constructor(e){
                this._cachePrevious = new Map, this._cache = new Map, this._hadAnyChanges = !1, this._aabbFactory = e;
            }
            recalculateCache() {
                if (!this._hadAnyChanges) return;
                const e = this._cachePrevious;
                this._cachePrevious = this._cache, this._cache = e, this._cache.clear(), this._hadAnyChanges = !1;
            }
            getTileAABB(e, t, i, r) {
                const o = `${e.z}_${e.x}_${e.y}`, a = this._cache.get(o);
                if (a) return a;
                const s = this._cachePrevious.get(o);
                if (s) return this._cache.set(o, s), s;
                const n = this._aabbFactory(e, t, i, r);
                return this._cache.set(o, n), this._hadAnyChanges = !0, n;
            }
        }
        function li(e, t, i) {
            const r = e - t;
            return r < 0 ? -r : Math.max(0, r - i);
        }
        function ci(e, t, i, r, o) {
            const a = e - i;
            let s;
            return s = a < 0 ? Math.min(-a, 1 + a - o) : a > 1 ? Math.min(Math.max(a - o, 0), 1 - a) : 0, Math.max(s, li(t, r, o));
        }
        class hi {
            constructor(){
                this._aabbCache = new ni(this._computeTileAABB);
            }
            recalculateCache() {
                this._aabbCache.recalculateCache();
            }
            distanceToTile2d(e, t, i, r) {
                const o = 1 << i.z, a = 1 / o, s = i.x / o, n = i.y / o;
                let l = 2;
                return l = Math.min(l, ci(e, t, s, n, a)), l = Math.min(l, ci(e, t, s + .5, -n - a, a)), l = Math.min(l, ci(e, t, s + .5, 2 - n - a, a)), l;
            }
            getWrap(e, t, i) {
                const r = 1 << t.z, o = 1 / r, a = t.x / r, s = li(e.x, a, o), n = li(e.x, a - 1, o), l = li(e.x, a + 1, o), c = Math.min(s, n, l);
                return c === l ? 1 : c === n ? -1 : 0;
            }
            allowVariableZoom(e, t) {
                return he(e, t) > 4;
            }
            allowWorldCopies() {
                return !1;
            }
            getTileAABB(e, t, i, r) {
                return this._aabbCache.getTileAABB(e, t, i, r);
            }
            _computeTileAABB(e, i, r, o) {
                if (e.z <= 0) return new Et([
                    -1,
                    -1,
                    -1
                ], [
                    1,
                    1,
                    1
                ]);
                if (1 === e.z) return new Et([
                    0 === e.x ? -1 : 0,
                    0 === e.y ? 0 : -1,
                    -1
                ], [
                    0 === e.x ? 0 : 1,
                    0 === e.y ? 1 : 0,
                    1
                ]);
                {
                    const i = [
                        Yt(0, 0, e.x, e.y, e.z),
                        Yt(t.Z, 0, e.x, e.y, e.z),
                        Yt(t.Z, t.Z, e.x, e.y, e.z),
                        Yt(0, t.Z, e.x, e.y, e.z)
                    ], r = [
                        1,
                        1,
                        1
                    ], o = [
                        -1,
                        -1,
                        -1
                    ];
                    for (const e of i)for(let t = 0; t < 3; t++)r[t] = Math.min(r[t], e[t]), o[t] = Math.max(o[t], e[t]);
                    if (0 === e.y || e.y === (1 << e.z) - 1) {
                        const t = [
                            0,
                            0 === e.y ? 1 : -1,
                            0
                        ];
                        for(let e = 0; e < 3; e++)r[e] = Math.min(r[e], t[e]), o[e] = Math.max(o[e], t[e]);
                    }
                    return new Et(r, o);
                }
            }
        }
        class ui {
            get pixelsToClipSpaceMatrix() {
                return this._helper.pixelsToClipSpaceMatrix;
            }
            get clipSpaceToPixelsMatrix() {
                return this._helper.clipSpaceToPixelsMatrix;
            }
            get pixelsToGLUnits() {
                return this._helper.pixelsToGLUnits;
            }
            get centerOffset() {
                return this._helper.centerOffset;
            }
            get size() {
                return this._helper.size;
            }
            get rotationMatrix() {
                return this._helper.rotationMatrix;
            }
            get centerPoint() {
                return this._helper.centerPoint;
            }
            get pixelsPerMeter() {
                return this._helper.pixelsPerMeter;
            }
            setMinZoom(e) {
                this._helper.setMinZoom(e);
            }
            setMaxZoom(e) {
                this._helper.setMaxZoom(e);
            }
            setMinPitch(e) {
                this._helper.setMinPitch(e);
            }
            setMaxPitch(e) {
                this._helper.setMaxPitch(e);
            }
            setRenderWorldCopies(e) {
                this._helper.setRenderWorldCopies(e);
            }
            setBearing(e) {
                this._helper.setBearing(e);
            }
            setPitch(e) {
                this._helper.setPitch(e);
            }
            setRoll(e) {
                this._helper.setRoll(e);
            }
            setFov(e) {
                this._helper.setFov(e);
            }
            setZoom(e) {
                this._helper.setZoom(e);
            }
            setCenter(e) {
                this._helper.setCenter(e);
            }
            setElevation(e) {
                this._helper.setElevation(e);
            }
            setMinElevationForCurrentTile(e) {
                this._helper.setMinElevationForCurrentTile(e);
            }
            setPadding(e) {
                this._helper.setPadding(e);
            }
            interpolatePadding(e, t, i) {
                return this._helper.interpolatePadding(e, t, i);
            }
            isPaddingEqual(e) {
                return this._helper.isPaddingEqual(e);
            }
            resize(e, t) {
                this._helper.resize(e, t);
            }
            getMaxBounds() {
                return this._helper.getMaxBounds();
            }
            setMaxBounds(e) {
                this._helper.setMaxBounds(e);
            }
            overrideNearFarZ(e, t) {
                this._helper.overrideNearFarZ(e, t);
            }
            clearNearFarZOverride() {
                this._helper.clearNearFarZOverride();
            }
            getCameraQueryGeometry(e) {
                return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e);
            }
            get tileSize() {
                return this._helper.tileSize;
            }
            get tileZoom() {
                return this._helper.tileZoom;
            }
            get scale() {
                return this._helper.scale;
            }
            get worldSize() {
                return this._helper.worldSize;
            }
            get width() {
                return this._helper.width;
            }
            get height() {
                return this._helper.height;
            }
            get lngRange() {
                return this._helper.lngRange;
            }
            get latRange() {
                return this._helper.latRange;
            }
            get minZoom() {
                return this._helper.minZoom;
            }
            get maxZoom() {
                return this._helper.maxZoom;
            }
            get zoom() {
                return this._helper.zoom;
            }
            get center() {
                return this._helper.center;
            }
            get minPitch() {
                return this._helper.minPitch;
            }
            get maxPitch() {
                return this._helper.maxPitch;
            }
            get pitch() {
                return this._helper.pitch;
            }
            get pitchInRadians() {
                return this._helper.pitchInRadians;
            }
            get roll() {
                return this._helper.roll;
            }
            get rollInRadians() {
                return this._helper.rollInRadians;
            }
            get bearing() {
                return this._helper.bearing;
            }
            get bearingInRadians() {
                return this._helper.bearingInRadians;
            }
            get fov() {
                return this._helper.fov;
            }
            get fovInRadians() {
                return this._helper.fovInRadians;
            }
            get elevation() {
                return this._helper.elevation;
            }
            get minElevationForCurrentTile() {
                return this._helper.minElevationForCurrentTile;
            }
            get padding() {
                return this._helper.padding;
            }
            get unmodified() {
                return this._helper.unmodified;
            }
            get renderWorldCopies() {
                return this._helper.renderWorldCopies;
            }
            get nearZ() {
                return this._helper.nearZ;
            }
            get farZ() {
                return this._helper.farZ;
            }
            get autoCalculateNearFarZ() {
                return this._helper.autoCalculateNearFarZ;
            }
            setTransitionState(e) {}
            constructor(){
                this._cachedClippingPlane = t.bh(), this._projectionMatrix = t.b1(), this._globeViewProjMatrix32f = t.b0(), this._globeViewProjMatrixNoCorrection = t.b1(), this._globeViewProjMatrixNoCorrectionInverted = t.b1(), this._globeProjMatrixInverted = t.b1(), this._cameraPosition = t.bi(), this._globeLatitudeErrorCorrectionRadians = 0, this._helper = new Mt({
                    calcMatrices: ()=>{
                        this._calcMatrices();
                    },
                    getConstrained: (e, t)=>this.getConstrained(e, t)
                }), this._coveringTilesDetailsProvider = new hi;
            }
            clone() {
                const e = new ui;
                return e.apply(this), e;
            }
            apply(e, t) {
                this._globeLatitudeErrorCorrectionRadians = t || 0, this._helper.apply(e);
            }
            get projectionMatrix() {
                return this._projectionMatrix;
            }
            get modelViewProjectionMatrix() {
                return this._globeViewProjMatrixNoCorrection;
            }
            get inverseProjectionMatrix() {
                return this._globeProjMatrixInverted;
            }
            get cameraPosition() {
                const e = t.bi();
                return e[0] = this._cameraPosition[0], e[1] = this._cameraPosition[1], e[2] = this._cameraPosition[2], e;
            }
            get cameraToCenterDistance() {
                return this._helper.cameraToCenterDistance;
            }
            getProjectionData(e) {
                const { overscaledTileID: t, applyGlobeMatrix: i } = e, r = this._helper.getMercatorTileCoordinates(t);
                return {
                    mainMatrix: this._globeViewProjMatrix32f,
                    tileMercatorCoords: r,
                    clippingPlane: this._cachedClippingPlane,
                    projectionTransition: i ? 1 : 0,
                    fallbackMatrix: this._globeViewProjMatrix32f
                };
            }
            _computeClippingPlane(e) {
                const i = this.pitchInRadians, r = this.cameraToCenterDistance / e, o = Math.sin(i) * r, a = Math.cos(i) * r + 1, s = 1 / Math.sqrt(o * o + a * a) * 1;
                let n = -o, l = a;
                const c = Math.sqrt(n * n + l * l);
                n /= c, l /= c;
                const h = [
                    0,
                    n,
                    l
                ];
                return t.bj(h, h, [
                    0,
                    0,
                    0
                ], -this.bearingInRadians), t.bk(h, h, [
                    0,
                    0,
                    0
                ], -1 * this.center.lat * Math.PI / 180), t.bl(h, h, [
                    0,
                    0,
                    0
                ], this.center.lng * Math.PI / 180), t.aO(h, h, .25), [
                    ...h,
                    .25 * -s
                ];
            }
            isLocationOccluded(e) {
                return !this.isSurfacePointVisible(Jt(e));
            }
            transformLightDirection(e) {
                const i = this._helper._center.lng * Math.PI / 180, r = this._helper._center.lat * Math.PI / 180, o = Math.cos(r), a = [
                    Math.sin(i) * o,
                    Math.sin(r),
                    Math.cos(i) * o
                ], s = [
                    a[2],
                    0,
                    -a[0]
                ], n = [
                    0,
                    0,
                    0
                ];
                t.aU(n, s, a), t.aT(s, s), t.aT(n, n);
                const l = [
                    0,
                    0,
                    0
                ];
                return t.aT(l, [
                    s[0] * e[0] + n[0] * e[1] + a[0] * e[2],
                    s[1] * e[0] + n[1] * e[1] + a[1] * e[2],
                    s[2] * e[0] + n[2] * e[1] + a[2] * e[2]
                ]), l;
            }
            getPixelScale() {
                return 1 / Math.cos(this._helper._center.lat * Math.PI / 180);
            }
            getCircleRadiusCorrection() {
                return Math.cos(this._helper._center.lat * Math.PI / 180);
            }
            getPitchedTextCorrection(e, i, r) {
                const o = function(e, i, r) {
                    const o = 1 / (1 << r.z);
                    return new t.$(e / t.Z * o + r.x * o, i / t.Z * o + r.y * o);
                }(e, i, r.canonical), a = (s = o.y, [
                    t.bg(o.x * Math.PI * 2 + Math.PI, 2 * Math.PI),
                    2 * Math.atan(Math.exp(Math.PI - s * Math.PI * 2)) - .5 * Math.PI
                ]);
                var s;
                return this.getCircleRadiusCorrection() / Math.cos(a[1]);
            }
            projectTileCoordinates(e, i, r, o) {
                const a = r.canonical, s = Yt(e, i, a.x, a.y, a.z), n = 1 + (o ? o(e, i) : 0) / t.br, l = [
                    s[0] * n,
                    s[1] * n,
                    s[2] * n,
                    1
                ];
                t.ap(l, l, this._globeViewProjMatrixNoCorrection);
                const c = this._cachedClippingPlane, h = c[0] * s[0] + c[1] * s[1] + c[2] * s[2] + c[3] < 0;
                return {
                    point: new t.P(l[0] / l[3], l[1] / l[3]),
                    signedDistanceFromCamera: l[3],
                    isOccluded: h
                };
            }
            _calcMatrices() {
                if (!this._helper._width || !this._helper._height) return;
                const e = ei(this.worldSize, this.center.lat), i = t.b2(), r = t.b2();
                this._helper.autoCalculateNearFarZ && (this._helper._nearZ = .5, this._helper._farZ = this.cameraToCenterDistance + 2 * e), t.aY(i, this.fovInRadians, this.width / this.height, this._helper._nearZ, this._helper._farZ);
                const o = this.centerOffset;
                i[8] = 2 * -o.x / this._helper._width, i[9] = 2 * o.y / this._helper._height, this._projectionMatrix = t.aZ(i), this._globeProjMatrixInverted = t.b2(), t.aj(this._globeProjMatrixInverted, i), t.L(i, i, [
                    0,
                    0,
                    -this.cameraToCenterDistance
                ]), t.a_(i, i, this.rollInRadians), t.a$(i, i, -this.pitchInRadians), t.a_(i, i, this.bearingInRadians), t.L(i, i, [
                    0,
                    0,
                    -e
                ]);
                const a = t.bi();
                a[0] = e, a[1] = e, a[2] = e, t.a$(r, i, this.center.lat * Math.PI / 180), t.bm(r, r, -this.center.lng * Math.PI / 180), t.M(r, r, a), this._globeViewProjMatrixNoCorrection = r, t.a$(i, i, this.center.lat * Math.PI / 180 - this._globeLatitudeErrorCorrectionRadians), t.bm(i, i, -this.center.lng * Math.PI / 180), t.M(i, i, a), this._globeViewProjMatrix32f = new Float32Array(i), this._globeViewProjMatrixNoCorrectionInverted = t.b2(), t.aj(this._globeViewProjMatrixNoCorrectionInverted, r);
                const s = t.bi();
                this._cameraPosition = t.bi(), this._cameraPosition[2] = this.cameraToCenterDistance / e, t.bj(this._cameraPosition, this._cameraPosition, s, -this.rollInRadians), t.bk(this._cameraPosition, this._cameraPosition, s, this.pitchInRadians), t.bj(this._cameraPosition, this._cameraPosition, s, -this.bearingInRadians), t.aP(this._cameraPosition, this._cameraPosition, [
                    0,
                    0,
                    1
                ]), t.bk(this._cameraPosition, this._cameraPosition, s, -this.center.lat * Math.PI / 180), t.bl(this._cameraPosition, this._cameraPosition, s, this.center.lng * Math.PI / 180), this._cachedClippingPlane = this._computeClippingPlane(e);
                const n = t.aZ(this._globeViewProjMatrixNoCorrectionInverted);
                t.M(n, n, [
                    1,
                    1,
                    -1
                ]), this._cachedFrustum = Rt.fromInvProjectionMatrix(n);
            }
            calculateFogMatrix(e) {
                t.w("calculateFogMatrix is not supported on globe projection.");
                const i = t.b2();
                return t.at(i), i;
            }
            getVisibleUnwrappedCoordinates(e) {
                return [
                    new t.aW(0, e)
                ];
            }
            getCameraFrustum() {
                return this._cachedFrustum;
            }
            getClippingPlane() {
                return this._cachedClippingPlane;
            }
            getCoveringTilesDetailsProvider() {
                return this._coveringTilesDetailsProvider;
            }
            recalculateZoomAndCenter(e) {
                e && t.w("terrain is not fully supported on vertical perspective projection."), this._helper.recalculateZoomAndCenter(0);
            }
            maxPitchScaleFactor() {
                return 1;
            }
            getCameraPoint() {
                return this._helper.getCameraPoint();
            }
            getCameraAltitude() {
                return this._helper.getCameraAltitude();
            }
            getCameraLngLat() {
                return this._helper.getCameraLngLat();
            }
            lngLatToCameraDepth(e, i) {
                if (!this._globeViewProjMatrixNoCorrection) return 1;
                const r = Jt(e);
                t.aO(r, r, 1 + i / t.br);
                const o = t.bh();
                return t.ap(o, [
                    r[0],
                    r[1],
                    r[2],
                    1
                ], this._globeViewProjMatrixNoCorrection), o[2] / o[3];
            }
            populateCache(e) {}
            getBounds() {
                const e = .5 * this.width, i = .5 * this.height, r = [
                    new t.P(0, 0),
                    new t.P(e, 0),
                    new t.P(this.width, 0),
                    new t.P(this.width, i),
                    new t.P(this.width, this.height),
                    new t.P(e, this.height),
                    new t.P(0, this.height),
                    new t.P(0, i)
                ], o = [];
                for (const e of r)o.push(this.unprojectScreenPoint(e));
                let a = 0, s = 0, n = 0, l = 0;
                const c = this.center;
                for (const e of o){
                    const i = t.bn(c.lng, e.lng), r = t.bn(c.lat, e.lat);
                    i < s && (s = i), i > a && (a = i), r < l && (l = r), r > n && (n = r);
                }
                const h = [
                    c.lng + s,
                    c.lat + l,
                    c.lng + a,
                    c.lat + n
                ];
                return this.isSurfacePointOnScreen([
                    0,
                    1,
                    0
                ]) && (h[3] = 90, h[0] = -180, h[2] = 180), this.isSurfacePointOnScreen([
                    0,
                    -1,
                    0
                ]) && (h[1] = -90, h[0] = -180, h[2] = 180), new V(h);
            }
            getConstrained(e, i) {
                const r = t.ae(e.lat, -85.051129, t.aJ), o = t.ae(+i, this.minZoom + ri(0, r), this.maxZoom);
                return {
                    center: new t.Q(e.lng, r),
                    zoom: o
                };
            }
            calculateCenterFromCameraLngLatAlt(e, t, i, r) {
                return this._helper.calculateCenterFromCameraLngLatAlt(e, t, i, r);
            }
            setLocationAtPoint(e, i) {
                const r = Jt(this.unprojectScreenPoint(i)), o = Jt(e), a = t.bi();
                t.bo(a);
                const s = t.bi();
                t.bl(s, r, a, -this.center.lng * Math.PI / 180), t.bk(s, s, a, this.center.lat * Math.PI / 180);
                const n = o[0] * o[0] + o[2] * o[2], l = s[0] * s[0];
                if (n < l) return;
                const c = Math.sqrt(n - l), h = -c, u = t.bp(o[0], o[2], s[0], c), d = t.bp(o[0], o[2], s[0], h), _ = t.bi();
                t.bl(_, o, a, -u);
                const p = t.bp(_[1], _[2], s[1], s[2]), m = t.bi();
                t.bl(m, o, a, -d);
                const f = t.bp(m[1], m[2], s[1], s[2]), g = .5 * Math.PI, v = p >= -g && p <= g, x = f >= -g && f <= g;
                let b, y;
                if (v && x) {
                    const e = this.center.lng * Math.PI / 180, i = this.center.lat * Math.PI / 180;
                    t.bs(u, e) + t.bs(p, i) < t.bs(d, e) + t.bs(f, i) ? (b = u, y = p) : (b = d, y = f);
                } else if (v) b = u, y = p;
                else {
                    if (!x) return;
                    b = d, y = f;
                }
                const w = b / Math.PI * 180, T = y / Math.PI * 180, P = this.center.lat;
                this.setCenter(new t.Q(w, t.ae(T, -90, 90))), this.setZoom(this.zoom + ri(P, this.center.lat));
            }
            locationToScreenPoint(e, i) {
                const r = Jt(e);
                if (i) {
                    const o = i.getElevationForLngLatZoom(e, this._helper._tileZoom);
                    t.aO(r, r, 1 + o / t.br);
                }
                return this._projectSurfacePointToScreen(r);
            }
            _projectSurfacePointToScreen(e) {
                const i = t.bh();
                return t.ap(i, [
                    ...e,
                    1
                ], this._globeViewProjMatrixNoCorrection), i[0] /= i[3], i[1] /= i[3], new t.P((.5 * i[0] + .5) * this.width, (.5 * -i[1] + .5) * this.height);
            }
            screenPointToMercatorCoordinate(e, i) {
                if (i) {
                    const t = i.pointCoordinate(e);
                    if (t) return t;
                }
                return t.$.fromLngLat(this.unprojectScreenPoint(e));
            }
            screenPointToLocation(e, t) {
                var i;
                return null === (i = this.screenPointToMercatorCoordinate(e, t)) || void 0 === i ? void 0 : i.toLngLat();
            }
            isPointOnMapSurface(e, t) {
                const i = this._cameraPosition, r = this.getRayDirectionFromPixel(e);
                return !!this.rayPlanetIntersection(i, r);
            }
            getRayDirectionFromPixel(e) {
                const i = t.bh();
                i[0] = e.x / this.width * 2 - 1, i[1] = -1 * (e.y / this.height * 2 - 1), i[2] = 1, i[3] = 1, t.ap(i, i, this._globeViewProjMatrixNoCorrectionInverted), i[0] /= i[3], i[1] /= i[3], i[2] /= i[3];
                const r = t.bi();
                r[0] = i[0] - this._cameraPosition[0], r[1] = i[1] - this._cameraPosition[1], r[2] = i[2] - this._cameraPosition[2];
                const o = t.bi();
                return t.aT(o, r), o;
            }
            isSurfacePointVisible(e) {
                const t = this._cachedClippingPlane;
                return t[0] * e[0] + t[1] * e[1] + t[2] * e[2] + t[3] >= 0;
            }
            isSurfacePointOnScreen(e) {
                if (!this.isSurfacePointVisible(e)) return !1;
                const i = t.bh();
                return t.ap(i, [
                    ...e,
                    1
                ], this._globeViewProjMatrixNoCorrection), i[0] /= i[3], i[1] /= i[3], i[2] /= i[3], i[0] > -1 && i[0] < 1 && i[1] > -1 && i[1] < 1 && i[2] > -1 && i[2] < 1;
            }
            rayPlanetIntersection(e, i) {
                const r = t.aV(e, i), o = t.bi(), a = t.bi();
                t.aO(a, i, r), t.aS(o, e, a);
                const s = 1 - t.aV(o, o);
                if (s < 0) return null;
                const n = t.aV(e, e) - 1, l = -r + (r < 0 ? 1 : -1) * Math.sqrt(s), c = n / l, h = l;
                return {
                    tMin: Math.min(c, h),
                    tMax: Math.max(c, h)
                };
            }
            unprojectScreenPoint(e) {
                const i = this._cameraPosition, r = this.getRayDirectionFromPixel(e), o = this.rayPlanetIntersection(i, r);
                if (o) {
                    const e = t.bi();
                    t.aP(e, i, [
                        r[0] * o.tMin,
                        r[1] * o.tMin,
                        r[2] * o.tMin
                    ]);
                    const a = t.bi();
                    return t.aT(a, e), ti(a);
                }
                const a = this._cachedClippingPlane[0] * r[0] + this._cachedClippingPlane[1] * r[1] + this._cachedClippingPlane[2] * r[2], s = -t.bq(this._cachedClippingPlane, i) / a, n = t.bi();
                if (s > 0) t.aP(n, i, [
                    r[0] * s,
                    r[1] * s,
                    r[2] * s
                ]);
                else {
                    const e = t.bi();
                    t.aP(e, i, [
                        2 * r[0],
                        2 * r[1],
                        2 * r[2]
                    ]);
                    const o = t.bq(this._cachedClippingPlane, e);
                    t.aS(n, e, [
                        this._cachedClippingPlane[0] * o,
                        this._cachedClippingPlane[1] * o,
                        this._cachedClippingPlane[2] * o
                    ]);
                }
                const l = t.bi();
                return t.aT(l, n), ti(l);
            }
            getMatrixForModel(e, i) {
                const r = t.Q.convert(e), o = 1 / t.br, a = t.b1();
                return t.bm(a, a, r.lng / 180 * Math.PI), t.a$(a, a, -r.lat / 180 * Math.PI), t.L(a, a, [
                    0,
                    0,
                    1 + i / t.br
                ]), t.a$(a, a, .5 * Math.PI), t.M(a, a, [
                    o,
                    o,
                    o
                ]), a;
            }
            getProjectionDataForCustomLayer(e = !0) {
                const i = this.getProjectionData({
                    overscaledTileID: new t.Y(0, 0, 0, 0, 0),
                    applyGlobeMatrix: e
                });
                return i.tileMercatorCoords = [
                    0,
                    0,
                    1,
                    1
                ], i;
            }
            getFastPathSimpleProjectionMatrix(e) {}
        }
        class di {
            get pixelsToClipSpaceMatrix() {
                return this._helper.pixelsToClipSpaceMatrix;
            }
            get clipSpaceToPixelsMatrix() {
                return this._helper.clipSpaceToPixelsMatrix;
            }
            get pixelsToGLUnits() {
                return this._helper.pixelsToGLUnits;
            }
            get centerOffset() {
                return this._helper.centerOffset;
            }
            get size() {
                return this._helper.size;
            }
            get rotationMatrix() {
                return this._helper.rotationMatrix;
            }
            get centerPoint() {
                return this._helper.centerPoint;
            }
            get pixelsPerMeter() {
                return this._helper.pixelsPerMeter;
            }
            setMinZoom(e) {
                this._helper.setMinZoom(e);
            }
            setMaxZoom(e) {
                this._helper.setMaxZoom(e);
            }
            setMinPitch(e) {
                this._helper.setMinPitch(e);
            }
            setMaxPitch(e) {
                this._helper.setMaxPitch(e);
            }
            setRenderWorldCopies(e) {
                this._helper.setRenderWorldCopies(e);
            }
            setBearing(e) {
                this._helper.setBearing(e);
            }
            setPitch(e) {
                this._helper.setPitch(e);
            }
            setRoll(e) {
                this._helper.setRoll(e);
            }
            setFov(e) {
                this._helper.setFov(e);
            }
            setZoom(e) {
                this._helper.setZoom(e);
            }
            setCenter(e) {
                this._helper.setCenter(e);
            }
            setElevation(e) {
                this._helper.setElevation(e);
            }
            setMinElevationForCurrentTile(e) {
                this._helper.setMinElevationForCurrentTile(e);
            }
            setPadding(e) {
                this._helper.setPadding(e);
            }
            interpolatePadding(e, t, i) {
                return this._helper.interpolatePadding(e, t, i);
            }
            isPaddingEqual(e) {
                return this._helper.isPaddingEqual(e);
            }
            resize(e, t, i = !0) {
                this._helper.resize(e, t, i);
            }
            getMaxBounds() {
                return this._helper.getMaxBounds();
            }
            setMaxBounds(e) {
                this._helper.setMaxBounds(e);
            }
            overrideNearFarZ(e, t) {
                this._helper.overrideNearFarZ(e, t);
            }
            clearNearFarZOverride() {
                this._helper.clearNearFarZOverride();
            }
            getCameraQueryGeometry(e) {
                return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e);
            }
            get tileSize() {
                return this._helper.tileSize;
            }
            get tileZoom() {
                return this._helper.tileZoom;
            }
            get scale() {
                return this._helper.scale;
            }
            get worldSize() {
                return this._helper.worldSize;
            }
            get width() {
                return this._helper.width;
            }
            get height() {
                return this._helper.height;
            }
            get lngRange() {
                return this._helper.lngRange;
            }
            get latRange() {
                return this._helper.latRange;
            }
            get minZoom() {
                return this._helper.minZoom;
            }
            get maxZoom() {
                return this._helper.maxZoom;
            }
            get zoom() {
                return this._helper.zoom;
            }
            get center() {
                return this._helper.center;
            }
            get minPitch() {
                return this._helper.minPitch;
            }
            get maxPitch() {
                return this._helper.maxPitch;
            }
            get pitch() {
                return this._helper.pitch;
            }
            get pitchInRadians() {
                return this._helper.pitchInRadians;
            }
            get roll() {
                return this._helper.roll;
            }
            get rollInRadians() {
                return this._helper.rollInRadians;
            }
            get bearing() {
                return this._helper.bearing;
            }
            get bearingInRadians() {
                return this._helper.bearingInRadians;
            }
            get fov() {
                return this._helper.fov;
            }
            get fovInRadians() {
                return this._helper.fovInRadians;
            }
            get elevation() {
                return this._helper.elevation;
            }
            get minElevationForCurrentTile() {
                return this._helper.minElevationForCurrentTile;
            }
            get padding() {
                return this._helper.padding;
            }
            get unmodified() {
                return this._helper.unmodified;
            }
            get renderWorldCopies() {
                return this._helper.renderWorldCopies;
            }
            get cameraToCenterDistance() {
                return this._helper.cameraToCenterDistance;
            }
            get nearZ() {
                return this._helper.nearZ;
            }
            get farZ() {
                return this._helper.farZ;
            }
            get autoCalculateNearFarZ() {
                return this._helper.autoCalculateNearFarZ;
            }
            get isGlobeRendering() {
                return this._globeness > 0;
            }
            setTransitionState(e, t) {
                this._globeness = e, this._globeLatitudeErrorCorrectionRadians = t, this._calcMatrices(), this._verticalPerspectiveTransform.getCoveringTilesDetailsProvider().recalculateCache(), this._mercatorTransform.getCoveringTilesDetailsProvider().recalculateCache();
            }
            get currentTransform() {
                return this.isGlobeRendering ? this._verticalPerspectiveTransform : this._mercatorTransform;
            }
            constructor(){
                this._globeLatitudeErrorCorrectionRadians = 0, this._globeness = 1, this._helper = new Mt({
                    calcMatrices: ()=>{
                        this._calcMatrices();
                    },
                    getConstrained: (e, t)=>this.getConstrained(e, t)
                }), this._globeness = 1, this._mercatorTransform = new Dt, this._verticalPerspectiveTransform = new ui;
            }
            clone() {
                const e = new di;
                return e._globeness = this._globeness, e._globeLatitudeErrorCorrectionRadians = this._globeLatitudeErrorCorrectionRadians, e.apply(this), e;
            }
            apply(e) {
                this._helper.apply(e), this._mercatorTransform.apply(this), this._verticalPerspectiveTransform.apply(this, this._globeLatitudeErrorCorrectionRadians);
            }
            get projectionMatrix() {
                return this.currentTransform.projectionMatrix;
            }
            get modelViewProjectionMatrix() {
                return this.currentTransform.modelViewProjectionMatrix;
            }
            get inverseProjectionMatrix() {
                return this.currentTransform.inverseProjectionMatrix;
            }
            get cameraPosition() {
                return this.currentTransform.cameraPosition;
            }
            getProjectionData(e) {
                const t = this._mercatorTransform.getProjectionData(e), i = this._verticalPerspectiveTransform.getProjectionData(e);
                return {
                    mainMatrix: this.isGlobeRendering ? i.mainMatrix : t.mainMatrix,
                    clippingPlane: i.clippingPlane,
                    tileMercatorCoords: i.tileMercatorCoords,
                    projectionTransition: e.applyGlobeMatrix ? this._globeness : 0,
                    fallbackMatrix: t.fallbackMatrix
                };
            }
            isLocationOccluded(e) {
                return this.currentTransform.isLocationOccluded(e);
            }
            transformLightDirection(e) {
                return this.currentTransform.transformLightDirection(e);
            }
            getPixelScale() {
                return t.bc(this._mercatorTransform.getPixelScale(), this._verticalPerspectiveTransform.getPixelScale(), this._globeness);
            }
            getCircleRadiusCorrection() {
                return t.bc(this._mercatorTransform.getCircleRadiusCorrection(), this._verticalPerspectiveTransform.getCircleRadiusCorrection(), this._globeness);
            }
            getPitchedTextCorrection(e, i, r) {
                const o = this._mercatorTransform.getPitchedTextCorrection(e, i, r), a = this._verticalPerspectiveTransform.getPitchedTextCorrection(e, i, r);
                return t.bc(o, a, this._globeness);
            }
            projectTileCoordinates(e, t, i, r) {
                return this.currentTransform.projectTileCoordinates(e, t, i, r);
            }
            _calcMatrices() {
                this._helper._width && this._helper._height && (this._verticalPerspectiveTransform.apply(this, this._globeLatitudeErrorCorrectionRadians), this._helper._nearZ = this._verticalPerspectiveTransform.nearZ, this._helper._farZ = this._verticalPerspectiveTransform.farZ, this._mercatorTransform.apply(this, !0, this.isGlobeRendering), this._helper._nearZ = this._mercatorTransform.nearZ, this._helper._farZ = this._mercatorTransform.farZ);
            }
            calculateFogMatrix(e) {
                return this.currentTransform.calculateFogMatrix(e);
            }
            getVisibleUnwrappedCoordinates(e) {
                return this.currentTransform.getVisibleUnwrappedCoordinates(e);
            }
            getCameraFrustum() {
                return this.currentTransform.getCameraFrustum();
            }
            getClippingPlane() {
                return this.currentTransform.getClippingPlane();
            }
            getCoveringTilesDetailsProvider() {
                return this.currentTransform.getCoveringTilesDetailsProvider();
            }
            recalculateZoomAndCenter(e) {
                this._mercatorTransform.recalculateZoomAndCenter(e), this._verticalPerspectiveTransform.recalculateZoomAndCenter(e);
            }
            maxPitchScaleFactor() {
                return this._mercatorTransform.maxPitchScaleFactor();
            }
            getCameraPoint() {
                return this._helper.getCameraPoint();
            }
            getCameraAltitude() {
                return this._helper.getCameraAltitude();
            }
            getCameraLngLat() {
                return this._helper.getCameraLngLat();
            }
            lngLatToCameraDepth(e, t) {
                return this.currentTransform.lngLatToCameraDepth(e, t);
            }
            populateCache(e) {
                this._mercatorTransform.populateCache(e), this._verticalPerspectiveTransform.populateCache(e);
            }
            getBounds() {
                return this.currentTransform.getBounds();
            }
            getConstrained(e, t) {
                return this.currentTransform.getConstrained(e, t);
            }
            calculateCenterFromCameraLngLatAlt(e, t, i, r) {
                return this._helper.calculateCenterFromCameraLngLatAlt(e, t, i, r);
            }
            setLocationAtPoint(e, t) {
                if (!this.isGlobeRendering) return this._mercatorTransform.setLocationAtPoint(e, t), void this.apply(this._mercatorTransform);
                this._verticalPerspectiveTransform.setLocationAtPoint(e, t), this.apply(this._verticalPerspectiveTransform);
            }
            locationToScreenPoint(e, t) {
                return this.currentTransform.locationToScreenPoint(e, t);
            }
            screenPointToMercatorCoordinate(e, t) {
                return this.currentTransform.screenPointToMercatorCoordinate(e, t);
            }
            screenPointToLocation(e, t) {
                return this.currentTransform.screenPointToLocation(e, t);
            }
            isPointOnMapSurface(e, t) {
                return this.currentTransform.isPointOnMapSurface(e, t);
            }
            getRayDirectionFromPixel(e) {
                return this._verticalPerspectiveTransform.getRayDirectionFromPixel(e);
            }
            getMatrixForModel(e, t) {
                return this.currentTransform.getMatrixForModel(e, t);
            }
            getProjectionDataForCustomLayer(e = !0) {
                const t = this._mercatorTransform.getProjectionDataForCustomLayer(e);
                if (!this.isGlobeRendering) return t;
                const i = this._verticalPerspectiveTransform.getProjectionDataForCustomLayer(e);
                return i.fallbackMatrix = t.mainMatrix, i;
            }
            getFastPathSimpleProjectionMatrix(e) {
                return this.currentTransform.getFastPathSimpleProjectionMatrix(e);
            }
        }
        class _i {
            get useGlobeControls() {
                return !0;
            }
            handlePanInertia(e, i) {
                const r = oi(e, i);
                return Math.abs(r.lng - i.center.lng) > 180 && (r.lng = i.center.lng + 179.5 * Math.sign(r.lng - i.center.lng)), {
                    easingCenter: r,
                    easingOffset: new t.P(0, 0)
                };
            }
            handleMapControlsRollPitchBearingZoom(e, i) {
                const r = e.around, o = i.screenPointToLocation(r);
                e.bearingDelta && i.setBearing(i.bearing + e.bearingDelta), e.pitchDelta && i.setPitch(i.pitch + e.pitchDelta), e.rollDelta && i.setRoll(i.roll + e.rollDelta);
                const a = i.zoom;
                e.zoomDelta && i.setZoom(i.zoom + e.zoomDelta);
                const s = i.zoom - a;
                if (0 === s) return;
                const n = t.bn(i.center.lng, o.lng), l = n / (Math.abs(n / 180) + 1), c = t.bn(i.center.lat, o.lat), h = i.getRayDirectionFromPixel(r), u = i.cameraPosition, d = -1 * t.aV(u, h), _ = t.bi();
                t.aP(_, u, [
                    h[0] * d,
                    h[1] * d,
                    h[2] * d
                ]);
                const p = t.bt(_) - 1, m = Math.exp(.5 * -Math.max(p - .3, 0)), f = ei(i.worldSize, i.center.lat) / Math.min(i.width, i.height), g = t.bf(f, .9, .5, 1, .25), v = (1 - t.aI(-s)) * Math.min(m, g), x = i.center.lat, b = i.zoom, y = new t.Q(i.center.lng + l * v, t.ae(i.center.lat + c * v, -85.051129, t.aJ));
                i.setLocationAtPoint(o, r);
                const w = i.center, T = t.bf(Math.abs(n), 45, 85, 0, 1), P = t.bf(f, .75, .35, 0, 1), C = Math.pow(Math.max(T, P), .25), I = t.bn(w.lng, y.lng), M = t.bn(w.lat, y.lat);
                i.setCenter(new t.Q(w.lng + I * C, w.lat + M * C).wrap()), i.setZoom(b + ri(x, i.center.lat));
            }
            handleMapControlsPan(e, t, i) {
                if (!e.panDelta) return;
                const r = t.center.lat, o = t.zoom;
                t.setCenter(oi(e.panDelta, t).wrap()), t.setZoom(o + ri(r, t.center.lat));
            }
            cameraForBoxAndBearing(e, i, r, o, a) {
                const s = Lt(e, i, r, o, a), n = i.left / a.width * 2 - 1, l = (a.width - i.right) / a.width * 2 - 1, c = i.top / a.height * -2 + 1, h = (a.height - i.bottom) / a.height * -2 + 1, u = t.bn(r.getWest(), r.getEast()) < 0, d = u ? r.getEast() : r.getWest(), _ = u ? r.getWest() : r.getEast(), p = Math.max(r.getNorth(), r.getSouth()), m = Math.min(r.getNorth(), r.getSouth()), f = d + .5 * t.bn(d, _), g = p + .5 * t.bn(p, m), v = a.clone();
                v.setCenter(s.center), v.setBearing(s.bearing), v.setPitch(0), v.setRoll(0), v.setZoom(s.zoom);
                const x = v.modelViewProjectionMatrix, b = [
                    Jt(r.getNorthWest()),
                    Jt(r.getNorthEast()),
                    Jt(r.getSouthWest()),
                    Jt(r.getSouthEast()),
                    Jt(new t.Q(_, g)),
                    Jt(new t.Q(d, g)),
                    Jt(new t.Q(f, p)),
                    Jt(new t.Q(f, m))
                ], y = Jt(s.center);
                let w = Number.POSITIVE_INFINITY;
                for (const e of b)n < 0 && (w = _i.getLesserNonNegativeNonNull(w, _i.solveVectorScale(e, y, x, "x", n))), l > 0 && (w = _i.getLesserNonNegativeNonNull(w, _i.solveVectorScale(e, y, x, "x", l))), c > 0 && (w = _i.getLesserNonNegativeNonNull(w, _i.solveVectorScale(e, y, x, "y", c))), h < 0 && (w = _i.getLesserNonNegativeNonNull(w, _i.solveVectorScale(e, y, x, "y", h)));
                if (Number.isFinite(w) && 0 !== w) return s.zoom = v.zoom + t.ab(w), s;
                zt();
            }
            handleJumpToCenterZoom(e, i) {
                const r = e.center.lat, o = e.getConstrained(i.center ? t.Q.convert(i.center) : e.center, e.zoom).center;
                e.setCenter(o.wrap());
                const a = void 0 !== i.zoom ? +i.zoom : e.zoom + ri(r, o.lat);
                e.zoom !== a && e.setZoom(a);
            }
            handleEaseTo(e, i) {
                const r = e.zoom, o = e.center, a = e.padding, s = {
                    roll: e.roll,
                    pitch: e.pitch,
                    bearing: e.bearing
                }, n = {
                    roll: void 0 === i.roll ? e.roll : i.roll,
                    pitch: void 0 === i.pitch ? e.pitch : i.pitch,
                    bearing: void 0 === i.bearing ? e.bearing : i.bearing
                }, l = void 0 !== i.zoom, c = !e.isPaddingEqual(i.padding);
                let h = !1;
                const u = i.center ? t.Q.convert(i.center) : o, d = e.getConstrained(u, r).center;
                Ct(e, d);
                const _ = e.clone();
                _.setCenter(d), _.setZoom(l ? +i.zoom : r + ri(o.lat, u.lat)), _.setBearing(i.bearing);
                const p = new t.P(t.ae(e.centerPoint.x + i.offsetAsPoint.x, 0, e.width), t.ae(e.centerPoint.y + i.offsetAsPoint.y, 0, e.height));
                _.setLocationAtPoint(d, p);
                const m = (i.offset && i.offsetAsPoint.mag()) > 0 ? _.center : d, f = l ? +i.zoom : r + ri(o.lat, m.lat), g = r + ri(o.lat, 0), v = f + ri(m.lat, 0), x = t.bn(o.lng, m.lng), b = t.bn(o.lat, m.lat), y = t.aI(v - g);
                return h = f !== r, {
                    easeFunc: (r)=>{
                        if (t.b6(s, n) || At({
                            startEulerAngles: s,
                            endEulerAngles: n,
                            tr: e,
                            k: r,
                            useSlerp: s.roll != n.roll
                        }), c && e.interpolatePadding(a, i.padding, r), i.around) t.w("Easing around a point is not supported under globe projection."), e.setLocationAtPoint(i.around, i.aroundPoint);
                        else {
                            const t = v > g ? Math.min(2, y) : Math.max(.5, y), i = Math.pow(t, 1 - r), a = si(o, x, b, r * i);
                            e.setCenter(a.wrap());
                        }
                        if (h) {
                            const i = t.B.number(g, v, r) + ri(0, e.center.lat);
                            e.setZoom(i);
                        }
                    },
                    isZooming: h,
                    elevationCenter: m
                };
            }
            handleFlyTo(e, i) {
                const r = void 0 !== i.zoom, o = e.center, a = e.zoom, s = e.padding, n = !e.isPaddingEqual(i.padding), l = e.getConstrained(t.Q.convert(i.center || i.locationAtOffset), a).center, c = r ? +i.zoom : e.zoom + ri(e.center.lat, l.lat), h = e.clone();
                h.setCenter(l), h.setZoom(c), h.setBearing(i.bearing);
                const u = new t.P(t.ae(e.centerPoint.x + i.offsetAsPoint.x, 0, e.width), t.ae(e.centerPoint.y + i.offsetAsPoint.y, 0, e.height));
                h.setLocationAtPoint(l, u);
                const d = h.center;
                Ct(e, d);
                const _ = function(e, i, r) {
                    const o = Jt(i), a = Jt(r), s = t.aV(o, a), n = Math.acos(s), l = Qt(e);
                    return n / (2 * Math.PI) * l;
                }(e, o, d), p = a + ri(o.lat, 0), m = c + ri(d.lat, 0), f = t.aI(m - p);
                let g;
                if ("number" == typeof i.minZoom) {
                    const r = +i.minZoom + ri(d.lat, 0), o = Math.min(r, p, m) + ri(0, d.lat), a = e.getConstrained(d, o).zoom + ri(d.lat, 0);
                    g = t.aI(a - p);
                }
                const v = t.bn(o.lng, d.lng), x = t.bn(o.lat, d.lat);
                return {
                    easeFunc: (r, a, l, h)=>{
                        const u = si(o, v, x, l);
                        n && e.interpolatePadding(s, i.padding, r);
                        const _ = 1 === r ? d : u;
                        e.setCenter(_.wrap());
                        const m = p + t.ab(a);
                        e.setZoom(1 === r ? c : m + ri(0, _.lat));
                    },
                    scaleOfZoom: f,
                    targetCenter: d,
                    scaleOfMinZoom: g,
                    pixelPathLength: _
                };
            }
            static solveVectorScale(e, t, i, r, o) {
                const a = "x" === r ? [
                    i[0],
                    i[4],
                    i[8],
                    i[12]
                ] : [
                    i[1],
                    i[5],
                    i[9],
                    i[13]
                ], s = [
                    i[3],
                    i[7],
                    i[11],
                    i[15]
                ], n = e[0] * a[0] + e[1] * a[1] + e[2] * a[2], l = e[0] * s[0] + e[1] * s[1] + e[2] * s[2], c = t[0] * a[0] + t[1] * a[1] + t[2] * a[2], h = t[0] * s[0] + t[1] * s[1] + t[2] * s[2];
                return c + o * l === n + o * h || s[3] * (n - c) + a[3] * (h - l) + n * h == c * l ? null : (c + a[3] - o * h - o * s[3]) / (c - n - o * h + o * l);
            }
            static getLesserNonNegativeNonNull(e, t) {
                return null !== t && t >= 0 && t < e ? t : e;
            }
        }
        class pi {
            constructor(e){
                this._globe = e, this._mercatorCameraHelper = new kt, this._verticalPerspectiveCameraHelper = new _i;
            }
            get useGlobeControls() {
                return this._globe.useGlobeRendering;
            }
            get currentHelper() {
                return this.useGlobeControls ? this._verticalPerspectiveCameraHelper : this._mercatorCameraHelper;
            }
            handlePanInertia(e, t) {
                return this.currentHelper.handlePanInertia(e, t);
            }
            handleMapControlsRollPitchBearingZoom(e, t) {
                return this.currentHelper.handleMapControlsRollPitchBearingZoom(e, t);
            }
            handleMapControlsPan(e, t, i) {
                this.currentHelper.handleMapControlsPan(e, t, i);
            }
            cameraForBoxAndBearing(e, t, i, r, o) {
                return this.currentHelper.cameraForBoxAndBearing(e, t, i, r, o);
            }
            handleJumpToCenterZoom(e, t) {
                this.currentHelper.handleJumpToCenterZoom(e, t);
            }
            handleEaseTo(e, t) {
                return this.currentHelper.handleEaseTo(e, t);
            }
            handleFlyTo(e, t) {
                return this.currentHelper.handleFlyTo(e, t);
            }
        }
        const mi = (e, i)=>t.x(e, i && i.filter((e)=>"source.canvas" !== e.identifier)), fi = t.bu();
        class gi extends t.E {
            constructor(e, i = {}){
                super(), this._rtlPluginLoaded = ()=>{
                    for(const e in this.sourceCaches){
                        const t = this.sourceCaches[e].getSource().type;
                        "vector" !== t && "geojson" !== t || this.sourceCaches[e].reload();
                    }
                }, this.map = e, this.dispatcher = new B(F(), e._getMapId()), this.dispatcher.registerMessageHandler("GG", (e, t)=>this.getGlyphs(e, t)), this.dispatcher.registerMessageHandler("GI", (e, t)=>this.getImages(e, t)), this.imageManager = new b, this.imageManager.setEventedParent(this), this.glyphManager = new P(e._requestManager, i.localIdeographFontFamily), this.lineAtlas = new R(256, 512), this.crossTileSymbolIndex = new ht, this._spritesImagesIds = {}, this._layers = {}, this._order = [], this.sourceCaches = {}, this.zoomHistory = new t.bv, this._loaded = !1, this._availableImages = [], this._resetUpdates(), this.dispatcher.broadcast("SR", t.bw()), oe().on(te, this._rtlPluginLoaded), this.on("data", (e)=>{
                    if ("source" !== e.dataType || "metadata" !== e.sourceDataType) return;
                    const t = this.sourceCaches[e.sourceId];
                    if (!t) return;
                    const i = t.getSource();
                    if (i && i.vectorLayerIds) for(const e in this._layers){
                        const t = this._layers[e];
                        t.source === i.id && this._validateLayer(t);
                    }
                });
            }
            loadURL(e, i = {}, r) {
                this.fire(new t.l("dataloading", {
                    dataType: "style"
                })), i.validate = "boolean" != typeof i.validate || i.validate;
                const o = this.map._requestManager.transformRequest(e, "Style");
                this._loadStyleRequest = new AbortController;
                const a = this._loadStyleRequest;
                t.j(o, this._loadStyleRequest).then((e)=>{
                    this._loadStyleRequest = null, this._load(e.data, i, r);
                }).catch((e)=>{
                    this._loadStyleRequest = null, e && !a.signal.aborted && this.fire(new t.k(e));
                });
            }
            loadJSON(e, i = {}, r) {
                this.fire(new t.l("dataloading", {
                    dataType: "style"
                })), this._frameRequest = new AbortController, s.frameAsync(this._frameRequest).then(()=>{
                    this._frameRequest = null, i.validate = !1 !== i.validate, this._load(e, i, r);
                }).catch(()=>{});
            }
            loadEmpty() {
                this.fire(new t.l("dataloading", {
                    dataType: "style"
                })), this._load(fi, {
                    validate: !1
                });
            }
            _load(e, i, r) {
                var o, a;
                const s = i.transformStyle ? i.transformStyle(r, e) : e;
                if (!i.validate || !mi(this, t.y(s))) {
                    this._loaded = !0, this.stylesheet = s;
                    for(const e in s.sources)this.addSource(e, s.sources[e], {
                        validate: !1
                    });
                    s.sprite ? this._loadSprite(s.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(s.glyphs), this._createLayers(), this.light = new M(this.stylesheet.light), this._setProjectionInternal((null === (o = this.stylesheet.projection) || void 0 === o ? void 0 : o.type) || "mercator"), this.sky = new S(this.stylesheet.sky), this.map.setTerrain(null !== (a = this.stylesheet.terrain) && void 0 !== a ? a : null), this.fire(new t.l("data", {
                        dataType: "style"
                    })), this.fire(new t.l("style.load"));
                }
            }
            _createLayers() {
                const e = t.bx(this.stylesheet.layers);
                this.dispatcher.broadcast("SL", e), this._order = e.map((e)=>e.id), this._layers = {}, this._serializedLayers = null;
                for (const i of e){
                    const e = t.by(i);
                    e.setEventedParent(this, {
                        layer: {
                            id: i.id
                        }
                    }), this._layers[i.id] = e;
                }
            }
            _loadSprite(e, i = !1, r) {
                let o;
                this.imageManager.setLoaded(!1), this._spriteRequest = new AbortController, (function(e, i, r, o) {
                    return t._(this, void 0, void 0, function*() {
                        const a = f(e), n = r > 1 ? "@2x" : "", l = {}, c = {};
                        for (const { id: e, url: r } of a){
                            const a = i.transformRequest(g(r, n, ".json"), "SpriteJSON");
                            l[e] = t.j(a, o);
                            const s = i.transformRequest(g(r, n, ".png"), "SpriteImage");
                            c[e] = p.getImage(s, o);
                        }
                        return yield Promise.all([
                            ...Object.values(l),
                            ...Object.values(c)
                        ]), function(e, i) {
                            return t._(this, void 0, void 0, function*() {
                                const t = {};
                                for(const r in e){
                                    t[r] = {};
                                    const o = s.getImageCanvasContext((yield i[r]).data), a = (yield e[r]).data;
                                    for(const e in a){
                                        const { width: i, height: s, x: n, y: l, sdf: c, pixelRatio: h, stretchX: u, stretchY: d, content: _, textFitWidth: p, textFitHeight: m } = a[e];
                                        t[r][e] = {
                                            data: null,
                                            pixelRatio: h,
                                            sdf: c,
                                            stretchX: u,
                                            stretchY: d,
                                            content: _,
                                            textFitWidth: p,
                                            textFitHeight: m,
                                            spriteData: {
                                                width: i,
                                                height: s,
                                                x: n,
                                                y: l,
                                                context: o
                                            }
                                        };
                                    }
                                }
                                return t;
                            });
                        }(l, c);
                    });
                })(e, this.map._requestManager, this.map.getPixelRatio(), this._spriteRequest).then((e)=>{
                    if (this._spriteRequest = null, e) for(const t in e){
                        this._spritesImagesIds[t] = [];
                        const r = this._spritesImagesIds[t] ? this._spritesImagesIds[t].filter((t)=>!(t in e)) : [];
                        for (const e of r)this.imageManager.removeImage(e), this._changedImages[e] = !0;
                        for(const r in e[t]){
                            const o = "default" === t ? r : `${t}:${r}`;
                            this._spritesImagesIds[t].push(o), o in this.imageManager.images ? this.imageManager.updateImage(o, e[t][r], !1) : this.imageManager.addImage(o, e[t][r]), i && (this._changedImages[o] = !0);
                        }
                    }
                }).catch((e)=>{
                    this._spriteRequest = null, o = e, this.fire(new t.k(o));
                }).finally(()=>{
                    this.imageManager.setLoaded(!0), this._availableImages = this.imageManager.listImages(), i && (this._changed = !0), this.dispatcher.broadcast("SI", this._availableImages), this.fire(new t.l("data", {
                        dataType: "style"
                    })), r && r(o);
                });
            }
            _unloadSprite() {
                for (const e of Object.values(this._spritesImagesIds).flat())this.imageManager.removeImage(e), this._changedImages[e] = !0;
                this._spritesImagesIds = {}, this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new t.l("data", {
                    dataType: "style"
                }));
            }
            _validateLayer(e) {
                const i = this.sourceCaches[e.source];
                if (!i) return;
                const r = e.sourceLayer;
                if (!r) return;
                const o = i.getSource();
                ("geojson" === o.type || o.vectorLayerIds && -1 === o.vectorLayerIds.indexOf(r)) && this.fire(new t.k(new Error(`Source layer "${r}" does not exist on source "${o.id}" as specified by style layer "${e.id}".`)));
            }
            loaded() {
                if (!this._loaded) return !1;
                if (Object.keys(this._updatedSources).length) return !1;
                for(const e in this.sourceCaches)if (!this.sourceCaches[e].loaded()) return !1;
                return !!this.imageManager.isLoaded();
            }
            _serializeByIds(e, i = !1) {
                const r = this._serializedAllLayers();
                if (!e || 0 === e.length) return Object.values(i ? t.bz(r) : r);
                const o = [];
                for (const a of e)if (r[a]) {
                    const e = i ? t.bz(r[a]) : r[a];
                    o.push(e);
                }
                return o;
            }
            _serializedAllLayers() {
                let e = this._serializedLayers;
                if (e) return e;
                e = this._serializedLayers = {};
                const t = Object.keys(this._layers);
                for (const i of t){
                    const t = this._layers[i];
                    "custom" !== t.type && (e[i] = t.serialize());
                }
                return e;
            }
            hasTransitions() {
                var e, t, i;
                if (null === (e = this.light) || void 0 === e ? void 0 : e.hasTransition()) return !0;
                if (null === (t = this.sky) || void 0 === t ? void 0 : t.hasTransition()) return !0;
                if (null === (i = this.projection) || void 0 === i ? void 0 : i.hasTransition()) return !0;
                for(const e in this.sourceCaches)if (this.sourceCaches[e].hasTransition()) return !0;
                for(const e in this._layers)if (this._layers[e].hasTransition()) return !0;
                return !1;
            }
            _checkLoaded() {
                if (!this._loaded) throw new Error("Style is not done loading.");
            }
            update(e) {
                if (!this._loaded) return;
                const i = this._changed;
                if (i) {
                    const t = Object.keys(this._updatedLayers), i = Object.keys(this._removedLayers);
                    (t.length || i.length) && this._updateWorkerLayers(t, i);
                    for(const e in this._updatedSources){
                        const t = this._updatedSources[e];
                        if ("reload" === t) this._reloadSource(e);
                        else {
                            if ("clear" !== t) throw new Error(`Invalid action ${t}`);
                            this._clearSource(e);
                        }
                    }
                    this._updateTilesForChangedImages(), this._updateTilesForChangedGlyphs();
                    for(const t in this._updatedPaintProps)this._layers[t].updateTransitions(e);
                    this.light.updateTransitions(e), this.sky.updateTransitions(e), this._resetUpdates();
                }
                const r = {};
                for(const e in this.sourceCaches){
                    const t = this.sourceCaches[e];
                    r[e] = t.used, t.used = !1;
                }
                for (const t of this._order){
                    const i = this._layers[t];
                    i.recalculate(e, this._availableImages), !i.isHidden(e.zoom) && i.source && (this.sourceCaches[i.source].used = !0);
                }
                for(const e in r){
                    const i = this.sourceCaches[e];
                    !!r[e] != !!i.used && i.fire(new t.l("data", {
                        sourceDataType: "visibility",
                        dataType: "source",
                        sourceId: e
                    }));
                }
                this.light.recalculate(e), this.sky.recalculate(e), this.projection.recalculate(e), this.z = e.zoom, i && this.fire(new t.l("data", {
                    dataType: "style"
                }));
            }
            _updateTilesForChangedImages() {
                const e = Object.keys(this._changedImages);
                if (e.length) {
                    for(const t in this.sourceCaches)this.sourceCaches[t].reloadTilesForDependencies([
                        "icons",
                        "patterns"
                    ], e);
                    this._changedImages = {};
                }
            }
            _updateTilesForChangedGlyphs() {
                if (this._glyphsDidChange) {
                    for(const e in this.sourceCaches)this.sourceCaches[e].reloadTilesForDependencies([
                        "glyphs"
                    ], [
                        ""
                    ]);
                    this._glyphsDidChange = !1;
                }
            }
            _updateWorkerLayers(e, t) {
                this.dispatcher.broadcast("UL", {
                    layers: this._serializeByIds(e, !1),
                    removedIds: t
                });
            }
            _resetUpdates() {
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {}, this._glyphsDidChange = !1;
            }
            setState(e, i = {}) {
                var r;
                this._checkLoaded();
                const o = this.serialize();
                if (e = i.transformStyle ? i.transformStyle(o, e) : e, (null === (r = i.validate) || void 0 === r || r) && mi(this, t.y(e))) return !1;
                (e = t.bz(e)).layers = t.bx(e.layers);
                const a = t.bA(o, e), s = this._getOperationsToPerform(a);
                if (s.unimplemented.length > 0) throw new Error(`Unimplemented: ${s.unimplemented.join(", ")}.`);
                if (0 === s.operations.length) return !1;
                for (const e of s.operations)e();
                return this.stylesheet = e, this._serializedLayers = null, !0;
            }
            _getOperationsToPerform(e) {
                const t = [], i = [];
                for (const r of e)switch(r.command){
                    case "setCenter":
                    case "setZoom":
                    case "setBearing":
                    case "setPitch":
                    case "setRoll":
                        continue;
                    case "addLayer":
                        t.push(()=>this.addLayer.apply(this, r.args));
                        break;
                    case "removeLayer":
                        t.push(()=>this.removeLayer.apply(this, r.args));
                        break;
                    case "setPaintProperty":
                        t.push(()=>this.setPaintProperty.apply(this, r.args));
                        break;
                    case "setLayoutProperty":
                        t.push(()=>this.setLayoutProperty.apply(this, r.args));
                        break;
                    case "setFilter":
                        t.push(()=>this.setFilter.apply(this, r.args));
                        break;
                    case "addSource":
                        t.push(()=>this.addSource.apply(this, r.args));
                        break;
                    case "removeSource":
                        t.push(()=>this.removeSource.apply(this, r.args));
                        break;
                    case "setLayerZoomRange":
                        t.push(()=>this.setLayerZoomRange.apply(this, r.args));
                        break;
                    case "setLight":
                        t.push(()=>this.setLight.apply(this, r.args));
                        break;
                    case "setGeoJSONSourceData":
                        t.push(()=>this.setGeoJSONSourceData.apply(this, r.args));
                        break;
                    case "setGlyphs":
                        t.push(()=>this.setGlyphs.apply(this, r.args));
                        break;
                    case "setSprite":
                        t.push(()=>this.setSprite.apply(this, r.args));
                        break;
                    case "setTerrain":
                        t.push(()=>this.map.setTerrain.apply(this, r.args));
                        break;
                    case "setSky":
                        t.push(()=>this.setSky.apply(this, r.args));
                        break;
                    case "setProjection":
                        this.setProjection.apply(this, r.args);
                        break;
                    case "setTransition":
                        t.push(()=>{});
                        break;
                    default:
                        i.push(r.command);
                }
                return {
                    operations: t,
                    unimplemented: i
                };
            }
            addImage(e, i) {
                if (this.getImage(e)) return this.fire(new t.k(new Error(`An image named "${e}" already exists.`)));
                this.imageManager.addImage(e, i), this._afterImageUpdated(e);
            }
            updateImage(e, t) {
                this.imageManager.updateImage(e, t);
            }
            getImage(e) {
                return this.imageManager.getImage(e);
            }
            removeImage(e) {
                if (!this.getImage(e)) return this.fire(new t.k(new Error(`An image named "${e}" does not exist.`)));
                this.imageManager.removeImage(e), this._afterImageUpdated(e);
            }
            _afterImageUpdated(e) {
                this._availableImages = this.imageManager.listImages(), this._changedImages[e] = !0, this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new t.l("data", {
                    dataType: "style"
                }));
            }
            listImages() {
                return this._checkLoaded(), this.imageManager.listImages();
            }
            addSource(e, i, r = {}) {
                if (this._checkLoaded(), void 0 !== this.sourceCaches[e]) throw new Error(`Source "${e}" already exists.`);
                if (!i.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i).join(", ")}.`);
                if ([
                    "vector",
                    "raster",
                    "geojson",
                    "video",
                    "image"
                ].indexOf(i.type) >= 0 && this._validate(t.y.source, `sources.${e}`, i, null, r)) return;
                this.map && this.map._collectResourceTiming && (i.collectResourceTiming = !0);
                const o = this.sourceCaches[e] = new de(e, i, this.dispatcher);
                o.style = this, o.setEventedParent(this, ()=>({
                        isSourceLoaded: o.loaded(),
                        source: o.serialize(),
                        sourceId: e
                    })), o.onAdd(this.map), this._changed = !0;
            }
            removeSource(e) {
                if (this._checkLoaded(), void 0 === this.sourceCaches[e]) throw new Error("There is no source with this ID");
                for(const i in this._layers)if (this._layers[i].source === e) return this.fire(new t.k(new Error(`Source "${e}" cannot be removed while layer "${i}" is using it.`)));
                const i = this.sourceCaches[e];
                delete this.sourceCaches[e], delete this._updatedSources[e], i.fire(new t.l("data", {
                    sourceDataType: "metadata",
                    dataType: "source",
                    sourceId: e
                })), i.setEventedParent(null), i.onRemove(this.map), this._changed = !0;
            }
            setGeoJSONSourceData(e, t) {
                if (this._checkLoaded(), void 0 === this.sourceCaches[e]) throw new Error(`There is no source with this ID=${e}`);
                const i = this.sourceCaches[e].getSource();
                if ("geojson" !== i.type) throw new Error(`geojsonSource.type is ${i.type}, which is !== 'geojson`);
                i.setData(t), this._changed = !0;
            }
            getSource(e) {
                return this.sourceCaches[e] && this.sourceCaches[e].getSource();
            }
            addLayer(e, i, r = {}) {
                this._checkLoaded();
                const o = e.id;
                if (this.getLayer(o)) return void this.fire(new t.k(new Error(`Layer "${o}" already exists on this map.`)));
                let a;
                if ("custom" === e.type) {
                    if (mi(this, t.bB(e))) return;
                    a = t.by(e);
                } else {
                    if ("source" in e && "object" == typeof e.source && (this.addSource(o, e.source), e = t.bz(e), e = t.e(e, {
                        source: o
                    })), this._validate(t.y.layer, `layers.${o}`, e, {
                        arrayIndex: -1
                    }, r)) return;
                    a = t.by(e), this._validateLayer(a), a.setEventedParent(this, {
                        layer: {
                            id: o
                        }
                    });
                }
                const s = i ? this._order.indexOf(i) : this._order.length;
                if (i && -1 === s) this.fire(new t.k(new Error(`Cannot add layer "${o}" before non-existing layer "${i}".`)));
                else {
                    if (this._order.splice(s, 0, o), this._layerOrderChanged = !0, this._layers[o] = a, this._removedLayers[o] && a.source && "custom" !== a.type) {
                        const e = this._removedLayers[o];
                        delete this._removedLayers[o], e.type !== a.type ? this._updatedSources[a.source] = "clear" : (this._updatedSources[a.source] = "reload", this.sourceCaches[a.source].pause());
                    }
                    this._updateLayer(a), a.onAdd && a.onAdd(this.map);
                }
            }
            moveLayer(e, i) {
                if (this._checkLoaded(), this._changed = !0, !this._layers[e]) return void this.fire(new t.k(new Error(`The layer '${e}' does not exist in the map's style and cannot be moved.`)));
                if (e === i) return;
                const r = this._order.indexOf(e);
                this._order.splice(r, 1);
                const o = i ? this._order.indexOf(i) : this._order.length;
                i && -1 === o ? this.fire(new t.k(new Error(`Cannot move layer "${e}" before non-existing layer "${i}".`))) : (this._order.splice(o, 0, e), this._layerOrderChanged = !0);
            }
            removeLayer(e) {
                this._checkLoaded();
                const i = this._layers[e];
                if (!i) return void this.fire(new t.k(new Error(`Cannot remove non-existing layer "${e}".`)));
                i.setEventedParent(null);
                const r = this._order.indexOf(e);
                this._order.splice(r, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[e] = i, delete this._layers[e], this._serializedLayers && delete this._serializedLayers[e], delete this._updatedLayers[e], delete this._updatedPaintProps[e], i.onRemove && i.onRemove(this.map);
            }
            getLayer(e) {
                return this._layers[e];
            }
            getLayersOrder() {
                return [
                    ...this._order
                ];
            }
            hasLayer(e) {
                return e in this._layers;
            }
            setLayerZoomRange(e, i, r) {
                this._checkLoaded();
                const o = this.getLayer(e);
                o ? o.minzoom === i && o.maxzoom === r || (null != i && (o.minzoom = i), null != r && (o.maxzoom = r), this._updateLayer(o)) : this.fire(new t.k(new Error(`Cannot set the zoom range of non-existing layer "${e}".`)));
            }
            setFilter(e, i, r = {}) {
                this._checkLoaded();
                const o = this.getLayer(e);
                if (o) {
                    if (!t.bC(o.filter, i)) return null == i ? (o.filter = void 0, void this._updateLayer(o)) : void (this._validate(t.y.filter, `layers.${o.id}.filter`, i, null, r) || (o.filter = t.bz(i), this._updateLayer(o)));
                } else this.fire(new t.k(new Error(`Cannot filter non-existing layer "${e}".`)));
            }
            getFilter(e) {
                return t.bz(this.getLayer(e).filter);
            }
            setLayoutProperty(e, i, r, o = {}) {
                this._checkLoaded();
                const a = this.getLayer(e);
                a ? t.bC(a.getLayoutProperty(i), r) || (a.setLayoutProperty(i, r, o), this._updateLayer(a)) : this.fire(new t.k(new Error(`Cannot style non-existing layer "${e}".`)));
            }
            getLayoutProperty(e, i) {
                const r = this.getLayer(e);
                if (r) return r.getLayoutProperty(i);
                this.fire(new t.k(new Error(`Cannot get style of non-existing layer "${e}".`)));
            }
            setPaintProperty(e, i, r, o = {}) {
                this._checkLoaded();
                const a = this.getLayer(e);
                a ? t.bC(a.getPaintProperty(i), r) || (a.setPaintProperty(i, r, o) && this._updateLayer(a), this._changed = !0, this._updatedPaintProps[e] = !0, this._serializedLayers = null) : this.fire(new t.k(new Error(`Cannot style non-existing layer "${e}".`)));
            }
            getPaintProperty(e, t) {
                return this.getLayer(e).getPaintProperty(t);
            }
            setFeatureState(e, i) {
                this._checkLoaded();
                const r = e.source, o = e.sourceLayer, a = this.sourceCaches[r];
                if (void 0 === a) return void this.fire(new t.k(new Error(`The source '${r}' does not exist in the map's style.`)));
                const s = a.getSource().type;
                "geojson" === s && o ? this.fire(new t.k(new Error("GeoJSON sources cannot have a sourceLayer parameter."))) : "vector" !== s || o ? (void 0 === e.id && this.fire(new t.k(new Error("The feature id parameter must be provided."))), a.setFeatureState(o, e.id, i)) : this.fire(new t.k(new Error("The sourceLayer parameter must be provided for vector source types.")));
            }
            removeFeatureState(e, i) {
                this._checkLoaded();
                const r = e.source, o = this.sourceCaches[r];
                if (void 0 === o) return void this.fire(new t.k(new Error(`The source '${r}' does not exist in the map's style.`)));
                const a = o.getSource().type, s = "vector" === a ? e.sourceLayer : void 0;
                "vector" !== a || s ? i && "string" != typeof e.id && "number" != typeof e.id ? this.fire(new t.k(new Error("A feature id is required to remove its specific state property."))) : o.removeFeatureState(s, e.id, i) : this.fire(new t.k(new Error("The sourceLayer parameter must be provided for vector source types.")));
            }
            getFeatureState(e) {
                this._checkLoaded();
                const i = e.source, r = e.sourceLayer, o = this.sourceCaches[i];
                if (void 0 !== o) return "vector" !== o.getSource().type || r ? (void 0 === e.id && this.fire(new t.k(new Error("The feature id parameter must be provided."))), o.getFeatureState(r, e.id)) : void this.fire(new t.k(new Error("The sourceLayer parameter must be provided for vector source types.")));
                this.fire(new t.k(new Error(`The source '${i}' does not exist in the map's style.`)));
            }
            getTransition() {
                return t.e({
                    duration: 300,
                    delay: 0
                }, this.stylesheet && this.stylesheet.transition);
            }
            serialize() {
                if (!this._loaded) return;
                const e = t.bD(this.sourceCaches, (e)=>e.serialize()), i = this._serializeByIds(this._order, !0), r = this.map.getTerrain() || void 0, o = this.stylesheet;
                return t.bE({
                    version: o.version,
                    name: o.name,
                    metadata: o.metadata,
                    light: o.light,
                    sky: o.sky,
                    center: o.center,
                    zoom: o.zoom,
                    bearing: o.bearing,
                    pitch: o.pitch,
                    sprite: o.sprite,
                    glyphs: o.glyphs,
                    transition: o.transition,
                    projection: o.projection,
                    sources: e,
                    layers: i,
                    terrain: r
                }, (e)=>void 0 !== e);
            }
            _updateLayer(e) {
                this._updatedLayers[e.id] = !0, e.source && !this._updatedSources[e.source] && "raster" !== this.sourceCaches[e.source].getSource().type && (this._updatedSources[e.source] = "reload", this.sourceCaches[e.source].pause()), this._serializedLayers = null, this._changed = !0;
            }
            _flattenAndSortRenderedFeatures(e) {
                const t = (e)=>"fill-extrusion" === this._layers[e].type, i = {}, r = [];
                for(let o = this._order.length - 1; o >= 0; o--){
                    const a = this._order[o];
                    if (t(a)) {
                        i[a] = o;
                        for (const t of e){
                            const e = t[a];
                            if (e) for (const t of e)r.push(t);
                        }
                    }
                }
                r.sort((e, t)=>t.intersectionZ - e.intersectionZ);
                const o = [];
                for(let a = this._order.length - 1; a >= 0; a--){
                    const s = this._order[a];
                    if (t(s)) for(let e = r.length - 1; e >= 0; e--){
                        const t = r[e].feature;
                        if (i[t.layer.id] < a) break;
                        o.push(t), r.pop();
                    }
                    else for (const t of e){
                        const e = t[s];
                        if (e) for (const t of e)o.push(t.feature);
                    }
                }
                return o;
            }
            queryRenderedFeatures(e, i, r) {
                i && i.filter && this._validate(t.y.filter, "queryRenderedFeatures.filter", i.filter, null, i);
                const o = {};
                if (i && i.layers) {
                    if (!(Array.isArray(i.layers) || i.layers instanceof Set)) return this.fire(new t.k(new Error("parameters.layers must be an Array or a Set of strings"))), [];
                    for (const e of i.layers){
                        const i = this._layers[e];
                        if (!i) return this.fire(new t.k(new Error(`The layer '${e}' does not exist in the map's style and cannot be queried for features.`))), [];
                        o[i.source] = !0;
                    }
                }
                const a = [];
                i.availableImages = this._availableImages;
                const s = this._serializedAllLayers(), n = i.layers instanceof Set ? i.layers : Array.isArray(i.layers) ? new Set(i.layers) : null, l = Object.assign(Object.assign({}, i), {
                    layers: n
                });
                for(const t in this.sourceCaches)i.layers && !o[t] || a.push(Z(this.sourceCaches[t], this._layers, s, e, l, r, this.map.terrain ? (e, t, i)=>this.map.terrain.getElevation(e, t, i) : void 0));
                return this.placement && a.push(function(e, t, i, r, o, a, s) {
                    const n = {}, l = a.queryRenderedSymbols(r), c = [];
                    for (const e of Object.keys(l).map(Number))c.push(s[e]);
                    c.sort(N);
                    for (const i of c){
                        const r = i.featureIndex.lookupSymbolFeatures(l[i.bucketInstanceId], t, i.bucketIndex, i.sourceLayerIndex, o.filter, o.layers, o.availableImages, e);
                        for(const e in r){
                            const t = n[e] = n[e] || [], o = r[e];
                            o.sort((e, t)=>{
                                const r = i.featureSortOrder;
                                if (r) {
                                    const i = r.indexOf(e.featureIndex);
                                    return r.indexOf(t.featureIndex) - i;
                                }
                                return t.featureIndex - e.featureIndex;
                            });
                            for (const e of o)t.push(e);
                        }
                    }
                    return function(e, t, i) {
                        for(const r in e)for (const o of e[r])G(o, i[t[r].source]);
                        return e;
                    }(n, e, i);
                }(this._layers, s, this.sourceCaches, e, l, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(a);
            }
            querySourceFeatures(e, i) {
                i && i.filter && this._validate(t.y.filter, "querySourceFeatures.filter", i.filter, null, i);
                const r = this.sourceCaches[e];
                return r ? function(e, t) {
                    const i = e.getRenderableIds().map((t)=>e.getTileByID(t)), r = [], o = {};
                    for(let e = 0; e < i.length; e++){
                        const a = i[e], s = a.tileID.canonical.key;
                        o[s] || (o[s] = !0, a.querySourceFeatures(r, t));
                    }
                    return r;
                }(r, i) : [];
            }
            getLight() {
                return this.light.getLight();
            }
            setLight(e, i = {}) {
                this._checkLoaded();
                const r = this.light.getLight();
                let o = !1;
                for(const i in e)if (!t.bC(e[i], r[i])) {
                    o = !0;
                    break;
                }
                if (!o) return;
                const a = {
                    now: s.now(),
                    transition: t.e({
                        duration: 300,
                        delay: 0
                    }, this.stylesheet.transition)
                };
                this.light.setLight(e, i), this.light.updateTransitions(a);
            }
            getProjection() {
                var e;
                return null === (e = this.stylesheet) || void 0 === e ? void 0 : e.projection;
            }
            setProjection(e) {
                if (this._checkLoaded(), this.projection) {
                    if (this.projection.name === e.type) return;
                    this.projection.destroy(), delete this.projection;
                }
                this.stylesheet.projection = e, this._setProjectionInternal(e.type);
            }
            getSky() {
                var e;
                return null === (e = this.stylesheet) || void 0 === e ? void 0 : e.sky;
            }
            setSky(e, i = {}) {
                this._checkLoaded();
                const r = this.getSky();
                let o = !1;
                if (!e && !r) return;
                if (e && !r) o = !0;
                else if (!e && r) o = !0;
                else for(const i in e)if (!t.bC(e[i], r[i])) {
                    o = !0;
                    break;
                }
                if (!o) return;
                const a = {
                    now: s.now(),
                    transition: t.e({
                        duration: 300,
                        delay: 0
                    }, this.stylesheet.transition)
                };
                this.stylesheet.sky = e, this.sky.setSky(e, i), this.sky.updateTransitions(a);
            }
            _setProjectionInternal(e) {
                const i = function(e) {
                    if (Array.isArray(e)) {
                        const t = new Xt({
                            type: e
                        });
                        return {
                            projection: t,
                            transform: new di,
                            cameraHelper: new pi(t)
                        };
                    }
                    switch(e){
                        case "mercator":
                            return {
                                projection: new vt,
                                transform: new Dt,
                                cameraHelper: new kt
                            };
                        case "globe":
                            {
                                const e = new Xt({
                                    type: [
                                        "interpolate",
                                        [
                                            "linear"
                                        ],
                                        [
                                            "zoom"
                                        ],
                                        11,
                                        "vertical-perspective",
                                        12,
                                        "mercator"
                                    ]
                                });
                                return {
                                    projection: e,
                                    transform: new di,
                                    cameraHelper: new pi(e)
                                };
                            }
                        case "vertical-perspective":
                            return {
                                projection: new Ht,
                                transform: new ui,
                                cameraHelper: new _i
                            };
                        default:
                            return t.w(`Unknown projection name: ${e}. Falling back to mercator projection.`), {
                                projection: new vt,
                                transform: new Dt,
                                cameraHelper: new kt
                            };
                    }
                }(e);
                this.projection = i.projection, this.map.migrateProjection(i.transform, i.cameraHelper);
                for(const e in this.sourceCaches)this.sourceCaches[e].reload();
            }
            _validate(e, i, r, o, a = {}) {
                return (!a || !1 !== a.validate) && mi(this, e.call(t.y, t.e({
                    key: i,
                    style: this.serialize(),
                    value: r,
                    styleSpec: t.v
                }, o)));
            }
            _remove(e = !0) {
                this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._loadStyleRequest && (this._loadStyleRequest.abort(), this._loadStyleRequest = null), this._spriteRequest && (this._spriteRequest.abort(), this._spriteRequest = null), oe().off(te, this._rtlPluginLoaded);
                for(const e in this._layers)this._layers[e].setEventedParent(null);
                for(const e in this.sourceCaches){
                    const t = this.sourceCaches[e];
                    t.setEventedParent(null), t.onRemove(this.map);
                }
                this.imageManager.setEventedParent(null), this.setEventedParent(null), e && this.dispatcher.broadcast("RM", void 0), this.dispatcher.remove(e);
            }
            _clearSource(e) {
                this.sourceCaches[e].clearTiles();
            }
            _reloadSource(e) {
                this.sourceCaches[e].resume(), this.sourceCaches[e].reload();
            }
            _updateSources(e) {
                for(const t in this.sourceCaches)this.sourceCaches[t].update(e, this.map.terrain);
            }
            _generateCollisionBoxes() {
                for(const e in this.sourceCaches)this._reloadSource(e);
            }
            _updatePlacement(e, t, i, r, o = !1) {
                let a = !1, n = !1;
                const l = {};
                for (const t of this._order){
                    const i = this._layers[t];
                    if ("symbol" !== i.type) continue;
                    if (!l[i.source]) {
                        const e = this.sourceCaches[i.source];
                        l[i.source] = e.getRenderableIds(!0).map((t)=>e.getTileByID(t)).sort((e, t)=>t.tileID.overscaledZ - e.tileID.overscaledZ || (e.tileID.isLessThan(t.tileID) ? -1 : 1));
                    }
                    const r = this.crossTileSymbolIndex.addLayer(i, l[i.source], e.center.lng);
                    a = a || r;
                }
                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), ((o = o || this._layerOrderChanged || 0 === i) || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(s.now(), e.zoom)) && (this.pauseablePlacement = new at(e, this.map.terrain, this._order, o, t, i, r, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, l), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(s.now()), n = !0), a && this.pauseablePlacement.placement.setStale()), n || a) for (const e of this._order){
                    const t = this._layers[e];
                    "symbol" === t.type && this.placement.updateLayerOpacities(t, l[t.source]);
                }
                return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(s.now());
            }
            _releaseSymbolFadeTiles() {
                for(const e in this.sourceCaches)this.sourceCaches[e].releaseSymbolFadeTiles();
            }
            getImages(e, i) {
                return t._(this, void 0, void 0, function*() {
                    const e = yield this.imageManager.getImages(i.icons);
                    this._updateTilesForChangedImages();
                    const t = this.sourceCaches[i.source];
                    return t && t.setDependencies(i.tileID.key, i.type, i.icons), e;
                });
            }
            getGlyphs(e, i) {
                return t._(this, void 0, void 0, function*() {
                    const e = yield this.glyphManager.getGlyphs(i.stacks), t = this.sourceCaches[i.source];
                    return t && t.setDependencies(i.tileID.key, i.type, [
                        ""
                    ]), e;
                });
            }
            getGlyphsUrl() {
                return this.stylesheet.glyphs || null;
            }
            setGlyphs(e, i = {}) {
                this._checkLoaded(), e && this._validate(t.y.glyphs, "glyphs", e, null, i) || (this._glyphsDidChange = !0, this.stylesheet.glyphs = e, this.glyphManager.entries = {}, this.glyphManager.setURL(e));
            }
            addSprite(e, i, r = {}, o) {
                this._checkLoaded();
                const a = [
                    {
                        id: e,
                        url: i
                    }
                ], s = [
                    ...f(this.stylesheet.sprite),
                    ...a
                ];
                this._validate(t.y.sprite, "sprite", s, null, r) || (this.stylesheet.sprite = s, this._loadSprite(a, !0, o));
            }
            removeSprite(e) {
                this._checkLoaded();
                const i = f(this.stylesheet.sprite);
                if (i.find((t)=>t.id === e)) {
                    if (this._spritesImagesIds[e]) for (const t of this._spritesImagesIds[e])this.imageManager.removeImage(t), this._changedImages[t] = !0;
                    i.splice(i.findIndex((t)=>t.id === e), 1), this.stylesheet.sprite = i.length > 0 ? i : void 0, delete this._spritesImagesIds[e], this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new t.l("data", {
                        dataType: "style"
                    }));
                } else this.fire(new t.k(new Error(`Sprite "${e}" doesn't exists on this map.`)));
            }
            getSprite() {
                return f(this.stylesheet.sprite);
            }
            setSprite(e, i = {}, r) {
                this._checkLoaded(), e && this._validate(t.y.sprite, "sprite", e, null, i) || (this.stylesheet.sprite = e, e ? this._loadSprite(e, !0, r) : (this._unloadSprite(), r && r(null)));
            }
        }
        var vi = t.aD([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Int16",
                components: 2
            }
        ]);
        class xi {
            constructor(){
                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
            }
            bind(e, t, i, r, o, a, s, n, l) {
                this.context = e;
                let c = this.boundPaintVertexBuffers.length !== r.length;
                for(let e = 0; !c && e < r.length; e++)this.boundPaintVertexBuffers[e] !== r[e] && (c = !0);
                !this.vao || this.boundProgram !== t || this.boundLayoutVertexBuffer !== i || c || this.boundIndexBuffer !== o || this.boundVertexOffset !== a || this.boundDynamicVertexBuffer !== s || this.boundDynamicVertexBuffer2 !== n || this.boundDynamicVertexBuffer3 !== l ? this.freshBind(t, i, r, o, a, s, n, l) : (e.bindVertexArray.set(this.vao), s && s.bind(), o && o.dynamicDraw && o.bind(), n && n.bind(), l && l.bind());
            }
            freshBind(e, t, i, r, o, a, s, n) {
                const l = e.numAttributes, c = this.context, h = c.gl;
                this.vao && this.destroy(), this.vao = c.createVertexArray(), c.bindVertexArray.set(this.vao), this.boundProgram = e, this.boundLayoutVertexBuffer = t, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = r, this.boundVertexOffset = o, this.boundDynamicVertexBuffer = a, this.boundDynamicVertexBuffer2 = s, this.boundDynamicVertexBuffer3 = n, t.enableAttributes(h, e);
                for (const t of i)t.enableAttributes(h, e);
                a && a.enableAttributes(h, e), s && s.enableAttributes(h, e), n && n.enableAttributes(h, e), t.bind(), t.setVertexAttribPointers(h, e, o);
                for (const t of i)t.bind(), t.setVertexAttribPointers(h, e, o);
                a && (a.bind(), a.setVertexAttribPointers(h, e, o)), r && r.bind(), s && (s.bind(), s.setVertexAttribPointers(h, e, o)), n && (n.bind(), n.setVertexAttribPointers(h, e, o)), c.currentNumAttributes = l;
            }
            destroy() {
                this.vao && (this.context.deleteVertexArray(this.vao), this.vao = null);
            }
        }
        const bi = (e, i, r, o, a)=>({
                u_texture: 0,
                u_ele_delta: e,
                u_fog_matrix: i,
                u_fog_color: r ? r.properties.get("fog-color") : t.b7.white,
                u_fog_ground_blend: r ? r.properties.get("fog-ground-blend") : 1,
                u_fog_ground_blend_opacity: a ? 0 : r ? r.calculateFogBlendOpacity(o) : 0,
                u_horizon_color: r ? r.properties.get("horizon-color") : t.b7.white,
                u_horizon_fog_blend: r ? r.properties.get("horizon-fog-blend") : 1,
                u_is_globe_mode: a ? 1 : 0
            }), yi = {
            mainMatrix: "u_projection_matrix",
            tileMercatorCoords: "u_projection_tile_mercator_coords",
            clippingPlane: "u_projection_clipping_plane",
            projectionTransition: "u_projection_transition",
            fallbackMatrix: "u_projection_fallback_matrix"
        };
        function wi(e) {
            const t = [];
            for(let i = 0; i < e.length; i++){
                if (null === e[i]) continue;
                const r = e[i].split(" ");
                t.push(r.pop());
            }
            return t;
        }
        class Ti {
            constructor(e, i, r, o, a, s, n, l){
                const c = e.gl;
                this.program = c.createProgram();
                const h = wi(i.staticAttributes), u = r ? r.getBinderAttributes() : [], d = h.concat(u), _ = dt.prelude.staticUniforms ? wi(dt.prelude.staticUniforms) : [], p = n.staticUniforms ? wi(n.staticUniforms) : [], m = i.staticUniforms ? wi(i.staticUniforms) : [], f = r ? r.getBinderUniforms() : [], g = _.concat(p).concat(m).concat(f), v = [];
                for (const e of g)v.indexOf(e) < 0 && v.push(e);
                const x = r ? r.defines() : [];
                Ut(c) && x.unshift("#version 300 es"), a && x.push("#define OVERDRAW_INSPECTOR;"), s && x.push("#define TERRAIN3D;"), l && x.push(l);
                let b = x.concat(dt.prelude.fragmentSource, n.fragmentSource, i.fragmentSource).join("\n"), y = x.concat(dt.prelude.vertexSource, n.vertexSource, i.vertexSource).join("\n");
                Ut(c) || (b = function(e) {
                    return e.replace(/\bin\s/g, "varying ").replace("out highp vec4 fragColor;", "").replace(/fragColor/g, "gl_FragColor").replace(/texture\(/g, "texture2D(");
                }(b), y = function(e) {
                    return e.replace(/\bin\s/g, "attribute ").replace(/\bout\s/g, "varying ").replace(/texture\(/g, "texture2D(");
                }(y));
                const w = c.createShader(c.FRAGMENT_SHADER);
                if (c.isContextLost()) return void (this.failedToCreate = !0);
                if (c.shaderSource(w, b), c.compileShader(w), !c.getShaderParameter(w, c.COMPILE_STATUS)) throw new Error(`Could not compile fragment shader: ${c.getShaderInfoLog(w)}`);
                c.attachShader(this.program, w);
                const T = c.createShader(c.VERTEX_SHADER);
                if (c.isContextLost()) return void (this.failedToCreate = !0);
                if (c.shaderSource(T, y), c.compileShader(T), !c.getShaderParameter(T, c.COMPILE_STATUS)) throw new Error(`Could not compile vertex shader: ${c.getShaderInfoLog(T)}`);
                c.attachShader(this.program, T), this.attributes = {};
                const P = {};
                this.numAttributes = d.length;
                for(let e = 0; e < this.numAttributes; e++)d[e] && (c.bindAttribLocation(this.program, e, d[e]), this.attributes[d[e]] = e);
                if (c.linkProgram(this.program), !c.getProgramParameter(this.program, c.LINK_STATUS)) throw new Error(`Program failed to link: ${c.getProgramInfoLog(this.program)}`);
                c.deleteShader(T), c.deleteShader(w);
                for(let e = 0; e < v.length; e++){
                    const t = v[e];
                    if (t && !P[t]) {
                        const e = c.getUniformLocation(this.program, t);
                        e && (P[t] = e);
                    }
                }
                this.fixedUniforms = o(e, P), this.terrainUniforms = ((e, i)=>({
                        u_depth: new t.bF(e, i.u_depth),
                        u_terrain: new t.bF(e, i.u_terrain),
                        u_terrain_dim: new t.b8(e, i.u_terrain_dim),
                        u_terrain_matrix: new t.bH(e, i.u_terrain_matrix),
                        u_terrain_unpack: new t.bI(e, i.u_terrain_unpack),
                        u_terrain_exaggeration: new t.b8(e, i.u_terrain_exaggeration)
                    }))(e, P), this.projectionUniforms = ((e, i)=>({
                        u_projection_matrix: new t.bH(e, i.u_projection_matrix),
                        u_projection_tile_mercator_coords: new t.bI(e, i.u_projection_tile_mercator_coords),
                        u_projection_clipping_plane: new t.bI(e, i.u_projection_clipping_plane),
                        u_projection_transition: new t.b8(e, i.u_projection_transition),
                        u_projection_fallback_matrix: new t.bH(e, i.u_projection_fallback_matrix)
                    }))(e, P), this.binderUniforms = r ? r.getUniforms(e, P) : [];
            }
            draw(e, t, i, r, o, a, s, n, l, c, h, u, d, _, p, m, f, g, v) {
                const x = e.gl;
                if (this.failedToCreate) return;
                if (e.program.set(this.program), e.setDepthMode(i), e.setStencilMode(r), e.setColorMode(o), e.setCullFace(a), n) {
                    e.activeTexture.set(x.TEXTURE2), x.bindTexture(x.TEXTURE_2D, n.depthTexture), e.activeTexture.set(x.TEXTURE3), x.bindTexture(x.TEXTURE_2D, n.texture);
                    for(const e in this.terrainUniforms)this.terrainUniforms[e].set(n[e]);
                }
                if (l) for(const e in l)this.projectionUniforms[yi[e]].set(l[e]);
                if (s) for(const e in this.fixedUniforms)this.fixedUniforms[e].set(s[e]);
                m && m.setUniforms(e, this.binderUniforms, _, {
                    zoom: p
                });
                let b = 0;
                switch(t){
                    case x.LINES:
                        b = 2;
                        break;
                    case x.TRIANGLES:
                        b = 3;
                        break;
                    case x.LINE_STRIP:
                        b = 1;
                }
                for (const i of d.get()){
                    const r = i.vaos || (i.vaos = {});
                    (r[c] || (r[c] = new xi)).bind(e, this, h, m ? m.getPaintVertexBuffers() : [], u, i.vertexOffset, f, g, v), x.drawElements(t, i.primitiveLength * b, x.UNSIGNED_SHORT, i.primitiveOffset * b * 2);
                }
            }
        }
        function Pi(e, i, r) {
            const o = 1 / t.aw(r, 1, i.transform.tileZoom), a = Math.pow(2, r.tileID.overscaledZ), s = r.tileSize * Math.pow(2, i.transform.tileZoom) / a, n = s * (r.tileID.canonical.x + r.tileID.wrap * a), l = s * r.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: r.imageAtlasTexture.size,
                u_scale: [
                    o,
                    e.fromScale,
                    e.toScale
                ],
                u_fade: e.t,
                u_pixel_coord_upper: [
                    n >> 16,
                    l >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & n,
                    65535 & l
                ]
            };
        }
        const Ci = (e, i, r, o)=>{
            const a = e.style.light, s = a.properties.get("position"), n = [
                s.x,
                s.y,
                s.z
            ], l = t.bL();
            "viewport" === a.properties.get("anchor") && t.bM(l, e.transform.bearingInRadians), t.bN(n, n, l);
            const c = e.transform.transformLightDirection(n), h = a.properties.get("color");
            return {
                u_lightpos: n,
                u_lightpos_globe: c,
                u_lightintensity: a.properties.get("intensity"),
                u_lightcolor: [
                    h.r,
                    h.g,
                    h.b
                ],
                u_vertical_gradient: +i,
                u_opacity: r,
                u_fill_translate: o
            };
        }, Ii = (e, i, r, o, a, s, n)=>t.e(Ci(e, i, r, o), Pi(s, e, n), {
                u_height_factor: -Math.pow(2, a.overscaledZ) / n.tileSize / 8
            }), Mi = (e, i, r, o)=>t.e(Pi(i, e, r), {
                u_fill_translate: o
            }), Ei = (e, t)=>({
                u_world: e,
                u_fill_translate: t
            }), Si = (e, i, r, o, a)=>t.e(Mi(e, i, r, a), {
                u_world: o
            }), Ri = (e, i, r, o, a)=>{
            const s = e.transform;
            let n, l, c = 0;
            if ("map" === r.paint.get("circle-pitch-alignment")) {
                const e = t.aw(i, 1, s.zoom);
                n = !0, l = [
                    e,
                    e
                ], c = e / (t.Z * Math.pow(2, i.tileID.overscaledZ)) * 2 * Math.PI * a;
            } else n = !1, l = s.pixelsToGLUnits;
            return {
                u_camera_to_center_distance: s.cameraToCenterDistance,
                u_scale_with_map: +("map" === r.paint.get("circle-pitch-scale")),
                u_pitch_with_map: +n,
                u_device_pixel_ratio: e.pixelRatio,
                u_extrude_scale: l,
                u_globe_extrude_scale: c,
                u_translate: o
            };
        }, Di = (e)=>({
                u_pixel_extrude_scale: [
                    1 / e.width,
                    1 / e.height
                ]
            }), zi = (e)=>({
                u_viewport_size: [
                    e.width,
                    e.height
                ]
            }), Ai = (e, t = 1)=>({
                u_color: e,
                u_overlay: 0,
                u_overlay_scale: t
            }), Li = (e, i, r, o)=>{
            const a = t.aw(e, 1, i) / (t.Z * Math.pow(2, e.tileID.overscaledZ)) * 2 * Math.PI * o;
            return {
                u_extrude_scale: t.aw(e, 1, i),
                u_intensity: r,
                u_globe_extrude_scale: a
            };
        }, ki = (e, i, r, o)=>{
            const a = t.K();
            t.bO(a, 0, e.width, e.height, 0, 0, 1);
            const s = e.context.gl;
            return {
                u_matrix: a,
                u_world: [
                    s.drawingBufferWidth,
                    s.drawingBufferHeight
                ],
                u_image: r,
                u_color_ramp: o,
                u_opacity: i.paint.get("heatmap-opacity")
            };
        }, Fi = (e, t, i)=>{
            const r = i.paint.get("hillshade-shadow-color"), o = i.paint.get("hillshade-highlight-color"), a = i.paint.get("hillshade-accent-color");
            let s = i.paint.get("hillshade-illumination-direction") * (Math.PI / 180);
            return "viewport" === i.paint.get("hillshade-illumination-anchor") && (s += e.transform.bearingInRadians), {
                u_image: 0,
                u_latrange: Oi(0, t.tileID),
                u_light: [
                    i.paint.get("hillshade-exaggeration"),
                    s
                ],
                u_shadow: r,
                u_highlight: o,
                u_accent: a
            };
        }, Bi = (e, i)=>{
            const r = i.stride, o = t.K();
            return t.bO(o, 0, t.Z, -8192, 0, 0, 1), t.L(o, o, [
                0,
                -8192,
                0
            ]), {
                u_matrix: o,
                u_image: 1,
                u_dimension: [
                    r,
                    r
                ],
                u_zoom: e.overscaledZ,
                u_unpack: i.getUnpackVector()
            };
        };
        function Oi(e, i) {
            const r = Math.pow(2, i.canonical.z), o = i.canonical.y;
            return [
                new t.$(0, o / r).toLngLat().lat,
                new t.$(0, (o + 1) / r).toLngLat().lat
            ];
        }
        const ji = (e, i, r, o)=>{
            const a = e.transform;
            return {
                u_translation: Vi(e, i, r),
                u_ratio: o / t.aw(i, 1, a.zoom),
                u_device_pixel_ratio: e.pixelRatio,
                u_units_to_pixels: [
                    1 / a.pixelsToGLUnits[0],
                    1 / a.pixelsToGLUnits[1]
                ]
            };
        }, Zi = (e, i, r, o, a)=>t.e(ji(e, i, r, o), {
                u_image: 0,
                u_image_height: a
            }), Ni = (e, i, r, o, a)=>{
            const s = e.transform, n = Ui(i, s);
            return {
                u_translation: Vi(e, i, r),
                u_texsize: i.imageAtlasTexture.size,
                u_ratio: o / t.aw(i, 1, s.zoom),
                u_device_pixel_ratio: e.pixelRatio,
                u_image: 0,
                u_scale: [
                    n,
                    a.fromScale,
                    a.toScale
                ],
                u_fade: a.t,
                u_units_to_pixels: [
                    1 / s.pixelsToGLUnits[0],
                    1 / s.pixelsToGLUnits[1]
                ]
            };
        }, Gi = (e, i, r, o, a, s)=>{
            const n = e.lineAtlas, l = Ui(i, e.transform), c = "round" === r.layout.get("line-cap"), h = n.getDash(a.from, c), u = n.getDash(a.to, c), d = h.width * s.fromScale, _ = u.width * s.toScale;
            return t.e(ji(e, i, r, o), {
                u_patternscale_a: [
                    l / d,
                    -h.height / 2
                ],
                u_patternscale_b: [
                    l / _,
                    -u.height / 2
                ],
                u_sdfgamma: n.width / (256 * Math.min(d, _) * e.pixelRatio) / 2,
                u_image: 0,
                u_tex_y_a: h.y,
                u_tex_y_b: u.y,
                u_mix: s.t
            });
        };
        function Ui(e, i) {
            return 1 / t.aw(e, 1, i.tileZoom);
        }
        function Vi(e, i, r) {
            return t.ax(e.transform, i, r.paint.get("line-translate"), r.paint.get("line-translate-anchor"));
        }
        const qi = (e, t, i, r, o)=>{
            var a, s;
            return {
                u_tl_parent: e,
                u_scale_parent: t,
                u_buffer_scale: 1,
                u_fade_t: i.mix,
                u_opacity: i.opacity * r.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: r.paint.get("raster-brightness-min"),
                u_brightness_high: r.paint.get("raster-brightness-max"),
                u_saturation_factor: (s = r.paint.get("raster-saturation"), s > 0 ? 1 - 1 / (1.001 - s) : -s),
                u_contrast_factor: (a = r.paint.get("raster-contrast"), a > 0 ? 1 / (1 - a) : 1 + a),
                u_spin_weights: Wi(r.paint.get("raster-hue-rotate")),
                u_coords_top: [
                    o[0].x,
                    o[0].y,
                    o[1].x,
                    o[1].y
                ],
                u_coords_bottom: [
                    o[3].x,
                    o[3].y,
                    o[2].x,
                    o[2].y
                ]
            };
        };
        function Wi(e) {
            e *= Math.PI / 180;
            const t = Math.sin(e), i = Math.cos(e);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * t - i + 1) / 3,
                (Math.sqrt(3) * t - i + 1) / 3
            ];
        }
        const $i = (e, t, i, r, o, a, s, n, l, c, h, u, d)=>{
            const _ = s.transform;
            return {
                u_is_size_zoom_constant: +("constant" === e || "source" === e),
                u_is_size_feature_constant: +("constant" === e || "camera" === e),
                u_size_t: t ? t.uSizeT : 0,
                u_size: t ? t.uSize : 0,
                u_camera_to_center_distance: _.cameraToCenterDistance,
                u_pitch: _.pitch / 360 * 2 * Math.PI,
                u_rotate_symbol: +i,
                u_aspect_ratio: _.width / _.height,
                u_fade_change: s.options.fadeDuration ? s.symbolFadeChange : 1,
                u_label_plane_matrix: n,
                u_coord_matrix: l,
                u_is_text: +h,
                u_pitch_with_map: +r,
                u_is_along_line: o,
                u_is_variable_anchor: a,
                u_texsize: u,
                u_texture: 0,
                u_translation: c,
                u_pitched_scale: d
            };
        }, Hi = (e, i, r, o, a, s, n, l, c, h, u, d, _, p)=>{
            const m = n.transform;
            return t.e($i(e, i, r, o, a, s, n, l, c, h, u, d, p), {
                u_gamma_scale: o ? Math.cos(m.pitch * Math.PI / 180) * m.cameraToCenterDistance : 1,
                u_device_pixel_ratio: n.pixelRatio,
                u_is_halo: 1
            });
        }, Ki = (e, i, r, o, a, s, n, l, c, h, u, d, _)=>t.e(Hi(e, i, r, o, a, s, n, l, c, h, !0, u, 0, _), {
                u_texsize_icon: d,
                u_texture_icon: 1
            }), Xi = (e, t)=>({
                u_opacity: e,
                u_color: t
            }), Qi = (e, i, r, o, a)=>t.e(function(e, i, r, o) {
                const a = r.imageManager.getPattern(e.from.toString()), s = r.imageManager.getPattern(e.to.toString()), { width: n, height: l } = r.imageManager.getPixelSize(), c = Math.pow(2, o.tileID.overscaledZ), h = o.tileSize * Math.pow(2, r.transform.tileZoom) / c, u = h * (o.tileID.canonical.x + o.tileID.wrap * c), d = h * o.tileID.canonical.y;
                return {
                    u_image: 0,
                    u_pattern_tl_a: a.tl,
                    u_pattern_br_a: a.br,
                    u_pattern_tl_b: s.tl,
                    u_pattern_br_b: s.br,
                    u_texsize: [
                        n,
                        l
                    ],
                    u_mix: i.t,
                    u_pattern_size_a: a.displaySize,
                    u_pattern_size_b: s.displaySize,
                    u_scale_a: i.fromScale,
                    u_scale_b: i.toScale,
                    u_tile_units_to_pixels: 1 / t.aw(o, 1, r.transform.tileZoom),
                    u_pixel_coord_upper: [
                        u >> 16,
                        d >> 16
                    ],
                    u_pixel_coord_lower: [
                        65535 & u,
                        65535 & d
                    ]
                };
            }(r, a, i, o), {
                u_opacity: e
            }), Yi = (e, t)=>{}, Ji = {
            fillExtrusion: (e, i)=>({
                    u_lightpos: new t.bJ(e, i.u_lightpos),
                    u_lightpos_globe: new t.bJ(e, i.u_lightpos_globe),
                    u_lightintensity: new t.b8(e, i.u_lightintensity),
                    u_lightcolor: new t.bJ(e, i.u_lightcolor),
                    u_vertical_gradient: new t.b8(e, i.u_vertical_gradient),
                    u_opacity: new t.b8(e, i.u_opacity),
                    u_fill_translate: new t.bK(e, i.u_fill_translate)
                }),
            fillExtrusionPattern: (e, i)=>({
                    u_lightpos: new t.bJ(e, i.u_lightpos),
                    u_lightpos_globe: new t.bJ(e, i.u_lightpos_globe),
                    u_lightintensity: new t.b8(e, i.u_lightintensity),
                    u_lightcolor: new t.bJ(e, i.u_lightcolor),
                    u_vertical_gradient: new t.b8(e, i.u_vertical_gradient),
                    u_height_factor: new t.b8(e, i.u_height_factor),
                    u_opacity: new t.b8(e, i.u_opacity),
                    u_fill_translate: new t.bK(e, i.u_fill_translate),
                    u_image: new t.bF(e, i.u_image),
                    u_texsize: new t.bK(e, i.u_texsize),
                    u_pixel_coord_upper: new t.bK(e, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.bK(e, i.u_pixel_coord_lower),
                    u_scale: new t.bJ(e, i.u_scale),
                    u_fade: new t.b8(e, i.u_fade)
                }),
            fill: (e, i)=>({
                    u_fill_translate: new t.bK(e, i.u_fill_translate)
                }),
            fillPattern: (e, i)=>({
                    u_image: new t.bF(e, i.u_image),
                    u_texsize: new t.bK(e, i.u_texsize),
                    u_pixel_coord_upper: new t.bK(e, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.bK(e, i.u_pixel_coord_lower),
                    u_scale: new t.bJ(e, i.u_scale),
                    u_fade: new t.b8(e, i.u_fade),
                    u_fill_translate: new t.bK(e, i.u_fill_translate)
                }),
            fillOutline: (e, i)=>({
                    u_world: new t.bK(e, i.u_world),
                    u_fill_translate: new t.bK(e, i.u_fill_translate)
                }),
            fillOutlinePattern: (e, i)=>({
                    u_world: new t.bK(e, i.u_world),
                    u_image: new t.bF(e, i.u_image),
                    u_texsize: new t.bK(e, i.u_texsize),
                    u_pixel_coord_upper: new t.bK(e, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.bK(e, i.u_pixel_coord_lower),
                    u_scale: new t.bJ(e, i.u_scale),
                    u_fade: new t.b8(e, i.u_fade),
                    u_fill_translate: new t.bK(e, i.u_fill_translate)
                }),
            circle: (e, i)=>({
                    u_camera_to_center_distance: new t.b8(e, i.u_camera_to_center_distance),
                    u_scale_with_map: new t.bF(e, i.u_scale_with_map),
                    u_pitch_with_map: new t.bF(e, i.u_pitch_with_map),
                    u_extrude_scale: new t.bK(e, i.u_extrude_scale),
                    u_device_pixel_ratio: new t.b8(e, i.u_device_pixel_ratio),
                    u_globe_extrude_scale: new t.b8(e, i.u_globe_extrude_scale),
                    u_translate: new t.bK(e, i.u_translate)
                }),
            collisionBox: (e, i)=>({
                    u_pixel_extrude_scale: new t.bK(e, i.u_pixel_extrude_scale)
                }),
            collisionCircle: (e, i)=>({
                    u_viewport_size: new t.bK(e, i.u_viewport_size)
                }),
            debug: (e, i)=>({
                    u_color: new t.bG(e, i.u_color),
                    u_overlay: new t.bF(e, i.u_overlay),
                    u_overlay_scale: new t.b8(e, i.u_overlay_scale)
                }),
            depth: Yi,
            clippingMask: Yi,
            heatmap: (e, i)=>({
                    u_extrude_scale: new t.b8(e, i.u_extrude_scale),
                    u_intensity: new t.b8(e, i.u_intensity),
                    u_globe_extrude_scale: new t.b8(e, i.u_globe_extrude_scale)
                }),
            heatmapTexture: (e, i)=>({
                    u_matrix: new t.bH(e, i.u_matrix),
                    u_world: new t.bK(e, i.u_world),
                    u_image: new t.bF(e, i.u_image),
                    u_color_ramp: new t.bF(e, i.u_color_ramp),
                    u_opacity: new t.b8(e, i.u_opacity)
                }),
            hillshade: (e, i)=>({
                    u_image: new t.bF(e, i.u_image),
                    u_latrange: new t.bK(e, i.u_latrange),
                    u_light: new t.bK(e, i.u_light),
                    u_shadow: new t.bG(e, i.u_shadow),
                    u_highlight: new t.bG(e, i.u_highlight),
                    u_accent: new t.bG(e, i.u_accent)
                }),
            hillshadePrepare: (e, i)=>({
                    u_matrix: new t.bH(e, i.u_matrix),
                    u_image: new t.bF(e, i.u_image),
                    u_dimension: new t.bK(e, i.u_dimension),
                    u_zoom: new t.b8(e, i.u_zoom),
                    u_unpack: new t.bI(e, i.u_unpack)
                }),
            line: (e, i)=>({
                    u_translation: new t.bK(e, i.u_translation),
                    u_ratio: new t.b8(e, i.u_ratio),
                    u_device_pixel_ratio: new t.b8(e, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t.bK(e, i.u_units_to_pixels)
                }),
            lineGradient: (e, i)=>({
                    u_translation: new t.bK(e, i.u_translation),
                    u_ratio: new t.b8(e, i.u_ratio),
                    u_device_pixel_ratio: new t.b8(e, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t.bK(e, i.u_units_to_pixels),
                    u_image: new t.bF(e, i.u_image),
                    u_image_height: new t.b8(e, i.u_image_height)
                }),
            linePattern: (e, i)=>({
                    u_translation: new t.bK(e, i.u_translation),
                    u_texsize: new t.bK(e, i.u_texsize),
                    u_ratio: new t.b8(e, i.u_ratio),
                    u_device_pixel_ratio: new t.b8(e, i.u_device_pixel_ratio),
                    u_image: new t.bF(e, i.u_image),
                    u_units_to_pixels: new t.bK(e, i.u_units_to_pixels),
                    u_scale: new t.bJ(e, i.u_scale),
                    u_fade: new t.b8(e, i.u_fade)
                }),
            lineSDF: (e, i)=>({
                    u_translation: new t.bK(e, i.u_translation),
                    u_ratio: new t.b8(e, i.u_ratio),
                    u_device_pixel_ratio: new t.b8(e, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t.bK(e, i.u_units_to_pixels),
                    u_patternscale_a: new t.bK(e, i.u_patternscale_a),
                    u_patternscale_b: new t.bK(e, i.u_patternscale_b),
                    u_sdfgamma: new t.b8(e, i.u_sdfgamma),
                    u_image: new t.bF(e, i.u_image),
                    u_tex_y_a: new t.b8(e, i.u_tex_y_a),
                    u_tex_y_b: new t.b8(e, i.u_tex_y_b),
                    u_mix: new t.b8(e, i.u_mix)
                }),
            raster: (e, i)=>({
                    u_tl_parent: new t.bK(e, i.u_tl_parent),
                    u_scale_parent: new t.b8(e, i.u_scale_parent),
                    u_buffer_scale: new t.b8(e, i.u_buffer_scale),
                    u_fade_t: new t.b8(e, i.u_fade_t),
                    u_opacity: new t.b8(e, i.u_opacity),
                    u_image0: new t.bF(e, i.u_image0),
                    u_image1: new t.bF(e, i.u_image1),
                    u_brightness_low: new t.b8(e, i.u_brightness_low),
                    u_brightness_high: new t.b8(e, i.u_brightness_high),
                    u_saturation_factor: new t.b8(e, i.u_saturation_factor),
                    u_contrast_factor: new t.b8(e, i.u_contrast_factor),
                    u_spin_weights: new t.bJ(e, i.u_spin_weights),
                    u_coords_top: new t.bI(e, i.u_coords_top),
                    u_coords_bottom: new t.bI(e, i.u_coords_bottom)
                }),
            symbolIcon: (e, i)=>({
                    u_is_size_zoom_constant: new t.bF(e, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t.bF(e, i.u_is_size_feature_constant),
                    u_size_t: new t.b8(e, i.u_size_t),
                    u_size: new t.b8(e, i.u_size),
                    u_camera_to_center_distance: new t.b8(e, i.u_camera_to_center_distance),
                    u_pitch: new t.b8(e, i.u_pitch),
                    u_rotate_symbol: new t.bF(e, i.u_rotate_symbol),
                    u_aspect_ratio: new t.b8(e, i.u_aspect_ratio),
                    u_fade_change: new t.b8(e, i.u_fade_change),
                    u_label_plane_matrix: new t.bH(e, i.u_label_plane_matrix),
                    u_coord_matrix: new t.bH(e, i.u_coord_matrix),
                    u_is_text: new t.bF(e, i.u_is_text),
                    u_pitch_with_map: new t.bF(e, i.u_pitch_with_map),
                    u_is_along_line: new t.bF(e, i.u_is_along_line),
                    u_is_variable_anchor: new t.bF(e, i.u_is_variable_anchor),
                    u_texsize: new t.bK(e, i.u_texsize),
                    u_texture: new t.bF(e, i.u_texture),
                    u_translation: new t.bK(e, i.u_translation),
                    u_pitched_scale: new t.b8(e, i.u_pitched_scale)
                }),
            symbolSDF: (e, i)=>({
                    u_is_size_zoom_constant: new t.bF(e, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t.bF(e, i.u_is_size_feature_constant),
                    u_size_t: new t.b8(e, i.u_size_t),
                    u_size: new t.b8(e, i.u_size),
                    u_camera_to_center_distance: new t.b8(e, i.u_camera_to_center_distance),
                    u_pitch: new t.b8(e, i.u_pitch),
                    u_rotate_symbol: new t.bF(e, i.u_rotate_symbol),
                    u_aspect_ratio: new t.b8(e, i.u_aspect_ratio),
                    u_fade_change: new t.b8(e, i.u_fade_change),
                    u_label_plane_matrix: new t.bH(e, i.u_label_plane_matrix),
                    u_coord_matrix: new t.bH(e, i.u_coord_matrix),
                    u_is_text: new t.bF(e, i.u_is_text),
                    u_pitch_with_map: new t.bF(e, i.u_pitch_with_map),
                    u_is_along_line: new t.bF(e, i.u_is_along_line),
                    u_is_variable_anchor: new t.bF(e, i.u_is_variable_anchor),
                    u_texsize: new t.bK(e, i.u_texsize),
                    u_texture: new t.bF(e, i.u_texture),
                    u_gamma_scale: new t.b8(e, i.u_gamma_scale),
                    u_device_pixel_ratio: new t.b8(e, i.u_device_pixel_ratio),
                    u_is_halo: new t.bF(e, i.u_is_halo),
                    u_translation: new t.bK(e, i.u_translation),
                    u_pitched_scale: new t.b8(e, i.u_pitched_scale)
                }),
            symbolTextAndIcon: (e, i)=>({
                    u_is_size_zoom_constant: new t.bF(e, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t.bF(e, i.u_is_size_feature_constant),
                    u_size_t: new t.b8(e, i.u_size_t),
                    u_size: new t.b8(e, i.u_size),
                    u_camera_to_center_distance: new t.b8(e, i.u_camera_to_center_distance),
                    u_pitch: new t.b8(e, i.u_pitch),
                    u_rotate_symbol: new t.bF(e, i.u_rotate_symbol),
                    u_aspect_ratio: new t.b8(e, i.u_aspect_ratio),
                    u_fade_change: new t.b8(e, i.u_fade_change),
                    u_label_plane_matrix: new t.bH(e, i.u_label_plane_matrix),
                    u_coord_matrix: new t.bH(e, i.u_coord_matrix),
                    u_is_text: new t.bF(e, i.u_is_text),
                    u_pitch_with_map: new t.bF(e, i.u_pitch_with_map),
                    u_is_along_line: new t.bF(e, i.u_is_along_line),
                    u_is_variable_anchor: new t.bF(e, i.u_is_variable_anchor),
                    u_texsize: new t.bK(e, i.u_texsize),
                    u_texsize_icon: new t.bK(e, i.u_texsize_icon),
                    u_texture: new t.bF(e, i.u_texture),
                    u_texture_icon: new t.bF(e, i.u_texture_icon),
                    u_gamma_scale: new t.b8(e, i.u_gamma_scale),
                    u_device_pixel_ratio: new t.b8(e, i.u_device_pixel_ratio),
                    u_is_halo: new t.bF(e, i.u_is_halo),
                    u_translation: new t.bK(e, i.u_translation),
                    u_pitched_scale: new t.b8(e, i.u_pitched_scale)
                }),
            background: (e, i)=>({
                    u_opacity: new t.b8(e, i.u_opacity),
                    u_color: new t.bG(e, i.u_color)
                }),
            backgroundPattern: (e, i)=>({
                    u_opacity: new t.b8(e, i.u_opacity),
                    u_image: new t.bF(e, i.u_image),
                    u_pattern_tl_a: new t.bK(e, i.u_pattern_tl_a),
                    u_pattern_br_a: new t.bK(e, i.u_pattern_br_a),
                    u_pattern_tl_b: new t.bK(e, i.u_pattern_tl_b),
                    u_pattern_br_b: new t.bK(e, i.u_pattern_br_b),
                    u_texsize: new t.bK(e, i.u_texsize),
                    u_mix: new t.b8(e, i.u_mix),
                    u_pattern_size_a: new t.bK(e, i.u_pattern_size_a),
                    u_pattern_size_b: new t.bK(e, i.u_pattern_size_b),
                    u_scale_a: new t.b8(e, i.u_scale_a),
                    u_scale_b: new t.b8(e, i.u_scale_b),
                    u_pixel_coord_upper: new t.bK(e, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.bK(e, i.u_pixel_coord_lower),
                    u_tile_units_to_pixels: new t.b8(e, i.u_tile_units_to_pixels)
                }),
            terrain: (e, i)=>({
                    u_texture: new t.bF(e, i.u_texture),
                    u_ele_delta: new t.b8(e, i.u_ele_delta),
                    u_fog_matrix: new t.bH(e, i.u_fog_matrix),
                    u_fog_color: new t.bG(e, i.u_fog_color),
                    u_fog_ground_blend: new t.b8(e, i.u_fog_ground_blend),
                    u_fog_ground_blend_opacity: new t.b8(e, i.u_fog_ground_blend_opacity),
                    u_horizon_color: new t.bG(e, i.u_horizon_color),
                    u_horizon_fog_blend: new t.b8(e, i.u_horizon_fog_blend),
                    u_is_globe_mode: new t.b8(e, i.u_is_globe_mode)
                }),
            terrainDepth: (e, i)=>({
                    u_ele_delta: new t.b8(e, i.u_ele_delta)
                }),
            terrainCoords: (e, i)=>({
                    u_texture: new t.bF(e, i.u_texture),
                    u_terrain_coords_id: new t.b8(e, i.u_terrain_coords_id),
                    u_ele_delta: new t.b8(e, i.u_ele_delta)
                }),
            projectionErrorMeasurement: (e, i)=>({
                    u_input: new t.b8(e, i.u_input),
                    u_output_expected: new t.b8(e, i.u_output_expected)
                }),
            atmosphere: (e, i)=>({
                    u_sun_pos: new t.bJ(e, i.u_sun_pos),
                    u_atmosphere_blend: new t.b8(e, i.u_atmosphere_blend),
                    u_globe_position: new t.bJ(e, i.u_globe_position),
                    u_globe_radius: new t.b8(e, i.u_globe_radius),
                    u_inv_proj_matrix: new t.bH(e, i.u_inv_proj_matrix)
                }),
            sky: (e, i)=>({
                    u_sky_color: new t.bG(e, i.u_sky_color),
                    u_horizon_color: new t.bG(e, i.u_horizon_color),
                    u_horizon: new t.bK(e, i.u_horizon),
                    u_horizon_normal: new t.bK(e, i.u_horizon_normal),
                    u_sky_horizon_blend: new t.b8(e, i.u_sky_horizon_blend),
                    u_sky_blend: new t.b8(e, i.u_sky_blend)
                })
        };
        class er {
            constructor(e, t, i){
                this.context = e;
                const r = e.gl;
                this.buffer = r.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), e.bindElementBuffer.set(this.buffer), r.bufferData(r.ELEMENT_ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? r.DYNAMIC_DRAW : r.STATIC_DRAW), this.dynamicDraw || delete t.arrayBuffer;
            }
            bind() {
                this.context.bindElementBuffer.set(this.buffer);
            }
            updateData(e) {
                const t = this.context.gl;
                if (!this.dynamicDraw) throw new Error("Attempted to update data while not in dynamic mode.");
                this.context.unbindVAO(), this.bind(), t.bufferSubData(t.ELEMENT_ARRAY_BUFFER, 0, e.arrayBuffer);
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        const tr = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        };
        class ir {
            constructor(e, t, i, r){
                this.length = t.length, this.attributes = i, this.itemSize = t.bytesPerElement, this.dynamicDraw = r, this.context = e;
                const o = e.gl;
                this.buffer = o.createBuffer(), e.bindVertexBuffer.set(this.buffer), o.bufferData(o.ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? o.DYNAMIC_DRAW : o.STATIC_DRAW), this.dynamicDraw || delete t.arrayBuffer;
            }
            bind() {
                this.context.bindVertexBuffer.set(this.buffer);
            }
            updateData(e) {
                if (e.length !== this.length) throw new Error(`Length of new data is ${e.length}, which doesn't match current length of ${this.length}`);
                const t = this.context.gl;
                this.bind(), t.bufferSubData(t.ARRAY_BUFFER, 0, e.arrayBuffer);
            }
            enableAttributes(e, t) {
                for(let i = 0; i < this.attributes.length; i++){
                    const r = t.attributes[this.attributes[i].name];
                    void 0 !== r && e.enableVertexAttribArray(r);
                }
            }
            setVertexAttribPointers(e, t, i) {
                for(let r = 0; r < this.attributes.length; r++){
                    const o = this.attributes[r], a = t.attributes[o.name];
                    void 0 !== a && e.vertexAttribPointer(a, o.components, e[tr[o.type]], !1, this.itemSize, o.offset + this.itemSize * (i || 0));
                }
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        class rr {
            constructor(e){
                this.gl = e.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
            }
            get() {
                return this.current;
            }
            set(e) {}
            getDefault() {
                return this.default;
            }
            setDefault() {
                this.set(this.default);
            }
        }
        class or extends rr {
            getDefault() {
                return t.b7.transparent;
            }
            set(e) {
                const t = this.current;
                (e.r !== t.r || e.g !== t.g || e.b !== t.b || e.a !== t.a || this.dirty) && (this.gl.clearColor(e.r, e.g, e.b, e.a), this.current = e, this.dirty = !1);
            }
        }
        class ar extends rr {
            getDefault() {
                return 1;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.clearDepth(e), this.current = e, this.dirty = !1);
            }
        }
        class sr extends rr {
            getDefault() {
                return 0;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.clearStencil(e), this.current = e, this.dirty = !1);
            }
        }
        class nr extends rr {
            getDefault() {
                return [
                    !0,
                    !0,
                    !0,
                    !0
                ];
            }
            set(e) {
                const t = this.current;
                (e[0] !== t[0] || e[1] !== t[1] || e[2] !== t[2] || e[3] !== t[3] || this.dirty) && (this.gl.colorMask(e[0], e[1], e[2], e[3]), this.current = e, this.dirty = !1);
            }
        }
        class lr extends rr {
            getDefault() {
                return !0;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.depthMask(e), this.current = e, this.dirty = !1);
            }
        }
        class cr extends rr {
            getDefault() {
                return 255;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.stencilMask(e), this.current = e, this.dirty = !1);
            }
        }
        class hr extends rr {
            getDefault() {
                return {
                    func: this.gl.ALWAYS,
                    ref: 0,
                    mask: 255
                };
            }
            set(e) {
                const t = this.current;
                (e.func !== t.func || e.ref !== t.ref || e.mask !== t.mask || this.dirty) && (this.gl.stencilFunc(e.func, e.ref, e.mask), this.current = e, this.dirty = !1);
            }
        }
        class ur extends rr {
            getDefault() {
                const e = this.gl;
                return [
                    e.KEEP,
                    e.KEEP,
                    e.KEEP
                ];
            }
            set(e) {
                const t = this.current;
                (e[0] !== t[0] || e[1] !== t[1] || e[2] !== t[2] || this.dirty) && (this.gl.stencilOp(e[0], e[1], e[2]), this.current = e, this.dirty = !1);
            }
        }
        class dr extends rr {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t = this.gl;
                e ? t.enable(t.STENCIL_TEST) : t.disable(t.STENCIL_TEST), this.current = e, this.dirty = !1;
            }
        }
        class _r extends rr {
            getDefault() {
                return [
                    0,
                    1
                ];
            }
            set(e) {
                const t = this.current;
                (e[0] !== t[0] || e[1] !== t[1] || this.dirty) && (this.gl.depthRange(e[0], e[1]), this.current = e, this.dirty = !1);
            }
        }
        class pr extends rr {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t = this.gl;
                e ? t.enable(t.DEPTH_TEST) : t.disable(t.DEPTH_TEST), this.current = e, this.dirty = !1;
            }
        }
        class mr extends rr {
            getDefault() {
                return this.gl.LESS;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.depthFunc(e), this.current = e, this.dirty = !1);
            }
        }
        class fr extends rr {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t = this.gl;
                e ? t.enable(t.BLEND) : t.disable(t.BLEND), this.current = e, this.dirty = !1;
            }
        }
        class gr extends rr {
            getDefault() {
                const e = this.gl;
                return [
                    e.ONE,
                    e.ZERO
                ];
            }
            set(e) {
                const t = this.current;
                (e[0] !== t[0] || e[1] !== t[1] || this.dirty) && (this.gl.blendFunc(e[0], e[1]), this.current = e, this.dirty = !1);
            }
        }
        class vr extends rr {
            getDefault() {
                return t.b7.transparent;
            }
            set(e) {
                const t = this.current;
                (e.r !== t.r || e.g !== t.g || e.b !== t.b || e.a !== t.a || this.dirty) && (this.gl.blendColor(e.r, e.g, e.b, e.a), this.current = e, this.dirty = !1);
            }
        }
        class xr extends rr {
            getDefault() {
                return this.gl.FUNC_ADD;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.blendEquation(e), this.current = e, this.dirty = !1);
            }
        }
        class br extends rr {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t = this.gl;
                e ? t.enable(t.CULL_FACE) : t.disable(t.CULL_FACE), this.current = e, this.dirty = !1;
            }
        }
        class yr extends rr {
            getDefault() {
                return this.gl.BACK;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.cullFace(e), this.current = e, this.dirty = !1);
            }
        }
        class wr extends rr {
            getDefault() {
                return this.gl.CCW;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.frontFace(e), this.current = e, this.dirty = !1);
            }
        }
        class Tr extends rr {
            getDefault() {
                return null;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.useProgram(e), this.current = e, this.dirty = !1);
            }
        }
        class Pr extends rr {
            getDefault() {
                return this.gl.TEXTURE0;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.activeTexture(e), this.current = e, this.dirty = !1);
            }
        }
        class Cr extends rr {
            getDefault() {
                const e = this.gl;
                return [
                    0,
                    0,
                    e.drawingBufferWidth,
                    e.drawingBufferHeight
                ];
            }
            set(e) {
                const t = this.current;
                (e[0] !== t[0] || e[1] !== t[1] || e[2] !== t[2] || e[3] !== t[3] || this.dirty) && (this.gl.viewport(e[0], e[1], e[2], e[3]), this.current = e, this.dirty = !1);
            }
        }
        class Ir extends rr {
            getDefault() {
                return null;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t = this.gl;
                t.bindFramebuffer(t.FRAMEBUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class Mr extends rr {
            getDefault() {
                return null;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t = this.gl;
                t.bindRenderbuffer(t.RENDERBUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class Er extends rr {
            getDefault() {
                return null;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t = this.gl;
                t.bindTexture(t.TEXTURE_2D, e), this.current = e, this.dirty = !1;
            }
        }
        class Sr extends rr {
            getDefault() {
                return null;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t = this.gl;
                t.bindBuffer(t.ARRAY_BUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class Rr extends rr {
            getDefault() {
                return null;
            }
            set(e) {
                const t = this.gl;
                t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class Dr extends rr {
            getDefault() {
                return null;
            }
            set(e) {
                var t;
                if (e === this.current && !this.dirty) return;
                const i = this.gl;
                Ut(i) ? i.bindVertexArray(e) : null === (t = i.getExtension("OES_vertex_array_object")) || void 0 === t || t.bindVertexArrayOES(e), this.current = e, this.dirty = !1;
            }
        }
        class zr extends rr {
            getDefault() {
                return 4;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t = this.gl;
                t.pixelStorei(t.UNPACK_ALIGNMENT, e), this.current = e, this.dirty = !1;
            }
        }
        class Ar extends rr {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t = this.gl;
                t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e), this.current = e, this.dirty = !1;
            }
        }
        class Lr extends rr {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t = this.gl;
                t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, e), this.current = e, this.dirty = !1;
            }
        }
        class kr extends rr {
            constructor(e, t){
                super(e), this.context = e, this.parent = t;
            }
            getDefault() {
                return null;
            }
        }
        class Fr extends kr {
            setDirty() {
                this.dirty = !0;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t = this.gl;
                t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, e, 0), this.current = e, this.dirty = !1;
            }
        }
        class Br extends kr {
            set(e) {
                if (e === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t = this.gl;
                t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_ATTACHMENT, t.RENDERBUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class Or extends kr {
            set(e) {
                if (e === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t = this.gl;
                t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_STENCIL_ATTACHMENT, t.RENDERBUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        const jr = "Framebuffer is not complete";
        class Zr {
            constructor(e, t, i, r, o){
                this.context = e, this.width = t, this.height = i;
                const a = e.gl, s = this.framebuffer = a.createFramebuffer();
                if (this.colorAttachment = new Fr(e, s), r) this.depthAttachment = o ? new Or(e, s) : new Br(e, s);
                else if (o) throw new Error("Stencil cannot be set without depth");
                if (a.checkFramebufferStatus(a.FRAMEBUFFER) !== a.FRAMEBUFFER_COMPLETE) throw new Error(jr);
            }
            destroy() {
                const e = this.context.gl, t = this.colorAttachment.get();
                if (t && e.deleteTexture(t), this.depthAttachment) {
                    const t = this.depthAttachment.get();
                    t && e.deleteRenderbuffer(t);
                }
                e.deleteFramebuffer(this.framebuffer);
            }
        }
        class Nr {
            constructor(e){
                var t, i;
                if (this.gl = e, this.clearColor = new or(this), this.clearDepth = new ar(this), this.clearStencil = new sr(this), this.colorMask = new nr(this), this.depthMask = new lr(this), this.stencilMask = new cr(this), this.stencilFunc = new hr(this), this.stencilOp = new ur(this), this.stencilTest = new dr(this), this.depthRange = new _r(this), this.depthTest = new pr(this), this.depthFunc = new mr(this), this.blend = new fr(this), this.blendFunc = new gr(this), this.blendColor = new vr(this), this.blendEquation = new xr(this), this.cullFace = new br(this), this.cullFaceSide = new yr(this), this.frontFace = new wr(this), this.program = new Tr(this), this.activeTexture = new Pr(this), this.viewport = new Cr(this), this.bindFramebuffer = new Ir(this), this.bindRenderbuffer = new Mr(this), this.bindTexture = new Er(this), this.bindVertexBuffer = new Sr(this), this.bindElementBuffer = new Rr(this), this.bindVertexArray = new Dr(this), this.pixelStoreUnpack = new zr(this), this.pixelStoreUnpackPremultiplyAlpha = new Ar(this), this.pixelStoreUnpackFlipY = new Lr(this), this.extTextureFilterAnisotropic = e.getExtension("EXT_texture_filter_anisotropic") || e.getExtension("MOZ_EXT_texture_filter_anisotropic") || e.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.maxTextureSize = e.getParameter(e.MAX_TEXTURE_SIZE), Ut(e)) {
                    this.HALF_FLOAT = e.HALF_FLOAT;
                    const r = e.getExtension("EXT_color_buffer_half_float");
                    this.RGBA16F = null !== (t = e.RGBA16F) && void 0 !== t ? t : null == r ? void 0 : r.RGBA16F_EXT, this.RGB16F = null !== (i = e.RGB16F) && void 0 !== i ? i : null == r ? void 0 : r.RGB16F_EXT, e.getExtension("EXT_color_buffer_float");
                } else {
                    e.getExtension("EXT_color_buffer_half_float"), e.getExtension("OES_texture_half_float_linear");
                    const t = e.getExtension("OES_texture_half_float");
                    this.HALF_FLOAT = null == t ? void 0 : t.HALF_FLOAT_OES;
                }
            }
            setDefault() {
                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
            }
            setDirty() {
                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArray.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
            }
            createIndexBuffer(e, t) {
                return new er(this, e, t);
            }
            createVertexBuffer(e, t, i) {
                return new ir(this, e, t, i);
            }
            createRenderbuffer(e, t, i) {
                const r = this.gl, o = r.createRenderbuffer();
                return this.bindRenderbuffer.set(o), r.renderbufferStorage(r.RENDERBUFFER, e, t, i), this.bindRenderbuffer.set(null), o;
            }
            createFramebuffer(e, t, i, r) {
                return new Zr(this, e, t, i, r);
            }
            clear({ color: e, depth: t, stencil: i }) {
                const r = this.gl;
                let o = 0;
                e && (o |= r.COLOR_BUFFER_BIT, this.clearColor.set(e), this.colorMask.set([
                    !0,
                    !0,
                    !0,
                    !0
                ])), void 0 !== t && (o |= r.DEPTH_BUFFER_BIT, this.depthRange.set([
                    0,
                    1
                ]), this.clearDepth.set(t), this.depthMask.set(!0)), void 0 !== i && (o |= r.STENCIL_BUFFER_BIT, this.clearStencil.set(i), this.stencilMask.set(255)), r.clear(o);
            }
            setCullFace(e) {
                !1 === e.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(e.mode), this.frontFace.set(e.frontFace));
            }
            setDepthMode(e) {
                e.func !== this.gl.ALWAYS || e.mask ? (this.depthTest.set(!0), this.depthFunc.set(e.func), this.depthMask.set(e.mask), this.depthRange.set(e.range)) : this.depthTest.set(!1);
            }
            setStencilMode(e) {
                e.test.func !== this.gl.ALWAYS || e.mask ? (this.stencilTest.set(!0), this.stencilMask.set(e.mask), this.stencilOp.set([
                    e.fail,
                    e.depthFail,
                    e.pass
                ]), this.stencilFunc.set({
                    func: e.test.func,
                    ref: e.ref,
                    mask: e.test.mask
                })) : this.stencilTest.set(!1);
            }
            setColorMode(e) {
                t.bC(e.blendFunction, Ft.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(e.blendFunction), this.blendColor.set(e.blendColor)), this.colorMask.set(e.mask);
            }
            createVertexArray() {
                var e;
                return Ut(this.gl) ? this.gl.createVertexArray() : null === (e = this.gl.getExtension("OES_vertex_array_object")) || void 0 === e ? void 0 : e.createVertexArrayOES();
            }
            deleteVertexArray(e) {
                var t;
                return Ut(this.gl) ? this.gl.deleteVertexArray(e) : null === (t = this.gl.getExtension("OES_vertex_array_object")) || void 0 === t ? void 0 : t.deleteVertexArrayOES(e);
            }
            unbindVAO() {
                this.bindVertexArray.set(null);
            }
        }
        let Gr;
        function Ur(e, i, r, o, a) {
            const s = e.context, n = e.transform, l = s.gl, c = e.useProgram("collisionBox"), h = [];
            let u = 0, d = 0;
            for(let t = 0; t < o.length; t++){
                const _ = o[t], p = i.getTile(_).getBucket(r);
                if (!p) continue;
                const m = a ? p.textCollisionBox : p.iconCollisionBox, f = p.collisionCircleArray;
                f.length > 0 && (h.push({
                    circleArray: f,
                    circleOffset: d,
                    coord: _
                }), u += f.length / 4, d = u), m && c.draw(s, l.LINES, jt.disabled, Nt.disabled, e.colorModeForRenderPass(), Ot.disabled, Di(e.transform), e.style.map.terrain && e.style.map.terrain.getTerrainData(_), n.getProjectionData({
                    overscaledTileID: _,
                    applyGlobeMatrix: !0,
                    applyTerrainMatrix: !0
                }), r.id, m.layoutVertexBuffer, m.indexBuffer, m.segments, null, e.transform.zoom, null, null, m.collisionVertexBuffer);
            }
            if (!a || !h.length) return;
            const _ = e.useProgram("collisionCircle"), p = new t.bP;
            p.resize(4 * u), p._trim();
            let m = 0;
            for (const e of h)for(let t = 0; t < e.circleArray.length / 4; t++){
                const i = 4 * t, r = e.circleArray[i + 0], o = e.circleArray[i + 1], a = e.circleArray[i + 2], s = e.circleArray[i + 3];
                p.emplace(m++, r, o, a, s, 0), p.emplace(m++, r, o, a, s, 1), p.emplace(m++, r, o, a, s, 2), p.emplace(m++, r, o, a, s, 3);
            }
            (!Gr || Gr.length < 2 * u) && (Gr = function(e) {
                const i = 2 * e, r = new t.bR;
                r.resize(i), r._trim();
                for(let e = 0; e < i; e++){
                    const t = 6 * e;
                    r.uint16[t + 0] = 4 * e + 0, r.uint16[t + 1] = 4 * e + 1, r.uint16[t + 2] = 4 * e + 2, r.uint16[t + 3] = 4 * e + 2, r.uint16[t + 4] = 4 * e + 3, r.uint16[t + 5] = 4 * e + 0;
                }
                return r;
            }(u));
            const f = s.createIndexBuffer(Gr, !0), g = s.createVertexBuffer(p, t.bQ.members, !0);
            for (const i of h){
                const o = zi(e.transform);
                _.draw(s, l.TRIANGLES, jt.disabled, Nt.disabled, e.colorModeForRenderPass(), Ot.disabled, o, e.style.map.terrain && e.style.map.terrain.getTerrainData(i.coord), null, r.id, g, f, t.aG.simpleSegment(0, 2 * i.circleOffset, i.circleArray.length, i.circleArray.length / 2), null, e.transform.zoom, null, null, null);
            }
            g.destroy(), f.destroy();
        }
        const Vr = t.at(new Float32Array(16));
        function qr(e, i, r, o, a, s) {
            const { horizontalAlign: n, verticalAlign: l } = t.aB(e);
            return new t.P((-(n - .5) * i / a + o[0]) * s, (-(l - .5) * r / a + o[1]) * s);
        }
        function Wr(e, i, r, o, a, s) {
            const n = i.tileAnchorPoint.add(new t.P(i.translation[0], i.translation[1]));
            if (i.pitchWithMap) {
                let e = o.mult(s);
                r || (e = e.rotate(-a));
                const t = n.add(e);
                return ye(t.x, t.y, i.pitchedLabelPlaneMatrix, i.getElevation).point;
            }
            if (r) {
                const t = Re(i.tileAnchorPoint.x + 1, i.tileAnchorPoint.y, i).point.sub(e), r = Math.atan(t.y / t.x) + (t.x < 0 ? Math.PI : 0);
                return e.add(o.rotate(r));
            }
            return e.add(o);
        }
        function $r(e, i, r, o, a, s, n, l, c, h, u, d) {
            const _ = e.text.placedSymbolArray, p = e.text.dynamicLayoutVertexArray, m = e.icon.dynamicLayoutVertexArray, f = {};
            p.clear();
            for(let m = 0; m < _.length; m++){
                const g = _.get(m), v = g.hidden || !g.crossTileID || e.allowVerticalPlacement && !g.placedOrientation ? null : o[g.crossTileID];
                if (v) {
                    const o = new t.P(g.anchorX, g.anchorY), _ = {
                        getElevation: d,
                        width: a.width,
                        height: a.height,
                        pitchedLabelPlaneMatrix: s,
                        pitchWithMap: r,
                        transform: a,
                        tileAnchorPoint: o,
                        translation: h,
                        unwrappedTileID: u
                    }, m = r ? ze(o.x, o.y, _) : Re(o.x, o.y, _), x = we(a.cameraToCenterDistance, m.signedDistanceFromCamera);
                    let b = t.ai(e.textSizeData, l, g) * x / t.av;
                    r && (b *= e.tilePixelRatio / n);
                    const { width: y, height: w, anchor: T, textOffset: P, textBoxScale: C } = v, I = qr(T, y, w, P, C, b), M = a.getPitchedTextCorrection(o.x + h[0], o.y + h[1], u), E = Wr(m.point, _, i, I, -a.bearingInRadians, M), S = e.allowVerticalPlacement && g.placedOrientation === t.ah.vertical ? Math.PI / 2 : 0;
                    for(let e = 0; e < g.numGlyphs; e++)t.ao(p, E, S);
                    c && g.associatedIconIndex >= 0 && (f[g.associatedIconIndex] = {
                        shiftedAnchor: E,
                        angle: S
                    });
                } else Be(g.numGlyphs, p);
            }
            if (c) {
                m.clear();
                const i = e.icon.placedSymbolArray;
                for(let e = 0; e < i.length; e++){
                    const r = i.get(e);
                    if (r.hidden) Be(r.numGlyphs, m);
                    else {
                        const i = f[e];
                        if (i) for(let e = 0; e < r.numGlyphs; e++)t.ao(m, i.shiftedAnchor, i.angle);
                        else Be(r.numGlyphs, m);
                    }
                }
                e.icon.dynamicLayoutVertexBuffer.updateData(m);
            }
            e.text.dynamicLayoutVertexBuffer.updateData(p);
        }
        function Hr(e, t, i) {
            return i.iconsInText && t ? "symbolTextAndIcon" : e ? "symbolSDF" : "symbolIcon";
        }
        function Kr(e, i, r, o, a, s, n, l, c, h, u, d, _) {
            const p = e.context, m = p.gl, f = e.transform, g = "map" === l, v = "map" === c, x = "viewport" !== l && "point" !== r.layout.get("symbol-placement"), b = g && !v && !x, y = !r.layout.get("symbol-sort-key").isConstant();
            let w = !1;
            const T = e.getDepthModeForSublayer(0, jt.ReadOnly), P = r._unevaluatedLayout.hasValue("text-variable-anchor") || r._unevaluatedLayout.hasValue("text-variable-anchor-offset"), C = [], I = f.getCircleRadiusCorrection();
            for (const l of o){
                const o = i.getTile(l), c = o.getBucket(r);
                if (!c) continue;
                const u = a ? c.text : c.icon;
                if (!u || !u.segments.get().length || !u.hasVisibleVertices) continue;
                const d = u.programConfigurations.get(r.id), p = a || c.sdfIcons, T = a ? c.textSizeData : c.iconSizeData, M = v || 0 !== f.pitch, E = e.useProgram(Hr(p, a, c), d), S = t.ag(T, f.zoom), R = e.style.map.terrain && e.style.map.terrain.getTerrainData(l);
                let D, z, A, L, k = [
                    0,
                    0
                ], F = null;
                if (a) z = o.glyphAtlasTexture, A = m.LINEAR, D = o.glyphAtlasTexture.size, c.iconsInText && (k = o.imageAtlasTexture.size, F = o.imageAtlasTexture, L = M || e.options.rotating || e.options.zooming || "composite" === T.kind || "camera" === T.kind ? m.LINEAR : m.NEAREST);
                else {
                    const t = 1 !== r.layout.get("icon-size").constantOr(0) || c.iconsNeedLinear;
                    z = o.imageAtlasTexture, A = p || e.options.rotating || e.options.zooming || t || M ? m.LINEAR : m.NEAREST, D = o.imageAtlasTexture.size;
                }
                const B = t.aw(o, 1, e.transform.zoom), O = ve(g, e.transform, B), j = t.K();
                t.aj(j, O);
                const Z = xe(v, g, e.transform, B), N = t.ax(f, o, s, n), G = f.getProjectionData({
                    overscaledTileID: l,
                    applyGlobeMatrix: !_,
                    applyTerrainMatrix: !0
                }), U = P && c.hasTextData(), V = "none" !== r.layout.get("icon-text-fit") && U && c.hasIconData();
                if (x) {
                    const t = e.style.map.terrain ? (t, i)=>e.style.map.terrain.getElevation(l, t, i) : null, i = "map" === r.layout.get("text-rotation-alignment");
                    Pe(c, e, a, O, j, v, h, i, l.toUnwrapped(), f.width, f.height, N, t);
                }
                const q = a && P || V, W = x || q ? Vr : v ? O : e.transform.clipSpaceToPixelsMatrix, $ = p && 0 !== r.paint.get(a ? "text-halo-width" : "icon-halo-width").constantOr(1);
                let H;
                H = p ? c.iconsInText ? Ki(T.kind, S, b, v, x, q, e, W, Z, N, D, k, I) : Hi(T.kind, S, b, v, x, q, e, W, Z, N, a, D, 0, I) : $i(T.kind, S, b, v, x, q, e, W, Z, N, a, D, I);
                const K = {
                    program: E,
                    buffers: u,
                    uniformValues: H,
                    projectionData: G,
                    atlasTexture: z,
                    atlasTextureIcon: F,
                    atlasInterpolation: A,
                    atlasInterpolationIcon: L,
                    isSDF: p,
                    hasHalo: $
                };
                if (y && c.canOverlap) {
                    w = !0;
                    const e = u.segments.get();
                    for (const i of e)C.push({
                        segments: new t.aG([
                            i
                        ]),
                        sortKey: i.sortKey,
                        state: K,
                        terrainData: R
                    });
                } else C.push({
                    segments: u.segments,
                    sortKey: 0,
                    state: K,
                    terrainData: R
                });
            }
            w && C.sort((e, t)=>e.sortKey - t.sortKey);
            for (const t of C){
                const i = t.state;
                if (p.activeTexture.set(m.TEXTURE0), i.atlasTexture.bind(i.atlasInterpolation, m.CLAMP_TO_EDGE), i.atlasTextureIcon && (p.activeTexture.set(m.TEXTURE1), i.atlasTextureIcon && i.atlasTextureIcon.bind(i.atlasInterpolationIcon, m.CLAMP_TO_EDGE)), i.isSDF) {
                    const o = i.uniformValues;
                    i.hasHalo && (o.u_is_halo = 1, Xr(i.buffers, t.segments, r, e, i.program, T, u, d, o, i.projectionData, t.terrainData)), o.u_is_halo = 0;
                }
                Xr(i.buffers, t.segments, r, e, i.program, T, u, d, i.uniformValues, i.projectionData, t.terrainData);
            }
        }
        function Xr(e, t, i, r, o, a, s, n, l, c, h) {
            const u = r.context;
            o.draw(u, u.gl.TRIANGLES, a, s, n, Ot.backCCW, l, h, c, i.id, e.layoutVertexBuffer, e.indexBuffer, t, i.paint, r.transform.zoom, e.programConfigurations.get(i.id), e.dynamicLayoutVertexBuffer, e.opacityVertexBuffer);
        }
        function Qr(e, i, r, o, a) {
            const s = e.context, n = s.gl, l = Nt.disabled, c = new Ft([
                n.ONE,
                n.ONE
            ], t.b7.transparent, [
                !0,
                !0,
                !0,
                !0
            ]), h = i.getBucket(r);
            if (!h) return;
            const u = o.key;
            let d = r.heatmapFbos.get(u);
            d || (d = Jr(s, i.tileSize, i.tileSize), r.heatmapFbos.set(u, d)), s.bindFramebuffer.set(d.framebuffer), s.viewport.set([
                0,
                0,
                i.tileSize,
                i.tileSize
            ]), s.clear({
                color: t.b7.transparent
            });
            const _ = h.programConfigurations.get(r.id), p = e.useProgram("heatmap", _, !a), m = e.transform.getProjectionData({
                overscaledTileID: i.tileID,
                applyGlobeMatrix: !0,
                applyTerrainMatrix: !0
            }), f = e.style.map.terrain.getTerrainData(o);
            p.draw(s, n.TRIANGLES, jt.disabled, l, c, Ot.disabled, Li(i, e.transform.zoom, r.paint.get("heatmap-intensity"), 1), f, m, r.id, h.layoutVertexBuffer, h.indexBuffer, h.segments, r.paint, e.transform.zoom, _);
        }
        function Yr(e, t, i, r, o) {
            const a = e.context, s = a.gl, n = e.transform;
            a.setColorMode(e.colorModeForRenderPass());
            const l = eo(a, t), c = i.key, h = t.heatmapFbos.get(c);
            if (!h) return;
            a.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, h.colorAttachment.get()), a.activeTexture.set(s.TEXTURE1), l.bind(s.LINEAR, s.CLAMP_TO_EDGE);
            const u = n.getProjectionData({
                overscaledTileID: i,
                applyTerrainMatrix: o,
                applyGlobeMatrix: !r
            });
            e.useProgram("heatmapTexture").draw(a, s.TRIANGLES, jt.disabled, Nt.disabled, e.colorModeForRenderPass(), Ot.disabled, ki(e, t, 0, 1), null, u, t.id, e.rasterBoundsBuffer, e.quadTriangleIndexBuffer, e.rasterBoundsSegments, t.paint, n.zoom), h.destroy(), t.heatmapFbos.delete(c);
        }
        function Jr(e, t, i) {
            var r, o;
            const a = e.gl, s = a.createTexture();
            a.bindTexture(a.TEXTURE_2D, s), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_S, a.CLAMP_TO_EDGE), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_T, a.CLAMP_TO_EDGE), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, a.LINEAR), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MAG_FILTER, a.LINEAR);
            const n = null !== (r = e.HALF_FLOAT) && void 0 !== r ? r : a.UNSIGNED_BYTE, l = null !== (o = e.RGBA16F) && void 0 !== o ? o : a.RGBA;
            a.texImage2D(a.TEXTURE_2D, 0, l, t, i, 0, a.RGBA, n, null);
            const c = e.createFramebuffer(t, i, !1, !1);
            return c.colorAttachment.set(s), c;
        }
        function eo(e, t) {
            return t.colorRampTexture || (t.colorRampTexture = new v(e, t.colorRamp, e.gl.RGBA)), t.colorRampTexture;
        }
        function to(e, t, i, r, o) {
            if (!i || !r || !r.imageAtlas) return;
            const a = r.imageAtlas.patternPositions;
            let s = a[i.to.toString()], n = a[i.from.toString()];
            if (!s && n && (s = n), !n && s && (n = s), !s || !n) {
                const e = o.getPaintProperty(t);
                s = a[e], n = a[e];
            }
            s && n && e.setConstantPatternPositions(s, n);
        }
        function io(e, i, r, o, a, s, n, l) {
            const c = e.context.gl, h = "fill-pattern", u = r.paint.get(h), d = u && u.constantOr(1), _ = r.getCrossfadeParameters();
            let p, m, f, g, v;
            const x = e.transform, b = r.paint.get("fill-translate"), y = r.paint.get("fill-translate-anchor");
            n ? (m = d && !r.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", p = c.LINES) : (m = d ? "fillPattern" : "fill", p = c.TRIANGLES);
            const w = u.constantOr(null);
            for (const u of o){
                const T = i.getTile(u);
                if (d && !T.patternsLoaded()) continue;
                const P = T.getBucket(r);
                if (!P) continue;
                const C = P.programConfigurations.get(r.id), I = e.useProgram(m, C), M = e.style.map.terrain && e.style.map.terrain.getTerrainData(u);
                d && (e.context.activeTexture.set(c.TEXTURE0), T.imageAtlasTexture.bind(c.LINEAR, c.CLAMP_TO_EDGE), C.updatePaintBuffers(_)), to(C, h, w, T, r);
                const E = x.getProjectionData({
                    overscaledTileID: u,
                    applyGlobeMatrix: !l,
                    applyTerrainMatrix: !0
                }), S = t.ax(x, T, b, y);
                if (n) {
                    g = P.indexBuffer2, v = P.segments2;
                    const t = [
                        c.drawingBufferWidth,
                        c.drawingBufferHeight
                    ];
                    f = "fillOutlinePattern" === m && d ? Si(e, _, T, t, S) : Ei(t, S);
                } else g = P.indexBuffer, v = P.segments, f = d ? Mi(e, _, T, S) : {
                    u_fill_translate: S
                };
                let R;
                if ("translucent" === e.renderPass && l) {
                    const [t] = e.getStencilConfigForOverlapAndUpdateStencilID(o);
                    R = t[u.overscaledZ];
                } else R = e.stencilModeForClipping(u);
                I.draw(e.context, p, a, R, s, Ot.backCCW, f, M, E, r.id, P.layoutVertexBuffer, g, v, r.paint, e.transform.zoom, C);
            }
        }
        function ro(e, i, r, o, a, s, n, l) {
            const c = e.context, h = c.gl, u = "fill-extrusion-pattern", d = r.paint.get(u), _ = d.constantOr(1), p = r.getCrossfadeParameters(), m = r.paint.get("fill-extrusion-opacity"), f = d.constantOr(null), g = e.transform;
            for (const d of o){
                const o = i.getTile(d), v = o.getBucket(r);
                if (!v) continue;
                const x = e.style.map.terrain && e.style.map.terrain.getTerrainData(d), b = v.programConfigurations.get(r.id), y = e.useProgram(_ ? "fillExtrusionPattern" : "fillExtrusion", b);
                _ && (e.context.activeTexture.set(h.TEXTURE0), o.imageAtlasTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), b.updatePaintBuffers(p));
                const w = g.getProjectionData({
                    overscaledTileID: d,
                    applyGlobeMatrix: !l,
                    applyTerrainMatrix: !0
                });
                to(b, u, f, o, r);
                const T = t.ax(g, o, r.paint.get("fill-extrusion-translate"), r.paint.get("fill-extrusion-translate-anchor")), P = r.paint.get("fill-extrusion-vertical-gradient"), C = _ ? Ii(e, P, m, T, d, p, o) : Ci(e, P, m, T);
                y.draw(c, c.gl.TRIANGLES, a, s, n, Ot.backCCW, C, x, w, r.id, v.layoutVertexBuffer, v.indexBuffer, v.segments, r.paint, e.transform.zoom, b, e.style.map.terrain && v.centroidVertexBuffer);
            }
        }
        function oo(e, t, i, r, o, a, s, n, l) {
            var c;
            const h = e.style.projection, u = e.context, d = e.transform, _ = u.gl, p = e.useProgram("hillshade"), m = !e.options.moving;
            for (const f of r){
                const r = t.getTile(f), g = r.fbo;
                if (!g) continue;
                const v = h.getMeshFromTileID(u, f.canonical, n, !0, "raster"), x = null === (c = e.style.map.terrain) || void 0 === c ? void 0 : c.getTerrainData(f);
                u.activeTexture.set(_.TEXTURE0), _.bindTexture(_.TEXTURE_2D, g.colorAttachment.get());
                const b = d.getProjectionData({
                    overscaledTileID: f,
                    aligned: m,
                    applyGlobeMatrix: !l,
                    applyTerrainMatrix: !0
                });
                p.draw(u, _.TRIANGLES, a, o[f.overscaledZ], s, Ot.backCCW, Fi(e, r, i), x, b, i.id, v.vertexBuffer, v.indexBuffer, v.segments);
            }
        }
        const ao = [
            new t.P(0, 0),
            new t.P(t.Z, 0),
            new t.P(t.Z, t.Z),
            new t.P(0, t.Z)
        ];
        function so(e, t, i, r, o, a, s, n, l = !1, c = !1) {
            const h = r[r.length - 1].overscaledZ, u = e.context, d = u.gl, _ = e.useProgram("raster"), p = e.transform, m = e.style.projection, f = e.colorModeForRenderPass(), g = !e.options.moving;
            for (const v of r){
                const r = e.getDepthModeForSublayer(v.overscaledZ - h, 1 === i.paint.get("raster-opacity") ? jt.ReadWrite : jt.ReadOnly, d.LESS), x = t.getTile(v);
                x.registerFadeDuration(i.paint.get("raster-fade-duration"));
                const b = t.findLoadedParent(v, 0), y = t.findLoadedSibling(v), w = no(x, b || y || null, t, i, e.transform, e.style.map.terrain);
                let T, P;
                const C = "nearest" === i.paint.get("raster-resampling") ? d.NEAREST : d.LINEAR;
                u.activeTexture.set(d.TEXTURE0), x.texture.bind(C, d.CLAMP_TO_EDGE, d.LINEAR_MIPMAP_NEAREST), u.activeTexture.set(d.TEXTURE1), b ? (b.texture.bind(C, d.CLAMP_TO_EDGE, d.LINEAR_MIPMAP_NEAREST), T = Math.pow(2, b.tileID.overscaledZ - x.tileID.overscaledZ), P = [
                    x.tileID.canonical.x * T % 1,
                    x.tileID.canonical.y * T % 1
                ]) : x.texture.bind(C, d.CLAMP_TO_EDGE, d.LINEAR_MIPMAP_NEAREST), x.texture.useMipmap && u.extTextureFilterAnisotropic && e.transform.pitch > 20 && d.texParameterf(d.TEXTURE_2D, u.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, u.extTextureFilterAnisotropicMax);
                const I = e.style.map.terrain && e.style.map.terrain.getTerrainData(v), M = p.getProjectionData({
                    overscaledTileID: v,
                    aligned: g,
                    applyGlobeMatrix: !c,
                    applyTerrainMatrix: !0
                }), E = qi(P || [
                    0,
                    0
                ], T || 1, w, i, n), S = m.getMeshFromTileID(u, v.canonical, a, s, "raster");
                _.draw(u, d.TRIANGLES, r, o ? o[v.overscaledZ] : Nt.disabled, f, l ? Ot.frontCCW : Ot.backCCW, E, I, M, i.id, S.vertexBuffer, S.indexBuffer, S.segments);
            }
        }
        function no(e, i, r, o, a, n) {
            const l = o.paint.get("raster-fade-duration");
            if (!n && l > 0) {
                const o = s.now(), n = (o - e.timeAdded) / l, c = i ? (o - i.timeAdded) / l : -1, h = r.getSource(), u = he(a, {
                    tileSize: h.tileSize,
                    roundZoom: h.roundZoom
                }), d = !i || Math.abs(i.tileID.overscaledZ - u) > Math.abs(e.tileID.overscaledZ - u), _ = d && e.refreshedUponExpiration ? 1 : t.ae(d ? n : 1 - c, 0, 1);
                return e.refreshedUponExpiration && n >= 1 && (e.refreshedUponExpiration = !1), i ? {
                    opacity: 1,
                    mix: 1 - _
                } : {
                    opacity: _,
                    mix: 0
                };
            }
            return {
                opacity: 1,
                mix: 0
            };
        }
        const lo = new t.b7(1, 0, 0, 1), co = new t.b7(0, 1, 0, 1), ho = new t.b7(0, 0, 1, 1), uo = new t.b7(1, 0, 1, 1), _o = new t.b7(0, 1, 1, 1);
        function po(e, t, i, r) {
            fo(e, 0, t + i / 2, e.transform.width, i, r);
        }
        function mo(e, t, i, r) {
            fo(e, t - i / 2, 0, i, e.transform.height, r);
        }
        function fo(e, t, i, r, o, a) {
            const s = e.context, n = s.gl;
            n.enable(n.SCISSOR_TEST), n.scissor(t * e.pixelRatio, i * e.pixelRatio, r * e.pixelRatio, o * e.pixelRatio), s.clear({
                color: a
            }), n.disable(n.SCISSOR_TEST);
        }
        function go(e, i, r) {
            const o = e.context, a = o.gl, s = e.useProgram("debug"), n = jt.disabled, l = Nt.disabled, c = e.colorModeForRenderPass(), h = "$debug", u = e.style.map.terrain && e.style.map.terrain.getTerrainData(r);
            o.activeTexture.set(a.TEXTURE0);
            const d = i.getTileByID(r.key).latestRawTileData, _ = Math.floor((d && d.byteLength || 0) / 1024), p = i.getTile(r).tileSize, m = 512 / Math.min(p, 512) * (r.overscaledZ / e.transform.zoom) * .5;
            let f = r.canonical.toString();
            r.overscaledZ !== r.canonical.z && (f += ` => ${r.overscaledZ}`), function(e, t) {
                e.initDebugOverlayCanvas();
                const i = e.debugOverlayCanvas, r = e.context.gl, o = e.debugOverlayCanvas.getContext("2d");
                o.clearRect(0, 0, i.width, i.height), o.shadowColor = "white", o.shadowBlur = 2, o.lineWidth = 1.5, o.strokeStyle = "white", o.textBaseline = "top", o.font = "bold 36px Open Sans, sans-serif", o.fillText(t, 5, 5), o.strokeText(t, 5, 5), e.debugOverlayTexture.update(i), e.debugOverlayTexture.bind(r.LINEAR, r.CLAMP_TO_EDGE);
            }(e, `${f} ${_}kB`);
            const g = e.transform.getProjectionData({
                overscaledTileID: r,
                applyGlobeMatrix: !0,
                applyTerrainMatrix: !0
            });
            s.draw(o, a.TRIANGLES, n, l, Ft.alphaBlended, Ot.disabled, Ai(t.b7.transparent, m), null, g, h, e.debugBuffer, e.quadTriangleIndexBuffer, e.debugSegments), s.draw(o, a.LINE_STRIP, n, l, c, Ot.disabled, Ai(t.b7.red), u, g, h, e.debugBuffer, e.tileBorderIndexBuffer, e.debugSegments);
        }
        function vo(e, t, i, r) {
            const { isRenderingGlobe: o } = r, a = e.context, s = a.gl, n = e.transform, l = e.colorModeForRenderPass(), c = e.getDepthModeFor3D(), h = e.useProgram("terrain");
            a.bindFramebuffer.set(null), a.viewport.set([
                0,
                0,
                e.width,
                e.height
            ]);
            for (const r of i){
                const i = t.getTerrainMesh(r.tileID), u = e.renderToTexture.getTexture(r), d = t.getTerrainData(r.tileID);
                a.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, u.texture);
                const _ = t.getMeshFrameDelta(n.zoom), p = n.calculateFogMatrix(r.tileID.toUnwrapped()), m = bi(_, p, e.style.sky, n.pitch, o), f = n.getProjectionData({
                    overscaledTileID: r.tileID,
                    applyTerrainMatrix: !1,
                    applyGlobeMatrix: !0
                });
                h.draw(a, s.TRIANGLES, c, Nt.disabled, l, Ot.backCCW, m, d, f, "terrain", i.vertexBuffer, i.indexBuffer, i.segments);
            }
        }
        function xo(e, i) {
            if (!i.mesh) {
                const r = new t.aF;
                r.emplaceBack(-1, -1), r.emplaceBack(1, -1), r.emplaceBack(1, 1), r.emplaceBack(-1, 1);
                const o = new t.aH;
                o.emplaceBack(0, 1, 2), o.emplaceBack(0, 2, 3), i.mesh = new pt(e.createVertexBuffer(r, mt.members), e.createIndexBuffer(o), t.aG.simpleSegment(0, 0, r.length, o.length));
            }
            return i.mesh;
        }
        class bo {
            constructor(e, i){
                this.context = new Nr(e), this.transform = i, this._tileTextures = {}, this.terrainFacilitator = {
                    dirty: !0,
                    matrix: t.at(new Float64Array(16)),
                    renderTime: 0
                }, this.setup(), this.numSublayers = de.maxUnderzooming + de.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new ht;
            }
            resize(e, t, i) {
                if (this.width = Math.floor(e * i), this.height = Math.floor(t * i), this.pixelRatio = i, this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.style) for (const e of this.style._order)this.style._layers[e].resize();
            }
            setup() {
                const e = this.context, i = new t.aF;
                i.emplaceBack(0, 0), i.emplaceBack(t.Z, 0), i.emplaceBack(0, t.Z), i.emplaceBack(t.Z, t.Z), this.tileExtentBuffer = e.createVertexBuffer(i, mt.members), this.tileExtentSegments = t.aG.simpleSegment(0, 0, 4, 2);
                const r = new t.aF;
                r.emplaceBack(0, 0), r.emplaceBack(t.Z, 0), r.emplaceBack(0, t.Z), r.emplaceBack(t.Z, t.Z), this.debugBuffer = e.createVertexBuffer(r, mt.members), this.debugSegments = t.aG.simpleSegment(0, 0, 4, 5);
                const o = new t.bW;
                o.emplaceBack(0, 0, 0, 0), o.emplaceBack(t.Z, 0, t.Z, 0), o.emplaceBack(0, t.Z, 0, t.Z), o.emplaceBack(t.Z, t.Z, t.Z, t.Z), this.rasterBoundsBuffer = e.createVertexBuffer(o, vi.members), this.rasterBoundsSegments = t.aG.simpleSegment(0, 0, 4, 2);
                const a = new t.aF;
                a.emplaceBack(0, 0), a.emplaceBack(t.Z, 0), a.emplaceBack(0, t.Z), a.emplaceBack(t.Z, t.Z), this.rasterBoundsBufferPosOnly = e.createVertexBuffer(a, mt.members), this.rasterBoundsSegmentsPosOnly = t.aG.simpleSegment(0, 0, 4, 5);
                const s = new t.aF;
                s.emplaceBack(0, 0), s.emplaceBack(1, 0), s.emplaceBack(0, 1), s.emplaceBack(1, 1), this.viewportBuffer = e.createVertexBuffer(s, mt.members), this.viewportSegments = t.aG.simpleSegment(0, 0, 4, 2);
                const n = new t.bX;
                n.emplaceBack(0), n.emplaceBack(1), n.emplaceBack(3), n.emplaceBack(2), n.emplaceBack(0), this.tileBorderIndexBuffer = e.createIndexBuffer(n);
                const l = new t.aH;
                l.emplaceBack(1, 0, 2), l.emplaceBack(1, 2, 3), this.quadTriangleIndexBuffer = e.createIndexBuffer(l);
                const c = this.context.gl;
                this.stencilClearMode = new Nt({
                    func: c.ALWAYS,
                    mask: 0
                }, 0, 255, c.ZERO, c.ZERO, c.ZERO), this.tileExtentMesh = new pt(this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
            }
            clearStencil() {
                const e = this.context, i = e.gl;
                this.nextStencilID = 1, this.currentStencilSource = void 0;
                const r = t.K();
                t.bO(r, 0, this.width, this.height, 0, 0, 1), t.M(r, r, [
                    i.drawingBufferWidth,
                    i.drawingBufferHeight,
                    0
                ]);
                const o = {
                    mainMatrix: r,
                    tileMercatorCoords: [
                        0,
                        0,
                        1,
                        1
                    ],
                    clippingPlane: [
                        0,
                        0,
                        0,
                        0
                    ],
                    projectionTransition: 0,
                    fallbackMatrix: r
                };
                this.useProgram("clippingMask", null, !0).draw(e, i.TRIANGLES, jt.disabled, this.stencilClearMode, Ft.disabled, Ot.disabled, null, null, o, "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
            }
            _renderTileClippingMasks(e, t, i) {
                if (this.currentStencilSource === e.source || !e.isTileClipped() || !t || !t.length) return;
                this.currentStencilSource = e.source, this.nextStencilID + t.length > 256 && this.clearStencil();
                const r = this.context;
                r.setColorMode(Ft.disabled), r.setDepthMode(jt.disabled);
                const o = {};
                for (const e of t)o[e.key] = this.nextStencilID++;
                this._renderTileMasks(o, t, i, !0), this._renderTileMasks(o, t, i, !1), this._tileClippingMaskIDs = o;
            }
            _renderTileMasks(e, t, i, r) {
                const o = this.context, a = o.gl, s = this.style.projection, n = this.transform, l = this.useProgram("clippingMask");
                for (const c of t){
                    const t = e[c.key], h = this.style.map.terrain && this.style.map.terrain.getTerrainData(c), u = s.getMeshFromTileID(this.context, c.canonical, r, !0, "stencil"), d = n.getProjectionData({
                        overscaledTileID: c,
                        applyGlobeMatrix: !0,
                        applyTerrainMatrix: !0
                    });
                    l.draw(o, a.TRIANGLES, jt.disabled, new Nt({
                        func: a.ALWAYS,
                        mask: 0
                    }, t, 255, a.KEEP, a.KEEP, a.REPLACE), Ft.disabled, i ? Ot.disabled : Ot.backCCW, null, h, d, "$clipping", u.vertexBuffer, u.indexBuffer, u.segments);
                }
            }
            _renderTilesDepthBuffer() {
                const e = this.context, t = e.gl, i = this.style.projection, r = this.transform, o = this.useProgram("depth"), a = this.getDepthModeFor3D(), s = ue(r, {
                    tileSize: r.tileSize
                });
                for (const n of s){
                    const s = this.style.map.terrain && this.style.map.terrain.getTerrainData(n), l = i.getMeshFromTileID(this.context, n.canonical, !0, !0, "raster"), c = r.getProjectionData({
                        overscaledTileID: n,
                        applyGlobeMatrix: !0,
                        applyTerrainMatrix: !0
                    });
                    o.draw(e, t.TRIANGLES, a, Nt.disabled, Ft.disabled, Ot.backCCW, null, s, c, "$clipping", l.vertexBuffer, l.indexBuffer, l.segments);
                }
            }
            stencilModeFor3D() {
                this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                const e = this.nextStencilID++, t = this.context.gl;
                return new Nt({
                    func: t.NOTEQUAL,
                    mask: 255
                }, e, 255, t.KEEP, t.KEEP, t.REPLACE);
            }
            stencilModeForClipping(e) {
                const t = this.context.gl;
                return new Nt({
                    func: t.EQUAL,
                    mask: 255
                }, this._tileClippingMaskIDs[e.key], 0, t.KEEP, t.KEEP, t.REPLACE);
            }
            getStencilConfigForOverlapAndUpdateStencilID(e) {
                const t = this.context.gl, i = e.sort((e, t)=>t.overscaledZ - e.overscaledZ), r = i[i.length - 1].overscaledZ, o = i[0].overscaledZ - r + 1;
                if (o > 1) {
                    this.currentStencilSource = void 0, this.nextStencilID + o > 256 && this.clearStencil();
                    const e = {};
                    for(let i = 0; i < o; i++)e[i + r] = new Nt({
                        func: t.GEQUAL,
                        mask: 255
                    }, i + this.nextStencilID, 255, t.KEEP, t.KEEP, t.REPLACE);
                    return this.nextStencilID += o, [
                        e,
                        i
                    ];
                }
                return [
                    {
                        [r]: Nt.disabled
                    },
                    i
                ];
            }
            stencilConfigForOverlapTwoPass(e) {
                const t = this.context.gl, i = e.sort((e, t)=>t.overscaledZ - e.overscaledZ), r = i[i.length - 1].overscaledZ, o = i[0].overscaledZ - r + 1;
                if (this.clearStencil(), o > 1) {
                    const e = {}, a = {};
                    for(let i = 0; i < o; i++)e[i + r] = new Nt({
                        func: t.GREATER,
                        mask: 255
                    }, o + 1 + i, 255, t.KEEP, t.KEEP, t.REPLACE), a[i + r] = new Nt({
                        func: t.GREATER,
                        mask: 255
                    }, 1 + i, 255, t.KEEP, t.KEEP, t.REPLACE);
                    return this.nextStencilID = 2 * o + 1, [
                        e,
                        a,
                        i
                    ];
                }
                return this.nextStencilID = 3, [
                    {
                        [r]: new Nt({
                            func: t.GREATER,
                            mask: 255
                        }, 2, 255, t.KEEP, t.KEEP, t.REPLACE)
                    },
                    {
                        [r]: new Nt({
                            func: t.GREATER,
                            mask: 255
                        }, 1, 255, t.KEEP, t.KEEP, t.REPLACE)
                    },
                    i
                ];
            }
            colorModeForRenderPass() {
                const e = this.context.gl;
                if (this._showOverdrawInspector) {
                    const i = 1 / 8;
                    return new Ft([
                        e.CONSTANT_COLOR,
                        e.ONE
                    ], new t.b7(i, i, i, 0), [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                }
                return "opaque" === this.renderPass ? Ft.unblended : Ft.alphaBlended;
            }
            getDepthModeForSublayer(e, t, i) {
                if (!this.opaquePassEnabledForLayer()) return jt.disabled;
                const r = 1 - ((1 + this.currentLayer) * this.numSublayers + e) * this.depthEpsilon;
                return new jt(i || this.context.gl.LEQUAL, t, [
                    r,
                    r
                ]);
            }
            getDepthModeFor3D() {
                return new jt(this.context.gl.LEQUAL, jt.ReadWrite, this.depthRangeFor3D);
            }
            opaquePassEnabledForLayer() {
                return this.currentLayer < this.opaquePassCutoff;
            }
            render(e, i) {
                var r, o;
                this.style = e, this.options = i, this.lineAtlas = e.lineAtlas, this.imageManager = e.imageManager, this.glyphManager = e.glyphManager, this.symbolFadeChange = e.placement.symbolFadeChange(s.now()), this.imageManager.beginFrame();
                const a = this.style._order, n = this.style.sourceCaches, l = {}, c = {}, h = {}, u = {
                    isRenderingToTexture: !1,
                    isRenderingGlobe: (null === (r = e.projection) || void 0 === r ? void 0 : r.transitionState) > 0
                };
                for(const e in n){
                    const t = n[e];
                    t.used && t.prepare(this.context), l[e] = t.getVisibleCoordinates(!1), c[e] = l[e].slice().reverse(), h[e] = t.getVisibleCoordinates(!0).reverse();
                }
                this.opaquePassCutoff = 1 / 0;
                for(let e = 0; e < a.length; e++)if (this.style._layers[a[e]].is3D()) {
                    this.opaquePassCutoff = e;
                    break;
                }
                this.maybeDrawDepthAndCoords(!1), this.renderToTexture && (this.renderToTexture.prepareForRender(this.style, this.transform.zoom), this.opaquePassCutoff = 0), this.renderPass = "offscreen";
                for (const e of a){
                    const t = this.style._layers[e];
                    if (!t.hasOffscreenPass() || t.isHidden(this.transform.zoom)) continue;
                    const i = c[t.source];
                    ("custom" === t.type || i.length) && this.renderLayer(this, n[t.source], t, i, u);
                }
                if (null === (o = this.style.projection) || void 0 === o || o.updateGPUdependent({
                    context: this.context,
                    useProgram: (e)=>this.useProgram(e)
                }), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.bindFramebuffer.set(null), this.context.clear({
                    color: i.showOverdrawInspector ? t.b7.black : t.b7.transparent,
                    depth: 1
                }), this.clearStencil(), this.style.sky && function(e, t) {
                    const i = e.context, r = i.gl, o = ((e, t, i)=>{
                        const r = Math.cos(t.rollInRadians), o = Math.sin(t.rollInRadians), a = yt(t), s = t.getProjectionData({
                            overscaledTileID: null,
                            applyGlobeMatrix: !0,
                            applyTerrainMatrix: !0
                        }).projectionTransition;
                        return {
                            u_sky_color: e.properties.get("sky-color"),
                            u_horizon_color: e.properties.get("horizon-color"),
                            u_horizon: [
                                (t.width / 2 - a * o) * i,
                                (t.height / 2 + a * r) * i
                            ],
                            u_horizon_normal: [
                                -o,
                                r
                            ],
                            u_sky_horizon_blend: e.properties.get("sky-horizon-blend") * t.height / 2 * i,
                            u_sky_blend: s
                        };
                    })(t, e.style.map.transform, e.pixelRatio), a = new jt(r.LEQUAL, jt.ReadWrite, [
                        0,
                        1
                    ]), s = Nt.disabled, n = e.colorModeForRenderPass(), l = e.useProgram("sky"), c = xo(i, t);
                    l.draw(i, r.TRIANGLES, a, s, n, Ot.disabled, o, null, void 0, "sky", c.vertexBuffer, c.indexBuffer, c.segments);
                }(this, this.style.sky), this._showOverdrawInspector = i.showOverdrawInspector, this.depthRangeFor3D = [
                    0,
                    1 - (e._order.length + 2) * this.numSublayers * this.depthEpsilon
                ], !this.renderToTexture) for(this.renderPass = "opaque", this.currentLayer = a.length - 1; this.currentLayer >= 0; this.currentLayer--){
                    const e = this.style._layers[a[this.currentLayer]], t = n[e.source], i = l[e.source];
                    this._renderTileClippingMasks(e, i, !1), this.renderLayer(this, t, e, i, u);
                }
                this.renderPass = "translucent";
                let d = !1;
                for(this.currentLayer = 0; this.currentLayer < a.length; this.currentLayer++){
                    const e = this.style._layers[a[this.currentLayer]], t = n[e.source];
                    if (this.renderToTexture && this.renderToTexture.renderLayer(e, u)) continue;
                    this.opaquePassEnabledForLayer() || d || (d = !0, u.isRenderingGlobe && !this.style.map.terrain && this._renderTilesDepthBuffer());
                    const i = ("symbol" === e.type ? h : c)[e.source];
                    this._renderTileClippingMasks(e, l[e.source], !1), this.renderLayer(this, t, e, i, u);
                }
                if (u.isRenderingGlobe && function(e, i, r) {
                    const o = e.context, a = o.gl, s = e.useProgram("atmosphere"), n = new jt(a.LEQUAL, jt.ReadOnly, [
                        0,
                        1
                    ]), l = e.transform, c = function(e, i) {
                        const r = e.properties.get("position"), o = [
                            -r.x,
                            -r.y,
                            -r.z
                        ], a = t.at(new Float64Array(16));
                        return "map" === e.properties.get("anchor") && (t.a_(a, a, i.rollInRadians), t.a$(a, a, -i.pitchInRadians), t.a_(a, a, i.bearingInRadians), t.a$(a, a, i.center.lat * Math.PI / 180), t.bm(a, a, -i.center.lng * Math.PI / 180)), t.bV(o, o, a), o;
                    }(r, e.transform), h = l.getProjectionData({
                        overscaledTileID: null,
                        applyGlobeMatrix: !0,
                        applyTerrainMatrix: !0
                    }), u = i.properties.get("atmosphere-blend") * h.projectionTransition;
                    if (0 === u) return;
                    const d = ei(l.worldSize, l.center.lat), _ = l.inverseProjectionMatrix, p = new Float64Array(4);
                    p[3] = 1, t.ap(p, p, l.modelViewProjectionMatrix), p[0] /= p[3], p[1] /= p[3], p[2] /= p[3], p[3] = 1, t.ap(p, p, _), p[0] /= p[3], p[1] /= p[3], p[2] /= p[3], p[3] = 1;
                    const m = ((e, t, i, r, o)=>({
                            u_sun_pos: e,
                            u_atmosphere_blend: t,
                            u_globe_position: i,
                            u_globe_radius: r,
                            u_inv_proj_matrix: o
                        }))(c, u, [
                        p[0],
                        p[1],
                        p[2]
                    ], d, _), f = xo(o, i);
                    s.draw(o, a.TRIANGLES, n, Nt.disabled, Ft.alphaBlended, Ot.disabled, m, null, null, "atmosphere", f.vertexBuffer, f.indexBuffer, f.segments);
                }(this, this.style.sky, this.style.light), this.options.showTileBoundaries) {
                    const e = function(e, t) {
                        let i = null;
                        const r = Object.values(e._layers).flatMap((i)=>i.source && !i.isHidden(t) ? [
                                e.sourceCaches[i.source]
                            ] : []), o = r.filter((e)=>"vector" === e.getSource().type), a = r.filter((e)=>"vector" !== e.getSource().type), s = (e)=>{
                            (!i || i.getSource().maxzoom < e.getSource().maxzoom) && (i = e);
                        };
                        return o.forEach((e)=>s(e)), i || a.forEach((e)=>s(e)), i;
                    }(this.style, this.transform.zoom);
                    e && function(e, t, i) {
                        for(let r = 0; r < i.length; r++)go(e, t, i[r]);
                    }(this, e, e.getVisibleCoordinates());
                }
                this.options.showPadding && function(e) {
                    const t = e.transform.padding;
                    po(e, e.transform.height - (t.top || 0), 3, lo), po(e, t.bottom || 0, 3, co), mo(e, t.left || 0, 3, ho), mo(e, e.transform.width - (t.right || 0), 3, uo);
                    const i = e.transform.centerPoint;
                    !function(e, t, i, r) {
                        fo(e, t - 1, i - 10, 2, 20, r), fo(e, t - 10, i - 1, 20, 2, r);
                    }(e, i.x, e.transform.height - i.y, _o);
                }(this), this.context.setDefault();
            }
            maybeDrawDepthAndCoords(e) {
                if (!this.style || !this.style.map || !this.style.map.terrain) return;
                const i = this.terrainFacilitator.matrix, r = this.transform.modelViewProjectionMatrix;
                let o = this.terrainFacilitator.dirty;
                o || (o = e ? !t.bY(i, r) : !t.bZ(i, r)), o || (o = this.style.map.terrain.sourceCache.anyTilesAfterTime(this.terrainFacilitator.renderTime)), o && (t.b_(i, r), this.terrainFacilitator.renderTime = Date.now(), this.terrainFacilitator.dirty = !1, function(e, i) {
                    const r = e.context, o = r.gl, a = e.transform, s = Ft.unblended, n = new jt(o.LEQUAL, jt.ReadWrite, [
                        0,
                        1
                    ]), l = i.sourceCache.getRenderableTiles(), c = e.useProgram("terrainDepth");
                    r.bindFramebuffer.set(i.getFramebuffer("depth").framebuffer), r.viewport.set([
                        0,
                        0,
                        e.width / devicePixelRatio,
                        e.height / devicePixelRatio
                    ]), r.clear({
                        color: t.b7.transparent,
                        depth: 1
                    });
                    for (const e of l){
                        const t = i.getTerrainMesh(e.tileID), l = i.getTerrainData(e.tileID), h = a.getProjectionData({
                            overscaledTileID: e.tileID,
                            applyTerrainMatrix: !1,
                            applyGlobeMatrix: !0
                        }), u = {
                            u_ele_delta: i.getMeshFrameDelta(a.zoom)
                        };
                        c.draw(r, o.TRIANGLES, n, Nt.disabled, s, Ot.backCCW, u, l, h, "terrain", t.vertexBuffer, t.indexBuffer, t.segments);
                    }
                    r.bindFramebuffer.set(null), r.viewport.set([
                        0,
                        0,
                        e.width,
                        e.height
                    ]);
                }(this, this.style.map.terrain), function(e, i) {
                    const r = e.context, o = r.gl, a = e.transform, s = Ft.unblended, n = new jt(o.LEQUAL, jt.ReadWrite, [
                        0,
                        1
                    ]), l = i.getCoordsTexture(), c = i.sourceCache.getRenderableTiles(), h = e.useProgram("terrainCoords");
                    r.bindFramebuffer.set(i.getFramebuffer("coords").framebuffer), r.viewport.set([
                        0,
                        0,
                        e.width / devicePixelRatio,
                        e.height / devicePixelRatio
                    ]), r.clear({
                        color: t.b7.transparent,
                        depth: 1
                    }), i.coordsIndex = [];
                    for (const e of c){
                        const t = i.getTerrainMesh(e.tileID), c = i.getTerrainData(e.tileID);
                        r.activeTexture.set(o.TEXTURE0), o.bindTexture(o.TEXTURE_2D, l.texture);
                        const u = {
                            u_terrain_coords_id: (255 - i.coordsIndex.length) / 255,
                            u_texture: 0,
                            u_ele_delta: i.getMeshFrameDelta(a.zoom)
                        }, d = a.getProjectionData({
                            overscaledTileID: e.tileID,
                            applyTerrainMatrix: !1,
                            applyGlobeMatrix: !0
                        });
                        h.draw(r, o.TRIANGLES, n, Nt.disabled, s, Ot.backCCW, u, c, d, "terrain", t.vertexBuffer, t.indexBuffer, t.segments), i.coordsIndex.push(e.tileID.key);
                    }
                    r.bindFramebuffer.set(null), r.viewport.set([
                        0,
                        0,
                        e.width,
                        e.height
                    ]);
                }(this, this.style.map.terrain));
            }
            renderLayer(e, i, r, o, a) {
                r.isHidden(this.transform.zoom) || ("background" === r.type || "custom" === r.type || (o || []).length) && (this.id = r.id, t.b$(r) ? function(e, i, r, o, a, s) {
                    if ("translucent" !== e.renderPass) return;
                    const { isRenderingToTexture: n } = s, l = Nt.disabled, c = e.colorModeForRenderPass();
                    (r._unevaluatedLayout.hasValue("text-variable-anchor") || r._unevaluatedLayout.hasValue("text-variable-anchor-offset")) && function(e, i, r, o, a, s, n, l, c) {
                        const h = i.transform, u = i.style.map.terrain, d = "map" === a, _ = "map" === s;
                        for (const a of e){
                            const e = o.getTile(a), s = e.getBucket(r);
                            if (!s || !s.text || !s.text.segments.get().length) continue;
                            const p = t.ag(s.textSizeData, h.zoom), m = t.aw(e, 1, i.transform.zoom), f = ve(d, i.transform, m), g = "none" !== r.layout.get("icon-text-fit") && s.hasIconData();
                            if (p) {
                                const i = Math.pow(2, h.zoom - e.tileID.overscaledZ), r = u ? (e, t)=>u.getElevation(a, e, t) : null;
                                $r(s, d, _, c, h, f, i, p, g, t.ax(h, e, n, l), a.toUnwrapped(), r);
                            }
                        }
                    }(o, e, r, i, r.layout.get("text-rotation-alignment"), r.layout.get("text-pitch-alignment"), r.paint.get("text-translate"), r.paint.get("text-translate-anchor"), a), 0 !== r.paint.get("icon-opacity").constantOr(1) && Kr(e, i, r, o, !1, r.paint.get("icon-translate"), r.paint.get("icon-translate-anchor"), r.layout.get("icon-rotation-alignment"), r.layout.get("icon-pitch-alignment"), r.layout.get("icon-keep-upright"), l, c, n), 0 !== r.paint.get("text-opacity").constantOr(1) && Kr(e, i, r, o, !0, r.paint.get("text-translate"), r.paint.get("text-translate-anchor"), r.layout.get("text-rotation-alignment"), r.layout.get("text-pitch-alignment"), r.layout.get("text-keep-upright"), l, c, n), i.map.showCollisionBoxes && (Ur(e, i, r, o, !0), Ur(e, i, r, o, !1));
                }(e, i, r, o, this.style.placement.variableOffsets, a) : t.c0(r) ? function(e, i, r, o, a) {
                    if ("translucent" !== e.renderPass) return;
                    const { isRenderingToTexture: s } = a, n = r.paint.get("circle-opacity"), l = r.paint.get("circle-stroke-width"), c = r.paint.get("circle-stroke-opacity"), h = !r.layout.get("circle-sort-key").isConstant();
                    if (0 === n.constantOr(1) && (0 === l.constantOr(1) || 0 === c.constantOr(1))) return;
                    const u = e.context, d = u.gl, _ = e.transform, p = e.getDepthModeForSublayer(0, jt.ReadOnly), m = Nt.disabled, f = e.colorModeForRenderPass(), g = [], v = _.getCircleRadiusCorrection();
                    for(let a = 0; a < o.length; a++){
                        const n = o[a], l = i.getTile(n), c = l.getBucket(r);
                        if (!c) continue;
                        const u = r.paint.get("circle-translate"), d = r.paint.get("circle-translate-anchor"), p = t.ax(_, l, u, d), m = c.programConfigurations.get(r.id), f = e.useProgram("circle", m), x = c.layoutVertexBuffer, b = c.indexBuffer, y = e.style.map.terrain && e.style.map.terrain.getTerrainData(n), w = {
                            programConfiguration: m,
                            program: f,
                            layoutVertexBuffer: x,
                            indexBuffer: b,
                            uniformValues: Ri(e, l, r, p, v),
                            terrainData: y,
                            projectionData: _.getProjectionData({
                                overscaledTileID: n,
                                applyGlobeMatrix: !s,
                                applyTerrainMatrix: !0
                            })
                        };
                        if (h) {
                            const e = c.segments.get();
                            for (const i of e)g.push({
                                segments: new t.aG([
                                    i
                                ]),
                                sortKey: i.sortKey,
                                state: w
                            });
                        } else g.push({
                            segments: c.segments,
                            sortKey: 0,
                            state: w
                        });
                    }
                    h && g.sort((e, t)=>e.sortKey - t.sortKey);
                    for (const t of g){
                        const { programConfiguration: i, program: o, layoutVertexBuffer: a, indexBuffer: s, uniformValues: n, terrainData: l, projectionData: c } = t.state;
                        o.draw(u, d.TRIANGLES, p, m, f, Ot.backCCW, n, l, c, r.id, a, s, t.segments, r.paint, e.transform.zoom, i);
                    }
                }(e, i, r, o, a) : t.c1(r) ? function(e, i, r, o, a) {
                    if (0 === r.paint.get("heatmap-opacity")) return;
                    const s = e.context, { isRenderingToTexture: n, isRenderingGlobe: l } = a;
                    if (e.style.map.terrain) {
                        for (const t of o){
                            const o = i.getTile(t);
                            i.hasRenderableParent(t) || ("offscreen" === e.renderPass ? Qr(e, o, r, t, l) : "translucent" === e.renderPass && Yr(e, r, t, n, l));
                        }
                        s.viewport.set([
                            0,
                            0,
                            e.width,
                            e.height
                        ]);
                    } else "offscreen" === e.renderPass ? function(e, i, r, o) {
                        const a = e.context, s = a.gl, n = e.transform, l = Nt.disabled, c = new Ft([
                            s.ONE,
                            s.ONE
                        ], t.b7.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]);
                        (function(e, i, r) {
                            const o = e.gl;
                            e.activeTexture.set(o.TEXTURE1), e.viewport.set([
                                0,
                                0,
                                i.width / 4,
                                i.height / 4
                            ]);
                            let a = r.heatmapFbos.get(t.bS);
                            a ? (o.bindTexture(o.TEXTURE_2D, a.colorAttachment.get()), e.bindFramebuffer.set(a.framebuffer)) : (a = Jr(e, i.width / 4, i.height / 4), r.heatmapFbos.set(t.bS, a));
                        })(a, e, r), a.clear({
                            color: t.b7.transparent
                        });
                        for(let t = 0; t < o.length; t++){
                            const h = o[t];
                            if (i.hasRenderableParent(h)) continue;
                            const u = i.getTile(h), d = u.getBucket(r);
                            if (!d) continue;
                            const _ = d.programConfigurations.get(r.id), p = e.useProgram("heatmap", _), m = n.getProjectionData({
                                overscaledTileID: h,
                                applyGlobeMatrix: !0,
                                applyTerrainMatrix: !1
                            }), f = n.getCircleRadiusCorrection();
                            p.draw(a, s.TRIANGLES, jt.disabled, l, c, Ot.backCCW, Li(u, n.zoom, r.paint.get("heatmap-intensity"), f), null, m, r.id, d.layoutVertexBuffer, d.indexBuffer, d.segments, r.paint, n.zoom, _);
                        }
                        a.viewport.set([
                            0,
                            0,
                            e.width,
                            e.height
                        ]);
                    }(e, i, r, o) : "translucent" === e.renderPass && function(e, i) {
                        const r = e.context, o = r.gl;
                        r.setColorMode(e.colorModeForRenderPass());
                        const a = i.heatmapFbos.get(t.bS);
                        a && (r.activeTexture.set(o.TEXTURE0), o.bindTexture(o.TEXTURE_2D, a.colorAttachment.get()), r.activeTexture.set(o.TEXTURE1), eo(r, i).bind(o.LINEAR, o.CLAMP_TO_EDGE), e.useProgram("heatmapTexture").draw(r, o.TRIANGLES, jt.disabled, Nt.disabled, e.colorModeForRenderPass(), Ot.disabled, ki(e, i, 0, 1), null, null, i.id, e.viewportBuffer, e.quadTriangleIndexBuffer, e.viewportSegments, i.paint, e.transform.zoom));
                    }(e, r);
                }(e, i, r, o, a) : t.c2(r) ? function(e, i, r, o, a) {
                    if ("translucent" !== e.renderPass) return;
                    const { isRenderingToTexture: s } = a, n = r.paint.get("line-opacity"), l = r.paint.get("line-width");
                    if (0 === n.constantOr(1) || 0 === l.constantOr(1)) return;
                    const c = e.getDepthModeForSublayer(0, jt.ReadOnly), h = e.colorModeForRenderPass(), u = r.paint.get("line-dasharray"), d = r.paint.get("line-pattern"), _ = d.constantOr(1), p = r.paint.get("line-gradient"), m = r.getCrossfadeParameters(), f = _ ? "linePattern" : u ? "lineSDF" : p ? "lineGradient" : "line", g = e.context, x = g.gl, b = e.transform;
                    let y = !0;
                    for (const a of o){
                        const n = i.getTile(a);
                        if (_ && !n.patternsLoaded()) continue;
                        const l = n.getBucket(r);
                        if (!l) continue;
                        const w = l.programConfigurations.get(r.id), T = e.context.program.get(), P = e.useProgram(f, w), C = y || P.program !== T, I = e.style.map.terrain && e.style.map.terrain.getTerrainData(a), M = d.constantOr(null);
                        if (M && n.imageAtlas) {
                            const e = n.imageAtlas, t = e.patternPositions[M.to.toString()], i = e.patternPositions[M.from.toString()];
                            t && i && w.setConstantPatternPositions(t, i);
                        }
                        const E = b.getProjectionData({
                            overscaledTileID: a,
                            applyGlobeMatrix: !s,
                            applyTerrainMatrix: !0
                        }), S = b.getPixelScale(), R = _ ? Ni(e, n, r, S, m) : u ? Gi(e, n, r, S, u, m) : p ? Zi(e, n, r, S, l.lineClipsArray.length) : ji(e, n, r, S);
                        if (_) g.activeTexture.set(x.TEXTURE0), n.imageAtlasTexture.bind(x.LINEAR, x.CLAMP_TO_EDGE), w.updatePaintBuffers(m);
                        else if (u && (C || e.lineAtlas.dirty)) g.activeTexture.set(x.TEXTURE0), e.lineAtlas.bind(g);
                        else if (p) {
                            const o = l.gradients[r.id];
                            let s = o.texture;
                            if (r.gradientVersion !== o.version) {
                                let n = 256;
                                if (r.stepInterpolant) {
                                    const r = i.getSource().maxzoom, o = a.canonical.z === r ? Math.ceil(1 << e.transform.maxZoom - a.canonical.z) : 1;
                                    n = t.ae(t.bT(l.maxLineLength / t.Z * 1024 * o), 256, g.maxTextureSize);
                                }
                                o.gradient = t.bU({
                                    expression: r.gradientExpression(),
                                    evaluationKey: "lineProgress",
                                    resolution: n,
                                    image: o.gradient || void 0,
                                    clips: l.lineClipsArray
                                }), o.texture ? o.texture.update(o.gradient) : o.texture = new v(g, o.gradient, x.RGBA), o.version = r.gradientVersion, s = o.texture;
                            }
                            g.activeTexture.set(x.TEXTURE0), s.bind(r.stepInterpolant ? x.NEAREST : x.LINEAR, x.CLAMP_TO_EDGE);
                        }
                        let D;
                        if (s) {
                            const [t] = e.getStencilConfigForOverlapAndUpdateStencilID(o);
                            D = t[a.overscaledZ];
                        } else D = e.stencilModeForClipping(a);
                        P.draw(g, x.TRIANGLES, c, D, h, Ot.disabled, R, I, E, r.id, l.layoutVertexBuffer, l.indexBuffer, l.segments, r.paint, e.transform.zoom, w, l.layoutVertexBuffer2), y = !1;
                    }
                }(e, i, r, o, a) : t.c3(r) ? function(e, i, r, o, a) {
                    const s = r.paint.get("fill-color"), n = r.paint.get("fill-opacity");
                    if (0 === n.constantOr(1)) return;
                    const { isRenderingToTexture: l } = a, c = e.colorModeForRenderPass(), h = r.paint.get("fill-pattern"), u = e.opaquePassEnabledForLayer() && !h.constantOr(1) && 1 === s.constantOr(t.b7.transparent).a && 1 === n.constantOr(0) ? "opaque" : "translucent";
                    if (e.renderPass === u) {
                        const t = e.getDepthModeForSublayer(1, "opaque" === e.renderPass ? jt.ReadWrite : jt.ReadOnly);
                        io(e, i, r, o, t, c, !1, l);
                    }
                    if ("translucent" === e.renderPass && r.paint.get("fill-antialias")) {
                        const t = e.getDepthModeForSublayer(r.getPaintProperty("fill-outline-color") ? 2 : 0, jt.ReadOnly);
                        io(e, i, r, o, t, c, !0, l);
                    }
                }(e, i, r, o, a) : t.c4(r) ? function(e, t, i, r, o) {
                    const a = i.paint.get("fill-extrusion-opacity");
                    if (0 === a) return;
                    const { isRenderingToTexture: s } = o;
                    if ("translucent" === e.renderPass) {
                        const o = new jt(e.context.gl.LEQUAL, jt.ReadWrite, e.depthRangeFor3D);
                        if (1 !== a || i.paint.get("fill-extrusion-pattern").constantOr(1)) ro(e, t, i, r, o, Nt.disabled, Ft.disabled, s), ro(e, t, i, r, o, e.stencilModeFor3D(), e.colorModeForRenderPass(), s);
                        else {
                            const a = e.colorModeForRenderPass();
                            ro(e, t, i, r, o, Nt.disabled, a, s);
                        }
                    }
                }(e, i, r, o, a) : t.c5(r) ? function(e, t, i, r, o) {
                    if ("offscreen" !== e.renderPass && "translucent" !== e.renderPass) return;
                    const { isRenderingToTexture: a } = o, s = e.context, n = e.style.projection.useSubdivision, l = e.getDepthModeForSublayer(0, jt.ReadOnly), c = e.colorModeForRenderPass();
                    if ("offscreen" === e.renderPass) !function(e, t, i, r, o, a, s) {
                        const n = e.context, l = n.gl;
                        for (const c of i){
                            const i = t.getTile(c), h = i.dem;
                            if (!h || !h.data) continue;
                            if (!i.needsHillshadePrepare) continue;
                            const u = h.dim, d = h.stride, _ = h.getPixels();
                            if (n.activeTexture.set(l.TEXTURE1), n.pixelStoreUnpackPremultiplyAlpha.set(!1), i.demTexture = i.demTexture || e.getTileTexture(d), i.demTexture) {
                                const e = i.demTexture;
                                e.update(_, {
                                    premultiply: !1
                                }), e.bind(l.NEAREST, l.CLAMP_TO_EDGE);
                            } else i.demTexture = new v(n, _, l.RGBA, {
                                premultiply: !1
                            }), i.demTexture.bind(l.NEAREST, l.CLAMP_TO_EDGE);
                            n.activeTexture.set(l.TEXTURE0);
                            let p = i.fbo;
                            if (!p) {
                                const e = new v(n, {
                                    width: u,
                                    height: u,
                                    data: null
                                }, l.RGBA);
                                e.bind(l.LINEAR, l.CLAMP_TO_EDGE), p = i.fbo = n.createFramebuffer(u, u, !0, !1), p.colorAttachment.set(e.texture);
                            }
                            n.bindFramebuffer.set(p.framebuffer), n.viewport.set([
                                0,
                                0,
                                u,
                                u
                            ]), e.useProgram("hillshadePrepare").draw(n, l.TRIANGLES, o, a, s, Ot.disabled, Bi(i.tileID, h), null, null, r.id, e.rasterBoundsBuffer, e.quadTriangleIndexBuffer, e.rasterBoundsSegments), i.needsHillshadePrepare = !1;
                        }
                    }(e, t, r, i, l, Nt.disabled, c), s.viewport.set([
                        0,
                        0,
                        e.width,
                        e.height
                    ]);
                    else if ("translucent" === e.renderPass) {
                        if (n) {
                            const [o, s, n] = e.stencilConfigForOverlapTwoPass(r);
                            oo(e, t, i, n, o, l, c, !1, a), oo(e, t, i, n, s, l, c, !0, a);
                        } else {
                            const [o, s] = e.getStencilConfigForOverlapAndUpdateStencilID(r);
                            oo(e, t, i, s, o, l, c, !1, a);
                        }
                    }
                }(e, i, r, o, a) : t.c6(r) ? function(e, t, i, r, o) {
                    if ("translucent" !== e.renderPass) return;
                    if (0 === i.paint.get("raster-opacity")) return;
                    if (!r.length) return;
                    const { isRenderingToTexture: a } = o, s = t.getSource(), n = e.style.projection.useSubdivision;
                    if (s instanceof X) so(e, t, i, r, null, !1, !1, s.tileCoords, s.flippedWindingOrder, a);
                    else if (n) {
                        const [o, s, n] = e.stencilConfigForOverlapTwoPass(r);
                        so(e, t, i, n, o, !1, !0, ao, !1, a), so(e, t, i, n, s, !0, !0, ao, !1, a);
                    } else {
                        const [o, s] = e.getStencilConfigForOverlapAndUpdateStencilID(r);
                        so(e, t, i, s, o, !1, !0, ao, !1, a);
                    }
                }(e, i, r, o, a) : t.c7(r) ? function(e, t, i, r, o) {
                    const a = i.paint.get("background-color"), s = i.paint.get("background-opacity");
                    if (0 === s) return;
                    const { isRenderingToTexture: n } = o, l = e.context, c = l.gl, h = e.style.projection, u = e.transform, d = u.tileSize, _ = i.paint.get("background-pattern");
                    if (e.isPatternMissing(_)) return;
                    const p = !_ && 1 === a.a && 1 === s && e.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                    if (e.renderPass !== p) return;
                    const m = Nt.disabled, f = e.getDepthModeForSublayer(0, "opaque" === p ? jt.ReadWrite : jt.ReadOnly), g = e.colorModeForRenderPass(), v = e.useProgram(_ ? "backgroundPattern" : "background"), x = r || ue(u, {
                        tileSize: d,
                        terrain: e.style.map.terrain
                    });
                    _ && (l.activeTexture.set(c.TEXTURE0), e.imageManager.bind(e.context));
                    const b = i.getCrossfadeParameters();
                    for (const t of x){
                        const r = u.getProjectionData({
                            overscaledTileID: t,
                            applyGlobeMatrix: !n,
                            applyTerrainMatrix: !0
                        }), o = _ ? Qi(s, e, _, {
                            tileID: t,
                            tileSize: d
                        }, b) : Xi(s, a), p = e.style.map.terrain && e.style.map.terrain.getTerrainData(t), x = h.getMeshFromTileID(l, t.canonical, !1, !0, "raster");
                        v.draw(l, c.TRIANGLES, f, m, g, Ot.backCCW, o, p, r, i.id, x.vertexBuffer, x.indexBuffer, x.segments);
                    }
                }(e, 0, r, o, a) : t.c8(r) && function(e, t, i, r) {
                    const { isRenderingGlobe: o } = r, a = e.context, s = i.implementation, n = e.style.projection, l = e.transform, c = l.getProjectionDataForCustomLayer(o), h = {
                        farZ: l.farZ,
                        nearZ: l.nearZ,
                        fov: l.fov * Math.PI / 180,
                        modelViewProjectionMatrix: l.modelViewProjectionMatrix,
                        projectionMatrix: l.projectionMatrix,
                        shaderData: {
                            variantName: n.shaderVariantName,
                            vertexShaderPrelude: `const float PI = 3.141592653589793;\nuniform mat4 u_projection_matrix;\n${n.shaderPreludeCode.vertexSource}`,
                            define: n.shaderDefine
                        },
                        defaultProjectionData: c
                    }, u = s.renderingMode ? s.renderingMode : "2d";
                    if ("offscreen" === e.renderPass) {
                        const t = s.prerender;
                        t && (e.setCustomLayerDefaults(), a.setColorMode(e.colorModeForRenderPass()), t.call(s, a.gl, h), a.setDirty(), e.setBaseState());
                    } else if ("translucent" === e.renderPass) {
                        e.setCustomLayerDefaults(), a.setColorMode(e.colorModeForRenderPass()), a.setStencilMode(Nt.disabled);
                        const t = "3d" === u ? e.getDepthModeFor3D() : e.getDepthModeForSublayer(0, jt.ReadOnly);
                        a.setDepthMode(t), s.render(a.gl, h), a.setDirty(), e.setBaseState(), a.bindFramebuffer.set(null);
                    }
                }(e, 0, r, a));
            }
            saveTileTexture(e) {
                const t = this._tileTextures[e.size[0]];
                t ? t.push(e) : this._tileTextures[e.size[0]] = [
                    e
                ];
            }
            getTileTexture(e) {
                const t = this._tileTextures[e];
                return t && t.length > 0 ? t.pop() : null;
            }
            isPatternMissing(e) {
                if (!e) return !1;
                if (!e.from || !e.to) return !0;
                const t = this.imageManager.getPattern(e.from.toString()), i = this.imageManager.getPattern(e.to.toString());
                return !t || !i;
            }
            useProgram(e, t, i = !1) {
                this.cache = this.cache || {};
                const r = !!this.style.map.terrain, o = this.style.projection, a = e + (t ? t.cacheKey : "") + `/${i ? gt : o.shaderVariantName}` + (this._showOverdrawInspector ? "/overdraw" : "") + (r ? "/terrain" : "");
                return this.cache[a] || (this.cache[a] = new Ti(this.context, dt[e], t, Ji[e], this._showOverdrawInspector, r, i ? dt.projectionMercator : o.shaderPreludeCode, i ? ft : o.shaderDefine)), this.cache[a];
            }
            setCustomLayerDefaults() {
                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
            }
            setBaseState() {
                const e = this.context.gl;
                this.context.cullFace.set(!1), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.blendEquation.set(e.FUNC_ADD);
            }
            initDebugOverlayCanvas() {
                null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new v(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
            }
            destroy() {
                this.debugOverlayTexture && this.debugOverlayTexture.destroy();
            }
            overLimit() {
                const { drawingBufferWidth: e, drawingBufferHeight: t } = this.context.gl;
                return this.width !== e || this.height !== t;
            }
        }
        function yo(e, t) {
            let i, r = !1, o = null, a = null;
            const s = ()=>{
                o = null, r && (e.apply(a, i), o = setTimeout(s, t), r = !1);
            };
            return (...e)=>(r = !0, a = this, i = e, o || s(), o);
        }
        class wo {
            constructor(e){
                this._getCurrentHash = ()=>{
                    const e = window.location.hash.replace("#", "");
                    if (this._hashName) {
                        let t;
                        return e.split("&").map((e)=>e.split("=")).forEach((e)=>{
                            e[0] === this._hashName && (t = e);
                        }), (t && t[1] || "").split("/");
                    }
                    return e.split("/");
                }, this._onHashChange = ()=>{
                    const e = this._getCurrentHash();
                    if (!this._isValidHash(e)) return !1;
                    const t = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(e[3] || 0) : this._map.getBearing();
                    return this._map.jumpTo({
                        center: [
                            +e[2],
                            +e[1]
                        ],
                        zoom: +e[0],
                        bearing: t,
                        pitch: +(e[4] || 0)
                    }), !0;
                }, this._updateHashUnthrottled = ()=>{
                    const e = window.location.href.replace(/(#.*)?$/, this.getHashString());
                    window.history.replaceState(window.history.state, null, e);
                }, this._removeHash = ()=>{
                    const e = this._getCurrentHash();
                    if (0 === e.length) return;
                    const t = e.join("/");
                    let i = t;
                    i.split("&").length > 0 && (i = i.split("&")[0]), this._hashName && (i = `${this._hashName}=${t}`);
                    let r = window.location.hash.replace(i, "");
                    r.startsWith("#&") ? r = r.slice(0, 1) + r.slice(2) : "#" === r && (r = "");
                    let o = window.location.href.replace(/(#.+)?$/, r);
                    o = o.replace("&&", "&"), window.history.replaceState(window.history.state, null, o);
                }, this._updateHash = yo(this._updateHashUnthrottled, 300), this._hashName = e && encodeURIComponent(e);
            }
            addTo(e) {
                return this._map = e, addEventListener("hashchange", this._onHashChange, !1), this._map.on("moveend", this._updateHash), this;
            }
            remove() {
                return removeEventListener("hashchange", this._onHashChange, !1), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), this._removeHash(), delete this._map, this;
            }
            getHashString(e) {
                const t = this._map.getCenter(), i = Math.round(100 * this._map.getZoom()) / 100, r = Math.ceil((i * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), o = Math.pow(10, r), a = Math.round(t.lng * o) / o, s = Math.round(t.lat * o) / o, n = this._map.getBearing(), l = this._map.getPitch();
                let c = "";
                if (c += e ? `/${a}/${s}/${i}` : `${i}/${s}/${a}`, (n || l) && (c += "/" + Math.round(10 * n) / 10), l && (c += `/${Math.round(l)}`), this._hashName) {
                    const e = this._hashName;
                    let t = !1;
                    const i = window.location.hash.slice(1).split("&").map((i)=>{
                        const r = i.split("=")[0];
                        return r === e ? (t = !0, `${r}=${c}`) : i;
                    }).filter((e)=>e);
                    return t || i.push(`${e}=${c}`), `#${i.join("&")}`;
                }
                return `#${c}`;
            }
            _isValidHash(e) {
                if (e.length < 3 || e.some(isNaN)) return !1;
                try {
                    new t.Q(+e[2], +e[1]);
                } catch (e) {
                    return !1;
                }
                const i = +e[0], r = +(e[3] || 0), o = +(e[4] || 0);
                return i >= this._map.getMinZoom() && i <= this._map.getMaxZoom() && r >= -180 && r <= 180 && o >= this._map.getMinPitch() && o <= this._map.getMaxPitch();
            }
        }
        const To = {
            linearity: .3,
            easing: t.c9(0, 0, .3, 1)
        }, Po = t.e({
            deceleration: 2500,
            maxSpeed: 1400
        }, To), Co = t.e({
            deceleration: 20,
            maxSpeed: 1400
        }, To), Io = t.e({
            deceleration: 1e3,
            maxSpeed: 360
        }, To), Mo = t.e({
            deceleration: 1e3,
            maxSpeed: 90
        }, To), Eo = t.e({
            deceleration: 1e3,
            maxSpeed: 360
        }, To);
        class So {
            constructor(e){
                this._map = e, this.clear();
            }
            clear() {
                this._inertiaBuffer = [];
            }
            record(e) {
                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                    time: s.now(),
                    settings: e
                });
            }
            _drainInertiaBuffer() {
                const e = this._inertiaBuffer, t = s.now();
                for(; e.length > 0 && t - e[0].time > 160;)e.shift();
            }
            _onMoveEnd(e) {
                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                const i = {
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    roll: 0,
                    pan: new t.P(0, 0),
                    pinchAround: void 0,
                    around: void 0
                };
                for (const { settings: e } of this._inertiaBuffer)i.zoom += e.zoomDelta || 0, i.bearing += e.bearingDelta || 0, i.pitch += e.pitchDelta || 0, i.roll += e.rollDelta || 0, e.panDelta && i.pan._add(e.panDelta), e.around && (i.around = e.around), e.pinchAround && (i.pinchAround = e.pinchAround);
                const r = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, o = {};
                if (i.pan.mag()) {
                    const a = Do(i.pan.mag(), r, t.e({}, Po, e || {})), s = i.pan.mult(a.amount / i.pan.mag()), n = this._map.cameraHelper.handlePanInertia(s, this._map.transform);
                    o.center = n.easingCenter, o.offset = n.easingOffset, Ro(o, a);
                }
                if (i.zoom) {
                    const e = Do(i.zoom, r, Co);
                    o.zoom = this._map.transform.zoom + e.amount, Ro(o, e);
                }
                if (i.bearing) {
                    const e = Do(i.bearing, r, Io);
                    o.bearing = this._map.transform.bearing + t.ae(e.amount, -179, 179), Ro(o, e);
                }
                if (i.pitch) {
                    const e = Do(i.pitch, r, Mo);
                    o.pitch = this._map.transform.pitch + e.amount, Ro(o, e);
                }
                if (i.roll) {
                    const e = Do(i.roll, r, Eo);
                    o.roll = this._map.transform.roll + t.ae(e.amount, -179, 179), Ro(o, e);
                }
                if (o.zoom || o.bearing) {
                    const e = void 0 === i.pinchAround ? i.around : i.pinchAround;
                    o.around = e ? this._map.unproject(e) : this._map.getCenter();
                }
                return this.clear(), t.e(o, {
                    noMoveStart: !0
                });
            }
        }
        function Ro(e, t) {
            (!e.duration || e.duration < t.duration) && (e.duration = t.duration, e.easing = t.easing);
        }
        function Do(e, i, r) {
            const { maxSpeed: o, linearity: a, deceleration: s } = r, n = t.ae(e * a / (i / 1e3), -o, o), l = Math.abs(n) / (s * a);
            return {
                easing: r.easing,
                duration: 1e3 * l,
                amount: n * (l / 2)
            };
        }
        class zo extends t.l {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e, i, r, o = {}){
                r = r instanceof MouseEvent ? r : new MouseEvent(e, r);
                const a = n.mousePos(i.getCanvas(), r), s = i.unproject(a);
                super(e, t.e({
                    point: a,
                    lngLat: s,
                    originalEvent: r
                }, o)), this._defaultPrevented = !1, this.target = i;
            }
        }
        class Ao extends t.l {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e, i, r){
                const o = "touchend" === e ? r.changedTouches : r.touches, a = n.touchPos(i.getCanvasContainer(), o), s = a.map((e)=>i.unproject(e)), l = a.reduce((e, t, i, r)=>e.add(t.div(r.length)), new t.P(0, 0));
                super(e, {
                    points: a,
                    point: l,
                    lngLats: s,
                    lngLat: i.unproject(l),
                    originalEvent: r
                }), this._defaultPrevented = !1;
            }
        }
        class Lo extends t.l {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e, t, i){
                super(e, {
                    originalEvent: i
                }), this._defaultPrevented = !1;
            }
        }
        class ko {
            constructor(e, t){
                this._map = e, this._clickTolerance = t.clickTolerance;
            }
            reset() {
                delete this._mousedownPos;
            }
            wheel(e) {
                return this._firePreventable(new Lo(e.type, this._map, e));
            }
            mousedown(e, t) {
                return this._mousedownPos = t, this._firePreventable(new zo(e.type, this._map, e));
            }
            mouseup(e) {
                this._map.fire(new zo(e.type, this._map, e));
            }
            click(e, t) {
                this._mousedownPos && this._mousedownPos.dist(t) >= this._clickTolerance || this._map.fire(new zo(e.type, this._map, e));
            }
            dblclick(e) {
                return this._firePreventable(new zo(e.type, this._map, e));
            }
            mouseover(e) {
                this._map.fire(new zo(e.type, this._map, e));
            }
            mouseout(e) {
                this._map.fire(new zo(e.type, this._map, e));
            }
            touchstart(e) {
                return this._firePreventable(new Ao(e.type, this._map, e));
            }
            touchmove(e) {
                this._map.fire(new Ao(e.type, this._map, e));
            }
            touchend(e) {
                this._map.fire(new Ao(e.type, this._map, e));
            }
            touchcancel(e) {
                this._map.fire(new Ao(e.type, this._map, e));
            }
            _firePreventable(e) {
                if (this._map.fire(e), e.defaultPrevented) return {};
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class Fo {
            constructor(e){
                this._map = e;
            }
            reset() {
                this._delayContextMenu = !1, this._ignoreContextMenu = !0, delete this._contextMenuEvent;
            }
            mousemove(e) {
                this._map.fire(new zo(e.type, this._map, e));
            }
            mousedown() {
                this._delayContextMenu = !0, this._ignoreContextMenu = !1;
            }
            mouseup() {
                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new zo("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
            }
            contextmenu(e) {
                this._delayContextMenu ? this._contextMenuEvent = e : this._ignoreContextMenu || this._map.fire(new zo(e.type, this._map, e)), this._map.listens("contextmenu") && e.preventDefault();
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class Bo {
            constructor(e){
                this._map = e;
            }
            get transform() {
                return this._map._requestedCameraState || this._map.transform;
            }
            get center() {
                return {
                    lng: this.transform.center.lng,
                    lat: this.transform.center.lat
                };
            }
            get zoom() {
                return this.transform.zoom;
            }
            get pitch() {
                return this.transform.pitch;
            }
            get bearing() {
                return this.transform.bearing;
            }
            unproject(e) {
                return this.transform.screenPointToLocation(t.P.convert(e), this._map.terrain);
            }
        }
        class Oo {
            constructor(e, t){
                this._map = e, this._tr = new Bo(e), this._el = e.getCanvasContainer(), this._container = e.getContainer(), this._clickTolerance = t.clickTolerance || 1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            enable() {
                this.isEnabled() || (this._enabled = !0);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            mousedown(e, t) {
                this.isEnabled() && e.shiftKey && 0 === e.button && (n.disableDrag(), this._startPos = this._lastPos = t, this._active = !0);
            }
            mousemoveWindow(e, t) {
                if (!this._active) return;
                const i = t;
                if (this._lastPos.equals(i) || !this._box && i.dist(this._startPos) < this._clickTolerance) return;
                const r = this._startPos;
                this._lastPos = i, this._box || (this._box = n.create("div", "maplibregl-boxzoom", this._container), this._container.classList.add("maplibregl-crosshair"), this._fireEvent("boxzoomstart", e));
                const o = Math.min(r.x, i.x), a = Math.max(r.x, i.x), s = Math.min(r.y, i.y), l = Math.max(r.y, i.y);
                n.setTransform(this._box, `translate(${o}px,${s}px)`), this._box.style.width = a - o + "px", this._box.style.height = l - s + "px";
            }
            mouseupWindow(e, i) {
                if (!this._active) return;
                if (0 !== e.button) return;
                const r = this._startPos, o = i;
                if (this.reset(), n.suppressClick(), r.x !== o.x || r.y !== o.y) return this._map.fire(new t.l("boxzoomend", {
                    originalEvent: e
                })), {
                    cameraAnimation: (e)=>e.fitScreenCoordinates(r, o, this._tr.bearing, {
                            linear: !0
                        })
                };
                this._fireEvent("boxzoomcancel", e);
            }
            keydown(e) {
                this._active && 27 === e.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", e));
            }
            reset() {
                this._active = !1, this._container.classList.remove("maplibregl-crosshair"), this._box && (n.remove(this._box), this._box = null), n.enableDrag(), delete this._startPos, delete this._lastPos;
            }
            _fireEvent(e, i) {
                return this._map.fire(new t.l(e, {
                    originalEvent: i
                }));
            }
        }
        function jo(e, t) {
            if (e.length !== t.length) throw new Error(`The number of touches and points are not equal - touches ${e.length}, points ${t.length}`);
            const i = {};
            for(let r = 0; r < e.length; r++)i[e[r].identifier] = t[r];
            return i;
        }
        class Zo {
            constructor(e){
                this.reset(), this.numTouches = e.numTouches;
            }
            reset() {
                delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
            }
            touchstart(e, i, r) {
                (this.centroid || r.length > this.numTouches) && (this.aborted = !0), this.aborted || (void 0 === this.startTime && (this.startTime = e.timeStamp), r.length === this.numTouches && (this.centroid = function(e) {
                    const i = new t.P(0, 0);
                    for (const t of e)i._add(t);
                    return i.div(e.length);
                }(i), this.touches = jo(r, i)));
            }
            touchmove(e, t, i) {
                if (this.aborted || !this.centroid) return;
                const r = jo(i, t);
                for(const e in this.touches){
                    const t = r[e];
                    (!t || t.dist(this.touches[e]) > 30) && (this.aborted = !0);
                }
            }
            touchend(e, t, i) {
                if ((!this.centroid || e.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                    const e = !this.aborted && this.centroid;
                    if (this.reset(), e) return e;
                }
            }
        }
        class No {
            constructor(e){
                this.singleTap = new Zo(e), this.numTaps = e.numTaps, this.reset();
            }
            reset() {
                this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
            }
            touchstart(e, t, i) {
                this.singleTap.touchstart(e, t, i);
            }
            touchmove(e, t, i) {
                this.singleTap.touchmove(e, t, i);
            }
            touchend(e, t, i) {
                const r = this.singleTap.touchend(e, t, i);
                if (r) {
                    const t = e.timeStamp - this.lastTime < 500, i = !this.lastTap || this.lastTap.dist(r) < 30;
                    if (t && i || this.reset(), this.count++, this.lastTime = e.timeStamp, this.lastTap = r, this.count === this.numTaps) return this.reset(), r;
                }
            }
        }
        class Go {
            constructor(e){
                this._tr = new Bo(e), this._zoomIn = new No({
                    numTouches: 1,
                    numTaps: 2
                }), this._zoomOut = new No({
                    numTouches: 2,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
            }
            touchstart(e, t, i) {
                this._zoomIn.touchstart(e, t, i), this._zoomOut.touchstart(e, t, i);
            }
            touchmove(e, t, i) {
                this._zoomIn.touchmove(e, t, i), this._zoomOut.touchmove(e, t, i);
            }
            touchend(e, t, i) {
                const r = this._zoomIn.touchend(e, t, i), o = this._zoomOut.touchend(e, t, i), a = this._tr;
                return r ? (this._active = !0, e.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t)=>t.easeTo({
                            duration: 300,
                            zoom: a.zoom + 1,
                            around: a.unproject(r)
                        }, {
                            originalEvent: e
                        })
                }) : o ? (this._active = !0, e.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t)=>t.easeTo({
                            duration: 300,
                            zoom: a.zoom - 1,
                            around: a.unproject(o)
                        }, {
                            originalEvent: e
                        })
                }) : void 0;
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Uo {
            constructor(e){
                this._enabled = !!e.enable, this._moveStateManager = e.moveStateManager, this._clickTolerance = e.clickTolerance || 1, this._moveFunction = e.move, this._activateOnStart = !!e.activateOnStart, e.assignEvents(this), this.reset();
            }
            reset(e) {
                this._active = !1, this._moved = !1, delete this._lastPoint, this._moveStateManager.endMove(e);
            }
            _move(...e) {
                const t = this._moveFunction(...e);
                if (t.bearingDelta || t.pitchDelta || t.rollDelta || t.around || t.panDelta) return this._active = !0, t;
            }
            dragStart(e, t) {
                this.isEnabled() && !this._lastPoint && this._moveStateManager.isValidStartEvent(e) && (this._moveStateManager.startMove(e), this._lastPoint = Array.isArray(t) ? t[0] : t, this._activateOnStart && this._lastPoint && (this._active = !0));
            }
            dragMove(e, t) {
                if (!this.isEnabled()) return;
                const i = this._lastPoint;
                if (!i) return;
                if (e.preventDefault(), !this._moveStateManager.isValidMoveEvent(e)) return void this.reset(e);
                const r = Array.isArray(t) ? t[0] : t;
                return !this._moved && r.dist(i) < this._clickTolerance ? void 0 : (this._moved = !0, this._lastPoint = r, this._move(i, r));
            }
            dragEnd(e) {
                this.isEnabled() && this._lastPoint && this._moveStateManager.isValidEndEvent(e) && (this._moved && n.suppressClick(), this.reset(e));
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            getClickTolerance() {
                return this._clickTolerance;
            }
        }
        const Vo = {
            0: 1,
            2: 2
        };
        class qo {
            constructor(e){
                this._correctEvent = e.checkCorrectEvent;
            }
            startMove(e) {
                const t = n.mouseButton(e);
                this._eventButton = t;
            }
            endMove(e) {
                delete this._eventButton;
            }
            isValidStartEvent(e) {
                return this._correctEvent(e);
            }
            isValidMoveEvent(e) {
                return !function(e, t) {
                    const i = Vo[t];
                    return void 0 === e.buttons || (e.buttons & i) !== i;
                }(e, this._eventButton);
            }
            isValidEndEvent(e) {
                return n.mouseButton(e) === this._eventButton;
            }
        }
        class Wo {
            constructor(){
                this._firstTouch = void 0;
            }
            _isOneFingerTouch(e) {
                return 1 === e.targetTouches.length;
            }
            _isSameTouchEvent(e) {
                return e.targetTouches[0].identifier === this._firstTouch;
            }
            startMove(e) {
                this._firstTouch = e.targetTouches[0].identifier;
            }
            endMove(e) {
                delete this._firstTouch;
            }
            isValidStartEvent(e) {
                return this._isOneFingerTouch(e);
            }
            isValidMoveEvent(e) {
                return this._isOneFingerTouch(e) && this._isSameTouchEvent(e);
            }
            isValidEndEvent(e) {
                return this._isOneFingerTouch(e) && this._isSameTouchEvent(e);
            }
        }
        class $o {
            constructor(e = new qo({
                checkCorrectEvent: ()=>!0
            }), t = new Wo){
                this.mouseMoveStateManager = e, this.oneFingerTouchMoveStateManager = t;
            }
            _executeRelevantHandler(e, t, i) {
                return e instanceof MouseEvent ? t(e) : "undefined" != typeof TouchEvent && e instanceof TouchEvent ? i(e) : void 0;
            }
            startMove(e) {
                this._executeRelevantHandler(e, (e)=>this.mouseMoveStateManager.startMove(e), (e)=>this.oneFingerTouchMoveStateManager.startMove(e));
            }
            endMove(e) {
                this._executeRelevantHandler(e, (e)=>this.mouseMoveStateManager.endMove(e), (e)=>this.oneFingerTouchMoveStateManager.endMove(e));
            }
            isValidStartEvent(e) {
                return this._executeRelevantHandler(e, (e)=>this.mouseMoveStateManager.isValidStartEvent(e), (e)=>this.oneFingerTouchMoveStateManager.isValidStartEvent(e));
            }
            isValidMoveEvent(e) {
                return this._executeRelevantHandler(e, (e)=>this.mouseMoveStateManager.isValidMoveEvent(e), (e)=>this.oneFingerTouchMoveStateManager.isValidMoveEvent(e));
            }
            isValidEndEvent(e) {
                return this._executeRelevantHandler(e, (e)=>this.mouseMoveStateManager.isValidEndEvent(e), (e)=>this.oneFingerTouchMoveStateManager.isValidEndEvent(e));
            }
        }
        const Ho = (e)=>{
            e.mousedown = e.dragStart, e.mousemoveWindow = e.dragMove, e.mouseup = e.dragEnd, e.contextmenu = (e)=>{
                e.preventDefault();
            };
        };
        class Ko {
            constructor(e, t){
                this._clickTolerance = e.clickTolerance || 1, this._map = t, this.reset();
            }
            reset() {
                this._active = !1, this._touches = {}, this._sum = new t.P(0, 0);
            }
            _shouldBePrevented(e) {
                return e < (this._map.cooperativeGestures.isEnabled() ? 2 : 1);
            }
            touchstart(e, t, i) {
                return this._calculateTransform(e, t, i);
            }
            touchmove(e, t, i) {
                if (this._active) {
                    if (!this._shouldBePrevented(i.length)) return e.preventDefault(), this._calculateTransform(e, t, i);
                    this._map.cooperativeGestures.notifyGestureBlocked("touch_pan", e);
                }
            }
            touchend(e, t, i) {
                this._calculateTransform(e, t, i), this._active && this._shouldBePrevented(i.length) && this.reset();
            }
            touchcancel() {
                this.reset();
            }
            _calculateTransform(e, i, r) {
                r.length > 0 && (this._active = !0);
                const o = jo(r, i), a = new t.P(0, 0), s = new t.P(0, 0);
                let n = 0;
                for(const e in o){
                    const t = o[e], i = this._touches[e];
                    i && (a._add(t), s._add(t.sub(i)), n++, o[e] = t);
                }
                if (this._touches = o, this._shouldBePrevented(n) || !s.mag()) return;
                const l = s.div(n);
                return this._sum._add(l), this._sum.mag() < this._clickTolerance ? void 0 : {
                    around: a.div(n),
                    panDelta: l
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Xo {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1, delete this._firstTwoTouches;
            }
            touchstart(e, t, i) {
                this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                    i[0].identifier,
                    i[1].identifier
                ], this._start([
                    t[0],
                    t[1]
                ]));
            }
            touchmove(e, t, i) {
                if (!this._firstTwoTouches) return;
                e.preventDefault();
                const [r, o] = this._firstTwoTouches, a = Qo(i, t, r), s = Qo(i, t, o);
                if (!a || !s) return;
                const n = this._aroundCenter ? null : a.add(s).div(2);
                return this._move([
                    a,
                    s
                ], n, e);
            }
            touchend(e, t, i) {
                if (!this._firstTwoTouches) return;
                const [r, o] = this._firstTwoTouches, a = Qo(i, t, r), s = Qo(i, t, o);
                a && s || (this._active && n.suppressClick(), this.reset());
            }
            touchcancel() {
                this.reset();
            }
            enable(e) {
                this._enabled = !0, this._aroundCenter = !!e && "center" === e.around;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
        }
        function Qo(e, t, i) {
            for(let r = 0; r < e.length; r++)if (e[r].identifier === i) return t[r];
        }
        function Yo(e, t) {
            return Math.log(e / t) / Math.LN2;
        }
        class Jo extends Xo {
            reset() {
                super.reset(), delete this._distance, delete this._startDistance;
            }
            _start(e) {
                this._startDistance = this._distance = e[0].dist(e[1]);
            }
            _move(e, t) {
                const i = this._distance;
                if (this._distance = e[0].dist(e[1]), this._active || !(Math.abs(Yo(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                    zoomDelta: Yo(this._distance, i),
                    pinchAround: t
                };
            }
        }
        function ea(e, t) {
            return 180 * e.angleWith(t) / Math.PI;
        }
        class ta extends Xo {
            reset() {
                super.reset(), delete this._minDiameter, delete this._startVector, delete this._vector;
            }
            _start(e) {
                this._startVector = this._vector = e[0].sub(e[1]), this._minDiameter = e[0].dist(e[1]);
            }
            _move(e, t, i) {
                const r = this._vector;
                if (this._vector = e[0].sub(e[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
                    bearingDelta: ea(this._vector, r),
                    pinchAround: t
                };
            }
            _isBelowThreshold(e) {
                this._minDiameter = Math.min(this._minDiameter, e.mag());
                const t = 25 / (Math.PI * this._minDiameter) * 360, i = ea(e, this._startVector);
                return Math.abs(i) < t;
            }
        }
        function ia(e) {
            return Math.abs(e.y) > Math.abs(e.x);
        }
        class ra extends Xo {
            constructor(e){
                super(), this._currentTouchCount = 0, this._map = e;
            }
            reset() {
                super.reset(), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
            }
            touchstart(e, t, i) {
                super.touchstart(e, t, i), this._currentTouchCount = i.length;
            }
            _start(e) {
                this._lastPoints = e, ia(e[0].sub(e[1])) && (this._valid = !1);
            }
            _move(e, t, i) {
                if (this._map.cooperativeGestures.isEnabled() && this._currentTouchCount < 3) return;
                const r = e[0].sub(this._lastPoints[0]), o = e[1].sub(this._lastPoints[1]);
                return this._valid = this.gestureBeginsVertically(r, o, i.timeStamp), this._valid ? (this._lastPoints = e, this._active = !0, {
                    pitchDelta: (r.y + o.y) / 2 * -0.5
                }) : void 0;
            }
            gestureBeginsVertically(e, t, i) {
                if (void 0 !== this._valid) return this._valid;
                const r = e.mag() >= 2, o = t.mag() >= 2;
                if (!r && !o) return;
                if (!r || !o) return void 0 === this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
                const a = e.y > 0 == t.y > 0;
                return ia(e) && ia(t) && a;
            }
        }
        const oa = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        };
        class aa {
            constructor(e){
                this._tr = new Bo(e);
                const t = oa;
                this._panStep = t.panStep, this._bearingStep = t.bearingStep, this._pitchStep = t.pitchStep, this._rotationDisabled = !1;
            }
            reset() {
                this._active = !1;
            }
            keydown(e) {
                if (e.altKey || e.ctrlKey || e.metaKey) return;
                let t = 0, i = 0, r = 0, o = 0, a = 0;
                switch(e.keyCode){
                    case 61:
                    case 107:
                    case 171:
                    case 187:
                        t = 1;
                        break;
                    case 189:
                    case 109:
                    case 173:
                        t = -1;
                        break;
                    case 37:
                        e.shiftKey ? i = -1 : (e.preventDefault(), o = -1);
                        break;
                    case 39:
                        e.shiftKey ? i = 1 : (e.preventDefault(), o = 1);
                        break;
                    case 38:
                        e.shiftKey ? r = 1 : (e.preventDefault(), a = -1);
                        break;
                    case 40:
                        e.shiftKey ? r = -1 : (e.preventDefault(), a = 1);
                        break;
                    default:
                        return;
                }
                return this._rotationDisabled && (i = 0, r = 0), {
                    cameraAnimation: (s)=>{
                        const n = this._tr;
                        s.easeTo({
                            duration: 300,
                            easeId: "keyboardHandler",
                            easing: sa,
                            zoom: t ? Math.round(n.zoom) + t * (e.shiftKey ? 2 : 1) : n.zoom,
                            bearing: n.bearing + i * this._bearingStep,
                            pitch: n.pitch + r * this._pitchStep,
                            offset: [
                                -o * this._panStep,
                                -a * this._panStep
                            ],
                            center: n.center
                        }, {
                            originalEvent: e
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            disableRotation() {
                this._rotationDisabled = !0;
            }
            enableRotation() {
                this._rotationDisabled = !1;
            }
        }
        function sa(e) {
            return e * (2 - e);
        }
        const na = 4.000244140625;
        class la {
            constructor(e, t){
                this._onTimeout = (e)=>{
                    this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(e);
                }, this._map = e, this._tr = new Bo(e), this._triggerRenderFrame = t, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = .0022222222222222222;
            }
            setZoomRate(e) {
                this._defaultZoomRate = e;
            }
            setWheelZoomRate(e) {
                this._wheelZoomRate = e;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active || void 0 !== this._finishTimeout;
            }
            isZooming() {
                return !!this._zooming;
            }
            enable(e) {
                this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!e && "center" === e.around);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            _shouldBePrevented(e) {
                return !!this._map.cooperativeGestures.isEnabled() && !(e.ctrlKey || this._map.cooperativeGestures.isBypassed(e));
            }
            wheel(e) {
                if (!this.isEnabled()) return;
                if (this._shouldBePrevented(e)) return void this._map.cooperativeGestures.notifyGestureBlocked("wheel_zoom", e);
                let t = e.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * e.deltaY : e.deltaY;
                const i = s.now(), r = i - (this._lastWheelEventTime || 0);
                this._lastWheelEventTime = i, 0 !== t && t % na == 0 ? this._type = "wheel" : 0 !== t && Math.abs(t) < 4 ? this._type = "trackpad" : r > 400 ? (this._type = null, this._lastValue = t, this._timeout = setTimeout(this._onTimeout, 40, e)) : this._type || (this._type = Math.abs(r * t) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, t += this._lastValue)), e.shiftKey && t && (t /= 4), this._type && (this._lastWheelEvent = e, this._delta -= t, this._active || this._start(e)), e.preventDefault();
            }
            _start(e) {
                if (!this._delta) return;
                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                const i = n.mousePos(this._map.getCanvas(), e), r = this._tr;
                this._aroundPoint = this._aroundCenter ? r.transform.locationToScreenPoint(t.Q.convert(r.center)) : i, this._frameId || (this._frameId = !0, this._triggerRenderFrame());
            }
            renderFrame() {
                if (!this._frameId) return;
                if (this._frameId = null, !this.isActive()) return;
                const e = this._tr.transform;
                if ("number" == typeof this._lastExpectedZoom) {
                    const t = e.zoom - this._lastExpectedZoom;
                    "number" == typeof this._startZoom && (this._startZoom += t), "number" == typeof this._targetZoom && (this._targetZoom += t);
                }
                if (0 !== this._delta) {
                    const i = "wheel" === this._type && Math.abs(this._delta) > na ? this._wheelZoomRate : this._defaultZoomRate;
                    let r = 2 / (1 + Math.exp(-Math.abs(this._delta * i)));
                    this._delta < 0 && 0 !== r && (r = 1 / r);
                    const o = "number" != typeof this._targetZoom ? e.scale : t.aI(this._targetZoom);
                    this._targetZoom = Math.min(e.maxZoom, Math.max(e.minZoom, t.ab(o * r))), "wheel" === this._type && (this._startZoom = e.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
                }
                const i = "number" != typeof this._targetZoom ? e.zoom : this._targetZoom, r = this._startZoom, o = this._easing;
                let a, n = !1;
                if ("wheel" === this._type && r && o) {
                    const e = s.now() - this._lastWheelEventTime, l = Math.min((e + 5) / 200, 1), c = o(l);
                    a = t.B.number(r, i, c), l < 1 ? this._frameId || (this._frameId = !0) : n = !0;
                } else a = i, n = !0;
                return this._active = !0, n && (this._active = !1, this._finishTimeout = setTimeout(()=>{
                    this._zooming = !1, this._triggerRenderFrame(), delete this._targetZoom, delete this._lastExpectedZoom, delete this._finishTimeout;
                }, 200)), this._lastExpectedZoom = a, {
                    noInertia: !0,
                    needsRenderFrame: !n,
                    zoomDelta: a - e.zoom,
                    around: this._aroundPoint,
                    originalEvent: this._lastWheelEvent
                };
            }
            _smoothOutEasing(e) {
                let i = t.cb;
                if (this._prevEase) {
                    const e = this._prevEase, r = (s.now() - e.start) / e.duration, o = e.easing(r + .01) - e.easing(r), a = .27 / Math.sqrt(o * o + 1e-4) * .01, n = Math.sqrt(.0729 - a * a);
                    i = t.c9(a, n, .25, 1);
                }
                return this._prevEase = {
                    start: s.now(),
                    duration: e,
                    easing: i
                }, i;
            }
            reset() {
                this._active = !1, this._zooming = !1, delete this._targetZoom, delete this._lastExpectedZoom, this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
            }
        }
        class ca {
            constructor(e, t){
                this._clickZoom = e, this._tapZoom = t;
            }
            enable() {
                this._clickZoom.enable(), this._tapZoom.enable();
            }
            disable() {
                this._clickZoom.disable(), this._tapZoom.disable();
            }
            isEnabled() {
                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
            }
            isActive() {
                return this._clickZoom.isActive() || this._tapZoom.isActive();
            }
        }
        class ha {
            constructor(e){
                this._tr = new Bo(e), this.reset();
            }
            reset() {
                this._active = !1;
            }
            dblclick(e, t) {
                return e.preventDefault(), {
                    cameraAnimation: (i)=>{
                        i.easeTo({
                            duration: 300,
                            zoom: this._tr.zoom + (e.shiftKey ? -1 : 1),
                            around: this._tr.unproject(t)
                        }, {
                            originalEvent: e
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class ua {
            constructor(){
                this._tap = new No({
                    numTouches: 1,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, delete this._tapPoint, this._tap.reset();
            }
            touchstart(e, t, i) {
                if (!this._swipePoint) {
                    if (this._tapTime) {
                        const r = t[0], o = e.timeStamp - this._tapTime < 500, a = this._tapPoint.dist(r) < 30;
                        o && a ? i.length > 0 && (this._swipePoint = r, this._swipeTouch = i[0].identifier) : this.reset();
                    } else this._tap.touchstart(e, t, i);
                }
            }
            touchmove(e, t, i) {
                if (this._tapTime) {
                    if (this._swipePoint) {
                        if (i[0].identifier !== this._swipeTouch) return;
                        const r = t[0], o = r.y - this._swipePoint.y;
                        return this._swipePoint = r, e.preventDefault(), this._active = !0, {
                            zoomDelta: o / 128
                        };
                    }
                } else this._tap.touchmove(e, t, i);
            }
            touchend(e, t, i) {
                if (this._tapTime) this._swipePoint && 0 === i.length && this.reset();
                else {
                    const r = this._tap.touchend(e, t, i);
                    r && (this._tapTime = e.timeStamp, this._tapPoint = r);
                }
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class da {
            constructor(e, t, i){
                this._el = e, this._mousePan = t, this._touchPan = i;
            }
            enable(e) {
                this._inertiaOptions = e || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("maplibregl-touch-drag-pan");
            }
            disable() {
                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("maplibregl-touch-drag-pan");
            }
            isEnabled() {
                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
            }
            isActive() {
                return this._mousePan.isActive() || this._touchPan.isActive();
            }
        }
        class _a {
            constructor(e, t, i, r){
                this._pitchWithRotate = e.pitchWithRotate, this._rollEnabled = e.rollEnabled, this._mouseRotate = t, this._mousePitch = i, this._mouseRoll = r;
            }
            enable() {
                this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable(), this._rollEnabled && this._mouseRoll.enable();
            }
            disable() {
                this._mouseRotate.disable(), this._mousePitch.disable(), this._mouseRoll.disable();
            }
            isEnabled() {
                return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled()) && (!this._rollEnabled || this._mouseRoll.isEnabled());
            }
            isActive() {
                return this._mouseRotate.isActive() || this._mousePitch.isActive() || this._mouseRoll.isActive();
            }
        }
        class pa {
            constructor(e, t, i, r){
                this._el = e, this._touchZoom = t, this._touchRotate = i, this._tapDragZoom = r, this._rotationDisabled = !1, this._enabled = !0;
            }
            enable(e) {
                this._touchZoom.enable(e), this._rotationDisabled || this._touchRotate.enable(e), this._tapDragZoom.enable(), this._el.classList.add("maplibregl-touch-zoom-rotate");
            }
            disable() {
                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("maplibregl-touch-zoom-rotate");
            }
            isEnabled() {
                return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
            }
            isActive() {
                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
            }
            disableRotation() {
                this._rotationDisabled = !0, this._touchRotate.disable();
            }
            enableRotation() {
                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
            }
        }
        class ma {
            constructor(e, t){
                this._bypassKey = -1 !== navigator.userAgent.indexOf("Mac") ? "metaKey" : "ctrlKey", this._map = e, this._options = t, this._enabled = !1;
            }
            isActive() {
                return !1;
            }
            reset() {}
            _setupUI() {
                if (this._container) return;
                const e = this._map.getCanvasContainer();
                e.classList.add("maplibregl-cooperative-gestures"), this._container = n.create("div", "maplibregl-cooperative-gesture-screen", e);
                let t = this._map._getUIString("CooperativeGesturesHandler.WindowsHelpText");
                "metaKey" === this._bypassKey && (t = this._map._getUIString("CooperativeGesturesHandler.MacHelpText"));
                const i = this._map._getUIString("CooperativeGesturesHandler.MobileHelpText"), r = document.createElement("div");
                r.className = "maplibregl-desktop-message", r.textContent = t, this._container.appendChild(r);
                const o = document.createElement("div");
                o.className = "maplibregl-mobile-message", o.textContent = i, this._container.appendChild(o), this._container.setAttribute("aria-hidden", "true");
            }
            _destroyUI() {
                this._container && (n.remove(this._container), this._map.getCanvasContainer().classList.remove("maplibregl-cooperative-gestures")), delete this._container;
            }
            enable() {
                this._setupUI(), this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this._destroyUI();
            }
            isEnabled() {
                return this._enabled;
            }
            isBypassed(e) {
                return e[this._bypassKey];
            }
            notifyGestureBlocked(e, i) {
                this._enabled && (this._map.fire(new t.l("cooperativegestureprevented", {
                    gestureType: e,
                    originalEvent: i
                })), this._container.classList.add("maplibregl-show"), setTimeout(()=>{
                    this._container.classList.remove("maplibregl-show");
                }, 100));
            }
        }
        const fa = (e)=>e.zoom || e.drag || e.roll || e.pitch || e.rotate;
        class ga extends t.l {
        }
        function va(e) {
            return e.panDelta && e.panDelta.mag() || e.zoomDelta || e.bearingDelta || e.pitchDelta || e.rollDelta;
        }
        class xa {
            constructor(e, i){
                this.handleWindowEvent = (e)=>{
                    this.handleEvent(e, `${e.type}Window`);
                }, this.handleEvent = (e, i)=>{
                    if ("blur" === e.type) return void this.stop(!0);
                    this._updatingCamera = !0;
                    const r = "renderFrame" === e.type ? void 0 : e, o = {
                        needsRenderFrame: !1
                    }, a = {}, s = {};
                    for (const { handlerName: l, handler: c, allowed: h } of this._handlers){
                        if (!c.isEnabled()) continue;
                        let u;
                        if (this._blockedByActive(s, h, l)) c.reset();
                        else if (c[i || e.type]) {
                            if (t.cc(e, i || e.type)) {
                                const t = n.mousePos(this._map.getCanvas(), e);
                                u = c[i || e.type](e, t);
                            } else if (t.cd(e, i || e.type)) {
                                const t = this._getMapTouches(e.touches), r = n.touchPos(this._map.getCanvas(), t);
                                u = c[i || e.type](e, r, t);
                            } else t.ce(i || e.type) || (u = c[i || e.type](e));
                            this.mergeHandlerResult(o, a, u, l, r), u && u.needsRenderFrame && this._triggerRenderFrame();
                        }
                        (u || c.isActive()) && (s[l] = c);
                    }
                    const l = {};
                    for(const e in this._previousActiveHandlers)s[e] || (l[e] = r);
                    this._previousActiveHandlers = s, (Object.keys(l).length || va(o)) && (this._changes.push([
                        o,
                        a,
                        l
                    ]), this._triggerRenderFrame()), (Object.keys(s).length || va(o)) && this._map._stop(!0), this._updatingCamera = !1;
                    const { cameraAnimation: c } = o;
                    c && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], c(this._map));
                }, this._map = e, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new So(e), this._bearingSnap = i.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(i);
                const r = this._el;
                this._listeners = [
                    [
                        r,
                        "touchstart",
                        {
                            passive: !0
                        }
                    ],
                    [
                        r,
                        "touchmove",
                        {
                            passive: !1
                        }
                    ],
                    [
                        r,
                        "touchend",
                        void 0
                    ],
                    [
                        r,
                        "touchcancel",
                        void 0
                    ],
                    [
                        r,
                        "mousedown",
                        void 0
                    ],
                    [
                        r,
                        "mousemove",
                        void 0
                    ],
                    [
                        r,
                        "mouseup",
                        void 0
                    ],
                    [
                        document,
                        "mousemove",
                        {
                            capture: !0
                        }
                    ],
                    [
                        document,
                        "mouseup",
                        void 0
                    ],
                    [
                        r,
                        "mouseover",
                        void 0
                    ],
                    [
                        r,
                        "mouseout",
                        void 0
                    ],
                    [
                        r,
                        "dblclick",
                        void 0
                    ],
                    [
                        r,
                        "click",
                        void 0
                    ],
                    [
                        r,
                        "keydown",
                        {
                            capture: !1
                        }
                    ],
                    [
                        r,
                        "keyup",
                        void 0
                    ],
                    [
                        r,
                        "wheel",
                        {
                            passive: !1
                        }
                    ],
                    [
                        r,
                        "contextmenu",
                        void 0
                    ],
                    [
                        window,
                        "blur",
                        void 0
                    ]
                ];
                for (const [e, t, i] of this._listeners)n.addEventListener(e, t, e === document ? this.handleWindowEvent : this.handleEvent, i);
            }
            destroy() {
                for (const [e, t, i] of this._listeners)n.removeEventListener(e, t, e === document ? this.handleWindowEvent : this.handleEvent, i);
            }
            _addDefaultHandlers(e) {
                const i = this._map, r = i.getCanvasContainer();
                this._add("mapEvent", new ko(i, e));
                const o = i.boxZoom = new Oo(i, e);
                this._add("boxZoom", o), e.interactive && e.boxZoom && o.enable();
                const a = i.cooperativeGestures = new ma(i, e.cooperativeGestures);
                this._add("cooperativeGestures", a), e.cooperativeGestures && a.enable();
                const s = new Go(i), l = new ha(i);
                i.doubleClickZoom = new ca(l, s), this._add("tapZoom", s), this._add("clickZoom", l), e.interactive && e.doubleClickZoom && i.doubleClickZoom.enable();
                const c = new ua;
                this._add("tapDragZoom", c);
                const h = i.touchPitch = new ra(i);
                this._add("touchPitch", h), e.interactive && e.touchPitch && i.touchPitch.enable(e.touchPitch);
                const u = ()=>i.project(i.getCenter()), d = function({ enable: e, clickTolerance: i, aroundCenter: r = !0, minPixelCenterThreshold: o = 100, rotateDegreesPerPixelMoved: a = .8 }, s) {
                    const l = new qo({
                        checkCorrectEvent: (e)=>0 === n.mouseButton(e) && e.ctrlKey || 2 === n.mouseButton(e) && !e.ctrlKey
                    });
                    return new Uo({
                        clickTolerance: i,
                        move: (e, i)=>{
                            const n = s();
                            if (r && Math.abs(n.y - e.y) > o) return {
                                bearingDelta: t.ca(new t.P(e.x, i.y), i, n)
                            };
                            let l = (i.x - e.x) * a;
                            return r && i.y < n.y && (l = -l), {
                                bearingDelta: l
                            };
                        },
                        moveStateManager: l,
                        enable: e,
                        assignEvents: Ho
                    });
                }(e, u), _ = function({ enable: e, clickTolerance: t, pitchDegreesPerPixelMoved: i = -0.5 }) {
                    const r = new qo({
                        checkCorrectEvent: (e)=>0 === n.mouseButton(e) && e.ctrlKey || 2 === n.mouseButton(e)
                    });
                    return new Uo({
                        clickTolerance: t,
                        move: (e, t)=>({
                                pitchDelta: (t.y - e.y) * i
                            }),
                        moveStateManager: r,
                        enable: e,
                        assignEvents: Ho
                    });
                }(e), p = function({ enable: e, clickTolerance: t, rollDegreesPerPixelMoved: i = .3 }, r) {
                    const o = new qo({
                        checkCorrectEvent: (e)=>2 === n.mouseButton(e) && e.ctrlKey
                    });
                    return new Uo({
                        clickTolerance: t,
                        move: (e, t)=>{
                            const o = r();
                            let a = (t.x - e.x) * i;
                            return t.y < o.y && (a = -a), {
                                rollDelta: a
                            };
                        },
                        moveStateManager: o,
                        enable: e,
                        assignEvents: Ho
                    });
                }(e, u);
                i.dragRotate = new _a(e, d, _, p), this._add("mouseRotate", d, [
                    "mousePitch"
                ]), this._add("mousePitch", _, [
                    "mouseRotate",
                    "mouseRoll"
                ]), this._add("mouseRoll", p, [
                    "mousePitch"
                ]), e.interactive && e.dragRotate && i.dragRotate.enable();
                const m = function({ enable: e, clickTolerance: t }) {
                    const i = new qo({
                        checkCorrectEvent: (e)=>0 === n.mouseButton(e) && !e.ctrlKey
                    });
                    return new Uo({
                        clickTolerance: t,
                        move: (e, t)=>({
                                around: t,
                                panDelta: t.sub(e)
                            }),
                        activateOnStart: !0,
                        moveStateManager: i,
                        enable: e,
                        assignEvents: Ho
                    });
                }(e), f = new Ko(e, i);
                i.dragPan = new da(r, m, f), this._add("mousePan", m), this._add("touchPan", f, [
                    "touchZoom",
                    "touchRotate"
                ]), e.interactive && e.dragPan && i.dragPan.enable(e.dragPan);
                const g = new ta, v = new Jo;
                i.touchZoomRotate = new pa(r, v, g, c), this._add("touchRotate", g, [
                    "touchPan",
                    "touchZoom"
                ]), this._add("touchZoom", v, [
                    "touchPan",
                    "touchRotate"
                ]), e.interactive && e.touchZoomRotate && i.touchZoomRotate.enable(e.touchZoomRotate);
                const x = i.scrollZoom = new la(i, ()=>this._triggerRenderFrame());
                this._add("scrollZoom", x, [
                    "mousePan"
                ]), e.interactive && e.scrollZoom && i.scrollZoom.enable(e.scrollZoom);
                const b = i.keyboard = new aa(i);
                this._add("keyboard", b), e.interactive && e.keyboard && i.keyboard.enable(), this._add("blockableMapEvent", new Fo(i));
            }
            _add(e, t, i) {
                this._handlers.push({
                    handlerName: e,
                    handler: t,
                    allowed: i
                }), this._handlersById[e] = t;
            }
            stop(e) {
                if (!this._updatingCamera) {
                    for (const { handler: e } of this._handlers)e.reset();
                    this._inertia.clear(), this._fireEvents({}, {}, e), this._changes = [];
                }
            }
            isActive() {
                for (const { handler: e } of this._handlers)if (e.isActive()) return !0;
                return !1;
            }
            isZooming() {
                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
            }
            isRotating() {
                return !!this._eventsInProgress.rotate;
            }
            isMoving() {
                return Boolean(fa(this._eventsInProgress)) || this.isZooming();
            }
            _blockedByActive(e, t, i) {
                for(const r in e)if (r !== i && (!t || t.indexOf(r) < 0)) return !0;
                return !1;
            }
            _getMapTouches(e) {
                const t = [];
                for (const i of e)this._el.contains(i.target) && t.push(i);
                return t;
            }
            mergeHandlerResult(e, i, r, o, a) {
                if (!r) return;
                t.e(e, r);
                const s = {
                    handlerName: o,
                    originalEvent: r.originalEvent || a
                };
                void 0 !== r.zoomDelta && (i.zoom = s), void 0 !== r.panDelta && (i.drag = s), void 0 !== r.rollDelta && (i.roll = s), void 0 !== r.pitchDelta && (i.pitch = s), void 0 !== r.bearingDelta && (i.rotate = s);
            }
            _applyChanges() {
                const e = {}, i = {}, r = {};
                for (const [o, a, s] of this._changes)o.panDelta && (e.panDelta = (e.panDelta || new t.P(0, 0))._add(o.panDelta)), o.zoomDelta && (e.zoomDelta = (e.zoomDelta || 0) + o.zoomDelta), o.bearingDelta && (e.bearingDelta = (e.bearingDelta || 0) + o.bearingDelta), o.pitchDelta && (e.pitchDelta = (e.pitchDelta || 0) + o.pitchDelta), o.rollDelta && (e.rollDelta = (e.rollDelta || 0) + o.rollDelta), void 0 !== o.around && (e.around = o.around), void 0 !== o.pinchAround && (e.pinchAround = o.pinchAround), o.noInertia && (e.noInertia = o.noInertia), t.e(i, a), t.e(r, s);
                this._updateMapTransform(e, i, r), this._changes = [];
            }
            _updateMapTransform(e, t, i) {
                const r = this._map, o = r._getTransformForUpdate(), a = r.terrain;
                if (!(va(e) || a && this._terrainMovement)) return this._fireEvents(t, i, !0);
                r._stop(!0);
                let { panDelta: s, zoomDelta: n, bearingDelta: l, pitchDelta: c, rollDelta: h, around: u, pinchAround: d } = e;
                void 0 !== d && (u = d), u = u || r.transform.centerPoint, a && !o.isPointOnMapSurface(u) && (u = o.centerPoint);
                const _ = {
                    panDelta: s,
                    zoomDelta: n,
                    rollDelta: h,
                    pitchDelta: c,
                    bearingDelta: l,
                    around: u
                };
                this._map.cameraHelper.useGlobeControls && !o.isPointOnMapSurface(u) && (u = o.centerPoint);
                const p = u.distSqr(o.centerPoint) < .01 ? o.center : o.screenPointToLocation(s ? u.sub(s) : u);
                a ? (this._map.cameraHelper.handleMapControlsRollPitchBearingZoom(_, o), this._terrainMovement || !t.drag && !t.zoom ? t.drag && this._terrainMovement ? o.setCenter(o.screenPointToLocation(o.centerPoint.sub(s))) : this._map.cameraHelper.handleMapControlsPan(_, o, p) : (this._terrainMovement = !0, this._map._elevationFreeze = !0, this._map.cameraHelper.handleMapControlsPan(_, o, p))) : (this._map.cameraHelper.handleMapControlsRollPitchBearingZoom(_, o), this._map.cameraHelper.handleMapControlsPan(_, o, p)), r._applyUpdatedTransform(o), this._map._update(), e.noInertia || this._inertia.record(e), this._fireEvents(t, i, !0);
            }
            _fireEvents(e, i, r) {
                const o = fa(this._eventsInProgress), a = fa(e), n = {};
                for(const t in e){
                    const { originalEvent: i } = e[t];
                    this._eventsInProgress[t] || (n[`${t}start`] = i), this._eventsInProgress[t] = e[t];
                }
                !o && a && this._fireEvent("movestart", a.originalEvent);
                for(const e in n)this._fireEvent(e, n[e]);
                a && this._fireEvent("move", a.originalEvent);
                for(const t in e){
                    const { originalEvent: i } = e[t];
                    this._fireEvent(t, i);
                }
                const l = {};
                let c;
                for(const e in this._eventsInProgress){
                    const { handlerName: t, originalEvent: r } = this._eventsInProgress[e];
                    this._handlersById[t].isActive() || (delete this._eventsInProgress[e], c = i[t] || r, l[`${e}end`] = c);
                }
                for(const e in l)this._fireEvent(e, l[e]);
                const h = fa(this._eventsInProgress), u = (o || a) && !h;
                if (u && this._terrainMovement) {
                    this._map._elevationFreeze = !1, this._terrainMovement = !1;
                    const e = this._map._getTransformForUpdate();
                    this._map.getCenterClampedToGround() && e.recalculateZoomAndCenter(this._map.terrain), this._map._applyUpdatedTransform(e);
                }
                if (r && u) {
                    this._updatingCamera = !0;
                    const e = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i = (e)=>0 !== e && -this._bearingSnap < e && e < this._bearingSnap;
                    !e || !e.essential && s.prefersReducedMotion ? (this._map.fire(new t.l("moveend", {
                        originalEvent: c
                    })), i(this._map.getBearing()) && this._map.resetNorth()) : (i(e.bearing || this._map.getBearing()) && (e.bearing = 0), e.freezeElevation = !0, this._map.easeTo(e, {
                        originalEvent: c
                    })), this._updatingCamera = !1;
                }
            }
            _fireEvent(e, i) {
                this._map.fire(new t.l(e, i ? {
                    originalEvent: i
                } : {}));
            }
            _requestFrame() {
                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e)=>{
                    delete this._frameId, this.handleEvent(new ga("renderFrame", {
                        timeStamp: e
                    })), this._applyChanges();
                });
            }
            _triggerRenderFrame() {
                void 0 === this._frameId && (this._frameId = this._requestFrame());
            }
        }
        class ba extends t.E {
            constructor(e, t, i){
                super(), this._renderFrameCallback = ()=>{
                    const e = Math.min((s.now() - this._easeStart) / this._easeOptions.duration, 1);
                    this._onEaseFrame(this._easeOptions.easing(e)), e < 1 && this._easeFrameId ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
                }, this._moving = !1, this._zooming = !1, this.transform = e, this._bearingSnap = i.bearingSnap, this.cameraHelper = t, this.on("moveend", ()=>{
                    delete this._requestedCameraState;
                });
            }
            migrateProjection(e, t) {
                e.apply(this.transform), this.transform = e, this.cameraHelper = t;
            }
            getCenter() {
                return new t.Q(this.transform.center.lng, this.transform.center.lat);
            }
            setCenter(e, t) {
                return this.jumpTo({
                    center: e
                }, t);
            }
            getCenterElevation() {
                return this.transform.elevation;
            }
            setCenterElevation(e, t) {
                return this.jumpTo({
                    elevation: e
                }, t), this;
            }
            getCenterClampedToGround() {
                return this._centerClampedToGround;
            }
            setCenterClampedToGround(e) {
                this._centerClampedToGround = e;
            }
            panBy(e, i, r) {
                return e = t.P.convert(e).mult(-1), this.panTo(this.transform.center, t.e({
                    offset: e
                }, i), r);
            }
            panTo(e, i, r) {
                return this.easeTo(t.e({
                    center: e
                }, i), r);
            }
            getZoom() {
                return this.transform.zoom;
            }
            setZoom(e, t) {
                return this.jumpTo({
                    zoom: e
                }, t), this;
            }
            zoomTo(e, i, r) {
                return this.easeTo(t.e({
                    zoom: e
                }, i), r);
            }
            zoomIn(e, t) {
                return this.zoomTo(this.getZoom() + 1, e, t), this;
            }
            zoomOut(e, t) {
                return this.zoomTo(this.getZoom() - 1, e, t), this;
            }
            getVerticalFieldOfView() {
                return this.transform.fov;
            }
            setVerticalFieldOfView(e, i) {
                return e != this.transform.fov && (this.transform.setFov(e), this.fire(new t.l("movestart", i)).fire(new t.l("move", i)).fire(new t.l("moveend", i))), this;
            }
            getBearing() {
                return this.transform.bearing;
            }
            setBearing(e, t) {
                return this.jumpTo({
                    bearing: e
                }, t), this;
            }
            getPadding() {
                return this.transform.padding;
            }
            setPadding(e, t) {
                return this.jumpTo({
                    padding: e
                }, t), this;
            }
            rotateTo(e, i, r) {
                return this.easeTo(t.e({
                    bearing: e
                }, i), r);
            }
            resetNorth(e, i) {
                return this.rotateTo(0, t.e({
                    duration: 1e3
                }, e), i), this;
            }
            resetNorthPitch(e, i) {
                return this.easeTo(t.e({
                    bearing: 0,
                    pitch: 0,
                    roll: 0,
                    duration: 1e3
                }, e), i), this;
            }
            snapToNorth(e, t) {
                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e, t) : this;
            }
            getPitch() {
                return this.transform.pitch;
            }
            setPitch(e, t) {
                return this.jumpTo({
                    pitch: e
                }, t), this;
            }
            getRoll() {
                return this.transform.roll;
            }
            setRoll(e, t) {
                return this.jumpTo({
                    roll: e
                }, t), this;
            }
            cameraForBounds(e, t) {
                e = V.convert(e).adjustAntiMeridian();
                const i = t && t.bearing || 0;
                return this._cameraForBoxAndBearing(e.getNorthWest(), e.getSouthEast(), i, t);
            }
            _cameraForBoxAndBearing(e, i, r, o) {
                const a = {
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0
                };
                if ("number" == typeof (o = t.e({
                    padding: a,
                    offset: [
                        0,
                        0
                    ],
                    maxZoom: this.transform.maxZoom
                }, o)).padding) {
                    const e = o.padding;
                    o.padding = {
                        top: e,
                        bottom: e,
                        right: e,
                        left: e
                    };
                }
                const s = t.e(a, o.padding);
                o.padding = s;
                const n = this.transform, l = new V(e, i);
                return this.cameraHelper.cameraForBoxAndBearing(o, s, l, r, n);
            }
            fitBounds(e, t, i) {
                return this._fitInternal(this.cameraForBounds(e, t), t, i);
            }
            fitScreenCoordinates(e, i, r, o, a) {
                return this._fitInternal(this._cameraForBoxAndBearing(this.transform.screenPointToLocation(t.P.convert(e)), this.transform.screenPointToLocation(t.P.convert(i)), r, o), o, a);
            }
            _fitInternal(e, i, r) {
                return e ? (delete (i = t.e(e, i)).padding, i.linear ? this.easeTo(i, r) : this.flyTo(i, r)) : this;
            }
            jumpTo(e, i) {
                this.stop();
                const r = this._getTransformForUpdate();
                let o = !1, a = !1, s = !1;
                const n = r.zoom;
                this.cameraHelper.handleJumpToCenterZoom(r, e);
                const l = r.zoom !== n;
                return "elevation" in e && r.elevation !== +e.elevation && r.setElevation(+e.elevation), "bearing" in e && r.bearing !== +e.bearing && (o = !0, r.setBearing(+e.bearing)), "pitch" in e && r.pitch !== +e.pitch && (a = !0, r.setPitch(+e.pitch)), "roll" in e && r.roll !== +e.roll && (s = !0, r.setRoll(+e.roll)), null == e.padding || r.isPaddingEqual(e.padding) || r.setPadding(e.padding), this._applyUpdatedTransform(r), this.fire(new t.l("movestart", i)).fire(new t.l("move", i)), l && this.fire(new t.l("zoomstart", i)).fire(new t.l("zoom", i)).fire(new t.l("zoomend", i)), o && this.fire(new t.l("rotatestart", i)).fire(new t.l("rotate", i)).fire(new t.l("rotateend", i)), a && this.fire(new t.l("pitchstart", i)).fire(new t.l("pitch", i)).fire(new t.l("pitchend", i)), s && this.fire(new t.l("rollstart", i)).fire(new t.l("roll", i)).fire(new t.l("rollend", i)), this.fire(new t.l("moveend", i));
            }
            calculateCameraOptionsFromTo(e, i, r, o = 0) {
                const a = t.$.fromLngLat(e, i), s = t.$.fromLngLat(r, o), n = s.x - a.x, l = s.y - a.y, c = s.z - a.z, h = Math.hypot(n, l, c);
                if (0 === h) throw new Error("Can't calculate camera options with same From and To");
                const u = Math.hypot(n, l), d = t.ab(this.transform.cameraToCenterDistance / h / this.transform.tileSize), _ = 180 * Math.atan2(n, -l) / Math.PI;
                let p = 180 * Math.acos(u / h) / Math.PI;
                return p = c < 0 ? 90 - p : 90 + p, {
                    center: s.toLngLat(),
                    elevation: o,
                    zoom: d,
                    pitch: p,
                    bearing: _
                };
            }
            calculateCameraOptionsFromCameraLngLatAltRotation(e, t, i, r, o) {
                const a = this.transform.calculateCenterFromCameraLngLatAlt(e, t, i, r);
                return {
                    center: a.center,
                    elevation: a.elevation,
                    zoom: a.zoom,
                    bearing: i,
                    pitch: r,
                    roll: o
                };
            }
            easeTo(e, i) {
                this._stop(!1, e.easeId), (!1 === (e = t.e({
                    offset: [
                        0,
                        0
                    ],
                    duration: 500,
                    easing: t.cb
                }, e)).animate || !e.essential && s.prefersReducedMotion) && (e.duration = 0);
                const r = this._getTransformForUpdate(), o = this.getBearing(), a = r.pitch, n = r.roll, l = "bearing" in e ? this._normalizeBearing(e.bearing, o) : o, c = "pitch" in e ? +e.pitch : a, h = "roll" in e ? this._normalizeBearing(e.roll, n) : n, u = "padding" in e ? e.padding : r.padding, d = t.P.convert(e.offset);
                let _, p;
                e.around && (_ = t.Q.convert(e.around), p = r.locationToScreenPoint(_));
                const m = {
                    moving: this._moving,
                    zooming: this._zooming,
                    rotating: this._rotating,
                    pitching: this._pitching,
                    rolling: this._rolling
                }, f = this.cameraHelper.handleEaseTo(r, {
                    bearing: l,
                    pitch: c,
                    roll: h,
                    padding: u,
                    around: _,
                    aroundPoint: p,
                    offsetAsPoint: d,
                    offset: e.offset,
                    zoom: e.zoom,
                    center: e.center
                });
                return this._rotating = this._rotating || o !== l, this._pitching = this._pitching || c !== a, this._rolling = this._rolling || h !== n, this._padding = !r.isPaddingEqual(u), this._zooming = this._zooming || f.isZooming, this._easeId = e.easeId, this._prepareEase(i, e.noMoveStart, m), this.terrain && this._prepareElevation(f.elevationCenter), this._ease((t)=>{
                    f.easeFunc(t), this.terrain && !e.freezeElevation && this._updateElevation(t), this._applyUpdatedTransform(r), this._fireMoveEvents(i);
                }, (t)=>{
                    this.terrain && e.freezeElevation && this._finalizeElevation(), this._afterEase(i, t);
                }, e), this;
            }
            _prepareEase(e, i, r = {}) {
                this._moving = !0, i || r.moving || this.fire(new t.l("movestart", e)), this._zooming && !r.zooming && this.fire(new t.l("zoomstart", e)), this._rotating && !r.rotating && this.fire(new t.l("rotatestart", e)), this._pitching && !r.pitching && this.fire(new t.l("pitchstart", e)), this._rolling && !r.rolling && this.fire(new t.l("rollstart", e));
            }
            _prepareElevation(e) {
                this._elevationCenter = e, this._elevationStart = this.transform.elevation, this._elevationTarget = this.terrain.getElevationForLngLatZoom(e, this.transform.tileZoom), this._elevationFreeze = !0;
            }
            _updateElevation(e) {
                this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom));
                const i = this.terrain.getElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom);
                if (e < 1 && i !== this._elevationTarget) {
                    const t = this._elevationTarget - this._elevationStart;
                    this._elevationStart += e * (t - (i - (t * e + this._elevationStart)) / (1 - e)), this._elevationTarget = i;
                }
                this.transform.setElevation(t.B.number(this._elevationStart, this._elevationTarget, e));
            }
            _finalizeElevation() {
                this._elevationFreeze = !1, this.getCenterClampedToGround() && this.transform.recalculateZoomAndCenter(this.terrain);
            }
            _getTransformForUpdate() {
                return this.transformCameraUpdate || this.terrain ? (this._requestedCameraState || (this._requestedCameraState = this.transform.clone()), this._requestedCameraState) : this.transform;
            }
            _elevateCameraIfInsideTerrain(e) {
                if (!this.terrain && e.elevation >= 0 && e.pitch <= 90) return {};
                const t = e.getCameraLngLat(), i = e.getCameraAltitude(), r = this.terrain ? this.terrain.getElevationForLngLatZoom(t, e.zoom) : 0;
                if (i < r) {
                    const i = this.calculateCameraOptionsFromTo(t, r, e.center, e.elevation);
                    return {
                        pitch: i.pitch,
                        zoom: i.zoom
                    };
                }
                return {};
            }
            _applyUpdatedTransform(e) {
                const t = [];
                if (t.push((e)=>this._elevateCameraIfInsideTerrain(e)), this.transformCameraUpdate && t.push((e)=>this.transformCameraUpdate(e)), !t.length) return;
                const i = e.clone();
                for (const e of t){
                    const t = i.clone(), { center: r, zoom: o, roll: a, pitch: s, bearing: n, elevation: l } = e(t);
                    r && t.setCenter(r), void 0 !== l && t.setElevation(l), void 0 !== o && t.setZoom(o), void 0 !== a && t.setRoll(a), void 0 !== s && t.setPitch(s), void 0 !== n && t.setBearing(n), i.apply(t);
                }
                this.transform.apply(i);
            }
            _fireMoveEvents(e) {
                this.fire(new t.l("move", e)), this._zooming && this.fire(new t.l("zoom", e)), this._rotating && this.fire(new t.l("rotate", e)), this._pitching && this.fire(new t.l("pitch", e)), this._rolling && this.fire(new t.l("roll", e));
            }
            _afterEase(e, i) {
                if (this._easeId && i && this._easeId === i) return;
                delete this._easeId;
                const r = this._zooming, o = this._rotating, a = this._pitching, s = this._rolling;
                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._rolling = !1, this._padding = !1, r && this.fire(new t.l("zoomend", e)), o && this.fire(new t.l("rotateend", e)), a && this.fire(new t.l("pitchend", e)), s && this.fire(new t.l("rollend", e)), this.fire(new t.l("moveend", e));
            }
            flyTo(e, i) {
                if (!e.essential && s.prefersReducedMotion) {
                    const r = t.O(e, [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch",
                        "roll",
                        "elevation"
                    ]);
                    return this.jumpTo(r, i);
                }
                this.stop(), e = t.e({
                    offset: [
                        0,
                        0
                    ],
                    speed: 1.2,
                    curve: 1.42,
                    easing: t.cb
                }, e);
                const r = this._getTransformForUpdate(), o = r.bearing, a = r.pitch, n = r.roll, l = r.padding, c = "bearing" in e ? this._normalizeBearing(e.bearing, o) : o, h = "pitch" in e ? +e.pitch : a, u = "roll" in e ? this._normalizeBearing(e.roll, n) : n, d = "padding" in e ? e.padding : r.padding, _ = t.P.convert(e.offset);
                let p = r.centerPoint.add(_);
                const m = r.screenPointToLocation(p), f = this.cameraHelper.handleFlyTo(r, {
                    bearing: c,
                    pitch: h,
                    roll: u,
                    padding: d,
                    locationAtOffset: m,
                    offsetAsPoint: _,
                    center: e.center,
                    minZoom: e.minZoom,
                    zoom: e.zoom
                });
                let g = e.curve;
                const v = Math.max(r.width, r.height), x = v / f.scaleOfZoom, b = f.pixelPathLength;
                "number" == typeof f.scaleOfMinZoom && (g = Math.sqrt(v / f.scaleOfMinZoom / b * 2));
                const y = g * g;
                function w(e) {
                    const t = (x * x - v * v + (e ? -1 : 1) * y * y * b * b) / (2 * (e ? x : v) * y * b);
                    return Math.log(Math.sqrt(t * t + 1) - t);
                }
                function T(e) {
                    return (Math.exp(e) - Math.exp(-e)) / 2;
                }
                function P(e) {
                    return (Math.exp(e) + Math.exp(-e)) / 2;
                }
                const C = w(!1);
                let I = function(e) {
                    return P(C) / P(C + g * e);
                }, M = function(e) {
                    var t;
                    return v * ((P(C) * (T(t = C + g * e) / P(t)) - T(C)) / y) / b;
                }, E = (w(!0) - C) / g;
                if (Math.abs(b) < 2e-6 || !isFinite(E)) {
                    if (Math.abs(v - x) < 1e-6) return this.easeTo(e, i);
                    const t = x < v ? -1 : 1;
                    E = Math.abs(Math.log(x / v)) / g, M = ()=>0, I = (e)=>Math.exp(t * g * e);
                }
                return e.duration = "duration" in e ? +e.duration : 1e3 * E / ("screenSpeed" in e ? +e.screenSpeed / g : +e.speed), e.maxDuration && e.duration > e.maxDuration && (e.duration = 0), this._zooming = !0, this._rotating = o !== c, this._pitching = h !== a, this._rolling = u !== n, this._padding = !r.isPaddingEqual(d), this._prepareEase(i, !1), this.terrain && this._prepareElevation(f.targetCenter), this._ease((s)=>{
                    const m = s * E, g = 1 / I(m), v = M(m);
                    this._rotating && r.setBearing(t.B.number(o, c, s)), this._pitching && r.setPitch(t.B.number(a, h, s)), this._rolling && r.setRoll(t.B.number(n, u, s)), this._padding && (r.interpolatePadding(l, d, s), p = r.centerPoint.add(_)), f.easeFunc(s, g, v, p), this.terrain && !e.freezeElevation && this._updateElevation(s), this._applyUpdatedTransform(r), this._fireMoveEvents(i);
                }, ()=>{
                    this.terrain && e.freezeElevation && this._finalizeElevation(), this._afterEase(i);
                }, e), this;
            }
            isEasing() {
                return !!this._easeFrameId;
            }
            stop() {
                return this._stop();
            }
            _stop(e, t) {
                var i;
                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
                    const e = this._onEaseEnd;
                    delete this._onEaseEnd, e.call(this, t);
                }
                return e || null === (i = this.handlers) || void 0 === i || i.stop(!1), this;
            }
            _ease(e, t, i) {
                !1 === i.animate || 0 === i.duration ? (e(1), t()) : (this._easeStart = s.now(), this._easeOptions = i, this._onEaseFrame = e, this._onEaseEnd = t, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }
            _normalizeBearing(e, i) {
                e = t.aL(e, -180, 180);
                const r = Math.abs(e - i);
                return Math.abs(e - 360 - i) < r && (e -= 360), Math.abs(e + 360 - i) < r && (e += 360), e;
            }
            queryTerrainElevation(e) {
                return this.terrain ? this.terrain.getElevationForLngLatZoom(t.Q.convert(e), this.transform.tileZoom) : null;
            }
        }
        const ya = {
            compact: !0,
            customAttribution: '<a href="https://maplibre.org/" target="_blank">MapLibre</a>'
        };
        class wa {
            constructor(e = ya){
                this._toggleAttribution = ()=>{
                    this._container.classList.contains("maplibregl-compact") && (this._container.classList.contains("maplibregl-compact-show") ? (this._container.setAttribute("open", ""), this._container.classList.remove("maplibregl-compact-show")) : (this._container.classList.add("maplibregl-compact-show"), this._container.removeAttribute("open")));
                }, this._updateData = (e)=>{
                    !e || "metadata" !== e.sourceDataType && "visibility" !== e.sourceDataType && "style" !== e.dataType && "terrain" !== e.type || this._updateAttributions();
                }, this._updateCompact = ()=>{
                    this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 === this._compact ? this._container.setAttribute("open", "") : this._container.classList.contains("maplibregl-compact") || this._container.classList.contains("maplibregl-attrib-empty") || (this._container.setAttribute("open", ""), this._container.classList.add("maplibregl-compact", "maplibregl-compact-show")) : (this._container.setAttribute("open", ""), this._container.classList.contains("maplibregl-compact") && this._container.classList.remove("maplibregl-compact", "maplibregl-compact-show"));
                }, this._updateCompactMinimize = ()=>{
                    this._container.classList.contains("maplibregl-compact") && this._container.classList.contains("maplibregl-compact-show") && this._container.classList.remove("maplibregl-compact-show");
                }, this.options = e;
            }
            getDefaultPosition() {
                return "bottom-right";
            }
            onAdd(e) {
                return this._map = e, this._compact = this.options.compact, this._container = n.create("details", "maplibregl-ctrl maplibregl-ctrl-attrib"), this._compactButton = n.create("summary", "maplibregl-ctrl-attrib-button", this._container), this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = n.create("div", "maplibregl-ctrl-attrib-inner", this._container), this._updateAttributions(), this._updateCompact(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("terrain", this._updateData), this._map.on("resize", this._updateCompact), this._map.on("drag", this._updateCompactMinimize), this._container;
            }
            onRemove() {
                n.remove(this._container), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("terrain", this._updateData), this._map.off("resize", this._updateCompact), this._map.off("drag", this._updateCompactMinimize), this._map = void 0, this._compact = void 0, this._attribHTML = void 0;
            }
            _setElementTitle(e, t) {
                const i = this._map._getUIString(`AttributionControl.${t}`);
                e.title = i, e.setAttribute("aria-label", i);
            }
            _updateAttributions() {
                if (!this._map.style) return;
                let e = [];
                if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e = e.concat(this.options.customAttribution.map((e)=>"string" != typeof e ? "" : e)) : "string" == typeof this.options.customAttribution && e.push(this.options.customAttribution)), this._map.style.stylesheet) {
                    const e = this._map.style.stylesheet;
                    this.styleOwner = e.owner, this.styleId = e.id;
                }
                const t = this._map.style.sourceCaches;
                for(const i in t){
                    const r = t[i];
                    if (r.used || r.usedForTerrain) {
                        const t = r.getSource();
                        t.attribution && e.indexOf(t.attribution) < 0 && e.push(t.attribution);
                    }
                }
                e = e.filter((e)=>String(e).trim()), e.sort((e, t)=>e.length - t.length), e = e.filter((t, i)=>{
                    for(let r = i + 1; r < e.length; r++)if (e[r].indexOf(t) >= 0) return !1;
                    return !0;
                });
                const i = e.join(" | ");
                i !== this._attribHTML && (this._attribHTML = i, e.length ? (this._innerContainer.innerHTML = n.sanitize(i), this._container.classList.remove("maplibregl-attrib-empty")) : this._container.classList.add("maplibregl-attrib-empty"), this._updateCompact(), this._editLink = null);
            }
        }
        class Ta {
            constructor(e = {}){
                this._updateCompact = ()=>{
                    const e = this._container.children;
                    if (e.length) {
                        const t = e[0];
                        this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 !== this._compact && t.classList.add("maplibregl-compact") : t.classList.remove("maplibregl-compact");
                    }
                }, this.options = e;
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            onAdd(e) {
                this._map = e, this._compact = this.options && this.options.compact, this._container = n.create("div", "maplibregl-ctrl");
                const t = n.create("a", "maplibregl-ctrl-logo");
                return t.target = "_blank", t.rel = "noopener nofollow", t.href = "https://maplibre.org/", t.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), t.setAttribute("rel", "noopener nofollow"), this._container.appendChild(t), this._container.style.display = "block", this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
            }
            onRemove() {
                n.remove(this._container), this._map.off("resize", this._updateCompact), this._map = void 0, this._compact = void 0;
            }
        }
        class Pa {
            constructor(){
                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
            }
            add(e) {
                const t = ++this._id;
                return this._queue.push({
                    callback: e,
                    id: t,
                    cancelled: !1
                }), t;
            }
            remove(e) {
                const t = this._currentlyRunning, i = t ? this._queue.concat(t) : this._queue;
                for (const t of i)if (t.id === e) return void (t.cancelled = !0);
            }
            run(e = 0) {
                if (this._currentlyRunning) throw new Error("Attempting to run(), but is already running.");
                const t = this._currentlyRunning = this._queue;
                this._queue = [];
                for (const i of t)if (!i.cancelled && (i.callback(e), this._cleared)) break;
                this._cleared = !1, this._currentlyRunning = !1;
            }
            clear() {
                this._currentlyRunning && (this._cleared = !0), this._queue = [];
            }
        }
        var Ca = t.aD([
            {
                name: "a_pos3d",
                type: "Int16",
                components: 3
            }
        ]);
        class Ia extends t.E {
            constructor(e){
                super(), this._lastTilesetChange = s.now(), this.sourceCache = e, this._tiles = {}, this._renderableTilesKeys = [], this._sourceTileCache = {}, this.minzoom = 0, this.maxzoom = 22, this.deltaZoom = 1, this.tileSize = e._source.tileSize * 2 ** this.deltaZoom, e.usedForTerrain = !0, e.tileSize = this.tileSize;
            }
            destruct() {
                this.sourceCache.usedForTerrain = !1, this.sourceCache.tileSize = null;
            }
            update(e, i) {
                this.sourceCache.update(e, i), this._renderableTilesKeys = [];
                const r = {};
                for (const o of ue(e, {
                    tileSize: this.tileSize,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    reparseOverscaled: !1,
                    terrain: i,
                    calculateTileZoom: this.sourceCache._source.calculateTileZoom
                }))r[o.key] = !0, this._renderableTilesKeys.push(o.key), this._tiles[o.key] || (o.terrainRttPosMatrix32f = new Float64Array(16), t.bO(o.terrainRttPosMatrix32f, 0, t.Z, t.Z, 0, 0, 1), this._tiles[o.key] = new ae(o, this.tileSize), this._lastTilesetChange = s.now());
                for(const e in this._tiles)r[e] || delete this._tiles[e];
            }
            freeRtt(e) {
                for(const t in this._tiles){
                    const i = this._tiles[t];
                    (!e || i.tileID.equals(e) || i.tileID.isChildOf(e) || e.isChildOf(i.tileID)) && (i.rtt = []);
                }
            }
            getRenderableTiles() {
                return this._renderableTilesKeys.map((e)=>this.getTileByID(e));
            }
            getTileByID(e) {
                return this._tiles[e];
            }
            getTerrainCoords(e, t) {
                return t ? this._getTerrainCoordsForTileRanges(e, t) : this._getTerrainCoordsForRegularTile(e);
            }
            _getTerrainCoordsForRegularTile(e) {
                const i = {};
                for (const r of this._renderableTilesKeys){
                    const o = this._tiles[r].tileID, a = e.clone(), s = t.b2();
                    if (o.canonical.equals(e.canonical)) t.bO(s, 0, t.Z, t.Z, 0, 0, 1);
                    else if (o.canonical.isChildOf(e.canonical)) {
                        const i = o.canonical.z - e.canonical.z, r = o.canonical.x - (o.canonical.x >> i << i), a = o.canonical.y - (o.canonical.y >> i << i), n = t.Z >> i;
                        t.bO(s, 0, n, n, 0, 0, 1), t.L(s, s, [
                            -r * n,
                            -a * n,
                            0
                        ]);
                    } else {
                        if (!e.canonical.isChildOf(o.canonical)) continue;
                        {
                            const i = e.canonical.z - o.canonical.z, r = e.canonical.x - (e.canonical.x >> i << i), a = e.canonical.y - (e.canonical.y >> i << i), n = t.Z >> i;
                            t.bO(s, 0, t.Z, t.Z, 0, 0, 1), t.L(s, s, [
                                r * n,
                                a * n,
                                0
                            ]), t.M(s, s, [
                                1 / 2 ** i,
                                1 / 2 ** i,
                                0
                            ]);
                        }
                    }
                    a.terrainRttPosMatrix32f = new Float32Array(s), i[r] = a;
                }
                return i;
            }
            _getTerrainCoordsForTileRanges(e, i) {
                const r = {};
                for (const o of this._renderableTilesKeys){
                    const a = this._tiles[o].tileID;
                    if (!this._isWithinTileRanges(a, i)) continue;
                    const s = e.clone(), n = t.b2();
                    if (a.canonical.z === e.canonical.z) {
                        const i = e.canonical.x - a.canonical.x, r = e.canonical.y - a.canonical.y;
                        t.bO(n, 0, t.Z, t.Z, 0, 0, 1), t.L(n, n, [
                            i * t.Z,
                            r * t.Z,
                            0
                        ]);
                    } else if (a.canonical.z > e.canonical.z) {
                        const i = a.canonical.z - e.canonical.z, r = a.canonical.x - (a.canonical.x >> i << i), o = a.canonical.y - (a.canonical.y >> i << i), s = e.canonical.x - (a.canonical.x >> i), l = e.canonical.y - (a.canonical.y >> i), c = t.Z >> i;
                        t.bO(n, 0, c, c, 0, 0, 1), t.L(n, n, [
                            -r * c + s * t.Z,
                            -o * c + l * t.Z,
                            0
                        ]);
                    } else {
                        const i = e.canonical.z - a.canonical.z, r = e.canonical.x - (e.canonical.x >> i << i), o = e.canonical.y - (e.canonical.y >> i << i), s = (e.canonical.x >> i) - a.canonical.x, l = (e.canonical.y >> i) - a.canonical.y, c = t.Z << i;
                        t.bO(n, 0, c, c, 0, 0, 1), t.L(n, n, [
                            r * t.Z + s * c,
                            o * t.Z + l * c,
                            0
                        ]);
                    }
                    s.terrainRttPosMatrix32f = new Float32Array(n), r[o] = s;
                }
                return r;
            }
            getSourceTile(e, t) {
                const i = this.sourceCache._source;
                let r = e.overscaledZ - this.deltaZoom;
                if (r > i.maxzoom && (r = i.maxzoom), r < i.minzoom) return null;
                this._sourceTileCache[e.key] || (this._sourceTileCache[e.key] = e.scaledTo(r).key);
                let o = this.sourceCache.getTileByID(this._sourceTileCache[e.key]);
                if ((!o || !o.dem) && t) for(; r >= i.minzoom && (!o || !o.dem);)o = this.sourceCache.getTileByID(e.scaledTo(r--).key);
                return o;
            }
            anyTilesAfterTime(e = Date.now()) {
                return this._lastTilesetChange >= e;
            }
            _isWithinTileRanges(e, t) {
                return t[e.canonical.z] && e.canonical.x >= t[e.canonical.z].minTileX && e.canonical.x <= t[e.canonical.z].maxTileX && e.canonical.y >= t[e.canonical.z].minTileY && e.canonical.y <= t[e.canonical.z].maxTileY;
            }
        }
        class Ma {
            constructor(e, t, i){
                this._meshCache = {}, this.painter = e, this.sourceCache = new Ia(t), this.options = i, this.exaggeration = "number" == typeof i.exaggeration ? i.exaggeration : 1, this.qualityFactor = 2, this.meshSize = 128, this._demMatrixCache = {}, this.coordsIndex = [], this._coordsTextureSize = 1024;
            }
            getDEMElevation(e, i, r, o = t.Z) {
                var a;
                if (!(i >= 0 && i < o && r >= 0 && r < o)) return 0;
                const s = this.getTerrainData(e), n = null === (a = s.tile) || void 0 === a ? void 0 : a.dem;
                if (!n) return 0;
                const l = t.cf([], [
                    i / o * t.Z,
                    r / o * t.Z
                ], s.u_terrain_matrix), c = [
                    l[0] * n.dim,
                    l[1] * n.dim
                ], h = Math.floor(c[0]), u = Math.floor(c[1]), d = c[0] - h, _ = c[1] - u;
                return n.get(h, u) * (1 - d) * (1 - _) + n.get(h + 1, u) * d * (1 - _) + n.get(h, u + 1) * (1 - d) * _ + n.get(h + 1, u + 1) * d * _;
            }
            getElevationForLngLatZoom(e, i) {
                if (!t.cg(i, e.wrap())) return 0;
                const { tileID: r, mercatorX: o, mercatorY: a } = this._getOverscaledTileIDFromLngLatZoom(e, i);
                return this.getElevation(r, o % t.Z, a % t.Z, t.Z);
            }
            getElevation(e, i, r, o = t.Z) {
                return this.getDEMElevation(e, i, r, o) * this.exaggeration;
            }
            getTerrainData(e) {
                if (!this._emptyDemTexture) {
                    const e = this.painter.context, i = new t.R({
                        width: 1,
                        height: 1
                    }, new Uint8Array(4));
                    this._emptyDepthTexture = new v(e, i, e.gl.RGBA, {
                        premultiply: !1
                    }), this._emptyDemUnpack = [
                        0,
                        0,
                        0,
                        0
                    ], this._emptyDemTexture = new v(e, new t.R({
                        width: 1,
                        height: 1
                    }), e.gl.RGBA, {
                        premultiply: !1
                    }), this._emptyDemTexture.bind(e.gl.NEAREST, e.gl.CLAMP_TO_EDGE), this._emptyDemMatrix = t.at([]);
                }
                const i = this.sourceCache.getSourceTile(e, !0);
                if (i && i.dem && (!i.demTexture || i.needsTerrainPrepare)) {
                    const e = this.painter.context;
                    i.demTexture = this.painter.getTileTexture(i.dem.stride), i.demTexture ? i.demTexture.update(i.dem.getPixels(), {
                        premultiply: !1
                    }) : i.demTexture = new v(e, i.dem.getPixels(), e.gl.RGBA, {
                        premultiply: !1
                    }), i.demTexture.bind(e.gl.NEAREST, e.gl.CLAMP_TO_EDGE), i.needsTerrainPrepare = !1;
                }
                const r = i && i + i.tileID.key + e.key;
                if (r && !this._demMatrixCache[r]) {
                    const r = this.sourceCache.sourceCache._source.maxzoom;
                    let o = e.canonical.z - i.tileID.canonical.z;
                    e.overscaledZ > e.canonical.z && (e.canonical.z >= r ? o = e.canonical.z - r : t.w("cannot calculate elevation if elevation maxzoom > source.maxzoom"));
                    const a = e.canonical.x - (e.canonical.x >> o << o), s = e.canonical.y - (e.canonical.y >> o << o), n = t.ch(new Float64Array(16), [
                        1 / (t.Z << o),
                        1 / (t.Z << o),
                        0
                    ]);
                    t.L(n, n, [
                        a * t.Z,
                        s * t.Z,
                        0
                    ]), this._demMatrixCache[e.key] = {
                        matrix: n,
                        coord: e
                    };
                }
                return {
                    u_depth: 2,
                    u_terrain: 3,
                    u_terrain_dim: i && i.dem && i.dem.dim || 1,
                    u_terrain_matrix: r ? this._demMatrixCache[e.key].matrix : this._emptyDemMatrix,
                    u_terrain_unpack: i && i.dem && i.dem.getUnpackVector() || this._emptyDemUnpack,
                    u_terrain_exaggeration: this.exaggeration,
                    texture: (i && i.demTexture || this._emptyDemTexture).texture,
                    depthTexture: (this._fboDepthTexture || this._emptyDepthTexture).texture,
                    tile: i
                };
            }
            getFramebuffer(e) {
                const t = this.painter, i = t.width / devicePixelRatio, r = t.height / devicePixelRatio;
                return !this._fbo || this._fbo.width === i && this._fbo.height === r || (this._fbo.destroy(), this._fboCoordsTexture.destroy(), this._fboDepthTexture.destroy(), delete this._fbo, delete this._fboDepthTexture, delete this._fboCoordsTexture), this._fboCoordsTexture || (this._fboCoordsTexture = new v(t.context, {
                    width: i,
                    height: r,
                    data: null
                }, t.context.gl.RGBA, {
                    premultiply: !1
                }), this._fboCoordsTexture.bind(t.context.gl.NEAREST, t.context.gl.CLAMP_TO_EDGE)), this._fboDepthTexture || (this._fboDepthTexture = new v(t.context, {
                    width: i,
                    height: r,
                    data: null
                }, t.context.gl.RGBA, {
                    premultiply: !1
                }), this._fboDepthTexture.bind(t.context.gl.NEAREST, t.context.gl.CLAMP_TO_EDGE)), this._fbo || (this._fbo = t.context.createFramebuffer(i, r, !0, !1), this._fbo.depthAttachment.set(t.context.createRenderbuffer(t.context.gl.DEPTH_COMPONENT16, i, r))), this._fbo.colorAttachment.set("coords" === e ? this._fboCoordsTexture.texture : this._fboDepthTexture.texture), this._fbo;
            }
            getCoordsTexture() {
                const e = this.painter.context;
                if (this._coordsTexture) return this._coordsTexture;
                const i = new Uint8Array(this._coordsTextureSize * this._coordsTextureSize * 4);
                for(let e = 0, t = 0; e < this._coordsTextureSize; e++)for(let r = 0; r < this._coordsTextureSize; r++, t += 4)i[t + 0] = 255 & r, i[t + 1] = 255 & e, i[t + 2] = r >> 8 << 4 | e >> 8, i[t + 3] = 0;
                const r = new t.R({
                    width: this._coordsTextureSize,
                    height: this._coordsTextureSize
                }, new Uint8Array(i.buffer)), o = new v(e, r, e.gl.RGBA, {
                    premultiply: !1
                });
                return o.bind(e.gl.NEAREST, e.gl.CLAMP_TO_EDGE), this._coordsTexture = o, o;
            }
            pointCoordinate(e) {
                this.painter.maybeDrawDepthAndCoords(!0);
                const i = new Uint8Array(4), r = this.painter.context, o = r.gl, a = Math.round(e.x * this.painter.pixelRatio / devicePixelRatio), s = Math.round(e.y * this.painter.pixelRatio / devicePixelRatio), n = Math.round(this.painter.height / devicePixelRatio);
                r.bindFramebuffer.set(this.getFramebuffer("coords").framebuffer), o.readPixels(a, n - s - 1, 1, 1, o.RGBA, o.UNSIGNED_BYTE, i), r.bindFramebuffer.set(null);
                const l = i[0] + (i[2] >> 4 << 8), c = i[1] + ((15 & i[2]) << 8), h = this.coordsIndex[255 - i[3]], u = h && this.sourceCache.getTileByID(h);
                if (!u) return null;
                const d = this._coordsTextureSize, _ = (1 << u.tileID.canonical.z) * d;
                return new t.$((u.tileID.canonical.x * d + l) / _ + u.tileID.wrap, (u.tileID.canonical.y * d + c) / _, this.getElevation(u.tileID, l, c, d));
            }
            depthAtPoint(e) {
                const t = new Uint8Array(4), i = this.painter.context, r = i.gl;
                return i.bindFramebuffer.set(this.getFramebuffer("depth").framebuffer), r.readPixels(e.x, this.painter.height / devicePixelRatio - e.y - 1, 1, 1, r.RGBA, r.UNSIGNED_BYTE, t), i.bindFramebuffer.set(null), (t[0] / 16777216 + t[1] / 65536 + t[2] / 256 + t[3]) / 256;
            }
            getTerrainMesh(e) {
                var i;
                const r = (null === (i = this.painter.style.projection) || void 0 === i ? void 0 : i.transitionState) > 0, o = r && 0 === e.canonical.y, a = r && e.canonical.y === (1 << e.canonical.z) - 1, s = `m_${o ? "n" : ""}_${a ? "s" : ""}`;
                if (this._meshCache[s]) return this._meshCache[s];
                const n = this.painter.context, l = new t.ci, c = new t.aH, h = this.meshSize, u = t.Z / h, d = h * h;
                for(let e = 0; e <= h; e++)for(let t = 0; t <= h; t++)l.emplaceBack(t * u, e * u, 0);
                for(let e = 0; e < d; e += h + 1)for(let t = 0; t < h; t++)c.emplaceBack(t + e, h + t + e + 1, h + t + e + 2), c.emplaceBack(t + e, h + t + e + 2, t + e + 1);
                const _ = l.length, p = _ + (h + 1), m = (h + 1) * h, f = o ? t.b9 : 0, g = o ? 0 : 1, v = a ? t.ba : t.Z, x = a ? 0 : 1;
                for(let e = 0; e <= h; e++)l.emplaceBack(e * u, f, g);
                for(let e = 0; e <= h; e++)l.emplaceBack(e * u, v, x);
                for(let e = 0; e < h; e++)c.emplaceBack(m + e, p + e, p + e + 1), c.emplaceBack(m + e, p + e + 1, m + e + 1), c.emplaceBack(0 + e, _ + e + 1, _ + e), c.emplaceBack(0 + e, 0 + e + 1, _ + e + 1);
                const b = l.length, y = b + 2 * (h + 1);
                for (const e of [
                    0,
                    1
                ])for(let i = 0; i <= h; i++)for (const r of [
                    0,
                    1
                ])l.emplaceBack(e * t.Z, i * u, r);
                for(let e = 0; e < 2 * h; e += 2)c.emplaceBack(b + e, b + e + 1, b + e + 3), c.emplaceBack(b + e, b + e + 3, b + e + 2), c.emplaceBack(y + e, y + e + 3, y + e + 1), c.emplaceBack(y + e, y + e + 2, y + e + 3);
                const w = new pt(n.createVertexBuffer(l, Ca.members), n.createIndexBuffer(c), t.aG.simpleSegment(0, 0, l.length, c.length));
                return this._meshCache[s] = w, w;
            }
            getMeshFrameDelta(e) {
                return 2 * Math.PI * t.br / Math.pow(2, Math.max(e, 0)) / 5;
            }
            getMinTileElevationForLngLatZoom(e, t) {
                var i;
                const { tileID: r } = this._getOverscaledTileIDFromLngLatZoom(e, t);
                return null !== (i = this.getMinMaxElevation(r).minElevation) && void 0 !== i ? i : 0;
            }
            getMinMaxElevation(e) {
                const t = this.getTerrainData(e).tile, i = {
                    minElevation: null,
                    maxElevation: null
                };
                return t && t.dem && (i.minElevation = t.dem.min * this.exaggeration, i.maxElevation = t.dem.max * this.exaggeration), i;
            }
            _getOverscaledTileIDFromLngLatZoom(e, i) {
                const r = t.$.fromLngLat(e.wrap()), o = (1 << i) * t.Z, a = r.x * o, s = r.y * o, n = Math.floor(a / t.Z), l = Math.floor(s / t.Z);
                return {
                    tileID: new t.Y(i, 0, i, n, l),
                    mercatorX: a,
                    mercatorY: s
                };
            }
        }
        class Ea {
            constructor(e, t, i){
                this._context = e, this._size = t, this._tileSize = i, this._objects = [], this._recentlyUsed = [], this._stamp = 0;
            }
            destruct() {
                for (const e of this._objects)e.texture.destroy(), e.fbo.destroy();
            }
            _createObject(e) {
                const t = this._context.createFramebuffer(this._tileSize, this._tileSize, !0, !0), i = new v(this._context, {
                    width: this._tileSize,
                    height: this._tileSize,
                    data: null
                }, this._context.gl.RGBA);
                return i.bind(this._context.gl.LINEAR, this._context.gl.CLAMP_TO_EDGE), this._context.extTextureFilterAnisotropic && this._context.gl.texParameterf(this._context.gl.TEXTURE_2D, this._context.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, this._context.extTextureFilterAnisotropicMax), t.depthAttachment.set(this._context.createRenderbuffer(this._context.gl.DEPTH_STENCIL, this._tileSize, this._tileSize)), t.colorAttachment.set(i.texture), {
                    id: e,
                    fbo: t,
                    texture: i,
                    stamp: -1,
                    inUse: !1
                };
            }
            getObjectForId(e) {
                return this._objects[e];
            }
            useObject(e) {
                e.inUse = !0, this._recentlyUsed = this._recentlyUsed.filter((t)=>e.id !== t), this._recentlyUsed.push(e.id);
            }
            stampObject(e) {
                e.stamp = ++this._stamp;
            }
            getOrCreateFreeObject() {
                for (const e of this._recentlyUsed)if (!this._objects[e].inUse) return this._objects[e];
                if (this._objects.length >= this._size) throw new Error("No free RenderPool available, call freeAllObjects() required!");
                const e = this._createObject(this._objects.length);
                return this._objects.push(e), e;
            }
            freeObject(e) {
                e.inUse = !1;
            }
            freeAllObjects() {
                for (const e of this._objects)this.freeObject(e);
            }
            isFull() {
                return !(this._objects.length < this._size) && !1 === this._objects.some((e)=>!e.inUse);
            }
        }
        const Sa = {
            background: !0,
            fill: !0,
            line: !0,
            raster: !0,
            hillshade: !0
        };
        class Ra {
            constructor(e, t){
                this.painter = e, this.terrain = t, this.pool = new Ea(e.context, 30, t.sourceCache.tileSize * t.qualityFactor);
            }
            destruct() {
                this.pool.destruct();
            }
            getTexture(e) {
                return this.pool.getObjectForId(e.rtt[this._stacks.length - 1].id).texture;
            }
            prepareForRender(e, t) {
                this._stacks = [], this._prevType = null, this._rttTiles = [], this._renderableTiles = this.terrain.sourceCache.getRenderableTiles(), this._renderableLayerIds = e._order.filter((i)=>!e._layers[i].isHidden(t)), this._coordsAscending = {};
                for(const t in e.sourceCaches){
                    this._coordsAscending[t] = {};
                    const i = e.sourceCaches[t].getVisibleCoordinates(), r = e.sourceCaches[t].getSource(), o = r instanceof X ? r.terrainTileRanges : null;
                    for (const e of i){
                        const i = this.terrain.sourceCache.getTerrainCoords(e, o);
                        for(const e in i)this._coordsAscending[t][e] || (this._coordsAscending[t][e] = []), this._coordsAscending[t][e].push(i[e]);
                    }
                }
                this._coordsAscendingStr = {};
                for (const t of e._order){
                    const i = e._layers[t], r = i.source;
                    if (Sa[i.type] && !this._coordsAscendingStr[r]) {
                        this._coordsAscendingStr[r] = {};
                        for(const e in this._coordsAscending[r])this._coordsAscendingStr[r][e] = this._coordsAscending[r][e].map((e)=>e.key).sort().join();
                    }
                }
                for (const e of this._renderableTiles)for(const t in this._coordsAscendingStr){
                    const i = this._coordsAscendingStr[t][e.tileID.key];
                    i && i !== e.rttCoords[t] && (e.rtt = []);
                }
            }
            renderLayer(e, i) {
                if (e.isHidden(this.painter.transform.zoom)) return !1;
                const r = Object.assign(Object.assign({}, i), {
                    isRenderingToTexture: !0
                }), o = e.type, a = this.painter, s = this._renderableLayerIds[this._renderableLayerIds.length - 1] === e.id;
                if (Sa[o] && (this._prevType && Sa[this._prevType] || this._stacks.push([]), this._prevType = o, this._stacks[this._stacks.length - 1].push(e.id), !s)) return !0;
                if (Sa[this._prevType] || Sa[o] && s) {
                    this._prevType = o;
                    const e = this._stacks.length - 1, i = this._stacks[e] || [];
                    for (const o of this._renderableTiles){
                        if (this.pool.isFull() && (vo(this.painter, this.terrain, this._rttTiles, r), this._rttTiles = [], this.pool.freeAllObjects()), this._rttTiles.push(o), o.rtt[e]) {
                            const t = this.pool.getObjectForId(o.rtt[e].id);
                            if (t.stamp === o.rtt[e].stamp) {
                                this.pool.useObject(t);
                                continue;
                            }
                        }
                        const s = this.pool.getOrCreateFreeObject();
                        this.pool.useObject(s), this.pool.stampObject(s), o.rtt[e] = {
                            id: s.id,
                            stamp: s.stamp
                        }, a.context.bindFramebuffer.set(s.fbo.framebuffer), a.context.clear({
                            color: t.b7.transparent,
                            stencil: 0
                        }), a.currentStencilSource = void 0;
                        for(let e = 0; e < i.length; e++){
                            const t = a.style._layers[i[e]], n = t.source ? this._coordsAscending[t.source][o.tileID.key] : [
                                o.tileID
                            ];
                            a.context.viewport.set([
                                0,
                                0,
                                s.fbo.width,
                                s.fbo.height
                            ]), a._renderTileClippingMasks(t, n, !0), a.renderLayer(a, a.style.sourceCaches[t.source], t, n, r), t.source && (o.rttCoords[t.source] = this._coordsAscendingStr[t.source][o.tileID.key]);
                        }
                    }
                    return vo(this.painter, this.terrain, this._rttTiles, r), this._rttTiles = [], this.pool.freeAllObjects(), Sa[o];
                }
                return !1;
            }
        }
        const Da = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "AttributionControl.MapFeedback": "Map feedback",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "MapLibre logo",
            "Map.Title": "Map",
            "Marker.Title": "Map marker",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "Popup.Close": "Close popup",
            "ScaleControl.Feet": "ft",
            "ScaleControl.Meters": "m",
            "ScaleControl.Kilometers": "km",
            "ScaleControl.Miles": "mi",
            "ScaleControl.NauticalMiles": "nm",
            "GlobeControl.Enable": "Enable globe",
            "GlobeControl.Disable": "Disable globe",
            "TerrainControl.Enable": "Enable terrain",
            "TerrainControl.Disable": "Disable terrain",
            "CooperativeGesturesHandler.WindowsHelpText": "Use Ctrl + scroll to zoom the map",
            "CooperativeGesturesHandler.MacHelpText": "Use \u2318 + scroll to zoom the map",
            "CooperativeGesturesHandler.MobileHelpText": "Use two fingers to move the map"
        }, za = i, Aa = {
            hash: !1,
            interactive: !0,
            bearingSnap: 7,
            attributionControl: ya,
            maplibreLogo: !1,
            refreshExpiredTiles: !0,
            canvasContextAttributes: {
                antialias: !1,
                preserveDrawingBuffer: !1,
                powerPreference: "high-performance",
                failIfMajorPerformanceCaveat: !1,
                desynchronized: !1,
                contextType: void 0
            },
            scrollZoom: !0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 60,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            cooperativeGestures: !1,
            trackResize: !0,
            center: [
                0,
                0
            ],
            elevation: 0,
            zoom: 0,
            bearing: 0,
            pitch: 0,
            roll: 0,
            renderWorldCopies: !0,
            maxTileCacheSize: null,
            maxTileCacheZoomLevels: t.a.MAX_TILE_CACHE_ZOOM_LEVELS,
            transformRequest: null,
            transformCameraUpdate: null,
            fadeDuration: 300,
            crossSourceCollisions: !0,
            clickTolerance: 3,
            localIdeographFontFamily: "sans-serif",
            pitchWithRotate: !0,
            rollEnabled: !1,
            validateStyle: !0,
            maxCanvasSize: [
                4096,
                4096
            ],
            cancelPendingTileRequestsWhileZooming: !0,
            centerClampedToGround: !0
        }, La = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1,
            visualizeRoll: !0
        };
        class ka {
            constructor(e, i, r = !1){
                this.mousedown = (e)=>{
                    this.startMove(e, n.mousePos(this.element, e)), n.addEventListener(window, "mousemove", this.mousemove), n.addEventListener(window, "mouseup", this.mouseup);
                }, this.mousemove = (e)=>{
                    this.move(e, n.mousePos(this.element, e));
                }, this.mouseup = (e)=>{
                    this._rotatePitchHanlder.dragEnd(e), this.offTemp();
                }, this.touchstart = (e)=>{
                    1 !== e.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = n.touchPos(this.element, e.targetTouches)[0], this.startMove(e, this._startPos), n.addEventListener(window, "touchmove", this.touchmove, {
                        passive: !1
                    }), n.addEventListener(window, "touchend", this.touchend));
                }, this.touchmove = (e)=>{
                    1 !== e.targetTouches.length ? this.reset() : (this._lastPos = n.touchPos(this.element, e.targetTouches)[0], this.move(e, this._lastPos));
                }, this.touchend = (e)=>{
                    0 === e.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), delete this._startPos, delete this._lastPos, this.offTemp();
                }, this.reset = ()=>{
                    this._rotatePitchHanlder.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
                }, this._clickTolerance = 10, this.element = i;
                const o = new $o;
                this._rotatePitchHanlder = new Uo({
                    clickTolerance: 3,
                    move: (e, o)=>{
                        const a = i.getBoundingClientRect(), s = new t.P((a.bottom - a.top) / 2, (a.right - a.left) / 2);
                        return {
                            bearingDelta: t.ca(new t.P(e.x, o.y), o, s),
                            pitchDelta: r ? -0.5 * (o.y - e.y) : void 0
                        };
                    },
                    moveStateManager: o,
                    enable: !0,
                    assignEvents: ()=>{}
                }), this.map = e, n.addEventListener(i, "mousedown", this.mousedown), n.addEventListener(i, "touchstart", this.touchstart, {
                    passive: !1
                }), n.addEventListener(i, "touchcancel", this.reset);
            }
            startMove(e, t) {
                this._rotatePitchHanlder.dragStart(e, t), n.disableDrag();
            }
            move(e, t) {
                const i = this.map, { bearingDelta: r, pitchDelta: o } = this._rotatePitchHanlder.dragMove(e, t) || {};
                r && i.setBearing(i.getBearing() + r), o && i.setPitch(i.getPitch() + o);
            }
            off() {
                const e = this.element;
                n.removeEventListener(e, "mousedown", this.mousedown), n.removeEventListener(e, "touchstart", this.touchstart, {
                    passive: !1
                }), n.removeEventListener(window, "touchmove", this.touchmove, {
                    passive: !1
                }), n.removeEventListener(window, "touchend", this.touchend), n.removeEventListener(e, "touchcancel", this.reset), this.offTemp();
            }
            offTemp() {
                n.enableDrag(), n.removeEventListener(window, "mousemove", this.mousemove), n.removeEventListener(window, "mouseup", this.mouseup), n.removeEventListener(window, "touchmove", this.touchmove, {
                    passive: !1
                }), n.removeEventListener(window, "touchend", this.touchend);
            }
        }
        let Fa;
        function Ba(e, i, r) {
            const o = new t.Q(e.lng, e.lat);
            if (e = new t.Q(e.lng, e.lat), i) {
                const o = new t.Q(e.lng - 360, e.lat), a = new t.Q(e.lng + 360, e.lat), s = r.locationToScreenPoint(e).distSqr(i);
                r.locationToScreenPoint(o).distSqr(i) < s ? e = o : r.locationToScreenPoint(a).distSqr(i) < s && (e = a);
            }
            for(; Math.abs(e.lng - r.center.lng) > 180;){
                const t = r.locationToScreenPoint(e);
                if (t.x >= 0 && t.y >= 0 && t.x <= r.width && t.y <= r.height) break;
                e.lng > r.center.lng ? e.lng -= 360 : e.lng += 360;
            }
            return e.lng !== o.lng && r.isPointOnMapSurface(r.locationToScreenPoint(e)) ? e : o;
        }
        const Oa = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        };
        function ja(e, t, i) {
            const r = e.classList;
            for(const e in Oa)r.remove(`maplibregl-${i}-anchor-${e}`);
            r.add(`maplibregl-${i}-anchor-${t}`);
        }
        class Za extends t.E {
            constructor(e){
                if (super(), this._onKeyPress = (e)=>{
                    const t = e.code, i = e.charCode || e.keyCode;
                    "Space" !== t && "Enter" !== t && 32 !== i && 13 !== i || this.togglePopup();
                }, this._onMapClick = (e)=>{
                    const t = e.originalEvent.target, i = this._element;
                    this._popup && (t === i || i.contains(t)) && this.togglePopup();
                }, this._update = (e)=>{
                    var t;
                    if (!this._map) return;
                    const i = this._map.loaded() && !this._map.isMoving();
                    ("terrain" === (null == e ? void 0 : e.type) || "render" === (null == e ? void 0 : e.type) && !i) && this._map.once("render", this._update), this._lngLat = this._map.transform.renderWorldCopies ? Ba(this._lngLat, this._flatPos, this._map.transform) : null === (t = this._lngLat) || void 0 === t ? void 0 : t.wrap(), this._flatPos = this._pos = this._map.project(this._lngLat)._add(this._offset), this._map.terrain && (this._flatPos = this._map.transform.locationToScreenPoint(this._lngLat)._add(this._offset));
                    let r = "";
                    "viewport" === this._rotationAlignment || "auto" === this._rotationAlignment ? r = `rotateZ(${this._rotation}deg)` : "map" === this._rotationAlignment && (r = `rotateZ(${this._rotation - this._map.getBearing()}deg)`);
                    let o = "";
                    "viewport" === this._pitchAlignment || "auto" === this._pitchAlignment ? o = "rotateX(0deg)" : "map" === this._pitchAlignment && (o = `rotateX(${this._map.getPitch()}deg)`), this._subpixelPositioning || e && "moveend" !== e.type || (this._pos = this._pos.round()), n.setTransform(this._element, `${Oa[this._anchor]} translate(${this._pos.x}px, ${this._pos.y}px) ${o} ${r}`), s.frameAsync(new AbortController).then(()=>{
                        this._updateOpacity(e && "moveend" === e.type);
                    }).catch(()=>{});
                }, this._onMove = (e)=>{
                    if (!this._isDragging) {
                        const t = this._clickTolerance || this._map._clickTolerance;
                        this._isDragging = e.point.dist(this._pointerdownPos) >= t;
                    }
                    this._isDragging && (this._pos = e.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new t.l("dragstart"))), this.fire(new t.l("drag")));
                }, this._onUp = ()=>{
                    this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), "active" === this._state && this.fire(new t.l("dragend")), this._state = "inactive";
                }, this._addDragHandler = (e)=>{
                    this._element.contains(e.originalEvent.target) && (e.preventDefault(), this._positionDelta = e.point.sub(this._pos).add(this._offset), this._pointerdownPos = e.point, this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
                }, this._anchor = e && e.anchor || "center", this._color = e && e.color || "#3FB1CE", this._scale = e && e.scale || 1, this._draggable = e && e.draggable || !1, this._clickTolerance = e && e.clickTolerance || 0, this._subpixelPositioning = e && e.subpixelPositioning || !1, this._isDragging = !1, this._state = "inactive", this._rotation = e && e.rotation || 0, this._rotationAlignment = e && e.rotationAlignment || "auto", this._pitchAlignment = e && e.pitchAlignment && "auto" !== e.pitchAlignment ? e.pitchAlignment : this._rotationAlignment, this.setOpacity(null == e ? void 0 : e.opacity, null == e ? void 0 : e.opacityWhenCovered), e && e.element) this._element = e.element, this._offset = t.P.convert(e && e.offset || [
                    0,
                    0
                ]);
                else {
                    this._defaultMarker = !0, this._element = n.create("div");
                    const i = n.createNS("http://www.w3.org/2000/svg", "svg"), r = 41, o = 27;
                    i.setAttributeNS(null, "display", "block"), i.setAttributeNS(null, "height", `${r}px`), i.setAttributeNS(null, "width", `${o}px`), i.setAttributeNS(null, "viewBox", `0 0 ${o} ${r}`);
                    const a = n.createNS("http://www.w3.org/2000/svg", "g");
                    a.setAttributeNS(null, "stroke", "none"), a.setAttributeNS(null, "stroke-width", "1"), a.setAttributeNS(null, "fill", "none"), a.setAttributeNS(null, "fill-rule", "evenodd");
                    const s = n.createNS("http://www.w3.org/2000/svg", "g");
                    s.setAttributeNS(null, "fill-rule", "nonzero");
                    const l = n.createNS("http://www.w3.org/2000/svg", "g");
                    l.setAttributeNS(null, "transform", "translate(3.0, 29.0)"), l.setAttributeNS(null, "fill", "#000000");
                    const c = [
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "9.5",
                            ry: "4.77275007"
                        },
                        {
                            rx: "8.5",
                            ry: "4.29549936"
                        },
                        {
                            rx: "7.5",
                            ry: "3.81822308"
                        },
                        {
                            rx: "6.5",
                            ry: "3.34094679"
                        },
                        {
                            rx: "5.5",
                            ry: "2.86367051"
                        },
                        {
                            rx: "4.5",
                            ry: "2.38636864"
                        }
                    ];
                    for (const e of c){
                        const t = n.createNS("http://www.w3.org/2000/svg", "ellipse");
                        t.setAttributeNS(null, "opacity", "0.04"), t.setAttributeNS(null, "cx", "10.5"), t.setAttributeNS(null, "cy", "5.80029008"), t.setAttributeNS(null, "rx", e.rx), t.setAttributeNS(null, "ry", e.ry), l.appendChild(t);
                    }
                    const h = n.createNS("http://www.w3.org/2000/svg", "g");
                    h.setAttributeNS(null, "fill", this._color);
                    const u = n.createNS("http://www.w3.org/2000/svg", "path");
                    u.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"), h.appendChild(u);
                    const d = n.createNS("http://www.w3.org/2000/svg", "g");
                    d.setAttributeNS(null, "opacity", "0.25"), d.setAttributeNS(null, "fill", "#000000");
                    const _ = n.createNS("http://www.w3.org/2000/svg", "path");
                    _.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"), d.appendChild(_);
                    const p = n.createNS("http://www.w3.org/2000/svg", "g");
                    p.setAttributeNS(null, "transform", "translate(6.0, 7.0)"), p.setAttributeNS(null, "fill", "#FFFFFF");
                    const m = n.createNS("http://www.w3.org/2000/svg", "g");
                    m.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
                    const f = n.createNS("http://www.w3.org/2000/svg", "circle");
                    f.setAttributeNS(null, "fill", "#000000"), f.setAttributeNS(null, "opacity", "0.25"), f.setAttributeNS(null, "cx", "5.5"), f.setAttributeNS(null, "cy", "5.5"), f.setAttributeNS(null, "r", "5.4999962");
                    const g = n.createNS("http://www.w3.org/2000/svg", "circle");
                    g.setAttributeNS(null, "fill", "#FFFFFF"), g.setAttributeNS(null, "cx", "5.5"), g.setAttributeNS(null, "cy", "5.5"), g.setAttributeNS(null, "r", "5.4999962"), m.appendChild(f), m.appendChild(g), s.appendChild(l), s.appendChild(h), s.appendChild(d), s.appendChild(p), s.appendChild(m), i.appendChild(s), i.setAttributeNS(null, "height", r * this._scale + "px"), i.setAttributeNS(null, "width", o * this._scale + "px"), this._element.appendChild(i), this._offset = t.P.convert(e && e.offset || [
                        0,
                        -14
                    ]);
                }
                if (this._element.classList.add("maplibregl-marker"), this._element.addEventListener("dragstart", (e)=>{
                    e.preventDefault();
                }), this._element.addEventListener("mousedown", (e)=>{
                    e.preventDefault();
                }), ja(this._element, this._anchor, "marker"), e && e.className) for (const t of e.className.split(" "))this._element.classList.add(t);
                this._popup = null;
            }
            addTo(e) {
                return this.remove(), this._map = e, this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", e._getUIString("Marker.Title")), e.getCanvasContainer().appendChild(this._element), e.on("move", this._update), e.on("moveend", this._update), e.on("terrain", this._update), e.on("projectiontransition", this._update), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
            }
            remove() {
                return this._opacityTimeout && (clearTimeout(this._opacityTimeout), delete this._opacityTimeout), this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("terrain", this._update), this._map.off("projectiontransition", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), n.remove(this._element), this._popup && this._popup.remove(), this;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(e) {
                return this._lngLat = t.Q.convert(e), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
            }
            getElement() {
                return this._element;
            }
            setPopup(e) {
                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), e) {
                    if (!("offset" in e.options)) {
                        const t = 38.1, i = 13.5, r = Math.abs(i) / Math.SQRT2;
                        e.options.offset = this._defaultMarker ? {
                            top: [
                                0,
                                0
                            ],
                            "top-left": [
                                0,
                                0
                            ],
                            "top-right": [
                                0,
                                0
                            ],
                            bottom: [
                                0,
                                -38.1
                            ],
                            "bottom-left": [
                                r,
                                -1 * (t - i + r)
                            ],
                            "bottom-right": [
                                -r,
                                -1 * (t - i + r)
                            ],
                            left: [
                                i,
                                -1 * (t - i)
                            ],
                            right: [
                                -13.5,
                                -1 * (t - i)
                            ]
                        } : this._offset;
                    }
                    this._popup = e, this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress);
                }
                return this;
            }
            setSubpixelPositioning(e) {
                return this._subpixelPositioning = e, this;
            }
            getPopup() {
                return this._popup;
            }
            togglePopup() {
                const e = this._popup;
                return this._element.style.opacity === this._opacityWhenCovered ? this : e ? (e.isOpen() ? e.remove() : (e.setLngLat(this._lngLat), e.addTo(this._map)), this) : this;
            }
            _updateOpacity(e = !1) {
                var i, r;
                if (!(null === (i = this._map) || void 0 === i ? void 0 : i.terrain)) {
                    const e = this._map.transform.isLocationOccluded(this._lngLat) ? this._opacityWhenCovered : this._opacity;
                    return void (this._element.style.opacity !== e && (this._element.style.opacity = e));
                }
                if (e) this._opacityTimeout = null;
                else {
                    if (this._opacityTimeout) return;
                    this._opacityTimeout = setTimeout(()=>{
                        this._opacityTimeout = null;
                    }, 100);
                }
                const o = this._map, a = o.terrain.depthAtPoint(this._pos), s = o.terrain.getElevationForLngLatZoom(this._lngLat, o.transform.tileZoom);
                if (o.transform.lngLatToCameraDepth(this._lngLat, s) - a < .006) return void (this._element.style.opacity = this._opacity);
                const n = -this._offset.y / o.transform.pixelsPerMeter, l = Math.sin(o.getPitch() * Math.PI / 180) * n, c = o.terrain.depthAtPoint(new t.P(this._pos.x, this._pos.y - this._offset.y)), h = o.transform.lngLatToCameraDepth(this._lngLat, s + l) - c > .006;
                (null === (r = this._popup) || void 0 === r ? void 0 : r.isOpen()) && h && this._popup.remove(), this._element.style.opacity = h ? this._opacityWhenCovered : this._opacity;
            }
            getOffset() {
                return this._offset;
            }
            setOffset(e) {
                return this._offset = t.P.convert(e), this._update(), this;
            }
            addClassName(e) {
                this._element.classList.add(e);
            }
            removeClassName(e) {
                this._element.classList.remove(e);
            }
            toggleClassName(e) {
                return this._element.classList.toggle(e);
            }
            setDraggable(e) {
                return this._draggable = !!e, this._map && (e ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
            }
            isDraggable() {
                return this._draggable;
            }
            setRotation(e) {
                return this._rotation = e || 0, this._update(), this;
            }
            getRotation() {
                return this._rotation;
            }
            setRotationAlignment(e) {
                return this._rotationAlignment = e || "auto", this._update(), this;
            }
            getRotationAlignment() {
                return this._rotationAlignment;
            }
            setPitchAlignment(e) {
                return this._pitchAlignment = e && "auto" !== e ? e : this._rotationAlignment, this._update(), this;
            }
            getPitchAlignment() {
                return this._pitchAlignment;
            }
            setOpacity(e, t) {
                return (void 0 === this._opacity || void 0 === e && void 0 === t) && (this._opacity = "1", this._opacityWhenCovered = "0.2"), void 0 !== e && (this._opacity = e), void 0 !== t && (this._opacityWhenCovered = t), this._map && this._updateOpacity(!0), this;
            }
        }
        const Na = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0
        };
        let Ga = 0, Ua = !1;
        const Va = {
            maxWidth: 100,
            unit: "metric"
        };
        function qa(e, t, i) {
            const r = i && i.maxWidth || 100, o = e._container.clientHeight / 2, a = e._container.clientWidth / 2, s = e.unproject([
                a - r / 2,
                o
            ]), n = e.unproject([
                a + r / 2,
                o
            ]), l = Math.round(e.project(n).x - e.project(s).x), c = Math.min(r, l, e._container.clientWidth), h = s.distanceTo(n);
            if (i && "imperial" === i.unit) {
                const i = 3.2808 * h;
                i > 5280 ? Wa(t, c, i / 5280, e._getUIString("ScaleControl.Miles")) : Wa(t, c, i, e._getUIString("ScaleControl.Feet"));
            } else i && "nautical" === i.unit ? Wa(t, c, h / 1852, e._getUIString("ScaleControl.NauticalMiles")) : h >= 1e3 ? Wa(t, c, h / 1e3, e._getUIString("ScaleControl.Kilometers")) : Wa(t, c, h, e._getUIString("ScaleControl.Meters"));
        }
        function Wa(e, t, i, r) {
            const o = function(e) {
                const t = Math.pow(10, `${Math.floor(e)}`.length - 1);
                let i = e / t;
                return i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : i >= 1 ? 1 : function(e) {
                    const t = Math.pow(10, Math.ceil(-Math.log(e) / Math.LN10));
                    return Math.round(e * t) / t;
                }(i), t * i;
            }(i);
            e.style.width = t * (o / i) + "px", e.innerHTML = `${o}&nbsp;${r}`;
        }
        const $a = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px",
            subpixelPositioning: !1,
            locationOccludedOpacity: void 0
        }, Ha = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", ");
        function Ka(e) {
            if (e) {
                if ("number" == typeof e) {
                    const i = Math.round(Math.abs(e) / Math.SQRT2);
                    return {
                        center: new t.P(0, 0),
                        top: new t.P(0, e),
                        "top-left": new t.P(i, i),
                        "top-right": new t.P(-i, i),
                        bottom: new t.P(0, -e),
                        "bottom-left": new t.P(i, -i),
                        "bottom-right": new t.P(-i, -i),
                        left: new t.P(e, 0),
                        right: new t.P(-e, 0)
                    };
                }
                if (e instanceof t.P || Array.isArray(e)) {
                    const i = t.P.convert(e);
                    return {
                        center: i,
                        top: i,
                        "top-left": i,
                        "top-right": i,
                        bottom: i,
                        "bottom-left": i,
                        "bottom-right": i,
                        left: i,
                        right: i
                    };
                }
                return {
                    center: t.P.convert(e.center || [
                        0,
                        0
                    ]),
                    top: t.P.convert(e.top || [
                        0,
                        0
                    ]),
                    "top-left": t.P.convert(e["top-left"] || [
                        0,
                        0
                    ]),
                    "top-right": t.P.convert(e["top-right"] || [
                        0,
                        0
                    ]),
                    bottom: t.P.convert(e.bottom || [
                        0,
                        0
                    ]),
                    "bottom-left": t.P.convert(e["bottom-left"] || [
                        0,
                        0
                    ]),
                    "bottom-right": t.P.convert(e["bottom-right"] || [
                        0,
                        0
                    ]),
                    left: t.P.convert(e.left || [
                        0,
                        0
                    ]),
                    right: t.P.convert(e.right || [
                        0,
                        0
                    ])
                };
            }
            return Ka(new t.P(0, 0));
        }
        const Xa = i;
        e.AJAXError = t.cm, e.Event = t.l, e.Evented = t.E, e.LngLat = t.Q, e.MercatorCoordinate = t.$, e.Point = t.P, e.addProtocol = t.cn, e.config = t.a, e.removeProtocol = t.co, e.AttributionControl = wa, e.BoxZoomHandler = Oo, e.CanvasSource = Y, e.CooperativeGesturesHandler = ma, e.DoubleClickZoomHandler = ca, e.DragPanHandler = da, e.DragRotateHandler = _a, e.EdgeInsets = Pt, e.FullscreenControl = class extends t.E {
            constructor(e = {}){
                super(), this._onFullscreenChange = ()=>{
                    var e;
                    let t = window.document.fullscreenElement || window.document.mozFullScreenElement || window.document.webkitFullscreenElement || window.document.msFullscreenElement;
                    for(; null === (e = null == t ? void 0 : t.shadowRoot) || void 0 === e ? void 0 : e.fullscreenElement;)t = t.shadowRoot.fullscreenElement;
                    t === this._container !== this._fullscreen && this._handleFullscreenChange();
                }, this._onClickFullscreen = ()=>{
                    this._isFullscreen() ? this._exitFullscreen() : this._requestFullscreen();
                }, this._fullscreen = !1, e && e.container && (e.container instanceof HTMLElement ? this._container = e.container : t.w("Full screen control 'container' must be a DOM element.")), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange" in document ? this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange" in document ? this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange" in document && (this._fullscreenchange = "MSFullscreenChange");
            }
            onAdd(e) {
                return this._map = e, this._container || (this._container = this._map.getContainer()), this._controlContainer = n.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), this._controlContainer;
            }
            onRemove() {
                n.remove(this._controlContainer), this._map = null, window.document.removeEventListener(this._fullscreenchange, this._onFullscreenChange);
            }
            _setupUI() {
                const e = this._fullscreenButton = n.create("button", "maplibregl-ctrl-fullscreen", this._controlContainer);
                n.create("span", "maplibregl-ctrl-icon", e).setAttribute("aria-hidden", "true"), e.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), window.document.addEventListener(this._fullscreenchange, this._onFullscreenChange);
            }
            _updateTitle() {
                const e = this._getTitle();
                this._fullscreenButton.setAttribute("aria-label", e), this._fullscreenButton.title = e;
            }
            _getTitle() {
                return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
            }
            _isFullscreen() {
                return this._fullscreen;
            }
            _handleFullscreenChange() {
                this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("maplibregl-ctrl-shrink"), this._fullscreenButton.classList.toggle("maplibregl-ctrl-fullscreen"), this._updateTitle(), this._fullscreen ? (this.fire(new t.l("fullscreenstart")), this._prevCooperativeGesturesEnabled = this._map.cooperativeGestures.isEnabled(), this._map.cooperativeGestures.disable()) : (this.fire(new t.l("fullscreenend")), this._prevCooperativeGesturesEnabled && this._map.cooperativeGestures.enable());
            }
            _exitFullscreen() {
                window.document.exitFullscreen ? window.document.exitFullscreen() : window.document.mozCancelFullScreen ? window.document.mozCancelFullScreen() : window.document.msExitFullscreen ? window.document.msExitFullscreen() : window.document.webkitCancelFullScreen ? window.document.webkitCancelFullScreen() : this._togglePseudoFullScreen();
            }
            _requestFullscreen() {
                this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.mozRequestFullScreen ? this._container.mozRequestFullScreen() : this._container.msRequestFullscreen ? this._container.msRequestFullscreen() : this._container.webkitRequestFullscreen ? this._container.webkitRequestFullscreen() : this._togglePseudoFullScreen();
            }
            _togglePseudoFullScreen() {
                this._container.classList.toggle("maplibregl-pseudo-fullscreen"), this._handleFullscreenChange(), this._map.resize();
            }
        }, e.GeoJSONSource = K, e.GeolocateControl = class extends t.E {
            constructor(e){
                super(), this._onSuccess = (e)=>{
                    if (this._map) {
                        if (this._isOutOfMapMaxBounds(e)) return this._setErrorState(), this.fire(new t.l("outofmaxbounds", e)), this._updateMarker(), void this._finish();
                        if (this.options.trackUserLocation) switch(this._lastKnownPosition = e, this._watchState){
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                break;
                            case "BACKGROUND":
                            case "BACKGROUND_ERROR":
                                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background");
                                break;
                            default:
                                throw new Error(`Unexpected watchState ${this._watchState}`);
                        }
                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(e), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(e), this.options.showUserLocation && this._dotElement.classList.remove("maplibregl-user-location-dot-stale"), this.fire(new t.l("geolocate", e)), this._finish();
                    }
                }, this._updateCamera = (e)=>{
                    const i = new t.Q(e.coords.longitude, e.coords.latitude), r = e.coords.accuracy, o = this._map.getBearing(), a = t.e({
                        bearing: o
                    }, this.options.fitBoundsOptions), s = V.fromLngLat(i, r);
                    this._map.fitBounds(s, a, {
                        geolocateSource: !0
                    });
                }, this._updateMarker = (e)=>{
                    if (e) {
                        const i = new t.Q(e.coords.longitude, e.coords.latitude);
                        this._accuracyCircleMarker.setLngLat(i).addTo(this._map), this._userLocationDotMarker.setLngLat(i).addTo(this._map), this._accuracy = e.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                }, this._onZoom = ()=>{
                    this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                }, this._onError = (e)=>{
                    if (this._map) {
                        if (this.options.trackUserLocation) {
                            if (1 === e.code) {
                                this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                const e = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                this._geolocateButton.title = e, this._geolocateButton.setAttribute("aria-label", e), void 0 !== this._geolocationWatchID && this._clearWatch();
                            } else {
                                if (3 === e.code && Ua) return;
                                this._setErrorState();
                            }
                        }
                        "OFF" !== this._watchState && this.options.showUserLocation && this._dotElement.classList.add("maplibregl-user-location-dot-stale"), this.fire(new t.l("error", e)), this._finish();
                    }
                }, this._finish = ()=>{
                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                }, this._setupUI = ()=>{
                    this._map && (this._container.addEventListener("contextmenu", (e)=>e.preventDefault()), this._geolocateButton = n.create("button", "maplibregl-ctrl-geolocate", this._container), n.create("span", "maplibregl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", this._geolocateButton.disabled = !0);
                }, this._finishSetupUI = (e)=>{
                    if (this._map) {
                        if (!1 === e) {
                            t.w("Geolocation support is not available so the GeolocateControl will be disabled.");
                            const e = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                            this._geolocateButton.disabled = !0, this._geolocateButton.title = e, this._geolocateButton.setAttribute("aria-label", e);
                        } else {
                            const e = this._map._getUIString("GeolocateControl.FindMyLocation");
                            this._geolocateButton.disabled = !1, this._geolocateButton.title = e, this._geolocateButton.setAttribute("aria-label", e);
                        }
                        this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = n.create("div", "maplibregl-user-location-dot"), this._userLocationDotMarker = new Za({
                            element: this._dotElement
                        }), this._circleElement = n.create("div", "maplibregl-user-location-accuracy-circle"), this._accuracyCircleMarker = new Za({
                            element: this._circleElement,
                            pitchAlignment: "map"
                        }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", ()=>this.trigger()), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", (e)=>{
                            e.geolocateSource || "ACTIVE_LOCK" !== this._watchState || e.originalEvent && "resize" === e.originalEvent.type || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this.fire(new t.l("trackuserlocationend")), this.fire(new t.l("userlocationlostfocus")));
                        });
                    }
                }, this.options = t.e({}, Na, e);
            }
            onAdd(e) {
                return this._map = e, this._container = n.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), (function() {
                    return t._(this, arguments, void 0, function*(e = !1) {
                        if (void 0 !== Fa && !e) return Fa;
                        if (void 0 === window.navigator.permissions) return Fa = !!window.navigator.geolocation, Fa;
                        try {
                            const e = yield window.navigator.permissions.query({
                                name: "geolocation"
                            });
                            Fa = "denied" !== e.state;
                        } catch (e) {
                            Fa = !!window.navigator.geolocation;
                        }
                        return Fa;
                    });
                })().then((e)=>this._finishSetupUI(e)), this._container;
            }
            onRemove() {
                void 0 !== this._geolocationWatchID && (window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), n.remove(this._container), this._map.off("zoom", this._onZoom), this._map = void 0, Ga = 0, Ua = !1;
            }
            _isOutOfMapMaxBounds(e) {
                const t = this._map.getMaxBounds(), i = e.coords;
                return t && (i.longitude < t.getWest() || i.longitude > t.getEast() || i.latitude < t.getSouth() || i.latitude > t.getNorth());
            }
            _setErrorState() {
                switch(this._watchState){
                    case "WAITING_ACTIVE":
                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error");
                        break;
                    case "ACTIVE_LOCK":
                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                        break;
                    case "BACKGROUND":
                        this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                        break;
                    case "ACTIVE_ERROR":
                        break;
                    default:
                        throw new Error(`Unexpected watchState ${this._watchState}`);
                }
            }
            _updateCircleRadius() {
                const e = this._map.getBounds(), t = e.getSouthEast(), i = e.getNorthEast(), r = t.distanceTo(i), o = Math.ceil(this._accuracy / (r / this._map._container.clientHeight) * 2);
                this._circleElement.style.width = `${o}px`, this._circleElement.style.height = `${o}px`;
            }
            trigger() {
                if (!this._setup) return t.w("Geolocate control triggered before added to a map"), !1;
                if (this.options.trackUserLocation) {
                    switch(this._watchState){
                        case "OFF":
                            this._watchState = "WAITING_ACTIVE", this.fire(new t.l("trackuserlocationstart"));
                            break;
                        case "WAITING_ACTIVE":
                        case "ACTIVE_LOCK":
                        case "ACTIVE_ERROR":
                        case "BACKGROUND_ERROR":
                            Ga--, Ua = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this.fire(new t.l("trackuserlocationend"));
                            break;
                        case "BACKGROUND":
                            this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new t.l("trackuserlocationstart")), this.fire(new t.l("userlocationfocus"));
                            break;
                        default:
                            throw new Error(`Unexpected watchState ${this._watchState}`);
                    }
                    switch(this._watchState){
                        case "WAITING_ACTIVE":
                            this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                            break;
                        case "ACTIVE_LOCK":
                            this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                            break;
                        case "OFF":
                            break;
                        default:
                            throw new Error(`Unexpected watchState ${this._watchState}`);
                    }
                    if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                    else if (void 0 === this._geolocationWatchID) {
                        let e;
                        this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), Ga++, Ga > 1 ? (e = {
                            maximumAge: 6e5,
                            timeout: 0
                        }, Ua = !0) : (e = this.options.positionOptions, Ua = !1), this._geolocationWatchID = window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, e);
                    }
                } else window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                return !0;
            }
            _clearWatch() {
                window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
            }
        }, e.GlobeControl = class {
            constructor(){
                this._toggleProjection = ()=>{
                    var e;
                    const t = null === (e = this._map.getProjection()) || void 0 === e ? void 0 : e.type;
                    this._map.setProjection("mercator" !== t && t ? {
                        type: "mercator"
                    } : {
                        type: "globe"
                    }), this._updateGlobeIcon();
                }, this._updateGlobeIcon = ()=>{
                    var e;
                    this._globeButton.classList.remove("maplibregl-ctrl-globe"), this._globeButton.classList.remove("maplibregl-ctrl-globe-enabled"), "globe" === (null === (e = this._map.getProjection()) || void 0 === e ? void 0 : e.type) ? (this._globeButton.classList.add("maplibregl-ctrl-globe-enabled"), this._globeButton.title = this._map._getUIString("GlobeControl.Disable")) : (this._globeButton.classList.add("maplibregl-ctrl-globe"), this._globeButton.title = this._map._getUIString("GlobeControl.Enable"));
                };
            }
            onAdd(e) {
                return this._map = e, this._container = n.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._globeButton = n.create("button", "maplibregl-ctrl-globe", this._container), n.create("span", "maplibregl-ctrl-icon", this._globeButton).setAttribute("aria-hidden", "true"), this._globeButton.type = "button", this._globeButton.addEventListener("click", this._toggleProjection), this._updateGlobeIcon(), this._map.on("styledata", this._updateGlobeIcon), this._container;
            }
            onRemove() {
                n.remove(this._container), this._map.off("styledata", this._updateGlobeIcon), this._globeButton.removeEventListener("click", this._toggleProjection), this._map = void 0;
            }
        }, e.Hash = wo, e.ImageSource = X, e.KeyboardHandler = aa, e.LngLatBounds = V, e.LogoControl = Ta, e.Map = class extends ba {
            constructor(e){
                var i, r;
                t.cj.mark(t.ck.create);
                const o = Object.assign(Object.assign(Object.assign({}, Aa), e), {
                    canvasContextAttributes: Object.assign(Object.assign({}, Aa.canvasContextAttributes), e.canvasContextAttributes)
                });
                if (null != o.minZoom && null != o.maxZoom && o.minZoom > o.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                if (null != o.minPitch && null != o.maxPitch && o.minPitch > o.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                if (null != o.minPitch && o.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                if (null != o.maxPitch && o.maxPitch > 180) throw new Error("maxPitch must be less than or equal to 180");
                const a = new Dt, s = new kt;
                if (void 0 !== o.minZoom && a.setMinZoom(o.minZoom), void 0 !== o.maxZoom && a.setMaxZoom(o.maxZoom), void 0 !== o.minPitch && a.setMinPitch(o.minPitch), void 0 !== o.maxPitch && a.setMaxPitch(o.maxPitch), void 0 !== o.renderWorldCopies && a.setRenderWorldCopies(o.renderWorldCopies), super(a, s, {
                    bearingSnap: o.bearingSnap
                }), this._idleTriggered = !1, this._crossFadingFactor = 1, this._renderTaskQueue = new Pa, this._controls = [], this._mapId = t.a4(), this._contextLost = (e)=>{
                    e.preventDefault(), this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this.fire(new t.l("webglcontextlost", {
                        originalEvent: e
                    }));
                }, this._contextRestored = (e)=>{
                    this._setupPainter(), this.resize(), this._update(), this.fire(new t.l("webglcontextrestored", {
                        originalEvent: e
                    }));
                }, this._onMapScroll = (e)=>{
                    if (e.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                }, this._onWindowOnline = ()=>{
                    this._update();
                }, this._interactive = o.interactive, this._maxTileCacheSize = o.maxTileCacheSize, this._maxTileCacheZoomLevels = o.maxTileCacheZoomLevels, this._canvasContextAttributes = Object.assign({}, o.canvasContextAttributes), this._trackResize = !0 === o.trackResize, this._bearingSnap = o.bearingSnap, this._centerClampedToGround = o.centerClampedToGround, this._refreshExpiredTiles = !0 === o.refreshExpiredTiles, this._fadeDuration = o.fadeDuration, this._crossSourceCollisions = !0 === o.crossSourceCollisions, this._collectResourceTiming = !0 === o.collectResourceTiming, this._locale = Object.assign(Object.assign({}, Da), o.locale), this._clickTolerance = o.clickTolerance, this._overridePixelRatio = o.pixelRatio, this._maxCanvasSize = o.maxCanvasSize, this.transformCameraUpdate = o.transformCameraUpdate, this.cancelPendingTileRequestsWhileZooming = !0 === o.cancelPendingTileRequestsWhileZooming, this._imageQueueHandle = p.addThrottleControl(()=>this.isMoving()), this._requestManager = new m(o.transformRequest), "string" == typeof o.container) {
                    if (this._container = document.getElementById(o.container), !this._container) throw new Error(`Container '${o.container}' not found.`);
                } else {
                    if (!(o.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                    this._container = o.container;
                }
                if (o.maxBounds && this.setMaxBounds(o.maxBounds), this._setupContainer(), this._setupPainter(), this.on("move", ()=>this._update(!1)), this.on("moveend", ()=>this._update(!1)), this.on("zoom", ()=>this._update(!0)), this.on("terrain", ()=>{
                    this.painter.terrainFacilitator.dirty = !0, this._update(!0);
                }), this.once("idle", ()=>{
                    this._idleTriggered = !0;
                }), "undefined" != typeof window) {
                    addEventListener("online", this._onWindowOnline, !1);
                    let e = !1;
                    const t = yo((e)=>{
                        this._trackResize && !this._removed && (this.resize(e), this.redraw());
                    }, 50);
                    this._resizeObserver = new ResizeObserver((i)=>{
                        e ? t(i) : e = !0;
                    }), this._resizeObserver.observe(this._container);
                }
                this.handlers = new xa(this, o), this._hash = o.hash && new wo("string" == typeof o.hash && o.hash || void 0).addTo(this), this._hash && this._hash._onHashChange() || (this.jumpTo({
                    center: o.center,
                    elevation: o.elevation,
                    zoom: o.zoom,
                    bearing: o.bearing,
                    pitch: o.pitch,
                    roll: o.roll
                }), o.bounds && (this.resize(), this.fitBounds(o.bounds, t.e({}, o.fitBoundsOptions, {
                    duration: 0
                }))));
                const n = "string" == typeof o.style || !("globe" === (null === (r = null === (i = o.style) || void 0 === i ? void 0 : i.projection) || void 0 === r ? void 0 : r.type));
                this.resize(null, n), this._localIdeographFontFamily = o.localIdeographFontFamily, this._validateStyle = o.validateStyle, o.style && this.setStyle(o.style, {
                    localIdeographFontFamily: o.localIdeographFontFamily
                }), o.attributionControl && this.addControl(new wa("boolean" == typeof o.attributionControl ? void 0 : o.attributionControl)), o.maplibreLogo && this.addControl(new Ta, o.logoPosition), this.on("style.load", ()=>{
                    if (n || this._resizeTransform(), this.transform.unmodified) {
                        const e = t.O(this.style.stylesheet, [
                            "center",
                            "zoom",
                            "bearing",
                            "pitch",
                            "roll"
                        ]);
                        this.jumpTo(e);
                    }
                }), this.on("data", (e)=>{
                    this._update("style" === e.dataType), this.fire(new t.l(`${e.dataType}data`, e));
                }), this.on("dataloading", (e)=>{
                    this.fire(new t.l(`${e.dataType}dataloading`, e));
                }), this.on("dataabort", (e)=>{
                    this.fire(new t.l("sourcedataabort", e));
                });
            }
            _getMapId() {
                return this._mapId;
            }
            addControl(e, i) {
                if (void 0 === i && (i = e.getDefaultPosition ? e.getDefaultPosition() : "top-right"), !e || !e.onAdd) return this.fire(new t.k(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                const r = e.onAdd(this);
                this._controls.push(e);
                const o = this._controlPositions[i];
                return -1 !== i.indexOf("bottom") ? o.insertBefore(r, o.firstChild) : o.appendChild(r), this;
            }
            removeControl(e) {
                if (!e || !e.onRemove) return this.fire(new t.k(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                const i = this._controls.indexOf(e);
                return i > -1 && this._controls.splice(i, 1), e.onRemove(this), this;
            }
            hasControl(e) {
                return this._controls.indexOf(e) > -1;
            }
            calculateCameraOptionsFromTo(e, t, i, r) {
                return null == r && this.terrain && (r = this.terrain.getElevationForLngLatZoom(i, this.transform.tileZoom)), super.calculateCameraOptionsFromTo(e, t, i, r);
            }
            resize(e, i = !0) {
                const [r, o] = this._containerDimensions(), a = this._getClampedPixelRatio(r, o);
                if (this._resizeCanvas(r, o, a), this.painter.resize(r, o, a), this.painter.overLimit()) {
                    const e = this.painter.context.gl;
                    this._maxCanvasSize = [
                        e.drawingBufferWidth,
                        e.drawingBufferHeight
                    ];
                    const t = this._getClampedPixelRatio(r, o);
                    this._resizeCanvas(r, o, t), this.painter.resize(r, o, t);
                }
                this._resizeTransform(i);
                const s = !this._moving;
                return s && (this.stop(), this.fire(new t.l("movestart", e)).fire(new t.l("move", e))), this.fire(new t.l("resize", e)), s && this.fire(new t.l("moveend", e)), this;
            }
            _resizeTransform(e = !0) {
                var t;
                const [i, r] = this._containerDimensions();
                this.transform.resize(i, r, e), null === (t = this._requestedCameraState) || void 0 === t || t.resize(i, r, e);
            }
            _getClampedPixelRatio(e, t) {
                const { 0: i, 1: r } = this._maxCanvasSize, o = this.getPixelRatio(), a = e * o, s = t * o;
                return Math.min(a > i ? i / a : 1, s > r ? r / s : 1) * o;
            }
            getPixelRatio() {
                var e;
                return null !== (e = this._overridePixelRatio) && void 0 !== e ? e : devicePixelRatio;
            }
            setPixelRatio(e) {
                this._overridePixelRatio = e, this.resize();
            }
            getBounds() {
                return this.transform.getBounds();
            }
            getMaxBounds() {
                return this.transform.getMaxBounds();
            }
            setMaxBounds(e) {
                return this.transform.setMaxBounds(V.convert(e)), this._update();
            }
            setMinZoom(e) {
                if ((e = null == e ? -2 : e) >= -2 && e <= this.transform.maxZoom) return this.transform.setMinZoom(e), this._update(), this.getZoom() < e && this.setZoom(e), this;
                throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
            }
            getMinZoom() {
                return this.transform.minZoom;
            }
            setMaxZoom(e) {
                if ((e = null == e ? 22 : e) >= this.transform.minZoom) return this.transform.setMaxZoom(e), this._update(), this.getZoom() > e && this.setZoom(e), this;
                throw new Error("maxZoom must be greater than the current minZoom");
            }
            getMaxZoom() {
                return this.transform.maxZoom;
            }
            setMinPitch(e) {
                if ((e = null == e ? 0 : e) < 0) throw new Error("minPitch must be greater than or equal to 0");
                if (e >= 0 && e <= this.transform.maxPitch) return this.transform.setMinPitch(e), this._update(), this.getPitch() < e && this.setPitch(e), this;
                throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
            }
            getMinPitch() {
                return this.transform.minPitch;
            }
            setMaxPitch(e) {
                if ((e = null == e ? 60 : e) > 180) throw new Error("maxPitch must be less than or equal to 180");
                if (e >= this.transform.minPitch) return this.transform.setMaxPitch(e), this._update(), this.getPitch() > e && this.setPitch(e), this;
                throw new Error("maxPitch must be greater than the current minPitch");
            }
            getMaxPitch() {
                return this.transform.maxPitch;
            }
            getRenderWorldCopies() {
                return this.transform.renderWorldCopies;
            }
            setRenderWorldCopies(e) {
                return this.transform.setRenderWorldCopies(e), this._update();
            }
            project(e) {
                return this.transform.locationToScreenPoint(t.Q.convert(e), this.style && this.terrain);
            }
            unproject(e) {
                return this.transform.screenPointToLocation(t.P.convert(e), this.terrain);
            }
            isMoving() {
                var e;
                return this._moving || (null === (e = this.handlers) || void 0 === e ? void 0 : e.isMoving());
            }
            isZooming() {
                var e;
                return this._zooming || (null === (e = this.handlers) || void 0 === e ? void 0 : e.isZooming());
            }
            isRotating() {
                var e;
                return this._rotating || (null === (e = this.handlers) || void 0 === e ? void 0 : e.isRotating());
            }
            _createDelegatedListener(e, t, i) {
                if ("mouseenter" === e || "mouseover" === e) {
                    let r = !1;
                    const o = (o)=>{
                        const a = t.filter((e)=>this.getLayer(e)), s = 0 !== a.length ? this.queryRenderedFeatures(o.point, {
                            layers: a
                        }) : [];
                        s.length ? r || (r = !0, i.call(this, new zo(e, this, o.originalEvent, {
                            features: s
                        }))) : r = !1;
                    };
                    return {
                        layers: t,
                        listener: i,
                        delegates: {
                            mousemove: o,
                            mouseout: ()=>{
                                r = !1;
                            }
                        }
                    };
                }
                if ("mouseleave" === e || "mouseout" === e) {
                    let r = !1;
                    const o = (o)=>{
                        const a = t.filter((e)=>this.getLayer(e));
                        (0 !== a.length ? this.queryRenderedFeatures(o.point, {
                            layers: a
                        }) : []).length ? r = !0 : r && (r = !1, i.call(this, new zo(e, this, o.originalEvent)));
                    }, a = (t)=>{
                        r && (r = !1, i.call(this, new zo(e, this, t.originalEvent)));
                    };
                    return {
                        layers: t,
                        listener: i,
                        delegates: {
                            mousemove: o,
                            mouseout: a
                        }
                    };
                }
                {
                    const r = (e)=>{
                        const r = t.filter((e)=>this.getLayer(e)), o = 0 !== r.length ? this.queryRenderedFeatures(e.point, {
                            layers: r
                        }) : [];
                        o.length && (e.features = o, i.call(this, e), delete e.features);
                    };
                    return {
                        layers: t,
                        listener: i,
                        delegates: {
                            [e]: r
                        }
                    };
                }
            }
            _saveDelegatedListener(e, t) {
                this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[e] = this._delegatedListeners[e] || [], this._delegatedListeners[e].push(t);
            }
            _removeDelegatedListener(e, t, i) {
                if (!this._delegatedListeners || !this._delegatedListeners[e]) return;
                const r = this._delegatedListeners[e];
                for(let e = 0; e < r.length; e++){
                    const o = r[e];
                    if (o.listener === i && o.layers.length === t.length && o.layers.every((e)=>t.includes(e))) {
                        for(const e in o.delegates)this.off(e, o.delegates[e]);
                        return void r.splice(e, 1);
                    }
                }
            }
            on(e, t, i) {
                if (void 0 === i) return super.on(e, t);
                const r = "string" == typeof t ? [
                    t
                ] : t, o = this._createDelegatedListener(e, r, i);
                this._saveDelegatedListener(e, o);
                for(const e in o.delegates)this.on(e, o.delegates[e]);
                return {
                    unsubscribe: ()=>{
                        this._removeDelegatedListener(e, r, i);
                    }
                };
            }
            once(e, t, i) {
                if (void 0 === i) return super.once(e, t);
                const r = "string" == typeof t ? [
                    t
                ] : t, o = this._createDelegatedListener(e, r, i);
                for(const t in o.delegates){
                    const a = o.delegates[t];
                    o.delegates[t] = (...t)=>{
                        this._removeDelegatedListener(e, r, i), a(...t);
                    };
                }
                this._saveDelegatedListener(e, o);
                for(const e in o.delegates)this.once(e, o.delegates[e]);
                return this;
            }
            off(e, t, i) {
                return void 0 === i ? super.off(e, t) : (this._removeDelegatedListener(e, "string" == typeof t ? [
                    t
                ] : t, i), this);
            }
            queryRenderedFeatures(e, i) {
                if (!this.style) return [];
                let r;
                const o = e instanceof t.P || Array.isArray(e), a = o ? e : [
                    [
                        0,
                        0
                    ],
                    [
                        this.transform.width,
                        this.transform.height
                    ]
                ];
                if (i = i || (o ? {} : e) || {}, a instanceof t.P || "number" == typeof a[0]) r = [
                    t.P.convert(a)
                ];
                else {
                    const e = t.P.convert(a[0]), i = t.P.convert(a[1]);
                    r = [
                        e,
                        new t.P(i.x, e.y),
                        i,
                        new t.P(e.x, i.y),
                        e
                    ];
                }
                return this.style.queryRenderedFeatures(r, i, this.transform);
            }
            querySourceFeatures(e, t) {
                return this.style.querySourceFeatures(e, t);
            }
            setStyle(e, i) {
                return !1 !== (i = t.e({}, {
                    localIdeographFontFamily: this._localIdeographFontFamily,
                    validate: this._validateStyle
                }, i)).diff && i.localIdeographFontFamily === this._localIdeographFontFamily && this.style && e ? (this._diffStyle(e, i), this) : (this._localIdeographFontFamily = i.localIdeographFontFamily, this._updateStyle(e, i));
            }
            setTransformRequest(e) {
                return this._requestManager.setTransformRequest(e), this;
            }
            _getUIString(e) {
                const t = this._locale[e];
                if (null == t) throw new Error(`Missing UI string '${e}'`);
                return t;
            }
            _updateStyle(e, t) {
                var i, r;
                if (t.transformStyle && this.style && !this.style._loaded) return void this.style.once("style.load", ()=>this._updateStyle(e, t));
                const o = this.style && t.transformStyle ? this.style.serialize() : void 0;
                return this.style && (this.style.setEventedParent(null), this.style._remove(!e)), e ? (this.style = new gi(this, t || {}), this.style.setEventedParent(this, {
                    style: this.style
                }), "string" == typeof e ? this.style.loadURL(e, t, o) : this.style.loadJSON(e, t, o), this) : (null === (r = null === (i = this.style) || void 0 === i ? void 0 : i.projection) || void 0 === r || r.destroy(), delete this.style, this);
            }
            _lazyInitEmptyStyle() {
                this.style || (this.style = new gi(this, {}), this.style.setEventedParent(this, {
                    style: this.style
                }), this.style.loadEmpty());
            }
            _diffStyle(e, i) {
                if ("string" == typeof e) {
                    const r = this._requestManager.transformRequest(e, "Style");
                    t.j(r, new AbortController).then((e)=>{
                        this._updateDiff(e.data, i);
                    }).catch((e)=>{
                        e && this.fire(new t.k(e));
                    });
                } else "object" == typeof e && this._updateDiff(e, i);
            }
            _updateDiff(e, i) {
                try {
                    this.style.setState(e, i) && this._update(!0);
                } catch (r) {
                    t.w(`Unable to perform style diff: ${r.message || r.error || r}.  Rebuilding the style from scratch.`), this._updateStyle(e, i);
                }
            }
            getStyle() {
                if (this.style) return this.style.serialize();
            }
            isStyleLoaded() {
                return this.style ? this.style.loaded() : t.w("There is no style added to the map.");
            }
            addSource(e, t) {
                return this._lazyInitEmptyStyle(), this.style.addSource(e, t), this._update(!0);
            }
            isSourceLoaded(e) {
                const i = this.style && this.style.sourceCaches[e];
                if (void 0 !== i) return i.loaded();
                this.fire(new t.k(new Error(`There is no source with ID '${e}'`)));
            }
            setTerrain(e) {
                if (this.style._checkLoaded(), this._terrainDataCallback && this.style.off("data", this._terrainDataCallback), e) {
                    const i = this.style.sourceCaches[e.source];
                    if (!i) throw new Error(`cannot load terrain, because there exists no source with ID: ${e.source}`);
                    null === this.terrain && i.reload();
                    for(const i in this.style._layers){
                        const r = this.style._layers[i];
                        "hillshade" === r.type && r.source === e.source && t.w("You are using the same source for a hillshade layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.");
                    }
                    this.terrain = new Ma(this.painter, i, e), this.painter.renderToTexture = new Ra(this.painter, this.terrain), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this.transform.setElevation(this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this._terrainDataCallback = (t)=>{
                        var i;
                        "style" === t.dataType ? this.terrain.sourceCache.freeRtt() : "source" === t.dataType && t.tile && (t.sourceId !== e.source || this._elevationFreeze || (this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this._centerClampedToGround && this.transform.setElevation(this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom))), "image" === (null === (i = t.source) || void 0 === i ? void 0 : i.type) ? this.terrain.sourceCache.freeRtt() : this.terrain.sourceCache.freeRtt(t.tile.tileID));
                    }, this.style.on("data", this._terrainDataCallback);
                } else this.terrain && this.terrain.sourceCache.destruct(), this.terrain = null, this.painter.renderToTexture && this.painter.renderToTexture.destruct(), this.painter.renderToTexture = null, this.transform.setMinElevationForCurrentTile(0), this._centerClampedToGround && this.transform.setElevation(0);
                return this.fire(new t.l("terrain", {
                    terrain: e
                })), this;
            }
            getTerrain() {
                var e, t;
                return null !== (t = null === (e = this.terrain) || void 0 === e ? void 0 : e.options) && void 0 !== t ? t : null;
            }
            areTilesLoaded() {
                const e = this.style && this.style.sourceCaches;
                for(const t in e){
                    const i = e[t]._tiles;
                    for(const e in i){
                        const t = i[e];
                        if ("loaded" !== t.state && "errored" !== t.state) return !1;
                    }
                }
                return !0;
            }
            removeSource(e) {
                return this.style.removeSource(e), this._update(!0);
            }
            getSource(e) {
                return this.style.getSource(e);
            }
            addImage(e, i, r = {}) {
                const { pixelRatio: o = 1, sdf: a = !1, stretchX: n, stretchY: l, content: c, textFitWidth: h, textFitHeight: u } = r;
                if (this._lazyInitEmptyStyle(), !(i instanceof HTMLImageElement || t.b(i))) {
                    if (void 0 === i.width || void 0 === i.height) return this.fire(new t.k(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    {
                        const { width: r, height: s, data: d } = i, _ = i;
                        return this.style.addImage(e, {
                            data: new t.R({
                                width: r,
                                height: s
                            }, new Uint8Array(d)),
                            pixelRatio: o,
                            stretchX: n,
                            stretchY: l,
                            content: c,
                            textFitWidth: h,
                            textFitHeight: u,
                            sdf: a,
                            version: 0,
                            userImage: _
                        }), _.onAdd && _.onAdd(this, e), this;
                    }
                }
                {
                    const { width: r, height: d, data: _ } = s.getImageData(i);
                    this.style.addImage(e, {
                        data: new t.R({
                            width: r,
                            height: d
                        }, _),
                        pixelRatio: o,
                        stretchX: n,
                        stretchY: l,
                        content: c,
                        textFitWidth: h,
                        textFitHeight: u,
                        sdf: a,
                        version: 0
                    });
                }
            }
            updateImage(e, i) {
                const r = this.style.getImage(e);
                if (!r) return this.fire(new t.k(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                const o = i instanceof HTMLImageElement || t.b(i) ? s.getImageData(i) : i, { width: a, height: n, data: l } = o;
                if (void 0 === a || void 0 === n) return this.fire(new t.k(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                if (a !== r.data.width || n !== r.data.height) return this.fire(new t.k(new Error("The width and height of the updated image must be that same as the previous version of the image")));
                const c = !(i instanceof HTMLImageElement || t.b(i));
                return r.data.replace(l, c), this.style.updateImage(e, r), this;
            }
            getImage(e) {
                return this.style.getImage(e);
            }
            hasImage(e) {
                return e ? !!this.style.getImage(e) : (this.fire(new t.k(new Error("Missing required image id"))), !1);
            }
            removeImage(e) {
                this.style.removeImage(e);
            }
            loadImage(e) {
                return p.getImage(this._requestManager.transformRequest(e, "Image"), new AbortController);
            }
            listImages() {
                return this.style.listImages();
            }
            addLayer(e, t) {
                return this._lazyInitEmptyStyle(), this.style.addLayer(e, t), this._update(!0);
            }
            moveLayer(e, t) {
                return this.style.moveLayer(e, t), this._update(!0);
            }
            removeLayer(e) {
                return this.style.removeLayer(e), this._update(!0);
            }
            getLayer(e) {
                return this.style.getLayer(e);
            }
            getLayersOrder() {
                return this.style.getLayersOrder();
            }
            setLayerZoomRange(e, t, i) {
                return this.style.setLayerZoomRange(e, t, i), this._update(!0);
            }
            setFilter(e, t, i = {}) {
                return this.style.setFilter(e, t, i), this._update(!0);
            }
            getFilter(e) {
                return this.style.getFilter(e);
            }
            setPaintProperty(e, t, i, r = {}) {
                return this.style.setPaintProperty(e, t, i, r), this._update(!0);
            }
            getPaintProperty(e, t) {
                return this.style.getPaintProperty(e, t);
            }
            setLayoutProperty(e, t, i, r = {}) {
                return this.style.setLayoutProperty(e, t, i, r), this._update(!0);
            }
            getLayoutProperty(e, t) {
                return this.style.getLayoutProperty(e, t);
            }
            setGlyphs(e, t = {}) {
                return this._lazyInitEmptyStyle(), this.style.setGlyphs(e, t), this._update(!0);
            }
            getGlyphs() {
                return this.style.getGlyphsUrl();
            }
            addSprite(e, t, i = {}) {
                return this._lazyInitEmptyStyle(), this.style.addSprite(e, t, i, (e)=>{
                    e || this._update(!0);
                }), this;
            }
            removeSprite(e) {
                return this._lazyInitEmptyStyle(), this.style.removeSprite(e), this._update(!0);
            }
            getSprite() {
                return this.style.getSprite();
            }
            setSprite(e, t = {}) {
                return this._lazyInitEmptyStyle(), this.style.setSprite(e, t, (e)=>{
                    e || this._update(!0);
                }), this;
            }
            setLight(e, t = {}) {
                return this._lazyInitEmptyStyle(), this.style.setLight(e, t), this._update(!0);
            }
            getLight() {
                return this.style.getLight();
            }
            setSky(e, t = {}) {
                return this._lazyInitEmptyStyle(), this.style.setSky(e, t), this._update(!0);
            }
            getSky() {
                return this.style.getSky();
            }
            setFeatureState(e, t) {
                return this.style.setFeatureState(e, t), this._update();
            }
            removeFeatureState(e, t) {
                return this.style.removeFeatureState(e, t), this._update();
            }
            getFeatureState(e) {
                return this.style.getFeatureState(e);
            }
            getContainer() {
                return this._container;
            }
            getCanvasContainer() {
                return this._canvasContainer;
            }
            getCanvas() {
                return this._canvas;
            }
            _containerDimensions() {
                let e = 0, t = 0;
                return this._container && (e = this._container.clientWidth || 400, t = this._container.clientHeight || 300), [
                    e,
                    t
                ];
            }
            _setupContainer() {
                const e = this._container;
                e.classList.add("maplibregl-map");
                const t = this._canvasContainer = n.create("div", "maplibregl-canvas-container", e);
                this._interactive && t.classList.add("maplibregl-interactive"), this._canvas = n.create("canvas", "maplibregl-canvas", t), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", this._interactive ? "0" : "-1"), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region");
                const i = this._containerDimensions(), r = this._getClampedPixelRatio(i[0], i[1]);
                this._resizeCanvas(i[0], i[1], r);
                const o = this._controlContainer = n.create("div", "maplibregl-control-container", e), a = this._controlPositions = {};
                [
                    "top-left",
                    "top-right",
                    "bottom-left",
                    "bottom-right"
                ].forEach((e)=>{
                    a[e] = n.create("div", `maplibregl-ctrl-${e} `, o);
                }), this._container.addEventListener("scroll", this._onMapScroll, !1);
            }
            _resizeCanvas(e, t, i) {
                this._canvas.width = Math.floor(i * e), this._canvas.height = Math.floor(i * t), this._canvas.style.width = `${e}px`, this._canvas.style.height = `${t}px`;
            }
            _setupPainter() {
                const e = Object.assign(Object.assign({}, this._canvasContextAttributes), {
                    alpha: !0,
                    depth: !0,
                    stencil: !0,
                    premultipliedAlpha: !0
                });
                let t = null;
                this._canvas.addEventListener("webglcontextcreationerror", (i)=>{
                    t = {
                        requestedAttributes: e
                    }, i && (t.statusMessage = i.statusMessage, t.type = i.type);
                }, {
                    once: !0
                });
                let i = null;
                if (i = this._canvasContextAttributes.contextType ? this._canvas.getContext(this._canvasContextAttributes.contextType, e) : this._canvas.getContext("webgl2", e) || this._canvas.getContext("webgl", e), !i) {
                    const e = "Failed to initialize WebGL";
                    throw t ? (t.message = e, new Error(JSON.stringify(t))) : new Error(e);
                }
                this.painter = new bo(i, this.transform), l.testSupport(i);
            }
            migrateProjection(e, i) {
                super.migrateProjection(e, i), this.painter.transform = e, this.fire(new t.l("projectiontransition", {
                    newProjection: this.style.projection.name
                }));
            }
            loaded() {
                return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
            }
            _update(e) {
                return this.style && this.style._loaded ? (this._styleDirty = this._styleDirty || e, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
            }
            _requestRenderFrame(e) {
                return this._update(), this._renderTaskQueue.add(e);
            }
            _cancelRenderFrame(e) {
                this._renderTaskQueue.remove(e);
            }
            _render(e) {
                var i, r, o, a, n;
                const l = this._idleTriggered ? this._fadeDuration : 0, c = (null === (i = this.style.projection) || void 0 === i ? void 0 : i.transitionState) > 0;
                if (this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(e), this._removed) return;
                let h = !1;
                if (this.style && this._styleDirty) {
                    this._styleDirty = !1;
                    const e = this.transform.zoom, i = s.now();
                    this.style.zoomHistory.update(e, i);
                    const r = new t.C(e, {
                        now: i,
                        fadeDuration: l,
                        zoomHistory: this.style.zoomHistory,
                        transition: this.style.getTransition()
                    }), o = r.crossFadingFactor();
                    1 === o && o === this._crossFadingFactor || (h = !0, this._crossFadingFactor = o), this.style.update(r);
                }
                const u = (null === (r = this.style.projection) || void 0 === r ? void 0 : r.transitionState) > 0 !== c;
                null === (o = this.style.projection) || void 0 === o || o.setErrorQueryLatitudeDegrees(this.transform.center.lat), this.transform.setTransitionState(null === (a = this.style.projection) || void 0 === a ? void 0 : a.transitionState, null === (n = this.style.projection) || void 0 === n ? void 0 : n.latitudeErrorCorrectionRadians), this.style && (this._sourcesDirty || u) && (this._sourcesDirty = !1, this.style._updateSources(this.transform)), this.terrain ? (this.terrain.sourceCache.update(this.transform, this.terrain), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), !this._elevationFreeze && this._centerClampedToGround && this.transform.setElevation(this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom))) : (this.transform.setMinElevationForCurrentTile(0), this._centerClampedToGround && this.transform.setElevation(0)), this._placementDirty = this.style && this.style._updatePlacement(this.transform, this.showCollisionBoxes, l, this._crossSourceCollisions, u), this.painter.render(this.style, {
                    showTileBoundaries: this.showTileBoundaries,
                    showOverdrawInspector: this._showOverdrawInspector,
                    rotating: this.isRotating(),
                    zooming: this.isZooming(),
                    moving: this.isMoving(),
                    fadeDuration: l,
                    showPadding: this.showPadding
                }), this.fire(new t.l("render")), this.loaded() && !this._loaded && (this._loaded = !0, t.cj.mark(t.ck.load), this.fire(new t.l("load"))), this.style && (this.style.hasTransitions() || h) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles();
                const d = this._sourcesDirty || this._styleDirty || this._placementDirty;
                return d || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new t.l("idle")), !this._loaded || this._fullyLoaded || d || (this._fullyLoaded = !0, t.cj.mark(t.ck.fullLoad)), this;
            }
            redraw() {
                return this.style && (this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._render(0)), this;
            }
            remove() {
                var e;
                this._hash && this._hash.remove();
                for (const e of this._controls)e.onRemove(this);
                this._controls = [], this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._renderTaskQueue.clear(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), "undefined" != typeof window && removeEventListener("online", this._onWindowOnline, !1), p.removeThrottleControl(this._imageQueueHandle), null === (e = this._resizeObserver) || void 0 === e || e.disconnect();
                const i = this.painter.context.gl.getExtension("WEBGL_lose_context");
                (null == i ? void 0 : i.loseContext) && i.loseContext(), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), n.remove(this._canvasContainer), n.remove(this._controlContainer), this._container.removeEventListener("scroll", this._onMapScroll, !1), this._container.classList.remove("maplibregl-map"), t.cj.clearMetrics(), this._removed = !0, this.fire(new t.l("remove"));
            }
            triggerRepaint() {
                this.style && !this._frameRequest && (this._frameRequest = new AbortController, s.frame(this._frameRequest, (e)=>{
                    t.cj.frame(e), this._frameRequest = null;
                    try {
                        this._render(e);
                    } catch (e) {
                        if (!t.cl(e) && !function(e) {
                            return e.message === jr;
                        }(e)) throw e;
                    }
                }, ()=>{}));
            }
            get showTileBoundaries() {
                return !!this._showTileBoundaries;
            }
            set showTileBoundaries(e) {
                this._showTileBoundaries !== e && (this._showTileBoundaries = e, this._update());
            }
            get showPadding() {
                return !!this._showPadding;
            }
            set showPadding(e) {
                this._showPadding !== e && (this._showPadding = e, this._update());
            }
            get showCollisionBoxes() {
                return !!this._showCollisionBoxes;
            }
            set showCollisionBoxes(e) {
                this._showCollisionBoxes !== e && (this._showCollisionBoxes = e, e ? this.style._generateCollisionBoxes() : this._update());
            }
            get showOverdrawInspector() {
                return !!this._showOverdrawInspector;
            }
            set showOverdrawInspector(e) {
                this._showOverdrawInspector !== e && (this._showOverdrawInspector = e, this._update());
            }
            get repaint() {
                return !!this._repaint;
            }
            set repaint(e) {
                this._repaint !== e && (this._repaint = e, this.triggerRepaint());
            }
            get vertices() {
                return !!this._vertices;
            }
            set vertices(e) {
                this._vertices = e, this._update();
            }
            get version() {
                return za;
            }
            getCameraTargetElevation() {
                return this.transform.elevation;
            }
            getProjection() {
                return this.style.getProjection();
            }
            setProjection(e) {
                return this._lazyInitEmptyStyle(), this.style.setProjection(e), this._update(!0);
            }
        }, e.MapMouseEvent = zo, e.MapTouchEvent = Ao, e.MapWheelEvent = Lo, e.Marker = Za, e.NavigationControl = class {
            constructor(e){
                this._updateZoomButtons = ()=>{
                    const e = this._map.getZoom(), t = e === this._map.getMaxZoom(), i = e === this._map.getMinZoom();
                    this._zoomInButton.disabled = t, this._zoomOutButton.disabled = i, this._zoomInButton.setAttribute("aria-disabled", t.toString()), this._zoomOutButton.setAttribute("aria-disabled", i.toString());
                }, this._rotateCompassArrow = ()=>{
                    this._compassIcon.style.transform = this.options.visualizePitch && this.options.visualizeRoll ? `scale(${1 / Math.pow(Math.cos(this._map.transform.pitchInRadians), .5)}) rotateZ(${-this._map.transform.roll}deg) rotateX(${this._map.transform.pitch}deg) rotateZ(${-this._map.transform.bearing}deg)` : this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(this._map.transform.pitchInRadians), .5)}) rotateX(${this._map.transform.pitch}deg) rotateZ(${-this._map.transform.bearing}deg)` : this.options.visualizeRoll ? `rotate(${-this._map.transform.bearing - this._map.transform.roll}deg)` : `rotate(${-this._map.transform.bearing}deg)`;
                }, this._setButtonTitle = (e, t)=>{
                    const i = this._map._getUIString(`NavigationControl.${t}`);
                    e.title = i, e.setAttribute("aria-label", i);
                }, this.options = t.e({}, La, e), this._container = n.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._container.addEventListener("contextmenu", (e)=>e.preventDefault()), this.options.showZoom && (this._zoomInButton = this._createButton("maplibregl-ctrl-zoom-in", (e)=>this._map.zoomIn({}, {
                        originalEvent: e
                    })), n.create("span", "maplibregl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("maplibregl-ctrl-zoom-out", (e)=>this._map.zoomOut({}, {
                        originalEvent: e
                    })), n.create("span", "maplibregl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (this._compass = this._createButton("maplibregl-ctrl-compass", (e)=>{
                    this.options.visualizePitch ? this._map.resetNorthPitch({}, {
                        originalEvent: e
                    }) : this._map.resetNorth({}, {
                        originalEvent: e
                    });
                }), this._compassIcon = n.create("span", "maplibregl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
            }
            onAdd(e) {
                return this._map = e, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this.options.visualizeRoll && this._map.on("roll", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new ka(this._map, this._compass, this.options.visualizePitch)), this._container;
            }
            onRemove() {
                n.remove(this._container), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this.options.visualizeRoll && this._map.off("roll", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
            }
            _createButton(e, t) {
                const i = n.create("button", e, this._container);
                return i.type = "button", i.addEventListener("click", t), i;
            }
        }, e.Popup = class extends t.E {
            constructor(e){
                super(), this._updateOpacity = ()=>{
                    void 0 !== this.options.locationOccludedOpacity && (this._container.style.opacity = this._map.transform.isLocationOccluded(this.getLngLat()) ? `${this.options.locationOccludedOpacity}` : void 0);
                }, this.remove = ()=>(this._content && n.remove(this._content), this._container && (n.remove(this._container), delete this._container), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("mousemove", this._onMouseMove), this._map.off("mouseup", this._onMouseUp), this._map.off("drag", this._onDrag), this._map._canvasContainer.classList.remove("maplibregl-track-pointer"), delete this._map, this.fire(new t.l("close"))), this), this._onMouseUp = (e)=>{
                    this._update(e.point);
                }, this._onMouseMove = (e)=>{
                    this._update(e.point);
                }, this._onDrag = (e)=>{
                    this._update(e.point);
                }, this._update = (e)=>{
                    var t;
                    if (!this._map || !this._lngLat && !this._trackPointer || !this._content) return;
                    if (!this._container) {
                        if (this._container = n.create("div", "maplibregl-popup", this._map.getContainer()), this._tip = n.create("div", "maplibregl-popup-tip", this._container), this._container.appendChild(this._content), this.options.className) for (const e of this.options.className.split(" "))this._container.classList.add(e);
                        this._closeButton && this._closeButton.setAttribute("aria-label", this._map._getUIString("Popup.Close")), this._trackPointer && this._container.classList.add("maplibregl-popup-track-pointer");
                    }
                    if (this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._lngLat = this._map.transform.renderWorldCopies && !this._trackPointer ? Ba(this._lngLat, this._flatPos, this._map.transform) : null === (t = this._lngLat) || void 0 === t ? void 0 : t.wrap(), this._trackPointer && !e) return;
                    const i = this._flatPos = this._pos = this._trackPointer && e ? e : this._map.project(this._lngLat);
                    this._map.terrain && (this._flatPos = this._trackPointer && e ? e : this._map.transform.locationToScreenPoint(this._lngLat));
                    let r = this.options.anchor;
                    const o = Ka(this.options.offset);
                    if (!r) {
                        const e = this._container.offsetWidth, t = this._container.offsetHeight;
                        let a;
                        a = i.y + o.bottom.y < t ? [
                            "top"
                        ] : i.y > this._map.transform.height - t ? [
                            "bottom"
                        ] : [], i.x < e / 2 ? a.push("left") : i.x > this._map.transform.width - e / 2 && a.push("right"), r = 0 === a.length ? "bottom" : a.join("-");
                    }
                    let a = i.add(o[r]);
                    this.options.subpixelPositioning || (a = a.round()), n.setTransform(this._container, `${Oa[r]} translate(${a.x}px,${a.y}px)`), ja(this._container, r, "popup"), this._updateOpacity();
                }, this._onClose = ()=>{
                    this.remove();
                }, this.options = t.e(Object.create($a), e);
            }
            addTo(e) {
                return this._map && this.remove(), this._map = e, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on("mousemove", this._onMouseMove), this._map.on("mouseup", this._onMouseUp), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")) : this._map.on("move", this._update), this.fire(new t.l("open")), this;
            }
            isOpen() {
                return !!this._map;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(e) {
                return this._lngLat = t.Q.convert(e), this._pos = null, this._flatPos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._onMouseMove), this._container && this._container.classList.remove("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.remove("maplibregl-track-pointer")), this;
            }
            trackPointer() {
                return this._trackPointer = !0, this._pos = null, this._flatPos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._onMouseMove), this._map.on("drag", this._onDrag), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")), this;
            }
            getElement() {
                return this._container;
            }
            setText(e) {
                return this.setDOMContent(document.createTextNode(e));
            }
            setHTML(e) {
                const t = document.createDocumentFragment(), i = document.createElement("body");
                let r;
                for(i.innerHTML = e; r = i.firstChild, r;)t.appendChild(r);
                return this.setDOMContent(t);
            }
            getMaxWidth() {
                var e;
                return null === (e = this._container) || void 0 === e ? void 0 : e.style.maxWidth;
            }
            setMaxWidth(e) {
                return this.options.maxWidth = e, this._update(), this;
            }
            setDOMContent(e) {
                if (this._content) for(; this._content.hasChildNodes();)this._content.firstChild && this._content.removeChild(this._content.firstChild);
                else this._content = n.create("div", "maplibregl-popup-content", this._container);
                return this._content.appendChild(e), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
            }
            addClassName(e) {
                return this._container && this._container.classList.add(e), this;
            }
            removeClassName(e) {
                return this._container && this._container.classList.remove(e), this;
            }
            setOffset(e) {
                return this.options.offset = e, this._update(), this;
            }
            toggleClassName(e) {
                if (this._container) return this._container.classList.toggle(e);
            }
            setSubpixelPositioning(e) {
                this.options.subpixelPositioning = e;
            }
            _createCloseButton() {
                this.options.closeButton && (this._closeButton = n.create("button", "maplibregl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
            }
            _focusFirstElement() {
                if (!this.options.focusAfterOpen || !this._container) return;
                const e = this._container.querySelector(Ha);
                e && e.focus();
            }
        }, e.RasterDEMTileSource = H, e.RasterTileSource = $, e.ScaleControl = class {
            constructor(e){
                this._onMove = ()=>{
                    qa(this._map, this._container, this.options);
                }, this.setUnit = (e)=>{
                    this.options.unit = e, qa(this._map, this._container, this.options);
                }, this.options = Object.assign(Object.assign({}, Va), e);
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            onAdd(e) {
                return this._map = e, this._container = n.create("div", "maplibregl-ctrl maplibregl-ctrl-scale", e.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
            }
            onRemove() {
                n.remove(this._container), this._map.off("move", this._onMove), this._map = void 0;
            }
        }, e.ScrollZoomHandler = la, e.Style = gi, e.TerrainControl = class {
            constructor(e){
                this._toggleTerrain = ()=>{
                    this._map.getTerrain() ? this._map.setTerrain(null) : this._map.setTerrain(this.options), this._updateTerrainIcon();
                }, this._updateTerrainIcon = ()=>{
                    this._terrainButton.classList.remove("maplibregl-ctrl-terrain"), this._terrainButton.classList.remove("maplibregl-ctrl-terrain-enabled"), this._map.terrain ? (this._terrainButton.classList.add("maplibregl-ctrl-terrain-enabled"), this._terrainButton.title = this._map._getUIString("TerrainControl.Disable")) : (this._terrainButton.classList.add("maplibregl-ctrl-terrain"), this._terrainButton.title = this._map._getUIString("TerrainControl.Enable"));
                }, this.options = e;
            }
            onAdd(e) {
                return this._map = e, this._container = n.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._terrainButton = n.create("button", "maplibregl-ctrl-terrain", this._container), n.create("span", "maplibregl-ctrl-icon", this._terrainButton).setAttribute("aria-hidden", "true"), this._terrainButton.type = "button", this._terrainButton.addEventListener("click", this._toggleTerrain), this._updateTerrainIcon(), this._map.on("terrain", this._updateTerrainIcon), this._container;
            }
            onRemove() {
                n.remove(this._container), this._map.off("terrain", this._updateTerrainIcon), this._map = void 0;
            }
        }, e.TwoFingersTouchPitchHandler = ra, e.TwoFingersTouchRotateHandler = ta, e.TwoFingersTouchZoomHandler = Jo, e.TwoFingersTouchZoomRotateHandler = pa, e.VectorTileSource = W, e.VideoSource = Q, e.addSourceType = (e, i)=>t._(void 0, void 0, void 0, function*() {
                if (ee(e)) throw new Error(`A source type called "${e}" already exists.`);
                ((e, t)=>{
                    J[e] = t;
                })(e, i);
            }), e.clearPrewarmedResources = function() {
            const e = L;
            e && (e.isPreloaded() && 1 === e.numActive() ? (e.release(D), L = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
        }, e.createTileMesh = Wt, e.getMaxParallelImageRequests = function() {
            return t.a.MAX_PARALLEL_IMAGE_REQUESTS;
        }, e.getRTLTextPluginStatus = function() {
            return oe().getRTLTextPluginStatus();
        }, e.getVersion = function() {
            return Xa;
        }, e.getWorkerCount = function() {
            return z.workerCount;
        }, e.getWorkerUrl = function() {
            return t.a.WORKER_URL;
        }, e.importScriptInWorkers = function(e) {
            return O().broadcast("IS", e);
        }, e.prewarm = function() {
            F().acquire(D);
        }, e.setMaxParallelImageRequests = function(e) {
            t.a.MAX_PARALLEL_IMAGE_REQUESTS = e;
        }, e.setRTLTextPlugin = function(e, t) {
            return oe().setRTLTextPlugin(e, t);
        }, e.setWorkerCount = function(e) {
            z.workerCount = e;
        }, e.setWorkerUrl = function(e) {
            t.a.WORKER_URL = e;
        };
    });
    //
    // Our custom intro provides a specialized "define()" function, called by the
    // AMD modules below, that sets up the worker blob URL and then executes the
    // main module, storing its exported value as 'maplibregl'
    var maplibregl$1 = maplibregl;
    return maplibregl$1;
});




var $1u0KT = parcelRequire("1u0KT");
"use client";
function $67986de690c27df1$export$190b15c73f607540(options) {
    const callbacks = {};
    const mapHandlerOptions = {};
    const mapReactiveOptions = {};
    for(const key in options){
        if (key.startsWith("on")) callbacks[key] = options[key];
        else if ($67986de690c27df1$var$mapHandlerNames.includes(key)) mapHandlerOptions[key] = options[key];
        else if ($67986de690c27df1$var$mapReactiveOptionNames.includes(key)) mapReactiveOptions[key] = options[key];
        else if (!key.startsWith("initial") && key !== "container" && key !== "style") throw Error(`unknown map option key ${key}`);
    }
    return [
        mapReactiveOptions,
        callbacks,
        mapHandlerOptions
    ];
}
function $67986de690c27df1$export$da4746288982e16c(props, optionKeyWhiteList) {
    const callbacks = {};
    const options = {};
    for(const key in props){
        if (optionKeyWhiteList?.includes(key)) {
            options[key] = props[key];
            continue;
        }
        if (key.startsWith("on")) callbacks[key] = props[key];
        else {
            const definitiveKey = key.startsWith("initial") ? key[7].toLowerCase() + key.substring(8) : key;
            if (options[definitiveKey]) throw new Error(`duplicate key ${definitiveKey}`);
            else options[definitiveKey] = props[key];
        }
    }
    return [
        options,
        callbacks
    ];
}
function $67986de690c27df1$export$c318821c87e22881(eventNameToCallbackName6, callbacks) {
    const activeEvents = Object.keys(eventNameToCallbackName6).filter((eventName)=>eventNameToCallbackName6[eventName] in callbacks);
    return activeEvents.sort();
}
function $67986de690c27df1$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$67986de690c27df1$export$9cb4719e2e525b7a(a[i], b[i])) return false;
        }
        return true;
    } else if (Array.isArray(b)) return false;
    if (typeof a === "object" && typeof b === "object") {
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        for (const key of aKeys){
            if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
            if (!$67986de690c27df1$export$9cb4719e2e525b7a(a[key], b[key])) return false;
        }
        return true;
    }
    return false;
}
function $67986de690c27df1$export$6e76a51429abdc33(lngLat1, lngLat2) {
    if (!lngLat1 && !lngLat2) return true;
    if (!lngLat1 || !lngLat2) return false;
    return Math.round(lngLat1.lng * 1e5) === Math.round(lngLat2.lng * 1e5) && Math.round(lngLat1.lat * 1e5) === Math.round(lngLat2.lat * 1e5);
}
function $67986de690c27df1$export$1a0834c2db5e7273(coords1, coords2) {
    if (!coords1 && !coords2) return true;
    if (!coords1 || !coords2) return false;
    const lngLat1 = (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).LngLat.convert(coords1);
    const lngLat2 = (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).LngLat.convert(coords2);
    return Math.round(lngLat1.lng * 1e5) === Math.round(lngLat2.lng * 1e5) && Math.round(lngLat1.lat * 1e5) === Math.round(lngLat2.lat * 1e5);
}
function $67986de690c27df1$export$9075cea3bef4a316(lngLat) {
    return {
        lng: lngLat.lng,
        lat: lngLat.lat
    };
}
function $67986de690c27df1$export$cb7477365ef68362(a, b) {
    const ax = Array.isArray(a) ? a[0] : a ? a.x : 0;
    const ay = Array.isArray(a) ? a[1] : a ? a.y : 0;
    const bx = Array.isArray(b) ? b[0] : b ? b.x : 0;
    const by = Array.isArray(b) ? b[1] : b ? b.y : 0;
    return ax === bx && ay === by;
}
function $67986de690c27df1$export$bca83f39213cca18(elt, prevClassNames, nextClassNames) {
    prevClassNames.forEach((name)=>{
        if (name === "") return;
        if (nextClassNames.indexOf(name) === -1) elt.classList.remove(name);
    });
    nextClassNames.forEach((name)=>{
        if (name === "") return;
        if (prevClassNames.indexOf(name) === -1 || !elt.classList.contains(name)) elt.classList.add(name);
    });
}
function $67986de690c27df1$export$d83341d6a2b86171(prevEventTypes, nextEventTypes, onSubscribe, onUnsubscribe) {
    prevEventTypes.forEach((eventName)=>{
        if (eventName !== "" && nextEventTypes.indexOf(eventName) === -1) onUnsubscribe(eventName);
    });
    nextEventTypes.forEach((eventName)=>{
        if (eventName !== "" && prevEventTypes.indexOf(eventName) === -1) onSubscribe(eventName);
    });
}
var $67986de690c27df1$var$markerHeight = 38.1;
var $67986de690c27df1$var$markerRadius = 13.5;
var $67986de690c27df1$var$linearOffset = Math.abs($67986de690c27df1$var$markerRadius) / Math.SQRT2;
var $67986de690c27df1$export$8022d542a436963b = {
    top: [
        0,
        0
    ],
    "top-left": [
        0,
        0
    ],
    "top-right": [
        0,
        0
    ],
    bottom: [
        0,
        -$67986de690c27df1$var$markerHeight
    ],
    "bottom-left": [
        $67986de690c27df1$var$linearOffset,
        ($67986de690c27df1$var$markerHeight - $67986de690c27df1$var$markerRadius + $67986de690c27df1$var$linearOffset) * -1
    ],
    "bottom-right": [
        -$67986de690c27df1$var$linearOffset,
        ($67986de690c27df1$var$markerHeight - $67986de690c27df1$var$markerRadius + $67986de690c27df1$var$linearOffset) * -1
    ],
    left: [
        $67986de690c27df1$var$markerRadius,
        ($67986de690c27df1$var$markerHeight - $67986de690c27df1$var$markerRadius) * -1
    ],
    right: [
        -$67986de690c27df1$var$markerRadius,
        ($67986de690c27df1$var$markerHeight - $67986de690c27df1$var$markerRadius) * -1
    ]
};
var $67986de690c27df1$var$gradientMarkerHeight = 50;
var $67986de690c27df1$export$7ebcd6df36973133 = {
    top: [
        0,
        0
    ],
    "top-left": [
        0,
        0
    ],
    "top-right": [
        0,
        0
    ],
    bottom: [
        0,
        -$67986de690c27df1$var$gradientMarkerHeight
    ],
    "bottom-left": [
        $67986de690c27df1$var$linearOffset,
        ($67986de690c27df1$var$gradientMarkerHeight - $67986de690c27df1$var$markerRadius + $67986de690c27df1$var$linearOffset) * -1
    ],
    "bottom-right": [
        -$67986de690c27df1$var$linearOffset,
        ($67986de690c27df1$var$gradientMarkerHeight - $67986de690c27df1$var$markerRadius + $67986de690c27df1$var$linearOffset) * -1
    ],
    left: [
        $67986de690c27df1$var$markerRadius,
        ($67986de690c27df1$var$gradientMarkerHeight - $67986de690c27df1$var$markerRadius) * -1
    ],
    right: [
        -$67986de690c27df1$var$markerRadius,
        ($67986de690c27df1$var$gradientMarkerHeight - $67986de690c27df1$var$markerRadius) * -1
    ]
};
var $67986de690c27df1$export$7e7e15c038f60dc5 = {
    version: 8,
    name: "Empty",
    sources: {},
    layers: []
};
function $67986de690c27df1$export$8b15d37bc3f197d4() {
    const characters = "abcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for(let i = 0; i < 8; i++){
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters[randomIndex];
    }
    return result;
}
// src/lib/MapManager.ts
var $67986de690c27df1$var$eventNameToCallbackName = {
    mousedown: "onMouseDown",
    mouseup: "onMouseUp",
    mouseover: "onMouseOver",
    mouseout: "onMouseOut",
    mousemove: "onMouseMove",
    mouseenter: "onMouseEnter",
    mouseleave: "onMouseLeave",
    click: "onClick",
    dblclick: "onDblClick",
    contextmenu: "onContextMenu",
    touchstart: "onTouchStart",
    touchend: "onTouchEnd",
    touchcancel: "onTouchCancel",
    touchmove: "onTouchMove",
    movestart: "onMoveStart",
    move: "onMove",
    moveend: "onMoveEnd",
    dragstart: "onDragStart",
    drag: "onDrag",
    dragend: "onDragEnd",
    zoomstart: "onZoomStart",
    zoom: "onZoom",
    zoomend: "onZoomEnd",
    rotatestart: "onRotateStart",
    rotate: "onRotate",
    rotateend: "onRotateEnd",
    pitchstart: "onPitchStart",
    pitch: "onPitch",
    pitchend: "onPitchEnd",
    wheel: "onWheel",
    resize: "onResize",
    remove: "onRemove",
    boxzoomstart: "onBoxZoomStart",
    boxzoomend: "onBoxZoomEnd",
    boxzoomcancel: "onBoxZoomCancel",
    webglcontextlost: "onWebglContextLost",
    webglcontextrestored: "onWebglContextRestored",
    load: "onLoad",
    render: "onRender",
    idle: "onIdle",
    error: "onError",
    data: "onData",
    styledata: "onStyleData",
    sourcedata: "onSourceData",
    dataloading: "onDataLoading",
    styledataloading: "onStyleDataLoading",
    sourcedataloading: "onSourceDataLoading",
    tiledataloading: "onTileDataLoading",
    styleimagemissing: "onStyleImageMissing",
    dataabort: "onDataAbort",
    sourcedataabort: "onSourceDataAbort",
    terrain: "onTerrain"
};
var $67986de690c27df1$var$mapReactiveOptionNames = [
    "maxBounds",
    "minZoom",
    "maxZoom",
    "minPitch",
    "maxPitch",
    "renderWorldCopies",
    "pixelRatio",
    "centerClampedToGround"
];
var $67986de690c27df1$var$mapHandlerNames = [
    "scrollZoom",
    "boxZoom",
    /**
   * DragRotateHandler is a composition of multiple handlers
   * MouseRotateHandler
   * MousePitchHandler (can be disabled with "pitchWithRotate" option)
   */ "dragRotate",
    // right click rotate the map (right click can optionnaly pitch the map)
    "dragPan",
    // left click pan the map
    "keyboard",
    "doubleClickZoom",
    // shift + dbl-click dezoom
    /**
   * TwoFingersTouchZoomRotateHandler is a composition of multiple handlers
   * touchZoom   : TwoFingersTouchZoomHandler
   * touchRotate : TwoFingersTouchRotateHandler (can be disabled)
   * tapDragZoom : TapDragZoomHandler
   */ "touchZoomRotate",
    "touchPitch",
    /**
   * desktop: ctrl + click to zoom
   * touch screen: two fingers to move the map
   */ "cooperativeGestures"
];
var $67986de690c27df1$var$DEFAULT_STYLE = "https://demotiles.maplibre.org/style.json";
var $67986de690c27df1$export$c521bb0b406df9a3 = class {
    reactiveOptions = {};
    handlerOptions = {};
    eventNames = [];
    callbacks;
    _map;
    padding;
    mapStyle;
    controlledSources = {};
    controlledLayers = {};
    controlledTerrain = null;
    constructor({ mapStyle: mapStyle = $67986de690c27df1$var$DEFAULT_STYLE, padding: padding }, mapProps, container){
        this.mapStyle = mapStyle;
        this.padding = padding;
        const [mapBaseOptions, callbacks] = $67986de690c27df1$export$da4746288982e16c(mapProps);
        this.callbacks = callbacks;
        const mapOptions = {
            ...mapBaseOptions,
            container: container,
            style: mapStyle
        };
        const map = new (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).Map(mapOptions);
        map.style.on("error", this._onStyleError);
        if (padding) map.setPadding(padding);
        this._map = map;
        this._updateCallbacks(callbacks);
    }
    setProps({ mapStyle: mapStyle = $67986de690c27df1$var$DEFAULT_STYLE, styleDiffing: styleDiffing = true, styleTransformStyle: styleTransformStyle, padding: padding }, mapProps) {
        const [reactiveOptions, callbacks, handlerOptions] = $67986de690c27df1$export$190b15c73f607540(mapProps);
        this._updateCallbacks(callbacks);
        this._updateStyle(mapStyle, {
            diff: styleDiffing,
            transformStyle: styleTransformStyle
        });
        this._updateReactiveOptions(reactiveOptions, {
            padding: padding
        });
        this._updateHandlers(handlerOptions);
    }
    getControlledTerrain() {
        return this.controlledTerrain;
    }
    setControlledTerrain(terrainProps) {
        this.controlledTerrain = terrainProps;
    }
    getControlledLayer(id) {
        return this.controlledLayers[id] ?? null;
    }
    setControlledLayer(id, layerProps) {
        if (!layerProps) delete this.controlledLayers[id];
        else this.controlledLayers[id] = layerProps;
    }
    getControlledSource(id) {
        return this.controlledSources[id] ?? null;
    }
    setControlledSource(id, layerProps) {
        if (!layerProps) delete this.controlledSources[id];
        else this.controlledSources[id] = layerProps;
    }
    _updateStyle(nextStyle, options) {
        const curStyle = this.mapStyle;
        if (nextStyle !== curStyle) {
            this.mapStyle = nextStyle;
            this._map.setStyle(nextStyle, {
                diff: options.diff,
                transformStyle: (prevStyle, nextStyle2)=>{
                    const prevControlledSources = prevStyle ? Object.fromEntries(Object.entries(prevStyle?.sources).filter(([sourceId])=>sourceId in this.controlledSources)) : {};
                    const prevControlledLayers = prevStyle ? prevStyle.layers.filter((layer)=>layer.id in this.controlledLayers) : [];
                    const result = {
                        ...nextStyle2,
                        sources: {
                            ...nextStyle2.sources,
                            ...prevControlledSources
                        },
                        layers: [
                            ...nextStyle2.layers,
                            ...prevControlledLayers
                        ],
                        terrain: this.controlledTerrain ? prevStyle?.terrain : nextStyle2.terrain
                    };
                    return options.transformStyle ? options.transformStyle(prevStyle, result) : result;
                }
            });
        }
    }
    _updateReactiveOptions(nextReactiveOptions, { padding: padding }) {
        const currReactiveOptions = this.reactiveOptions;
        this.reactiveOptions = nextReactiveOptions;
        for (const optionName of $67986de690c27df1$var$mapReactiveOptionNames)if (optionName in nextReactiveOptions && !$67986de690c27df1$export$9cb4719e2e525b7a(currReactiveOptions[optionName], nextReactiveOptions[optionName])) {
            const setterName = `set${optionName[0].toUpperCase()}${optionName.substring(1)}`;
            this._map[setterName](nextReactiveOptions[optionName]);
        }
        if (padding && !$67986de690c27df1$export$9cb4719e2e525b7a(this.padding, padding)) this._map.setPadding(padding);
        this.padding = padding;
    }
    _updateCallbacks(callbacks = {}) {
        this.callbacks = callbacks;
        const nextEventNames = $67986de690c27df1$export$c318821c87e22881($67986de690c27df1$var$eventNameToCallbackName, callbacks);
        if (this.eventNames.join("-") === nextEventNames.join("-")) return;
        $67986de690c27df1$export$d83341d6a2b86171(this.eventNames, nextEventNames, (eventName)=>this._map.on(eventName, this._onMapEvent), (eventName)=>this._map.off(eventName, this._onMapEvent));
        this.eventNames = nextEventNames;
    }
    _updateHandlers(nextHandlers) {
        const currHandlers = this.handlerOptions;
        this.handlerOptions = nextHandlers;
        for (const propName of $67986de690c27df1$var$mapHandlerNames){
            const nextValue = nextHandlers[propName] ?? true;
            const currValue = currHandlers[propName] ?? true;
            if (!$67986de690c27df1$export$9cb4719e2e525b7a(nextValue, currValue)) {
                if (nextValue) this._map[propName].enable(nextValue);
                else this._map[propName].disable();
            }
        }
    }
    _onStyleError = (event)=>{
        if (event.error.name !== "AbortError") console.error(event.error);
    };
    _onMapEvent = (e)=>{
        const eventType = e.type;
        const callbackName = $67986de690c27df1$var$eventNameToCallbackName[eventType];
        if (this.callbacks[callbackName]) this.callbacks[callbackName]?.(e);
        else console.info("not managed RMap event", eventType, e);
    };
    get map() {
        return this._map;
    }
    destroy() {
        this._updateCallbacks();
        this._map.remove();
    }
};
var $67986de690c27df1$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
// src/lib/MapManagers.ts
var $67986de690c27df1$var$MapManagers = class {
    _maps = {};
    _listeners = {};
    add(id, mapManager) {
        this._maps[id] = mapManager;
        this._listeners[id]?.forEach(([mounted, setMounted])=>{
            if (!mounted) setMounted(true);
        });
    }
    remove(id) {
        delete this._maps[id];
        this._listeners[id]?.forEach(([mounted, setMounted])=>{
            if (mounted) setMounted(false);
        });
    }
    get(id) {
        if (!id) return null;
        return this._maps[id] ?? null;
    }
    addListener(id, mountedState) {
        if (this._listeners[id]) this._listeners[id].push(mountedState);
        else this._listeners[id] = [
            mountedState
        ];
        const isMounted = !!this._maps[id];
        if (mountedState[0] !== isMounted) mountedState[1](isMounted);
    }
    removeListener(id, [, callback]) {
        this._listeners[id] = this._listeners[id].filter(([, cb])=>cb !== callback);
    }
};
var $67986de690c27df1$export$e20e23d2da0e68f6 = (0, $acw62.createContext)(null);
var $67986de690c27df1$export$7ee6502f18337a70 = ({ children: children })=>{
    const mapManagersRef = (0, $acw62.useRef)(null);
    if (!mapManagersRef.current) mapManagersRef.current = new $67986de690c27df1$var$MapManagers();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($67986de690c27df1$export$e20e23d2da0e68f6.Provider, {
        value: mapManagersRef,
        children: children
    });
};
var $67986de690c27df1$export$2f34e2691e6cbc62 = (0, $acw62.createContext)(null);
var $67986de690c27df1$var$childContainerStyle = {
    height: "100%"
};
var $67986de690c27df1$export$454d0ddbc3d07eed = (0, $acw62.forwardRef)(function RMap2({ children: /* RMapProps */ children, style: style, id: propsId, className: className, onMounted: onMounted, mapStyle: /* ManagerOptions */ mapStyle, styleDiffing: styleDiffing, styleTransformStyle: styleTransformStyle, padding: padding, /* MapProps */ ...mapProps }, ref) {
    const containerRef = (0, $acw62.useRef)(null);
    const needPropsUpdate = (0, $acw62.useRef)(true);
    const idRef = (0, $acw62.useRef)(propsId ?? $67986de690c27df1$export$8b15d37bc3f197d4());
    if (propsId && propsId !== idRef.current) throw new Error(`RMap id should not change. "${propsId}" "${idRef.current}". If you defined id as const string add a "key" prop to your RMap component`);
    const id = idRef.current;
    const externalMapManagersRef = (0, $acw62.useContext)($67986de690c27df1$export$e20e23d2da0e68f6);
    const localMapManagersRef = (0, $acw62.useRef)();
    if (!externalMapManagersRef && !localMapManagersRef.current) localMapManagersRef.current = new $67986de690c27df1$var$MapManagers();
    const mapManagers = externalMapManagersRef ? externalMapManagersRef.current : localMapManagersRef.current;
    const [, reRender] = (0, $acw62.useState)(0);
    $67986de690c27df1$var$useIsomorphicLayoutEffect(()=>{
        const mapManager = mapManagers.get(id);
        if (!mapManager) {
            const instance = new $67986de690c27df1$export$c521bb0b406df9a3({
                mapStyle: mapStyle,
                styleDiffing: styleDiffing,
                padding: padding
            }, mapProps, containerRef.current);
            mapManagers.add(id, instance);
            onMounted && onMounted(instance.map);
            reRender((v)=>v + 1);
            needPropsUpdate.current = false;
        } else if (needPropsUpdate.current) mapManager.setProps({
            mapStyle: mapStyle,
            padding: padding,
            styleDiffing: styleDiffing,
            styleTransformStyle: styleTransformStyle
        }, mapProps);
        else needPropsUpdate.current = true;
    });
    $67986de690c27df1$var$useIsomorphicLayoutEffect(()=>{
        return ()=>{
            const mapManager = mapManagers.get(id);
            if (mapManager) {
                mapManager.destroy();
                mapManagers.remove(id);
            }
        };
    }, []);
    (0, $acw62.useImperativeHandle)(ref, ()=>mapManagers.get(id)?.map || null, [
        id,
        mapManagers
    ]);
    $67986de690c27df1$var$useIsomorphicLayoutEffect(()=>{
        if (!className) return;
        const container = containerRef.current;
        className.split(" ").map((classItem)=>container.classList.add(classItem));
        return ()=>void className.split(" ").map((classItem)=>container.classList.remove(classItem));
    }, [
        className
    ]);
    const completeStyle = (0, $acw62.useMemo)(()=>({
            position: "relative",
            width: "100%",
            height: "100%",
            ...style
        }), [
        style
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: containerRef,
        id: id,
        style: completeStyle,
        children: mapManagers.get(id) && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($67986de690c27df1$export$2f34e2691e6cbc62.Provider, {
            value: id,
            children: externalMapManagersRef ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "maplibregl-children",
                style: $67986de690c27df1$var$childContainerStyle,
                children: children
            }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($67986de690c27df1$export$e20e23d2da0e68f6.Provider, {
                value: localMapManagersRef,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "maplibregl-children",
                    style: $67986de690c27df1$var$childContainerStyle,
                    children: children
                })
            })
        })
    });
});
function $67986de690c27df1$export$6fe804cce6711030(optionalId) {
    const mapManagersRef = (0, $acw62.useContext)($67986de690c27df1$export$e20e23d2da0e68f6);
    const currentMapId = (0, $acw62.useContext)($67986de690c27df1$export$2f34e2691e6cbc62);
    const id = optionalId ?? currentMapId;
    const mapManager = mapManagersRef?.current.get(id) ?? null;
    const mountedState = (0, $acw62.useState)(mapManager !== null);
    if (!mapManagersRef?.current) throw new Error("use useMapManager in components inside <RMap /> or inside <RMapContextProvider />");
    if (!id) throw new Error("provide an id to useMap or use inside <RMap />");
    (0, $acw62.useEffect)(()=>{
        const mapManagers = mapManagersRef.current;
        if (!mapManagers) throw new Error("mapManagers can't disappear");
        mapManagers.addListener(id, mountedState);
        return ()=>{
            mapManagers.removeListener(id, mountedState);
        };
    }, [
        id,
        mapManagersRef,
        mountedState,
        mapManager
    ]);
    return mapManager;
}
// src/hooks/useMap.ts
function $67986de690c27df1$export$86f8f9f08863e403(optionalId) {
    return $67986de690c27df1$export$6fe804cce6711030(optionalId)?.map ?? null;
}
// src/components/RMarker/RMarker.tsx
var $67986de690c27df1$var$eventNameToCallbackName2 = {
    dragstart: "onDragStart",
    drag: "onDrag",
    dragend: "onDragEnd",
    click: "onClick"
};
var $67986de690c27df1$export$8923644c6dcc0dca = (0, $acw62.memo)((0, $acw62.forwardRef)(function RMarker2(props, ref) {
    const { longitude: longitude, latitude: latitude, children: children, ...markerProps } = props;
    const map = $67986de690c27df1$export$86f8f9f08863e403();
    const [options, callbacks] = $67986de690c27df1$export$da4746288982e16c(markerProps);
    const prevOptionsRef = (0, $acw62.useRef)(options);
    const callbacksRef = (0, $acw62.useRef)();
    callbacksRef.current = callbacks;
    const marker = (0, $acw62.useMemo)(()=>{
        const completeOptions = {
            ...options,
            element: children ? document.createElement("div") : void 0
        };
        const mk = new (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).Marker(completeOptions);
        mk.setLngLat([
            longitude,
            latitude
        ]);
        return mk;
    }, []);
    const nextEventsStr = $67986de690c27df1$export$c318821c87e22881($67986de690c27df1$var$eventNameToCallbackName2, callbacks).join("-");
    (0, $acw62.useEffect)(()=>{
        function onMarkerEvent(e) {
            const eventType = e.type;
            const callbackName = $67986de690c27df1$var$eventNameToCallbackName2[eventType];
            if (callbacksRef.current?.[callbackName]) callbacksRef.current[callbackName]?.(e);
            else console.info("not managed RMarker event", eventType, e);
        }
        const eventNames = nextEventsStr.split("-");
        eventNames.forEach((eventName)=>{
            if (eventName === "click") marker.getElement().addEventListener("click", onMarkerEvent);
            else marker.on(eventName, onMarkerEvent);
        });
        return ()=>{
            eventNames.forEach((eventName)=>{
                if (eventName === "click") marker.getElement().removeEventListener("click", onMarkerEvent);
                else marker.off(eventName, onMarkerEvent);
            });
        };
    }, [
        nextEventsStr,
        marker
    ]);
    (0, $acw62.useEffect)(()=>{
        marker.addTo(map);
        return ()=>void marker.remove();
    }, []);
    const { className: className, offset: offset, draggable: draggable, clickTolerance: clickTolerance = 0, rotation: rotation, rotationAlignment: rotationAlignment, subpixelPositioning: subpixelPositioning = false, pitchAlignment: pitchAlignment, opacity: opacity, opacityWhenCovered: opacityWhenCovered } = options;
    (0, $acw62.useImperativeHandle)(ref, ()=>marker, [
        marker
    ]);
    if (prevOptionsRef.current.className !== className) $67986de690c27df1$export$bca83f39213cca18(marker._element, prevOptionsRef.current.className?.split(" ") || [], className?.split(" ") || []);
    if (marker.getLngLat().lng !== longitude || marker.getLngLat().lat !== latitude) marker.setLngLat([
        longitude,
        latitude
    ]);
    if (offset && !$67986de690c27df1$export$cb7477365ef68362(marker.getOffset(), offset)) marker.setOffset(offset);
    if (marker.isDraggable() !== draggable) marker.setDraggable(draggable);
    if (marker._clickTolerance !== clickTolerance) marker._clickTolerance = clickTolerance;
    if (marker.getRotation() !== rotation) marker.setRotation(rotation);
    if (marker.getRotationAlignment() !== rotationAlignment) marker.setRotationAlignment(rotationAlignment);
    if (marker.getPitchAlignment() !== pitchAlignment) marker.setPitchAlignment(pitchAlignment);
    if (marker._opacity !== opacity || marker._opacityWhenCovered !== opacityWhenCovered) marker.setOpacity(opacity, opacityWhenCovered);
    if (marker.setSubpixelPositioning && marker._subpixelPositioning !== subpixelPositioning) marker.setSubpixelPositioning(subpixelPositioning);
    prevOptionsRef.current = options;
    return children ? (0, $1u0KT.createPortal)(children, marker.getElement()) : null;
}));
var $67986de690c27df1$var$eventNameToCallbackName3 = {
    map_click: "onMapClick",
    map_move: "onMapMove"
};
var $67986de690c27df1$export$cc3017644f5b7cfa = (0, $acw62.memo)((0, $acw62.forwardRef)(function RPopup2(props, ref) {
    const { longitude: longitude, latitude: latitude, children: children, ...popupProps } = props;
    const map = $67986de690c27df1$export$86f8f9f08863e403();
    const [options, callbacks] = $67986de690c27df1$export$da4746288982e16c(popupProps);
    const popupRef = (0, $acw62.useRef)(null);
    const prevOptionsRef = (0, $acw62.useRef)(options);
    const currCallbacksRef = (0, $acw62.useRef)();
    currCallbacksRef.current = callbacks;
    const container = (0, $acw62.useMemo)(()=>{
        return document.createElement("div");
    }, []);
    if (!popupRef.current) {
        popupRef.current = new (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).Popup({
            ...options,
            closeButton: false,
            closeOnClick: false,
            closeOnMove: false
        });
        if (longitude !== void 0 && latitude !== void 0) popupRef.current.setLngLat([
            longitude,
            latitude
        ]);
    }
    const nextEventsStr = $67986de690c27df1$export$c318821c87e22881($67986de690c27df1$var$eventNameToCallbackName3, callbacks).join("-");
    (0, $acw62.useEffect)(()=>{
        function onPopupEvent(e) {
            const eventType = e.type;
            const callbackName = $67986de690c27df1$var$eventNameToCallbackName3[eventType] || // @ts-ignore
            $67986de690c27df1$var$eventNameToCallbackName3[`map_${eventType}`];
            if (currCallbacksRef.current?.[callbackName]) currCallbacksRef.current[callbackName]?.(e);
            else console.info("not managed RPopup event", eventType, e);
        }
        if (nextEventsStr === "") return;
        const eventNames = nextEventsStr.split("-");
        const popupStable = popupRef.current;
        eventNames.forEach((eventName)=>{
            if (eventName.startsWith("map_")) map.on(eventName.substring(4), onPopupEvent);
            else popupStable.on(eventName, onPopupEvent);
        });
        return ()=>{
            eventNames.forEach((eventName)=>{
                if (eventName.startsWith("map_")) map.off(eventName.substring(4), onPopupEvent);
                else popupStable.off(eventName, onPopupEvent);
            });
        };
    }, [
        nextEventsStr,
        map
    ]);
    (0, $acw62.useEffect)(()=>{
        popupRef.current.setDOMContent(container).addTo(map);
        return ()=>void popupRef.current.remove();
    }, [
        container,
        map
    ]);
    const { offset: offset, maxWidth: maxWidth = "240px", className: className } = options;
    (0, $acw62.useImperativeHandle)(ref, ()=>popupRef.current, [
        popupRef
    ]);
    if (popupRef.current.isOpen()) {
        if (longitude !== void 0 && latitude !== void 0 && (popupRef.current.getLngLat().lng !== longitude || popupRef.current.getLngLat().lat !== latitude)) popupRef.current.setLngLat([
            longitude,
            latitude
        ]);
        if (offset && !$67986de690c27df1$export$9cb4719e2e525b7a(popupRef.current.options.offset, offset)) popupRef.current.setOffset(offset);
        if (prevOptionsRef.current.className !== className) $67986de690c27df1$export$bca83f39213cca18(container, prevOptionsRef.current.className?.split(" ") || [], className?.split(" ") || []);
        if (popupRef.current.getMaxWidth() !== maxWidth) popupRef.current.setMaxWidth(maxWidth);
    }
    prevOptionsRef.current = options;
    return (0, $1u0KT.createPortal)(children, container);
}));
var $67986de690c27df1$var$eventNameToCallbackName4 = {
    mousedown: "onMouseDown",
    mouseup: "onMouseUp",
    mouseover: "onMouseOver",
    mouseout: "onMouseOut",
    mousemove: "onMouseMove",
    mouseenter: "onMouseEnter",
    mouseleave: "onMouseLeave",
    click: "onClick",
    dblclick: "onDblClick",
    contextmenu: "onContextMenu",
    touchstart: "onTouchStart",
    touchend: "onTouchEnd",
    touchcancel: "onTouchCancel",
    touchmove: "onTouchMove"
};
function $67986de690c27df1$var$createLayer(map, layerOptions, beforeId) {
    if (map.style?._loaded) {
        if (// BackgroundLayerSpecification and CustomLayerInterface has no source
        layerOptions.type === "background" || layerOptions.type === "custom" || // source exists for LayerSpecification who need one
        layerOptions.source && map.getSource(layerOptions.source)) {
            map.addLayer(layerOptions, beforeId && map.getLayer(beforeId) ? beforeId : void 0);
            return map.getLayer(layerOptions.id);
        }
    }
    return void 0;
}
function $67986de690c27df1$var$updateLayer(map, { beforeId: nextBeforeId, ...nextOptions }, { beforeId: prevBeforeId, ...prevOptions }) {
    if (prevOptions.type === "custom" || nextOptions.type === "custom") return;
    if (prevBeforeId !== nextBeforeId) map.moveLayer(nextOptions.id, nextBeforeId);
    if (nextOptions.type !== "background" && nextOptions.type !== "custom" && prevOptions.filter !== nextOptions.filter) map.setFilter(nextOptions.id, nextOptions.filter);
    const prevO = prevOptions;
    const nextO = nextOptions;
    if (prevO.layout !== nextO.layout) {
        if (nextO.layout) {
            for (const key of Object.keys(nextO.layout))if (nextO.layout[key] !== prevO.layout?.[key]) map.setLayoutProperty(nextOptions.id, key, nextO.layout[key]);
        }
        for(const key in prevO.layout)if (!Object.prototype.hasOwnProperty.call(nextO.layout, key)) map.setLayoutProperty(nextOptions.id, key, void 0);
    }
    if (prevO.paint !== nextO.paint) {
        if (nextO.paint) {
            for (const key of Object.keys(nextO.paint))if (nextO.paint[key] !== prevO.paint?.[key]) map.setPaintProperty(nextOptions.id, key, nextO.paint[key]);
        }
        for(const key in prevO.paint)if (!Object.prototype.hasOwnProperty.call(nextO.paint, key)) map.setPaintProperty(nextOptions.id, key, void 0);
    }
    if (prevO.minzoom !== nextO.minzoom || prevO.maxzoom !== nextO.maxzoom) {
        if (nextO.minzoom && nextO.maxzoom) map.setLayerZoomRange(nextOptions.id, nextO.minzoom, nextO.maxzoom);
    }
}
var $67986de690c27df1$export$436487146afe7e99 = (0, $acw62.memo)((0, $acw62.forwardRef)(function RLayer2(props, ref) {
    const { beforeId: beforeId, ...layerProps } = props;
    const [layerOptions, callbacks] = $67986de690c27df1$export$da4746288982e16c(layerProps, [
        "onAdd"
    ]);
    const id = layerOptions.id;
    const mapManager = $67986de690c27df1$export$6fe804cce6711030();
    if (!mapManager) throw new Error("use <RLayer /> component inside <RMap />");
    const map = mapManager.map;
    const initialLayerId = (0, $acw62.useRef)(id);
    if (id !== initialLayerId.current) throw new Error(`RLayer id should not change. "${id}" "${initialLayerId.current}". If you defined id as const string add a "key" prop to your RLayer component`);
    const prevProps = mapManager.getControlledLayer(id) ?? props;
    const [, setVersion] = (0, $acw62.useState)(0);
    const reRender = (0, $acw62.useCallback)(()=>setVersion((v)=>v + 1), []);
    if (props.type !== prevProps.type) throw new Error(`RLayer type should not change. "${props.type}" "${prevProps.type}"`);
    const callbacksRef = (0, $acw62.useRef)();
    callbacksRef.current = callbacks;
    (0, $acw62.useEffect)(()=>{
        map.on("styledata", reRender);
        if (map.style && map.style._loaded) reRender();
        return ()=>{
            map.off("styledata", reRender);
            if (map.style && map.style._loaded && map.getLayer(id)) map.removeLayer(id);
            mapManager?.setControlledLayer(id, null);
        };
    }, [
        map,
        id,
        mapManager,
        reRender
    ]);
    const nextEventsStr = $67986de690c27df1$export$c318821c87e22881($67986de690c27df1$var$eventNameToCallbackName4, callbacks).join("-");
    (0, $acw62.useEffect)(()=>{
        function onLayerEvent(e) {
            const eventType = e.type;
            const callbackName = $67986de690c27df1$var$eventNameToCallbackName4[eventType];
            if (callbacksRef.current?.[callbackName]) callbacksRef.current[callbackName]?.(e);
            else console.info("not managed RLayer event", eventType, e);
        }
        const eventNames = nextEventsStr.split("-");
        eventNames.forEach((eventName)=>{
            map.on(eventName, id, onLayerEvent);
        });
        return ()=>{
            eventNames.forEach((eventName)=>{
                map.off(eventName, id, onLayerEvent);
            });
        };
    }, [
        nextEventsStr,
        id,
        map
    ]);
    let layer = map.style?._loaded && map.getLayer(id);
    if (layer) $67986de690c27df1$var$updateLayer(map, props, prevProps);
    else {
        layer = $67986de690c27df1$var$createLayer(map, layerOptions, beforeId);
        if (layer) map.off("styledata", reRender);
    }
    (0, $acw62.useImperativeHandle)(ref, ()=>layer || null, [
        layer
    ]);
    mapManager.setControlledLayer(id, props);
    return null;
}));
function $67986de690c27df1$var$createSource(map, id, sourceOptions) {
    if (map.style?._loaded) {
        map.addSource(id, sourceOptions);
        return map.getSource(id);
    }
    return void 0;
}
function $67986de690c27df1$var$updateSource(source, nextOptions, prevOptions) {
    switch(nextOptions.type){
        case "image":
            {
                const prevO = prevOptions;
                const nextO = nextOptions;
                if (prevO.url !== nextO.url) source.updateImage({
                    url: nextO.url,
                    coordinates: nextO.coordinates
                });
                if (prevO.coordinates !== nextO.coordinates) source.setCoordinates(nextO.coordinates);
                break;
            }
        case "video":
            {
                const prevO = prevOptions;
                const nextO = nextOptions;
                if (prevO.coordinates !== nextO.coordinates) source.setCoordinates(nextO.coordinates);
                break;
            }
        case "geojson":
            {
                const prevO = prevOptions;
                const nextO = nextOptions;
                if (prevO.data !== nextO.data) source.setData(nextO.data);
                if (prevO.cluster !== nextO.cluster || prevO.clusterMaxZoom !== nextO.clusterMaxZoom || prevO.clusterRadius !== nextO.clusterRadius) source.setClusterOptions({
                    cluster: nextO.cluster,
                    clusterMaxZoom: nextO.clusterMaxZoom,
                    clusterRadius: nextO.clusterRadius
                });
                break;
            }
        case "raster":
        case "raster-dem":
        case "vector":
            {
                const prevO = prevOptions;
                const nextO = nextOptions;
                if (prevO.tiles !== nextO.tiles && nextO.tiles) source.setTiles(nextO.tiles);
                if (prevO.url !== nextO.url && nextO.url) source.setUrl(nextO.url);
                break;
            }
    }
}
var $67986de690c27df1$export$c556dc2545483cc5 = (0, $acw62.memo)((0, $acw62.forwardRef)(function RSource2(props, ref) {
    const { id: id, ...sourceOptions } = props;
    const mapManager = $67986de690c27df1$export$6fe804cce6711030();
    const map = mapManager.map;
    const initialId = (0, $acw62.useRef)(id);
    if (id !== initialId.current) throw new Error(`RSource id should not change. "${id}" "${initialId.current}". If you defined id as const string add a "key" prop to your RSource component`);
    const { id: _, ...prevOptions } = mapManager.getControlledSource(id) ?? props;
    if (sourceOptions.type !== prevOptions.type) throw new Error(`RSource type should not change. "${sourceOptions.type}" "${prevOptions.type}"`);
    const [, setVersion] = (0, $acw62.useState)(0);
    const reRender = (0, $acw62.useCallback)(()=>void setTimeout(()=>setVersion((v)=>v + 1), 0), []);
    (0, $acw62.useEffect)(()=>{
        map.on("styledata", reRender);
        if (map.style && map.style._loaded) reRender();
        return ()=>{
            map.off("styledata", reRender);
            if (map.style && map.getSource(id)) {
                const layers = map.getStyle()?.layers;
                if (layers) {
                    for (const layer of layers)if (layer.type !== "background" && layer.type !== "custom" && layer.source === id) map.removeLayer(layer.id);
                }
                map.removeSource(id);
            }
            mapManager?.setControlledSource(id, null);
        };
    }, [
        map,
        id,
        mapManager,
        reRender
    ]);
    let source = map.style?._loaded && map.getSource(id);
    if (source) $67986de690c27df1$var$updateSource(source, sourceOptions, prevOptions);
    else {
        source = $67986de690c27df1$var$createSource(map, id, sourceOptions);
        if (source) map.off("styledata", reRender);
    }
    (0, $acw62.useImperativeHandle)(ref, ()=>source || null, [
        source
    ]);
    mapManager.setControlledSource(id, props);
    return null;
}));
var $67986de690c27df1$export$ecea4fb6818c8b5e = (props)=>{
    const terrainOptions = props;
    const mapManager = $67986de690c27df1$export$6fe804cce6711030();
    const map = mapManager.map;
    const prevOptions = mapManager.getControlledTerrain() ?? props;
    const [, setVersion] = (0, $acw62.useState)(0);
    const reRender = (0, $acw62.useCallback)(()=>setVersion((v)=>v + 1), []);
    (0, $acw62.useEffect)(()=>{
        map.on("styledata", reRender);
        if (map.style && map.style._loaded) reRender();
        return ()=>{
            map.off("styledata", reRender);
            if (map.style?._loaded && map.getTerrain()) map.setTerrain(null);
            mapManager?.setControlledTerrain(null);
        };
    }, [
        map,
        mapManager,
        reRender
    ]);
    const terrain = map.style?._loaded && (map.getSource(terrainOptions.source) ? map.getTerrain() : false);
    if (terrain) {
        if (prevOptions.exaggeration !== terrainOptions.exaggeration || prevOptions.source !== terrainOptions.source) map.setTerrain(terrainOptions);
    } else if (map.style?._loaded) {
        if (map.getSource(terrainOptions.source)) {
            map.setTerrain(terrainOptions);
            map.off("styledata", reRender);
        }
    }
    mapManager.setControlledTerrain(props);
    return null;
};
// node_modules/.pnpm/@mapbox+point-geometry@1.1.0/node_modules/@mapbox/point-geometry/index.js
function $67986de690c27df1$var$Point(x, y) {
    this.x = x;
    this.y = y;
}
$67986de690c27df1$var$Point.prototype = {
    /**
   * Clone this point, returning a new point that can be modified
   * without affecting the old one.
   * @return {Point} the clone
   */ clone () {
        return new $67986de690c27df1$var$Point(this.x, this.y);
    },
    /**
   * Add this point's x & y coordinates to another point,
   * yielding a new point.
   * @param {Point} p the other point
   * @return {Point} output point
   */ add (p) {
        return this.clone()._add(p);
    },
    /**
   * Subtract this point's x & y coordinates to from point,
   * yielding a new point.
   * @param {Point} p the other point
   * @return {Point} output point
   */ sub (p) {
        return this.clone()._sub(p);
    },
    /**
   * Multiply this point's x & y coordinates by point,
   * yielding a new point.
   * @param {Point} p the other point
   * @return {Point} output point
   */ multByPoint (p) {
        return this.clone()._multByPoint(p);
    },
    /**
   * Divide this point's x & y coordinates by point,
   * yielding a new point.
   * @param {Point} p the other point
   * @return {Point} output point
   */ divByPoint (p) {
        return this.clone()._divByPoint(p);
    },
    /**
   * Multiply this point's x & y coordinates by a factor,
   * yielding a new point.
   * @param {number} k factor
   * @return {Point} output point
   */ mult (k) {
        return this.clone()._mult(k);
    },
    /**
   * Divide this point's x & y coordinates by a factor,
   * yielding a new point.
   * @param {number} k factor
   * @return {Point} output point
   */ div (k) {
        return this.clone()._div(k);
    },
    /**
   * Rotate this point around the 0, 0 origin by an angle a,
   * given in radians
   * @param {number} a angle to rotate around, in radians
   * @return {Point} output point
   */ rotate (a) {
        return this.clone()._rotate(a);
    },
    /**
   * Rotate this point around p point by an angle a,
   * given in radians
   * @param {number} a angle to rotate around, in radians
   * @param {Point} p Point to rotate around
   * @return {Point} output point
   */ rotateAround (a, p) {
        return this.clone()._rotateAround(a, p);
    },
    /**
   * Multiply this point by a 4x1 transformation matrix
   * @param {[number, number, number, number]} m transformation matrix
   * @return {Point} output point
   */ matMult (m) {
        return this.clone()._matMult(m);
    },
    /**
   * Calculate this point but as a unit vector from 0, 0, meaning
   * that the distance from the resulting point to the 0, 0
   * coordinate will be equal to 1 and the angle from the resulting
   * point to the 0, 0 coordinate will be the same as before.
   * @return {Point} unit vector point
   */ unit () {
        return this.clone()._unit();
    },
    /**
   * Compute a perpendicular point, where the new y coordinate
   * is the old x coordinate and the new x coordinate is the old y
   * coordinate multiplied by -1
   * @return {Point} perpendicular point
   */ perp () {
        return this.clone()._perp();
    },
    /**
   * Return a version of this point with the x & y coordinates
   * rounded to integers.
   * @return {Point} rounded point
   */ round () {
        return this.clone()._round();
    },
    /**
   * Return the magnitude of this point: this is the Euclidean
   * distance from the 0, 0 coordinate to this point's x and y
   * coordinates.
   * @return {number} magnitude
   */ mag () {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    },
    /**
   * Judge whether this point is equal to another point, returning
   * true or false.
   * @param {Point} other the other point
   * @return {boolean} whether the points are equal
   */ equals (other) {
        return this.x === other.x && this.y === other.y;
    },
    /**
   * Calculate the distance from this point to another point
   * @param {Point} p the other point
   * @return {number} distance
   */ dist (p) {
        return Math.sqrt(this.distSqr(p));
    },
    /**
   * Calculate the distance from this point to another point,
   * without the square root step. Useful if you're comparing
   * relative distances.
   * @param {Point} p the other point
   * @return {number} distance
   */ distSqr (p) {
        const dx = p.x - this.x, dy = p.y - this.y;
        return dx * dx + dy * dy;
    },
    /**
   * Get the angle from the 0, 0 coordinate to this point, in radians
   * coordinates.
   * @return {number} angle
   */ angle () {
        return Math.atan2(this.y, this.x);
    },
    /**
   * Get the angle from this point to another point, in radians
   * @param {Point} b the other point
   * @return {number} angle
   */ angleTo (b) {
        return Math.atan2(this.y - b.y, this.x - b.x);
    },
    /**
   * Get the angle between this point and another point, in radians
   * @param {Point} b the other point
   * @return {number} angle
   */ angleWith (b) {
        return this.angleWithSep(b.x, b.y);
    },
    /**
   * Find the angle of the two vectors, solving the formula for
   * the cross product a x b = |a||b|sin(θ) for θ.
   * @param {number} x the x-coordinate
   * @param {number} y the y-coordinate
   * @return {number} the angle in radians
   */ angleWithSep (x, y) {
        return Math.atan2(this.x * y - this.y * x, this.x * x + this.y * y);
    },
    /** @param {[number, number, number, number]} m */ _matMult (m) {
        const x = m[0] * this.x + m[1] * this.y, y = m[2] * this.x + m[3] * this.y;
        this.x = x;
        this.y = y;
        return this;
    },
    /** @param {Point} p */ _add (p) {
        this.x += p.x;
        this.y += p.y;
        return this;
    },
    /** @param {Point} p */ _sub (p) {
        this.x -= p.x;
        this.y -= p.y;
        return this;
    },
    /** @param {number} k */ _mult (k) {
        this.x *= k;
        this.y *= k;
        return this;
    },
    /** @param {number} k */ _div (k) {
        this.x /= k;
        this.y /= k;
        return this;
    },
    /** @param {Point} p */ _multByPoint (p) {
        this.x *= p.x;
        this.y *= p.y;
        return this;
    },
    /** @param {Point} p */ _divByPoint (p) {
        this.x /= p.x;
        this.y /= p.y;
        return this;
    },
    _unit () {
        this._div(this.mag());
        return this;
    },
    _perp () {
        const y = this.y;
        this.y = this.x;
        this.x = -y;
        return this;
    },
    /** @param {number} angle */ _rotate (angle) {
        const cos = Math.cos(angle), sin = Math.sin(angle), x = cos * this.x - sin * this.y, y = sin * this.x + cos * this.y;
        this.x = x;
        this.y = y;
        return this;
    },
    /**
   * @param {number} angle
   * @param {Point} p
   */ _rotateAround (angle, p) {
        const cos = Math.cos(angle), sin = Math.sin(angle), x = p.x + cos * (this.x - p.x) - sin * (this.y - p.y), y = p.y + sin * (this.x - p.x) + cos * (this.y - p.y);
        this.x = x;
        this.y = y;
        return this;
    },
    _round () {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    },
    constructor: $67986de690c27df1$var$Point
};
$67986de690c27df1$var$Point.convert = function(p) {
    if (p instanceof $67986de690c27df1$var$Point) return /** @type {Point} */ p;
    if (Array.isArray(p)) return new $67986de690c27df1$var$Point(+p[0], +p[1]);
    if (p.x !== void 0 && p.y !== void 0) return new $67986de690c27df1$var$Point(+p.x, +p.y);
    throw new Error("Expected [x, y] or {x, y} point format");
};
// src/maplibre-core/util/dom.ts
var $67986de690c27df1$var$DOM = class _DOM {
    static docStyle = typeof window !== "undefined" && window.document && window.document.documentElement.style;
    static userSelect;
    static selectProp = _DOM.testProp([
        "userSelect",
        "MozUserSelect",
        "WebkitUserSelect",
        "msUserSelect"
    ]);
    static transformProp = _DOM.testProp([
        "transform",
        "WebkitTransform"
    ]);
    static testProp(props) {
        if (!_DOM.docStyle) return props[0];
        for(let i = 0; i < props.length; i++){
            if (props[i] in _DOM.docStyle) return props[i];
        }
        return props[0];
    }
    static create(tagName, className, container) {
        const el = window.document.createElement(tagName);
        if (className !== void 0) el.className = className;
        if (container) container.appendChild(el);
        return el;
    }
    static createNS(namespaceURI, tagName) {
        const el = window.document.createElementNS(namespaceURI, tagName);
        return el;
    }
    static disableDrag() {
        if (_DOM.docStyle && _DOM.selectProp) {
            _DOM.userSelect = _DOM.docStyle[_DOM.selectProp];
            _DOM.docStyle[_DOM.selectProp] = "none";
        }
    }
    static enableDrag() {
        if (_DOM.docStyle && _DOM.selectProp) _DOM.docStyle[_DOM.selectProp] = _DOM.userSelect;
    }
    static setTransform(el, value) {
        el.style[_DOM.transformProp] = value;
    }
    static addEventListener(target, type, callback, options = {}) {
        if ("passive" in options) target.addEventListener(type, callback, options);
        else target.addEventListener(type, callback, options.capture);
    }
    static removeEventListener(target, type, callback, options = {}) {
        if ("passive" in options) target.removeEventListener(type, callback, options);
        else target.removeEventListener(type, callback, options.capture);
    }
    // Suppress the next click, but only if it's immediate.
    // @ts-ignore
    static suppressClickInternal(e) {
        e.preventDefault();
        e.stopPropagation();
        window.removeEventListener("click", _DOM.suppressClickInternal, true);
    }
    static suppressClick() {
        window.addEventListener("click", _DOM.suppressClickInternal, true);
        window.setTimeout(()=>{
            window.removeEventListener("click", _DOM.suppressClickInternal, true);
        }, 0);
    }
    static getScale(element) {
        const rect = element.getBoundingClientRect();
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    static getPoint(el, scale, e) {
        const rect = scale.boundingClientRect;
        return new $67986de690c27df1$var$Point(// rect.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - rect.left) / scale.x - el.clientLeft, (e.clientY - rect.top) / scale.y - el.clientTop);
    }
    static mousePos(el, e) {
        const scale = _DOM.getScale(el);
        return _DOM.getPoint(el, scale, e);
    }
    static touchPos(el, touches) {
        const points = [];
        const scale = _DOM.getScale(el);
        for(let i = 0; i < touches.length; i++)points.push(_DOM.getPoint(el, scale, touches[i]));
        return points;
    }
    static mouseButton(e) {
        return e.button;
    }
    static remove(node) {
        if (node.parentNode) node.parentNode.removeChild(node);
    }
};
// src/components/RGradientMarker/GradientMarker.ts
var $67986de690c27df1$var$defaultColor = "#ffe64b";
var $67986de690c27df1$var$defaultHeight = 50;
var $67986de690c27df1$export$41b0a9d4e98b129b = class extends (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).Marker {
    _interactive;
    _shape;
    _icon;
    _height = $67986de690c27df1$var$defaultHeight;
    _text;
    _circleElement = null;
    _iconElement = null;
    _textElement = null;
    _markerElement;
    constructor(options){
        options ??= {};
        options.element = $67986de690c27df1$var$DOM.create("div", "maplibregl-gradient-marker");
        if (options.className) options.element.classList.add(options.className);
        super(options);
        if (this._draggable) this._element.classList.add("draggable");
        this._interactive = options && options.interactive === false ? false : "pending";
        this._shape = (options && options.shape) ?? "pin";
        this._color = (options && options.color) ?? $67986de690c27df1$var$defaultColor;
        this._icon = options && options.icon;
        this._text = options && options.text;
        this._defaultMarker = true;
        this._element.setAttribute("aria-label", "Map marker");
        this._element.setAttribute("tabindex", "0");
        this.setScale(this._scale);
        this.setColor(this._color);
        this._markerElement = $67986de690c27df1$var$DOM.create("div", `marker`);
        this.setShape(this._shape);
        if (this._text) this.setText(this._text);
        else if (this._icon) this.setIcon(this._icon);
        const target = $67986de690c27df1$var$DOM.create("div", "target");
        this._element.appendChild(this._markerElement);
        this._element.appendChild(target);
    }
    _onActive = ()=>{
        this._map.getContainer().addEventListener("mouseup", this._onInactive, {
            once: true
        });
        this._map.getContainer().addEventListener("touchend", this._onInactive, {
            once: true
        });
        this._element.classList.add("active");
    };
    _onInactive = ()=>{
        this._element.classList.remove("active");
    };
    addTo(map) {
        (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).Marker.prototype.addTo.apply(this, [
            map
        ]);
        if (this._interactive === "pending") this.setInteractive(true);
        return this;
    }
    setInteractive(interactive = true) {
        if (this._interactive === interactive) return;
        this._interactive = interactive;
        if (interactive) this._element.dataset.interactive = "";
        else delete this._element.dataset.interactive;
        if (interactive) {
            this._element.addEventListener("mousedown", this._onActive);
            this._element.addEventListener("touchstart", this._onActive);
        } else {
            this._element.removeEventListener("mousedown", this._onInactive);
            this._element.removeEventListener("touchstart", this._onInactive);
        }
    }
    getInteractive() {
        return this._interactive;
    }
    remove() {
        if (this._map) this.setInteractive(false);
        (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).Marker.prototype.remove.apply(this);
        return this;
    }
    setIcon(icon) {
        this.resetIconText();
        this._icon = icon;
        if (!icon) return this;
        this._circleElement = $67986de690c27df1$var$DOM.create("div", "circle", this._markerElement);
        if (typeof icon === "string") {
            this._iconElement = $67986de690c27df1$var$DOM.create("i", icon, this._markerElement);
            this._iconElement.className = icon || "";
        } else if (typeof icon === "function") {
            this._iconElement = icon();
            this._markerElement?.append(this._iconElement);
        } else {
            this._iconElement = icon;
            this._markerElement?.append(icon);
        }
        return this;
    }
    getIcon() {
        return this._icon;
    }
    resetIconText() {
        this._circleElement?.remove();
        this._iconElement?.remove();
        this._textElement?.remove();
        this._circleElement = null;
        this._iconElement = null;
        this._textElement = null;
    }
    setText(text) {
        this.resetIconText();
        this._text = text;
        if (!text) return this;
        this._circleElement = $67986de690c27df1$var$DOM.create("div", "circle", this._markerElement);
        this._textElement = $67986de690c27df1$var$DOM.create("div", "text", this._markerElement);
        this._textElement.innerText = text;
        return this;
    }
    getText() {
        return this._text;
    }
    setColor(color) {
        this._color = color || $67986de690c27df1$var$defaultColor;
        this._element.style.setProperty("--marker-color", this._color);
        return this;
    }
    getColor() {
        return this._color;
    }
    setScale(scale = 1, markerHeight2 = $67986de690c27df1$var$defaultHeight) {
        this._scale = scale;
        this._height = markerHeight2 * this._scale;
        this._element.style.setProperty("--marker-scale", scale.toString());
        return this;
    }
    getScale() {
        return this._scale;
    }
    setShape(shape) {
        this._shape = shape || "pin";
        this._anchor = this._shape === "pin" ? "bottom" : "center";
        this._element.dataset.shape = this._shape;
        this._update();
        return this;
    }
    getShape() {
        return this._shape;
    }
    setDraggable(shouldBeDraggable) {
        (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).Marker.prototype.setDraggable.apply(this, [
            shouldBeDraggable
        ]);
        this._element.classList.toggle("draggable", shouldBeDraggable);
        return this;
    }
};
var $67986de690c27df1$var$eventNameToCallbackName5 = {
    dragstart: "onDragStart",
    drag: "onDrag",
    dragend: "onDragEnd",
    click: "onClick"
};
var $67986de690c27df1$export$9c80a1fbd87b52cd = (0, $acw62.memo)((0, $acw62.forwardRef)(function RGradientMarker2(props, ref) {
    const { longitude: longitude, latitude: latitude, ...markerProps } = props;
    const map = $67986de690c27df1$export$86f8f9f08863e403();
    const [options, markerCallbacks] = $67986de690c27df1$export$da4746288982e16c(markerProps);
    const prevOptionsRef = (0, $acw62.useRef)(options);
    const currCallbacksRef = (0, $acw62.useRef)();
    currCallbacksRef.current = markerCallbacks;
    const marker = (0, $acw62.useMemo)(()=>{
        const mk = new $67986de690c27df1$export$41b0a9d4e98b129b({
            ...options,
            anchor: "bottom"
        });
        mk.setLngLat([
            longitude,
            latitude
        ]);
        return mk;
    }, []);
    const eventDepStr = $67986de690c27df1$export$c318821c87e22881($67986de690c27df1$var$eventNameToCallbackName5, markerCallbacks).join("-");
    (0, $acw62.useEffect)(()=>{
        function onGradientMarkerEvent(e) {
            const eventType = e.type;
            const callbackName = $67986de690c27df1$var$eventNameToCallbackName5[eventType];
            if (currCallbacksRef.current?.[callbackName]) currCallbacksRef.current[callbackName]?.(e);
            else console.info("not managed RGradientMarker event", eventType, e);
        }
        const eventNames = eventDepStr.split("-");
        eventNames.forEach((eventName)=>{
            if (eventName === "click") marker.getElement().addEventListener("click", onGradientMarkerEvent);
            else marker.on(eventName, onGradientMarkerEvent);
        });
        return ()=>{
            eventNames.forEach((eventName)=>{
                if (eventName === "click") marker.getElement().removeEventListener("click", onGradientMarkerEvent);
                else marker.off(eventName, onGradientMarkerEvent);
            });
        };
    }, [
        eventDepStr,
        marker
    ]);
    (0, $acw62.useEffect)(()=>{
        marker.addTo(map);
        return ()=>void marker.remove();
    }, []);
    const { scale: scale, color: color, text: text, icon: icon, interactive: interactive, className: className, draggable: draggable, clickTolerance: clickTolerance = 0, rotation: rotation, rotationAlignment: rotationAlignment, subpixelPositioning: subpixelPositioning = false, pitchAlignment: pitchAlignment, shape: shape, opacity: opacity, opacityWhenCovered: opacityWhenCovered } = options;
    (0, $acw62.useImperativeHandle)(ref, ()=>marker, [
        marker
    ]);
    if (prevOptionsRef.current.className !== className) $67986de690c27df1$export$bca83f39213cca18(marker._element, prevOptionsRef.current.className?.split(" ") || [], className?.split(" ") || []);
    if (marker.getInteractive() !== interactive) marker.setInteractive(interactive);
    if (marker.getShape() !== shape) marker.setShape(shape);
    if (marker.getLngLat().lng !== longitude || marker.getLngLat().lat !== latitude) marker.setLngLat([
        longitude,
        latitude
    ]);
    if (marker.isDraggable() !== draggable) marker.setDraggable(draggable);
    if (marker._clickTolerance !== clickTolerance) marker._clickTolerance = clickTolerance;
    if (marker.getRotation() !== rotation) marker.setRotation(rotation);
    if (marker.getRotationAlignment() !== rotationAlignment) marker.setRotationAlignment(rotationAlignment);
    if (marker.getPitchAlignment() !== pitchAlignment) marker.setPitchAlignment(pitchAlignment);
    if (marker._opacity !== opacity || marker._opacityWhenCovered !== opacityWhenCovered) marker.setOpacity(opacity, opacityWhenCovered);
    if (marker.setSubpixelPositioning && marker._subpixelPositioning !== subpixelPositioning) marker.setSubpixelPositioning(subpixelPositioning);
    if (marker.getColor() !== color) marker.setColor(color);
    if (marker.getScale() !== scale) marker.setScale(scale);
    if (marker.getText() !== text) marker.setText(text);
    if (marker.getIcon() !== icon) marker.setIcon(icon);
    prevOptionsRef.current = options;
    return null;
}));
function $67986de690c27df1$export$65f9e44c8791b8aa({ customEventName: customEventName = "contextmenu-maplibre", enabled: enabled = true }) {
    const map = $67986de690c27df1$export$86f8f9f08863e403();
    (0, $acw62.useEffect)(()=>{
        if (!enabled) return;
        const eventName = window.matchMedia("(pointer: coarse)").matches ? "click" : "contextmenu";
        function handleContextMenu(evt) {
            setTimeout(()=>{
                if (evt.defaultPrevented) return;
                const { originalEvent: originalEvent, point: point, lngLat: lngLat } = evt;
                map.getCanvasContainer().dispatchEvent(new CustomEvent(customEventName, {
                    detail: {
                        originalEvent: originalEvent,
                        point: point,
                        lngLat: lngLat,
                        emulated: eventName !== "contextmenu"
                    }
                }));
            });
        }
        map.on(eventName, handleContextMenu);
        return ()=>{
            map.off(eventName, handleContextMenu);
        };
    }, [
        map,
        enabled,
        customEventName
    ]);
    return null;
}
function $67986de690c27df1$export$c56b1355d6c7ccb7({ position: position, className: className = "maplibregl-ctrl maplibregl-ctrl-group" }) {
    const map = $67986de690c27df1$export$86f8f9f08863e403();
    const containerRef = (0, $acw62.useRef)();
    const prevOptionsRef = (0, $acw62.useRef)({
        className: className
    });
    if (!containerRef.current) {
        const ctrl = document.createElement("div");
        ctrl.className = className;
        containerRef.current = ctrl;
    }
    (0, $acw62.useEffect)(()=>{
        const ctrl = containerRef.current;
        if (ctrl && !ctrl.parentElement) {
            const positionContainer = map._controlPositions[position];
            if (!positionContainer) throw new Error(`Unable to add control, position ${position} doesn't exists`);
            if (position.indexOf("bottom") !== -1) positionContainer.insertBefore(ctrl, positionContainer.firstChild);
            else positionContainer.appendChild(ctrl);
        }
        return ()=>{
            containerRef.current && containerRef.current.remove();
        };
    }, [
        map,
        position
    ]);
    if (prevOptionsRef.current.className !== className) $67986de690c27df1$export$bca83f39213cca18(containerRef.current, prevOptionsRef.current.className?.split(" ") || [], className?.split(" ") || []);
    prevOptionsRef.current = {
        className: className
    };
    return {
        container: containerRef.current
    };
}
function $67986de690c27df1$export$724404db9982ac37({ height: height = 27 }) {
    const [duration, setDuration] = (0, $acw62.useState)("25s");
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: height * 21 / 27,
        height: height,
        viewBox: "-10.5 -10.5 21 27",
        fill: "none",
        version: "1.1",
        id: "svg3",
        xmlns: "http://www.w3.org/2000/svg",
        onMouseEnter: ()=>setDuration("2s"),
        onMouseLeave: ()=>setDuration("25s"),
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "#82b4fe",
                fillRule: "evenodd",
                d: "m 0.04378077,-7.0160133 c -3.95934197,-0.025693 -7.19979577,2.9709105 -7.22395607,6.67957072 -0.021351,3.28396108 1.6024867,4.88716988 3.3609363,6.62322508 1.2259466,1.2102943 2.5172339,2.4851233 3.36206037,4.4390285 0.056993,0.04631 0.095121,0.07722 0.1114948,0.09183 a 0.41450831,0.41450831 0 0 0 0.2727553,0.103225 0.41515047,0.41515047 0 0 0 0.2741963,-0.09961 c 0.00438,-0.0039 0.012527,-0.0074 0.022479,-0.01165 0.027304,-0.01171 0.068791,-0.02955 0.090222,-0.0789 C 1.1559887,8.7954149 2.4656545,7.5377628 3.7164045,6.3367792 5.4974902,4.626493 7.158975,3.0309869 7.1802478,-0.24301718 7.2043965,-3.9517594 4.0032063,-6.9901745 0.04378537,-7.016023 Z m -0.06903,10.6235008 C 1.9352357,3.6202595 3.5351559,2.0173639 3.5480768,0.02733852 3.5610008,-1.9626869 1.9821136,-3.5862858 0.02154667,-3.5990486 -1.9390213,-3.6118206 -3.5388592,-2.0089214 -3.5518634,-0.01889648 -3.5647874,1.9711289 -1.9858982,3.5947246 -0.02533123,3.6074875 Z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "currentColor",
                d: "m -2.4911489,12.068709 c -0.3270955,-0.0022 -0.5946317,0.359604 -0.5975214,0.807906 l -0.014767,2.269118 c -0.00295,0.448302 0.2598305,0.813445 0.587006,0.815611 l 5.0075702,0.03259 c 0.3270965,0.0022 0.5946306,-0.359606 0.5975218,-0.807909 l 0.014775,-2.269117 c 0.00304,-0.44838 -0.259831,-0.813523 -0.5870064,-0.815609 z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("g", {
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: "0",
                        cy: "0",
                        r: "2",
                        fill: "currentColor",
                        id: "circle1"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("g", {
                        stroke: "currentColor",
                        strokeWidth: "1",
                        fill: "none",
                        id: "g3",
                        children: [
                            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                                rx: "10",
                                ry: "4.5",
                                id: "ellipse1",
                                cx: "0",
                                cy: "0"
                            }),
                            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                                rx: "10",
                                ry: "4.5",
                                transform: "rotate(60)",
                                id: "ellipse2",
                                cx: "0",
                                cy: "0"
                            }),
                            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                                rx: "10",
                                ry: "4.5",
                                transform: "rotate(120)",
                                id: "ellipse3",
                                cx: "0",
                                cy: "0"
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        dur: duration,
                        values: "0 0 0;360 0 0;",
                        repeatCount: "indefinite"
                    })
                ]
            })
        ]
    });
}
var $67986de690c27df1$export$2c307b2ef62b2739 = (0, $acw62.memo)(function MrcLogoControl2({ position: position = "bottom-left" }) {
    const { container: container } = $67986de690c27df1$export$c56b1355d6c7ccb7({
        position: position,
        className: "maplibregl-ctrl maplibregl-ctrl-mrc-logo"
    });
    return (0, $1u0KT.createPortal)(/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("a", {
        target: "_blank",
        rel: "noopener nofollow",
        href: "https://maplibre-react-components.pentatrion.com",
        "aria-label": "MapLibre React components logo",
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($67986de690c27df1$export$724404db9982ac37, {
            height: 30
        })
    }), container);
});
function $67986de690c27df1$var$useEventCallback(callback) {
    const ref = (0, $acw62.useRef)(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    ref.current = callback;
    return (0, $acw62.useCallback)((...args)=>ref.current?.(...args), [
        ref
    ]);
}
// src/hooks/useControl.ts
function $67986de690c27df1$export$62ad9a427fe0e7c8({ position: position = "top-right", factory: factory, onRemove: onRemove }) {
    const map = $67986de690c27df1$export$86f8f9f08863e403();
    const ctrl = (0, $acw62.useMemo)(()=>factory(map), [
        map
    ]);
    const onRemoveStable = $67986de690c27df1$var$useEventCallback(onRemove || null);
    (0, $acw62.useEffect)(()=>{
        if (!map.hasControl(ctrl)) map.addControl(ctrl, position);
        return ()=>{
            onRemoveStable && onRemoveStable(map);
            if (map.hasControl(ctrl)) map.removeControl(ctrl);
        };
    }, [
        map,
        ctrl,
        onRemoveStable,
        position
    ]);
    return ctrl;
}
// src/controls/RAttributionControl.ts
var $67986de690c27df1$export$9e77b1029f2ca2b4 = (0, $acw62.memo)((0, $acw62.forwardRef)(function RAttributionControl2({ position: position = "bottom-right", ...controlOptions }, ref) {
    const control = $67986de690c27df1$export$62ad9a427fe0e7c8({
        position: position,
        factory: ()=>new (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).AttributionControl(controlOptions)
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>control);
    return null;
}));
var $67986de690c27df1$export$ed65862fda9c58fb = (0, $acw62.memo)((0, $acw62.forwardRef)(function RFullscreenControl2({ position: position = "top-right", ...controlOptions }, ref) {
    const control = $67986de690c27df1$export$62ad9a427fe0e7c8({
        position: position,
        factory: ()=>new (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).FullscreenControl(controlOptions)
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>control);
    return null;
}));
var $67986de690c27df1$export$42809c4f7c2431ae = (0, $acw62.memo)((0, $acw62.forwardRef)(function RGeolocateControl2({ position: position = "top-right", ...controlOptions }, ref) {
    const control = $67986de690c27df1$export$62ad9a427fe0e7c8({
        position: position,
        factory: ()=>new (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).GeolocateControl(controlOptions)
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>control);
    return null;
}));
var $67986de690c27df1$export$2577021fc8737584 = (0, $acw62.memo)((0, $acw62.forwardRef)(function RGlobeControl2({ position: position = "top-right" }, ref) {
    const control = $67986de690c27df1$export$62ad9a427fe0e7c8({
        position: position,
        factory: ()=>new (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).GlobeControl()
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>control);
    return null;
}));
var $67986de690c27df1$export$a0ef8c7356b5d6aa = (0, $acw62.memo)((0, $acw62.forwardRef)(function RLogoControl2({ position: position = "bottom-left", ...controlOptions }, ref) {
    const control = $67986de690c27df1$export$62ad9a427fe0e7c8({
        position: position,
        factory: ()=>new (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).LogoControl(controlOptions)
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>control);
    return null;
}));
var $67986de690c27df1$export$ec748852f392b6c1 = (0, $acw62.memo)((0, $acw62.forwardRef)(function RNavigationControl2({ position: position = "top-right", ...controlOptions }, ref) {
    const control = $67986de690c27df1$export$62ad9a427fe0e7c8({
        position: position,
        factory: ()=>new (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).NavigationControl(controlOptions)
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>control);
    return null;
}));
var $67986de690c27df1$export$e8975d1abd28226a = (0, $acw62.memo)((0, $acw62.forwardRef)(function RScaleControl2({ position: position = "bottom-left", ...controlOptions }, ref) {
    const control = $67986de690c27df1$export$62ad9a427fe0e7c8({
        position: position,
        factory: ()=>new (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).ScaleControl(controlOptions)
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>control);
    return null;
}));
var $67986de690c27df1$export$2367adcdc65fbb5d = (0, $acw62.memo)((0, $acw62.forwardRef)(function RTerrainControl2({ position: position = "top-right", ...controlOptions }, ref) {
    const control = $67986de690c27df1$export$62ad9a427fe0e7c8({
        position: position,
        factory: ()=>new (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).TerrainControl(controlOptions)
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>control);
    return null;
}));
var $67986de690c27df1$export$c3acd9133dd6f1cb = ()=>{
    const mapRef = (0, $acw62.useRef)(null);
    const canvasRef = (0, $acw62.useRef)(null);
    const setMapAndCanvasRef = (0, $acw62.useCallback)((map)=>{
        mapRef.current = map;
        canvasRef.current = map?.getCanvasContainer();
    }, []);
    return {
        mapRef: mapRef,
        canvasRef: canvasRef,
        setMapAndCanvasRef: setMapAndCanvasRef
    };
};
var $67986de690c27df1$export$bb4e8232f26a7d7d = ()=>{
    const map = $67986de690c27df1$export$86f8f9f08863e403();
    const canvasRef = (0, $acw62.useRef)(map.getCanvasContainer());
    return canvasRef;
};


var $65d191346d2f0e85$exports = {};
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory($65d191346d2f0e85$exports);
})($65d191346d2f0e85$exports, function(exports1) {
    'use strict';
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!('_leaflet_id' in obj)) obj['_leaflet_id'] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, 'options')) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error('No value provided for variable ' + str);
            else if (typeof value === 'function') value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window['webkit' + name] || window['moz' + name] || window['ms' + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') || getPrefixed('CancelRequestAnimationFrame') || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === 'function' ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === 'undefined' || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === 'object') for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== 'string') console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== 'function') {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return 'Point(' + formatNum(this.x) + ', ' + formatNum(this.y) + ')';
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === 'object' && 'x' in x && 'y' in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === 'number' || 'x' in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === 'number' || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(',');
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return 'LatLng(' + formatNum(this.lat, precision) + ', ' + formatNum(this.lng, precision) + ')';
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== 'object') {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === 'object' && 'lat' in a) return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: 'EPSG:3857',
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: 'EPSG:900913'
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS('http://www.w3.org/2000/svg', name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = '', i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? 'z' : 'x' : '';
        }
        // SVG complains about empty path strings
        return str || 'M0 0';
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = 'ActiveXObject' in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains('webkit');
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains('android');
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains('android 2') || userAgentContains('android 3');
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains('chrome');
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains('safari');
    var phantom = userAgentContains('phantom');
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = 'OTransition' in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf('Win') === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && 'transition' in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = 'MozPerspective' in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = 'ontouchstart' in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener('testPassiveEventSupport', falseFn, opts);
            window.removeEventListener('testPassiveEventSupport', falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement('canvas').getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate('svg').createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement('div');
        div.innerHTML = '<svg/>';
        return (div.firstChild && div.firstChild.namespaceURI) === 'http://www.w3.org/2000/svg';
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement('div');
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = 'url(#default#VML)';
            return shape && typeof shape.adj === 'object';
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf('Mac') === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf('Linux') === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? 'MSPointerDown' : 'pointerdown';
    var POINTER_MOVE = Browser.msPointer ? 'MSPointerMove' : 'pointermove';
    var POINTER_UP = Browser.msPointer ? 'MSPointerUp' : 'pointerup';
    var POINTER_CANCEL = Browser.msPointer ? 'MSPointerCancel' : 'pointercancel';
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === 'touchstart') _addPointerDocListener();
        if (!handle[type]) {
            console.warn('wrong event specified:', type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn('wrong event specified:', type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = 'dblclick';
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener('dblclick', handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === 'mouse' || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener('click', simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener('dblclick', handlers.dblclick);
        obj.removeEventListener('click', handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        'transform',
        'webkitTransform',
        'OTransform',
        'MozTransform',
        'msTransform'
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        'webkitTransition',
        'transition',
        'OTransition',
        'MozTransition',
        'msTransition'
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === 'string' ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === 'auto') && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === 'auto' ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || '';
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + ' ' : '') + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ('opacity' in el.style) el.style.opacity = value;
        else if ('filter' in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = 'DXImageTransform.Microsoft.Alpha';
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + 'px';
            el.style.top = point.y + 'px';
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ('onselectstart' in document) {
        disableTextSelection = function() {
            on(window, 'selectstart', preventDefault);
        };
        enableTextSelection = function() {
            off(window, 'selectstart', preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            'userSelect',
            'WebkitUserSelect',
            'OUserSelect',
            'MozUserSelect',
            'msUserSelect'
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = 'none';
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, 'dragstart', preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, 'dragstart', preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = 'none';
        on(window, 'keydown', restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, 'keydown', restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === 'object') for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = '_leaflet_events';
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === 'object') for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        wheel: !('onwheel' in window) && 'mousewheel'
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') handler = addDoubleTapListener(obj, handler);
        else if ('addEventListener' in obj) {
            if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' || type === 'mousewheel') obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === 'mouseenter' || type === 'mouseleave') {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent('on' + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? '_' + stamp(context) : '');
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') removeDoubleTapListener(obj, handler);
        else if ('removeEventListener' in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent('on' + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, 'wheel', stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, 'mousedown touchstart dblclick contextmenu', stopPropagation);
        el['_leaflet_disable_click'] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire('start');
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire('step');
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire('end');
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === 'number' ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error('Bounds are not valid.');
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire('moveend');
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    'step': this._onPanTransitionStep,
                    'end': this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire('movestart');
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, 'leaflet-pan-anim');
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire('move').fire('moveend');
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens('moveend', this._panInsideMaxBounds)) this.off('moveend', this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on('moveend', this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire('move');
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
                } else this.fire('moveend');
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire('resize', {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire('viewreset');
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!('geolocation' in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: 'Geolocation not supported.'
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? 'permission denied' : c === 2 ? 'position unavailable' : 'timeout');
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire('locationerror', {
                code: c,
                message: 'Geolocation error: ' + message + '.'
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === 'number') data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire('locationfound', data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off('moveend', this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error('Map container is being reused by another instance');
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire('unload');
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''), pane = create$1('div', className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === 'string' ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error('Map container not found.');
            else if (container._leaflet_id) throw new Error('Map container is already initialized.');
            on(container, 'scroll', this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, 'leaflet-container' + (Browser.touch ? ' leaflet-touch' : '') + (Browser.retina ? ' leaflet-retina' : '') + (Browser.ielt9 ? ' leaflet-oldie' : '') + (Browser.safari ? ' leaflet-safari' : '') + (this._fadeAnimated ? ' leaflet-fade-anim' : ''));
            var position = getStyle(container, 'position');
            if (position !== 'absolute' && position !== 'relative' && position !== 'fixed' && position !== 'sticky') container.style.position = 'relative';
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane('mapPane', this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane('tilePane');
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane('overlayPane');
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane('shadowPane');
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane('markerPane');
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane('tooltipPane');
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane('popupPane');
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, 'leaflet-zoom-hide');
                addClass(panes.shadowPane, 'leaflet-zoom-hide');
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire('viewprereset');
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire('viewreset');
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire('load');
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire('zoomstart');
            if (!noMoveStart) this.fire('movestart');
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire('zoom', data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire('move', data);
            } else if (data && data.pinch) this.fire('zoom', data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire('zoomend');
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire('moveend');
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error('Set map center and zoom first.');
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, 'resize', this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === 'mouseout' || type === 'mouseover', src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === 'click' || type === 'preclick') && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el['_leaflet_disable_click']) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el['_leaflet_disable_events'] || e.type === 'click' && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === 'mousedown') // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            'click',
            'dblclick',
            'mouseover',
            'mouseout',
            'contextmenu'
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === 'click') {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = 'preclick';
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === 'contextmenu') preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on('load', callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire('move');
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, 'leaflet-pan-anim');
            this.fire('moveend');
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
            this._panes.mapPane.appendChild(proxy);
            this.on('zoomanim', function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on('load moveend', this._animMoveEnd, this);
            this._on('unload', this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off('load moveend', this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, 'leaflet-zoom-anim');
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire('zoomanim', {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, 'leaflet-zoom-anim');
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire('zoom');
            delete this._tempFireZoomEvent;
            this.fire('move');
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: 'topright'
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, 'leaflet-control');
            if (pos.indexOf('bottom') !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on('unload', this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off('unload', this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = 'leaflet-', container = this._controlContainer = create$1('div', l + 'control-container', this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + ' ' + l + hSide;
                corners[vSide + hSide] = create$1('div', className, container);
            }
            createCorner('top', 'left');
            createCorner('top', 'right');
            createCorner('bottom', 'left');
            createCorner('bottom', 'right');
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: 'topright',
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on('add remove', this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off('add remove', this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off('add remove', this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, 'leaflet-control-layers-expanded');
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, 'leaflet-control-layers-scrollbar');
                this._section.style.height = acceptableHeight + 'px';
            } else removeClass(this._section, 'leaflet-control-layers-scrollbar');
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, 'leaflet-control-layers-expanded');
            return this;
        },
        _initLayout: function() {
            var className = 'leaflet-control-layers', container = this._container = create$1('div', className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute('aria-haspopup', true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1('section', className + '-list');
            if (collapsed) {
                this._map.on('click', this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1('a', className + '-toggle', container);
            link.href = '#';
            link.title = 'Layers';
            link.setAttribute('role', 'button');
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1('div', className + '-base', section);
            this._separator = create$1('div', className + '-separator', section);
            this._overlaysList = create$1('div', className + '-overlays', section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on('add remove', this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === 'add' ? 'overlayadd' : 'overlayremove' : e.type === 'add' ? 'baselayerchange' : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : '') + '/>';
            var radioFragment = document.createElement('div');
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement('label'), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement('input');
                input.type = 'checkbox';
                input.className = 'leaflet-control-layers-selector';
                input.defaultChecked = checked;
            } else input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, 'click', this._onInputClick, this);
            var name = document.createElement('span');
            name.innerHTML = ' ' + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement('span');
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, 'click', preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, 'click', preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: 'topleft',
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: 'Zoom in',
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: 'Zoom out'
        },
        onAdd: function(map) {
            var zoomName = 'leaflet-control-zoom', container = create$1('div', zoomName + ' leaflet-bar'), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + '-in', container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + '-out', container, this._zoomOut);
            this._updateDisabled();
            map.on('zoomend zoomlevelschange', this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off('zoomend zoomlevelschange', this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1('a', className, container);
            link.innerHTML = html;
            link.href = '#';
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute('role', 'button');
            link.setAttribute('aria-label', title);
            disableClickPropagation(link);
            on(link, 'click', stop);
            on(link, 'click', fn, this);
            on(link, 'click', this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = 'leaflet-disabled';
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute('aria-disabled', 'false');
            this._zoomOutButton.setAttribute('aria-disabled', 'false');
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute('aria-disabled', 'true');
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute('aria-disabled', 'true');
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: 'bottomleft',
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = 'leaflet-control-scale', container = create$1('div', className), options = this.options;
            this._addScales(options, className + '-line', container);
            map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1('div', className, container);
            if (options.imperial) this._iScale = create$1('div', className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: 'bottomright',
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + ' ' : '') + 'Leaflet</a>'
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1('div', 'leaflet-control-attribution');
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on('layeradd', this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off('layeradd', this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once('remove', function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(', '));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? 'touchstart mousedown' : 'mousedown';
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, 'leaflet-zoom-anim')) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire('down');
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === 'mousedown';
            on(document, mouseevent ? 'mousemove' : 'touchmove', this._onMove, this);
            on(document, mouseevent ? 'mouseup' : 'touchend touchcancel', this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire('dragstart');
                this._moved = true;
                addClass(document.body, 'leaflet-dragging');
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, 'leaflet-drag-target');
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire('predrag', e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire('drag', e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, 'leaflet-dragging');
            if (this._lastTarget) {
                removeClass(this._lastTarget, 'leaflet-drag-target');
                this._lastTarget = null;
            }
            off(document, 'mousemove touchmove', this._onMove, this);
            off(document, 'mouseup touchend touchcancel', this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire('dragend', {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined';
    }
    function _flat(latlngs) {
        console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: 'EPSG:3395',
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: 'EPSG:4326',
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: 'overlayPane',
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once('remove', function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire('add');
            map.fire('layeradd', {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error('The provided object is not a Layer.');
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire('layerremove', {
                    layer: layer
                });
                layer.fire('remove');
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire('zoomlevelschange');
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke('setZIndex', zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire('layeradd', {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire('layerremove', {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke('setStyle', style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke('bringToFront');
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke('bringToBack');
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon('icon', oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon('shadow', oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === 'icon') throw new Error('iconUrl not set in Icon options (see the docs).');
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + 'Size'];
            if (typeof sizeOption === 'number') sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
            if (anchor) {
                img.style.marginLeft = -anchor.x + 'px';
                img.style.marginTop = -anchor.y + 'px';
            }
            if (size) {
                img.style.width = size.x + 'px';
                img.style.height = size.y + 'px';
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement('img');
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: 'marker-icon.png',
            iconRetinaUrl: 'marker-icon-2x.png',
            shadowUrl: 'marker-shadow.png',
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== 'string') IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1('div', 'leaflet-default-icon-path', document.body);
            var path = getStyle(el, 'background-image') || getStyle(el, 'backgroundImage'); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return '';
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, 'leaflet-marker-draggable');
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, 'leaflet-marker-draggable');
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire('movestart').fire('dragstart');
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire('move', e).fire('drag', e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire('moveend').fire('dragend', e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: '',
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: 'Marker',
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: 'markerPane',
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: 'shadowPane',
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on('zoomanim', this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off('zoomanim', this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === 'IMG') icon.alt = options.alt || '';
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = '0';
                icon.setAttribute('role', 'button');
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, 'focus', this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = '';
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, 'focus', this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, 'leaflet-interactive');
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: '#3388ff',
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: 'round',
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: 'round',
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: 'evenodd',
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === 'number') // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error('Circle radius cannot be NaN');
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === 'function') style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case 'Point':
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case 'MultiPoint':
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case 'LineString':
            case 'MultiLineString':
                latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case 'Polygon':
            case 'MultiPolygon':
                latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case 'GeometryCollection':
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: 'Feature',
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case 'FeatureCollection':
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error('Invalid GeoJSON object.');
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') return geojson;
        return {
            type: 'Feature',
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: 'Point',
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'LineString',
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'Polygon',
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: 'MultiPoint',
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === 'MultiPoint') return this.toMultiPoint(precision);
            var isGeometryCollection = type === 'GeometryCollection', jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === 'FeatureCollection') jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: 'GeometryCollection'
            });
            return {
                type: 'FeatureCollection',
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: '',
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: '',
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ''
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, 'leaflet-interactive');
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'IMG';
            var img = this._image = wasElementSupplied ? this._url : create$1('img');
            addClass(img, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(img, 'leaflet-zoom-animated');
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, 'load');
            img.onerror = bind(this._overlayOnError, this, 'error');
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + 'px';
            image.style.height = size.y + 'px';
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire('error');
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'VIDEO';
            var vid = this._image = wasElementSupplied ? this._url : create$1('video');
            addClass(vid, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(vid, 'leaflet-zoom-animated');
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, 'load');
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName('source');
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) vid.style['objectFit'] = 'fill';
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1('source');
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(el, 'leaflet-zoom-animated');
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: '',
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ''
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, 'leaflet-interactive');
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, 'leaflet-interactive');
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = 'hidden';
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = '';
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error('Unable to get source layer LatLng.');
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === 'function' ? this._content(this._source || this) : this._content;
            if (typeof content === 'string') node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire('contentupdate');
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + 'px';
            this._container.style.left = left + 'px';
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: 'popupPane',
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ''
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire('popupopen', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire('popupopen', {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on('preclick', stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire('popupclose', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire('popupclose', {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off('preclick', stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-popup', container = this._container = create$1('div', prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-animated');
            var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
            this._contentNode = create$1('div', prefix + '-content', wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, 'contextmenu', stopPropagation);
            this._tipContainer = create$1('div', prefix + '-tip-container', container);
            this._tip = create$1('div', prefix + '-tip', this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
                closeButton.setAttribute('role', 'button'); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute('aria-label', 'Close popup');
                closeButton.href = '#close';
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, 'click', function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = '';
            style.whiteSpace = 'nowrap';
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + 'px';
            style.whiteSpace = '';
            style.height = '';
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = 'leaflet-popup-scrolled';
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + 'px';
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire('autopanstart').panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: 'tooltipPane',
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: 'auto',
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire('tooltipopen', {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire('tooltipopen', {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire('tooltipclose', {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire('tooltipclose', {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-tooltip', className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            this._contentNode = this._container = create$1('div', className);
            this._container.setAttribute('role', 'tooltip');
            this._container.setAttribute('id', 'leaflet-tooltip-' + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === 'top') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === 'bottom') {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === 'center') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === 'right') {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === 'left') {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = 'right';
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = 'left';
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, 'leaflet-tooltip-right');
            removeClass(container, 'leaflet-tooltip-left');
            removeClass(container, 'leaflet-tooltip-top');
            removeClass(container, 'leaflet-tooltip-bottom');
            addClass(container, 'leaflet-tooltip-' + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? 'off' : 'on', events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) {
                on(el, 'focus', function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, 'blur', this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) el.setAttribute('aria-describedby', this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once('moveend', function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: 'leaflet-div-icon'
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === 'DIV' ? oldIcon : document.createElement('div'), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : '';
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + 'px ' + -bgPos.y + 'px';
            }
            this._setIconStyles(div, 'icon');
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: 'tilePane',
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: '',
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement('div');
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error('Attempted to load an infinite number of tiles');
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire('loading');
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ':' + coords.y + ':' + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(':'), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire('tileunload', {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, 'leaflet-tile');
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + 'px';
            tile.style.height = tileSize.y + 'px';
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire('tileloadstart', {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire('tileerror', {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, 'leaflet-tile-loaded');
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire('tileload', {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire('load');
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: 'abc',
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: '',
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === 'string') options.subdomains = options.subdomains.split('');
            this.on('tileunload', this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement('img');
            on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
            on(tile, 'error', bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === '') tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === 'string') tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = '';
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? '@2x' : '',
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data['y'] = invertedY;
                data['-y'] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute('src') !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire('tileabort', {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute('src', emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute('src') === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: 'WMS',
            request: 'GetMap',
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: '',
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: '',
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: 'image/jpeg',
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: '1.1.1'
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(','), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, 'leaflet-zoom-animated');
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on('update', this._updatePaths, this);
        },
        onRemove: function() {
            this.off('update', this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement('canvas');
            on(container, 'mousemove', this._onMouseMove, this);
            on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
            on(container, 'mouseout', this._handleMouseOut, this);
            container['_leaflet_disable_events'] = true;
            this._ctx = container.getContext('2d');
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + 'px';
            container.style.height = size.y + 'px';
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire('update');
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === 'string') {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || 'evenodd');
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === 'click' || e.type === 'preclick') || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, 'leaflet-interactive');
                this._fireEvent([
                    layer
                ], e, 'mouseout');
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, 'leaflet-interactive'); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, 'mouseover');
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
            return function(name) {
                return document.createElement('<lvml:' + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1('div', 'leaflet-vml-container');
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire('update');
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate('shape');
            addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
            container.coordsize = '1 1';
            layer._path = vmlCreate('path');
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate('stroke');
                container.appendChild(stroke);
                stroke.weight = options.weight + 'px';
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(' ') : options.dashArray.replace(/( *, *)/g, ' ');
                else stroke.dashStyle = '';
                stroke.endcap = options.lineCap.replace('butt', 'flat');
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate('fill');
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? 'M0 0' : 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create('svg');
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute('pointer-events', 'none');
            this._rootGroup = create('g');
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute('width', size.x);
                container.setAttribute('height', size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute('viewBox', [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(' '));
            this.fire('update');
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create('path');
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, 'leaflet-interactive');
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute('stroke', options.color);
                path.setAttribute('stroke-opacity', options.opacity);
                path.setAttribute('stroke-width', options.weight);
                path.setAttribute('stroke-linecap', options.lineCap);
                path.setAttribute('stroke-linejoin', options.lineJoin);
                if (options.dashArray) path.setAttribute('stroke-dasharray', options.dashArray);
                else path.removeAttribute('stroke-dasharray');
                if (options.dashOffset) path.setAttribute('stroke-dashoffset', options.dashOffset);
                else path.removeAttribute('stroke-dashoffset');
            } else path.setAttribute('stroke', 'none');
            if (options.fill) {
                path.setAttribute('fill', options.fillColor || options.color);
                path.setAttribute('fill-opacity', options.fillOpacity);
                path.setAttribute('fill-rule', options.fillRule || 'evenodd');
            } else path.setAttribute('fill', 'none');
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
            // drawing a circle with two half-arcs
            var d = layer._empty() ? 'M0 0' : 'M' + (p.x - r) + ',' + p.y + arc + r * 2 + ',0 ' + arc + -r * 2 + ',0 ';
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute('d', path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === 'overlayPane' || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on('unload', this._destroy, this);
        },
        addHooks: function() {
            on(this._container, 'mousedown', this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, 'mousedown', this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1('div', 'leaflet-zoom-box', this._container);
                addClass(this._container, 'leaflet-crosshair');
                this._map.fire('boxzoomstart');
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + 'px';
            this._box.style.height = size.y + 'px';
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, 'leaflet-crosshair');
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire('boxzoomend', {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on('dblclick', this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off('dblclick', this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === 'center') map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on('predrag', this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on('predrag', this._onPreDragWrap, this);
                    map.on('zoomend', this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-grab');
            removeClass(this._map._container, 'leaflet-touch-drag');
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire('movestart').fire('dragstart');
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire('move', e).fire('drag', e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire('dragend', e);
            if (noInertia) map.fire('moveend');
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire('moveend');
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook('addHandler', 'dragging', Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = '0';
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire('focus');
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire('blur');
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, 'keydown', this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, 'keydown', this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook('addHandler', 'keyboard', Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'wheel', this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, 'wheel', this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === 'center') map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'touchstart', this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, 'touchstart', this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, 'touchend', preventDefault);
                on(document, 'touchend touchcancel', this._cancelClickPrevent);
                this._simulateEvent('contextmenu', first);
            }, this), tapHoldDelay);
            on(document, 'touchend touchcancel contextmenu', this._cancel, this);
            on(document, 'touchmove', this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, 'touchend', preventDefault);
            off(document, 'touchend touchcancel', cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, 'touchend touchcancel contextmenu', this._cancel, this);
            off(document, 'touchmove', this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook('addHandler', 'tapHold', TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, 'leaflet-touch-zoom');
            on(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-touch-zoom');
            off(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== 'center') this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, 'touchmove', this._onTouchMove, this);
            on(document, 'touchend touchcancel', this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === 'center') {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, 'touchmove', this._onTouchMove, this);
            off(document, 'touchend touchcancel', this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});


function $f1201195ac35f0f9$export$ebfc23f91adaa3a1() {
    const { isPending: isPending, error: error, data: data } = (0, $4529664c1ee19d35$export$c3a687f3d6e3fb65)('stops');
    const [filterText, setFilterText] = (0, $acw62.useState)('');
    let GStops = data;
    if (isPending) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec34a5c615255cb$export$dcc7532e7120780d), {
        className: "flex justify-content-center"
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                className: "fa-solid fa-face-frown fa-5x"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            "Wyst\u0105pi\u0142 b\u0142\u0105d \u0142adowania przystank\xf3w: ",
            error.message
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39fba10236e696df$export$e310308e1c9f886), {
                filterText: filterText,
                onFilterTextChange: setFilterText,
                placeholder: "Znajd\u017A przystanek"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f1201195ac35f0f9$var$StopList, {
                filterText: filterText,
                GStops: GStops
            })
        ]
    });
}
function $f1201195ac35f0f9$var$StopList({ GStops: GStops, filterText: filterText, panelHeight: panelHeight }) {
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const dispatch = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$6bbcf3368996eea5));
    const map = (0, $67986de690c27df1$export$86f8f9f08863e403)('map-ml');
    const items = [];
    if (!map) return;
    Object.entries(GStops).forEach(([key, element])=>{
        if (element.stop_name.toLowerCase().indexOf(filterText.toLowerCase()) === -1 && /*         element.tts_stop_name.toLowerCase().indexOf(
                        filterText.toLowerCase()
                    ) === -1 && */ element.stop_id.toLowerCase().indexOf(filterText.toLowerCase()) === -1) return;
        items.push(element);
    });
    const itemTemplate = (item, options)=>{
        const className = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('hover:text-orange-700 cursor-pointer align-items-center p-2', {
            'surface-hover': options.odd
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: className,
            style: {
                height: options.props.itemSize + 'px',
                whiteSpace: 'nowrap',
                overflow: 'hidden'
            },
            onClick: ()=>{
                dispatch({
                    type: 'changed',
                    newTool: {
                        ...tool,
                        selection: item.stop_id,
                        propertyEditor: {
                            edit: item,
                            popup: true
                        }
                    }
                });
                map.jumpTo({
                    center: [
                        item.stop_lon,
                        item.stop_lat
                    ],
                    zoom: 19
                });
            },
            children: [
                "\uD83D\uDE8F ",
                item.stop_name,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a79a81cc3b591c5$export$5d8a4b9af9ca5f5b), {
                    platformCode: item.platform_code
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "text-xs text-200",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                            className: "mr-3",
                            children: item.stop_id
                        }),
                        item.stats.trips_count > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                    children: item.stats.trips_count
                                }),
                                " postoj\xf3w, ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                    children: Object.keys(item.stats.routes).length
                                }),
                                " linii."
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: "Brak postoj\xf3w na tym przystanku"
                        })
                    ]
                })
            ]
        }, item.stop_id);
    };
    const loadingTemplate = (options)=>{
        const className = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('flex align-items-center p-2', {
            odd: options.odd
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: className,
            style: {
                height: '40px'
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $844f2af056435114$export$8f31e4c4a37b8e9c), {
                width: options.even ? '60%' : '50%',
                height: "1.3rem"
            })
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50cb59e69476e4bf$export$fbd4ea7fe0fb889), {
            autoSize: true,
            items: items,
            itemSize: 50,
            itemTemplate: itemTemplate,
            showLoader: true,
            /*  delay={100} */ loadingTemplate: loadingTemplate,
            className: "border-1 surface-border border-round w-full h-full"
        })
    });
}


function $0ce9c809e1b9b543$export$6c8a70fd93e9f663() {
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    let panelHeight = '82vh';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                height: panelHeight
            },
            children: tool.propertyEditor == null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1201195ac35f0f9$export$ebfc23f91adaa3a1), {
                className: "flex align-content-center"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae224ec83d154ed8$export$a68282c78c73c3fe), {
                selectedItem: tool.propertyEditor.edit
            }, tool.propertyEditor.edit.stop_id)
        })
    });
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");





function $e2cd10a5f6773a01$export$bfbea4d618559e4a({ GRoute: GRoute }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        style: {
            display: 'inline-block',
            padding: '.3rem',
            marginRight: '.3rem',
            minWidth: '3rem',
            color: '#' + GRoute.route_text_color,
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: '#' + GRoute.route_text_color,
            backgroundColor: '#' + GRoute.route_color,
            textDecoration: GRoute.suspended ? 'line-through red solid 2px' : undefined,
            textAlign: 'center',
            opacity: GRoute.suspended ? '0.5' : '1'
        },
        children: typeof GRoute.route_short_name !== "string" || String(GRoute.route_short_name).trim().length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: GRoute.route_long_name
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
            children: GRoute.route_short_name
        })
    });
}




function $6a665a3ac8a12ef4$export$f0b439f829a094d({ GRoute: GRoute, style: style }) {
    function getRouteIco(route_type) {
        switch(route_type){
            case 0:
                return "fa-solid fa-train-tram";
            case 1:
                return "fa-solid fa-train-subway";
            case 2:
                return "fa-solid fa-train";
            case 3:
                return "fa-solid fa-bus";
            case 4:
                return "fa-solid fa-ferry";
            case 6:
                return "fa-solid fa-cable-car";
            default:
                return "fa-solid fa-route";
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        style: {
            opacity: GRoute.suspended ? '0.5' : '1',
            display: 'inline-block',
            margin: '2px',
            ...style
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
            className: getRouteIco(GRoute.route_type)
        })
    });
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $65d01f18dbe7987a$export$58d75f9829cbe158 = /*#__PURE__*/ (0, $acw62.createContext)({
    inputValues: {},
    dataUpdatedAt: {}
});






var $acw62 = parcelRequire("acw62");






function $8752d282f3fd7a50$export$7c61201097bd33b6({ resourceTable: resourceTable, selectedItemId: selectedItemId, header: header, errorText: errorText, children: children }) {
    const { isPending: isPending, error: error, data: data, dataUpdatedAt: dataUpdatedAt } = (0, $4529664c1ee19d35$export$ac3dd26b67094cc3)(resourceTable, selectedItemId);
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const dispatch = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$6bbcf3368996eea5));
    function handleExit() {
        dispatch({
            type: 'changed',
            newTool: {
                ...tool,
                propertyEditor: null,
                selection: null // odznacz zasób
            }
        });
        return true;
    }
    if (isPending || !data) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec34a5c615255cb$export$dcc7532e7120780d), {
        className: "flex justify-content-center"
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                className: "fa-solid fa-face-frown fa-5x"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            errorText,
            " ",
            error.message
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "p-3 relative w-full",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                icon: "pi pi-times",
                rounded: true,
                text: true,
                severity: "danger",
                "aria-label": "Cancel",
                className: "absolute top-0 right-0",
                onClick: handleExit
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    maxWidth: '30vw'
                },
                className: "pb-3 white-space-nowrap overflow-hidden text-overflow-ellipsis",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "fa-solid fa-pen-to-square mr-2"
                    }),
                    header
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $028ce6f6ddd144ee$export$9159ebcaf8f42267), {
                style: {
                    width: '100%',
                    height: '80vh'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $65d01f18dbe7987a$export$58d75f9829cbe158).Provider, {
                    value: {
                        inputValues: data,
                        dataUpdatedAt: dataUpdatedAt
                    },
                    children: children
                })
            })
        ]
    }, String(selectedItemId));
}



var $acw62 = parcelRequire("acw62");








'use client';
function $5a26c965a435b320$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5a26c965a435b320$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5a26c965a435b320$var$_typeof(o);
}
function $5a26c965a435b320$var$toPrimitive(t, r) {
    if ("object" != $5a26c965a435b320$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5a26c965a435b320$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $5a26c965a435b320$var$toPropertyKey(t) {
    var i = $5a26c965a435b320$var$toPrimitive(t, "string");
    return "symbol" == $5a26c965a435b320$var$_typeof(i) ? i : i + "";
}
function $5a26c965a435b320$var$_defineProperty(e, r, t) {
    return (r = $5a26c965a435b320$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $5a26c965a435b320$var$_extends() {
    return $5a26c965a435b320$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5a26c965a435b320$var$_extends.apply(null, arguments);
}
function $5a26c965a435b320$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $5a26c965a435b320$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $5a26c965a435b320$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $5a26c965a435b320$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5a26c965a435b320$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5a26c965a435b320$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5a26c965a435b320$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5a26c965a435b320$var$_slicedToArray(r, e) {
    return $5a26c965a435b320$var$_arrayWithHoles(r) || $5a26c965a435b320$var$_iterableToArrayLimit(r, e) || $5a26c965a435b320$var$_unsupportedIterableToArray(r, e) || $5a26c965a435b320$var$_nonIterableRest();
}
var $5a26c965a435b320$var$classes = {
    root: function root(_ref) {
        var props = _ref.props;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-colorpicker p-component', {
            'p-colorpicker-overlay': !props.inline
        });
    },
    input: function input(_ref2) {
        var props = _ref2.props;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-colorpicker-preview p-inputtext', props.inputClassName, {
            'p-disabled': props.disabled
        });
    },
    panel: function panel(_ref3) {
        var panelProps = _ref3.panelProps, context = _ref3.context;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-colorpicker-panel', panelProps.panelClassName, {
            'p-colorpicker-overlay-panel': !panelProps.inline,
            'p-disabled': panelProps.disabled,
            'p-input-filled': context && context.inputStyle === 'filled' || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).inputStyle === 'filled',
            'p-ripple-disabled': context && context.ripple === false || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).ripple === false
        });
    },
    content: 'p-colorpicker-content',
    hueHandle: 'p-colorpicker-hue-handle',
    hue: 'p-colorpicker-hue',
    colorHandle: 'p-colorpicker-color-handle',
    color: 'p-colorpicker-color',
    selector: 'p-colorpicker-color-selector',
    transition: 'p-connected-overlay'
};
var $5a26c965a435b320$var$styles = "\n@layer primereact {\n    .p-colorpicker {\n        display: inline-block;\n    }\n    \n    .p-colorpicker-dragging {\n        cursor: pointer;\n    }\n    \n    .p-colorpicker-overlay {\n        position: relative;\n    }\n    \n    .p-colorpicker-panel {\n        position: relative;\n        width: 193px;\n        height: 166px;\n    }\n    \n    .p-colorpicker-overlay-panel {\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n    \n    .p-colorpicker-preview {\n        cursor: pointer;\n    }\n    \n    .p-colorpicker-panel .p-colorpicker-content {\n        position: relative;\n    }\n    \n    .p-colorpicker-panel .p-colorpicker-color-selector {\n        width: 150px;\n        height: 150px;\n        top: 8px;\n        left: 8px;\n        position: absolute;\n    }\n    \n    .p-colorpicker-panel .p-colorpicker-color {\n        width: 150px;\n        height: 150px;\n    }\n    \n    .p-colorpicker-panel .p-colorpicker-color-handle {\n        position: absolute;\n        top: 0px;\n        left: 150px;\n        border-radius: 100%;\n        width: 10px;\n        height: 10px;\n        border-width: 1px;\n        border-style: solid;\n        margin: -5px 0 0 -5px;\n        cursor: pointer;\n        opacity: 0.85;\n    }\n    \n    .p-colorpicker-panel .p-colorpicker-hue {\n        width: 17px;\n        height: 150px;\n        top: 8px;\n        left: 167px;\n        position: absolute;\n        opacity: 0.85;\n    }\n    \n    .p-colorpicker-panel .p-colorpicker-hue-handle {\n        position: absolute;\n        top: 150px;\n        left: 0px;\n        width: 21px;\n        margin-left: -2px;\n        margin-top: -5px;\n        height: 10px;\n        border-width: 2px;\n        border-style: solid;\n        opacity: 0.85;\n        cursor: pointer;\n    }\n    \n    .p-colorpicker-panel .p-colorpicker-color {\n        background: linear-gradient(to top, #000 0%, rgb(0 0 0 / 0) 100%), linear-gradient(to right, #fff 0%, rgb(255 255 255 / 0) 100%)\n    }\n    .p-colorpicker-panel .p-colorpicker-hue {\n        background: linear-gradient(0deg, red 0, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, red)\n    }\n}\n";
var $5a26c965a435b320$var$ColorPickerBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'ColorPicker',
        appendTo: null,
        autoFocus: false,
        children: undefined,
        className: null,
        defaultColor: 'ff0000',
        disabled: false,
        format: 'hex',
        id: null,
        inline: false,
        inputClassName: null,
        inputId: null,
        inputRef: null,
        inputStyle: null,
        onChange: null,
        onHide: null,
        onShow: null,
        panelClassName: null,
        panelStyle: null,
        style: null,
        tabIndex: null,
        tooltip: null,
        tooltipOptions: null,
        transitionOptions: null,
        value: null
    },
    css: {
        classes: $5a26c965a435b320$var$classes,
        styles: $5a26c965a435b320$var$styles
    }
});
var $5a26c965a435b320$var$ColorPickerPanel = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var ptm = props.ptm, cx = props.cx;
    var createElement = function createElement() {
        var panelProps = mergeProps({
            className: cx('panel', {
                panelProps: props,
                context: context
            }),
            style: props.panelStyle,
            onClick: props.onClick
        }, ptm('panel', {
            hostName: props.hostName
        }));
        var transitionProps = mergeProps({
            classNames: cx('transition'),
            "in": props["in"],
            timeout: {
                enter: 120,
                exit: 100
            },
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: props.onEnter,
            onEntered: props.onEntered,
            onExit: props.onExit,
            onExited: props.onExited
        }, ptm('transition', {
            hostName: props.hostName
        }));
        return /*#__PURE__*/ $acw62.createElement((0, $17afce1b96f6eaec$export$a7a5590ad6d7af0), $5a26c965a435b320$var$_extends({
            nodeRef: ref
        }, transitionProps), /*#__PURE__*/ $acw62.createElement("div", $5a26c965a435b320$var$_extends({
            ref: ref
        }, panelProps), props.children));
    };
    var element = createElement();
    return props.inline ? element : /*#__PURE__*/ $acw62.createElement((0, $e7a3b5428092a192$export$602eac185826482c), {
        element: element,
        appendTo: props.appendTo
    });
});
$5a26c965a435b320$var$ColorPickerPanel.displayName = 'ColorPickerPanel';
function $5a26c965a435b320$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5a26c965a435b320$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5a26c965a435b320$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5a26c965a435b320$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5a26c965a435b320$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5a26c965a435b320$export$9feb1bc2e5f1ccb3 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $5a26c965a435b320$var$ColorPickerBase.getProps(inProps, context);
    var _React$useState = $acw62.useState(false), _React$useState2 = $5a26c965a435b320$var$_slicedToArray(_React$useState, 2), overlayVisibleState = _React$useState2[0], setOverlayVisibleState = _React$useState2[1];
    var _ColorPickerBase$setM = $5a26c965a435b320$var$ColorPickerBase.setMetaData({
        props: props,
        state: {
            overlayVisible: overlayVisibleState
        }
    }), ptm = _ColorPickerBase$setM.ptm, cx = _ColorPickerBase$setM.cx, isUnstyled = _ColorPickerBase$setM.isUnstyled;
    var isCloseOnEscape = overlayVisibleState && props.closeOnEscape;
    var overlayDisplayOrder = (0, $fbdf1e36fa0a01d8$export$6353a33119af9098)('overlay-panel', isCloseOnEscape);
    (0, $b76d8eda63b3c134$export$142583cb150b394)($5a26c965a435b320$var$ColorPickerBase.css.styles, isUnstyled, {
        name: 'colorpicker'
    });
    (0, $fbdf1e36fa0a01d8$export$dee4359f392495ae)({
        callback: function callback() {
            hide();
        },
        when: overlayVisibleState && overlayDisplayOrder,
        priority: [
            (0, $fbdf1e36fa0a01d8$export$5153c70e1a2d4b71).OVERLAY_PANEL,
            overlayDisplayOrder
        ]
    });
    var elementRef = $acw62.useRef(null);
    var overlayRef = $acw62.useRef(null);
    var inputRef = $acw62.useRef(props.inputRef);
    var colorSelectorRef = $acw62.useRef(null);
    var colorHandleRef = $acw62.useRef(null);
    var hueHandleRef = $acw62.useRef(null);
    var hueViewRef = $acw62.useRef(null);
    var hueDragging = $acw62.useRef(false);
    var hsbValue = $acw62.useRef(null);
    var colorDragging = $acw62.useRef(false);
    var _useOverlayListener = (0, $fbdf1e36fa0a01d8$export$2fef17345d27a5b4)({
        target: elementRef,
        overlay: overlayRef,
        listener: function listener(event, _ref) {
            var valid = _ref.valid;
            valid && hide();
        },
        when: overlayVisibleState
    }), _useOverlayListener2 = $5a26c965a435b320$var$_slicedToArray(_useOverlayListener, 2), bindOverlayListener = _useOverlayListener2[0], unbindOverlayListener = _useOverlayListener2[1];
    var _useEventListener = (0, $fbdf1e36fa0a01d8$export$7080b3e976bc91ab)({
        type: 'mousemove',
        listener: function listener(event) {
            colorDragging.current && pickColor(event);
            hueDragging.current && pickHue(event);
        }
    }), _useEventListener2 = $5a26c965a435b320$var$_slicedToArray(_useEventListener, 2), bindDocumentMouseMoveListener = _useEventListener2[0], unbindDocumentMouseMoveListener = _useEventListener2[1];
    var _useEventListener3 = (0, $fbdf1e36fa0a01d8$export$7080b3e976bc91ab)({
        type: 'mouseup',
        listener: function listener() {
            colorDragging.current = hueDragging.current = false;
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(elementRef.current, 'p-colorpicker-dragging');
            unbindDocumentMouseMoveListener();
            unbindDocumentMouseUpListener();
        }
    }), _useEventListener4 = $5a26c965a435b320$var$_slicedToArray(_useEventListener3, 2), bindDocumentMouseUpListener = _useEventListener4[0], unbindDocumentMouseUpListener = _useEventListener4[1];
    var onPanelClick = function onPanelClick(event) {
        if (!props.inline) (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).emit('overlay-click', {
            originalEvent: event,
            target: elementRef.current
        });
    };
    var onHueMousedown = function onHueMousedown(event) {
        if (props.disabled) return;
        bindDragListeners();
        onHueDragStart(event);
    };
    var onHueDragStart = function onHueDragStart(event) {
        if (props.disabled) return;
        hueDragging.current = true;
        pickHue(event);
        !isUnstyled && (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(elementRef.current, 'p-colorpicker-dragging');
    };
    var getPositionY = function getPositionY(event) {
        if (event.pageY !== undefined) return event.pageY;
        else if (event.changedTouches !== undefined) return event.changedTouches[0].pageY;
        else return 0;
    };
    var pickHue = function pickHue(event) {
        var top = hueViewRef.current.getBoundingClientRect().top + (window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0);
        var yPos = getPositionY(event);
        var hue = Math.floor(360 * (150 - Math.max(0, Math.min(150, yPos - top))) / 150);
        hsbValue.current = validateHSB({
            h: hue,
            s: hsbValue.current.s,
            b: hsbValue.current.b
        });
        updateColorSelector();
        updateHue();
        updateModel();
    };
    var onColorMousedown = function onColorMousedown(event) {
        if (props.disabled) return;
        bindDragListeners();
        onColorDragStart(event);
    };
    var onColorDragStart = function onColorDragStart(event) {
        if (props.disabled) return;
        colorDragging.current = true;
        pickColor(event);
        !isUnstyled && (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(elementRef.current, 'p-colorpicker-dragging');
        event.preventDefault();
    };
    var onDrag = function onDrag(event) {
        if (colorDragging.current) {
            pickColor(event);
            event.preventDefault();
        }
        if (hueDragging.current) {
            pickHue(event);
            event.preventDefault();
        }
    };
    var onDragEnd = function onDragEnd() {
        colorDragging.current = false;
        hueDragging.current = false;
        !isUnstyled && (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(elementRef.current, 'p-colorpicker-dragging');
        unbindDragListeners();
    };
    var bindDragListeners = function bindDragListeners() {
        bindDocumentMouseMoveListener();
        bindDocumentMouseUpListener();
    };
    var unbindDragListeners = function unbindDragListeners() {
        unbindDocumentMouseMoveListener();
        unbindDocumentMouseUpListener();
    };
    var pickColor = function pickColor(event) {
        var rect = colorSelectorRef.current.getBoundingClientRect();
        var top = rect.top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);
        var left = rect.left + document.body.scrollLeft;
        var saturation = Math.floor(100 * Math.max(0, Math.min(150, (event.pageX || event.changedTouches[0].pageX) - left)) / 150);
        var brightness = Math.floor(100 * (150 - Math.max(0, Math.min(150, (event.pageY || event.changedTouches[0].pageY) - top))) / 150);
        hsbValue.current = validateHSB({
            h: hsbValue.current.h,
            s: saturation,
            b: brightness
        });
        updateColorHandle();
        updateInput();
        updateModel();
    };
    var updateModel = function updateModel() {
        switch(props.format){
            case 'hex':
                onChange(HSBtoHEX(hsbValue.current));
                break;
            case 'rgb':
                onChange(HSBtoRGB(hsbValue.current));
                break;
            case 'hsb':
                onChange(hsbValue.current);
                break;
        }
    };
    var toHSB = function toHSB(value) {
        var hsb;
        if (value) switch(props.format){
            case 'hex':
                hsb = HEXtoHSB(value);
                break;
            case 'rgb':
                hsb = RGBtoHSB(value);
                break;
            case 'hsb':
                hsb = value;
                break;
        }
        else hsb = HEXtoHSB(props.defaultColor);
        return hsb;
    };
    var updateHSBValue = function updateHSBValue(value) {
        hsbValue.current = toHSB(value);
    };
    var onChange = function onChange(value) {
        if (props.onChange) props.onChange({
            value: value,
            stopPropagation: function stopPropagation() {},
            preventDefault: function preventDefault() {},
            target: {
                name: props.name,
                id: props.id,
                value: value
            }
        });
    };
    var updateColorSelector = function updateColorSelector() {
        if (colorSelectorRef.current) {
            var newHsbValue = validateHSB({
                h: hsbValue.current.h,
                s: 100,
                b: 100
            });
            colorSelectorRef.current.style.backgroundColor = '#' + HSBtoHEX(newHsbValue);
        }
    };
    var updateColorHandle = function updateColorHandle() {
        if (colorHandleRef.current) {
            colorHandleRef.current.style.left = Math.floor(150 * hsbValue.current.s / 100) + 'px';
            colorHandleRef.current.style.top = Math.floor(150 * (100 - hsbValue.current.b) / 100) + 'px';
        }
    };
    var updateHue = function updateHue() {
        if (hueHandleRef.current) hueHandleRef.current.style.top = Math.floor(150 - 150 * hsbValue.current.h / 360) + 'px';
    };
    var updateInput = function updateInput() {
        if (inputRef.current) inputRef.current.style.backgroundColor = '#' + HSBtoHEX(hsbValue.current);
    };
    var show = function show() {
        setOverlayVisibleState(true);
    };
    var hide = function hide() {
        setOverlayVisibleState(false);
    };
    var onOverlayEnter = function onOverlayEnter() {
        var styles = !props.inline ? {
            position: 'absolute',
            top: '0',
            left: '0'
        } : undefined;
        (0, $a73ce425265b079e$export$832931caede8e4b9).set('overlay', overlayRef.current, context && context.autoZIndex || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).autoZIndex, context && context.zIndex.overlay || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).zIndex.overlay);
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).addStyles(overlayRef.current, styles);
        alignOverlay();
    };
    var onOverlayEntered = function onOverlayEntered() {
        bindOverlayListener();
        props.onShow && props.onShow();
    };
    var onOverlayExit = function onOverlayExit() {
        unbindOverlayListener();
    };
    var onOverlayExited = function onOverlayExited() {
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(overlayRef.current);
        props.onHide && props.onHide();
    };
    var onInputClick = function onInputClick() {
        togglePanel();
    };
    var togglePanel = function togglePanel() {
        overlayVisibleState ? hide() : show();
    };
    var onInputKeydown = function onInputKeydown(event) {
        switch(event.which){
            //space
            case 32:
                togglePanel();
                event.preventDefault();
                break;
            //escape and tab
            case 27:
            case 9:
                hide();
                break;
        }
    };
    var validateHSB = function validateHSB(hsb) {
        return {
            h: Math.min(360, Math.max(0, hsb.h)),
            s: Math.min(100, Math.max(0, hsb.s)),
            b: Math.min(100, Math.max(0, hsb.b))
        };
    };
    var HEXtoRGB = function HEXtoRGB(hex) {
        var hexValue = parseInt(hex.indexOf('#') > -1 ? hex.substring(1) : hex, 16);
        return {
            r: hexValue >> 16,
            g: (hexValue & 0x00ff00) >> 8,
            b: hexValue & 0x0000ff
        };
    };
    var HEXtoHSB = function HEXtoHSB(hex) {
        return RGBtoHSB(HEXtoRGB(hex));
    };
    var RGBtoHSB = function RGBtoHSB(rgb) {
        var hsb = {
            h: 0,
            s: 0,
            b: 0
        };
        var min = Math.min(rgb.r, rgb.g, rgb.b);
        var max = Math.max(rgb.r, rgb.g, rgb.b);
        var delta = max - min;
        hsb.b = max;
        hsb.s = max !== 0 ? 255 * delta / max : 0;
        if (hsb.s !== 0) {
            if (rgb.r === max) hsb.h = (rgb.g - rgb.b) / delta;
            else if (rgb.g === max) hsb.h = 2 + (rgb.b - rgb.r) / delta;
            else hsb.h = 4 + (rgb.r - rgb.g) / delta;
        } else hsb.h = -1;
        hsb.h = hsb.h * 60;
        if (hsb.h < 0) hsb.h = hsb.h + 360;
        hsb.s = hsb.s * (100 / 255);
        hsb.b = hsb.b * (100 / 255);
        return hsb;
    };
    var HSBtoRGB = function HSBtoRGB(hsb) {
        var rgb = {
            r: null,
            g: null,
            b: null
        };
        var h = Math.round(hsb.h);
        var s = Math.round(hsb.s * 255 / 100);
        var v = Math.round(hsb.b * 255 / 100);
        if (s === 0) rgb = {
            r: v,
            g: v,
            b: v
        };
        else {
            var t1 = v;
            var t2 = (255 - s) * v / 255;
            var t3 = (t1 - t2) * (h % 60) / 60;
            if (h === 360) h = 0;
            if (h < 60) {
                rgb.r = t1;
                rgb.b = t2;
                rgb.g = t2 + t3;
            } else if (h < 120) {
                rgb.g = t1;
                rgb.b = t2;
                rgb.r = t1 - t3;
            } else if (h < 180) {
                rgb.g = t1;
                rgb.r = t2;
                rgb.b = t2 + t3;
            } else if (h < 240) {
                rgb.b = t1;
                rgb.r = t2;
                rgb.g = t1 - t3;
            } else if (h < 300) {
                rgb.b = t1;
                rgb.g = t2;
                rgb.r = t2 + t3;
            } else if (h < 360) {
                rgb.r = t1;
                rgb.g = t2;
                rgb.b = t1 - t3;
            } else {
                rgb.r = 0;
                rgb.g = 0;
                rgb.b = 0;
            }
        }
        return {
            r: Math.round(rgb.r),
            g: Math.round(rgb.g),
            b: Math.round(rgb.b)
        };
    };
    var RGBtoHEX = function RGBtoHEX(rgb) {
        var hex = [
            rgb.r.toString(16),
            rgb.g.toString(16),
            rgb.b.toString(16)
        ];
        for(var key in hex)if (hex[key].length === 1) hex[key] = '0' + hex[key];
        return hex.join('');
    };
    var HSBtoHEX = function HSBtoHEX(hsb) {
        return RGBtoHEX(HSBtoRGB(hsb));
    };
    var updateUI = function updateUI() {
        updateHue();
        updateColorHandle();
        updateInput();
        updateColorSelector();
    };
    var alignOverlay = function alignOverlay() {
        if (inputRef.current) (0, $a73ce425265b079e$export$ff8ccbac9225de62).alignOverlay(overlayRef.current, inputRef.current.parentElement, props.appendTo || context && context.appendTo || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).appendTo);
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            show: show,
            hide: hide,
            focus: function focus() {
                return (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getOverlay: function getOverlay() {
                return overlayRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            }
        };
    });
    $acw62.useEffect(function() {
        (0, $a73ce425265b079e$export$4855211e6b8ad895).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        updateHSBValue(props.value);
        updateUI();
        if (props.autoFocus) (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current, props.autoFocus);
        alignOverlay();
    });
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (!colorDragging.current && !hueDragging.current) updateHSBValue(props.value);
    }, [
        props.value
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        updateUI();
    });
    (0, $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96)(function() {
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(overlayRef.current);
    });
    var createColorSelector = function createColorSelector() {
        var selectorProps = mergeProps({
            ref: colorSelectorRef,
            className: cx('selector'),
            onMouseDown: function onMouseDown(e) {
                return onColorMousedown(e);
            },
            onTouchStart: function onTouchStart(e) {
                return onColorDragStart(e);
            },
            onTouchMove: function onTouchMove(e) {
                return onDrag(e);
            },
            onTouchEnd: onDragEnd
        }, ptm('selector'));
        var colorProps = mergeProps({
            className: cx('color')
        }, ptm('color'));
        var colorHandlerProps = mergeProps({
            ref: colorHandleRef,
            className: cx('colorHandle')
        }, ptm('colorHandle'));
        return /*#__PURE__*/ $acw62.createElement("div", selectorProps, /*#__PURE__*/ $acw62.createElement("div", colorProps, /*#__PURE__*/ $acw62.createElement("div", colorHandlerProps)));
    };
    var createHue = function createHue() {
        var hueProps = mergeProps({
            className: cx('hue'),
            onMouseDown: function onMouseDown(e) {
                return onHueMousedown(e);
            },
            onTouchStart: function onTouchStart(e) {
                return onHueDragStart(e);
            },
            onTouchMove: function onTouchMove(e) {
                return onDrag(e);
            },
            onTouchEnd: onDragEnd
        }, ptm('hue'));
        var hueHandlerProps = mergeProps({
            className: cx('hueHandle')
        }, ptm('hueHandle'));
        return /*#__PURE__*/ $acw62.createElement("div", $5a26c965a435b320$var$_extends({
            ref: hueViewRef
        }, hueProps), /*#__PURE__*/ $acw62.createElement("div", $5a26c965a435b320$var$_extends({
            ref: hueHandleRef
        }, hueHandlerProps)));
    };
    var createContent = function createContent() {
        var colorSelector = createColorSelector();
        var hue = createHue();
        var contentProps = mergeProps({
            className: cx('content')
        }, ptm('content'));
        return /*#__PURE__*/ $acw62.createElement("div", contentProps, colorSelector, hue);
    };
    var createInput = function createInput() {
        if (!props.inline) {
            var inputProps = $5a26c965a435b320$var$ColorPickerBase.getOtherProps(props);
            var _inputProps = mergeProps($5a26c965a435b320$var$_objectSpread({
                ref: inputRef,
                type: 'text',
                readOnly: true,
                className: cx('input'),
                style: props.inputStyle,
                id: props.inputId,
                tabIndex: props.tabIndex,
                disabled: props.disabled,
                onClick: onInputClick,
                onKeyDown: onInputKeydown
            }, inputProps), ptm('input'));
            return /*#__PURE__*/ $acw62.createElement("input", _inputProps);
        }
        return null;
    };
    var hasTooltip = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.tooltip);
    var content = createContent();
    var input = createInput();
    var rootProps = mergeProps({
        id: props.id,
        ref: elementRef,
        style: props.style,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root'))
    }, $5a26c965a435b320$var$ColorPickerBase.getOtherProps(props), ptm('root'));
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", rootProps, input, /*#__PURE__*/ $acw62.createElement($5a26c965a435b320$var$ColorPickerPanel, {
        hostName: "ColorPicker",
        ref: overlayRef,
        appendTo: props.appendTo,
        inline: props.inline,
        disabled: props.disabled,
        panelStyle: props.panelStyle,
        panelClassName: props.panelClassName,
        onClick: onPanelClick,
        "in": props.inline || overlayVisibleState,
        onEnter: onOverlayEnter,
        onEntered: onOverlayEntered,
        onExit: onOverlayExit,
        onExited: onOverlayExited,
        transitionOptions: props.transitionOptions,
        ptm: ptm,
        cx: cx
    }, content)), hasTooltip && /*#__PURE__*/ $acw62.createElement((0, $b74dfa9f7ee9d9bc$export$28c660c63b792dea), $5a26c965a435b320$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm('tooltip')
    }, props.tooltipOptions)));
}));
$5a26c965a435b320$export$9feb1bc2e5f1ccb3.displayName = 'ColorPicker';





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");





'use client';
function $9409b2c05480e5bc$var$_extends() {
    return $9409b2c05480e5bc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9409b2c05480e5bc$var$_extends.apply(null, arguments);
}
function $9409b2c05480e5bc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9409b2c05480e5bc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9409b2c05480e5bc$var$_typeof(o);
}
function $9409b2c05480e5bc$var$toPrimitive(t, r) {
    if ("object" != $9409b2c05480e5bc$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9409b2c05480e5bc$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9409b2c05480e5bc$var$toPropertyKey(t) {
    var i = $9409b2c05480e5bc$var$toPrimitive(t, "string");
    return "symbol" == $9409b2c05480e5bc$var$_typeof(i) ? i : i + "";
}
function $9409b2c05480e5bc$var$_defineProperty(e, r, t) {
    return (r = $9409b2c05480e5bc$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $9409b2c05480e5bc$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, checked = _ref.checked;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-inputswitch p-component', {
            'p-highlight': checked,
            'p-disabled': props.disabled,
            'p-invalid': props.invalid
        });
    },
    input: 'p-inputswitch-input',
    slider: 'p-inputswitch-slider'
};
var $9409b2c05480e5bc$var$InputSwitchBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'InputSwitch',
        autoFocus: false,
        checked: false,
        className: null,
        disabled: false,
        falseValue: false,
        id: null,
        inputId: null,
        inputRef: null,
        invalid: false,
        name: null,
        onBlur: null,
        onChange: null,
        onFocus: null,
        style: null,
        tabIndex: null,
        tooltip: null,
        tooltipOptions: null,
        trueValue: true,
        children: undefined
    },
    css: {
        classes: $9409b2c05480e5bc$var$classes
    }
});
function $9409b2c05480e5bc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9409b2c05480e5bc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9409b2c05480e5bc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9409b2c05480e5bc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9409b2c05480e5bc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9409b2c05480e5bc$export$b9b970c64c06506e = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $9409b2c05480e5bc$var$InputSwitchBase.getProps(inProps, context);
    var _InputSwitchBase$setM = $9409b2c05480e5bc$var$InputSwitchBase.setMetaData({
        props: props
    }), ptm = _InputSwitchBase$setM.ptm, cx = _InputSwitchBase$setM.cx, isUnstyled = _InputSwitchBase$setM.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($9409b2c05480e5bc$var$InputSwitchBase.css.styles, isUnstyled, {
        name: 'inputswitch'
    });
    var elementRef = $acw62.useRef(null);
    var inputRef = $acw62.useRef(props.inputRef);
    var checked = props.checked === props.trueValue;
    var onChange = function onChange(event) {
        if (props.onChange) {
            var value = checked ? props.falseValue : props.trueValue;
            props.onChange({
                originalEvent: event,
                value: value,
                stopPropagation: function stopPropagation() {
                    event === null || event === void 0 || event.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event === null || event === void 0 || event.preventDefault();
                },
                target: {
                    name: props.name,
                    id: props.id,
                    value: value
                }
            });
        }
    };
    var onFocus = function onFocus(event) {
        var _props$onFocus;
        props === null || props === void 0 || (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props, event);
    };
    var onBlur = function onBlur(event) {
        var _props$onBlur;
        props === null || props === void 0 || (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 || _props$onBlur.call(props, event);
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            focus: function focus() {
                return (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            }
        };
    });
    $acw62.useEffect(function() {
        (0, $a73ce425265b079e$export$4855211e6b8ad895).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        if (props.autoFocus) (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current, props.autoFocus);
    });
    var hasTooltip = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.tooltip);
    var otherProps = $9409b2c05480e5bc$var$InputSwitchBase.getOtherProps(props);
    var ariaProps = (0, $a73ce425265b079e$export$4855211e6b8ad895).reduceKeys(otherProps, (0, $a73ce425265b079e$export$ff8ccbac9225de62).ARIA_PROPS);
    var rootProps = mergeProps({
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root', {
            checked: checked
        })),
        style: props.style,
        role: 'checkbox',
        'aria-checked': checked,
        'data-p-highlight': checked,
        'data-p-disabled': props.disabled
    }, otherProps, ptm('root'));
    var inputProps = mergeProps($9409b2c05480e5bc$var$_objectSpread({
        type: 'checkbox',
        id: props.inputId,
        name: props.name,
        checked: checked,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        disabled: props.disabled,
        role: 'switch',
        tabIndex: props.tabIndex,
        'aria-checked': checked,
        className: cx('input')
    }, ariaProps), ptm('input'));
    var sliderProps = mergeProps({
        className: cx('slider')
    }, ptm('slider'));
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", $9409b2c05480e5bc$var$_extends({
        id: props.id,
        ref: elementRef
    }, rootProps), /*#__PURE__*/ $acw62.createElement("input", $9409b2c05480e5bc$var$_extends({
        ref: inputRef
    }, inputProps)), /*#__PURE__*/ $acw62.createElement("span", sliderProps)), hasTooltip && /*#__PURE__*/ $acw62.createElement((0, $b74dfa9f7ee9d9bc$export$28c660c63b792dea), $9409b2c05480e5bc$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm('tooltip')
    }, props.tooltipOptions)));
}));
$9409b2c05480e5bc$export$b9b970c64c06506e.displayName = 'InputSwitch';


function $c93f02bd02853250$export$e0cf7497da6814f0({ propertyName: propertyName, initialVal: initialVal, label: label, id: id, onDone: onDone }) {
    const [val, setVal] = (0, $acw62.useState)(initialVal);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: id + '-' + propertyName,
                style: {
                    display: 'block'
                },
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9409b2c05480e5bc$export$b9b970c64c06506e), {
                inputId: id + '-' + propertyName,
                checked: val,
                name: propertyName,
                onChange: (e)=>{
                    setVal(e.value);
                    onDone(propertyName, e.value);
                }
            })
        ]
    });
}






var $acw62 = parcelRequire("acw62");






'use client';
function $639e87ee01b59761$var$_extends() {
    return $639e87ee01b59761$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $639e87ee01b59761$var$_extends.apply(null, arguments);
}
function $639e87ee01b59761$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $639e87ee01b59761$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $639e87ee01b59761$var$_typeof(o);
}
function $639e87ee01b59761$var$toPrimitive(t, r) {
    if ("object" != $639e87ee01b59761$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $639e87ee01b59761$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $639e87ee01b59761$var$toPropertyKey(t) {
    var i = $639e87ee01b59761$var$toPrimitive(t, "string");
    return "symbol" == $639e87ee01b59761$var$_typeof(i) ? i : i + "";
}
function $639e87ee01b59761$var$_defineProperty(e, r, t) {
    return (r = $639e87ee01b59761$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $639e87ee01b59761$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $639e87ee01b59761$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $639e87ee01b59761$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $639e87ee01b59761$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $639e87ee01b59761$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $639e87ee01b59761$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $639e87ee01b59761$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $639e87ee01b59761$var$_slicedToArray(r, e) {
    return $639e87ee01b59761$var$_arrayWithHoles(r) || $639e87ee01b59761$var$_iterableToArrayLimit(r, e) || $639e87ee01b59761$var$_unsupportedIterableToArray(r, e) || $639e87ee01b59761$var$_nonIterableRest();
}
var $639e87ee01b59761$var$classes = {
    box: 'p-checkbox-box',
    input: 'p-checkbox-input',
    icon: 'p-checkbox-icon',
    root: function root(_ref) {
        var props = _ref.props, checked = _ref.checked, context = _ref.context;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-checkbox p-component', {
            'p-highlight': checked,
            'p-disabled': props.disabled,
            'p-invalid': props.invalid,
            'p-variant-filled': props.variant ? props.variant === 'filled' : context && context.inputStyle === 'filled'
        });
    }
};
var $639e87ee01b59761$var$CheckboxBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'Checkbox',
        autoFocus: false,
        checked: false,
        className: null,
        disabled: false,
        falseValue: false,
        icon: null,
        id: null,
        inputId: null,
        inputRef: null,
        invalid: false,
        variant: null,
        name: null,
        onChange: null,
        onContextMenu: null,
        onMouseDown: null,
        readOnly: false,
        required: false,
        style: null,
        tabIndex: null,
        tooltip: null,
        tooltipOptions: null,
        trueValue: true,
        value: null,
        children: undefined
    },
    css: {
        classes: $639e87ee01b59761$var$classes
    }
});
function $639e87ee01b59761$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $639e87ee01b59761$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $639e87ee01b59761$var$ownKeys(Object(t), !0).forEach(function(r) {
            $639e87ee01b59761$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $639e87ee01b59761$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $639e87ee01b59761$export$48513f6b9f8ce62d = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $639e87ee01b59761$var$CheckboxBase.getProps(inProps, context);
    var _React$useState = $acw62.useState(false), _React$useState2 = $639e87ee01b59761$var$_slicedToArray(_React$useState, 2), focusedState = _React$useState2[0], setFocusedState = _React$useState2[1];
    var _CheckboxBase$setMeta = $639e87ee01b59761$var$CheckboxBase.setMetaData({
        props: props,
        state: {
            focused: focusedState
        },
        context: {
            checked: props.checked === props.trueValue,
            disabled: props.disabled
        }
    }), ptm = _CheckboxBase$setMeta.ptm, cx = _CheckboxBase$setMeta.cx, isUnstyled = _CheckboxBase$setMeta.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($639e87ee01b59761$var$CheckboxBase.css.styles, isUnstyled, {
        name: 'checkbox'
    });
    var elementRef = $acw62.useRef(null);
    var inputRef = $acw62.useRef(props.inputRef);
    var isChecked = function isChecked() {
        return props.checked === props.trueValue;
    };
    var _onChange = function onChange(event) {
        if (props.disabled || props.readonly) return;
        if (props.onChange) {
            var _props$onChange;
            var _checked = isChecked();
            var value = _checked ? props.falseValue : props.trueValue;
            var eventData = {
                originalEvent: event,
                value: props.value,
                checked: value,
                stopPropagation: function stopPropagation() {
                    event === null || event === void 0 || event.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event === null || event === void 0 || event.preventDefault();
                },
                target: {
                    type: 'checkbox',
                    name: props.name,
                    id: props.id,
                    value: props.value,
                    checked: value
                }
            };
            props === null || props === void 0 || (_props$onChange = props.onChange) === null || _props$onChange === void 0 || _props$onChange.call(props, eventData);
            // do not continue if the user defined click wants to prevent
            if (event.defaultPrevented) return;
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current);
        }
    };
    var _onFocus = function onFocus() {
        var _props$onFocus;
        setFocusedState(true);
        props === null || props === void 0 || (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props);
    };
    var _onBlur = function onBlur() {
        var _props$onBlur;
        setFocusedState(false);
        props === null || props === void 0 || (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 || _props$onBlur.call(props);
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            focus: function focus() {
                return (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            }
        };
    });
    $acw62.useEffect(function() {
        (0, $a73ce425265b079e$export$4855211e6b8ad895).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        inputRef.current.checked = isChecked();
    }, [
        props.checked,
        props.trueValue
    ]);
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        if (props.autoFocus) (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current, props.autoFocus);
    });
    var checked = isChecked();
    var hasTooltip = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.tooltip);
    var otherProps = $639e87ee01b59761$var$CheckboxBase.getOtherProps(props);
    var rootProps = mergeProps({
        id: props.id,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root', {
            checked: checked,
            context: context
        })),
        style: props.style,
        'data-p-highlight': checked,
        'data-p-disabled': props.disabled,
        onContextMenu: props.onContextMenu,
        onMouseDown: props.onMouseDown
    }, otherProps, ptm('root'));
    var createInputElement = function createInputElement() {
        var ariaProps = (0, $a73ce425265b079e$export$4855211e6b8ad895).reduceKeys(otherProps, (0, $a73ce425265b079e$export$ff8ccbac9225de62).ARIA_PROPS);
        var inputProps = mergeProps($639e87ee01b59761$var$_objectSpread({
            id: props.inputId,
            type: 'checkbox',
            className: cx('input'),
            name: props.name,
            tabIndex: props.tabIndex,
            onFocus: function onFocus(e) {
                return _onFocus();
            },
            onBlur: function onBlur(e) {
                return _onBlur();
            },
            onChange: function onChange(e) {
                return _onChange(e);
            },
            disabled: props.disabled,
            readOnly: props.readOnly,
            required: props.required,
            'aria-invalid': props.invalid,
            checked: checked
        }, ariaProps), ptm('input'));
        return /*#__PURE__*/ $acw62.createElement("input", $639e87ee01b59761$var$_extends({
            ref: inputRef
        }, inputProps));
    };
    var createBoxElement = function createBoxElement() {
        var iconProps = mergeProps({
            className: cx('icon')
        }, ptm('icon'));
        var boxProps = mergeProps({
            className: cx('box', {
                checked: checked
            }),
            'data-p-highlight': checked,
            'data-p-disabled': props.disabled
        }, ptm('box'));
        var icon = checked ? props.icon || /*#__PURE__*/ $acw62.createElement((0, $ed79679a1c3e60de$export$7dd004358974b05d), iconProps) : null;
        var checkboxIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $639e87ee01b59761$var$_objectSpread({}, iconProps), {
            props: props,
            checked: checked
        });
        return /*#__PURE__*/ $acw62.createElement("div", boxProps, checkboxIcon);
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", $639e87ee01b59761$var$_extends({
        ref: elementRef
    }, rootProps), createInputElement(), createBoxElement()), hasTooltip && /*#__PURE__*/ $acw62.createElement((0, $b74dfa9f7ee9d9bc$export$28c660c63b792dea), $639e87ee01b59761$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm('tooltip')
    }, props.tooltipOptions)));
}));
$639e87ee01b59761$export$48513f6b9f8ce62d.displayName = 'Checkbox';



var $acw62 = parcelRequire("acw62");
function $7fb0fd4947ad04b9$export$970da85b7539806d({ propertyName: propertyName, initialVal: initialVal, label: label, id: id, onDone: onDone }) {
    const [val, setVal] = (0, $acw62.useState)(initialVal);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex align-items-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639e87ee01b59761$export$48513f6b9f8ce62d), {
                onChange: (e)=>{
                    setVal(e.checked);
                    onDone(propertyName, e.checked);
                },
                inputId: id + '-' + propertyName,
                checked: val,
                name: propertyName
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: id + '-' + propertyName,
                className: "ml-2",
                children: label
            })
        ]
    });
}





parcelRequire("acw62");


const $4b972aed698e51d9$var$routeTypeOptions = [
    {
        name: 'Tramwajowa',
        value: 0
    },
    {
        name: 'Metro',
        value: 1
    },
    {
        name: 'Kolejowa',
        value: 2
    },
    {
        name: 'Autobusowa',
        value: 3
    },
    {
        name: 'Prom, statek, tramwaj wodny',
        value: 4
    },
    {
        name: 'Kolej linowa, gondolowa, podwieszana',
        value: 6
    },
    {
        name: 'Kolej linowo-terenowa',
        value: 7
    },
    {
        name: 'Trolejbusowa',
        value: 11
    },
    {
        name: 'Monorail (kolej jednoszynowa)',
        value: 12
    }
];
const $4b972aed698e51d9$var$routeTypeOptionTemplate = (option)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex align-items-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a665a3ac8a12ef4$export$f0b439f829a094d), {
                GRoute: {
                    route_type: option.value,
                    suspended: false
                },
                style: {
                    marginRight: '1.5rem'
                }
            }),
            " ",
            option.name
        ]
    });
};
const $4b972aed698e51d9$var$routeTypeSelectedTemplate = (option, props)=>{
    if (option) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex align-items-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a665a3ac8a12ef4$export$f0b439f829a094d), {
                GRoute: {
                    route_type: option.value,
                    suspended: false
                },
                style: {
                    marginRight: '1.5rem'
                }
            }),
            " ",
            option.name
        ]
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: props.placeholder
    });
};
function $4b972aed698e51d9$export$4fa24d2d3971dbe9({ propertyName: propertyName, initialVal: initialVal, label: label, onDone: onDone }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $193f2811aaebee8a$export$260594f1c0239dfe), {
        propertyName: propertyName,
        initialVal: initialVal,
        label: label,
        options: $4b972aed698e51d9$var$routeTypeOptions,
        onDone: onDone,
        itemTemplate: $4b972aed698e51d9$var$routeTypeOptionTemplate,
        valueTemplate: $4b972aed698e51d9$var$routeTypeSelectedTemplate
    });
}


function $10aab0d7f6d3d904$export$b23901d4da9b75d8({ GRoute: GRoute }) {
    const header = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-200 text-sm",
                children: GRoute.route_id
            }),
            " [",
            GRoute.route_short_name,
            "] ",
            GRoute.route_long_name
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8752d282f3fd7a50$export$7c61201097bd33b6), {
        resourceTable: "routes",
        selectedItemId: GRoute.route_id,
        header: header,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($10aab0d7f6d3d904$export$b5b996b2267af334, {})
    });
}
function $10aab0d7f6d3d904$export$b5b996b2267af334() {
    const id = (0, $acw62.useId)();
    const snap = (0, $acw62.useContext)((0, $7d6297100045faa6$export$83327a4f6aff409e));
    const data = (0, $acw62.useContext)((0, $65d01f18dbe7987a$export$58d75f9829cbe158));
    const handleOverlays = (0, $acw62.useContext)((0, $bdccf6b6a87b04cc$export$a2200b96afd16271));
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const dispatch = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$6bbcf3368996eea5));
    const modifyRoute = (0, $4529664c1ee19d35$export$5ecbcf6a102ccf18)();
    const deleteRoute = (0, $4529664c1ee19d35$export$ac4094b3ba481216)('routes');
    const { data: networksData } = (0, $4529664c1ee19d35$export$c3a687f3d6e3fb65)('networks');
    const [modifiedValues, setModifiedValues] = (0, $acw62.useState)(data.inputValues);
    const [validationErrors, setValidationErrors] = (0, $acw62.useState)(false);
    const [isMutationPending, setIsMutationPending] = (0, $acw62.useState)(false);
    const networksOptions = [];
    if (networksData) for (const [key, val] of Object.entries(networksData))networksOptions.push({
        value: key,
        name: val
    });
    const symbolOptions = [
        {
            value: false,
            name: "(nie okre\u015Blono)"
        },
        {
            value: 'U',
            name: "U \u2013 linia u\u017Cyteczno\u015Bci publicznej"
        },
        {
            value: 'RS',
            name: "RS \u2013 przew\xf3z regularny specjalny"
        },
        {
            value: 'R',
            name: "R \u2013 inny przew\xf3z regularny"
        }
    ];
    function handleInput(propertyName, value) {
        let newValues = {
            ...modifiedValues
        };
        newValues[propertyName] = value;
        setModifiedValues(newValues);
    }
    async function handleInputDone(propertyName, value) {
        if (value === data.inputValues[propertyName]) return; // Nie wysyłamy zmian na serwer, jeżeli nowa wartość jest taka jak już zapisana do serwera.
        const payload = {
            query: {
                modified_id: data.inputValues.route_id,
                resourceTable: 'routes'
            },
            fields: {}
        };
        payload.fields[propertyName] = value;
        setIsMutationPending(true);
        try {
            const asyncMutation = await modifyRoute.mutateAsync(payload); // próbujemy przeprowadzić mutację
            // wykasuj ewentualne istniejące błędy walidacji z UI, skoro wszystko poszło ok
            if (validationErrors[propertyName]) {
                let updatedValidationErrors = {
                    ...validationErrors
                };
                updatedValidationErrors[propertyName] = false;
                setValidationErrors({
                    ...updatedValidationErrors
                });
            }
        } catch (error) {
            const errorCode = error.message.slice(0, 3);
            if (errorCode == '422') {
                //obsługa błędów walidacji
                let updatedValidationErrors = {
                    ...validationErrors
                };
                updatedValidationErrors[propertyName] = Object.values(error.cause.validation[propertyName]).join(', ');
                setValidationErrors({
                    ...updatedValidationErrors
                });
            } else {
                //obsługa pozostałych błędów
                handleOverlays('toast', {
                    severity: "error",
                    summary: "B\u0142\u0105d " + errorCode,
                    detail: typeof error.cause === 'undefined' || typeof error.cause.message === 'undefined' ? "Wyst\u0105pi\u0142 b\u0142\u0105d. Czynno\u015B\u0107 nie mog\u0142a zosta\u0107 zako\u0144czona powodzeniem. " + error.message : error.cause.message
                });
                console.log(error);
            }
        } finally{
            setIsMutationPending(false);
        }
    }
    function handleInputCancel() {
        setModifiedValues(data.inputValues);
    }
    function handleClickDelete() {
        async function accept() {
            try {
                //próbujemy usunąć linię
                const asyncMutation = await deleteRoute.mutateAsync(data.inputValues.route_id);
                // to wykona się tylko, jeżeli nam się udało
                dispatch({
                    type: 'changed',
                    newTool: {
                        ...tool,
                        propertyEditor: null,
                        selection: null // odznacz przystanek
                    }
                });
                handleOverlays('toast', {
                    summary: "Linia zosta\u0142a usuni\u0119ta",
                    severity: 'success'
                });
            } catch (error) {
                // Obługa błędów
                console.log(error);
                const errorCode = error.message.slice(0, 3);
                handleOverlays('toast', {
                    severity: "error",
                    summary: "B\u0142\u0105d " + errorCode,
                    detail: typeof error.cause === 'undefined' || typeof error.cause.message === 'undefined' ? "Wyst\u0105pi\u0142 b\u0142\u0105d. Czynno\u015B\u0107 nie mog\u0142a zosta\u0107 zako\u0144czona powodzeniem." : error.cause.message
                });
            } finally{
                // musimy być pewni, że inwalidacja zapytań nastąpi PO zakończeniu operacji
                // dlatego następuje tutaj, a nie w Queries.js
                (0, $4529664c1ee19d35$export$7c07b633a151f9c5).invalidateQueries({
                    queryKey: [
                        'GTFS',
                        snap,
                        'routes',
                        data.inputValues.route_id
                    ]
                });
                (0, $4529664c1ee19d35$export$7c07b633a151f9c5).invalidateQueries({
                    queryKey: [
                        'GTFS',
                        snap,
                        'routes'
                    ]
                });
            }
        }
        handleOverlays('confirmDialog', {
            message: "Linia zniknie z rozk\u0142adu jazdy wraz z wszystkimi trasami i kursami. Operacja jest nieodwracalna.",
            header: "Usun\u0105\u0107 lini\u0119 " + data.inputValues.route_id + ' ' + data.inputValues.route_short_name + ' ' + data.inputValues.route_long_name + '?',
            icon: 'pi pi-info-circle',
            style: {
                width: '500px '
            },
            breakpoints: {
                '960px': '100vw'
            },
            defaultFocus: 'reject',
            acceptLabel: "Usu\u0144",
            acceptClassName: 'p-button-danger',
            acceptIcon: 'fa-solid fa-trash',
            rejectLabel: 'Anuluj',
            accept: accept
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "formgrid grid",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "field col-6",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                        propertyName: "route_id",
                        label: "ID linii",
                        id: id,
                        value: modifiedValues.route_id,
                        initialVal: data.inputValues.route_id,
                        onDone: handleInputDone,
                        onChange: handleInput,
                        onCancel: handleInputCancel,
                        /* invalid={validationErrors.stop_id} */ disabled: false,
                        pending: isMutationPending
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "field col-6",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                        propertyName: "route_short_name",
                        label: "Numer linii",
                        id: id,
                        value: modifiedValues.route_short_name,
                        initialVal: data.inputValues.route_short_name,
                        onDone: handleInputDone,
                        onChange: handleInput,
                        onCancel: handleInputCancel,
                        /* invalid={validationErrors.stop_id} */ disabled: false,
                        pending: isMutationPending,
                        style: {
                            backgroundColor: '#' + modifiedValues.route_color,
                            borderColor: '#' + modifiedValues.route_text_color,
                            color: '#' + modifiedValues.route_text_color,
                            fontWeight: 'bold'
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "field col-12",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                        propertyName: "route_long_name",
                        label: "Nazwa linii",
                        id: id,
                        value: modifiedValues.route_long_name,
                        initialVal: data.inputValues.route_long_name,
                        onDone: handleInputDone,
                        onChange: handleInput,
                        onCancel: handleInputCancel,
                        /* invalid={validationErrors.stop_id} */ disabled: false,
                        pending: isMutationPending
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "field col-6 text-right",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            htmlFor: id + '_route_color',
                            children: "Kolor linii: "
                        }),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a26c965a435b320$export$9feb1bc2e5f1ccb3), {
                            inputId: id + '_route_color',
                            value: data.inputValues.route_color,
                            defaultColor: "000000",
                            onChange: (e)=>{
                                let newValues = {
                                    ...modifiedValues
                                };
                                newValues['route_color'] = e.value;
                                setModifiedValues(newValues); // tzw. (trochę) optymistyczna aktualizacja...
                            },
                            onHide: ()=>{
                                handleInputDone('route_color', modifiedValues.route_color);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "field col-4",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                        propertyName: "route_color",
                        id: id,
                        value: modifiedValues.route_color,
                        initialVal: data.inputValues.route_color,
                        onDone: handleInputDone,
                        onChange: handleInput,
                        onCancel: handleInputCancel,
                        /* invalid={validationErrors.stop_id} */ disabled: false,
                        pending: isMutationPending
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "field col-6 text-right",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            htmlFor: id + '_route_text_color',
                            children: "Kolor numeru linii: "
                        }),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a26c965a435b320$export$9feb1bc2e5f1ccb3), {
                            inputId: id + '_route_text_color',
                            value: data.inputValues.route_text_color,
                            defaultColor: "ffffff",
                            onChange: (e)=>{
                                let newValues = {
                                    ...modifiedValues
                                };
                                newValues['route_text_color'] = e.value;
                                setModifiedValues(newValues); // tzw. (trochę) optymistyczna aktualizacja...
                            },
                            onHide: ()=>{
                                handleInputDone('route_text_color', modifiedValues.route_text_color);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "field col-4",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                        propertyName: "route_text_color",
                        id: id,
                        value: modifiedValues.route_text_color,
                        initialVal: data.inputValues.route_text_color,
                        onDone: handleInputDone,
                        onChange: handleInput,
                        onCancel: handleInputCancel,
                        /* invalid={validationErrors.stop_id} */ disabled: false,
                        pending: isMutationPending
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "field col-12",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b972aed698e51d9$export$4fa24d2d3971dbe9), {
                        propertyName: "route_type",
                        initialVal: data.inputValues.route_type,
                        label: "Trakcja",
                        onDone: handleInputDone
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "field col-4",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                        propertyName: "route_sort_order",
                        label: "Pozycja w spisie",
                        id: id,
                        value: modifiedValues.route_sort_order,
                        initialVal: data.inputValues.route_sort_order,
                        onDone: handleInputDone,
                        onChange: handleInput,
                        onCancel: handleInputCancel,
                        /* invalid={validationErrors.stop_id} */ disabled: false,
                        pending: isMutationPending
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "field col-8",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                        propertyName: "route_url",
                        label: "Link do WWW z opisem linii",
                        placeholder: "(np. https://example.com/trasa)",
                        id: id,
                        value: modifiedValues.route_url,
                        initialVal: data.inputValues.route_url,
                        onDone: handleInputDone,
                        onChange: handleInput,
                        onCancel: handleInputCancel,
                        /* invalid={validationErrors.stop_id} */ disabled: false,
                        pending: isMutationPending
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "field col-12",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $193f2811aaebee8a$export$260594f1c0239dfe), {
                        propertyName: "network_id",
                        initialVal: data.inputValues.network_id,
                        label: "Sie\u0107 komunikacyjna",
                        options: networksOptions,
                        onDone: handleInputDone
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "field col-8",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $193f2811aaebee8a$export$260594f1c0239dfe), {
                        propertyName: "route_symbol",
                        initialVal: data.inputValues.route_symbol,
                        label: "Oznaczenie linii",
                        options: symbolOptions,
                        onDone: handleInputDone
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "field col-4",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c93f02bd02853250$export$e0cf7497da6814f0), {
                        propertyName: "suspended",
                        initialVal: data.inputValues.suspended,
                        label: "Zawieszona",
                        id: id,
                        onDone: handleInputDone
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "field col-6",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7fb0fd4947ad04b9$export$970da85b7539806d), {
                        propertyName: "wheelchair_accessible",
                        label: "Dost\u0119pna dla w\xf3zk\xf3w",
                        initialVal: data.inputValues.wheelchair_accessible,
                        id: id,
                        onDone: handleInputDone
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "field col-6",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7fb0fd4947ad04b9$export$970da85b7539806d), {
                        propertyName: "air_conditioned",
                        label: "Klimatyzowana",
                        initialVal: data.inputValues.air_conditioned,
                        id: id,
                        onDone: handleInputDone
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "field col-12 mt-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                        severity: "danger",
                        onClick: handleClickDelete,
                        icon: "fa-solid fa-trash",
                        label: "Usu\u0144 lini\u0119",
                        outlined: true
                    })
                })
            ]
        })
    });
}






var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");















'use client';
function $2565b8a300f577e7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2565b8a300f577e7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2565b8a300f577e7$var$_typeof(o);
}
function $2565b8a300f577e7$var$toPrimitive(t, r) {
    if ("object" != $2565b8a300f577e7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2565b8a300f577e7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2565b8a300f577e7$var$toPropertyKey(t) {
    var i = $2565b8a300f577e7$var$toPrimitive(t, "string");
    return "symbol" == $2565b8a300f577e7$var$_typeof(i) ? i : i + "";
}
function $2565b8a300f577e7$var$_defineProperty(e, r, t) {
    return (r = $2565b8a300f577e7$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2565b8a300f577e7$var$_extends() {
    return $2565b8a300f577e7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2565b8a300f577e7$var$_extends.apply(null, arguments);
}
function $2565b8a300f577e7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $2565b8a300f577e7$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $2565b8a300f577e7$var$_arrayLikeToArray(r);
}
function $2565b8a300f577e7$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $2565b8a300f577e7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2565b8a300f577e7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2565b8a300f577e7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $2565b8a300f577e7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2565b8a300f577e7$var$_toConsumableArray(r) {
    return $2565b8a300f577e7$var$_arrayWithoutHoles(r) || $2565b8a300f577e7$var$_iterableToArray(r) || $2565b8a300f577e7$var$_unsupportedIterableToArray(r) || $2565b8a300f577e7$var$_nonIterableSpread();
}
function $2565b8a300f577e7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $2565b8a300f577e7$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2565b8a300f577e7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2565b8a300f577e7$var$_slicedToArray(r, e) {
    return $2565b8a300f577e7$var$_arrayWithHoles(r) || $2565b8a300f577e7$var$_iterableToArrayLimit(r, e) || $2565b8a300f577e7$var$_unsupportedIterableToArray(r, e) || $2565b8a300f577e7$var$_nonIterableRest();
}
var $2565b8a300f577e7$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, focusedState = _ref.focusedState;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-autocomplete p-component p-inputwrapper', {
            'p-autocomplete-dd': props.dropdown,
            'p-autocomplete-multiple': props.multiple,
            'p-inputwrapper-filled': props.value,
            'p-invalid': props.invalid,
            'p-inputwrapper-focus': focusedState
        });
    },
    container: function container(_ref2) {
        var props = _ref2.props, context = _ref2.context;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-autocomplete-multiple-container p-component p-inputtext', {
            'p-disabled': props.disabled,
            'p-variant-filled': props.variant ? props.variant === 'filled' : context && context.inputStyle === 'filled'
        });
    },
    loadingIcon: 'p-autocomplete-loader',
    dropdownButton: 'p-autocomplete-dropdown',
    removeTokenIcon: 'p-autocomplete-token-icon',
    token: 'p-autocomplete-token p-highlight',
    tokenLabel: 'p-autocomplete-token-label',
    inputToken: 'p-autocomplete-input-token',
    input: function input(_ref3) {
        var props = _ref3.props, context = _ref3.context;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-autocomplete-input', {
            'p-autocomplete-dd-input': props.dropdown,
            'p-variant-filled': props.variant ? props.variant === 'filled' : context && context.inputStyle === 'filled'
        });
    },
    panel: function panel(_ref4) {
        var context = _ref4.context;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-autocomplete-panel p-component', {
            'p-ripple-disabled': context && context.ripple === false || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).ripple === false
        });
    },
    listWrapper: 'p-autocomplete-items-wrapper',
    list: function list(_ref5) {
        var virtualScrollerOptions = _ref5.virtualScrollerOptions, options = _ref5.options;
        return virtualScrollerOptions ? (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-autocomplete-items', options.className) : 'p-autocomplete-items';
    },
    emptyMessage: 'p-autocomplete-item',
    item: function item(_ref6) {
        var suggestion = _ref6.suggestion, optionGroupLabel = _ref6.optionGroupLabel, selected = _ref6.selected;
        return optionGroupLabel ? (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-autocomplete-item', {
            'p-disabled': suggestion.disabled
        }, {
            selected: selected
        }) : (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-autocomplete-item', {
            'p-disabled': suggestion.disabled
        }, {
            'p-highlight': selected
        });
    },
    itemGroup: 'p-autocomplete-item-group',
    footer: 'p-autocomplete-footer',
    transition: 'p-connected-overlay'
};
var $2565b8a300f577e7$var$styles = "\n@layer primereact {\n    .p-autocomplete {\n        display: inline-flex;\n        position: relative;\n    }\n    \n    .p-autocomplete-loader {\n        position: absolute;\n        top: 50%;\n        margin-top: -.5rem;\n    }\n    \n    .p-autocomplete-dd .p-autocomplete-input {\n        flex: 1 1 auto;\n        width: 1%;\n    }\n    \n    .p-autocomplete-dd .p-autocomplete-input,\n    .p-autocomplete-dd .p-autocomplete-multiple-container {\n         border-top-right-radius: 0;\n         border-bottom-right-radius: 0;\n     }\n    \n    .p-autocomplete-dd .p-autocomplete-dropdown {\n         border-top-left-radius: 0;\n         border-bottom-left-radius: 0px;\n    }\n    \n    .p-autocomplete .p-autocomplete-panel {\n        min-width: 100%;\n    }\n    \n    .p-autocomplete-panel {\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n    \n    .p-autocomplete-items {\n        margin: 0;\n        padding: 0;\n        list-style-type: none;\n    }\n    \n    .p-autocomplete-item {\n        cursor: pointer;\n        white-space: nowrap;\n        position: relative;\n        overflow: hidden;\n    }\n    \n    .p-autocomplete-multiple-container {\n        margin: 0;\n        padding: 0;\n        list-style-type: none;\n        cursor: text;\n        overflow: hidden;\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n    }\n    \n    .p-autocomplete-token {\n        cursor: default;\n        display: inline-flex;\n        align-items: center;\n        flex: 0 0 auto;\n    }\n    \n    .p-autocomplete-token-icon {\n        cursor: pointer;\n    }\n    \n    .p-autocomplete-input-token {\n        flex: 1 1 auto;\n        display: inline-flex;\n    }\n    \n    .p-autocomplete-input-token input {\n        border: 0 none;\n        outline: 0 none;\n        background-color: transparent;\n        margin: 0;\n        padding: 0;\n        box-shadow: none;\n        border-radius: 0;\n        width: 100%;\n    }\n    \n    .p-fluid .p-autocomplete {\n        display: flex;\n    }\n    \n    .p-fluid .p-autocomplete-dd .p-autocomplete-input {\n        width: 1%;\n    }\n    \n    .p-autocomplete-items-wrapper {\n        overflow: auto;\n    } \n}\n";
var $2565b8a300f577e7$var$AutoCompleteBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'AutoComplete',
        id: null,
        appendTo: null,
        autoFocus: false,
        autoHighlight: false,
        className: null,
        completeMethod: null,
        delay: 300,
        disabled: false,
        dropdown: false,
        dropdownAriaLabel: null,
        dropdownAutoFocus: true,
        dropdownIcon: null,
        dropdownMode: 'blank',
        emptyMessage: null,
        field: null,
        forceSelection: false,
        inputClassName: null,
        inputId: null,
        inputRef: null,
        inputStyle: null,
        variant: null,
        invalid: false,
        itemTemplate: null,
        loadingIcon: null,
        maxLength: null,
        minLength: 1,
        multiple: false,
        name: null,
        onBlur: null,
        onChange: null,
        onClear: null,
        onClick: null,
        onContextMenu: null,
        onDblClick: null,
        onDropdownClick: null,
        onFocus: null,
        onHide: null,
        onKeyPress: null,
        onKeyUp: null,
        onMouseDown: null,
        onSelect: null,
        onShow: null,
        onUnselect: null,
        optionGroupChildren: null,
        optionGroupLabel: null,
        optionGroupTemplate: null,
        panelClassName: null,
        panelFooterTemplate: null,
        panelStyle: null,
        placeholder: null,
        readOnly: false,
        removeTokenIcon: null,
        scrollHeight: '200px',
        selectedItemTemplate: null,
        selectionLimit: null,
        showEmptyMessage: false,
        size: null,
        style: null,
        suggestions: null,
        tabIndex: null,
        tooltip: null,
        tooltipOptions: null,
        transitionOptions: null,
        type: 'text',
        value: null,
        virtualScrollerOptions: null,
        children: undefined
    },
    css: {
        classes: $2565b8a300f577e7$var$classes,
        styles: $2565b8a300f577e7$var$styles
    }
});
function $2565b8a300f577e7$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2565b8a300f577e7$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2565b8a300f577e7$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $2565b8a300f577e7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2565b8a300f577e7$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2565b8a300f577e7$var$AutoCompletePanel = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var ptm = props.ptm, cx = props.cx;
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var _ptm = function _ptm(key, options) {
        return ptm(key, $2565b8a300f577e7$var$_objectSpread$1({
            hostName: props.hostName
        }, options));
    };
    var getPTOptions = function getPTOptions(item, key) {
        return _ptm(key, {
            context: {
                selected: props.selectedItem.current === item,
                disabled: item.disabled
            }
        });
    };
    var getOptionGroupRenderKey = function getOptionGroupRenderKey(optionGroup) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(optionGroup, props.optionGroupLabel);
    };
    var getOptionRenderKey = function getOptionRenderKey(option) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(option, props.field);
    };
    var createFooter = function createFooter() {
        if (props.panelFooterTemplate) {
            var content = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.panelFooterTemplate, props, props.onOverlayHide);
            var footerProps = mergeProps({
                className: cx('footer')
            }, _ptm('footer'));
            return /*#__PURE__*/ $acw62.createElement("div", footerProps, content);
        }
        return null;
    };
    var findKeyIndex = function findKeyIndex(array, key, value) {
        return array.findIndex(function(obj) {
            return obj[key] === value;
        });
    };
    var latestKey = $acw62.useRef({
        key: null,
        index: 0,
        keyIndex: 0
    });
    var createLabelItem = function createLabelItem(item, key, index, labelItemProps) {
        var content = props.optionGroupTemplate ? (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.optionGroupTemplate, item, index) : props.getOptionGroupLabel(item) || item;
        var itemGroupProps = mergeProps($2565b8a300f577e7$var$_objectSpread$1({
            index: index,
            className: cx('itemGroup'),
            'data-p-highlight': false
        }, labelItemProps), _ptm('itemGroup'));
        return /*#__PURE__*/ $acw62.createElement("li", $2565b8a300f577e7$var$_extends({}, itemGroupProps, {
            key: key ? key : null
        }), content);
    };
    var isOptionSelected = function isOptionSelected(item) {
        if (props.selectedItem && props.selectedItem.current && Array.isArray(props.selectedItem.current)) return props.selectedItem.current.some(function(selectedItem) {
            return (0, $a73ce425265b079e$export$4855211e6b8ad895).deepEquals(selectedItem, item);
        });
        else return (0, $a73ce425265b079e$export$4855211e6b8ad895).deepEquals(props.selectedItem.current, item);
    };
    var createListItem = function createListItem(item, key, index, listItemProps) {
        var selected = isOptionSelected(item);
        var content = props.itemTemplate ? (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.itemTemplate, item, index) : props.field ? (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(item, props.field) : item;
        var itemProps = mergeProps($2565b8a300f577e7$var$_objectSpread$1({
            index: index,
            role: 'option',
            className: cx('item', {
                optionGroupLabel: props.optionGroupLabel,
                suggestion: item,
                selected: selected
            }),
            onClick: function onClick(e) {
                return props.onItemClick(e, item);
            },
            'aria-selected': selected
        }, listItemProps), getPTOptions(item, 'item'));
        return /*#__PURE__*/ $acw62.createElement("li", $2565b8a300f577e7$var$_extends({
            key: key
        }, itemProps), content, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
    };
    var createGroupChildren = function createGroupChildren(optionGroup, i) {
        var groupChildren = props.getOptionGroupChildren(optionGroup);
        return groupChildren.map(function(item, j) {
            var key = i + '_' + j;
            var itemProps = mergeProps({
                'data-group': i,
                'data-index': j,
                'data-p-disabled': item.disabled
            });
            return createListItem(item, key, j, itemProps);
        });
    };
    var createItem = function createItem(suggestion, index) {
        var scrollerOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var style = {
            height: scrollerOptions.props ? scrollerOptions.props.itemSize : undefined
        };
        if (props.optionGroupLabel) {
            if (props.virtualScrollerOptions) {
                var keyIndex = findKeyIndex(props.suggestions, props.optionGroupLabel, suggestion);
                if (keyIndex !== -1) {
                    latestKey.current = {
                        key: suggestion,
                        index: index,
                        keyIndex: keyIndex
                    };
                    var _key = index + '_' + getOptionGroupRenderKey(suggestion);
                    return createLabelItem(suggestion, _key, index, {
                        style: style
                    });
                }
                var _key2 = index + '_' + latestKey.current.keyIndex;
                var _itemProps = mergeProps({
                    style: style,
                    'data-group': latestKey.current.keyIndex,
                    'data-index': index - latestKey.current.index - 1,
                    'data-p-disabled': suggestion.disabled
                });
                return createListItem(suggestion, _key2, index, _itemProps);
            }
            var childrenContent = createGroupChildren(suggestion, index);
            var _key3 = index + '_' + getOptionGroupRenderKey(suggestion);
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, {
                key: _key3
            }, createLabelItem(suggestion, undefined, index, {
                style: style
            }), childrenContent);
        }
        var key = "".concat(index, "_").concat((0, $a73ce425265b079e$export$4855211e6b8ad895).isObject(suggestion) ? getOptionRenderKey(suggestion) : suggestion);
        var itemProps = mergeProps({
            style: style,
            'data-p-disabled': suggestion.disabled
        }, getPTOptions(suggestion, 'item'));
        return createListItem(suggestion, key, index, itemProps);
    };
    var createItems = function createItems() {
        return props.suggestions ? props.suggestions.map(createItem) : null;
    };
    var flattenGroupedItems = function flattenGroupedItems(items) {
        try {
            return items === null || items === void 0 ? void 0 : items.map(function(item) {
                return [
                    item === null || item === void 0 ? void 0 : item[props === null || props === void 0 ? void 0 : props.optionGroupLabel]
                ].concat($2565b8a300f577e7$var$_toConsumableArray(item === null || item === void 0 ? void 0 : item[props === null || props === void 0 ? void 0 : props.optionGroupChildren]));
            }).flat();
        } catch (e) {}
    };
    var createContent = function createContent() {
        if (props.showEmptyMessage && (0, $a73ce425265b079e$export$4855211e6b8ad895).isEmpty(props.suggestions)) {
            var emptyMessage = props.emptyMessage || (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('emptyMessage');
            var emptyMessageProps = mergeProps({
                className: cx('emptyMessage')
            }, _ptm('emptyMesage'));
            var _listProps = mergeProps({
                className: cx('list')
            }, _ptm('list'));
            return /*#__PURE__*/ $acw62.createElement("ul", _listProps, /*#__PURE__*/ $acw62.createElement("li", emptyMessageProps, emptyMessage));
        }
        if (props.virtualScrollerOptions) {
            var _items = props.suggestions ? props.optionGroupLabel ? flattenGroupedItems(props === null || props === void 0 ? void 0 : props.suggestions) : props.suggestions : null;
            var virtualScrollerProps = $2565b8a300f577e7$var$_objectSpread$1($2565b8a300f577e7$var$_objectSpread$1({}, props.virtualScrollerOptions), {
                style: $2565b8a300f577e7$var$_objectSpread$1($2565b8a300f577e7$var$_objectSpread$1({}, props.virtualScrollerOptions.style), {
                    height: props.scrollHeight
                }),
                autoSize: true,
                items: _items,
                itemTemplate: function itemTemplate(item, options) {
                    return item && createItem(item, options.index, options);
                },
                contentTemplate: function contentTemplate(options) {
                    var listProps = mergeProps({
                        id: props.listId,
                        ref: options.contentRef,
                        style: options.style,
                        className: cx('list', {
                            virtualScrollerProps: virtualScrollerProps,
                            options: options
                        }),
                        role: 'listbox'
                    }, _ptm('list'));
                    return /*#__PURE__*/ $acw62.createElement("ul", listProps, options.children);
                }
            });
            return /*#__PURE__*/ $acw62.createElement((0, $50cb59e69476e4bf$export$fbd4ea7fe0fb889), $2565b8a300f577e7$var$_extends({
                ref: props.virtualScrollerRef
            }, virtualScrollerProps, {
                pt: _ptm('virtualScroller'),
                __parentMetadata: {
                    parent: props.metaData
                }
            }));
        }
        var items = createItems();
        var listProps = mergeProps({
            id: props.listId,
            className: cx('list'),
            role: 'listbox'
        }, _ptm('list'));
        var listWrapperProps = mergeProps({
            className: cx('listWrapper'),
            style: {
                maxHeight: props.scrollHeight || 'auto'
            }
        }, _ptm('listWrapper'));
        return /*#__PURE__*/ $acw62.createElement("div", listWrapperProps, /*#__PURE__*/ $acw62.createElement("ul", listProps, items));
    };
    var createElement = function createElement() {
        var style = $2565b8a300f577e7$var$_objectSpread$1({}, props.panelStyle || {});
        var content = createContent();
        var footer = createFooter();
        var panelProps = mergeProps({
            className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.panelClassName, cx('panel', {
                context: context
            })),
            style: style,
            onClick: function onClick(e) {
                return props.onClick(e);
            }
        }, _ptm('panel'));
        var transitionProps = mergeProps({
            classNames: cx('transition'),
            "in": props["in"],
            timeout: {
                enter: 120,
                exit: 100
            },
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: props.onEnter,
            onEntering: props.onEntering,
            onEntered: props.onEntered,
            onExit: props.onExit,
            onExited: props.onExited
        }, _ptm('transition'));
        return /*#__PURE__*/ $acw62.createElement((0, $17afce1b96f6eaec$export$a7a5590ad6d7af0), $2565b8a300f577e7$var$_extends({
            nodeRef: ref
        }, transitionProps), /*#__PURE__*/ $acw62.createElement("div", $2565b8a300f577e7$var$_extends({
            ref: ref
        }, panelProps), content, footer));
    };
    var element = createElement();
    return /*#__PURE__*/ $acw62.createElement((0, $e7a3b5428092a192$export$602eac185826482c), {
        element: element,
        appendTo: props.appendTo
    });
}));
$2565b8a300f577e7$var$AutoCompletePanel.displayName = 'AutoCompletePanel';
function $2565b8a300f577e7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2565b8a300f577e7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2565b8a300f577e7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2565b8a300f577e7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2565b8a300f577e7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2565b8a300f577e7$export$6b41f50dc0c59fb3 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $2565b8a300f577e7$var$AutoCompleteBase.getProps(inProps, context);
    var _React$useState = $acw62.useState(props.id), _React$useState2 = $2565b8a300f577e7$var$_slicedToArray(_React$useState, 2), idState = _React$useState2[0], setIdState = _React$useState2[1];
    var _React$useState3 = $acw62.useState(false), _React$useState4 = $2565b8a300f577e7$var$_slicedToArray(_React$useState3, 2), searchingState = _React$useState4[0], setSearchingState = _React$useState4[1];
    var _React$useState5 = $acw62.useState(false), _React$useState6 = $2565b8a300f577e7$var$_slicedToArray(_React$useState5, 2), focusedState = _React$useState6[0], setFocusedState = _React$useState6[1];
    var _React$useState7 = $acw62.useState(false), _React$useState8 = $2565b8a300f577e7$var$_slicedToArray(_React$useState7, 2), overlayVisibleState = _React$useState8[0], setOverlayVisibleState = _React$useState8[1];
    var metaData = {
        props: props,
        state: {
            id: idState,
            searching: searchingState,
            focused: focusedState,
            overlayVisible: overlayVisibleState
        }
    };
    var _AutoCompleteBase$set = $2565b8a300f577e7$var$AutoCompleteBase.setMetaData(metaData), ptm = _AutoCompleteBase$set.ptm, cx = _AutoCompleteBase$set.cx, sx = _AutoCompleteBase$set.sx, isUnstyled = _AutoCompleteBase$set.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($2565b8a300f577e7$var$AutoCompleteBase.css.styles, isUnstyled, {
        name: 'autocomplete'
    });
    var elementRef = $acw62.useRef(null);
    var overlayRef = $acw62.useRef(null);
    var inputRef = $acw62.useRef(props.inputRef);
    var multiContainerRef = $acw62.useRef(null);
    var virtualScrollerRef = $acw62.useRef(null);
    var timeout = $acw62.useRef(null);
    var selectedItem = $acw62.useRef(null);
    var _useOverlayListener = (0, $fbdf1e36fa0a01d8$export$2fef17345d27a5b4)({
        target: elementRef,
        overlay: overlayRef,
        listener: function listener(event, _ref) {
            var type = _ref.type, valid = _ref.valid;
            if (valid) type === 'outside' ? !isInputClicked(event) && hide() : hide();
        },
        when: overlayVisibleState
    }), _useOverlayListener2 = $2565b8a300f577e7$var$_slicedToArray(_useOverlayListener, 2), bindOverlayListener = _useOverlayListener2[0], unbindOverlayListener = _useOverlayListener2[1];
    var isInputClicked = function isInputClicked(event) {
        return props.multiple ? event.target === multiContainerRef.current || multiContainerRef.current.contains(event.target) : event.target === inputRef.current;
    };
    var onInputChange = function onInputChange(event) {
        //Cancel the search request if user types within the timeout
        if (timeout.current) clearTimeout(timeout.current);
        var query = event.target.value;
        if (!props.multiple) updateModel(event, query);
        if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isEmpty(query)) {
            hide();
            props.onClear && props.onClear(event);
        } else if (query.length >= props.minLength) timeout.current = setTimeout(function() {
            search(event, query, 'input');
        }, props.delay);
        else hide();
    };
    var search = function search(event, query, source) {
        //allow empty string but not undefined or null
        if (query === undefined || query === null) return;
        //do not search blank values on input change
        if (source === 'input' && query.trim().length === 0) return;
        if (props.completeMethod) {
            setSearchingState(true);
            props.completeMethod({
                originalEvent: event,
                query: query
            });
        }
    };
    var selectItem = function selectItem(event, option, preventInputFocus) {
        if (props.multiple) {
            inputRef.current.value = '';
            // allows empty value/selectionlimit and within sectionlimit
            if (!isSelected(option) && isAllowMoreValues()) {
                var newValue = props.value ? [].concat($2565b8a300f577e7$var$_toConsumableArray(props.value), [
                    option
                ]) : [
                    option
                ];
                updateModel(event, newValue);
            }
        } else {
            updateInputField(option);
            updateModel(event, option);
        }
        if (props.onSelect) props.onSelect({
            originalEvent: event,
            value: option
        });
        if (!preventInputFocus) {
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current);
            hide();
        }
    };
    var updateModel = function updateModel(event, value) {
        if (props.onChange) props.onChange({
            originalEvent: event,
            value: value,
            stopPropagation: function stopPropagation() {
                event.stopPropagation();
            },
            preventDefault: function preventDefault() {
                event.preventDefault();
            },
            target: {
                name: props.name,
                id: idState,
                value: value
            }
        });
        selectedItem.current = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(value) ? value : null;
    };
    var formatValue = function formatValue(value) {
        var useTemplate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isEmpty(value)) return '';
        if (typeof value === 'string') return value;
        if (useTemplate && props.selectedItemTemplate) return (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.selectedItemTemplate, value) || value;
        if (props.field) {
            var _ObjectUtils$resolveF;
            return (_ObjectUtils$resolveF = (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(value, props.field)) !== null && _ObjectUtils$resolveF !== void 0 ? _ObjectUtils$resolveF : value;
        }
        return value;
    };
    var updateInputField = function updateInputField(value) {
        inputRef.current.value = formatValue(value);
    };
    var show = function show() {
        setOverlayVisibleState(true);
    };
    var hide = function hide() {
        setOverlayVisibleState(false);
        setSearchingState(false);
    };
    var onOverlayEnter = function onOverlayEnter() {
        (0, $a73ce425265b079e$export$832931caede8e4b9).set('overlay', overlayRef.current, context && context.autoZIndex || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).autoZIndex, context && context.zIndex.overlay || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).zIndex.overlay);
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).addStyles(overlayRef.current, {
            position: 'absolute',
            top: '0',
            left: '0'
        });
        alignOverlay();
    };
    var onOverlayEntering = function onOverlayEntering() {
        if (props.autoHighlight && props.suggestions && props.suggestions.length) autoHighlightFirstOption();
    };
    var autoHighlightFirstOption = function autoHighlightFirstOption() {
        var _getScrollableElement;
        var element = (_getScrollableElement = getScrollableElement()) === null || _getScrollableElement === void 0 || (_getScrollableElement = _getScrollableElement.firstChild) === null || _getScrollableElement === void 0 ? void 0 : _getScrollableElement.firstChild;
        if (element) {
            !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(element, 'p-highlight');
            element.setAttribute('data-p-highlight', true);
        }
    };
    var onOverlayEntered = function onOverlayEntered() {
        bindOverlayListener();
        props.onShow && props.onShow();
    };
    var onOverlayExit = function onOverlayExit() {
        unbindOverlayListener();
    };
    var onOverlayExited = function onOverlayExited() {
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(overlayRef.current);
        props.onHide && props.onHide();
    };
    var alignOverlay = function alignOverlay() {
        var target = props.multiple ? multiContainerRef.current : inputRef.current;
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).alignOverlay(overlayRef.current, target, props.appendTo || context && context.appendTo || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).appendTo);
    };
    var onPanelClick = function onPanelClick(event) {
        (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).emit('overlay-click', {
            originalEvent: event,
            target: elementRef.current
        });
    };
    var onDropdownClick = function onDropdownClick(event) {
        if (props.dropdownAutoFocus) (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current, props.dropdownAutoFocus);
        if (props.dropdownMode === 'blank') search(event, '', 'dropdown');
        else if (props.dropdownMode === 'current') search(event, inputRef.current.value, 'dropdown');
        if (props.onDropdownClick) props.onDropdownClick({
            originalEvent: event,
            query: inputRef.current.value
        });
    };
    var removeItem = function removeItem(event, index) {
        var removedValue = props.value[index];
        var newValue = props.value.filter(function(_, i) {
            return index !== i;
        });
        updateModel(event, newValue);
        if (props.onUnselect) props.onUnselect({
            originalEvent: event,
            value: removedValue
        });
    };
    var onInputKeyDown = function onInputKeyDown(event) {
        if (overlayVisibleState) {
            var highlightItem = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(overlayRef.current, 'li[data-p-highlight="true"]');
            switch(event.which){
                //down
                case 40:
                    if (highlightItem) {
                        var nextElement = _findNextItem(highlightItem);
                        if (nextElement) {
                            !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(nextElement, 'p-highlight');
                            nextElement.setAttribute('data-p-highlight', true);
                            !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(highlightItem, 'p-highlight');
                            highlightItem.setAttribute('data-p-highlight', false);
                            (0, $a73ce425265b079e$export$ff8ccbac9225de62).scrollInView(getScrollableElement(), nextElement);
                        }
                    } else {
                        highlightItem = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(overlayRef.current, 'li');
                        if ((0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(highlightItem, 'data-pc-section') === 'itemgroup') highlightItem = _findNextItem(highlightItem);
                        if (highlightItem) {
                            !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(highlightItem, 'p-highlight');
                            highlightItem.setAttribute('data-p-highlight', true);
                        }
                    }
                    event.preventDefault();
                    break;
                //up
                case 38:
                    if (highlightItem) {
                        var previousElement = _findPrevItem(highlightItem);
                        if (previousElement) {
                            !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(previousElement, 'p-highlight');
                            previousElement.setAttribute('data-p-highlight', true);
                            !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(highlightItem, 'p-highlight');
                            highlightItem.setAttribute('data-p-highlight', false);
                            (0, $a73ce425265b079e$export$ff8ccbac9225de62).scrollInView(getScrollableElement(), previousElement);
                        }
                    }
                    event.preventDefault();
                    break;
                //enter
                case 13:
                    if (highlightItem) {
                        selectHighlightItem(event, highlightItem);
                        hide();
                        event.preventDefault();
                    }
                    break;
                //escape
                case 27:
                    hide();
                    event.preventDefault();
                    break;
                //tab
                case 9:
                    if (highlightItem) selectHighlightItem(event, highlightItem);
                    hide();
                    break;
            }
        }
        if (props.multiple) switch(event.which){
            //backspace
            case 8:
                if (props.value && props.value.length && !inputRef.current.value) {
                    var removedValue = props.value[props.value.length - 1];
                    var newValue = props.value.slice(0, -1);
                    updateModel(event, newValue);
                    if (props.onUnselect) props.onUnselect({
                        originalEvent: event,
                        value: removedValue
                    });
                }
                break;
        }
    };
    var selectHighlightItem = function selectHighlightItem(event, item) {
        if (props.optionGroupLabel) {
            var optionGroup = props.suggestions[item.dataset.group];
            selectItem(event, getOptionGroupChildren(optionGroup)[item.dataset.index]);
        } else selectItem(event, props.suggestions[item.getAttribute('index')]);
    };
    var _findNextItem = function findNextItem(item) {
        var nextItem = item.nextElementSibling;
        return nextItem ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(nextItem, 'data-pc-section') === 'itemgroup' ? _findNextItem(nextItem) : nextItem : null;
    };
    var _findPrevItem = function findPrevItem(item) {
        var prevItem = item.previousElementSibling;
        return prevItem ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(prevItem, 'data-pc-section') === 'itemgroup' ? _findPrevItem(prevItem) : prevItem : null;
    };
    var onInputFocus = function onInputFocus(event) {
        setFocusedState(true);
        props.onFocus && props.onFocus(event);
    };
    var forceItemSelection = function forceItemSelection(event) {
        if (props.multiple) {
            inputRef.current.value = '';
            return;
        }
        var inputValue = (0, $a73ce425265b079e$export$4855211e6b8ad895).trim(event.target.value).toLowerCase();
        var allItems = (props.suggestions || []).flatMap(function(group) {
            return group.items ? group.items : [
                group
            ];
        });
        var item = allItems.find(function(it) {
            var value = props.field ? (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(it, props.field) : it;
            var trimmedValue = value ? (0, $a73ce425265b079e$export$4855211e6b8ad895).trim(value).toLowerCase() : '';
            return trimmedValue && inputValue === trimmedValue;
        });
        if (item) selectItem(event, item, true);
        else {
            inputRef.current.value = '';
            updateModel(event, null);
            props.onClear && props.onClear(event);
        }
    };
    var onInputBlur = function onInputBlur(event) {
        setFocusedState(false);
        if (props.forceSelection) forceItemSelection(event);
        props.onBlur && props.onBlur(event);
    };
    var onMultiContainerClick = function onMultiContainerClick(event) {
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current);
        props.onClick && props.onClick(event);
    };
    var onMultiInputFocus = function onMultiInputFocus(event) {
        onInputFocus(event);
        !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(multiContainerRef.current, 'p-focus');
        multiContainerRef.current.setAttribute('data-p-focus', true);
    };
    var onMultiInputBlur = function onMultiInputBlur(event) {
        onInputBlur(event);
        !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(multiContainerRef.current, 'p-focus');
        multiContainerRef.current.setAttribute('data-p-focus', false);
    };
    var isSelected = function isSelected(val) {
        return props.value ? props.value.some(function(v) {
            return (0, $a73ce425265b079e$export$4855211e6b8ad895).equals(v, val);
        }) : false;
    };
    var getScrollableElement = function getScrollableElement() {
        var _overlayRef$current;
        return overlayRef === null || overlayRef === void 0 || (_overlayRef$current = overlayRef.current) === null || _overlayRef$current === void 0 ? void 0 : _overlayRef$current.firstChild;
    };
    var getOptionGroupLabel = function getOptionGroupLabel(optionGroup) {
        return props.optionGroupLabel ? (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(optionGroup, props.optionGroupLabel) : optionGroup;
    };
    var getOptionGroupChildren = function getOptionGroupChildren(optionGroup) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(optionGroup, props.optionGroupChildren);
    };
    var isAllowMoreValues = function isAllowMoreValues() {
        return !props.value || !props.selectionLimit || props.value.length < props.selectionLimit;
    };
    $acw62.useEffect(function() {
        (0, $a73ce425265b079e$export$4855211e6b8ad895).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        if (!idState) setIdState((0, $a73ce425265b079e$export$d5d9b89141473caf)());
        if (props.autoFocus) (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current, props.autoFocus);
        alignOverlay();
    });
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (searchingState && props.autoHighlight && props.suggestions && props.suggestions.length) autoHighlightFirstOption();
    }, [
        searchingState
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (searchingState) {
            (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.suggestions) || props.showEmptyMessage ? show() : hide();
            setSearchingState(false);
        }
    }, [
        props.suggestions
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (inputRef.current && !props.multiple) updateInputField(props.value);
        if (overlayVisibleState) alignOverlay();
    });
    (0, $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96)(function() {
        if (timeout.current) clearTimeout(timeout.current);
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(overlayRef.current);
    });
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            search: search,
            show: show,
            hide: hide,
            focus: function focus() {
                return (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getOverlay: function getOverlay() {
                return overlayRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            },
            getVirtualScroller: function getVirtualScroller() {
                return virtualScrollerRef.current;
            }
        };
    });
    var createSimpleAutoComplete = function createSimpleAutoComplete() {
        var value = formatValue(props.value);
        var ariaControls = overlayVisibleState ? idState + '_list' : null;
        return /*#__PURE__*/ $acw62.createElement((0, $ab1a721814a59df6$export$7034fcb7d6351061), $2565b8a300f577e7$var$_extends({
            ref: inputRef,
            id: props.inputId,
            type: props.type,
            name: props.name,
            defaultValue: value,
            role: "combobox",
            "aria-autocomplete": "list",
            "aria-controls": ariaControls,
            "aria-haspopup": "listbox",
            "aria-expanded": overlayVisibleState,
            className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.inputClassName, cx('input', {
                context: context
            })),
            style: props.inputStyle,
            autoComplete: "off",
            readOnly: props.readOnly,
            required: props.required,
            disabled: props.disabled,
            placeholder: props.placeholder,
            size: props.size,
            maxLength: props.maxLength,
            tabIndex: props.tabIndex,
            onBlur: onInputBlur,
            onFocus: onInputFocus,
            onChange: onInputChange,
            onMouseDown: props.onMouseDown,
            onKeyUp: props.onKeyUp,
            onKeyDown: onInputKeyDown,
            onKeyPress: props.onKeyPress,
            onContextMenu: props.onContextMenu,
            onClick: props.onClick,
            onDoubleClick: props.onDblClick,
            pt: ptm('input'),
            unstyled: props.unstyled
        }, ariaProps, {
            __parentMetadata: {
                parent: metaData
            }
        }));
    };
    var createChips = function createChips() {
        if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.value)) return props.value.map(function(val, index) {
            var key = index + 'multi-item';
            var removeTokenIconProps = mergeProps({
                className: cx('removeTokenIcon'),
                onClick: function onClick(e) {
                    return removeItem(e, index);
                }
            }, ptm('removeTokenIcon'));
            var icon = props.removeTokenIcon || /*#__PURE__*/ $acw62.createElement((0, $81bfb4f889b27300$export$4236c899190094ee), removeTokenIconProps);
            var removeTokenIcon = !props.disabled && (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $2565b8a300f577e7$var$_objectSpread({}, removeTokenIconProps), {
                props: props
            });
            var tokenProps = mergeProps({
                className: cx('token')
            }, ptm('token'));
            var tokenLabelProps = mergeProps({
                className: cx('tokenLabel')
            }, ptm('tokenLabel'));
            return /*#__PURE__*/ $acw62.createElement("li", $2565b8a300f577e7$var$_extends({
                key: key
            }, tokenProps), /*#__PURE__*/ $acw62.createElement("span", tokenLabelProps, formatValue(val, true)), removeTokenIcon);
        });
        selectedItem.current = null;
        return null;
    };
    var createMultiInput = function createMultiInput(allowMoreValues) {
        var ariaControls = overlayVisibleState ? idState + '_list' : null;
        var inputTokenProps = mergeProps({
            className: cx('inputToken')
        }, ptm('inputToken'));
        var inputProps = mergeProps($2565b8a300f577e7$var$_objectSpread({
            id: props.inputId,
            ref: inputRef,
            'aria-autocomplete': 'list',
            'aria-controls': ariaControls,
            'aria-expanded': overlayVisibleState,
            'aria-haspopup': 'listbox',
            autoComplete: 'off',
            className: props.inputClassName,
            disabled: props.disabled,
            maxLength: props.maxLength,
            name: props.name,
            onBlur: onMultiInputBlur,
            onChange: allowMoreValues ? onInputChange : undefined,
            onFocus: onMultiInputFocus,
            onKeyDown: allowMoreValues ? onInputKeyDown : undefined,
            onKeyPress: props.onKeyPress,
            onKeyUp: props.onKeyUp,
            placeholder: allowMoreValues ? props.placeholder : undefined,
            readOnly: props.readOnly || !allowMoreValues,
            required: props.required,
            role: 'combobox',
            style: props.inputStyle,
            tabIndex: props.tabIndex,
            type: props.type
        }, ariaProps), ptm('input'));
        return /*#__PURE__*/ $acw62.createElement("li", inputTokenProps, /*#__PURE__*/ $acw62.createElement("input", inputProps));
    };
    var createMultipleAutoComplete = function createMultipleAutoComplete() {
        var allowMoreValues = isAllowMoreValues();
        var tokens = createChips();
        var input = createMultiInput(allowMoreValues);
        var containerProps = mergeProps({
            ref: multiContainerRef,
            className: cx('container', {
                context: context
            }),
            onClick: allowMoreValues ? onMultiContainerClick : undefined,
            onContextMenu: props.onContextMenu,
            onMouseDown: props.onMouseDown,
            onDoubleClick: props.onDblClick,
            'data-p-focus': focusedState,
            'data-p-disabled': props.disabled
        }, ptm('container'));
        return /*#__PURE__*/ $acw62.createElement("ul", containerProps, tokens, input);
    };
    var createDropdown = function createDropdown() {
        if (props.dropdown) {
            var ariaLabel = props.dropdownAriaLabel || props.placeholder || (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('choose');
            return /*#__PURE__*/ $acw62.createElement((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                type: "button",
                icon: props.dropdownIcon || /*#__PURE__*/ $acw62.createElement((0, $2539671ba6368b77$export$4857d3f3f5f8319b), null),
                className: cx('dropdownButton'),
                disabled: props.disabled,
                onClick: onDropdownClick,
                "aria-label": ariaLabel,
                pt: ptm('dropdownButton'),
                __parentMetadata: {
                    parent: metaData
                }
            });
        }
        return null;
    };
    var createLoader = function createLoader() {
        if (searchingState) {
            var loadingIconProps = mergeProps({
                className: cx('loadingIcon')
            }, ptm('loadingIcon'));
            var icon = props.loadingIcon || /*#__PURE__*/ $acw62.createElement((0, $f693dcb2ccf8330b$export$fe708d541030d854), $2565b8a300f577e7$var$_extends({}, loadingIconProps, {
                spin: true
            }));
            var loaderIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $2565b8a300f577e7$var$_objectSpread({}, loadingIconProps), {
                props: props
            });
            return loaderIcon;
        }
        return null;
    };
    var createInput = function createInput() {
        return props.multiple ? createMultipleAutoComplete() : createSimpleAutoComplete();
    };
    var listId = idState + '_list';
    var hasTooltip = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.tooltip);
    var otherProps = $2565b8a300f577e7$var$AutoCompleteBase.getOtherProps(props);
    var ariaProps = (0, $a73ce425265b079e$export$4855211e6b8ad895).reduceKeys(otherProps, (0, $a73ce425265b079e$export$ff8ccbac9225de62).ARIA_PROPS);
    var loader = createLoader();
    var input = createInput();
    var dropdown = createDropdown();
    var rootProps = mergeProps({
        id: idState,
        ref: elementRef,
        style: props.style,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root', {
            focusedState: focusedState
        }))
    }, otherProps, ptm('root'));
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("span", rootProps, input, loader, dropdown, /*#__PURE__*/ $acw62.createElement($2565b8a300f577e7$var$AutoCompletePanel, $2565b8a300f577e7$var$_extends({
        hostName: "AutoComplete",
        ref: overlayRef,
        virtualScrollerRef: virtualScrollerRef
    }, props, {
        listId: listId,
        onItemClick: selectItem,
        selectedItem: selectedItem,
        onClick: onPanelClick,
        getOptionGroupLabel: getOptionGroupLabel,
        getOptionGroupChildren: getOptionGroupChildren,
        "in": overlayVisibleState,
        onEnter: onOverlayEnter,
        onEntering: onOverlayEntering,
        onEntered: onOverlayEntered,
        onExit: onOverlayExit,
        onExited: onOverlayExited,
        ptm: ptm,
        cx: cx,
        sx: sx
    }))), hasTooltip && /*#__PURE__*/ $acw62.createElement((0, $b74dfa9f7ee9d9bc$export$28c660c63b792dea), $2565b8a300f577e7$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm('tooltip')
    }, props.tooltipOptions)));
}));
$2565b8a300f577e7$export$6b41f50dc0c59fb3.displayName = 'AutoComplete';



var $acw62 = parcelRequire("acw62");








'use client';
function $f81f7a6994ee8076$var$_extends() {
    return $f81f7a6994ee8076$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f81f7a6994ee8076$var$_extends.apply(null, arguments);
}
function $f81f7a6994ee8076$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f81f7a6994ee8076$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f81f7a6994ee8076$var$_typeof(o);
}
function $f81f7a6994ee8076$var$toPrimitive(t, r) {
    if ("object" != $f81f7a6994ee8076$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f81f7a6994ee8076$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f81f7a6994ee8076$var$toPropertyKey(t) {
    var i = $f81f7a6994ee8076$var$toPrimitive(t, "string");
    return "symbol" == $f81f7a6994ee8076$var$_typeof(i) ? i : i + "";
}
function $f81f7a6994ee8076$var$_defineProperty(e, r, t) {
    return (r = $f81f7a6994ee8076$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $f81f7a6994ee8076$var$MessageBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'Message',
        id: null,
        className: null,
        style: null,
        text: null,
        icon: null,
        severity: 'info',
        content: null,
        children: undefined
    },
    css: {
        classes: {
            root: function root(_ref) {
                var severity = _ref.props.severity;
                return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-inline-message p-component', $f81f7a6994ee8076$var$_defineProperty({}, "p-inline-message-".concat(severity), severity));
            },
            icon: 'p-inline-message-icon',
            text: 'p-inline-message-text'
        },
        styles: "\n        @layer primereact {\n            .p-inline-message {\n                display: inline-flex;\n                align-items: center;\n                justify-content: center;\n                vertical-align: top;\n            }\n\n            .p-inline-message-icon {\n                flex-shrink: 0;\n            }\n            \n            .p-inline-message-icon-only .p-inline-message-text {\n                visibility: hidden;\n                width: 0;\n            }\n            \n            .p-fluid .p-inline-message {\n                display: flex;\n            }        \n        }\n        "
    }
});
function $f81f7a6994ee8076$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f81f7a6994ee8076$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f81f7a6994ee8076$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f81f7a6994ee8076$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f81f7a6994ee8076$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f81f7a6994ee8076$export$f69c19e57285b83a = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $f81f7a6994ee8076$var$MessageBase.getProps(inProps, context);
    var elementRef = $acw62.useRef(null);
    var _MessageBase$setMetaD = $f81f7a6994ee8076$var$MessageBase.setMetaData({
        props: props
    }), ptm = _MessageBase$setMetaD.ptm, cx = _MessageBase$setMetaD.cx, isUnstyled = _MessageBase$setMetaD.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($f81f7a6994ee8076$var$MessageBase.css.styles, isUnstyled, {
        name: 'message'
    });
    var createContent = function createContent() {
        if (props.content) return (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.content, props);
        var text = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.text, props);
        var iconProps = mergeProps({
            className: cx('icon')
        }, ptm('icon'));
        var icon = props.icon;
        if (!icon) switch(props.severity){
            case 'info':
                icon = /*#__PURE__*/ $acw62.createElement((0, $e4c55e6257866442$export$235e99e4cce237dc), iconProps);
                break;
            case 'warn':
                icon = /*#__PURE__*/ $acw62.createElement((0, $b5ef9f4da061dfbc$export$b409b230b61d4724), iconProps);
                break;
            case 'error':
                icon = /*#__PURE__*/ $acw62.createElement((0, $81bfb4f889b27300$export$4236c899190094ee), iconProps);
                break;
            case 'success':
                icon = /*#__PURE__*/ $acw62.createElement((0, $ed79679a1c3e60de$export$7dd004358974b05d), iconProps);
                break;
        }
        var messageIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $f81f7a6994ee8076$var$_objectSpread({}, iconProps), {
            props: props
        });
        var textProps = mergeProps({
            className: cx('text')
        }, ptm('text'));
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, messageIcon, /*#__PURE__*/ $acw62.createElement("span", textProps, text));
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var content = createContent();
    var rootProps = mergeProps({
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root')),
        style: props.style,
        role: 'alert',
        'aria-live': 'polite',
        'aria-atomic': 'true'
    }, $f81f7a6994ee8076$var$MessageBase.getOtherProps(props), ptm('root'));
    return /*#__PURE__*/ $acw62.createElement("div", $f81f7a6994ee8076$var$_extends({
        id: props.id,
        ref: elementRef
    }, rootProps), content);
}));
$f81f7a6994ee8076$export$f69c19e57285b83a.displayName = 'Message';


function $3055f2719f064def$export$8cc69cc26244aa41({ values: values, onChangeRouteId: onChangeRouteId, onChangeRouteShortName: onChangeRouteShortName, onChangeRouteLongName: onChangeRouteLongName }) {
    formId = (0, $acw62.useId)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "field grid",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        for: formId + '_route_id',
                        className: "col-fixed",
                        style: {
                            width: '40%'
                        },
                        children: "ID nowej linii"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "col w-auto",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab1a721814a59df6$export$7034fcb7d6351061), {
                                id: formId + '_route_id',
                                value: values.route_id,
                                style: "w-100",
                                onChange: onChangeRouteId,
                                invalid: Boolean(values.validation_errors.route_id)
                            }),
                            values.validation_errors.route_id ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f81f7a6994ee8076$export$f69c19e57285b83a), {
                                severity: "error",
                                className: "mt-1",
                                text: values.validation_errors.route_id
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "field grid",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        for: formId + '_route_short_name',
                        className: "col-fixed",
                        style: {
                            width: '40%'
                        },
                        children: "Numer nowej linii"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "col w-auto",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab1a721814a59df6$export$7034fcb7d6351061), {
                                id: formId + '_route_short_name',
                                value: values.route_short_name,
                                style: "w-100",
                                onChange: onChangeRouteShortName,
                                invalid: Boolean(values.validation_errors.route_short_name)
                            }),
                            values.validation_errors.route_short_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f81f7a6994ee8076$export$f69c19e57285b83a), {
                                severity: "error",
                                className: "mt-1",
                                text: values.validation_errors.route_short_name
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        for: formId + '_route_name',
                        children: "Pe\u0142na nazwa nowej linii"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2565b8a300f577e7$export$6b41f50dc0c59fb3), {
                        className: "w-full",
                        inputClassName: "w-full",
                        value: values.route_long_name,
                        id: formId + '_route_name',
                        onChange: onChangeRouteLongName,
                        invalid: Boolean(values.validation_errors.route_long_name)
                    }),
                    values.validation_errors.route_long_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f81f7a6994ee8076$export$f69c19e57285b83a), {
                        severity: "error",
                        className: "mt-1",
                        text: values.validation_errors.route_long_name
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                ]
            })
        ]
    });
}


function $71f78cb9f165c1c4$export$6da1dca7da6e390e({ visible: visible, onHide: onHide }) {
    const { status: defaultIdStatus, data: defaultId } = (0, $4529664c1ee19d35$export$9f26b15dde9e2d17)('routes');
    const toolDispatch = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$6bbcf3368996eea5));
    const handleOverlay = (0, $acw62.useContext)((0, $bdccf6b6a87b04cc$export$a2200b96afd16271));
    const newRouteMutation = (0, $4529664c1ee19d35$export$9ae21d5a231f960d)('routes');
    const [values, setValues] = (0, $acw62.useState)({
        route_id: '',
        route_short_name: '',
        route_long_name: '',
        validation_errors: {
            route_id: false
        }
    });
    const dialogFooterContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                label: "Anuluj",
                icon: "pi pi-times",
                onClick: ()=>onHide(),
                className: "p-button-text"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                label: "OK",
                icon: "pi pi-check",
                onClick: ()=>{
                    handleSendData();
                },
                autoFocus: true
            })
        ]
    });
    function handleChangeID(e) {
        setValues({
            ...values,
            route_id: e.target.value
        });
    }
    function handleChangeRouteShortName(e) {
        setValues({
            ...values,
            route_short_name: e.target.value
        });
    }
    function handleChangeRouteLongName(e) {
        setValues({
            ...values,
            route_long_name: e.value
        });
    }
    async function handleSendData() {
        const data = {
            fields: {
                route_id: values.route_id ? values.route_id : defaultId,
                route_short_name: values.route_short_name,
                route_long_name: values.route_long_name,
                route_color: 'ffffff',
                route_text_color: '000000',
                agency_id: 1,
                route_type: 3,
                suspended: 1
            }
        };
        try {
            const mutation = await newRouteMutation.mutateAsync(data);
            onHide();
            // po udanym dodaniu przystanku otwórz go w edytorze
            toolDispatch({
                type: 'changed',
                newTool: {
                    ...(0, $91fa2a3eb54dc801$export$88ae2e76299eaa00).tools.routesTool,
                    selection: data.fields.route_id,
                    propertyEditor: {
                        edit: data.fields
                    }
                }
            });
        } catch (error) {
            const errorCode = error.message.slice(0, 3);
            if (errorCode == '422') {
                //obsługa błędów walidacji
                let updatedValidationErrors = {};
                let propertyNames = Object.keys(error.cause.validation);
                propertyNames.forEach((value)=>{
                    messages = Object.values(error.cause.validation[value]).join(', ');
                    updatedValidationErrors[value] = messages;
                });
                setValues({
                    ...values,
                    validation_errors: {
                        ...updatedValidationErrors
                    }
                });
            } else //obsługa wszystkich pozostałych błędów
            handleOverlay('toast', {
                severity: "error",
                summary: "B\u0142\u0105d " + errorCode,
                detail: error.message
            });
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3c56f96c6f20f77$export$3ddf2d174ce01153), {
        header: "Nowa linia",
        footer: dialogFooterContent,
        visible: visible,
        style: {
            width: '50vw',
            maxWidth: '500px'
        },
        breakpoints: {
            '960px': '75vw',
            '641px': '100vw'
        },
        onHide: onHide,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "m-0",
            children: defaultIdStatus === 'success' || defaultIdStatus === 'error' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3055f2719f064def$export$8cc69cc26244aa41), {
                values: {
                    ...values,
                    route_id: values.route_id ? values.route_id : defaultId
                },
                onChangeRouteId: handleChangeID,
                onChangeRouteShortName: handleChangeRouteShortName,
                onChangeRouteLongName: handleChangeRouteLongName
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec34a5c615255cb$export$dcc7532e7120780d), {})
        })
    });
}


function $ff1247d49b7577bb$export$1e874fa7547c249e() {
    const { isPending: isPending, error: error, data: data } = (0, $4529664c1ee19d35$export$c3a687f3d6e3fb65)('routes');
    const [filterText, setFilterText] = (0, $acw62.useState)('');
    let GRoute = data;
    if (isPending) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec34a5c615255cb$export$dcc7532e7120780d), {
        className: "flex justify-content-center"
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                className: "fa-solid fa-face-frown fa-5x"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            "Wyst\u0105pi\u0142 b\u0142\u0105d \u0142adowania linii: ",
            error.message
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39fba10236e696df$export$e310308e1c9f886), {
                filterText: filterText,
                onFilterTextChange: setFilterText,
                placeholder: "Znajd\u017A lini\u0119"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ff1247d49b7577bb$var$RouteList, {
                filterText: filterText,
                GRoute: GRoute
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ff1247d49b7577bb$var$RouteBottomPanel, {})
        ]
    });
}
function $ff1247d49b7577bb$var$RouteList({ filterText: filterText }) {
    const { isPending: isPending, error: error, data: GRoutes } = (0, $4529664c1ee19d35$export$c3a687f3d6e3fb65)('routes');
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const dispatch = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$6bbcf3368996eea5));
    const items = [];
    if (isPending || !GRoutes) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec34a5c615255cb$export$dcc7532e7120780d), {});
    Object.entries(GRoutes).forEach(([key, element])=>{
        if (String(element.route_short_name).toLowerCase().indexOf(filterText.toLowerCase()) === -1 && element.route_id.toLowerCase().indexOf(filterText.toLowerCase()) === -1 && element.route_long_name.toLowerCase().indexOf(filterText.toLowerCase()) === -1) return;
        items.push(element);
    });
    const itemTemplate = (item, options)=>{
        const className = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('flex align-items-center gap-1 hover:text-orange-700 cursor-pointer align-items-center p-2', {
            'surface-hover': options.odd
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                height: options.props.itemSize + 'px',
                whiteSpace: 'nowrap',
                overflow: 'hidden'
            },
            className: className,
            onDoubleClick: ()=>{
                dispatch({
                    type: 'changed',
                    newTool: {
                        ...tool,
                        selection: item.route_id,
                        propertyEditor: {
                            edit: item
                        }
                    }
                });
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a665a3ac8a12ef4$export$f0b439f829a094d), {
                    GRoute: item
                }),
                item.route_short_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2cd10a5f6773a01$export$bfbea4d618559e4a), {
                    GRoute: item
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "text-sm",
                    children: [
                        item.route_short_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                            children: item.route_long_name
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                            className: "hover:text-orange-700",
                            style: {
                                display: "inline-block",
                                fontWeight: "normal",
                                backgroundColor: '#' + item.route_color,
                                color: '#' + item.route_text_color,
                                borderStyle: 'solid',
                                borderWidth: '0.5pt',
                                padding: '2px',
                                borderColor: '#' + item.route_text_color
                            },
                            children: item.route_long_name
                        }),
                        item.suspended ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-red-200",
                            children: " zawieszona "
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-200",
                            children: item.network_id
                        })
                    ]
                })
            ]
        }, item.route_id);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50cb59e69476e4bf$export$fbd4ea7fe0fb889), {
            items: items,
            itemSize: 55,
            itemTemplate: itemTemplate,
            showLoader: true,
            className: "border-1 surface-border border-round w-full",
            style: {
                height: '92%'
            }
        })
    });
}
function $ff1247d49b7577bb$var$RouteBottomPanel() {
    const [dialogVisible, setDialogVisible] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "w-full p-3",
        style: {
            height: '3%'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                severity: "success",
                icon: "fa-solid fa-plus",
                label: "Dodaj now\u0105 lini\u0119",
                outlined: true,
                onClick: ()=>{
                    setDialogVisible(true);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $71f78cb9f165c1c4$export$6da1dca7da6e390e), {
                visible: dialogVisible,
                onHide: ()=>{
                    if (!dialogVisible) return;
                    setDialogVisible(false);
                }
            })
        ]
    });
}



function $dc298fb1b60eb998$export$3565eb3d00ca5a74() {
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    let panelHeight = '82vh';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                height: panelHeight
            },
            children: tool.propertyEditor == null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ff1247d49b7577bb$export$1e874fa7547c249e), {
                className: "flex align-content-center"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10aab0d7f6d3d904$export$b23901d4da9b75d8), {
                GRoute: tool.propertyEditor.edit
            }, tool.propertyEditor.edit.route_id)
        })
    });
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

'use client';
function $52de9a7ac5fafbe2$var$_extends() {
    return $52de9a7ac5fafbe2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $52de9a7ac5fafbe2$var$_extends.apply(null, arguments);
}
var $52de9a7ac5fafbe2$export$1c939d3c9b6931b = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $52de9a7ac5fafbe2$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.99994 14C6.91097 14.0004 6.82281 13.983 6.74064 13.9489C6.65843 13.9148 6.58387 13.8646 6.52133 13.8013L1.10198 8.38193C0.982318 8.25351 0.917175 8.08367 0.920272 7.90817C0.923368 7.73267 0.994462 7.56523 1.11858 7.44111C1.24269 7.317 1.41014 7.2459 1.58563 7.2428C1.76113 7.23971 1.93098 7.30485 2.0594 7.42451L6.32263 11.6877V0.677419C6.32263 0.497756 6.394 0.325452 6.52104 0.198411C6.64808 0.0713706 6.82039 0 7.00005 0C7.17971 0 7.35202 0.0713706 7.47906 0.198411C7.6061 0.325452 7.67747 0.497756 7.67747 0.677419V11.6877L11.9407 7.42451C12.0691 7.30485 12.2389 7.23971 12.4144 7.2428C12.5899 7.2459 12.7574 7.317 12.8815 7.44111C13.0056 7.56523 13.0767 7.73267 13.0798 7.90817C13.0829 8.08367 13.0178 8.25351 12.8981 8.38193L7.47875 13.8013C7.41621 13.8646 7.34164 13.9148 7.25944 13.9489C7.17727 13.983 7.08912 14.0004 7.00015 14C7.00012 14 7.00009 14 7.00005 14C7.00001 14 6.99998 14 6.99994 14Z",
        fill: "currentColor"
    }));
}));
$52de9a7ac5fafbe2$export$1c939d3c9b6931b.displayName = 'ArrowDownIcon';



var $acw62 = parcelRequire("acw62");

'use client';
function $ea99738bd0d0eedb$var$_extends() {
    return $ea99738bd0d0eedb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ea99738bd0d0eedb$var$_extends.apply(null, arguments);
}
var $ea99738bd0d0eedb$export$f1a507b991affc46 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $ea99738bd0d0eedb$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.51551 13.799C6.64205 13.9255 6.813 13.9977 6.99193 14C7.17087 13.9977 7.34182 13.9255 7.46835 13.799C7.59489 13.6725 7.66701 13.5015 7.66935 13.3226V2.31233L11.9326 6.57554C11.9951 6.63887 12.0697 6.68907 12.1519 6.72319C12.2341 6.75731 12.3223 6.77467 12.4113 6.77425C12.5003 6.77467 12.5885 6.75731 12.6707 6.72319C12.7529 6.68907 12.8274 6.63887 12.89 6.57554C13.0168 6.44853 13.0881 6.27635 13.0881 6.09683C13.0881 5.91732 13.0168 5.74514 12.89 5.61812L7.48846 0.216594C7.48274 0.210436 7.4769 0.204374 7.47094 0.198411C7.3439 0.0713707 7.1716 0 6.99193 0C6.81227 0 6.63997 0.0713707 6.51293 0.198411C6.50704 0.204296 6.50128 0.210278 6.49563 0.216354L1.09386 5.61812C0.974201 5.74654 0.909057 5.91639 0.912154 6.09189C0.91525 6.26738 0.986345 6.43483 1.11046 6.55894C1.23457 6.68306 1.40202 6.75415 1.57752 6.75725C1.75302 6.76035 1.92286 6.6952 2.05128 6.57554L6.31451 2.31231V13.3226C6.31685 13.5015 6.38898 13.6725 6.51551 13.799Z",
        fill: "currentColor"
    }));
}));
$ea99738bd0d0eedb$export$f1a507b991affc46.displayName = 'ArrowUpIcon';




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

'use client';
function $f24a8bfa1942f2ac$var$_extends() {
    return $f24a8bfa1942f2ac$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f24a8bfa1942f2ac$var$_extends.apply(null, arguments);
}
var $f24a8bfa1942f2ac$export$2f7bdd6eb480d530 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $f24a8bfa1942f2ac$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.71602 11.164C5.80782 11.2021 5.9063 11.2215 6.00569 11.221C6.20216 11.2301 6.39427 11.1612 6.54025 11.0294C6.68191 10.8875 6.76148 10.6953 6.76148 10.4948C6.76148 10.2943 6.68191 10.1021 6.54025 9.96024L3.51441 6.9344L6.54025 3.90855C6.624 3.76126 6.65587 3.59011 6.63076 3.42254C6.60564 3.25498 6.525 3.10069 6.40175 2.98442C6.2785 2.86815 6.11978 2.79662 5.95104 2.7813C5.78229 2.76598 5.61329 2.80776 5.47112 2.89994L1.97123 6.39983C1.82957 6.54167 1.75 6.73393 1.75 6.9344C1.75 7.13486 1.82957 7.32712 1.97123 7.46896L5.47112 10.9991C5.54096 11.0698 5.62422 11.1259 5.71602 11.164ZM11.0488 10.9689C11.1775 11.1156 11.3585 11.2061 11.5531 11.221C11.7477 11.2061 11.9288 11.1156 12.0574 10.9689C12.1815 10.8302 12.25 10.6506 12.25 10.4645C12.25 10.2785 12.1815 10.0989 12.0574 9.96024L9.03158 6.93439L12.0574 3.90855C12.1248 3.76739 12.1468 3.60881 12.1204 3.45463C12.0939 3.30045 12.0203 3.15826 11.9097 3.04765C11.7991 2.93703 11.6569 2.86343 11.5027 2.83698C11.3486 2.81053 11.19 2.83252 11.0488 2.89994L7.51865 6.36957C7.37699 6.51141 7.29742 6.70367 7.29742 6.90414C7.29742 7.1046 7.37699 7.29686 7.51865 7.4387L11.0488 10.9689Z",
        fill: "currentColor"
    }));
}));
$f24a8bfa1942f2ac$export$2f7bdd6eb480d530.displayName = 'AngleDoubleLeftIcon';





var $acw62 = parcelRequire("acw62");

'use client';
function $2dda038d72db8524$var$_extends() {
    return $2dda038d72db8524$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2dda038d72db8524$var$_extends.apply(null, arguments);
}
var $2dda038d72db8524$export$3741352f2ad35b27 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $2dda038d72db8524$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.68757 11.1451C7.7791 11.1831 7.8773 11.2024 7.9764 11.2019C8.07769 11.1985 8.17721 11.1745 8.26886 11.1312C8.36052 11.088 8.44238 11.0265 8.50943 10.9505L12.0294 7.49085C12.1707 7.34942 12.25 7.15771 12.25 6.95782C12.25 6.75794 12.1707 6.56622 12.0294 6.42479L8.50943 2.90479C8.37014 2.82159 8.20774 2.78551 8.04633 2.80192C7.88491 2.81833 7.73309 2.88635 7.6134 2.99588C7.4937 3.10541 7.41252 3.25061 7.38189 3.40994C7.35126 3.56927 7.37282 3.73423 7.44337 3.88033L10.4605 6.89748L7.44337 9.91463C7.30212 10.0561 7.22278 10.2478 7.22278 10.4477C7.22278 10.6475 7.30212 10.8393 7.44337 10.9807C7.51301 11.0512 7.59603 11.1071 7.68757 11.1451ZM1.94207 10.9505C2.07037 11.0968 2.25089 11.1871 2.44493 11.2019C2.63898 11.1871 2.81949 11.0968 2.94779 10.9505L6.46779 7.49085C6.60905 7.34942 6.68839 7.15771 6.68839 6.95782C6.68839 6.75793 6.60905 6.56622 6.46779 6.42479L2.94779 2.90479C2.80704 2.83757 2.6489 2.81563 2.49517 2.84201C2.34143 2.86839 2.19965 2.94178 2.08936 3.05207C1.97906 3.16237 1.90567 3.30415 1.8793 3.45788C1.85292 3.61162 1.87485 3.76975 1.94207 3.9105L4.95922 6.92765L1.94207 9.9448C1.81838 10.0831 1.75 10.2621 1.75 10.4477C1.75 10.6332 1.81838 10.8122 1.94207 10.9505Z",
        fill: "currentColor"
    }));
}));
$2dda038d72db8524$export$3741352f2ad35b27.displayName = 'AngleDoubleRightIcon';



var $acw62 = parcelRequire("acw62");

'use client';
function $e73ad5d038623fb5$var$_extends() {
    return $e73ad5d038623fb5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e73ad5d038623fb5$var$_extends.apply(null, arguments);
}
var $e73ad5d038623fb5$export$f5db305c33b6241b = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $e73ad5d038623fb5$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5.25 11.1728C5.14929 11.1694 5.05033 11.1455 4.9592 11.1025C4.86806 11.0595 4.78666 10.9984 4.72 10.9228C4.57955 10.7822 4.50066 10.5916 4.50066 10.3928C4.50066 10.1941 4.57955 10.0035 4.72 9.86283L7.72 6.86283L4.72 3.86283C4.66067 3.71882 4.64765 3.55991 4.68275 3.40816C4.71785 3.25642 4.79932 3.11936 4.91585 3.01602C5.03238 2.91268 5.17819 2.84819 5.33305 2.83149C5.4879 2.81479 5.64411 2.84671 5.78 2.92283L9.28 6.42283C9.42045 6.56346 9.49934 6.75408 9.49934 6.95283C9.49934 7.15158 9.42045 7.34221 9.28 7.48283L5.78 10.9228C5.71333 10.9984 5.63193 11.0595 5.5408 11.1025C5.44966 11.1455 5.35071 11.1694 5.25 11.1728Z",
        fill: "currentColor"
    }));
}));
$e73ad5d038623fb5$export$f5db305c33b6241b.displayName = 'AngleRightIcon';



var $acw62 = parcelRequire("acw62");

'use client';
function $0cd470e69a5f4267$var$_extends() {
    return $0cd470e69a5f4267$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0cd470e69a5f4267$var$_extends.apply(null, arguments);
}
var $0cd470e69a5f4267$export$3df4a161b319f37a = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $0cd470e69a5f4267$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8.75 11.185C8.65146 11.1854 8.55381 11.1662 8.4628 11.1284C8.37179 11.0906 8.28924 11.0351 8.22 10.965L4.72 7.46496C4.57955 7.32433 4.50066 7.13371 4.50066 6.93496C4.50066 6.73621 4.57955 6.54558 4.72 6.40496L8.22 2.93496C8.36095 2.84357 8.52851 2.80215 8.69582 2.81733C8.86312 2.83252 9.02048 2.90344 9.14268 3.01872C9.26487 3.134 9.34483 3.28696 9.36973 3.4531C9.39463 3.61924 9.36303 3.78892 9.28 3.93496L6.28 6.93496L9.28 9.93496C9.42045 10.0756 9.49934 10.2662 9.49934 10.465C9.49934 10.6637 9.42045 10.8543 9.28 10.995C9.13526 11.1257 8.9448 11.1939 8.75 11.185Z",
        fill: "currentColor"
    }));
}));
$0cd470e69a5f4267$export$3df4a161b319f37a.displayName = 'AngleLeftIcon';



'use client';
function $6cec6232b30d1913$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $6cec6232b30d1913$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $6cec6232b30d1913$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $6cec6232b30d1913$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $6cec6232b30d1913$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6cec6232b30d1913$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $6cec6232b30d1913$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6cec6232b30d1913$var$_slicedToArray(r, e) {
    return $6cec6232b30d1913$var$_arrayWithHoles(r) || $6cec6232b30d1913$var$_iterableToArrayLimit(r, e) || $6cec6232b30d1913$var$_unsupportedIterableToArray(r, e) || $6cec6232b30d1913$var$_nonIterableRest();
}
function $6cec6232b30d1913$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6cec6232b30d1913$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6cec6232b30d1913$var$_typeof(o);
}
function $6cec6232b30d1913$var$toPrimitive(t, r) {
    if ("object" != $6cec6232b30d1913$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6cec6232b30d1913$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6cec6232b30d1913$var$toPropertyKey(t) {
    var i = $6cec6232b30d1913$var$toPrimitive(t, "string");
    return "symbol" == $6cec6232b30d1913$var$_typeof(i) ? i : i + "";
}
function $6cec6232b30d1913$var$_defineProperty(e, r, t) {
    return (r = $6cec6232b30d1913$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $6cec6232b30d1913$var$classes = {
    root: 'p-paginator p-component',
    left: 'p-paginator-left-content',
    end: 'p-paginator-right-content',
    firstPageIcon: 'p-paginator-icon',
    firstPageButton: function firstPageButton(_ref) {
        var disabled = _ref.disabled;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-paginator-first p-paginator-element p-link', {
            'p-disabled': disabled
        });
    },
    prevPageIcon: 'p-paginator-icon',
    prevPageButton: function prevPageButton(_ref2) {
        var disabled = _ref2.disabled;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-paginator-prev p-paginator-element p-link', {
            'p-disabled': disabled
        });
    },
    nextPageIcon: 'p-paginator-icon',
    nextPageButton: function nextPageButton(_ref3) {
        var disabled = _ref3.disabled;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-paginator-next p-paginator-element p-link', {
            'p-disabled': disabled
        });
    },
    lastPageIcon: 'p-paginator-icon',
    lastPageButton: function lastPageButton(_ref4) {
        var disabled = _ref4.disabled;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-paginator-last p-paginator-element p-link', {
            'p-disabled': disabled
        });
    },
    pageButton: function pageButton(_ref5) {
        var pageLink = _ref5.pageLink, startPageInView = _ref5.startPageInView, endPageInView = _ref5.endPageInView, page = _ref5.page;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-paginator-page p-paginator-element p-link', {
            'p-paginator-page-start': pageLink === startPageInView,
            'p-paginator-page-end': pageLink === endPageInView,
            'p-highlight': pageLink - 1 === page
        });
    },
    pages: 'p-paginator-pages'
};
var $6cec6232b30d1913$var$styles = "\n@layer primereact {\n    .p-paginator {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-wrap: wrap;\n    }\n    \n    .p-paginator-left-content {\n        margin-right: auto;\n    }\n    \n    .p-paginator-right-content {\n        margin-left: auto;\n    }\n    \n    .p-paginator-page,\n    .p-paginator-next,\n    .p-paginator-last,\n    .p-paginator-first,\n    .p-paginator-prev,\n    .p-paginator-current {\n        cursor: pointer;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        line-height: 1;\n        user-select: none;\n        overflow: hidden;\n        position: relative;\n    }\n    \n    .p-paginator-element:focus {\n        z-index: 1;\n        position: relative;\n    }\n}\n";
var $6cec6232b30d1913$var$PaginatorBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'Paginator',
        __parentMetadata: null,
        totalRecords: 0,
        rows: 0,
        first: 0,
        pageLinkSize: 5,
        rowsPerPageOptions: null,
        alwaysShow: true,
        style: null,
        className: null,
        template: 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown',
        onPageChange: null,
        leftContent: null,
        rightContent: null,
        dropdownAppendTo: null,
        currentPageReportTemplate: '({currentPage} of {totalPages})',
        children: undefined
    },
    css: {
        classes: $6cec6232b30d1913$var$classes,
        styles: $6cec6232b30d1913$var$styles
    }
});
var $6cec6232b30d1913$var$CurrentPageReportBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'CurrentPageReport',
        pageCount: null,
        page: null,
        first: null,
        rows: null,
        totalRecords: null,
        reportTemplate: '({currentPage} of {totalPages})',
        template: null,
        children: undefined
    }
});
var $6cec6232b30d1913$var$FirstPageLinkBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'FirstPageLink',
        disabled: false,
        onClick: null,
        template: null,
        firstPageLinkIcon: null,
        children: undefined
    }
});
var $6cec6232b30d1913$var$JumpToPageInputBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'JumpToPageInput',
        page: null,
        rows: null,
        pageCount: null,
        disabled: false,
        template: null,
        onChange: null,
        children: undefined,
        metaData: null,
        ptm: null
    }
});
var $6cec6232b30d1913$var$LastPageLinkBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'LastPageLink',
        disabled: false,
        onClick: null,
        template: null,
        lastPageLinkIcon: null,
        children: undefined
    }
});
var $6cec6232b30d1913$var$NextPageLinkBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'NextPageLink',
        disabled: false,
        onClick: null,
        template: null,
        nextPageLinkIcon: null,
        children: undefined
    }
});
var $6cec6232b30d1913$var$PageLinksBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'PageLinks',
        value: null,
        page: null,
        rows: null,
        pageCount: null,
        links: null,
        template: null,
        children: undefined
    }
});
var $6cec6232b30d1913$var$PrevPageLinkBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'PrevPageLink',
        disabled: false,
        onClick: null,
        template: null,
        prevPageLinkIcon: null,
        children: undefined
    }
});
var $6cec6232b30d1913$var$RowsPerPageDropdownBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'RowsPerPageDropdown',
        options: null,
        value: null,
        page: null,
        pageCount: null,
        totalRecords: 0,
        appendTo: null,
        onChange: null,
        template: null,
        disabled: false,
        children: undefined
    }
});
function $6cec6232b30d1913$var$ownKeys$5(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6cec6232b30d1913$var$_objectSpread$5(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6cec6232b30d1913$var$ownKeys$5(Object(t), !0).forEach(function(r) {
            $6cec6232b30d1913$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6cec6232b30d1913$var$ownKeys$5(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6cec6232b30d1913$var$CurrentPageReport = /*#__PURE__*/ $acw62.memo(function(inProps) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $6cec6232b30d1913$var$CurrentPageReportBase.getProps(inProps, context);
    var report = {
        currentPage: props.page + 1,
        totalPages: props.totalPages,
        first: Math.min(props.first + 1, props.totalRecords),
        last: Math.min(props.first + props.rows, props.totalRecords),
        rows: props.rows,
        totalRecords: props.totalRecords
    };
    var text = props.reportTemplate.replace('{currentPage}', report.currentPage).replace('{totalPages}', report.totalPages).replace('{first}', report.first).replace('{last}', report.last).replace('{rows}', report.rows).replace('{totalRecords}', report.totalRecords);
    var currentProps = mergeProps({
        'aria-live': 'polite',
        className: 'p-paginator-current'
    }, props.ptm('current', {
        hostName: props.hostName
    }));
    var element = /*#__PURE__*/ $acw62.createElement("span", currentProps, text);
    if (props.template) {
        var defaultOptions = $6cec6232b30d1913$var$_objectSpread$5($6cec6232b30d1913$var$_objectSpread$5({}, report), {
            ariaLive: 'polite',
            className: 'p-paginator-current',
            element: element,
            props: props
        });
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.template, defaultOptions);
    }
    return element;
});
$6cec6232b30d1913$var$CurrentPageReport.displayName = 'CurrentPageReport';
function $6cec6232b30d1913$var$ownKeys$4(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6cec6232b30d1913$var$_objectSpread$4(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6cec6232b30d1913$var$ownKeys$4(Object(t), !0).forEach(function(r) {
            $6cec6232b30d1913$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6cec6232b30d1913$var$ownKeys$4(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6cec6232b30d1913$var$FirstPageLink = /*#__PURE__*/ $acw62.memo(function(inProps) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $6cec6232b30d1913$var$FirstPageLinkBase.getProps(inProps, context);
    var ptm = props.ptm, cx = props.cx;
    var getPTOptions = function getPTOptions(key) {
        return ptm(key, {
            hostName: props.hostName,
            context: {
                disabled: props.disabled
            }
        });
    };
    var className = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-paginator-first p-paginator-element p-link', {
        'p-disabled': props.disabled
    });
    var iconClassName = 'p-paginator-icon';
    var firstPageIconProps = mergeProps({
        className: cx('firstPageIcon')
    }, getPTOptions('firstPageIcon'));
    var icon = props.firstPageLinkIcon || /*#__PURE__*/ $acw62.createElement((0, $f24a8bfa1942f2ac$export$2f7bdd6eb480d530), firstPageIconProps);
    var firstPageLinkIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $6cec6232b30d1913$var$_objectSpread$4({}, firstPageIconProps), {
        props: props
    });
    var firstPageButtonProps = mergeProps({
        type: 'button',
        className: cx('firstPageButton', {
            disabled: props.disabled
        }),
        onClick: props.onClick,
        disabled: props.disabled,
        'aria-label': (0, $51b25b42ecc1a0c7$export$eb839c9fd3d638b9)('firstPageLabel')
    }, getPTOptions('firstPageButton'));
    var element = /*#__PURE__*/ $acw62.createElement("button", firstPageButtonProps, firstPageLinkIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
    if (props.template) {
        var defaultOptions = {
            onClick: props.onClick,
            className: className,
            iconClassName: iconClassName,
            disabled: props.disabled,
            element: element,
            props: props
        };
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.template, defaultOptions);
    }
    return element;
});
$6cec6232b30d1913$var$FirstPageLink.displayName = 'FirstPageLink';
function $6cec6232b30d1913$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $6cec6232b30d1913$var$toPropertyKey(o.key), o);
    }
}
function $6cec6232b30d1913$var$_createClass(e, r, t) {
    return r && $6cec6232b30d1913$var$_defineProperties(e.prototype, r), t && $6cec6232b30d1913$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $6cec6232b30d1913$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
var $6cec6232b30d1913$var$FilterMatchMode = Object.freeze({
    STARTS_WITH: 'startsWith',
    CONTAINS: 'contains',
    NOT_CONTAINS: 'notContains',
    ENDS_WITH: 'endsWith',
    EQUALS: 'equals',
    NOT_EQUALS: 'notEquals',
    IN: 'in',
    LESS_THAN: 'lt',
    LESS_THAN_OR_EQUAL_TO: 'lte',
    GREATER_THAN: 'gt',
    GREATER_THAN_OR_EQUAL_TO: 'gte',
    BETWEEN: 'between',
    DATE_IS: 'dateIs',
    DATE_IS_NOT: 'dateIsNot',
    DATE_BEFORE: 'dateBefore',
    DATE_AFTER: 'dateAfter',
    CUSTOM: 'custom'
});
/**
 * @deprecated please use PrimeReactContext
 */ var $6cec6232b30d1913$var$PrimeReact = /*#__PURE__*/ $6cec6232b30d1913$var$_createClass(function PrimeReact() {
    $6cec6232b30d1913$var$_classCallCheck(this, PrimeReact);
});
$6cec6232b30d1913$var$_defineProperty($6cec6232b30d1913$var$PrimeReact, "ripple", false);
$6cec6232b30d1913$var$_defineProperty($6cec6232b30d1913$var$PrimeReact, "inputStyle", 'outlined');
$6cec6232b30d1913$var$_defineProperty($6cec6232b30d1913$var$PrimeReact, "locale", 'en');
$6cec6232b30d1913$var$_defineProperty($6cec6232b30d1913$var$PrimeReact, "appendTo", null);
$6cec6232b30d1913$var$_defineProperty($6cec6232b30d1913$var$PrimeReact, "cssTransition", true);
$6cec6232b30d1913$var$_defineProperty($6cec6232b30d1913$var$PrimeReact, "autoZIndex", true);
$6cec6232b30d1913$var$_defineProperty($6cec6232b30d1913$var$PrimeReact, "hideOverlaysOnDocumentScrolling", false);
$6cec6232b30d1913$var$_defineProperty($6cec6232b30d1913$var$PrimeReact, "nonce", null);
$6cec6232b30d1913$var$_defineProperty($6cec6232b30d1913$var$PrimeReact, "nullSortOrder", 1);
$6cec6232b30d1913$var$_defineProperty($6cec6232b30d1913$var$PrimeReact, "zIndex", {
    modal: 1100,
    overlay: 1000,
    menu: 1000,
    tooltip: 1100,
    toast: 1200
});
$6cec6232b30d1913$var$_defineProperty($6cec6232b30d1913$var$PrimeReact, "pt", undefined);
$6cec6232b30d1913$var$_defineProperty($6cec6232b30d1913$var$PrimeReact, "filterMatchModeOptions", {
    text: [
        $6cec6232b30d1913$var$FilterMatchMode.STARTS_WITH,
        $6cec6232b30d1913$var$FilterMatchMode.CONTAINS,
        $6cec6232b30d1913$var$FilterMatchMode.NOT_CONTAINS,
        $6cec6232b30d1913$var$FilterMatchMode.ENDS_WITH,
        $6cec6232b30d1913$var$FilterMatchMode.EQUALS,
        $6cec6232b30d1913$var$FilterMatchMode.NOT_EQUALS
    ],
    numeric: [
        $6cec6232b30d1913$var$FilterMatchMode.EQUALS,
        $6cec6232b30d1913$var$FilterMatchMode.NOT_EQUALS,
        $6cec6232b30d1913$var$FilterMatchMode.LESS_THAN,
        $6cec6232b30d1913$var$FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
        $6cec6232b30d1913$var$FilterMatchMode.GREATER_THAN,
        $6cec6232b30d1913$var$FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
    ],
    date: [
        $6cec6232b30d1913$var$FilterMatchMode.DATE_IS,
        $6cec6232b30d1913$var$FilterMatchMode.DATE_IS_NOT,
        $6cec6232b30d1913$var$FilterMatchMode.DATE_BEFORE,
        $6cec6232b30d1913$var$FilterMatchMode.DATE_AFTER
    ]
});
$6cec6232b30d1913$var$_defineProperty($6cec6232b30d1913$var$PrimeReact, "changeTheme", function(currentTheme, newTheme, linkElementId, callback) {
    var _linkElement$parentNo;
    var linkElement = document.getElementById(linkElementId);
    if (!linkElement) throw Error("Element with id ".concat(linkElementId, " not found."));
    var newThemeUrl = linkElement.getAttribute('href').replace(currentTheme, newTheme);
    var newLinkElement = document.createElement('link');
    newLinkElement.setAttribute('rel', 'stylesheet');
    newLinkElement.setAttribute('id', linkElementId);
    newLinkElement.setAttribute('href', newThemeUrl);
    newLinkElement.addEventListener('load', function() {
        if (callback) callback();
    });
    (_linkElement$parentNo = linkElement.parentNode) === null || _linkElement$parentNo === void 0 || _linkElement$parentNo.replaceChild(newLinkElement, linkElement);
});
var $6cec6232b30d1913$var$locales = {
    en: {
        accept: 'Yes',
        addRule: 'Add Rule',
        am: 'AM',
        apply: 'Apply',
        cancel: 'Cancel',
        choose: 'Choose',
        chooseDate: 'Choose Date',
        chooseMonth: 'Choose Month',
        chooseYear: 'Choose Year',
        clear: 'Clear',
        completed: 'Completed',
        contains: 'Contains',
        custom: 'Custom',
        dateAfter: 'Date is after',
        dateBefore: 'Date is before',
        dateFormat: 'mm/dd/yy',
        dateIs: 'Date is',
        dateIsNot: 'Date is not',
        dayNames: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ],
        dayNamesMin: [
            'Su',
            'Mo',
            'Tu',
            'We',
            'Th',
            'Fr',
            'Sa'
        ],
        dayNamesShort: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ],
        emptyFilterMessage: 'No results found',
        emptyMessage: 'No available options',
        emptySearchMessage: 'No results found',
        emptySelectionMessage: 'No selected item',
        endsWith: 'Ends with',
        equals: 'Equals',
        fileSizeTypes: [
            'B',
            'KB',
            'MB',
            'GB',
            'TB',
            'PB',
            'EB',
            'ZB',
            'YB'
        ],
        filter: 'Filter',
        firstDayOfWeek: 0,
        gt: 'Greater than',
        gte: 'Greater than or equal to',
        lt: 'Less than',
        lte: 'Less than or equal to',
        matchAll: 'Match All',
        matchAny: 'Match Any',
        medium: 'Medium',
        monthNames: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        monthNamesShort: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        nextDecade: 'Next Decade',
        nextHour: 'Next Hour',
        nextMinute: 'Next Minute',
        nextMonth: 'Next Month',
        nextSecond: 'Next Second',
        nextYear: 'Next Year',
        noFilter: 'No Filter',
        notContains: 'Not contains',
        notEquals: 'Not equals',
        now: 'Now',
        passwordPrompt: 'Enter a password',
        pending: 'Pending',
        pm: 'PM',
        prevDecade: 'Previous Decade',
        prevHour: 'Previous Hour',
        prevMinute: 'Previous Minute',
        prevMonth: 'Previous Month',
        prevSecond: 'Previous Second',
        prevYear: 'Previous Year',
        reject: 'No',
        removeRule: 'Remove Rule',
        searchMessage: '{0} results are available',
        selectionMessage: '{0} items selected',
        showMonthAfterYear: false,
        startsWith: 'Starts with',
        strong: 'Strong',
        today: 'Today',
        upload: 'Upload',
        weak: 'Weak',
        weekHeader: 'Wk',
        aria: {
            cancelEdit: 'Cancel Edit',
            close: 'Close',
            collapseRow: 'Row Collapsed',
            editRow: 'Edit Row',
            expandRow: 'Row Expanded',
            falseLabel: 'False',
            filterConstraint: 'Filter Constraint',
            filterOperator: 'Filter Operator',
            firstPageLabel: 'First Page',
            gridView: 'Grid View',
            hideFilterMenu: 'Hide Filter Menu',
            jumpToPageDropdownLabel: 'Jump to Page Dropdown',
            jumpToPageInputLabel: 'Jump to Page Input',
            lastPageLabel: 'Last Page',
            listView: 'List View',
            moveAllToSource: 'Move All to Source',
            moveAllToTarget: 'Move All to Target',
            moveBottom: 'Move Bottom',
            moveDown: 'Move Down',
            moveToSource: 'Move to Source',
            moveToTarget: 'Move to Target',
            moveTop: 'Move Top',
            moveUp: 'Move Up',
            navigation: 'Navigation',
            next: 'Next',
            nextPageLabel: 'Next Page',
            nullLabel: 'Not Selected',
            pageLabel: 'Page {page}',
            otpLabel: 'Please enter one time password character {0}',
            passwordHide: 'Hide Password',
            passwordShow: 'Show Password',
            previous: 'Previous',
            previousPageLabel: 'Previous Page',
            rotateLeft: 'Rotate Left',
            rotateRight: 'Rotate Right',
            rowsPerPageLabel: 'Rows per page',
            saveEdit: 'Save Edit',
            scrollTop: 'Scroll Top',
            selectAll: 'All items selected',
            selectRow: 'Row Selected',
            showFilterMenu: 'Show Filter Menu',
            slide: 'Slide',
            slideNumber: '{slideNumber}',
            star: '1 star',
            stars: '{star} stars',
            trueLabel: 'True',
            unselectAll: 'All items unselected',
            unselectRow: 'Row Unselected',
            zoomImage: 'Zoom Image',
            zoomIn: 'Zoom In',
            zoomOut: 'Zoom Out'
        }
    }
};
/**
 * Find an ARIA label in the locale by key.  If options are passed it will replace all options:
 * ```ts
 * const ariaValue = "Page {page}, User {user}, Role {role}";
 * const options = { page: 2, user: "John", role: "Admin" };
 * const result = ariaLabel('yourLabel', { page: 2, user: "John", role: "Admin" })
 * console.log(result); // Output: Page 2, User John, Role Admin
 * ```
 * @param {string} ariaKey key of the ARIA label to look up in locale.
 * @param {any} options JSON options like { page: 2, user: "John", role: "Admin" }
 * @returns the ARIA label with replaced values
 */ function $6cec6232b30d1913$var$ariaLabel(ariaKey, options) {
    if (ariaKey.includes('__proto__') || ariaKey.includes('prototype')) throw new Error('Unsafe ariaKey detected');
    var _locale = $6cec6232b30d1913$var$PrimeReact.locale;
    try {
        var _ariaLabel = $6cec6232b30d1913$var$localeOptions(_locale).aria[ariaKey];
        if (_ariaLabel) {
            for(var key in options)if (options.hasOwnProperty(key)) _ariaLabel = _ariaLabel.replace("{".concat(key, "}"), options[key]);
        }
        return _ariaLabel;
    } catch (error) {
        throw new Error("The ".concat(ariaKey, " option is not found in the current locale('").concat(_locale, "')."));
    }
}
function $6cec6232b30d1913$var$localeOptions(locale) {
    var _locale = locale || $6cec6232b30d1913$var$PrimeReact.locale;
    if (_locale.includes('__proto__') || _locale.includes('prototype')) throw new Error('Unsafe locale detected');
    return $6cec6232b30d1913$var$locales[_locale];
}
var $6cec6232b30d1913$var$JumpToPageInput = /*#__PURE__*/ $acw62.memo(function(inProps) {
    (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $6cec6232b30d1913$var$JumpToPageInputBase.getProps(inProps, context);
    var ariaLabelValue = $6cec6232b30d1913$var$ariaLabel('jumpToPageInputLabel');
    var onChange = function onChange(event) {
        if (props.onChange) props.onChange(props.rows * (event.value - 1), props.rows);
    };
    var value = props.totalPages > 0 ? props.page + 1 : 0;
    var element = /*#__PURE__*/ $acw62.createElement((0, $df4bf6c8c7efd937$export$cf9581d419a141cf), {
        value: value,
        onChange: onChange,
        className: "p-paginator-page-input",
        disabled: props.disabled,
        pt: props.ptm('JTPInput'),
        unstyled: props.unstyled,
        __parentMetadata: {
            parent: props.metaData
        },
        "aria-label": ariaLabelValue
    });
    if (props.template) {
        var defaultOptions = {
            value: value,
            onChange: onChange,
            disabled: props.disabled,
            className: 'p-paginator-page-input',
            'aria-label': ariaLabelValue,
            element: element,
            props: props
        };
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.template, defaultOptions);
    }
    return element;
});
$6cec6232b30d1913$var$JumpToPageInput.displayName = 'JumpToPageInput';
function $6cec6232b30d1913$var$ownKeys$3(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6cec6232b30d1913$var$_objectSpread$3(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6cec6232b30d1913$var$ownKeys$3(Object(t), !0).forEach(function(r) {
            $6cec6232b30d1913$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6cec6232b30d1913$var$ownKeys$3(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6cec6232b30d1913$var$LastPageLink = /*#__PURE__*/ $acw62.memo(function(inProps) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $6cec6232b30d1913$var$LastPageLinkBase.getProps(inProps, context);
    var ptm = props.ptm, cx = props.cx;
    var getPTOptions = function getPTOptions(key) {
        return ptm(key, {
            hostName: props.hostName,
            context: {
                disabled: props.disabled
            }
        });
    };
    var className = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-paginator-last p-paginator-element p-link', {
        'p-disabled': props.disabled
    });
    var iconClassName = 'p-paginator-icon';
    var lastPageIconProps = mergeProps({
        className: cx('lastPageIcon')
    }, getPTOptions('lastPageIcon'));
    var icon = props.lastPageLinkIcon || /*#__PURE__*/ $acw62.createElement((0, $2dda038d72db8524$export$3741352f2ad35b27), lastPageIconProps);
    var lastPageLinkIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $6cec6232b30d1913$var$_objectSpread$3({}, lastPageIconProps), {
        props: props
    });
    var lastPageButtonProps = mergeProps({
        type: 'button',
        className: cx('lastPageButton', {
            disabled: props.disabled
        }),
        onClick: props.onClick,
        disabled: props.disabled,
        'aria-label': (0, $51b25b42ecc1a0c7$export$eb839c9fd3d638b9)('lastPageLabel')
    }, getPTOptions('lastPageButton'));
    var element = /*#__PURE__*/ $acw62.createElement("button", lastPageButtonProps, lastPageLinkIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
    if (props.template) {
        var defaultOptions = {
            onClick: props.onClick,
            className: className,
            iconClassName: iconClassName,
            disabled: props.disabled,
            element: element,
            props: props
        };
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.template, defaultOptions);
    }
    return element;
});
$6cec6232b30d1913$var$LastPageLink.displayName = 'LastPageLink';
function $6cec6232b30d1913$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6cec6232b30d1913$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6cec6232b30d1913$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $6cec6232b30d1913$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6cec6232b30d1913$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6cec6232b30d1913$var$NextPageLink = /*#__PURE__*/ $acw62.memo(function(inProps) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $6cec6232b30d1913$var$NextPageLinkBase.getProps(inProps, context);
    var ptm = props.ptm, cx = props.cx;
    var getPTOptions = function getPTOptions(key) {
        return ptm(key, {
            hostName: props.hostName,
            context: {
                disabled: props.disabled
            }
        });
    };
    var className = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-paginator-next p-paginator-element p-link', {
        'p-disabled': props.disabled
    });
    var iconClassName = 'p-paginator-icon';
    var nextPageIconProps = mergeProps({
        className: cx('nextPageIcon')
    }, getPTOptions('nextPageIcon'));
    var icon = props.nextPageLinkIcon || /*#__PURE__*/ $acw62.createElement((0, $e73ad5d038623fb5$export$f5db305c33b6241b), nextPageIconProps);
    var nextPageLinkIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $6cec6232b30d1913$var$_objectSpread$2({}, nextPageIconProps), {
        props: props
    });
    var nextPageButtonProps = mergeProps({
        type: 'button',
        className: cx('nextPageButton', {
            disabled: props.disabled
        }),
        onClick: props.onClick,
        disabled: props.disabled,
        'aria-label': (0, $51b25b42ecc1a0c7$export$eb839c9fd3d638b9)('nextPageLabel')
    }, getPTOptions('nextPageButton'));
    var element = /*#__PURE__*/ $acw62.createElement("button", nextPageButtonProps, nextPageLinkIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
    if (props.template) {
        var defaultOptions = {
            onClick: props.onClick,
            className: className,
            iconClassName: iconClassName,
            disabled: props.disabled,
            element: element,
            nextPageLinkIcon: nextPageLinkIcon,
            props: props
        };
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.template, defaultOptions);
    }
    return element;
});
$6cec6232b30d1913$var$NextPageLink.displayName = 'NextPageLink';
var $6cec6232b30d1913$var$PageLinks = /*#__PURE__*/ $acw62.memo(function(inProps) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $6cec6232b30d1913$var$PageLinksBase.getProps(inProps, context);
    var ptm = props.ptm, cx = props.cx;
    var getPTOptions = function getPTOptions(pageLink, key) {
        return ptm(key, {
            hostName: props.hostName,
            context: {
                active: pageLink - 1 === props.page
            }
        });
    };
    var onPageLinkClick = function onPageLinkClick(event, pageLink) {
        if (props.onClick) props.onClick({
            originalEvent: event,
            value: pageLink
        });
        event.preventDefault();
    };
    var elements;
    if (props.value) {
        var startPageInView = props.value[0];
        var endPageInView = props.value[props.value.length - 1];
        elements = props.value.map(function(pageLink) {
            var className = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-paginator-page p-paginator-element p-link', {
                'p-paginator-page-start': pageLink === startPageInView,
                'p-paginator-page-end': pageLink === endPageInView,
                'p-highlight': pageLink - 1 === props.page
            });
            var pageButtonProps = mergeProps({
                type: 'button',
                onClick: function onClick(e) {
                    return onPageLinkClick(e, pageLink);
                },
                className: cx('pageButton', {
                    pageLink: pageLink,
                    startPageInView: startPageInView,
                    endPageInView: endPageInView,
                    page: props.page
                }),
                disabled: props.disabled,
                'aria-label': (0, $51b25b42ecc1a0c7$export$eb839c9fd3d638b9)('pageLabel', {
                    page: pageLink
                }),
                'aria-current': pageLink - 1 === props.page ? 'true' : undefined
            }, getPTOptions(pageLink, 'pageButton'));
            var element = /*#__PURE__*/ $acw62.createElement("button", pageButtonProps, pageLink, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
            if (props.template) {
                var defaultOptions = {
                    onClick: function onClick(e) {
                        return onPageLinkClick(e, pageLink);
                    },
                    className: className,
                    view: {
                        startPage: startPageInView - 1,
                        endPage: endPageInView - 1
                    },
                    page: pageLink - 1,
                    currentPage: props.page,
                    totalPages: props.totalPages,
                    ariaLabel: (0, $51b25b42ecc1a0c7$export$eb839c9fd3d638b9)('pageLabel', {
                        page: pageLink
                    }),
                    ariaCurrent: pageLink - 1 === props.page ? 'true' : undefined,
                    element: element,
                    props: props
                };
                element = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.template, defaultOptions);
            }
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, {
                key: pageLink
            }, element);
        });
    }
    var pagesProps = mergeProps({
        className: cx('pages')
    }, ptm('pages', {
        hostName: props.hostName
    }));
    return /*#__PURE__*/ $acw62.createElement("span", pagesProps, elements);
});
$6cec6232b30d1913$var$PageLinks.displayName = 'PageLinks';
function $6cec6232b30d1913$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6cec6232b30d1913$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6cec6232b30d1913$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $6cec6232b30d1913$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6cec6232b30d1913$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6cec6232b30d1913$var$PrevPageLink = /*#__PURE__*/ $acw62.memo(function(inProps) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $6cec6232b30d1913$var$PrevPageLinkBase.getProps(inProps, context);
    var ptm = props.ptm, cx = props.cx;
    var getPTOptions = function getPTOptions(key) {
        return ptm(key, {
            hostName: props.hostName,
            context: {
                disabled: props.disabled
            }
        });
    };
    var className = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-paginator-prev p-paginator-element p-link', {
        'p-disabled': props.disabled
    });
    var iconClassName = 'p-paginator-icon';
    var prevPageIconProps = mergeProps({
        className: cx('prevPageIcon')
    }, getPTOptions('prevPageIcon'));
    var icon = props.prevPageLinkIcon || /*#__PURE__*/ $acw62.createElement((0, $0cd470e69a5f4267$export$3df4a161b319f37a), prevPageIconProps);
    var prevPageLinkIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $6cec6232b30d1913$var$_objectSpread$1({}, prevPageIconProps), {
        props: props
    });
    var prevPageButtonProps = mergeProps({
        type: 'button',
        className: cx('prevPageButton', {
            disabled: props.disabled
        }),
        onClick: props.onClick,
        disabled: props.disabled,
        'aria-label': (0, $51b25b42ecc1a0c7$export$eb839c9fd3d638b9)('previousPageLabel')
    }, getPTOptions('prevPageButton'));
    var element = /*#__PURE__*/ $acw62.createElement("button", prevPageButtonProps, prevPageLinkIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
    if (props.template) {
        var defaultOptions = {
            onClick: props.onClick,
            className: className,
            iconClassName: iconClassName,
            disabled: props.disabled,
            element: element,
            props: props
        };
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.template, defaultOptions);
    }
    return element;
});
$6cec6232b30d1913$var$PrevPageLink.displayName = 'PrevPageLink';
var $6cec6232b30d1913$var$RowsPerPageDropdown = /*#__PURE__*/ $acw62.memo(function(inProps) {
    (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $6cec6232b30d1913$var$RowsPerPageDropdownBase.getProps(inProps, context);
    var hasOptions = props.options && props.options.length > 0;
    var options = hasOptions ? props.options.map(function(opt) {
        return {
            label: String(opt),
            value: opt
        };
    }) : [];
    var placeholderValue = (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('choose');
    var ariaLabelValue = $6cec6232b30d1913$var$ariaLabel('jumpToPageDropdownLabel');
    var element = hasOptions ? /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $ad3650ac53d907a7$export$931cbfb6bfb85fc), {
        value: props.value,
        options: options,
        onChange: props.onChange,
        appendTo: props.appendTo,
        disabled: props.disabled,
        placeholder: placeholderValue,
        "aria-label": ariaLabelValue,
        pt: props.ptm('RPPDropdown'),
        unstyled: props.unstyled,
        __parentMetadata: {
            parent: props.metaData
        }
    })) : null;
    if (props.template) {
        var defaultOptions = {
            value: props.value,
            options: options,
            onChange: props.onChange,
            appendTo: props.appendTo,
            currentPage: props.page,
            totalPages: props.pageCount,
            totalRecords: props.totalRecords,
            disabled: props.disabled,
            ariaLabel: ariaLabelValue,
            element: element,
            props: props
        };
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.template, defaultOptions);
    }
    return element;
});
$6cec6232b30d1913$var$RowsPerPageDropdown.displayName = 'RowsPerPageDropdown';
function $6cec6232b30d1913$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6cec6232b30d1913$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6cec6232b30d1913$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6cec6232b30d1913$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6cec6232b30d1913$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6cec6232b30d1913$export$98986e0ddad1af5a = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $6cec6232b30d1913$var$PaginatorBase.getProps(inProps, context);
    var metaData = $6cec6232b30d1913$var$_objectSpread({
        props: props
    }, props.__parentMetadata);
    var _PaginatorBase$setMet = $6cec6232b30d1913$var$PaginatorBase.setMetaData(metaData), ptm = _PaginatorBase$setMet.ptm, cx = _PaginatorBase$setMet.cx, isUnstyled = _PaginatorBase$setMet.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($6cec6232b30d1913$var$PaginatorBase.css.styles, isUnstyled, {
        name: 'paginator'
    });
    var elementRef = $acw62.useRef(null);
    var page = Math.floor(props.first / props.rows);
    var totalPages = Math.ceil(props.totalRecords / props.rows);
    var isFirstPage = page === 0;
    var isLastPage = page === totalPages - 1;
    var isEmpty = totalPages === 0;
    var calculatePageLinkBoundaries = function calculatePageLinkBoundaries() {
        var numberOfPages = totalPages;
        var visiblePages = Math.min(props.pageLinkSize, numberOfPages);
        //calculate range, keep current in middle if necessary
        var start = Math.max(0, Math.ceil(page - visiblePages / 2));
        var end = Math.min(numberOfPages - 1, start + visiblePages - 1);
        //check when approaching to last page
        var delta = props.pageLinkSize - (end - start + 1);
        start = Math.max(0, start - delta);
        return [
            start,
            end
        ];
    };
    var updatePageLinks = function updatePageLinks() {
        var pageLinks = [];
        var boundaries = calculatePageLinkBoundaries();
        var start = boundaries[0];
        var end = boundaries[1];
        for(var i = start; i <= end; i++)pageLinks.push(i + 1);
        return pageLinks;
    };
    var changePage = function changePage(first, rows) {
        var pc = totalPages;
        var p = Math.floor(first / rows);
        if (p >= 0 && p < pc) {
            var newPageState = {
                first: first,
                rows: rows,
                page: p,
                totalPages: pc
            };
            if (props.onPageChange) props.onPageChange(newPageState);
        }
    };
    var changePageToFirst = function changePageToFirst(event) {
        changePage(0, props.rows);
        event.preventDefault();
    };
    var changePageToPrev = function changePageToPrev(event) {
        changePage(props.first - props.rows, props.rows);
        event.preventDefault();
    };
    var onPageLinkClick = function onPageLinkClick(event) {
        changePage((event.value - 1) * props.rows, props.rows);
    };
    var changePageToNext = function changePageToNext(event) {
        changePage(props.first + props.rows, props.rows);
        event.preventDefault();
    };
    var changePageToLast = function changePageToLast(event) {
        changePage((totalPages - 1) * props.rows, props.rows);
        event.preventDefault();
    };
    var onRowsChange = function onRowsChange(event) {
        var rows = event.value;
        changePage(0, rows);
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (page > 0 && props.first >= props.totalRecords) changePage((totalPages - 1) * props.rows, props.rows);
    }, [
        props.totalRecords
    ]);
    var createElement = function createElement(key, template) {
        var element;
        switch(key){
            case 'FirstPageLink':
                element = /*#__PURE__*/ $acw62.createElement($6cec6232b30d1913$var$FirstPageLink, {
                    hostName: "Paginator",
                    key: key,
                    page: page,
                    totalPages: totalPages,
                    totalRecords: props.totalRecords,
                    rows: props.rows,
                    onClick: changePageToFirst,
                    disabled: isFirstPage || isEmpty,
                    template: template,
                    firstPageLinkIcon: props.firstPageLinkIcon,
                    ptm: ptm,
                    cx: cx
                });
                break;
            case 'PrevPageLink':
                element = /*#__PURE__*/ $acw62.createElement($6cec6232b30d1913$var$PrevPageLink, {
                    hostName: "Paginator",
                    key: key,
                    page: page,
                    totalPages: totalPages,
                    totalRecords: props.totalRecords,
                    rows: props.rows,
                    onClick: changePageToPrev,
                    disabled: isFirstPage || isEmpty,
                    template: template,
                    prevPageLinkIcon: props.prevPageLinkIcon,
                    ptm: ptm,
                    cx: cx
                });
                break;
            case 'NextPageLink':
                element = /*#__PURE__*/ $acw62.createElement($6cec6232b30d1913$var$NextPageLink, {
                    hostName: "Paginator",
                    key: key,
                    page: page,
                    totalPages: totalPages,
                    totalRecords: props.totalRecords,
                    rows: props.rows,
                    onClick: changePageToNext,
                    disabled: isLastPage || isEmpty,
                    template: template,
                    nextPageLinkIcon: props.nextPageLinkIcon,
                    ptm: ptm,
                    cx: cx
                });
                break;
            case 'LastPageLink':
                element = /*#__PURE__*/ $acw62.createElement($6cec6232b30d1913$var$LastPageLink, {
                    hostName: "Paginator",
                    key: key,
                    page: page,
                    totalPages: totalPages,
                    totalRecords: props.totalRecords,
                    rows: props.rows,
                    onClick: changePageToLast,
                    disabled: isLastPage || isEmpty,
                    template: template,
                    lastPageLinkIcon: props.lastPageLinkIcon,
                    ptm: ptm,
                    cx: cx
                });
                break;
            case 'PageLinks':
                element = /*#__PURE__*/ $acw62.createElement($6cec6232b30d1913$var$PageLinks, {
                    hostName: "Paginator",
                    key: key,
                    page: page,
                    totalPages: totalPages,
                    totalRecords: props.totalRecords,
                    rows: props.rows,
                    value: updatePageLinks(),
                    onClick: onPageLinkClick,
                    template: template,
                    ptm: ptm,
                    cx: cx
                });
                break;
            case 'RowsPerPageDropdown':
                element = /*#__PURE__*/ $acw62.createElement($6cec6232b30d1913$var$RowsPerPageDropdown, {
                    hostName: "Paginator",
                    key: key,
                    value: props.rows,
                    page: page,
                    totalPages: totalPages,
                    totalRecords: props.totalRecords,
                    options: props.rowsPerPageOptions,
                    onChange: onRowsChange,
                    appendTo: props.dropdownAppendTo,
                    template: template,
                    disabled: isEmpty,
                    unstyled: props.unstyled,
                    ptm: ptm,
                    cx: cx,
                    metaData: metaData
                });
                break;
            case 'CurrentPageReport':
                element = /*#__PURE__*/ $acw62.createElement($6cec6232b30d1913$var$CurrentPageReport, {
                    hostName: "Paginator",
                    reportTemplate: props.currentPageReportTemplate,
                    key: key,
                    page: page,
                    totalPages: totalPages,
                    totalRecords: props.totalRecords,
                    rows: props.rows,
                    first: props.first,
                    template: template,
                    ptm: ptm
                });
                break;
            case 'JumpToPageInput':
                element = /*#__PURE__*/ $acw62.createElement($6cec6232b30d1913$var$JumpToPageInput, {
                    hostName: "Paginator",
                    key: key,
                    rows: props.rows,
                    page: page,
                    totalPages: totalPages,
                    onChange: changePage,
                    disabled: isEmpty,
                    template: template,
                    ptm: ptm,
                    unstyled: props.unstyled,
                    metaData: metaData
                });
                break;
            default:
                element = null;
                break;
        }
        return element;
    };
    var createElements = function createElements() {
        var template = props.template;
        if (template) {
            if ($6cec6232b30d1913$var$_typeof(template) === 'object') return template.layout ? template.layout.split(' ').map(function(value) {
                var key = value.trim();
                return createElement(key, template[key]);
            }) : Object.entries(template).map(function(_ref) {
                var _ref2 = $6cec6232b30d1913$var$_slicedToArray(_ref, 2), key = _ref2[0], _template = _ref2[1];
                return createElement(key, _template);
            });
            return template.split(' ').map(function(value) {
                return createElement(value.trim());
            });
        }
        return null;
    };
    if (!props.alwaysShow && totalPages <= 1) return null;
    var leftContent = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.leftContent, props);
    var rightContent = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.rightContent, props);
    var elements = createElements();
    var leftProps = mergeProps({
        className: cx('left')
    }, ptm('left'));
    var leftElement = leftContent && /*#__PURE__*/ $acw62.createElement("div", leftProps, leftContent);
    var endProps = mergeProps({
        className: cx('end')
    }, ptm('end'));
    var rightElement = rightContent && /*#__PURE__*/ $acw62.createElement("div", endProps, rightContent);
    var rootProps = mergeProps({
        ref: elementRef,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root')),
        style: props.style
    }, $6cec6232b30d1913$var$PaginatorBase.getOtherProps(props), ptm('root'));
    return /*#__PURE__*/ $acw62.createElement("div", rootProps, leftElement, elements, rightElement);
}));
$6cec6232b30d1913$export$98986e0ddad1af5a.displayName = 'Paginator';




var $acw62 = parcelRequire("acw62");

'use client';
function $d0fda18a33495251$var$_extends() {
    return $d0fda18a33495251$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d0fda18a33495251$var$_extends.apply(null, arguments);
}
var $d0fda18a33495251$export$5e8ad5a7e6c181f = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $d0fda18a33495251$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.3226 3.6129H0.677419C0.497757 3.6129 0.325452 3.54152 0.198411 3.41448C0.0713707 3.28744 0 3.11514 0 2.93548C0 2.75581 0.0713707 2.58351 0.198411 2.45647C0.325452 2.32943 0.497757 2.25806 0.677419 2.25806H13.3226C13.5022 2.25806 13.6745 2.32943 13.8016 2.45647C13.9286 2.58351 14 2.75581 14 2.93548C14 3.11514 13.9286 3.28744 13.8016 3.41448C13.6745 3.54152 13.5022 3.6129 13.3226 3.6129ZM13.3226 7.67741H0.677419C0.497757 7.67741 0.325452 7.60604 0.198411 7.479C0.0713707 7.35196 0 7.17965 0 6.99999C0 6.82033 0.0713707 6.64802 0.198411 6.52098C0.325452 6.39394 0.497757 6.32257 0.677419 6.32257H13.3226C13.5022 6.32257 13.6745 6.39394 13.8016 6.52098C13.9286 6.64802 14 6.82033 14 6.99999C14 7.17965 13.9286 7.35196 13.8016 7.479C13.6745 7.60604 13.5022 7.67741 13.3226 7.67741ZM0.677419 11.7419H13.3226C13.5022 11.7419 13.6745 11.6706 13.8016 11.5435C13.9286 11.4165 14 11.2442 14 11.0645C14 10.8848 13.9286 10.7125 13.8016 10.5855C13.6745 10.4585 13.5022 10.3871 13.3226 10.3871H0.677419C0.497757 10.3871 0.325452 10.4585 0.198411 10.5855C0.0713707 10.7125 0 10.8848 0 11.0645C0 11.2442 0.0713707 11.4165 0.198411 11.5435C0.325452 11.6706 0.497757 11.7419 0.677419 11.7419Z",
        fill: "currentColor"
    }));
}));
$d0fda18a33495251$export$5e8ad5a7e6c181f.displayName = 'BarsIcon';





var $acw62 = parcelRequire("acw62");

'use client';
function $17ca5e057f7346f4$var$_extends() {
    return $17ca5e057f7346f4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $17ca5e057f7346f4$var$_extends.apply(null, arguments);
}
var $17ca5e057f7346f4$export$b837bd7eac09a33e = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $17ca5e057f7346f4$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M4.38708 13C4.28408 13.0005 4.18203 12.9804 4.08691 12.9409C3.99178 12.9014 3.9055 12.8433 3.83313 12.7701C3.68634 12.6231 3.60388 12.4238 3.60388 12.2161C3.60388 12.0084 3.68634 11.8091 3.83313 11.6622L8.50507 6.99022L3.83313 2.31827C3.69467 2.16968 3.61928 1.97313 3.62287 1.77005C3.62645 1.56698 3.70872 1.37322 3.85234 1.22959C3.99596 1.08597 4.18972 1.00371 4.3928 1.00012C4.59588 0.996539 4.79242 1.07192 4.94102 1.21039L10.1669 6.43628C10.3137 6.58325 10.3962 6.78249 10.3962 6.99022C10.3962 7.19795 10.3137 7.39718 10.1669 7.54416L4.94102 12.7701C4.86865 12.8433 4.78237 12.9014 4.68724 12.9409C4.59212 12.9804 4.49007 13.0005 4.38708 13Z",
        fill: "currentColor"
    }));
}));
$17ca5e057f7346f4$export$b837bd7eac09a33e.displayName = 'ChevronRightIcon';



var $acw62 = parcelRequire("acw62");

'use client';
function $811be042db154f01$var$_extends() {
    return $811be042db154f01$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $811be042db154f01$var$_extends.apply(null, arguments);
}
var $811be042db154f01$export$d2c72b688139a728 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $811be042db154f01$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0.609628 13.959C0.530658 13.9599 0.452305 13.9451 0.379077 13.9156C0.305849 13.8861 0.239191 13.8424 0.18294 13.787C0.118447 13.7234 0.0688234 13.6464 0.0376166 13.5614C0.00640987 13.4765 -0.00560954 13.3857 0.00241768 13.2956L0.25679 10.1501C0.267698 10.0041 0.331934 9.86709 0.437312 9.76516L9.51265 0.705715C10.0183 0.233014 10.6911 -0.0203041 11.3835 0.00127367C12.0714 0.00660201 12.7315 0.27311 13.2298 0.746671C13.7076 1.23651 13.9824 1.88848 13.9992 2.57201C14.0159 3.25554 13.7733 3.92015 13.32 4.4327L4.23648 13.5331C4.13482 13.6342 4.0017 13.6978 3.85903 13.7133L0.667067 14L0.609628 13.959ZM1.43018 10.4696L1.25787 12.714L3.50619 12.5092L12.4502 3.56444C12.6246 3.35841 12.7361 3.10674 12.7714 2.83933C12.8067 2.57193 12.7644 2.30002 12.6495 2.05591C12.5346 1.8118 12.3519 1.60575 12.1231 1.46224C11.8943 1.31873 11.6291 1.2438 11.3589 1.24633C11.1813 1.23508 11.0033 1.25975 10.8355 1.31887C10.6677 1.37798 10.5136 1.47033 10.3824 1.59036L1.43018 10.4696Z",
        fill: "currentColor"
    }));
}));
$811be042db154f01$export$d2c72b688139a728.displayName = 'PencilIcon';










var $acw62 = parcelRequire("acw62");

'use client';
function $dd6dc61de5d4086e$var$_extends() {
    return $dd6dc61de5d4086e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $dd6dc61de5d4086e$var$_extends.apply(null, arguments);
}
var $dd6dc61de5d4086e$export$28f6150e232898de = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $dd6dc61de5d4086e$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8.64708 14H5.35296C5.18981 13.9979 5.03395 13.9321 4.91858 13.8167C4.8032 13.7014 4.73745 13.5455 4.73531 13.3824V7L0.329431 0.98C0.259794 0.889466 0.217389 0.780968 0.20718 0.667208C0.19697 0.553448 0.219379 0.439133 0.271783 0.337647C0.324282 0.236453 0.403423 0.151519 0.500663 0.0920138C0.597903 0.0325088 0.709548 0.000692754 0.823548 0H13.1765C13.2905 0.000692754 13.4021 0.0325088 13.4994 0.0920138C13.5966 0.151519 13.6758 0.236453 13.7283 0.337647C13.7807 0.439133 13.8031 0.553448 13.7929 0.667208C13.7826 0.780968 13.7402 0.889466 13.6706 0.98L9.26472 7V13.3824C9.26259 13.5455 9.19683 13.7014 9.08146 13.8167C8.96609 13.9321 8.81022 13.9979 8.64708 14ZM5.97061 12.7647H8.02943V6.79412C8.02878 6.66289 8.07229 6.53527 8.15296 6.43177L11.9412 1.23529H2.05884L5.86355 6.43177C5.94422 6.53527 5.98773 6.66289 5.98708 6.79412L5.97061 12.7647Z",
        fill: "currentColor"
    }));
}));
$dd6dc61de5d4086e$export$28f6150e232898de.displayName = 'FilterIcon';



var $acw62 = parcelRequire("acw62");

'use client';
function $a8c157e014b5b4d0$var$_extends() {
    return $a8c157e014b5b4d0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a8c157e014b5b4d0$var$_extends.apply(null, arguments);
}
var $a8c157e014b5b4d0$export$8bb975439d7d7e7c = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $a8c157e014b5b4d0$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.4994 0.0920138C13.5967 0.151519 13.6758 0.236453 13.7283 0.337647C13.7807 0.439133 13.8031 0.553448 13.7929 0.667208C13.7827 0.780968 13.7403 0.889466 13.6707 0.98L11.406 4.06823C11.3099 4.19928 11.1656 4.28679 11.005 4.3115C10.8444 4.33621 10.6805 4.2961 10.5495 4.2C10.4184 4.1039 10.3309 3.95967 10.3062 3.79905C10.2815 3.63843 10.3216 3.47458 10.4177 3.34353L11.9412 1.23529H7.41184C7.24803 1.23529 7.09093 1.17022 6.97509 1.05439C6.85926 0.938558 6.79419 0.781457 6.79419 0.617647C6.79419 0.453837 6.85926 0.296736 6.97509 0.180905C7.09093 0.0650733 7.24803 0 7.41184 0H13.1765C13.2905 0.000692754 13.4022 0.0325088 13.4994 0.0920138ZM4.20008 0.181168H4.24126L13.2013 9.03411C13.3169 9.14992 13.3819 9.3069 13.3819 9.47058C13.3819 9.63426 13.3169 9.79124 13.2013 9.90705C13.1445 9.96517 13.0766 10.0112 13.0016 10.0423C12.9266 10.0735 12.846 10.0891 12.7648 10.0882C12.6836 10.0886 12.6032 10.0728 12.5283 10.0417C12.4533 10.0106 12.3853 9.96479 12.3283 9.90705L9.3142 6.92587L9.26479 6.99999V13.3823C9.26265 13.5455 9.19689 13.7014 9.08152 13.8167C8.96615 13.9321 8.81029 13.9979 8.64714 14H5.35302C5.18987 13.9979 5.03401 13.9321 4.91864 13.8167C4.80327 13.7014 4.73751 13.5455 4.73537 13.3823V6.99999L0.329492 1.02117C0.259855 0.930634 0.21745 0.822137 0.207241 0.708376C0.197031 0.594616 0.21944 0.480301 0.271844 0.378815C0.324343 0.277621 0.403484 0.192687 0.500724 0.133182C0.597964 0.073677 0.709609 0.041861 0.823609 0.0411682H3.86243C3.92448 0.0461551 3.9855 0.060022 4.04361 0.0823446C4.10037 0.10735 4.15311 0.140655 4.20008 0.181168ZM8.02949 6.79411C8.02884 6.66289 8.07235 6.53526 8.15302 6.43176L8.42478 6.05293L3.55773 1.23529H2.0589L5.84714 6.43176C5.92781 6.53526 5.97132 6.66289 5.97067 6.79411V12.7647H8.02949V6.79411Z",
        fill: "currentColor"
    }));
}));
$a8c157e014b5b4d0$export$8bb975439d7d7e7c.displayName = 'FilterSlashIcon';



var $acw62 = parcelRequire("acw62");

'use client';
function $4e8ee92851268d00$var$_extends() {
    return $4e8ee92851268d00$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4e8ee92851268d00$var$_extends.apply(null, arguments);
}
var $4e8ee92851268d00$export$f21ab0717a89c77f = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $4e8ee92851268d00$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M7.67742 6.32258V0.677419C7.67742 0.497757 7.60605 0.325452 7.47901 0.198411C7.35197 0.0713707 7.17966 0 7 0C6.82034 0 6.64803 0.0713707 6.52099 0.198411C6.39395 0.325452 6.32258 0.497757 6.32258 0.677419V6.32258H0.677419C0.497757 6.32258 0.325452 6.39395 0.198411 6.52099C0.0713707 6.64803 0 6.82034 0 7C0 7.17966 0.0713707 7.35197 0.198411 7.47901C0.325452 7.60605 0.497757 7.67742 0.677419 7.67742H6.32258V13.3226C6.32492 13.5015 6.39704 13.6725 6.52358 13.799C6.65012 13.9255 6.82106 13.9977 7 14C7.17966 14 7.35197 13.9286 7.47901 13.8016C7.60605 13.6745 7.67742 13.5022 7.67742 13.3226V7.67742H13.3226C13.5022 7.67742 13.6745 7.60605 13.8016 7.47901C13.9286 7.35197 14 7.17966 14 7C13.9977 6.82106 13.9255 6.65012 13.799 6.52358C13.6725 6.39704 13.5015 6.32492 13.3226 6.32258H7.67742Z",
        fill: "currentColor"
    }));
}));
$4e8ee92851268d00$export$f21ab0717a89c77f.displayName = 'PlusIcon';



var $acw62 = parcelRequire("acw62");

'use client';
function $9e4e4fe49a7215c8$var$_extends() {
    return $9e4e4fe49a7215c8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9e4e4fe49a7215c8$var$_extends.apply(null, arguments);
}
var $9e4e4fe49a7215c8$export$d23329de703dffc4 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $9e4e4fe49a7215c8$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.44802 13.9955H10.552C10.8056 14.0129 11.06 13.9797 11.3006 13.898C11.5412 13.8163 11.7632 13.6877 11.9537 13.5196C12.1442 13.3515 12.2995 13.1473 12.4104 12.9188C12.5213 12.6903 12.5858 12.442 12.6 12.1884V4.36041H13.4C13.5591 4.36041 13.7117 4.29722 13.8243 4.18476C13.9368 4.07229 14 3.91976 14 3.76071C14 3.60166 13.9368 3.44912 13.8243 3.33666C13.7117 3.22419 13.5591 3.16101 13.4 3.16101H12.0537C12.0203 3.1557 11.9863 3.15299 11.952 3.15299C11.9178 3.15299 11.8838 3.1557 11.8503 3.16101H11.2285C11.2421 3.10893 11.2487 3.05513 11.248 3.00106V1.80966C11.2171 1.30262 10.9871 0.828306 10.608 0.48989C10.229 0.151475 9.73159 -0.0236625 9.22402 0.00257442H4.77602C4.27251 -0.0171866 3.78126 0.160868 3.40746 0.498617C3.03365 0.836366 2.807 1.30697 2.77602 1.80966V3.00106C2.77602 3.0556 2.78346 3.10936 2.79776 3.16101H0.6C0.521207 3.16101 0.443185 3.17652 0.37039 3.20666C0.297595 3.2368 0.231451 3.28097 0.175736 3.33666C0.120021 3.39235 0.0758251 3.45846 0.0456722 3.53121C0.0155194 3.60397 0 3.68196 0 3.76071C0 3.83946 0.0155194 3.91744 0.0456722 3.9902C0.0758251 4.06296 0.120021 4.12907 0.175736 4.18476C0.231451 4.24045 0.297595 4.28462 0.37039 4.31476C0.443185 4.3449 0.521207 4.36041 0.6 4.36041H1.40002V12.1884C1.41426 12.442 1.47871 12.6903 1.58965 12.9188C1.7006 13.1473 1.85582 13.3515 2.04633 13.5196C2.23683 13.6877 2.45882 13.8163 2.69944 13.898C2.94005 13.9797 3.1945 14.0129 3.44802 13.9955ZM2.60002 4.36041H11.304V12.1884C11.304 12.5163 10.952 12.7961 10.504 12.7961H3.40002C2.97602 12.7961 2.60002 12.5163 2.60002 12.1884V4.36041ZM3.95429 3.16101C3.96859 3.10936 3.97602 3.0556 3.97602 3.00106V1.80966C3.97602 1.48183 4.33602 1.20197 4.77602 1.20197H9.24802C9.66403 1.20197 10.048 1.48183 10.048 1.80966V3.00106C10.0473 3.05515 10.054 3.10896 10.0678 3.16101H3.95429ZM5.57571 10.997C5.41731 10.995 5.26597 10.9311 5.15395 10.8191C5.04193 10.7071 4.97808 10.5558 4.97601 10.3973V6.77517C4.97601 6.61612 5.0392 6.46359 5.15166 6.35112C5.26413 6.23866 5.41666 6.17548 5.57571 6.17548C5.73476 6.17548 5.8873 6.23866 5.99976 6.35112C6.11223 6.46359 6.17541 6.61612 6.17541 6.77517V10.3894C6.17647 10.4688 6.16174 10.5476 6.13208 10.6213C6.10241 10.695 6.05841 10.762 6.00261 10.8186C5.94682 10.8751 5.88035 10.92 5.80707 10.9506C5.73378 10.9813 5.65514 10.9971 5.57571 10.997ZM7.99968 10.8214C8.11215 10.9339 8.26468 10.997 8.42373 10.997C8.58351 10.9949 8.73604 10.93 8.84828 10.8163C8.96052 10.7025 9.02345 10.5491 9.02343 10.3894V6.77517C9.02343 6.61612 8.96025 6.46359 8.84778 6.35112C8.73532 6.23866 8.58278 6.17548 8.42373 6.17548C8.26468 6.17548 8.11215 6.23866 7.99968 6.35112C7.88722 6.46359 7.82404 6.61612 7.82404 6.77517V10.3973C7.82404 10.5564 7.88722 10.7089 7.99968 10.8214Z",
        fill: "currentColor"
    }));
}));
$9e4e4fe49a7215c8$export$d23329de703dffc4.displayName = 'TrashIcon';





var $acw62 = parcelRequire("acw62");

'use client';
function $e1453b839132f2f7$var$_extends() {
    return $e1453b839132f2f7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e1453b839132f2f7$var$_extends.apply(null, arguments);
}
var $e1453b839132f2f7$export$d79696f0483bfbd9 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $e1453b839132f2f7$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5.64515 3.61291C5.47353 3.61291 5.30192 3.54968 5.16644 3.4142L3.38708 1.63484L1.60773 3.4142C1.34579 3.67613 0.912244 3.67613 0.650309 3.4142C0.388374 3.15226 0.388374 2.71871 0.650309 2.45678L2.90837 0.198712C3.17031 -0.0632236 3.60386 -0.0632236 3.86579 0.198712L6.12386 2.45678C6.38579 2.71871 6.38579 3.15226 6.12386 3.4142C5.98837 3.54968 5.81676 3.61291 5.64515 3.61291Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M3.38714 14C3.01681 14 2.70972 13.6929 2.70972 13.3226V0.677419C2.70972 0.307097 3.01681 0 3.38714 0C3.75746 0 4.06456 0.307097 4.06456 0.677419V13.3226C4.06456 13.6929 3.75746 14 3.38714 14Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M10.6129 14C10.4413 14 10.2697 13.9368 10.1342 13.8013L7.87611 11.5432C7.61418 11.2813 7.61418 10.8477 7.87611 10.5858C8.13805 10.3239 8.5716 10.3239 8.83353 10.5858L10.6129 12.3652L12.3922 10.5858C12.6542 10.3239 13.0877 10.3239 13.3497 10.5858C13.6116 10.8477 13.6116 11.2813 13.3497 11.5432L11.0916 13.8013C10.9561 13.9368 10.7845 14 10.6129 14Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M10.6129 14C10.2426 14 9.93552 13.6929 9.93552 13.3226V0.677419C9.93552 0.307097 10.2426 0 10.6129 0C10.9833 0 11.2904 0.307097 11.2904 0.677419V13.3226C11.2904 13.6929 10.9832 14 10.6129 14Z",
        fill: "currentColor"
    }));
}));
$e1453b839132f2f7$export$d79696f0483bfbd9.displayName = 'SortAltIcon';



var $acw62 = parcelRequire("acw62");

'use client';
function $9ca6dde71eace8f8$var$_extends() {
    return $9ca6dde71eace8f8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9ca6dde71eace8f8$var$_extends.apply(null, arguments);
}
var $9ca6dde71eace8f8$export$81e628514f0bafd8 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $9ca6dde71eace8f8$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M4.93953 10.5858L3.83759 11.6877V0.677419C3.83759 0.307097 3.53049 0 3.16017 0C2.78985 0 2.48275 0.307097 2.48275 0.677419V11.6877L1.38082 10.5858C1.11888 10.3239 0.685331 10.3239 0.423396 10.5858C0.16146 10.8477 0.16146 11.2813 0.423396 11.5432L2.68146 13.8013C2.74469 13.8645 2.81694 13.9097 2.89823 13.9458C2.97952 13.9819 3.06985 14 3.16017 14C3.25049 14 3.33178 13.9819 3.42211 13.9458C3.5034 13.9097 3.57565 13.8645 3.63888 13.8013L5.89694 11.5432C6.15888 11.2813 6.15888 10.8477 5.89694 10.5858C5.63501 10.3239 5.20146 10.3239 4.93953 10.5858ZM13.0957 0H7.22468C6.85436 0 6.54726 0.307097 6.54726 0.677419C6.54726 1.04774 6.85436 1.35484 7.22468 1.35484H13.0957C13.466 1.35484 13.7731 1.04774 13.7731 0.677419C13.7731 0.307097 13.466 0 13.0957 0ZM7.22468 5.41935H9.48275C9.85307 5.41935 10.1602 5.72645 10.1602 6.09677C10.1602 6.4671 9.85307 6.77419 9.48275 6.77419H7.22468C6.85436 6.77419 6.54726 6.4671 6.54726 6.09677C6.54726 5.72645 6.85436 5.41935 7.22468 5.41935ZM7.6763 8.12903H7.22468C6.85436 8.12903 6.54726 8.43613 6.54726 8.80645C6.54726 9.17677 6.85436 9.48387 7.22468 9.48387H7.6763C8.04662 9.48387 8.35372 9.17677 8.35372 8.80645C8.35372 8.43613 8.04662 8.12903 7.6763 8.12903ZM7.22468 2.70968H11.2892C11.6595 2.70968 11.9666 3.01677 11.9666 3.3871C11.9666 3.75742 11.6595 4.06452 11.2892 4.06452H7.22468C6.85436 4.06452 6.54726 3.75742 6.54726 3.3871C6.54726 3.01677 6.85436 2.70968 7.22468 2.70968Z",
        fill: "currentColor"
    }));
}));
$9ca6dde71eace8f8$export$81e628514f0bafd8.displayName = 'SortAmountDownIcon';



var $acw62 = parcelRequire("acw62");

'use client';
function $0893b5fb3a615728$var$_extends() {
    return $0893b5fb3a615728$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0893b5fb3a615728$var$_extends.apply(null, arguments);
}
var $0893b5fb3a615728$export$7a06440e4457d3e9 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $0893b5fb3a615728$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M3.63435 0.19871C3.57113 0.135484 3.49887 0.0903226 3.41758 0.0541935C3.255 -0.0180645 3.06532 -0.0180645 2.90274 0.0541935C2.82145 0.0903226 2.74919 0.135484 2.68597 0.19871L0.427901 2.45677C0.165965 2.71871 0.165965 3.15226 0.427901 3.41419C0.689836 3.67613 1.12338 3.67613 1.38532 3.41419L2.48726 2.31226V13.3226C2.48726 13.6929 2.79435 14 3.16467 14C3.535 14 3.84209 13.6929 3.84209 13.3226V2.31226L4.94403 3.41419C5.07951 3.54968 5.25113 3.6129 5.42274 3.6129C5.59435 3.6129 5.76597 3.54968 5.90145 3.41419C6.16338 3.15226 6.16338 2.71871 5.90145 2.45677L3.64338 0.19871H3.63435ZM13.7685 13.3226C13.7685 12.9523 13.4615 12.6452 13.0911 12.6452H7.22016C6.84984 12.6452 6.54274 12.9523 6.54274 13.3226C6.54274 13.6929 6.84984 14 7.22016 14H13.0911C13.4615 14 13.7685 13.6929 13.7685 13.3226ZM7.22016 8.58064C6.84984 8.58064 6.54274 8.27355 6.54274 7.90323C6.54274 7.5329 6.84984 7.22581 7.22016 7.22581H9.47823C9.84855 7.22581 10.1556 7.5329 10.1556 7.90323C10.1556 8.27355 9.84855 8.58064 9.47823 8.58064H7.22016ZM7.22016 5.87097H7.67177C8.0421 5.87097 8.34919 5.56387 8.34919 5.19355C8.34919 4.82323 8.0421 4.51613 7.67177 4.51613H7.22016C6.84984 4.51613 6.54274 4.82323 6.54274 5.19355C6.54274 5.56387 6.84984 5.87097 7.22016 5.87097ZM11.2847 11.2903H7.22016C6.84984 11.2903 6.54274 10.9832 6.54274 10.6129C6.54274 10.2426 6.84984 9.93548 7.22016 9.93548H11.2847C11.655 9.93548 11.9621 10.2426 11.9621 10.6129C11.9621 10.9832 11.655 11.2903 11.2847 11.2903Z",
        fill: "currentColor"
    }));
}));
$0893b5fb3a615728$export$7a06440e4457d3e9.displayName = 'SortAmountUpAltIcon';


'use client';
function $68eba9483912474c$var$_extends() {
    return $68eba9483912474c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $68eba9483912474c$var$_extends.apply(null, arguments);
}
function $68eba9483912474c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $68eba9483912474c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $68eba9483912474c$var$_typeof(o);
}
function $68eba9483912474c$var$toPrimitive(t, r) {
    if ("object" != $68eba9483912474c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $68eba9483912474c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $68eba9483912474c$var$toPropertyKey(t) {
    var i = $68eba9483912474c$var$toPrimitive(t, "string");
    return "symbol" == $68eba9483912474c$var$_typeof(i) ? i : i + "";
}
function $68eba9483912474c$var$_defineProperty(e, r, t) {
    return (r = $68eba9483912474c$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $68eba9483912474c$var$_arrayLikeToArray$1(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $68eba9483912474c$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $68eba9483912474c$var$_arrayLikeToArray$1(r);
}
function $68eba9483912474c$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $68eba9483912474c$var$_unsupportedIterableToArray$1(r, a) {
    if (r) {
        if ("string" == typeof r) return $68eba9483912474c$var$_arrayLikeToArray$1(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $68eba9483912474c$var$_arrayLikeToArray$1(r, a) : void 0;
    }
}
function $68eba9483912474c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $68eba9483912474c$var$_toConsumableArray(r) {
    return $68eba9483912474c$var$_arrayWithoutHoles(r) || $68eba9483912474c$var$_iterableToArray(r) || $68eba9483912474c$var$_unsupportedIterableToArray$1(r) || $68eba9483912474c$var$_nonIterableSpread();
}
function $68eba9483912474c$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $68eba9483912474c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $68eba9483912474c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $68eba9483912474c$var$_slicedToArray(r, e) {
    return $68eba9483912474c$var$_arrayWithHoles(r) || $68eba9483912474c$var$_iterableToArrayLimit(r, e) || $68eba9483912474c$var$_unsupportedIterableToArray$1(r, e) || $68eba9483912474c$var$_nonIterableRest();
}
var $68eba9483912474c$var$getStorage = function getStorage(stateStorageProp) {
    switch(stateStorageProp){
        case 'local':
            return window.localStorage;
        case 'session':
            return window.sessionStorage;
        case 'custom':
            return null;
        default:
            throw new Error(stateStorageProp + ' is not a valid value for the state storage, supported values are "local", "session" and "custom".');
    }
};
var $68eba9483912474c$var$ColumnBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'Column',
        align: null,
        alignFrozen: 'left',
        alignHeader: null,
        body: null,
        bodyClassName: null,
        bodyStyle: null,
        cellEditValidateOnClose: false,
        cellEditValidator: null,
        cellEditValidatorEvent: 'click',
        className: null,
        colSpan: null,
        columnKey: null,
        dataType: 'text',
        editor: null,
        excludeGlobalFilter: false,
        expander: false,
        exportField: null,
        exportable: true,
        field: null,
        filter: false,
        filterApply: null,
        filterClear: null,
        filterElement: null,
        filterField: null,
        filterFooter: null,
        filterFunction: null,
        filterHeader: null,
        filterHeaderClassName: null,
        filterHeaderStyle: null,
        filterMatchMode: null,
        filterMatchModeOptions: null,
        filterMaxLength: null,
        filterMenuClassName: null,
        filterMenuStyle: null,
        filterPlaceholder: null,
        filterType: 'text',
        footer: null,
        footerClassName: null,
        footerStyle: null,
        frozen: false,
        header: null,
        headerClassName: null,
        headerStyle: null,
        headerTooltip: null,
        headerTooltipOptions: null,
        hidden: false,
        maxConstraints: 2,
        onBeforeCellEditHide: null,
        onBeforeCellEditShow: null,
        onCellEditCancel: null,
        onCellEditComplete: null,
        onCellEditInit: null,
        onFilterApplyClick: null,
        onFilterClear: null,
        onFilterConstraintAdd: null,
        onFilterConstraintRemove: null,
        onFilterMatchModeChange: null,
        onFilterOperatorChange: null,
        reorderable: true,
        resizeable: true,
        rowEditor: false,
        rowReorder: false,
        rowReorderIcon: null,
        rowSpan: null,
        selectionMode: null,
        showAddButton: true,
        showApplyButton: true,
        showClearButton: true,
        showFilterMatchModes: true,
        showFilterMenu: true,
        showFilterMenuOptions: true,
        showFilterOperator: true,
        sortField: null,
        sortFunction: null,
        sortable: false,
        sortableDisabled: false,
        style: null,
        children: undefined
    },
    getCProp: function getCProp(column, name) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getComponentProp(column, name, $68eba9483912474c$var$ColumnBase.defaultProps);
    },
    getCProps: function getCProps(column) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getComponentProps(column, $68eba9483912474c$var$ColumnBase.defaultProps);
    },
    getCOtherProps: function getCOtherProps(column) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getComponentDiffProps(column, $68eba9483912474c$var$ColumnBase.defaultProps);
    }
});
function $68eba9483912474c$var$ownKeys$e(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68eba9483912474c$var$_objectSpread$e(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68eba9483912474c$var$ownKeys$e(Object(t), !0).forEach(function(r) {
            $68eba9483912474c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68eba9483912474c$var$ownKeys$e(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $68eba9483912474c$var$styles$1 = "\n@layer primereact {\n    .p-datatable {\n        position: relative;\n    }\n\n    .p-datatable > .p-datatable-wrapper {\n        overflow: auto;\n    }\n\n    .p-datatable-table {\n        border-spacing: 0px;\n        width: 100%;\n    }\n\n    .p-datatable .p-sortable-disabled {\n        cursor: auto;\n    }\n\n    .p-datatable .p-sortable-column {\n        cursor: pointer;\n        user-select: none;\n    }\n\n    .p-datatable .p-sortable-column .p-column-title,\n    .p-datatable .p-sortable-column .p-sortable-column-icon,\n    .p-datatable .p-sortable-column .p-sortable-column-badge {\n        vertical-align: middle;\n    }\n\n    .p-datatable .p-sortable-column .p-sortable-column-badge {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .p-datatable-selectable .p-selectable-row,\n    .p-datatable-selectable-cell .p-selectable-cell {\n        cursor: pointer;\n    }\n\n    .p-datatable-drag-selection-helper {\n        position: absolute;\n        z-index: 99999999;\n    }\n\n    /* Scrollable */\n    .p-datatable-scrollable > .p-datatable-wrapper {\n        position: relative;\n    }\n\n    .p-datatable-scrollable-table > .p-datatable-thead {\n        position: sticky;\n        top: 0;\n        z-index: 2;\n    }\n\n    .p-datatable.p-datatable-gridlines .p-datatable-scrollable-table > .p-datatable-thead {\n        top: -1px;\n    }\n\n    .p-datatable-scrollable-table > .p-datatable-frozen-tbody {\n        position: sticky;\n        z-index: 1;\n    }\n\n    .p-datatable-scrollable-table > .p-datatable-tfoot {\n        position: sticky;\n        bottom: 0;\n        z-index: 1;\n    }\n\n    .p-datatable-scrollable .p-frozen-column {\n        position: sticky;\n        background: inherit;\n    }\n\n    .p-datatable-scrollable th.p-frozen-column {\n        z-index: 1;\n    }\n\n    .p-datatable-flex-scrollable {\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n    }\n\n    .p-datatable-flex-scrollable > .p-datatable-wrapper {\n        display: flex;\n        flex-direction: column;\n        flex: 1;\n        height: 100%;\n    }\n\n    .p-datatable-scrollable-table > .p-datatable-tbody > .p-rowgroup-header {\n        position: sticky;\n        z-index: 1;\n    }\n\n    /* Resizable */\n    .p-datatable-resizable-table > .p-datatable-thead > tr > th,\n    .p-datatable-resizable-table > .p-datatable-tfoot > tr > td,\n    .p-datatable-resizable-table > .p-datatable-tbody > tr > td {\n        overflow: hidden;\n        white-space: nowrap;\n    }\n\n    .p-datatable-resizable-table > .p-datatable-thead > tr > th.p-resizable-column:not(.p-frozen-column) {\n        background-clip: padding-box;\n        position: relative;\n    }\n\n    .p-datatable-resizable-table-fit > .p-datatable-thead > tr > th.p-resizable-column:last-child .p-column-resizer {\n        display: none;\n    }\n\n    .p-datatable .p-column-resizer {\n        display: block;\n        position: absolute;\n        top: 0;\n        right: 0;\n        margin: 0;\n        width: 0.5rem;\n        height: 100%;\n        padding: 0px;\n        cursor: col-resize;\n        border: 1px solid transparent;\n    }\n\n    .p-datatable .p-column-header-content {\n        display: flex;\n        align-items: center;\n    }\n\n    .p-datatable .p-column-resizer-helper {\n        width: 1px;\n        position: absolute;\n        z-index: 10;\n        display: none;\n    }\n\n    .p-datatable .p-row-editor-init,\n    .p-datatable .p-row-editor-save,\n    .p-datatable .p-row-editor-cancel {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        overflow: hidden;\n        position: relative;\n    }\n\n    /* Expand */\n    .p-datatable .p-row-toggler {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        overflow: hidden;\n        position: relative;\n    }\n\n    /* Reorder */\n    .p-datatable-reorder-indicator-up,\n    .p-datatable-reorder-indicator-down {\n        position: absolute;\n        display: none;\n    }\n\n    .p-reorderable-column,\n    .p-datatable-reorderablerow-handle {\n        cursor: move;\n    }\n\n    /* Loader */\n    .p-datatable .p-datatable-loading-overlay {\n        position: absolute;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        z-index: 2;\n    }\n\n    /* Filter */\n    .p-column-filter-row {\n        display: flex;\n        align-items: center;\n        width: 100%;\n    }\n\n    .p-column-filter-menu {\n        display: inline-flex;\n        margin-left: auto;\n    }\n\n    .p-column-filter-row .p-column-filter-element {\n        flex: 1 1 auto;\n        width: 1%;\n    }\n\n    .p-column-filter-menu-button,\n    .p-column-filter-clear-button {\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n        text-decoration: none;\n        overflow: hidden;\n        position: relative;\n    }\n\n    .p-column-filter-overlay {\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n\n    .p-column-filter-row-items {\n        margin: 0;\n        padding: 0;\n        list-style: none;\n    }\n\n    .p-column-filter-row-item {\n        cursor: pointer;\n    }\n\n    .p-column-filter-add-button,\n    .p-column-filter-remove-button {\n        justify-content: center;\n    }\n\n    .p-column-filter-add-button .p-button-label,\n    .p-column-filter-remove-button .p-button-label {\n        flex-grow: 0;\n    }\n\n    .p-column-filter-buttonbar {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .p-column-filter-buttonbar .p-button:not(.p-button-icon-only) {\n        width: auto;\n    }\n\n    /* Responsive */\n    .p-datatable .p-datatable-tbody > tr > td > .p-column-title {\n        display: none;\n    }\n\n    /* VirtualScroller */\n    .p-datatable-virtualscroller-spacer {\n        display: flex;\n    }\n\n    .p-datatable .p-virtualscroller .p-virtualscroller-loading {\n        transform: none;\n        min-height: 0;\n        position: sticky;\n        top: 0;\n        left: 0;\n    }\n\n    /* Alignment */\n    .p-datatable .p-datatable-thead > tr > th.p-align-left > .p-column-header-content,\n    .p-datatable .p-datatable-tbody > tr > td.p-align-left,\n    .p-datatable .p-datatable-tfoot > tr > td.p-align-left {\n        text-align: left;\n        justify-content: flex-start;\n    }\n\n    .p-datatable .p-datatable-thead > tr > th.p-align-right > .p-column-header-content,\n    .p-datatable .p-datatable-tbody > tr > td.p-align-right,\n    .p-datatable .p-datatable-tfoot > tr > td.p-align-right {\n        text-align: right;\n        justify-content: flex-end;\n    }\n\n    .p-datatable .p-datatable-thead > tr > th.p-align-center > .p-column-header-content,\n    .p-datatable .p-datatable-tbody > tr > td.p-align-center,\n    .p-datatable .p-datatable-tfoot > tr > td.p-align-center {\n        text-align: center;\n        justify-content: center;\n    }\n}\n";
var $68eba9483912474c$var$classes$2 = {
    root: function root(_ref) {
        var props = _ref.props, selectable = _ref.selectable;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-datatable p-component', {
            'p-datatable-hoverable-rows': props.rowHover,
            'p-datatable-selectable': selectable && !props.cellSelection,
            'p-datatable-selectable-cell': selectable && props.cellSelection,
            'p-datatable-resizable': props.resizableColumns,
            'p-datatable-resizable-fit': props.resizableColumns && props.columnResizeMode === 'fit',
            'p-datatable-scrollable': props.scrollable,
            'p-datatable-flex-scrollable': props.scrollable && props.scrollHeight === 'flex',
            'p-datatable-responsive-stack': props.responsiveLayout === 'stack',
            'p-datatable-responsive-scroll': props.responsiveLayout === 'scroll',
            'p-datatable-striped': props.stripedRows,
            'p-datatable-gridlines': props.showGridlines,
            'p-datatable-grouped-header': props.headerColumnGroup != null,
            'p-datatable-grouped-footer': props.footerColumnGroup != null,
            'p-datatable-sm': props.size === 'small',
            'p-datatable-lg': props.size === 'large'
        });
    },
    loadingIcon: 'p-datatable-loading-icon',
    loadingOverlay: 'p-datatable-loading-overlay p-component-overlay',
    header: 'p-datatable-header',
    wrapper: 'p-datatable-wrapper',
    table: function table(_ref2) {
        var props = _ref2.props;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-datatable-table', {
            'p-datatable-scrollable-table': props.scrollable,
            'p-datatable-resizable-table': props.resizableColumns,
            'p-datatable-resizable-table-fit': props.resizableColumns && props.columnResizeMode === 'fit'
        });
    },
    thead: 'p-datatable-thead',
    tfoot: 'p-datatable-tfoot',
    footer: 'p-datatable-footer',
    checkIcon: 'p-checkbox-icon',
    resizeHelper: 'p-column-resizer-helper',
    reorderIndicatorUp: 'p-datatable-reorder-indicator-up',
    reorderIndicatorDown: 'p-datatable-reorder-indicator-down',
    paginator: function paginator(_ref3) {
        var position = _ref3.position;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-paginator-' + position);
    },
    bodyCell: function bodyCell(_ref4) {
        var selectionMode = _ref4.selectionMode, editor = _ref4.editor, editingState = _ref4.editingState, frozen = _ref4.frozen, cellSelected = _ref4.cellSelected, align = _ref4.align, props = _ref4.bodyProps, getCellParams = _ref4.getCellParams;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)($68eba9483912474c$var$_defineProperty({
            'p-selection-column': selectionMode !== null,
            'p-editable-column': editor,
            'p-cell-editing': editor && editingState,
            'p-frozen-column': frozen,
            'p-selectable-cell': props.allowCellSelection && props.isSelectable({
                data: getCellParams(),
                index: props.rowIndex
            }),
            'p-highlight': cellSelected
        }, "p-align-".concat(align), !!align));
    },
    columnTitle: 'p-column-title',
    bodyRow: function bodyRow(_ref5) {
        var props = _ref5.rowProps;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)({
            'p-highlight': !props.allowCellSelection && props.selected || props.contextMenuSelected,
            'p-highlight-contextmenu': props.contextMenuSelected,
            'p-selectable-row': props.allowRowSelection && props.isSelectable({
                data: props.rowData,
                index: props.rowIndex
            }),
            'p-row-odd': props.rowIndex % 2 !== 0
        });
    },
    rowGroupTogglerIcon: 'p-row-toggler-icon',
    rowGroupToggler: 'p-row-toggler p-link',
    rowGroupHeader: 'p-rowgroup-header',
    rowGroupHeaderName: 'p-rowgroup-header-name',
    rowGroupFooter: 'p-rowgroup-footer',
    rowReorderIcon: 'p-datatable-reorderablerow-handle',
    rowTogglerIcon: 'p-row-toggler-icon',
    rowToggler: 'p-row-toggler p-link',
    rowEditorSaveIcon: 'p-row-editor-save-icon',
    rowEditorSaveButton: 'p-row-editor-save p-link',
    rowEditorCancelIcon: 'p-row-editor-cancel-icon',
    rowEditorCancelButton: 'p-row-editor-cancel p-link',
    rowEditorInitIcon: 'p-row-editor-init-icon',
    rowEditorInitButton: 'p-row-editor-init p-link',
    rowExpansion: 'p-datatable-row-expansion',
    virtualScrollerSpacer: function virtualScrollerSpacer(_ref6) {
        var className = _ref6.className;
        return className;
    },
    tbody: function tbody(_ref7) {
        var className = _ref7.className;
        return className;
    },
    filterInput: 'p-fluid p-column-filter-element',
    filterMenuButton: function filterMenuButton(_ref8) {
        var overlayVisibleState = _ref8.overlayVisibleState, hasFilter = _ref8.hasFilter;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-column-filter-menu-button p-link', {
            'p-column-filter-menu-button-open': overlayVisibleState,
            'p-column-filter-menu-button-active': hasFilter()
        });
    },
    headerFilterClearButton: function headerFilterClearButton(_ref9) {
        var hasRowFilter = _ref9.hasRowFilter;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-column-filter-clear-button p-link', {
            'p-hidden-space': !hasRowFilter()
        });
    },
    filterSeparator: 'p-column-filter-separator',
    filterRowItem: function filterRowItem(_ref10) {
        var isRowMatchModeSelected = _ref10.isRowMatchModeSelected, isShowMatchModes = _ref10.isShowMatchModes, value = _ref10.value;
        return isShowMatchModes() ? (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-column-filter-row-item', {
            'p-highlight': value && isRowMatchModeSelected(value)
        }) : undefined;
    },
    filterRowItems: 'p-column-filter-row-items',
    filterOperator: 'p-column-filter-operator',
    filterConstraints: 'p-column-filter-constraints',
    filterConstraint: 'p-column-filter-constraint',
    filterAddRule: 'p-column-filter-add-rule',
    filterButtonBar: 'p-column-filter-buttonbar',
    filterOverlay: function filterOverlay(_ref11) {
        var props = _ref11.columnFilterProps, context = _ref11.context, getColumnProp = _ref11.getColumnProp;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-column-filter-overlay p-component p-fluid', getColumnProp('filterMenuClassName'), {
            'p-column-filter-overlay-menu': props.display === 'menu',
            'p-input-filled': context && context.inputStyle === 'filled' || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).inputStyle === 'filled',
            'p-ripple-disabled': context && context.ripple === false || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).ripple === false
        });
    },
    columnFilter: function columnFilter(_ref12) {
        var props = _ref12.columnFilterProps;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-column-filter p-fluid', {
            'p-column-filter-row': props.display === 'row',
            'p-column-filter-menu': props.display === 'menu'
        });
    },
    columnResizer: 'p-column-resizer',
    emptyMessage: 'p-datatable-emptymessage',
    sortBadge: 'p-sortable-column-badge',
    sortIcon: 'p-sortable-column-icon',
    headerTitle: 'p-column-title',
    headerContent: 'p-column-header-content',
    headerCell: function headerCell(_ref13) {
        var props = _ref13.headerProps, frozen = _ref13.frozen, sortMeta = _ref13.sortMeta, align = _ref13.align, _isSortableDisabled = _ref13._isSortableDisabled, getColumnProp = _ref13.getColumnProp;
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).isEmpty(props) ? (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-filter-column', {
            'p-frozen-column': frozen
        }) : (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)($68eba9483912474c$var$_defineProperty({
            'p-filter-column': !props.headerColumnGroup && props.filterDisplay === 'row',
            'p-sortable-column': getColumnProp('sortable'),
            'p-resizable-column': props.resizableColumns && getColumnProp('resizeable'),
            'p-highlight': sortMeta.sorted,
            'p-frozen-column': frozen,
            'p-selection-column': getColumnProp('selectionMode'),
            'p-sortable-disabled': getColumnProp('sortable') && _isSortableDisabled,
            'p-reorderable-column': props.reorderableColumns && getColumnProp('reorderable') && !frozen
        }, "p-align-".concat(align), !!align));
    },
    footerCell: function footerCell(_ref14) {
        var getColumnProp = _ref14.getColumnProp, align = _ref14.align;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)($68eba9483912474c$var$_defineProperty({
            'p-frozen-column': getColumnProp('frozen')
        }, "p-align-".concat(align), !!align));
    },
    transition: 'p-connected-overlay'
};
var $68eba9483912474c$var$inlineStyles = {
    wrapper: {
        overflow: 'auto'
    },
    resizeHelper: {
        display: 'none'
    },
    reorderIndicatorUp: function reorderIndicatorUp(_ref15) {
        var style = _ref15.style;
        return $68eba9483912474c$var$_objectSpread$e({}, style);
    },
    reorderIndicatorDown: function reorderIndicatorDown(_ref16) {
        var style = _ref16.style;
        return $68eba9483912474c$var$_objectSpread$e({}, style);
    }
};
var $68eba9483912474c$var$DataTableBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'DataTable',
        alwaysShowPaginator: true,
        breakpoint: '960px',
        cellClassName: null,
        cellSelection: false,
        checkIcon: null,
        className: null,
        collapsedRowIcon: null,
        columnResizeMode: 'fit',
        compareSelectionBy: 'deepEquals',
        contextMenuSelection: null,
        csvSeparator: ',',
        currentPageReportTemplate: '({currentPage} of {totalPages})',
        customRestoreState: null,
        customSaveState: null,
        dataKey: null,
        defaultSortOrder: 1,
        dragSelection: false,
        editMode: null,
        editingRows: null,
        emptyMessage: null,
        expandableRowGroups: false,
        expandedRowIcon: null,
        expandedRows: null,
        exportFilename: 'download',
        exportFunction: null,
        filterClearIcon: null,
        filterDelay: 300,
        filterDisplay: 'menu',
        filterIcon: null,
        filterLocale: undefined,
        filters: null,
        first: 0,
        footer: null,
        footerColumnGroup: null,
        frozenRow: false,
        frozenValue: null,
        frozenWidth: null,
        globalFilter: null,
        globalFilterFields: null,
        globalFilterMatchMode: (0, $51b25b42ecc1a0c7$export$b9fbdf9129f67822).CONTAINS,
        groupRowsBy: null,
        header: null,
        headerColumnGroup: null,
        id: null,
        isDataSelectable: null,
        lazy: false,
        loading: false,
        loadingIcon: null,
        metaKeySelection: false,
        multiSortMeta: null,
        onAllRowsSelect: null,
        onAllRowsUnselect: null,
        onCellClick: null,
        onCellSelect: null,
        onCellUnselect: null,
        onColReorder: null,
        onColumnResizeEnd: null,
        onColumnResizerClick: null,
        onColumnResizerDoubleClick: null,
        onContextMenu: null,
        onContextMenuSelectionChange: null,
        onFilter: null,
        onPage: null,
        onRowClick: null,
        onRowCollapse: null,
        onRowDoubleClick: null,
        onRowEditCancel: null,
        onRowEditChange: null,
        onRowEditComplete: null,
        onRowEditInit: null,
        onRowEditSave: null,
        onRowExpand: null,
        onRowMouseEnter: null,
        onRowMouseLeave: null,
        onRowPointerDown: null,
        onRowPointerUp: null,
        onRowReorder: null,
        onRowSelect: null,
        onRowToggle: null,
        onRowUnselect: null,
        onSelectAllChange: null,
        onSelectionChange: null,
        onSort: null,
        onStateRestore: null,
        onStateSave: null,
        onValueChange: null,
        pageLinkSize: 5,
        paginator: false,
        paginatorClassName: null,
        paginatorDropdownAppendTo: null,
        paginatorLeft: null,
        paginatorPosition: 'bottom',
        paginatorRight: null,
        paginatorTemplate: 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown',
        removableSort: false,
        reorderIndicatorDownIcon: null,
        reorderIndicatorUpIcon: null,
        reorderableColumns: false,
        reorderableRows: false,
        resizableColumns: false,
        responsiveLayout: 'scroll',
        rowClassName: null,
        rowEditValidator: null,
        rowEditorCancelIcon: null,
        rowEditorInitIcon: null,
        rowEditorSaveIcon: null,
        rowExpansionTemplate: null,
        rowGroupFooterTemplate: null,
        rowGroupHeaderTemplate: null,
        rowGroupMode: null,
        rowHover: false,
        rows: null,
        rowsPerPageOptions: null,
        scrollHeight: null,
        scrollable: false,
        selectAll: false,
        selectOnEdit: true,
        selection: null,
        selectionAriaLabel: null,
        selectionAutoFocus: true,
        selectionMode: null,
        selectionPageOnly: false,
        showGridlines: false,
        showHeaders: true,
        showRowReorderElement: null,
        showSelectAll: true,
        showSelectionElement: null,
        size: 'normal',
        sortField: null,
        sortIcon: null,
        sortMode: 'single',
        sortOrder: null,
        stateKey: null,
        stateStorage: 'session',
        stripedRows: false,
        style: null,
        tabIndex: 0,
        tableClassName: null,
        tableStyle: null,
        totalRecords: null,
        value: null,
        virtualScrollerOptions: null,
        children: undefined
    },
    css: {
        styles: $68eba9483912474c$var$styles$1,
        classes: $68eba9483912474c$var$classes$2,
        inlineStyles: $68eba9483912474c$var$inlineStyles
    }
});
function $68eba9483912474c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $68eba9483912474c$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $68eba9483912474c$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
var $68eba9483912474c$var$classes$1 = {
    box: 'p-checkbox-box',
    input: 'p-checkbox-input',
    icon: 'p-checkbox-icon',
    root: function root(_ref) {
        var props = _ref.props, checked = _ref.checked, context = _ref.context;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-checkbox p-component', {
            'p-highlight': checked,
            'p-disabled': props.disabled,
            'p-invalid': props.invalid,
            'p-variant-filled': props.variant ? props.variant === 'filled' : context && context.inputStyle === 'filled'
        });
    }
};
var $68eba9483912474c$var$CheckboxBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'Checkbox',
        autoFocus: false,
        checked: false,
        className: null,
        disabled: false,
        falseValue: false,
        icon: null,
        id: null,
        inputId: null,
        inputRef: null,
        invalid: false,
        variant: null,
        name: null,
        onChange: null,
        onContextMenu: null,
        onMouseDown: null,
        readOnly: false,
        required: false,
        style: null,
        tabIndex: null,
        tooltip: null,
        tooltipOptions: null,
        trueValue: true,
        value: null,
        children: undefined
    },
    css: {
        classes: $68eba9483912474c$var$classes$1
    }
});
function $68eba9483912474c$var$ownKeys$d(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68eba9483912474c$var$_objectSpread$d(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68eba9483912474c$var$ownKeys$d(Object(t), !0).forEach(function(r) {
            $68eba9483912474c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68eba9483912474c$var$ownKeys$d(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $68eba9483912474c$var$Checkbox = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $68eba9483912474c$var$CheckboxBase.getProps(inProps, context);
    var _React$useState = $acw62.useState(false), _React$useState2 = $68eba9483912474c$var$_slicedToArray(_React$useState, 2), focusedState = _React$useState2[0], setFocusedState = _React$useState2[1];
    var _CheckboxBase$setMeta = $68eba9483912474c$var$CheckboxBase.setMetaData({
        props: props,
        state: {
            focused: focusedState
        },
        context: {
            checked: props.checked === props.trueValue,
            disabled: props.disabled
        }
    }), ptm = _CheckboxBase$setMeta.ptm, cx = _CheckboxBase$setMeta.cx, isUnstyled = _CheckboxBase$setMeta.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($68eba9483912474c$var$CheckboxBase.css.styles, isUnstyled, {
        name: 'checkbox'
    });
    var elementRef = $acw62.useRef(null);
    var inputRef = $acw62.useRef(props.inputRef);
    var isChecked = function isChecked() {
        return props.checked === props.trueValue;
    };
    var _onChange = function onChange(event) {
        if (props.disabled || props.readonly) return;
        if (props.onChange) {
            var _props$onChange;
            var _checked = isChecked();
            var value = _checked ? props.falseValue : props.trueValue;
            var eventData = {
                originalEvent: event,
                value: props.value,
                checked: value,
                stopPropagation: function stopPropagation() {
                    event === null || event === void 0 || event.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event === null || event === void 0 || event.preventDefault();
                },
                target: {
                    type: 'checkbox',
                    name: props.name,
                    id: props.id,
                    value: props.value,
                    checked: value
                }
            };
            props === null || props === void 0 || (_props$onChange = props.onChange) === null || _props$onChange === void 0 || _props$onChange.call(props, eventData);
            // do not continue if the user defined click wants to prevent
            if (event.defaultPrevented) return;
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current);
        }
    };
    var _onFocus = function onFocus() {
        var _props$onFocus;
        setFocusedState(true);
        props === null || props === void 0 || (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props);
    };
    var _onBlur = function onBlur() {
        var _props$onBlur;
        setFocusedState(false);
        props === null || props === void 0 || (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 || _props$onBlur.call(props);
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            focus: function focus() {
                return (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            }
        };
    });
    $acw62.useEffect(function() {
        (0, $a73ce425265b079e$export$4855211e6b8ad895).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        inputRef.current.checked = isChecked();
    }, [
        props.checked,
        props.trueValue
    ]);
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        if (props.autoFocus) (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current, props.autoFocus);
    });
    var checked = isChecked();
    var hasTooltip = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.tooltip);
    var otherProps = $68eba9483912474c$var$CheckboxBase.getOtherProps(props);
    var rootProps = mergeProps({
        id: props.id,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root', {
            checked: checked,
            context: context
        })),
        style: props.style,
        'data-p-highlight': checked,
        'data-p-disabled': props.disabled,
        onContextMenu: props.onContextMenu,
        onMouseDown: props.onMouseDown
    }, otherProps, ptm('root'));
    var createInputElement = function createInputElement() {
        var ariaProps = (0, $a73ce425265b079e$export$4855211e6b8ad895).reduceKeys(otherProps, (0, $a73ce425265b079e$export$ff8ccbac9225de62).ARIA_PROPS);
        var inputProps = mergeProps($68eba9483912474c$var$_objectSpread$d({
            id: props.inputId,
            type: 'checkbox',
            className: cx('input'),
            name: props.name,
            tabIndex: props.tabIndex,
            onFocus: function onFocus(e) {
                return _onFocus();
            },
            onBlur: function onBlur(e) {
                return _onBlur();
            },
            onChange: function onChange(e) {
                return _onChange(e);
            },
            disabled: props.disabled,
            readOnly: props.readOnly,
            required: props.required,
            'aria-invalid': props.invalid,
            checked: checked
        }, ariaProps), ptm('input'));
        return /*#__PURE__*/ $acw62.createElement("input", $68eba9483912474c$var$_extends({
            ref: inputRef
        }, inputProps));
    };
    var createBoxElement = function createBoxElement() {
        var iconProps = mergeProps({
            className: cx('icon')
        }, ptm('icon'));
        var boxProps = mergeProps({
            className: cx('box', {
                checked: checked
            }),
            'data-p-highlight': checked,
            'data-p-disabled': props.disabled
        }, ptm('box'));
        var icon = checked ? props.icon || /*#__PURE__*/ $acw62.createElement((0, $ed79679a1c3e60de$export$7dd004358974b05d), iconProps) : null;
        var checkboxIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $68eba9483912474c$var$_objectSpread$d({}, iconProps), {
            props: props,
            checked: checked
        });
        return /*#__PURE__*/ $acw62.createElement("div", boxProps, checkboxIcon);
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", $68eba9483912474c$var$_extends({
        ref: elementRef
    }, rootProps), createInputElement(), createBoxElement()), hasTooltip && /*#__PURE__*/ $acw62.createElement((0, $b74dfa9f7ee9d9bc$export$28c660c63b792dea), $68eba9483912474c$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm('tooltip')
    }, props.tooltipOptions)));
}));
$68eba9483912474c$var$Checkbox.displayName = 'Checkbox';
function $68eba9483912474c$var$ownKeys$c(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68eba9483912474c$var$_objectSpread$c(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68eba9483912474c$var$ownKeys$c(Object(t), !0).forEach(function(r) {
            $68eba9483912474c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68eba9483912474c$var$ownKeys$c(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $68eba9483912474c$var$RowCheckbox = /*#__PURE__*/ $acw62.memo(function(props) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var getColumnProps = function getColumnProps() {
        return $68eba9483912474c$var$ColumnBase.getCProps(props.column);
    };
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx;
    var getColumnPTOptions = function getColumnPTOptions(key) {
        var columnMetaData = {
            props: getColumnProps(),
            parent: props.metaData,
            hostName: props.hostName,
            state: {},
            context: {
                index: props.tabIndex,
                checked: props.checked,
                disabled: props.disabled
            }
        };
        return mergeProps(ptm("column.".concat(key), {
            column: columnMetaData
        }), ptm("column.".concat(key), columnMetaData), ptmo(getColumnProps(), key, columnMetaData));
    };
    var onChange = function onChange(event) {
        if (!props.disabled) props.onChange(event);
    };
    var checkboxIconProps = mergeProps({
        className: cx('checkIcon')
    }, getColumnPTOptions('rowCheckbox.icon'));
    var icon = props.checked ? props.checkIcon || /*#__PURE__*/ $acw62.createElement((0, $ed79679a1c3e60de$export$7dd004358974b05d), checkboxIconProps) : null;
    var checkIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $68eba9483912474c$var$_objectSpread$c({}, checkboxIconProps), {
        props: props
    });
    var tabIndex = props.disabled ? null : '0';
    var checkboxProps = {
        role: 'checkbox',
        'aria-checked': props.checked,
        tabIndex: tabIndex,
        onChange: onChange,
        'aria-label': props.ariaLabel,
        checked: props.checked,
        icon: checkIcon,
        disabled: props.disabled,
        unstyled: props.unstyled,
        pt: getColumnPTOptions('rowCheckbox')
    };
    return /*#__PURE__*/ $acw62.createElement($68eba9483912474c$var$Checkbox, checkboxProps);
});
$68eba9483912474c$var$RowCheckbox.displayName = 'RowCheckbox';
var $68eba9483912474c$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, context = _ref.context;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-radiobutton p-component', {
            'p-highlight': props.checked,
            'p-disabled': props.disabled,
            'p-invalid': props.invalid,
            'p-variant-filled': props.variant ? props.variant === 'filled' : context && context.inputStyle === 'filled'
        });
    },
    box: 'p-radiobutton-box',
    input: 'p-radiobutton-input',
    icon: 'p-radiobutton-icon'
};
var $68eba9483912474c$var$RadioButtonBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'RadioButton',
        autoFocus: false,
        checked: false,
        className: null,
        disabled: false,
        id: null,
        inputId: null,
        inputRef: null,
        invalid: false,
        variant: null,
        name: null,
        onChange: null,
        onClick: null,
        required: false,
        style: null,
        tabIndex: null,
        tooltip: null,
        tooltipOptions: null,
        value: null,
        children: undefined
    },
    css: {
        classes: $68eba9483912474c$var$classes
    }
});
function $68eba9483912474c$var$ownKeys$b(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68eba9483912474c$var$_objectSpread$b(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68eba9483912474c$var$ownKeys$b(Object(t), !0).forEach(function(r) {
            $68eba9483912474c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68eba9483912474c$var$ownKeys$b(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $68eba9483912474c$var$RadioButton = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $68eba9483912474c$var$RadioButtonBase.getProps(inProps, context);
    var elementRef = $acw62.useRef(null);
    var inputRef = $acw62.useRef(props.inputRef);
    var _RadioButtonBase$setM = $68eba9483912474c$var$RadioButtonBase.setMetaData({
        props: props
    }), ptm = _RadioButtonBase$setM.ptm, cx = _RadioButtonBase$setM.cx, isUnstyled = _RadioButtonBase$setM.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($68eba9483912474c$var$RadioButtonBase.css.styles, isUnstyled, {
        name: 'radiobutton'
    });
    var select = function select(event) {
        onChange(event);
    };
    var onChange = function onChange(event) {
        if (props.disabled || props.readonly) return;
        if (props.onChange) {
            var checked = props.checked;
            var radioClicked = event.target instanceof HTMLDivElement;
            var inputClicked = event.target === inputRef.current;
            var isInputToggled = inputClicked && event.target.checked !== checked;
            var isRadioToggled = radioClicked && ((0, $a73ce425265b079e$export$ff8ccbac9225de62).hasClass(elementRef.current, 'p-radiobutton-checked') === checked ? !checked : false);
            var value = !checked;
            var eventData = {
                originalEvent: event,
                value: props.value,
                checked: value,
                stopPropagation: function stopPropagation() {
                    event === null || event === void 0 || event.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event === null || event === void 0 || event.preventDefault();
                },
                target: {
                    type: 'radio',
                    name: props.name,
                    id: props.id,
                    value: props.value,
                    checked: value
                }
            };
            if (isInputToggled || isRadioToggled) {
                var _props$onChange;
                props === null || props === void 0 || (_props$onChange = props.onChange) === null || _props$onChange === void 0 || _props$onChange.call(props, eventData);
                // do not continue if the user defined click wants to prevent
                if (event.defaultPrevented) return;
                if (isRadioToggled) inputRef.current.checked = value;
            }
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current);
        }
    };
    var onFocus = function onFocus(event) {
        var _props$onFocus;
        props === null || props === void 0 || (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props, event);
    };
    var onBlur = function onBlur(event) {
        var _props$onBlur;
        props === null || props === void 0 || (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 || _props$onBlur.call(props, event);
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            select: select,
            focus: function focus() {
                return (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            }
        };
    });
    $acw62.useEffect(function() {
        if (inputRef.current) inputRef.current.checked = props.checked;
    }, [
        props.checked
    ]);
    $acw62.useEffect(function() {
        (0, $a73ce425265b079e$export$4855211e6b8ad895).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        if (props.autoFocus) (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current, props.autoFocus);
    });
    var hasTooltip = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.tooltip);
    var otherProps = $68eba9483912474c$var$RadioButtonBase.getOtherProps(props);
    var rootProps = mergeProps({
        id: props.id,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root', {
            context: context
        })),
        style: props.style,
        'data-p-checked': props.checked
    }, otherProps, ptm('root'));
    delete rootProps.input;
    delete rootProps.box;
    delete rootProps.icon;
    var createInputElement = function createInputElement() {
        var ariaProps = (0, $a73ce425265b079e$export$4855211e6b8ad895).reduceKeys(otherProps, (0, $a73ce425265b079e$export$ff8ccbac9225de62).ARIA_PROPS);
        var inputProps = mergeProps($68eba9483912474c$var$_objectSpread$b({
            id: props.inputId,
            type: 'radio',
            name: props.name,
            defaultChecked: props.checked,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            disabled: props.disabled,
            readOnly: props.readonly,
            required: props.required,
            tabIndex: props.tabIndex,
            className: cx('input')
        }, ariaProps), inProps.input, ptm('input'));
        return /*#__PURE__*/ $acw62.createElement("input", $68eba9483912474c$var$_extends({
            ref: inputRef
        }, inputProps));
    };
    var createBoxElement = function createBoxElement() {
        var boxProps = mergeProps({
            className: cx('box')
        }, inProps.box, ptm('box'));
        var iconProps = mergeProps({
            className: cx('icon')
        }, inProps.icon, ptm('icon'));
        return /*#__PURE__*/ $acw62.createElement("div", boxProps, /*#__PURE__*/ $acw62.createElement("div", iconProps));
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", $68eba9483912474c$var$_extends({
        ref: elementRef
    }, rootProps), createInputElement(), createBoxElement()), hasTooltip && /*#__PURE__*/ $acw62.createElement((0, $b74dfa9f7ee9d9bc$export$28c660c63b792dea), $68eba9483912474c$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm('tooltip')
    }, props.tooltipOptions)));
}));
$68eba9483912474c$var$RadioButton.displayName = 'RadioButton';
var $68eba9483912474c$var$RowRadioButton = /*#__PURE__*/ $acw62.memo(function(props) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var getColumnProps = function getColumnProps() {
        return $68eba9483912474c$var$ColumnBase.getCProps(props.column);
    };
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo;
    var getColumnPTOptions = function getColumnPTOptions(key) {
        var columnMetaData = {
            props: getColumnProps(),
            parent: props.metaData,
            hostName: props.hostName,
            state: {},
            context: {
                index: props.tabIndex,
                checked: props.checked,
                disabled: props.disabled
            }
        };
        return mergeProps(ptm("column.".concat(key), {
            column: columnMetaData
        }), ptm("column.".concat(key), columnMetaData), ptmo(getColumnProps(), key, columnMetaData));
    };
    var onChange = function onChange(event) {
        if (!props.disabled) props.onChange(event);
    };
    var radioButtonProps = {
        role: 'radio',
        'aria-checked': props.checked,
        checked: props.checked,
        disabled: props.disabled,
        name: "".concat(props.tableSelector, "_dt_radio"),
        onChange: onChange,
        unstyled: props.unstyled,
        pt: getColumnPTOptions('rowRadioButton')
    };
    return /*#__PURE__*/ $acw62.createElement($68eba9483912474c$var$RadioButton, radioButtonProps);
});
$68eba9483912474c$var$RowRadioButton.displayName = 'RowRadioButton';
function $68eba9483912474c$var$ownKeys$a(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68eba9483912474c$var$_objectSpread$a(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68eba9483912474c$var$ownKeys$a(Object(t), !0).forEach(function(r) {
            $68eba9483912474c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68eba9483912474c$var$ownKeys$a(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $68eba9483912474c$var$BodyCell = /*#__PURE__*/ $acw62.memo(function(props) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var _React$useState = $acw62.useState(props.editing), _React$useState2 = $68eba9483912474c$var$_slicedToArray(_React$useState, 2), editingState = _React$useState2[0], setEditingState = _React$useState2[1];
    var _React$useState3 = $acw62.useState(props.rowData), _React$useState4 = $68eba9483912474c$var$_slicedToArray(_React$useState3, 2), editingRowDataState = _React$useState4[0], setEditingRowDataState = _React$useState4[1];
    var _React$useState5 = $acw62.useState({}), _React$useState6 = $68eba9483912474c$var$_slicedToArray(_React$useState5, 2), styleObjectState = _React$useState6[0], setStyleObjectState = _React$useState6[1];
    var elementRef = $acw62.useRef(null);
    var keyHelperRef = $acw62.useRef(null);
    var overlayEventListener = $acw62.useRef(null);
    var selfClick = $acw62.useRef(false);
    var focusTimeout = $acw62.useRef(null);
    var initFocusTimeout = $acw62.useRef(null);
    var editingRowDataStateRef = $acw62.useRef(null);
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx;
    var getColumnProp = function getColumnProp(name) {
        return $68eba9483912474c$var$ColumnBase.getCProp(props.column, name);
    };
    var getColumnProps = function getColumnProps() {
        return $68eba9483912474c$var$ColumnBase.getCProps(props.column);
    };
    var getColumnPTOptions = function getColumnPTOptions(key) {
        var cProps = getColumnProps();
        var columnMetaData = {
            props: cProps,
            parent: props.metaData,
            hostName: props.hostName,
            state: {
                styleObject: styleObjectState,
                editing: editingState,
                editingRowData: editingRowDataState
            },
            context: {
                index: props.index,
                size: props.metaData.props.size,
                showGridlines: props.metaData.props.showGridlines
            }
        };
        return mergeProps(ptm("column.".concat(key), {
            column: columnMetaData
        }), ptm("column.".concat(key), columnMetaData), ptmo(cProps, key, columnMetaData));
    };
    var field = getColumnProp('field') || "field_".concat(props.index);
    var editingKey = props.dataKey ? props.rowData && props.rowData[props.dataKey] || props.rowIndex : props.rowIndex;
    var isEditable = function isEditable() {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.editMode) && getColumnProp('editor');
    };
    var cellEditValidateOnClose = function cellEditValidateOnClose() {
        return getColumnProp('cellEditValidateOnClose');
    };
    var _useEventListener = (0, $fbdf1e36fa0a01d8$export$7080b3e976bc91ab)({
        type: 'click',
        listener: function listener(e) {
            setTimeout(function() {
                if (!selfClick.current && isOutsideClicked(e.target)) // #2666 for overlay components and outside is clicked
                switchCellToViewMode(e, true);
            }, 0);
            selfClick.current = false;
        },
        options: true,
        when: isEditable()
    }), _useEventListener2 = $68eba9483912474c$var$_slicedToArray(_useEventListener, 2), bindDocumentClickListener = _useEventListener2[0], unbindDocumentClickListener = _useEventListener2[1];
    var isSelected = function isSelected() {
        return props.selection ? props.selection instanceof Array ? findIndex(props.selection) > -1 : equals(props.selection) : false;
    };
    var equalsData = function equalsData(data) {
        return props.compareSelectionBy === 'equals' ? data === props.rowData : (0, $a73ce425265b079e$export$4855211e6b8ad895).equals(data, props.rowData, props.dataKey);
    };
    var equals = function equals(selectedCell) {
        return selectedCell && (selectedCell.rowIndex === props.rowIndex || equalsData(selectedCell.rowData)) && (selectedCell.field === field || selectedCell.cellIndex === props.index);
    };
    var isOutsideClicked = function isOutsideClicked(target) {
        return elementRef.current && !(elementRef.current.isSameNode(target) || elementRef.current.contains(target));
    };
    var getVirtualScrollerOption = function getVirtualScrollerOption(option) {
        return props.virtualScrollerOptions ? props.virtualScrollerOptions[option] : null;
    };
    var getStyle = function getStyle() {
        var bodyStyle = getColumnProp('bodyStyle');
        var columnStyle = getColumnProp('style');
        return getColumnProp('frozen') ? Object.assign({}, columnStyle, bodyStyle, styleObjectState) : Object.assign({}, columnStyle, bodyStyle);
    };
    var getCellParams = function getCellParams() {
        return {
            value: resolveFieldData(),
            field: field,
            rowData: props.rowData,
            rowIndex: props.rowIndex,
            cellIndex: props.index,
            selected: isSelected(),
            column: props.column,
            props: props
        };
    };
    var getCellCallbackParams = function getCellCallbackParams(event) {
        var params = getCellParams();
        return $68eba9483912474c$var$_objectSpread$a({
            originalEvent: event
        }, params);
    };
    var resolveFieldData = function resolveFieldData(data) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(data || props.rowData, field);
    };
    var getEditingRowData = function getEditingRowData() {
        return props.editingMeta && props.editingMeta[editingKey] ? props.editingMeta[editingKey].data : props.rowData;
    };
    var getTabIndex = function getTabIndex(cellSelected) {
        return props.allowCellSelection ? cellSelected ? 0 : props.rowIndex === 0 && props.index === 0 ? props.tabIndex : -1 : null;
    };
    var findIndex = function findIndex(collection) {
        return (collection || []).findIndex(function(data) {
            return equals(data);
        });
    };
    var closeCell = function closeCell(event) {
        var params = getCellCallbackParams(event);
        var onBeforeCellEditHide = getColumnProp('onBeforeCellEditHide');
        if (onBeforeCellEditHide) onBeforeCellEditHide(params);
        /* When using the 'tab' key, the focus event of the next cell is not called in IE. */ setTimeout(function() {
            setEditingState(false);
            unbindDocumentClickListener();
            (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).off('overlay-click', overlayEventListener.current);
            overlayEventListener.current = null;
            editingRowDataStateRef.current = null;
            selfClick.current = false;
        }, 1);
    };
    var switchCellToViewMode = function switchCellToViewMode(event, submit) {
        var callbackParams = getCellCallbackParams(event);
        var newRowData = $68eba9483912474c$var$_objectSpread$a({}, editingRowDataStateRef.current);
        var newValue = resolveFieldData(newRowData);
        var params = $68eba9483912474c$var$_objectSpread$a($68eba9483912474c$var$_objectSpread$a({}, callbackParams), {}, {
            newRowData: newRowData,
            newValue: newValue
        });
        var onCellEditCancel = getColumnProp('onCellEditCancel');
        var cellEditValidator = getColumnProp('cellEditValidator');
        var onCellEditComplete = getColumnProp('onCellEditComplete');
        if (!submit && onCellEditCancel) onCellEditCancel(params);
        var valid = true;
        if ((!submit || cellEditValidateOnClose()) && cellEditValidator) valid = cellEditValidator(params);
        if (valid) {
            if (submit && onCellEditComplete) onCellEditComplete(params);
            closeCell(event);
        } else event.preventDefault();
        setEditingRowDataState(newRowData);
    };
    var _findNextSelectableCell = function findNextSelectableCell(cell) {
        var nextCell = cell.nextElementSibling;
        return nextCell ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(nextCell, 'data-p-selectable-cell') ? nextCell : _findNextSelectableCell(nextCell) : null;
    };
    var _findPrevSelectableCell = function findPrevSelectableCell(cell) {
        var prevCell = cell.previousElementSibling;
        return prevCell ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(prevCell, 'data-p-selectable-cell') ? prevCell : _findPrevSelectableCell(prevCell) : null;
    };
    var _findDownSelectableCell = function findDownSelectableCell(cell) {
        var downRow = cell.parentElement.nextElementSibling;
        var downCell = downRow ? downRow.children[props.index] : null;
        return downRow && downCell ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(downRow, 'data-p-selectable-row') && (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(downCell, 'data-p-selectable-cell') ? downCell : _findDownSelectableCell(downCell) : null;
    };
    var _findUpSelectableCell = function findUpSelectableCell(cell) {
        var upRow = cell.parentElement.previousElementSibling;
        var upCell = upRow ? upRow.children[props.index] : null;
        return upRow && upCell ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(upRow, 'data-p-selectable-row') && (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(upCell, 'data-p-selectable-cell') ? upCell : _findUpSelectableCell(upCell) : null;
    };
    var changeTabIndex = function changeTabIndex(currentCell, nextCell) {
        if (currentCell && nextCell) {
            currentCell.tabIndex = -1;
            nextCell.tabIndex = props.tabIndex;
        }
    };
    var focusOnElement = function focusOnElement() {
        clearTimeout(focusTimeout.current);
        focusTimeout.current = setTimeout(function() {
            if (editingState) {
                var focusableEl = props.editMode === 'cell' ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getFirstFocusableElement(elementRef.current, ':not([data-pc-section="editorkeyhelperlabel"])') : (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(elementRef.current, '[data-p-row-editor-save="true"]');
                focusableEl && focusableEl.focus();
            }
            keyHelperRef.current && (keyHelperRef.current.tabIndex = editingState ? -1 : 0);
        }, 1);
    };
    var focusOnInit = function focusOnInit() {
        clearTimeout(initFocusTimeout.current);
        initFocusTimeout.current = setTimeout(function() {
            var focusableEl = props.editMode === 'row' ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(elementRef.current, '[data-p-row-editor-init="true"]') : null;
            focusableEl && focusableEl.focus();
        }, 1);
    };
    var updateStickyPosition = function updateStickyPosition() {
        if (getColumnProp('frozen')) {
            var styleObject = $68eba9483912474c$var$_objectSpread$a({}, styleObjectState);
            var align = getColumnProp('alignFrozen');
            if (align === 'right') {
                var right = 0;
                var next = elementRef.current && elementRef.current.nextElementSibling;
                if (next && next.classList.contains('p-frozen-column')) right = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(next) + parseFloat(next.style.right || 0);
                styleObject.right = right + 'px';
            } else {
                var left = 0;
                var prev = elementRef.current && elementRef.current.previousElementSibling;
                if (prev && prev.classList.contains('p-frozen-column')) left = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(prev) + parseFloat(prev.style.left || 0);
                styleObject.left = left + 'px';
            }
            var isSameStyle = styleObjectState.left === styleObject.left && styleObjectState.right === styleObject.right;
            !isSameStyle && setStyleObjectState(styleObject);
        }
    };
    var editorCallback = function editorCallback(val) {
        var editingRowData = $68eba9483912474c$var$_objectSpread$a({}, editingRowDataState);
        (0, $a73ce425265b079e$export$4855211e6b8ad895).mutateFieldData(editingRowData, field, val);
        setEditingRowDataState(editingRowData);
        // update editing meta for complete methods on row mode
        var currentData = getEditingRowData();
        if (currentData) (0, $a73ce425265b079e$export$4855211e6b8ad895).mutateFieldData(currentData, field, val);
        editingRowDataStateRef.current = editingRowData;
    };
    var _onClick = function onClick(event) {
        var params = getCellCallbackParams(event);
        if (props.editMode !== 'row' && isEditable() && !editingState && (props.selectOnEdit || !props.selectOnEdit && props.selected)) {
            selfClick.current = true;
            var onBeforeCellEditShow = getColumnProp('onBeforeCellEditShow');
            var onCellEditInit = getColumnProp('onCellEditInit');
            var cellEditValidatorEvent = getColumnProp('cellEditValidatorEvent');
            if (onBeforeCellEditShow) {
                // if user returns false do not show the editor
                if (onBeforeCellEditShow(params) === false) return;
                // if user prevents default stop the editor
                if (event && event.defaultPrevented) return;
            }
            // If the data is sorted using sort icon, it has been added to wait for the sort operation when any cell is wanted to be opened.
            setTimeout(function() {
                setEditingState(true);
                if (onCellEditInit) {
                    if (onCellEditInit(params) === false) return;
                    // if user prevents default stop the editor
                    if (event && event.defaultPrevented) return;
                }
                if (cellEditValidatorEvent === 'click') {
                    bindDocumentClickListener();
                    overlayEventListener.current = function(e) {
                        if (!isOutsideClicked(e.target)) selfClick.current = true;
                    };
                    (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).on('overlay-click', overlayEventListener.current);
                }
            }, 1);
        }
        if (props.allowCellSelection && props.onClick) props.onClick(params);
    };
    var _onMouseDown = function onMouseDown(event) {
        var params = getCellCallbackParams(event);
        props.onMouseDown && props.onMouseDown(params);
    };
    var _onMouseUp = function onMouseUp(event) {
        var params = getCellCallbackParams(event);
        props.onMouseUp && props.onMouseUp(params);
    };
    var _onKeyDown = function onKeyDown(event) {
        if (props.editMode !== 'row') {
            if (event.code === 'Enter' || event.code === 'NumpadEnter' || event.code === 'Tab') switchCellToViewMode(event, true);
            if (event.code === 'Escape') switchCellToViewMode(event, false);
        }
        if (props.allowCellSelection) {
            var target = event.target, cell = event.currentTarget;
            switch(event.code){
                case 'ArrowLeft':
                    var prevCell = _findPrevSelectableCell(cell);
                    if (prevCell) {
                        changeTabIndex(cell, prevCell);
                        prevCell.focus();
                    }
                    event.preventDefault();
                    break;
                case 'ArrowRight':
                    var nextCell = _findNextSelectableCell(cell);
                    if (nextCell) {
                        changeTabIndex(cell, nextCell);
                        nextCell.focus();
                    }
                    event.preventDefault();
                    break;
                case 'ArrowUp':
                    var upCell = _findUpSelectableCell(cell);
                    if (upCell) {
                        changeTabIndex(cell, upCell);
                        upCell.focus();
                    }
                    event.preventDefault();
                    break;
                case 'ArrowDown':
                    var downCell = _findDownSelectableCell(cell);
                    if (downCell) {
                        changeTabIndex(cell, downCell);
                        downCell.focus();
                    }
                    event.preventDefault();
                    break;
                case 'Enter':
                case 'NumpadEnter':
                    if (event.shiftKey || event.ctrlKey) ;
                    else if (!(0, $a73ce425265b079e$export$ff8ccbac9225de62).isClickable(target)) {
                        _onClick(event);
                        event.preventDefault();
                    }
                    break;
                case 'Space':
                    if (!(0, $a73ce425265b079e$export$ff8ccbac9225de62).isClickable(target) && !target.readOnly) {
                        _onClick(event);
                        event.preventDefault();
                    }
                    break;
            }
        }
    };
    var _onBlur = function onBlur(event) {
        selfClick.current = false;
        if (props.editMode !== 'row' && editingState && getColumnProp('cellEditValidatorEvent') === 'blur') switchCellToViewMode(event, true);
    };
    var onEditorFocus = function onEditorFocus(event) {
        _onClick(event);
    };
    var onRadioChange = function onRadioChange(event) {
        props.onRadioChange({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var onCheckboxChange = function onCheckboxChange(event) {
        props.onCheckboxChange({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var onRowToggle = function onRowToggle(event) {
        props.onRowToggle({
            originalEvent: event,
            data: props.rowData
        });
        event.preventDefault();
        event.stopPropagation();
    };
    var onRowEditInit = function onRowEditInit(event) {
        props.onRowEditInit({
            originalEvent: event,
            data: props.rowData,
            newData: getEditingRowData(),
            field: field,
            index: props.rowIndex
        });
    };
    var onRowEditSave = function onRowEditSave(event) {
        props.onRowEditSave({
            originalEvent: event,
            data: props.rowData,
            newData: getEditingRowData(),
            field: field,
            index: props.rowIndex
        });
        focusOnInit();
    };
    var onRowEditCancel = function onRowEditCancel(event) {
        props.onRowEditCancel({
            originalEvent: event,
            data: props.rowData,
            newData: getEditingRowData(),
            field: field,
            index: props.rowIndex
        });
        focusOnInit();
    };
    $acw62.useEffect(function() {
        if (getColumnProp('frozen')) updateStickyPosition();
        if (props.editMode === 'cell' || props.editMode === 'row') focusOnElement();
    }, [
        props.editMode,
        props.editing,
        editingState
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $acw62.useEffect(function() {
        if (props.editMode === 'row' && props.editing !== editingState) setEditingState(props.editing);
    }, [
        props.editMode,
        props.editing,
        editingState
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (props.editMode === 'cell' || props.editMode === 'row') {
            var editingRowData = getEditingRowData();
            setEditingRowDataState(editingRowData);
            editingRowDataStateRef.current = editingRowData;
        }
    }, [
        props.editingMeta
    ]);
    $acw62.useEffect(function() {
        if (props.editMode === 'cell' || props.editMode === 'row') {
            var callbackParams = getCellCallbackParams();
            var params = $68eba9483912474c$var$_objectSpread$a($68eba9483912474c$var$_objectSpread$a({}, callbackParams), {}, {
                editing: editingState,
                editingKey: editingKey
            });
            props.onEditingMetaChange(params);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editingState
    ]);
    (0, $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96)(function() {
        if (overlayEventListener.current) {
            (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).off('overlay-click', overlayEventListener.current);
            overlayEventListener.current = null;
        }
    });
    var createLoading = function createLoading() {
        var options = getVirtualScrollerOption('getLoaderOptions')(props.rowIndex, {
            cellIndex: props.index,
            cellFirst: props.index === 0,
            cellLast: props.index === getVirtualScrollerOption('columns').length - 1,
            cellEven: props.index % 2 === 0,
            cellOdd: props.index % 2 !== 0,
            column: props.column,
            field: field
        });
        var content = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(getVirtualScrollerOption('loadingTemplate'), options);
        var bodyCellProps = mergeProps(getColumnPTOptions('bodyCell'), {
            role: 'cell'
        });
        return /*#__PURE__*/ $acw62.createElement("td", bodyCellProps, content);
    };
    var createElement = function createElement() {
        var content;
        var editorKeyHelper;
        var cellSelected = props.allowCellSelection && isSelected();
        var isRowEditor = props.editMode === 'row';
        var tabIndex = getTabIndex(cellSelected);
        var selectionMode = getColumnProp('selectionMode');
        var rowReorder = getColumnProp('rowReorder');
        var header = getColumnProp('header');
        var body = getColumnProp('body');
        var editor = getColumnProp('editor');
        var frozen = getColumnProp('frozen');
        var align = getColumnProp('align');
        var value = resolveFieldData();
        var columnBodyOptions = {
            column: props.column,
            field: field,
            rowIndex: props.rowIndex,
            frozenRow: props.frozenRow,
            props: props.tableProps
        };
        var rowEditor = (0, $a73ce425265b079e$export$4855211e6b8ad895).getPropValue(getColumnProp('rowEditor'), props.rowData, columnBodyOptions);
        var expander = (0, $a73ce425265b079e$export$4855211e6b8ad895).getPropValue(getColumnProp('expander'), props.rowData, columnBodyOptions);
        var cellClassName = (0, $a73ce425265b079e$export$4855211e6b8ad895).getPropValue(props.cellClassName, value, columnBodyOptions);
        var bodyClassName = (0, $a73ce425265b079e$export$4855211e6b8ad895).getPropValue(getColumnProp('bodyClassName'), props.rowData, columnBodyOptions);
        var style = getStyle();
        var columnTitleProps = mergeProps({
            className: cx('columnTitle')
        }, getColumnPTOptions('columnTitle'));
        var title = props.responsiveLayout === 'stack' && /*#__PURE__*/ $acw62.createElement("span", columnTitleProps, (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(header, {
            props: props.tableProps
        }));
        if (selectionMode) {
            var showSelection = props.showSelectionElement ? props.showSelectionElement(props.rowData, {
                rowIndex: props.rowIndex,
                props: props.tableProps
            }) : true;
            var label;
            if (showSelection) {
                var ariaLabelField = props.selectionAriaLabel || props.tableProps.dataKey;
                var ariaLabelText = (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(props.rowData, ariaLabelField);
                label = "".concat(props.selected ? (0, $51b25b42ecc1a0c7$export$eb839c9fd3d638b9)('unselectRow') : (0, $51b25b42ecc1a0c7$export$eb839c9fd3d638b9)('selectRow'), " ").concat(ariaLabelText);
            }
            content = showSelection && /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, selectionMode === 'single' && /*#__PURE__*/ $acw62.createElement($68eba9483912474c$var$RowRadioButton, {
                hostName: props.hostName,
                column: props.column,
                checked: props.selected,
                disabled: !props.isSelectable({
                    data: props.rowData,
                    index: props.rowIndex
                }),
                onChange: onRadioChange,
                tabIndex: props.tabIndex,
                tableSelector: props.tableSelector,
                ariaLabel: label,
                ptCallbacks: props.ptCallbacks,
                metaData: props.metaData,
                unstyled: props.unstyled
            }), selectionMode === 'multiple' && /*#__PURE__*/ $acw62.createElement($68eba9483912474c$var$RowCheckbox, {
                hostName: props.hostName,
                column: props.column,
                checked: props.selected,
                disabled: !props.isSelectable({
                    data: props.rowData,
                    index: props.rowIndex
                }),
                onChange: onCheckboxChange,
                tabIndex: props.tabIndex,
                ariaLabel: label,
                checkIcon: props.checkIcon,
                ptCallbacks: props.ptCallbacks,
                metaData: props.metaData,
                unstyled: props.unstyled
            }));
        } else if (rowReorder) {
            var showReorder = props.showRowReorderElement ? props.showRowReorderElement(props.rowData, {
                rowIndex: props.rowIndex,
                props: props.tableProps
            }) : true;
            var customIcon = getColumnProp('rowReorderIcon');
            var rowReorderIconProps = mergeProps({
                className: cx('rowReorderIcon')
            }, customIcon ? null : getColumnPTOptions('rowReorderIcon'));
            var rowReorderIcon = customIcon || /*#__PURE__*/ $acw62.createElement((0, $d0fda18a33495251$export$5e8ad5a7e6c181f), rowReorderIconProps);
            content = showReorder ? (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(rowReorderIcon, $68eba9483912474c$var$_objectSpread$a({}, rowReorderIconProps), {
                props: props
            }) : null;
        } else if (expander) {
            var rowTogglerIconProps = mergeProps({
                className: cx('rowTogglerIcon'),
                'aria-hidden': true
            }, getColumnPTOptions('rowTogglerIcon'));
            var icon = props.expanded ? props.expandedRowIcon || /*#__PURE__*/ $acw62.createElement((0, $2539671ba6368b77$export$4857d3f3f5f8319b), rowTogglerIconProps) : props.collapsedRowIcon || /*#__PURE__*/ $acw62.createElement((0, $17ca5e057f7346f4$export$b837bd7eac09a33e), rowTogglerIconProps);
            var togglerIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $68eba9483912474c$var$_objectSpread$a({}, rowTogglerIconProps), {
                props: props
            });
            var ariaControls = "".concat(props.tableSelector, "_content_").concat(props.rowIndex, "_expanded");
            var _ariaLabelField = props.selectionAriaLabel || props.tableProps.dataKey;
            var _ariaLabelText = (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(props.rowData, _ariaLabelField);
            var _label = "".concat(props.expanded ? (0, $51b25b42ecc1a0c7$export$eb839c9fd3d638b9)('collapseLabel') : (0, $51b25b42ecc1a0c7$export$eb839c9fd3d638b9)('expandLabel'), " ").concat(_ariaLabelText);
            var expanderProps = {
                onClick: onRowToggle,
                className: cx('rowToggler')
            };
            var rowTogglerProps = mergeProps($68eba9483912474c$var$_objectSpread$a($68eba9483912474c$var$_objectSpread$a({}, expanderProps), {}, {
                type: 'button',
                'aria-expanded': props.expanded,
                'aria-controls': ariaControls,
                tabIndex: props.tabIndex,
                'aria-label': _label
            }), getColumnPTOptions('rowToggler'));
            content = /*#__PURE__*/ $acw62.createElement("button", rowTogglerProps, togglerIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
            if (body) {
                expanderProps.element = content;
                content = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(body, props.rowData, {
                    column: props.column,
                    field: field,
                    rowIndex: props.rowIndex,
                    frozenRow: props.frozenRow,
                    props: props.tableProps,
                    expander: expanderProps
                });
            }
        } else if (isRowEditor && rowEditor) {
            var rowEditorProps = {};
            var rowEditorSaveIconProps = mergeProps({
                className: cx('rowEditorSaveIcon')
            }, getColumnPTOptions('rowEditorSaveIcon'));
            var rowEditorCancelIconProps = mergeProps({
                className: cx('rowEditorCancelIcon')
            }, getColumnPTOptions('rowEditorCancelIcon'));
            var rowEditorInitIconProps = mergeProps({
                className: cx('rowEditorInitIcon')
            }, getColumnPTOptions('rowEditorInitIcon'));
            var rowEditorSaveIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(props.rowEditorSaveIcon || /*#__PURE__*/ $acw62.createElement((0, $ed79679a1c3e60de$export$7dd004358974b05d), rowEditorSaveIconProps), $68eba9483912474c$var$_objectSpread$a({}, rowEditorSaveIconProps), {
                props: props
            });
            var rowEditorCancelIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(props.rowEditorCancelIcon || /*#__PURE__*/ $acw62.createElement((0, $2a5691e8eb30be5a$export$32edebbf2d9136cc), rowEditorCancelIconProps), $68eba9483912474c$var$_objectSpread$a({}, rowEditorCancelIconProps), {
                props: props
            });
            var rowEditorInitIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(props.rowEditorInitIcon || /*#__PURE__*/ $acw62.createElement((0, $811be042db154f01$export$d2c72b688139a728), rowEditorInitIconProps), $68eba9483912474c$var$_objectSpread$a({}, rowEditorInitIconProps), {
                props: props
            });
            if (editingState) {
                rowEditorProps = {
                    editing: true,
                    onSaveClick: onRowEditSave,
                    saveClassName: cx('rowEditorSaveButton'),
                    onCancelClick: onRowEditCancel,
                    cancelClassName: cx('rowEditorCancelButton')
                };
                var rowEditorSaveButtonProps = mergeProps({
                    type: 'button',
                    name: 'row-save',
                    'aria-label': (0, $51b25b42ecc1a0c7$export$eb839c9fd3d638b9)('saveEdit'),
                    onClick: rowEditorProps.onSaveClick,
                    className: rowEditorProps.saveClassName,
                    tabIndex: props.tabIndex,
                    'data-p-row-editor-save': true
                }, getColumnPTOptions('rowEditorSaveButton'));
                var rowEditorCancelButtonProps = mergeProps({
                    type: 'button',
                    name: 'row-cancel',
                    'aria-label': (0, $51b25b42ecc1a0c7$export$eb839c9fd3d638b9)('cancelEdit'),
                    onClick: rowEditorProps.onCancelClick,
                    className: rowEditorProps.cancelClassName,
                    tabIndex: props.tabIndex
                }, getColumnPTOptions('rowEditorCancelButton'));
                content = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("button", rowEditorSaveButtonProps, rowEditorSaveIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null)), /*#__PURE__*/ $acw62.createElement("button", rowEditorCancelButtonProps, rowEditorCancelIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null)));
            } else {
                rowEditorProps = {
                    editing: false,
                    onInitClick: onRowEditInit,
                    initClassName: cx('rowEditorInitButton')
                };
                var rowEditorInitButtonProps = mergeProps({
                    type: 'button',
                    name: 'row-edit',
                    'aria-label': (0, $51b25b42ecc1a0c7$export$eb839c9fd3d638b9)('editRow'),
                    onClick: rowEditorProps.onInitClick,
                    className: rowEditorProps.initClassName,
                    tabIndex: props.tabIndex,
                    'data-p-row-editor-init': true
                }, getColumnPTOptions('rowEditorInitButton'));
                content = /*#__PURE__*/ $acw62.createElement("button", rowEditorInitButtonProps, rowEditorInitIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
            }
            if (body) {
                rowEditorProps.element = content;
                content = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(body, props.rowData, {
                    column: props.column,
                    field: field,
                    rowIndex: props.rowIndex,
                    frozenRow: props.frozenRow,
                    props: props.tableProps,
                    rowEditor: rowEditorProps
                });
            }
        } else if (body && (!editingState || !editor)) content = body ? (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(body, props.rowData, {
            column: props.column,
            field: field,
            rowIndex: props.rowIndex,
            frozenRow: props.frozenRow,
            props: props.tableProps
        }) : value;
        else if (editor && editingState) content = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(editor, {
            rowData: editingRowDataState,
            value: resolveFieldData(editingRowDataState),
            column: props.column,
            field: field,
            rowIndex: props.rowIndex,
            frozenRow: props.frozenRow,
            props: props.tableProps,
            editorCallback: editorCallback
        });
        else content = value;
        content = typeof content === 'boolean' ? content.toString() : content;
        if (!isRowEditor && editor) {
            var editorKeyHelperProps = mergeProps({
                tabIndex: '0',
                className: 'p-cell-editor-key-helper p-hidden-accessible',
                onFocus: function onFocus(e) {
                    return onEditorFocus(e);
                }
            }, getColumnPTOptions('editorKeyHelperLabel'));
            var editorKeyHelperLabelProps = mergeProps(getColumnPTOptions('editorKeyHelper'));
            /* eslint-disable */ editorKeyHelper = /*#__PURE__*/ $acw62.createElement("a", $68eba9483912474c$var$_extends({
                ref: keyHelperRef
            }, editorKeyHelperProps), /*#__PURE__*/ $acw62.createElement("span", editorKeyHelperLabelProps));
        /* eslint-enable */ }
        var bodyCellProps = mergeProps({
            style: style,
            className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(bodyClassName, getColumnProp('className'), cellClassName, cx('bodyCell', {
                selectionMode: selectionMode,
                editor: editor,
                editingState: editingState,
                frozen: frozen,
                cellSelected: cellSelected,
                align: align,
                bodyProps: props,
                getCellParams: getCellParams
            })),
            rowSpan: props.rowSpan,
            tabIndex: tabIndex,
            role: 'cell',
            onClick: function onClick(e) {
                return _onClick(e);
            },
            onKeyDown: function onKeyDown(e) {
                return _onKeyDown(e);
            },
            onBlur: function onBlur(e) {
                return _onBlur(e);
            },
            onMouseDown: function onMouseDown(e) {
                return _onMouseDown(e);
            },
            onMouseUp: function onMouseUp(e) {
                return _onMouseUp(e);
            },
            'data-p-selectable-cell': props.allowCellSelection && props.isSelectable({
                data: getCellParams(),
                index: props.rowIndex
            }),
            'data-p-selection-column': getColumnProp('selectionMode') != null,
            'data-p-editable-column': isEditable() != null,
            'data-p-cell-editing': editingState,
            'data-p-frozen-column': frozen
        }, getColumnPTOptions('root'), getColumnPTOptions('bodyCell'));
        return /*#__PURE__*/ $acw62.createElement("td", $68eba9483912474c$var$_extends({
            ref: elementRef
        }, bodyCellProps), editorKeyHelper, title, content);
    };
    return getVirtualScrollerOption('loading') ? createLoading() : createElement();
});
$68eba9483912474c$var$BodyCell.displayName = 'BodyCell';
function $68eba9483912474c$var$ownKeys$9(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68eba9483912474c$var$_objectSpread$9(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68eba9483912474c$var$ownKeys$9(Object(t), !0).forEach(function(r) {
            $68eba9483912474c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68eba9483912474c$var$ownKeys$9(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $68eba9483912474c$var$BodyRow = /*#__PURE__*/ $acw62.memo(function(props) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var _React$useState = $acw62.useState(false), _React$useState2 = $68eba9483912474c$var$_slicedToArray(_React$useState, 2), editingState = _React$useState2[0], setEditingState = _React$useState2[1];
    var editing = props.onRowEditChange ? props.editing : editingState;
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, cx = _props$ptCallbacks.cx;
    var getBodyRowPTOptions = function getBodyRowPTOptions(key) {
        return ptm(key, {
            parent: props.metaData,
            hostName: props.hostName,
            state: {
                editing: editing
            },
            context: {
                index: props.index,
                selectable: props.allowRowSelection && props.isSelectable({
                    data: props.rowData,
                    index: props.rowIndex
                }),
                selected: !props.allowCellSelection && props.selected || props.contextMenuSelected,
                stripedRows: props.metaData.props.stripedRows
            }
        });
    };
    var getColumnProp = function getColumnProp(column, name) {
        return $68eba9483912474c$var$ColumnBase.getCProp(column, name);
    };
    var isFocusable = function isFocusable() {
        return props.selectionMode && props.selectionModeInColumn !== 'single' && props.selectionModeInColumn !== 'multiple';
    };
    var isGrouped = function isGrouped(column) {
        var columnField = getColumnProp(column, 'field');
        if (props.groupRowsBy && columnField) return Array.isArray(props.groupRowsBy) ? props.groupRowsBy.indexOf(columnField) > -1 : props.groupRowsBy === columnField;
        return false;
    };
    var equals = function equals(data1, data2) {
        return props.compareSelectionBy === 'equals' ? data1 === data2 : (0, $a73ce425265b079e$export$4855211e6b8ad895).equals(data1, data2, props.dataKey);
    };
    var getTabIndex = function getTabIndex() {
        return isFocusable() && !props.allowCellSelection ? props.rowIndex === 0 ? props.tabIndex : -1 : null;
    };
    var findIndex = function findIndex(collection, rowData) {
        return (collection || []).findIndex(function(data) {
            return equals(rowData, data);
        });
    };
    var changeTabIndex = function changeTabIndex(currentRow, nextRow) {
        if (currentRow && nextRow) {
            currentRow.tabIndex = -1;
            nextRow.tabIndex = props.tabIndex;
        }
    };
    var findFirstSelectableRow = function findFirstSelectableRow(row) {
        var firstRow = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(row.parentNode, 'tr[data-p-selectable-row]');
        return firstRow ? firstRow : null;
    };
    var _findNextSelectableRow = function findNextSelectableRow(row) {
        var nextRow = row.nextElementSibling;
        return nextRow ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(nextRow, 'data-p-selectable-row') === true ? nextRow : _findNextSelectableRow(nextRow) : null;
    };
    var _findPrevSelectableRow = function findPrevSelectableRow(row) {
        var prevRow = row.previousElementSibling;
        return prevRow ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(prevRow, 'data-p-selectable-row') === true ? prevRow : _findPrevSelectableRow(prevRow) : null;
    };
    var findLastSelectableRow = function findLastSelectableRow(row) {
        var lastRow = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(row.parentNode, 'tr[data-p-selectable-row]:last-child');
        return lastRow ? lastRow : null;
    };
    var shouldRenderBodyCell = function shouldRenderBodyCell(value, column, i) {
        if (getColumnProp(column, 'hidden')) return false;
        else if (props.rowGroupMode && props.rowGroupMode === 'rowspan' && isGrouped(column)) {
            var prevRowData = value[i - 1];
            if (prevRowData) {
                var currentRowFieldData = (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(value[i], getColumnProp(column, 'field'));
                var previousRowFieldData = (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(prevRowData, getColumnProp(column, 'field'));
                return currentRowFieldData !== previousRowFieldData;
            }
        }
        return true;
    };
    var calculateRowGroupSize = function calculateRowGroupSize(value, column, index) {
        if (isGrouped(column)) {
            var currentRowFieldData = (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(value[index], getColumnProp(column, 'field'));
            var nextRowFieldData = currentRowFieldData;
            var groupRowSpan = 0;
            while(currentRowFieldData === nextRowFieldData){
                groupRowSpan++;
                var nextRowData = value[++index];
                if (nextRowData) nextRowFieldData = (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(nextRowData, getColumnProp(column, 'field'));
                else break;
            }
            return groupRowSpan === 1 ? null : groupRowSpan;
        }
        return null;
    };
    var _onClick = function onClick(event) {
        props.onRowClick({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onDoubleClick = function onDoubleClick(event) {
        props.onRowDoubleClick({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onPointerDown = function onPointerDown(event) {
        props.onRowPointerDown({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onPointerUp = function onPointerUp(event) {
        props.onRowPointerUp({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var onRightClick = function onRightClick(event) {
        props.onRowRightClick({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onMouseEnter = function onMouseEnter(event) {
        props.onRowMouseEnter({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onMouseLeave = function onMouseLeave(event) {
        props.onRowMouseLeave({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onTouchEnd = function onTouchEnd(event) {
        props.onRowTouchEnd(event);
    };
    var _onKeyDown = function onKeyDown(event) {
        if (isFocusable() && !props.allowCellSelection) {
            var target = event.target, row = event.currentTarget;
            switch(event.code){
                case 'ArrowDown':
                    onArrowDownKey(row, event);
                    break;
                case 'ArrowUp':
                    onArrowUpKey(row, event);
                    break;
                case 'Home':
                    onHomeKey(row, event);
                    break;
                case 'End':
                    onEndKey(row, event);
                    break;
                case 'Enter':
                case 'NumpadEnter':
                    onEnterKey(row, event, target);
                    break;
                case 'Space':
                    onSpaceKey(row, event, target);
                    break;
                case 'Tab':
                    onTabKey(row, event);
                    break;
            }
        }
    };
    var onArrowDownKey = function onArrowDownKey(row, event) {
        var nextRow = _findNextSelectableRow(row);
        if (nextRow) {
            changeTabIndex(row, nextRow);
            nextRow.focus();
        }
        event.preventDefault();
    };
    var onArrowUpKey = function onArrowUpKey(row, event) {
        var prevRow = _findPrevSelectableRow(row);
        if (prevRow) {
            changeTabIndex(row, prevRow);
            prevRow.focus();
        }
        event.preventDefault();
    };
    var onHomeKey = function onHomeKey(row, event) {
        var firstRow = findFirstSelectableRow(row);
        if (firstRow) {
            changeTabIndex(row, firstRow);
            firstRow.focus();
        }
        event.preventDefault();
    };
    var onEndKey = function onEndKey(row, event) {
        var lastRow = findLastSelectableRow(row);
        if (lastRow) {
            changeTabIndex(row, lastRow);
            lastRow.focus();
        }
        event.preventDefault();
    };
    var onEnterKey = function onEnterKey(row, event, target) {
        if (!(0, $a73ce425265b079e$export$ff8ccbac9225de62).isClickable(target)) {
            _onClick(event);
            event.preventDefault();
        }
    };
    var onSpaceKey = function onSpaceKey(row, event, target) {
        if (!(0, $a73ce425265b079e$export$ff8ccbac9225de62).isClickable(target) && !target.readOnly) {
            _onClick(event);
            event.preventDefault();
        }
    };
    var onTabKey = function onTabKey(row, event) {
        var parent = row.parentNode;
        var rows = (0, $a73ce425265b079e$export$ff8ccbac9225de62).find(parent, 'tr[data-p-selectable-row="true"]');
        if (event.code === 'Tab' && rows && rows.length > 0) {
            var firstSelectedRow = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(parent, 'tr[data-p-highlight="true"]');
            var focusedItem = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(parent, 'tr[data-p-selectable-row="true"][tabindex="0"]');
            if (firstSelectedRow) {
                firstSelectedRow.tabIndex = '0';
                focusedItem && focusedItem !== firstSelectedRow && (focusedItem.tabIndex = '-1');
            } else {
                rows[0].tabIndex = '0';
                focusedItem !== rows[0] && (rows[props.rowIndex].tabIndex = '-1');
            }
        }
    };
    var _onMouseDown = function onMouseDown(event) {
        props.onRowMouseDown({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onMouseUp = function onMouseUp(event) {
        props.onRowMouseUp({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onDragStart = function onDragStart(event) {
        props.onRowDragStart({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onDragOver = function onDragOver(event) {
        props.onRowDragOver({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onDragLeave = function onDragLeave(event) {
        props.onRowDragLeave({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onDragEnd = function onDragEnd(event) {
        props.onRowDragEnd({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onDrop = function onDrop(event) {
        props.onRowDrop({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var onEditChange = function onEditChange(e, isEditing) {
        if (props.onRowEditChange) {
            var editingRows;
            var dataKey = props.dataKey;
            var originalEvent = e.originalEvent, data = e.data, index = e.index, newData = e.newData;
            if (dataKey) {
                var dataKeyValue = String((0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(data, dataKey));
                editingRows = props.editingRows ? $68eba9483912474c$var$_objectSpread$9({}, props.editingRows) : {};
                if (!isEditing) {
                    delete editingRows[dataKeyValue];
                    // if the key value was changed, stop editing for the new key value too
                    var newDataKeyValue = String((0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(newData, dataKey));
                    delete editingRows[newDataKeyValue];
                } else editingRows[dataKeyValue] = true;
            } else {
                var editingRowIndex = findIndex(props.editingRows, data);
                editingRows = props.editingRows ? $68eba9483912474c$var$_toConsumableArray(props.editingRows) : [];
                if (editingRowIndex !== -1) editingRows = editingRows.filter(function(val, i) {
                    return i !== editingRowIndex;
                });
                else editingRows.push(data);
            }
            props.onRowEditChange({
                originalEvent: originalEvent,
                data: editingRows,
                index: index
            });
        } else setEditingState(isEditing);
    };
    var onEditInit = function onEditInit(e) {
        var event = e.originalEvent;
        if (props.onRowEditInit) props.onRowEditInit({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
        onEditChange(e, true);
        event.preventDefault();
    };
    var onEditSave = function onEditSave(e) {
        var event = e.originalEvent, newData = e.newData;
        var valid = props.rowEditValidator ? props.rowEditValidator(newData, {
            props: props.tableProps,
            rowIndex: props.rowIndex
        }) : true;
        if (props.onRowEditSave) props.onRowEditSave({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex,
            newData: newData,
            valid: valid
        });
        if (valid) {
            if (props.onRowEditComplete) props.onRowEditComplete(e);
            onEditChange(e, false);
        }
        event.preventDefault();
    };
    var onEditCancel = function onEditCancel(e) {
        var event = e.originalEvent;
        if (props.onRowEditCancel) props.onRowEditCancel({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
        onEditChange(e, false);
        event.preventDefault();
    };
    var createContent = function createContent() {
        return props.columns.map(function(col, i) {
            if (shouldRenderBodyCell(props.value, col, props.index)) {
                var key = "".concat(props.rowIndex, "_").concat(getColumnProp(col, 'columnKey') || getColumnProp(col, 'field'), "_").concat(i);
                var rowSpan = props.rowGroupMode === 'rowspan' ? calculateRowGroupSize(props.value, col, props.index) : null;
                return /*#__PURE__*/ $acw62.createElement($68eba9483912474c$var$BodyCell, {
                    hostName: props.hostName,
                    key: key,
                    allowCellSelection: props.allowCellSelection,
                    cellClassName: props.cellClassName,
                    checkIcon: props.checkIcon,
                    collapsedRowIcon: props.collapsedRowIcon,
                    column: col,
                    compareSelectionBy: props.compareSelectionBy,
                    dataKey: props.dataKey,
                    editMode: props.editMode,
                    editing: editing,
                    editingMeta: props.editingMeta,
                    expanded: props.expanded,
                    expandedRowIcon: props.expandedRowIcon,
                    frozenRow: props.frozenRow,
                    index: i,
                    isSelectable: props.isSelectable,
                    onCheckboxChange: props.onCheckboxChange,
                    onClick: props.onCellClick,
                    onEditingMetaChange: props.onEditingMetaChange,
                    onMouseDown: props.onCellMouseDown,
                    onMouseUp: props.onCellMouseUp,
                    onRadioChange: props.onRadioChange,
                    onRowEditCancel: onEditCancel,
                    onRowEditInit: onEditInit,
                    onRowEditSave: onEditSave,
                    onRowToggle: props.onRowToggle,
                    responsiveLayout: props.responsiveLayout,
                    rowData: props.rowData,
                    rowEditorCancelIcon: props.rowEditorCancelIcon,
                    rowEditorInitIcon: props.rowEditorInitIcon,
                    rowEditorSaveIcon: props.rowEditorSaveIcon,
                    rowIndex: props.rowIndex,
                    rowSpan: rowSpan,
                    selectOnEdit: props.selectOnEdit,
                    selected: props.selected,
                    selection: props.selection,
                    selectionAriaLabel: props.tableProps.selectionAriaLabel,
                    showRowReorderElement: props.showRowReorderElement,
                    showSelectionElement: props.showSelectionElement,
                    tabIndex: props.tabIndex,
                    tableProps: props.tableProps,
                    tableSelector: props.tableSelector,
                    value: props.value,
                    virtualScrollerOptions: props.virtualScrollerOptions,
                    ptCallbacks: props.ptCallbacks,
                    metaData: props.metaData,
                    unstyled: props.unstyled
                });
            }
            return null;
        });
    };
    var rowClassName = (0, $a73ce425265b079e$export$4855211e6b8ad895).getPropValue(props.rowClassName, props.rowData, {
        props: props.tableProps
    });
    var style = {
        height: props.virtualScrollerOptions ? props.virtualScrollerOptions.itemSize : undefined
    };
    var content = createContent();
    var tabIndex = getTabIndex();
    var rowProps = mergeProps({
        role: 'row',
        tabIndex: tabIndex,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(cx('bodyRow', {
            rowProps: props
        })),
        style: style,
        onMouseDown: function onMouseDown(e) {
            return _onMouseDown(e);
        },
        onMouseUp: function onMouseUp(e) {
            return _onMouseUp(e);
        },
        onMouseEnter: function onMouseEnter(e) {
            return _onMouseEnter(e);
        },
        onMouseLeave: function onMouseLeave(e) {
            return _onMouseLeave(e);
        },
        onClick: function onClick(e) {
            return _onClick(e);
        },
        onDoubleClick: function onDoubleClick(e) {
            return _onDoubleClick(e);
        },
        onPointerDown: function onPointerDown(e) {
            return _onPointerDown(e);
        },
        onPointerUp: function onPointerUp(e) {
            return _onPointerUp(e);
        },
        onContextMenu: function onContextMenu(e) {
            return onRightClick(e);
        },
        onTouchEnd: function onTouchEnd(e) {
            return _onTouchEnd(e);
        },
        onKeyDown: function onKeyDown(e) {
            return _onKeyDown(e);
        },
        onDragStart: function onDragStart(e) {
            return _onDragStart(e);
        },
        onDragOver: function onDragOver(e) {
            return _onDragOver(e);
        },
        onDragLeave: function onDragLeave(e) {
            return _onDragLeave(e);
        },
        onDragEnd: function onDragEnd(e) {
            return _onDragEnd(e);
        },
        onDrop: function onDrop(e) {
            return _onDrop(e);
        },
        'aria-selected': props !== null && props !== void 0 && props.selectionMode ? props.selected : null,
        'data-p-selectable-row': props.allowRowSelection && props.isSelectable({
            data: props.rowData,
            index: props.rowIndex
        }),
        'data-p-highlight': props.selected,
        'data-p-highlight-contextmenu': props.contextMenuSelected
    }, getBodyRowPTOptions('bodyRow'), {
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(rowClassName) // #5983 must be last so all unstyled merging takes place first
    });
    return /*#__PURE__*/ $acw62.createElement("tr", rowProps, content);
});
$68eba9483912474c$var$BodyRow.displayName = 'BodyRow';
function $68eba9483912474c$var$ownKeys$8(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68eba9483912474c$var$_objectSpread$8(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68eba9483912474c$var$ownKeys$8(Object(t), !0).forEach(function(r) {
            $68eba9483912474c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68eba9483912474c$var$ownKeys$8(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $68eba9483912474c$var$RowTogglerButton = /*#__PURE__*/ $acw62.memo(function(props) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx;
    _props$ptCallbacks.isUnstyled;
    var _onClick = function onClick(event) {
        props.onClick({
            originalEvent: event,
            data: props.rowData
        });
    };
    var getColumnProps = function getColumnProps() {
        return $68eba9483912474c$var$ColumnBase.getCProps(props.column);
    };
    var getColumnPTOptions = function getColumnPTOptions(key) {
        var cProps = getColumnProps();
        var columnMetaData = {
            props: getColumnProps(),
            parent: props.metaData,
            hostName: props.hostName
        };
        return mergeProps(ptm("column.".concat(key), {
            column: columnMetaData
        }), ptm("column.".concat(key), columnMetaData), ptmo(cProps, key, columnMetaData));
    };
    var rowGroupTogglerIconProps = mergeProps({
        className: cx('rowGroupTogglerIcon'),
        'aria-hidden': true
    }, ptm('rowGroupTogglerIcon'), getColumnPTOptions('rowGroupTogglerIcon'));
    var icon = props.expanded ? props.expandedRowIcon || /*#__PURE__*/ $acw62.createElement((0, $2539671ba6368b77$export$4857d3f3f5f8319b), rowGroupTogglerIconProps) : props.collapsedRowIcon || /*#__PURE__*/ $acw62.createElement((0, $17ca5e057f7346f4$export$b837bd7eac09a33e), rowGroupTogglerIconProps);
    var togglerIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $68eba9483912474c$var$_objectSpread$8({}, rowGroupTogglerIconProps), {
        props: props
    });
    var label = props.expanded ? (0, $51b25b42ecc1a0c7$export$eb839c9fd3d638b9)('collapseLabel') : (0, $51b25b42ecc1a0c7$export$eb839c9fd3d638b9)('expandLabel');
    var rowGroupTogglerProps = mergeProps({
        type: 'button',
        onClick: function onClick(e) {
            return _onClick(e);
        },
        className: cx('rowGroupToggler'),
        tabIndex: props.tabIndex,
        'aria-label': label
    }, ptm('rowGroupToggler'), getColumnPTOptions('rowGroupToggler'));
    return /*#__PURE__*/ $acw62.createElement("button", rowGroupTogglerProps, togglerIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
});
$68eba9483912474c$var$RowTogglerButton.displayName = 'RowTogglerButton';
var $68eba9483912474c$var$_excluded = [
    "originalEvent"
];
function $68eba9483912474c$var$ownKeys$7(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68eba9483912474c$var$_objectSpread$7(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68eba9483912474c$var$ownKeys$7(Object(t), !0).forEach(function(r) {
            $68eba9483912474c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68eba9483912474c$var$ownKeys$7(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $68eba9483912474c$var$TableBody = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx, isUnstyled = _props$ptCallbacks.isUnstyled;
    var _React$useState = $acw62.useState({}), _React$useState2 = $68eba9483912474c$var$_slicedToArray(_React$useState, 2), rowGroupHeaderStyleObjectState = _React$useState2[0], setRowGroupHeaderStyleObjectState = _React$useState2[1];
    var getColumnProps = function getColumnProps(column) {
        return $68eba9483912474c$var$ColumnBase.getCProps(column);
    };
    var getColumnPTOptions = function getColumnPTOptions(key) {
        var cProps = getColumnProps(props.column);
        var columnMetaData = {
            props: cProps,
            parent: props.metaData,
            hostName: props.hostName,
            state: {
                rowGroupHeaderStyleObject: rowGroupHeaderStyleObjectState
            }
        };
        return mergeProps(ptm("column.".concat(key), {
            column: columnMetaData
        }), ptm("column.".concat(key), columnMetaData), ptmo(cProps, key, columnMetaData));
    };
    var elementRef = $acw62.useRef(null);
    var refCallback = $acw62.useCallback(function(el) {
        elementRef.current = el;
        props.virtualScrollerContentRef && props.virtualScrollerContentRef(el);
    }, [
        props
    ]);
    var dragSelectionHelper = $acw62.useRef(null);
    var initialDragPosition = $acw62.useRef(null);
    var anchorRowIndex = $acw62.useRef(null);
    var anchorCellIndex = $acw62.useRef(null);
    var rangeRowIndex = $acw62.useRef(null);
    var anchorRowFirst = $acw62.useRef(null);
    var rowTouched = $acw62.useRef(false);
    var rowDragging = $acw62.useRef(false);
    var draggedRowIndex = $acw62.useRef(null);
    var droppedRowIndex = $acw62.useRef(null);
    var isSubheaderGrouping = props.rowGroupMode && props.rowGroupMode === 'subheader';
    var isRadioSelectionMode = props.selectionMode === 'radiobutton';
    var isCheckboxSelectionMode = props.selectionMode === 'checkbox';
    var isRadioSelectionModeInColumn = props.selectionModeInColumn === 'single';
    var isCheckboxSelectionModeInColumn = props.selectionModeInColumn === 'multiple';
    var equals = function equals(data1, data2) {
        if (allowCellSelection()) return (data1.rowIndex === data2.rowIndex || data1.rowData === data2.rowData) && (data1.field === data2.field || data1.cellIndex === data2.cellIndex);
        return props.compareSelectionBy === 'equals' ? data1 === data2 : (0, $a73ce425265b079e$export$4855211e6b8ad895).equals(data1, data2, props.dataKey);
    };
    var isSelectionEnabled = function isSelectionEnabled() {
        return props.selectionMode || props.selectionModeInColumn !== null || props.columns && props.columns.some(function(col) {
            return col && !!getColumnProp(col, 'selectionMode');
        });
    };
    var isSingleSelection = function isSingleSelection() {
        return props.selectionMode === 'single' && !isCheckboxSelectionModeInColumn || !isRadioSelectionMode && isRadioSelectionModeInColumn;
    };
    var isMultipleSelection = function isMultipleSelection() {
        return props.selectionMode === 'multiple' && !isRadioSelectionModeInColumn || isCheckboxSelectionModeInColumn;
    };
    var isRadioOnlySelection = function isRadioOnlySelection() {
        return isRadioSelectionMode && isRadioSelectionModeInColumn;
    };
    var isCheckboxOnlySelection = function isCheckboxOnlySelection() {
        return isCheckboxSelectionMode && isCheckboxSelectionModeInColumn;
    };
    var isSelected = function isSelected(rowData) {
        if (rowData && props.selection) return props.selection instanceof Array ? findIndex(props.selection, rowData) > -1 : equals(rowData, props.selection);
        return false;
    };
    var isContextMenuSelected = function isContextMenuSelected(rowData) {
        if (rowData && props.contextMenuSelection) return equals(rowData, props.contextMenuSelection);
        return false;
    };
    var isSelectable = function isSelectable(options) {
        return props.isDataSelectable ? props.isDataSelectable(options) : true;
    };
    var isRowExpanded = function isRowExpanded(rowData) {
        if (rowData && props.expandedRows) {
            if (isSubheaderGrouping && props.expandableRowGroups) return isRowGroupExpanded(rowData);
            if (props.dataKey) {
                var rowId = (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(rowData, props.dataKey);
                var expanded = false;
                if (props.expandedRows) {
                    if (Array.isArray(props.expandedRows)) expanded = props.expandedRows.some(function(row) {
                        return (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(row, props.dataKey) === rowId;
                    });
                    else expanded = props.expandedRows[rowId] !== undefined;
                }
                return expanded;
            }
            return findIndex(props.expandedRows, rowData) !== -1;
        }
        return false;
    };
    var isRowGroupExpanded = function isRowGroupExpanded(rowData) {
        if (props.dataKey === props.groupRowsBy) return Object.keys(props.expandedRows).some(function(data) {
            return (0, $a73ce425265b079e$export$4855211e6b8ad895).equals(data, (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(rowData, props.dataKey));
        });
        return props.expandedRows.some(function(data) {
            return (0, $a73ce425265b079e$export$4855211e6b8ad895).equals(data, rowData, props.groupRowsBy);
        });
    };
    var isRowEditing = function isRowEditing(rowData) {
        if (props.editMode === 'row' && rowData && props.editingRows) {
            if (props.dataKey) return props.editingRows ? props.editingRows[(0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(rowData, props.dataKey)] !== undefined : false;
            return findIndex(props.editingRows, rowData) !== -1;
        }
        return false;
    };
    var allowDrag = function allowDrag(event) {
        return props.dragSelection && isMultipleSelection() && !event.originalEvent.shiftKey;
    };
    var allowRowDrag = function allowRowDrag(event) {
        return !allowCellSelection() && allowDrag(event) || props.reorderableRows;
    };
    var allowCellDrag = function allowCellDrag(event) {
        return allowCellSelection() && allowDrag(event);
    };
    var allowSelection = function allowSelection(event) {
        return !(0, $a73ce425265b079e$export$ff8ccbac9225de62).isClickable(event.originalEvent.target);
    };
    var allowMetaKeySelection = function allowMetaKeySelection(event) {
        return !rowTouched.current && (!props.metaKeySelection || props.metaKeySelection && (event.originalEvent.metaKey || event.originalEvent.ctrlKey));
    };
    var allowRangeSelection = function allowRangeSelection(event) {
        return isMultipleSelection() && event.originalEvent.shiftKey && anchorRowIndex.current !== null;
    };
    var allowRowSelection = function allowRowSelection() {
        return (props.selectionMode || props.selectionModeInColumn) && !isRadioOnlySelection() && !isCheckboxOnlySelection();
    };
    var allowCellSelection = function allowCellSelection() {
        return props.cellSelection && !isRadioSelectionModeInColumn && !isCheckboxSelectionModeInColumn;
    };
    var getColumnsLength = function getColumnsLength() {
        return props.columns ? props.columns.length : 0;
    };
    var getColumnProp = function getColumnProp(column, name) {
        return $68eba9483912474c$var$ColumnBase.getCProp(column, name);
    };
    var getVirtualScrollerOption = function getVirtualScrollerOption(option, options) {
        options = options || props.virtualScrollerOptions;
        return options ? options[option] : null;
    };
    var findIndex = function findIndex(collection, rowData) {
        return (collection || []).findIndex(function(data) {
            return equals(rowData, data);
        });
    };
    var rowGroupHeaderStyle = function rowGroupHeaderStyle() {
        if (props.scrollable) return {
            top: rowGroupHeaderStyleObjectState.top
        };
        return null;
    };
    var getRowKey = function getRowKey(rowData, index) {
        return props.dataKey ? (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(rowData, props.dataKey) : index;
    };
    var shouldRenderRowGroupHeader = function shouldRenderRowGroupHeader(value, rowData, i) {
        var currentRowFieldData = (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(rowData, props.groupRowsBy);
        var prevRowData = value[i - 1];
        if (prevRowData) {
            var previousRowFieldData = (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(prevRowData, props.groupRowsBy);
            return !(0, $a73ce425265b079e$export$4855211e6b8ad895).deepEquals(currentRowFieldData, previousRowFieldData);
        }
        return true;
    };
    var shouldRenderRowGroupFooter = function shouldRenderRowGroupFooter(value, rowData, i, expanded) {
        if (props.expandableRowGroups && !expanded) return false;
        var currentRowFieldData = (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(rowData, props.groupRowsBy);
        var nextRowData = value[i + 1];
        if (nextRowData) {
            var nextRowFieldData = (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(nextRowData, props.groupRowsBy);
            return !(0, $a73ce425265b079e$export$4855211e6b8ad895).deepEquals(currentRowFieldData, nextRowFieldData);
        }
        return true;
    };
    var updateFrozenRowStickyPosition = function updateFrozenRowStickyPosition() {
        elementRef.current.style.top = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterHeight(elementRef.current.previousElementSibling) + 'px';
    };
    var updateFrozenRowGroupHeaderStickyPosition = function updateFrozenRowGroupHeaderStickyPosition() {
        var tableHeaderHeight = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterHeight(elementRef.current.previousElementSibling);
        var top = tableHeaderHeight + 'px';
        if (rowGroupHeaderStyleObjectState.top !== top) setRowGroupHeaderStyleObjectState({
            top: top
        });
    };
    var onSingleSelection = function onSingleSelection(_ref) {
        var originalEvent = _ref.originalEvent, data = _ref.data, index = _ref.index, toggleable = _ref.toggleable, type = _ref.type;
        if (!isSelectable({
            data: data,
            index: index
        })) return;
        var selected = isSelected(data);
        var selection = props.selection;
        if (selected) {
            if (toggleable) {
                selection = null;
                onUnselect({
                    originalEvent: originalEvent,
                    data: data,
                    type: type
                });
            }
        } else {
            selection = data;
            onSelect({
                originalEvent: originalEvent,
                data: data,
                type: type
            });
        }
        focusOnElement(originalEvent, true);
        if (props.onSelectionChange && selection !== props.selection) props.onSelectionChange({
            originalEvent: originalEvent,
            value: selection,
            type: type
        });
    };
    var onMultipleSelection = function onMultipleSelection(_ref2) {
        var originalEvent = _ref2.originalEvent, data = _ref2.data, index = _ref2.index, toggleable = _ref2.toggleable, type = _ref2.type;
        if (!isSelectable({
            data: data,
            index: index
        })) return;
        var selected = isSelected(data);
        var selection = props.selection || [];
        if (selected) {
            if (toggleable) {
                var selectionIndex = findIndex(selection, data);
                selection = props.selection.filter(function(val, i) {
                    return i !== selectionIndex;
                });
                onUnselect({
                    originalEvent: originalEvent,
                    data: data,
                    type: type
                });
            } else if (selection.length) {
                props.selection.forEach(function(d) {
                    return onUnselect({
                        originalEvent: originalEvent,
                        data: d,
                        type: type
                    });
                });
                selection = [
                    data
                ];
                onSelect({
                    originalEvent: originalEvent,
                    data: data,
                    type: type
                });
            }
        } else {
            selection = (0, $a73ce425265b079e$export$4855211e6b8ad895).isObject(selection) ? [
                selection
            ] : selection;
            selection = toggleable && isMultipleSelection() ? [].concat($68eba9483912474c$var$_toConsumableArray(selection), [
                data
            ]) : [
                data
            ];
            onSelect({
                originalEvent: originalEvent,
                data: data,
                type: type
            });
        }
        if (props.onSelectionChange && selection !== props.selection) props.onSelectionChange({
            originalEvent: originalEvent,
            value: selection,
            type: type
        });
    };
    var onRangeSelection = function onRangeSelection(event, type) {
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).clearSelection();
        rangeRowIndex.current = allowCellSelection() ? event.rowIndex : event.index;
        var selection = selectRange(event);
        if (props.onSelectionChange && selection !== props.selection) props.onSelectionChange({
            originalEvent: event.originalEvent,
            value: selection,
            type: type
        });
        anchorRowIndex.current = rangeRowIndex.current;
        anchorCellIndex.current = event.cellIndex;
    };
    var selectRange = function selectRange(event) {
        var rangeStart;
        var rangeEnd;
        var isAllowCellSelection = allowCellSelection();
        if (rangeRowIndex.current > anchorRowIndex.current) {
            rangeStart = anchorRowIndex.current;
            rangeEnd = rangeRowIndex.current;
        } else if (rangeRowIndex.current < anchorRowIndex.current) {
            rangeStart = rangeRowIndex.current;
            rangeEnd = anchorRowIndex.current;
        } else rangeStart = rangeEnd = rangeRowIndex.current;
        return isAllowCellSelection ? selectRangeOnCell(event, rangeStart, rangeEnd) : selectRangeOnRow(event, rangeStart, rangeEnd);
    };
    var selectRangeOnRow = function selectRangeOnRow(event, rowRangeStart, rowRangeEnd) {
        var value = props.tableProps.value;
        var selection = [];
        for(var i = rowRangeStart; i <= rowRangeEnd; i++){
            var rangeRowData = value[i];
            if (!isSelectable({
                data: rangeRowData,
                index: i
            })) continue;
            selection.push(rangeRowData);
            onSelect({
                originalEvent: event.originalEvent,
                data: rangeRowData,
                type: 'row'
            });
        }
        return selection;
    };
    var selectRangeOnCell = function selectRangeOnCell(event, rowRangeStart, rowRangeEnd) {
        var cellRangeStart;
        var cellRangeEnd;
        var cellIndex = event.cellIndex;
        if (cellIndex > anchorCellIndex.current) {
            cellRangeStart = anchorCellIndex.current;
            cellRangeEnd = cellIndex;
        } else if (cellIndex < anchorCellIndex.current) {
            cellRangeStart = cellIndex;
            cellRangeEnd = anchorCellIndex.current;
        } else cellRangeStart = cellRangeEnd = cellIndex;
        var value = props.value;
        var selection = [];
        for(var i = rowRangeStart; i <= rowRangeEnd; i++){
            var rowData = value[i];
            var columns = props.columns;
            var rowIndex = props.paginator ? i + props.first : i;
            for(var j = cellRangeStart; j <= cellRangeEnd; j++){
                var field = getColumnProp(columns[j], 'field');
                var _value = (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(rowData, field);
                var rangeRowData = {
                    value: _value,
                    field: field,
                    rowData: rowData,
                    rowIndex: rowIndex,
                    cellIndex: j,
                    selected: true
                };
                if (!isSelectable({
                    data: rangeRowData,
                    index: i
                })) continue;
                selection.push(rangeRowData);
                onSelect({
                    originalEvent: event.originalEvent,
                    data: rangeRowData,
                    type: 'cell'
                });
            }
        }
        return selection;
    };
    var onSelect = function onSelect(event) {
        if (allowCellSelection()) props.onCellSelect && props.onCellSelect($68eba9483912474c$var$_objectSpread$7($68eba9483912474c$var$_objectSpread$7({
            originalEvent: event.originalEvent
        }, event.data), {}, {
            type: event.type
        }));
        else props.onRowSelect && props.onRowSelect(event);
    };
    var onUnselect = function onUnselect(event) {
        if (allowCellSelection()) props.onCellUnselect && props.onCellUnselect($68eba9483912474c$var$_objectSpread$7($68eba9483912474c$var$_objectSpread$7({
            originalEvent: event.originalEvent
        }, event.data), {}, {
            type: event.type
        }));
        else props.onRowUnselect && props.onRowUnselect(event);
    };
    var enableDragSelection = function enableDragSelection(event) {
        if (props.dragSelection && !dragSelectionHelper.current) {
            dragSelectionHelper.current = document.createElement('div');
            dragSelectionHelper.current.setAttribute('p-datatable-drag-selection-helper', 'true');
            !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(dragSelectionHelper.current, 'p-datatable-drag-selection-helper');
            initialDragPosition.current = {
                x: event.clientX,
                y: event.clientY
            };
            dragSelectionHelper.current.style.top = "".concat(event.pageY, "px");
            dragSelectionHelper.current.style.left = "".concat(event.pageX, "px");
            bindDragSelectionEvents();
        }
    };
    var focusOnElement = function focusOnElement(event, isFocused) {
        var target = event.currentTarget;
        if (!allowCellSelection() && props.selectionAutoFocus) {
            if (isCheckboxSelectionModeInColumn) {
                var checkbox = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(target, 'td[data-p-selection-column="true"] [data-pc-section="checkbox"]');
                checkbox && checkbox.focus();
            } else if (isRadioSelectionModeInColumn) {
                var radio = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(target, 'td[data-p-selection-column="true"] input[type="radio"]');
                radio && radio.focus();
            }
        }
        !isFocused && target && target.focus();
    };
    var changeTabIndex = function changeTabIndex(event, type) {
        var target = event.currentTarget;
        var isSelectable = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(target, type === 'cell' ? 'data-p-selectable-cell' : 'data-p-selectable-row') === true;
        if (isSelectable) {
            var selector = type === 'cell' ? 'tr > td' : 'tr';
            var tabbableEl = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(elementRef.current, "".concat(selector, "[tabindex=\"").concat(props.tabIndex, "\"]"));
            if (tabbableEl && target) {
                tabbableEl.tabIndex = -1;
                target.tabIndex = props.tabIndex;
            }
        }
    };
    var onRowClick = function onRowClick(event) {
        if (event.defaultPrevented || event.originalEvent && event.originalEvent.defaultPrevented || allowCellSelection() || !allowSelection(event)) return;
        props.onRowClick && props.onRowClick(event);
        if (allowRowSelection()) {
            if (allowRangeSelection(event)) onRangeSelection(event, 'row');
            else {
                var toggleable = isRadioSelectionModeInColumn || isCheckboxSelectionModeInColumn || allowMetaKeySelection(event);
                anchorRowIndex.current = event.index;
                rangeRowIndex.current = event.index;
                anchorRowFirst.current = props.first;
                if (isSingleSelection()) onSingleSelection($68eba9483912474c$var$_objectSpread$7($68eba9483912474c$var$_objectSpread$7({}, event), {}, {
                    toggleable: toggleable,
                    type: 'row'
                }));
                else onMultipleSelection($68eba9483912474c$var$_objectSpread$7($68eba9483912474c$var$_objectSpread$7({}, event), {}, {
                    toggleable: toggleable,
                    type: 'row'
                }));
            }
            changeTabIndex(event.originalEvent, 'row');
        } else focusOnElement(event.originalEvent);
        rowTouched.current = false;
    };
    var onRowDoubleClick = function onRowDoubleClick(e) {
        var event = e.originalEvent;
        if ((0, $a73ce425265b079e$export$ff8ccbac9225de62).isClickable(event.target)) return;
        if (props.onRowDoubleClick) props.onRowDoubleClick(e);
    };
    var onRowPointerDown = function onRowPointerDown(e) {
        var event = e.originalEvent;
        if ((0, $a73ce425265b079e$export$ff8ccbac9225de62).isClickable(event.target)) return;
        if (props.onRowPointerDown) props.onRowPointerDown(e);
    };
    var onRowPointerUp = function onRowPointerUp(e) {
        var event = e.originalEvent;
        if ((0, $a73ce425265b079e$export$ff8ccbac9225de62).isClickable(event.target)) return;
        if (props.onRowPointerUp) props.onRowPointerUp(e);
    };
    var onRowRightClick = function onRowRightClick(event) {
        if (props.onContextMenu || props.onContextMenuSelectionChange) {
            var hasSelection = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.selection);
            var data = event.data;
            if (hasSelection) (0, $a73ce425265b079e$export$ff8ccbac9225de62).clearSelection();
            if (props.onContextMenuSelectionChange) props.onContextMenuSelectionChange({
                originalEvent: event.originalEvent,
                value: data,
                index: event.index
            });
            if (props.onContextMenu) props.onContextMenu({
                originalEvent: event.originalEvent,
                data: data,
                index: event.index
            });
            event.originalEvent.preventDefault();
        }
    };
    var onRowMouseEnter = function onRowMouseEnter(event) {
        props.onRowMouseEnter && props.onRowMouseEnter(event);
    };
    var onRowMouseLeave = function onRowMouseLeave(event) {
        props.onRowMouseLeave && props.onRowMouseLeave(event);
    };
    var onRowTouchEnd = function onRowTouchEnd() {
        rowTouched.current = true;
    };
    var onRowMouseDown = function onRowMouseDown(e) {
        var event = e.originalEvent;
        var isDraggableHandle = isUnstyled() ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(event.target, 'data-pc-section') === 'rowreordericon' || event.target.closest('[data-pc-section="rowreordericon"]') : (0, $a73ce425265b079e$export$ff8ccbac9225de62).hasClass(event.target, 'p-datatable-reorderablerow-handle') || event.target.closest('.p-datatable-reorderablerow-handle');
        event.currentTarget.draggable = isDraggableHandle;
        event.target.draggable = isDraggableHandle;
        if (allowRowDrag(e)) {
            enableDragSelection(event);
            anchorRowIndex.current = e.index;
            rangeRowIndex.current = e.index;
            anchorRowFirst.current = props.first;
        }
    };
    var onRowMouseUp = function onRowMouseUp(event) {
        var isSameRow = event.index === anchorRowIndex.current;
        if (allowRowDrag(event) && !isSameRow) onRangeSelection(event, 'row');
    };
    var onRowToggle = function onRowToggle(event) {
        var expandedRows;
        var dataKey = props.dataKey;
        var hasDataKey = props.groupRowsBy ? dataKey === props.groupRowsBy : !!dataKey;
        if (hasDataKey) {
            var dataKeyValue = String((0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(event.data, dataKey));
            expandedRows = props.expandedRows ? $68eba9483912474c$var$_objectSpread$7({}, props.expandedRows) : {};
            if (expandedRows[dataKeyValue] != null) {
                delete expandedRows[dataKeyValue];
                if (props.onRowCollapse) props.onRowCollapse({
                    originalEvent: event,
                    data: event.data
                });
            } else {
                expandedRows[dataKeyValue] = true;
                if (props.onRowExpand) props.onRowExpand({
                    originalEvent: event,
                    data: event.data
                });
            }
        } else {
            var expandedRowIndex = findIndex(props.expandedRows, event.data);
            expandedRows = props.expandedRows ? $68eba9483912474c$var$_toConsumableArray(props.expandedRows) : [];
            if (expandedRowIndex !== -1) {
                expandedRows = expandedRows.filter(function(_, i) {
                    return i !== expandedRowIndex;
                });
                if (props.onRowCollapse) props.onRowCollapse({
                    originalEvent: event,
                    data: event.data
                });
            } else {
                expandedRows.push(event.data);
                if (props.onRowExpand) props.onRowExpand({
                    originalEvent: event,
                    data: event.data
                });
            }
        }
        if (props.onRowToggle) props.onRowToggle({
            data: expandedRows
        });
    };
    var onRowDragStart = function onRowDragStart(e) {
        var event = e.originalEvent, index = e.index;
        if (allowRowDrag(e)) {
            rowDragging.current = true;
            draggedRowIndex.current = index;
            event.dataTransfer.setData('text', 'b'); // For firefox
        }
    };
    var onRowDragOver = function onRowDragOver(e) {
        var event = e.originalEvent, index = e.index;
        if (!rowDragging.current) return;
        if (draggedRowIndex.current !== index) {
            var rowElement = event.currentTarget;
            var rowY = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOffset(rowElement).top + (0, $a73ce425265b079e$export$ff8ccbac9225de62).getWindowScrollTop();
            var pageY = event.pageY + window.scrollY;
            var rowMidY = rowY + (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterHeight(rowElement) / 2;
            var prevRowElement = rowElement.previousElementSibling;
            if (pageY < rowMidY) {
                rowElement.setAttribute('data-p-datatable-dragpoint-bottom', 'false');
                !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(rowElement, 'p-datatable-dragpoint-bottom');
                droppedRowIndex.current = index;
                if (prevRowElement) {
                    prevRowElement.setAttribute('data-p-datatable-dragpoint-bottom', 'true');
                    !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(prevRowElement, 'p-datatable-dragpoint-bottom');
                } else {
                    rowElement.setAttribute('data-p-datatable-dragpoint-top', 'true');
                    !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(rowElement, 'p-datatable-dragpoint-top');
                }
            } else {
                if (prevRowElement) {
                    prevRowElement.setAttribute('data-p-datatable-dragpoint-bottom', 'false');
                    !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(prevRowElement, 'p-datatable-dragpoint-bottom');
                } else {
                    rowElement.setAttribute('data-p-datatable-dragpoint-top', 'true');
                    !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(rowElement, 'p-datatable-dragpoint-top');
                }
                if (index + 1 !== draggedRowIndex.current) droppedRowIndex.current = index + 1;
                rowElement.setAttribute('data-p-datatable-dragpoint-bottom', 'true');
                !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(rowElement, 'p-datatable-dragpoint-bottom');
            }
        }
        event.preventDefault();
    };
    var onRowDragLeave = function onRowDragLeave(e) {
        var event = e.originalEvent;
        var rowElement = event.currentTarget;
        var prevRowElement = rowElement.previousElementSibling;
        if (prevRowElement) {
            prevRowElement.setAttribute('data-p-datatable-dragpoint-bottom', 'false');
            !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(prevRowElement, 'p-datatable-dragpoint-bottom');
        }
        rowElement.setAttribute('data-p-datatable-dragpoint-bottom', 'false');
        !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(rowElement, 'p-datatable-dragpoint-bottom');
        rowElement.setAttribute('data-p-datatable-dragpoint-top', 'false');
        !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(rowElement, 'p-datatable-dragpoint-top');
    };
    var onRowDragEnd = function onRowDragEnd(e) {
        var event = e.originalEvent;
        rowDragging.current = false;
        draggedRowIndex.current = null;
        droppedRowIndex.current = null;
        event.currentTarget.draggable = false;
    };
    var onRowDrop = function onRowDrop(e) {
        var event = e.originalEvent;
        if (droppedRowIndex.current != null) {
            var dropIndex = draggedRowIndex.current > droppedRowIndex.current ? droppedRowIndex.current : droppedRowIndex.current === 0 ? 0 : droppedRowIndex.current - 1;
            var val = $68eba9483912474c$var$_toConsumableArray(props.tableProps.value);
            (0, $a73ce425265b079e$export$4855211e6b8ad895).reorderArray(val, draggedRowIndex.current, dropIndex);
            if (props.onRowReorder) props.onRowReorder({
                originalEvent: event,
                value: val,
                dragIndex: draggedRowIndex.current,
                dropIndex: dropIndex
            });
        }
        //cleanup
        onRowDragLeave(e);
        onRowDragEnd(e);
        event.preventDefault();
    };
    var onRadioChange = function onRadioChange(event) {
        onSingleSelection($68eba9483912474c$var$_objectSpread$7($68eba9483912474c$var$_objectSpread$7({}, event), {}, {
            toggleable: true,
            type: 'radio'
        }));
    };
    var onCheckboxChange = function onCheckboxChange(event) {
        onMultipleSelection($68eba9483912474c$var$_objectSpread$7($68eba9483912474c$var$_objectSpread$7({}, event), {}, {
            toggleable: true,
            type: 'checkbox'
        }));
    };
    var onDragSelectionMouseMove = function onDragSelectionMouseMove(event) {
        var _initialDragPosition$ = initialDragPosition.current, x = _initialDragPosition$.x, y = _initialDragPosition$.y;
        var dx = event.clientX - x;
        var dy = event.clientY - y;
        if (dy < 0) dragSelectionHelper.current.style.top = "".concat(event.pageY + 5, "px");
        if (dx < 0) dragSelectionHelper.current.style.left = "".concat(event.pageX + 5, "px");
        dragSelectionHelper.current.style.height = "".concat(Math.abs(dy), "px");
        dragSelectionHelper.current.style.width = "".concat(Math.abs(dx), "px");
        event.preventDefault();
    };
    var _onDragSelectionMouseUp = function onDragSelectionMouseUp() {
        if (dragSelectionHelper.current) {
            dragSelectionHelper.current.remove();
            dragSelectionHelper.current = null;
        }
        document.removeEventListener('mousemove', onDragSelectionMouseMove);
        document.removeEventListener('mouseup', _onDragSelectionMouseUp);
    };
    var onCellClick = function onCellClick(event) {
        if (!allowSelection(event)) return;
        props.onCellClick && props.onCellClick(event);
        if (allowCellSelection()) {
            if (allowRangeSelection(event)) onRangeSelection(event, 'cell');
            else {
                var toggleable = allowMetaKeySelection(event);
                var originalEvent = event.originalEvent, data = $68eba9483912474c$var$_objectWithoutProperties(event, $68eba9483912474c$var$_excluded);
                anchorRowIndex.current = event.rowIndex;
                rangeRowIndex.current = event.rowIndex;
                anchorRowFirst.current = props.first;
                anchorCellIndex.current = event.cellIndex;
                if (isSingleSelection()) onSingleSelection({
                    originalEvent: originalEvent,
                    data: data,
                    index: event.rowIndex,
                    toggleable: toggleable,
                    type: 'cell'
                });
                else onMultipleSelection({
                    originalEvent: originalEvent,
                    data: data,
                    index: event.rowIndex,
                    toggleable: toggleable,
                    type: 'cell'
                });
            }
            changeTabIndex(event.originalEvent, 'cell');
        }
        rowTouched.current = false;
    };
    var onCellMouseDown = function onCellMouseDown(event) {
        if (allowCellDrag(event)) {
            enableDragSelection(event.originalEvent);
            anchorRowIndex.current = event.rowIndex;
            rangeRowIndex.current = event.rowIndex;
            anchorRowFirst.current = props.first;
            anchorCellIndex.current = event.cellIndex;
        }
    };
    var onCellMouseUp = function onCellMouseUp(event) {
        var isSameCell = event.rowIndex === anchorRowIndex.current && event.cellIndex === anchorCellIndex.current;
        if (allowCellDrag(event) && !isSameCell) onRangeSelection(event, 'cell');
    };
    var bindDragSelectionEvents = function bindDragSelectionEvents() {
        document.addEventListener('mousemove', onDragSelectionMouseMove);
        document.addEventListener('mouseup', _onDragSelectionMouseUp);
        document.body.appendChild(dragSelectionHelper.current);
    };
    var unbindDragSelectionEvents = function unbindDragSelectionEvents() {
        _onDragSelectionMouseUp();
    };
    $acw62.useEffect(function() {
        if (props.frozenRow) updateFrozenRowStickyPosition();
        if (props.scrollable && props.rowGroupMode === 'subheader') updateFrozenRowGroupHeaderStickyPosition();
    });
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (props.paginator && isMultipleSelection()) anchorRowIndex.current = null;
    }, [
        props.first
    ]);
    (0, $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96)(function() {
        if (props.dragSelection) unbindDragSelectionEvents();
    });
    var createEmptyContent = function createEmptyContent() {
        if (!props.loading) {
            var colSpan = getColumnsLength();
            var _content = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.emptyMessage, {
                props: props.tableProps,
                frozen: props.frozenRow
            }) || (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('emptyMessage');
            var emptyMessageProps = mergeProps({
                className: cx('emptyMessage'),
                role: 'row'
            }, getColumnPTOptions('emptyMessage'));
            var bodyCellProps = mergeProps({
                colSpan: colSpan,
                role: 'cell'
            }, getColumnPTOptions('root'), getColumnPTOptions('bodyCell'));
            return /*#__PURE__*/ $acw62.createElement("tr", emptyMessageProps, /*#__PURE__*/ $acw62.createElement("td", bodyCellProps, _content));
        }
        return null;
    };
    var createGroupHeader = function createGroupHeader(rowData, rowIndex, expanded, colSpan) {
        if (isSubheaderGrouping && shouldRenderRowGroupHeader(props.value, rowData, rowIndex - props.first)) {
            var style = rowGroupHeaderStyle();
            var toggler = props.expandableRowGroups && /*#__PURE__*/ $acw62.createElement($68eba9483912474c$var$RowTogglerButton, {
                hostName: props.hostName,
                onClick: onRowToggle,
                rowData: rowData,
                expanded: expanded,
                expandedRowIcon: props.expandedRowIcon,
                collapsedRowIcon: props.collapsedRowIcon,
                ptCallbacks: props.ptCallbacks,
                metaData: props.metaData,
                unstyled: isUnstyled()
            });
            var options = {
                index: rowIndex,
                props: props.tableProps,
                customRendering: false
            };
            var _content2 = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.rowGroupHeaderTemplate, rowData, options);
            // check if the user wants complete control of the rendering
            if (!options.customRendering) {
                var bodyCellProps = mergeProps({
                    colSpan: colSpan
                }, getColumnPTOptions('root'), getColumnPTOptions('bodyCell'));
                var rowGroupHeaderNameProps = mergeProps({
                    className: cx('rowGroupHeaderName')
                }, getColumnPTOptions('rowGroupHeaderName'));
                _content2 = /*#__PURE__*/ $acw62.createElement("td", bodyCellProps, toggler, /*#__PURE__*/ $acw62.createElement("span", rowGroupHeaderNameProps, _content2));
            }
            var rowGroupHeaderProps = mergeProps({
                className: cx('rowGroupHeader'),
                style: style,
                role: 'row'
            }, getColumnPTOptions('rowGroupHeader'));
            return /*#__PURE__*/ $acw62.createElement("tr", rowGroupHeaderProps, _content2);
        }
        return null;
    };
    var createRow = function createRow(rowData, rowIndex, index, expanded) {
        if (!props.expandableRowGroups || expanded) {
            var selected = isSelectionEnabled() ? isSelected(rowData) : false;
            var contextMenuSelected = isContextMenuSelected(rowData);
            var _allowRowSelection = allowRowSelection();
            var _allowCellSelection = allowCellSelection();
            var editing = isRowEditing(rowData);
            return /*#__PURE__*/ $acw62.createElement($68eba9483912474c$var$BodyRow, {
                hostName: props.hostName,
                allowCellSelection: _allowCellSelection,
                allowRowSelection: _allowRowSelection,
                cellClassName: props.cellClassName,
                checkIcon: props.checkIcon,
                collapsedRowIcon: props.collapsedRowIcon,
                columns: props.columns,
                compareSelectionBy: props.compareSelectionBy,
                contextMenuSelected: contextMenuSelected,
                dataKey: props.dataKey,
                editMode: props.editMode,
                editing: editing,
                editingMeta: props.editingMeta,
                editingRows: props.editingRows,
                expanded: expanded,
                expandedRowIcon: props.expandedRowIcon,
                frozenRow: props.frozenRow,
                groupRowsBy: props.groupRowsBy,
                index: index,
                isSelectable: isSelectable,
                onCellClick: onCellClick,
                onCellMouseDown: onCellMouseDown,
                onCellMouseUp: onCellMouseUp,
                onCheckboxChange: onCheckboxChange,
                onEditingMetaChange: props.onEditingMetaChange,
                onRadioChange: onRadioChange,
                onRowClick: onRowClick,
                onRowDoubleClick: onRowDoubleClick,
                onRowPointerDown: onRowPointerDown,
                onRowPointerUp: onRowPointerUp,
                onRowDragEnd: onRowDragEnd,
                onRowDragLeave: onRowDragLeave,
                onRowDragOver: onRowDragOver,
                onRowDragStart: onRowDragStart,
                onRowDrop: onRowDrop,
                onRowEditCancel: props.onRowEditCancel,
                onRowEditChange: props.onRowEditChange,
                onRowEditComplete: props.onRowEditComplete,
                onRowEditInit: props.onRowEditInit,
                onRowEditSave: props.onRowEditSave,
                onRowMouseDown: onRowMouseDown,
                onRowMouseEnter: onRowMouseEnter,
                onRowMouseLeave: onRowMouseLeave,
                onRowMouseUp: onRowMouseUp,
                onRowRightClick: onRowRightClick,
                onRowToggle: onRowToggle,
                onRowTouchEnd: onRowTouchEnd,
                responsiveLayout: props.responsiveLayout,
                rowClassName: props.rowClassName,
                rowData: rowData,
                rowEditValidator: props.rowEditValidator,
                rowEditorCancelIcon: props.rowEditorCancelIcon,
                rowEditorInitIcon: props.rowEditorInitIcon,
                rowEditorSaveIcon: props.rowEditorSaveIcon,
                rowGroupMode: props.rowGroupMode,
                rowIndex: rowIndex,
                selectOnEdit: props.selectOnEdit,
                selected: selected,
                selection: props.selection,
                selectionMode: props.selectionMode,
                selectionModeInColumn: props.selectionModeInColumn,
                showRowReorderElement: props.showRowReorderElement,
                showSelectionElement: props.showSelectionElement,
                tabIndex: props.tabIndex,
                tableProps: props.tableProps,
                tableSelector: props.tableSelector,
                value: props.value,
                virtualScrollerOptions: props.virtualScrollerOptions,
                ptCallbacks: props.ptCallbacks,
                metaData: props.metaData,
                unstyled: isUnstyled()
            });
        }
    };
    var createExpansion = function createExpansion(rowData, rowIndex, expanded, colSpan) {
        if (expanded && !(isSubheaderGrouping && props.expandableRowGroups)) {
            var id = "".concat(props.tableSelector, "_content_").concat(rowIndex, "_expanded");
            var options = {
                index: rowIndex,
                customRendering: false
            };
            var _content3 = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.rowExpansionTemplate, rowData, options);
            // check if the user wants complete control of the rendering
            if (!options.customRendering) {
                var bodyCellProps = mergeProps({
                    colSpan: colSpan,
                    role: 'cell'
                }, getColumnPTOptions('root'), getColumnPTOptions('bodyCell'));
                _content3 = /*#__PURE__*/ $acw62.createElement("td", bodyCellProps, _content3);
            }
            var rowExpansionProps = mergeProps({
                id: id,
                className: cx('rowExpansion'),
                role: 'row'
            }, getColumnPTOptions('rowExpansion'));
            return /*#__PURE__*/ $acw62.createElement("tr", rowExpansionProps, _content3);
        }
        return null;
    };
    var createGroupFooter = function createGroupFooter(rowData, rowIndex, expanded, colSpan) {
        if (isSubheaderGrouping && shouldRenderRowGroupFooter(props.value, rowData, rowIndex - props.first, expanded)) {
            var _content4 = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.rowGroupFooterTemplate, rowData, {
                index: rowIndex,
                colSpan: colSpan,
                props: props.tableProps
            });
            var rowGroupFooterProps = mergeProps({
                className: cx('rowGroupFooter'),
                role: 'row'
            }, getColumnPTOptions('rowGroupFooter'));
            return /*#__PURE__*/ $acw62.createElement("tr", rowGroupFooterProps, _content4);
        }
        return null;
    };
    var createContent = function createContent() {
        return props.value && props.value.map(function(rowData, index) {
            var rowIndex = getVirtualScrollerOption('getItemOptions') ? getVirtualScrollerOption('getItemOptions')(index).index : props.first + index;
            var key = getRowKey(rowData, rowIndex);
            var expanded = isRowExpanded(rowData);
            var colSpan = getColumnsLength();
            var groupHeader = createGroupHeader(rowData, rowIndex, expanded, colSpan);
            var row = createRow(rowData, rowIndex, index, expanded);
            var expansion = createExpansion(rowData, rowIndex, expanded, colSpan);
            var groupFooter = createGroupFooter(rowData, rowIndex, expanded, colSpan);
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, {
                key: key
            }, groupHeader, row, expansion, groupFooter);
        });
    };
    var content = props.empty ? createEmptyContent() : createContent();
    var ptKey = props.className === 'p-datatable-virtualscroller-spacer' ? 'virtualScrollerSpacer' : 'tbody';
    var tbodyProps = mergeProps({
        style: props.style,
        className: cx(ptKey, {
            className: props.className
        }),
        role: ' rowgroup'
    }, ptm(ptKey, {
        hostName: props.hostName
    }));
    return /*#__PURE__*/ $acw62.createElement("tbody", $68eba9483912474c$var$_extends({
        ref: refCallback
    }, tbodyProps), content);
}));
$68eba9483912474c$var$TableBody.displayName = 'TableBody';
var $68eba9483912474c$var$ColumnGroupBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'ColumnGroup',
        children: undefined
    },
    getCProp: function getCProp(group, name) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getComponentProp(group, name, $68eba9483912474c$var$ColumnGroupBase.defaultProps);
    },
    getCProps: function getCProps(group) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getComponentProps(group, $68eba9483912474c$var$ColumnGroupBase.defaultProps);
    }
});
var $68eba9483912474c$var$RowBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'Row',
        style: null,
        className: null,
        children: undefined
    },
    getCProp: function getCProp(row, name) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getComponentProp(row, name, $68eba9483912474c$var$RowBase.defaultProps);
    }
});
function $68eba9483912474c$var$ownKeys$6(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68eba9483912474c$var$_objectSpread$6(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68eba9483912474c$var$ownKeys$6(Object(t), !0).forEach(function(r) {
            $68eba9483912474c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68eba9483912474c$var$ownKeys$6(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $68eba9483912474c$var$FooterCell = /*#__PURE__*/ $acw62.memo(function(props) {
    var _React$useState = $acw62.useState({}), _React$useState2 = $68eba9483912474c$var$_slicedToArray(_React$useState, 2), styleObjectState = _React$useState2[0], setStyleObjectState = _React$useState2[1];
    var elementRef = $acw62.useRef(null);
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var getColumnProps = function getColumnProps() {
        return $68eba9483912474c$var$ColumnBase.getCProps(props.column);
    };
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx;
    var getColumnPTOptions = function getColumnPTOptions(key) {
        var cProps = getColumnProps();
        var columnMetaData = {
            props: cProps,
            parent: props.metaData,
            hostName: props.hostName,
            state: {
                styleObject: styleObjectState
            },
            context: {
                index: props.index,
                size: props.metaData.props.size,
                showGridlines: props.metaData.props.showGridlines
            }
        };
        return mergeProps(ptm("column.".concat(key), {
            column: columnMetaData
        }), ptm("column.".concat(key), columnMetaData), ptmo(cProps, key, columnMetaData));
    };
    var getColumnProp = function getColumnProp(name) {
        return $68eba9483912474c$var$ColumnBase.getCProp(props.column, name);
    };
    var getStyle = function getStyle() {
        var footerStyle = getColumnProp('footerStyle');
        var columnStyle = getColumnProp('style');
        return getColumnProp('frozen') ? Object.assign({}, columnStyle, footerStyle, styleObjectState) : Object.assign({}, columnStyle, footerStyle);
    };
    var updateStickyPosition = function updateStickyPosition() {
        if (getColumnProp('frozen')) {
            var styleObject = $68eba9483912474c$var$_objectSpread$6({}, styleObjectState);
            var _align = getColumnProp('alignFrozen');
            if (_align === 'right') {
                var right = 0;
                var next = elementRef.current.nextElementSibling;
                if (next && next.classList.contains('p-frozen-column')) right = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(next) + parseFloat(next.style.right || 0);
                styleObject.right = right + 'px';
            } else {
                var left = 0;
                var prev = elementRef.current.previousElementSibling;
                if (prev && prev.classList.contains('p-frozen-column')) left = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(prev) + parseFloat(prev.style.left || 0);
                styleObject.left = left + 'px';
            }
            var isSameStyle = styleObjectState.left === styleObject.left && styleObjectState.right === styleObject.right;
            !isSameStyle && setStyleObjectState(styleObject);
        }
    };
    $acw62.useEffect(function() {
        if (getColumnProp('frozen')) updateStickyPosition();
    });
    var style = getStyle();
    var align = getColumnProp('align');
    var colSpan = getColumnProp('colSpan');
    var rowSpan = getColumnProp('rowSpan');
    var content = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(getColumnProp('footer'), {
        props: props.tableProps
    });
    var footerCellProps = mergeProps({
        style: style,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(getColumnProp('footerClassName'), getColumnProp('className'), cx('footerCell', {
            getColumnProp: getColumnProp,
            align: align
        })),
        role: 'cell',
        colSpan: colSpan,
        rowSpan: rowSpan
    }, getColumnPTOptions('root'), getColumnPTOptions('footerCell'));
    return /*#__PURE__*/ $acw62.createElement("td", $68eba9483912474c$var$_extends({
        ref: elementRef
    }, footerCellProps), content);
});
$68eba9483912474c$var$FooterCell.displayName = 'FooterCell';
var $68eba9483912474c$var$TableFooter = /*#__PURE__*/ $acw62.memo(function(props) {
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx;
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var getRowProps = function getRowProps(row) {
        return $68eba9483912474c$var$ColumnGroupBase.getCProps(row);
    };
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var getColumnGroupProps = function getColumnGroupProps() {
        return props.footerColumnGroup ? $68eba9483912474c$var$ColumnGroupBase.getCProps(props.footerColumnGroup) : undefined;
    };
    var getRowPTOptions = function getRowPTOptions(row, key) {
        var rProps = getRowProps(row);
        var rowMetaData = {
            props: rProps,
            parent: props.metaData,
            hostName: props.hostName
        };
        return mergeProps(ptm("row.".concat(key), {
            row: rowMetaData
        }), ptm("row.".concat(key), rowMetaData), ptmo(rProps, key, rowMetaData));
    };
    var getColumnGroupPTOptions = function getColumnGroupPTOptions(key) {
        var cGProps = getColumnGroupProps();
        var columnGroupMetaData = {
            props: getColumnGroupProps(),
            parent: props.metaData,
            hostName: props.hostName
        };
        return mergeProps(ptm("columnGroup.".concat(key), {
            columnGroup: columnGroupMetaData
        }), ptm("columnGroup.".concat(key), columnGroupMetaData), ptmo(cGProps, key, columnGroupMetaData));
    };
    var hasFooter = function hasFooter() {
        return props.footerColumnGroup ? true : props.columns ? props.columns.some(function(col) {
            return col && getColumnProp(col, 'footer');
        }) : false;
    };
    var getColumnProp = function getColumnProp(column, name) {
        return $68eba9483912474c$var$ColumnBase.getCProp(column, name);
    };
    var createGroupFooterCells = function createGroupFooterCells(row) {
        var columns = $acw62.Children.toArray($68eba9483912474c$var$RowBase.getCProp(row, 'children'));
        return createFooterCells(columns);
    };
    var createFooterCells = function createFooterCells(columns) {
        return $acw62.Children.map(columns, function(col, i) {
            var isVisible = col ? !getColumnProp(col, 'hidden') : true;
            var key = col ? getColumnProp(col, 'columnKey') || getColumnProp(col, 'field') || i : i;
            return isVisible && /*#__PURE__*/ $acw62.createElement($68eba9483912474c$var$FooterCell, {
                hostName: props.hostName,
                key: key,
                tableProps: props.tableProps,
                column: col,
                ptCallbacks: props.ptCallbacks,
                metaData: props.metaData
            });
        });
    };
    var createContent = function createContent() {
        if (props.footerColumnGroup) {
            var rows = $acw62.Children.toArray($68eba9483912474c$var$ColumnGroupBase.getCProp(props.footerColumnGroup, 'children'));
            return rows.map(function(row, i) {
                var rootProps = mergeProps({
                    role: 'row'
                }, $68eba9483912474c$var$RowBase.getProps(row.props, context), getRowPTOptions(row, 'root'));
                return /*#__PURE__*/ $acw62.createElement("tr", $68eba9483912474c$var$_extends({}, rootProps, {
                    key: i
                }), createGroupFooterCells(row));
            });
        }
        var footerRowProps = mergeProps({
            role: 'row'
        }, ptm('footerRow', {
            hostName: props.hostName
        }));
        return /*#__PURE__*/ $acw62.createElement("tr", footerRowProps, createFooterCells(props.columns));
    };
    if (hasFooter()) {
        var content = createContent();
        var tfootProps = mergeProps({
            className: cx('tfoot'),
            role: 'rowgroup'
        }, getColumnGroupPTOptions('root'), ptm('tfoot', {
            hostName: props.hostName
        }));
        return /*#__PURE__*/ $acw62.createElement("tfoot", tfootProps, content);
    }
    return null;
});
$68eba9483912474c$var$TableFooter.displayName = 'TableFooter';
function $68eba9483912474c$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $68eba9483912474c$var$toPropertyKey(o.key), o);
    }
}
function $68eba9483912474c$var$_createClass(e, r, t) {
    return r && $68eba9483912474c$var$_defineProperties(e.prototype, r), t && $68eba9483912474c$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $68eba9483912474c$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
var $68eba9483912474c$var$FilterMatchMode = Object.freeze({
    STARTS_WITH: 'startsWith',
    CONTAINS: 'contains',
    NOT_CONTAINS: 'notContains',
    ENDS_WITH: 'endsWith',
    EQUALS: 'equals',
    NOT_EQUALS: 'notEquals',
    IN: 'in',
    LESS_THAN: 'lt',
    LESS_THAN_OR_EQUAL_TO: 'lte',
    GREATER_THAN: 'gt',
    GREATER_THAN_OR_EQUAL_TO: 'gte',
    BETWEEN: 'between',
    DATE_IS: 'dateIs',
    DATE_IS_NOT: 'dateIsNot',
    DATE_BEFORE: 'dateBefore',
    DATE_AFTER: 'dateAfter',
    CUSTOM: 'custom'
});
/**
 * @deprecated please use PrimeReactContext
 */ var $68eba9483912474c$var$PrimeReact = /*#__PURE__*/ $68eba9483912474c$var$_createClass(function PrimeReact() {
    $68eba9483912474c$var$_classCallCheck(this, PrimeReact);
});
$68eba9483912474c$var$_defineProperty($68eba9483912474c$var$PrimeReact, "ripple", false);
$68eba9483912474c$var$_defineProperty($68eba9483912474c$var$PrimeReact, "inputStyle", 'outlined');
$68eba9483912474c$var$_defineProperty($68eba9483912474c$var$PrimeReact, "locale", 'en');
$68eba9483912474c$var$_defineProperty($68eba9483912474c$var$PrimeReact, "appendTo", null);
$68eba9483912474c$var$_defineProperty($68eba9483912474c$var$PrimeReact, "cssTransition", true);
$68eba9483912474c$var$_defineProperty($68eba9483912474c$var$PrimeReact, "autoZIndex", true);
$68eba9483912474c$var$_defineProperty($68eba9483912474c$var$PrimeReact, "hideOverlaysOnDocumentScrolling", false);
$68eba9483912474c$var$_defineProperty($68eba9483912474c$var$PrimeReact, "nonce", null);
$68eba9483912474c$var$_defineProperty($68eba9483912474c$var$PrimeReact, "nullSortOrder", 1);
$68eba9483912474c$var$_defineProperty($68eba9483912474c$var$PrimeReact, "zIndex", {
    modal: 1100,
    overlay: 1000,
    menu: 1000,
    tooltip: 1100,
    toast: 1200
});
$68eba9483912474c$var$_defineProperty($68eba9483912474c$var$PrimeReact, "pt", undefined);
$68eba9483912474c$var$_defineProperty($68eba9483912474c$var$PrimeReact, "filterMatchModeOptions", {
    text: [
        $68eba9483912474c$var$FilterMatchMode.STARTS_WITH,
        $68eba9483912474c$var$FilterMatchMode.CONTAINS,
        $68eba9483912474c$var$FilterMatchMode.NOT_CONTAINS,
        $68eba9483912474c$var$FilterMatchMode.ENDS_WITH,
        $68eba9483912474c$var$FilterMatchMode.EQUALS,
        $68eba9483912474c$var$FilterMatchMode.NOT_EQUALS
    ],
    numeric: [
        $68eba9483912474c$var$FilterMatchMode.EQUALS,
        $68eba9483912474c$var$FilterMatchMode.NOT_EQUALS,
        $68eba9483912474c$var$FilterMatchMode.LESS_THAN,
        $68eba9483912474c$var$FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
        $68eba9483912474c$var$FilterMatchMode.GREATER_THAN,
        $68eba9483912474c$var$FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
    ],
    date: [
        $68eba9483912474c$var$FilterMatchMode.DATE_IS,
        $68eba9483912474c$var$FilterMatchMode.DATE_IS_NOT,
        $68eba9483912474c$var$FilterMatchMode.DATE_BEFORE,
        $68eba9483912474c$var$FilterMatchMode.DATE_AFTER
    ]
});
$68eba9483912474c$var$_defineProperty($68eba9483912474c$var$PrimeReact, "changeTheme", function(currentTheme, newTheme, linkElementId, callback) {
    var _linkElement$parentNo;
    var linkElement = document.getElementById(linkElementId);
    if (!linkElement) throw Error("Element with id ".concat(linkElementId, " not found."));
    var newThemeUrl = linkElement.getAttribute('href').replace(currentTheme, newTheme);
    var newLinkElement = document.createElement('link');
    newLinkElement.setAttribute('rel', 'stylesheet');
    newLinkElement.setAttribute('id', linkElementId);
    newLinkElement.setAttribute('href', newThemeUrl);
    newLinkElement.addEventListener('load', function() {
        if (callback) callback();
    });
    (_linkElement$parentNo = linkElement.parentNode) === null || _linkElement$parentNo === void 0 || _linkElement$parentNo.replaceChild(newLinkElement, linkElement);
});
var $68eba9483912474c$var$locales = {
    en: {
        accept: 'Yes',
        addRule: 'Add Rule',
        am: 'AM',
        apply: 'Apply',
        cancel: 'Cancel',
        choose: 'Choose',
        chooseDate: 'Choose Date',
        chooseMonth: 'Choose Month',
        chooseYear: 'Choose Year',
        clear: 'Clear',
        completed: 'Completed',
        contains: 'Contains',
        custom: 'Custom',
        dateAfter: 'Date is after',
        dateBefore: 'Date is before',
        dateFormat: 'mm/dd/yy',
        dateIs: 'Date is',
        dateIsNot: 'Date is not',
        dayNames: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ],
        dayNamesMin: [
            'Su',
            'Mo',
            'Tu',
            'We',
            'Th',
            'Fr',
            'Sa'
        ],
        dayNamesShort: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ],
        emptyFilterMessage: 'No results found',
        emptyMessage: 'No available options',
        emptySearchMessage: 'No results found',
        emptySelectionMessage: 'No selected item',
        endsWith: 'Ends with',
        equals: 'Equals',
        fileSizeTypes: [
            'B',
            'KB',
            'MB',
            'GB',
            'TB',
            'PB',
            'EB',
            'ZB',
            'YB'
        ],
        filter: 'Filter',
        firstDayOfWeek: 0,
        gt: 'Greater than',
        gte: 'Greater than or equal to',
        lt: 'Less than',
        lte: 'Less than or equal to',
        matchAll: 'Match All',
        matchAny: 'Match Any',
        medium: 'Medium',
        monthNames: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        monthNamesShort: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        nextDecade: 'Next Decade',
        nextHour: 'Next Hour',
        nextMinute: 'Next Minute',
        nextMonth: 'Next Month',
        nextSecond: 'Next Second',
        nextYear: 'Next Year',
        noFilter: 'No Filter',
        notContains: 'Not contains',
        notEquals: 'Not equals',
        now: 'Now',
        passwordPrompt: 'Enter a password',
        pending: 'Pending',
        pm: 'PM',
        prevDecade: 'Previous Decade',
        prevHour: 'Previous Hour',
        prevMinute: 'Previous Minute',
        prevMonth: 'Previous Month',
        prevSecond: 'Previous Second',
        prevYear: 'Previous Year',
        reject: 'No',
        removeRule: 'Remove Rule',
        searchMessage: '{0} results are available',
        selectionMessage: '{0} items selected',
        showMonthAfterYear: false,
        startsWith: 'Starts with',
        strong: 'Strong',
        today: 'Today',
        upload: 'Upload',
        weak: 'Weak',
        weekHeader: 'Wk',
        aria: {
            cancelEdit: 'Cancel Edit',
            close: 'Close',
            collapseRow: 'Row Collapsed',
            editRow: 'Edit Row',
            expandRow: 'Row Expanded',
            falseLabel: 'False',
            filterConstraint: 'Filter Constraint',
            filterOperator: 'Filter Operator',
            firstPageLabel: 'First Page',
            gridView: 'Grid View',
            hideFilterMenu: 'Hide Filter Menu',
            jumpToPageDropdownLabel: 'Jump to Page Dropdown',
            jumpToPageInputLabel: 'Jump to Page Input',
            lastPageLabel: 'Last Page',
            listView: 'List View',
            moveAllToSource: 'Move All to Source',
            moveAllToTarget: 'Move All to Target',
            moveBottom: 'Move Bottom',
            moveDown: 'Move Down',
            moveToSource: 'Move to Source',
            moveToTarget: 'Move to Target',
            moveTop: 'Move Top',
            moveUp: 'Move Up',
            navigation: 'Navigation',
            next: 'Next',
            nextPageLabel: 'Next Page',
            nullLabel: 'Not Selected',
            pageLabel: 'Page {page}',
            otpLabel: 'Please enter one time password character {0}',
            passwordHide: 'Hide Password',
            passwordShow: 'Show Password',
            previous: 'Previous',
            previousPageLabel: 'Previous Page',
            rotateLeft: 'Rotate Left',
            rotateRight: 'Rotate Right',
            rowsPerPageLabel: 'Rows per page',
            saveEdit: 'Save Edit',
            scrollTop: 'Scroll Top',
            selectAll: 'All items selected',
            selectRow: 'Row Selected',
            showFilterMenu: 'Show Filter Menu',
            slide: 'Slide',
            slideNumber: '{slideNumber}',
            star: '1 star',
            stars: '{star} stars',
            trueLabel: 'True',
            unselectAll: 'All items unselected',
            unselectRow: 'Row Unselected',
            zoomImage: 'Zoom Image',
            zoomIn: 'Zoom In',
            zoomOut: 'Zoom Out'
        }
    }
};
/**
 * Find an ARIA label in the locale by key.  If options are passed it will replace all options:
 * ```ts
 * const ariaValue = "Page {page}, User {user}, Role {role}";
 * const options = { page: 2, user: "John", role: "Admin" };
 * const result = ariaLabel('yourLabel', { page: 2, user: "John", role: "Admin" })
 * console.log(result); // Output: Page 2, User John, Role Admin
 * ```
 * @param {string} ariaKey key of the ARIA label to look up in locale.
 * @param {any} options JSON options like { page: 2, user: "John", role: "Admin" }
 * @returns the ARIA label with replaced values
 */ function $68eba9483912474c$var$ariaLabel(ariaKey, options) {
    if (ariaKey.includes('__proto__') || ariaKey.includes('prototype')) throw new Error('Unsafe ariaKey detected');
    var _locale = $68eba9483912474c$var$PrimeReact.locale;
    try {
        var _ariaLabel = $68eba9483912474c$var$localeOptions(_locale).aria[ariaKey];
        if (_ariaLabel) {
            for(var key in options)if (options.hasOwnProperty(key)) _ariaLabel = _ariaLabel.replace("{".concat(key, "}"), options[key]);
        }
        return _ariaLabel;
    } catch (error) {
        throw new Error("The ".concat(ariaKey, " option is not found in the current locale('").concat(_locale, "')."));
    }
}
function $68eba9483912474c$var$localeOptions(locale) {
    var _locale = locale || $68eba9483912474c$var$PrimeReact.locale;
    if (_locale.includes('__proto__') || _locale.includes('prototype')) throw new Error('Unsafe locale detected');
    return $68eba9483912474c$var$locales[_locale];
}
var $68eba9483912474c$var$styles = '';
var $68eba9483912474c$var$FocusTrapBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'FocusTrap',
        children: undefined
    },
    css: {
        styles: $68eba9483912474c$var$styles
    },
    getProps: function getProps(props) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getMergedProps(props, $68eba9483912474c$var$FocusTrapBase.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).getDiffProps(props, $68eba9483912474c$var$FocusTrapBase.defaultProps);
    }
});
function $68eba9483912474c$var$ownKeys$5(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68eba9483912474c$var$_objectSpread$5(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68eba9483912474c$var$ownKeys$5(Object(t), !0).forEach(function(r) {
            $68eba9483912474c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68eba9483912474c$var$ownKeys$5(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $68eba9483912474c$var$FocusTrap = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(inProps, ref) {
    var targetRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    var firstFocusableElementRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    var lastFocusableElementRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    var context = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $68eba9483912474c$var$FocusTrapBase.getProps(inProps, context);
    var metaData = {
        props: props
    };
    (0, $fbdf1e36fa0a01d8$export$72c85e333541e7f)($68eba9483912474c$var$FocusTrapBase.css.styles, {
        name: 'focustrap'
    });
    var _FocusTrapBase$setMet = $68eba9483912474c$var$FocusTrapBase.setMetaData($68eba9483912474c$var$_objectSpread$5({}, metaData));
    _FocusTrapBase$setMet.ptm;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, function() {
        return {
            props: props,
            getInk: function getInk() {
                return firstFocusableElementRef.current;
            },
            getTarget: function getTarget() {
                return targetRef.current;
            }
        };
    });
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        if (!props.disabled) {
            targetRef.current = getTarget();
            setAutoFocus(targetRef.current);
        }
    });
    var getTarget = function getTarget() {
        return firstFocusableElementRef.current && firstFocusableElementRef.current.parentElement;
    };
    /**
   * This method sets the auto focus on the first focusable element within the target element.
   * It first tries to find a focusable element using the autoFocusSelector. If no such element is found,
   * it then tries to find a focusable element using the firstFocusableSelector.
   * If the autoFocus prop is set to true and a focusable element is found, it sets the focus on that element.
   *
   * @param {HTMLElement} target - The target element within which to find a focusable element.
   */ var setAutoFocus = function setAutoFocus(target) {
        var _ref = props || {}, _ref$autoFocusSelecto = _ref.autoFocusSelector, autoFocusSelector = _ref$autoFocusSelecto === void 0 ? '' : _ref$autoFocusSelecto, _ref$firstFocusableSe = _ref.firstFocusableSelector, firstFocusableSelector = _ref$firstFocusableSe === void 0 ? '' : _ref$firstFocusableSe, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus;
        var defaultAutoFocusSelector = "".concat(getComputedSelector(autoFocusSelector));
        var computedAutoFocusSelector = "[autofocus]".concat(defaultAutoFocusSelector, ", [data-pc-autofocus='true']").concat(defaultAutoFocusSelector);
        var focusableElement = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getFirstFocusableElement(target, computedAutoFocusSelector);
        autoFocus && !focusableElement && (focusableElement = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getFirstFocusableElement(target, getComputedSelector(firstFocusableSelector)));
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(focusableElement);
    };
    var getComputedSelector = function getComputedSelector(selector) {
        return ":not(.p-hidden-focusable):not([data-p-hidden-focusable=\"true\"])".concat(selector !== null && selector !== void 0 ? selector : '');
    };
    var onFirstHiddenElementFocus = function onFirstHiddenElementFocus(event) {
        var _targetRef$current;
        var currentTarget = event.currentTarget, relatedTarget = event.relatedTarget;
        var focusableElement = relatedTarget === currentTarget.$_pfocustrap_lasthiddenfocusableelement || !((_targetRef$current = targetRef.current) !== null && _targetRef$current !== void 0 && _targetRef$current.contains(relatedTarget)) ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getFirstFocusableElement(currentTarget.parentElement, getComputedSelector(currentTarget.$_pfocustrap_focusableselector)) : currentTarget.$_pfocustrap_lasthiddenfocusableelement;
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(focusableElement);
    };
    var onLastHiddenElementFocus = function onLastHiddenElementFocus(event) {
        var _targetRef$current2;
        var currentTarget = event.currentTarget, relatedTarget = event.relatedTarget;
        var focusableElement = relatedTarget === currentTarget.$_pfocustrap_firsthiddenfocusableelement || !((_targetRef$current2 = targetRef.current) !== null && _targetRef$current2 !== void 0 && _targetRef$current2.contains(relatedTarget)) ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getLastFocusableElement(currentTarget.parentElement, getComputedSelector(currentTarget.$_pfocustrap_focusableselector)) : currentTarget.$_pfocustrap_firsthiddenfocusableelement;
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(focusableElement);
    };
    var createHiddenFocusableElements = function createHiddenFocusableElements() {
        var _ref2 = props || {}, _ref2$tabIndex = _ref2.tabIndex, tabIndex = _ref2$tabIndex === void 0 ? 0 : _ref2$tabIndex;
        var createFocusableElement = function createFocusableElement(onFocus, section) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                ref: section === 'firstfocusableelement' ? firstFocusableElementRef : lastFocusableElementRef,
                className: 'p-hidden-accessible p-hidden-focusable',
                tabIndex: tabIndex,
                role: 'presentation',
                "aria-hidden": true,
                "data-p-hidden-accessible": true,
                "data-p-hidden-focusable": true,
                onFocus: onFocus,
                "data-pc-section": section
            });
        };
        var firstFocusableElement = createFocusableElement(onFirstHiddenElementFocus, 'firstfocusableelement');
        var lastFocusableElement = createFocusableElement(onLastHiddenElementFocus, 'lastfocusableelement');
        if (firstFocusableElement.ref.current && lastFocusableElement.ref.current) {
            firstFocusableElement.ref.current.$_pfocustrap_lasthiddenfocusableelement = lastFocusableElement.ref.current;
            lastFocusableElement.ref.current.$_pfocustrap_firsthiddenfocusableelement = firstFocusableElement.ref.current;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, firstFocusableElement, props.children, lastFocusableElement);
    };
    return createHiddenFocusableElements();
}));
var $68eba9483912474c$var$FocusTrap$1 = $68eba9483912474c$var$FocusTrap;
function $68eba9483912474c$var$ownKeys$4(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68eba9483912474c$var$_objectSpread$4(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68eba9483912474c$var$ownKeys$4(Object(t), !0).forEach(function(r) {
            $68eba9483912474c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68eba9483912474c$var$ownKeys$4(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $68eba9483912474c$var$ColumnFilter = /*#__PURE__*/ $acw62.memo(function(props) {
    var _React$useState = $acw62.useState(false), _React$useState2 = $68eba9483912474c$var$_slicedToArray(_React$useState, 2), overlayVisibleState = _React$useState2[0], setOverlayVisibleState = _React$useState2[1];
    var overlayRef = $acw62.useRef(null);
    var overlayId = $acw62.useRef(null);
    var iconRef = $acw62.useRef(null);
    var selfClick = $acw62.useRef(false);
    var overlayEventListener = $acw62.useRef(null);
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var getColumnProp = function getColumnProp(name) {
        return $68eba9483912474c$var$ColumnBase.getCProp(props.column, name);
    };
    var getColumnProps = function getColumnProps() {
        return $68eba9483912474c$var$ColumnBase.getCProps(props.column);
    };
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx;
    var getColumnPTOptions = function getColumnPTOptions(key, params) {
        var cProps = getColumnProps();
        var columnMetadata = $68eba9483912474c$var$_objectSpread$4({
            props: cProps,
            parent: props.metaData,
            hostName: props.hostName,
            state: {
                overlayVisible: overlayVisibleState
            }
        }, params);
        return mergeProps(ptm("column.".concat(key), {
            column: columnMetadata
        }), ptm("column.".concat(key), columnMetadata), ptmo(cProps, key, columnMetadata));
    };
    var field = getColumnProp('filterField') || getColumnProp('field');
    var filterModel = props.filters[field];
    var filterStoreModel = props.filtersStore && props.filtersStore[field];
    var _useOverlayListener = (0, $fbdf1e36fa0a01d8$export$2fef17345d27a5b4)({
        target: iconRef,
        overlay: overlayRef,
        listener: function listener(event, _ref) {
            var type = _ref.type, valid = _ref.valid;
            if (valid) type === 'outside' ? !selfClick.current && !isTargetClicked(event.target) && hide() : hide();
            selfClick.current = false;
        },
        when: overlayVisibleState
    }), _useOverlayListener2 = $68eba9483912474c$var$_slicedToArray(_useOverlayListener, 2), bindOverlayListener = _useOverlayListener2[0], unbindOverlayListener = _useOverlayListener2[1];
    var hasFilter = function hasFilter() {
        if (!filterStoreModel || !filterModel) return false;
        return filterStoreModel.operator ? !isFilterBlank(filterModel.constraints[0].value) : !isFilterBlank(filterModel.value);
    };
    var hasRowFilter = function hasRowFilter() {
        return filterModel && !isFilterBlank(filterModel.value);
    };
    var isFilterBlank = function isFilterBlank(filter) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).isEmpty(filter);
    };
    var isRowMatchModeSelected = function isRowMatchModeSelected(matchMode) {
        return filterModel && filterModel.matchMode === matchMode;
    };
    var matchModes = function matchModes() {
        return getColumnProp('filterMatchModeOptions') || context && context.filterMatchModeOptions[findDataType()].map(function(key) {
            return {
                label: (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)(key),
                value: key
            };
        }) || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).filterMatchModeOptions[findDataType()].map(function(key) {
            return {
                label: (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)(key),
                value: key
            };
        });
    };
    var isShowMenuButton = function isShowMenuButton() {
        return getColumnProp('showFilterMenu') && (props.display === 'row' ? getColumnProp('dataType') !== 'boolean' : true);
    };
    var isShowClearButton = function isShowClearButton() {
        return getColumnProp('showClearButton') && props.display === 'row';
    };
    var isShowMatchModes = function isShowMatchModes() {
        return getColumnProp('dataType') !== 'boolean' && getColumnProp('showFilterMatchModes') && matchModes() && getColumnProp('showFilterMenuOptions');
    };
    var isShowOperator = function isShowOperator() {
        return getColumnProp('showFilterOperator') && filterModel && filterModel.operator && getColumnProp('showFilterMenuOptions');
    };
    var showRemoveIcon = function showRemoveIcon() {
        return fieldConstraints().length > 1;
    };
    var isShowAddConstraint = function isShowAddConstraint() {
        return getColumnProp('showAddButton') && filterModel && filterModel.operator && fieldConstraints() && fieldConstraints().length < getColumnProp('maxConstraints') && getColumnProp('showFilterMenuOptions');
    };
    var isOutsideClicked = function isOutsideClicked(target) {
        return !isTargetClicked(target) && overlayRef.current && !(overlayRef.current.isSameNode(target) || overlayRef.current.contains(target));
    };
    var isTargetClicked = function isTargetClicked(target) {
        return iconRef.current && (iconRef.current.isSameNode(target) || iconRef.current.contains(target));
    };
    var getDefaultConstraint = function getDefaultConstraint() {
        if (filterStoreModel) {
            if (filterStoreModel.operator) return {
                matchMode: filterStoreModel.constraints[0].matchMode,
                operator: filterStoreModel.operator
            };
            return {
                matchMode: filterStoreModel.matchMode
            };
        }
    };
    var findDataType = function findDataType() {
        var dataType = getColumnProp('dataType');
        var matchMode = getColumnProp('filterMatchMode');
        var hasMatchMode = function hasMatchMode(key) {
            return context && context.filterMatchModeOptions[key].some(function(mode) {
                return mode === matchMode;
            }) || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).filterMatchModeOptions[key].some(function(mode) {
                return mode === matchMode;
            });
        };
        if (matchMode === 'custom' && !hasMatchMode(dataType)) {
            context && context.filterMatchModeOptions[dataType].push((0, $51b25b42ecc1a0c7$export$b9fbdf9129f67822).CUSTOM) || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).filterMatchModeOptions[dataType].push((0, $51b25b42ecc1a0c7$export$b9fbdf9129f67822).CUSTOM);
            return dataType;
        } else if (matchMode) return Object.keys(context && context.filterMatchModeOptions || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).filterMatchModeOptions).find(function(key) {
            return hasMatchMode(key);
        }) || dataType;
        return dataType;
    };
    var clearFilter = function clearFilter() {
        var filterClearCallback = getColumnProp('onFilterClear');
        var defaultConstraint = getDefaultConstraint();
        var filters = $68eba9483912474c$var$_objectSpread$4({}, props.filters);
        if (filters[field].operator) {
            filters[field].constraints.splice(1);
            filters[field].operator = defaultConstraint.operator;
            filters[field].constraints[0] = {
                value: null,
                matchMode: defaultConstraint.matchMode
            };
        } else {
            filters[field].value = null;
            filters[field].matchMode = defaultConstraint.matchMode;
        }
        filterClearCallback && filterClearCallback();
        props.onFilterChange(filters);
        props.onFilterApply();
        hide();
    };
    var applyFilter = function applyFilter() {
        var filterApplyClickCallback = getColumnProp('onFilterApplyClick');
        filterApplyClickCallback && filterApplyClickCallback({
            field: field,
            constraints: filterModel
        });
        props.onFilterApply();
        hide();
    };
    var toggleMenu = function toggleMenu() {
        setOverlayVisibleState(function(prevVisible) {
            return !prevVisible;
        });
    };
    var onToggleButtonKeyDown = function onToggleButtonKeyDown(event) {
        switch(event.key){
            case 'Escape':
            case 'Tab':
                hide();
                break;
            case 'ArrowDown':
                if (overlayVisibleState) {
                    var focusable = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getFirstFocusableElement(overlayRef.current);
                    focusable && focusable.focus();
                    event.preventDefault();
                } else if (event.altKey) {
                    setOverlayVisibleState(true);
                    event.preventDefault();
                }
                break;
        }
    };
    var onContentKeyDown = function onContentKeyDown(event) {
        if (event.key === 'Escape') {
            hide();
            iconRef.current && iconRef.current.focus();
        }
    };
    var onInputChange = function onInputChange(event, index) {
        var filters = $68eba9483912474c$var$_objectSpread$4({}, props.filters);
        var value = event.target.value;
        var filterField = filters[field];
        if (props.display === 'menu' && (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(filterField.constraints)) filterField.constraints[index].value = value;
        else filterField.value = value;
        props.onFilterChange(filters);
        if (!getColumnProp('showApplyButton') || props.display === 'row') props.onFilterApply();
    };
    var onInputKeydown = function onInputKeydown(event, _index) {
        if (event.key === 'Enter') {
            if (!getColumnProp('showApplyButton') || props.display === 'menu') applyFilter();
        }
    };
    var onRowMatchModeChange = function onRowMatchModeChange(matchMode) {
        var filterMatchModeChangeCallback = getColumnProp('onFilterMatchModeChange');
        var filters = $68eba9483912474c$var$_objectSpread$4({}, props.filters);
        filters[field].matchMode = matchMode;
        filterMatchModeChangeCallback && filterMatchModeChangeCallback({
            field: field,
            matchMode: matchMode
        });
        props.onFilterChange(filters);
        props.onFilterApply();
        hide();
    };
    var onRowMatchModeKeyDown = function onRowMatchModeKeyDown(event, matchMode, clear) {
        var item = event.target;
        switch(event.key){
            case 'ArrowDown':
                var nextItem = _findNextItem(item);
                if (nextItem) {
                    item.removeAttribute('tabindex');
                    nextItem.tabIndex = 0;
                    nextItem.focus();
                }
                event.preventDefault();
                break;
            case 'ArrowUp':
                var prevItem = _findPrevItem(item);
                if (prevItem) {
                    item.removeAttribute('tabindex');
                    prevItem.tabIndex = 0;
                    prevItem.focus();
                }
                event.preventDefault();
                break;
            case 'Enter':
                clear ? clearFilter() : onRowMatchModeChange(matchMode.value);
                event.preventDefault();
                break;
        }
    };
    var onOperatorChange = function onOperatorChange(e) {
        var filterOperationChangeCallback = getColumnProp('onFilterOperatorChange');
        var value = e.value;
        var filters = $68eba9483912474c$var$_objectSpread$4({}, props.filters);
        filters[field].operator = value;
        props.onFilterChange(filters);
        filterOperationChangeCallback && filterOperationChangeCallback({
            field: field,
            operator: value
        });
        if (!getColumnProp('showApplyButton')) props.onFilterApply();
    };
    var onMenuMatchModeChange = function onMenuMatchModeChange(value, index) {
        var filterMatchModeChangeCallback = getColumnProp('onFilterMatchModeChange');
        var filters = $68eba9483912474c$var$_objectSpread$4({}, props.filters);
        var filterField = filters[field];
        if (props.display === 'menu' && (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(filterField.constraints)) filterField.constraints[index].matchMode = value;
        else filterField.matchMode = value;
        props.onFilterChange(filters);
        filterMatchModeChangeCallback && filterMatchModeChangeCallback({
            field: field,
            matchMode: value,
            index: index
        });
        if (!getColumnProp('showApplyButton')) props.onFilterApply();
    };
    var addConstraint = function addConstraint() {
        var filterConstraintAddCallback = getColumnProp('onFilterConstraintAdd');
        var defaultConstraint = getDefaultConstraint();
        var filters = $68eba9483912474c$var$_objectSpread$4({}, props.filters);
        var newConstraint = {
            value: null,
            matchMode: defaultConstraint.matchMode
        };
        filters[field].constraints.push(newConstraint);
        filterConstraintAddCallback && filterConstraintAddCallback({
            field: field,
            constraint: newConstraint
        });
        props.onFilterChange(filters);
        if (!getColumnProp('showApplyButton')) props.onFilterApply();
    };
    var removeConstraint = function removeConstraint(index) {
        var filterConstraintRemoveCallback = getColumnProp('onFilterConstraintRemove');
        var filters = $68eba9483912474c$var$_objectSpread$4({}, props.filters);
        var removedConstraint = filters[field].constraints.splice(index, 1);
        filterConstraintRemoveCallback && filterConstraintRemoveCallback({
            field: field,
            constraint: removedConstraint
        });
        props.onFilterChange(filters);
        if (!getColumnProp('showApplyButton')) props.onFilterApply();
    };
    var _findNextItem = function findNextItem(item) {
        var nextItem = item.nextElementSibling;
        return nextItem ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(nextItem, 'data-p-column-filter-separator') === true ? _findNextItem(nextItem) : nextItem : item.parentElement.firstElementChild;
    };
    var _findPrevItem = function findPrevItem(item) {
        var prevItem = item.previousElementSibling;
        return prevItem ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(prevItem, 'data-p-column-filter-separator') === true ? _findPrevItem(prevItem) : prevItem : item.parentElement.lastElementChild;
    };
    var hide = function hide() {
        setOverlayVisibleState(false);
    };
    var onContentClick = function onContentClick(event) {
        selfClick.current = true;
        (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).emit('overlay-click', {
            originalEvent: event,
            target: overlayRef.current
        });
    };
    var onContentMouseDown = function onContentMouseDown() {
        selfClick.current = true;
    };
    var onOverlayEnter = function onOverlayEnter() {
        (0, $a73ce425265b079e$export$832931caede8e4b9).set('overlay', overlayRef.current, context && context.autoZIndex || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).autoZIndex, context && context.zIndex.overlay || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).zIndex.overlay);
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).addStyles(overlayRef.current, {
            position: 'absolute',
            top: '0',
            left: '0'
        });
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).alignOverlay(overlayRef.current, iconRef.current, context && context.appendTo || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).appendTo, false);
        overlayEventListener.current = function(e) {
            if (!isOutsideClicked(e.target)) selfClick.current = true;
        };
        (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).on('overlay-click', overlayEventListener.current);
    };
    var onOverlayEntered = function onOverlayEntered() {
        bindOverlayListener();
    };
    var onOverlayExit = function onOverlayExit() {
        onOverlayHide();
    };
    var onOverlayExited = function onOverlayExited() {
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(overlayRef.current);
    };
    var onOverlayHide = function onOverlayHide() {
        unbindOverlayListener();
        (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).off('overlay-click', overlayEventListener.current);
        overlayEventListener.current = null;
        selfClick.current = false;
    };
    var fieldConstraints = function fieldConstraints() {
        return filterModel ? filterModel.constraints || [
            filterModel
        ] : [];
    };
    var operator = function operator() {
        return filterModel.operator;
    };
    var operatorOptions = function operatorOptions() {
        return [
            {
                label: (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('matchAll'),
                value: (0, $51b25b42ecc1a0c7$export$9cc7a9d8d8c733ca).AND
            },
            {
                label: (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('matchAny'),
                value: (0, $51b25b42ecc1a0c7$export$9cc7a9d8d8c733ca).OR
            }
        ];
    };
    var noFilterLabel = function noFilterLabel() {
        return (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('noFilter');
    };
    var removeRuleButtonLabel = function removeRuleButtonLabel() {
        return (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('removeRule');
    };
    var addRuleButtonLabel = function addRuleButtonLabel() {
        return (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('addRule');
    };
    var clearButtonLabel = function clearButtonLabel() {
        return (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('clear');
    };
    var applyButtonLabel = function applyButtonLabel() {
        return (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('apply');
    };
    var filterCallback = function filterCallback(value) {
        var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var filters = $68eba9483912474c$var$_objectSpread$4({}, props.filters);
        var meta = filters[field];
        props.display === 'menu' && meta && meta.operator ? filters[field].constraints[index].value = value : filters[field].value = value;
        props.onFilterChange(filters);
    };
    var filterApplyCallback = function filterApplyCallback() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        args && filterCallback(args[0], args[1]);
        props.onFilterApply();
    };
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (props.display === 'menu' && overlayVisibleState) (0, $a73ce425265b079e$export$ff8ccbac9225de62).alignOverlay(overlayRef.current, iconRef.current, context && context.appendTo || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).appendTo, false);
    });
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        if (!overlayId.current) overlayId.current = (0, $a73ce425265b079e$export$d5d9b89141473caf)();
    });
    (0, $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96)(function() {
        if (overlayEventListener.current) {
            (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).off('overlay-click', overlayEventListener.current);
            overlayEventListener.current = null;
        }
        if (overlayRef.current) {
            (0, $a73ce425265b079e$export$832931caede8e4b9).clear(overlayRef.current);
            onOverlayHide();
        }
    });
    var createFilterElement = function createFilterElement(model, index) {
        var value = model ? model.value : null;
        return getColumnProp('filterElement') ? (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(getColumnProp('filterElement'), {
            field: field,
            index: index,
            filterModel: model,
            value: value,
            filterApplyCallback: filterApplyCallback,
            filterCallback: filterCallback
        }) : /*#__PURE__*/ $acw62.createElement((0, $ab1a721814a59df6$export$7034fcb7d6351061), {
            type: getColumnProp('filterType'),
            value: value || '',
            onChange: function onChange(e) {
                return onInputChange(e, index);
            },
            onKeyDown: function onKeyDown(e) {
                return onInputKeydown(e);
            },
            className: "p-column-filter",
            placeholder: getColumnProp('filterPlaceholder'),
            maxLength: getColumnProp('filterMaxLength'),
            "aria-label": getColumnProp('filterPlaceholder'),
            unstyled: props.unstyled,
            __parentMetadata: {
                parent: props.metaData
            }
        });
    };
    var createRowFilterElement = function createRowFilterElement() {
        if (props.display === 'row') {
            var content = createFilterElement(filterModel, 0);
            var filterInputProps = mergeProps({
                className: cx('filterInput')
            }, getColumnPTOptions('filterInput'));
            return /*#__PURE__*/ $acw62.createElement("div", filterInputProps, content);
        }
        return null;
    };
    var createMenuFilterElement = function createMenuFilterElement(fieldConstraint, index) {
        return props.display === 'menu' ? createFilterElement(fieldConstraint, index) : null;
    };
    var createMenuButton = function createMenuButton() {
        if (!isShowMenuButton()) return null;
        var filterIconProps = mergeProps({
            'aria-hidden': true
        }, getColumnPTOptions('filterIcon'));
        var icon = props.filterIcon || /*#__PURE__*/ $acw62.createElement((0, $dd6dc61de5d4086e$export$28f6150e232898de), filterIconProps);
        var columnFilterIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $68eba9483912474c$var$_objectSpread$4({}, filterIconProps), {
            props: props
        });
        var label = overlayVisibleState ? $68eba9483912474c$var$ariaLabel('hideFilterMenu') : $68eba9483912474c$var$ariaLabel('showFilterMenu');
        var filterMenuButtonProps = mergeProps({
            type: 'button',
            className: cx('filterMenuButton', {
                overlayVisibleState: overlayVisibleState,
                hasFilter: hasFilter
            }),
            'aria-haspopup': true,
            'aria-expanded': overlayVisibleState,
            'aria-label': label,
            'aria-controls': overlayVisibleState ? overlayId.current : undefined,
            onClick: function onClick(e) {
                return toggleMenu();
            },
            onKeyDown: function onKeyDown(e) {
                return onToggleButtonKeyDown(e);
            }
        }, getColumnPTOptions('filterMenuButton', {
            context: {
                active: hasFilter()
            }
        }));
        return /*#__PURE__*/ $acw62.createElement("button", $68eba9483912474c$var$_extends({
            ref: iconRef
        }, filterMenuButtonProps), columnFilterIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
    };
    var createClearButton = function createClearButton() {
        if (!isShowClearButton()) return null;
        var filterClearIconProps = mergeProps({
            'aria-hidden': true
        }, getColumnPTOptions('filterClearIcon'));
        var icon = props.filterClearIcon || /*#__PURE__*/ $acw62.createElement((0, $a8c157e014b5b4d0$export$8bb975439d7d7e7c), filterClearIconProps);
        var filterClearIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $68eba9483912474c$var$_objectSpread$4({}, filterClearIconProps), {
            props: props
        });
        var clearLabel = clearButtonLabel();
        var headerFilterClearButtonProps = mergeProps({
            className: cx('headerFilterClearButton', {
                hasRowFilter: hasRowFilter
            }),
            type: 'button',
            onClick: function onClick(e) {
                return clearFilter();
            },
            'aria-label': clearLabel
        }, getColumnPTOptions('headerFilterClearButton', {
            context: {
                hidden: hasRowFilter()
            }
        }));
        return /*#__PURE__*/ $acw62.createElement("button", headerFilterClearButtonProps, filterClearIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
    };
    var createRowItems = function createRowItems() {
        if (isShowMatchModes()) {
            var _matchModes = matchModes();
            var _noFilterLabel = noFilterLabel();
            var filterSeparatorProps = mergeProps({
                className: cx('filterSeparator'),
                'data-p-column-filter-separator': true
            }, getColumnPTOptions('filterSeparator'));
            var filterRowItemProps = mergeProps({
                className: cx('filterRowItem', {
                    isRowMatchModeSelected: isRowMatchModeSelected,
                    isShowMatchModes: isShowMatchModes
                }),
                onClick: function onClick(e) {
                    return clearFilter();
                },
                onKeyDown: function onKeyDown(e) {
                    return onRowMatchModeKeyDown(e, null, true);
                }
            }, getColumnPTOptions('filterRowItem'));
            var filterRowItemsProps = mergeProps({
                className: cx('filterRowItems')
            }, getColumnPTOptions('filterRowItems'));
            return /*#__PURE__*/ $acw62.createElement("ul", filterRowItemsProps, _matchModes.map(function(matchMode, i) {
                var value = matchMode.value, label = matchMode.label;
                var tabIndex = i === 0 ? 0 : null;
                var filterRowItemProps = mergeProps({
                    className: cx('filterRowItem', {
                        isRowMatchModeSelected: isRowMatchModeSelected,
                        isShowMatchModes: isShowMatchModes,
                        value: value
                    }),
                    onClick: function onClick() {
                        return onRowMatchModeChange(value);
                    },
                    onKeyDown: function onKeyDown(e) {
                        return onRowMatchModeKeyDown(e, matchMode);
                    },
                    tabIndex: tabIndex
                }, getColumnPTOptions('filterRowItem', {
                    context: {
                        highlighted: matchMode && isRowMatchModeSelected(value)
                    }
                }));
                return /*#__PURE__*/ $acw62.createElement("li", $68eba9483912474c$var$_extends({}, filterRowItemProps, {
                    key: label
                }), label);
            }), /*#__PURE__*/ $acw62.createElement("li", filterSeparatorProps), /*#__PURE__*/ $acw62.createElement("li", filterRowItemProps, _noFilterLabel));
        }
        return null;
    };
    var createOperator = function createOperator() {
        if (isShowOperator()) {
            var options = operatorOptions();
            var value = operator();
            var filterOperatorProps = mergeProps({
                className: cx('filterOperator')
            }, getColumnPTOptions('filterOperator'));
            return /*#__PURE__*/ $acw62.createElement("div", filterOperatorProps, /*#__PURE__*/ $acw62.createElement((0, $ad3650ac53d907a7$export$931cbfb6bfb85fc), {
                options: options,
                value: value,
                onChange: onOperatorChange,
                className: "p-column-filter-operator-dropdown",
                pt: getColumnPTOptions('filterOperatorDropdown'),
                unstyled: props.unstyled,
                __parentMetadata: {
                    parent: props.metaData
                },
                "aria-label": $68eba9483912474c$var$ariaLabel('filterOperator')
            }));
        }
        return null;
    };
    var createMatchModeDropdown = function createMatchModeDropdown(constraint, index) {
        if (isShowMatchModes()) {
            var options = matchModes();
            return /*#__PURE__*/ $acw62.createElement((0, $ad3650ac53d907a7$export$931cbfb6bfb85fc), {
                options: options,
                value: constraint.matchMode,
                onChange: function onChange(e) {
                    return onMenuMatchModeChange(e.value, index);
                },
                className: "p-column-filter-matchmode-dropdown",
                pt: getColumnPTOptions('filterMatchModeDropdown'),
                unstyled: props.unstyled,
                __parentMetadata: {
                    parent: props.metaData
                },
                "aria-label": $68eba9483912474c$var$ariaLabel('filterConstraint')
            });
        }
        return null;
    };
    var createRemoveButton = function createRemoveButton(index) {
        if (showRemoveIcon()) {
            var removeRuleLabel = removeRuleButtonLabel();
            return /*#__PURE__*/ $acw62.createElement((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                type: "button",
                icon: props.filterRemoveIcon || /*#__PURE__*/ $acw62.createElement((0, $9e4e4fe49a7215c8$export$d23329de703dffc4), null),
                className: "p-column-filter-remove-button p-button-text p-button-danger p-button-sm",
                onClick: function onClick() {
                    return removeConstraint(index);
                },
                label: removeRuleLabel,
                pt: getColumnPTOptions('filterRemoveButton'),
                unstyled: props.unstyled,
                __parentMetadata: {
                    parent: props.metaData
                }
            });
        }
        return null;
    };
    var createConstraints = function createConstraints() {
        var _fieldConstraints = fieldConstraints();
        var filterConstraintsProps = mergeProps({
            className: cx('filterConstraints')
        }, getColumnPTOptions('filterConstraints'));
        var filterConstraintProps = mergeProps({
            className: cx('filterConstraint')
        }, getColumnPTOptions('filterConstraint'));
        return /*#__PURE__*/ $acw62.createElement("div", filterConstraintsProps, _fieldConstraints.map(function(fieldConstraint, i) {
            var matchModeDropdown = createMatchModeDropdown(fieldConstraint, i);
            var menuFilterElement = createMenuFilterElement(fieldConstraint, i);
            var removeButton = createRemoveButton(i);
            var filterRemoveProps = mergeProps(getColumnPTOptions('filterRemove'));
            return /*#__PURE__*/ $acw62.createElement("div", $68eba9483912474c$var$_extends({}, filterConstraintProps, {
                key: i
            }), matchModeDropdown, menuFilterElement, /*#__PURE__*/ $acw62.createElement("div", filterRemoveProps, removeButton));
        }));
    };
    var createAddRule = function createAddRule() {
        if (isShowAddConstraint()) {
            var addRuleLabel = addRuleButtonLabel();
            var filterAddRuleProps = mergeProps({
                className: cx('filterAddRule')
            }, getColumnPTOptions('filterAddRule'));
            return /*#__PURE__*/ $acw62.createElement("div", filterAddRuleProps, /*#__PURE__*/ $acw62.createElement((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                type: "button",
                label: addRuleLabel,
                icon: props.filterAddIcon || /*#__PURE__*/ $acw62.createElement((0, $4e8ee92851268d00$export$f21ab0717a89c77f), null),
                className: "p-column-filter-add-button p-button-text p-button-sm",
                onClick: addConstraint,
                pt: getColumnPTOptions('filterAddRuleButton'),
                unstyled: props.unstyled,
                __parentMetadata: {
                    parent: props.metaData
                }
            }));
        }
        return null;
    };
    var createFilterClearButton = function createFilterClearButton() {
        if (getColumnProp('showClearButton')) {
            if (!getColumnProp('filterClear')) {
                var clearLabel = clearButtonLabel();
                return /*#__PURE__*/ $acw62.createElement((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                    type: "button",
                    outlined: true,
                    size: "small",
                    onClick: clearFilter,
                    label: clearLabel,
                    pt: getColumnPTOptions('filterClearButton'),
                    unstyled: props.unstyled,
                    __parentMetadata: {
                        parent: props.metaData
                    }
                });
            }
            return (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(getColumnProp('filterClear'), {
                field: field,
                filterModel: filterModel,
                filterClearCallback: clearFilter
            });
        }
        return null;
    };
    var createFilterApplyButton = function createFilterApplyButton() {
        if (getColumnProp('showApplyButton')) {
            if (!getColumnProp('filterApply')) {
                var applyLabel = applyButtonLabel();
                return /*#__PURE__*/ $acw62.createElement((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                    type: "button",
                    size: "small",
                    onClick: applyFilter,
                    label: applyLabel,
                    pt: getColumnPTOptions('filterApplyButton'),
                    unstyled: props.unstyled,
                    __parentMetadata: {
                        parent: props.metaData
                    }
                });
            }
            return (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(getColumnProp('filterApply'), {
                field: field,
                filterModel: filterModel,
                filterApplyCallback: applyFilter
            });
        }
        return null;
    };
    var createButtonBar = function createButtonBar() {
        var clearButton = createFilterClearButton();
        var applyButton = createFilterApplyButton();
        var filterButtonbarProps = mergeProps({
            className: cx('filterButtonBar')
        }, getColumnPTOptions('filterButtonBar'));
        return /*#__PURE__*/ $acw62.createElement("div", filterButtonbarProps, clearButton, applyButton);
    };
    var createItems = function createItems() {
        var operator = createOperator();
        var constraints = createConstraints();
        var addRule = createAddRule();
        var buttonBar = createButtonBar();
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, operator, constraints, addRule, buttonBar);
    };
    var createOverlay = function createOverlay() {
        var style = getColumnProp('filterMenuStyle');
        var filterHeader = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(getColumnProp('filterHeader'), {
            field: field,
            filterModel: filterModel,
            filterApplyCallback: filterApplyCallback
        });
        var filterFooter = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(getColumnProp('filterFooter'), {
            field: field,
            filterModel: filterModel,
            filterApplyCallback: filterApplyCallback
        });
        var items = props.display === 'row' ? createRowItems() : createItems();
        var filterOverlayProps = mergeProps({
            style: style,
            className: cx('filterOverlay', {
                columnFilterProps: props,
                context: context,
                getColumnProp: getColumnProp
            }),
            onKeyDown: function onKeyDown(e) {
                return onContentKeyDown(e);
            },
            onClick: function onClick(e) {
                return onContentClick(e);
            },
            onMouseDown: function onMouseDown(e) {
                return onContentMouseDown();
            },
            id: overlayId.current,
            'aria-modal': overlayVisibleState,
            role: 'dialog'
        }, getColumnPTOptions('filterOverlay'));
        var transitionProps = mergeProps({
            classNames: cx('transition'),
            "in": overlayVisibleState,
            timeout: {
                enter: 120,
                exit: 100
            },
            unmountOnExit: true,
            onEnter: onOverlayEnter,
            onEntered: onOverlayEntered,
            onExit: onOverlayExit,
            onExited: onOverlayExited
        }, getColumnPTOptions('transition'));
        return /*#__PURE__*/ $acw62.createElement((0, $e7a3b5428092a192$export$602eac185826482c), null, /*#__PURE__*/ $acw62.createElement((0, $17afce1b96f6eaec$export$a7a5590ad6d7af0), $68eba9483912474c$var$_extends({
            nodeRef: overlayRef
        }, transitionProps), /*#__PURE__*/ $acw62.createElement("div", $68eba9483912474c$var$_extends({
            ref: overlayRef
        }, filterOverlayProps), /*#__PURE__*/ $acw62.createElement($68eba9483912474c$var$FocusTrap$1, {
            autoFocus: true
        }, filterHeader, items, filterFooter))));
    };
    var rowFilterElement = createRowFilterElement();
    var menuButton = createMenuButton();
    var clearButton = createClearButton();
    var overlay = createOverlay();
    var columnFilter = mergeProps({
        className: cx('columnFilter', {
            columnFilterProps: props
        })
    }, getColumnPTOptions('columnFilter'));
    return /*#__PURE__*/ $acw62.createElement("div", columnFilter, rowFilterElement, menuButton, clearButton, overlay);
});
$68eba9483912474c$var$ColumnFilter.displayName = 'ColumnFilter';
function $68eba9483912474c$var$ownKeys$3(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68eba9483912474c$var$_objectSpread$3(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68eba9483912474c$var$ownKeys$3(Object(t), !0).forEach(function(r) {
            $68eba9483912474c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68eba9483912474c$var$ownKeys$3(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $68eba9483912474c$var$HeaderCheckbox = /*#__PURE__*/ $acw62.memo(function(props) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var getColumnProps = function getColumnProps() {
        return $68eba9483912474c$var$ColumnBase.getCProps(props.column);
    };
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx;
    var getColumnPTOptions = function getColumnPTOptions(key) {
        var cProps = getColumnProps();
        var columnMetaData = {
            props: cProps,
            parent: props.metaData,
            hostName: props.hostName,
            state: {},
            context: {
                checked: props.checked,
                disabled: props.disabled
            }
        };
        return mergeProps(ptm("column.".concat(key), {
            column: columnMetaData
        }), ptm("column.".concat(key), columnMetaData), ptmo(cProps, key, columnMetaData));
    };
    var onChange = function onChange(event) {
        if (!props.disabled) props.onChange({
            originalEvent: event,
            checked: !props.checked
        });
    };
    var headerCheckboxIconProps = mergeProps({
        className: cx('checkIcon')
    }, getColumnPTOptions('headerCheckbox.icon'));
    var icon = props.checked ? props.checkIcon || /*#__PURE__*/ $acw62.createElement((0, $ed79679a1c3e60de$export$7dd004358974b05d), headerCheckboxIconProps) : null;
    var checkIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $68eba9483912474c$var$_objectSpread$3({}, headerCheckboxIconProps), {
        props: props
    });
    var tabIndex = props.disabled ? null : 0;
    var headerCheckboxProps = {
        role: 'checkbox',
        'aria-checked': props.checked,
        'aria-label': props.checked ? $68eba9483912474c$var$ariaLabel('selectAll') : $68eba9483912474c$var$ariaLabel('unselectAll'),
        tabIndex: tabIndex,
        onChange: onChange,
        icon: checkIcon,
        checked: props.checked,
        disabled: props.disabled,
        unstyled: props.unstyled,
        pt: getColumnPTOptions('headerCheckbox')
    };
    return /*#__PURE__*/ $acw62.createElement($68eba9483912474c$var$Checkbox, headerCheckboxProps);
});
$68eba9483912474c$var$HeaderCheckbox.displayName = 'HeaderCheckbox';
function $68eba9483912474c$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68eba9483912474c$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68eba9483912474c$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $68eba9483912474c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68eba9483912474c$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $68eba9483912474c$var$HeaderCell = /*#__PURE__*/ $acw62.memo(function(props) {
    var _React$useState = $acw62.useState({}), _React$useState2 = $68eba9483912474c$var$_slicedToArray(_React$useState, 2), styleObjectState = _React$useState2[0], setStyleObjectState = _React$useState2[1];
    var elementRef = $acw62.useRef(null);
    var prevColumn = (0, $fbdf1e36fa0a01d8$export$5cae361ad82dce8b)(props.column);
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var parentMetaData = props.metaData, ptCallbacks = props.ptCallbacks, index = props.index;
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx;
    var params = {
        index: index
    };
    var parentParams = $68eba9483912474c$var$_objectSpread$2($68eba9483912474c$var$_objectSpread$2({}, parentMetaData), params);
    var getColumnProps = function getColumnProps() {
        return $68eba9483912474c$var$ColumnBase.getCProps(props.column);
    };
    var getColumnPTOptions = function getColumnPTOptions(key) {
        var cProps = getColumnProps();
        var columnMetaData = {
            props: cProps,
            parent: parentParams,
            hostName: props.hostName,
            state: {
                styleObject: styleObjectState
            },
            context: {
                index: props.index,
                sorted: getSortMeta().sorted,
                resizable: props.resizableColumns,
                size: props.metaData.props.size,
                showGridlines: props.metaData.props.showGridlines
            }
        };
        return mergeProps(ptm("column.".concat(key), {
            column: columnMetaData
        }), ptm("column.".concat(key), columnMetaData), ptmo(cProps, key, columnMetaData));
    };
    var isBadgeVisible = function isBadgeVisible() {
        return props.multiSortMeta && props.multiSortMeta.length > 1;
    };
    var isSortableDisabled = function isSortableDisabled() {
        return !getColumnProp('sortable') || getColumnProp('sortable') && (props.allSortableDisabled || getColumnProp('sortableDisabled'));
    };
    var getColumnProp = function getColumnProp() {
        return props.column ? typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string' ? $68eba9483912474c$var$ColumnBase.getCProp(props.column, arguments.length <= 0 ? undefined : arguments[0]) : $68eba9483912474c$var$ColumnBase.getCProp((arguments.length <= 0 ? undefined : arguments[0]) || props.column, arguments.length <= 1 ? undefined : arguments[1]) : null;
    };
    var getStyle = function getStyle() {
        var headerStyle = getColumnProp('headerStyle');
        var columnStyle = getColumnProp('style');
        return getColumnProp('frozen') ? Object.assign({}, columnStyle, headerStyle, styleObjectState) : Object.assign({}, columnStyle, headerStyle);
    };
    var getMultiSortMetaIndex = function getMultiSortMetaIndex() {
        return props.multiSortMeta.findIndex(function(meta) {
            return meta.field === getColumnProp('field') || meta.field === getColumnProp('sortField');
        });
    };
    var getSortMeta = function getSortMeta() {
        var sorted = false;
        var sortOrder = 0;
        var metaIndex = -1;
        if (props.sortMode === 'single') {
            sorted = props.sortField && (props.sortField === getColumnProp('field') || props.sortField === getColumnProp('sortField'));
            sortOrder = sorted ? props.sortOrder : 0;
        } else if (props.sortMode === 'multiple') {
            metaIndex = getMultiSortMetaIndex();
            if (metaIndex > -1) {
                sorted = true;
                sortOrder = props.multiSortMeta[metaIndex].order;
            }
        }
        return {
            sorted: sorted,
            sortOrder: sortOrder,
            metaIndex: metaIndex
        };
    };
    var getAriaSort = function getAriaSort(_ref) {
        var sorted = _ref.sorted, sortOrder = _ref.sortOrder;
        if (getColumnProp('sortable')) {
            if (sorted && sortOrder < 0) return 'descending';
            else if (sorted && sortOrder > 0) return 'ascending';
            return 'none';
        }
        return null;
    };
    var updateStickyPosition = function updateStickyPosition() {
        if (getColumnProp('frozen')) {
            var styleObject = $68eba9483912474c$var$_objectSpread$2({}, styleObjectState);
            var align = getColumnProp('alignFrozen');
            if (align === 'right') {
                var right = 0;
                var next = elementRef.current.nextElementSibling;
                if (next && next.classList.contains('p-frozen-column')) right = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(next) + parseFloat(next.style.right || 0);
                styleObject.right = right + 'px';
            } else {
                var left = 0;
                var prev = elementRef.current.previousElementSibling;
                if (prev && prev.classList.contains('p-frozen-column')) left = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(prev) + parseFloat(prev.style.left || 0);
                styleObject.left = left + 'px';
            }
            var filterRow = elementRef.current.parentElement.nextElementSibling;
            if (filterRow) {
                var _index = (0, $a73ce425265b079e$export$ff8ccbac9225de62).index(elementRef.current);
                filterRow.children[_index].style.left = styleObject.left;
                filterRow.children[_index].style.right = styleObject.right;
            }
            var isSameStyle = styleObjectState.left === styleObject.left && styleObjectState.right === styleObject.right;
            !isSameStyle && setStyleObjectState(styleObject);
        }
    };
    var updateSortableDisabled = function updateSortableDisabled(prevColumn) {
        if (getColumnProp(prevColumn, 'sortableDisabled') !== getColumnProp('sortableDisabled') || getColumnProp(prevColumn, 'sortable') !== getColumnProp('sortable')) props.onSortableChange();
    };
    var _onClick = function onClick(event) {
        if (!isSortableDisabled()) {
            var targetNode = event.target;
            if ((0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(targetNode, 'data-p-sortable-column') === true || (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(targetNode, 'data-pc-section') === 'headertitle' || (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(targetNode, 'data-pc-section') === 'headercontent' || (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(targetNode, 'data-pc-section') === 'sortIcon' || (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(targetNode.parentElement, 'data-pc-section') === 'sortIcon' || targetNode.closest('[data-p-sortable-column="true"]') && !targetNode.closest('[data-pc-section="filtermenubutton"]')) {
                (0, $a73ce425265b079e$export$ff8ccbac9225de62).clearSelection();
                props.onSortChange({
                    originalEvent: event,
                    column: props.column,
                    sortableDisabledFields: props.sortableDisabledFields
                });
            }
        }
    };
    var _onMouseDown = function onMouseDown(event) {
        props.onColumnMouseDown({
            originalEvent: event,
            column: props.column
        });
    };
    var _onKeyDown = function onKeyDown(event) {
        if ((event.code == 'Enter' || event.code === 'NumpadEnter' || event.code == 'Space') && event.currentTarget === elementRef.current && (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(event.currentTarget, 'data-p-sortable-column') === true) {
            _onClick(event);
            event.preventDefault();
        }
    };
    var _onDragStart = function onDragStart(event) {
        props.onColumnDragStart({
            originalEvent: event,
            column: props.column
        });
    };
    var _onDragOver = function onDragOver(event) {
        props.onColumnDragOver({
            originalEvent: event,
            column: props.column
        });
    };
    var _onDragLeave = function onDragLeave(event) {
        props.onColumnDragLeave({
            originalEvent: event,
            column: props.column
        });
    };
    var _onDrop = function onDrop(event) {
        props.onColumnDrop({
            originalEvent: event,
            column: props.column
        });
    };
    var onResizeStart = function onResizeStart(event) {
        props.onColumnResizeStart({
            originalEvent: event,
            column: props.column
        });
    };
    var onResizerClick = function onResizerClick(event) {
        if (props.onColumnResizerClick) {
            props.onColumnResizerClick({
                originalEvent: event,
                element: event.currentTarget.parentElement,
                column: props.column
            });
            event.preventDefault();
        }
    };
    var onResizerDoubleClick = function onResizerDoubleClick(event) {
        if (props.onColumnResizerDoubleClick) {
            props.onColumnResizerDoubleClick({
                originalEvent: event,
                element: event.currentTarget.parentElement,
                column: props.column
            });
            event.preventDefault();
        }
    };
    $acw62.useEffect(function() {
        if (getColumnProp('frozen')) updateStickyPosition();
        updateSortableDisabled(prevColumn);
    });
    var createResizer = function createResizer() {
        if (props.resizableColumns && !getColumnProp('frozen')) {
            var columnResizerProps = mergeProps({
                className: cx('columnResizer'),
                onMouseDown: function onMouseDown(e) {
                    return onResizeStart(e);
                },
                onTouchStart: function onTouchStart(e) {
                    return onResizeStart(e);
                },
                onClick: function onClick(e) {
                    return onResizerClick(e);
                },
                onDoubleClick: function onDoubleClick(e) {
                    return onResizerDoubleClick(e);
                }
            }, getColumnPTOptions('columnResizer'));
            return /*#__PURE__*/ $acw62.createElement("span", columnResizerProps);
        }
        return null;
    };
    var createTitle = function createTitle() {
        var title = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(getColumnProp('header'), {
            props: props.tableProps
        });
        var headerTitleProps = mergeProps({
            className: cx('headerTitle')
        }, getColumnPTOptions('headerTitle'));
        return /*#__PURE__*/ $acw62.createElement("span", headerTitleProps, title);
    };
    var createSortIcon = function createSortIcon(_ref2) {
        var sorted = _ref2.sorted, sortOrder = _ref2.sortOrder;
        if (getColumnProp('sortable')) {
            var sortIconProps = mergeProps({
                className: cx('sortIcon')
            }, getColumnPTOptions('sortIcon'));
            var sortProps = mergeProps(getColumnPTOptions('sort'));
            var icon = sorted ? sortOrder < 0 ? /*#__PURE__*/ $acw62.createElement((0, $9ca6dde71eace8f8$export$81e628514f0bafd8), sortIconProps) : /*#__PURE__*/ $acw62.createElement((0, $0893b5fb3a615728$export$7a06440e4457d3e9), sortIconProps) : /*#__PURE__*/ $acw62.createElement((0, $e1453b839132f2f7$export$d79696f0483bfbd9), sortIconProps);
            var sortIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(props.sortIcon || icon, $68eba9483912474c$var$_objectSpread$2({}, sortIconProps), {
                props: props,
                sorted: sorted,
                sortOrder: sortOrder
            });
            return /*#__PURE__*/ $acw62.createElement("span", sortProps, sortIcon);
        }
        return null;
    };
    var createBadge = function createBadge(_ref3) {
        var metaIndex = _ref3.metaIndex;
        if (metaIndex !== -1 && isBadgeVisible()) {
            var value = props.groupRowsBy && props.groupRowsBy === props.groupRowSortField ? metaIndex : metaIndex + 1;
            var sortBadgeProps = mergeProps({
                className: cx('sortBadge')
            }, getColumnPTOptions('root'), getColumnPTOptions('sortBadge'));
            return /*#__PURE__*/ $acw62.createElement("span", sortBadgeProps, value);
        }
        return null;
    };
    var createCheckbox = function createCheckbox() {
        if (props.showSelectAll && getColumnProp('selectionMode') === 'multiple' && props.filterDisplay !== 'row') {
            var allRowsSelected = props.allRowsSelected(props.value);
            return /*#__PURE__*/ $acw62.createElement($68eba9483912474c$var$HeaderCheckbox, {
                hostName: props.hostName,
                column: props.column,
                checked: allRowsSelected,
                onChange: props.onColumnCheckboxChange,
                disabled: props.empty,
                ptCallbacks: ptCallbacks,
                metaData: parentMetaData,
                unstyled: props.unstyled
            });
        }
        return null;
    };
    var createFilter = function createFilter() {
        if (props.filterDisplay === 'menu' && getColumnProp('filter')) return /*#__PURE__*/ $acw62.createElement($68eba9483912474c$var$ColumnFilter, {
            hostName: props.hostName,
            display: "menu",
            column: props.column,
            filters: props.filters,
            onFilterChange: props.onFilterChange,
            onFilterApply: props.onFilterApply,
            filtersStore: props.filtersStore,
            filterIcon: props.filterIcon,
            filterClearIcon: props.filterClearIcon,
            ptCallbacks: ptCallbacks,
            metaData: parentMetaData,
            unstyled: props.unstyled
        });
        return null;
    };
    var createHeader = function createHeader(sortMeta) {
        var title = createTitle();
        var sortIcon = createSortIcon(sortMeta);
        var badge = createBadge(sortMeta);
        var checkbox = createCheckbox();
        var filter = createFilter();
        var headerContentProps = mergeProps({
            className: cx('headerContent')
        }, getColumnPTOptions('headerContent'));
        return /*#__PURE__*/ $acw62.createElement("div", headerContentProps, title, sortIcon, badge, checkbox, filter);
    };
    var createElement = function createElement() {
        var _isSortableDisabled = isSortableDisabled();
        var sortMeta = getSortMeta();
        var style = getStyle();
        var align = getColumnProp('alignHeader') || getColumnProp('align');
        var frozen = getColumnProp('frozen');
        var tabIndex = getColumnProp('sortable') && !_isSortableDisabled ? props.tabIndex : null;
        var colSpan = getColumnProp('colSpan');
        var rowSpan = getColumnProp('rowSpan');
        var ariaSort = getAriaSort(sortMeta);
        var headerTooltip = getColumnProp('headerTooltip');
        var headerClassName = getColumnProp('headerClassName');
        var hasTooltip = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(headerTooltip);
        var headerTooltipOptions = getColumnProp('headerTooltipOptions');
        var resizer = createResizer();
        var header = createHeader(sortMeta);
        var headerCellProps = mergeProps({
            className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(headerClassName, cx('headerCell', {
                headerProps: props,
                frozen: frozen,
                sortMeta: sortMeta,
                align: align,
                _isSortableDisabled: _isSortableDisabled,
                getColumnProp: getColumnProp
            })),
            style: style,
            role: 'columnheader',
            onClick: function onClick(e) {
                return _onClick(e);
            },
            onKeyDown: function onKeyDown(e) {
                return _onKeyDown(e);
            },
            onMouseDown: function onMouseDown(e) {
                return _onMouseDown(e);
            },
            onDragStart: function onDragStart(e) {
                return _onDragStart(e);
            },
            onDragOver: function onDragOver(e) {
                return _onDragOver(e);
            },
            onDragLeave: function onDragLeave(e) {
                return _onDragLeave(e);
            },
            onDrop: function onDrop(e) {
                return _onDrop(e);
            },
            tabIndex: tabIndex,
            colSpan: colSpan,
            rowSpan: rowSpan,
            'aria-sort': ariaSort,
            'data-p-sortable-column': getColumnProp('sortable'),
            'data-p-resizable-column': props.resizableColumns,
            'data-p-highlight': sortMeta.sorted,
            'data-p-filter-column': !props.metaData.props.headerColumnGroup && props.filterDisplay === 'row',
            'data-p-frozen-column': getColumnProp('frozen'),
            'data-p-reorderable-column': props.reorderableColumns
        }, getColumnPTOptions('root'), getColumnPTOptions('headerCell'));
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("th", $68eba9483912474c$var$_extends({
            ref: elementRef
        }, headerCellProps), resizer, header), hasTooltip && /*#__PURE__*/ $acw62.createElement((0, $b74dfa9f7ee9d9bc$export$28c660c63b792dea), $68eba9483912474c$var$_extends({
            target: elementRef,
            content: headerTooltip,
            pt: getColumnPTOptions('tooltip'),
            unstyled: props.unstyled
        }, headerTooltipOptions)));
    };
    var element = createElement();
    return element;
});
$68eba9483912474c$var$HeaderCell.displayName = 'HeaderCell';
function $68eba9483912474c$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68eba9483912474c$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68eba9483912474c$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $68eba9483912474c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68eba9483912474c$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $68eba9483912474c$var$TableHeader = /*#__PURE__*/ $acw62.memo(function(props) {
    var _React$useState = $acw62.useState([]), _React$useState2 = $68eba9483912474c$var$_slicedToArray(_React$useState, 2), sortableDisabledFieldsState = _React$useState2[0], setSortableDisabledFieldsState = _React$useState2[1];
    var _React$useState3 = $acw62.useState(false), _React$useState4 = $68eba9483912474c$var$_slicedToArray(_React$useState3, 2), allSortableDisabledState = _React$useState4[0], setAllSortableDisabledState = _React$useState4[1];
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var isSingleSort = props.sortMode === 'single';
    var isMultipleSort = props.sortMode === 'multiple';
    var isAllSortableDisabled = isSingleSort && allSortableDisabledState;
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx;
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var getColumnProp = function getColumnProp(column, name) {
        return $68eba9483912474c$var$ColumnBase.getCProp(column, name);
    };
    var getColumnProps = function getColumnProps(column) {
        return $68eba9483912474c$var$ColumnBase.getCProps(column);
    };
    var getRowProps = function getRowProps(row) {
        return $68eba9483912474c$var$ColumnGroupBase.getCProps(row);
    };
    var getColumnGroupProps = function getColumnGroupProps() {
        return props.headerColumnGroup ? ptmo($68eba9483912474c$var$ColumnGroupBase.getCProps(props.headerColumnGroup)) : undefined;
    };
    var getColumnGroupPTOptions = function getColumnGroupPTOptions(key) {
        var cGProps = getColumnGroupProps();
        var columnGroupMetaData = {
            props: cGProps,
            parent: props.metaData,
            hostName: props.hostName,
            state: {
                sortableDisabledFields: sortableDisabledFieldsState,
                allSortableDisabled: allSortableDisabledState
            }
        };
        return mergeProps(ptm("columnGroup.".concat(key), {
            columnGroup: columnGroupMetaData
        }), ptm("columnGroup.".concat(key), columnGroupMetaData), ptmo(cGProps, key, columnGroupMetaData));
    };
    var getColumnPTOptions = function getColumnPTOptions(column, key) {
        var cProps = getColumnProps(column);
        var columnMetaData = {
            props: cProps,
            parent: props.metaData,
            hostName: props.hostName,
            state: {
                sortableDisabledFields: sortableDisabledFieldsState,
                allSortableDisabled: allSortableDisabledState
            }
        };
        return mergeProps(ptm("column.".concat(key), {
            column: columnMetaData
        }), ptm("column.".concat(key), columnMetaData), ptmo(cProps, key, columnMetaData));
    };
    var getRowPTOptions = function getRowPTOptions(row, key) {
        var rProps = getRowProps(row);
        var rowMetaData = {
            props: rProps,
            parent: props.metaData,
            hostName: props.hostName
        };
        return mergeProps(ptm("row.".concat(key), {
            row: rowMetaData
        }), ptm("row.".concat(key), rowMetaData), ptmo(rProps, key, rowMetaData));
    };
    var isColumnSorted = function isColumnSorted(column) {
        return props.sortField !== null ? getColumnProp(column, 'field') === props.sortField || getColumnProp(column, 'sortField') === props.sortField : false;
    };
    var updateSortableDisabled = function updateSortableDisabled() {
        if (isSingleSort || isMultipleSort && props.onSortChange) {
            var sortableDisabledFields = [];
            var allSortableDisabled = false;
            props.columns.forEach(function(column) {
                if (getColumnProp(column, 'sortableDisabled')) {
                    sortableDisabledFields.push(getColumnProp(column, 'sortField') || getColumnProp(column, 'field'));
                    if (!allSortableDisabled && isColumnSorted(column)) allSortableDisabled = true;
                }
            });
            setSortableDisabledFieldsState(sortableDisabledFields);
            setAllSortableDisabledState(allSortableDisabled);
        }
    };
    var onSortableChange = function onSortableChange() {
        updateSortableDisabled();
    };
    var onCheckboxChange = function onCheckboxChange(e) {
        props.onColumnCheckboxChange(e, props.value);
    };
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        updateSortableDisabled();
    });
    var createGroupHeaderCells = function createGroupHeaderCells(row) {
        var columns = $acw62.Children.toArray($68eba9483912474c$var$RowBase.getCProp(row, 'children'));
        return createHeaderCells(columns);
    };
    var createHeaderCells = function createHeaderCells(columns) {
        return $acw62.Children.map(columns, function(col, i) {
            var isVisible = col ? !getColumnProp(col, 'hidden') : true;
            var key = col ? getColumnProp(col, 'columnKey') || getColumnProp(col, 'field') || i : i;
            return isVisible && /*#__PURE__*/ $acw62.createElement($68eba9483912474c$var$HeaderCell, {
                hostName: props.hostName,
                allRowsSelected: props.allRowsSelected,
                allSortableDisabled: isAllSortableDisabled,
                column: col,
                index: i,
                empty: props.empty,
                filterClearIcon: props.filterClearIcon,
                filterDisplay: props.filterDisplay,
                filterIcon: props.filterIcon,
                filters: props.filters,
                filtersStore: props.filtersStore,
                groupRowSortField: props.groupRowSortField,
                groupRowsBy: props.groupRowsBy,
                key: key,
                multiSortMeta: props.multiSortMeta,
                onColumnCheckboxChange: onCheckboxChange,
                onColumnDragLeave: props.onColumnDragLeave,
                onColumnDragOver: props.onColumnDragOver,
                onColumnDragStart: props.onColumnDragStart,
                onColumnDrop: props.onColumnDrop,
                onColumnMouseDown: props.onColumnMouseDown,
                onColumnResizeStart: props.onColumnResizeStart,
                onColumnResizerClick: props.onColumnResizerClick,
                onColumnResizerDoubleClick: props.onColumnResizerDoubleClick,
                onFilterApply: props.onFilterApply,
                onFilterChange: props.onFilterChange,
                onSortChange: props.onSortChange,
                onSortableChange: onSortableChange,
                reorderableColumns: props.reorderableColumns,
                resizableColumns: props.resizableColumns,
                showSelectAll: props.showSelectAll,
                sortField: props.sortField,
                sortIcon: props.sortIcon,
                sortMode: props.sortMode,
                sortOrder: props.sortOrder,
                sortableDisabledFields: sortableDisabledFieldsState,
                tabIndex: props.tabIndex,
                tableProps: props.tableProps,
                value: props.value,
                ptCallbacks: props.ptCallbacks,
                metaData: props.metaData,
                unstyled: props.unstyled
            });
        });
    };
    var createCheckbox = function createCheckbox(column, selectionMode) {
        if (props.showSelectAll && selectionMode === 'multiple') {
            var allRowsSelected = props.allRowsSelected(props.value);
            return /*#__PURE__*/ $acw62.createElement($68eba9483912474c$var$HeaderCheckbox, {
                hostName: props.hostName,
                column: column,
                checked: allRowsSelected,
                onChange: onCheckboxChange,
                disabled: props.empty,
                ptCallbacks: props.ptCallbacks,
                metaData: props.metaData,
                unstyled: props.unstyled
            });
        }
        return null;
    };
    var createFilter = function createFilter(column, filter) {
        if (filter) return /*#__PURE__*/ $acw62.createElement($68eba9483912474c$var$ColumnFilter, {
            hostName: props.hostName,
            display: "row",
            column: column,
            filterClearIcon: props.filterClearIcon,
            filterIcon: props.filterIcon,
            filters: props.filters,
            filtersStore: props.filtersStore,
            metaData: props.metaData,
            onFilterApply: props.onFilterApply,
            onFilterChange: props.onFilterChange,
            ptCallbacks: props.ptCallbacks,
            unstyled: props.unstyled
        });
        return null;
    };
    var createFilterCells = function createFilterCells() {
        return $acw62.Children.map(props.columns, function(col, i) {
            var isVisible = !getColumnProp(col, 'hidden');
            if (isVisible) {
                var _ColumnBase$getCProps = $68eba9483912474c$var$ColumnBase.getCProps(col), filterHeaderStyle = _ColumnBase$getCProps.filterHeaderStyle, style = _ColumnBase$getCProps.style, filterHeaderClassName = _ColumnBase$getCProps.filterHeaderClassName, className = _ColumnBase$getCProps.className, frozen = _ColumnBase$getCProps.frozen, columnKey = _ColumnBase$getCProps.columnKey, field = _ColumnBase$getCProps.field, selectionMode = _ColumnBase$getCProps.selectionMode, filter = _ColumnBase$getCProps.filter;
                var colStyle = $68eba9483912474c$var$_objectSpread$1($68eba9483912474c$var$_objectSpread$1({}, filterHeaderStyle || {}), style || {});
                var colKey = columnKey || field || i;
                var checkbox = createCheckbox(col, selectionMode);
                var filterRow = createFilter(col, filter);
                var headerCellProps = mergeProps({
                    style: colStyle,
                    className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(filterHeaderClassName, className, cx('headerCell', {
                        frozen: frozen,
                        column: col
                    }))
                }, getColumnPTOptions(col, 'root'), getColumnPTOptions(col, 'headerCell'));
                return /*#__PURE__*/ $acw62.createElement("th", $68eba9483912474c$var$_extends({
                    key: colKey
                }, headerCellProps), checkbox, filterRow);
            }
            return null;
        });
    };
    var createContent = function createContent() {
        if (props.headerColumnGroup) {
            var rows = $acw62.Children.toArray($68eba9483912474c$var$ColumnGroupBase.getCProp(props.headerColumnGroup, 'children'));
            return rows.map(function(row, i) {
                var headerRowProps = mergeProps({
                    role: 'row'
                }, $68eba9483912474c$var$RowBase.getProps(row.props, context), getRowPTOptions(row, 'root'));
                return /*#__PURE__*/ $acw62.createElement("tr", $68eba9483912474c$var$_extends({}, headerRowProps, {
                    key: i
                }), createGroupHeaderCells(row));
            });
        }
        var headerRowProps = mergeProps({
            role: 'row'
        }, ptm('headerRow', {
            hostName: props.hostName
        }));
        var headerRow = /*#__PURE__*/ $acw62.createElement("tr", headerRowProps, createHeaderCells(props.columns));
        var filterRow = props.filterDisplay === 'row' && /*#__PURE__*/ $acw62.createElement("tr", headerRowProps, createFilterCells());
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, headerRow, filterRow);
    };
    var content = createContent();
    var theadProps = mergeProps({
        className: cx('thead'),
        role: 'rowgroup'
    }, getColumnGroupPTOptions('root'), ptm('thead', {
        hostName: props.hostName
    }));
    return /*#__PURE__*/ $acw62.createElement("thead", theadProps, content);
});
$68eba9483912474c$var$TableHeader.displayName = 'TableHeader';
function $68eba9483912474c$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $68eba9483912474c$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $68eba9483912474c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $68eba9483912474c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $68eba9483912474c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $68eba9483912474c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $68eba9483912474c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68eba9483912474c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68eba9483912474c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $68eba9483912474c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68eba9483912474c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $68eba9483912474c$export$df30df7ec97b32b5 = /*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var props = $68eba9483912474c$var$DataTableBase.getProps(inProps, context);
    var _React$useState = $acw62.useState(props.first), _React$useState2 = $68eba9483912474c$var$_slicedToArray(_React$useState, 2), firstState = _React$useState2[0], setFirstState = _React$useState2[1];
    var _React$useState3 = $acw62.useState(props.rows), _React$useState4 = $68eba9483912474c$var$_slicedToArray(_React$useState3, 2), rowsState = _React$useState4[0], setRowsState = _React$useState4[1];
    var _React$useState5 = $acw62.useState(props.sortField), _React$useState6 = $68eba9483912474c$var$_slicedToArray(_React$useState5, 2), sortFieldState = _React$useState6[0], setSortFieldState = _React$useState6[1];
    var _React$useState7 = $acw62.useState(props.sortOrder), _React$useState8 = $68eba9483912474c$var$_slicedToArray(_React$useState7, 2), sortOrderState = _React$useState8[0], setSortOrderState = _React$useState8[1];
    var _React$useState9 = $acw62.useState(props.multiSortMeta), _React$useState10 = $68eba9483912474c$var$_slicedToArray(_React$useState9, 2), multiSortMetaState = _React$useState10[0], setMultiSortMetaState = _React$useState10[1];
    var _React$useState11 = $acw62.useState(props.filters), _React$useState12 = $68eba9483912474c$var$_slicedToArray(_React$useState11, 2), filtersState = _React$useState12[0], setFiltersState = _React$useState12[1];
    var _React$useState13 = $acw62.useState([]), _React$useState14 = $68eba9483912474c$var$_slicedToArray(_React$useState13, 2), columnOrderState = _React$useState14[0], setColumnOrderState = _React$useState14[1];
    var _React$useState15 = $acw62.useState(null), _React$useState16 = $68eba9483912474c$var$_slicedToArray(_React$useState15, 2), groupRowsSortMetaState = _React$useState16[0], setGroupRowsSortMetaState = _React$useState16[1];
    var _React$useState17 = $acw62.useState({}), _React$useState18 = $68eba9483912474c$var$_slicedToArray(_React$useState17, 2), editingMetaState = _React$useState18[0], setEditingMetaState = _React$useState18[1];
    var _React$useState19 = $acw62.useState(props.rows), _React$useState20 = $68eba9483912474c$var$_slicedToArray(_React$useState19, 2), d_rowsState = _React$useState20[0], setD_rowsState = _React$useState20[1];
    var _React$useState21 = $acw62.useState({}), _React$useState22 = $68eba9483912474c$var$_slicedToArray(_React$useState21, 2), d_filtersState = _React$useState22[0], setD_filtersState = _React$useState22[1];
    var metaData = {
        props: props,
        state: {
            first: firstState,
            rows: rowsState,
            sortField: sortFieldState,
            sortOrder: sortOrderState,
            multiSortMeta: multiSortMetaState,
            filters: filtersState,
            columnOrder: columnOrderState,
            groupRowsSortMeta: groupRowsSortMetaState,
            editingMeta: editingMetaState,
            d_rows: d_rowsState,
            d_filters: d_filtersState
        },
        context: {
            scrollable: props.scrollable
        }
    };
    var ptCallbacks = $68eba9483912474c$var$DataTableBase.setMetaData(metaData);
    (0, $b76d8eda63b3c134$export$142583cb150b394)($68eba9483912474c$var$DataTableBase.css.styles, ptCallbacks.isUnstyled, {
        name: 'datatable'
    });
    var attributeSelector = $acw62.useRef('');
    var elementRef = $acw62.useRef(null);
    var tableRef = $acw62.useRef(null);
    var wrapperRef = $acw62.useRef(null);
    var bodyRef = $acw62.useRef(null);
    var frozenBodyRef = $acw62.useRef(null);
    var virtualScrollerRef = $acw62.useRef(null);
    var reorderIndicatorUpRef = $acw62.useRef(null);
    var reorderIndicatorDownRef = $acw62.useRef(null);
    var colReorderIconWidth = $acw62.useRef(null);
    var colReorderIconHeight = $acw62.useRef(null);
    var resizeHelperRef = $acw62.useRef(null);
    var draggedColumnElement = $acw62.useRef(null);
    var draggedColumn = $acw62.useRef(null);
    var dropPosition = $acw62.useRef(null);
    var styleElement = $acw62.useRef(null);
    var responsiveStyleElement = $acw62.useRef(null);
    var beforeResizeStyleElement = $acw62.useRef(null);
    var columnWidthsState = $acw62.useRef(null);
    var tableWidthState = $acw62.useRef(null);
    var resizeColumn = $acw62.useRef(null);
    var resizeColumnElement = $acw62.useRef(null);
    var columnResizing = $acw62.useRef(false);
    var lastResizeHelperX = $acw62.useRef(null);
    var columnSortable = $acw62.useRef(false);
    var columnSortFunction = $acw62.useRef(null);
    var columnField = $acw62.useRef(null);
    var filterTimeout = $acw62.useRef(null);
    if (props.rows !== d_rowsState && !props.onPage) {
        setRowsState(props.rows);
        setD_rowsState(props.rows);
    }
    var columnResizeStartListener = function columnResizeStartListener(event) {
        return columnResizing.current && onColumnResize(event);
    };
    var columnResizeEndListener = function columnResizeEndListener() {
        return columnResizing.current && (columnResizing.current = false, onColumnResizeEnd());
    };
    var _useEventListener = (0, $fbdf1e36fa0a01d8$export$7080b3e976bc91ab)({
        type: 'mousemove',
        listener: columnResizeStartListener
    }), _useEventListener2 = $68eba9483912474c$var$_slicedToArray(_useEventListener, 2), bindDocumentMouseMoveListener = _useEventListener2[0], unbindDocumentMouseMoveListener = _useEventListener2[1];
    var _useEventListener3 = (0, $fbdf1e36fa0a01d8$export$7080b3e976bc91ab)({
        type: 'mouseup',
        listener: columnResizeEndListener
    }), _useEventListener4 = $68eba9483912474c$var$_slicedToArray(_useEventListener3, 2), bindDocumentMouseUpListener = _useEventListener4[0], unbindDocumentMouseUpListener = _useEventListener4[1];
    var _useEventListener5 = (0, $fbdf1e36fa0a01d8$export$7080b3e976bc91ab)({
        type: 'touchmove',
        listener: columnResizeStartListener
    }), _useEventListener6 = $68eba9483912474c$var$_slicedToArray(_useEventListener5, 2), bindDocumentTouchMoveListener = _useEventListener6[0], unbindDocumentTouchMoveListener = _useEventListener6[1];
    var _useEventListener7 = (0, $fbdf1e36fa0a01d8$export$7080b3e976bc91ab)({
        type: 'touchend',
        listener: columnResizeEndListener
    }), _useEventListener8 = $68eba9483912474c$var$_slicedToArray(_useEventListener7, 2), bindDocumentTouchEndListener = _useEventListener8[0], unbindDocumentTouchEndListener = _useEventListener8[1];
    var isCustomStateStorage = function isCustomStateStorage() {
        return props.stateStorage === 'custom';
    };
    var isStateful = function isStateful() {
        return props.stateKey != null || isCustomStateStorage();
    };
    var isVirtualScrollerDisabled = function isVirtualScrollerDisabled() {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).isEmpty(props.virtualScrollerOptions) || !props.scrollable;
    };
    var isEquals = function isEquals(data1, data2) {
        return props.compareSelectionBy === 'equals' ? data1 === data2 : (0, $a73ce425265b079e$export$4855211e6b8ad895).equals(data1, data2, props.dataKey);
    };
    var hasFilter = function hasFilter() {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(getFilters()) || props.globalFilter;
    };
    var getFirst = function getFirst() {
        return props.onPage ? props.first : firstState;
    };
    var getRows = function getRows() {
        return props.onPage ? props.rows : rowsState;
    };
    var getSortField = function getSortField() {
        return props.onSort ? props.sortField : sortFieldState;
    };
    var getSortOrder = function getSortOrder() {
        return props.onSort ? props.sortOrder : sortOrderState;
    };
    var getMultiSortMeta = function getMultiSortMeta() {
        return (props.onSort ? props.multiSortMeta : multiSortMetaState) || [];
    };
    var getFilters = function getFilters() {
        return props.onFilter ? props.filters : filtersState;
    };
    var getColumnProp = function getColumnProp(column, name) {
        return $68eba9483912474c$var$ColumnBase.getCProp(column, name);
    };
    var getColumns = function getColumns(ignoreReorderable) {
        var columns = $acw62.Children.toArray(props.children);
        if (!columns) return null;
        if (!ignoreReorderable && props.reorderableColumns && columnOrderState) {
            var orderedColumns = columnOrderState.reduce(function(arr, columnKey) {
                var column = findColumnByKey(columns, columnKey);
                column && arr.push(column);
                return arr;
            }, []);
            return [].concat($68eba9483912474c$var$_toConsumableArray(orderedColumns), $68eba9483912474c$var$_toConsumableArray(columns.filter(function(col) {
                return orderedColumns.indexOf(col) < 0;
            })));
        }
        return columns;
    };
    var saveState = function saveState() {
        var state = {};
        if (props.paginator) {
            state.first = getFirst();
            state.rows = getRows();
        }
        var sortField = getSortField();
        if (sortField) {
            state.sortField = sortField;
            state.sortOrder = getSortOrder();
        }
        var multiSortMeta = getMultiSortMeta();
        if (multiSortMeta) state.multiSortMeta = multiSortMeta;
        if (hasFilter()) state.filters = getFilters();
        if (props.resizableColumns) saveColumnWidths(state);
        if (props.reorderableColumns) state.columnOrder = columnOrderState;
        if (props.expandedRows) state.expandedRows = props.expandedRows;
        if (props.selection && props.onSelectionChange) state.selection = props.selection;
        if (isCustomStateStorage()) {
            if (props.customSaveState) props.customSaveState(state);
        } else {
            var storage = $68eba9483912474c$var$getStorage(props.stateStorage);
            if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(state)) storage.setItem(props.stateKey, JSON.stringify(state));
        }
        if (props.onStateSave) props.onStateSave(state);
    };
    var clearState = function clearState() {
        var storage = $68eba9483912474c$var$getStorage(props.stateStorage);
        if (storage && props.stateKey) storage.removeItem(props.stateKey);
    };
    var restoreState = function restoreState() {
        var restoredState = {};
        if (isCustomStateStorage()) {
            if (props.customRestoreState) restoredState = props.customRestoreState();
        } else {
            var storage = $68eba9483912474c$var$getStorage(props.stateStorage);
            var stateString = storage.getItem(props.stateKey);
            var dateFormat = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/;
            var reviver = function reviver(key, value) {
                return typeof value === 'string' && dateFormat.test(value) ? new Date(value) : value;
            };
            if (stateString) restoredState = JSON.parse(stateString, reviver);
        }
        _restoreState(restoredState);
    };
    var restoreTableState = function restoreTableState(restoredState) {
        _restoreState(restoredState);
    };
    var _restoreState = function _restoreState() {
        var restoredState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(restoredState)) {
            if (props.paginator) {
                if (props.onPage) {
                    var getOnPageParams = function getOnPageParams(first, rows) {
                        var totalRecords = getTotalRecords(processedData());
                        var pageCount = Math.ceil(totalRecords / rows) || 1;
                        var page = Math.floor(first / rows);
                        return {
                            first: first,
                            rows: rows,
                            page: page,
                            pageCount: pageCount
                        };
                    };
                    props.onPage(createEvent(getOnPageParams(restoredState.first, restoredState.rows)));
                } else {
                    setFirstState(restoredState.first);
                    setRowsState(restoredState.rows);
                }
            }
            if (restoredState.sortField) {
                if (props.onSort) props.onSort(createEvent({
                    sortField: restoredState.sortField,
                    sortOrder: restoredState.sortOrder
                }));
                else {
                    setSortFieldState(restoredState.sortField);
                    setSortOrderState(restoredState.sortOrder);
                }
            }
            if (restoredState.multiSortMeta) {
                if (props.onSort) props.onSort(createEvent({
                    multiSortMeta: restoredState.multiSortMeta
                }));
                else setMultiSortMetaState(restoredState.multiSortMeta);
            }
            if (restoredState.filters) {
                setD_filtersState(cloneFilters(restoredState.filters));
                if (props.onFilter) props.onFilter(createEvent({
                    filters: restoredState.filters
                }));
                else setFiltersState(cloneFilters(restoredState.filters));
            }
            if (props.resizableColumns) {
                columnWidthsState.current = restoredState.columnWidths;
                tableWidthState.current = restoredState.tableWidth;
                restoreColumnWidths();
            }
            if (props.reorderableColumns) setColumnOrderState(restoredState.columnOrder);
            if (restoredState.expandedRows && props.onRowToggle) props.onRowToggle({
                data: restoredState.expandedRows
            });
            if (restoredState.selection && props.onSelectionChange) props.onSelectionChange({
                value: restoredState.selection
            });
            if (props.onStateRestore) props.onStateRestore(restoredState);
        }
    };
    var saveColumnWidths = function saveColumnWidths(state) {
        var widths = [];
        var headers = (0, $a73ce425265b079e$export$ff8ccbac9225de62).find(elementRef.current, '[data-pc-section="thead"] > tr > th');
        headers.forEach(function(header) {
            return widths.push((0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(header));
        });
        state.columnWidths = widths.join(',');
        if (props.columnResizeMode === 'expand') state.tableWidth = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(tableRef.current) + 'px';
    };
    var addColumnWidthStyles = function addColumnWidthStyles(widths) {
        createStyleElement();
        var innerHTML = '';
        var selector = "[data-pc-name=\"datatable\"][".concat(attributeSelector.current, "] > [data-pc-section=\"wrapper\"] ").concat(isVirtualScrollerDisabled() ? '' : '> [data-pc-name="virtualscroller"]', " > [data-pc-section=\"table\"]");
        widths.forEach(function(width, index) {
            var style = "width: ".concat(width, "px !important; max-width: ").concat(width, "px !important");
            innerHTML = innerHTML + "\n                ".concat(selector, " > [data-pc-section=\"thead\"] > tr > th:nth-child(").concat(index + 1, "),\n                ").concat(selector, " > [data-pc-section=\"tbody\"] > tr > td:nth-child(").concat(index + 1, "),\n                ").concat(selector, " > [data-pc-section=\"tfoot\"] > tr > td:nth-child(").concat(index + 1, ") {\n                    ").concat(style, "\n                }\n            ");
        });
        styleElement.current.innerHTML = innerHTML;
    };
    var restoreColumnWidths = function restoreColumnWidths() {
        if (columnWidthsState.current) {
            var widths = columnWidthsState.current.split(',');
            if (props.columnResizeMode === 'expand' && tableWidthState.current) {
                tableRef.current.style.width = tableWidthState.current;
                tableRef.current.style.minWidth = tableWidthState.current;
            }
            if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(widths)) addColumnWidthStyles(widths);
        }
    };
    var findParentHeader = function findParentHeader(element) {
        if (element.nodeName === 'TH') return element;
        var parent = element.parentElement;
        while(parent.nodeName !== 'TH'){
            parent = parent.parentElement;
            if (!parent) break;
        }
        return parent;
    };
    var getGroupRowSortField = function getGroupRowSortField() {
        return props.sortMode === 'single' ? props.sortField : groupRowsSortMetaState ? groupRowsSortMetaState.field : null;
    };
    var getSelectableData = function getSelectableData(val) {
        if (props.showSelectionElement || props.isDataSelectable) return val.filter(function(data, index) {
            var isSelectable = true;
            if (props.showSelectionElement) isSelectable = props.showSelectionElement({
                rowIndex: index,
                props: props
            });
            if (props.isDataSelectable && isSelectable) isSelectable = props.isDataSelectable({
                data: data,
                index: index
            });
            return isSelectable;
        });
        return val;
    };
    var allRowsSelected = function allRowsSelected(processedData) {
        if (props.onSelectAllChange) return props.selectAll;
        var data = props.selectionPageOnly ? dataToRender(processedData) : processedData;
        var val = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.frozenValue) ? [].concat($68eba9483912474c$var$_toConsumableArray(props.frozenValue), $68eba9483912474c$var$_toConsumableArray(data)) : data;
        var selectableVal = getSelectableData(val);
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(selectableVal) && props.selection && selectableVal.every(function(sv) {
            return (0, $a73ce425265b079e$export$4855211e6b8ad895).isArray(props.selection) && props.selection.some(function(s) {
                return isEquals(s, sv);
            });
        });
    };
    var getSelectionModeInColumn = function getSelectionModeInColumn(columns) {
        if (columns) {
            var col = columns.find(function(c) {
                return !!getColumnProp(c, 'selectionMode');
            });
            return col ? getColumnProp(col, 'selectionMode') : null;
        }
        return null;
    };
    var findColumnByKey = function findColumnByKey(columns, key) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(columns) ? columns.find(function(col) {
            return getColumnProp(col, 'columnKey') === key || getColumnProp(col, 'field') === key;
        }) : null;
    };
    var getTotalRecords = function getTotalRecords(data) {
        return props.lazy ? props.totalRecords : data ? data.length : 0;
    };
    var onEditingMetaChange = function onEditingMetaChange(e) {
        var rowData = e.rowData, field = e.field, editingKey = e.editingKey;
        e.rowIndex;
        var editing = e.editing;
        var editingMeta = $68eba9483912474c$var$_objectSpread({}, editingMetaState);
        var meta = editingMeta[editingKey];
        if (editing) {
            !meta && (meta = editingMeta[editingKey] = {
                data: $68eba9483912474c$var$_objectSpread({}, rowData),
                fields: []
            });
            meta.fields.push(field);
        } else if (meta) {
            var fields = meta.fields.filter(function(f) {
                return f !== field;
            });
            !fields.length ? delete editingMeta[editingKey] : meta.fields = fields;
        }
        setEditingMetaState(editingMeta);
    };
    var clearEditingMetaData = function clearEditingMetaData() {
        if (props.editMode && (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(editingMetaState)) setEditingMetaState({});
    };
    var onColumnResizeStart = function onColumnResizeStart(e) {
        createBeforeResizeStyleElement();
        var event = e.originalEvent, column = e.column;
        var containerLeft = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOffset(elementRef.current).left;
        resizeColumn.current = column;
        resizeColumnElement.current = event.currentTarget.parentElement;
        columnResizing.current = true;
        lastResizeHelperX.current = (event.type === 'touchstart' ? event.changedTouches[0].clientX : event.pageX) - containerLeft + elementRef.current.scrollLeft;
        bindColumnResizeEvents();
    };
    var onColumnResize = function onColumnResize(event) {
        var containerLeft = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOffset(elementRef.current).left;
        elementRef.current.setAttribute('data-p-unselectable-text', true);
        resizeHelperRef.current.style.height = elementRef.current.offsetHeight + 'px';
        resizeHelperRef.current.style.top = "0px";
        resizeHelperRef.current.style.left = (event.type === 'touchmove' ? event.changedTouches[0].clientX : event.pageX) - containerLeft + elementRef.current.scrollLeft + 'px';
        resizeHelperRef.current.style.display = 'block';
    };
    var onColumnResizeEnd = function onColumnResizeEnd() {
        var delta = resizeHelperRef.current.offsetLeft - lastResizeHelperX.current;
        var columnWidth = resizeColumnElement.current.offsetWidth;
        var newColumnWidth = columnWidth + delta;
        var minWidth = resizeColumnElement.current.style.minWidth || 15;
        if (columnWidth + delta > parseInt(minWidth, 10)) {
            if (props.columnResizeMode === 'fit') {
                var nextColumn = resizeColumnElement.current.nextElementSibling;
                var nextColumnWidth = nextColumn.offsetWidth - delta;
                if (newColumnWidth > 15 && nextColumnWidth > 15) resizeTableCells(newColumnWidth, nextColumnWidth);
            } else if (props.columnResizeMode === 'expand') {
                var tableWidth = tableRef.current.offsetWidth + delta + 'px';
                var updateTableWidth = function updateTableWidth(el) {
                    !!el && (el.style.width = el.style.minWidth = tableWidth);
                };
                // https://github.com/primefaces/primereact/issues/3970 Reasoning: resize table cells before updating the table width so that it can use existing computed cell widths and adjust only the one column.
                resizeTableCells(newColumnWidth);
                updateTableWidth(tableRef.current);
                if (!isVirtualScrollerDisabled()) {
                    updateTableWidth(bodyRef.current);
                    updateTableWidth(frozenBodyRef.current);
                    if (wrapperRef.current) updateTableWidth((0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(wrapperRef.current, '[data-pc-name="virtualscroller"] > table > tbody'));
                }
            }
            if (props.onColumnResizeEnd) props.onColumnResizeEnd({
                element: resizeColumnElement.current,
                column: resizeColumn.current,
                delta: delta
            });
            if (isStateful()) saveState();
        }
        resizeHelperRef.current.style.display = 'none';
        resizeColumn.current = null;
        resizeColumnElement.current = null;
        elementRef.current.setAttribute('data-p-unselectable-text', 'true');
        destroyBeforeResizeStyleElement();
        unbindColumnResizeEvents();
    };
    var resizeTableCells = function resizeTableCells(newColumnWidth, nextColumnWidth) {
        var widths = [];
        var colIndex = (0, $a73ce425265b079e$export$ff8ccbac9225de62).index(resizeColumnElement.current);
        var headers = (0, $a73ce425265b079e$export$ff8ccbac9225de62).find(tableRef.current, '[data-pc-section="thead"] > tr > th');
        headers.forEach(function(header) {
            return widths.push((0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(header));
        });
        destroyStyleElement();
        createStyleElement();
        var innerHTML = '';
        var selector = "[data-pc-name=\"datatable\"][".concat(attributeSelector.current, "] > [data-pc-section=\"wrapper\"] ").concat(isVirtualScrollerDisabled() ? '' : '> [data-pc-name="virtualscroller"]', " > [data-pc-section=\"table\"]");
        widths.forEach(function(width, index) {
            var colWidth = index === colIndex ? newColumnWidth : nextColumnWidth && index === colIndex + 1 ? nextColumnWidth : width;
            var style = "width: ".concat(colWidth, "px !important; max-width: ").concat(colWidth, "px !important");
            innerHTML = innerHTML + "\n                 ".concat(selector, " > [data-pc-section=\"thead\"] > tr > th:nth-child(").concat(index + 1, "),\n                ").concat(selector, " > [data-pc-section=\"tbody\"] > tr > td:nth-child(").concat(index + 1, "),\n                ").concat(selector, " > [data-pc-section=\"tfoot\"] > tr > td:nth-child(").concat(index + 1, ") {\n                    ").concat(style, "\n                }\n            ");
        });
        styleElement.current.innerHTML = innerHTML;
    };
    var bindColumnResizeEvents = function bindColumnResizeEvents() {
        bindDocumentMouseMoveListener();
        bindDocumentMouseUpListener();
        bindDocumentTouchMoveListener();
        bindDocumentTouchEndListener();
    };
    var unbindColumnResizeEvents = function unbindColumnResizeEvents() {
        unbindDocumentMouseMoveListener();
        unbindDocumentMouseUpListener();
        unbindDocumentTouchMoveListener();
        unbindDocumentTouchEndListener();
    };
    var onColumnHeaderMouseDown = function onColumnHeaderMouseDown(e) {
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).clearSelection();
        var event = e.originalEvent, column = e.column;
        if (props.reorderableColumns && getColumnProp(column, 'reorderable') !== false && !getColumnProp(column, 'frozen')) {
            if (event.target.nodeName === 'INPUT' || event.target.nodeName === 'TEXTAREA' || (0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(event.target, '[data-pc-section="columnresizer"]')) event.currentTarget.draggable = false;
            else event.currentTarget.draggable = true;
        }
    };
    var onColumnHeaderCheckboxChange = function onColumnHeaderCheckboxChange(e, processedData) {
        if (props.onSelectAllChange) props.onSelectAllChange(e);
        else {
            var originalEvent = e.originalEvent, checked = e.checked;
            var _data = props.selectionPageOnly ? dataToRender(processedData) : processedData;
            var selection = props.selectionPageOnly && props.selection ? props.selection.filter(function(s) {
                return !_data.some(function(d) {
                    return isEquals(s, d);
                });
            }) : [];
            if (checked) {
                selection = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.frozenValue) ? [].concat($68eba9483912474c$var$_toConsumableArray(selection), $68eba9483912474c$var$_toConsumableArray(props.frozenValue), $68eba9483912474c$var$_toConsumableArray(_data)) : [].concat($68eba9483912474c$var$_toConsumableArray(selection), $68eba9483912474c$var$_toConsumableArray(_data));
                selection = getSelectableData(selection);
                props.onAllRowsSelect && props.onAllRowsSelect({
                    originalEvent: originalEvent,
                    data: selection,
                    type: 'all'
                });
            } else props.onAllRowsUnselect && props.onAllRowsUnselect({
                originalEvent: originalEvent,
                data: selection,
                type: 'all'
            });
            if (props.onSelectionChange) props.onSelectionChange({
                originalEvent: originalEvent,
                value: selection,
                type: 'all'
            });
        }
    };
    var onColumnHeaderDragStart = function onColumnHeaderDragStart(e) {
        var event = e.originalEvent, column = e.column;
        if (columnResizing.current) {
            event.preventDefault();
            return;
        }
        if (!props.reorderableColumns) return;
        colReorderIconWidth.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getHiddenElementOuterWidth(reorderIndicatorUpRef.current);
        colReorderIconHeight.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getHiddenElementOuterHeight(reorderIndicatorUpRef.current);
        draggedColumn.current = column;
        draggedColumnElement.current = findParentHeader(event.currentTarget);
        event.dataTransfer.setData('text', 'b'); // Firefox requires this to make dragging possible
    };
    var onColumnHeaderDragOver = function onColumnHeaderDragOver(e) {
        var event = e.originalEvent, column = e.column;
        var dropHeader = findParentHeader(event.currentTarget);
        if (props.reorderableColumns && draggedColumnElement.current && dropHeader && !getColumnProp(column, 'frozen')) {
            event.preventDefault();
            if (draggedColumnElement.current !== dropHeader) {
                var containerOffset = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOffset(elementRef.current);
                var dropHeaderOffset = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOffset(dropHeader);
                var targetLeft = dropHeaderOffset.left - containerOffset.left;
                var columnCenter = dropHeaderOffset.left + dropHeader.offsetWidth / 2;
                var dragIndex = (0, $a73ce425265b079e$export$ff8ccbac9225de62).index(draggedColumnElement.current);
                var dropIndex = (0, $a73ce425265b079e$export$ff8ccbac9225de62).index(findParentHeader(event.currentTarget));
                reorderIndicatorUpRef.current.style.top = dropHeaderOffset.top - containerOffset.top - (colReorderIconHeight.current - 1) + 'px';
                reorderIndicatorDownRef.current.style.top = dropHeaderOffset.top - containerOffset.top + dropHeader.offsetHeight + 'px';
                if (event.pageX > columnCenter && dragIndex < dropIndex) {
                    reorderIndicatorUpRef.current.style.left = targetLeft + dropHeader.offsetWidth - Math.ceil(colReorderIconWidth.current / 2) + 'px';
                    reorderIndicatorDownRef.current.style.left = targetLeft + dropHeader.offsetWidth - Math.ceil(colReorderIconWidth.current / 2) + 'px';
                    dropPosition.current = 1;
                } else if (dragIndex > dropIndex) {
                    reorderIndicatorUpRef.current.style.left = targetLeft - Math.ceil(colReorderIconWidth.current / 2) + 'px';
                    reorderIndicatorDownRef.current.style.left = targetLeft - Math.ceil(colReorderIconWidth.current / 2) + 'px';
                    dropPosition.current = -1;
                }
                reorderIndicatorUpRef.current.style.display = 'block';
                reorderIndicatorDownRef.current.style.display = 'block';
            }
        }
    };
    var onColumnHeaderDragLeave = function onColumnHeaderDragLeave(e) {
        var event = e.originalEvent;
        if (props.reorderableColumns && draggedColumnElement.current) {
            event.preventDefault();
            reorderIndicatorUpRef.current.style.display = 'none';
            reorderIndicatorDownRef.current.style.display = 'none';
        }
    };
    var onColumnHeaderDrop = function onColumnHeaderDrop(e) {
        var event = e.originalEvent, column = e.column;
        event.preventDefault();
        if (draggedColumnElement.current) {
            var dragIndex = (0, $a73ce425265b079e$export$ff8ccbac9225de62).index(draggedColumnElement.current);
            var dropIndex = (0, $a73ce425265b079e$export$ff8ccbac9225de62).index(findParentHeader(event.currentTarget));
            var allowDrop = dragIndex !== dropIndex;
            if (allowDrop && (dropIndex - dragIndex === 1 && dropPosition.current === -1 || dragIndex - dropIndex === 1 && dropPosition.current === 1)) allowDrop = false;
            if (allowDrop) {
                var _columns = getColumns();
                var isSameColumn = function isSameColumn(col1, col2) {
                    return getColumnProp(col1, 'columnKey') || getColumnProp(col2, 'columnKey') ? (0, $a73ce425265b079e$export$4855211e6b8ad895).equals(col1.props, col2.props, 'columnKey') : (0, $a73ce425265b079e$export$4855211e6b8ad895).equals(col1.props, col2.props, 'field');
                };
                var dragColIndex = _columns.findIndex(function(child) {
                    return isSameColumn(child, draggedColumn.current);
                });
                var dropColIndex = _columns.findIndex(function(child) {
                    return isSameColumn(child, column);
                });
                var widths = [];
                var headers = (0, $a73ce425265b079e$export$ff8ccbac9225de62).find(tableRef.current, '[data-pc-section="thead"] > tr > th');
                headers.forEach(function(header) {
                    return widths.push((0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(header));
                });
                var movedItem = widths.find(function(items, index) {
                    return index === dragColIndex;
                });
                var remainingItems = widths.filter(function(items, index) {
                    return index !== dragColIndex;
                });
                var reorderedWidths = [].concat($68eba9483912474c$var$_toConsumableArray(remainingItems.slice(0, dropColIndex)), [
                    movedItem
                ], $68eba9483912474c$var$_toConsumableArray(remainingItems.slice(dropColIndex)));
                addColumnWidthStyles(reorderedWidths);
                if (dropColIndex < dragColIndex && dropPosition.current === 1) dropColIndex++;
                if (dropColIndex > dragColIndex && dropPosition.current === -1) dropColIndex--;
                (0, $a73ce425265b079e$export$4855211e6b8ad895).reorderArray(_columns, dragColIndex, dropColIndex);
                var columnOrder = _columns.reduce(function(orders, col) {
                    orders.push(getColumnProp(col, 'columnKey') || getColumnProp(col, 'field'));
                    return orders;
                }, []);
                setColumnOrderState(columnOrder);
                if (props.onColReorder) props.onColReorder({
                    originalEvent: event,
                    dragIndex: dragColIndex,
                    dropIndex: dropColIndex,
                    columns: _columns
                });
            }
            reorderIndicatorUpRef.current.style.display = 'none';
            reorderIndicatorDownRef.current.style.display = 'none';
            draggedColumnElement.current.draggable = false;
            draggedColumnElement.current = null;
            draggedColumn.current = null;
            dropPosition.current = null;
        }
    };
    var createBeforeResizeStyleElement = function createBeforeResizeStyleElement() {
        beforeResizeStyleElement.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).createInlineStyle(context && context.nonce || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).nonce, context && context.styleContainer);
        var innerHTML = "\n[data-pc-name=\"datatable\"][".concat(attributeSelector.current, "] {\n    user-select:none;\n}\n        ");
        beforeResizeStyleElement.current.innerHTML = innerHTML;
    };
    var createStyleElement = function createStyleElement() {
        styleElement.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).createInlineStyle(context && context.nonce || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).nonce, context && context.styleContainer);
    };
    var createResponsiveStyle = function createResponsiveStyle() {
        if (!responsiveStyleElement.current) {
            responsiveStyleElement.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).createInlineStyle(context && context.nonce || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).nonce, context && context.styleContainer);
            var tableSelector = ".p-datatable-wrapper ".concat(isVirtualScrollerDisabled() ? '' : '> .p-virtualscroller', " > .p-datatable-table");
            var selector = ".p-datatable[".concat(attributeSelector.current, "] > ").concat(tableSelector);
            var gridLinesSelector = ".p-datatable[".concat(attributeSelector.current, "].p-datatable-gridlines > ").concat(tableSelector);
            var innerHTML = "\n@media screen and (max-width: ".concat(props.breakpoint, ") {\n    ").concat(selector, " > .p-datatable-thead > tr > th,\n    ").concat(selector, " > .p-datatable-tfoot > tr > td {\n        display: none;\n    }\n\n    ").concat(selector, " > .p-datatable-tbody > tr > td {\n        display: flex;\n        width: 100%;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    ").concat(selector, " > .p-datatable-tbody > tr > td:not(:last-child) {\n        border: 0 none;\n    }\n\n    ").concat(gridLinesSelector, " > .p-datatable-tbody > tr > td:last-child {\n        border-top: 0;\n        border-right: 0;\n        border-left: 0;\n    }\n\n    ").concat(selector, " > .p-datatable-tbody > tr > td > .p-column-title {\n        display: block;\n    }\n}\n");
            responsiveStyleElement.current.innerHTML = innerHTML;
        }
    };
    var destroyResponsiveStyle = function destroyResponsiveStyle() {
        responsiveStyleElement.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeInlineStyle(responsiveStyleElement.current);
    };
    var destroyStyleElement = function destroyStyleElement() {
        styleElement.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeInlineStyle(styleElement.current);
    };
    var destroyBeforeResizeStyleElement = function destroyBeforeResizeStyleElement() {
        beforeResizeStyleElement.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeInlineStyle(beforeResizeStyleElement.current);
    };
    var onPageChange = function onPageChange(e) {
        clearEditingMetaData();
        if (props.onPage) props.onPage(createEvent(e));
        else {
            setFirstState(e.first);
            setRowsState(e.rows);
        }
        if (props.onValueChange) props.onValueChange(processedData());
    };
    var onSortChange = function onSortChange(e) {
        clearEditingMetaData();
        var event = e.originalEvent, column = e.column, sortableDisabledFields = e.sortableDisabledFields;
        var sortField = getColumnProp(column, 'sortField') || getColumnProp(column, 'field');
        var sortOrder = props.defaultSortOrder;
        var multiSortMeta;
        var eventMeta;
        columnSortable.current = getColumnProp(column, 'sortable');
        columnSortFunction.current = getColumnProp(column, 'sortFunction');
        columnField.current = sortField;
        if (props.sortMode === 'multiple') {
            var metaKey = event.metaKey || event.ctrlKey;
            multiSortMeta = $68eba9483912474c$var$_toConsumableArray(getMultiSortMeta());
            var sortMeta = multiSortMeta.find(function(sortMeta) {
                return sortMeta.field === sortField;
            });
            sortOrder = sortMeta ? getCalculatedSortOrder(sortMeta.order) : sortOrder;
            var newMetaData = {
                field: sortField,
                order: sortOrder
            };
            if (sortOrder) {
                multiSortMeta = metaKey ? multiSortMeta : multiSortMeta.filter(function(meta) {
                    return sortableDisabledFields.some(function(field) {
                        return field === meta.field;
                    });
                });
                addSortMeta(newMetaData, multiSortMeta);
            } else if (props.removableSort) removeSortMeta(newMetaData, multiSortMeta);
            eventMeta = {
                multiSortMeta: multiSortMeta
            };
        } else {
            sortOrder = getSortField() === sortField ? getCalculatedSortOrder(getSortOrder()) : sortOrder;
            if (props.removableSort) sortField = sortOrder ? sortField : null;
            eventMeta = {
                sortField: sortField,
                sortOrder: sortOrder
            };
        }
        if (props.onSort) props.onSort(createEvent(eventMeta));
        else {
            setFirstState(0);
            setSortFieldState(eventMeta.sortField);
            setSortOrderState(eventMeta.sortOrder);
            setMultiSortMetaState(eventMeta.multiSortMeta);
        }
        if (props.onValueChange) props.onValueChange(processedData({
            sortField: sortField,
            sortOrder: sortOrder,
            multiSortMeta: multiSortMeta
        }));
    };
    var getCalculatedSortOrder = function getCalculatedSortOrder(currentOrder) {
        return props.removableSort ? props.defaultSortOrder === currentOrder ? currentOrder * -1 : 0 : currentOrder * -1;
    };
    var compareValuesOnSort = function compareValuesOnSort(value1, value2, comparator, order) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).sort(value1, value2, order, comparator, context && context.nullSortOrder || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).nullSortOrder);
    };
    var addSortMeta = function addSortMeta(meta, multiSortMeta) {
        var index = multiSortMeta.findIndex(function(sortMeta) {
            return sortMeta.field === meta.field;
        });
        if (index >= 0) multiSortMeta[index] = meta;
        else multiSortMeta.push(meta);
    };
    var removeSortMeta = function removeSortMeta(meta, multiSortMeta) {
        var index = multiSortMeta.findIndex(function(sortMeta) {
            return sortMeta.field === meta.field;
        });
        if (index >= 0) multiSortMeta.splice(index, 1);
        multiSortMeta = multiSortMeta.length > 0 ? multiSortMeta : null;
    };
    var sortSingle = function sortSingle(data, field, order) {
        if (props.groupRowsBy && props.groupRowsBy === props.sortField) {
            var multiSortMeta = [
                {
                    field: props.sortField,
                    order: props.sortOrder || props.defaultSortOrder
                }
            ];
            props.sortField !== field && multiSortMeta.push({
                field: field,
                order: order
            });
            return sortMultiple(data, multiSortMeta);
        }
        var value = $68eba9483912474c$var$_toConsumableArray(data);
        if (columnSortable.current && columnSortFunction.current) value = columnSortFunction.current({
            data: data,
            field: field,
            order: order
        });
        else {
            // performance optimization to prevent resolving field data in each loop
            var lookupMap = new Map();
            var comparator = (0, $a73ce425265b079e$export$4855211e6b8ad895).localeComparator(context && context.locale || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).locale);
            var _iterator = $68eba9483912474c$var$_createForOfIteratorHelper(data), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var item = _step.value;
                    lookupMap.set(item, (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(item, field));
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
            value.sort(function(data1, data2) {
                var value1 = lookupMap.get(data1);
                var value2 = lookupMap.get(data2);
                return compareValuesOnSort(value1, value2, comparator, order);
            });
        }
        return value;
    };
    var sortMultiple = function sortMultiple(data) {
        var multiSortMeta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        if (props.groupRowsBy && (groupRowsSortMetaState || multiSortMeta.length && props.groupRowsBy === multiSortMeta[0].field)) {
            var groupRowsSortMeta = groupRowsSortMetaState;
            var firstSortMeta = multiSortMeta[0];
            if (!groupRowsSortMeta) {
                groupRowsSortMeta = firstSortMeta;
                setGroupRowsSortMetaState(groupRowsSortMeta);
            }
            if (firstSortMeta.field !== groupRowsSortMeta.field) multiSortMeta = [
                groupRowsSortMeta
            ].concat($68eba9483912474c$var$_toConsumableArray(multiSortMeta));
        }
        var value = $68eba9483912474c$var$_toConsumableArray(data);
        if (columnSortable.current && columnSortFunction.current) {
            var meta = multiSortMeta.find(function(meta) {
                return meta.field === columnField.current;
            });
            var field = columnField.current;
            var order = meta ? meta.order : props.defaultSortOrder;
            value = columnSortFunction.current({
                data: data,
                field: field,
                order: order,
                multiSortMeta: multiSortMeta
            });
        } else {
            var comparator = (0, $a73ce425265b079e$export$4855211e6b8ad895).localeComparator(context && context.locale || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).locale);
            value.sort(function(data1, data2) {
                return _multisortField(data1, data2, multiSortMeta, 0, comparator);
            });
        }
        return value;
    };
    var _multisortField = function multisortField(data1, data2, multiSortMeta, index, comparator) {
        if (!multiSortMeta || !multiSortMeta[index]) return;
        var value1 = (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(data1, multiSortMeta[index].field);
        var value2 = (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(data2, multiSortMeta[index].field);
        // check if they are equal handling dates and locales
        if ((0, $a73ce425265b079e$export$4855211e6b8ad895).compare(value1, value2, comparator) === 0) return multiSortMeta.length - 1 > index ? _multisortField(data1, data2, multiSortMeta, index + 1, comparator) : 0;
        return compareValuesOnSort(value1, value2, comparator, multiSortMeta[index].order);
    };
    var onFilterChange = function onFilterChange(filters) {
        clearEditingMetaData();
        setD_filtersState(filters);
    };
    var onFilterApply = function onFilterApply(filtersToApply) {
        clearTimeout(filterTimeout.current);
        filterTimeout.current = setTimeout(function() {
            var filters = cloneFilters(filtersToApply || d_filtersState);
            if (props.onFilter) props.onFilter(createEvent({
                filters: filters
            }));
            else {
                setFirstState(0);
                setFiltersState(filters);
            }
            if (props.onValueChange) props.onValueChange(processedData({
                filters: filters
            }));
        }, props.filterDelay);
    };
    var getActiveFilters = function getActiveFilters(filters) {
        var removeEmptyFilters = function removeEmptyFilters(_ref) {
            var _ref2 = $68eba9483912474c$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
            if (value.constraints) {
                var filteredConstraints = value.constraints.filter(function(constraint) {
                    return constraint.value !== null;
                });
                if (filteredConstraints.length > 0) return [
                    key,
                    $68eba9483912474c$var$_objectSpread($68eba9483912474c$var$_objectSpread({}, value), {}, {
                        constraints: filteredConstraints
                    })
                ];
            } else if (value.value !== null) return [
                key,
                value
            ];
            return undefined;
        };
        var filterValidEntries = function filterValidEntries(entry) {
            return entry !== undefined;
        };
        var entries = Object.entries(filters).map(removeEmptyFilters).filter(filterValidEntries);
        return Object.fromEntries(entries);
    };
    var filterLocal = function filterLocal(data, filters) {
        if (!data) return;
        var activeFilters = filters ? getActiveFilters(filters) : {};
        var columns = getColumns();
        var filteredValue = [];
        var isGlobalFilter = activeFilters.global || props.globalFilter;
        var globalFilterFieldsArray;
        if (isGlobalFilter) globalFilterFieldsArray = props.globalFilterFields || columns.filter(function(col) {
            return !getColumnProp(col, 'excludeGlobalFilter');
        }).map(function(col) {
            return getColumnProp(col, 'filterField') || getColumnProp(col, 'field');
        });
        for(var i = 0; i < data.length; i++){
            var localMatch = true;
            var globalMatch = false;
            var localFiltered = false;
            for(var prop in activeFilters){
                if (prop === 'null') continue;
                if (Object.prototype.hasOwnProperty.call(activeFilters, prop) && prop !== 'global') {
                    localFiltered = true;
                    var filterField = prop;
                    var filterMeta = activeFilters[filterField];
                    if (filterMeta.operator) for(var j = 0; j < filterMeta.constraints.length; j++){
                        var filterConstraint = filterMeta.constraints[j];
                        localMatch = executeLocalFilter(filterField, data[i], filterConstraint, j);
                        if (filterMeta.operator === (0, $51b25b42ecc1a0c7$export$9cc7a9d8d8c733ca).OR && localMatch || filterMeta.operator === (0, $51b25b42ecc1a0c7$export$9cc7a9d8d8c733ca).AND && !localMatch) break;
                    }
                    else localMatch = executeLocalFilter(filterField, data[i], filterMeta, 0);
                    if (!localMatch) break;
                }
            }
            if (localMatch && isGlobalFilter && !globalMatch && globalFilterFieldsArray) for(var _j = 0; _j < globalFilterFieldsArray.length; _j++){
                var globalFilterField = globalFilterFieldsArray[_j];
                var matchMode = activeFilters.global ? activeFilters.global.matchMode : props.globalFilterMatchMode;
                var value = activeFilters.global ? activeFilters.global.value : props.globalFilter;
                globalMatch = (0, $51b25b42ecc1a0c7$export$f4fb036b8adcc8c8).filters[matchMode]((0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(data[i], globalFilterField), value, props.filterLocale);
                if (globalMatch) break;
            }
            var matches = void 0;
            if (isGlobalFilter) matches = localFiltered ? localFiltered && localMatch && globalMatch : globalMatch;
            else matches = localFiltered && localMatch;
            if (matches) filteredValue.push(data[i]);
        }
        if (filteredValue.length === props.value.length || Object.keys(activeFilters).length === 0) filteredValue = data;
        return filteredValue;
    };
    var executeLocalFilter = function executeLocalFilter(field, rowData, filterMeta, index) {
        var filterValue = filterMeta.value;
        var filterMatchMode = filterMeta.matchMode === 'custom' ? "custom_".concat(field) : filterMeta.matchMode || (0, $51b25b42ecc1a0c7$export$b9fbdf9129f67822).STARTS_WITH;
        var dataFieldValue = (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(rowData, field);
        var filterConstraint = (0, $51b25b42ecc1a0c7$export$f4fb036b8adcc8c8).filters[filterMatchMode];
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).isFunction(filterConstraint) && filterConstraint(dataFieldValue, filterValue, props.filterLocale, index);
    };
    var cloneFilters = function cloneFilters(filters) {
        filters = filters || props.filters;
        var cloned = {};
        if (filters) Object.entries(filters).forEach(function(_ref3) {
            var _ref4 = $68eba9483912474c$var$_slicedToArray(_ref3, 2), prop = _ref4[0], value = _ref4[1];
            cloned[prop] = value.operator ? {
                operator: value.operator,
                constraints: value.constraints.map(function(constraint) {
                    return $68eba9483912474c$var$_objectSpread({}, constraint);
                })
            } : $68eba9483912474c$var$_objectSpread({}, value);
        });
        else {
            var _columns2 = getColumns();
            cloned = _columns2.reduce(function(filters, col) {
                var field = getColumnProp(col, 'filterField') || getColumnProp(col, 'field');
                var filterFunction = getColumnProp(col, 'filterFunction');
                var dataType = getColumnProp(col, 'dataType');
                var matchMode = getColumnProp(col, 'filterMatchMode') || (context && context.filterMatchModeOptions[dataType] || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).filterMatchModeOptions[dataType] ? context && context.filterMatchModeOptions[dataType][0] || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).filterMatchModeOptions[dataType][0] : (0, $51b25b42ecc1a0c7$export$b9fbdf9129f67822).STARTS_WITH);
                var constraint = {
                    value: null,
                    matchMode: matchMode
                };
                if (filterFunction) (0, $51b25b42ecc1a0c7$export$f4fb036b8adcc8c8).register("custom_".concat(field), function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return filterFunction.apply(void 0, args.concat([
                        {
                            column: col
                        }
                    ]));
                });
                filters[field] = props.filterDisplay === 'menu' ? {
                    operator: (0, $51b25b42ecc1a0c7$export$9cc7a9d8d8c733ca).AND,
                    constraints: [
                        constraint
                    ]
                } : constraint;
                return filters;
            }, {});
        }
        return cloned;
    };
    var filter = function filter(value, field, matchMode) {
        var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        var filters = $68eba9483912474c$var$_objectSpread({}, d_filtersState);
        var meta = filters[field];
        var constraint = meta && meta.operator ? meta.constraints[index] : meta;
        constraint = meta ? {
            value: value,
            matchMode: matchMode || constraint.matchMode
        } : {
            value: value,
            matchMode: matchMode
        };
        props.filterDisplay === 'menu' && meta && meta.operator ? filters[field].constraints[index] = constraint : filters[field] = constraint;
        setD_filtersState(filters);
        onFilterApply(filters);
    };
    var reset = function reset() {
        setD_rowsState(props.rows);
        setD_filtersState(cloneFilters(props.filters));
        setGroupRowsSortMetaState(null);
        setEditingMetaState({});
        if (!props.onPage) {
            setFirstState(props.first);
            setRowsState(props.rows);
        }
        if (!props.onSort) {
            setSortFieldState(props.sortField);
            setSortOrderState(props.sortOrder);
            setMultiSortMetaState(props.multiSortMeta);
        }
        if (!props.onFilter) setFiltersState(props.filters);
        resetColumnOrder();
    };
    var resetScroll = function resetScroll() {
        if (wrapperRef.current) {
            var scrollableContainer = !isVirtualScrollerDisabled() ? (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(wrapperRef.current, '[data-pc-name="virtualscroller"]') : wrapperRef.current;
            scrollableContainer.scrollTo(0, 0);
        }
    };
    var resetResizeColumnsWidth = function resetResizeColumnsWidth() {
        destroyStyleElement();
    };
    var resetColumnOrder = function resetColumnOrder() {
        var columns = getColumns(true);
        var columnOrder = [];
        if (columns) columnOrder = columns.reduce(function(orders, col) {
            orders.push(getColumnProp(col, 'columnKey') || getColumnProp(col, 'field'));
            return orders;
        }, []);
        setColumnOrderState(columnOrder);
    };
    var exportCSV = function exportCSV(options) {
        var data;
        var csv = "\uFEFF";
        var columns = getColumns();
        if (options && options.selectionOnly) data = props.selection || [];
        else data = [].concat($68eba9483912474c$var$_toConsumableArray(props.frozenValue || []), $68eba9483912474c$var$_toConsumableArray(processedData() || []));
        //headers
        columns.forEach(function(column, i) {
            var _ref5 = [
                getColumnProp(column, 'field'),
                getColumnProp(column, 'header'),
                getColumnProp(column, 'exportHeader'),
                getColumnProp(column, 'exportable')
            ], field = _ref5[0], header = _ref5[1], exportHeader = _ref5[2], exportable = _ref5[3];
            if (exportable && field) {
                var columnHeader = String(exportHeader || header || field).replace(/"/g, '""').replace(/\n/g, "\u2028");
                csv = csv + ('"' + columnHeader + '"');
                if (i < columns.length - 1) csv = csv + props.csvSeparator;
            }
        });
        //body
        data.forEach(function(record) {
            csv = csv + '\n';
            columns.forEach(function(column, i) {
                var _ref6 = [
                    getColumnProp(column, 'field'),
                    getColumnProp(column, 'exportField'),
                    getColumnProp(column, 'exportable')
                ], colField = _ref6[0], exportField = _ref6[1], exportable = _ref6[2];
                var field = exportField || colField;
                if (exportable && field) {
                    var cellData = (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(record, field);
                    if (cellData != null) {
                        if (props.exportFunction) cellData = props.exportFunction({
                            data: cellData,
                            field: field,
                            rowData: record,
                            column: column
                        });
                        else cellData = String(cellData).replace(/"/g, '""').replace(/\n/g, "\u2028");
                    } else cellData = '';
                    csv = csv + ('"' + cellData + '"');
                    if (i < columns.length - 1) csv = csv + props.csvSeparator;
                }
            });
        });
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).exportCSV(csv, props.exportFilename);
    };
    var closeEditingCell = function closeEditingCell() {
        if (props.editMode !== 'row') document.body.click();
    };
    var closeEditingRows = function closeEditingRows() {
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).find(document.body, '[data-pc-section="roweditorcancelbuttonprops"]').forEach(function(button, index) {
            setTimeout(function() {
                button.click();
            }, index * 5);
        });
    };
    var createEvent = function createEvent(event) {
        return $68eba9483912474c$var$_objectSpread({
            first: getFirst(),
            rows: getRows(),
            sortField: getSortField(),
            sortOrder: getSortOrder(),
            multiSortMeta: getMultiSortMeta(),
            filters: getFilters()
        }, event);
    };
    var processedData = function processedData(localState) {
        var data = props.value || [];
        if (!props.lazy) {
            if (data && data.length) {
                var filters = localState && localState.filters || getFilters();
                var sortField = localState && localState.sortField || getSortField();
                var sortOrder = localState && localState.sortOrder || getSortOrder();
                var multiSortMeta = localState && localState.multiSortMeta || getMultiSortMeta();
                var _columns3 = getColumns();
                var sortColumn = _columns3.find(function(col) {
                    return getColumnProp(col, 'field') === sortField;
                });
                if (sortColumn) {
                    columnSortable.current = getColumnProp(sortColumn, 'sortable');
                    columnSortFunction.current = getColumnProp(sortColumn, 'sortFunction');
                }
                if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(filters) || props.globalFilter) data = filterLocal(data, filters);
                if (sortField || (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(multiSortMeta)) {
                    if (props.sortMode === 'single') data = sortSingle(data, sortField, sortOrder);
                    else if (props.sortMode === 'multiple') data = sortMultiple(data, multiSortMeta);
                }
            }
        }
        return data;
    };
    var dataToRender = function dataToRender(data) {
        if (data && props.paginator) {
            var first = props.lazy ? 0 : getFirst();
            return data.slice(first, first + getRows());
        }
        return data;
    };
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        if (elementRef.current) {
            attributeSelector.current = (0, $a73ce425265b079e$export$d5d9b89141473caf)();
            elementRef.current.setAttribute(attributeSelector.current, '');
        }
        //setFiltersState(cloneFilters(props.filters)); // Github #4248
        setD_filtersState(cloneFilters(props.filters));
        if (isStateful()) {
            restoreState();
            if (props.resizableColumns) restoreColumnWidths();
        }
    });
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (props.responsiveLayout === 'stack' && !props.scrollable) createResponsiveStyle();
        return function() {
            destroyResponsiveStyle();
        };
    }, [
        props.breakpoint
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        var filters = cloneFilters(props.filters);
        setFiltersState(filters);
        setD_filtersState(cloneFilters(props.filters));
        if (props.onValueChange) props.onValueChange(processedData({
            filters: filters
        }));
    }, [
        props.filters
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (isStateful()) saveState();
    });
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        destroyResponsiveStyle();
        if (props.responsiveLayout === 'stack' && !props.scrollable) createResponsiveStyle();
    }, [
        props.responsiveLayout,
        props.scrollable
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (props.globalFilter) filter(props.globalFilter, 'global', props.globalFilterMatchMode);
        else // #3819 was filtering but now reset filter state
        if (d_filtersState['global']) {
            var filters = $68eba9483912474c$var$_objectSpread({}, d_filtersState);
            delete filters['global'];
            setD_filtersState(filters);
            onFilterApply(filters);
        }
    }, [
        props.globalFilter,
        props.globalFilterMatchMode
    ]);
    (0, $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96)(function() {
        unbindColumnResizeEvents();
        destroyStyleElement();
        destroyResponsiveStyle();
        destroyBeforeResizeStyleElement();
    });
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            clearState: clearState,
            closeEditingCell: closeEditingCell,
            closeEditingRows: closeEditingRows,
            exportCSV: exportCSV,
            filter: filter,
            reset: reset,
            resetColumnOrder: resetColumnOrder,
            resetScroll: resetScroll,
            resetResizeColumnsWidth: resetResizeColumnsWidth,
            restoreColumnWidths: restoreColumnWidths,
            restoreState: restoreState,
            restoreTableState: restoreTableState,
            saveState: saveState,
            getFilterMeta: function getFilterMeta() {
                return filtersState;
            },
            setFilterMeta: function setFilterMeta(filters) {
                return setFiltersState(filters);
            },
            getSortMeta: function getSortMeta() {
                return multiSortMetaState;
            },
            setSortMeta: function setSortMeta(sorts) {
                return setMultiSortMetaState(sorts);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getTable: function getTable() {
                return tableRef.current;
            },
            getVirtualScroller: function getVirtualScroller() {
                return virtualScrollerRef.current;
            }
        };
    });
    var createLoader = function createLoader() {
        if (props.loading) {
            var loadingIconProps = mergeProps({
                className: ptCallbacks.cx('loadingIcon')
            }, ptCallbacks.ptm('loadingIcon'));
            var icon = props.loadingIcon || /*#__PURE__*/ $acw62.createElement((0, $f693dcb2ccf8330b$export$fe708d541030d854), $68eba9483912474c$var$_extends({}, loadingIconProps, {
                spin: true
            }));
            var loadingIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $68eba9483912474c$var$_objectSpread({}, loadingIconProps), {
                props: props
            });
            var loadingOverlayProps = mergeProps({
                className: ptCallbacks.cx('loadingOverlay')
            }, ptCallbacks.ptm('loadingOverlay'));
            return /*#__PURE__*/ $acw62.createElement("div", loadingOverlayProps, loadingIcon);
        }
        return null;
    };
    var createHeader = function createHeader() {
        if (props.header) {
            var _content = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.header, {
                props: props
            });
            var headerProps = mergeProps({
                className: ptCallbacks.cx('header')
            }, ptCallbacks.ptm('header'));
            return /*#__PURE__*/ $acw62.createElement("div", headerProps, _content);
        }
        return null;
    };
    var createTableHeader = function createTableHeader(options, empty, _isVirtualScrollerDisabled) {
        if (props.showHeaders === false) return null;
        var sortField = getSortField();
        var sortOrder = getSortOrder();
        var multiSortMeta = $68eba9483912474c$var$_toConsumableArray(getMultiSortMeta());
        var groupRowSortField = getGroupRowSortField();
        var filters = d_filtersState;
        var filtersStore = !props.onFilter && props.filters || getFilters();
        var processedData = options.items, virtualScrollerProps = options.props, columns = options.columns;
        var data = _isVirtualScrollerDisabled || virtualScrollerProps.lazy ? processedData : virtualScrollerProps.items;
        return /*#__PURE__*/ $acw62.createElement($68eba9483912474c$var$TableHeader, {
            hostName: "DataTable",
            value: data,
            tableProps: props,
            columns: columns,
            tabIndex: props.tabIndex,
            empty: empty,
            headerColumnGroup: props.headerColumnGroup,
            resizableColumns: props.resizableColumns,
            onColumnResizeStart: onColumnResizeStart,
            onColumnResizerClick: props.onColumnResizerClick,
            onColumnResizerDoubleClick: props.onColumnResizerDoubleClick,
            sortMode: props.sortMode,
            sortField: sortField,
            sortIcon: props.sortIcon,
            sortOrder: sortOrder,
            multiSortMeta: multiSortMeta,
            groupRowsBy: props.groupRowsBy,
            groupRowSortField: groupRowSortField,
            onSortChange: onSortChange,
            filterDisplay: props.filterDisplay,
            filters: filters,
            filtersStore: filtersStore,
            filterIcon: props.filterIcon,
            filterClearIcon: props.filterClearIcon,
            onFilterChange: onFilterChange,
            onFilterApply: onFilterApply,
            showSelectAll: props.showSelectAll,
            allRowsSelected: allRowsSelected,
            onColumnCheckboxChange: onColumnHeaderCheckboxChange,
            onColumnMouseDown: onColumnHeaderMouseDown,
            onColumnDragStart: onColumnHeaderDragStart,
            onColumnDragOver: onColumnHeaderDragOver,
            onColumnDragLeave: onColumnHeaderDragLeave,
            onColumnDrop: onColumnHeaderDrop,
            rowGroupMode: props.rowGroupMode,
            reorderableColumns: props.reorderableColumns,
            ptCallbacks: ptCallbacks,
            metaData: metaData,
            unstyled: props.unstyled
        });
    };
    var createTableBody = function createTableBody(options, selectionModeInColumn, empty, isVirtualScrollerDisabled) {
        var first = getFirst();
        var rows = options.rows, columns = options.columns, contentRef = options.contentRef, style = options.style, className = options.className, spacerStyle = options.spacerStyle, itemSize = options.itemSize;
        var frozenBody = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.frozenValue) && /*#__PURE__*/ $acw62.createElement($68eba9483912474c$var$TableBody, {
            hostName: "DataTable",
            ref: frozenBodyRef,
            cellClassName: props.cellClassName,
            cellSelection: props.cellSelection,
            checkIcon: props.checkIcon,
            className: "p-datatable-tbody p-datatable-frozen-tbody",
            collapsedRowIcon: props.collapsedRowIcon,
            columns: columns,
            compareSelectionBy: props.compareSelectionBy,
            contextMenuSelection: props.contextMenuSelection,
            dataKey: props.dataKey,
            dragSelection: props.dragSelection,
            editMode: props.editMode,
            editingMeta: editingMetaState,
            editingRows: props.editingRows,
            emptyMessage: props.emptyMessage,
            expandableRowGroups: props.expandableRowGroups,
            expandedRowIcon: props.expandedRowIcon,
            expandedRows: props.expandedRows,
            first: first,
            frozenRow: true,
            groupRowsBy: props.groupRowsBy,
            isDataSelectable: props.isDataSelectable,
            isVirtualScrollerDisabled: true,
            lazy: props.lazy,
            loading: props.loading,
            metaKeySelection: props.metaKeySelection,
            onCellClick: props.onCellClick,
            onCellSelect: props.onCellSelect,
            onCellUnselect: props.onCellUnselect,
            onContextMenu: props.onContextMenu,
            onContextMenuSelectionChange: props.onContextMenuSelectionChange,
            onEditingMetaChange: onEditingMetaChange,
            onRowClick: props.onRowClick,
            onRowCollapse: props.onRowCollapse,
            onRowDoubleClick: props.onRowDoubleClick,
            onRowPointerDown: props.onRowPointerDown,
            onRowPointerUp: props.onRowPointerUp,
            onRowEditCancel: props.onRowEditCancel,
            onRowEditChange: props.onRowEditChange,
            onRowEditComplete: props.onRowEditComplete,
            onRowEditInit: props.onRowEditInit,
            onRowEditSave: props.onRowEditSave,
            onRowExpand: props.onRowExpand,
            onRowMouseEnter: props.onRowMouseEnter,
            onRowMouseLeave: props.onRowMouseLeave,
            onRowReorder: props.onRowReorder,
            onRowSelect: props.onRowSelect,
            onRowToggle: props.onRowToggle,
            onRowUnselect: props.onRowUnselect,
            onSelectionChange: props.onSelectionChange,
            paginator: props.paginator,
            reorderableRows: props.reorderableRows,
            responsiveLayout: props.responsiveLayout,
            rowClassName: props.rowClassName,
            rowEditValidator: props.rowEditValidator,
            rowEditorCancelIcon: props.rowEditorCancelIcon,
            rowEditorInitIcon: props.rowEditorInitIcon,
            rowEditorSaveIcon: props.rowEditorSaveIcon,
            rowExpansionTemplate: props.rowExpansionTemplate,
            rowGroupFooterTemplate: props.rowGroupFooterTemplate,
            rowGroupHeaderTemplate: props.rowGroupHeaderTemplate,
            rowGroupMode: props.rowGroupMode,
            scrollable: props.scrollable,
            selectOnEdit: props.selectOnEdit,
            selection: props.selection,
            selectionAutoFocus: props.selectionAutoFocus,
            selectionMode: props.selectionMode,
            selectionModeInColumn: selectionModeInColumn,
            showRowReorderElement: props.showRowReorderElement,
            showSelectionElement: props.showSelectionElement,
            tabIndex: props.tabIndex,
            tableProps: props,
            tableSelector: attributeSelector.current,
            value: props.frozenValue,
            virtualScrollerOptions: options,
            ptCallbacks: ptCallbacks,
            metaData: metaData,
            unstyled: props.unstyled
        });
        var body = /*#__PURE__*/ $acw62.createElement($68eba9483912474c$var$TableBody, {
            hostName: "DataTable",
            ref: bodyRef,
            cellClassName: props.cellClassName,
            cellSelection: props.cellSelection,
            checkIcon: props.checkIcon,
            className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-datatable-tbody', className),
            collapsedRowIcon: props.collapsedRowIcon,
            columns: columns,
            compareSelectionBy: props.compareSelectionBy,
            contextMenuSelection: props.contextMenuSelection,
            dataKey: props.dataKey,
            dragSelection: props.dragSelection,
            editMode: props.editMode,
            editingMeta: editingMetaState,
            editingRows: props.editingRows,
            empty: empty,
            emptyMessage: props.emptyMessage,
            expandableRowGroups: props.expandableRowGroups,
            expandedRowIcon: props.expandedRowIcon,
            expandedRows: props.expandedRows,
            first: first,
            frozenRow: false,
            groupRowsBy: props.groupRowsBy,
            isDataSelectable: props.isDataSelectable,
            isVirtualScrollerDisabled: isVirtualScrollerDisabled,
            lazy: props.lazy,
            loading: props.loading,
            metaKeySelection: props.metaKeySelection,
            onCellClick: props.onCellClick,
            onCellSelect: props.onCellSelect,
            onCellUnselect: props.onCellUnselect,
            onContextMenu: props.onContextMenu,
            onContextMenuSelectionChange: props.onContextMenuSelectionChange,
            onEditingMetaChange: onEditingMetaChange,
            onRowClick: props.onRowClick,
            onRowCollapse: props.onRowCollapse,
            onRowDoubleClick: props.onRowDoubleClick,
            onRowEditCancel: props.onRowEditCancel,
            onRowEditChange: props.onRowEditChange,
            onRowEditComplete: props.onRowEditComplete,
            onRowEditInit: props.onRowEditInit,
            onRowEditSave: props.onRowEditSave,
            onRowExpand: props.onRowExpand,
            onRowMouseEnter: props.onRowMouseEnter,
            onRowMouseLeave: props.onRowMouseLeave,
            onRowPointerDown: props.onRowPointerDown,
            onRowPointerUp: props.onRowPointerUp,
            onRowReorder: props.onRowReorder,
            onRowSelect: props.onRowSelect,
            onRowToggle: props.onRowToggle,
            onRowUnselect: props.onRowUnselect,
            onSelectionChange: props.onSelectionChange,
            paginator: props.paginator,
            reorderableRows: props.reorderableRows,
            responsiveLayout: props.responsiveLayout,
            rowClassName: props.rowClassName,
            rowEditValidator: props.rowEditValidator,
            rowEditorCancelIcon: props.rowEditorCancelIcon,
            rowEditorInitIcon: props.rowEditorInitIcon,
            rowEditorSaveIcon: props.rowEditorSaveIcon,
            rowExpansionTemplate: props.rowExpansionTemplate,
            rowGroupFooterTemplate: props.rowGroupFooterTemplate,
            rowGroupHeaderTemplate: props.rowGroupHeaderTemplate,
            rowGroupMode: props.rowGroupMode,
            scrollable: props.scrollable,
            selectOnEdit: props.selectOnEdit,
            selection: props.selection,
            selectionAutoFocus: props.selectionAutoFocus,
            selectionMode: props.selectionMode,
            selectionModeInColumn: selectionModeInColumn,
            showRowReorderElement: props.showRowReorderElement,
            showSelectionElement: props.showSelectionElement,
            style: style,
            tabIndex: props.tabIndex,
            tableProps: props,
            tableSelector: attributeSelector.current,
            value: dataToRender(rows),
            virtualScrollerContentRef: contentRef,
            virtualScrollerOptions: options,
            ptCallbacks: ptCallbacks,
            metaData: metaData,
            unstyled: props.unstyled
        });
        var spacerBody = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(spacerStyle) ? /*#__PURE__*/ $acw62.createElement($68eba9483912474c$var$TableBody, {
            hostName: "DataTable",
            style: {
                height: "calc(".concat(spacerStyle.height, " - ").concat(rows.length * itemSize, "px)")
            },
            className: "p-datatable-virtualscroller-spacer",
            ptCallbacks: ptCallbacks,
            metaData: metaData,
            unstyled: props.unstyled
        }) : null;
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, frozenBody, body, spacerBody);
    };
    var createTableFooter = function createTableFooter(options) {
        var columns = options.columns;
        return /*#__PURE__*/ $acw62.createElement($68eba9483912474c$var$TableFooter, {
            hostName: "DataTable",
            tableProps: props,
            columns: columns,
            footerColumnGroup: props.footerColumnGroup,
            ptCallbacks: ptCallbacks,
            metaData: metaData,
            unstyled: props.unstyled
        });
    };
    var createContent = function createContent(processedData, columns, selectionModeInColumn, empty) {
        if (!columns) return;
        var _isVirtualScrollerDisabled = isVirtualScrollerDisabled();
        var virtualScrollerOptions = props.virtualScrollerOptions || {};
        var wrapperProps = mergeProps({
            className: ptCallbacks.cx('wrapper'),
            style: $68eba9483912474c$var$_objectSpread($68eba9483912474c$var$_objectSpread({}, ptCallbacks.sx('wrapper')), {}, {
                maxHeight: _isVirtualScrollerDisabled ? props.scrollHeight : null
            })
        }, ptCallbacks.ptm('wrapper'));
        return /*#__PURE__*/ $acw62.createElement("div", $68eba9483912474c$var$_extends({
            ref: wrapperRef
        }, wrapperProps), /*#__PURE__*/ $acw62.createElement((0, $50cb59e69476e4bf$export$fbd4ea7fe0fb889), $68eba9483912474c$var$_extends({
            ref: virtualScrollerRef
        }, virtualScrollerOptions, {
            items: processedData,
            columns: columns,
            style: $68eba9483912474c$var$_objectSpread($68eba9483912474c$var$_objectSpread({}, virtualScrollerOptions.style), {
                height: props.scrollHeight !== 'flex' ? props.scrollHeight : undefined
            }),
            scrollHeight: props.scrollHeight !== 'flex' ? undefined : '100%',
            disabled: _isVirtualScrollerDisabled,
            loaderDisabled: true,
            inline: true,
            autoSize: true,
            pt: ptCallbacks.ptm('virtualScroller'),
            __parentMetadata: {
                parent: metaData
            },
            showSpacer: false,
            unstyled: props.unstyled,
            contentTemplate: function contentTemplate(options) {
                var ref = function ref(el) {
                    tableRef.current = el;
                    options.spacerRef && options.spacerRef(el);
                };
                var tableHeader = createTableHeader(options, empty, _isVirtualScrollerDisabled);
                var tableBody = createTableBody(options, selectionModeInColumn, empty, _isVirtualScrollerDisabled);
                var tableFooter = createTableFooter(options);
                var tableProps = mergeProps({
                    className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.tableClassName, ptCallbacks.cx('table')),
                    style: props.tableStyle,
                    role: 'table'
                }, ptCallbacks.ptm('table'));
                return /*#__PURE__*/ $acw62.createElement("table", $68eba9483912474c$var$_extends({
                    ref: ref
                }, tableProps), tableHeader, tableBody, tableFooter);
            }
        })));
    };
    var createFooter = function createFooter() {
        if (props.footer) {
            var _content2 = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.footer, {
                props: props
            });
            var footerProps = mergeProps({
                className: ptCallbacks.cx('footer')
            }, ptCallbacks.ptm('footer'));
            return /*#__PURE__*/ $acw62.createElement("div", footerProps, _content2);
        }
        return null;
    };
    var createPaginator = function createPaginator(position, totalRecords) {
        return /*#__PURE__*/ $acw62.createElement((0, $6cec6232b30d1913$export$98986e0ddad1af5a), {
            first: getFirst(),
            rows: getRows(),
            pageLinkSize: props.pageLinkSize,
            className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.paginatorClassName, ptCallbacks.cx('paginator', {
                position: position
            })),
            onPageChange: onPageChange,
            template: props.paginatorTemplate,
            totalRecords: totalRecords,
            rowsPerPageOptions: props.rowsPerPageOptions,
            currentPageReportTemplate: props.currentPageReportTemplate,
            leftContent: props.paginatorLeft,
            rightContent: props.paginatorRight,
            alwaysShow: props.alwaysShowPaginator,
            dropdownAppendTo: props.paginatorDropdownAppendTo,
            pt: ptCallbacks.ptm('paginator'),
            unstyled: props.unstyled,
            __parentMetadata: {
                parent: metaData
            }
        });
    };
    var createPaginatorTop = function createPaginatorTop(totalRecords) {
        if (props.paginator && props.paginatorPosition !== 'bottom') return createPaginator('top', totalRecords);
        return null;
    };
    var createPaginatorBottom = function createPaginatorBottom(totalRecords) {
        if (props.paginator && props.paginatorPosition !== 'top') return createPaginator('bottom', totalRecords);
        return null;
    };
    var createResizeHelper = function createResizeHelper() {
        if (props.resizableColumns) {
            var resizeHelperProps = mergeProps({
                className: ptCallbacks.cx('resizeHelper'),
                style: ptCallbacks.sx('resizeHelper')
            }, ptCallbacks.ptm('resizeHelper'));
            return /*#__PURE__*/ $acw62.createElement("div", $68eba9483912474c$var$_extends({
                ref: resizeHelperRef
            }, resizeHelperProps));
        }
        return null;
    };
    var createReorderIndicators = function createReorderIndicators() {
        if (props.reorderableColumns) {
            var style = {
                position: 'absolute',
                display: 'none'
            };
            var reorderIndicatorUpProps = mergeProps({
                className: ptCallbacks.cx('reorderIndicatorUp'),
                style: ptCallbacks.sx('reorderIndicatorUp', {
                    style: style
                })
            }, ptCallbacks.ptm('reorderIndicatorUp'));
            var reorderIndicatorUpIconProps = mergeProps(ptCallbacks.ptm('reorderIndicatorUpIcon'));
            var reorderIndicatorUpIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(props.reorderIndicatorUpIcon || /*#__PURE__*/ $acw62.createElement((0, $52de9a7ac5fafbe2$export$1c939d3c9b6931b), reorderIndicatorUpIconProps), $68eba9483912474c$var$_objectSpread({}, reorderIndicatorUpIconProps), {
                props: props
            });
            var reorderIndicatorDownProps = mergeProps({
                className: ptCallbacks.cx('reorderIndicatorDown'),
                style: ptCallbacks.sx('reorderIndicatorDown', {
                    style: style
                })
            }, ptCallbacks.ptm('reorderIndicatorDown'));
            var reorderIndicatorDownIconProps = mergeProps(ptCallbacks.ptm('reorderIndicatorDownIcon'));
            var reorderIndicatorDownIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(props.reorderIndicatorDownIcon || /*#__PURE__*/ $acw62.createElement((0, $ea99738bd0d0eedb$export$f1a507b991affc46), reorderIndicatorDownIconProps), $68eba9483912474c$var$_objectSpread({}, reorderIndicatorDownIconProps), {
                props: props
            });
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("span", $68eba9483912474c$var$_extends({
                ref: reorderIndicatorUpRef
            }, reorderIndicatorUpProps), reorderIndicatorUpIcon), /*#__PURE__*/ $acw62.createElement("span", $68eba9483912474c$var$_extends({
                ref: reorderIndicatorDownRef
            }, reorderIndicatorDownProps), reorderIndicatorDownIcon));
        }
        return null;
    };
    var data = processedData();
    var columns = getColumns();
    var totalRecords = getTotalRecords(data);
    var empty = (0, $a73ce425265b079e$export$4855211e6b8ad895).isEmpty(data);
    var selectionModeInColumn = getSelectionModeInColumn(columns);
    var selectable = props.selectionMode || selectionModeInColumn;
    var loader = createLoader();
    var header = createHeader();
    var paginatorTop = createPaginatorTop(totalRecords);
    var content = createContent(data, columns, selectionModeInColumn, empty);
    var paginatorBottom = createPaginatorBottom(totalRecords);
    var footer = createFooter();
    var resizeHelper = createResizeHelper();
    var reorderIndicators = createReorderIndicators();
    var rootProps = mergeProps({
        id: props.id,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, ptCallbacks.cx('root', {
            selectable: selectable
        })),
        style: props.style,
        'data-scrollselectors': '.p-datatable-wrapper',
        'data-showgridlines': props.showGridlines
    }, $68eba9483912474c$var$DataTableBase.getOtherProps(props), ptCallbacks.ptm('root'));
    return /*#__PURE__*/ $acw62.createElement("div", $68eba9483912474c$var$_extends({
        ref: elementRef
    }, rootProps), loader, header, paginatorTop, content, paginatorBottom, footer, resizeHelper, reorderIndicators);
});
$68eba9483912474c$export$df30df7ec97b32b5.displayName = 'DataTable';


'use client';
var $f8e4d38781145a41$export$816b5d811295e6bc = function Column() {};
//@todo Pass Parent MetaData
$f8e4d38781145a41$export$816b5d811295e6bc.displayName = 'Column';






const $57ee609582c542b6$export$2f50c9ccc17bc06a = {
    1: {
        'Nowy Rok': '0101',
        "Trzech Kr\xf3li": '0106',
        "\u015Awi\u0119to Pracy": '0501',
        "\u015Awi\u0119to Konstytucji 3 Maja": '0503',
        "\u015Awi\u0119to Narodowe 15 Sierpnia": '0815',
        "\u015Awi\u0119to Wszystkich \u015Awi\u0119tych": '1101',
        "\u015Awi\u0119to Niepodleg\u0142o\u015Bci": '1111',
        "Bo\u017Ce Narodzenie (pierwszy dzie\u0144)": '1225',
        "Bo\u017Ce Narodzenie (drugi dzie\u0144)": '1226',
        'Wielkanoc': 'W',
        "Poniedzia\u0142ek Wielkanocny": 'W+1',
        "Zielone \u015Awi\u0105tki": 'W+49',
        "Bo\u017Ce Cia\u0142o": 'W+60'
    },
    2: {
        'Nowy Rok': '0101',
        "Bo\u017Ce Narodzenie (pierwszy dzie\u0144)": '1225',
        "Bo\u017Ce Narodzenie (drugi dzie\u0144)": '1226',
        'Wielkanoc': 'W',
        "Poniedzia\u0142ek Wielkanocny": 'W+1'
    },
    3: {
        'Nowy Rok': '0101',
        "Bo\u017Ce Narodzenie (pierwszy dzie\u0144)": '1225',
        'Wielkanoc': 'W'
    },
    4: {
        "Wigilia Bo\u017Cego Narodzenia": '1224',
        'sylwester': '1231'
    },
    5: {
        'Wielka Sobota': 'W+-1',
        "Wielki Pi\u0105tek": 'W+-2',
        'Wielki Czwartek': 'W+-3'
    },
    6: {
        'Wielka Sobota': 'W+-1'
    },
    7: {
        '2 maja': '0502',
        "pi\u0105tek po Bo\u017Cym Ciele": 'W+61'
    }
};
function $57ee609582c542b6$export$2e2bcd8739ae039(dateString) {
    // Parsowanie daty
    const year = parseInt(dateString.substring(0, 4), 10);
    const month = parseInt(dateString.substring(4, 6), 10) - 1; // Miesiące w JS są zerobazowe
    const day = parseInt(dateString.substring(6, 8), 10);
    // Tworzenie obiektu Date
    const date = new Date(year, month, day);
    // Formatowanie daty do DD.MM.YYYY
    return date.toLocaleDateString("pl-PL");
}
function $57ee609582c542b6$export$294b5a2c8fb6dbfa(dateString) {
    if (!dateString) return null;
    const year = parseInt(dateString.substring(0, 4), 10);
    const month = parseInt(dateString.substring(4, 6), 10) - 1; // Miesiące są zerobazowe w JS
    const day = parseInt(dateString.substring(6, 8), 10);
    // Tworzenie obiektu Date
    return new Date(year, month, day);
}
function $57ee609582c542b6$export$443ababd588c81c9(date) {
    if (!date) return false;
    const year = date.getFullYear(); // Pobiera rok
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Miesiące są zerobazowe, więc dodaj 1
    const day = String(date.getDate()).padStart(2, '0'); // Dodaj wiodące zero, jeśli potrzeba
    return `${year}${month}${day}`;
}
function $57ee609582c542b6$export$f403be5580bb4449(dateStr) {
    const [day, month, year] = dateStr.split('.').map(Number);
    return new Date(year, month - 1, day); // Miesiące w JS są indeksowane od 0
}
function $57ee609582c542b6$export$1ba6550947cefd28(startDate, endDate, holidaySet) {
    let begining;
    let ending;
    begining = startDate;
    ending = endDate;
    dateList = [];
    for(let i = begining.getFullYear(); i <= ending.getFullYear(); i++)//dla każdego roku z przedziału...
    //oblicz święta stałe
    for (const [key, value] of Object.entries(holidaySet)){
        let holiday;
        //data święta
        if (value[0] === 'W') {
            //święto ruchome
            let odlegloscOdWielkanocy = 0;
            if (value.length > 1) {
                let substr = value.split('+');
                odlegloscOdWielkanocy = parseInt(substr[1]);
            }
            moveableFeastDate = $57ee609582c542b6$var$calculateEaster(i, true);
            moveableFeastDate.setDate(moveableFeastDate.getDate() + odlegloscOdWielkanocy);
            if (moveableFeastDate >= begining && moveableFeastDate <= ending) dateList.push(String(moveableFeastDate.getFullYear()) + String(moveableFeastDate.getMonth() + 1).padStart(2, 0) + String(moveableFeastDate.getDate()).padStart(2, 0));
        } else {
            //święto nieruchome
            holiday = $57ee609582c542b6$export$294b5a2c8fb6dbfa(i.toString() + value.toString());
            if (holiday >= begining && holiday <= ending) dateList.push(i.toString() + value.toString());
        }
    }
    dateList.sort();
    return dateList;
}
function $57ee609582c542b6$var$calculateEaster(rok, zwrocObiektDaty = false) {
    var a = rok % 19;
    var b = Math.floor(rok / 100);
    var c = rok % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var p = (h + l - 7 * m + 114) % 31;
    var dzien = p + 1;
    var miesiac = Math.floor((h + l - 7 * m + 114) / 31);
    if (zwrocObiektDaty) return new Date(rok, miesiac - 1, dzien);
    else return String(rok) + String(miesiac).padStart(2, 0) + String(dzien).padStart(2, 0);
}
function $57ee609582c542b6$export$b5e0a67a7694b7fe(timeString) {
    if (typeof timeString !== 'string') return false;
    const [hours, minutes, seconds = 0] = timeString.split(":").map(Number);
    const date = new Date();
    date.setHours(hours % 24, minutes, seconds, 0);
    return date;
}
function $57ee609582c542b6$export$7ba7d389fd0af3e(date, addDay = 0) {
    if (date) {
        const hours = addDay ? Number(date.getHours() + addDay * 24).toString().padStart(2, '0') : date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds();
        if (seconds !== 0) return `${hours}:${minutes}:${seconds.toString().padStart(2, '0')}`;
        else return `${hours}:${minutes}`;
    }
}
function $57ee609582c542b6$export$97f3bd6a84b329eb(gtfsTimeString) {
    if (typeof gtfsTimeString !== 'string') return null;
    let addDay = 0;
    let dayIndicator = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    let gtfsTimeArray = gtfsTimeString.split(':');
    if (gtfsTimeArray.length > 3) return null;
    if (parseInt(gtfsTimeArray[0]) > 23) {
        addDay = Math.floor(parseInt(gtfsTimeArray[0]) / 24);
        gtfsTimeArray[0] = parseInt(gtfsTimeArray[0]) - addDay * 24;
        gtfsTimeArray[0] = gtfsTimeArray[0] <= 9 ? '0' + gtfsTimeArray[0].toString() : gtfsTimeArray[0].toString();
        dayIndicator = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("sup", {
            className: "text-green-500 text-xs",
            title: addDay === 1 ? "nast\u0119pnego dnia" : '+ ' + addDay + ' dni',
            children: [
                "+",
                addDay,
                "\xa0d."
            ]
        });
    }
    return gtfsTimeArray[2] === '00' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            " ",
            gtfsTimeArray[0] + ':' + gtfsTimeArray[1],
            dayIndicator,
            " "
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            " ",
            gtfsTimeArray[0] + ':' + gtfsTimeArray[1],
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("sub", {
                className: "text-xs text-400",
                children: [
                    ":",
                    gtfsTimeArray[2]
                ]
            }),
            dayIndicator
        ]
    });
}
function $57ee609582c542b6$export$acbf344db7f7262e(gtfsTimeString) {
    // Rozdzielenie czasu na godziny, minuty i ewentualnie sekundy
    const [godziny, minuty, sekundy = 0] = gtfsTimeString.split(':').map(Number);
    // Obliczenie całkowitej liczby sekund
    return godziny * 3600 + minuty * 60 + sekundy;
}
function $57ee609582c542b6$export$810cbdbd69486b75(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor(seconds % 3600 / 60);
    const secs = seconds % 60;
    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(secs).padStart(2, '0');
    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}
function $57ee609582c542b6$export$aa15578fa4825bd5(timeString) {
    const regex = /^(\d{1,}):([0-5]?\d)(:([0-5]?\d))?$/;
    const match = timeString.match(regex);
    if (!match) return false;
    const hours = parseInt(match[1], 10);
    const minutes = parseInt(match[2], 10);
    const seconds = match[4] !== undefined ? parseInt(match[4], 10) : null;
    // Walidacja minut i sekund
    if (minutes >= 60 || seconds !== null && seconds >= 60) return false;
    return true;
}


function $f887be4558783b79$export$7a9784aa1942d522() {
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const toolDispatch = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$6bbcf3368996eea5));
    const { isPending: isPending, error: error, data: data } = (0, $4529664c1ee19d35$export$c3a687f3d6e3fb65)('trips');
    if (isPending || !data) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec34a5c615255cb$export$dcc7532e7120780d), {});
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                className: "fa-solid fa-face-frown fa-5x"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            "Wyst\u0105pi\u0142 b\u0142\u0105d \u0142adowania kurs\xf3w: ",
            error.message
        ]
    });
    const headerCalIco = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
        className: "fa-solid fa-calendar-days"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $68eba9483912474c$export$df30df7ec97b32b5), {
        paginator: true,
        rows: 18,
        rowsPerPageOptions: [
            18,
            36,
            50,
            100,
            200
        ],
        style: {
            minWidth: '48vw'
        },
        scrollHeight: "81.5vh",
        removableSort: true,
        scrollable: true,
        dataKey: "trip_id",
        value: data,
        size: "small",
        stripedRows: true,
        selectionMode: "single",
        selection: tool.selection ? tool.selection : [],
        onRowDoubleClick: (e)=>{
            toolDispatch({
                type: 'changed',
                newTool: {
                    ...tool,
                    selection: e.data,
                    propertyEditor: {
                        edit: e.data
                    }
                }
            });
        },
        onSelectionChange: (e)=>{
            console.log('onSelChg', e);
            toolDispatch({
                type: 'changed',
                newTool: {
                    ...tool,
                    selection: e.value,
                    propertyEditor: null
                }
            });
        },
        tableStyle: {
            minWidth: '50rem'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8e4d38781145a41$export$816b5d811295e6bc), {
                field: "trip_id",
                sortable: true,
                headerTooltipOptions: {
                    position: "bottom"
                },
                headerTooltip: "Nr kursu",
                header: "Nr"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8e4d38781145a41$export$816b5d811295e6bc), {
                field: "route_id",
                filter: true,
                headerTooltipOptions: {
                    position: "bottom"
                },
                headerTooltip: "ID linii",
                sortable: true,
                header: "L."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8e4d38781145a41$export$816b5d811295e6bc), {
                field: "service_id",
                filter: true,
                sortable: true,
                headerTooltipOptions: {
                    position: "bottom"
                },
                headerTooltip: "Kalendarz",
                header: headerCalIco
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8e4d38781145a41$export$816b5d811295e6bc), {
                field: "first_departure_time",
                sortable: true,
                headerTooltipOptions: {
                    position: "bottom"
                },
                headerTooltip: "Godzina odjazdu z przystanku pocz\u0105tkowego",
                header: "O.",
                body: (trip)=>(0, $57ee609582c542b6$export$97f3bd6a84b329eb)(trip.first_departure_time)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8e4d38781145a41$export$816b5d811295e6bc), {
                field: "first_stop_name",
                filter: true,
                sortable: true,
                headerTooltipOptions: {
                    position: "bottom"
                },
                headerTooltip: "Nazwa przystanku pocz\u0105tkowego",
                header: "\uD83D\uDE8F Pocz\u0105tek"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8e4d38781145a41$export$816b5d811295e6bc), {
                field: "last_stop_name",
                filter: true,
                sortable: true,
                headerTooltipOptions: {
                    position: "bottom"
                },
                headerTooltip: "Nazwa przystanku ko\u0144cowego",
                header: "\uD83D\uDE8F Koniec"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8e4d38781145a41$export$816b5d811295e6bc), {
                field: "last_arrival_time",
                headerTooltipOptions: {
                    position: "bottom"
                },
                headerTooltip: "Godzina przyjazdu na przystanek ko\u0144cowy",
                sortable: true,
                header: "P.",
                body: (trip)=>(0, $57ee609582c542b6$export$97f3bd6a84b329eb)(trip.last_arrival_time)
            })
        ]
    });
}






var $acw62 = parcelRequire("acw62");














var $acw62 = parcelRequire("acw62");




'use client';
function $afb81e7f5a1693f5$var$_extends() {
    return $afb81e7f5a1693f5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $afb81e7f5a1693f5$var$_extends.apply(null, arguments);
}
function $afb81e7f5a1693f5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $afb81e7f5a1693f5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $afb81e7f5a1693f5$var$_typeof(o);
}
function $afb81e7f5a1693f5$var$toPrimitive(t, r) {
    if ("object" != $afb81e7f5a1693f5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $afb81e7f5a1693f5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $afb81e7f5a1693f5$var$toPropertyKey(t) {
    var i = $afb81e7f5a1693f5$var$toPrimitive(t, "string");
    return "symbol" == $afb81e7f5a1693f5$var$_typeof(i) ? i : i + "";
}
function $afb81e7f5a1693f5$var$_defineProperty(e, r, t) {
    return (r = $afb81e7f5a1693f5$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $afb81e7f5a1693f5$var$TimelineBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'Timeline',
        align: 'left',
        className: null,
        content: null,
        dataKey: null,
        layout: 'vertical',
        marker: null,
        opposite: null,
        value: null,
        children: undefined
    },
    css: {
        classes: {
            marker: 'p-timeline-event-marker',
            connector: 'p-timeline-event-connector',
            event: 'p-timeline-event',
            opposite: 'p-timeline-event-opposite',
            separator: 'p-timeline-event-separator',
            content: 'p-timeline-event-content',
            root: function root(_ref) {
                var props = _ref.props;
                return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-timeline p-component', $afb81e7f5a1693f5$var$_defineProperty($afb81e7f5a1693f5$var$_defineProperty({}, "p-timeline-".concat(props.align), true), "p-timeline-".concat(props.layout), true), props.className);
            }
        },
        styles: "\n        @layer primereact {\n            .p-timeline {\n                display: flex;\n                flex-grow: 1;\n                flex-direction: column;\n            }\n        \n            .p-timeline-left .p-timeline-event-opposite {\n                text-align: right;\n            }\n        \n            .p-timeline-left .p-timeline-event-content {\n                text-align: left;\n            }\n        \n            .p-timeline-right .p-timeline-event {\n                flex-direction: row-reverse;\n            }\n        \n            .p-timeline-right .p-timeline-event-opposite {\n                text-align: left;\n            }\n        \n            .p-timeline-right .p-timeline-event-content {\n                text-align: right;\n            }\n        \n            .p-timeline-vertical.p-timeline-alternate .p-timeline-event:nth-child(even) {\n                flex-direction: row-reverse;\n            }\n        \n            .p-timeline-vertical.p-timeline-alternate .p-timeline-event:nth-child(odd) .p-timeline-event-opposite {\n                text-align: right;\n            }\n        \n            .p-timeline-vertical.p-timeline-alternate .p-timeline-event:nth-child(odd) .p-timeline-event-content {\n                text-align: left;\n            }\n        \n            .p-timeline-vertical.p-timeline-alternate .p-timeline-event:nth-child(even) .p-timeline-event-opposite {\n                text-align: left;\n            }\n        \n            .p-timeline-vertical.p-timeline-alternate .p-timeline-event:nth-child(even) .p-timeline-event-content {\n                text-align: right;\n            }\n        \n            .p-timeline-event {\n                display: flex;\n                position: relative;\n                min-height: 70px;\n            }\n        \n            .p-timeline-event:last-child {\n                min-height: 0;\n            }\n        \n            .p-timeline-event-opposite {\n                flex: 1;\n                padding: 0 1rem;\n            }\n        \n            .p-timeline-event-content {\n                flex: 1;\n                padding: 0 1rem;\n            }\n        \n            .p-timeline-event-separator {\n                flex: 0;\n                display: flex;\n                align-items: center;\n                flex-direction: column;\n            }\n        \n            .p-timeline-event-marker {\n                display: flex;\n                align-self: baseline;\n            }\n        \n            .p-timeline-event-connector {\n                flex-grow: 1;\n            }\n        \n            .p-timeline-horizontal {\n                flex-direction: row;\n            }\n        \n            .p-timeline-horizontal .p-timeline-event {\n                flex-direction: column;\n                flex: 1;\n            }\n        \n            .p-timeline-horizontal .p-timeline-event:last-child {\n                flex: 0;\n            }\n        \n            .p-timeline-horizontal .p-timeline-event-separator {\n                flex-direction: row;\n            }\n        \n            .p-timeline-horizontal .p-timeline-event-connector  {\n                width: 100%;\n            }\n        \n            .p-timeline-bottom .p-timeline-event {\n                flex-direction: column-reverse;\n            }\n        \n            .p-timeline-horizontal.p-timeline-alternate .p-timeline-event:nth-child(even) {\n                flex-direction: column-reverse;\n            }\n        }\n    "
    }
});
var $afb81e7f5a1693f5$export$e6a97ba2cae5bb94 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $afb81e7f5a1693f5$var$TimelineBase.getProps(inProps, context);
    var _TimelineBase$setMeta = $afb81e7f5a1693f5$var$TimelineBase.setMetaData({
        props: props
    }), ptm = _TimelineBase$setMeta.ptm, cx = _TimelineBase$setMeta.cx, isUnstyled = _TimelineBase$setMeta.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($afb81e7f5a1693f5$var$TimelineBase.css.styles, isUnstyled, {
        name: 'timeline'
    });
    var getPTOptions = function getPTOptions(key, index) {
        return ptm(key, {
            context: {
                index: index
            }
        });
    };
    var elementRef = $acw62.useRef(null);
    var getKey = function getKey(item, index) {
        return props.dataKey ? (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(item, props.dataKey) : "pr_id__".concat(index);
    };
    var createEvents = function createEvents() {
        return props.value && props.value.map(function(item, index) {
            var opposite = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.opposite, item, index);
            var markerProps = mergeProps({
                className: cx('marker')
            }, getPTOptions('marker', index));
            var marker = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.marker, item, index) || /*#__PURE__*/ $acw62.createElement("div", markerProps);
            var connectorProps = mergeProps({
                className: cx('connector')
            }, getPTOptions('connector', index));
            var connector = index !== props.value.length - 1 && /*#__PURE__*/ $acw62.createElement("div", connectorProps);
            var content = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.content, item, index);
            var eventProps = mergeProps({
                className: cx('event')
            }, getPTOptions('event', index));
            var oppositeProps = mergeProps({
                className: cx('opposite')
            }, getPTOptions('opposite', index));
            var separatorProps = mergeProps({
                className: cx('separator')
            }, getPTOptions('separator', index));
            var contentProps = mergeProps({
                className: cx('content')
            }, getPTOptions('content', index));
            return /*#__PURE__*/ $acw62.createElement("div", $afb81e7f5a1693f5$var$_extends({
                key: getKey(item, index)
            }, eventProps), /*#__PURE__*/ $acw62.createElement("div", oppositeProps, opposite), /*#__PURE__*/ $acw62.createElement("div", separatorProps, marker, connector), /*#__PURE__*/ $acw62.createElement("div", contentProps, content));
        });
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var events = createEvents();
    var rootProps = mergeProps({
        ref: elementRef,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root'))
    }, $afb81e7f5a1693f5$var$TimelineBase.getOtherProps(props), ptm('root'));
    return /*#__PURE__*/ $acw62.createElement("div", rootProps, events);
}));
$afb81e7f5a1693f5$export$e6a97ba2cae5bb94.displayName = 'Timeline';






var $acw62 = parcelRequire("acw62");

function $1d6960ee2c70857c$export$ae057cadaccd07b0({ tripId: tripId }) {
    const [dialog, setDialog] = (0, $acw62.useState)(null);
    const { data: data, error: error, isPending: isPending } = (0, $4529664c1ee19d35$export$ac3dd26b67094cc3)('stop_times', tripId);
    if (!data || error || isPending) return;
    function findPreviousItem(data, item) {
        const index = data.indexOf(item);
        if (index > 0) return data[index - 1];
        else return null; // Zwraca null, jeśli obiekt docelowy znajduje się na początku lub nie istnieje w tablicy
    }
    const stopTimePrompt = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "komin-stop-times-add",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
            raised: true,
            size: "small",
            icon: "fa-solid fa-square-plus",
            severity: "success",
            style: {
                transform: 'translateY(-25%)',
                padding: '0'
            }
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            stopTimePrompt,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $afb81e7f5a1693f5$export$e6a97ba2cae5bb94), {
                className: "pb-4",
                value: data,
                dataKey: "kid",
                content: (item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "relative h-full",
                        children: [
                            item.kid !== data[0].kid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "absolute text-xs text-color-secondary",
                                style: {
                                    left: '-3rem',
                                    top: '-2rem'
                                },
                                children: [
                                    "+ ",
                                    findPreviousItem(data, item) && ((0, $57ee609582c542b6$export$acbf344db7f7262e)(item.arrival_time) - (0, $57ee609582c542b6$export$acbf344db7f7262e)(findPreviousItem(data, item).departure_time)) / 60,
                                    " min."
                                ]
                            }),
                            item.stop_name,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a79a81cc3b591c5$export$5d8a4b9af9ca5f5b), {
                                platformCode: item.platform_code
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "inline-block text-200 text-xs ml-2",
                                children: item.stop_id
                            }),
                            stopTimePrompt
                        ]
                    }),
                opposite: (item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                        children: [
                            item.arrival_time !== item.departure_time ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: (0, $57ee609582c542b6$export$97f3bd6a84b329eb)(item.arrival_time)
                            }) : '',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: (0, $57ee609582c542b6$export$97f3bd6a84b329eb)(item.departure_time)
                            })
                        ]
                    }),
                pt: {
                    opposite: {
                        style: {
                            flex: '0.24'
                        }
                    }
                }
            })
        ]
    });
}


function $b04cbb916e47f1c3$export$3e42b03d5f4efae0({ GTrip: GTrip }) {
    const header = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            "Kurs nr ",
            GTrip.trip_id,
            " ",
            GTrip.trip_short_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    " \u2014 ",
                    GTrip.trip_short_name
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8752d282f3fd7a50$export$7c61201097bd33b6), {
        resourceTable: "trips",
        selectedItemId: GTrip.trip_id,
        header: header,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b04cbb916e47f1c3$var$TripPropertiesForm, {})
    });
}
function $b04cbb916e47f1c3$var$TripPropertiesForm() {
    const id = (0, $acw62.useId)();
    const snap = (0, $acw62.useContext)((0, $7d6297100045faa6$export$83327a4f6aff409e));
    const modifyTrip = (0, $4529664c1ee19d35$export$5ecbcf6a102ccf18)();
    const data = (0, $acw62.useContext)((0, $65d01f18dbe7987a$export$58d75f9829cbe158));
    const handleOverlays = (0, $acw62.useContext)((0, $bdccf6b6a87b04cc$export$a2200b96afd16271));
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const [modifiedValues, setModifiedValues] = (0, $acw62.useState)(data.inputValues);
    const [validationErrors, setValidationErrors] = (0, $acw62.useState)(false);
    const [isMutationPending, setIsMutationPending] = (0, $acw62.useState)(false);
    const { data: routes } = (0, $4529664c1ee19d35$export$c3a687f3d6e3fb65)('routes');
    const { data: calendars } = (0, $4529664c1ee19d35$export$c3a687f3d6e3fb65)('calendars');
    function handleClickDelete() {}
    function handleInput(propertyName, value) {
        let newValues = {
            ...modifiedValues
        };
        newValues[propertyName] = value;
        setModifiedValues(newValues);
    }
    async function handleInputDone(propertyName, value) {
        if (value === data.inputValues[propertyName]) return; // Nie wysyłamy zmian na serwer, jeżeli nowa wartość jest taka jak już zapisana do serwera.
        const payload = {
            query: {
                modified_id: String(data.inputValues.trip_id),
                resourceTable: 'trips'
            },
            fields: {}
        };
        payload.fields[propertyName] = value;
        console.log('payload', payload);
        setIsMutationPending(true);
        try {
            const asyncMutation = await modifyTrip.mutateAsync(payload); // próbujemy przeprowadzić mutację
            // wykasuj ewentualne istniejące błędy walidacji z UI, skoro wszystko poszło ok
            if (validationErrors[propertyName]) {
                let updatedValidationErrors = {
                    ...validationErrors
                };
                updatedValidationErrors[propertyName] = false;
                setValidationErrors({
                    ...updatedValidationErrors
                });
            }
        } catch (error) {
            const errorCode = error.message.slice(0, 3);
            if (errorCode == '422') {
                //obsługa błędów walidacji
                let updatedValidationErrors = {
                    ...validationErrors
                };
                updatedValidationErrors[propertyName] = Object.values(error.cause.validation[propertyName]).join(', ');
                setValidationErrors({
                    ...updatedValidationErrors
                });
            } else {
                //obsługa pozostałych błędów
                handleOverlays('toast', {
                    severity: "error",
                    summary: "B\u0142\u0105d " + errorCode,
                    detail: typeof error.cause === 'undefined' || typeof error.cause.message === 'undefined' ? "Wyst\u0105pi\u0142 b\u0142\u0105d. Czynno\u015B\u0107 nie mog\u0142a zosta\u0107 zako\u0144czona powodzeniem. " + error.message : error.cause.message
                });
                console.log(error);
            }
        } finally{
            setIsMutationPending(false);
        }
    }
    function handleInputCancel() {
        setModifiedValues(data.inputValues);
    }
    const routesOptions = routes ? Object.values(routes) : [];
    const calendarsOptions = calendars ? Object.values(calendars) : [];
    const routeOptionTemplate = (option)=>{
        const item = option;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex align-items-center",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a665a3ac8a12ef4$export$f0b439f829a094d), {
                    GRoute: item
                }),
                item.route_short_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2cd10a5f6773a01$export$bfbea4d618559e4a), {
                    GRoute: item
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "text-sm",
                    children: [
                        item.route_short_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                            children: item.route_long_name
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                            className: "hover:text-orange-700",
                            style: {
                                display: "inline-block",
                                fontWeight: "normal",
                                backgroundColor: '#' + item.route_color,
                                color: '#' + item.route_text_color,
                                borderStyle: 'solid',
                                borderWidth: '0.5pt',
                                padding: '2px',
                                borderColor: '#' + item.route_text_color
                            },
                            children: item.route_long_name
                        }),
                        item.suspended ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-red-200",
                            children: " zawieszona "
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-200",
                            children: item.network_id
                        })
                    ]
                })
            ]
        });
    };
    const routeSelectedTemplate = (option, props)=>{
        if (option) {
            const item = option;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex align-items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a665a3ac8a12ef4$export$f0b439f829a094d), {
                        GRoute: item
                    }),
                    item.route_short_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2cd10a5f6773a01$export$bfbea4d618559e4a), {
                        GRoute: item
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-sm",
                        children: [
                            item.route_short_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                children: item.route_long_name
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                className: "hover:text-orange-700",
                                style: {
                                    display: "inline-block",
                                    fontWeight: "normal",
                                    backgroundColor: '#' + item.route_color,
                                    color: '#' + item.route_text_color,
                                    borderStyle: 'solid',
                                    borderWidth: '0.5pt',
                                    padding: '2px',
                                    borderColor: '#' + item.route_text_color
                                },
                                children: item.route_long_name
                            }),
                            item.suspended ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-red-200",
                                children: " zawieszona "
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-200",
                                children: item.network_id
                            })
                        ]
                    })
                ]
            });
        } else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            children: props.placeholder
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "formgrid grid",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "field col-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                            propertyName: "trip_id",
                            label: "Numer kursu",
                            id: id,
                            value: modifiedValues.trip_id,
                            initialVal: data.inputValues.trip_id,
                            onDone: handleInputDone,
                            onChange: handleInput,
                            onCancel: handleInputCancel,
                            /* invalid={validationErrors.stop_id} */ disabled: false,
                            pending: isMutationPending
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "field col-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                            propertyName: "trip_short_name",
                            label: "Publiczny numer kursu",
                            id: id,
                            value: modifiedValues.trip_short_name,
                            initialVal: data.inputValues.trip_short_name,
                            onDone: handleInputDone,
                            onChange: handleInput,
                            onCancel: handleInputCancel,
                            /* invalid={validationErrors.stop_id} */ disabled: false,
                            pending: isMutationPending
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "field col-12",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $193f2811aaebee8a$export$260594f1c0239dfe), {
                            propertyName: "route_id",
                            initialVal: data.inputValues.route_id,
                            label: "Nale\u017Cy do linii:",
                            options: routesOptions,
                            onDone: handleInputDone,
                            itemTemplate: routeOptionTemplate,
                            valueTemplate: routeSelectedTemplate,
                            optionValue: "route_id",
                            filter: true,
                            filterBy: "route_id,route_short_name,route_long_name",
                            filterInputAutoFocus: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "field col-12",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                            propertyName: "trip_headsign",
                            label: "Tablica kierunkowa:",
                            id: id,
                            value: modifiedValues.trip_headsign,
                            initialVal: data.inputValues.trip_headsign,
                            onDone: handleInputDone,
                            onChange: handleInput,
                            onCancel: handleInputCancel,
                            /* invalid={validationErrors.stop_id} */ disabled: false,
                            pending: isMutationPending
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "field col-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb72469920eab510$export$17c974d806bdef7f), {
                            id: id,
                            propertyName: "direction_id",
                            initialVal: data.inputValues.direction_id,
                            label: "Kierunek jazdy:",
                            options: [
                                {
                                    label: 'TAM',
                                    value: 0
                                },
                                {
                                    label: "POWR\xd3T",
                                    value: 1
                                }
                            ],
                            optionValue: "value"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "field col-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                            propertyName: "block_id",
                            label: "Nr brygady",
                            id: id,
                            value: modifiedValues.block_id,
                            initialVal: data.inputValues.block_id,
                            onDone: handleInputDone,
                            onChange: handleInput,
                            onCancel: handleInputCancel,
                            /* invalid={validationErrors.stop_id} */ disabled: false,
                            pending: isMutationPending
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "field col-12",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $193f2811aaebee8a$export$260594f1c0239dfe), {
                            propertyName: "service_id",
                            initialVal: data.inputValues.service_id,
                            label: "Kursuje wed\u0142ug kalendarza:",
                            options: calendarsOptions,
                            onDone: handleInputDone,
                            itemTemplate: (option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        option.service_id,
                                        " \u2013 ",
                                        option.service_description
                                    ]
                                }),
                            valueTemplate: (option, props)=>{
                                if (option) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        option.service_id,
                                        " \u2013 ",
                                        option.service_description
                                    ]
                                });
                                else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: props.placeholder
                                });
                            },
                            optionValue: "service_id",
                            optionLabel: "service_description",
                            filter: true,
                            filterBy: "service_id",
                            filterInputAutoFocus: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "field col-12",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb72469920eab510$export$17c974d806bdef7f), {
                            id: id,
                            propertyName: "wheelchair_accessible",
                            initialVal: data.inputValues.wheelchair_accessible,
                            label: "Dost\u0119pno\u015B\u0107 dla w\xf3zk\xf3w:",
                            options: [
                                {
                                    label: 'Brak info',
                                    value: 0
                                },
                                {
                                    label: "Dost\u0119pny",
                                    value: 1
                                },
                                {
                                    label: "Niedost\u0119pny",
                                    value: 2
                                }
                            ],
                            optionValue: "value",
                            onDone: handleInputDone
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "field col-12",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb72469920eab510$export$17c974d806bdef7f), {
                            id: id,
                            propertyName: "bikes_allowed",
                            initialVal: data.inputValues.bikes_allowed,
                            label: "Przew\xf3z rower\xf3w:",
                            options: [
                                {
                                    label: 'Brak info',
                                    value: 0
                                },
                                {
                                    label: "Mo\u017Cliwy",
                                    value: 1
                                },
                                {
                                    label: "Niemo\u017Cliwy",
                                    value: 2
                                }
                            ],
                            optionValue: "value",
                            onDone: handleInputDone
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "mt-3",
                children: "Trasa kursu"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d6960ee2c70857c$export$ae057cadaccd07b0), {
                tripId: tool.propertyEditor.edit.trip_id
            }, tool.propertyEditor.edit.trip_id)
        ]
    });
}



function $dd559f73ce48bb94$export$9f977905c4004548() {
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    let panelHeight = '82vh';
    let Panel;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                height: panelHeight
            },
            children: tool.propertyEditor == null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f887be4558783b79$export$7a9784aa1942d522), {
                className: "flex align-content-center"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b04cbb916e47f1c3$export$3e42b03d5f4efae0), {
                    GTrip: tool.propertyEditor.edit
                }, tool.propertyEditor.edit.trip_id)
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");








'use client';
function $dde48341f3da2113$var$_extends() {
    return $dde48341f3da2113$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $dde48341f3da2113$var$_extends.apply(null, arguments);
}
function $dde48341f3da2113$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dde48341f3da2113$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dde48341f3da2113$var$_typeof(o);
}
function $dde48341f3da2113$var$toPrimitive(t, r) {
    if ("object" != $dde48341f3da2113$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $dde48341f3da2113$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $dde48341f3da2113$var$toPropertyKey(t) {
    var i = $dde48341f3da2113$var$toPrimitive(t, "string");
    return "symbol" == $dde48341f3da2113$var$_typeof(i) ? i : i + "";
}
function $dde48341f3da2113$var$_defineProperty(e, r, t) {
    return (r = $dde48341f3da2113$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $dde48341f3da2113$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $dde48341f3da2113$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $dde48341f3da2113$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $dde48341f3da2113$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $dde48341f3da2113$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $dde48341f3da2113$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $dde48341f3da2113$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dde48341f3da2113$var$_slicedToArray(r, e) {
    return $dde48341f3da2113$var$_arrayWithHoles(r) || $dde48341f3da2113$var$_iterableToArrayLimit(r, e) || $dde48341f3da2113$var$_unsupportedIterableToArray(r, e) || $dde48341f3da2113$var$_nonIterableRest();
}
var $dde48341f3da2113$var$styles = "\n@layer primereact {\n    .p-contextmenu ul {\n        margin: 0;\n        padding: 0;\n        list-style: none;\n    }\n\n    .p-contextmenu .p-submenu-list {\n        position: absolute;\n        min-width: 100%;\n        z-index: 1;\n    }\n\n    .p-contextmenu .p-menuitem-link {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        text-decoration: none;\n        overflow: hidden;\n        position: relative;\n    }\n\n    .p-contextmenu .p-menuitem-text {\n        line-height: 1;\n    }\n\n    .p-contextmenu .p-menuitem {\n        position: relative;\n    }\n\n    .p-contextmenu .p-menuitem-link .p-submenu-icon {\n        margin-left: auto;\n    }\n\n    .p-contextmenu-enter {\n        opacity: 0;\n    }\n\n    .p-contextmenu-enter-active {\n        opacity: 1;\n        transition: opacity 250ms;\n    }\n}\n";
var $dde48341f3da2113$var$classes = {
    root: function root(_ref) {
        var context = _ref.context;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-contextmenu p-component', {
            'p-input-filled': context && context.inputStyle === 'filled' || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).inputStyle === 'filled',
            'p-ripple-disabled': context && context.ripple === false || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).ripple === false
        });
    },
    menu: function menu(_ref2) {
        var props = _ref2.menuProps;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)({
            ' p-contextmenu-root-list': props.root,
            'p-submenu-list': !props.root
        });
    },
    menuitem: function menuitem(_ref3) {
        var item = _ref3.item, active = _ref3.active, focused = _ref3.focused, disabled = _ref3.disabled;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-menuitem', {
            'p-menuitem-active p-highlight': active,
            'p-focus': focused,
            'p-disabled': disabled
        }, item.className);
    },
    action: function action(_ref4) {
        var item = _ref4.item;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-menuitem-link', {
            'p-disabled': item.disabled
        });
    },
    content: 'p-menuitem-content',
    icon: 'p-menuitem-icon',
    submenuIcon: 'p-submenu-icon',
    label: 'p-menuitem-text',
    separator: 'p-menuitem-separator',
    transition: 'p-contextmenu',
    submenuTransition: 'p-contextmenusub'
};
var $dde48341f3da2113$var$ContextMenuBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'ContextMenu',
        id: null,
        ariaLabel: null,
        ariaLabelledby: null,
        model: null,
        style: null,
        className: null,
        global: false,
        autoZIndex: true,
        baseZIndex: 0,
        tabIndex: 0,
        breakpoint: undefined,
        scrollHeight: '400px',
        appendTo: null,
        transitionOptions: null,
        onFocus: null,
        onBlur: null,
        onShow: null,
        onHide: null,
        submenuIcon: null,
        children: undefined
    },
    css: {
        classes: $dde48341f3da2113$var$classes,
        styles: $dde48341f3da2113$var$styles
    }
});
function $dde48341f3da2113$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dde48341f3da2113$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dde48341f3da2113$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $dde48341f3da2113$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dde48341f3da2113$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dde48341f3da2113$var$ContextMenuSub = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var submenuRef = $acw62.useRef(null);
    var active = props.root || !props.resetMenu;
    var ptm = props.ptm, cx = props.cx;
    var getPTOptions = function getPTOptions(processedItem, key, index) {
        return ptm(key, {
            hostName: props.hostName,
            context: {
                active: isItemActive(processedItem),
                focused: isItemFocused(processedItem),
                disabled: isItemDisabled(processedItem),
                index: index
            }
        });
    };
    var onItemMouseEnter = function onItemMouseEnter(event, item) {
        if (item.disabled || props.isMobileMode) {
            event.preventDefault();
            return;
        }
        props.onItemMouseEnter({
            originalEvent: event,
            processedItem: item
        });
    };
    var onItemClick = function onItemClick(event, processedItem) {
        var item = processedItem.item;
        if (item.disabled) {
            event.preventDefault();
            return;
        }
        if (item.command) item.command({
            originalEvent: event,
            item: item
        });
        props.onItemClick({
            originalEvent: event,
            processedItem: processedItem,
            isFocus: true
        });
        if (!item.items) props.onLeafClick(event);
        if (!item.url) {
            event.preventDefault();
            event.stopPropagation();
        }
    };
    var position = function position() {
        if (!props.isMobileMode) {
            var parentItem = submenuRef.current.parentElement;
            var containerOffset = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOffset(parentItem);
            var viewport = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getViewport();
            var sublistWidth = submenuRef.current.offsetParent ? submenuRef.current.offsetWidth : (0, $a73ce425265b079e$export$ff8ccbac9225de62).getHiddenElementOuterWidth(submenuRef.current);
            var itemOuterWidth = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(parentItem.children[0]);
            var top = parseInt(containerOffset.top, 10) + submenuRef.current.offsetHeight - (0, $a73ce425265b079e$export$ff8ccbac9225de62).getWindowScrollTop();
            if (top > viewport.height) submenuRef.current.style.top = viewport.height - top + 'px';
            else submenuRef.current.style.top = '0px';
            if (parseInt(containerOffset.left, 10) + itemOuterWidth + sublistWidth > viewport.width - (0, $a73ce425265b079e$export$ff8ccbac9225de62).calculateScrollbarWidth()) submenuRef.current.style.left = -1 * sublistWidth + 'px';
            else submenuRef.current.style.left = itemOuterWidth + 'px';
        }
    };
    var onEnter = function onEnter() {
        position();
    };
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        active && position();
    });
    var getItemId = function getItemId(processedItem) {
        return "".concat(props.menuId, "_").concat(processedItem.key);
    };
    var getItemProp = function getItemProp(processedItem, name, params) {
        return processedItem && processedItem.item ? (0, $a73ce425265b079e$export$4855211e6b8ad895).getItemValue(processedItem.item[name], params) : undefined;
    };
    var isItemActive = function isItemActive(processedItem) {
        return props.activeItemPath && props.activeItemPath.some(function(path) {
            return path.key === processedItem.key;
        });
    };
    var isItemVisible = function isItemVisible(processedItem) {
        return getItemProp(processedItem, 'visible') !== false;
    };
    var isItemDisabled = function isItemDisabled(processedItem) {
        return getItemProp(processedItem, 'disabled');
    };
    var isItemFocused = function isItemFocused(processedItem) {
        return props.focusedItemId === getItemId(processedItem);
    };
    var isItemGroup = function isItemGroup(processedItem) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(processedItem.items);
    };
    var getAriaSetSize = function getAriaSetSize() {
        return props.model.filter(function(processedItem) {
            return isItemVisible(processedItem) && !getItemProp(processedItem, 'separator');
        }).length;
    };
    var getAriaPosInset = function getAriaPosInset(index) {
        return index - props.model.slice(0, index).filter(function(processedItem) {
            return isItemVisible(processedItem) && getItemProp(processedItem, 'separator');
        }).length + 1;
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElement: function getElement() {
                return submenuRef.current;
            }
        };
    });
    var createSeparator = function createSeparator(index) {
        var key = props.id + '_separator_' + index;
        var separatorProps = mergeProps({
            id: key,
            key: key,
            className: cx('separator'),
            role: 'separator'
        }, ptm('separator', {
            hostName: props.hostName
        }));
        return /*#__PURE__*/ $acw62.createElement("li", separatorProps);
    };
    var createSubmenu = function createSubmenu(item, index) {
        if (isItemGroup(item)) return /*#__PURE__*/ $acw62.createElement($dde48341f3da2113$var$ContextMenuSub, {
            id: props.id + '_' + index,
            role: "menu",
            menuId: props.menuId,
            focusedItemId: props.focusedItemId,
            activeItemPath: props.activeItemPath,
            level: props.level + 1,
            hostName: props.hostName,
            ariaLabelledby: getItemId(item),
            menuProps: props.menuProps,
            model: item.items,
            resetMenu: !isItemActive(item),
            onLeafClick: props.onLeafClick,
            onItemClick: props.onItemClick,
            onItemMouseEnter: props.onItemMouseEnter,
            isMobileMode: props.isMobileMode,
            submenuIcon: props.submenuIcon,
            ptm: ptm,
            cx: cx
        });
        return null;
    };
    var createMenuItem = function createMenuItem(processedItem, index) {
        if (!isItemVisible(processedItem)) return null;
        var item = processedItem.item;
        var active = isItemActive(processedItem);
        var disabled = isItemDisabled(processedItem);
        var focused = isItemFocused(processedItem);
        var isGroup = isItemGroup(processedItem);
        var key = getItemId(processedItem);
        var iconProps = mergeProps({
            className: cx('icon')
        }, getPTOptions(processedItem, 'icon', index));
        var icon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(item.icon, $dde48341f3da2113$var$_objectSpread$1({}, iconProps), {
            props: props.menuProps
        });
        var submenuIconProps = mergeProps({
            className: cx('submenuIcon')
        }, getPTOptions(processedItem, 'submenuIcon', index));
        var labelProps = mergeProps({
            className: cx('label')
        }, getPTOptions(processedItem, 'label', index));
        var items = getItemProp(processedItem, 'items');
        var submenuIcon = items && (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(props.submenuIcon || /*#__PURE__*/ $acw62.createElement((0, $e73ad5d038623fb5$export$f5db305c33b6241b), submenuIconProps), $dde48341f3da2113$var$_objectSpread$1({}, submenuIconProps), {
            props: props.menuProps
        });
        var label = item.label && /*#__PURE__*/ $acw62.createElement("span", labelProps, item.label);
        var submenu = createSubmenu(processedItem, index);
        var actionProps = mergeProps({
            href: item.url || '#',
            'aria-hidden': true,
            tabIndex: -1,
            className: cx('action', {
                item: item
            }),
            target: item.target
        }, getPTOptions(processedItem, 'action', index));
        var content = /*#__PURE__*/ $acw62.createElement("a", actionProps, icon, label, submenuIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
        if (item.template) {
            var defaultContentOptions = {
                className: 'p-menuitem-link',
                labelClassName: 'p-menuitem-text',
                iconClassName: 'p-menuitem-icon',
                submenuIconClassName: cx('submenuIcon'),
                element: content,
                props: props,
                active: active
            };
            content = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(item.template, item, defaultContentOptions);
        }
        var contentProps = mergeProps({
            onClick: function onClick(event) {
                return onItemClick(event, processedItem);
            },
            onMouseEnter: function onMouseEnter(event) {
                return onItemMouseEnter(event, processedItem);
            },
            className: cx('content')
        }, getPTOptions(processedItem, 'content', index));
        var menuitemProps = mergeProps($dde48341f3da2113$var$_defineProperty({
            id: key,
            key: key,
            role: 'menuitem',
            'aria-label': item.label,
            'aria-disabled': disabled,
            'aria-expanded': isGroup ? active : undefined,
            'aria-haspopup': isGroup && !item.url ? 'menu' : undefined,
            'aria-level': props.level + 1,
            'aria-setsize': getAriaSetSize(),
            'aria-posinset': getAriaPosInset(index),
            'data-p-highlight': active,
            'data-p-focused': focused,
            'data-p-disabled': disabled,
            className: cx('menuitem', {
                item: item,
                active: active,
                focused: focused,
                disabled: isItemDisabled(item)
            }),
            style: item.style
        }, "key", key), getPTOptions(processedItem, 'menuitem', index));
        return /*#__PURE__*/ $acw62.createElement("li", menuitemProps, /*#__PURE__*/ $acw62.createElement("div", contentProps, content), submenu);
    };
    var createItem = function createItem(processedItem, index) {
        if (processedItem.visible === false) return null;
        return processedItem.separator ? createSeparator(index) : createMenuItem(processedItem, index);
    };
    var createMenu = function createMenu() {
        return props.model ? props.model.map(createItem) : null;
    };
    var submenu = createMenu();
    var menuProps = mergeProps({
        className: cx('menu', {
            menuProps: props
        }),
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        onKeyDown: props.onKeyDown,
        'aria-label': props.ariaLabel,
        'aria-labelledby': props.ariaLabelledby,
        'aria-orientation': 'vertical',
        'aria-activedescendant': props.ariaActivedescendant,
        tabIndex: props.tabIndex,
        role: props.role
    }, ptm('menu', {
        hostName: props.hostName
    }));
    var transitionProps = mergeProps({
        classNames: cx('submenuTransition'),
        "in": active,
        timeout: {
            enter: 0,
            exit: 0
        },
        unmountOnExit: true,
        onEnter: onEnter
    }, ptm('menu.transition', {
        hostName: props.hostName
    }));
    return /*#__PURE__*/ $acw62.createElement((0, $17afce1b96f6eaec$export$a7a5590ad6d7af0), $dde48341f3da2113$var$_extends({
        nodeRef: submenuRef
    }, transitionProps), /*#__PURE__*/ $acw62.createElement("ul", $dde48341f3da2113$var$_extends({
        ref: submenuRef
    }, menuProps), submenu));
}));
$dde48341f3da2113$var$ContextMenuSub.displayName = 'ContextMenuSub';
function $dde48341f3da2113$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dde48341f3da2113$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dde48341f3da2113$var$ownKeys(Object(t), !0).forEach(function(r) {
            $dde48341f3da2113$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dde48341f3da2113$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dde48341f3da2113$export$8dc6765e8be191c7 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $dde48341f3da2113$var$ContextMenuBase.getProps(inProps, context);
    var _React$useState = $acw62.useState(props.id), _React$useState2 = $dde48341f3da2113$var$_slicedToArray(_React$useState, 2), idState = _React$useState2[0], setIdState = _React$useState2[1];
    var _React$useState3 = $acw62.useState(false), _React$useState4 = $dde48341f3da2113$var$_slicedToArray(_React$useState3, 2), visibleState = _React$useState4[0], setVisibleState = _React$useState4[1];
    var _React$useState5 = $acw62.useState(false), _React$useState6 = $dde48341f3da2113$var$_slicedToArray(_React$useState5, 2), reshowState = _React$useState6[0], setReshowState = _React$useState6[1];
    var _React$useState7 = $acw62.useState(false), _React$useState8 = $dde48341f3da2113$var$_slicedToArray(_React$useState7, 2), resetMenuState = _React$useState8[0], setResetMenuState = _React$useState8[1];
    var _React$useState9 = $acw62.useState(null), _React$useState10 = $dde48341f3da2113$var$_slicedToArray(_React$useState9, 2), attributeSelectorState = _React$useState10[0], setAttributeSelectorState = _React$useState10[1];
    var _React$useState11 = $acw62.useState(false), _React$useState12 = $dde48341f3da2113$var$_slicedToArray(_React$useState11, 2), focused = _React$useState12[0], setFocused = _React$useState12[1];
    var _React$useState13 = $acw62.useState(false), _React$useState14 = $dde48341f3da2113$var$_slicedToArray(_React$useState13, 2), focusTrigger = _React$useState14[0], setFocusTrigger = _React$useState14[1];
    var _React$useState15 = $acw62.useState({
        index: -1,
        level: 0,
        parentKey: ''
    }), _React$useState16 = $dde48341f3da2113$var$_slicedToArray(_React$useState15, 2), focusedItemInfo = _React$useState16[0], setFocusedItemInfo = _React$useState16[1];
    var _React$useState17 = $acw62.useState(''), _React$useState18 = $dde48341f3da2113$var$_slicedToArray(_React$useState17, 2), activeItemPath = _React$useState18[0], setActiveItemPath = _React$useState18[1];
    var _React$useState19 = $acw62.useState([]), _React$useState20 = $dde48341f3da2113$var$_slicedToArray(_React$useState19, 2), processedItems = _React$useState20[0], setProcessedItems = _React$useState20[1];
    var _React$useState21 = $acw62.useState([]), _React$useState22 = $dde48341f3da2113$var$_slicedToArray(_React$useState21, 2), visibleItems = _React$useState22[0], setVisibleItems = _React$useState22[1];
    var _React$useState23 = $acw62.useState(null), _React$useState24 = $dde48341f3da2113$var$_slicedToArray(_React$useState23, 2), focusedItemId = _React$useState24[0], setFocusedItemId = _React$useState24[1];
    var _ContextMenuBase$setM = $dde48341f3da2113$var$ContextMenuBase.setMetaData({
        props: props,
        state: {
            id: idState,
            visible: visibleState,
            reshow: reshowState,
            resetMenu: resetMenuState,
            attributeSelector: attributeSelectorState
        }
    }), ptm = _ContextMenuBase$setM.ptm, cx = _ContextMenuBase$setM.cx, isUnstyled = _ContextMenuBase$setM.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($dde48341f3da2113$var$ContextMenuBase.css.styles, isUnstyled, {
        name: 'contextmenu'
    });
    var menuRef = $acw62.useRef(null);
    var listRef = $acw62.useRef(null);
    var currentEvent = $acw62.useRef(null);
    var searchValue = $acw62.useRef('');
    var searchTimeout = $acw62.useRef(null);
    var styleElementRef = $acw62.useRef(null);
    var isMobileMode = (0, $fbdf1e36fa0a01d8$export$dd42f485803cd57d)("screen and (max-width: ".concat(props.breakpoint, ")"), !!props.breakpoint);
    var _useEventListener = (0, $fbdf1e36fa0a01d8$export$7080b3e976bc91ab)({
        type: 'click',
        listener: function listener(event) {
            if (isOutsideClicked(event) && event.button !== 2) {
                hide(event);
                setResetMenuState(true);
            }
        }
    }), _useEventListener2 = $dde48341f3da2113$var$_slicedToArray(_useEventListener, 2), bindDocumentClickListener = _useEventListener2[0], unbindDocumentClickListener = _useEventListener2[1];
    var _useEventListener3 = (0, $fbdf1e36fa0a01d8$export$7080b3e976bc91ab)({
        type: 'contextmenu',
        when: props.global,
        listener: function listener(event) {
            show(event);
        }
    }), _useEventListener4 = $dde48341f3da2113$var$_slicedToArray(_useEventListener3, 1), bindDocumentContextMenuListener = _useEventListener4[0];
    var _useResizeListener = (0, $fbdf1e36fa0a01d8$export$158eb97be50d41ef)({
        listener: function listener(event) {
            if (visibleState && !(0, $a73ce425265b079e$export$ff8ccbac9225de62).isTouchDevice()) hide(event);
        }
    }), _useResizeListener2 = $dde48341f3da2113$var$_slicedToArray(_useResizeListener, 2), bindDocumentResizeListener = _useResizeListener2[0], unbindDocumentResizeListener = _useResizeListener2[1];
    var createStyle = function createStyle() {
        if (!styleElementRef.current) {
            styleElementRef.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).createInlineStyle(context && context.nonce || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).nonce, context && context.styleContainer);
            var selector = "".concat(attributeSelectorState);
            var innerHTML = "\n@media screen and (max-width: ".concat(props.breakpoint, ") {\n    .p-contextmenu[").concat(selector, "] > ul {\n        max-height: ").concat(props.scrollHeight, ";\n        overflow: ").concat(props.scrollHeight ? 'auto' : '', ";\n    }\n\n    .p-contextmenu[").concat(selector, "] .p-submenu-list {\n        position: relative;\n    }\n\n    .p-contextmenu[").concat(selector, "] .p-menuitem-active > .p-submenu-list {\n        left: 0;\n        box-shadow: none;\n        border-radius: 0;\n        padding: 0 0 0 calc(var(--inline-spacing) * 2); /* @todo */\n    }\n\n    .p-contextmenu[").concat(selector, "] .p-menuitem-active > .p-menuitem-link > .p-submenu-icon {\n        transform: rotate(-180deg);\n    }\n\n    .p-contextmenu[").concat(selector, "] .p-submenu-icon:before {\n        content: \"\\e930\";\n    }\n}\n");
            styleElementRef.current.innerHTML = innerHTML;
        }
    };
    var destroyStyle = function destroyStyle() {
        styleElementRef.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeInlineStyle(styleElementRef.current);
    };
    var onMenuClick = function onMenuClick() {
        setResetMenuState(false);
    };
    var onMenuMouseEnter = function onMenuMouseEnter() {
        setResetMenuState(false);
    };
    var show = function show(event) {
        setActiveItemPath([]);
        setFocusedItemInfo({
            index: -1,
            level: 0,
            parentKey: ''
        });
        event.stopPropagation();
        event.preventDefault();
        currentEvent.current = event;
        if (visibleState) setReshowState(true);
        else {
            setVisibleState(true);
            props.onShow && props.onShow(currentEvent.current);
        }
        Promise.resolve().then(function() {
            listRef.current && (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(listRef.current.getElement());
        });
    };
    var hide = function hide(event) {
        currentEvent.current = event;
        setVisibleState(false);
        setReshowState(false);
        setActiveItemPath([]);
        setFocusedItemInfo({
            index: -1,
            level: 0,
            parentKey: ''
        });
        props.onHide && props.onHide(currentEvent.current);
    };
    var onEnter = function onEnter() {
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).addStyles(menuRef.current, {
            position: 'absolute'
        });
        if (props.autoZIndex) (0, $a73ce425265b079e$export$832931caede8e4b9).set('menu', menuRef.current, context && context.autoZIndex || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).autoZIndex, props.baseZIndex || context && context.zIndex.menu || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).zIndex.menu);
        position(currentEvent.current);
        if (attributeSelectorState && props.breakpoint) {
            menuRef.current.setAttribute(attributeSelectorState, '');
            createStyle();
        }
    };
    var onEntered = function onEntered() {
        bindDocumentListeners();
    };
    var onExit = function onExit() {
        unbindDocumentListeners();
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(menuRef.current);
    };
    var onExited = function onExited() {
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(menuRef.current);
        destroyStyle();
    };
    var position = function position(event) {
        if (event) {
            var left = event.pageX + 1;
            var top = event.pageY + 1;
            var width = menuRef.current.offsetParent ? menuRef.current.offsetWidth : (0, $a73ce425265b079e$export$ff8ccbac9225de62).getHiddenElementOuterWidth(menuRef.current);
            var height = menuRef.current.offsetParent ? menuRef.current.offsetHeight : (0, $a73ce425265b079e$export$ff8ccbac9225de62).getHiddenElementOuterHeight(menuRef.current);
            var viewport = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getViewport();
            //flip
            if (left + width - document.body.scrollLeft > viewport.width) left = left - width;
            //flip
            if (top + height - document.body.scrollTop > viewport.height) top = top - height;
            //fit
            if (left < document.body.scrollLeft) left = document.body.scrollLeft;
            //fit
            if (top < document.body.scrollTop) top = document.body.scrollTop;
            menuRef.current.style.left = left + 'px';
            menuRef.current.style.top = top + 'px';
        }
    };
    var createProcessedItems = $acw62.useCallback(function(items, level) {
        var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var parentKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
        var processedItems = [];
        items && items.forEach(function(item, index) {
            var key = (parentKey !== '' ? parentKey + '_' : '') + index;
            var newItem = {
                item: item,
                index: index,
                level: level,
                separator: item.separator,
                key: key,
                parent: parent,
                parentKey: parentKey
            };
            newItem.items = createProcessedItems(item.items, level + 1, newItem, key);
            processedItems.push(newItem);
        });
        return processedItems;
    }, []);
    var onLeafClick = function onLeafClick(event) {
        setResetMenuState(true);
        hide(event);
        event.stopPropagation();
    };
    var isOutsideClicked = function isOutsideClicked(event) {
        return menuRef && menuRef.current && !(menuRef.current.isSameNode(event.target) || menuRef.current.contains(event.target));
    };
    var bindDocumentListeners = function bindDocumentListeners() {
        bindDocumentResizeListener();
        bindDocumentClickListener();
    };
    var unbindDocumentListeners = function unbindDocumentListeners() {
        unbindDocumentResizeListener();
        unbindDocumentClickListener();
    };
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        var uniqueId = (0, $a73ce425265b079e$export$d5d9b89141473caf)();
        !idState && setIdState(uniqueId);
        if (props.global) bindDocumentContextMenuListener();
        if (props.breakpoint) !attributeSelectorState && setAttributeSelectorState(uniqueId);
    });
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        props.global && bindDocumentContextMenuListener();
    }, [
        props.global
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (attributeSelectorState && menuRef.current) {
            menuRef.current.setAttribute(attributeSelectorState, '');
            createStyle();
        }
        return function() {
            destroyStyle();
        };
    }, [
        attributeSelectorState,
        props.breakpoint
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (visibleState) {
            setVisibleState(false);
            setReshowState(false);
            setResetMenuState(true);
        } else if (!reshowState && !visibleState && resetMenuState) show(currentEvent.current);
    }, [
        reshowState
    ]);
    $acw62.useEffect(function() {
        var itemsToProcess = props.model || [];
        var processed = createProcessedItems(itemsToProcess, 0, null, '');
        setProcessedItems(processed);
    }, [
        props.model,
        createProcessedItems
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        var _focusedItemId = focusedItemInfo.index !== -1 ? "".concat(idState).concat((0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(focusedItemInfo.parentKey) ? '_' + focusedItemInfo.parentKey : '', "_").concat(focusedItemInfo.index) : null;
        setFocusedItemId(_focusedItemId);
    }, [
        focusedItemInfo
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        var processedItem = activeItemPath && activeItemPath.find(function(p) {
            return p.key === focusedItemInfo.parentKey;
        });
        var _visibleItems = processedItem ? processedItem.items : processedItems;
        setVisibleItems(_visibleItems);
    }, [
        activeItemPath,
        focusedItemInfo
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (focusTrigger) {
            var itemIndex = focusedItemInfo.index !== -1 ? findNextItemIndex(focusedItemInfo.index) : findFirstFocusedItemIndex();
            changeFocusedItemIndex(itemIndex);
            setActiveItemPath(activeItemPath.filter(function(p) {
                return p.parentKey !== focusedItemInfo.parentKey;
            }));
            setFocusTrigger(false);
        }
    }, [
        focusTrigger
    ]);
    (0, $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96)(function() {
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(menuRef.current);
    });
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            show: show,
            hide: hide,
            getElement: function getElement() {
                return menuRef.current;
            }
        };
    });
    var onFocus = function onFocus(event) {
        setFocused(true);
        setFocusedItemInfo(focusedItemInfo.index !== -1 ? focusedItemInfo : {
            index: -1,
            level: 0,
            parentKey: ''
        });
        props.onFocus && props.onFocus(event);
    };
    var onBlur = function onBlur(event) {
        setFocused(false);
        setFocusedItemInfo({
            index: -1,
            level: 0,
            parentKey: ''
        });
        searchValue.current = '';
        searchValue.current = '';
        props.onBlur && props.onBlur(event);
    };
    var onKeyDown = function onKeyDown(event) {
        var metaKey = event.metaKey || event.ctrlKey;
        switch(event.code){
            case 'ArrowDown':
                onArrowDownKey(event);
                break;
            case 'ArrowUp':
                onArrowUpKey(event);
                break;
            case 'ArrowLeft':
                onArrowLeftKey(event);
                break;
            case 'ArrowRight':
                onArrowRightKey(event);
                break;
            case 'Home':
                onHomeKey(event);
                break;
            case 'End':
                onEndKey(event);
                break;
            case 'Space':
                onSpaceKey(event);
                break;
            case 'Enter':
            case 'NumpadEnter':
                onEnterKey(event);
                break;
            case 'Escape':
                onEscapeKey(event);
                break;
            case 'Tab':
                onTabKey(event);
                break;
            case 'PageDown':
            case 'PageUp':
            case 'Backspace':
            case 'ShiftLeft':
            case 'ShiftRight':
                break;
            default:
                if (!metaKey && (0, $a73ce425265b079e$export$4855211e6b8ad895).isPrintableCharacter(event.key)) searchItems(event, event.key);
                break;
        }
    };
    var onItemChange = function onItemChange(event) {
        var processedItem = event.processedItem, isFocus = event.isFocus, _event$updateState = event.updateState, updateState = _event$updateState === void 0 ? true : _event$updateState;
        if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isEmpty(processedItem)) return;
        var index = processedItem.index, key = processedItem.key, level = processedItem.level, parentKey = processedItem.parentKey, items = processedItem.items;
        var grouped = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(items);
        var _activeItemPath = activeItemPath.filter(function(p) {
            return p.parentKey !== parentKey && p.parentKey !== key;
        });
        if (grouped && updateState) {
            _activeItemPath.push(processedItem);
            setVisibleState(true);
        }
        setFocusedItemInfo({
            index: index,
            level: level,
            parentKey: parentKey
        });
        setActiveItemPath(_activeItemPath);
        isFocus && (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(listRef.current.getElement());
    };
    var onItemClick = function onItemClick(event) {
        var processedItem = event.processedItem;
        var grouped = isProccessedItemGroup(processedItem);
        var selected = isSelected(processedItem);
        if (selected) {
            var index = processedItem.index, key = processedItem.key, level = processedItem.level, parentKey = processedItem.parentKey;
            setActiveItemPath(activeItemPath.filter(function(p) {
                return key !== p.key && key.startsWith(p.key);
            }));
            setFocusedItemInfo({
                index: index,
                level: level,
                parentKey: parentKey
            });
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(listRef.current.getElement());
        } else grouped ? onItemChange(event) : hide();
    };
    var onItemMouseEnter = function onItemMouseEnter(event) {
        onItemChange(event);
    };
    var onArrowDownKey = function onArrowDownKey(event) {
        var itemIndex = focusedItemInfo.index !== -1 ? findNextItemIndex(focusedItemInfo.index) : findFirstFocusedItemIndex();
        changeFocusedItemIndex(itemIndex);
        event.preventDefault();
    };
    var onArrowUpKey = function onArrowUpKey(event) {
        if (event.altKey) {
            if (focusedItemInfo.index !== -1) {
                var processedItem = visibleItems[focusedItemInfo.index];
                var grouped = isProccessedItemGroup(processedItem);
                !grouped && onItemChange({
                    originalEvent: event,
                    processedItem: processedItem
                });
            }
            event.preventDefault();
        } else {
            var itemIndex = focusedItemInfo.index !== -1 ? findPrevItemIndex(focusedItemInfo.index) : findLastFocusedItemIndex();
            changeFocusedItemIndex(itemIndex);
            event.preventDefault();
        }
    };
    var onArrowLeftKey = function onArrowLeftKey(event) {
        var processedItem = visibleItems[focusedItemInfo.index];
        var parentItem = activeItemPath.find(function(p) {
            return p.key === processedItem.parentKey;
        });
        var root = (0, $a73ce425265b079e$export$4855211e6b8ad895).isEmpty(processedItem.parent);
        if (!root) {
            setFocusedItemInfo({
                index: -1,
                parentKey: parentItem ? parentItem.parentKey : ''
            });
            searchValue.current = '';
            setTimeout(function() {
                return setFocusTrigger(true);
            }, 0);
        }
        event.preventDefault();
    };
    var onArrowRightKey = function onArrowRightKey(event) {
        var processedItem = visibleItems[focusedItemInfo.index];
        var grouped = isProccessedItemGroup(processedItem);
        if (grouped) {
            onItemChange({
                originalEvent: event,
                processedItem: processedItem
            });
            setFocusedItemInfo({
                index: -1,
                parentKey: processedItem.key
            });
            searchValue.current = '';
            setTimeout(function() {
                return setFocusTrigger(true);
            }, 0);
        }
        event.preventDefault();
    };
    var onHomeKey = function onHomeKey(event) {
        changeFocusedItemIndex(findFirstItemIndex());
        event.preventDefault();
    };
    var onEndKey = function onEndKey(event) {
        changeFocusedItemIndex(findLastItemIndex());
        event.preventDefault();
    };
    var onEnterKey = function onEnterKey(event) {
        if (focusedItemInfo.index !== -1) {
            var _element = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(listRef.current.getElement(), "li[id=\"".concat("".concat(focusedItemId), "\"]"));
            var anchorElement = _element && (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(_element, 'a[data-pc-section="action"]');
            anchorElement ? anchorElement.click() : _element && _element.click();
            var processedItem = visibleItems[focusedItemInfo.index];
            var grouped = isProccessedItemGroup(processedItem);
            !grouped && setFocusedItemInfo($dde48341f3da2113$var$_objectSpread($dde48341f3da2113$var$_objectSpread({}, focusedItemInfo), {}, {
                index: findFirstFocusedItemIndex()
            }));
        }
        event.preventDefault();
    };
    var onSpaceKey = function onSpaceKey(event) {
        onEnterKey(event);
    };
    var onEscapeKey = function onEscapeKey(event) {
        hide();
        setFocusedItemInfo({
            focusedItemInfo: focusedItemInfo,
            index: findFirstFocusedItemIndex()
        });
        event.preventDefault();
    };
    var onTabKey = function onTabKey(event) {
        if (focusedItemInfo.index !== -1) {
            var processedItem = visibleItems[focusedItemInfo.index];
            var grouped = isProccessedItemGroup(processedItem);
            !grouped && onItemChange({
                originalEvent: event,
                processedItem: processedItem
            });
        }
        hide();
    };
    var searchItems = function searchItems(event, _char) {
        searchValue.current = searchValue.current || '' + _char;
        var itemIndex = -1;
        var matched = false;
        if (focusedItemInfo.index !== -1) {
            itemIndex = visibleItems.slice(focusedItemInfo.index).findIndex(function(processedItem) {
                return isItemMatched(processedItem);
            });
            itemIndex = itemIndex === -1 ? visibleItems.slice(0, focusedItemInfo.index).findIndex(function(processedItem) {
                return isItemMatched(processedItem);
            }) : itemIndex + focusedItemInfo.index;
        } else itemIndex = visibleItems.findIndex(function(processedItem) {
            return isItemMatched(processedItem);
        });
        if (itemIndex !== -1) matched = true;
        if (itemIndex === -1 && focusedItemInfo.index === -1) itemIndex = findFirstFocusedItemIndex();
        if (itemIndex !== -1) changeFocusedItemIndex(itemIndex);
        if (searchTimeout.current) clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(function() {
            searchValue.current = '';
            searchTimeout.current = null;
        }, 500);
        return matched;
    };
    var changeFocusedItemIndex = function changeFocusedItemIndex(index) {
        if (focusedItemInfo.index !== index) {
            setFocusedItemInfo($dde48341f3da2113$var$_objectSpread($dde48341f3da2113$var$_objectSpread({}, focusedItemInfo), {}, {
                index: index
            }));
            scrollInView();
        }
    };
    var scrollInView = function scrollInView() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
        var _id = index !== -1 ? "".concat(idState, "_").concat(index) : focusedItemId;
        var element = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(listRef.current.getElement(), "li[id=\"".concat(_id, "\"]"));
        if (element) element.scrollIntoView && element.scrollIntoView({
            block: 'nearest',
            inline: 'start'
        });
    };
    var getItemProp = function getItemProp(item, name) {
        return item ? (0, $a73ce425265b079e$export$4855211e6b8ad895).getItemValue(item[name]) : undefined;
    };
    var getItemLabel = function getItemLabel(item) {
        return getItemProp(item, 'label');
    };
    var getProccessedItemLabel = function getProccessedItemLabel(processedItem) {
        return processedItem ? getItemLabel(processedItem.item) : undefined;
    };
    var isProccessedItemGroup = function isProccessedItemGroup(processedItem) {
        return processedItem && (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(processedItem.items);
    };
    var isItemDisabled = function isItemDisabled(item) {
        return getItemProp(item, 'disabled');
    };
    var isItemSeparator = function isItemSeparator(item) {
        return getItemProp(item, 'separator');
    };
    var isValidItem = function isValidItem(processedItem) {
        return !!processedItem && !isItemDisabled(processedItem.item) && !isItemSeparator(processedItem.item);
    };
    var isItemMatched = function isItemMatched(processedItem) {
        return isValidItem(processedItem) && getProccessedItemLabel(processedItem).toLocaleLowerCase().startsWith(searchValue.current.toLocaleLowerCase());
    };
    var findNextItemIndex = function findNextItemIndex(index) {
        var matchedItemIndex = index < visibleItems.length - 1 ? visibleItems.slice(index + 1).findIndex(function(processedItem) {
            return isValidItem(processedItem);
        }) : -1;
        return matchedItemIndex > -1 ? matchedItemIndex + index + 1 : index;
    };
    var findPrevItemIndex = function findPrevItemIndex(index) {
        var matchedItemIndex = index > 0 ? (0, $a73ce425265b079e$export$4855211e6b8ad895).findLastIndex(visibleItems.slice(0, index), function(processedItem) {
            return isValidItem(processedItem);
        }) : -1;
        return matchedItemIndex > -1 ? matchedItemIndex : index;
    };
    var isSelected = function isSelected(processedItem) {
        return activeItemPath && activeItemPath.some(function(p) {
            return p.key === processedItem.key;
        });
    };
    var isValidSelectedItem = function isValidSelectedItem(processedItem) {
        return isValidItem(processedItem) && isSelected(processedItem);
    };
    var findFirstItemIndex = function findFirstItemIndex() {
        return visibleItems.findIndex(function(processedItem) {
            return isValidItem(processedItem);
        });
    };
    var findLastItemIndex = function findLastItemIndex() {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).findLastIndex(visibleItems, function(processedItem) {
            return isValidItem(processedItem);
        });
    };
    var findFirstFocusedItemIndex = function findFirstFocusedItemIndex() {
        var selectedIndex = findSelectedItemIndex();
        return selectedIndex < 0 ? findFirstItemIndex() : selectedIndex;
    };
    var findLastFocusedItemIndex = function findLastFocusedItemIndex() {
        var selectedIndex = findSelectedItemIndex();
        return selectedIndex < 0 ? findLastItemIndex() : selectedIndex;
    };
    var findSelectedItemIndex = function findSelectedItemIndex() {
        return visibleItems.findIndex(function(processedItem) {
            return isValidSelectedItem(processedItem);
        });
    };
    var createContextMenu = function createContextMenu() {
        var rootProps = mergeProps({
            id: props.id,
            className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root', {
                context: context
            })),
            style: props.style,
            onClick: function onClick(e) {
                return onMenuClick();
            },
            onMouseEnter: function onMouseEnter(e) {
                return onMenuMouseEnter();
            }
        }, $dde48341f3da2113$var$ContextMenuBase.getOtherProps(props), ptm('root'));
        var transitionProps = mergeProps({
            classNames: cx('transition'),
            "in": visibleState,
            timeout: {
                enter: 250,
                exit: 0
            },
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: onEnter,
            onEntered: onEntered,
            onExit: onExit,
            onExited: onExited
        }, ptm('transition'));
        return /*#__PURE__*/ $acw62.createElement((0, $17afce1b96f6eaec$export$a7a5590ad6d7af0), $dde48341f3da2113$var$_extends({
            nodeRef: menuRef
        }, transitionProps), /*#__PURE__*/ $acw62.createElement("div", $dde48341f3da2113$var$_extends({
            ref: menuRef
        }, rootProps), /*#__PURE__*/ $acw62.createElement($dde48341f3da2113$var$ContextMenuSub, {
            ref: listRef,
            ariaLabel: props.ariaLabel,
            ariaLabelledby: props.ariaLabelledby,
            activeItemPath: activeItemPath,
            hostName: "ContextMenu",
            id: idState + '_list',
            role: "menubar",
            tabIndex: props.tabIndex || 0,
            ariaActivedescendant: focused ? focusedItemId : undefined,
            menuId: idState,
            focusedItemId: focused ? focusedItemId : undefined,
            menuProps: props,
            model: processedItems,
            level: 0,
            root: true,
            onItemClick: onItemClick,
            onItemMouseEnter: onItemMouseEnter,
            onFocus: onFocus,
            onBlur: onBlur,
            onKeyDown: onKeyDown,
            resetMenu: resetMenuState,
            onLeafClick: onLeafClick,
            isMobileMode: isMobileMode,
            submenuIcon: props.submenuIcon,
            ptm: ptm,
            cx: cx
        })));
    };
    var element = createContextMenu();
    return /*#__PURE__*/ $acw62.createElement((0, $e7a3b5428092a192$export$602eac185826482c), {
        element: element,
        appendTo: props.appendTo
    });
}));
$dde48341f3da2113$export$8dc6765e8be191c7.displayName = 'ContextMenu';



const $938976f073b0fc26$var$daysOfWeek = [
    "Pn",
    "Wt",
    "\u015Ar",
    "Cz",
    "Pt",
    "So",
    "Nd"
];
const $938976f073b0fc26$export$3f28bc2654ada96 = ({ year: year, getDayClass: getDayClass })=>{
    const modifyCalendar = (0, $4529664c1ee19d35$export$5ecbcf6a102ccf18)();
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const [selectedDay, setSelectedDay] = (0, $acw62.useState)();
    const cm = (0, $acw62.useRef)(null);
    function handleInputDone(propertyName, value) {
        const payload = {
            query: {
                modified_id: tool.propertyEditor.service_id,
                resourceTable: 'calendars'
            },
            fields: {}
        };
        payload.fields[propertyName] = value;
        const mutation = modifyCalendar.mutate(payload);
    }
    const cmItems = [
        {
            label: "Ustaw wyj\u0105tek: w ten dzie\u0144 kursuje",
            icon: 'fa-solid fa-calendar-plus',
            command: ()=>{
                handleInputDone('exceptions_date_added_add', [
                    selectedDay
                ]);
            }
        },
        {
            label: "Ustaw wyj\u0105tek: w ten dzie\u0144 nie kursuje",
            icon: 'fa-solid fa-calendar-minus',
            command: ()=>{
                handleInputDone('exceptions_date_removed_add', [
                    selectedDay
                ]);
            }
        },
        {
            label: "Usu\u0144 ten dzie\u0144 z listy wyj\u0105tk\xf3w",
            command: ()=>{
                handleInputDone('exceptions_date_added_remove', [
                    selectedDay
                ]);
                handleInputDone('exceptions_date_removed_remove', [
                    selectedDay
                ]);
            }
        }
    ];
    const onRightClick = (event, day)=>{
        if (cm.current) {
            setSelectedDay(day);
            cm.current.show(event);
        }
    };
    const getDaysInMonth = (month, year)=>{
        return new Date(year, month + 1, 0).getDate();
    };
    const getFirstDayOfMonth = (month, year)=>{
        let firstDay = new Date(year, month, 1).getDay();
        return firstDay === 0 ? 6 : firstDay - 1;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "calendar-container",
        children: [
            [
                ...Array(12)
            ].map((_, month)=>{
                const daysInMonth = getDaysInMonth(month, year);
                const firstDay = getFirstDayOfMonth(month, year);
                const days = Array.from({
                    length: firstDay
                }, ()=>null).concat([
                    ...Array(daysInMonth)
                ].map((_, i)=>i + 1));
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "month-container",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b74dfa9f7ee9d9bc$export$28c660c63b792dea), {
                            target: ".out-of-range",
                            content: "Data poza okresem wa\u017Cno\u015Bci"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b74dfa9f7ee9d9bc$export$28c660c63b792dea), {
                            target: ".normally-runs",
                            content: "Kursuje normalnie"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b74dfa9f7ee9d9bc$export$28c660c63b792dea), {
                            target: ".normally-does-not-run",
                            content: "Nie kursuje"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b74dfa9f7ee9d9bc$export$28c660c63b792dea), {
                            target: ".runs-as-exception",
                            content: "Wyj\u0105tkowo kursuje"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b74dfa9f7ee9d9bc$export$28c660c63b792dea), {
                            target: ".does-not-run-as-exception",
                            content: "Wyj\u0105tkowo nie kursuje"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            className: "month-title",
                            children: new Date(year, month).toLocaleString("pl-PL", {
                                month: "long"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "days-grid",
                            children: [
                                $938976f073b0fc26$var$daysOfWeek.map((day)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "day-header",
                                        children: day
                                    }, day)),
                                days.map((day, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: `day-cell ${day ? getDayClass(year, month, day) : ""}`,
                                        onContextMenu: (event)=>onRightClick(event, (0, $57ee609582c542b6$export$443ababd588c81c9)(new Date(year, month, day))),
                                        children: day || ""
                                    }, index))
                            ]
                        })
                    ]
                }, month);
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dde48341f3da2113$export$8dc6765e8be191c7), {
                ref: cm,
                model: cmItems,
                onHide: ()=>setSelectedDay(undefined)
            })
        ]
    }, year);
};






function $9148fdee410b91ec$export$39d78c94fb91ad03({ serviceId: serviceId }) {
    const now = new Date();
    const [year, setYear] = (0, $acw62.useState)(now.getFullYear());
    const { data: data, isPending: isPending, error: error } = (0, $4529664c1ee19d35$export$ac3dd26b67094cc3)('calendars', serviceId);
    if (isPending) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec34a5c615255cb$export$dcc7532e7120780d), {});
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: error.message
    });
    function getDayClass(year, month, day) {
        // todo: oznaczenie świąt w kalendarzu, jak np. tu:
        // if(month == 11 && day == 25) return 'holiday';
        const date = new Date(year, month, day);
        if (date < (0, $57ee609582c542b6$export$294b5a2c8fb6dbfa)(data.start_date)) return 'out-of-range';
        if (date > (0, $57ee609582c542b6$export$294b5a2c8fb6dbfa)(data.end_date)) return 'out-of-range';
        if (data.exceptions_dates_removed.includes((0, $57ee609582c542b6$export$443ababd588c81c9)(date))) return 'does-not-run-as-exception';
        if (data.exceptions_dates_added.includes((0, $57ee609582c542b6$export$443ababd588c81c9)(date))) return 'runs-as-exception';
        if (data.monday === true && date.getDay() === 1 || data.tuesday === true && date.getDay() === 2 || data.wednesday === true && date.getDay() === 3 || data.thursday === true && date.getDay() === 4 || data.friday === true && date.getDay() === 5 || data.saturday === true && date.getDay() === 6 || data.sunday === true && date.getDay() === 0) return 'normally-runs';
        return 'normally-does-not-run';
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "w-full flex justify-content-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df4bf6c8c7efd937$export$cf9581d419a141cf), {
                    value: year,
                    onValueChange: (e)=>setYear(e.value),
                    showButtons: true,
                    buttonLayout: "horizontal",
                    incrementButtonIcon: "fa-solid fa-chevron-right",
                    decrementButtonIcon: "fa-solid fa-chevron-left",
                    useGrouping: false
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $938976f073b0fc26$export$3f28bc2654ada96), {
                year: year,
                getDayClass: getDayClass
            }, serviceId)
        ]
    });
}




var $acw62 = parcelRequire("acw62");









'use client';
function $37f8d4c0bc2f6dce$var$_extends() {
    return $37f8d4c0bc2f6dce$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $37f8d4c0bc2f6dce$var$_extends.apply(null, arguments);
}
function $37f8d4c0bc2f6dce$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $37f8d4c0bc2f6dce$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $37f8d4c0bc2f6dce$var$_typeof(o);
}
function $37f8d4c0bc2f6dce$var$toPrimitive(t, r) {
    if ("object" != $37f8d4c0bc2f6dce$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $37f8d4c0bc2f6dce$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $37f8d4c0bc2f6dce$var$toPropertyKey(t) {
    var i = $37f8d4c0bc2f6dce$var$toPrimitive(t, "string");
    return "symbol" == $37f8d4c0bc2f6dce$var$_typeof(i) ? i : i + "";
}
function $37f8d4c0bc2f6dce$var$_defineProperty(e, r, t) {
    return (r = $37f8d4c0bc2f6dce$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $37f8d4c0bc2f6dce$var$_arrayLikeToArray$1(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $37f8d4c0bc2f6dce$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $37f8d4c0bc2f6dce$var$_arrayLikeToArray$1(r);
}
function $37f8d4c0bc2f6dce$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $37f8d4c0bc2f6dce$var$_unsupportedIterableToArray$1(r, a) {
    if (r) {
        if ("string" == typeof r) return $37f8d4c0bc2f6dce$var$_arrayLikeToArray$1(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $37f8d4c0bc2f6dce$var$_arrayLikeToArray$1(r, a) : void 0;
    }
}
function $37f8d4c0bc2f6dce$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $37f8d4c0bc2f6dce$var$_toConsumableArray(r) {
    return $37f8d4c0bc2f6dce$var$_arrayWithoutHoles(r) || $37f8d4c0bc2f6dce$var$_iterableToArray(r) || $37f8d4c0bc2f6dce$var$_unsupportedIterableToArray$1(r) || $37f8d4c0bc2f6dce$var$_nonIterableSpread();
}
function $37f8d4c0bc2f6dce$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $37f8d4c0bc2f6dce$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $37f8d4c0bc2f6dce$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $37f8d4c0bc2f6dce$var$_slicedToArray(r, e) {
    return $37f8d4c0bc2f6dce$var$_arrayWithHoles(r) || $37f8d4c0bc2f6dce$var$_iterableToArrayLimit(r, e) || $37f8d4c0bc2f6dce$var$_unsupportedIterableToArray$1(r, e) || $37f8d4c0bc2f6dce$var$_nonIterableRest();
}
var $37f8d4c0bc2f6dce$var$classes = {
    itemGroup: 'p-listbox-item-group',
    emptyMessage: 'p-listbox-empty-message',
    list: 'p-listbox-list',
    wrapper: function wrapper(_ref) {
        var props = _ref.props;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-listbox-list-wrapper', props.listClassName);
    },
    root: function root(_ref2) {
        var props = _ref2.props;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-listbox p-component', {
            'p-disabled': props.disabled,
            'p-invalid': props.invalid
        }, props.className);
    },
    item: function item(_ref3) {
        var props = _ref3.props;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-listbox-item', {
            'p-highlight': props.selected,
            'p-focus': props.focusedOptionIndex === props.index,
            'p-disabled': props.disabled
        }, props.option.className);
    },
    filterContainer: 'p-listbox-filter-container',
    filterIcon: 'p-listbox-filter-icon',
    filterInput: 'p-listbox-filter',
    header: 'p-listbox-header'
};
var $37f8d4c0bc2f6dce$var$styles = "\n@layer primereact {\n    .p-listbox-list-wrapper {\n        overflow: auto;\n    }\n    \n    .p-listbox-list {\n        list-style-type: none;\n        margin: 0;\n        padding: 0;\n    }\n    \n    .p-listbox-item {\n        cursor: pointer;\n        position: relative;\n        overflow: hidden;\n        outline: none;\n    }\n    \n    .p-listbox-filter-container {\n        position: relative;\n    }\n    \n    .p-listbox-filter-icon {\n        position: absolute;\n        top: 50%;\n        margin-top: -.5rem;\n    }\n    \n    .p-listbox-filter {\n        width: 100%;\n    }\n}\n";
var $37f8d4c0bc2f6dce$var$inlineStyles = {
    itemGroup: function itemGroup(_ref4) {
        var scrollerOptions = _ref4.scrollerOptions;
        return {
            height: scrollerOptions.props ? scrollerOptions.props.itemSize : undefined
        };
    },
    list: function list(_ref5) {
        var options = _ref5.options, props = _ref5.props;
        return props.virtualScrollerOptions ? options.style : undefined;
    }
};
var $37f8d4c0bc2f6dce$var$ListBoxBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'ListBox',
        className: null,
        dataKey: null,
        disabled: null,
        emptyFilterMessage: null,
        emptyMessage: null,
        filter: false,
        filterIcon: null,
        filterBy: null,
        filterInputProps: null,
        filterLocale: undefined,
        filterMatchMode: 'contains',
        filterPlaceholder: null,
        filterTemplate: null,
        filterValue: null,
        focusOnHover: true,
        id: null,
        itemTemplate: null,
        invalid: false,
        listClassName: null,
        listStyle: null,
        metaKeySelection: false,
        selectOnFocus: false,
        autoOptionFocus: false,
        multiple: false,
        onChange: null,
        onFilterValueChange: null,
        optionDisabled: null,
        optionGroupChildren: null,
        optionGroupLabel: null,
        optionGroupTemplate: null,
        optionLabel: null,
        optionValue: null,
        options: null,
        style: null,
        tabIndex: 0,
        tooltip: null,
        tooltipOptions: null,
        value: null,
        virtualScrollerOptions: null,
        children: undefined
    },
    css: {
        classes: $37f8d4c0bc2f6dce$var$classes,
        styles: $37f8d4c0bc2f6dce$var$styles,
        inlineStyles: $37f8d4c0bc2f6dce$var$inlineStyles
    }
});
function $37f8d4c0bc2f6dce$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $37f8d4c0bc2f6dce$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $37f8d4c0bc2f6dce$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $37f8d4c0bc2f6dce$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $37f8d4c0bc2f6dce$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $37f8d4c0bc2f6dce$var$ListBoxHeader = /*#__PURE__*/ $acw62.memo(function(props) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, cx = _props$ptCallbacks.cx;
    var getPTOptions = function getPTOptions(key, options) {
        return ptm(key, $37f8d4c0bc2f6dce$var$_objectSpread$1({
            hostName: props.hostName
        }, options));
    };
    var filterOptions = {
        filter: function filter(e) {
            return onFilter(e);
        },
        reset: function reset() {
            return props.resetFilter();
        }
    };
    var onFilter = function onFilter(event) {
        if (props.onFilter) props.onFilter({
            originalEvent: event,
            value: event.target.value
        });
    };
    var createHeader = function createHeader() {
        var filterIconProps = mergeProps({
            className: cx('filterIcon')
        }, getPTOptions('filterIcon'));
        var icon = props.filterIcon || /*#__PURE__*/ $acw62.createElement((0, $dbb1fbeb3f53a92c$export$82eafebb825fc23f), filterIconProps);
        var filterIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $37f8d4c0bc2f6dce$var$_objectSpread$1({}, filterIconProps), {
            props: props
        });
        var headerProps = mergeProps({
            className: cx('header')
        }, getPTOptions('header'));
        var filterContainerProps = mergeProps({
            className: cx('filterContainer')
        }, getPTOptions('filterContainer'));
        var content = /*#__PURE__*/ $acw62.createElement("div", filterContainerProps, /*#__PURE__*/ $acw62.createElement((0, $ab1a721814a59df6$export$7034fcb7d6351061), $37f8d4c0bc2f6dce$var$_extends({
            type: "text",
            value: props.filter,
            onChange: onFilter,
            className: cx('filterInput'),
            disabled: props.disabled,
            placeholder: props.filterPlaceholder
        }, props.filterInputProps, {
            pt: ptm('filterInput'),
            unstyled: props.unstyled,
            __parentMetadata: {
                parent: props.metaData
            }
        })), filterIcon);
        if (props.filterTemplate) {
            var defaultContentOptions = {
                className: 'p-listbox-filter-container',
                element: content,
                filterOptions: filterOptions,
                filterInputChange: onFilter,
                filterIconClassName: 'p-dropdown-filter-icon',
                props: props
            };
            content = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.filterTemplate, defaultContentOptions);
        }
        return /*#__PURE__*/ $acw62.createElement("div", headerProps, content);
    };
    var content = createHeader();
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, content);
});
$37f8d4c0bc2f6dce$var$ListBoxHeader.displayName = 'ListBoxHeader';
var $37f8d4c0bc2f6dce$var$ListBoxItem = /*#__PURE__*/ $acw62.memo(function(props) {
    var _React$useState = $acw62.useState(false), _React$useState2 = $37f8d4c0bc2f6dce$var$_slicedToArray(_React$useState, 2), focusedState = _React$useState2[0], setFocusedState = _React$useState2[1];
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, cx = _props$ptCallbacks.cx;
    var getPTOptions = function getPTOptions(key) {
        return ptm(key, {
            hostName: props.hostName,
            context: {
                selected: props.selected,
                disabled: props.disabled,
                focused: focusedState,
                focusedOptionIndex: props.focusedOptionIndex
            }
        });
    };
    var onFocus = function onFocus(event) {
        setFocusedState(true);
    };
    var onBlur = function onBlur(event) {
        setFocusedState(false);
    };
    var onTouchEnd = function onTouchEnd(event) {
        if (props.onTouchEnd) props.onTouchEnd({
            originalEvent: event,
            option: props.option
        });
    };
    var content = props.template ? (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.template, props.option) : props.label;
    var itemProps = mergeProps({
        id: props.id,
        className: cx('item', {
            props: props
        }),
        style: props.style,
        onClick: function onClick(event) {
            return props.onClick(event, props.option, props.index);
        },
        onTouchEnd: onTouchEnd,
        onFocus: onFocus,
        onBlur: onBlur,
        tabIndex: '-1',
        onMouseDown: function onMouseDown(event) {
            return props.onOptionMouseDown(event, props.index);
        },
        onMouseMove: function onMouseMove(event) {
            return props.onOptionMouseMove(event, props.index);
        },
        'aria-label': props.label,
        role: 'option',
        'aria-selected': props.selected,
        'aria-disabled': props.disabled,
        'data-p-disabled': props.disabled
    }, getPTOptions('item'));
    return /*#__PURE__*/ $acw62.createElement("li", $37f8d4c0bc2f6dce$var$_extends({}, itemProps, {
        key: props.optionKey
    }), content, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
});
$37f8d4c0bc2f6dce$var$ListBoxItem.displayName = 'ListBoxItem';
function $37f8d4c0bc2f6dce$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $37f8d4c0bc2f6dce$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $37f8d4c0bc2f6dce$var$ownKeys(Object(t), !0).forEach(function(r) {
            $37f8d4c0bc2f6dce$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $37f8d4c0bc2f6dce$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $37f8d4c0bc2f6dce$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $37f8d4c0bc2f6dce$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $37f8d4c0bc2f6dce$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $37f8d4c0bc2f6dce$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $37f8d4c0bc2f6dce$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $37f8d4c0bc2f6dce$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $37f8d4c0bc2f6dce$export$41f133550aa26f48 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $37f8d4c0bc2f6dce$var$ListBoxBase.getProps(inProps, context);
    var _React$useState = $acw62.useState(null), _React$useState2 = $37f8d4c0bc2f6dce$var$_slicedToArray(_React$useState, 2), focusedOptionIndex = _React$useState2[0], setFocusedOptionIndex = _React$useState2[1];
    var searchTimeout = $acw62.useRef(null);
    var firstHiddenFocusableElement = $acw62.useRef(null);
    var lastHiddenFocusableElement = $acw62.useRef(null);
    var _React$useState3 = $acw62.useState(-1), _React$useState4 = $37f8d4c0bc2f6dce$var$_slicedToArray(_React$useState3, 2), startRangeIndex = _React$useState4[0], setStartRangeIndex = _React$useState4[1];
    var _React$useState5 = $acw62.useState(false), _React$useState6 = $37f8d4c0bc2f6dce$var$_slicedToArray(_React$useState5, 2), focused = _React$useState6[0], setFocused = _React$useState6[1];
    var _React$useState7 = $acw62.useState(''), _React$useState8 = $37f8d4c0bc2f6dce$var$_slicedToArray(_React$useState7, 2), filterValueState = _React$useState8[0], setFilterValueState = _React$useState8[1];
    var _React$useState9 = $acw62.useState(''), _React$useState10 = $37f8d4c0bc2f6dce$var$_slicedToArray(_React$useState9, 2), searchValue = _React$useState10[0], setSearchValue = _React$useState10[1];
    var elementRef = $acw62.useRef(null);
    var virtualScrollerRef = $acw62.useRef(null);
    var id = $acw62.useRef(null);
    var listRef = $acw62.useRef(null);
    var optionTouched = $acw62.useRef(false);
    var filteredValue = (props.onFilterValueChange ? props.filterValue : filterValueState) || '';
    var hasFilter = filteredValue && filteredValue.trim().length > 0;
    var metaData = {
        props: props,
        state: {
            filterValue: filteredValue
        }
    };
    var ptCallbacks = $37f8d4c0bc2f6dce$var$ListBoxBase.setMetaData(metaData);
    (0, $b76d8eda63b3c134$export$142583cb150b394)($37f8d4c0bc2f6dce$var$ListBoxBase.css.styles, ptCallbacks.isUnstyled, {
        name: 'listbox'
    });
    var onOptionSelect = function onOptionSelect(event, option) {
        var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
        if (props.disabled || isOptionDisabled(option)) return;
        props.multiple ? onOptionSelectMultiple(event.originalEvent, option) : onOptionSelectSingle(event.originalEvent, option);
        optionTouched.current = false;
        index !== -1 && setFocusedOptionIndex(index);
    };
    var onOptionMouseDown = function onOptionMouseDown(event, index) {
        changeFocusedOptionIndex(event, index);
    };
    var onOptionMouseMove = function onOptionMouseMove(event, index) {
        if (props.focusOnHover && focused) changeFocusedOptionIndex(event, index);
    };
    var onOptionTouchEnd = function onOptionTouchEnd() {
        if (props.disabled) return;
        optionTouched.current = true;
    };
    var onOptionSelectSingle = function onOptionSelectSingle(event, option) {
        var selected = isSelected(option);
        var valueChanged = false;
        var value = null;
        var metaSelection = optionTouched.current ? false : props.metaKeySelection;
        if (metaSelection) {
            var metaKey = event.metaKey || event.ctrlKey;
            if (selected) {
                if (metaKey) {
                    value = null;
                    valueChanged = true;
                }
            } else {
                value = getOptionValue(option);
                valueChanged = true;
            }
        } else {
            value = selected ? null : getOptionValue(option);
            valueChanged = true;
        }
        if (valueChanged) updateModel(event, value);
    };
    var onOptionSelectMultiple = function onOptionSelectMultiple(event, option) {
        var selected = isSelected(option);
        var valueChanged = false;
        var value = null;
        var metaSelection = optionTouched ? false : props.metaKeySelection;
        if (metaSelection) {
            var metaKey = event.metaKey || event.ctrlKey;
            if (selected) {
                if (metaKey) value = removeOption(option);
                else value = [
                    getOptionValue(option)
                ];
                valueChanged = true;
            } else {
                value = metaKey ? props.value || [] : [];
                value = [].concat($37f8d4c0bc2f6dce$var$_toConsumableArray(value), [
                    getOptionValue(option)
                ]);
                valueChanged = true;
            }
        } else {
            if (selected) value = removeOption(option);
            else value = [].concat($37f8d4c0bc2f6dce$var$_toConsumableArray(props.value || []), [
                getOptionValue(option)
            ]);
            valueChanged = true;
        }
        if (valueChanged) props.onChange({
            originalEvent: event,
            value: value,
            stopPropagation: function stopPropagation() {
                event === null || event === void 0 || event.stopPropagation();
            },
            preventDefault: function preventDefault() {
                event === null || event === void 0 || event.preventDefault();
            },
            target: {
                name: props.name,
                id: props.id,
                value: value
            }
        });
    };
    var hasSelectedOption = function hasSelectedOption() {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.value);
    };
    var isOptionGroup = function isOptionGroup(option) {
        return props.optionGroupLabel && option.optionGroup && option.group;
    };
    var isValidOption = function isValidOption(option) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(option) && !(isOptionDisabled(option) || isOptionGroup(option));
    };
    var isValidSelectedOption = function isValidSelectedOption(option) {
        return isValidOption(option) && isSelected(option);
    };
    var findFirstOptionIndex = function findFirstOptionIndex() {
        return visibleOptions.findIndex(function(option) {
            return isValidOption(option);
        });
    };
    var findLastSelectedOptionIndex = function findLastSelectedOptionIndex() {
        return hasSelectedOption() ? (0, $a73ce425265b079e$export$4855211e6b8ad895).findLastIndex(visibleOptions, function(option) {
            return isValidSelectedOption(option);
        }) : -1;
    };
    var findSelectedOptionIndex = function findSelectedOptionIndex() {
        if (hasSelectedOption()) {
            if (props.multiple) {
                var _loop = function _loop() {
                    var value = props.value[index];
                    var matchedOptionIndex = visibleOptions.findIndex(function(option) {
                        return isValidSelectedOption(option) && isEquals(value, getOptionValue(option));
                    });
                    if (matchedOptionIndex > -1) return {
                        v: matchedOptionIndex
                    };
                }, _ret;
                for(var index = props.value.length - 1; index >= 0; index--){
                    _ret = _loop();
                    if (_ret) return _ret.v;
                }
            } else return visibleOptions.findIndex(function(option) {
                return isValidSelectedOption(option);
            });
        }
        return -1;
    };
    var findFirstSelectedOptionIndex = function findFirstSelectedOptionIndex() {
        return hasSelectedOption() ? visibleOptions.findIndex(function(option) {
            return isValidSelectedOption(option);
        }) : -1;
    };
    var findLastOptionIndex = function findLastOptionIndex() {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).findLastIndex(visibleOptions, function(option) {
            return isValidOption(option);
        });
    };
    var findNextOptionIndex = function findNextOptionIndex(index) {
        var matchedOptionIndex = index < visibleOptions.length - 1 ? visibleOptions.slice(index + 1).findIndex(function(option) {
            return isValidOption(option);
        }) : -1;
        return matchedOptionIndex > -1 ? matchedOptionIndex + index + 1 : index;
    };
    var findPrevOptionIndex = function findPrevOptionIndex(index) {
        var matchedOptionIndex = index > 0 ? (0, $a73ce425265b079e$export$4855211e6b8ad895).findLastIndex(visibleOptions.slice(0, index), function(option) {
            return isValidOption(option);
        }) : -1;
        return matchedOptionIndex > -1 ? matchedOptionIndex : index;
    };
    var focusedOptionId = function focusedOptionId() {
        return focusedOptionIndex !== -1 ? "".concat(id.current, "_").concat(focusedOptionIndex) : null;
    };
    var findNearestSelectedOptionIndex = function findNearestSelectedOptionIndex(index) {
        var firstCheckUp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var matchedOptionIndex = -1;
        if (hasSelectedOption()) {
            if (firstCheckUp) {
                matchedOptionIndex = findPrevSelectedOptionIndex(index);
                matchedOptionIndex = matchedOptionIndex === -1 ? findNextSelectedOptionIndex(index) : matchedOptionIndex;
            } else {
                matchedOptionIndex = findNextSelectedOptionIndex(index);
                matchedOptionIndex = matchedOptionIndex === -1 ? findPrevSelectedOptionIndex(index) : matchedOptionIndex;
            }
        }
        return matchedOptionIndex > -1 ? matchedOptionIndex : index;
    };
    var isOptionMatched = function isOptionMatched(option) {
        var _getOptionLabel;
        return isValidOption(option) && ((_getOptionLabel = getOptionLabel(option)) === null || _getOptionLabel === void 0 ? void 0 : _getOptionLabel.toLocaleLowerCase(props.filterLocale).startsWith(searchValue.toLocaleLowerCase(props.filterLocale)));
    };
    var searchOptions = function searchOptions(event, _char) {
        setSearchValue((searchValue || '') + _char);
        var optionIndex = -1;
        if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(searchValue)) {
            if (focusedOptionIndex !== -1) {
                optionIndex = visibleOptions.slice(focusedOptionIndex).findIndex(function(option) {
                    return isOptionMatched(option);
                });
                optionIndex = optionIndex === -1 ? visibleOptions.slice(0, focusedOptionIndex).findIndex(function(option) {
                    return isOptionMatched(option);
                }) : optionIndex + focusedOptionIndex;
            } else optionIndex = visibleOptions.findIndex(function(option) {
                return isOptionMatched(option);
            });
            if (optionIndex === -1 && focusedOptionIndex === -1) optionIndex = findFirstFocusedOptionIndex();
            if (optionIndex !== -1) changeFocusedOptionIndex(event, optionIndex);
        }
        if (searchTimeout.current) clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(function() {
            setSearchValue('');
            searchTimeout.current = null;
        }, 500);
    };
    var findNextSelectedOptionIndex = function findNextSelectedOptionIndex(index) {
        var matchedOptionIndex = hasSelectedOption() && index < visibleOptions.length - 1 ? visibleOptions.slice(index + 1).findIndex(function(option) {
            return isValidSelectedOption(option);
        }) : -1;
        return matchedOptionIndex > -1 ? matchedOptionIndex + index + 1 : -1;
    };
    var findPrevSelectedOptionIndex = function findPrevSelectedOptionIndex(index) {
        var matchedOptionIndex = hasSelectedOption() && index > 0 ? (0, $a73ce425265b079e$export$4855211e6b8ad895).findLastIndex(visibleOptions.slice(0, index), function(option) {
            return isValidSelectedOption(option);
        }) : -1;
        return matchedOptionIndex > -1 ? matchedOptionIndex : -1;
    };
    var onOptionSelectRange = function onOptionSelectRange(event) {
        var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
        var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
        start === -1 && (start = findNearestSelectedOptionIndex(end, true));
        end === -1 && (end = findNearestSelectedOptionIndex(start));
        if (start !== -1 && end !== -1) {
            var rangeStart = Math.min(start, end);
            var rangeEnd = Math.max(start, end);
            var value = visibleOptions.slice(rangeStart, rangeEnd + 1).filter(function(option) {
                return isValidOption(option);
            }).map(function(option) {
                return getOptionValue(option);
            });
            updateModel(event, value);
        }
    };
    var findFirstFocusedOptionIndex = function findFirstFocusedOptionIndex() {
        var selectedIndex = findFirstSelectedOptionIndex();
        return selectedIndex < 0 ? findFirstOptionIndex() : selectedIndex;
    };
    var findLastFocusedOptionIndex = function findLastFocusedOptionIndex() {
        var selectedIndex = findLastSelectedOptionIndex();
        return selectedIndex < 0 ? findLastOptionIndex() : selectedIndex;
    };
    var changeFocusedOptionIndex = function changeFocusedOptionIndex(event, index) {
        if (focusedOptionIndex !== index) {
            setFocusedOptionIndex(index);
            scrollInView();
            if (event && props.selectOnFocus && !props.multiple) onOptionSelect(event, visibleOptions[index]);
        }
    };
    var onArrowDownKey = function onArrowDownKey(event) {
        var optionIndex = focusedOptionIndex !== -1 ? findNextOptionIndex(focusedOptionIndex) : findFirstFocusedOptionIndex();
        if (props.multiple && event.shiftKey) onOptionSelectRange(event, startRangeIndex, optionIndex);
        changeFocusedOptionIndex(event, optionIndex);
        event.preventDefault();
    };
    var onArrowUpKey = function onArrowUpKey(event) {
        var optionIndex = focusedOptionIndex !== -1 ? findPrevOptionIndex(focusedOptionIndex) : findLastFocusedOptionIndex();
        if (props.multiple && event.shiftKey) onOptionSelectRange(event, optionIndex, startRangeIndex);
        changeFocusedOptionIndex(event, optionIndex);
        event.preventDefault();
    };
    var onEnterKey = function onEnterKey(event) {
        if (focusedOptionIndex !== -1) {
            if (props.multiple && event.shiftKey) onOptionSelectRange(event, focusedOptionIndex);
            else onOptionSelect(event, visibleOptions[focusedOptionIndex]);
        }
        event.preventDefault();
    };
    var onSpaceKey = function onSpaceKey(event) {
        onEnterKey(event);
    };
    var onShiftKey = function onShiftKey() {
        setStartRangeIndex(focusedOptionIndex);
    };
    var onHomeKey = function onHomeKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (pressedInInputText) {
            event.currentTarget.setSelectionRange(0, 0);
            setFocusedOptionIndex(-1);
        } else {
            var metaKey = event.metaKey || event.ctrlKey;
            var optionIndex = findFirstOptionIndex();
            if (props.multiple && event.shiftKey && metaKey) onOptionSelectRange(event, optionIndex, startRangeIndex);
            changeFocusedOptionIndex(event, optionIndex);
        }
        event.preventDefault();
    };
    var onEndKey = function onEndKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (pressedInInputText) {
            var target = event.currentTarget;
            var len = target.value.length;
            target.setSelectionRange(len, len);
            setFocusedOptionIndex(-1);
        } else {
            var metaKey = event.metaKey || event.ctrlKey;
            var optionIndex = findLastOptionIndex();
            if (props.multiple && event.shiftKey && metaKey) onOptionSelectRange(event, startRangeIndex, optionIndex);
            changeFocusedOptionIndex(event, optionIndex);
        }
        event.preventDefault();
    };
    var onPageUpKey = function onPageUpKey(event) {
        scrollInView(0);
        event.preventDefault();
    };
    var onPageDownKey = function onPageDownKey(event) {
        scrollInView(visibleOptions.length - 1);
        event.preventDefault();
    };
    var onListKeyDown = function onListKeyDown(event) {
        var metaKey = event.metaKey || event.ctrlKey;
        switch(event.code){
            case 'ArrowDown':
                onArrowDownKey(event);
                break;
            case 'ArrowUp':
                onArrowUpKey(event);
                break;
            case 'Home':
                onHomeKey(event);
                break;
            case 'End':
                onEndKey(event);
                break;
            case 'PageDown':
                onPageDownKey(event);
                break;
            case 'PageUp':
                onPageUpKey(event);
                break;
            case 'Enter':
            case 'NumpadEnter':
            case 'Space':
                onSpaceKey(event);
                event.preventDefault();
                break;
            case 'Tab':
                break;
            case 'ShiftLeft':
            case 'ShiftRight':
                onShiftKey();
                break;
            default:
                if (props.multiple && event.key === 'a' && metaKey) {
                    var value = visibleOptions.filter(function(option) {
                        return isValidOption(option);
                    }).map(function(option) {
                        return getOptionValue(option);
                    });
                    updateModel(event, value);
                    event.preventDefault();
                    break;
                }
                if (!metaKey && (0, $a73ce425265b079e$export$4855211e6b8ad895).isPrintableCharacter(event.key)) {
                    searchOptions(event, event.key);
                    event.preventDefault();
                }
                break;
        }
    };
    var scrollInView = function scrollInView() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
        setTimeout(function() {
            // As long as this is a timeout - there is not guarantee that listRef will still
            // exist by the moment of calling that function. So, if list is already destroyed
            // by this moment - do nothing:
            if (!listRef.current) return;
            var idx = index !== -1 ? "".concat(id.current, "_").concat(index) : focusedOptionId();
            var element = listRef.current.querySelector("li[id=\"".concat(idx, "\"]"));
            if (element) element.scrollIntoView({
                block: 'nearest',
                inline: 'nearest',
                behavior: 'smooth'
            });
            else if (props.virtualScrollerOptions) virtualScrollerRef.current && virtualScrollerRef.current.scrollToIndex(index !== -1 ? index : focusedOptionIndex);
        }, 0);
    };
    var onFilter = function onFilter(event) {
        virtualScrollerRef.current && virtualScrollerRef.current.scrollToIndex(0);
        var originalEvent = event.originalEvent, value = event.value;
        if (props.onFilterValueChange) props.onFilterValueChange({
            originalEvent: originalEvent,
            value: value
        });
        else setFilterValueState(value);
    };
    var resetFilter = function resetFilter() {
        setFilterValueState('');
        props.onFilter && props.onFilter({
            filter: ''
        });
    };
    var autoUpdateModel = function autoUpdateModel() {
        var isFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : focused;
        if (props.selectOnFocus && props.autoOptionFocus && !hasSelectedOption() && !props.multiple && isFocus) {
            var currentFocusOptionIndex = findFirstFocusedOptionIndex();
            onOptionSelect(null, visibleOptions[currentFocusOptionIndex]);
            setFocusedOptionIndex(currentFocusOptionIndex);
        }
    };
    var updateModel = function updateModel(event, value) {
        if (props.onChange) props.onChange({
            originalEvent: event,
            value: value,
            stopPropagation: function stopPropagation() {
                event === null || event === void 0 || event.stopPropagation();
            },
            preventDefault: function preventDefault() {
                event === null || event === void 0 || event.preventDefault();
            },
            target: {
                name: props.name,
                id: props.id,
                value: value
            }
        });
    };
    var removeOption = function removeOption(option) {
        return props.value.filter(function(val) {
            return !(0, $a73ce425265b079e$export$4855211e6b8ad895).equals(val, getOptionValue(option), props.dataKey);
        });
    };
    var getSelectedOptionIndex = function getSelectedOptionIndex() {
        if (props.value != null && visibleOptions) {
            if (props.optionGroupLabel) for(var i = 0; i < visibleOptions.length; i++){
                var selectedOptionIndex = findOptionIndexInList(props.value, getOptionGroupChildren(visibleOptions[i]));
                if (selectedOptionIndex !== -1) return {
                    group: i,
                    option: selectedOptionIndex
                };
            }
            else return findOptionIndexInList(props.value, visibleOptions);
        }
        return -1;
    };
    var equalityKey = function equalityKey() {
        return props.optionValue ? null : props.dataKey;
    };
    var findOptionIndexInList = function findOptionIndexInList(value, list) {
        var key = equalityKey();
        return list.findIndex(function(item) {
            return (0, $a73ce425265b079e$export$4855211e6b8ad895).equals(value, getOptionValue(item), key);
        });
    };
    var isEquals = function isEquals(value1, value2) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).equals(value1, value2, equalityKey());
    };
    var isSelected = function isSelected(option) {
        var optionValue = getOptionValue(option);
        if (props.multiple) return (props.value || []).some(function(value) {
            return isEquals(value, optionValue);
        });
        return isEquals(props.value, optionValue);
    };
    var getOptionLabel = function getOptionLabel(option) {
        return props.optionLabel ? (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(option, props.optionLabel) : option && option.label !== undefined ? option.label : option;
    };
    var getOptionValue = function getOptionValue(option) {
        return props.optionValue ? (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(option, props.optionValue) : option && option.value !== undefined ? option.value : option;
    };
    var getOptionRenderKey = function getOptionRenderKey(option) {
        return props.dataKey ? (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(option, props.dataKey) : getOptionLabel(option);
    };
    var isOptionDisabled = function isOptionDisabled(option) {
        if (props.optionDisabled) return (0, $a73ce425265b079e$export$4855211e6b8ad895).isFunction(props.optionDisabled) ? props.optionDisabled(option) : (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(option, props.optionDisabled);
        return option && option.disabled !== undefined ? option.disabled : false;
    };
    var onFirstHiddenFocus = function onFirstHiddenFocus() {
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(listRef.current);
        var firstFocusableEl = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getFirstFocusableElement(elementRef.current, ':not([data-p-hidden-focusable="true"])');
        lastHiddenFocusableElement.current.tabIndex = (0, $a73ce425265b079e$export$ff8ccbac9225de62).isElement(firstFocusableEl) ? undefined : -1;
        firstHiddenFocusableElement.current.tabIndex = -1;
        changeFocusedOptionIndex(null, 0);
    };
    var onLastHiddenFocus = function onLastHiddenFocus(event) {
        var relatedTarget = event.relatedTarget;
        if (relatedTarget === listRef.current) {
            var firstFocusableEl = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getFirstFocusableElement(elementRef.current, ':not([data-p-hidden-focusable="true"])');
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(firstFocusableEl);
            firstHiddenFocusableElement.current.tabIndex = undefined;
        } else (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(firstHiddenFocusableElement.current);
        lastHiddenFocusableElement.current.tabIndex = -1;
    };
    var onListFocus = function onListFocus() {
        setFocused(true);
        setFocusedOptionIndex(focusedOptionIndex !== -1 ? focusedOptionIndex : props.autoOptionFocus ? findFirstFocusedOptionIndex() : findSelectedOptionIndex());
        autoUpdateModel(true);
    };
    var onListBlur = function onListBlur() {
        setFocused(false);
        setFocusedOptionIndex(-1);
        setStartRangeIndex(-1);
        setSearchValue('');
    };
    var getOptionGroupRenderKey = function getOptionGroupRenderKey(optionGroup) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(optionGroup, props.optionGroupLabel);
    };
    var getOptionGroupLabel = function getOptionGroupLabel(optionGroup) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(optionGroup, props.optionGroupLabel);
    };
    var getOptionGroupChildren = function getOptionGroupChildren(optionGroup) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).resolveFieldData(optionGroup, props.optionGroupChildren);
    };
    var flatOptions = function flatOptions(options) {
        return (options || []).reduce(function(result, option, index) {
            result.push({
                optionGroup: option,
                group: true,
                index: index,
                code: option.code,
                label: option.label
            });
            var optionGroupChildren = getOptionGroupChildren(option);
            optionGroupChildren && optionGroupChildren.forEach(function(o) {
                return result.push(o);
            });
            return result;
        }, []);
    };
    var getVisibleOptions = function getVisibleOptions() {
        var options = props.optionGroupLabel ? flatOptions(props.options) : props.options;
        if (hasFilter) {
            var filterValue = filteredValue.trim().toLocaleLowerCase(props.filterLocale);
            var searchFields = props.filterBy ? props.filterBy.split(',') : [
                props.optionLabel || 'label'
            ];
            if (props.optionGroupLabel) {
                var filteredGroups = [];
                var _iterator = $37f8d4c0bc2f6dce$var$_createForOfIteratorHelper(props.options), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var optgroup = _step.value;
                        var filteredSubOptions = (0, $51b25b42ecc1a0c7$export$f4fb036b8adcc8c8).filter(getOptionGroupChildren(optgroup), searchFields, filterValue, props.filterMatchMode, props.filterLocale);
                        if (filteredSubOptions && filteredSubOptions.length) filteredGroups.push($37f8d4c0bc2f6dce$var$_objectSpread($37f8d4c0bc2f6dce$var$_objectSpread({}, optgroup), {
                            items: filteredSubOptions
                        }));
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return flatOptions(filteredGroups);
            }
            return (0, $51b25b42ecc1a0c7$export$f4fb036b8adcc8c8).filter(options, searchFields, filterValue, props.filterMatchMode, props.filterLocale);
        }
        return options;
    };
    var scrollToSelectedIndex = function scrollToSelectedIndex() {
        if (virtualScrollerRef.current) {
            var selectedIndex = getSelectedOptionIndex();
            if (selectedIndex !== -1) setTimeout(function() {
                return virtualScrollerRef.current.scrollToIndex(selectedIndex);
            }, 0);
        }
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            focus: function focus() {
                return (0, $a73ce425265b079e$export$ff8ccbac9225de62).focusFirstElement(elementRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getVirtualScroller: function getVirtualScroller() {
                return virtualScrollerRef.current;
            }
        };
    });
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        scrollToSelectedIndex();
        id.current = (0, $a73ce425265b079e$export$d5d9b89141473caf)();
    });
    var createHeader = function createHeader() {
        return props.filter ? /*#__PURE__*/ $acw62.createElement($37f8d4c0bc2f6dce$var$ListBoxHeader, {
            hostName: "ListBox",
            filter: filteredValue,
            filterIcon: props.filterIcon,
            onFilter: onFilter,
            resetFilter: resetFilter,
            filterTemplate: props.filterTemplate,
            disabled: props.disabled,
            filterPlaceholder: props.filterPlaceholder,
            filterInputProps: props.filterInputProps,
            ptCallbacks: ptCallbacks,
            metaData: metaData
        }) : null;
    };
    var createItem = function createItem(option, index) {
        var scrollerOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var style = {
            height: scrollerOptions.props ? scrollerOptions.props.itemSize : undefined
        };
        if (option.group && option.optionGroup && props.optionGroupLabel) {
            var groupContent = props.optionGroupTemplate ? (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.optionGroupTemplate, option, index) : getOptionGroupLabel(option);
            var key = index + '_' + getOptionGroupRenderKey(option);
            var itemGroupProps = mergeProps({
                className: ptCallbacks.cx('itemGroup'),
                style: ptCallbacks.sx('itemGroup', {
                    scrollerOptions: scrollerOptions
                }),
                role: 'group'
            }, ptCallbacks.ptm('itemGroup'));
            return /*#__PURE__*/ $acw62.createElement("li", $37f8d4c0bc2f6dce$var$_extends({}, itemGroupProps, {
                key: key
            }), groupContent);
        }
        var optionLabel = getOptionLabel(option);
        var optionKey = index + '_' + getOptionRenderKey(option);
        var disabled = isOptionDisabled(option);
        return /*#__PURE__*/ $acw62.createElement($37f8d4c0bc2f6dce$var$ListBoxItem, {
            id: id.current + '_' + index,
            hostName: "ListBox",
            optionKey: optionKey,
            key: optionKey,
            label: optionLabel,
            index: index,
            onOptionMouseDown: onOptionMouseDown,
            onOptionMouseMove: onOptionMouseMove,
            focusedOptionIndex: focusedOptionIndex,
            option: option,
            style: style,
            template: props.itemTemplate,
            selected: isSelected(option),
            onClick: onOptionSelect,
            onTouchEnd: onOptionTouchEnd,
            disabled: disabled,
            ptCallbacks: ptCallbacks,
            metaData: metaData
        });
    };
    var createItems = function createItems() {
        if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(visibleOptions)) return visibleOptions.map(createItem);
        else if (hasFilter) return createEmptyMessage(props.emptyFilterMessage, true);
        return createEmptyMessage(props.emptyMessage);
    };
    var createEmptyMessage = function createEmptyMessage(emptyMessage, isFilter) {
        var emptyMessageProps = mergeProps({
            className: ptCallbacks.cx('emptyMessage')
        }, ptCallbacks.ptm('emptyMessage'));
        var message = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(emptyMessage, props) || (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)(isFilter ? 'emptyFilterMessage' : 'emptyMessage');
        return /*#__PURE__*/ $acw62.createElement("li", emptyMessageProps, message);
    };
    var createList = function createList() {
        if (props.virtualScrollerOptions) {
            var virtualScrollerProps = $37f8d4c0bc2f6dce$var$_objectSpread($37f8d4c0bc2f6dce$var$_objectSpread({}, props.virtualScrollerOptions), {
                items: visibleOptions,
                onLazyLoad: function onLazyLoad(event) {
                    return props.virtualScrollerOptions.onLazyLoad($37f8d4c0bc2f6dce$var$_objectSpread($37f8d4c0bc2f6dce$var$_objectSpread({}, event), {
                        filter: visibleOptions
                    }));
                },
                itemTemplate: function itemTemplate(item, options) {
                    return item && createItem(item, options.index, options);
                },
                contentTemplate: function contentTemplate(options) {
                    var listProps = mergeProps($37f8d4c0bc2f6dce$var$_objectSpread({
                        ref: listRef,
                        style: ptCallbacks.sx('list', {
                            options: options
                        }),
                        className: ptCallbacks.cx('list', {
                            options: options
                        }),
                        role: 'listbox',
                        tabIndex: '-1',
                        'aria-multiselectable': props.multiple,
                        onFocus: onListFocus,
                        onBlur: onListBlur,
                        onKeyDown: onListKeyDown
                    }, ariaProps), ptCallbacks.ptm('list'));
                    return /*#__PURE__*/ $acw62.createElement("ul", listProps, options.children);
                }
            });
            return /*#__PURE__*/ $acw62.createElement((0, $50cb59e69476e4bf$export$fbd4ea7fe0fb889), $37f8d4c0bc2f6dce$var$_extends({
                ref: virtualScrollerRef
            }, virtualScrollerProps, {
                pt: ptCallbacks.ptm('virtualScroller')
            }));
        }
        var items = createItems();
        var listProps = mergeProps($37f8d4c0bc2f6dce$var$_objectSpread({
            ref: listRef,
            className: ptCallbacks.cx('list'),
            role: 'listbox',
            'aria-multiselectable': props.multiple,
            tabIndex: '-1',
            onFocus: onListFocus,
            onBlur: onListBlur,
            onKeyDown: onListKeyDown
        }, ariaProps), ptCallbacks.ptm('list'));
        return /*#__PURE__*/ $acw62.createElement("ul", listProps, items);
    };
    var visibleOptions = getVisibleOptions();
    var hasTooltip = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.tooltip);
    var otherProps = $37f8d4c0bc2f6dce$var$ListBoxBase.getOtherProps(props);
    var ariaProps = (0, $a73ce425265b079e$export$4855211e6b8ad895).reduceKeys(otherProps, (0, $a73ce425265b079e$export$ff8ccbac9225de62).ARIA_PROPS);
    var list = createList();
    var header = createHeader();
    var wrapperProps = mergeProps({
        className: ptCallbacks.cx('wrapper'),
        style: props.listStyle
    }, ptCallbacks.ptm('wrapper'));
    var rootProps = mergeProps({
        ref: elementRef,
        id: props.id,
        className: ptCallbacks.cx('root'),
        style: props.style
    }, $37f8d4c0bc2f6dce$var$ListBoxBase.getOtherProps(props), ptCallbacks.ptm('root'));
    var hiddenFirstElement = mergeProps({
        ref: firstHiddenFocusableElement,
        role: 'presentation',
        'aria-hidden': 'true',
        className: 'p-hidden-accessible p-hidden-focusable',
        tabIndex: !props.disabled ? props.tabIndex : -1,
        onFocus: onFirstHiddenFocus,
        'data-p-hidden-accessible': true,
        'data-p-hidden-focusable': true
    }, ptCallbacks.ptm('hiddenFirstFocusableEl'));
    var hiddenLastElement = mergeProps({
        ref: lastHiddenFocusableElement,
        role: 'presentation',
        'aria-hidden': 'true',
        className: 'p-hidden-accessible p-hidden-focusable',
        tabIndex: !props.disabled ? props.tabIndex : -1,
        onFocus: onLastHiddenFocus,
        'data-p-hidden-accessible': true,
        'data-p-hidden-focusable': true
    }, ptCallbacks.ptm('hiddenLastFocusableEl'));
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", rootProps, /*#__PURE__*/ $acw62.createElement("span", hiddenFirstElement), header, /*#__PURE__*/ $acw62.createElement("div", wrapperProps, list), /*#__PURE__*/ $acw62.createElement("span", hiddenLastElement)), hasTooltip && /*#__PURE__*/ $acw62.createElement((0, $b74dfa9f7ee9d9bc$export$28c660c63b792dea), $37f8d4c0bc2f6dce$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptCallbacks.ptm('tooltip')
    }, props.tooltipOptions)));
}));
$37f8d4c0bc2f6dce$export$41f133550aa26f48.displayName = 'ListBox';







var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

'use client';
function $3e5119c1e8269632$var$_extends() {
    return $3e5119c1e8269632$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3e5119c1e8269632$var$_extends.apply(null, arguments);
}
var $3e5119c1e8269632$export$5fda1783bb83f57b = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $3e5119c1e8269632$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M10.7838 1.51351H9.83783V0.567568C9.83783 0.417039 9.77804 0.272676 9.6716 0.166237C9.56516 0.0597971 9.42079 0 9.27027 0C9.11974 0 8.97538 0.0597971 8.86894 0.166237C8.7625 0.272676 8.7027 0.417039 8.7027 0.567568V1.51351H5.29729V0.567568C5.29729 0.417039 5.2375 0.272676 5.13106 0.166237C5.02462 0.0597971 4.88025 0 4.72973 0C4.5792 0 4.43484 0.0597971 4.3284 0.166237C4.22196 0.272676 4.16216 0.417039 4.16216 0.567568V1.51351H3.21621C2.66428 1.51351 2.13494 1.73277 1.74467 2.12305C1.35439 2.51333 1.13513 3.04266 1.13513 3.59459V11.9189C1.13513 12.4709 1.35439 13.0002 1.74467 13.3905C2.13494 13.7807 2.66428 14 3.21621 14H10.7838C11.3357 14 11.865 13.7807 12.2553 13.3905C12.6456 13.0002 12.8649 12.4709 12.8649 11.9189V3.59459C12.8649 3.04266 12.6456 2.51333 12.2553 2.12305C11.865 1.73277 11.3357 1.51351 10.7838 1.51351ZM3.21621 2.64865H4.16216V3.59459C4.16216 3.74512 4.22196 3.88949 4.3284 3.99593C4.43484 4.10237 4.5792 4.16216 4.72973 4.16216C4.88025 4.16216 5.02462 4.10237 5.13106 3.99593C5.2375 3.88949 5.29729 3.74512 5.29729 3.59459V2.64865H8.7027V3.59459C8.7027 3.74512 8.7625 3.88949 8.86894 3.99593C8.97538 4.10237 9.11974 4.16216 9.27027 4.16216C9.42079 4.16216 9.56516 4.10237 9.6716 3.99593C9.77804 3.88949 9.83783 3.74512 9.83783 3.59459V2.64865H10.7838C11.0347 2.64865 11.2753 2.74831 11.4527 2.92571C11.6301 3.10311 11.7297 3.34371 11.7297 3.59459V5.67568H2.27027V3.59459C2.27027 3.34371 2.36993 3.10311 2.54733 2.92571C2.72473 2.74831 2.96533 2.64865 3.21621 2.64865ZM10.7838 12.8649H3.21621C2.96533 12.8649 2.72473 12.7652 2.54733 12.5878C2.36993 12.4104 2.27027 12.1698 2.27027 11.9189V6.81081H11.7297V11.9189C11.7297 12.1698 11.6301 12.4104 11.4527 12.5878C11.2753 12.7652 11.0347 12.8649 10.7838 12.8649Z",
        fill: "currentColor"
    }));
}));
$3e5119c1e8269632$export$5fda1783bb83f57b.displayName = 'CalendarIcon';




var $acw62 = parcelRequire("acw62");

'use client';
function $dcc9b5d50491f528$var$_extends() {
    return $dcc9b5d50491f528$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $dcc9b5d50491f528$var$_extends.apply(null, arguments);
}
var $dcc9b5d50491f528$export$20bc5960c3c9eebb = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var pti = (0, $48a8663a5f44055b$export$a188ecdd443fe91a).getPTI(inProps);
    return /*#__PURE__*/ $acw62.createElement("svg", $dcc9b5d50491f528$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M9.61296 13C9.50997 13.0005 9.40792 12.9804 9.3128 12.9409C9.21767 12.9014 9.13139 12.8433 9.05902 12.7701L3.83313 7.54416C3.68634 7.39718 3.60388 7.19795 3.60388 6.99022C3.60388 6.78249 3.68634 6.58325 3.83313 6.43628L9.05902 1.21039C9.20762 1.07192 9.40416 0.996539 9.60724 1.00012C9.81032 1.00371 10.0041 1.08597 10.1477 1.22959C10.2913 1.37322 10.3736 1.56698 10.3772 1.77005C10.3808 1.97313 10.3054 2.16968 10.1669 2.31827L5.49496 6.99022L10.1669 11.6622C10.3137 11.8091 10.3962 12.0084 10.3962 12.2161C10.3962 12.4238 10.3137 12.6231 10.1669 12.7701C10.0945 12.8433 10.0083 12.9014 9.91313 12.9409C9.81801 12.9804 9.71596 13.0005 9.61296 13Z",
        fill: "currentColor"
    }));
}));
$dcc9b5d50491f528$export$20bc5960c3c9eebb.displayName = 'ChevronLeftIcon';










'use client';
function $7829c495bb40f01d$var$_extends() {
    return $7829c495bb40f01d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7829c495bb40f01d$var$_extends.apply(null, arguments);
}
function $7829c495bb40f01d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7829c495bb40f01d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7829c495bb40f01d$var$_typeof(o);
}
function $7829c495bb40f01d$var$toPrimitive(t, r) {
    if ("object" != $7829c495bb40f01d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7829c495bb40f01d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $7829c495bb40f01d$var$toPropertyKey(t) {
    var i = $7829c495bb40f01d$var$toPrimitive(t, "string");
    return "symbol" == $7829c495bb40f01d$var$_typeof(i) ? i : i + "";
}
function $7829c495bb40f01d$var$_defineProperty(e, r, t) {
    return (r = $7829c495bb40f01d$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7829c495bb40f01d$var$_arrayLikeToArray$1(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $7829c495bb40f01d$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $7829c495bb40f01d$var$_arrayLikeToArray$1(r);
}
function $7829c495bb40f01d$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $7829c495bb40f01d$var$_unsupportedIterableToArray$1(r, a) {
    if (r) {
        if ("string" == typeof r) return $7829c495bb40f01d$var$_arrayLikeToArray$1(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7829c495bb40f01d$var$_arrayLikeToArray$1(r, a) : void 0;
    }
}
function $7829c495bb40f01d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7829c495bb40f01d$var$_toConsumableArray(r) {
    return $7829c495bb40f01d$var$_arrayWithoutHoles(r) || $7829c495bb40f01d$var$_iterableToArray(r) || $7829c495bb40f01d$var$_unsupportedIterableToArray$1(r) || $7829c495bb40f01d$var$_nonIterableSpread();
}
function $7829c495bb40f01d$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $7829c495bb40f01d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $7829c495bb40f01d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7829c495bb40f01d$var$_slicedToArray(r, e) {
    return $7829c495bb40f01d$var$_arrayWithHoles(r) || $7829c495bb40f01d$var$_iterableToArrayLimit(r, e) || $7829c495bb40f01d$var$_unsupportedIterableToArray$1(r, e) || $7829c495bb40f01d$var$_nonIterableRest();
}
var $7829c495bb40f01d$var$styles = "\n@layer primereact {\n    .p-calendar {\n        position: relative;\n        display: inline-flex;\n        max-width: 100%;\n    }\n\n    .p-calendar .p-inputtext {\n        flex: 1 1 auto;\n        width: 1%;\n    }\n\n    .p-calendar-w-btn-right .p-inputtext {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n    }\n\n    .p-calendar-w-btn-right .p-datepicker-trigger {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .p-calendar-w-btn-left .p-inputtext {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .p-calendar-w-btn-left .p-datepicker-trigger {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n    }\n\n    /* Fluid */\n    .p-fluid .p-calendar {\n        display: flex;\n    }\n\n    .p-fluid .p-calendar .p-inputtext {\n        width: 1%;\n    }\n\n    /* Datepicker */\n    .p-calendar .p-datepicker {\n        min-width: 100%;\n    }\n\n    .p-datepicker {\n        width: auto;\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n\n    .p-datepicker-inline {\n        display: inline-block;\n        position: static;\n        overflow-x: auto;\n    }\n\n    /* Header */\n    .p-datepicker-header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .p-datepicker-header .p-datepicker-title {\n        margin: 0 auto;\n    }\n\n    .p-datepicker-prev,\n    .p-datepicker-next {\n        cursor: pointer;\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n        overflow: hidden;\n        position: relative;\n    }\n\n    /* Multiple Month DatePicker */\n    .p-datepicker-multiple-month .p-datepicker-group-container {\n        display: flex;\n    }\n\n    .p-datepicker-multiple-month .p-datepicker-group-container .p-datepicker-group {\n        flex: 1 1 auto;\n    }\n\n    /* Multiple Month DatePicker */\n    .p-datepicker-multiple-month .p-datepicker-group-container {\n        display: flex;\n    }\n\n    /* DatePicker Table */\n    .p-datepicker table {\n        width: 100%;\n        border-collapse: collapse;\n    }\n\n    .p-datepicker td > span {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n        margin: 0 auto;\n        overflow: hidden;\n        position: relative;\n    }\n\n    /* Month Picker */\n    .p-monthpicker-month {\n        width: 33.3%;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        overflow: hidden;\n        position: relative;\n    }\n\n    /*  Button Bar */\n    .p-datepicker-buttonbar {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    /* Time Picker */\n    .p-timepicker {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .p-timepicker button {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        overflow: hidden;\n        position: relative;\n    }\n\n    .p-timepicker > div {\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n    }\n\n    /* Touch UI */\n    .p-datepicker-touch-ui,\n    .p-calendar .p-datepicker-touch-ui {\n        position: fixed;\n        top: 50%;\n        left: 50%;\n        min-width: 80vw;\n        transform: translate(-50%, -50%);\n    }\n\n    /* Year Picker */\n    .p-yearpicker-year {\n        width: 50%;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        overflow: hidden;\n        position: relative;\n    }\n}\n";
var $7829c495bb40f01d$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, focusedState = _ref.focusedState, isFilled = _ref.isFilled, panelVisible = _ref.panelVisible;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-calendar p-component p-inputwrapper', $7829c495bb40f01d$var$_defineProperty($7829c495bb40f01d$var$_defineProperty($7829c495bb40f01d$var$_defineProperty($7829c495bb40f01d$var$_defineProperty($7829c495bb40f01d$var$_defineProperty($7829c495bb40f01d$var$_defineProperty($7829c495bb40f01d$var$_defineProperty({}, "p-calendar-w-btn p-calendar-w-btn-".concat(props.iconPos), props.showIcon), 'p-calendar-disabled', props.disabled), 'p-invalid', props.invalid), 'p-calendar-timeonly', props.timeOnly), 'p-inputwrapper-filled', props.value || isFilled), 'p-inputwrapper-focus', focusedState), 'p-focus', focusedState || panelVisible));
    },
    input: function input(_ref2) {
        var props = _ref2.props, context = _ref2.context;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-inputtext p-component', {
            'p-variant-filled': props.variant ? props.variant === 'filled' : context && context.inputStyle === 'filled'
        });
    },
    dropdownButton: 'p-datepicker-trigger',
    buttonbar: 'p-datepicker-buttonbar',
    todayButton: 'p-button-text',
    clearButton: 'p-button-text',
    footer: 'p-datepicker-footer',
    yearPicker: 'p-yearpicker',
    year: function year(_ref3) {
        var isYearSelected = _ref3.isYearSelected, y = _ref3.y, isMonthYearDisabled = _ref3.isMonthYearDisabled;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-yearpicker-year', {
            'p-highlight': isYearSelected(y),
            'p-disabled': isMonthYearDisabled(-1, y)
        });
    },
    monthPicker: 'p-monthpicker',
    month: function month(_ref4) {
        var isMonthSelected = _ref4.isMonthSelected, isMonthYearDisabled = _ref4.isMonthYearDisabled, i = _ref4.i, currentYear = _ref4.currentYear;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-monthpicker-month', {
            'p-highlight': isMonthSelected(i),
            'p-disabled': isMonthYearDisabled(i, currentYear)
        });
    },
    hourPicker: 'p-hour-picker',
    secondPicker: 'p-second-picker',
    minutePicker: 'p-minute-picker',
    millisecondPicker: 'p-millisecond-picker',
    ampmPicker: 'p-ampm-picker',
    separatorContainer: 'p-separator',
    dayLabel: function dayLabel(_ref5) {
        var className = _ref5.className;
        return className;
    },
    day: function day(_ref6) {
        var date = _ref6.date;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)({
            'p-datepicker-other-month': date.otherMonth,
            'p-datepicker-today': date.today
        });
    },
    panel: function panel(_ref7) {
        var panelClassName = _ref7.panelClassName;
        return panelClassName;
    },
    previousIcon: 'p-datepicker-prev-icon',
    previousButton: 'p-datepicker-prev',
    nextIcon: 'p-datepicker-next-icon',
    nextButton: 'p-datepicker-next',
    incrementButton: 'p-link',
    decrementButton: 'p-link',
    title: 'p-datepicker-title',
    timePicker: 'p-timepicker',
    monthTitle: 'p-datepicker-month p-link',
    yearTitle: 'p-datepicker-year p-link',
    decadeTitle: 'p-datepicker-decade',
    header: 'p-datepicker-header',
    groupContainer: 'p-datepicker-group-container',
    group: 'p-datepicker-group',
    select: function select(_ref8) {
        var props = _ref8.props;
        return props.monthNavigator && props.view !== 'month' ? 'p-datepicker-month' : props.yearNavigator ? 'p-datepicker-year' : undefined;
    },
    weekHeader: 'p-datepicker-weekheader p-disabled',
    weekNumber: 'p-datepicker-weeknumber',
    weekLabelContainer: 'p-disabled',
    container: 'p-datepicker-calendar-container',
    table: 'p-datepicker-calendar',
    transition: 'p-connected-overlay'
};
var $7829c495bb40f01d$var$CalendarBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'Calendar',
        appendTo: null,
        ariaLabelledBy: null,
        ariaLabel: null,
        autoZIndex: true,
        autoFocus: false,
        baseZIndex: 0,
        className: null,
        clearButtonClassName: 'p-button-secondary',
        dateFormat: null,
        dateTemplate: null,
        decadeTemplate: null,
        decrementIcon: null,
        disabled: false,
        disabledDates: null,
        disabledDays: null,
        enabledDates: null,
        footerTemplate: null,
        formatDateTime: null,
        headerTemplate: null,
        hideOnDateTimeSelect: false,
        hideOnRangeSelection: false,
        hourFormat: '24',
        icon: null,
        iconPos: 'right',
        id: null,
        incrementIcon: null,
        inline: false,
        inputClassName: null,
        inputId: null,
        inputMode: 'none',
        inputRef: null,
        inputStyle: null,
        variant: null,
        invalid: false,
        keepInvalid: false,
        locale: null,
        mask: null,
        maskSlotChar: '_',
        maxDate: null,
        maxDateCount: null,
        minDate: null,
        monthNavigator: false,
        monthNavigatorTemplate: null,
        name: null,
        nextIcon: null,
        numberOfMonths: 1,
        onBlur: null,
        onChange: null,
        onClearButtonClick: null,
        onFocus: null,
        onHide: null,
        onInput: null,
        onMonthChange: null,
        onSelect: null,
        onShow: null,
        onTodayButtonClick: null,
        onViewDateChange: null,
        onVisibleChange: null,
        panelClassName: null,
        panelStyle: null,
        parseDateTime: null,
        placeholder: null,
        prevIcon: null,
        readOnlyInput: false,
        required: false,
        selectOtherMonths: false,
        selectionMode: 'single',
        shortYearCutoff: '+10',
        showButtonBar: false,
        showIcon: false,
        showMillisec: false,
        showMinMaxRange: false,
        showOnFocus: true,
        showOtherMonths: true,
        showSeconds: false,
        showTime: false,
        showWeek: false,
        stepHour: 1,
        stepMillisec: 1,
        stepMinute: 1,
        stepSecond: 1,
        style: null,
        tabIndex: null,
        timeOnly: false,
        todayButtonClassName: 'p-button-secondary',
        tooltip: null,
        tooltipOptions: null,
        touchUI: false,
        transitionOptions: null,
        value: null,
        view: 'date',
        viewDate: null,
        visible: false,
        yearNavigator: false,
        yearNavigatorTemplate: null,
        yearRange: null,
        children: undefined
    },
    css: {
        classes: $7829c495bb40f01d$var$classes,
        styles: $7829c495bb40f01d$var$styles
    }
});
var $7829c495bb40f01d$var$CalendarPanel = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var cx = props.cx;
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var createElement = function createElement() {
        var panelProps = mergeProps({
            className: cx('panel', {
                panelClassName: props.className
            }),
            style: props.style,
            role: props.inline ? null : 'dialog',
            id: props.id,
            'aria-label': (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('chooseDate', props.locale),
            'aria-modal': props.inline ? null : 'true',
            onClick: props.onClick,
            onMouseUp: props.onMouseUp
        }, props.ptm('panel', {
            hostName: props.hostName
        }));
        var transitionProps = mergeProps({
            classNames: cx('transition'),
            "in": props["in"],
            timeout: {
                enter: 120,
                exit: 100
            },
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: props.onEnter,
            onEntered: props.onEntered,
            onExit: props.onExit,
            onExited: props.onExited
        }, props.ptm('transition', {
            hostName: props.hostName
        }));
        return /*#__PURE__*/ $acw62.createElement((0, $17afce1b96f6eaec$export$a7a5590ad6d7af0), $7829c495bb40f01d$var$_extends({
            nodeRef: ref
        }, transitionProps), /*#__PURE__*/ $acw62.createElement("div", $7829c495bb40f01d$var$_extends({
            ref: ref
        }, panelProps), props.children));
    };
    var element = createElement();
    return props.inline ? element : /*#__PURE__*/ $acw62.createElement((0, $e7a3b5428092a192$export$602eac185826482c), {
        element: element,
        appendTo: props.appendTo
    });
});
$7829c495bb40f01d$var$CalendarPanel.displayName = 'CalendarPanel';
function $7829c495bb40f01d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7829c495bb40f01d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7829c495bb40f01d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7829c495bb40f01d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7829c495bb40f01d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7829c495bb40f01d$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $7829c495bb40f01d$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $7829c495bb40f01d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7829c495bb40f01d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7829c495bb40f01d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7829c495bb40f01d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $7829c495bb40f01d$export$e1aef45b828286de = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $7829c495bb40f01d$var$CalendarBase.getProps(inProps, context);
    var _React$useState = $acw62.useState(false), _React$useState2 = $7829c495bb40f01d$var$_slicedToArray(_React$useState, 2), focusedState = _React$useState2[0], setFocusedState = _React$useState2[1];
    var _React$useState3 = $acw62.useState(false), _React$useState4 = $7829c495bb40f01d$var$_slicedToArray(_React$useState3, 2), overlayVisibleState = _React$useState4[0], setOverlayVisibleState = _React$useState4[1];
    var _React$useState5 = $acw62.useState(null), _React$useState6 = $7829c495bb40f01d$var$_slicedToArray(_React$useState5, 2), viewDateState = _React$useState6[0], setViewDateState = _React$useState6[1];
    var _React$useState7 = $acw62.useState(props.id), _React$useState8 = $7829c495bb40f01d$var$_slicedToArray(_React$useState7, 2), idState = _React$useState8[0], setIdState = _React$useState8[1];
    var isCloseOnEscape = overlayVisibleState && props.closeOnEscape;
    var overlayDisplayOrder = (0, $fbdf1e36fa0a01d8$export$6353a33119af9098)('overlay-panel', isCloseOnEscape);
    var metaData = {
        props: props,
        state: {
            focused: focusedState,
            overlayVisible: overlayVisibleState,
            viewDate: viewDateState
        }
    };
    var _CalendarBase$setMeta = $7829c495bb40f01d$var$CalendarBase.setMetaData(metaData), ptm = _CalendarBase$setMeta.ptm, cx = _CalendarBase$setMeta.cx, isUnstyled = _CalendarBase$setMeta.isUnstyled;
    (0, $fbdf1e36fa0a01d8$export$dee4359f392495ae)({
        callback: function callback() {
            hide();
        },
        when: overlayVisibleState && overlayDisplayOrder,
        priority: [
            (0, $fbdf1e36fa0a01d8$export$5153c70e1a2d4b71).OVERLAY_PANEL,
            overlayDisplayOrder
        ]
    });
    (0, $b76d8eda63b3c134$export$142583cb150b394)($7829c495bb40f01d$var$CalendarBase.css.styles, isUnstyled, {
        name: 'calendar'
    });
    var elementRef = $acw62.useRef(null);
    var overlayRef = $acw62.useRef(null);
    var inputRef = $acw62.useRef(props.inputRef);
    var navigation = $acw62.useRef(null);
    var ignoreFocusFunctionality = $acw62.useRef(false);
    var timePickerTimer = $acw62.useRef(null);
    var viewStateChanged = $acw62.useRef(false);
    var touchUIMask = $acw62.useRef(null);
    var overlayEventListener = $acw62.useRef(null);
    var touchUIMaskClickListener = $acw62.useRef(null);
    var isOverlayClicked = $acw62.useRef(false);
    var previousButton = $acw62.useRef(false);
    var nextButton = $acw62.useRef(false);
    var viewChangedWithKeyDown = $acw62.useRef(false);
    var onChangeRef = $acw62.useRef(null);
    var isClearClicked = $acw62.useRef(false);
    var _React$useState9 = $acw62.useState('date'), _React$useState10 = $7829c495bb40f01d$var$_slicedToArray(_React$useState9, 2), currentView = _React$useState10[0], setCurrentView = _React$useState10[1];
    var _React$useState11 = $acw62.useState(null), _React$useState12 = $7829c495bb40f01d$var$_slicedToArray(_React$useState11, 2), currentMonth = _React$useState12[0], setCurrentMonth = _React$useState12[1];
    var _React$useState13 = $acw62.useState(null), _React$useState14 = $7829c495bb40f01d$var$_slicedToArray(_React$useState13, 2), currentYear = _React$useState14[0], setCurrentYear = _React$useState14[1];
    var _React$useState15 = $acw62.useState([]), _React$useState16 = $7829c495bb40f01d$var$_slicedToArray(_React$useState15, 2), yearOptions = _React$useState16[0], setYearOptions = _React$useState16[1];
    var previousValue = (0, $fbdf1e36fa0a01d8$export$5cae361ad82dce8b)(props.value);
    var visible = props.inline || (props.onVisibleChange ? props.visible : overlayVisibleState);
    var attributeSelector = (0, $a73ce425265b079e$export$d5d9b89141473caf)();
    var panelId = idState + '_panel';
    var _useOverlayListener = (0, $fbdf1e36fa0a01d8$export$2fef17345d27a5b4)({
        target: elementRef,
        overlay: overlayRef,
        listener: function listener(event, _ref) {
            var type = _ref.type, valid = _ref.valid;
            if (valid) type === 'outside' ? !isOverlayClicked.current && !isNavIconClicked(event.target) && hide('outside') : hide();
            isOverlayClicked.current = false;
        },
        when: !(props.touchUI || props.inline) && visible,
        type: 'mousedown'
    }), _useOverlayListener2 = $7829c495bb40f01d$var$_slicedToArray(_useOverlayListener, 2), bindOverlayListener = _useOverlayListener2[0], unbindOverlayListener = _useOverlayListener2[1];
    var getDateFormat = function getDateFormat() {
        return props.dateFormat || (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('dateFormat', props.locale);
    };
    var onInputFocus = function onInputFocus(event) {
        if (ignoreFocusFunctionality.current) {
            setFocusedState(true);
            ignoreFocusFunctionality.current = false;
        } else {
            if (props.showOnFocus && !visible) show();
            setFocusedState(true);
            props.onFocus && props.onFocus(event);
        }
    };
    var onInputBlur = function onInputBlur(event) {
        updateInputfield(props.value);
        props.onBlur && props.onBlur(event);
        setFocusedState(false);
    };
    var onInputKeyDown = function onInputKeyDown(event) {
        switch(event.code){
            case 'ArrowDown':
                if (!overlayVisibleState) show();
                else {
                    focusToFirstCell();
                    event.preventDefault();
                }
                break;
            case 'Escape':
                hide();
                props.touchUI && disableModality();
                break;
            case 'Tab':
                if (overlayRef && overlayRef.current) {
                    (0, $a73ce425265b079e$export$ff8ccbac9225de62).getFocusableElements(overlayRef.current).forEach(function(el) {
                        return el.tabIndex = '-1';
                    });
                    hide();
                    props.touchUI && disableModality();
                }
                break;
        }
    };
    var onUserInput = function onUserInput(event) {
        updateValueOnInput(event, event.target.value);
        props.onInput && props.onInput(event);
    };
    var updateValueOnInput = function updateValueOnInput(event, rawValue, invalidCallback) {
        try {
            var value = parseValueFromString(props.timeOnly ? rawValue.replace('_', '') : rawValue);
            if (isValidSelection(value)) {
                updateModel(event, value);
                var date = value.length ? value[0] : value;
                updateViewDate(event, date);
                onViewDateSelect({
                    event: event,
                    date: date
                });
            }
        } catch (err) {
            //invalid date
            if (invalidCallback) invalidCallback();
            else {
                var _value = props.keepInvalid ? rawValue : null;
                updateModel(event, _value);
            }
        }
    };
    var onViewDateSelect = function onViewDateSelect(_ref2) {
        var event = _ref2.event, date = _ref2.date;
        if (date && props.onSelect) {
            var day = date.getDate();
            var month = date.getMonth();
            var year = date.getFullYear();
            onDateSelect(event, {
                day: day,
                month: month,
                year: year,
                selectable: isSelectable(day, month, year)
            }, null, true);
        }
    };
    var reFocusInputField = function reFocusInputField() {
        if (!props.inline && inputRef.current) {
            ignoreFocusFunctionality.current = true;
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current);
        }
    };
    var isValidSelection = function isValidSelection(value) {
        var isValid = true;
        if (isSingleSelection()) {
            if (!(isSelectable(value.getDate(), value.getMonth(), value.getFullYear(), false) && isSelectableTime(value))) isValid = false;
        } else if (value.every(function(v) {
            return isSelectable(v.getDate(), v.getMonth(), v.getFullYear(), false) && isSelectableTime(v);
        })) {
            if (isRangeSelection()) isValid = value.length > 1 && value[1] >= value[0];
        }
        return isValid;
    };
    var onButtonClick = function onButtonClick() {
        visible ? hide() : show();
    };
    var onPrevButtonClick = function onPrevButtonClick(event) {
        navigation.current = {
            backward: true,
            button: true
        };
        navBackward(event);
    };
    var onNextButtonClick = function onNextButtonClick(event) {
        navigation.current = {
            backward: false,
            button: true
        };
        navForward(event);
    };
    var onContainerButtonKeydown = function onContainerButtonKeydown(event) {
        switch(event.code){
            case 'Tab':
                !props.inline && trapFocus(event);
                break;
            case 'Escape':
                hide(null, reFocusInputField);
                event.preventDefault();
                break;
        }
    };
    var onPickerKeyDown = function onPickerKeyDown(event, type, direction) {
        if (event.key === 'Enter' || event.key === 'Space') {
            onTimePickerElementMouseDown(event, type, direction);
            event.preventDefault();
            return;
        }
        onContainerButtonKeydown(event);
    };
    var onPickerKeyUp = function onPickerKeyUp(event) {
        if (event.key === 'Enter' || event.key === 'Space') {
            onTimePickerElementMouseUp();
            event.preventDefault();
            return;
        }
    };
    var trapFocus = function trapFocus(event) {
        event === null || event === void 0 || event.preventDefault();
        var focusableElements = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getFocusableElements(overlayRef.current);
        if (focusableElements && focusableElements.length > 0) {
            if (!document.activeElement) focusableElements[0].focus();
            else {
                var focusedIndex = focusableElements.indexOf(document.activeElement);
                if (event !== null && event !== void 0 && event.shiftKey) {
                    if (focusedIndex === -1 || focusedIndex === 0) focusableElements[focusableElements.length - 1].focus();
                    else focusableElements[focusedIndex - 1].focus();
                } else if (focusedIndex === -1 || focusedIndex === focusableElements.length - 1) focusableElements[0].focus();
                else focusableElements[focusedIndex + 1].focus();
            }
        }
    };
    var updateFocus = function updateFocus() {
        if (navigation.current) {
            if (navigation.current.button) {
                initFocusableCell();
                if (navigation.current.backward) previousButton.current.focus();
                else nextButton.current.focus();
            } else {
                var cell;
                if (navigation.current.backward) {
                    var cells = (0, $a73ce425265b079e$export$ff8ccbac9225de62).find(overlayRef.current, 'table td span:not([data-p-disabled="true"])');
                    cell = cells[cells.length - 1];
                } else cell = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(overlayRef.current, 'table td span:not([data-p-disabled="true"])');
                if (cell) {
                    cell.tabIndex = '0';
                    cell.focus();
                }
            }
            navigation.current = null;
        } else initFocusableCell();
    };
    var initFocusableCell = function initFocusableCell() {
        var cell;
        if (currentView === 'month') {
            var cells = (0, $a73ce425265b079e$export$ff8ccbac9225de62).find(overlayRef.current, '[data-pc-section="monthpicker"] [data-pc-section="month"]');
            var selectedCell = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(overlayRef.current, '[data-pc-section="monthpicker"] [data-pc-section="month"][data-p-highlight="true"]');
            cells.forEach(function(cell) {
                return cell.tabIndex = -1;
            });
            cell = selectedCell || cells[0];
        } else {
            cell = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(overlayRef.current, 'span[data-p-highlight="true"]');
            if (!cell) {
                var todayCell = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(overlayRef.current, 'td.p-datepicker-today span:not(.p-disabled)');
                cell = todayCell || (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(overlayRef.current, 'table td span:not([data-p-disabled="true"])');
            }
        }
        if (cell) cell.tabIndex = '0';
    };
    var focusToFirstCell = function focusToFirstCell() {
        if (currentView) {
            var cell;
            if (currentView === 'date') {
                cell = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(overlayRef.current, 'span[data-p-highlight="true"]');
                if (!cell) {
                    var todayCell = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(overlayRef.current, 'td.p-datepicker-today span:not(.p-disabled)');
                    cell = todayCell || (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(overlayRef.current, 'table td span:not([data-p-disabled="true"])');
                }
            } else if (currentView === 'month' || currentView === 'year') {
                cell = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(overlayRef.current, 'span[data-p-highlight="true"]');
                if (!cell) cell = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(overlayRef.current, "[data-pc-section=\"".concat(currentView, "picker\"] [data-pc-section=\"").concat(currentView, "\"]:not([data-p-disabled=\"true\"])"));
            }
            if (cell) {
                cell.tabIndex = '0';
                cell && cell.focus();
            }
        }
    };
    var navBackward = function navBackward(event) {
        if (props.disabled) {
            event.preventDefault();
            return;
        }
        var newViewDate = cloneDate(getViewDate());
        newViewDate.setDate(1);
        if (currentView === 'date') {
            if (newViewDate.getMonth() === 0) {
                var newYear = decrementYear();
                newViewDate.setMonth(11);
                newViewDate.setFullYear(newYear);
                props.onMonthChange && props.onMonthChange({
                    month: 11,
                    year: newYear
                });
                setCurrentMonth(11);
            } else {
                newViewDate.setMonth(newViewDate.getMonth() - 1);
                props.onMonthChange && props.onMonthChange({
                    month: currentMonth - 1,
                    year: currentYear
                });
                setCurrentMonth(function(prevState) {
                    return prevState - 1;
                });
            }
        } else if (currentView === 'month') {
            var _newYear = newViewDate.getFullYear() - 1;
            if (props.yearNavigator) {
                var minYear = parseInt(props.yearRange.split(':')[0], 10);
                if (_newYear < minYear) _newYear = minYear;
            }
            newViewDate.setFullYear(_newYear);
        }
        if (currentView === 'month') newViewDate.setFullYear(decrementYear());
        else if (currentView === 'year') newViewDate.setFullYear(decrementDecade());
        updateViewDate(event, newViewDate);
        event.preventDefault();
    };
    var navForward = function navForward(event) {
        if (props.disabled) {
            event.preventDefault();
            return;
        }
        var newViewDate = cloneDate(getViewDate());
        newViewDate.setDate(1);
        if (currentView === 'date') {
            if (newViewDate.getMonth() === 11) {
                var newYear = incrementYear();
                newViewDate.setMonth(0);
                newViewDate.setFullYear(newYear);
                props.onMonthChange && props.onMonthChange({
                    month: 0,
                    year: newYear
                });
                setCurrentMonth(0);
            } else {
                newViewDate.setMonth(newViewDate.getMonth() + 1);
                props.onMonthChange && props.onMonthChange({
                    month: currentMonth + 1,
                    year: currentYear
                });
                setCurrentMonth(function(prevState) {
                    return prevState + 1;
                });
            }
        } else if (currentView === 'month') {
            var _newYear2 = newViewDate.getFullYear() + 1;
            if (props.yearNavigator) {
                var maxYear = parseInt(props.yearRange.split(':')[1], 10);
                if (_newYear2 > maxYear) _newYear2 = maxYear;
            }
            newViewDate.setFullYear(_newYear2);
        }
        if (currentView === 'month') newViewDate.setFullYear(incrementYear());
        else if (currentView === 'year') newViewDate.setFullYear(incrementDecade());
        updateViewDate(event, newViewDate);
        event.preventDefault();
    };
    var populateYearOptions = function populateYearOptions(start, end) {
        var _yearOptions = [];
        for(var i = start; i <= end; i++)yearOptions.push(i);
        setYearOptions(_yearOptions);
    };
    var decrementYear = function decrementYear() {
        var _currentYear = currentYear - 1;
        setCurrentYear(_currentYear);
        if (props.yearNavigator && _currentYear < yearOptions[0]) {
            var difference = yearOptions[yearOptions.length - 1] - yearOptions[0];
            populateYearOptions(yearOptions[0] - difference, yearOptions[yearOptions.length - 1] - difference);
        }
        return _currentYear;
    };
    var incrementYear = function incrementYear() {
        var _currentYear = currentYear + 1;
        setCurrentYear(_currentYear);
        if (props.yearNavigator && _currentYear.current > yearOptions[yearOptions.length - 1]) {
            var difference = yearOptions[yearOptions.length - 1] - yearOptions[0];
            populateYearOptions(yearOptions[0] + difference, yearOptions[yearOptions.length - 1] + difference);
        }
        return _currentYear;
    };
    var onMonthDropdownChange = function onMonthDropdownChange(event, value) {
        var currentViewDate = getViewDate();
        var newViewDate = cloneDate(currentViewDate);
        newViewDate.setDate(1);
        newViewDate.setMonth(parseInt(value, 10));
        updateViewDate(event, newViewDate);
    };
    var onYearDropdownChange = function onYearDropdownChange(event, value) {
        var currentViewDate = getViewDate();
        var newViewDate = cloneDate(currentViewDate);
        newViewDate.setFullYear(parseInt(value, 10));
        updateViewDate(event, newViewDate);
    };
    var onTodayButtonClick = function onTodayButtonClick(event) {
        var today = new Date();
        var dateMeta = {
            day: today.getDate(),
            month: today.getMonth(),
            year: today.getFullYear(),
            today: true,
            selectable: true
        };
        var timeMeta = {
            hours: today.getHours(),
            minutes: today.getMinutes(),
            seconds: today.getSeconds(),
            milliseconds: today.getMilliseconds()
        };
        updateViewDate(event, today);
        onDateSelect(event, dateMeta, timeMeta);
        props.onTodayButtonClick && props.onTodayButtonClick(event);
    };
    var onClearButtonClick = function onClearButtonClick(event) {
        isClearClicked.current = true;
        updateModel(event, null);
        updateInputfield(null);
        hide();
        props.onClearButtonClick && props.onClearButtonClick(event);
    };
    var onPanelClick = function onPanelClick(event) {
        if (!props.inline) (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).emit('overlay-click', {
            originalEvent: event,
            target: elementRef.current
        });
    };
    var onPanelMouseUp = function onPanelMouseUp(event) {
        onPanelClick(event);
    };
    var onTimePickerElementMouseDown = function onTimePickerElementMouseDown(event, type, direction) {
        if (!props.disabled) {
            _repeat(event, null, type, direction);
            event.preventDefault();
        }
    };
    var onTimePickerElementMouseUp = function onTimePickerElementMouseUp() {
        if (!props.disabled) clearTimePickerTimer();
    };
    var onTimePickerElementMouseLeave = function onTimePickerElementMouseLeave() {
        if (!props.disabled) clearTimePickerTimer();
    };
    var _repeat = function repeat(event, interval, type, direction) {
        clearTimePickerTimer();
        timePickerTimer.current = setTimeout(function() {
            _repeat(event, 100, type, direction);
        }, interval || 500);
        switch(type){
            case 0:
                if (direction === 1) incrementHour(event);
                else decrementHour(event);
                break;
            case 1:
                if (direction === 1) incrementMinute(event);
                else decrementMinute(event);
                break;
            case 2:
                if (direction === 1) incrementSecond(event);
                else decrementSecond(event);
                break;
            case 3:
                if (direction === 1) incrementMilliSecond(event);
                else decrementMilliSecond(event);
                break;
        }
    };
    var clearTimePickerTimer = function clearTimePickerTimer() {
        if (timePickerTimer.current) clearTimeout(timePickerTimer.current);
    };
    var roundMinutesToStep = function roundMinutesToStep(minutes) {
        if (props.stepMinute) return Math.round(minutes / props.stepMinute) * props.stepMinute;
        return minutes;
    };
    var incrementHour = function incrementHour(event) {
        var currentTime = getCurrentDateTime();
        var currentHour = currentTime.getHours();
        var newHour = currentHour + props.stepHour;
        newHour = newHour >= 24 ? newHour - 24 : newHour;
        if (validateHour(newHour, currentTime)) {
            if (props.maxDate && props.maxDate.toDateString() === currentTime.toDateString() && props.maxDate.getHours() === newHour) {
                if (props.maxDate.getMinutes() < currentTime.getMinutes()) {
                    if (props.maxDate.getSeconds() < currentTime.getSeconds()) {
                        if (props.maxDate.getMilliseconds() < currentTime.getMilliseconds()) updateTime(event, newHour, props.maxDate.getMinutes(), props.maxDate.getSeconds(), props.maxDate.getMilliseconds());
                        else updateTime(event, newHour, props.maxDate.getMinutes(), props.maxDate.getSeconds(), currentTime.getMilliseconds());
                    } else updateTime(event, newHour, props.maxDate.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
                } else if (props.maxDate.getMinutes() === currentTime.getMinutes()) {
                    if (props.maxDate.getSeconds() < currentTime.getSeconds()) {
                        if (props.maxDate.getMilliseconds() < currentTime.getMilliseconds()) updateTime(event, newHour, props.maxDate.getMinutes(), props.maxDate.getSeconds(), props.maxDate.getMilliseconds());
                        else updateTime(event, newHour, props.maxDate.getMinutes(), props.maxDate.getSeconds(), currentTime.getMilliseconds());
                    } else updateTime(event, newHour, props.maxDate.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
                } else updateTime(event, newHour, roundMinutesToStep(currentTime.getMinutes()), currentTime.getSeconds(), currentTime.getMilliseconds());
            } else updateTime(event, newHour, roundMinutesToStep(currentTime.getMinutes()), currentTime.getSeconds(), currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var decrementHour = function decrementHour(event) {
        var currentTime = getCurrentDateTime();
        var currentHour = currentTime.getHours();
        var newHour = currentHour - props.stepHour;
        newHour = newHour < 0 ? newHour + 24 : newHour;
        if (validateHour(newHour, currentTime)) {
            if (props.minDate && props.minDate.toDateString() === currentTime.toDateString() && props.minDate.getHours() === newHour) {
                if (props.minDate.getMinutes() > currentTime.getMinutes()) {
                    if (props.minDate.getSeconds() > currentTime.getSeconds()) {
                        if (props.minDate.getMilliseconds() > currentTime.getMilliseconds()) updateTime(event, newHour, props.minDate.getMinutes(), props.minDate.getSeconds(), props.minDate.getMilliseconds());
                        else updateTime(event, newHour, props.minDate.getMinutes(), props.minDate.getSeconds(), currentTime.getMilliseconds());
                    } else updateTime(event, newHour, props.minDate.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
                } else if (props.minDate.getMinutes() === currentTime.getMinutes()) {
                    if (props.minDate.getSeconds() > currentTime.getSeconds()) {
                        if (props.minDate.getMilliseconds() > currentTime.getMilliseconds()) updateTime(event, newHour, props.minDate.getMinutes(), props.minDate.getSeconds(), props.minDate.getMilliseconds());
                        else updateTime(event, newHour, props.minDate.getMinutes(), props.minDate.getSeconds(), currentTime.getMilliseconds());
                    } else updateTime(event, newHour, props.minDate.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
                } else updateTime(event, newHour, roundMinutesToStep(currentTime.getMinutes()), currentTime.getSeconds(), currentTime.getMilliseconds());
            } else updateTime(event, newHour, roundMinutesToStep(currentTime.getMinutes()), currentTime.getSeconds(), currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var doStepMinute = function doStepMinute(currentMinute, step) {
        if (props.stepMinute <= 1) return step ? currentMinute + step : currentMinute;
        if (!step) {
            step = props.stepMinute;
            if (currentMinute % step === 0) return currentMinute;
        }
        return Math.floor((currentMinute + step) / step) * step;
    };
    var incrementMinute = function incrementMinute(event) {
        var currentTime = getCurrentDateTime();
        var currentMinute = currentTime.getMinutes();
        var newMinute = doStepMinute(currentMinute, props.stepMinute);
        newMinute = newMinute > 59 ? newMinute - 60 : newMinute;
        if (validateMinute(newMinute, currentTime)) {
            if (props.maxDate && props.maxDate.toDateString() === currentTime.toDateString() && props.maxDate.getMinutes() === newMinute) {
                if (props.maxDate.getSeconds() < currentTime.getSeconds()) {
                    if (props.maxDate.getMilliseconds() < currentTime.getMilliseconds()) updateTime(event, currentTime.getHours(), newMinute, props.maxDate.getSeconds(), props.maxDate.getMilliseconds());
                    else updateTime(event, currentTime.getHours(), newMinute, props.maxDate.getSeconds(), currentTime.getMilliseconds());
                } else updateTime(event, currentTime.getHours(), newMinute, currentTime.getSeconds(), currentTime.getMilliseconds());
            } else updateTime(event, currentTime.getHours(), newMinute, currentTime.getSeconds(), currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var decrementMinute = function decrementMinute(event) {
        var currentTime = getCurrentDateTime();
        var currentMinute = currentTime.getMinutes();
        var newMinute = doStepMinute(currentMinute, -props.stepMinute);
        newMinute = newMinute < 0 ? newMinute + 60 : newMinute;
        if (validateMinute(newMinute, currentTime)) {
            if (props.minDate && props.minDate.toDateString() === currentTime.toDateString() && props.minDate.getMinutes() === newMinute) {
                if (props.minDate.getSeconds() > currentTime.getSeconds()) {
                    if (props.minDate.getMilliseconds() > currentTime.getMilliseconds()) updateTime(event, currentTime.getHours(), newMinute, props.minDate.getSeconds(), props.minDate.getMilliseconds());
                    else updateTime(event, currentTime.getHours(), newMinute, props.minDate.getSeconds(), currentTime.getMilliseconds());
                } else updateTime(event, currentTime.getHours(), newMinute, currentTime.getSeconds(), currentTime.getMilliseconds());
            } else updateTime(event, currentTime.getHours(), newMinute, currentTime.getSeconds(), currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var incrementSecond = function incrementSecond(event) {
        var currentTime = getCurrentDateTime();
        var currentSecond = currentTime.getSeconds();
        var newSecond = currentSecond + props.stepSecond;
        newSecond = newSecond > 59 ? newSecond - 60 : newSecond;
        if (validateSecond(newSecond, currentTime)) {
            if (props.maxDate && props.maxDate.toDateString() === currentTime.toDateString() && props.maxDate.getSeconds() === newSecond) {
                if (props.maxDate.getMilliseconds() < currentTime.getMilliseconds()) updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, props.maxDate.getMilliseconds());
                else updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, currentTime.getMilliseconds());
            } else updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var decrementSecond = function decrementSecond(event) {
        var currentTime = getCurrentDateTime();
        var currentSecond = currentTime.getSeconds();
        var newSecond = currentSecond - props.stepSecond;
        newSecond = newSecond < 0 ? newSecond + 60 : newSecond;
        if (validateSecond(newSecond, currentTime)) {
            if (props.minDate && props.minDate.toDateString() === currentTime.toDateString() && props.minDate.getSeconds() === newSecond) {
                if (props.minDate.getMilliseconds() > currentTime.getMilliseconds()) updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, props.minDate.getMilliseconds());
                else updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, currentTime.getMilliseconds());
            } else updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var incrementMilliSecond = function incrementMilliSecond(event) {
        var currentTime = getCurrentDateTime();
        var currentMillisecond = currentTime.getMilliseconds();
        var newMillisecond = currentMillisecond + props.stepMillisec;
        newMillisecond = newMillisecond > 999 ? newMillisecond - 1000 : newMillisecond;
        if (validateMillisecond(newMillisecond, currentTime)) updateTime(event, currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds(), newMillisecond);
        event.preventDefault();
    };
    var decrementMilliSecond = function decrementMilliSecond(event) {
        var currentTime = getCurrentDateTime();
        var currentMillisecond = currentTime.getMilliseconds();
        var newMillisecond = currentMillisecond - props.stepMillisec;
        newMillisecond = newMillisecond < 0 ? newMillisecond + 999 : newMillisecond;
        if (validateMillisecond(newMillisecond, currentTime)) updateTime(event, currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds(), newMillisecond);
        event.preventDefault();
    };
    var toggleAmPm = function toggleAmPm(event) {
        var currentTime = getCurrentDateTime();
        var currentHour = currentTime.getHours();
        var newHour = currentHour >= 12 ? currentHour - 12 : currentHour + 12;
        if (validateHour(convertTo24Hour(newHour, currentHour > 11), currentTime)) updateTime(event, newHour, currentTime.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
        event.preventDefault();
    };
    var getViewDate = function getViewDate(date) {
        var propValue = props.value;
        var viewDate = date || (props.onViewDateChange ? props.viewDate : viewDateState);
        if (Array.isArray(propValue)) propValue = propValue[0];
        return viewDate && isValidDate(viewDate) ? viewDate : propValue && isValidDate(propValue) ? propValue : new Date();
    };
    var getCurrentDateTime = function getCurrentDateTime() {
        if (isSingleSelection()) return props.value && props.value instanceof Date ? cloneDate(props.value) : getViewDate();
        else if (isMultipleSelection()) {
            if (props.value && props.value.length) return cloneDate(props.value[props.value.length - 1]);
        } else if (isRangeSelection()) {
            if (props.value && props.value.length) {
                var startDate = cloneDate(props.value[0]);
                var endDate = cloneDate(props.value[1]);
                return endDate || startDate;
            }
        }
        return new Date();
    };
    var cloneDate = function cloneDate(date) {
        return isValidDate(date) ? new Date(date.valueOf()) : date;
    };
    var isValidDate = function isValidDate(date) {
        return date instanceof Date && !isNaN(date);
    };
    var convertTo24Hour = function convertTo24Hour(hour, pm) {
        if (props.hourFormat === '12') return hour === 12 ? pm ? 12 : 0 : pm ? hour + 12 : hour;
        return hour;
    };
    var validateHour = function validateHour(hour, value) {
        var valid = true;
        var valueDateString = value ? value.toDateString() : null;
        if (props.minDate && valueDateString && props.minDate.toDateString() === valueDateString) {
            if (props.minDate.getHours() > hour) valid = false;
        }
        if (props.maxDate && valueDateString && props.maxDate.toDateString() === valueDateString) {
            if (props.maxDate.getHours() < hour) valid = false;
        }
        return valid;
    };
    var validateMinute = function validateMinute(minute, value) {
        var valid = true;
        var valueDateString = value ? value.toDateString() : null;
        if (props.minDate && valueDateString && props.minDate.toDateString() === valueDateString) {
            if (value.getHours() === props.minDate.getHours()) {
                if (props.minDate.getMinutes() > minute) valid = false;
            }
        }
        if (props.maxDate && valueDateString && props.maxDate.toDateString() === valueDateString) {
            if (value.getHours() === props.maxDate.getHours()) {
                if (props.maxDate.getMinutes() < minute) valid = false;
            }
        }
        return valid;
    };
    var validateSecond = function validateSecond(second, value) {
        var valid = true;
        var valueDateString = value ? value.toDateString() : null;
        if (props.minDate && valueDateString && props.minDate.toDateString() === valueDateString) {
            if (value.getHours() === props.minDate.getHours() && value.getMinutes() === props.minDate.getMinutes()) {
                if (props.minDate.getSeconds() > second) valid = false;
            }
        }
        if (props.maxDate && valueDateString && props.maxDate.toDateString() === valueDateString) {
            if (value.getHours() === props.maxDate.getHours() && value.getMinutes() === props.maxDate.getMinutes()) {
                if (props.maxDate.getSeconds() < second) valid = false;
            }
        }
        return valid;
    };
    var validateMillisecond = function validateMillisecond(millisecond, value) {
        var valid = true;
        var valueDateString = value ? value.toDateString() : null;
        if (props.minDate && valueDateString && props.minDate.toDateString() === valueDateString) {
            if (value.getHours() === props.minDate.getHours() && value.getSeconds() === props.minDate.getSeconds() && value.getMinutes() === props.minDate.getMinutes()) {
                if (props.minDate.getMilliseconds() > millisecond) valid = false;
            }
        }
        if (props.maxDate && valueDateString && props.maxDate.toDateString() === valueDateString) {
            if (value.getHours() === props.maxDate.getHours() && value.getSeconds() === props.maxDate.getSeconds() && value.getMinutes() === props.maxDate.getMinutes()) {
                if (props.maxDate.getMilliseconds() < millisecond) valid = false;
            }
        }
        return valid;
    };
    var validateDate = function validateDate(value) {
        if (props.yearNavigator) {
            var viewYear = value.getFullYear();
            var minRangeYear = props.yearRange ? parseInt(props.yearRange.split(':')[0], 10) : null;
            var maxRangeYear = props.yearRange ? parseInt(props.yearRange.split(':')[1], 10) : null;
            var minYear = props.minDate && minRangeYear != null ? Math.max(props.minDate.getFullYear(), minRangeYear) : props.minDate || minRangeYear;
            var maxYear = props.maxDate && maxRangeYear != null ? Math.min(props.maxDate.getFullYear(), maxRangeYear) : props.maxDate || maxRangeYear;
            if (minYear && minYear > viewYear) viewYear = minYear;
            if (maxYear && maxYear < viewYear) viewYear = maxYear;
            value.setFullYear(viewYear);
        }
        if (renderMonthsNavigator(0)) {
            var viewMonth = value.getMonth();
            var viewMonthWithMinMax = parseInt(isInMinYear(value) && Math.max(props.minDate.getMonth(), viewMonth).toString() || isInMaxYear(value) && Math.min(props.maxDate.getMonth(), viewMonth).toString() || viewMonth);
            value.setMonth(viewMonthWithMinMax);
        }
    };
    var updateTime = function updateTime(event, hour, minute, second, millisecond) {
        var newDateTime = getCurrentDateTime();
        newDateTime.setHours(hour);
        newDateTime.setMinutes(minute);
        newDateTime.setSeconds(second);
        newDateTime.setMilliseconds(millisecond);
        if (isMultipleSelection()) {
            if (props.value && props.value.length) {
                var value = $7829c495bb40f01d$var$_toConsumableArray(props.value);
                value[value.length - 1] = newDateTime;
                newDateTime = value;
            } else newDateTime = [
                newDateTime
            ];
        } else if (isRangeSelection()) {
            if (props.value && props.value.length) {
                var startDate = props.value[0];
                var endDate = props.value[1];
                newDateTime = endDate ? [
                    startDate,
                    newDateTime
                ] : [
                    newDateTime,
                    null
                ];
            } else newDateTime = [
                newDateTime,
                null
            ];
        }
        updateModel(event, newDateTime);
        if (props.onSelect) props.onSelect({
            originalEvent: event,
            value: newDateTime
        });
        updateInputfield(newDateTime);
    };
    var updateViewDate = function updateViewDate(event, value) {
        validateDate(value);
        if (props.onViewDateChange && event) props.onViewDateChange({
            originalEvent: event,
            value: value
        });
        else {
            viewStateChanged.current = true;
            setViewDateState(value);
        }
        if (!value) onClearButtonClick(event);
    };
    var setNavigationState = function setNavigationState(newViewDate) {
        if (!newViewDate || !props.showMinMaxRange || props.view !== 'date' || !overlayRef.current) return;
        var navPrev = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(overlayRef.current, '[data-pc-section="previousbutton"]');
        var navNext = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(overlayRef.current, '[data-pc-section="nextbutton"]');
        if (props.disabled) {
            !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(navPrev, 'p-disabled');
            navPrev.setAttribute('data-p-disabled', true);
            !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(navNext, 'p-disabled');
            navNext.setAttribute('data-p-disabled', true);
            return;
        }
        // previous (check first day of month at 00:00:00)
        if (props.minDate) {
            var firstDayOfMonth = cloneDate(newViewDate);
            if (firstDayOfMonth.getMonth() === 0) {
                firstDayOfMonth.setMonth(11, 1);
                firstDayOfMonth.setFullYear(firstDayOfMonth.getFullYear() - 1);
            } else firstDayOfMonth.setMonth(firstDayOfMonth.getMonth(), 1);
            firstDayOfMonth.setHours(0);
            firstDayOfMonth.setMinutes(0);
            firstDayOfMonth.setSeconds(0);
            if (props.minDate > firstDayOfMonth) (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(navPrev, 'p-disabled');
            else (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(navPrev, 'p-disabled');
        }
        // next (check last day of month at 11:59:59)
        if (props.maxDate) {
            var lastDayOfMonth = cloneDate(newViewDate);
            if (lastDayOfMonth.getMonth() === 11) {
                lastDayOfMonth.setMonth(0, 1);
                lastDayOfMonth.setFullYear(lastDayOfMonth.getFullYear() + 1);
            } else lastDayOfMonth.setMonth(lastDayOfMonth.getMonth() + 1, 1);
            lastDayOfMonth.setHours(0);
            lastDayOfMonth.setMinutes(0);
            lastDayOfMonth.setSeconds(0);
            lastDayOfMonth.setSeconds(-1);
            if (props.maxDate < lastDayOfMonth) (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(navNext, 'p-disabled');
            else (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(navNext, 'p-disabled');
        }
    };
    var onDateCellKeydown = function onDateCellKeydown(event, date, groupIndex) {
        var cellContent = event.currentTarget;
        var cell = cellContent.parentElement;
        var cellIndex = (0, $a73ce425265b079e$export$ff8ccbac9225de62).index(cell);
        switch(event.code){
            case 'ArrowDown':
                cellContent.tabIndex = '-1';
                var nextRow = cell.parentElement.nextElementSibling;
                if (nextRow) {
                    var tableRowIndex = (0, $a73ce425265b079e$export$ff8ccbac9225de62).index(cell.parentElement);
                    var tableRows = Array.from(cell.parentElement.parentElement.children);
                    var nextTableRows = tableRows.slice(tableRowIndex + 1);
                    var hasNextFocusableDate = nextTableRows.find(function(el) {
                        var focusCell = el.children[cellIndex].children[0];
                        return !(0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(focusCell, 'data-p-disabled');
                    });
                    if (hasNextFocusableDate) {
                        var focusCell = hasNextFocusableDate.children[cellIndex].children[0];
                        focusCell.tabIndex = '0';
                        focusCell.focus();
                    } else {
                        navigation.current = {
                            backward: false
                        };
                        navForward(event);
                    }
                } else {
                    navigation.current = {
                        backward: false
                    };
                    navForward(event);
                }
                event.preventDefault();
                break;
            case 'ArrowUp':
                cellContent.tabIndex = '-1';
                if (event.altKey) hide(null, reFocusInputField);
                else {
                    var prevRow = cell.parentElement.previousElementSibling;
                    if (prevRow) {
                        var _tableRowIndex = (0, $a73ce425265b079e$export$ff8ccbac9225de62).index(cell.parentElement);
                        var _tableRows = Array.from(cell.parentElement.parentElement.children);
                        var prevTableRows = _tableRows.slice(0, _tableRowIndex).reverse();
                        var _hasNextFocusableDate = prevTableRows.find(function(el) {
                            var focusCell = el.children[cellIndex].children[0];
                            return !(0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(focusCell, 'data-p-disabled');
                        });
                        if (_hasNextFocusableDate) {
                            var _focusCell = _hasNextFocusableDate.children[cellIndex].children[0];
                            _focusCell.tabIndex = '0';
                            _focusCell.focus();
                        } else {
                            navigation.current = {
                                backward: true
                            };
                            navBackward(event);
                        }
                    } else {
                        navigation.current = {
                            backward: true
                        };
                        navBackward(event);
                    }
                }
                event.preventDefault();
                break;
            case 'ArrowLeft':
                cellContent.tabIndex = '-1';
                var prevCell = cell.previousElementSibling;
                if (prevCell) {
                    var cells = Array.from(cell.parentElement.children);
                    var prevCells = cells.slice(0, cellIndex).reverse();
                    var _hasNextFocusableDate2 = prevCells.find(function(el) {
                        var focusCell = el.children[0];
                        return !(0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(focusCell, 'data-p-disabled');
                    });
                    if (_hasNextFocusableDate2) {
                        var _focusCell2 = _hasNextFocusableDate2.children[0];
                        _focusCell2.tabIndex = '0';
                        _focusCell2.focus();
                    } else navigateToMonth(true, groupIndex, event);
                } else navigateToMonth(true, groupIndex, event);
                event.preventDefault();
                break;
            case 'ArrowRight':
                cellContent.tabIndex = '-1';
                var nextCell = cell.nextElementSibling;
                if (nextCell) {
                    var _cells = Array.from(cell.parentElement.children);
                    var nextCells = _cells.slice(cellIndex + 1);
                    var _hasNextFocusableDate3 = nextCells.find(function(el) {
                        var focusCell = el.children[0];
                        return !(0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(focusCell, 'data-p-disabled');
                    });
                    if (_hasNextFocusableDate3) {
                        var _focusCell3 = _hasNextFocusableDate3.children[0];
                        _focusCell3.tabIndex = '0';
                        _focusCell3.focus();
                    } else navigateToMonth(false, groupIndex, event);
                } else navigateToMonth(false, groupIndex, event);
                event.preventDefault();
                break;
            case 'Enter':
            case 'NumpadEnter':
            case 'Space':
                onDateSelect(event, date);
                event.preventDefault();
                break;
            case 'Escape':
                hide(null, reFocusInputField);
                event.preventDefault();
                break;
            case 'Tab':
                if (!props.inline) trapFocus(event);
                break;
            case 'Home':
                cellContent.tabIndex = '-1';
                var currentRow = cell.parentElement;
                var _focusCell4 = currentRow.children[0].children[0];
                if ((0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(_focusCell4, 'data-p-disabled')) navigateToMonth(groupIndex, true, event);
                else {
                    _focusCell4.tabIndex = '0';
                    _focusCell4.focus();
                }
                event.preventDefault();
                break;
            case 'End':
                cellContent.tabIndex = '-1';
                var _currentRow = cell.parentElement;
                var _focusCell5 = _currentRow.children[_currentRow.children.length - 1].children[0];
                if ((0, $a73ce425265b079e$export$ff8ccbac9225de62).getAttribute(_focusCell5, 'data-p-disabled')) navigateToMonth(groupIndex, false, event);
                else {
                    _focusCell5.tabIndex = '0';
                    _focusCell5.focus();
                }
                event.preventDefault();
                break;
            case 'PageUp':
                cellContent.tabIndex = '-1';
                if (event.shiftKey) {
                    navigation.current = {
                        backward: true
                    };
                    navBackward(event);
                } else navigateToMonth(groupIndex, true, event);
                event.preventDefault();
                break;
            case 'PageDown':
                cellContent.tabIndex = '-1';
                if (event.shiftKey) {
                    navigation.current = {
                        backward: false
                    };
                    navForward(event);
                } else navigateToMonth(groupIndex, false, event);
                event.preventDefault();
                break;
        }
    };
    var navigateToMonth = function navigateToMonth(prev, groupIndex, event) {
        if (prev) {
            if (props.numberOfMonths === 1 || groupIndex === 0) {
                navigation.current = {
                    backward: true
                };
                navBackward(event);
            } else {
                var prevMonthContainer = overlayRef.current.children[groupIndex - 1];
                var cells = (0, $a73ce425265b079e$export$ff8ccbac9225de62).find(prevMonthContainer, 'table td span:not([data-p-disabled="true"])');
                var focusCell = cells[cells.length - 1];
                focusCell.tabIndex = '0';
                focusCell.focus();
            }
        } else if (props.numberOfMonths === 1 || groupIndex === props.numberOfMonths - 1) {
            navigation.current = {
                backward: false
            };
            navForward(event);
        } else {
            var nextMonthContainer = overlayRef.current.children[groupIndex + 1];
            var _focusCell6 = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(nextMonthContainer, 'table td span:not([data-p-disabled="true"])');
            _focusCell6.tabIndex = '0';
            _focusCell6.focus();
        }
    };
    var onMonthCellKeydown = function onMonthCellKeydown(event, index) {
        var cell = event.currentTarget;
        switch(event.code){
            //arrows
            case 'ArrowUp':
            case 'ArrowDown':
                cell.tabIndex = '-1';
                var cells = cell.parentElement.children;
                var cellIndex = (0, $a73ce425265b079e$export$ff8ccbac9225de62).index(cell);
                var nextCell = cells[event.which === 40 ? cellIndex + 3 : cellIndex - 3];
                if (nextCell) {
                    nextCell.tabIndex = '0';
                    nextCell.focus();
                }
                event.preventDefault();
                break;
            case 'ArrowLeft':
                cell.tabIndex = '-1';
                var prevCell = cell.previousElementSibling;
                if (prevCell) {
                    prevCell.tabIndex = '0';
                    prevCell.focus();
                } else {
                    navigation.current = {
                        backward: true
                    };
                    navBackward(event);
                }
                event.preventDefault();
                break;
            case 'ArrowRight':
                cell.tabIndex = '-1';
                var _nextCell = cell.nextElementSibling;
                if (_nextCell) {
                    _nextCell.tabIndex = '0';
                    _nextCell.focus();
                } else {
                    navigation.current = {
                        backward: false
                    };
                    navForward(event);
                }
                event.preventDefault();
                break;
            case 'PageUp':
                if (event.shiftKey) return;
                navigation.current = {
                    backward: true
                };
                navBackward(event);
                break;
            case 'PageDown':
                if (event.shiftKey) return;
                navigation.current = {
                    backward: false
                };
                navForward(event);
                break;
            case 'Enter':
            case 'NumpadEnter':
            case 'Space':
                if (props.view !== 'month') viewChangedWithKeyDown.current = true;
                onMonthSelect(event, index);
                event.preventDefault();
                break;
            case 'Escape':
                hide(null, reFocusInputField);
                event.preventDefault();
                break;
            case 'Tab':
                trapFocus(event);
                break;
        }
    };
    var onYearCellKeydown = function onYearCellKeydown(event, index) {
        var cell = event.currentTarget;
        switch(event.code){
            //arrows
            case 'ArrowUp':
            case 'ArrowDown':
                cell.tabIndex = '-1';
                var cells = cell.parentElement.children;
                var cellIndex = (0, $a73ce425265b079e$export$ff8ccbac9225de62).index(cell);
                var nextCell = cells[event.code === 'ArrowDown' ? cellIndex + 2 : cellIndex - 2];
                if (nextCell) {
                    nextCell.tabIndex = '0';
                    nextCell.focus();
                }
                event.preventDefault();
                break;
            case 'ArrowLeft':
                cell.tabIndex = '-1';
                var prevCell = cell.previousElementSibling;
                if (prevCell) {
                    prevCell.tabIndex = '0';
                    prevCell.focus();
                } else {
                    navigation.current = {
                        backward: true
                    };
                    navBackward(event);
                }
                event.preventDefault();
                break;
            case 'ArrowRight':
                cell.tabIndex = '-1';
                var _nextCell2 = cell.nextElementSibling;
                if (_nextCell2) {
                    _nextCell2.tabIndex = '0';
                    _nextCell2.focus();
                } else {
                    navigation.current = {
                        backward: false
                    };
                    navForward(event);
                }
                event.preventDefault();
                break;
            case 'PageUp':
                if (event.shiftKey) return;
                navigation.current = {
                    backward: true
                };
                navBackward(event);
                break;
            case 'PageDown':
                if (event.shiftKey) return;
                navigation.current = {
                    backward: false
                };
                navForward(event);
                break;
            case 'Enter':
            case 'NumpadEnter':
            case 'Space':
                if (props.view !== 'year') viewChangedWithKeyDown.current = true;
                onYearSelect(event, index);
                event.preventDefault();
                break;
            case 'Escape':
                hide(null, reFocusInputField);
                event.preventDefault();
                break;
            case 'Tab':
                trapFocus(event);
                break;
        }
    };
    var onDateSelect = function onDateSelect(event, dateMeta, timeMeta, isUpdateViewDate) {
        if (!event) return;
        if (props.disabled || !dateMeta.selectable) {
            event.preventDefault();
            return;
        }
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).find(overlayRef.current, 'table td span:not([data-p-disabled="true"])').forEach(function(cell) {
            return cell.tabIndex = -1;
        });
        event.currentTarget.focus();
        if (isMultipleSelection()) {
            if (isSelected(dateMeta)) {
                var value = props.value.filter(function(date) {
                    return !isDateEquals(date, dateMeta);
                });
                updateModel(event, value);
                updateInputfield(value);
            } else if (!props.maxDateCount || !props.value || props.maxDateCount > props.value.length) selectDate(event, dateMeta, timeMeta);
        } else selectDate(event, dateMeta, timeMeta);
        if (!props.inline && isSingleSelection() && (!props.showTime || props.hideOnDateTimeSelect) && !isUpdateViewDate) {
            setTimeout(function() {
                hide('dateselect');
            }, 100);
            if (touchUIMask.current) disableModality();
        }
        event.preventDefault();
    };
    var selectTime = function selectTime(date, timeMeta) {
        if (props.showTime) {
            var hours;
            var minutes;
            var seconds;
            var milliseconds;
            if (timeMeta) {
                hours = timeMeta.hours;
                minutes = timeMeta.minutes;
                seconds = timeMeta.seconds;
                milliseconds = timeMeta.milliseconds;
            } else {
                var time = getCurrentDateTime();
                var _ref3 = [
                    time.getHours(),
                    time.getMinutes(),
                    time.getSeconds(),
                    time.getMilliseconds()
                ];
                hours = _ref3[0];
                minutes = _ref3[1];
                seconds = _ref3[2];
                milliseconds = _ref3[3];
            }
            date.setHours(hours);
            date.setMinutes(doStepMinute(minutes));
            date.setSeconds(seconds);
            date.setMilliseconds(milliseconds);
        }
    };
    var selectDate = function selectDate(event, dateMeta, timeMeta) {
        var date = new Date(dateMeta.year, dateMeta.month, dateMeta.day);
        selectTime(date, timeMeta);
        if (props.minDate && props.minDate > date) date = props.minDate;
        if (props.maxDate && props.maxDate < date) date = props.maxDate;
        var selectedValues = date;
        if (isSingleSelection()) updateModel(event, date);
        else if (isMultipleSelection()) {
            selectedValues = props.value ? [].concat($7829c495bb40f01d$var$_toConsumableArray(props.value), [
                date
            ]) : [
                date
            ];
            updateModel(event, selectedValues);
        } else if (isRangeSelection()) {
            if (props.value && props.value.length) {
                var startDate = props.value[0];
                var endDate = props.value[1];
                if (!endDate) {
                    if (date.getTime() >= startDate.getTime()) endDate = date;
                    else {
                        endDate = startDate;
                        startDate = date;
                    }
                } else {
                    startDate = date;
                    endDate = null;
                }
                selectedValues = [
                    startDate,
                    endDate
                ];
                updateModel(event, selectedValues);
                if (props.hideOnRangeSelection && endDate !== null) setTimeout(function() {
                    setOverlayVisibleState(false);
                }, 150);
            } else {
                selectedValues = [
                    date,
                    null
                ];
                updateModel(event, selectedValues);
            }
        }
        if (props.onSelect) props.onSelect({
            originalEvent: event,
            value: date
        });
        updateInputfield(selectedValues);
    };
    var decrementDecade = function decrementDecade() {
        var _currentYear = currentYear - 10;
        setCurrentYear(_currentYear);
        return _currentYear;
    };
    var incrementDecade = function incrementDecade() {
        var _currentYear = currentYear + 10;
        setCurrentYear(_currentYear);
        return _currentYear;
    };
    var switchToMonthView = function switchToMonthView(event) {
        if (event && event.code && (event.code === 'Enter' || event.code === 'NumpadEnter' || event.code === 'Space')) viewChangedWithKeyDown.current = true;
        setCurrentView('month');
        event.preventDefault();
    };
    var switchToYearView = function switchToYearView(event) {
        if (event && event.code && (event.code === 'Enter' || event.code === 'NumpadEnter' || event.code === 'Space')) viewChangedWithKeyDown.current = true;
        setCurrentView('year');
        event.preventDefault();
    };
    var onMonthSelect = function onMonthSelect(event, month) {
        if (props.view === 'month') {
            onDateSelect(event, {
                year: currentYear,
                month: month,
                day: 1,
                selectable: true
            });
            event.preventDefault();
        } else {
            setCurrentMonth(month);
            createMonthsMeta(month, currentYear);
            var currentDate = cloneDate(getCurrentDateTime());
            currentDate.setDate(1); // #2948 always set to 1st of month
            currentDate.setMonth(month);
            currentDate.setYear(currentYear);
            setViewDateState(currentDate);
            setCurrentView('date');
            props.onMonthChange && props.onMonthChange({
                month: month + 1,
                year: currentYear
            });
            updateViewDate(event, currentDate);
            onViewDateSelect({
                event: event,
                date: currentDate
            });
        }
    };
    var onYearSelect = function onYearSelect(event, year) {
        if (props.view === 'year') onDateSelect(event, {
            year: year,
            month: 0,
            day: 1,
            selectable: true
        });
        else {
            setCurrentYear(year);
            setCurrentView('month');
            props.onMonthChange && props.onMonthChange({
                month: currentMonth + 1,
                year: year
            });
        }
    };
    var updateModel = function updateModel(event, value) {
        if (props.onChange) {
            var newValue = cloneDate(value);
            viewStateChanged.current = true;
            onChangeRef.current({
                originalEvent: event,
                value: newValue,
                stopPropagation: function stopPropagation() {
                    event === null || event === void 0 || event.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event === null || event === void 0 || event.preventDefault();
                },
                target: {
                    name: props.name,
                    id: props.id,
                    value: newValue
                }
            });
        }
    };
    var show = function show(type) {
        if (props.onVisibleChange) props.onVisibleChange({
            visible: true,
            type: type
        });
        else {
            setOverlayVisibleState(true);
            overlayEventListener.current = function(e) {
                if (!isOutsideClicked(e) && visible) isOverlayClicked.current = true;
            };
            (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).on('overlay-click', overlayEventListener.current);
        }
    };
    var hide = function hide(type, callback) {
        var _hideCallback = function _hideCallback() {
            viewStateChanged.current = false;
            ignoreFocusFunctionality.current = false;
            isOverlayClicked.current = false;
            callback && callback();
            (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).off('overlay-click', overlayEventListener.current);
            overlayEventListener.current = null;
        };
        props.touchUI && disableModality();
        if (props.onVisibleChange) props.onVisibleChange({
            visible: type !== 'dateselect',
            // false only if selecting a value to close panel
            type: type,
            callback: _hideCallback
        });
        else {
            setOverlayVisibleState(false);
            _hideCallback();
        }
    };
    var onOverlayEnter = function onOverlayEnter() {
        var styles = props.touchUI ? {
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        } : !props.inline ? {
            position: 'absolute',
            top: '0',
            left: '0'
        } : undefined;
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).addStyles(overlayRef.current, styles);
        if (props.autoZIndex) {
            var key = props.touchUI ? 'modal' : 'overlay';
            (0, $a73ce425265b079e$export$832931caede8e4b9).set(key, overlayRef.current, context && context.autoZIndex || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).autoZIndex, props.baseZIndex || context && context.zIndex[key] || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).zIndex[key]);
        }
        if (!props.touchUI && overlayRef && overlayRef.current && inputRef && inputRef.current && !appendDisabled()) {
            var inputWidth = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(inputRef.current);
            // #5435 must have reasonable width if input is too small
            if (inputWidth < 220) inputWidth = 220;
            if (props.view === 'date') overlayRef.current.style.width = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(overlayRef.current) + 'px';
            else overlayRef.current.style.width = inputWidth + 'px';
            // #5830 Tailwind does not need a min width it breaks the styling
            if (!isUnstyled()) overlayRef.current.style.minWidth = inputWidth + 'px';
        }
        alignOverlay();
    };
    var onOverlayEntered = function onOverlayEntered() {
        bindOverlayListener();
        props.onShow && props.onShow();
        setFocusedState(false);
    };
    var onOverlayExit = function onOverlayExit() {
        unbindOverlayListener();
    };
    var onOverlayExited = function onOverlayExited() {
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(overlayRef.current);
        props.onHide && props.onHide();
    };
    var appendDisabled = function appendDisabled() {
        var appendTo = props.appendTo || context && context.appendTo || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).appendTo;
        return appendTo === 'self' || props.inline;
    };
    var alignOverlay = function alignOverlay() {
        if (props.touchUI) enableModality();
        else if (overlayRef && overlayRef.current && inputRef && inputRef.current) {
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).alignOverlay(overlayRef.current, inputRef.current, props.appendTo || context && context.appendTo || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).appendTo);
            if (appendDisabled()) (0, $a73ce425265b079e$export$ff8ccbac9225de62).relativePosition(overlayRef.current, inputRef.current);
            else (0, $a73ce425265b079e$export$ff8ccbac9225de62).absolutePosition(overlayRef.current, inputRef.current);
        }
        // #6093 Forcibly remove minWidth when in unstyled mode
        if (isUnstyled()) overlayRef.current.style.minWidth = '';
    };
    var enableModality = function enableModality() {
        if (!touchUIMask.current) {
            touchUIMask.current = document.createElement('div');
            touchUIMask.current.style.zIndex = String((0, $a73ce425265b079e$export$832931caede8e4b9).get(overlayRef.current) - 1);
            !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).addMultipleClasses(touchUIMask.current, 'p-component-overlay p-datepicker-mask p-datepicker-mask-scrollblocker p-component-overlay-enter');
            touchUIMaskClickListener.current = function() {
                disableModality();
                hide();
            };
            touchUIMask.current.addEventListener('click', touchUIMaskClickListener.current);
            document.body.appendChild(touchUIMask.current);
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).blockBodyScroll();
        }
    };
    var disableModality = function disableModality() {
        if (touchUIMask.current) {
            if (isUnstyled) destroyMask();
            else {
                !isUnstyled() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(touchUIMask.current, 'p-component-overlay-leave');
                if ((0, $a73ce425265b079e$export$ff8ccbac9225de62).hasCSSAnimation(touchUIMask.current) > 0) touchUIMask.current.addEventListener('animationend', function() {
                    destroyMask();
                });
                else destroyMask();
            }
        }
    };
    var destroyMask = function destroyMask() {
        if (touchUIMask.current) {
            touchUIMask.current.removeEventListener('click', touchUIMaskClickListener.current);
            touchUIMaskClickListener.current = null;
            document.body.removeChild(touchUIMask.current);
            touchUIMask.current = null;
        }
        var bodyChildren = document.body.children;
        var hasBlockerMasks;
        for(var i = 0; i < bodyChildren.length; i++){
            var bodyChild = bodyChildren[i];
            if ((0, $a73ce425265b079e$export$ff8ccbac9225de62).hasClass(bodyChild, 'p-datepicker-mask-scrollblocker')) {
                hasBlockerMasks = true;
                break;
            }
        }
        if (!hasBlockerMasks) (0, $a73ce425265b079e$export$ff8ccbac9225de62).unblockBodyScroll();
    };
    var isOutsideClicked = function isOutsideClicked(event) {
        return elementRef.current && !(elementRef.current.isSameNode(event.target) || isNavIconClicked(event.target) || elementRef.current.contains(event.target) || overlayRef.current && overlayRef.current.contains(event.target));
    };
    var isNavIconClicked = function isNavIconClicked(target) {
        return previousButton.current && (previousButton.current.isSameNode(target) || previousButton.current.contains(target)) || nextButton.current && (nextButton.current.isSameNode(target) || nextButton.current.contains(target));
    };
    var getFirstDayOfMonthIndex = function getFirstDayOfMonthIndex(month, year) {
        var day = new Date();
        day.setDate(1);
        day.setMonth(month);
        day.setFullYear(year);
        var dayIndex = day.getDay() + getSundayIndex();
        return dayIndex >= 7 ? dayIndex - 7 : dayIndex;
    };
    var getDaysCountInMonth = function getDaysCountInMonth(month, year) {
        return 32 - daylightSavingAdjust(new Date(year, month, 32)).getDate();
    };
    var getDaysCountInPrevMonth = function getDaysCountInPrevMonth(month, year) {
        var prev = getPreviousMonthAndYear(month, year);
        return getDaysCountInMonth(prev.month, prev.year);
    };
    var daylightSavingAdjust = function daylightSavingAdjust(date) {
        if (!date) return null;
        date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
        return date;
    };
    var getPreviousMonthAndYear = function getPreviousMonthAndYear(month, year) {
        var m;
        var y;
        if (month === 0) {
            m = 11;
            y = year - 1;
        } else {
            m = month - 1;
            y = year;
        }
        return {
            month: m,
            year: y
        };
    };
    var getNextMonthAndYear = function getNextMonthAndYear(month, year) {
        var m;
        var y;
        if (month === 11) {
            m = 0;
            y = year + 1;
        } else {
            m = month + 1;
            y = year;
        }
        return {
            month: m,
            year: y
        };
    };
    var getSundayIndex = function getSundayIndex() {
        var firstDayOfWeek = (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('firstDayOfWeek', props.locale);
        return firstDayOfWeek > 0 ? 7 - firstDayOfWeek : 0;
    };
    var createWeekDaysMeta = function createWeekDaysMeta() {
        var weekDays = [];
        var _localeOptions = (0, $51b25b42ecc1a0c7$export$ef9c48731c26e22d)(props.locale), dayIndex = _localeOptions.firstDayOfWeek, dayNamesMin = _localeOptions.dayNamesMin;
        for(var i = 0; i < 7; i++){
            weekDays.push(dayNamesMin[dayIndex]);
            dayIndex = dayIndex === 6 ? 0 : ++dayIndex;
        }
        return weekDays;
    };
    var createMonthsMeta = function createMonthsMeta(month, year) {
        var months = [];
        for(var i = 0; i < props.numberOfMonths; i++){
            var m = month + i;
            var y = year;
            if (m > 11) {
                m = m % 11 - 1;
                y = year + 1;
            }
            months.push(createMonthMeta(m, y));
        }
        return months;
    };
    var createMonthMeta = function createMonthMeta(month, year) {
        var dates = [];
        var firstDay = getFirstDayOfMonthIndex(month, year);
        var daysLength = getDaysCountInMonth(month, year);
        var prevMonthDaysLength = getDaysCountInPrevMonth(month, year);
        var dayNo = 1;
        var today = new Date();
        var weekNumbers = [];
        var monthRows = Math.ceil((daysLength + firstDay) / 7);
        for(var i = 0; i < monthRows; i++){
            var week = [];
            if (i === 0) {
                for(var j = prevMonthDaysLength - firstDay + 1; j <= prevMonthDaysLength; j++){
                    var prev = getPreviousMonthAndYear(month, year);
                    week.push({
                        day: j,
                        month: prev.month,
                        year: prev.year,
                        otherMonth: true,
                        today: isToday(today, j, prev.month, prev.year),
                        selectable: isSelectable(j, prev.month, prev.year, true)
                    });
                }
                var remainingDaysLength = 7 - week.length;
                for(var _j = 0; _j < remainingDaysLength; _j++){
                    week.push({
                        day: dayNo,
                        month: month,
                        year: year,
                        today: isToday(today, dayNo, month, year),
                        selectable: isSelectable(dayNo, month, year, false)
                    });
                    dayNo++;
                }
            } else for(var _j2 = 0; _j2 < 7; _j2++){
                if (dayNo > daysLength) {
                    var next = getNextMonthAndYear(month, year);
                    week.push({
                        day: dayNo - daysLength,
                        month: next.month,
                        year: next.year,
                        otherMonth: true,
                        today: isToday(today, dayNo - daysLength, next.month, next.year),
                        selectable: isSelectable(dayNo - daysLength, next.month, next.year, true)
                    });
                } else week.push({
                    day: dayNo,
                    month: month,
                    year: year,
                    today: isToday(today, dayNo, month, year),
                    selectable: isSelectable(dayNo, month, year, false)
                });
                dayNo++;
            }
            if (props.showWeek) weekNumbers.push(getWeekNumber(new Date(week[0].year, week[0].month, week[0].day)));
            dates.push(week);
        }
        return {
            month: month,
            year: year,
            dates: dates,
            weekNumbers: weekNumbers
        };
    };
    var getWeekNumber = function getWeekNumber(date) {
        var checkDate = cloneDate(date);
        checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));
        var time = checkDate.getTime();
        checkDate.setMonth(0);
        checkDate.setDate(1);
        return Math.floor(Math.round((time - checkDate.getTime()) / 86400000) / 7) + 1;
    };
    var isSelectable = function isSelectable(day, month, year, otherMonth) {
        var validMin = true;
        var validMax = true;
        var validDate = true;
        var validDay = true;
        var validMonth = true;
        if (props.minDate) {
            if (props.minDate.getFullYear() > year) validMin = false;
            else if (props.minDate.getFullYear() === year) {
                if (month > -1 && props.minDate.getMonth() > month) validMin = false;
                else if (month > -1 && props.minDate.getMonth() === month) {
                    if (day > 0 && props.minDate.getDate() > day) validMin = false;
                }
            }
        }
        if (props.maxDate) {
            if (props.maxDate.getFullYear() < year) validMax = false;
            else if (props.maxDate.getFullYear() === year) {
                if (month > -1 && props.maxDate.getMonth() < month) validMax = false;
                else if (month > -1 && props.maxDate.getMonth() === month) {
                    if (day > 0 && props.maxDate.getDate() < day) validMax = false;
                }
            }
        }
        if (props.disabledDates || props.enabledDates || props.disabledDays) validDay = !isDayDisabled(day, month, year);
        if (props.selectOtherMonths === false && otherMonth) validMonth = false;
        return validMin && validMax && validDate && validDay && validMonth;
    };
    var isSelectableTime = function isSelectableTime(value) {
        var validMin = true;
        var validMax = true;
        if (props.minDate && props.minDate.toDateString() === value.toDateString()) {
            if (props.minDate.getHours() > value.getHours()) validMin = false;
            else if (props.minDate.getHours() === value.getHours()) {
                if (props.minDate.getMinutes() > value.getMinutes()) validMin = false;
                else if (props.minDate.getMinutes() === value.getMinutes()) {
                    if (props.minDate.getSeconds() > value.getSeconds()) validMin = false;
                    else if (props.minDate.getSeconds() === value.getSeconds()) {
                        if (props.minDate.getMilliseconds() > value.getMilliseconds()) validMin = false;
                    }
                }
            }
        }
        if (props.maxDate && props.maxDate.toDateString() === value.toDateString()) {
            if (props.maxDate.getHours() < value.getHours()) validMax = false;
            else if (props.maxDate.getHours() === value.getHours()) {
                if (props.maxDate.getMinutes() < value.getMinutes()) validMax = false;
                else if (props.maxDate.getMinutes() === value.getMinutes()) {
                    if (props.maxDate.getSeconds() < value.getSeconds()) validMax = false;
                    else if (props.maxDate.getSeconds() === value.getSeconds()) {
                        if (props.maxDate.getMilliseconds() < value.getMilliseconds()) validMax = false;
                    }
                }
            }
        }
        return validMin && validMax;
    };
    var isSelected = function isSelected(dateMeta) {
        if (props.value) {
            if (isSingleSelection()) return isDateEquals(props.value, dateMeta);
            else if (isMultipleSelection()) {
                var selected = false;
                var _iterator = $7829c495bb40f01d$var$_createForOfIteratorHelper(props.value), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var date = _step.value;
                        selected = isDateEquals(date, dateMeta);
                        if (selected) break;
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return selected;
            } else if (isRangeSelection()) {
                if (props.value[1]) return isDateEquals(props.value[0], dateMeta) || isDateEquals(props.value[1], dateMeta) || isDateBetween(props.value[0], props.value[1], dateMeta);
                return isDateEquals(props.value[0], dateMeta);
            }
        } else return false;
    };
    var isComparable = function isComparable() {
        return props.value != null && typeof props.value !== 'string';
    };
    var isMonthSelected = function isMonthSelected(month) {
        if (!isComparable()) return false;
        if (isMultipleSelection()) return props.value.some(function(v) {
            return v.getMonth() === month && v.getFullYear() === currentYear;
        });
        else if (isRangeSelection()) {
            var _props$value = $7829c495bb40f01d$var$_slicedToArray(props.value, 2), start = _props$value[0], end = _props$value[1];
            var startYear = start ? start.getFullYear() : null;
            var endYear = end ? end.getFullYear() : null;
            var startMonth = start ? start.getMonth() : null;
            var endMonth = end ? end.getMonth() : null;
            if (!end) return startYear === currentYear && startMonth === month;
            else {
                var currentDate = new Date(currentYear, month, 1);
                var startDate = new Date(startYear, startMonth, 1);
                var endDate = new Date(endYear, endMonth, 1);
                return currentDate >= startDate && currentDate <= endDate;
            }
        } else return props.value.getMonth() === month && props.value.getFullYear() === currentYear;
    };
    var isYearSelected = function isYearSelected(year) {
        if (!isComparable()) return false;
        if (isMultipleSelection()) return props.value.some(function(v) {
            return v.getFullYear() === year;
        });
        else if (isRangeSelection()) {
            var start = props.value[0] ? props.value[0].getFullYear() : null;
            var end = props.value[1] ? props.value[1].getFullYear() : null;
            return start === year || end === year || start < year && end > year;
        } else return props.value.getFullYear() === year;
    };
    var switchViewButtonDisabled = function switchViewButtonDisabled() {
        return props.numberOfMonths > 1 || props.disabled;
    };
    var isDateEquals = function isDateEquals(value, dateMeta) {
        if (value && value instanceof Date) return value.getDate() === dateMeta.day && value.getMonth() === dateMeta.month && value.getFullYear() === dateMeta.year;
        return false;
    };
    var isDateBetween = function isDateBetween(start, end, dateMeta) {
        var between = false;
        if (start && end) {
            var date = new Date(dateMeta.year, dateMeta.month, dateMeta.day);
            return start.getTime() <= date.getTime() && end.getTime() >= date.getTime();
        }
        return between;
    };
    var isSingleSelection = function isSingleSelection() {
        return props.selectionMode === 'single';
    };
    var isRangeSelection = function isRangeSelection() {
        return props.selectionMode === 'range';
    };
    var isMultipleSelection = function isMultipleSelection() {
        return props.selectionMode === 'multiple';
    };
    var isToday = function isToday(today, day, month, year) {
        return today.getDate() === day && today.getMonth() === month && today.getFullYear() === year;
    };
    var isDayDisabled = function isDayDisabled(day, month, year) {
        var isDisabled = false;
        // first check for disabled dates
        if (props.disabledDates) {
            if (props.disabledDates.some(function(d) {
                return d.getFullYear() === year && d.getMonth() === month && d.getDate() === day;
            })) isDisabled = true;
        }
        // next if not disabled then check for disabled days
        if (!isDisabled && props.disabledDays && currentView === 'date') {
            var weekday = new Date(year, month, day);
            var weekdayNumber = weekday.getDay();
            if (props.disabledDays.indexOf(weekdayNumber) !== -1) isDisabled = true;
        }
        // last check for enabled dates to force dates enabled
        if (props.enabledDates) {
            var isEnabled = props.enabledDates.some(function(d) {
                return d.getFullYear() === year && d.getMonth() === month && d.getDate() === day;
            });
            if (isEnabled) isDisabled = false;
            else if (!props.disabledDays && !props.disabledDates) // disable other dates when only enabledDates are present
            isDisabled = true;
        }
        return isDisabled;
    };
    var isMonthYearDisabled = function isMonthYearDisabled(month, year) {
        var daysCountInAllMonth = month === -1 ? new Array(12).fill(0).map(function(_, i) {
            return getDaysCountInMonth(i, year);
        }) : [
            getDaysCountInMonth(month, year)
        ];
        for(var i = 0; i < daysCountInAllMonth.length; i++){
            var monthDays = daysCountInAllMonth[i];
            var _month = month === -1 ? i : month;
            for(var day = 1; day <= monthDays; day++){
                var isDateSelectable = isSelectable(day, _month, year);
                if (isDateSelectable) return false;
            }
        }
        return true;
    };
    var updateInputfield = function updateInputfield(value) {
        if (!inputRef.current) return;
        var formattedValue = '';
        if (value) try {
            if (isSingleSelection()) formattedValue = isValidDate(value) ? formatDateTime(value) : props.keepInvalid ? value : '';
            else if (isMultipleSelection()) for(var i = 0; i < value.length; i++){
                var selectedValue = value[i];
                var dateAsString = isValidDate(selectedValue) ? formatDateTime(selectedValue) : '';
                formattedValue = formattedValue + dateAsString;
                if (i !== value.length - 1) formattedValue = formattedValue + ', ';
            }
            else if (isRangeSelection()) {
                if (value && value.length) {
                    var startDate = value[0];
                    var endDate = value[1];
                    formattedValue = isValidDate(startDate) ? formatDateTime(startDate) : '';
                    if (endDate) formattedValue = formattedValue + (isValidDate(endDate) ? ' - ' + formatDateTime(endDate) : '');
                }
            }
        } catch (err) {
            formattedValue = value;
        }
        inputRef.current.value = formattedValue;
    };
    var formatDateTime = function formatDateTime(date) {
        if (props.formatDateTime) return props.formatDateTime(date);
        var formattedValue = null;
        if (date) {
            if (props.timeOnly) formattedValue = formatTime(date);
            else {
                formattedValue = formatDate(date, getDateFormat());
                if (props.showTime) formattedValue = formattedValue + (' ' + formatTime(date));
            }
        }
        return formattedValue;
    };
    var formatDate = function formatDate(date, format) {
        if (!date) return '';
        var iFormat;
        var lookAhead = function lookAhead(match) {
            var matches = iFormat + 1 < format.length && format.charAt(iFormat + 1) === match;
            if (matches) iFormat++;
            return matches;
        };
        var formatNumber = function formatNumber(match, value, len) {
            var num = '' + value;
            if (lookAhead(match)) while(num.length < len)num = '0' + num;
            return num;
        };
        var formatName = function formatName(match, value, shortNames, longNames) {
            return lookAhead(match) ? longNames[value] : shortNames[value];
        };
        var output = '';
        var literal = false;
        var _localeOptions2 = (0, $51b25b42ecc1a0c7$export$ef9c48731c26e22d)(props.locale), dayNamesShort = _localeOptions2.dayNamesShort, dayNames = _localeOptions2.dayNames, monthNamesShort = _localeOptions2.monthNamesShort, monthNames = _localeOptions2.monthNames;
        if (date) {
            for(iFormat = 0; iFormat < format.length; iFormat++)if (literal) {
                if (format.charAt(iFormat) === "'" && !lookAhead("'")) literal = false;
                else output = output + format.charAt(iFormat);
            } else switch(format.charAt(iFormat)){
                case 'd':
                    output = output + formatNumber('d', date.getDate(), 2);
                    break;
                case 'D':
                    output = output + formatName('D', date.getDay(), dayNamesShort, dayNames);
                    break;
                case 'o':
                    output = output + formatNumber('o', Math.round((new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() - new Date(date.getFullYear(), 0, 0).getTime()) / 86400000), 3);
                    break;
                case 'm':
                    output = output + formatNumber('m', date.getMonth() + 1, 2);
                    break;
                case 'M':
                    output = output + formatName('M', date.getMonth(), monthNamesShort, monthNames);
                    break;
                case 'y':
                    output = output + (lookAhead('y') ? date.getFullYear() : (date.getFullYear() % 100 < 10 ? '0' : '') + date.getFullYear() % 100);
                    break;
                case '@':
                    output = output + date.getTime();
                    break;
                case '!':
                    output = output + (date.getTime() * 10000 + ticksTo1970);
                    break;
                case "'":
                    if (lookAhead("'")) output = output + "'";
                    else literal = true;
                    break;
                default:
                    output = output + format.charAt(iFormat);
            }
        }
        return output;
    };
    var formatTime = function formatTime(date) {
        if (!date) return '';
        var output = '';
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();
        var milliseconds = date.getMilliseconds();
        if (props.hourFormat === '12' && hours > 11 && hours !== 12) hours = hours - 12;
        if (props.hourFormat === '12') output = output + (hours === 0 ? 12 : hours < 10 ? '0' + hours : hours);
        else output = output + (hours < 10 ? '0' + hours : hours);
        output = output + ':';
        output = output + (minutes < 10 ? '0' + minutes : minutes);
        if (props.showSeconds) {
            output = output + ':';
            output = output + (seconds < 10 ? '0' + seconds : seconds);
        }
        if (props.showMillisec) {
            output = output + '.';
            output = output + (milliseconds < 100 ? (milliseconds < 10 ? '00' : '0') + milliseconds : milliseconds);
        }
        if (props.hourFormat === '12') output = output + (date.getHours() > 11 ? ' PM' : ' AM');
        return output;
    };
    var parseValueFromString = function parseValueFromString(text) {
        if (!text || text.trim().length === 0) return null;
        var value;
        if (isSingleSelection()) value = parseDateTime(text);
        else if (isMultipleSelection()) {
            var tokens = text.split(',');
            value = [];
            var _iterator2 = $7829c495bb40f01d$var$_createForOfIteratorHelper(tokens), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var token = _step2.value;
                    value.push(parseDateTime(token.trim()));
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        } else if (isRangeSelection()) {
            var _tokens = text.split(' - ');
            value = [];
            for(var i = 0; i < _tokens.length; i++)value[i] = parseDateTime(_tokens[i].trim());
        }
        return value;
    };
    var parseDateTime = function parseDateTime(text) {
        if (props.parseDateTime) return props.parseDateTime(text);
        var date;
        var parts = text.split(' ');
        if (props.timeOnly) {
            date = new Date();
            populateTime(date, parts[0], parts[1]);
        } else if (props.showTime) {
            date = parseDate(parts[0], getDateFormat());
            populateTime(date, parts[1], parts[2]);
        } else date = parseDate(text, getDateFormat());
        return date;
    };
    var populateTime = function populateTime(value, timeString, ampm) {
        if (props.hourFormat === '12' && ampm !== 'PM' && ampm !== 'AM') throw new Error('Invalid Time');
        var time = parseTime(timeString, ampm);
        value.setHours(time.hour);
        value.setMinutes(time.minute);
        value.setSeconds(time.second);
        value.setMilliseconds(time.millisecond);
    };
    var parseTime = function parseTime(value, ampm) {
        value = props.showMillisec ? value.replace('.', ':') : value;
        var tokens = value.split(':');
        var validTokenLength = props.showSeconds ? 3 : 2;
        validTokenLength = props.showMillisec ? validTokenLength + 1 : validTokenLength;
        if (tokens.length !== validTokenLength || tokens[0].length !== 2 || tokens[1].length !== 2 || props.showSeconds && tokens[2].length !== 2 || props.showMillisec && tokens[3].length !== 3) throw new Error('Invalid time');
        var h = parseInt(tokens[0], 10);
        var m = parseInt(tokens[1], 10);
        var s = props.showSeconds ? parseInt(tokens[2], 10) : null;
        var ms = props.showMillisec ? parseInt(tokens[3], 10) : null;
        if (isNaN(h) || isNaN(m) || h > 23 || m > 59 || props.hourFormat === '12' && h > 12 || props.showSeconds && (isNaN(s) || s > 59) || props.showMillisec && (isNaN(s) || s > 1000)) throw new Error('Invalid time');
        else {
            if (props.hourFormat === '12') {
                if (h !== 12 && ampm === 'PM') h = h + 12;
                if (h === 12 && ampm === 'AM') h = h - 12;
            }
            return {
                hour: h,
                minute: m,
                second: s,
                millisecond: ms
            };
        }
    };
    // Ported from jquery-ui datepicker parseDate
    var parseDate = function parseDate(value, format) {
        if (format == null || value == null) throw new Error('Invalid arguments');
        value = $7829c495bb40f01d$var$_typeof(value) === 'object' ? value.toString() : value + '';
        if (value === '') return null;
        var iFormat;
        var dim;
        var extra;
        var iValue = 0;
        var shortYearCutoff = typeof props.shortYearCutoff !== 'string' ? props.shortYearCutoff : new Date().getFullYear() % 100 + parseInt(props.shortYearCutoff, 10);
        var year = -1;
        var month = -1;
        var day = -1;
        var doy = -1;
        var literal = false;
        var date;
        var lookAhead = function lookAhead(match) {
            var matches = iFormat + 1 < format.length && format.charAt(iFormat + 1) === match;
            if (matches) iFormat++;
            return matches;
        };
        var getNumber = function getNumber(match) {
            var isDoubled = lookAhead(match);
            var size = match === '@' ? 14 : match === '!' ? 20 : match === 'y' && isDoubled ? 4 : match === 'o' ? 3 : 2;
            var minSize = match === 'y' ? size : 1;
            var digits = new RegExp('^\\d{' + minSize + ',' + size + '}');
            var num = value.substring(iValue).match(digits);
            if (!num) throw new Error('Missing number at position ' + iValue);
            iValue = iValue + num[0].length;
            return parseInt(num[0], 10);
        };
        var getName = function getName(match, shortNames, longNames) {
            var index = -1;
            var arr = lookAhead(match) ? longNames : shortNames;
            var names = [];
            for(var i = 0; i < arr.length; i++)names.push([
                i,
                arr[i]
            ]);
            names.sort(function(a, b) {
                return -(a[1].length - b[1].length);
            });
            for(var _i = 0; _i < names.length; _i++){
                var name = names[_i][1];
                if (value.substr(iValue, name.length).toLowerCase() === name.toLowerCase()) {
                    index = names[_i][0];
                    iValue = iValue + name.length;
                    break;
                }
            }
            if (index !== -1) return index + 1;
            throw new Error('Unknown name at position ' + iValue);
        };
        var checkLiteral = function checkLiteral() {
            if (value.charAt(iValue) !== format.charAt(iFormat)) throw new Error('Unexpected literal at position ' + iValue);
            iValue++;
        };
        if (props.view === 'month') day = 1;
        if (props.view === 'year') {
            day = 1;
            month = 1;
        }
        var _localeOptions3 = (0, $51b25b42ecc1a0c7$export$ef9c48731c26e22d)(props.locale), dayNamesShort = _localeOptions3.dayNamesShort, dayNames = _localeOptions3.dayNames, monthNamesShort = _localeOptions3.monthNamesShort, monthNames = _localeOptions3.monthNames;
        for(iFormat = 0; iFormat < format.length; iFormat++)if (literal) {
            if (format.charAt(iFormat) === "'" && !lookAhead("'")) literal = false;
            else checkLiteral();
        } else switch(format.charAt(iFormat)){
            case 'd':
                day = getNumber('d');
                break;
            case 'D':
                getName('D', dayNamesShort, dayNames);
                break;
            case 'o':
                doy = getNumber('o');
                break;
            case 'm':
                month = getNumber('m');
                break;
            case 'M':
                month = getName('M', monthNamesShort, monthNames);
                break;
            case 'y':
                year = getNumber('y');
                break;
            case '@':
                date = new Date(getNumber('@'));
                year = date.getFullYear();
                month = date.getMonth() + 1;
                day = date.getDate();
                break;
            case '!':
                date = new Date((getNumber('!') - ticksTo1970) / 10000);
                year = date.getFullYear();
                month = date.getMonth() + 1;
                day = date.getDate();
                break;
            case "'":
                if (lookAhead("'")) checkLiteral();
                else literal = true;
                break;
            default:
                checkLiteral();
        }
        if (iValue < value.length) {
            extra = value.substr(iValue);
            if (!/^\s+/.test(extra)) throw new Error('Extra/unparsed characters found in date: ' + extra);
        }
        if (year === -1) year = new Date().getFullYear();
        else if (year < 100) year = year + (new Date().getFullYear() - new Date().getFullYear() % 100 + (year <= shortYearCutoff ? 0 : -100));
        if (doy > -1) {
            month = 1;
            day = doy;
            do {
                dim = getDaysCountInMonth(year, month - 1);
                if (day <= dim) break;
                month++;
                day = day - dim;
            }while (true);
        }
        date = daylightSavingAdjust(new Date(year, month - 1, day));
        if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) throw new Error('Invalid date'); // E.g. 31/02/00
        return date;
    };
    var isInMinYear = function isInMinYear(viewDate) {
        return props.minDate && props.minDate.getFullYear() === viewDate.getFullYear();
    };
    var isInMaxYear = function isInMaxYear(viewDate) {
        return props.maxDate && props.maxDate.getFullYear() === viewDate.getFullYear();
    };
    $acw62.useEffect(function() {
        (0, $a73ce425265b079e$export$4855211e6b8ad895).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        var viewDate = getViewDate(props.viewDate);
        validateDate(viewDate);
        setViewDateState(viewDate);
        setCurrentMonth(viewDate.getMonth());
        setCurrentYear(viewDate.getFullYear());
        setCurrentView(props.view);
        if (!idState) {
            var uniqueId = (0, $a73ce425265b079e$export$d5d9b89141473caf)();
            !idState && setIdState(uniqueId);
        }
        if (props.inline) {
            overlayRef && overlayRef.current.setAttribute(attributeSelector, '');
            if (!props.disabled) {
                initFocusableCell();
                if (props.numberOfMonths === 1) overlayRef.current.style.width = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(overlayRef.current) + 'px';
            }
        }
        if (props.value) {
            updateInputfield(props.value);
            setValue(props.value);
        }
        if (props.autoFocus) // delay showing until rendered so `alignPanel()` method aligns the popup in the right location
        setTimeout(function() {
            return (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current, props.autoFocus);
        }, 200);
    });
    $acw62.useEffect(function() {
        // see https://github.com/primefaces/primereact/issues/4030
        onChangeRef.current = props.onChange;
    }, [
        props.onChange
    ]);
    $acw62.useEffect(function() {
        var unbindMaskEvents = null;
        if (props.mask) unbindMaskEvents = (0, $a73ce425265b079e$export$d99f0801a68bbcf1)(inputRef.current, {
            mask: props.mask,
            slotChar: props.maskSlotChar,
            readOnly: props.readOnlyInput || props.disabled,
            onChange: function onChange(e) {
                updateValueOnInput(e.originalEvent, e.value, function() {
                    return false;
                });
            },
            onBlur: function onBlur(e) {
                updateValueOnInput(e, e.target.value);
            }
        }).unbindEvents;
        return function() {
            props.mask && unbindMaskEvents && unbindMaskEvents();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.disabled,
        props.mask,
        props.readOnlyInput
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (viewChangedWithKeyDown.current) setCurrentView(props.view);
        viewChangedWithKeyDown.current = false;
    }, [
        props.view
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (visible && !props.inline) focusToFirstCell();
    }, [
        visible,
        currentView,
        props.inline
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (!props.onViewDateChange && !viewStateChanged.current) setValue(props.value);
        if (props.viewDate) {
            var date = getViewDate(props.viewDate);
            updateViewDate(null, date);
            onViewDateSelect({
                event: null,
                date: date
            });
        }
    }, [
        props.onViewDateChange,
        props.value,
        props.viewDate
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (overlayVisibleState || props.visible) // Github #5529
        setTimeout(function() {
            alignOverlay();
        });
    }, [
        currentView,
        overlayVisibleState,
        props.visible
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        var newDate = props.value;
        if (previousValue !== newDate) {
            var isInputFocused = document.activeElement === inputRef.current;
            // Do not update value in input if user types something in it:
            if (!isInputFocused) updateInputfield(newDate);
            // #3516 view date not updated when value set programatically
            if (!newDate) return;
            var viewDate = newDate;
            if (isMultipleSelection()) {
                if (newDate.length) viewDate = newDate[newDate.length - 1];
            } else if (isRangeSelection()) {
                if (newDate.length) {
                    var startDate = newDate[0];
                    var endDate = newDate[1];
                    viewDate = endDate || startDate;
                }
            }
            if (viewDate instanceof Date) {
                validateDate(viewDate);
                setViewDateState(viewDate);
                setCurrentMonth(viewDate.getMonth());
                setCurrentYear(viewDate.getFullYear());
            }
        }
    }, [
        props.value,
        visible
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        updateInputfield(props.value);
    }, [
        props.dateFormat,
        props.hourFormat,
        props.timeOnly,
        props.showSeconds,
        props.showMillisec,
        props.showTime,
        props.locale
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (overlayRef.current) {
            setNavigationState(viewDateState);
            updateFocus();
        }
    });
    (0, $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96)(function() {
        if (touchUIMask.current) {
            disableModality();
            touchUIMask.current = null;
        }
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(overlayRef.current);
    });
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            show: show,
            hide: hide,
            getCurrentDateTime: getCurrentDateTime,
            getViewDate: getViewDate,
            updateViewDate: updateViewDate,
            focus: function focus() {
                return (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(inputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getOverlay: function getOverlay() {
                return overlayRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            }
        };
    });
    var setValue = function setValue(propValue) {
        if (Array.isArray(propValue)) propValue = propValue[0];
        var prevPropValue = previousValue;
        if (Array.isArray(prevPropValue)) prevPropValue = prevPropValue[0];
        var viewDate = props.viewDate && isValidDate(props.viewDate) ? props.viewDate : propValue && isValidDate(propValue) ? propValue : new Date();
        if (isClearClicked.current && props.showTime) {
            viewDate.setHours(0, 0, 0);
            isClearClicked.current = false;
        }
        if (!prevPropValue && propValue || propValue && propValue instanceof Date && propValue.getTime() !== prevPropValue.getTime()) validateDate(viewDate);
        setViewDateState(viewDate);
        viewStateChanged.current = true;
    };
    var createBackwardNavigator = function createBackwardNavigator(isVisible) {
        var navigatorProps = isVisible ? {
            onClick: onPrevButtonClick,
            onKeyDown: function onKeyDown(e) {
                return onContainerButtonKeydown(e);
            }
        } : {
            style: {
                visibility: 'hidden'
            }
        };
        var previousIconProps = mergeProps({
            className: cx('previousIcon')
        }, ptm('previousIcon'));
        var icon = props.prevIcon || /*#__PURE__*/ $acw62.createElement((0, $dcc9b5d50491f528$export$20bc5960c3c9eebb), previousIconProps);
        var backwardNavigatorIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $7829c495bb40f01d$var$_objectSpread({}, previousIconProps), {
            props: props
        });
        var _localeOptions4 = (0, $51b25b42ecc1a0c7$export$ef9c48731c26e22d)(props.locale), prevDecade = _localeOptions4.prevDecade, prevYear = _localeOptions4.prevYear, prevMonth = _localeOptions4.prevMonth;
        var previousButtonLabel = currentView === 'year' ? prevDecade : currentView === 'month' ? prevYear : prevMonth;
        var previousButtonProps = mergeProps($7829c495bb40f01d$var$_objectSpread({
            type: 'button',
            className: cx('previousButton'),
            'aria-label': previousButtonLabel
        }, navigatorProps), ptm('previousButton'));
        return /*#__PURE__*/ $acw62.createElement("button", $7829c495bb40f01d$var$_extends({
            ref: previousButton
        }, previousButtonProps), backwardNavigatorIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
    };
    var createForwardNavigator = function createForwardNavigator(isVisible) {
        var navigatorProps = isVisible ? {
            onClick: onNextButtonClick,
            onKeyDown: function onKeyDown(e) {
                return onContainerButtonKeydown(e);
            }
        } : {
            style: {
                visibility: 'hidden'
            }
        };
        var nextIconProps = mergeProps({
            className: cx('nextIcon')
        }, ptm('nextIcon'));
        var icon = props.nextIcon || /*#__PURE__*/ $acw62.createElement((0, $17ca5e057f7346f4$export$b837bd7eac09a33e), nextIconProps);
        var forwardNavigatorIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $7829c495bb40f01d$var$_objectSpread({}, nextIconProps), {
            props: props
        });
        var _localeOptions5 = (0, $51b25b42ecc1a0c7$export$ef9c48731c26e22d)(props.locale), nextDecade = _localeOptions5.nextDecade, nextYear = _localeOptions5.nextYear, nextMonth = _localeOptions5.nextMonth;
        var nextButtonLabel = currentView === 'year' ? nextDecade : currentView === 'month' ? nextYear : nextMonth;
        var nextButtonProps = mergeProps($7829c495bb40f01d$var$_objectSpread({
            type: 'button',
            className: cx('nextButton'),
            'aria-label': nextButtonLabel
        }, navigatorProps), ptm('nextButton'));
        return /*#__PURE__*/ $acw62.createElement("button", $7829c495bb40f01d$var$_extends({
            ref: nextButton
        }, nextButtonProps), forwardNavigatorIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
    };
    var renderMonthsNavigator = function renderMonthsNavigator(index) {
        return props.monthNavigator && props.view !== 'month' && (props.numberOfMonths === 1 || index === 0);
    };
    var createTitleMonthElement = function createTitleMonthElement(month, monthIndex) {
        var monthNames = (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('monthNames', props.locale);
        if (renderMonthsNavigator(monthIndex)) {
            var viewDate = getViewDate();
            var viewMonth = viewDate.getMonth();
            var displayedMonthOptions = monthNames.map(function(month, index) {
                return (!isInMinYear(viewDate) || index >= props.minDate.getMonth()) && (!isInMaxYear(viewDate) || index <= props.maxDate.getMonth()) ? {
                    label: month,
                    value: index,
                    index: index
                } : null;
            }).filter(function(option) {
                return !!option;
            });
            var displayedMonthNames = displayedMonthOptions.map(function(option) {
                return option.label;
            });
            var selectProps = mergeProps({
                className: cx('select'),
                onChange: function onChange(e) {
                    return onMonthDropdownChange(e, e.target.value);
                },
                value: viewMonth
            }, ptm('select'));
            var _content = /*#__PURE__*/ $acw62.createElement("select", selectProps, displayedMonthOptions.map(function(option) {
                var optionProps = mergeProps({
                    value: option.value
                }, ptm('option'));
                return /*#__PURE__*/ $acw62.createElement("option", $7829c495bb40f01d$var$_extends({}, optionProps, {
                    key: option.label
                }), option.label);
            }));
            if (props.monthNavigatorTemplate) {
                var defaultContentOptions = {
                    onChange: onMonthDropdownChange,
                    className: 'p-datepicker-month',
                    value: viewMonth,
                    names: displayedMonthNames,
                    options: displayedMonthOptions,
                    element: _content,
                    props: props
                };
                return (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.monthNavigatorTemplate, defaultContentOptions);
            }
            return _content;
        }
        var monthTitleProps = mergeProps({
            className: cx('monthTitle'),
            onKeyDown: onContainerButtonKeydown,
            'aria-label': (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('chooseMonth', props.locale),
            onClick: switchToMonthView,
            disabled: switchViewButtonDisabled()
        }, ptm('monthTitle'));
        return currentView === 'date' && /*#__PURE__*/ $acw62.createElement("button", monthTitleProps, monthNames[month]);
    };
    var createTitleYearElement = function createTitleYearElement(metaYear) {
        var viewDate = getViewDate();
        var viewYear = viewDate.getFullYear();
        var displayYear = props.numberOfMonths > 1 || props.yearNavigator ? metaYear : currentYear;
        if (props.yearNavigator) {
            var _yearOptions2 = [];
            if (props.yearRange) {
                var years = props.yearRange.split(':');
                var yearStart = parseInt(years[0], 10);
                var yearEnd = parseInt(years[1], 10);
                for(var i = yearStart; i <= yearEnd; i++)_yearOptions2.push(i);
            } else {
                var base = viewYear - viewYear % 10;
                for(var _i2 = 0; _i2 < 10; _i2++)_yearOptions2.push(base + _i2);
            }
            var displayedYearNames = _yearOptions2.filter(function(year) {
                return !(props.minDate && props.minDate.getFullYear() > year) && !(props.maxDate && props.maxDate.getFullYear() < year);
            });
            var selectProps = mergeProps({
                className: cx('select'),
                onChange: function onChange(e) {
                    return onYearDropdownChange(e, e.target.value);
                },
                value: displayYear
            }, ptm('select'));
            var _content2 = /*#__PURE__*/ $acw62.createElement("select", selectProps, displayedYearNames.map(function(year) {
                var optionProps = mergeProps({
                    value: year
                }, ptm('option'));
                return /*#__PURE__*/ $acw62.createElement("option", $7829c495bb40f01d$var$_extends({}, optionProps, {
                    key: year
                }), year);
            }));
            if (props.yearNavigatorTemplate) {
                var options = displayedYearNames.map(function(name, i) {
                    return {
                        label: name,
                        value: name,
                        index: i
                    };
                });
                var defaultContentOptions = {
                    onChange: onYearDropdownChange,
                    className: 'p-datepicker-year',
                    value: viewYear,
                    names: displayedYearNames,
                    options: options,
                    element: _content2,
                    props: props
                };
                return (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.yearNavigatorTemplate, defaultContentOptions);
            }
            return _content2;
        }
        var yearTitleProps = mergeProps({
            className: cx('yearTitle'),
            'aria-label': (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('chooseYear', props.locale),
            onClick: function onClick(e) {
                return switchToYearView(e);
            },
            disabled: switchViewButtonDisabled()
        }, ptm('yearTitle'));
        return currentView !== 'year' && /*#__PURE__*/ $acw62.createElement("button", yearTitleProps, displayYear);
    };
    var createTitleDecadeElement = function createTitleDecadeElement() {
        var years = yearPickerValues();
        var decadeTitleProps = mergeProps({
            className: cx('decadeTitle')
        }, ptm('decadeTitle'));
        if (currentView === 'year') {
            var decadeTitleTextProps = mergeProps(ptm('decadeTitleText'));
            return /*#__PURE__*/ $acw62.createElement("span", decadeTitleProps, props.decadeTemplate ? props.decadeTemplate(years) : /*#__PURE__*/ $acw62.createElement("span", decadeTitleTextProps, "".concat(yearPickerValues()[0], " - ").concat(yearPickerValues()[yearPickerValues().length - 1])));
        }
        return null;
    };
    var createTitle = function createTitle(monthMetaData, index) {
        var month = createTitleMonthElement(monthMetaData.month, index);
        var year = createTitleYearElement(monthMetaData.year);
        var decade = createTitleDecadeElement();
        var titleProps = mergeProps({
            className: cx('title')
        }, ptm('title'));
        var showMonthAfterYear = (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('showMonthAfterYear', props.locale);
        return /*#__PURE__*/ $acw62.createElement("div", titleProps, showMonthAfterYear ? year : month, showMonthAfterYear ? month : year, decade);
    };
    var createDayNames = function createDayNames(weekDays) {
        var weekDayProps = mergeProps(ptm('weekDay'));
        var tableHeaderCellProps = mergeProps({
            scope: 'col'
        }, ptm('tableHeaderCell'));
        var dayNames = weekDays.map(function(weekDay, index) {
            return /*#__PURE__*/ $acw62.createElement("th", $7829c495bb40f01d$var$_extends({}, tableHeaderCellProps, {
                key: "".concat(weekDay, "-").concat(index)
            }), /*#__PURE__*/ $acw62.createElement("span", weekDayProps, weekDay));
        });
        if (props.showWeek) {
            var weekHeaderProps = mergeProps({
                scope: 'col',
                className: cx('weekHeader'),
                'data-p-disabled': props.showWeek
            }, ptm('weekHeader', {
                context: {
                    disabled: props.showWeek
                }
            }));
            var weekLabel = mergeProps(ptm('weekLabel'));
            var weekHeader = /*#__PURE__*/ $acw62.createElement("th", $7829c495bb40f01d$var$_extends({}, weekHeaderProps, {
                key: "wn"
            }), /*#__PURE__*/ $acw62.createElement("span", weekLabel, (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('weekHeader', props.locale)));
            return [
                weekHeader
            ].concat($7829c495bb40f01d$var$_toConsumableArray(dayNames));
        }
        return dayNames;
    };
    var createDateCellContent = function createDateCellContent(date, className, groupIndex) {
        var content = props.dateTemplate ? props.dateTemplate(date) : date.day;
        var selected = isSelected(date);
        var dayLabelProps = mergeProps({
            className: cx('dayLabel', {
                className: className
            }),
            'aria-selected': selected,
            'aria-disabled': !date.selectable,
            onClick: function onClick(e) {
                return onDateSelect(e, date);
            },
            onKeyDown: function onKeyDown(e) {
                return onDateCellKeydown(e, date, groupIndex);
            },
            'data-p-highlight': selected,
            'data-p-disabled': !date.selectable
        }, ptm('dayLabel', {
            context: {
                selected: selected,
                disabled: !date.selectable
            }
        }));
        return /*#__PURE__*/ $acw62.createElement("span", dayLabelProps, content, selected && /*#__PURE__*/ $acw62.createElement("div", {
            "aria-live": "polite",
            className: "p-hidden-accessible",
            "data-p-hidden-accessible": true,
            pt: ptm('hiddenSelectedDay')
        }));
    };
    var createWeek = function createWeek(weekDates, weekNumber, groupIndex) {
        var week = weekDates.map(function(date) {
            var selected = isSelected(date);
            var dateClassName = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)({
                'p-highlight': selected,
                'p-disabled': !date.selectable
            });
            var content = date.otherMonth && !props.showOtherMonths ? null : createDateCellContent(date, dateClassName, groupIndex);
            var formattedValue = formatDate(new Date(date.year, date.month, date.day), getDateFormat());
            var dayProps = mergeProps({
                className: cx('day', {
                    date: date
                }),
                'aria-label': formattedValue,
                'data-p-today': date.today,
                'data-p-other-month': date.otherMonth
            }, ptm('day', {
                context: {
                    date: date,
                    today: date.today,
                    otherMonth: date.otherMonth
                }
            }));
            return /*#__PURE__*/ $acw62.createElement("td", $7829c495bb40f01d$var$_extends({}, dayProps, {
                key: date.day
            }), content);
        });
        if (props.showWeek) {
            var weekNumberProps = mergeProps({
                className: cx('weekNumber')
            }, ptm('weekNumber'));
            var weekLabelContainerProps = mergeProps({
                className: cx('weekLabelContainer'),
                'data-p-disabled': props.showWeek
            }, ptm('weekLabelContainer', {
                context: {
                    disabled: props.showWeek
                }
            }));
            var weekNumberCell = /*#__PURE__*/ $acw62.createElement("td", $7829c495bb40f01d$var$_extends({}, weekNumberProps, {
                key: 'wn' + weekNumber
            }), /*#__PURE__*/ $acw62.createElement("span", weekLabelContainerProps, weekNumber));
            return [
                weekNumberCell
            ].concat($7829c495bb40f01d$var$_toConsumableArray(week));
        }
        return week;
    };
    var createDates = function createDates(monthMetaData, groupIndex) {
        var tableBodyRowProps = mergeProps(ptm('tableBodyRowProps'));
        return monthMetaData.dates.map(function(weekDates, index) {
            return /*#__PURE__*/ $acw62.createElement("tr", $7829c495bb40f01d$var$_extends({}, tableBodyRowProps, {
                key: index
            }), createWeek(weekDates, monthMetaData.weekNumbers[index], groupIndex));
        });
    };
    var createDateViewGrid = function createDateViewGrid(monthMetaData, weekDays, groupIndex) {
        var dayNames = createDayNames(weekDays);
        var dates = createDates(monthMetaData, groupIndex);
        var containerProps = mergeProps({
            className: cx('container')
        }, ptm('container'));
        var tableProps = mergeProps({
            role: 'grid',
            className: cx('table')
        }, ptm('table'));
        var tableHeaderProps = mergeProps(ptm('tableHeader'));
        var tableHeaderRowProps = mergeProps(ptm('tableHeaderRow'));
        var tableBodyProps = mergeProps(ptm('tableBody'));
        return currentView === 'date' && /*#__PURE__*/ $acw62.createElement("div", $7829c495bb40f01d$var$_extends({}, containerProps, {
            key: (0, $a73ce425265b079e$export$d5d9b89141473caf)('calendar_container_')
        }), /*#__PURE__*/ $acw62.createElement("table", tableProps, /*#__PURE__*/ $acw62.createElement("thead", tableHeaderProps, /*#__PURE__*/ $acw62.createElement("tr", tableHeaderRowProps, dayNames)), /*#__PURE__*/ $acw62.createElement("tbody", tableBodyProps, dates)));
    };
    var createMonth = function createMonth(monthMetaData, index) {
        var weekDays = createWeekDaysMeta();
        var backwardNavigator = createBackwardNavigator(index === 0);
        var forwardNavigator = createForwardNavigator(props.numberOfMonths === 1 || index === props.numberOfMonths - 1);
        var title = createTitle(monthMetaData, index);
        var dateViewGrid = createDateViewGrid(monthMetaData, weekDays, index);
        var header = props.headerTemplate ? props.headerTemplate() : null;
        var monthKey = monthMetaData.month + '-' + monthMetaData.year;
        var groupProps = mergeProps({
            className: cx('group')
        }, ptm('group'));
        var headerProps = mergeProps({
            className: cx('header')
        }, ptm('header'));
        return /*#__PURE__*/ $acw62.createElement("div", $7829c495bb40f01d$var$_extends({}, groupProps, {
            key: monthKey
        }), /*#__PURE__*/ $acw62.createElement("div", $7829c495bb40f01d$var$_extends({}, headerProps, {
            key: index
        }), header, backwardNavigator, title, forwardNavigator), dateViewGrid);
    };
    var createMonths = function createMonths(monthsMetaData) {
        var groups = monthsMetaData.map(createMonth);
        var groupContainerProps = mergeProps({
            className: cx('groupContainer')
        }, ptm('groupContainer'));
        return /*#__PURE__*/ $acw62.createElement("div", groupContainerProps, groups);
    };
    var createDateView = function createDateView() {
        var viewDate = getViewDate();
        var monthsMetaData = createMonthsMeta(viewDate.getMonth(), viewDate.getFullYear());
        var months = createMonths(monthsMetaData);
        return months;
    };
    var monthPickerValues = function monthPickerValues() {
        var monthPickerValues = [];
        var monthNamesShort = (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('monthNamesShort', props.locale);
        for(var i = 0; i <= 11; i++)monthPickerValues.push(monthNamesShort[i]);
        return monthPickerValues;
    };
    var yearPickerValues = function yearPickerValues() {
        var yearPickerValues = [];
        var base = currentYear - currentYear % 10;
        for(var i = 0; i < 10; i++)yearPickerValues.push(base + i);
        return yearPickerValues;
    };
    var createMonthYearView = function createMonthYearView() {
        var backwardNavigator = createBackwardNavigator(true);
        var forwardNavigator = createForwardNavigator(true);
        var yearElement = createTitleYearElement(getViewDate().getFullYear());
        var decade = createTitleDecadeElement();
        var groupContainerProps = mergeProps({
            className: cx('groupContainer')
        }, ptm('groupContainer'));
        var groupProps = mergeProps({
            className: cx('group')
        }, ptm('group'));
        var headerProps = mergeProps({
            className: cx('header')
        }, ptm('header'));
        var titleProps = mergeProps({
            className: cx('title')
        }, ptm('title'));
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", groupContainerProps, /*#__PURE__*/ $acw62.createElement("div", groupProps, /*#__PURE__*/ $acw62.createElement("div", headerProps, backwardNavigator, /*#__PURE__*/ $acw62.createElement("div", titleProps, yearElement, decade), forwardNavigator))));
    };
    var createDatePicker = function createDatePicker() {
        if (!props.timeOnly) {
            if (props.view === 'date') return createDateView();
            return createMonthYearView();
        }
        return null;
    };
    var incrementIconProps = mergeProps(ptm('incrementIcon'));
    var decrementIconProps = mergeProps(ptm('decrementIcon'));
    var incrementIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(props.incrementIcon || /*#__PURE__*/ $acw62.createElement((0, $a26a14ced485563c$export$7f01a6cbee61a0f2), incrementIconProps), $7829c495bb40f01d$var$_objectSpread({}, incrementIconProps), {
        props: props
    });
    var decrementIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(props.decrementIcon || /*#__PURE__*/ $acw62.createElement((0, $2539671ba6368b77$export$4857d3f3f5f8319b), decrementIconProps), $7829c495bb40f01d$var$_objectSpread({}, decrementIconProps), {
        props: props
    });
    var createHourPicker = function createHourPicker() {
        var currentTime = getCurrentDateTime();
        var minute = doStepMinute(currentTime.getMinutes());
        var hour = currentTime.getHours();
        // #3770 account for step minutes rolling to next hour
        hour = minute > 59 ? hour + 1 : hour;
        if (props.hourFormat === '12') {
            if (hour === 0) hour = 12;
            else if (hour > 11 && hour !== 12) hour = hour - 12;
        }
        var hourProps = mergeProps(ptm('hour'));
        var _localeOptions6 = (0, $51b25b42ecc1a0c7$export$ef9c48731c26e22d)(props.locale), nextHour = _localeOptions6.nextHour, prevHour = _localeOptions6.prevHour;
        var hourDisplay = hour < 10 ? '0' + hour : hour;
        var hourPickerProps = mergeProps({
            className: cx('hourPicker')
        }, ptm('hourPicker'));
        var incrementButtonProps = mergeProps({
            type: 'button',
            className: cx('incrementButton'),
            'aria-label': nextHour,
            onMouseDown: function onMouseDown(e) {
                return onTimePickerElementMouseDown(e, 0, 1);
            },
            onMouseUp: onTimePickerElementMouseUp,
            onMouseLeave: onTimePickerElementMouseLeave,
            onKeyDown: function onKeyDown(e) {
                return onPickerKeyDown(e, 0, 1);
            },
            onKeyUp: onPickerKeyUp
        }, ptm('incrementButton'));
        var decrementButtonProps = mergeProps({
            type: 'button',
            className: cx('decrementButton'),
            'aria-label': prevHour,
            onMouseDown: function onMouseDown(e) {
                return onTimePickerElementMouseDown(e, 0, -1);
            },
            onMouseUp: onTimePickerElementMouseUp,
            onMouseLeave: onTimePickerElementMouseLeave,
            onKeyDown: function onKeyDown(e) {
                return onPickerKeyDown(e, 0, -1);
            },
            onKeyUp: onPickerKeyUp
        }, ptm('decrementButton'));
        return /*#__PURE__*/ $acw62.createElement("div", hourPickerProps, /*#__PURE__*/ $acw62.createElement("button", incrementButtonProps, incrementIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null)), /*#__PURE__*/ $acw62.createElement("span", hourProps, hourDisplay), /*#__PURE__*/ $acw62.createElement("button", decrementButtonProps, decrementIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null)));
    };
    var createMinutePicker = function createMinutePicker() {
        var currentTime = getCurrentDateTime();
        var minute = doStepMinute(currentTime.getMinutes());
        minute = minute > 59 ? minute - 60 : minute;
        var minuteProps = mergeProps(ptm('minute'));
        var _localeOptions7 = (0, $51b25b42ecc1a0c7$export$ef9c48731c26e22d)(props.locale), nextMinute = _localeOptions7.nextMinute, prevMinute = _localeOptions7.prevMinute;
        var minuteDisplay = minute < 10 ? '0' + minute : minute;
        var minutePickerProps = mergeProps({
            className: cx('minutePicker')
        }, ptm('minutePicker'));
        var incrementButtonProps = mergeProps({
            type: 'button',
            className: cx('incrementButton'),
            'aria-label': nextMinute,
            onMouseDown: function onMouseDown(e) {
                return onTimePickerElementMouseDown(e, 1, 1);
            },
            onMouseUp: onTimePickerElementMouseUp,
            onMouseLeave: onTimePickerElementMouseLeave,
            onKeyDown: function onKeyDown(e) {
                return onPickerKeyDown(e, 1, 1);
            },
            onKeyUp: onPickerKeyUp
        }, ptm('incrementButton'));
        var decrementButtonProps = mergeProps({
            type: 'button',
            className: cx('decrementButton'),
            'aria-label': prevMinute,
            onMouseDown: function onMouseDown(e) {
                return onTimePickerElementMouseDown(e, 1, -1);
            },
            onMouseUp: onTimePickerElementMouseUp,
            onMouseLeave: onTimePickerElementMouseLeave,
            onKeyDown: function onKeyDown(e) {
                return onPickerKeyDown(e, 1, -1);
            },
            onKeyUp: onPickerKeyUp
        }, ptm('decrementButton'));
        return /*#__PURE__*/ $acw62.createElement("div", minutePickerProps, /*#__PURE__*/ $acw62.createElement("button", incrementButtonProps, incrementIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null)), /*#__PURE__*/ $acw62.createElement("span", minuteProps, minuteDisplay), /*#__PURE__*/ $acw62.createElement("button", decrementButtonProps, decrementIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null)));
    };
    var createSecondPicker = function createSecondPicker() {
        if (props.showSeconds) {
            var currentTime = getCurrentDateTime();
            var _localeOptions8 = (0, $51b25b42ecc1a0c7$export$ef9c48731c26e22d)(props.locale), nextSecond = _localeOptions8.nextSecond, prevSecond = _localeOptions8.prevSecond;
            var secondProps = mergeProps(ptm('second'));
            var second = currentTime.getSeconds();
            var secondDisplay = second < 10 ? '0' + second : second;
            var secondPickerProps = mergeProps({
                className: cx('secondPicker')
            }, ptm('secondPicker'));
            var incrementButtonProps = mergeProps({
                type: 'button',
                className: cx('incrementButton'),
                'aria-label': nextSecond,
                onMouseDown: function onMouseDown(e) {
                    return onTimePickerElementMouseDown(e, 2, 1);
                },
                onMouseUp: onTimePickerElementMouseUp,
                onMouseLeave: onTimePickerElementMouseLeave,
                onKeyDown: function onKeyDown(e) {
                    return onPickerKeyDown(e, 2, 1);
                },
                onKeyUp: onPickerKeyUp
            }, ptm('incrementButton'));
            var decrementButtonProps = mergeProps({
                type: 'button',
                className: cx('decrementButton'),
                'aria-label': prevSecond,
                onMouseDown: function onMouseDown(e) {
                    return onTimePickerElementMouseDown(e, 2, -1);
                },
                onMouseUp: onTimePickerElementMouseUp,
                onMouseLeave: onTimePickerElementMouseLeave,
                onKeyDown: function onKeyDown(e) {
                    return onPickerKeyDown(e, 2, -1);
                },
                onKeyUp: onPickerKeyUp
            }, ptm('decrementButton'));
            return /*#__PURE__*/ $acw62.createElement("div", secondPickerProps, /*#__PURE__*/ $acw62.createElement("button", incrementButtonProps, incrementIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null)), /*#__PURE__*/ $acw62.createElement("span", secondProps, secondDisplay), /*#__PURE__*/ $acw62.createElement("button", decrementButtonProps, decrementIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null)));
        }
        return null;
    };
    var createMiliSecondPicker = function createMiliSecondPicker() {
        if (props.showMillisec) {
            var currentTime = getCurrentDateTime();
            var _localeOptions9 = (0, $51b25b42ecc1a0c7$export$ef9c48731c26e22d)(props.locale), nextMilliSecond = _localeOptions9.nextMilliSecond, prevMilliSecond = _localeOptions9.prevMilliSecond;
            var millisecondProps = mergeProps(ptm('millisecond'));
            var millisecond = currentTime.getMilliseconds();
            var millisecondDisplay = millisecond < 100 ? (millisecond < 10 ? '00' : '0') + millisecond : millisecond;
            var millisecondPickerProps = mergeProps({
                className: cx('millisecondPicker')
            }, ptm('millisecondPicker'));
            var incrementButtonProps = mergeProps({
                type: 'button',
                className: cx('incrementButton'),
                'aria-label': nextMilliSecond,
                onMouseDown: function onMouseDown(e) {
                    return onTimePickerElementMouseDown(e, 3, 1);
                },
                onMouseUp: onTimePickerElementMouseUp,
                onMouseLeave: onTimePickerElementMouseLeave,
                onKeyDown: function onKeyDown(e) {
                    return onPickerKeyDown(e, 3, 1);
                },
                onKeyUp: onPickerKeyUp
            }, ptm('incrementButton'));
            var decrementButtonProps = mergeProps({
                type: 'button',
                className: cx('decrementButton'),
                'aria-label': prevMilliSecond,
                onMouseDown: function onMouseDown(e) {
                    return onTimePickerElementMouseDown(e, 3, -1);
                },
                onMouseUp: onTimePickerElementMouseUp,
                onMouseLeave: onTimePickerElementMouseLeave,
                onKeyDown: function onKeyDown(e) {
                    return onPickerKeyDown(e, 3, -1);
                },
                onKeyUp: onPickerKeyUp
            }, ptm('decrementButton'));
            return /*#__PURE__*/ $acw62.createElement("div", millisecondPickerProps, /*#__PURE__*/ $acw62.createElement("button", incrementButtonProps, incrementIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null)), /*#__PURE__*/ $acw62.createElement("span", millisecondProps, millisecondDisplay), /*#__PURE__*/ $acw62.createElement("button", decrementButtonProps, decrementIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null)));
        }
        return null;
    };
    var createAmPmPicker = function createAmPmPicker() {
        if (props.hourFormat === '12') {
            var currentTime = getCurrentDateTime();
            var _localeOptions10 = (0, $51b25b42ecc1a0c7$export$ef9c48731c26e22d)(props.locale), am = _localeOptions10.am, pm = _localeOptions10.pm;
            var hour = currentTime.getHours();
            var display = hour > 11 ? 'PM' : 'AM';
            var ampmProps = mergeProps(ptm('ampm'));
            var ampmPickerProps = mergeProps({
                className: cx('ampmPicker')
            }, ptm('ampmPicker'));
            var incrementButtonProps = mergeProps({
                type: 'button',
                className: cx('incrementButton'),
                'aria-label': am,
                onClick: function onClick(e) {
                    return toggleAmPm(e);
                }
            }, ptm('incrementButton'));
            var decrementButtonProps = mergeProps({
                type: 'button',
                className: cx('decrementButton'),
                'aria-label': pm,
                onClick: function onClick(e) {
                    return toggleAmPm(e);
                }
            }, ptm('decrementButton'));
            return /*#__PURE__*/ $acw62.createElement("div", ampmPickerProps, /*#__PURE__*/ $acw62.createElement("button", incrementButtonProps, incrementIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null)), /*#__PURE__*/ $acw62.createElement("span", ampmProps, display), /*#__PURE__*/ $acw62.createElement("button", decrementButtonProps, decrementIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null)));
        }
        return null;
    };
    var createSeparator = function createSeparator(separator) {
        var separatorContainerProps = mergeProps({
            className: cx('separatorContainer')
        }, ptm('separatorContainer'));
        var separatorProps = mergeProps(ptm('separator'));
        return /*#__PURE__*/ $acw62.createElement("div", separatorContainerProps, /*#__PURE__*/ $acw62.createElement("span", separatorProps, separator));
    };
    var createTimePicker = function createTimePicker() {
        if ((props.showTime || props.timeOnly) && currentView === 'date') {
            var timePickerProps = mergeProps({
                className: cx('timePicker')
            }, ptm('timePicker'));
            return /*#__PURE__*/ $acw62.createElement("div", timePickerProps, createHourPicker(), createSeparator(':'), createMinutePicker(), props.showSeconds && createSeparator(':'), createSecondPicker(), props.showMillisec && createSeparator('.'), createMiliSecondPicker(), props.hourFormat === '12' && createSeparator(':'), createAmPmPicker());
        }
        return null;
    };
    var createInputElement = function createInputElement() {
        if (!props.inline) return /*#__PURE__*/ $acw62.createElement((0, $ab1a721814a59df6$export$7034fcb7d6351061), {
            ref: inputRef,
            id: props.inputId,
            name: props.name,
            type: "text",
            role: "combobox",
            className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.inputClassName, cx('input', {
                context: context
            })),
            style: props.inputStyle,
            readOnly: props.readOnlyInput,
            disabled: props.disabled,
            required: props.required,
            autoComplete: "off",
            placeholder: props.placeholder,
            tabIndex: props.tabIndex,
            onInput: onUserInput,
            onFocus: onInputFocus,
            onBlur: onInputBlur,
            onKeyDown: onInputKeyDown,
            "aria-expanded": overlayVisibleState,
            "aria-autocomplete": "none",
            "aria-haspopup": "dialog",
            "aria-controls": panelId,
            "aria-labelledby": props.ariaLabelledBy,
            "aria-label": props.ariaLabel,
            inputMode: props.inputMode,
            tooltip: props.tooltip,
            tooltipOptions: props.tooltipOptions,
            pt: ptm('input'),
            unstyled: props.unstyled,
            __parentMetadata: {
                parent: metaData
            }
        });
        return null;
    };
    var createButton = function createButton() {
        if (props.showIcon) return /*#__PURE__*/ $acw62.createElement((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
            type: "button",
            icon: props.icon || /*#__PURE__*/ $acw62.createElement((0, $3e5119c1e8269632$export$5fda1783bb83f57b), null),
            onClick: onButtonClick,
            tabIndex: "-1",
            disabled: props.disabled,
            "aria-haspopup": "dialog",
            "aria-label": (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('chooseDate', props.locale),
            "aria-expanded": overlayVisibleState,
            "aria-controls": panelId,
            className: cx('dropdownButton'),
            pt: ptm('dropdownButton'),
            __parentMetadata: {
                parent: metaData
            }
        });
        return null;
    };
    var createContent = function createContent() {
        var input = createInputElement();
        var button = createButton();
        if (props.iconPos === 'left') return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, button, input);
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, input, button);
    };
    var createButtonBar = function createButtonBar() {
        if (props.showButtonBar) {
            var _localeOptions11 = (0, $51b25b42ecc1a0c7$export$ef9c48731c26e22d)(props.locale), today = _localeOptions11.today, clear = _localeOptions11.clear, now = _localeOptions11.now;
            var nowDate = new Date();
            var isHidden = props.minDate && props.minDate > nowDate || props.maxDate && props.maxDate < nowDate;
            var buttonbarProps = mergeProps({
                className: cx('buttonbar')
            }, ptm('buttonbar'));
            return /*#__PURE__*/ $acw62.createElement("div", buttonbarProps, /*#__PURE__*/ $acw62.createElement((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                type: "button",
                label: props.showTime ? now : today,
                onClick: onTodayButtonClick,
                onKeyDown: function onKeyDown(e) {
                    return onContainerButtonKeydown(e);
                },
                className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.todayButtonClassName, cx('todayButton')),
                pt: ptm('todayButton'),
                style: isHidden ? {
                    visibility: 'hidden'
                } : undefined
            }), /*#__PURE__*/ $acw62.createElement((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                type: "button",
                label: clear,
                onClick: onClearButtonClick,
                onKeyDown: function onKeyDown(e) {
                    return onContainerButtonKeydown(e);
                },
                className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.clearButtonClassName, cx('clearButton')),
                pt: ptm('clearButton')
            }));
        }
        return null;
    };
    var createFooter = function createFooter() {
        if (props.footerTemplate) {
            var _content3 = props.footerTemplate();
            var footerProps = mergeProps({
                className: cx('footer')
            }, ptm('footer'));
            return /*#__PURE__*/ $acw62.createElement("div", footerProps, _content3);
        }
        return null;
    };
    var createMonthPicker = function createMonthPicker() {
        if (currentView === 'month') {
            var monthPickerProps = mergeProps({
                className: cx('monthPicker')
            }, ptm('monthPicker'));
            return /*#__PURE__*/ $acw62.createElement("div", monthPickerProps, monthPickerValues().map(function(m, i) {
                var selected = isMonthSelected(i);
                var monthProps = mergeProps({
                    className: cx('month', {
                        isMonthSelected: isMonthSelected,
                        isMonthYearDisabled: isMonthYearDisabled,
                        i: i,
                        currentYear: currentYear
                    }),
                    onClick: function onClick(event) {
                        return onMonthSelect(event, i);
                    },
                    onKeyDown: function onKeyDown(event) {
                        return onMonthCellKeydown(event, i);
                    },
                    'data-p-disabled': isMonthYearDisabled(i, currentYear),
                    'data-p-highlight': selected
                }, ptm('month', {
                    context: {
                        month: m,
                        monthIndex: i,
                        selected: selected,
                        disabled: isMonthYearDisabled(i, currentYear)
                    }
                }));
                return /*#__PURE__*/ $acw62.createElement("span", $7829c495bb40f01d$var$_extends({}, monthProps, {
                    key: "month".concat(i + 1)
                }), m, selected && /*#__PURE__*/ $acw62.createElement("div", {
                    "aria-live": "polite",
                    className: "p-hidden-accessible",
                    "data-p-hidden-accessible": true,
                    pt: ptm('hiddenMonth')
                }, m));
            }));
        }
        return null;
    };
    var createYearPicker = function createYearPicker() {
        if (currentView === 'year') {
            var yearPickerProps = mergeProps({
                className: cx('yearPicker')
            }, ptm('yearPicker'));
            return /*#__PURE__*/ $acw62.createElement("div", yearPickerProps, yearPickerValues().map(function(y, i) {
                var selected = isYearSelected(y);
                var yearProps = mergeProps({
                    className: cx('year', {
                        isYearSelected: isYearSelected,
                        isMonthYearDisabled: isMonthYearDisabled,
                        y: y
                    }),
                    onClick: function onClick(event) {
                        return onYearSelect(event, y);
                    },
                    onKeyDown: function onKeyDown(event) {
                        return onYearCellKeydown(event, y);
                    },
                    'data-p-highlight': isYearSelected(y),
                    'data-p-disabled': isMonthYearDisabled(-1, y)
                }, ptm('year', {
                    context: {
                        year: y,
                        yearIndex: i,
                        selected: selected,
                        disabled: isMonthYearDisabled(-1, y)
                    }
                }));
                return /*#__PURE__*/ $acw62.createElement("span", $7829c495bb40f01d$var$_extends({}, yearProps, {
                    key: "year".concat(i + 1)
                }), y, selected && /*#__PURE__*/ $acw62.createElement("div", {
                    "aria-live": "polite",
                    className: "p-hidden-accessible",
                    "data-p-hidden-accessible": true,
                    pt: ptm('hiddenYear')
                }, y));
            }));
        }
        return null;
    };
    var panelClassName = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-datepicker p-component', props.panelClassName, {
        'p-datepicker-inline': props.inline,
        'p-disabled': props.disabled,
        'p-datepicker-timeonly': props.timeOnly,
        'p-datepicker-multiple-month': props.numberOfMonths > 1,
        'p-datepicker-monthpicker': currentView === 'month',
        'p-datepicker-touch-ui': props.touchUI,
        'p-input-filled': context && context.inputStyle === 'filled' || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).inputStyle === 'filled',
        'p-ripple-disabled': context && context.ripple === false || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).ripple === false
    });
    var content = createContent();
    var datePicker = createDatePicker();
    var timePicker = createTimePicker();
    var buttonBar = createButtonBar();
    var footer = createFooter();
    var monthPicker = createMonthPicker();
    var yearPicker = createYearPicker();
    var isFilled = (0, $a73ce425265b079e$export$ff8ccbac9225de62).hasClass(inputRef.current, 'p-filled') && inputRef.current.value !== '';
    var rootProps = mergeProps({
        id: props.id,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root', {
            focusedState: focusedState,
            isFilled: isFilled,
            panelVisible: visible
        })),
        style: props.style
    }, $7829c495bb40f01d$var$CalendarBase.getOtherProps(props), ptm('root'));
    return /*#__PURE__*/ $acw62.createElement("span", $7829c495bb40f01d$var$_extends({
        ref: elementRef
    }, rootProps), content, /*#__PURE__*/ $acw62.createElement($7829c495bb40f01d$var$CalendarPanel, {
        hostName: "Calendar",
        id: panelId,
        locale: props.locale,
        ref: overlayRef,
        className: panelClassName,
        style: props.panelStyle,
        appendTo: props.appendTo,
        inline: props.inline,
        onClick: onPanelClick,
        onMouseUp: onPanelMouseUp,
        "in": visible,
        onEnter: onOverlayEnter,
        onEntered: onOverlayEntered,
        onExit: onOverlayExit,
        onExited: onOverlayExited,
        transitionOptions: props.transitionOptions,
        ptm: ptm,
        cx: cx
    }, datePicker, timePicker, monthPicker, yearPicker, buttonBar, footer));
}));
$7829c495bb40f01d$export$e1aef45b828286de.displayName = 'Calendar';



function $ca5b82fb5b0f5a89$export$3362f77fda609a1d({ values: values, onChangeServiceId: onChangeServiceId, onChangeDateRange: onChangeDateRange }) {
    formId = (0, $acw62.useId)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "field grid",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        for: formId + '_service_id',
                        className: "col-fixed",
                        style: {
                            width: '40%'
                        },
                        children: "Oznaczenie kalendarza"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "col w-auto",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab1a721814a59df6$export$7034fcb7d6351061), {
                                id: formId + '_service_id',
                                value: values.service_id,
                                style: "w-100",
                                onChange: onChangeServiceId,
                                invalid: Boolean(values.validation_errors.service_id)
                            }),
                            values.validation_errors.service_id ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f81f7a6994ee8076$export$f69c19e57285b83a), {
                                severity: "error",
                                className: "mt-1",
                                text: values.validation_errors.service_id
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        for: formId + '_date_range',
                        className: "col-fixed",
                        style: {
                            width: '40%'
                        },
                        children: "Okres wa\u017Cno\u015Bci"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "col w-auto",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7829c495bb40f01d$export$e1aef45b828286de), {
                                inputClassName: "w-100",
                                value: values.start_date || values.end_date ? [
                                    values.start_date,
                                    values.end_date
                                ] : null,
                                id: formId + '_date_range',
                                onChange: onChangeDateRange,
                                invalid: Boolean(values.validation_errors.date_range),
                                selectionMode: "range",
                                readOnlyInput: true,
                                hideOnRangeSelection: true
                            }),
                            values.validation_errors.date_range ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f81f7a6994ee8076$export$f69c19e57285b83a), {
                                severity: "error",
                                className: "mt-1",
                                text: values.validation_errors.date_range
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                        ]
                    })
                ]
            })
        ]
    });
}



function $f9411c457ecf7c4f$export$666a6d25c0d49a67({ visible: visible, onHide: onHide }) {
    const { status: defaultIdStatus, data: defaultId } = (0, $4529664c1ee19d35$export$9f26b15dde9e2d17)('calendars');
    const toolDispatch = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$6bbcf3368996eea5));
    const handleOverlay = (0, $acw62.useContext)((0, $bdccf6b6a87b04cc$export$a2200b96afd16271));
    const newCalendarMutation = (0, $4529664c1ee19d35$export$9ae21d5a231f960d)('calendars');
    const [values, setValues] = (0, $acw62.useState)({
        service_id: '',
        start_date: null,
        end_date: null,
        validation_errors: {
            route_id: false
        }
    });
    const dialogFooterContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                label: "Anuluj",
                icon: "pi pi-times",
                onClick: ()=>onHide(),
                className: "p-button-text"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                label: "OK",
                icon: "pi pi-check",
                onClick: ()=>{
                    handleSendData();
                },
                autoFocus: true
            })
        ]
    });
    function handleChangeID(e) {
        setValues({
            ...values,
            service_id: e.target.value
        });
    }
    function handleChangeDateRange(e) {
        setValues({
            ...values,
            start_date: e.value[0],
            end_date: e.value[1]
        });
    }
    async function handleSendData() {
        const data = {
            fields: {
                service_id: values.service_id ? values.service_id : defaultId,
                start_date: (0, $57ee609582c542b6$export$443ababd588c81c9)(values.start_date),
                end_date: (0, $57ee609582c542b6$export$443ababd588c81c9)(values.end_date),
                exceptions_dates_added: [],
                exceptions_dates_removed: []
            }
        };
        try {
            const mutation = await newCalendarMutation.mutateAsync(data);
            onHide();
            // po udanym dodaniu przystanku otwórz go w edytorze
            toolDispatch({
                type: 'changed',
                newTool: {
                    ...(0, $91fa2a3eb54dc801$export$88ae2e76299eaa00).tools.calendarsTool,
                    selection: data.fields,
                    propertyEditor: {
                        ...data.fields
                    }
                }
            });
        } catch (error) {
            const errorCode = error.message.slice(0, 3);
            if (errorCode == '422') {
                //obsługa błędów walidacji
                let updatedValidationErrors = {};
                let propertyNames = Object.keys(error.cause.validation);
                propertyNames.forEach((value)=>{
                    messages = Object.values(error.cause.validation[value]).join(', ');
                    updatedValidationErrors[value] = messages;
                });
                setValues({
                    ...values,
                    validation_errors: {
                        ...updatedValidationErrors
                    }
                });
            } else //obsługa wszystkich pozostałych błędów
            handleOverlay('toast', {
                severity: "error",
                summary: "B\u0142\u0105d " + errorCode,
                detail: error.message
            });
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3c56f96c6f20f77$export$3ddf2d174ce01153), {
        header: "Nowy kalendarz",
        footer: dialogFooterContent,
        visible: visible,
        style: {
            width: '50vw',
            maxWidth: '500px'
        },
        breakpoints: {
            '960px': '75vw',
            '641px': '100vw'
        },
        onHide: onHide,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "m-0",
            children: defaultIdStatus === 'success' || defaultIdStatus === 'error' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca5b82fb5b0f5a89$export$3362f77fda609a1d), {
                values: {
                    ...values,
                    service_id: values.service_id ? values.service_id : defaultId
                },
                onChangeServiceId: handleChangeID,
                onChangeDateRange: handleChangeDateRange
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec34a5c615255cb$export$dcc7532e7120780d), {})
        })
    });
}


function $6708c38e45e15ddb$export$904d39b6b448e4e5() {
    const { isPending: isPending, error: error, data: data } = (0, $4529664c1ee19d35$export$c3a687f3d6e3fb65)('calendars');
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const dispatch = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$6bbcf3368996eea5));
    if (isPending || !data || !Array.isArray(data)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec34a5c615255cb$export$dcc7532e7120780d), {});
    if (error) return error.message;
    const calendarTemplate = (option)=>{
        const today = new Date();
        const dateStyle = (0, $57ee609582c542b6$export$294b5a2c8fb6dbfa)(option.start_date) < today && (0, $57ee609582c542b6$export$294b5a2c8fb6dbfa)(option.end_date) > today ? {
            fontWeight: 'bold',
            color: 'var(--green-700)'
        } : {
            fontWeight: 'normal'
        };
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex align-items-center",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        fontWeight: 'bold',
                        width: '15%'
                    },
                    children: option.service_id
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "text-sm",
                    style: {
                        width: '75%'
                    },
                    children: [
                        option.service_description,
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "text-xs text-200",
                            children: [
                                "Wa\u017Cny od ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: dateStyle,
                                    children: (0, $57ee609582c542b6$export$2e2bcd8739ae039)(option.start_date)
                                }),
                                " do ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: dateStyle,
                                    children: (0, $57ee609582c542b6$export$2e2bcd8739ae039)(option.end_date)
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $37f8d4c0bc2f6dce$export$41f133550aa26f48), {
                listStyle: {
                    maxHeight: '90%'
                },
                pt: {
                    header: {
                        style: {
                            maxHeight: '10%'
                        }
                    }
                },
                style: {
                    height: '90%'
                },
                options: data,
                optionLabel: "service_description",
                filter: true,
                filterBy: "service_id",
                itemTemplate: calendarTemplate,
                value: tool.selection,
                onChange: (e)=>dispatch({
                        type: 'changed',
                        newTool: {
                            ...tool,
                            selection: e.value,
                            propertyEditor: e.value
                        }
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6708c38e45e15ddb$var$CalendarBottomPanel, {})
        ]
    });
}
function $6708c38e45e15ddb$var$CalendarBottomPanel() {
    const [dialogVisible, setDialogVisible] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "w-full p-3",
        style: {
            height: '10%'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                severity: "success",
                icon: "fa-solid fa-plus",
                label: "Dodaj nowy kalendarz",
                outlined: true,
                onClick: ()=>{
                    setDialogVisible(true);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9411c457ecf7c4f$export$666a6d25c0d49a67), {
                visible: dialogVisible,
                onHide: ()=>{
                    if (!dialogVisible) return;
                    setDialogVisible(false);
                }
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");











function $74d1bb7d1ffe923a$export$cfdc085ffca97c47() {
    const tool1 = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const toolDispatch = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$6bbcf3368996eea5));
    const { data: segment, isPendingS: isPendingS, errorS: errorS } = (0, $4529664c1ee19d35$export$133314fb4acfa730)(tool1.selection ? tool1.selection.route_type : 3, tool1.selection ? tool1.selection.from_stop_id : null, tool1.selection ? tool1.selection.to_stop_id : null);
    const { data: stopsList, isPending: isPending, error: error } = (0, $4529664c1ee19d35$export$c3a687f3d6e3fb65)('stops');
    let panelHeight = '82vh';
    if (isPending || !stopsList) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec34a5c615255cb$export$dcc7532e7120780d), {
        className: "flex justify-content-center"
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                className: "fa-solid fa-face-frown fa-5x"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            "Wyst\u0105pi\u0142 b\u0142\u0105d \u0142adowania przystank\xf3w: ",
            error.message
        ]
    });
    const handleSelectStop = (propertyName, value)=>{
        let newEndpoints = tool1.selection ? {
            ...tool1.selection
        } : {
            route_type: 3,
            from_stop_id: null,
            to_stop_id: null
        };
        newEndpoints[propertyName] = value;
        toolDispatch({
            type: 'changed',
            newTool: {
                ...tool1,
                selection: newEndpoints,
                propertyEditor: {
                    edit: newEndpoints
                }
            }
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $028ce6f6ddd144ee$export$9159ebcaf8f42267), {
            style: {
                height: panelHeight,
                width: '100%'
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "formgrid grid p-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "field col-12",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b972aed698e51d9$export$4fa24d2d3971dbe9), {
                            propertyName: "route_type",
                            initialVal: segment ? segment.route_type : 3,
                            label: "Trakcja",
                            onDone: (propertyName, value)=>{
                                handleSelectStop(propertyName, value);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "field col-12",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1aa42f680c61ccaa$export$f2e335d0f285264e), {
                            initialVal: tool1.selection && tool1.selection.from_stop_id && tool1.selection.from_stop_id,
                            propertyName: "from_stop_id",
                            label: "Od przystanku:",
                            options: Object.values(stopsList),
                            onDone: (propertyName, value)=>{
                                handleSelectStop(propertyName, value);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "field col-12",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1aa42f680c61ccaa$export$f2e335d0f285264e), {
                            propertyName: "to_stop_id",
                            initialVal: tool1.selection && tool1.selection.to_stop_id && tool1.selection.to_stop_id,
                            label: "Do przystanku:",
                            options: Object.values(stopsList),
                            onDone: (propertyName, value)=>{
                                handleSelectStop(propertyName, value);
                            }
                        })
                    }),
                    tool1.selection && tool1.selection.from_stop_id && tool1.selection.to_stop_id ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($74d1bb7d1ffe923a$var$SegmentEditOrCreate, {
                        segment: segment
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: "Wybierz powy\u017Cej"
                    })
                ]
            })
        })
    });
}
function $74d1bb7d1ffe923a$var$SegmentEditOrCreate({ segment: segment }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: segment ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($74d1bb7d1ffe923a$var$SegmentPropertyEditor, {
            segment: segment
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($74d1bb7d1ffe923a$var$SegmentCreate, {})
    });
}
function $74d1bb7d1ffe923a$var$SegmentCreate() {
    const tool1 = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const toolDispatch = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$6bbcf3368996eea5));
    const segmentMutation = (0, $4529664c1ee19d35$export$9b54cc4511b2d3c8)();
    if (tool1.selection.from_stop_id === tool1.selection.to_stop_id) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f81f7a6994ee8076$export$f69c19e57285b83a), {
        className: "m-2",
        severity: "error",
        text: "Odcinek nie mo\u017Ce ko\u0144czy\u0107 si\u0119 i zaczyna\u0107 w tym samym miejscu"
    });
    const handleCreateSegment = ()=>{
        const payload = {
            query: {
                from_stop_id: tool1.selection.from_stop_id,
                to_stop_id: tool1.selection.to_stop_id,
                route_type: tool1.selection.route_type
            },
            fields: {
                default_travel_time: '00:00:00',
                length: '0'
            }
        };
        segmentMutation.mutate(payload); // próbujemy przeprowadzić mutację
    };
    const handleCreateSegmentFromMap = ()=>{
        const payload = {
            query: {
                from_stop_id: tool1.selection.from_stop_id,
                to_stop_id: tool1.selection.to_stop_id,
                route_type: tool1.selection.route_type
            },
            fields: {
                action: 'fromMap'
            }
        };
        segmentMutation.mutate(payload); // próbujemy przeprowadzić mutację
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "formgrid grid p-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-12",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                    outlined: true,
                    label: "Utw\xf3rz odcinek mi\u0119dzy tymi przystankami",
                    icon: "fa-solid fa-square-plus",
                    className: "w-full",
                    onClick: handleCreateSegment,
                    severity: "success"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-12",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                    outlined: true,
                    label: "Utw\xf3rz odcinek wg danych z mapy",
                    icon: "fa-solid fa-map",
                    className: "w-full",
                    onClick: handleCreateSegmentFromMap,
                    severity: "help"
                })
            })
        ]
    });
}
function $74d1bb7d1ffe923a$var$SegmentPropertyEditor({ segment: segment }) {
    const id = (0, $acw62.useId)();
    const handleOverlays = (0, $acw62.useContext)((0, $bdccf6b6a87b04cc$export$a2200b96afd16271));
    const [modifiedValues, setModifiedValues] = (0, $acw62.useState)(segment);
    const [isMutationPending, setIsMutationPending] = (0, $acw62.useState)(false);
    const [validationErrors, setValidationErrors] = (0, $acw62.useState)(false);
    const segmentMutation = (0, $4529664c1ee19d35$export$9b54cc4511b2d3c8)();
    if (!segment) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: "Brak segmentu"
    });
    if (!modifiedValues) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: "?"
    });
    const handleInput = (propertyName, value)=>{
        let newValues = {
            ...modifiedValues
        };
        newValues[propertyName] = value;
        setModifiedValues(newValues);
    };
    function handleInputCancel() {
        setModifiedValues(segment);
    }
    const handleInputDone = async (propertyName, value)=>{
        if (value === segment[propertyName]) return; // Nie wysyłamy zmian na serwer, jeżeli nowa wartość jest taka jak już zapisana do serwera.
        const payload = {
            query: {
                from_stop_id: tool.selection.from_stop_id,
                to_stop_id: tool.selection.to_stop_id,
                route_type: tool.selection.route_type
            },
            fields: {}
        };
        payload.fields[propertyName] = value;
        setIsMutationPending(true);
        try {
            const asyncMutation = await segmentMutation.mutateAsync(payload); // próbujemy przeprowadzić mutację
            // wykasuj ewentualne istniejące błędy walidacji z UI, skoro wszystko poszło ok
            if (validationErrors[propertyName]) {
                let updatedValidationErrors = {
                    ...validationErrors
                };
                updatedValidationErrors[propertyName] = false;
                setValidationErrors({
                    ...updatedValidationErrors
                });
            }
        } catch (error) {
            const errorCode = error.message.slice(0, 3);
            if (errorCode == '422') {
                //obsługa błędów walidacji
                let updatedValidationErrors = {
                    ...validationErrors
                };
                updatedValidationErrors[propertyName] = Object.values(error.cause.validation[propertyName]).join(', ');
                setValidationErrors({
                    ...updatedValidationErrors
                });
            } else {
                //obsługa pozostałych błędów
                handleOverlays('toast', {
                    severity: "error",
                    summary: "B\u0142\u0105d " + errorCode,
                    detail: typeof error.cause === 'undefined' || typeof error.cause.message === 'undefined' ? "Wyst\u0105pi\u0142 b\u0142\u0105d. Czynno\u015B\u0107 nie mog\u0142a zosta\u0107 zako\u0144czona powodzeniem. " + error.message : error.cause.message
                });
                console.log(error);
            }
        } finally{
            setIsMutationPending(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "formgrid grid p-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "col-12",
                children: "Domy\u015Blne parametry odcinka"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                    numeric: true,
                    propertyName: "length",
                    initialVal: segment.length,
                    label: "Odleg\u0142o\u015B\u0107",
                    id: id,
                    value: modifiedValues.length,
                    onDone: handleInputDone,
                    onChange: handleInput,
                    onCancel: handleInputCancel,
                    pending: isMutationPending,
                    suffix: " km"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                    numeric: true,
                    propertyName: "default_travel_time",
                    initialVal: (0, $57ee609582c542b6$export$acbf344db7f7262e)(segment.default_travel_time) / 60,
                    label: "Czas przej.",
                    id: id,
                    value: (0, $57ee609582c542b6$export$acbf344db7f7262e)(modifiedValues.default_travel_time) / 60,
                    onDone: (propertyName, value)=>handleInputDone(propertyName, (0, $57ee609582c542b6$export$810cbdbd69486b75)(value * 60)),
                    onChange: (propertyName, value)=>handleInput(propertyName, (0, $57ee609582c542b6$export$810cbdbd69486b75)(value * 60)),
                    onCancel: handleInputCancel,
                    pending: isMutationPending,
                    suffix: " min."
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                    numeric: true,
                    propertyName: "avs",
                    initialVal: segment.length && segment.default_travel_time ? segment.length / ((0, $57ee609582c542b6$export$acbf344db7f7262e)(segment.default_travel_time) / 3600) : null,
                    label: "\u015Arednia pr\u0119dk.",
                    id: id,
                    value: modifiedValues.length && modifiedValues.default_travel_time ? modifiedValues.length / ((0, $57ee609582c542b6$export$acbf344db7f7262e)(modifiedValues.default_travel_time) / 3600) : null,
                    onChange: (propertyName, value)=>{
                        let timeH = modifiedValues.length / value;
                        let timeS = timeH * 3600;
                        if (value) setModifiedValues({
                            ...modifiedValues,
                            default_travel_time: (0, $57ee609582c542b6$export$810cbdbd69486b75)(timeS)
                        });
                    },
                    onDone: ()=>{
                        handleInputDone('default_travel_time', modifiedValues.default_travel_time);
                    },
                    onCancel: handleInputCancel,
                    pending: isMutationPending,
                    suffix: " km/h"
                })
            })
        ]
    });
}


function $f41078fe3814b564$export$1ba59dacbcbf90fe() {
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    let panel = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    switch(tool.name){
        case 'stopsTool':
            panel = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ce9c809e1b9b543$export$6c8a70fd93e9f663), {});
            break;
        case 'segmentsTool':
            panel = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74d1bb7d1ffe923a$export$cfdc085ffca97c47), {});
            break;
        case 'routesTool':
            panel = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc298fb1b60eb998$export$3565eb3d00ca5a74), {});
            break;
        case 'calendarsTool':
            panel = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6708c38e45e15ddb$export$904d39b6b448e4e5), {});
            break;
        case 'tripsTool':
            panel = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd559f73ce48bb94$export$9f977905c4004548), {});
            break;
        default:
            panel = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: "Wybierz narz\u0119dzie na g\xf3rze..."
            });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                width: '100%',
                height: '85vh'
            },
            children: panel
        })
    });
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");




'use client';
var $bda916b241ac3048$var$ToolbarBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'Toolbar',
        id: null,
        style: null,
        className: null,
        left: null,
        right: null,
        start: null,
        center: null,
        end: null,
        children: undefined
    },
    css: {
        classes: {
            root: 'p-toolbar p-component',
            start: 'p-toolbar-group-start p-toolbar-group-left',
            center: 'p-toolbar-group-center',
            end: 'p-toolbar-group-end p-toolbar-group-right'
        },
        styles: "\n        @layer primereact {\n            .p-toolbar {\n                display: flex;\n                align-items: center;\n                justify-content: space-between;\n                flex-wrap: wrap;\n            }\n            \n            .p-toolbar-group-start,\n            .p-toolbar-group-center,\n            .p-toolbar-group-end {\n                display: flex;\n                align-items: center;\n            }\n            \n            .p-toolbar-group-left,\n            .p-toolbar-group-right {\n                display: flex;\n                align-items: center;\n            }\n        }\n        "
    }
});
var $bda916b241ac3048$export$4c260019440d418f = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $bda916b241ac3048$var$ToolbarBase.getProps(inProps, context);
    var elementRef = $acw62.useRef(null);
    var start = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.left || props.start, props);
    var center = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.center, props);
    var end = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.right || props.end, props);
    var _ToolbarBase$setMetaD = $bda916b241ac3048$var$ToolbarBase.setMetaData({
        props: props
    }), ptm = _ToolbarBase$setMetaD.ptm, cx = _ToolbarBase$setMetaD.cx, isUnstyled = _ToolbarBase$setMetaD.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($bda916b241ac3048$var$ToolbarBase.css.styles, isUnstyled, {
        name: 'toolbar'
    });
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var startProps = mergeProps({
        className: cx('start')
    }, ptm('start'));
    var centerProps = mergeProps({
        className: cx('center')
    }, ptm('center'));
    var endProps = mergeProps({
        className: cx('end')
    }, ptm('end'));
    var rootProps = mergeProps({
        id: props.id,
        ref: elementRef,
        style: props.style,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root')),
        role: 'toolbar'
    }, $bda916b241ac3048$var$ToolbarBase.getOtherProps(props), ptm('root'));
    return /*#__PURE__*/ $acw62.createElement("div", rootProps, /*#__PURE__*/ $acw62.createElement("div", startProps, start), /*#__PURE__*/ $acw62.createElement("div", centerProps, center), /*#__PURE__*/ $acw62.createElement("div", endProps, end));
}));
$bda916b241ac3048$export$4c260019440d418f.displayName = 'Toolbar';






var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");









'use client';
function $28146166e5d308f6$var$_extends() {
    return $28146166e5d308f6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $28146166e5d308f6$var$_extends.apply(null, arguments);
}
function $28146166e5d308f6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $28146166e5d308f6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $28146166e5d308f6$var$_typeof(o);
}
function $28146166e5d308f6$var$toPrimitive(t, r) {
    if ("object" != $28146166e5d308f6$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $28146166e5d308f6$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $28146166e5d308f6$var$toPropertyKey(t) {
    var i = $28146166e5d308f6$var$toPrimitive(t, "string");
    return "symbol" == $28146166e5d308f6$var$_typeof(i) ? i : i + "";
}
function $28146166e5d308f6$var$_defineProperty(e, r, t) {
    return (r = $28146166e5d308f6$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $28146166e5d308f6$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $28146166e5d308f6$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $28146166e5d308f6$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $28146166e5d308f6$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $28146166e5d308f6$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $28146166e5d308f6$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $28146166e5d308f6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $28146166e5d308f6$var$_slicedToArray(r, e) {
    return $28146166e5d308f6$var$_arrayWithHoles(r) || $28146166e5d308f6$var$_iterableToArrayLimit(r, e) || $28146166e5d308f6$var$_unsupportedIterableToArray(r, e) || $28146166e5d308f6$var$_nonIterableRest();
}
var $28146166e5d308f6$var$classes = {
    root: function root(_ref) {
        _ref.props;
        var context = _ref.context;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-overlaypanel p-component', {
            'p-input-filled': context && context.inputStyle === 'filled' || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).inputStyle === 'filled',
            'p-ripple-disabled': context && context.ripple === false || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).ripple === false
        });
    },
    closeIcon: 'p-overlaypanel-close-icon',
    closeButton: 'p-overlaypanel-close p-link',
    content: 'p-overlaypanel-content',
    transition: 'p-overlaypanel'
};
var $28146166e5d308f6$var$styles = "\n@layer primereact {\n    .p-overlaypanel {\n        position: absolute;\n        margin-top: 10px;\n        /* Github #3122: Prevent animation flickering  */\n        top: -9999px;\n        left: -9999px;\n    }\n    \n    .p-overlaypanel-flipped {\n        margin-top: -10px;\n        margin-bottom: 10px;\n    }\n    \n    .p-overlaypanel-close {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        overflow: hidden;\n        position: relative;\n    }\n    \n    /* Animation */\n    .p-overlaypanel-enter {\n        opacity: 0;\n        transform: scaleY(0.8);\n    }\n    \n    .p-overlaypanel-enter-active {\n        opacity: 1;\n        transform: scaleY(1);\n        transition: transform .12s cubic-bezier(0, 0, 0.2, 1), opacity .12s cubic-bezier(0, 0, 0.2, 1);\n    }\n    \n    .p-overlaypanel-enter-done {\n        transform: none;\n    }\n    \n    .p-overlaypanel-exit {\n        opacity: 1;\n    }\n    \n    .p-overlaypanel-exit-active {\n        opacity: 0;\n        transition: opacity .1s linear;\n    }\n    \n    .p-overlaypanel:after, .p-overlaypanel:before {\n        bottom: 100%;\n        left: calc(var(--overlayArrowLeft, 0) + 1.25rem);\n        content: \" \";\n        height: 0;\n        width: 0;\n        position: absolute;\n        pointer-events: none;\n    }\n    \n    .p-overlaypanel:after {\n        border-width: 8px;\n        margin-left: -8px;\n    }\n    \n    .p-overlaypanel:before {\n        border-width: 10px;\n        margin-left: -10px;\n    }\n    \n    .p-overlaypanel-flipped:after, .p-overlaypanel-flipped:before {\n        bottom: auto;\n        top: 100%;\n    }\n    \n    .p-overlaypanel.p-overlaypanel-flipped:after {\n        border-bottom-color: transparent;\n    }\n    \n    .p-overlaypanel.p-overlaypanel-flipped:before {\n        border-bottom-color: transparent\n    }\n}\n";
var $28146166e5d308f6$var$OverlayPanelBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'OverlayPanel',
        id: null,
        dismissable: true,
        showCloseIcon: false,
        closeIcon: null,
        style: null,
        className: null,
        appendTo: null,
        breakpoints: null,
        ariaCloseLabel: null,
        transitionOptions: null,
        onShow: null,
        onHide: null,
        children: undefined,
        closeOnEscape: true
    },
    css: {
        classes: $28146166e5d308f6$var$classes,
        styles: $28146166e5d308f6$var$styles
    }
});
function $28146166e5d308f6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $28146166e5d308f6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $28146166e5d308f6$var$ownKeys(Object(t), !0).forEach(function(r) {
            $28146166e5d308f6$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $28146166e5d308f6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $28146166e5d308f6$export$500eae29f537c78b = /*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $28146166e5d308f6$var$OverlayPanelBase.getProps(inProps, context);
    var _React$useState = $acw62.useState(false), _React$useState2 = $28146166e5d308f6$var$_slicedToArray(_React$useState, 2), visibleState = _React$useState2[0], setVisibleState = _React$useState2[1];
    var _OverlayPanelBase$set = $28146166e5d308f6$var$OverlayPanelBase.setMetaData({
        props: props,
        state: {
            visible: visibleState
        }
    }), ptm = _OverlayPanelBase$set.ptm, cx = _OverlayPanelBase$set.cx;
    _OverlayPanelBase$set.sx;
    var isUnstyled = _OverlayPanelBase$set.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($28146166e5d308f6$var$OverlayPanelBase.css.styles, isUnstyled, {
        name: 'overlaypanel'
    });
    var attributeSelector = $acw62.useRef('');
    var overlayRef = $acw62.useRef(null);
    var currentTargetRef = $acw62.useRef(null);
    var isPanelClicked = $acw62.useRef(false);
    var styleElement = $acw62.useRef(null);
    var overlayEventListener = $acw62.useRef(null);
    var _useOverlayListener = (0, $fbdf1e36fa0a01d8$export$2fef17345d27a5b4)({
        target: currentTargetRef,
        overlay: overlayRef,
        listener: function listener(event, _ref) {
            var type = _ref.type, valid = _ref.valid;
            if (valid) switch(type){
                case 'outside':
                    props.dismissable && !isPanelClicked.current && hide();
                    break;
                case 'resize':
                case 'scroll':
                case 'orientationchange':
                    align();
                    break;
            }
            isPanelClicked.current = false;
        },
        when: visibleState
    }), _useOverlayListener2 = $28146166e5d308f6$var$_slicedToArray(_useOverlayListener, 2), bindOverlayListener = _useOverlayListener2[0], unbindOverlayListener = _useOverlayListener2[1];
    var isCloseOnEscape = visibleState && props.closeOnEscape;
    var overlayPanelDisplayOrder = (0, $fbdf1e36fa0a01d8$export$6353a33119af9098)('overlay-panel', isCloseOnEscape);
    (0, $fbdf1e36fa0a01d8$export$dee4359f392495ae)({
        callback: function callback() {
            hide();
        },
        when: isCloseOnEscape && overlayPanelDisplayOrder,
        priority: [
            (0, $fbdf1e36fa0a01d8$export$5153c70e1a2d4b71).OVERLAY_PANEL,
            overlayPanelDisplayOrder
        ]
    });
    var isOutsideClicked = function isOutsideClicked(target) {
        return overlayRef && overlayRef.current && !(overlayRef.current.isSameNode(target) || overlayRef.current.contains(target));
    };
    var hasTargetChanged = function hasTargetChanged(event, target) {
        return currentTargetRef.current != null && currentTargetRef.current !== (target || event.currentTarget || event.target);
    };
    var onCloseClick = function onCloseClick(event) {
        hide();
        event.preventDefault();
    };
    var onPanelClick = function onPanelClick(event) {
        isPanelClicked.current = true;
        (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).emit('overlay-click', {
            originalEvent: event,
            target: currentTargetRef.current
        });
    };
    var onContentClick = function onContentClick() {
        isPanelClicked.current = true;
    };
    var toggle = function toggle(event, target) {
        if (visibleState) {
            hide();
            if (hasTargetChanged(event, target)) {
                currentTargetRef.current = target || event.currentTarget || event.target;
                setTimeout(function() {
                    show(event, currentTargetRef.current);
                }, 200);
            }
        } else show(event, target);
    };
    var show = function show(event, target) {
        currentTargetRef.current = target || event.currentTarget || event.target;
        if (visibleState) align();
        else {
            setVisibleState(true);
            overlayEventListener.current = function(e) {
                !isOutsideClicked(e.target) && (isPanelClicked.current = true);
            };
            (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).on('overlay-click', overlayEventListener.current);
        }
    };
    var hide = function hide() {
        setVisibleState(false);
        (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).off('overlay-click', overlayEventListener.current);
        overlayEventListener.current = null;
    };
    var onEnter = function onEnter() {
        overlayRef.current.setAttribute(attributeSelector.current, '');
        (0, $a73ce425265b079e$export$832931caede8e4b9).set('overlay', overlayRef.current, context && context.autoZIndex || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).autoZIndex, context && context.zIndex.overlay || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).zIndex.overlay);
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).addStyles(overlayRef.current, {
            position: 'absolute',
            top: '0',
            left: '0'
        });
        align();
    };
    var onEntered = function onEntered() {
        bindOverlayListener();
        props.onShow && props.onShow();
    };
    var onExit = function onExit() {
        unbindOverlayListener();
    };
    var onExited = function onExited() {
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(overlayRef.current);
        props.onHide && props.onHide();
    };
    var align = function align() {
        if (currentTargetRef.current && overlayRef.current) {
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).absolutePosition(overlayRef.current, currentTargetRef.current);
            var containerOffset = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOffset(overlayRef.current);
            var targetOffset = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOffset(currentTargetRef.current);
            var arrowLeft = 0;
            if (containerOffset.left < targetOffset.left) arrowLeft = targetOffset.left - containerOffset.left;
            overlayRef.current.style.setProperty('--overlayArrowLeft', "".concat(arrowLeft, "px"));
            if (containerOffset.top < targetOffset.top) {
                overlayRef.current.setAttribute('data-p-overlaypanel-flipped', 'true');
                isUnstyled && (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(overlayRef.current, 'p-overlaypanel-flipped');
            } else {
                overlayRef.current.setAttribute('data-p-overlaypanel-flipped', 'false');
                isUnstyled && (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(overlayRef.current, 'p-overlaypanel-flipped');
            }
        }
    };
    var createStyle = function createStyle() {
        if (!styleElement.current) {
            styleElement.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).createInlineStyle(context && context.nonce || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).nonce, context && context.styleContainer);
            var innerHTML = '';
            for(var breakpoint in props.breakpoints)innerHTML = innerHTML + "\n                    @media screen and (max-width: ".concat(breakpoint, ") {\n                        .p-overlaypanel[").concat(attributeSelector.current, "] {\n                            width: ").concat(props.breakpoints[breakpoint], ";\n                        }\n                    }\n                ");
            styleElement.current.innerHTML = innerHTML;
        }
    };
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        attributeSelector.current = (0, $a73ce425265b079e$export$d5d9b89141473caf)();
        if (props.breakpoints) createStyle();
    });
    (0, $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96)(function() {
        styleElement.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeInlineStyle(styleElement.current);
        if (overlayEventListener.current) {
            (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).off('overlay-click', overlayEventListener.current);
            overlayEventListener.current = null;
        }
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(overlayRef.current);
    });
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            toggle: toggle,
            show: show,
            hide: hide,
            align: align,
            isVisible: function isVisible() {
                return visibleState;
            },
            getElement: function getElement() {
                return overlayRef.current;
            }
        };
    });
    var createCloseIcon = function createCloseIcon() {
        var closeIconProps = mergeProps({
            className: cx('closeIcon'),
            'aria-hidden': true
        }, ptm('closeIcon'));
        var icon = props.closeIcon || /*#__PURE__*/ $acw62.createElement((0, $2a5691e8eb30be5a$export$32edebbf2d9136cc), closeIconProps);
        var closeIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $28146166e5d308f6$var$_objectSpread({}, closeIconProps), {
            props: props
        });
        var ariaLabel = props.ariaCloseLabel || (0, $51b25b42ecc1a0c7$export$aa1e8754cc4d1e7a)('close');
        var closeButtonProps = mergeProps({
            type: 'button',
            className: cx('closeButton'),
            onClick: function onClick(e) {
                return onCloseClick(e);
            },
            'aria-label': ariaLabel
        }, ptm('closeButton'));
        if (props.showCloseIcon) return /*#__PURE__*/ $acw62.createElement("button", closeButtonProps, closeIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
        return null;
    };
    var createElement = function createElement() {
        var closeIcon = createCloseIcon();
        var rootProps = mergeProps({
            id: props.id,
            className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root', {
                context: context
            })),
            style: props.style,
            onClick: function onClick(e) {
                return onPanelClick(e);
            }
        }, $28146166e5d308f6$var$OverlayPanelBase.getOtherProps(props), ptm('root'));
        var contentProps = mergeProps({
            className: cx('content'),
            onClick: function onClick(e) {
                return onContentClick();
            },
            onMouseDown: onContentClick
        }, $28146166e5d308f6$var$OverlayPanelBase.getOtherProps(props), ptm('content'));
        var transitionProps = mergeProps({
            classNames: cx('transition'),
            "in": visibleState,
            timeout: {
                enter: 120,
                exit: 100
            },
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: onEnter,
            onEntered: onEntered,
            onExit: onExit,
            onExited: onExited
        }, ptm('transition'));
        return /*#__PURE__*/ $acw62.createElement((0, $17afce1b96f6eaec$export$a7a5590ad6d7af0), $28146166e5d308f6$var$_extends({
            nodeRef: overlayRef
        }, transitionProps), /*#__PURE__*/ $acw62.createElement("div", $28146166e5d308f6$var$_extends({
            ref: overlayRef
        }, rootProps), /*#__PURE__*/ $acw62.createElement("div", contentProps, props.children), closeIcon));
    };
    var element = createElement();
    return /*#__PURE__*/ $acw62.createElement((0, $e7a3b5428092a192$export$602eac185826482c), {
        element: element,
        appendTo: props.appendTo
    });
});
$28146166e5d308f6$export$500eae29f537c78b.displayName = 'OverlayPanel';






var $acw62 = parcelRequire("acw62");




'use client';
function $2b4b4f758c46a789$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2b4b4f758c46a789$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2b4b4f758c46a789$var$_typeof(o);
}
function $2b4b4f758c46a789$var$toPrimitive(t, r) {
    if ("object" != $2b4b4f758c46a789$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2b4b4f758c46a789$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2b4b4f758c46a789$var$toPropertyKey(t) {
    var i = $2b4b4f758c46a789$var$toPrimitive(t, "string");
    return "symbol" == $2b4b4f758c46a789$var$_typeof(i) ? i : i + "";
}
function $2b4b4f758c46a789$var$_defineProperty(e, r, t) {
    return (r = $2b4b4f758c46a789$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $2b4b4f758c46a789$var$classes = {
    value: 'p-tag-value',
    icon: 'p-tag-icon',
    root: function root(_ref) {
        var props = _ref.props;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-tag p-component', $2b4b4f758c46a789$var$_defineProperty($2b4b4f758c46a789$var$_defineProperty({}, "p-tag-".concat(props.severity), props.severity !== null), 'p-tag-rounded', props.rounded));
    }
};
var $2b4b4f758c46a789$var$styles = "\n@layer primereact {\n    .p-tag {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n    }\n    \n    .p-tag-icon,\n    .p-tag-value,\n    .p-tag-icon.pi {\n        line-height: 1.5;\n    }\n    \n    .p-tag.p-tag-rounded {\n        border-radius: 10rem;\n    }\n}\n";
var $2b4b4f758c46a789$var$TagBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'Tag',
        value: null,
        severity: null,
        rounded: false,
        icon: null,
        style: null,
        className: null,
        children: undefined
    },
    css: {
        classes: $2b4b4f758c46a789$var$classes,
        styles: $2b4b4f758c46a789$var$styles
    }
});
function $2b4b4f758c46a789$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2b4b4f758c46a789$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2b4b4f758c46a789$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2b4b4f758c46a789$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2b4b4f758c46a789$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2b4b4f758c46a789$export$3288d34c523a1192 = /*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $2b4b4f758c46a789$var$TagBase.getProps(inProps, context);
    var _TagBase$setMetaData = $2b4b4f758c46a789$var$TagBase.setMetaData({
        props: props
    }), ptm = _TagBase$setMetaData.ptm, cx = _TagBase$setMetaData.cx, isUnstyled = _TagBase$setMetaData.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($2b4b4f758c46a789$var$TagBase.css.styles, isUnstyled, {
        name: 'tag'
    });
    var elementRef = $acw62.useRef(null);
    var iconProps = mergeProps({
        className: cx('icon')
    }, ptm('icon'));
    var icon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(props.icon, $2b4b4f758c46a789$var$_objectSpread({}, iconProps), {
        props: props
    });
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var rootProps = mergeProps({
        ref: elementRef,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root')),
        style: props.style
    }, $2b4b4f758c46a789$var$TagBase.getOtherProps(props), ptm('root'));
    var valueProps = mergeProps({
        className: cx('value')
    }, ptm('value'));
    return /*#__PURE__*/ $acw62.createElement("span", rootProps, icon, /*#__PURE__*/ $acw62.createElement("span", valueProps, props.value), /*#__PURE__*/ $acw62.createElement("span", null, props.children));
});
$2b4b4f758c46a789$export$3288d34c523a1192.displayName = 'Tag';





function $3aa8b1408404ece6$export$2e2bcd8739ae039() {
    const { isPending: isPending, error: error, data: data } = (0, $4529664c1ee19d35$export$b48399ba0dc32743)();
    const currentSnapshot = (0, $acw62.useContext)((0, $7d6297100045faa6$export$83327a4f6aff409e));
    const dispatch = (0, $acw62.useContext)((0, $7d6297100045faa6$export$3c15e91bc2bcd54b));
    const op = (0, $acw62.useRef)(null);
    const toast = (0, $acw62.useRef)(null);
    const snapSelect = (e)=>{
        op.current.hide();
        toast.current.show({
            severity: 'info',
            summary: "Wybrano baz\u0119 danych",
            detail: e.data.snap_name,
            life: 3000
        });
    };
    const statusBodyTemplate = (snap)=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b4b4f758c46a789$export$3288d34c523a1192), {
            value: getStatusName(snap),
            severity: getSeverity(snap)
        });
    };
    const getSeverity = (snap)=>{
        switch(snap.snap_status){
            case 0:
                return 'success';
            case 1:
                return 'danger';
            case 2:
                return 'info';
            default:
                return null;
        }
    };
    const getStatusName = (snap)=>{
        switch(snap.snap_status){
            case 0:
                return 'projektowana';
            case 1:
                return 'aktualna';
            case 2:
                return 'archiwalna';
            default:
                return null;
        }
    };
    if (isPending) return;
    if (error) return;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "card flex flex-column align-items-center gap-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe304f6df74368ab$export$8d8dc7d5f743331b), {
                ref: toast,
                position: "top-center"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                size: "small",
                type: "button",
                icon: "fa-solid fa-database",
                label: currentSnapshot.snap_name,
                severity: getSeverity(currentSnapshot),
                onClick: (e)=>op.current.toggle(e)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $28146166e5d308f6$export$500eae29f537c78b), {
                ref: op,
                showCloseIcon: true,
                closeOnEscape: true,
                dismissable: false,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $68eba9483912474c$export$df30df7ec97b32b5), {
                    value: data,
                    selectionMode: "single",
                    paginator: true,
                    rows: 5,
                    selection: currentSnapshot,
                    onSelectionChange: (e)=>{
                        e.value && dispatch({
                            type: "changed",
                            selectedSnapshot: e.value
                        });
                    },
                    onRowClick: snapSelect,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8e4d38781145a41$export$816b5d811295e6bc), {
                            field: "snap_prefix",
                            header: "ID",
                            sortable: true,
                            style: {
                                minWidth: '5rem'
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8e4d38781145a41$export$816b5d811295e6bc), {
                            field: "snap_name",
                            header: "Name",
                            sortable: true,
                            style: {
                                minWidth: '12rem'
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8e4d38781145a41$export$816b5d811295e6bc), {
                            field: "snap_description",
                            header: "Opis",
                            sortable: true,
                            style: {
                                minWidth: '12rem'
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8e4d38781145a41$export$816b5d811295e6bc), {
                            field: "snap_status",
                            header: "Status",
                            sortable: true,
                            style: {
                                minWidth: '4rem'
                            },
                            body: statusBodyTemplate
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8e4d38781145a41$export$816b5d811295e6bc), {
                            field: "snap_creation_date",
                            header: "Utworzona",
                            sortable: true,
                            style: {
                                minWidth: '12rem'
                            }
                        })
                    ]
                })
            })
        ]
    });
}





var $acw62 = parcelRequire("acw62");



function $25371e0037f808e3$export$cd6ac6b243da4143({ propertyName: propertyName, initialVal: initialVal, label: label, id: id, onDone: onDone, showClear: showClear, optionLabel: optionLabel = 'name' }) {
    const [selectedOption, setSelectedOption] = (0, $acw62.useState)(initialVal);
    const { data: data, isPending: isPending, error: error } = (0, $4529664c1ee19d35$export$c3a687f3d6e3fb65)('routes');
    if (isPending || error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "..."
    });
    const options = data ? Object.values(data) : [];
    const routeOptionTemplate = (option)=>{
        const item = option;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex align-items-center",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a665a3ac8a12ef4$export$f0b439f829a094d), {
                    GRoute: item
                }),
                item.route_short_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2cd10a5f6773a01$export$bfbea4d618559e4a), {
                    GRoute: item
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "text-sm",
                    children: [
                        item.route_short_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                            children: item.route_long_name
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                            className: "hover:text-orange-700",
                            style: {
                                display: "inline-block",
                                fontWeight: "normal",
                                backgroundColor: '#' + item.route_color,
                                color: '#' + item.route_text_color,
                                borderStyle: 'solid',
                                borderWidth: '0.5pt',
                                padding: '2px',
                                borderColor: '#' + item.route_text_color
                            },
                            children: item.route_long_name
                        }),
                        item.suspended ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-red-200",
                            children: " zawieszona "
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-200",
                            children: item.network_id
                        })
                    ]
                })
            ]
        });
    };
    const routeSelectedTemplate = (option, props)=>{
        if (option) {
            const item = option;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex align-items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a665a3ac8a12ef4$export$f0b439f829a094d), {
                        GRoute: item
                    }),
                    item.route_short_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2cd10a5f6773a01$export$bfbea4d618559e4a), {
                        GRoute: item
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-sm",
                        children: [
                            item.route_short_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                children: item.route_long_name
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                className: "hover:text-orange-700",
                                style: {
                                    display: "inline-block",
                                    fontWeight: "normal",
                                    backgroundColor: '#' + item.route_color,
                                    color: '#' + item.route_text_color,
                                    borderStyle: 'solid',
                                    borderWidth: '0.5pt',
                                    padding: '2px',
                                    borderColor: '#' + item.route_text_color
                                },
                                children: item.route_long_name
                            }),
                            item.suspended ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-red-200",
                                children: " zawieszona "
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-200",
                                children: item.network_id
                            })
                        ]
                    })
                ]
            });
        } else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            children: props.placeholder
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad3650ac53d907a7$export$931cbfb6bfb85fc), {
            value: selectedOption,
            inputId: id + '-' + propertyName,
            onChange: (e)=>{
                setSelectedOption(e.value);
                onDone(e.value);
            },
            options: options,
            placeholder: "(prosz\u0119 wybra\u0107)",
            className: "w-full",
            itemTemplate: routeOptionTemplate,
            valueTemplate: routeSelectedTemplate,
            showClear: showClear,
            filter: true,
            filterBy: "route_id,route_short_name,route_long_name",
            filterInputAutoFocus: true,
            optionLabel: optionLabel,
            optionValue: "route_id",
            style: {
                maxWidth: '437.25px'
            }
        })
    });
}


function $e094d53bc8e9d6c2$export$f7e5e5a2fbd99270() {
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const toolDispatch = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$6bbcf3368996eea5));
    const startContent = [];
    for (const [key, val] of Object.entries((0, $91fa2a3eb54dc801$export$88ae2e76299eaa00).tools))startContent.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e094d53bc8e9d6c2$var$ToolButton, {
        icon: val.icon,
        tool: val,
        selected: tool.name === key
    }, key));
    let centerContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    if (tool.name === 'timetablesTool') centerContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25371e0037f808e3$export$cd6ac6b243da4143), {
        onDone: (value)=>{
            toolDispatch({
                type: 'changed',
                newTool: {
                    ...tool,
                    selection: value
                }
            });
        }
    });
    /*
    const centerContent = (
        <IconField iconPosition="left">
            <InputIcon className="pi pi-search" />
            <InputText placeholder="Search" />
        </IconField>
    );
     */ const endContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3aa8b1408404ece6$export$2e2bcd8739ae039), {})
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "mb-2",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bda916b241ac3048$export$4c260019440d418f), {
            start: startContent,
            center: centerContent,
            end: endContent,
            className: "p-3"
        })
    });
}
function $e094d53bc8e9d6c2$var$ToolButton({ tool: tool, icon: icon, selected: selected }) {
    const dispatch = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$6bbcf3368996eea5));
    let className = "mr-2";
    let style = {
    };
    if (selected) style = {
        ...style,
        backgroundColor: 'var(--yellow-500)',
        color: 'black'
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
        text: true,
        icon: icon,
        className: className,
        style: style,
        tooltip: tool.description,
        tooltipOptions: {
            position: 'bottom'
        },
        onClick: ()=>{
            dispatch({
                type: 'changed',
                newTool: {
                    ...tool
                }
            });
        }
    });
}










var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $cbd94c399cef41ea$export$b8efcc4bff45e15b = 1;
function $cbd94c399cef41ea$export$fb237fa819e17281(map) {
    return Object.freeze({
        __version: $cbd94c399cef41ea$export$b8efcc4bff45e15b,
        map: map
    });
}
function $cbd94c399cef41ea$export$9efaf186a2224858(source, extra) {
    return Object.freeze({
        ...source,
        ...extra
    });
}
const $cbd94c399cef41ea$export$7de1b54b0142048f = (0, $acw62.createContext)(null);
function $cbd94c399cef41ea$export$ea59151b8430a4e9() {
    const context = (0, $acw62.use)($cbd94c399cef41ea$export$7de1b54b0142048f);
    if (context == null) throw new Error('No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>');
    return context;
}




var $acw62 = parcelRequire("acw62");
function $ee011fc978fcb926$var$MapContainerComponent({ bounds: bounds, boundsOptions: boundsOptions, center: center, children: children, className: className, id: id, placeholder: placeholder, style: style, whenReady: whenReady, zoom: zoom, ...options }, forwardedRef) {
    const [props] = (0, $acw62.useState)({
        className: className,
        id: id,
        style: style
    });
    const [context, setContext] = (0, $acw62.useState)(null);
    const mapInstanceRef = (0, $acw62.useRef)(undefined);
    (0, $acw62.useImperativeHandle)(forwardedRef, ()=>context?.map ?? null, [
        context
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: ref callback
    const mapRef = (0, $acw62.useCallback)((node)=>{
        if (node !== null && !mapInstanceRef.current) {
            const map = new (0, $65d191346d2f0e85$exports.Map)(node, options);
            mapInstanceRef.current = map;
            if (center != null && zoom != null) map.setView(center, zoom);
            else if (bounds != null) map.fitBounds(bounds, boundsOptions);
            if (whenReady != null) map.whenReady(whenReady);
            setContext((0, $cbd94c399cef41ea$export$fb237fa819e17281)(map));
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            context?.map.remove();
        };
    }, [
        context
    ]);
    const contents = context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cbd94c399cef41ea$export$7de1b54b0142048f), {
        value: context
    }, children) : placeholder ?? null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...props,
        ref: mapRef
    }, contents);
}
const $ee011fc978fcb926$export$23f3dfd47374502b = /*#__PURE__*/ (0, $acw62.forwardRef)($ee011fc978fcb926$var$MapContainerComponent);


var $acw62 = parcelRequire("acw62");
function $c4349977e33cccc7$export$a080ff44e8067a44(instance, context, container) {
    return Object.freeze({
        instance: instance,
        context: context,
        container: container
    });
}
function $c4349977e33cccc7$export$2e66ec8a7fb1892f(createElement, updateElement) {
    if (updateElement == null) return function useImmutableLeafletElement(props, context) {
        const elementRef = (0, $acw62.useRef)(undefined);
        if (!elementRef.current) elementRef.current = createElement(props, context);
        return elementRef;
    };
    return function useMutableLeafletElement(props, context) {
        const elementRef = (0, $acw62.useRef)(undefined);
        if (!elementRef.current) elementRef.current = createElement(props, context);
        const propsRef = (0, $acw62.useRef)(props);
        const { instance: instance } = elementRef.current;
        (0, $acw62.useEffect)(function updateElementProps() {
            if (propsRef.current !== props) {
                updateElement(instance, props, propsRef.current);
                propsRef.current = props;
            }
        }, [
            instance,
            props,
            updateElement
        ]);
        return elementRef;
    };
}


var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

function $b5b5154e09abe911$export$96eac748c3f41e82(useElement) {
    function ContainerComponent(props, forwardedRef) {
        const { instance: instance, context: context } = useElement(props).current;
        (0, $acw62.useImperativeHandle)(forwardedRef, ()=>instance);
        const { children: children } = props;
        return children == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cbd94c399cef41ea$export$7de1b54b0142048f), {
            value: context
        }, children);
    }
    return /*#__PURE__*/ (0, $acw62.forwardRef)(ContainerComponent);
}
function $b5b5154e09abe911$export$bc37ddc24ed05446(useElement) {
    function OverlayComponent(props, forwardedRef) {
        const [isOpen, setOpen] = (0, $acw62.useState)(false);
        const { instance: instance } = useElement(props, setOpen).current;
        (0, $acw62.useImperativeHandle)(forwardedRef, ()=>instance);
        // biome-ignore lint/correctness/useExhaustiveDependencies: update overlay when children change
        (0, $acw62.useEffect)(function updateOverlay() {
            if (isOpen) instance.update();
        }, [
            instance,
            isOpen,
            props.children
        ]);
        // @ts-ignore _contentNode missing in type definition
        const contentNode = instance._contentNode;
        return contentNode ? /*#__PURE__*/ (0, $1u0KT.createPortal)(props.children, contentNode) : null;
    }
    return /*#__PURE__*/ (0, $acw62.forwardRef)(OverlayComponent);
}
function $b5b5154e09abe911$export$18af5c7a9e9b3664(useElement) {
    function LeafComponent(props, forwardedRef) {
        const { instance: instance } = useElement(props).current;
        (0, $acw62.useImperativeHandle)(forwardedRef, ()=>instance);
        return null;
    }
    return /*#__PURE__*/ (0, $acw62.forwardRef)(LeafComponent);
}



var $acw62 = parcelRequire("acw62");

function $1b63afa14c569d34$export$28d24ab3914549cd(useElement) {
    return function useLeafletControl(props) {
        const context = (0, $cbd94c399cef41ea$export$ea59151b8430a4e9)();
        const elementRef = useElement(props, context);
        const { instance: instance } = elementRef.current;
        const positionRef = (0, $acw62.useRef)(props.position);
        const { position: position } = props;
        (0, $acw62.useEffect)(function addControl() {
            instance.addTo(context.map);
            return function removeControl() {
                instance.remove();
            };
        }, [
            context.map,
            instance
        ]);
        (0, $acw62.useEffect)(function updateControl() {
            if (position != null && position !== positionRef.current) {
                instance.setPosition(position);
                positionRef.current = position;
            }
        }, [
            instance,
            position
        ]);
        return elementRef;
    };
}



var $acw62 = parcelRequire("acw62");
function $3ab6965f3c0b8e48$export$46b870813daca3d4(map, attribution) {
    const attributionRef = (0, $acw62.useRef)(attribution);
    (0, $acw62.useEffect)(function updateAttribution() {
        if (attribution !== attributionRef.current && map.attributionControl != null) {
            if (attributionRef.current != null) map.attributionControl.removeAttribution(attributionRef.current);
            if (attribution != null) map.attributionControl.addAttribution(attribution);
        }
        attributionRef.current = attribution;
    }, [
        map,
        attribution
    ]);
}




var $acw62 = parcelRequire("acw62");
function $7099e9dbf72f5596$export$8ce912bc34d0dbea(element, eventHandlers) {
    const eventHandlersRef = (0, $acw62.useRef)(undefined);
    (0, $acw62.useEffect)(function addEventHandlers() {
        if (eventHandlers != null) element.instance.on(eventHandlers);
        eventHandlersRef.current = eventHandlers;
        return function removeEventHandlers() {
            if (eventHandlersRef.current != null) element.instance.off(eventHandlersRef.current);
            eventHandlersRef.current = null;
        };
    }, [
        element,
        eventHandlers
    ]);
}


function $32d90284a15401c8$export$6ee5d263358f5c0e(props, context) {
    const pane = props.pane ?? context.pane;
    return pane ? {
        ...props,
        pane: pane
    } : props;
}


function $36464a5b4c62d1dd$export$d5eca53b0accc0e0(useElement, useLifecycle) {
    return function useDivOverlay(props, setOpen) {
        const context = (0, $cbd94c399cef41ea$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $32d90284a15401c8$export$6ee5d263358f5c0e)(props, context), context);
        (0, $3ab6965f3c0b8e48$export$46b870813daca3d4)(context.map, props.attribution);
        (0, $7099e9dbf72f5596$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        useLifecycle(elementRef.current, context, props, setOpen);
        return elementRef;
    };
}




var $acw62 = parcelRequire("acw62");




function $79b51af07cb34fe6$export$cd00a227f8cfb2c2(element, context) {
    (0, $acw62.useEffect)(function addLayer() {
        const container = context.layerContainer ?? context.map;
        container.addLayer(element.instance);
        return function removeLayer() {
            context.layerContainer?.removeLayer(element.instance);
            context.map.removeLayer(element.instance);
        };
    }, [
        context,
        element
    ]);
}
function $79b51af07cb34fe6$export$73f852c6a5abdefa(useElement) {
    return function useLayer(props) {
        const context = (0, $cbd94c399cef41ea$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $32d90284a15401c8$export$6ee5d263358f5c0e)(props, context), context);
        (0, $3ab6965f3c0b8e48$export$46b870813daca3d4)(context.map, props.attribution);
        (0, $7099e9dbf72f5596$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        $79b51af07cb34fe6$export$cd00a227f8cfb2c2(elementRef.current, context);
        return elementRef;
    };
}



var $acw62 = parcelRequire("acw62");




function $25da1ed181e98b0a$export$d0296329a1f118ca(element, props) {
    const optionsRef = (0, $acw62.useRef)(undefined);
    (0, $acw62.useEffect)(function updatePathOptions() {
        if (props.pathOptions !== optionsRef.current) {
            const options = props.pathOptions ?? {};
            element.instance.setStyle(options);
            optionsRef.current = options;
        }
    }, [
        element,
        props
    ]);
}
function $25da1ed181e98b0a$export$5fea2fe6048fc3db(useElement) {
    return function usePath(props) {
        const context = (0, $cbd94c399cef41ea$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $32d90284a15401c8$export$6ee5d263358f5c0e)(props, context), context);
        (0, $7099e9dbf72f5596$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        (0, $79b51af07cb34fe6$export$cd00a227f8cfb2c2)(elementRef.current, context);
        $25da1ed181e98b0a$export$d0296329a1f118ca(elementRef.current, props);
        return elementRef;
    };
}


function $26087237d6669ee9$export$896a3ef451e396c4(createInstance) {
    function createElement(props, context) {
        return (0, $c4349977e33cccc7$export$a080ff44e8067a44)(createInstance(props), context);
    }
    const useElement = (0, $c4349977e33cccc7$export$2e66ec8a7fb1892f)(createElement);
    const useControl = (0, $1b63afa14c569d34$export$28d24ab3914549cd)(useElement);
    return (0, $b5b5154e09abe911$export$18af5c7a9e9b3664)(useControl);
}
function $26087237d6669ee9$export$8a4d5778bce4c3ac(createElement, updateElement) {
    const useElement = (0, $c4349977e33cccc7$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const useLayer = (0, $79b51af07cb34fe6$export$73f852c6a5abdefa)(useElement);
    return (0, $b5b5154e09abe911$export$96eac748c3f41e82)(useLayer);
}
function $26087237d6669ee9$export$7d18e209be943d7d(createElement, useLifecycle) {
    const useElement = (0, $c4349977e33cccc7$export$2e66ec8a7fb1892f)(createElement);
    const useOverlay = (0, $36464a5b4c62d1dd$export$d5eca53b0accc0e0)(useElement, useLifecycle);
    return (0, $b5b5154e09abe911$export$bc37ddc24ed05446)(useOverlay);
}
function $26087237d6669ee9$export$5e776dbe3c7d2790(createElement, updateElement) {
    const useElement = (0, $c4349977e33cccc7$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const usePath = (0, $25da1ed181e98b0a$export$5fea2fe6048fc3db)(useElement);
    return (0, $b5b5154e09abe911$export$96eac748c3f41e82)(usePath);
}
function $26087237d6669ee9$export$4f432c6de5c4ddb8(createElement, updateElement) {
    const useElement = (0, $c4349977e33cccc7$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const useLayer = (0, $79b51af07cb34fe6$export$73f852c6a5abdefa)(useElement);
    return (0, $b5b5154e09abe911$export$18af5c7a9e9b3664)(useLayer);
}

function $94fa316de2622a09$export$b39104a5f1b9296f(layer, props, prevProps) {
    const { opacity: opacity, zIndex: zIndex } = props;
    if (opacity != null && opacity !== prevProps.opacity) layer.setOpacity(opacity);
    if (zIndex != null && zIndex !== prevProps.zIndex) layer.setZIndex(zIndex);
}



const $35109d75658c2839$export$f52ee31d61d0b27b = (0, $26087237d6669ee9$export$4f432c6de5c4ddb8)(function createTileLayer({ url: url, ...options }, context) {
    const layer = new (0, $65d191346d2f0e85$exports.TileLayer)(url, (0, $32d90284a15401c8$export$6ee5d263358f5c0e)(options, context));
    return (0, $c4349977e33cccc7$export$a080ff44e8067a44)(layer, context);
}, function updateTileLayer(layer, props, prevProps) {
    (0, $94fa316de2622a09$export$b39104a5f1b9296f)(layer, props, prevProps);
    const { url: url } = props;
    if (url != null && url !== prevProps.url) layer.setUrl(url);
});




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");



function $d60b8875bce1c81d$export$33f7236917d41ec0({ values: values, onChangeStopId: onChangeStopId, onChangeStopName: onChangeStopName }) {
    formId = (0, $acw62.useId)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "field grid",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        for: formId + '_stop_id',
                        className: "col-fixed",
                        style: {
                            width: '40%'
                        },
                        children: "ID nowego przystanku"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "col w-auto",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab1a721814a59df6$export$7034fcb7d6351061), {
                                id: formId + '_stop_id',
                                value: values.stop_id,
                                style: "w-100",
                                onChange: onChangeStopId,
                                invalid: Boolean(values.validation_errors.stop_id)
                            }),
                            values.validation_errors.stop_id ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f81f7a6994ee8076$export$f69c19e57285b83a), {
                                severity: "error",
                                className: "mt-1",
                                text: values.validation_errors.stop_id
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        for: formId + '_stop_name',
                        children: "Nazwa nowego przystanku"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2565b8a300f577e7$export$6b41f50dc0c59fb3), {
                        className: "w-full",
                        inputClassName: "w-full",
                        value: values.stop_name,
                        id: formId + '_stop_name',
                        placeholder: values.stop_name_placeholder,
                        onChange: onChangeStopName,
                        invalid: Boolean(values.validation_errors.stop_name)
                    }),
                    values.validation_errors.stop_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f81f7a6994ee8076$export$f69c19e57285b83a), {
                        severity: "error",
                        className: "mt-1",
                        text: values.validation_errors.stop_name
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                ]
            })
        ]
    });
}


function $101f013d0aabd6e9$export$3573dc1501de3aa4({ visible: visible, stopLocation: stopLocation, onHide: onHide }) {
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const { status: defaultIdStatus, data: defaultId } = (0, $4529664c1ee19d35$export$9f26b15dde9e2d17)('stops');
    const toolDispatch = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$6bbcf3368996eea5));
    const handleOverlay = (0, $acw62.useContext)((0, $bdccf6b6a87b04cc$export$a2200b96afd16271));
    const newStopMutation = (0, $4529664c1ee19d35$export$3aef3b03d18726d1)();
    const [values, setValues] = (0, $acw62.useState)({
        stop_id: '',
        stop_name: '',
        unnamed_stop_nr: 1,
        stop_name_placeholder: 'Przystanek bez nazwy ',
        validation_errors: {
            stop_id: false,
            stop_name: false
        }
    });
    const dialogFooterContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                label: "Anuluj",
                icon: "pi pi-times",
                onClick: ()=>onHide(),
                className: "p-button-text"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                label: "OK",
                icon: "pi pi-check",
                onClick: ()=>{
                    handleSendData();
                },
                autoFocus: true
            })
        ]
    });
    function handleChangeID(e) {
        setValues({
            ...values,
            stop_id: e.target.value
        });
    }
    function handleChangeStopName(e) {
        setValues({
            ...values,
            stop_name: e.value
        });
    }
    async function handleSendData() {
        const data = {
            fields: {
                stop_id: values.stop_id ? values.stop_id : defaultId,
                stop_name: values.stop_name ? values.stop_name : values.stop_name_placeholder + values.unnamed_stop_nr,
                stop_lat: stopLocation.lat,
                stop_lon: stopLocation.lng
            }
        };
        try {
            const mutation = await newStopMutation.mutateAsync(data);
            if (values.stop_name === '') setValues({
                ...values,
                unnamed_stop_nr: values.unnamed_stop_nr + 1
            });
            onHide();
            // po udanym dodaniu przystanku otwórz go w edytorze
            toolDispatch({
                type: 'changed',
                newTool: {
                    ...(0, $91fa2a3eb54dc801$export$88ae2e76299eaa00).tools.stopsTool,
                    selection: data.fields.stop_id,
                    propertyEditor: {
                        edit: data.fields
                    }
                }
            });
        } catch (error) {
            const errorCode = error.message.slice(0, 3);
            if (errorCode == '422') {
                //obsługa błędów walidacji
                let updatedValidationErrors = {};
                let propertyNames = Object.keys(error.cause.validation);
                propertyNames.forEach((value)=>{
                    messages = Object.values(error.cause.validation[value]).join(', ');
                    updatedValidationErrors[value] = messages;
                });
                setValues({
                    ...values,
                    validation_errors: {
                        ...updatedValidationErrors
                    }
                });
            } else //obsługa wszystkich pozostałych błędów
            handleOverlay('toast', {
                severity: "error",
                summary: "B\u0142\u0105d " + errorCode,
                detail: error.message
            });
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3c56f96c6f20f77$export$3ddf2d174ce01153), {
        header: "Nowy przystanek",
        footer: dialogFooterContent,
        visible: visible,
        style: {
            width: '50vw',
            maxWidth: '500px'
        },
        breakpoints: {
            '960px': '75vw',
            '641px': '100vw'
        },
        onHide: onHide,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "m-0",
            children: defaultIdStatus === 'success' || defaultIdStatus === 'error' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d60b8875bce1c81d$export$33f7236917d41ec0), {
                values: {
                    ...values,
                    stop_id: values.stop_id ? values.stop_id : defaultId,
                    stop_name_placeholder: values.stop_name_placeholder + values.unnamed_stop_nr
                },
                onChangeStopId: handleChangeID,
                onChangeStopName: handleChangeStopName
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec34a5c615255cb$export$dcc7532e7120780d), {})
        })
    });
}




var $acw62 = parcelRequire("acw62");
function $8a64faf0323c3697$export$86f8f9f08863e403() {
    return (0, $cbd94c399cef41ea$export$ea59151b8430a4e9)().map;
}
function $8a64faf0323c3697$export$4c2959913f5c7962(type, handler) {
    const map = $8a64faf0323c3697$export$86f8f9f08863e403();
    (0, $acw62.useEffect)(function addMapEventHandler() {
        // @ts-ignore event type
        map.on(type, handler);
        return function removeMapEventHandler() {
            // @ts-ignore event type
            map.off(type, handler);
        };
    }, [
        map,
        type,
        handler
    ]);
    return map;
}
function $8a64faf0323c3697$export$1c51e2c234152172(handlers) {
    const map = $8a64faf0323c3697$export$86f8f9f08863e403();
    (0, $acw62.useEffect)(function addMapEventHandlers() {
        map.on(handlers);
        return function removeMapEventHandlers() {
            map.off(handlers);
        };
    }, [
        map,
        handlers
    ]);
    return map;
}


function $335adba5521801cb$export$b59922a98a716877() {
    const handleOverlay = (0, $acw62.useContext)((0, $bdccf6b6a87b04cc$export$a2200b96afd16271));
    const [selectedLocation, setSelectedLocation] = (0, $acw62.useState)(null);
    const [visibleDialog, setVisibleDialog] = (0, $acw62.useState)(false);
    const cm = (0, $acw62.useRef)(null);
    const map = (0, $8a64faf0323c3697$export$1c51e2c234152172)({
        contextmenu: (e)=>{
            if (cm.current) {
                setSelectedLocation(e.latlng);
                cm.current.show(e.originalEvent);
            }
        }
    });
    const cmItems = [
        {
            label: "Utw\xf3rz przystanek tutaj",
            icon: 'fa-solid fa-location-dot',
            command: ()=>{
                setVisibleDialog('newStopDialog');
            }
        },
        {
            label: 'Skopiuj koordynaty',
            icon: 'fa-solid fa-copy',
            command: async ()=>{
                const locationStr = selectedLocation.lat + ',' + selectedLocation.lng;
                try {
                    await navigator.clipboard.writeText(locationStr);
                    handleOverlay('toast', {
                        severity: "success",
                        summary: 'Pozycja skopiowana do schowka',
                        detail: locationStr
                    });
                } catch (error) {
                    handleOverlay('toast', {
                        severity: "error",
                        summary: "Kopiowanie nie uda\u0142o si\u0119",
                        detail: "Mo\u017Cesz spr\xf3bowa\u0107 skopiowa\u0107 pozycj\u0119 z tego okienka: \r\n " + locationStr + ".\r\n Szczeg\xf3\u0142y b\u0142\u0119du: " + error.message
                    });
                }
            }
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dde48341f3da2113$export$8dc6765e8be191c7), {
                popup: true,
                model: cmItems,
                ref: cm
            }),
            selectedLocation ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $101f013d0aabd6e9$export$3573dc1501de3aa4), {
                stopLocation: selectedLocation,
                visible: visibleDialog === 'newStopDialog',
                onHide: ()=>{
                    setVisibleDialog(false);
                }
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
        ]
    });
}






var $acw62 = parcelRequire("acw62");


const $d30568f206d68912$export$e98856a975cab58e = (0, $26087237d6669ee9$export$8a4d5778bce4c3ac)(function createMarker({ position: position, ...options }, ctx) {
    const marker = new (0, $65d191346d2f0e85$exports.Marker)(position, options);
    return (0, $c4349977e33cccc7$export$a080ff44e8067a44)(marker, (0, $cbd94c399cef41ea$export$9efaf186a2224858)(ctx, {
        overlayContainer: marker
    }));
}, function updateMarker(marker, props, prevProps) {
    if (props.position !== prevProps.position) marker.setLatLng(props.position);
    if (props.icon != null && props.icon !== prevProps.icon) marker.setIcon(props.icon);
    if (props.zIndexOffset != null && props.zIndexOffset !== prevProps.zIndexOffset) marker.setZIndexOffset(props.zIndexOffset);
    if (props.opacity != null && props.opacity !== prevProps.opacity) marker.setOpacity(props.opacity);
    if (marker.dragging != null && props.draggable !== prevProps.draggable) {
        if (props.draggable === true) marker.dragging.enable();
        else marker.dragging.disable();
    }
});




var $acw62 = parcelRequire("acw62");
const $41a1beb44c6aafd3$export$129a32eedafa97c5 = (0, $26087237d6669ee9$export$7d18e209be943d7d)(function createPopup(props, context) {
    const popup = new (0, $65d191346d2f0e85$exports.Popup)(props, context.overlayContainer);
    return (0, $c4349977e33cccc7$export$a080ff44e8067a44)(popup, context);
}, function usePopupLifecycle(element, context, { position: position }, setOpen) {
    (0, $acw62.useEffect)(function addPopup() {
        const { instance: instance } = element;
        function onPopupOpen(event) {
            if (event.popup === instance) {
                instance.update();
                setOpen(true);
            }
        }
        function onPopupClose(event) {
            if (event.popup === instance) setOpen(false);
        }
        context.map.on({
            popupopen: onPopupOpen,
            popupclose: onPopupClose
        });
        if (context.overlayContainer == null) {
            // Attach to a Map
            if (position != null) instance.setLatLng(position);
            instance.openOn(context.map);
        } else // Attach to container component
        context.overlayContainer.bindPopup(instance);
        return function removePopup() {
            context.map.off({
                popupopen: onPopupOpen,
                popupclose: onPopupClose
            });
            context.overlayContainer?.unbindPopup();
            context.map.removeLayer(instance);
        };
    }, [
        element,
        context,
        setOpen,
        position
    ]);
});









var $acw62 = parcelRequire("acw62");


function $7120856f025ad77b$export$4a25a2f8e16f4a69({ cmRef: cmRef, GStop: GStop }) {
    const toolDispatch = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$6bbcf3368996eea5));
    const handleOverlay = (0, $acw62.useContext)((0, $bdccf6b6a87b04cc$export$a2200b96afd16271));
    const cmItems = [
        {
            label: 'Edytuj przystanek',
            icon: 'fa-solid fa-pen-to-square',
            command: ()=>{
                toolDispatch({
                    type: 'changed',
                    newTool: {
                        ...(0, $91fa2a3eb54dc801$export$88ae2e76299eaa00).tools.stopsTool,
                        selection: GStop.stop_id,
                        propertyEditor: {
                            edit: GStop
                        }
                    }
                });
            }
        },
        {
            label: 'Skopiuj koordynaty przystanku',
            icon: 'fa-solid fa-copy',
            command: async ()=>{
                const locationStr = GStop.stop_lat + ',' + GStop.stop_lon;
                try {
                    await navigator.clipboard.writeText(locationStr);
                    handleOverlay('toast', {
                        severity: "success",
                        summary: 'Pozycja skopiowana do schowka',
                        detail: locationStr
                    });
                } catch (error) {
                    handleOverlay('toast', {
                        severity: "error",
                        summary: "Kopiowanie nie uda\u0142o si\u0119",
                        detail: "Mo\u017Cesz spr\xf3bowa\u0107 skopiowa\u0107 pozycj\u0119 z tego okienka: \r\n " + locationStr + ".\r\n Szczeg\xf3\u0142y b\u0142\u0119du: " + error.message
                    });
                }
            }
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dde48341f3da2113$export$8dc6765e8be191c7), {
        ref: cmRef,
        model: cmItems
    });
}


function $4a1862680e40c05e$export$1fa24f6e3d88c20c({ GStopId: GStopId, openPopup: openPopup, isDraggable: isDraggable, specialIcon: specialIcon }) {
    const map = (0, $8a64faf0323c3697$export$86f8f9f08863e403)();
    const markerRef = (0, $acw62.useRef)(null);
    const cmRef = (0, $acw62.useRef)(null);
    const toolDispatch = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$6bbcf3368996eea5));
    const modifyStop = (0, $4529664c1ee19d35$export$a60c7f0127bb920c)();
    const { isPending: isPending, error: error, data: GStops } = (0, $4529664c1ee19d35$export$c3a687f3d6e3fb65)('stops');
    if (isPending || error || (Object.entries(GStops).length = 0)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    const GStop = GStops[GStopId];
    const selectedIcon = new (0, $65d191346d2f0e85$exports.Icon)({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-gold.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [
            25,
            41
        ],
        iconAnchor: [
            12,
            41
        ],
        popupAnchor: [
            1,
            -34
        ],
        shadowSize: [
            41,
            41
        ]
    });
    const defaultIcon = new (0, $65d191346d2f0e85$exports.Icon).Default;
    (0, $acw62.useEffect)(()=>{
        if (openPopup) {
            map.setView([
                GStop.stop_lat,
                GStop.stop_lon
            ], 17);
            setTimeout(()=>{
                markerRef.current.openPopup();
            }, 250);
        }
    }, [
        map,
        GStop.stop_lat,
        GStop.stop_lon,
        openPopup,
        markerRef.current
    ]);
    let icon = defaultIcon;
    if (specialIcon) icon = specialIcon;
    else icon = isDraggable ? selectedIcon : defaultIcon;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d30568f206d68912$export$e98856a975cab58e), {
        ref: markerRef,
        position: [
            GStop.stop_lat,
            GStop.stop_lon
        ],
        draggable: isDraggable,
        openPopup: openPopup,
        icon: icon,
        eventHandlers: {
            contextmenu: (e)=>{
                if (cmRef.current) cmRef.current.show(e.originalEvent);
            },
            dblclick: ()=>{
                toolDispatch({
                    type: 'changed',
                    newTool: {
                        ...(0, $91fa2a3eb54dc801$export$88ae2e76299eaa00).tools.stopsTool,
                        selection: GStop.stop_id,
                        propertyEditor: {
                            edit: GStop
                        }
                    }
                });
            },
            dragend: (e)=>{
                const latLng = e.target.getLatLng();
                const data = {
                    query: {
                        modified_stop_id: GStop.stop_id
                    },
                    fields: {
                        stop_lat: latLng.lat,
                        stop_lon: latLng.lng
                    }
                };
                modifyStop.mutate(data);
            }
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4a1862680e40c05e$var$PopupStop, {
                GStop: GStop
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7120856f025ad77b$export$4a25a2f8e16f4a69), {
                cmRef: cmRef,
                GStop: GStop
            })
        ]
    }, GStop.stop_id);
}
function $4a1862680e40c05e$var$PopupStop({ GStop: GStop }) {
    const routes = typeof GStop.stats.routes !== 'undefined' ? Object.entries(GStop.stats.routes).map(([, GRoute])=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2cd10a5f6773a01$export$bfbea4d618559e4a), {
            GRoute: GRoute
        }, GRoute.route_id);
    }) : [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $41a1beb44c6aafd3$export$129a32eedafa97c5), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                children: [
                    "\uD83D\uDE8F ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontWeight: 'normal'
                        },
                        className: "text-200 text-xs",
                        children: GStop.stop_id
                    }),
                    " ",
                    GStop.stop_name,
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a79a81cc3b591c5$export$5d8a4b9af9ca5f5b), {
                        platformCode: GStop.platform_code
                    })
                ]
            }),
            routes.length > 0 ? routes : "\u274C Brak linii odje\u017Cd\u017Caj\u0105cych z tego stanowiska."
        ]
    });
}




var $d74276d64ed130b8$exports = {};
/*
 * Leaflet.markercluster 1.5.3+master.e5124b2,
 * Provides Beautiful Animated Marker Clustering functionality for Leaflet, a JS library for interactive maps.
 * https://github.com/Leaflet/Leaflet.markercluster
 * (c) 2012-2017, Dave Leaver, smartrak
 */ (function(global, factory) {
    factory($d74276d64ed130b8$exports);
})($d74276d64ed130b8$exports, function(exports1) {
    'use strict';
    /*
	 * L.MarkerClusterGroup extends L.FeatureGroup by clustering the markers contained within
	 */ var MarkerClusterGroup = L.MarkerClusterGroup = L.FeatureGroup.extend({
        options: {
            maxClusterRadius: 80,
            iconCreateFunction: null,
            clusterPane: L.Marker.prototype.options.pane,
            spiderfyOnEveryZoom: false,
            spiderfyOnMaxZoom: true,
            showCoverageOnHover: true,
            zoomToBoundsOnClick: true,
            singleMarkerMode: false,
            disableClusteringAtZoom: null,
            // Setting this to false prevents the removal of any clusters outside of the viewpoint, which
            // is the default behaviour for performance reasons.
            removeOutsideVisibleBounds: true,
            // Set to false to disable all animations (zoom and spiderfy).
            // If false, option animateAddingMarkers below has no effect.
            // If L.DomUtil.TRANSITION is falsy, this option has no effect.
            animate: true,
            //Whether to animate adding markers after adding the MarkerClusterGroup to the map
            // If you are adding individual markers set to true, if adding bulk markers leave false for massive performance gains.
            animateAddingMarkers: false,
            // Make it possible to provide custom function to calculate spiderfy shape positions
            spiderfyShapePositions: null,
            //Increase to increase the distance away that spiderfied markers appear from the center
            spiderfyDistanceMultiplier: 1,
            // Make it possible to specify a polyline options on a spider leg
            spiderLegPolylineOptions: {
                weight: 1.5,
                color: '#222',
                opacity: 0.5
            },
            // When bulk adding layers, adds markers in chunks. Means addLayers may not add all the layers in the call, others will be loaded during setTimeouts
            chunkedLoading: false,
            chunkInterval: 200,
            chunkDelay: 50,
            chunkProgress: null,
            //Options to pass to the L.Polygon constructor
            polygonOptions: {}
        },
        initialize: function(options) {
            L.Util.setOptions(this, options);
            if (!this.options.iconCreateFunction) this.options.iconCreateFunction = this._defaultIconCreateFunction;
            this._featureGroup = L.featureGroup();
            this._featureGroup.addEventParent(this);
            this._nonPointGroup = L.featureGroup();
            this._nonPointGroup.addEventParent(this);
            this._inZoomAnimation = 0;
            this._needsClustering = [];
            this._needsRemoving = []; //Markers removed while we aren't on the map need to be kept track of
            //The bounds of the currently shown area (from _getExpandedVisibleBounds) Updated on zoom/move
            this._currentShownBounds = null;
            this._queue = [];
            this._childMarkerEventHandlers = {
                'dragstart': this._childMarkerDragStart,
                'move': this._childMarkerMoved,
                'dragend': this._childMarkerDragEnd
            };
            // Hook the appropriate animation methods.
            var animate = L.DomUtil.TRANSITION && this.options.animate;
            L.extend(this, animate ? this._withAnimation : this._noAnimation);
            // Remember which MarkerCluster class to instantiate (animated or not).
            this._markerCluster = animate ? L.MarkerCluster : L.MarkerClusterNonAnimated;
        },
        addLayer: function(layer) {
            if (layer instanceof L.LayerGroup) return this.addLayers([
                layer
            ]);
            //Don't cluster non point data
            if (!layer.getLatLng) {
                this._nonPointGroup.addLayer(layer);
                this.fire('layeradd', {
                    layer: layer
                });
                return this;
            }
            if (!this._map) {
                this._needsClustering.push(layer);
                this.fire('layeradd', {
                    layer: layer
                });
                return this;
            }
            if (this.hasLayer(layer)) return this;
            //If we have already clustered we'll need to add this one to a cluster
            if (this._unspiderfy) this._unspiderfy();
            this._addLayer(layer, this._maxZoom);
            this.fire('layeradd', {
                layer: layer
            });
            // Refresh bounds and weighted positions.
            this._topClusterLevel._recalculateBounds();
            this._refreshClustersIcons();
            //Work out what is visible
            var visibleLayer = layer, currentZoom = this._zoom;
            if (layer.__parent) while(visibleLayer.__parent._zoom >= currentZoom)visibleLayer = visibleLayer.__parent;
            if (this._currentShownBounds.contains(visibleLayer.getLatLng())) {
                if (this.options.animateAddingMarkers) this._animationAddLayer(layer, visibleLayer);
                else this._animationAddLayerNonAnimated(layer, visibleLayer);
            }
            return this;
        },
        removeLayer: function(layer) {
            if (layer instanceof L.LayerGroup) return this.removeLayers([
                layer
            ]);
            //Non point layers
            if (!layer.getLatLng) {
                this._nonPointGroup.removeLayer(layer);
                this.fire('layerremove', {
                    layer: layer
                });
                return this;
            }
            if (!this._map) {
                if (!this._arraySplice(this._needsClustering, layer) && this.hasLayer(layer)) this._needsRemoving.push({
                    layer: layer,
                    latlng: layer._latlng
                });
                this.fire('layerremove', {
                    layer: layer
                });
                return this;
            }
            if (!layer.__parent) return this;
            if (this._unspiderfy) {
                this._unspiderfy();
                this._unspiderfyLayer(layer);
            }
            //Remove the marker from clusters
            this._removeLayer(layer, true);
            this.fire('layerremove', {
                layer: layer
            });
            // Refresh bounds and weighted positions.
            this._topClusterLevel._recalculateBounds();
            this._refreshClustersIcons();
            layer.off(this._childMarkerEventHandlers, this);
            if (this._featureGroup.hasLayer(layer)) {
                this._featureGroup.removeLayer(layer);
                if (layer.clusterShow) layer.clusterShow();
            }
            return this;
        },
        //Takes an array of markers and adds them in bulk
        addLayers: function(layersArray, skipLayerAddEvent) {
            if (!L.Util.isArray(layersArray)) return this.addLayer(layersArray);
            var fg = this._featureGroup, npg = this._nonPointGroup, chunked = this.options.chunkedLoading, chunkInterval = this.options.chunkInterval, chunkProgress = this.options.chunkProgress, l = layersArray.length, offset = 0, originalArray = true, m;
            if (this._map) {
                var started = new Date().getTime();
                var process = L.bind(function() {
                    var start = new Date().getTime();
                    // Make sure to unspiderfy before starting to add some layers
                    if (this._map && this._unspiderfy) this._unspiderfy();
                    for(; offset < l; offset++){
                        if (chunked && offset % 200 === 0) {
                            // every couple hundred markers, instrument the time elapsed since processing started:
                            var elapsed = new Date().getTime() - start;
                            if (elapsed > chunkInterval) break; // been working too hard, time to take a break :-)
                        }
                        m = layersArray[offset];
                        // Group of layers, append children to layersArray and skip.
                        // Side effects:
                        // - Total increases, so chunkProgress ratio jumps backward.
                        // - Groups are not included in this group, only their non-group child layers (hasLayer).
                        // Changing array length while looping does not affect performance in current browsers:
                        // http://jsperf.com/for-loop-changing-length/6
                        if (m instanceof L.LayerGroup) {
                            if (originalArray) {
                                layersArray = layersArray.slice();
                                originalArray = false;
                            }
                            this._extractNonGroupLayers(m, layersArray);
                            l = layersArray.length;
                            continue;
                        }
                        //Not point data, can't be clustered
                        if (!m.getLatLng) {
                            npg.addLayer(m);
                            if (!skipLayerAddEvent) this.fire('layeradd', {
                                layer: m
                            });
                            continue;
                        }
                        if (this.hasLayer(m)) continue;
                        this._addLayer(m, this._maxZoom);
                        if (!skipLayerAddEvent) this.fire('layeradd', {
                            layer: m
                        });
                        //If we just made a cluster of size 2 then we need to remove the other marker from the map (if it is) or we never will
                        if (m.__parent) {
                            if (m.__parent.getChildCount() === 2) {
                                var markers = m.__parent.getAllChildMarkers(), otherMarker = markers[0] === m ? markers[1] : markers[0];
                                fg.removeLayer(otherMarker);
                            }
                        }
                    }
                    if (chunkProgress) // report progress and time elapsed:
                    chunkProgress(offset, l, new Date().getTime() - started);
                    // Completed processing all markers.
                    if (offset === l) {
                        // Refresh bounds and weighted positions.
                        this._topClusterLevel._recalculateBounds();
                        this._refreshClustersIcons();
                        this._topClusterLevel._recursivelyAddChildrenToMap(null, this._zoom, this._currentShownBounds);
                    } else setTimeout(process, this.options.chunkDelay);
                }, this);
                process();
            } else {
                var needsClustering = this._needsClustering;
                for(; offset < l; offset++){
                    m = layersArray[offset];
                    // Group of layers, append children to layersArray and skip.
                    if (m instanceof L.LayerGroup) {
                        if (originalArray) {
                            layersArray = layersArray.slice();
                            originalArray = false;
                        }
                        this._extractNonGroupLayers(m, layersArray);
                        l = layersArray.length;
                        continue;
                    }
                    //Not point data, can't be clustered
                    if (!m.getLatLng) {
                        npg.addLayer(m);
                        continue;
                    }
                    if (this.hasLayer(m)) continue;
                    needsClustering.push(m);
                }
            }
            return this;
        },
        //Takes an array of markers and removes them in bulk
        removeLayers: function(layersArray) {
            var i, m, l = layersArray.length, fg = this._featureGroup, npg = this._nonPointGroup, originalArray = true;
            if (!this._map) {
                for(i = 0; i < l; i++){
                    m = layersArray[i];
                    // Group of layers, append children to layersArray and skip.
                    if (m instanceof L.LayerGroup) {
                        if (originalArray) {
                            layersArray = layersArray.slice();
                            originalArray = false;
                        }
                        this._extractNonGroupLayers(m, layersArray);
                        l = layersArray.length;
                        continue;
                    }
                    this._arraySplice(this._needsClustering, m);
                    npg.removeLayer(m);
                    if (this.hasLayer(m)) this._needsRemoving.push({
                        layer: m,
                        latlng: m._latlng
                    });
                    this.fire('layerremove', {
                        layer: m
                    });
                }
                return this;
            }
            if (this._unspiderfy) {
                this._unspiderfy();
                // Work on a copy of the array, so that next loop is not affected.
                var layersArray2 = layersArray.slice(), l2 = l;
                for(i = 0; i < l2; i++){
                    m = layersArray2[i];
                    // Group of layers, append children to layersArray and skip.
                    if (m instanceof L.LayerGroup) {
                        this._extractNonGroupLayers(m, layersArray2);
                        l2 = layersArray2.length;
                        continue;
                    }
                    this._unspiderfyLayer(m);
                }
            }
            for(i = 0; i < l; i++){
                m = layersArray[i];
                // Group of layers, append children to layersArray and skip.
                if (m instanceof L.LayerGroup) {
                    if (originalArray) {
                        layersArray = layersArray.slice();
                        originalArray = false;
                    }
                    this._extractNonGroupLayers(m, layersArray);
                    l = layersArray.length;
                    continue;
                }
                if (!m.__parent) {
                    npg.removeLayer(m);
                    this.fire('layerremove', {
                        layer: m
                    });
                    continue;
                }
                this._removeLayer(m, true, true);
                this.fire('layerremove', {
                    layer: m
                });
                if (fg.hasLayer(m)) {
                    fg.removeLayer(m);
                    if (m.clusterShow) m.clusterShow();
                }
            }
            // Refresh bounds and weighted positions.
            this._topClusterLevel._recalculateBounds();
            this._refreshClustersIcons();
            //Fix up the clusters and markers on the map
            this._topClusterLevel._recursivelyAddChildrenToMap(null, this._zoom, this._currentShownBounds);
            return this;
        },
        //Removes all layers from the MarkerClusterGroup
        clearLayers: function() {
            //Need our own special implementation as the LayerGroup one doesn't work for us
            //If we aren't on the map (yet), blow away the markers we know of
            if (!this._map) {
                this._needsClustering = [];
                this._needsRemoving = [];
                delete this._gridClusters;
                delete this._gridUnclustered;
            }
            if (this._noanimationUnspiderfy) this._noanimationUnspiderfy();
            //Remove all the visible layers
            this._featureGroup.clearLayers();
            this._nonPointGroup.clearLayers();
            this.eachLayer(function(marker) {
                marker.off(this._childMarkerEventHandlers, this);
                delete marker.__parent;
            }, this);
            if (this._map) //Reset _topClusterLevel and the DistanceGrids
            this._generateInitialClusters();
            return this;
        },
        //Override FeatureGroup.getBounds as it doesn't work
        getBounds: function() {
            var bounds = new L.LatLngBounds();
            if (this._topClusterLevel) bounds.extend(this._topClusterLevel._bounds);
            for(var i = this._needsClustering.length - 1; i >= 0; i--)bounds.extend(this._needsClustering[i].getLatLng());
            bounds.extend(this._nonPointGroup.getBounds());
            return bounds;
        },
        //Overrides LayerGroup.eachLayer
        eachLayer: function(method, context) {
            var markers = this._needsClustering.slice(), needsRemoving = this._needsRemoving, thisNeedsRemoving, i, j;
            if (this._topClusterLevel) this._topClusterLevel.getAllChildMarkers(markers);
            for(i = markers.length - 1; i >= 0; i--){
                thisNeedsRemoving = true;
                for(j = needsRemoving.length - 1; j >= 0; j--)if (needsRemoving[j].layer === markers[i]) {
                    thisNeedsRemoving = false;
                    break;
                }
                if (thisNeedsRemoving) method.call(context, markers[i]);
            }
            this._nonPointGroup.eachLayer(method, context);
        },
        //Overrides LayerGroup.getLayers
        getLayers: function() {
            var layers = [];
            this.eachLayer(function(l) {
                layers.push(l);
            });
            return layers;
        },
        //Overrides LayerGroup.getLayer, WARNING: Really bad performance
        getLayer: function(id) {
            var result = null;
            id = parseInt(id, 10);
            this.eachLayer(function(l) {
                if (L.stamp(l) === id) result = l;
            });
            return result;
        },
        //Returns true if the given layer is in this MarkerClusterGroup
        hasLayer: function(layer) {
            if (!layer) return false;
            var i, anArray = this._needsClustering;
            for(i = anArray.length - 1; i >= 0; i--){
                if (anArray[i] === layer) return true;
            }
            anArray = this._needsRemoving;
            for(i = anArray.length - 1; i >= 0; i--){
                if (anArray[i].layer === layer) return false;
            }
            return !!(layer.__parent && layer.__parent._group === this) || this._nonPointGroup.hasLayer(layer);
        },
        //Zoom down to show the given layer (spiderfying if necessary) then calls the callback
        zoomToShowLayer: function(layer, callback) {
            var map = this._map;
            if (typeof callback !== 'function') callback = function() {};
            var showMarker = function() {
                // Assumes that map.hasLayer checks for direct appearance on map, not recursively calling
                // hasLayer on Layer Groups that are on map (typically not calling this MarkerClusterGroup.hasLayer, which would always return true)
                if ((map.hasLayer(layer) || map.hasLayer(layer.__parent)) && !this._inZoomAnimation) {
                    this._map.off('moveend', showMarker, this);
                    this.off('animationend', showMarker, this);
                    if (map.hasLayer(layer)) callback();
                    else if (layer.__parent._icon) {
                        this.once('spiderfied', callback, this);
                        layer.__parent.spiderfy();
                    }
                }
            };
            if (layer._icon && this._map.getBounds().contains(layer.getLatLng())) //Layer is visible ond on screen, immediate return
            callback();
            else if (layer.__parent._zoom < Math.round(this._map._zoom)) {
                //Layer should be visible at this zoom level. It must not be on screen so just pan over to it
                this._map.on('moveend', showMarker, this);
                this._map.panTo(layer.getLatLng());
            } else {
                this._map.on('moveend', showMarker, this);
                this.on('animationend', showMarker, this);
                layer.__parent.zoomToBounds();
            }
        },
        //Overrides FeatureGroup.onAdd
        onAdd: function(map) {
            this._map = map;
            var i, l, layer;
            if (!isFinite(this._map.getMaxZoom())) throw "Map has no maxZoom specified";
            this._featureGroup.addTo(map);
            this._nonPointGroup.addTo(map);
            if (!this._gridClusters) this._generateInitialClusters();
            this._maxLat = map.options.crs.projection.MAX_LATITUDE;
            //Restore all the positions as they are in the MCG before removing them
            for(i = 0, l = this._needsRemoving.length; i < l; i++){
                layer = this._needsRemoving[i];
                layer.newlatlng = layer.layer._latlng;
                layer.layer._latlng = layer.latlng;
            }
            //Remove them, then restore their new positions
            for(i = 0, l = this._needsRemoving.length; i < l; i++){
                layer = this._needsRemoving[i];
                this._removeLayer(layer.layer, true);
                layer.layer._latlng = layer.newlatlng;
            }
            this._needsRemoving = [];
            //Remember the current zoom level and bounds
            this._zoom = Math.round(this._map._zoom);
            this._currentShownBounds = this._getExpandedVisibleBounds();
            this._map.on('zoomend', this._zoomEnd, this);
            this._map.on('moveend', this._moveEnd, this);
            if (this._spiderfierOnAdd) this._spiderfierOnAdd();
            this._bindEvents();
            //Actually add our markers to the map:
            l = this._needsClustering;
            this._needsClustering = [];
            this.addLayers(l, true);
        },
        //Overrides FeatureGroup.onRemove
        onRemove: function(map) {
            map.off('zoomend', this._zoomEnd, this);
            map.off('moveend', this._moveEnd, this);
            this._unbindEvents();
            //In case we are in a cluster animation
            this._map._mapPane.className = this._map._mapPane.className.replace(' leaflet-cluster-anim', '');
            if (this._spiderfierOnRemove) this._spiderfierOnRemove();
            delete this._maxLat;
            //Clean up all the layers we added to the map
            this._hideCoverage();
            this._featureGroup.remove();
            this._nonPointGroup.remove();
            this._featureGroup.clearLayers();
            this._map = null;
        },
        getVisibleParent: function(marker) {
            var vMarker = marker;
            while(vMarker && !vMarker._icon)vMarker = vMarker.__parent;
            return vMarker || null;
        },
        //Remove the given object from the given array
        _arraySplice: function(anArray, obj) {
            for(var i = anArray.length - 1; i >= 0; i--)if (anArray[i] === obj) {
                anArray.splice(i, 1);
                return true;
            }
        },
        /**
		 * Removes a marker from all _gridUnclustered zoom levels, starting at the supplied zoom.
		 * @param marker to be removed from _gridUnclustered.
		 * @param z integer bottom start zoom level (included)
		 * @private
		 */ _removeFromGridUnclustered: function(marker, z) {
            var map = this._map, gridUnclustered = this._gridUnclustered, minZoom = Math.floor(this._map.getMinZoom());
            for(; z >= minZoom; z--){
                if (!gridUnclustered[z].removeObject(marker, map.project(marker.getLatLng(), z))) break;
            }
        },
        _childMarkerDragStart: function(e) {
            e.target.__dragStart = e.target._latlng;
        },
        _childMarkerMoved: function(e) {
            if (!this._ignoreMove && !e.target.__dragStart) {
                var isPopupOpen = e.target._popup && e.target._popup.isOpen();
                this._moveChild(e.target, e.oldLatLng, e.latlng);
                if (isPopupOpen) e.target.openPopup();
            }
        },
        _moveChild: function(layer, from, to) {
            layer._latlng = from;
            this.removeLayer(layer);
            layer._latlng = to;
            this.addLayer(layer);
        },
        _childMarkerDragEnd: function(e) {
            var dragStart = e.target.__dragStart;
            delete e.target.__dragStart;
            if (dragStart) this._moveChild(e.target, dragStart, e.target._latlng);
        },
        //Internal function for removing a marker from everything.
        //dontUpdateMap: set to true if you will handle updating the map manually (for bulk functions)
        _removeLayer: function(marker, removeFromDistanceGrid, dontUpdateMap) {
            var gridClusters = this._gridClusters, gridUnclustered = this._gridUnclustered, fg = this._featureGroup, map = this._map, minZoom = Math.floor(this._map.getMinZoom());
            //Remove the marker from distance clusters it might be in
            if (removeFromDistanceGrid) this._removeFromGridUnclustered(marker, this._maxZoom);
            //Work our way up the clusters removing them as we go if required
            var cluster = marker.__parent, markers = cluster._markers, otherMarker;
            //Remove the marker from the immediate parents marker list
            this._arraySplice(markers, marker);
            while(cluster){
                cluster._childCount--;
                cluster._boundsNeedUpdate = true;
                if (cluster._zoom < minZoom) break;
                else if (removeFromDistanceGrid && cluster._childCount <= 1) {
                    //We need to push the other marker up to the parent
                    otherMarker = cluster._markers[0] === marker ? cluster._markers[1] : cluster._markers[0];
                    //Update distance grid
                    gridClusters[cluster._zoom].removeObject(cluster, map.project(cluster._cLatLng, cluster._zoom));
                    gridUnclustered[cluster._zoom].addObject(otherMarker, map.project(otherMarker.getLatLng(), cluster._zoom));
                    //Move otherMarker up to parent
                    this._arraySplice(cluster.__parent._childClusters, cluster);
                    cluster.__parent._markers.push(otherMarker);
                    otherMarker.__parent = cluster.__parent;
                    if (cluster._icon) {
                        //Cluster is currently on the map, need to put the marker on the map instead
                        fg.removeLayer(cluster);
                        if (!dontUpdateMap) fg.addLayer(otherMarker);
                    }
                } else cluster._iconNeedsUpdate = true;
                cluster = cluster.__parent;
            }
            delete marker.__parent;
        },
        _isOrIsParent: function(el, oel) {
            while(oel){
                if (el === oel) return true;
                oel = oel.parentNode;
            }
            return false;
        },
        //Override L.Evented.fire
        fire: function(type, data, propagate) {
            if (data && data.layer instanceof L.MarkerCluster) {
                //Prevent multiple clustermouseover/off events if the icon is made up of stacked divs (Doesn't work in ie <= 8, no relatedTarget)
                if (data.originalEvent && this._isOrIsParent(data.layer._icon, data.originalEvent.relatedTarget)) return;
                type = 'cluster' + type;
            }
            L.FeatureGroup.prototype.fire.call(this, type, data, propagate);
        },
        //Override L.Evented.listens
        listens: function(type, propagate) {
            return L.FeatureGroup.prototype.listens.call(this, type, propagate) || L.FeatureGroup.prototype.listens.call(this, 'cluster' + type, propagate);
        },
        //Default functionality
        _defaultIconCreateFunction: function(cluster) {
            var childCount = cluster.getChildCount();
            var c = ' marker-cluster-';
            if (childCount < 10) c += 'small';
            else if (childCount < 100) c += 'medium';
            else c += 'large';
            return new L.DivIcon({
                html: '<div><span>' + childCount + '</span></div>',
                className: 'marker-cluster' + c,
                iconSize: new L.Point(40, 40)
            });
        },
        _bindEvents: function() {
            var map = this._map, spiderfyOnMaxZoom = this.options.spiderfyOnMaxZoom, showCoverageOnHover = this.options.showCoverageOnHover, zoomToBoundsOnClick = this.options.zoomToBoundsOnClick, spiderfyOnEveryZoom = this.options.spiderfyOnEveryZoom;
            //Zoom on cluster click or spiderfy if we are at the lowest level
            if (spiderfyOnMaxZoom || zoomToBoundsOnClick || spiderfyOnEveryZoom) this.on('clusterclick clusterkeypress', this._zoomOrSpiderfy, this);
            //Show convex hull (boundary) polygon on mouse over
            if (showCoverageOnHover) {
                this.on('clustermouseover', this._showCoverage, this);
                this.on('clustermouseout', this._hideCoverage, this);
                map.on('zoomend', this._hideCoverage, this);
            }
        },
        _zoomOrSpiderfy: function(e) {
            var cluster = e.layer, bottomCluster = cluster;
            if (e.type === 'clusterkeypress' && e.originalEvent && e.originalEvent.keyCode !== 13) return;
            while(bottomCluster._childClusters.length === 1)bottomCluster = bottomCluster._childClusters[0];
            if (bottomCluster._zoom === this._maxZoom && bottomCluster._childCount === cluster._childCount && this.options.spiderfyOnMaxZoom) // All child markers are contained in a single cluster from this._maxZoom to this cluster.
            cluster.spiderfy();
            else if (this.options.zoomToBoundsOnClick) cluster.zoomToBounds();
            if (this.options.spiderfyOnEveryZoom) cluster.spiderfy();
            // Focus the map again for keyboard users.
            if (e.originalEvent && e.originalEvent.keyCode === 13) this._map._container.focus();
        },
        _showCoverage: function(e) {
            var map = this._map;
            if (this._inZoomAnimation) return;
            if (this._shownPolygon) map.removeLayer(this._shownPolygon);
            if (e.layer.getChildCount() > 2 && e.layer !== this._spiderfied) {
                this._shownPolygon = new L.Polygon(e.layer.getConvexHull(), this.options.polygonOptions);
                map.addLayer(this._shownPolygon);
            }
        },
        _hideCoverage: function() {
            if (this._shownPolygon) {
                this._map.removeLayer(this._shownPolygon);
                this._shownPolygon = null;
            }
        },
        _unbindEvents: function() {
            var spiderfyOnMaxZoom = this.options.spiderfyOnMaxZoom, showCoverageOnHover = this.options.showCoverageOnHover, zoomToBoundsOnClick = this.options.zoomToBoundsOnClick, spiderfyOnEveryZoom = this.options.spiderfyOnEveryZoom, map = this._map;
            if (spiderfyOnMaxZoom || zoomToBoundsOnClick || spiderfyOnEveryZoom) this.off('clusterclick clusterkeypress', this._zoomOrSpiderfy, this);
            if (showCoverageOnHover) {
                this.off('clustermouseover', this._showCoverage, this);
                this.off('clustermouseout', this._hideCoverage, this);
                map.off('zoomend', this._hideCoverage, this);
            }
        },
        _zoomEnd: function() {
            if (!this._map) return;
            this._mergeSplitClusters();
            this._zoom = Math.round(this._map._zoom);
            this._currentShownBounds = this._getExpandedVisibleBounds();
        },
        _moveEnd: function() {
            if (this._inZoomAnimation) return;
            var newBounds = this._getExpandedVisibleBounds();
            this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), this._zoom, newBounds);
            this._topClusterLevel._recursivelyAddChildrenToMap(null, Math.round(this._map._zoom), newBounds);
            this._currentShownBounds = newBounds;
            return;
        },
        _generateInitialClusters: function() {
            var maxZoom = Math.ceil(this._map.getMaxZoom()), minZoom = Math.floor(this._map.getMinZoom()), radius = this.options.maxClusterRadius, radiusFn = radius;
            //If we just set maxClusterRadius to a single number, we need to create
            //a simple function to return that number. Otherwise, we just have to
            //use the function we've passed in.
            if (typeof radius !== "function") radiusFn = function() {
                return radius;
            };
            if (this.options.disableClusteringAtZoom !== null) maxZoom = this.options.disableClusteringAtZoom - 1;
            this._maxZoom = maxZoom;
            this._gridClusters = {};
            this._gridUnclustered = {};
            //Set up DistanceGrids for each zoom
            for(var zoom = maxZoom; zoom >= minZoom; zoom--){
                this._gridClusters[zoom] = new L.DistanceGrid(radiusFn(zoom));
                this._gridUnclustered[zoom] = new L.DistanceGrid(radiusFn(zoom));
            }
            // Instantiate the appropriate L.MarkerCluster class (animated or not).
            this._topClusterLevel = new this._markerCluster(this, minZoom - 1);
        },
        //Zoom: Zoom to start adding at (Pass this._maxZoom to start at the bottom)
        _addLayer: function(layer, zoom) {
            var gridClusters = this._gridClusters, gridUnclustered = this._gridUnclustered, minZoom = Math.floor(this._map.getMinZoom()), markerPoint, z;
            if (this.options.singleMarkerMode) this._overrideMarkerIcon(layer);
            layer.on(this._childMarkerEventHandlers, this);
            //Find the lowest zoom level to slot this one in
            for(; zoom >= minZoom; zoom--){
                markerPoint = this._map.project(layer.getLatLng(), zoom); // calculate pixel position
                //Try find a cluster close by
                var closest = gridClusters[zoom].getNearObject(markerPoint);
                if (closest) {
                    closest._addChild(layer);
                    layer.__parent = closest;
                    return;
                }
                //Try find a marker close by to form a new cluster with
                closest = gridUnclustered[zoom].getNearObject(markerPoint);
                if (closest) {
                    var parent = closest.__parent;
                    if (parent) this._removeLayer(closest, false);
                    //Create new cluster with these 2 in it
                    var newCluster = new this._markerCluster(this, zoom, closest, layer);
                    gridClusters[zoom].addObject(newCluster, this._map.project(newCluster._cLatLng, zoom));
                    closest.__parent = newCluster;
                    layer.__parent = newCluster;
                    //First create any new intermediate parent clusters that don't exist
                    var lastParent = newCluster;
                    for(z = zoom - 1; z > parent._zoom; z--){
                        lastParent = new this._markerCluster(this, z, lastParent);
                        gridClusters[z].addObject(lastParent, this._map.project(closest.getLatLng(), z));
                    }
                    parent._addChild(lastParent);
                    //Remove closest from this zoom level and any above that it is in, replace with newCluster
                    this._removeFromGridUnclustered(closest, zoom);
                    return;
                }
                //Didn't manage to cluster in at this zoom, record us as a marker here and continue upwards
                gridUnclustered[zoom].addObject(layer, markerPoint);
            }
            //Didn't get in anything, add us to the top
            this._topClusterLevel._addChild(layer);
            layer.__parent = this._topClusterLevel;
            return;
        },
        /**
		 * Refreshes the icon of all "dirty" visible clusters.
		 * Non-visible "dirty" clusters will be updated when they are added to the map.
		 * @private
		 */ _refreshClustersIcons: function() {
            this._featureGroup.eachLayer(function(c) {
                if (c instanceof L.MarkerCluster && c._iconNeedsUpdate) c._updateIcon();
            });
        },
        //Enqueue code to fire after the marker expand/contract has happened
        _enqueue: function(fn) {
            this._queue.push(fn);
            if (!this._queueTimeout) this._queueTimeout = setTimeout(L.bind(this._processQueue, this), 300);
        },
        _processQueue: function() {
            for(var i = 0; i < this._queue.length; i++)this._queue[i].call(this);
            this._queue.length = 0;
            clearTimeout(this._queueTimeout);
            this._queueTimeout = null;
        },
        //Merge and split any existing clusters that are too big or small
        _mergeSplitClusters: function() {
            var mapZoom = Math.round(this._map._zoom);
            //In case we are starting to split before the animation finished
            this._processQueue();
            if (this._zoom < mapZoom && this._currentShownBounds.intersects(this._getExpandedVisibleBounds())) {
                this._animationStart();
                //Remove clusters now off screen
                this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), this._zoom, this._getExpandedVisibleBounds());
                this._animationZoomIn(this._zoom, mapZoom);
            } else if (this._zoom > mapZoom) {
                this._animationStart();
                this._animationZoomOut(this._zoom, mapZoom);
            } else this._moveEnd();
        },
        //Gets the maps visible bounds expanded in each direction by the size of the screen (so the user cannot see an area we do not cover in one pan)
        _getExpandedVisibleBounds: function() {
            if (!this.options.removeOutsideVisibleBounds) return this._mapBoundsInfinite;
            else if (L.Browser.mobile) return this._checkBoundsMaxLat(this._map.getBounds());
            return this._checkBoundsMaxLat(this._map.getBounds().pad(1)); // Padding expands the bounds by its own dimensions but scaled with the given factor.
        },
        /**
		 * Expands the latitude to Infinity (or -Infinity) if the input bounds reach the map projection maximum defined latitude
		 * (in the case of Web/Spherical Mercator, it is 85.0511287798 / see https://en.wikipedia.org/wiki/Web_Mercator#Formulas).
		 * Otherwise, the removeOutsideVisibleBounds option will remove markers beyond that limit, whereas the same markers without
		 * this option (or outside MCG) will have their position floored (ceiled) by the projection and rendered at that limit,
		 * making the user think that MCG "eats" them and never displays them again.
		 * @param bounds L.LatLngBounds
		 * @returns {L.LatLngBounds}
		 * @private
		 */ _checkBoundsMaxLat: function(bounds) {
            var maxLat = this._maxLat;
            if (maxLat !== undefined) {
                if (bounds.getNorth() >= maxLat) bounds._northEast.lat = Infinity;
                if (bounds.getSouth() <= -maxLat) bounds._southWest.lat = -Infinity;
            }
            return bounds;
        },
        //Shared animation code
        _animationAddLayerNonAnimated: function(layer, newCluster) {
            if (newCluster === layer) this._featureGroup.addLayer(layer);
            else if (newCluster._childCount === 2) {
                newCluster._addToMap();
                var markers = newCluster.getAllChildMarkers();
                this._featureGroup.removeLayer(markers[0]);
                this._featureGroup.removeLayer(markers[1]);
            } else newCluster._updateIcon();
        },
        /**
		 * Extracts individual (i.e. non-group) layers from a Layer Group.
		 * @param group to extract layers from.
		 * @param output {Array} in which to store the extracted layers.
		 * @returns {*|Array}
		 * @private
		 */ _extractNonGroupLayers: function(group, output) {
            var layers = group.getLayers(), i = 0, layer;
            output = output || [];
            for(; i < layers.length; i++){
                layer = layers[i];
                if (layer instanceof L.LayerGroup) {
                    this._extractNonGroupLayers(layer, output);
                    continue;
                }
                output.push(layer);
            }
            return output;
        },
        /**
		 * Implements the singleMarkerMode option.
		 * @param layer Marker to re-style using the Clusters iconCreateFunction.
		 * @returns {L.Icon} The newly created icon.
		 * @private
		 */ _overrideMarkerIcon: function(layer) {
            var icon = layer.options.icon = this.options.iconCreateFunction({
                getChildCount: function() {
                    return 1;
                },
                getAllChildMarkers: function() {
                    return [
                        layer
                    ];
                }
            });
            return icon;
        }
    });
    // Constant bounds used in case option "removeOutsideVisibleBounds" is set to false.
    L.MarkerClusterGroup.include({
        _mapBoundsInfinite: new L.LatLngBounds(new L.LatLng(-Infinity, -Infinity), new L.LatLng(Infinity, Infinity))
    });
    L.MarkerClusterGroup.include({
        _noAnimation: {
            //Non Animated versions of everything
            _animationStart: function() {
            //Do nothing...
            },
            _animationZoomIn: function(previousZoomLevel, newZoomLevel) {
                this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), previousZoomLevel);
                this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
                //We didn't actually animate, but we use this event to mean "clustering animations have finished"
                this.fire('animationend');
            },
            _animationZoomOut: function(previousZoomLevel, newZoomLevel) {
                this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), previousZoomLevel);
                this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
                //We didn't actually animate, but we use this event to mean "clustering animations have finished"
                this.fire('animationend');
            },
            _animationAddLayer: function(layer, newCluster) {
                this._animationAddLayerNonAnimated(layer, newCluster);
            }
        },
        _withAnimation: {
            //Animated versions here
            _animationStart: function() {
                this._map._mapPane.className += ' leaflet-cluster-anim';
                this._inZoomAnimation++;
            },
            _animationZoomIn: function(previousZoomLevel, newZoomLevel) {
                var bounds = this._getExpandedVisibleBounds(), fg = this._featureGroup, minZoom = Math.floor(this._map.getMinZoom()), i;
                this._ignoreMove = true;
                //Add all children of current clusters to map and remove those clusters from map
                this._topClusterLevel._recursively(bounds, previousZoomLevel, minZoom, function(c) {
                    var startPos = c._latlng, markers = c._markers, m;
                    if (!bounds.contains(startPos)) startPos = null;
                    if (c._isSingleParent() && previousZoomLevel + 1 === newZoomLevel) {
                        fg.removeLayer(c);
                        c._recursivelyAddChildrenToMap(null, newZoomLevel, bounds);
                    } else {
                        //Fade out old cluster
                        c.clusterHide();
                        c._recursivelyAddChildrenToMap(startPos, newZoomLevel, bounds);
                    }
                    //Remove all markers that aren't visible any more
                    //TODO: Do we actually need to do this on the higher levels too?
                    for(i = markers.length - 1; i >= 0; i--){
                        m = markers[i];
                        if (!bounds.contains(m._latlng)) fg.removeLayer(m);
                    }
                });
                this._forceLayout();
                //Update opacities
                this._topClusterLevel._recursivelyBecomeVisible(bounds, newZoomLevel);
                //TODO Maybe? Update markers in _recursivelyBecomeVisible
                fg.eachLayer(function(n) {
                    if (!(n instanceof L.MarkerCluster) && n._icon) n.clusterShow();
                });
                //update the positions of the just added clusters/markers
                this._topClusterLevel._recursively(bounds, previousZoomLevel, newZoomLevel, function(c) {
                    c._recursivelyRestoreChildPositions(newZoomLevel);
                });
                this._ignoreMove = false;
                //Remove the old clusters and close the zoom animation
                this._enqueue(function() {
                    //update the positions of the just added clusters/markers
                    this._topClusterLevel._recursively(bounds, previousZoomLevel, minZoom, function(c) {
                        fg.removeLayer(c);
                        c.clusterShow();
                    });
                    this._animationEnd();
                });
            },
            _animationZoomOut: function(previousZoomLevel, newZoomLevel) {
                this._animationZoomOutSingle(this._topClusterLevel, previousZoomLevel - 1, newZoomLevel);
                //Need to add markers for those that weren't on the map before but are now
                this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
                //Remove markers that were on the map before but won't be now
                this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), previousZoomLevel, this._getExpandedVisibleBounds());
            },
            _animationAddLayer: function(layer, newCluster) {
                var me = this, fg = this._featureGroup;
                fg.addLayer(layer);
                if (newCluster !== layer) {
                    if (newCluster._childCount > 2) {
                        newCluster._updateIcon();
                        this._forceLayout();
                        this._animationStart();
                        layer._setPos(this._map.latLngToLayerPoint(newCluster.getLatLng()));
                        layer.clusterHide();
                        this._enqueue(function() {
                            fg.removeLayer(layer);
                            layer.clusterShow();
                            me._animationEnd();
                        });
                    } else {
                        this._forceLayout();
                        me._animationStart();
                        me._animationZoomOutSingle(newCluster, this._map.getMaxZoom(), this._zoom);
                    }
                }
            }
        },
        // Private methods for animated versions.
        _animationZoomOutSingle: function(cluster, previousZoomLevel, newZoomLevel) {
            var bounds = this._getExpandedVisibleBounds(), minZoom = Math.floor(this._map.getMinZoom());
            //Animate all of the markers in the clusters to move to their cluster center point
            cluster._recursivelyAnimateChildrenInAndAddSelfToMap(bounds, minZoom, previousZoomLevel + 1, newZoomLevel);
            var me = this;
            //Update the opacity (If we immediately set it they won't animate)
            this._forceLayout();
            cluster._recursivelyBecomeVisible(bounds, newZoomLevel);
            //TODO: Maybe use the transition timing stuff to make this more reliable
            //When the animations are done, tidy up
            this._enqueue(function() {
                //This cluster stopped being a cluster before the timeout fired
                if (cluster._childCount === 1) {
                    var m = cluster._markers[0];
                    //If we were in a cluster animation at the time then the opacity and position of our child could be wrong now, so fix it
                    this._ignoreMove = true;
                    m.setLatLng(m.getLatLng());
                    this._ignoreMove = false;
                    if (m.clusterShow) m.clusterShow();
                } else cluster._recursively(bounds, newZoomLevel, minZoom, function(c) {
                    c._recursivelyRemoveChildrenFromMap(bounds, minZoom, previousZoomLevel + 1);
                });
                me._animationEnd();
            });
        },
        _animationEnd: function() {
            if (this._map) this._map._mapPane.className = this._map._mapPane.className.replace(' leaflet-cluster-anim', '');
            this._inZoomAnimation--;
            this.fire('animationend');
        },
        //Force a browser layout of stuff in the map
        // Should apply the current opacity and location to all elements so we can update them again for an animation
        _forceLayout: function() {
            //In my testing this works, infact offsetWidth of any element seems to work.
            //Could loop all this._layers and do this for each _icon if it stops working
            L.Util.falseFn(document.body.offsetWidth);
        }
    });
    L.markerClusterGroup = function(options) {
        return new L.MarkerClusterGroup(options);
    };
    var MarkerCluster = L.MarkerCluster = L.Marker.extend({
        options: L.Icon.prototype.options,
        initialize: function(group, zoom, a, b) {
            L.Marker.prototype.initialize.call(this, a ? a._cLatLng || a.getLatLng() : new L.LatLng(0, 0), {
                icon: this,
                pane: group.options.clusterPane
            });
            this._group = group;
            this._zoom = zoom;
            this._markers = [];
            this._childClusters = [];
            this._childCount = 0;
            this._iconNeedsUpdate = true;
            this._boundsNeedUpdate = true;
            this._bounds = new L.LatLngBounds();
            if (a) this._addChild(a);
            if (b) this._addChild(b);
        },
        //Recursively retrieve all child markers of this cluster
        getAllChildMarkers: function(storageArray, ignoreDraggedMarker) {
            storageArray = storageArray || [];
            for(var i = this._childClusters.length - 1; i >= 0; i--)this._childClusters[i].getAllChildMarkers(storageArray, ignoreDraggedMarker);
            for(var j = this._markers.length - 1; j >= 0; j--){
                if (ignoreDraggedMarker && this._markers[j].__dragStart) continue;
                storageArray.push(this._markers[j]);
            }
            return storageArray;
        },
        //Returns the count of how many child markers we have
        getChildCount: function() {
            return this._childCount;
        },
        //Zoom to the minimum of showing all of the child markers, or the extents of this cluster
        zoomToBounds: function(fitBoundsOptions) {
            var childClusters = this._childClusters.slice(), map = this._group._map, boundsZoom = map.getBoundsZoom(this._bounds), zoom = this._zoom + 1, mapZoom = map.getZoom(), i;
            //calculate how far we need to zoom down to see all of the markers
            while(childClusters.length > 0 && boundsZoom > zoom){
                zoom++;
                var newClusters = [];
                for(i = 0; i < childClusters.length; i++)newClusters = newClusters.concat(childClusters[i]._childClusters);
                childClusters = newClusters;
            }
            if (boundsZoom > zoom) this._group._map.setView(this._latlng, zoom);
            else if (boundsZoom <= mapZoom) this._group._map.setView(this._latlng, mapZoom + 1);
            else this._group._map.fitBounds(this._bounds, fitBoundsOptions);
        },
        getBounds: function() {
            var bounds = new L.LatLngBounds();
            bounds.extend(this._bounds);
            return bounds;
        },
        _updateIcon: function() {
            this._iconNeedsUpdate = true;
            if (this._icon) this.setIcon(this);
        },
        //Cludge for Icon, we pretend to be an icon for performance
        createIcon: function() {
            if (this._iconNeedsUpdate) {
                this._iconObj = this._group.options.iconCreateFunction(this);
                this._iconNeedsUpdate = false;
            }
            return this._iconObj.createIcon();
        },
        createShadow: function() {
            return this._iconObj.createShadow();
        },
        _addChild: function(new1, isNotificationFromChild) {
            this._iconNeedsUpdate = true;
            this._boundsNeedUpdate = true;
            this._setClusterCenter(new1);
            if (new1 instanceof L.MarkerCluster) {
                if (!isNotificationFromChild) {
                    this._childClusters.push(new1);
                    new1.__parent = this;
                }
                this._childCount += new1._childCount;
            } else {
                if (!isNotificationFromChild) this._markers.push(new1);
                this._childCount++;
            }
            if (this.__parent) this.__parent._addChild(new1, true);
        },
        /**
		 * Makes sure the cluster center is set. If not, uses the child center if it is a cluster, or the marker position.
		 * @param child L.MarkerCluster|L.Marker that will be used as cluster center if not defined yet.
		 * @private
		 */ _setClusterCenter: function(child) {
            if (!this._cLatLng) // when clustering, take position of the first point as the cluster center
            this._cLatLng = child._cLatLng || child._latlng;
        },
        /**
		 * Assigns impossible bounding values so that the next extend entirely determines the new bounds.
		 * This method avoids having to trash the previous L.LatLngBounds object and to create a new one, which is much slower for this class.
		 * As long as the bounds are not extended, most other methods would probably fail, as they would with bounds initialized but not extended.
		 * @private
		 */ _resetBounds: function() {
            var bounds = this._bounds;
            if (bounds._southWest) {
                bounds._southWest.lat = Infinity;
                bounds._southWest.lng = Infinity;
            }
            if (bounds._northEast) {
                bounds._northEast.lat = -Infinity;
                bounds._northEast.lng = -Infinity;
            }
        },
        _recalculateBounds: function() {
            var markers = this._markers, childClusters = this._childClusters, latSum = 0, lngSum = 0, totalCount = this._childCount, i, child, childLatLng, childCount;
            // Case where all markers are removed from the map and we are left with just an empty _topClusterLevel.
            if (totalCount === 0) return;
            // Reset rather than creating a new object, for performance.
            this._resetBounds();
            // Child markers.
            for(i = 0; i < markers.length; i++){
                childLatLng = markers[i]._latlng;
                this._bounds.extend(childLatLng);
                latSum += childLatLng.lat;
                lngSum += childLatLng.lng;
            }
            // Child clusters.
            for(i = 0; i < childClusters.length; i++){
                child = childClusters[i];
                // Re-compute child bounds and weighted position first if necessary.
                if (child._boundsNeedUpdate) child._recalculateBounds();
                this._bounds.extend(child._bounds);
                childLatLng = child._wLatLng;
                childCount = child._childCount;
                latSum += childLatLng.lat * childCount;
                lngSum += childLatLng.lng * childCount;
            }
            this._latlng = this._wLatLng = new L.LatLng(latSum / totalCount, lngSum / totalCount);
            // Reset dirty flag.
            this._boundsNeedUpdate = false;
        },
        //Set our markers position as given and add it to the map
        _addToMap: function(startPos) {
            if (startPos) {
                this._backupLatlng = this._latlng;
                this.setLatLng(startPos);
            }
            this._group._featureGroup.addLayer(this);
        },
        _recursivelyAnimateChildrenIn: function(bounds, center, maxZoom) {
            this._recursively(bounds, this._group._map.getMinZoom(), maxZoom - 1, function(c) {
                var markers = c._markers, i, m;
                for(i = markers.length - 1; i >= 0; i--){
                    m = markers[i];
                    //Only do it if the icon is still on the map
                    if (m._icon) {
                        m._setPos(center);
                        m.clusterHide();
                    }
                }
            }, function(c) {
                var childClusters = c._childClusters, j, cm;
                for(j = childClusters.length - 1; j >= 0; j--){
                    cm = childClusters[j];
                    if (cm._icon) {
                        cm._setPos(center);
                        cm.clusterHide();
                    }
                }
            });
        },
        _recursivelyAnimateChildrenInAndAddSelfToMap: function(bounds, mapMinZoom, previousZoomLevel, newZoomLevel) {
            this._recursively(bounds, newZoomLevel, mapMinZoom, function(c) {
                c._recursivelyAnimateChildrenIn(bounds, c._group._map.latLngToLayerPoint(c.getLatLng()).round(), previousZoomLevel);
                //TODO: depthToAnimateIn affects _isSingleParent, if there is a multizoom we may/may not be.
                //As a hack we only do a animation free zoom on a single level zoom, if someone does multiple levels then we always animate
                if (c._isSingleParent() && previousZoomLevel - 1 === newZoomLevel) {
                    c.clusterShow();
                    c._recursivelyRemoveChildrenFromMap(bounds, mapMinZoom, previousZoomLevel); //Immediately remove our children as we are replacing them. TODO previousBounds not bounds
                } else c.clusterHide();
                c._addToMap();
            });
        },
        _recursivelyBecomeVisible: function(bounds, zoomLevel) {
            this._recursively(bounds, this._group._map.getMinZoom(), zoomLevel, null, function(c) {
                c.clusterShow();
            });
        },
        _recursivelyAddChildrenToMap: function(startPos, zoomLevel, bounds) {
            this._recursively(bounds, this._group._map.getMinZoom() - 1, zoomLevel, function(c) {
                if (zoomLevel === c._zoom) return;
                //Add our child markers at startPos (so they can be animated out)
                for(var i = c._markers.length - 1; i >= 0; i--){
                    var nm = c._markers[i];
                    if (!bounds.contains(nm._latlng)) continue;
                    if (startPos) {
                        nm._backupLatlng = nm.getLatLng();
                        nm.setLatLng(startPos);
                        if (nm.clusterHide) nm.clusterHide();
                    }
                    c._group._featureGroup.addLayer(nm);
                }
            }, function(c) {
                c._addToMap(startPos);
            });
        },
        _recursivelyRestoreChildPositions: function(zoomLevel) {
            //Fix positions of child markers
            for(var i = this._markers.length - 1; i >= 0; i--){
                var nm = this._markers[i];
                if (nm._backupLatlng) {
                    nm.setLatLng(nm._backupLatlng);
                    delete nm._backupLatlng;
                }
            }
            if (zoomLevel - 1 === this._zoom) //Reposition child clusters
            for(var j = this._childClusters.length - 1; j >= 0; j--)this._childClusters[j]._restorePosition();
            else for(var k = this._childClusters.length - 1; k >= 0; k--)this._childClusters[k]._recursivelyRestoreChildPositions(zoomLevel);
        },
        _restorePosition: function() {
            if (this._backupLatlng) {
                this.setLatLng(this._backupLatlng);
                delete this._backupLatlng;
            }
        },
        //exceptBounds: If set, don't remove any markers/clusters in it
        _recursivelyRemoveChildrenFromMap: function(previousBounds, mapMinZoom, zoomLevel, exceptBounds) {
            var m, i;
            this._recursively(previousBounds, mapMinZoom - 1, zoomLevel - 1, function(c) {
                //Remove markers at every level
                for(i = c._markers.length - 1; i >= 0; i--){
                    m = c._markers[i];
                    if (!exceptBounds || !exceptBounds.contains(m._latlng)) {
                        c._group._featureGroup.removeLayer(m);
                        if (m.clusterShow) m.clusterShow();
                    }
                }
            }, function(c) {
                //Remove child clusters at just the bottom level
                for(i = c._childClusters.length - 1; i >= 0; i--){
                    m = c._childClusters[i];
                    if (!exceptBounds || !exceptBounds.contains(m._latlng)) {
                        c._group._featureGroup.removeLayer(m);
                        if (m.clusterShow) m.clusterShow();
                    }
                }
            });
        },
        //Run the given functions recursively to this and child clusters
        // boundsToApplyTo: a L.LatLngBounds representing the bounds of what clusters to recurse in to
        // zoomLevelToStart: zoom level to start running functions (inclusive)
        // zoomLevelToStop: zoom level to stop running functions (inclusive)
        // runAtEveryLevel: function that takes an L.MarkerCluster as an argument that should be applied on every level
        // runAtBottomLevel: function that takes an L.MarkerCluster as an argument that should be applied at only the bottom level
        _recursively: function(boundsToApplyTo, zoomLevelToStart, zoomLevelToStop, runAtEveryLevel, runAtBottomLevel) {
            var childClusters = this._childClusters, zoom = this._zoom, i, c;
            if (zoomLevelToStart <= zoom) {
                if (runAtEveryLevel) runAtEveryLevel(this);
                if (runAtBottomLevel && zoom === zoomLevelToStop) runAtBottomLevel(this);
            }
            if (zoom < zoomLevelToStart || zoom < zoomLevelToStop) for(i = childClusters.length - 1; i >= 0; i--){
                c = childClusters[i];
                if (c._boundsNeedUpdate) c._recalculateBounds();
                if (boundsToApplyTo.intersects(c._bounds)) c._recursively(boundsToApplyTo, zoomLevelToStart, zoomLevelToStop, runAtEveryLevel, runAtBottomLevel);
            }
        },
        //Returns true if we are the parent of only one cluster and that cluster is the same as us
        _isSingleParent: function() {
            //Don't need to check this._markers as the rest won't work if there are any
            return this._childClusters.length > 0 && this._childClusters[0]._childCount === this._childCount;
        }
    });
    /*
	* Extends L.Marker to include two extra methods: clusterHide and clusterShow.
	* 
	* They work as setOpacity(0) and setOpacity(1) respectively, but
	* don't overwrite the options.opacity
	* 
	*/ L.Marker.include({
        clusterHide: function() {
            var backup = this.options.opacity;
            this.setOpacity(0);
            this.options.opacity = backup;
            return this;
        },
        clusterShow: function() {
            return this.setOpacity(this.options.opacity);
        }
    });
    L.DistanceGrid = function(cellSize) {
        this._cellSize = cellSize;
        this._sqCellSize = cellSize * cellSize;
        this._grid = {};
        this._objectPoint = {};
    };
    L.DistanceGrid.prototype = {
        addObject: function(obj, point) {
            var x = this._getCoord(point.x), y = this._getCoord(point.y), grid = this._grid, row = grid[y] = grid[y] || {}, cell = row[x] = row[x] || [], stamp = L.Util.stamp(obj);
            this._objectPoint[stamp] = point;
            cell.push(obj);
        },
        updateObject: function(obj, point) {
            this.removeObject(obj);
            this.addObject(obj, point);
        },
        //Returns true if the object was found
        removeObject: function(obj, point) {
            var x = this._getCoord(point.x), y = this._getCoord(point.y), grid = this._grid, row = grid[y] = grid[y] || {}, cell = row[x] = row[x] || [], i, len;
            delete this._objectPoint[L.Util.stamp(obj)];
            for(i = 0, len = cell.length; i < len; i++)if (cell[i] === obj) {
                cell.splice(i, 1);
                if (len === 1) delete row[x];
                return true;
            }
        },
        eachObject: function(fn, context) {
            var i, j, k, len, row, cell, removed, grid = this._grid;
            for(i in grid){
                row = grid[i];
                for(j in row){
                    cell = row[j];
                    for(k = 0, len = cell.length; k < len; k++){
                        removed = fn.call(context, cell[k]);
                        if (removed) {
                            k--;
                            len--;
                        }
                    }
                }
            }
        },
        getNearObject: function(point) {
            var x = this._getCoord(point.x), y = this._getCoord(point.y), i, j, k, row, cell, len, obj, dist, objectPoint = this._objectPoint, closestDistSq = this._sqCellSize, closest = null;
            for(i = y - 1; i <= y + 1; i++){
                row = this._grid[i];
                if (row) for(j = x - 1; j <= x + 1; j++){
                    cell = row[j];
                    if (cell) for(k = 0, len = cell.length; k < len; k++){
                        obj = cell[k];
                        dist = this._sqDist(objectPoint[L.Util.stamp(obj)], point);
                        if (dist < closestDistSq || dist <= closestDistSq && closest === null) {
                            closestDistSq = dist;
                            closest = obj;
                        }
                    }
                }
            }
            return closest;
        },
        _getCoord: function(x) {
            var coord = Math.floor(x / this._cellSize);
            return isFinite(coord) ? coord : x;
        },
        _sqDist: function(p, p2) {
            var dx = p2.x - p.x, dy = p2.y - p.y;
            return dx * dx + dy * dy;
        }
    };
    /* Copyright (c) 2012 the authors listed at the following URL, and/or
	the authors of referenced articles or incorporated external code:
	http://en.literateprograms.org/Quickhull_(Javascript)?action=history&offset=20120410175256

	Permission is hereby granted, free of charge, to any person obtaining
	a copy of this software and associated documentation files (the
	"Software"), to deal in the Software without restriction, including
	without limitation the rights to use, copy, modify, merge, publish,
	distribute, sublicense, and/or sell copies of the Software, and to
	permit persons to whom the Software is furnished to do so, subject to
	the following conditions:

	The above copyright notice and this permission notice shall be
	included in all copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

	Retrieved from: http://en.literateprograms.org/Quickhull_(Javascript)?oldid=18434
	*/ (function() {
        L.QuickHull = {
            /*
			 * @param {Object} cpt a point to be measured from the baseline
			 * @param {Array} bl the baseline, as represented by a two-element
			 *   array of latlng objects.
			 * @returns {Number} an approximate distance measure
			 */ getDistant: function(cpt, bl) {
                var vY = bl[1].lat - bl[0].lat, vX = bl[0].lng - bl[1].lng;
                return vX * (cpt.lat - bl[0].lat) + vY * (cpt.lng - bl[0].lng);
            },
            /*
			 * @param {Array} baseLine a two-element array of latlng objects
			 *   representing the baseline to project from
			 * @param {Array} latLngs an array of latlng objects
			 * @returns {Object} the maximum point and all new points to stay
			 *   in consideration for the hull.
			 */ findMostDistantPointFromBaseLine: function(baseLine, latLngs) {
                var maxD = 0, maxPt = null, newPoints = [], i, pt, d;
                for(i = latLngs.length - 1; i >= 0; i--){
                    pt = latLngs[i];
                    d = this.getDistant(pt, baseLine);
                    if (d > 0) newPoints.push(pt);
                    else continue;
                    if (d > maxD) {
                        maxD = d;
                        maxPt = pt;
                    }
                }
                return {
                    maxPoint: maxPt,
                    newPoints: newPoints
                };
            },
            /*
			 * Given a baseline, compute the convex hull of latLngs as an array
			 * of latLngs.
			 *
			 * @param {Array} latLngs
			 * @returns {Array}
			 */ buildConvexHull: function(baseLine, latLngs) {
                var convexHullBaseLines = [], t = this.findMostDistantPointFromBaseLine(baseLine, latLngs);
                if (t.maxPoint) {
                    convexHullBaseLines = convexHullBaseLines.concat(this.buildConvexHull([
                        baseLine[0],
                        t.maxPoint
                    ], t.newPoints));
                    convexHullBaseLines = convexHullBaseLines.concat(this.buildConvexHull([
                        t.maxPoint,
                        baseLine[1]
                    ], t.newPoints));
                    return convexHullBaseLines;
                } else return [
                    baseLine[0]
                ];
            },
            /*
			 * Given an array of latlngs, compute a convex hull as an array
			 * of latlngs
			 *
			 * @param {Array} latLngs
			 * @returns {Array}
			 */ getConvexHull: function(latLngs) {
                // find first baseline
                var maxLat = false, minLat = false, maxLng = false, minLng = false, maxLatPt = null, minLatPt = null, maxLngPt = null, minLngPt = null, maxPt = null, minPt = null, i;
                for(i = latLngs.length - 1; i >= 0; i--){
                    var pt = latLngs[i];
                    if (maxLat === false || pt.lat > maxLat) {
                        maxLatPt = pt;
                        maxLat = pt.lat;
                    }
                    if (minLat === false || pt.lat < minLat) {
                        minLatPt = pt;
                        minLat = pt.lat;
                    }
                    if (maxLng === false || pt.lng > maxLng) {
                        maxLngPt = pt;
                        maxLng = pt.lng;
                    }
                    if (minLng === false || pt.lng < minLng) {
                        minLngPt = pt;
                        minLng = pt.lng;
                    }
                }
                if (minLat !== maxLat) {
                    minPt = minLatPt;
                    maxPt = maxLatPt;
                } else {
                    minPt = minLngPt;
                    maxPt = maxLngPt;
                }
                var ch = [].concat(this.buildConvexHull([
                    minPt,
                    maxPt
                ], latLngs), this.buildConvexHull([
                    maxPt,
                    minPt
                ], latLngs));
                return ch;
            }
        };
    })();
    L.MarkerCluster.include({
        getConvexHull: function() {
            var childMarkers = this.getAllChildMarkers(), points = [], p, i;
            for(i = childMarkers.length - 1; i >= 0; i--){
                p = childMarkers[i].getLatLng();
                points.push(p);
            }
            return L.QuickHull.getConvexHull(points);
        }
    });
    //This code is 100% based on https://github.com/jawj/OverlappingMarkerSpiderfier-Leaflet
    //Huge thanks to jawj for implementing it first to make my job easy :-)
    L.MarkerCluster.include({
        _2PI: Math.PI * 2,
        _circleFootSeparation: 25,
        _circleStartAngle: 0,
        _spiralFootSeparation: 28,
        _spiralLengthStart: 11,
        _spiralLengthFactor: 5,
        _circleSpiralSwitchover: 9,
        // 0 -> always spiral; Infinity -> always circle
        spiderfy: function() {
            if (this._group._spiderfied === this || this._group._inZoomAnimation) return;
            var childMarkers = this.getAllChildMarkers(null, true), group = this._group, map = group._map, center = map.latLngToLayerPoint(this._latlng), positions;
            this._group._unspiderfy();
            this._group._spiderfied = this;
            //TODO Maybe: childMarkers order by distance to center
            if (this._group.options.spiderfyShapePositions) positions = this._group.options.spiderfyShapePositions(childMarkers.length, center);
            else if (childMarkers.length >= this._circleSpiralSwitchover) positions = this._generatePointsSpiral(childMarkers.length, center);
            else {
                center.y += 10; // Otherwise circles look wrong => hack for standard blue icon, renders differently for other icons.
                positions = this._generatePointsCircle(childMarkers.length, center);
            }
            this._animationSpiderfy(childMarkers, positions);
        },
        unspiderfy: function(zoomDetails) {
            /// <param Name="zoomDetails">Argument from zoomanim if being called in a zoom animation or null otherwise</param>
            if (this._group._inZoomAnimation) return;
            this._animationUnspiderfy(zoomDetails);
            this._group._spiderfied = null;
        },
        _generatePointsCircle: function(count, centerPt) {
            var circumference = this._group.options.spiderfyDistanceMultiplier * this._circleFootSeparation * (2 + count), legLength = circumference / this._2PI, angleStep = this._2PI / count, res = [], i, angle;
            legLength = Math.max(legLength, 35); // Minimum distance to get outside the cluster icon.
            res.length = count;
            for(i = 0; i < count; i++){
                angle = this._circleStartAngle + i * angleStep;
                res[i] = new L.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle))._round();
            }
            return res;
        },
        _generatePointsSpiral: function(count, centerPt) {
            var spiderfyDistanceMultiplier = this._group.options.spiderfyDistanceMultiplier, legLength = spiderfyDistanceMultiplier * this._spiralLengthStart, separation = spiderfyDistanceMultiplier * this._spiralFootSeparation, lengthFactor = spiderfyDistanceMultiplier * this._spiralLengthFactor * this._2PI, angle = 0, res = [], i;
            res.length = count;
            // Higher index, closer position to cluster center.
            for(i = count; i >= 0; i--){
                // Skip the first position, so that we are already farther from center and we avoid
                // being under the default cluster icon (especially important for Circle Markers).
                if (i < count) res[i] = new L.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle))._round();
                angle += separation / legLength + i * 0.0005;
                legLength += lengthFactor / angle;
            }
            return res;
        },
        _noanimationUnspiderfy: function() {
            var group = this._group, map = group._map, fg = group._featureGroup, childMarkers = this.getAllChildMarkers(null, true), m, i;
            group._ignoreMove = true;
            this.setOpacity(1);
            for(i = childMarkers.length - 1; i >= 0; i--){
                m = childMarkers[i];
                fg.removeLayer(m);
                if (m._preSpiderfyLatlng) {
                    m.setLatLng(m._preSpiderfyLatlng);
                    delete m._preSpiderfyLatlng;
                }
                if (m.setZIndexOffset) m.setZIndexOffset(0);
                if (m._spiderLeg) {
                    map.removeLayer(m._spiderLeg);
                    delete m._spiderLeg;
                }
            }
            group.fire('unspiderfied', {
                cluster: this,
                markers: childMarkers
            });
            group._ignoreMove = false;
            group._spiderfied = null;
        }
    });
    //Non Animated versions of everything
    L.MarkerClusterNonAnimated = L.MarkerCluster.extend({
        _animationSpiderfy: function(childMarkers, positions) {
            var group = this._group, map = group._map, fg = group._featureGroup, legOptions = this._group.options.spiderLegPolylineOptions, i, m, leg, newPos;
            group._ignoreMove = true;
            // Traverse in ascending order to make sure that inner circleMarkers are on top of further legs. Normal markers are re-ordered by newPosition.
            // The reverse order trick no longer improves performance on modern browsers.
            for(i = 0; i < childMarkers.length; i++){
                newPos = map.layerPointToLatLng(positions[i]);
                m = childMarkers[i];
                // Add the leg before the marker, so that in case the latter is a circleMarker, the leg is behind it.
                leg = new L.Polyline([
                    this._latlng,
                    newPos
                ], legOptions);
                map.addLayer(leg);
                m._spiderLeg = leg;
                // Now add the marker.
                m._preSpiderfyLatlng = m._latlng;
                m.setLatLng(newPos);
                if (m.setZIndexOffset) m.setZIndexOffset(1000000); //Make these appear on top of EVERYTHING
                fg.addLayer(m);
            }
            this.setOpacity(0.3);
            group._ignoreMove = false;
            group.fire('spiderfied', {
                cluster: this,
                markers: childMarkers
            });
        },
        _animationUnspiderfy: function() {
            this._noanimationUnspiderfy();
        }
    });
    //Animated versions here
    L.MarkerCluster.include({
        _animationSpiderfy: function(childMarkers, positions) {
            var me = this, group = this._group, map = group._map, fg = group._featureGroup, thisLayerLatLng = this._latlng, thisLayerPos = map.latLngToLayerPoint(thisLayerLatLng), svg = L.Path.SVG, legOptions = L.extend({}, this._group.options.spiderLegPolylineOptions), finalLegOpacity = legOptions.opacity, i, m, leg, legPath, legLength, newPos;
            if (finalLegOpacity === undefined) finalLegOpacity = L.MarkerClusterGroup.prototype.options.spiderLegPolylineOptions.opacity;
            if (svg) {
                // If the initial opacity of the spider leg is not 0 then it appears before the animation starts.
                legOptions.opacity = 0;
                // Add the class for CSS transitions.
                legOptions.className = (legOptions.className || '') + ' leaflet-cluster-spider-leg';
            } else // Make sure we have a defined opacity.
            legOptions.opacity = finalLegOpacity;
            group._ignoreMove = true;
            // Add markers and spider legs to map, hidden at our center point.
            // Traverse in ascending order to make sure that inner circleMarkers are on top of further legs. Normal markers are re-ordered by newPosition.
            // The reverse order trick no longer improves performance on modern browsers.
            for(i = 0; i < childMarkers.length; i++){
                m = childMarkers[i];
                newPos = map.layerPointToLatLng(positions[i]);
                // Add the leg before the marker, so that in case the latter is a circleMarker, the leg is behind it.
                leg = new L.Polyline([
                    thisLayerLatLng,
                    newPos
                ], legOptions);
                map.addLayer(leg);
                m._spiderLeg = leg;
                // Explanations: https://jakearchibald.com/2013/animated-line-drawing-svg/
                // In our case the transition property is declared in the CSS file.
                if (svg) {
                    legPath = leg._path;
                    legLength = legPath.getTotalLength() + 0.1; // Need a small extra length to avoid remaining dot in Firefox.
                    legPath.style.strokeDasharray = legLength; // Just 1 length is enough, it will be duplicated.
                    legPath.style.strokeDashoffset = legLength;
                }
                // If it is a marker, add it now and we'll animate it out
                if (m.setZIndexOffset) m.setZIndexOffset(1000000); // Make normal markers appear on top of EVERYTHING
                if (m.clusterHide) m.clusterHide();
                // Vectors just get immediately added
                fg.addLayer(m);
                if (m._setPos) m._setPos(thisLayerPos);
            }
            group._forceLayout();
            group._animationStart();
            // Reveal markers and spider legs.
            for(i = childMarkers.length - 1; i >= 0; i--){
                newPos = map.layerPointToLatLng(positions[i]);
                m = childMarkers[i];
                //Move marker to new position
                m._preSpiderfyLatlng = m._latlng;
                m.setLatLng(newPos);
                if (m.clusterShow) m.clusterShow();
                // Animate leg (animation is actually delegated to CSS transition).
                if (svg) {
                    leg = m._spiderLeg;
                    legPath = leg._path;
                    legPath.style.strokeDashoffset = 0;
                    //legPath.style.strokeOpacity = finalLegOpacity;
                    leg.setStyle({
                        opacity: finalLegOpacity
                    });
                }
            }
            this.setOpacity(0.3);
            group._ignoreMove = false;
            setTimeout(function() {
                group._animationEnd();
                group.fire('spiderfied', {
                    cluster: me,
                    markers: childMarkers
                });
            }, 200);
        },
        _animationUnspiderfy: function(zoomDetails) {
            var me = this, group = this._group, map = group._map, fg = group._featureGroup, thisLayerPos = zoomDetails ? map._latLngToNewLayerPoint(this._latlng, zoomDetails.zoom, zoomDetails.center) : map.latLngToLayerPoint(this._latlng), childMarkers = this.getAllChildMarkers(null, true), svg = L.Path.SVG, m, i, leg, legPath, legLength, nonAnimatable;
            group._ignoreMove = true;
            group._animationStart();
            //Make us visible and bring the child markers back in
            this.setOpacity(1);
            for(i = childMarkers.length - 1; i >= 0; i--){
                m = childMarkers[i];
                //Marker was added to us after we were spiderfied
                if (!m._preSpiderfyLatlng) continue;
                //Close any popup on the marker first, otherwise setting the location of the marker will make the map scroll
                m.closePopup();
                //Fix up the location to the real one
                m.setLatLng(m._preSpiderfyLatlng);
                delete m._preSpiderfyLatlng;
                //Hack override the location to be our center
                nonAnimatable = true;
                if (m._setPos) {
                    m._setPos(thisLayerPos);
                    nonAnimatable = false;
                }
                if (m.clusterHide) {
                    m.clusterHide();
                    nonAnimatable = false;
                }
                if (nonAnimatable) fg.removeLayer(m);
                // Animate the spider leg back in (animation is actually delegated to CSS transition).
                if (svg) {
                    leg = m._spiderLeg;
                    legPath = leg._path;
                    legLength = legPath.getTotalLength() + 0.1;
                    legPath.style.strokeDashoffset = legLength;
                    leg.setStyle({
                        opacity: 0
                    });
                }
            }
            group._ignoreMove = false;
            setTimeout(function() {
                //If we have only <= one child left then that marker will be shown on the map so don't remove it!
                var stillThereChildCount = 0;
                for(i = childMarkers.length - 1; i >= 0; i--){
                    m = childMarkers[i];
                    if (m._spiderLeg) stillThereChildCount++;
                }
                for(i = childMarkers.length - 1; i >= 0; i--){
                    m = childMarkers[i];
                    if (!m._spiderLeg) continue;
                    if (m.clusterShow) m.clusterShow();
                    if (m.setZIndexOffset) m.setZIndexOffset(0);
                    if (stillThereChildCount > 1) fg.removeLayer(m);
                    map.removeLayer(m._spiderLeg);
                    delete m._spiderLeg;
                }
                group._animationEnd();
                group.fire('unspiderfied', {
                    cluster: me,
                    markers: childMarkers
                });
            }, 200);
        }
    });
    L.MarkerClusterGroup.include({
        //The MarkerCluster currently spiderfied (if any)
        _spiderfied: null,
        unspiderfy: function() {
            this._unspiderfy.apply(this, arguments);
        },
        _spiderfierOnAdd: function() {
            this._map.on('click', this._unspiderfyWrapper, this);
            if (this._map.options.zoomAnimation) this._map.on('zoomstart', this._unspiderfyZoomStart, this);
            //Browsers without zoomAnimation or a big zoom don't fire zoomstart
            this._map.on('zoomend', this._noanimationUnspiderfy, this);
            if (!L.Browser.touch) this._map.getRenderer(this);
        },
        _spiderfierOnRemove: function() {
            this._map.off('click', this._unspiderfyWrapper, this);
            this._map.off('zoomstart', this._unspiderfyZoomStart, this);
            this._map.off('zoomanim', this._unspiderfyZoomAnim, this);
            this._map.off('zoomend', this._noanimationUnspiderfy, this);
            //Ensure that markers are back where they should be
            // Use no animation to avoid a sticky leaflet-cluster-anim class on mapPane
            this._noanimationUnspiderfy();
        },
        //On zoom start we add a zoomanim handler so that we are guaranteed to be last (after markers are animated)
        //This means we can define the animation they do rather than Markers doing an animation to their actual location
        _unspiderfyZoomStart: function() {
            if (!this._map) return;
            this._map.on('zoomanim', this._unspiderfyZoomAnim, this);
        },
        _unspiderfyZoomAnim: function(zoomDetails) {
            //Wait until the first zoomanim after the user has finished touch-zooming before running the animation
            if (L.DomUtil.hasClass(this._map._mapPane, 'leaflet-touching')) return;
            this._map.off('zoomanim', this._unspiderfyZoomAnim, this);
            this._unspiderfy(zoomDetails);
        },
        _unspiderfyWrapper: function() {
            /// <summary>_unspiderfy but passes no arguments</summary>
            this._unspiderfy();
        },
        _unspiderfy: function(zoomDetails) {
            if (this._spiderfied) this._spiderfied.unspiderfy(zoomDetails);
        },
        _noanimationUnspiderfy: function() {
            if (this._spiderfied) this._spiderfied._noanimationUnspiderfy();
        },
        //If the given layer is currently being spiderfied then we unspiderfy it so it isn't on the map anymore etc
        _unspiderfyLayer: function(layer) {
            if (layer._spiderLeg) {
                this._featureGroup.removeLayer(layer);
                if (layer.clusterShow) layer.clusterShow();
                //Position will be fixed up immediately in _animationUnspiderfy
                if (layer.setZIndexOffset) layer.setZIndexOffset(0);
                this._map.removeLayer(layer._spiderLeg);
                delete layer._spiderLeg;
            }
        }
    });
    /**
	 * Adds 1 public method to MCG and 1 to L.Marker to facilitate changing
	 * markers' icon options and refreshing their icon and their parent clusters
	 * accordingly (case where their iconCreateFunction uses data of childMarkers
	 * to make up the cluster icon).
	 */ L.MarkerClusterGroup.include({
        /**
		 * Updates the icon of all clusters which are parents of the given marker(s).
		 * In singleMarkerMode, also updates the given marker(s) icon.
		 * @param layers L.MarkerClusterGroup|L.LayerGroup|Array(L.Marker)|Map(L.Marker)|
		 * L.MarkerCluster|L.Marker (optional) list of markers (or single marker) whose parent
		 * clusters need to be updated. If not provided, retrieves all child markers of this.
		 * @returns {L.MarkerClusterGroup}
		 */ refreshClusters: function(layers) {
            if (!layers) layers = this._topClusterLevel.getAllChildMarkers();
            else if (layers instanceof L.MarkerClusterGroup) layers = layers._topClusterLevel.getAllChildMarkers();
            else if (layers instanceof L.LayerGroup) layers = layers._layers;
            else if (layers instanceof L.MarkerCluster) layers = layers.getAllChildMarkers();
            else if (layers instanceof L.Marker) layers = [
                layers
            ];
             // else: must be an Array(L.Marker)|Map(L.Marker)
            this._flagParentsIconsNeedUpdate(layers);
            this._refreshClustersIcons();
            // In case of singleMarkerMode, also re-draw the markers.
            if (this.options.singleMarkerMode) this._refreshSingleMarkerModeMarkers(layers);
            return this;
        },
        /**
		 * Simply flags all parent clusters of the given markers as having a "dirty" icon.
		 * @param layers Array(L.Marker)|Map(L.Marker) list of markers.
		 * @private
		 */ _flagParentsIconsNeedUpdate: function(layers) {
            var id, parent;
            // Assumes layers is an Array or an Object whose prototype is non-enumerable.
            for(id in layers){
                // Flag parent clusters' icon as "dirty", all the way up.
                // Dumb process that flags multiple times upper parents, but still
                // much more efficient than trying to be smart and make short lists,
                // at least in the case of a hierarchy following a power law:
                // http://jsperf.com/flag-nodes-in-power-hierarchy/2
                parent = layers[id].__parent;
                while(parent){
                    parent._iconNeedsUpdate = true;
                    parent = parent.__parent;
                }
            }
        },
        /**
		 * Re-draws the icon of the supplied markers.
		 * To be used in singleMarkerMode only.
		 * @param layers Array(L.Marker)|Map(L.Marker) list of markers.
		 * @private
		 */ _refreshSingleMarkerModeMarkers: function(layers) {
            var id, layer;
            for(id in layers){
                layer = layers[id];
                // Make sure we do not override markers that do not belong to THIS group.
                if (this.hasLayer(layer)) // Need to re-create the icon first, then re-draw the marker.
                layer.setIcon(this._overrideMarkerIcon(layer));
            }
        }
    });
    L.Marker.include({
        /**
		 * Updates the given options in the marker's icon and refreshes the marker.
		 * @param options map object of icon options.
		 * @param directlyRefreshClusters boolean (optional) true to trigger
		 * MCG.refreshClustersOf() right away with this single marker.
		 * @returns {L.Marker}
		 */ refreshIconOptions: function(options, directlyRefreshClusters) {
            var icon = this.options.icon;
            L.setOptions(icon, options);
            this.setIcon(icon);
            // Shortcut to refresh the associated MCG clusters right away.
            // To be used when refreshing a single marker.
            // Otherwise, better use MCG.refreshClusters() once at the end with
            // the list of modified markers.
            if (directlyRefreshClusters && this.__parent) this.__parent._group.refreshClusters(this);
            return this;
        }
    });
    exports1.MarkerClusterGroup = MarkerClusterGroup;
    exports1.MarkerCluster = MarkerCluster;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


function $0e4b36871cb38152$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0e4b36871cb38152$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0e4b36871cb38152$var$_typeof(o);
}
var $0e4b36871cb38152$var$_excluded = [
    "children"
];
function $0e4b36871cb38152$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0e4b36871cb38152$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0e4b36871cb38152$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0e4b36871cb38152$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0e4b36871cb38152$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0e4b36871cb38152$var$_defineProperty(e, r, t) {
    return (r = $0e4b36871cb38152$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0e4b36871cb38152$var$_toPropertyKey(t) {
    var i = $0e4b36871cb38152$var$_toPrimitive(t, "string");
    return "symbol" == $0e4b36871cb38152$var$_typeof(i) ? i : i + "";
}
function $0e4b36871cb38152$var$_toPrimitive(t, r) {
    if ("object" != $0e4b36871cb38152$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0e4b36871cb38152$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0e4b36871cb38152$var$_slicedToArray(r, e) {
    return $0e4b36871cb38152$var$_arrayWithHoles(r) || $0e4b36871cb38152$var$_iterableToArrayLimit(r, e) || $0e4b36871cb38152$var$_unsupportedIterableToArray(r, e) || $0e4b36871cb38152$var$_nonIterableRest();
}
function $0e4b36871cb38152$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0e4b36871cb38152$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0e4b36871cb38152$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0e4b36871cb38152$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $0e4b36871cb38152$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $0e4b36871cb38152$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $0e4b36871cb38152$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $0e4b36871cb38152$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $0e4b36871cb38152$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $0e4b36871cb38152$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
(0, (/*@__PURE__*/$parcel$interopDefault($65d191346d2f0e85$exports))).MarkerClusterGroup.include({
    _flushLayerBuffer: function _flushLayerBuffer() {
        this.addLayers(this._layerBuffer);
        this._layerBuffer = [];
    },
    addLayer: function addLayer(layer) {
        if (this._layerBuffer.length === 0) setTimeout(this._flushLayerBuffer.bind(this), 50);
        this._layerBuffer.push(layer);
    }
});
(0, (/*@__PURE__*/$parcel$interopDefault($65d191346d2f0e85$exports))).MarkerClusterGroup.addInitHook(function() {
    this._layerBuffer = [];
});
function $0e4b36871cb38152$var$createMarkerCluster(_ref, context) {
    var _c = _ref.children, props = $0e4b36871cb38152$var$_objectWithoutProperties(_ref, $0e4b36871cb38152$var$_excluded);
    var clusterProps = {};
    var clusterEvents = {};
    // Splitting props and events to different objects
    Object.entries(props).forEach(function(_ref2) {
        var _ref3 = $0e4b36871cb38152$var$_slicedToArray(_ref2, 2), propName = _ref3[0], prop = _ref3[1];
        return propName.startsWith("on") ? clusterEvents[propName] = prop : clusterProps[propName] = prop;
    });
    var instance = new (0, (/*@__PURE__*/$parcel$interopDefault($65d191346d2f0e85$exports))).MarkerClusterGroup(clusterProps);
    // Initializing event listeners
    Object.entries(clusterEvents).forEach(function(_ref4) {
        var _ref5 = $0e4b36871cb38152$var$_slicedToArray(_ref4, 2), eventAsProp = _ref5[0], callback = _ref5[1];
        var clusterEvent = "cluster".concat(eventAsProp.substring(2).toLowerCase());
        instance.on(clusterEvent, callback);
    });
    return {
        instance: instance,
        context: $0e4b36871cb38152$var$_objectSpread($0e4b36871cb38152$var$_objectSpread({}, context), {}, {
            layerContainer: instance
        })
    };
}
var $0e4b36871cb38152$var$MarkerCluster = (0, $26087237d6669ee9$export$5e776dbe3c7d2790)($0e4b36871cb38152$var$createMarkerCluster);
var $0e4b36871cb38152$export$2e2bcd8739ae039 = $0e4b36871cb38152$var$MarkerCluster;




var $acw62 = parcelRequire("acw62");

function $ce276886dcf523ad$export$4864c54e62c27a47() {
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const { isPending: isPending, error: error, data: GStops } = (0, $4529664c1ee19d35$export$c3a687f3d6e3fb65)('stops');
    let MarkersStops = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    if (isPending || error || (Object.entries(GStops).length = 0)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    MarkersStops = Object.entries(GStops).map(([, GStop])=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a1862680e40c05e$export$1fa24f6e3d88c20c), {
            GStopId: GStop.stop_id,
            openPopup: tool.selection == GStop.stop_id,
            isDraggable: tool.selection === GStop.stop_id
        }, GStop.stop_id + (tool.selection === GStop.stop_id).toString());
    // React nie chciał rerednerować markera po zmianie kontekstu na przesuwalny, więc wymusiliśmy to zmianą klucza.
    // Rozwiązanie raczej prowizoryczne...
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e4b36871cb38152$export$2e2bcd8739ae039), {
        spiderfyOnMaxZoom: false,
        disableClusteringAtZoom: 17,
        children: MarkersStops
    });
}





const $e465b3fb8ee9e32a$export$520fbf7f9cbd232d = (0, $26087237d6669ee9$export$5e776dbe3c7d2790)(function createFeatureGroup({ children: _c, ...options }, ctx) {
    const group = new (0, $65d191346d2f0e85$exports.FeatureGroup)([], options);
    return (0, $c4349977e33cccc7$export$a080ff44e8067a44)(group, (0, $cbd94c399cef41ea$export$9efaf186a2224858)(ctx, {
        layerContainer: group,
        overlayContainer: group
    }));
});



const $5ee04e1ff3099aa1$export$79f3ee03e63e7073 = (0, $26087237d6669ee9$export$5e776dbe3c7d2790)(function createPolyline({ positions: positions, ...options }, ctx) {
    const polyline = new (0, $65d191346d2f0e85$exports.Polyline)(positions, options);
    return (0, $c4349977e33cccc7$export$a080ff44e8067a44)(polyline, (0, $cbd94c399cef41ea$export$9efaf186a2224858)(ctx, {
        overlayContainer: polyline
    }));
}, function updatePolyline(layer, props, prevProps) {
    if (props.positions !== prevProps.positions) layer.setLatLngs(props.positions);
});




var $acw62 = parcelRequire("acw62");

function $ae7fd79431624400$export$e42503de3d4e6844() {
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const map = (0, $8a64faf0323c3697$export$86f8f9f08863e403)();
    const GRoute = tool.propertyEditor.edit;
    const fgRef = (0, $acw62.useRef)(null);
    const Polylines = [];
    const { isPending: isPending, error: error, data: data } = (0, $4529664c1ee19d35$export$ac3dd26b67094cc3)('shapes/route', GRoute.route_id, 'both');
    /** nie rozumiem do końca, jak działa useMemo ani czy zależności dodane do tablicy są ok
     * (opierałem się na przykładach z dokumentacji), ale poniższy kod to handler eventu
     * wywoływanego po dodaniu FeatureGroup do mapy. Pozwala na wycentrowanie mapy na naszej trasie.
     */ const fgHandlers = (0, $acw62.useMemo)(()=>({
            add () {
                if (Polylines.length > 0) map.fitBounds(fgRef.current.getBounds());
            }
        }), [
        map,
        fgRef.current,
        Polylines
    ]);
    if (isPending || error || !data) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    const options = {
        color: '#' + GRoute.route_color,
        weight: 5,
        opacity: 1
    };
    const variantOptions = {
        color: '#' + GRoute.route_color,
        weight: 2,
        dashArray: [
            5,
            15
        ]
    };
    data.forEach((element)=>{
        let first = true;
        for (const [key, value] of Object.entries(element)){
            Polylines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ee04e1ff3099aa1$export$79f3ee03e63e7073), {
                positions: value,
                pathOptions: first ? options : variantOptions
            }, key));
            first = false;
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e465b3fb8ee9e32a$export$520fbf7f9cbd232d), {
        ref: fgRef,
        eventHandlers: fgHandlers,
        children: Polylines
    }, GRoute.route_id);
}






var $acw62 = parcelRequire("acw62");
const $3d11f925141a968e$export$28c660c63b792dea = (0, $26087237d6669ee9$export$7d18e209be943d7d)(function createTooltip(props, context) {
    const tooltip = new (0, $65d191346d2f0e85$exports.Tooltip)(props, context.overlayContainer);
    return (0, $c4349977e33cccc7$export$a080ff44e8067a44)(tooltip, context);
}, function useTooltipLifecycle(element, context, { position: position }, setOpen) {
    (0, $acw62.useEffect)(function addTooltip() {
        const container = context.overlayContainer;
        if (container == null) return;
        const { instance: instance } = element;
        const onTooltipOpen = (event)=>{
            if (event.tooltip === instance) {
                if (position != null) instance.setLatLng(position);
                instance.update();
                setOpen(true);
            }
        };
        const onTooltipClose = (event)=>{
            if (event.tooltip === instance) setOpen(false);
        };
        container.on({
            tooltipopen: onTooltipOpen,
            tooltipclose: onTooltipClose
        });
        container.bindTooltip(instance);
        return function removeTooltip() {
            container.off({
                tooltipopen: onTooltipOpen,
                tooltipclose: onTooltipClose
            });
            // @ts-ignore protected property
            if (container._map != null) container.unbindTooltip();
        };
    }, [
        element,
        context,
        setOpen,
        position
    ]);
});





var $acw62 = parcelRequire("acw62");

function $94a5511817a776c3$export$216f3d463081c189() {
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const map = (0, $8a64faf0323c3697$export$86f8f9f08863e403)();
    const GTrip = tool.selection;
    const fgRef = (0, $acw62.useRef)(null);
    const { isPending: stopsIsPending, error: stopsError, data: stopsData } = (0, $4529664c1ee19d35$export$ac3dd26b67094cc3)('trips', GTrip.trip_id, 'stop_times');
    const { isPending: shapeIsPending, error: shapeError, data: shapeData } = (0, $4529664c1ee19d35$export$ac3dd26b67094cc3)('shapes', GTrip.shape_id);
    const fgHandlers = (0, $acw62.useMemo)(()=>({
            add () {
                map.fitBounds(fgRef.current.getBounds());
            }
        }), [
        map,
        fgRef.current
    ]);
    if (shapeIsPending || shapeError || !shapeData || stopsIsPending || stopsError || !stopsData) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    const divStopIcon = new (0, $65d191346d2f0e85$exports.DivIcon)({
        className: 'trip-stop-marker'
    });
    console.log('stopsData', stopsData);
    const TripPolyline = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ee04e1ff3099aa1$export$79f3ee03e63e7073), {
        positions: shapeData
    }, GTrip.shape_id);
    const StopsMarkers = stopsData.map((stopTime, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d30568f206d68912$export$e98856a975cab58e), {
            position: [
                stopTime.stop_lat,
                stopTime.stop_lon
            ],
            icon: divStopIcon,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3d11f925141a968e$export$28c660c63b792dea), {
                children: [
                    index,
                    ". [",
                    stopTime.arrival_time === stopTime.departure_time ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: stopTime.departure_time
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            stopTime.arrival_time,
                            " \u2014 ",
                            stopTime.departure_time
                        ]
                    }),
                    "]\xa0",
                    stopTime.stop_name
                ]
            })
        }, stopTime.stop_sequence));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e465b3fb8ee9e32a$export$520fbf7f9cbd232d), {
        ref: fgRef,
        eventHandlers: fgHandlers,
        children: [
            TripPolyline,
            StopsMarkers
        ]
    }, GTrip.trip_id);
}







var $acw62 = parcelRequire("acw62");

function $3df033c1d98da9b8$export$fda25ac98c28c075() {
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const { isPending: isPending, error: error, data: GStops } = (0, $4529664c1ee19d35$export$c3a687f3d6e3fb65)('stops');
    let MarkersStops = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    if (isPending || error || (Object.entries(GStops).length = 0)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    MarkersStops = Object.entries(GStops).map(([, GStop])=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a1862680e40c05e$export$1fa24f6e3d88c20c), {
            GStopId: GStop.stop_id,
            openPopup: tool.selection == GStop.stop_id,
            isDraggable: tool.selection === GStop.stop_id
        }, GStop.stop_id + (tool.selection === GStop.stop_id).toString());
    // React nie chciał rerednerować markera po zmianie kontekstu na przesuwalny, więc wymusiliśmy to zmianą klucza.
    // Rozwiązanie raczej prowizoryczne...
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e4b36871cb38152$export$2e2bcd8739ae039), {
        spiderfyOnMaxZoom: false,
        disableClusteringAtZoom: 17,
        children: MarkersStops
    });
}


function $86f5942de4db652c$export$a5c7b93649eaf8f8() {
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    let Layers = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    switch(tool.name){
        case 'stopsTool':
            Layers = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce276886dcf523ad$export$4864c54e62c27a47), {});
            break;
        case 'routesTool':
            if (tool.propertyEditor) Layers = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae7fd79431624400$export$e42503de3d4e6844), {});
            else Layers = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
            break;
        case 'tripsTool':
            if (tool.selection) Layers = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94a5511817a776c3$export$216f3d463081c189), {});
            break;
        case 'segmentsTool':
            Layers = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3df033c1d98da9b8$export$fda25ac98c28c075), {});
            break;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ee011fc978fcb926$export$23f3dfd47374502b), {
        center: [
            54.464441078,
            17.020304345
        ],
        zoom: 13,
        style: {
            height: '89vh',
            width: '100%'
        },
        preferCanvas: true,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35109d75658c2839$export$f52ee31d61d0b27b), {
                attribution: '\xa9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            }),
            Layers,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $335adba5521801cb$export$b59922a98a716877), {})
        ]
    });
}









var $acw62 = parcelRequire("acw62");















var $acw62 = parcelRequire("acw62");












'use client';
function $003b4fc9f8cc5a16$var$_extends() {
    return $003b4fc9f8cc5a16$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $003b4fc9f8cc5a16$var$_extends.apply(null, arguments);
}
function $003b4fc9f8cc5a16$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $003b4fc9f8cc5a16$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $003b4fc9f8cc5a16$var$_typeof(o);
}
function $003b4fc9f8cc5a16$var$toPrimitive(t, r) {
    if ("object" != $003b4fc9f8cc5a16$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $003b4fc9f8cc5a16$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $003b4fc9f8cc5a16$var$toPropertyKey(t) {
    var i = $003b4fc9f8cc5a16$var$toPrimitive(t, "string");
    return "symbol" == $003b4fc9f8cc5a16$var$_typeof(i) ? i : i + "";
}
function $003b4fc9f8cc5a16$var$_defineProperty(e, r, t) {
    return (r = $003b4fc9f8cc5a16$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $003b4fc9f8cc5a16$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $003b4fc9f8cc5a16$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $003b4fc9f8cc5a16$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $003b4fc9f8cc5a16$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $003b4fc9f8cc5a16$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $003b4fc9f8cc5a16$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $003b4fc9f8cc5a16$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $003b4fc9f8cc5a16$var$_slicedToArray(r, e) {
    return $003b4fc9f8cc5a16$var$_arrayWithHoles(r) || $003b4fc9f8cc5a16$var$_iterableToArrayLimit(r, e) || $003b4fc9f8cc5a16$var$_unsupportedIterableToArray(r, e) || $003b4fc9f8cc5a16$var$_nonIterableRest();
}
var $003b4fc9f8cc5a16$var$classes$1 = {
    root: function root(_ref) {
        var props = _ref.props, context = _ref.context;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-tieredmenu p-component', {
            'p-tieredmenu-overlay': props.popup,
            'p-input-filled': context && context.inputStyle === 'filled' || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).inputStyle === 'filled',
            'p-ripple-disabled': context && context.ripple === false || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).ripple === false
        });
    },
    separator: 'p-menuitem-separator',
    icon: function icon(_ref2) {
        var _icon = _ref2._icon;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-menuitem-icon', _icon);
    },
    content: 'p-menuitem-content',
    label: 'p-menuitem-text',
    submenuIcon: 'p-submenu-icon',
    action: 'p-menuitem-link',
    menuitem: function menuitem(_ref3) {
        var itemClassName = _ref3.itemClassName, active = _ref3.active, focused = _ref3.focused, disabled = _ref3.disabled;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-menuitem', {
            'p-menuitem-active p-highlight': active,
            'p-focus': focused,
            'p-disabled': disabled
        }, itemClassName);
    },
    menu: 'p-tieredmenu-root-list',
    submenu: 'p-submenu-list',
    transition: 'p-connected-overlay'
};
var $003b4fc9f8cc5a16$var$inlineStyles = {
    submenu: function submenu(_ref4) {
        var props = _ref4.subProps;
        return {
            display: !props.root && props.parentActive ? 'block' : 'none'
        };
    }
};
var $003b4fc9f8cc5a16$var$styles$1 = "\n@layer primereact {\n    .p-tieredmenu-overlay {\n        position: absolute;\n    }\n\n    .p-tieredmenu ul {\n        margin: 0;\n        padding: 0;\n        list-style: none;\n    }\n\n    .p-tieredmenu .p-submenu-list {\n        position: absolute;\n        min-width: 100%;\n        z-index: 1;\n        display: none;\n    }\n\n    .p-tieredmenu .p-menuitem-link {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        text-decoration: none;\n        overflow: hidden;\n        position: relative;\n    }\n\n    .p-tieredmenu .p-menuitem-text {\n        line-height: 1;\n    }\n\n    .p-tieredmenu .p-menuitem {\n        position: relative;\n    }\n\n    .p-tieredmenu .p-menuitem-link .p-submenu-icon {\n        margin-left: auto;\n    }\n\n    .p-tieredmenu .p-menuitem-active > .p-submenu-list {\n        display: block;\n        left: 100%;\n        top: 0;\n    }\n\n    .p-tieredmenu .p-menuitem-active > .p-submenu-list-flipped {\n        left: -100%;\n    }\n}\n";
var $003b4fc9f8cc5a16$var$TieredMenuBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'TieredMenu',
        __parentMetadata: null,
        id: null,
        model: null,
        popup: false,
        style: null,
        className: null,
        autoZIndex: true,
        baseZIndex: 0,
        breakpoint: undefined,
        scrollHeight: '400px',
        appendTo: null,
        transitionOptions: null,
        onShow: null,
        onFocus: null,
        onBlur: null,
        onHide: null,
        submenuIcon: null,
        children: undefined
    },
    css: {
        classes: $003b4fc9f8cc5a16$var$classes$1,
        styles: $003b4fc9f8cc5a16$var$styles$1,
        inlineStyles: $003b4fc9f8cc5a16$var$inlineStyles
    }
});
function $003b4fc9f8cc5a16$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $003b4fc9f8cc5a16$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $003b4fc9f8cc5a16$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $003b4fc9f8cc5a16$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $003b4fc9f8cc5a16$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $003b4fc9f8cc5a16$var$TieredMenuSub = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var elementRef = $acw62.useRef(null);
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var ptm = props.ptm, cx = props.cx, sx = props.sx;
    var getPTOptions = function getPTOptions(item, key) {
        return ptm(key, {
            hostName: props.hostName,
            context: {
                active: isItemActive(item)
            }
        });
    };
    var position = function position() {
        if (elementRef.current) {
            var parentItem = elementRef.current.parentElement;
            var containerOffset = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOffset(parentItem);
            var viewport = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getViewport();
            var sublistWidth = elementRef.current.offsetParent ? elementRef.current.offsetWidth : (0, $a73ce425265b079e$export$ff8ccbac9225de62).getHiddenElementOuterWidth(elementRef.current);
            var itemOuterWidth = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(parentItem.children[0]);
            var top = parseInt(containerOffset.top, 10) + elementRef.current.offsetHeight - (0, $a73ce425265b079e$export$ff8ccbac9225de62).getWindowScrollTop();
            if (top > viewport.height) elementRef.current.style.top = viewport.height - top + 'px';
            else elementRef.current.style.top = '0px';
            if (parseInt(containerOffset.left, 10) + itemOuterWidth + sublistWidth > viewport.width - (0, $a73ce425265b079e$export$ff8ccbac9225de62).calculateScrollbarWidth()) (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(elementRef.current, 'p-submenu-list-flipped');
        }
    };
    var onItemClick = function onItemClick(event1, processedItem) {
        var item = processedItem.item;
        if (isItemDisabled(processedItem)) {
            event1.preventDefault();
            return;
        }
        if (item.command) item.command({
            originalEvent: event1,
            item: item
        });
        props.onItemClick && props.onItemClick({
            originalEvent: event1,
            processedItem: processedItem
        });
        if (!item.url) {
            event1.preventDefault();
            event1.stopPropagation();
        }
    };
    var getItemId = function getItemId(processedItem) {
        return "".concat(props.menuId, "_").concat(processedItem.key);
    };
    var getItemProp = function getItemProp(processedItem, name, params) {
        return processedItem && processedItem.item ? (0, $a73ce425265b079e$export$4855211e6b8ad895).getItemValue(processedItem.item[name], params) : undefined;
    };
    var isItemActive = function isItemActive(processedItem) {
        return props.activeItemPath.some(function(path) {
            return path.key === processedItem.key;
        });
    };
    var isItemVisible = function isItemVisible(processedItem) {
        return getItemProp(processedItem, 'visible') !== false;
    };
    var isItemDisabled = function isItemDisabled(processedItem) {
        return getItemProp(processedItem, 'disabled');
    };
    var isItemFocused = function isItemFocused(processedItem) {
        return props.focusedItemId === getItemId(processedItem);
    };
    var isItemGroup = function isItemGroup(processedItem) {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(processedItem.items);
    };
    var onItemMouseEnter = function onItemMouseEnter(event1, processedItem) {
        props.onItemMouseEnter && props.onItemMouseEnter({
            originalEvent: event1,
            processedItem: processedItem
        });
    };
    var getAriaSetSize = function getAriaSetSize() {
        return props.model.filter(function(processedItem) {
            return isItemVisible(processedItem) && !getItemProp(processedItem, 'separator');
        }).length;
    };
    var getAriaPosInset = function getAriaPosInset(index) {
        return index - props.model.slice(0, index).filter(function(processedItem) {
            return isItemVisible(processedItem) && getItemProp(processedItem, 'separator');
        }).length + 1;
    };
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (!props.root && props.parentActive && !props.isMobileMode) position();
    }, [
        props.parentActive
    ]);
    $acw62.useImperativeHandle(ref, function() {
        return {
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var createSeparator = function createSeparator(index) {
        var key = 'separator_' + index;
        var separatorProps = mergeProps({
            key: key,
            className: cx('separator'),
            role: 'separator'
        }, ptm('separator', {
            hostName: props.hostName
        }));
        return /*#__PURE__*/ $acw62.createElement("li", separatorProps);
    };
    var createSubmenu = function createSubmenu(processedItem, index) {
        if (isItemGroup(processedItem)) return /*#__PURE__*/ $acw62.createElement($003b4fc9f8cc5a16$var$TieredMenuSub, {
            id: props.id + '_' + index,
            menuProps: props.menuProps,
            model: processedItem.items,
            menuId: props.menuId,
            ariaLabelledby: getItemId(processedItem),
            focusedItemId: props.focusedItemId,
            activeItemPath: props.activeItemPath,
            level: props.level + 1,
            onItemClick: props.onItemClick,
            popup: props.popup,
            onItemMouseEnter: props.onItemMouseEnter,
            parentActive: isItemActive(processedItem),
            isMobileMode: props.isMobileMode,
            submenuIcon: props.submenuIcon,
            ptm: props.ptm,
            cx: cx,
            sx: sx
        });
        return null;
    };
    var createMenuItem = function createMenuItem(processedItem, index) {
        if (isItemVisible(processedItem) === false) return null;
        var item = processedItem.item;
        var style = getItemProp(processedItem, 'style');
        var itemClassName = getItemProp(processedItem, 'className');
        var _icon = getItemProp(processedItem, 'icon');
        var target = getItemProp(processedItem, 'target');
        var url = getItemProp(processedItem, 'url');
        var key = getItemId(processedItem);
        var focused = isItemFocused(processedItem);
        var active = isItemActive(processedItem);
        var disabled = isItemDisabled(processedItem);
        var grouped = isItemGroup(processedItem);
        var linkClassName = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-menuitem-link');
        var iconClassName = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-menuitem-icon', _icon);
        var iconProps = mergeProps({
            className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(item.icon, 'p-menuitem-icon', 'icon')
        }, getPTOptions(processedItem, 'icon'));
        var icon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(_icon, $003b4fc9f8cc5a16$var$_objectSpread$2({}, iconProps), {
            props: props.menuProps
        });
        var labelProps = mergeProps({
            className: cx('label')
        }, getPTOptions(processedItem, 'label'));
        var label = item.label && /*#__PURE__*/ $acw62.createElement("span", labelProps, item.label);
        var submenuIconClassName = 'p-submenu-icon';
        var submenuIconProps = mergeProps({
            className: cx('submenuIcon')
        }, getPTOptions(processedItem, 'submenuIcon'));
        var submenuIcon = grouped && (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(props.submenuIcon || /*#__PURE__*/ $acw62.createElement((0, $e73ad5d038623fb5$export$f5db305c33b6241b), submenuIconProps), $003b4fc9f8cc5a16$var$_objectSpread$2({}, submenuIconProps), {
            props: props.menuProps
        });
        var submenu = createSubmenu(processedItem, index);
        var actionProps = mergeProps({
            href: url || '#',
            'aria-hidden': true,
            tabIndex: '-1',
            onFocus: function onFocus(event1) {
                return event1.stopPropagation();
            },
            className: cx('action'),
            target: target
        }, getPTOptions(processedItem, 'action'));
        var content = /*#__PURE__*/ $acw62.createElement("a", actionProps, icon, label, submenuIcon, /*#__PURE__*/ $acw62.createElement((0, $8e3aa2f039797217$export$9e9146f7e027fdaa), null));
        if (item.template) {
            var defaultContentOptions = {
                className: linkClassName,
                labelClassName: 'p-menuitem-text',
                iconClassName: iconClassName,
                submenuIconClassName: submenuIconClassName,
                element: content,
                props: props,
                active: active,
                disabled: disabled
            };
            content = (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(item.template, item, defaultContentOptions);
        }
        var contentProps = mergeProps({
            onClick: function onClick(event1) {
                return onItemClick(event1, processedItem);
            },
            onMouseEnter: function onMouseEnter(event1) {
                return onItemMouseEnter(event1, processedItem);
            },
            className: cx('content')
        }, getPTOptions(processedItem, 'content'));
        var menuitemProps = mergeProps({
            key: key,
            id: key,
            'aria-label': item.label,
            'aria-disabled': disabled,
            'aria-expanded': grouped ? active : undefined,
            'aria-haspopup': grouped && !url ? 'menu' : undefined,
            'aria-setsize': getAriaSetSize(),
            'aria-posinset': getAriaPosInset(index),
            'data-p-highlight': active,
            'data-p-disabled': disabled,
            'data-p-visited': focused,
            className: cx('menuitem', {
                itemClassName: itemClassName,
                active: active,
                focused: focused,
                disabled: disabled
            }),
            style: style,
            onMouseEnter: function onMouseEnter(event1) {
                return onItemMouseEnter(event1, item);
            },
            role: 'menuitem'
        }, getPTOptions(processedItem, 'menuitem'));
        return /*#__PURE__*/ $acw62.createElement("li", menuitemProps, /*#__PURE__*/ $acw62.createElement("div", contentProps, content), submenu);
    };
    var createItem = function createItem(processedItem, index) {
        if (processedItem.visible === false) return null;
        return getItemProp(processedItem, 'separator') ? createSeparator(index) : createMenuItem(processedItem, index);
    };
    var createMenu = function createMenu() {
        return props.model ? props.model.map(createItem) : null;
    };
    var submenu = createMenu();
    var ptKey = props.root ? 'menu' : 'submenu';
    var menuProps = mergeProps({
        ref: elementRef,
        id: props.id,
        tabIndex: props.tabIndex,
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        onKeyDown: props.onKeyDown,
        className: cx(ptKey, {
            subProps: props
        }),
        style: sx(ptKey, {
            subProps: props
        }),
        role: props.root ? 'menubar' : 'menu',
        'aria-label': props.ariaLabel,
        'aria-labelledby': props.ariaLabelledby,
        'aria-orientation': props.ariaOrientation,
        'aria-activedescendant': props.focusedItemId
    }, ptm(ptKey, {
        hostName: props.hostName
    }));
    return /*#__PURE__*/ $acw62.createElement("ul", menuProps, submenu);
}));
$003b4fc9f8cc5a16$var$TieredMenuSub.displayName = 'TieredMenuSub';
function $003b4fc9f8cc5a16$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $003b4fc9f8cc5a16$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $003b4fc9f8cc5a16$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $003b4fc9f8cc5a16$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $003b4fc9f8cc5a16$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $003b4fc9f8cc5a16$var$TieredMenu = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $003b4fc9f8cc5a16$var$TieredMenuBase.getProps(inProps, context);
    var _React$useState = $acw62.useState(props.id), _React$useState2 = $003b4fc9f8cc5a16$var$_slicedToArray(_React$useState, 2), idState = _React$useState2[0], setIdState = _React$useState2[1];
    var _React$useState3 = $acw62.useState(!props.popup), _React$useState4 = $003b4fc9f8cc5a16$var$_slicedToArray(_React$useState3, 2), visibleState = _React$useState4[0], setVisibleState = _React$useState4[1];
    var _React$useState5 = $acw62.useState([]), _React$useState6 = $003b4fc9f8cc5a16$var$_slicedToArray(_React$useState5, 2), activeItemPath = _React$useState6[0], setActiveItemPath = _React$useState6[1];
    var _React$useState7 = $acw62.useState(false), _React$useState8 = $003b4fc9f8cc5a16$var$_slicedToArray(_React$useState7, 2), focused = _React$useState8[0], setFocused = _React$useState8[1];
    var _React$useState9 = $acw62.useState(null), _React$useState10 = $003b4fc9f8cc5a16$var$_slicedToArray(_React$useState9, 2), focusedItemId = _React$useState10[0], setFocusedItemId = _React$useState10[1];
    var _React$useState11 = $acw62.useState({
        index: -1,
        level: 0,
        parentKey: ''
    }), _React$useState12 = $003b4fc9f8cc5a16$var$_slicedToArray(_React$useState11, 2), focusedItemInfo = _React$useState12[0], setFocusedItemInfo = _React$useState12[1];
    var _React$useState13 = $acw62.useState(false), _React$useState14 = $003b4fc9f8cc5a16$var$_slicedToArray(_React$useState13, 2), dirty = _React$useState14[0], setDirty = _React$useState14[1];
    var _React$useState15 = $acw62.useState([]), _React$useState16 = $003b4fc9f8cc5a16$var$_slicedToArray(_React$useState15, 2), processedItems = _React$useState16[0], setProcessedItems = _React$useState16[1];
    var _React$useState17 = $acw62.useState([]), _React$useState18 = $003b4fc9f8cc5a16$var$_slicedToArray(_React$useState17, 2), visibleItems = _React$useState18[0], setVisibleItems = _React$useState18[1];
    var _React$useState19 = $acw62.useState(false), _React$useState20 = $003b4fc9f8cc5a16$var$_slicedToArray(_React$useState19, 2), focusTrigger = _React$useState20[0], setFocusTrigger = _React$useState20[1];
    var _React$useState21 = $acw62.useState(null), _React$useState22 = $003b4fc9f8cc5a16$var$_slicedToArray(_React$useState21, 2), attributeSelectorState = _React$useState22[0], setAttributeSelectorState = _React$useState22[1];
    var metaData = $003b4fc9f8cc5a16$var$_objectSpread$1($003b4fc9f8cc5a16$var$_objectSpread$1({
        props: props
    }, props.__parentMetadata), {}, {
        state: {
            id: idState,
            visible: visibleState,
            attributeSelector: attributeSelectorState
        }
    });
    var _TieredMenuBase$setMe = $003b4fc9f8cc5a16$var$TieredMenuBase.setMetaData(metaData), ptm = _TieredMenuBase$setMe.ptm, cx = _TieredMenuBase$setMe.cx, sx = _TieredMenuBase$setMe.sx, isUnstyled = _TieredMenuBase$setMe.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($003b4fc9f8cc5a16$var$TieredMenuBase.css.styles, isUnstyled, {
        name: 'tieredmenu'
    });
    var containerRef = $acw62.useRef(null);
    var menuRef = $acw62.useRef(null);
    var targetRef = $acw62.useRef(null);
    var relatedTarget = $acw62.useRef(null);
    var styleElementRef = $acw62.useRef(null);
    var searchValue = $acw62.useRef(null);
    var searchTimeout = $acw62.useRef(null);
    var isMobileMode = (0, $fbdf1e36fa0a01d8$export$dd42f485803cd57d)("screen and (max-width: ".concat(props.breakpoint, ")"), !!props.breakpoint);
    var _useEventListener = (0, $fbdf1e36fa0a01d8$export$7080b3e976bc91ab)({
        type: 'click',
        listener: function listener(event1) {
            var isOutsideContainer = containerRef.current && !containerRef.current.contains(event1.target);
            var isOutsideTarget = props.popup ? !(targetRef.current && (targetRef.current === event1.target || targetRef.current.contains(event1.target))) : true;
            if (isOutsideContainer && isOutsideTarget) hide(event1, !props.popup);
        }
    }), _useEventListener2 = $003b4fc9f8cc5a16$var$_slicedToArray(_useEventListener, 2), bindDocumentClickListener = _useEventListener2[0], unbindDocumentClickListener = _useEventListener2[1];
    var _useResizeListener = (0, $fbdf1e36fa0a01d8$export$158eb97be50d41ef)({
        listener: function listener() {
            !isMobileMode && hide(event, true);
        }
    }), _useResizeListener2 = $003b4fc9f8cc5a16$var$_slicedToArray(_useResizeListener, 2), bindDocumentResizeListener = _useResizeListener2[0], unbindDocumentResizeListener = _useResizeListener2[1];
    var onPanelClick = function onPanelClick(event1) {
        if (props.popup) (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).emit('overlay-click', {
            originalEvent: event1,
            target: targetRef.current
        });
    };
    var toggle = function toggle(event1) {
        if (props.popup) visibleState ? hide(event1) : show(event1);
    };
    var show = function show(event1) {
        if (props.popup) {
            targetRef.current = event1.currentTarget;
            setVisibleState(true);
            props.onShow && props.onShow(event1);
            relatedTarget.current = event1.relatedTarget || null;
        }
        setFocusedItemInfo({
            index: findFirstFocusedItemIndex(),
            level: 0,
            parentKey: ''
        });
    };
    var hide = function hide(event1, isFocus) {
        if (props.popup) {
            setVisibleState(false);
            props.onHide && props.onHide(event1);
        }
        var menuElement = getMenuElement();
        setActiveItemPath([]);
        setFocusedItemInfo({
            index: -1,
            level: 0,
            parentKey: ''
        });
        isFocus && (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(relatedTarget.current || targetRef.current || menuElement);
        setDirty(false);
    };
    var onFocus = function onFocus(event1) {
        setFocused(true);
        setFocusedItemInfo(focusedItemInfo.index !== -1 ? focusedItemInfo : {
            index: findFirstFocusedItemIndex(),
            level: 0,
            parentKey: ''
        });
        props.onFocus && props.onFocus(event1);
    };
    var onBlur = function onBlur(event1) {
        setFocused(false);
        setFocusedItemInfo({
            index: -1,
            level: 0,
            parentKey: ''
        });
        searchValue.current = '';
        setDirty(false);
        props.onBlur && props.onBlur(event1);
    };
    var onKeyDown = function onKeyDown(event1) {
        var metaKey = event1.metaKey || event1.ctrlKey;
        switch(event1.code){
            case 'ArrowDown':
                onArrowDownKey(event1);
                break;
            case 'ArrowUp':
                onArrowUpKey(event1);
                break;
            case 'ArrowLeft':
                onArrowLeftKey(event1);
                break;
            case 'ArrowRight':
                onArrowRightKey(event1);
                break;
            case 'Home':
                onHomeKey(event1);
                break;
            case 'End':
                onEndKey(event1);
                break;
            case 'Space':
                onSpaceKey(event1);
                break;
            case 'Enter':
            case 'NumpadEnter':
                onEnterKey(event1);
                break;
            case 'Escape':
                props.popup && (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(targetRef.current);
                onEscapeKey(event1);
                break;
            case 'Tab':
                onTabKey(event1);
                break;
            case 'PageDown':
            case 'PageUp':
            case 'Backspace':
            case 'ShiftLeft':
            case 'ShiftRight':
                break;
            default:
                if (!metaKey && (0, $a73ce425265b079e$export$4855211e6b8ad895).isPrintableCharacter(event1.key)) searchItems(event1.key);
                break;
        }
    };
    var onItemChange = function onItemChange(event1) {
        var processedItem = event1.processedItem, isFocus = event1.isFocus;
        if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isEmpty(processedItem)) return;
        var index = processedItem.index, key = processedItem.key, level = processedItem.level, parentKey = processedItem.parentKey, items = processedItem.items;
        var grouped = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(items);
        var _activeItemPath = activeItemPath.filter(function(p) {
            return p.parentKey !== parentKey && p.parentKey !== key;
        });
        if (grouped) _activeItemPath.push(processedItem);
        setFocusedItemInfo({
            index: index,
            level: level,
            parentKey: parentKey
        });
        setActiveItemPath(_activeItemPath);
        grouped && setDirty(true);
        isFocus && (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(getMenuElement());
    };
    var onItemClick = function onItemClick(event1) {
        var originalEvent = event1.originalEvent, processedItem = event1.processedItem;
        if (isItemDisabled(processedItem) || props.isMobileMode) return;
        var grouped = isProccessedItemGroup(processedItem);
        var root = (0, $a73ce425265b079e$export$4855211e6b8ad895).isEmpty(processedItem.parent);
        var selected = isSelected(processedItem);
        var menuElement = getMenuElement();
        if (selected) {
            var index = processedItem.index, key = processedItem.key, level = processedItem.level, parentKey = processedItem.parentKey;
            setActiveItemPath(activeItemPath.filter(function(p) {
                return key !== p.key && key.startsWith(p.key);
            }));
            setFocusedItemInfo({
                index: index,
                level: level,
                parentKey: parentKey
            });
            if (!grouped) setDirty(!root);
            setTimeout(function() {
                (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(menuElement);
                if (grouped) setDirty(true);
            }, 0);
        } else if (grouped) {
            (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(menuElement);
            onItemChange(event1);
        } else {
            var rootProcessedItem = root ? processedItem : activeItemPath.find(function(p) {
                return p.parentKey === '';
            });
            var rootProcessedItemIndex = rootProcessedItem ? rootProcessedItem.index : -1;
            hide(originalEvent, true);
            setFocusedItemInfo({
                index: rootProcessedItemIndex,
                parentKey: rootProcessedItem ? rootProcessedItem.parentKey : ''
            });
        }
    };
    var onItemMouseEnter = function onItemMouseEnter(event1) {
        var originalEvent = event1.originalEvent, processedItem = event1.processedItem;
        if (isItemDisabled(processedItem) || props.isMobileMode) {
            originalEvent.preventDefault();
            return;
        }
        if (dirty && !props.popup) onItemChange(event1);
    };
    var onArrowDownKey = function onArrowDownKey(event1) {
        var itemIndex = focusedItemInfo.index !== -1 ? findNextItemIndex(focusedItemInfo.index) : findFirstFocusedItemIndex();
        changeFocusedItemIndex(itemIndex);
        event1.preventDefault();
    };
    var onArrowUpKey = function onArrowUpKey(event1) {
        if (event1.altKey) {
            if (props.popup) (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(targetRef.current);
            if (focusedItemInfo.index !== -1) {
                var processedItem = visibleItems[focusedItemInfo.index];
                var grouped = isProccessedItemGroup(processedItem);
                !grouped && onItemChange({
                    originalEvent: event1,
                    processedItem: processedItem
                });
            }
            props.popup && hide(event1, true);
            event1.preventDefault();
        } else {
            var itemIndex = focusedItemInfo.index !== -1 ? findPrevItemIndex(focusedItemInfo.index) : findLastFocusedItemIndex();
            changeFocusedItemIndex(itemIndex);
            event1.preventDefault();
        }
    };
    var onArrowLeftKey = function onArrowLeftKey(event1) {
        var processedItem = visibleItems[focusedItemInfo.index];
        var parentItem = activeItemPath.find(function(p) {
            return p.key === processedItem.parentKey;
        });
        var root = (0, $a73ce425265b079e$export$4855211e6b8ad895).isEmpty(processedItem.parent);
        if (!root) {
            setFocusedItemInfo({
                index: -1,
                parentKey: parentItem ? parentItem.parentKey : ''
            });
            searchValue.current = '';
            setTimeout(function() {
                return setFocusTrigger(true);
            }, 0);
        }
        setActiveItemPath(activeItemPath.filter(function(p) {
            return p.parentKey !== focusedItemInfo.parentKey;
        }));
        event1.preventDefault();
    };
    var onArrowRightKey = function onArrowRightKey(event1) {
        var processedItem = visibleItems[focusedItemInfo.index];
        var grouped = isProccessedItemGroup(processedItem);
        if (grouped) {
            onItemChange({
                originalEvent: event1,
                processedItem: processedItem
            });
            setFocusedItemInfo({
                index: -1,
                parentKey: processedItem.key
            });
            searchValue.current = '';
            setTimeout(function() {
                return setFocusTrigger(true);
            }, 0);
        }
        event1.preventDefault();
    };
    var onHomeKey = function onHomeKey(event1) {
        changeFocusedItemIndex(findFirstItemIndex());
        event1.preventDefault();
    };
    var onEndKey = function onEndKey(event1) {
        changeFocusedItemIndex(findLastItemIndex());
        event1.preventDefault();
    };
    var onEnterKey = function onEnterKey(event1) {
        if (focusedItemInfo.index !== -1) {
            var _element = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(getMenuElement(), "li[id=\"".concat("".concat(focusedItemId), "\"]"));
            var anchorElement = _element && (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(_element, '[data-pc-section="action"]');
            props.popup && (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(targetRef.current);
            anchorElement ? anchorElement.click() : _element && _element.click();
        }
        event1.preventDefault();
    };
    var onSpaceKey = function onSpaceKey(event1) {
        onEnterKey(event1);
    };
    var onEscapeKey = function onEscapeKey(event1) {
        hide(event1, true);
        !props.popup && setFocusedItemInfo($003b4fc9f8cc5a16$var$_objectSpread$1($003b4fc9f8cc5a16$var$_objectSpread$1({}, focusedItemInfo), {}, {
            index: findFirstFocusedItemIndex()
        }));
        event1.preventDefault();
    };
    var onTabKey = function onTabKey(event1) {
        if (focusedItemInfo.index !== -1) {
            var processedItem = visibleItems[focusedItemInfo.index];
            var grouped = isProccessedItemGroup(processedItem);
            !grouped && onItemChange({
                originalEvent: event1,
                processedItem: processedItem
            });
        }
        hide(event1);
    };
    var getMenuElement = function getMenuElement() {
        return menuRef.current.getElement() || null;
    };
    var getItemProp = function getItemProp(item, name) {
        return item ? (0, $a73ce425265b079e$export$4855211e6b8ad895).getItemValue(item[name]) : undefined;
    };
    var getItemLabel = function getItemLabel(item) {
        return getItemProp(item, 'label');
    };
    var isItemDisabled = function isItemDisabled(item) {
        return getItemProp(item, 'disabled');
    };
    var isItemSeparator = function isItemSeparator(item) {
        return getItemProp(item, 'separator');
    };
    var getProccessedItemLabel = function getProccessedItemLabel(processedItem) {
        return processedItem ? getItemLabel(processedItem.item) : undefined;
    };
    var isProccessedItemGroup = function isProccessedItemGroup(processedItem) {
        return processedItem && (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(processedItem.items);
    };
    var isItemMatched = function isItemMatched(processedItem) {
        return isValidItem(processedItem) && getProccessedItemLabel(processedItem).toLocaleLowerCase().startsWith(searchValue.current.toLocaleLowerCase());
    };
    var isValidItem = function isValidItem(processedItem) {
        return !!processedItem && !isItemDisabled(processedItem.item) && !isItemSeparator(processedItem.item);
    };
    var isValidSelectedItem = function isValidSelectedItem(processedItem) {
        return isValidItem(processedItem) && isSelected(processedItem);
    };
    var isSelected = function isSelected(processedItem) {
        return activeItemPath.some(function(p) {
            return p.key === processedItem.key;
        });
    };
    var findFirstItemIndex = function findFirstItemIndex() {
        return visibleItems.findIndex(function(processedItem) {
            return isValidItem(processedItem);
        });
    };
    var findLastItemIndex = function findLastItemIndex() {
        return (0, $a73ce425265b079e$export$4855211e6b8ad895).findLastIndex(visibleItems, function(processedItem) {
            return isValidItem(processedItem);
        });
    };
    var findNextItemIndex = function findNextItemIndex(index) {
        var matchedItemIndex = index < visibleItems.length - 1 ? visibleItems.slice(index + 1).findIndex(function(processedItem) {
            return isValidItem(processedItem);
        }) : -1;
        return matchedItemIndex > -1 ? matchedItemIndex + index + 1 : index;
    };
    var findPrevItemIndex = function findPrevItemIndex(index) {
        var matchedItemIndex = index > 0 ? (0, $a73ce425265b079e$export$4855211e6b8ad895).findLastIndex(visibleItems.slice(0, index), function(processedItem) {
            return isValidItem(processedItem);
        }) : -1;
        return matchedItemIndex > -1 ? matchedItemIndex : index;
    };
    var findSelectedItemIndex = function findSelectedItemIndex() {
        return visibleItems.findIndex(function(processedItem) {
            return isValidSelectedItem(processedItem);
        });
    };
    var findFirstFocusedItemIndex = function findFirstFocusedItemIndex() {
        var selectedIndex = findSelectedItemIndex();
        return selectedIndex < 0 ? findFirstItemIndex() : selectedIndex;
    };
    var findLastFocusedItemIndex = function findLastFocusedItemIndex() {
        var selectedIndex = findSelectedItemIndex();
        return selectedIndex < 0 ? findLastItemIndex() : selectedIndex;
    };
    var searchItems = function searchItems(_char) {
        searchValue.current = (searchValue.current || '') + _char;
        var itemIndex = -1;
        var matched = false;
        if (focusedItemInfo.index !== -1) {
            itemIndex = visibleItems.slice(focusedItemInfo.index).findIndex(function(processedItem) {
                return isItemMatched(processedItem);
            });
            itemIndex = itemIndex === -1 ? visibleItems.slice(0, focusedItemInfo.index).findIndex(function(processedItem) {
                return isItemMatched(processedItem);
            }) : itemIndex + focusedItemInfo.index;
        } else itemIndex = visibleItems.findIndex(function(processedItem) {
            return isItemMatched(processedItem);
        });
        if (itemIndex !== -1) matched = true;
        if (itemIndex === -1 && focusedItemInfo.index === -1) itemIndex = findFirstFocusedItemIndex();
        if (itemIndex !== -1) changeFocusedItemIndex(itemIndex);
        if (searchTimeout.current) clearTimeout(searchTimeout);
        searchTimeout.current = setTimeout(function() {
            searchValue.current = '';
            searchTimeout.current = null;
        }, 500);
        return matched;
    };
    var changeFocusedItemIndex = function changeFocusedItemIndex(index) {
        if (focusedItemInfo.index !== index) {
            setFocusedItemInfo($003b4fc9f8cc5a16$var$_objectSpread$1($003b4fc9f8cc5a16$var$_objectSpread$1({}, focusedItemInfo), {}, {
                index: index
            }));
            scrollInView();
        }
    };
    var scrollInView = function scrollInView() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
        var id = index !== -1 ? "".concat(idState, "_").concat(index) : focusedItemId;
        var element = (0, $a73ce425265b079e$export$ff8ccbac9225de62).findSingle(getMenuElement(), "li[id=\"".concat(id, "\"]"));
        if (element) element.scrollIntoView && element.scrollIntoView({
            block: 'nearest',
            inline: 'start'
        });
    };
    var createProcessedItems = $acw62.useCallback(function(items) {
        var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var parentKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
        var processedItems = [];
        items && items.forEach(function(item, index) {
            var key = (parentKey !== '' ? parentKey + '_' : '') + index;
            var newItem = {
                item: item,
                index: index,
                level: level,
                key: key,
                parent: parent,
                parentKey: parentKey
            };
            newItem.items = createProcessedItems(item.items, level + 1, newItem, key);
            processedItems.push(newItem);
        });
        return processedItems;
    }, []);
    var createStyle = function createStyle() {
        if (!styleElementRef.current) {
            styleElementRef.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).createInlineStyle(context && context.nonce || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).nonce, context && context.styleContainer);
            var selector = "".concat(attributeSelectorState);
            var innerHTML = "\n@media screen and (max-width: ".concat(props.breakpoint, ") {\n    .p-tieredmenu[").concat(selector, "] > ul {\n        max-height: ").concat(props.scrollHeight, ";\n        overflow: ").concat(props.scrollHeight ? 'auto' : '', ";\n    }\n\n    .p-tieredmenu[").concat(selector, "] .p-submenu-list {\n        position: relative;\n    }\n\n    .p-tieredmenu[").concat(selector, "] .p-menuitem-active > .p-submenu-list {\n        left: 0;\n        box-shadow: none;\n        border-radius: 0;\n        padding: 0 0 0 calc(var(--inline-spacing) * 2); /* @todo */\n    }\n\n    .p-tieredmenu[").concat(selector, "] .p-menuitem-active > .p-menuitem-link > .p-submenu-icon {\n        transform: rotate(-180deg);\n    }\n\n    .p-tieredmenu[").concat(selector, "] .p-submenu-icon:before {\n        content: \"\\e930\";\n    }\n\n    ").concat(!props.popup ? ".p-tieredmenu[".concat(selector, "] { width: 100%; }") : '', "\n}\n");
            styleElementRef.current.innerHTML = innerHTML;
        }
    };
    var destroyStyle = function destroyStyle() {
        styleElementRef.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeInlineStyle(styleElementRef.current);
    };
    var alignOverlay = function alignOverlay() {
        var calculateMinWidth = (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(targetRef.current) > (0, $a73ce425265b079e$export$ff8ccbac9225de62).getOuterWidth(containerRef.current);
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).alignOverlay(containerRef.current, targetRef.current, props.appendTo, calculateMinWidth);
    };
    var onEnter = function onEnter() {
        if (props.autoZIndex) (0, $a73ce425265b079e$export$832931caede8e4b9).set('menu', containerRef.current, context && context.autoZIndex || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).autoZIndex, props.baseZIndex || context && context.zIndex.menu || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).zIndex.menu);
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).addStyles(containerRef.current, {
            position: 'absolute',
            top: '0',
            left: '0'
        });
        alignOverlay();
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(menuRef.current.getElement());
        scrollInView();
        if (attributeSelectorState && props.breakpoint) {
            containerRef.current.setAttribute(attributeSelectorState, '');
            createStyle();
        }
    };
    var onEntered = function onEntered() {
        bindDocumentClickListener();
        bindDocumentResizeListener();
    };
    var onExit = function onExit() {
        targetRef.current = null;
        unbindDocumentClickListener();
        unbindDocumentResizeListener();
    };
    var onExited = function onExited() {
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(containerRef.current);
        destroyStyle();
    };
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        var uniqueId = (0, $a73ce425265b079e$export$d5d9b89141473caf)();
        !idState && setIdState(uniqueId);
        if (props.breakpoint) !attributeSelectorState && setAttributeSelectorState(uniqueId);
    });
    $acw62.useEffect(function() {
        var itemsToProcess = props.model || [];
        var processed = createProcessedItems(itemsToProcess);
        setProcessedItems(processed);
    }, [
        props.model,
        createProcessedItems
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        var processedItem = activeItemPath.find(function(p) {
            return p.key === focusedItemInfo.parentKey;
        });
        var processed = processedItem ? processedItem.items : processedItems;
        setVisibleItems(processed);
    }, [
        activeItemPath,
        focusedItemInfo,
        processedItems
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        var focusedId = focusedItemInfo.index !== -1 ? "".concat(idState).concat((0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(focusedItemInfo.parentKey) ? '_' + focusedItemInfo.parentKey : '', "_").concat(focusedItemInfo.index) : null;
        setFocusedItemId(focusedId);
    }, [
        focusedItemInfo
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (!props.popup) {
            if ((0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(activeItemPath)) {
                bindDocumentClickListener();
                bindDocumentResizeListener();
            } else {
                unbindDocumentClickListener();
                unbindDocumentResizeListener();
            }
        }
    }, [
        activeItemPath
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (focusTrigger) {
            var itemIndex = focusedItemInfo.index !== -1 ? findNextItemIndex(focusedItemInfo.index) : findFirstFocusedItemIndex();
            changeFocusedItemIndex(itemIndex);
            setActiveItemPath(activeItemPath.filter(function(p) {
                return p.parentKey !== focusedItemInfo.parentKey;
            }));
            setFocusTrigger(false);
        }
    }, [
        focusTrigger
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (attributeSelectorState && containerRef.current) {
            containerRef.current.setAttribute(attributeSelectorState, '');
            createStyle();
        }
        return function() {
            destroyStyle();
        };
    }, [
        attributeSelectorState,
        props.breakpoint
    ]);
    (0, $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96)(function() {
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(containerRef.current);
    });
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            toggle: toggle,
            show: show,
            hide: hide,
            getElement: function getElement() {
                return containerRef.current;
            }
        };
    });
    var createElement = function createElement() {
        var rootProps = mergeProps({
            ref: containerRef,
            id: props.id,
            className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root')),
            style: props.style,
            onClick: onPanelClick
        }, $003b4fc9f8cc5a16$var$TieredMenuBase.getOtherProps(props), ptm('root'));
        var transitionProps = mergeProps({
            classNames: cx('transition'),
            "in": visibleState,
            timeout: {
                enter: 120,
                exit: 100
            },
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: onEnter,
            onEntered: onEntered,
            onExit: onExit,
            onExited: onExited
        }, ptm('transition'));
        return /*#__PURE__*/ $acw62.createElement((0, $17afce1b96f6eaec$export$a7a5590ad6d7af0), $003b4fc9f8cc5a16$var$_extends({
            nodeRef: containerRef
        }, transitionProps), /*#__PURE__*/ $acw62.createElement("div", rootProps, /*#__PURE__*/ $acw62.createElement($003b4fc9f8cc5a16$var$TieredMenuSub, {
            id: idState + '_list',
            ref: menuRef,
            hostName: "TieredMenu",
            menuProps: props,
            tabIndex: 0,
            model: processedItems,
            ariaLabel: props.ariaLabel,
            ariaLabelledBy: props.ariaLabelledBy,
            ariaOrientation: "vertical",
            ariaActiveDescendant: focused ? focusedItemId : undefined,
            menuId: idState,
            level: 0,
            focusedItemId: focusedItemId,
            activeItemPath: activeItemPath,
            onFocus: onFocus,
            onBlur: onBlur,
            onKeyDown: onKeyDown,
            onItemClick: onItemClick,
            onItemMouseEnter: onItemMouseEnter,
            root: true,
            popup: props.popup,
            onHide: hide,
            isMobileMode: isMobileMode,
            submenuIcon: props.submenuIcon,
            ptm: ptm,
            cx: cx,
            sx: sx
        })));
    };
    var element = createElement();
    return props.popup ? /*#__PURE__*/ $acw62.createElement((0, $e7a3b5428092a192$export$602eac185826482c), {
        element: element,
        appendTo: props.appendTo
    }) : element;
}));
$003b4fc9f8cc5a16$var$TieredMenu.displayName = 'TieredMenu';
var $003b4fc9f8cc5a16$var$classes = {
    icon: 'p-button-icon p-c',
    root: function root(_ref) {
        var props = _ref.props, size = _ref.size;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-splitbutton p-component', $003b4fc9f8cc5a16$var$_defineProperty($003b4fc9f8cc5a16$var$_defineProperty($003b4fc9f8cc5a16$var$_defineProperty($003b4fc9f8cc5a16$var$_defineProperty($003b4fc9f8cc5a16$var$_defineProperty($003b4fc9f8cc5a16$var$_defineProperty({
            'p-disabled': props.disabled,
            'p-button-loading-label-only': props.loading && !props.icon && props.label
        }, "p-button-".concat(props.severity), props.severity), 'p-button-raised', props.raised), 'p-button-rounded', props.rounded), 'p-button-text', props.text), 'p-button-outlined', props.outlined), "p-button-".concat(size), size));
    },
    button: 'p-splitbutton-defaultbutton',
    menuButton: 'p-splitbutton-menubutton',
    menu: function menu(_ref2) {
        var props = _ref2.props;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-menu p-menu-overlay p-component', props.menuClassName);
    },
    menuList: 'p-menu-list p-reset',
    separator: 'p-menu-separator',
    menuIcon: 'p-menuitem-icon',
    menuLabel: 'p-menuitem-text',
    anchor: function anchor(_ref3) {
        var _className = _ref3._className, disabled = _ref3.disabled;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-menuitem-link', _className, {
            'p-disabled': disabled
        });
    },
    menuItem: 'p-menuitem',
    transition: 'p-connected-overlay'
};
var $003b4fc9f8cc5a16$var$styles = "\n@layer primereact {\n    .p-splitbutton {\n        display: inline-flex;\n        position: relative;\n    }\n\n    .p-splitbutton .p-splitbutton-defaultbutton,\n    .p-splitbutton.p-button-rounded > .p-splitbutton-defaultbutton.p-button,\n    .p-splitbutton.p-button-outlined > .p-splitbutton-defaultbutton.p-button,\n    .p-splitbutton.p-button-outlined > .p-splitbutton-defaultbutton.p-button-outlined.p-button:hover {\n        flex: 1 1 auto;\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n        border-right: 0 none;\n    }\n\n    .p-splitbutton-menubutton,\n    .p-splitbutton.p-button-rounded > .p-splitbutton-menubutton.p-button,\n    .p-splitbutton.p-button-outlined > .p-splitbutton-menubutton.p-button {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .p-splitbutton .p-menu {\n        min-width: 100%;\n    }\n\n    .p-fluid .p-splitbutton  {\n        display: flex;\n    }\n}\n";
var $003b4fc9f8cc5a16$var$SplitButtonBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'SplitButton',
        id: null,
        label: null,
        icon: null,
        autoZIndex: true,
        baseZIndex: 0,
        loading: false,
        loadingIcon: null,
        model: null,
        disabled: null,
        style: null,
        className: null,
        buttonClassName: null,
        menuStyle: null,
        menuClassName: null,
        menuButtonClassName: null,
        buttonProps: null,
        menuButtonProps: null,
        tabIndex: null,
        severity: null,
        rounded: false,
        raised: false,
        outlined: false,
        text: false,
        size: null,
        appendTo: null,
        tooltip: null,
        tooltipOptions: null,
        buttonTemplate: null,
        transitionOptions: null,
        dropdownIcon: null,
        onClick: null,
        onShow: null,
        onHide: null,
        children: undefined
    },
    css: {
        classes: $003b4fc9f8cc5a16$var$classes,
        styles: $003b4fc9f8cc5a16$var$styles
    }
});
function $003b4fc9f8cc5a16$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $003b4fc9f8cc5a16$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $003b4fc9f8cc5a16$var$ownKeys(Object(t), !0).forEach(function(r) {
            $003b4fc9f8cc5a16$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $003b4fc9f8cc5a16$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $003b4fc9f8cc5a16$export$651ad66661acd392 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $fbdf1e36fa0a01d8$export$9596428d77cc41ba)();
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $003b4fc9f8cc5a16$var$SplitButtonBase.getProps(inProps, context);
    var _React$useState = $acw62.useState(props.id), _React$useState2 = $003b4fc9f8cc5a16$var$_slicedToArray(_React$useState, 2), idState = _React$useState2[0], setIdState = _React$useState2[1];
    var _React$useState3 = $acw62.useState(false), _React$useState4 = $003b4fc9f8cc5a16$var$_slicedToArray(_React$useState3, 2), overlayVisibleState = _React$useState4[0], setOverlayVisibleState = _React$useState4[1];
    var elementRef = $acw62.useRef(null);
    var menuRef = $acw62.useRef(null);
    var defaultButtonRef = $acw62.useRef(null);
    var overlayRef = $acw62.useRef(null);
    var overlayDisplayOrder = (0, $fbdf1e36fa0a01d8$export$6353a33119af9098)('split-button-tooltip', overlayVisibleState);
    var metaData = {
        props: props,
        state: {
            id: idState,
            overlayVisible: overlayVisibleState
        }
    };
    var _SplitButtonBase$setM = $003b4fc9f8cc5a16$var$SplitButtonBase.setMetaData(metaData), ptm = _SplitButtonBase$setM.ptm, cx = _SplitButtonBase$setM.cx, isUnstyled = _SplitButtonBase$setM.isUnstyled;
    (0, $b76d8eda63b3c134$export$142583cb150b394)($003b4fc9f8cc5a16$var$SplitButtonBase.css.styles, isUnstyled, {
        name: 'splitbutton'
    });
    (0, $fbdf1e36fa0a01d8$export$dee4359f392495ae)({
        callback: function callback() {
            hide();
        },
        when: overlayVisibleState && overlayDisplayOrder,
        priority: [
            (0, $fbdf1e36fa0a01d8$export$5153c70e1a2d4b71).SPLIT_BUTTON,
            overlayDisplayOrder
        ]
    });
    var onPanelClick = function onPanelClick(event1) {
        (0, $8f8d568a0a544f71$export$dbec172f58a34ef1).emit('overlay-click', {
            originalEvent: event1,
            target: elementRef.current
        });
    };
    var onMenuButtonKeyDown = function onMenuButtonKeyDown(event1) {
        if (event1.code === 'ArrowDown' || event1.code === 'ArrowUp') {
            onDropdownButtonClick(event1);
            event1.preventDefault();
        }
    };
    var onDropdownButtonClick = function onDropdownButtonClick(event1) {
        overlayVisibleState ? hide(event1) : show(event1);
    };
    var show = function show(event1) {
        setOverlayVisibleState(true);
        menuRef.current && menuRef.current.show(event1);
    };
    var hide = function hide(event1) {
        setOverlayVisibleState(false);
        menuRef.current && menuRef.current.hide(event1);
    };
    var onMenuShow = function onMenuShow() {
        props.onShow && props.onShow();
    };
    var onMenuHide = function onMenuHide() {
        setOverlayVisibleState(false);
        props.onHide && props.onHide();
    };
    var alignOverlay = function alignOverlay() {
        (0, $a73ce425265b079e$export$ff8ccbac9225de62).alignOverlay(overlayRef.current, defaultButtonRef.current.parentElement, props.appendTo || context && context.appendTo || (0, $51b25b42ecc1a0c7$export$2e2bcd8739ae039).appendTo);
    };
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        if (!idState) setIdState((0, $a73ce425265b079e$export$d5d9b89141473caf)());
        alignOverlay();
    });
    (0, $fbdf1e36fa0a01d8$export$f3a192d0cbd30b96)(function() {
        (0, $a73ce425265b079e$export$832931caede8e4b9).clear(overlayRef.current);
    });
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            show: show,
            hide: hide,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    if (props.visible === false) return null;
    var hasTooltip = (0, $a73ce425265b079e$export$4855211e6b8ad895).isNotEmpty(props.tooltip);
    var sizeMapping = {
        large: 'lg',
        small: 'sm'
    };
    var size = sizeMapping[props.size];
    var buttonContent = props.buttonTemplate ? (0, $a73ce425265b079e$export$4855211e6b8ad895).getJSXElement(props.buttonTemplate, props) : null;
    var menuId = idState + '_overlay';
    var dropdownIcon = function dropdownIcon() {
        var iconProps = mergeProps({
            className: cx('icon')
        }, ptm('icon'));
        var icon = props.dropdownIcon || /*#__PURE__*/ $acw62.createElement((0, $2539671ba6368b77$export$4857d3f3f5f8319b), iconProps);
        var dropdownIcon = (0, $a73ce425265b079e$export$7114f767f3d3c711).getJSXIcon(icon, $003b4fc9f8cc5a16$var$_objectSpread({}, iconProps), {
            props: props
        });
        return dropdownIcon;
    };
    var rootProps = mergeProps({
        ref: elementRef,
        id: idState,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root', {
            size: size
        })),
        style: props.style
    }, $003b4fc9f8cc5a16$var$SplitButtonBase.getOtherProps(props), ptm('root'));
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", rootProps, /*#__PURE__*/ $acw62.createElement((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), $003b4fc9f8cc5a16$var$_extends({
        ref: defaultButtonRef,
        type: "button",
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.buttonClassName, cx('button')),
        icon: props.icon,
        loading: props.loading,
        loadingIcon: props.loadingIcon,
        severity: props.severity,
        label: props.label,
        "aria-label": props.label,
        raised: props.raised,
        onClick: props.onClick,
        disabled: props.disabled,
        tabIndex: props.tabIndex,
        size: props.size,
        outlined: props.outlined,
        text: props.text
    }, props.buttonProps, {
        pt: ptm('button'),
        __parentMetadata: {
            parent: metaData
        },
        unstyled: props.unstyled
    }), buttonContent), /*#__PURE__*/ $acw62.createElement((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), $003b4fc9f8cc5a16$var$_extends({
        type: "button",
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.menuButtonClassName, cx('menuButton')),
        icon: dropdownIcon,
        onClick: onDropdownButtonClick,
        disabled: props.disabled,
        "aria-expanded": overlayVisibleState,
        "aria-haspopup": "true",
        "aria-controls": menuId
    }, props.menuButtonProps, {
        size: props.size,
        severity: props.severity,
        outlined: props.outlined,
        text: props.text,
        raised: props.raised,
        pt: ptm('menuButton'),
        __parentMetadata: {
            parent: metaData
        },
        onKeyDown: onMenuButtonKeyDown,
        unstyled: props.unstyled
    })), /*#__PURE__*/ $acw62.createElement($003b4fc9f8cc5a16$var$TieredMenu, {
        ref: menuRef,
        popup: true,
        unstyled: props.unstyled,
        model: props.model,
        appendTo: props.appendTo,
        id: menuId,
        style: props.menuStyle,
        autoZIndex: props.autoZIndex,
        baseZIndex: props.baseZIndex,
        className: (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.menuClassName, cx('menu')),
        onClick: onPanelClick,
        onShow: onMenuShow,
        onHide: onMenuHide,
        pt: ptm('menu'),
        __parentMetadata: {
            parent: metaData
        }
    })), hasTooltip && /*#__PURE__*/ $acw62.createElement((0, $b74dfa9f7ee9d9bc$export$28c660c63b792dea), $003b4fc9f8cc5a16$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm('tooltip')
    }, props.tooltipOptions)));
}));
$003b4fc9f8cc5a16$export$651ad66661acd392.displayName = 'SplitButton';



var $acw62 = parcelRequire("acw62");

function $f597238716a9a994$export$580c22c1b98aae58({ id: id, icon: icon, options: options, optionLabel: optionLabel, optionValue: optionValue, label: label, propertyName: propertyName, emptyMessage: emptyMessage, onDone: onDone, pending: pending, minDate: minDate, maxDate: maxDate }) {
    const [value, setValue] = (0, $acw62.useState)([]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                htmlFor: id + '_' + propertyName,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: icon
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ml-2",
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $37f8d4c0bc2f6dce$export$41f133550aa26f48), {
                multiple: true,
                id: id + '_' + propertyName,
                options: options,
                optionLabel: optionLabel,
                optionValue: optionValue,
                emptyMessage: emptyMessage,
                listStyle: {
                    height: '250px'
                },
                value: value,
                onChange: (e)=>setValue(e.value)
            }),
            value.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                label: value.length > 1 ? "Usu\u0144 zazn. daty" : "Usu\u0144 zazn. dat\u0119",
                icon: "fa-solid fa-square-minus",
                severity: "danger",
                outlined: true,
                className: "w-full",
                onClick: (e)=>{
                    onDone(propertyName + '_remove', value);
                    setValue([]);
                }
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f597238716a9a994$var$PickDate, {
                minDate: minDate,
                maxDate: maxDate,
                onDone: onDone,
                propertyName: propertyName
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f597238716a9a994$var$HolidayPicker, {
                propertyName: propertyName,
                minDate: minDate,
                maxDate: maxDate,
                onDone: onDone
            })
        ]
    });
}
function $f597238716a9a994$var$PickDate({ minDate: minDate, maxDate: maxDate, onDone: onDone, propertyName: propertyName }) {
    const [date, setDate] = (0, $acw62.useState)(null);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "w-full flex",
        children: [
            date ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                severity: "success",
                icon: "fa-solid fa-square-plus",
                "aria-label": "Dodaj",
                onClick: (e)=>{
                    onDone(propertyName + '_add', [
                        (0, $57ee609582c542b6$export$443ababd588c81c9)(date)
                    ]);
                    setDate(null);
                }
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7829c495bb40f01d$export$e1aef45b828286de), {
                showIcon: true,
                icon: "fa-solid fa-calendar-days",
                placeholder: "Dodaj dat\u0119 do listy",
                dateFormat: "dd.mm.yy",
                minDate: minDate,
                maxDate: maxDate,
                value: date,
                onChange: (e)=>setDate(e.value)
            })
        ]
    });
}
function $f597238716a9a994$var$HolidayPicker({ propertyName: propertyName, onDone: onDone, minDate: minDate, maxDate: maxDate }) {
    const items = [
        {
            label: 'Wszystkie dni ustawowo wolne od pracy',
            command: ()=>{
                onDone(propertyName + '_add', (0, $57ee609582c542b6$export$1ba6550947cefd28)(minDate, maxDate, (0, $57ee609582c542b6$export$2f50c9ccc17bc06a)[1]));
            }
        },
        {
            label: '"Du\u017Ce" \u015Bwi\u0119ta (Nowy Rok, I i II dn. Wielkanocy, I i II dn. Bo\u017Cego Narodzenia)',
            command: ()=>{
                onDone(propertyName + '_add', (0, $57ee609582c542b6$export$1ba6550947cefd28)(minDate, maxDate, (0, $57ee609582c542b6$export$2f50c9ccc17bc06a)[2]));
            }
        },
        {
            label: '"Bardzo du\u017Ce" \u015Bwi\u0119ta (Nowy Rok, I dn Wielkanocy, I dn. Bo\u017Cego Narodzenia)',
            command: ()=>{
                onDone(propertyName + '_add', (0, $57ee609582c542b6$export$1ba6550947cefd28)(minDate, maxDate, (0, $57ee609582c542b6$export$2f50c9ccc17bc06a)[3]));
            }
        },
        {
            label: "Wigilia Bo\u017Cego Narodzenia i sylwester",
            command: ()=>{
                onDone(propertyName + '_add', (0, $57ee609582c542b6$export$1ba6550947cefd28)(minDate, maxDate, (0, $57ee609582c542b6$export$2f50c9ccc17bc06a)[4]));
            }
        },
        {
            label: "Triduum Paschalne w Ko\u015Bciele Rzymskokatolickim",
            command: ()=>{
                onDone(propertyName + '_add', (0, $57ee609582c542b6$export$1ba6550947cefd28)(minDate, maxDate, (0, $57ee609582c542b6$export$2f50c9ccc17bc06a)[5]));
            }
        },
        {
            label: 'Wielka Sobota',
            command: ()=>{
                onDone(propertyName + '_add', (0, $57ee609582c542b6$export$1ba6550947cefd28)(minDate, maxDate, (0, $57ee609582c542b6$export$2f50c9ccc17bc06a)[6]));
            }
        },
        {
            label: "2 maja i pi\u0105tek po Bo\u017Cym Ciele",
            command: ()=>{
                onDone(propertyName + '_add', (0, $57ee609582c542b6$export$1ba6550947cefd28)(minDate, maxDate, (0, $57ee609582c542b6$export$2f50c9ccc17bc06a)[7]));
            }
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $003b4fc9f8cc5a16$export$651ad66661acd392), {
        outlined: true,
        size: "small",
        severity: "help",
        className: "w-full mt-1",
        icon: "fa-solid fa-calendar-xmark",
        label: "Dodaj \u015Bwi\u0119ta do listy",
        model: items,
        menuStyle: {
            minWidth: '40rem'
        },
        onClick: ()=>{
            onDone(propertyName + '_add', (0, $57ee609582c542b6$export$1ba6550947cefd28)(minDate, maxDate, (0, $57ee609582c542b6$export$2f50c9ccc17bc06a)[1]));
        }
    });
}




function $23c2db7eed16b3e2$export$d13b21338788fc28({ GCalendar: GCalendar }) {
    const header = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-200 text-sm",
                children: GCalendar.service_id
            }),
            " ",
            GCalendar.service_description
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8752d282f3fd7a50$export$7c61201097bd33b6), {
        resourceTable: "calendars",
        selectedItemId: GCalendar.service_id,
        header: header,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($23c2db7eed16b3e2$var$CalendarPropertiesForm, {})
    });
}
function $23c2db7eed16b3e2$var$CalendarPropertiesForm() {
    const id = (0, $acw62.useId)();
    const data = (0, $acw62.useContext)((0, $65d01f18dbe7987a$export$58d75f9829cbe158));
    const modifyCalendar = (0, $4529664c1ee19d35$export$5ecbcf6a102ccf18)();
    const [modifiedValues, setModifiedValues] = (0, $acw62.useState)(data.inputValues);
    const [validationErrors, setValidationErrors] = (0, $acw62.useState)(false);
    const [isMutationPending, setIsMutationPending] = (0, $acw62.useState)(false);
    const handleOverlays = (0, $acw62.useContext)((0, $bdccf6b6a87b04cc$export$a2200b96afd16271));
    const { data: calendarList, isPending: isPending, error: error } = (0, $4529664c1ee19d35$export$c3a687f3d6e3fb65)('calendars');
    const weekSelectorValues = [];
    if (data.inputValues.monday === true) weekSelectorValues.push('monday');
    if (data.inputValues.tuesday === true) weekSelectorValues.push('tuesday');
    if (data.inputValues.wednesday === true) weekSelectorValues.push('wednesday');
    if (data.inputValues.thursday === true) weekSelectorValues.push('thursday');
    if (data.inputValues.friday === true) weekSelectorValues.push('friday');
    if (data.inputValues.saturday === true) weekSelectorValues.push('saturday');
    if (data.inputValues.sunday === true) weekSelectorValues.push('sunday');
    let dateAddedValues = [];
    let dateRemovedValues = [];
    dateAddedValues = data.inputValues.exceptions_dates_added.map((x)=>{
        return {
            option: (0, $57ee609582c542b6$export$2e2bcd8739ae039)(x),
            value: x
        };
    });
    dateRemovedValues = data.inputValues.exceptions_dates_removed.map((x)=>{
        return {
            option: (0, $57ee609582c542b6$export$2e2bcd8739ae039)(x),
            value: x
        };
    });
    function handleInput(propertyName, value) {
        let newValues = {
            ...modifiedValues
        };
        newValues[propertyName] = value;
        setModifiedValues(newValues);
    }
    function handleInputCancel() {
        setModifiedValues(data.inputValues);
    }
    console.log('Mutation object:', modifyCalendar);
    console.log('Mutation mutate function:', modifyCalendar.mutateAsync);
    /* TODO: refaktoryzacja "handleInputDone" wszędzie, we wszystkich formularzach.
        Być może wcale nie potrzebujemy tak złożonej funkcji, która powtarza się we wszystkich
        formularzach i zawsze jest funckją asynchroniczną z optymistyczną aktualizacją,
        która powoduje trochę błędów i jest trudna w debugowaniu.


        Sprawdźmy, czy możemy stowrzyć jedną funkcję "handleSimpleInputDone" opartą na zwykłej
        mutacji, bez tego asynchronicznego pierdololo. Edycja przystanków wymaga wprawdzie
        edycji optymistycznej. Ale tutaj może to niepotrzebne. Zwłaszcza, że optymistyczna
        aktualizacja przerywa nam renderowanie komponentu z listboxem po lewej i resetuje go
        do początkowej pozycji... bezsęs
        
        */ async function handleInputDone(propertyName, value) {
        if (value === data.inputValues[propertyName]) return; // Nie wysyłamy zmian na serwer, jeżeli nowa wartość jest taka jak już zapisana do serwera.
        const payload = {
            query: {
                modified_id: String(data.inputValues.service_id),
                resourceTable: 'calendars'
            },
            fields: {}
        };
        payload.fields[propertyName] = value;
        setIsMutationPending(true);
        try {
            console.log('Calling mutation.mutate with payload', payload);
            const asyncMutation = await modifyCalendar.mutateAsync(payload).then(()=>console.log('Mutation finished')); // próbujemy przeprowadzić mutację
            // wykasuj ewentualne istniejące błędy walidacji z UI, skoro wszystko poszło ok
            if (validationErrors[propertyName]) {
                let updatedValidationErrors = {
                    ...validationErrors
                };
                updatedValidationErrors[propertyName] = false;
                setValidationErrors({
                    ...updatedValidationErrors
                });
            }
        } catch (error) {
            const errorCode = error.message.slice(0, 3);
            if (errorCode == '422') {
                //obsługa błędów walidacji
                let updatedValidationErrors = {
                    ...validationErrors
                };
                updatedValidationErrors[propertyName] = Object.values(error.cause.validation[propertyName]).join(', ');
                setValidationErrors({
                    ...updatedValidationErrors
                });
            } else {
                //obsługa pozostałych błędów
                handleOverlays('toast', {
                    severity: "error",
                    summary: "B\u0142\u0105d " + errorCode,
                    detail: typeof error.cause === 'undefined' || typeof error.cause.message === 'undefined' ? "Wyst\u0105pi\u0142 b\u0142\u0105d. Czynno\u015B\u0107 nie mog\u0142a zosta\u0107 zako\u0144czona powodzeniem. " + error.message : error.cause.message
                });
                console.log(error);
            }
        } finally{
            setIsMutationPending(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "formgrid grid",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                    propertyName: "service_id",
                    label: "Oznaczenie kalendarza",
                    id: id,
                    value: modifiedValues.service_id,
                    initialVal: data.inputValues.service_id,
                    onDone: handleInputDone,
                    onChange: handleInput,
                    onCalcel: handleInputCancel,
                    pending: isMutationPending
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "field col-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        htmlFor: id + '_start_date',
                        children: "Wa\u017Cny od:"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7829c495bb40f01d$export$e1aef45b828286de), {
                        inputId: id + '_start_date',
                        value: (0, $57ee609582c542b6$export$294b5a2c8fb6dbfa)(modifiedValues.start_date),
                        dateFormat: "dd.mm.yy",
                        onChange: (e)=>{
                            let newValues = {
                                ...modifiedValues
                            };
                            newValues['start_date'] = (0, $57ee609582c542b6$export$443ababd588c81c9)(e.value);
                            setModifiedValues(newValues); // tzw. (trochę) optymistyczna aktualizacja...
                            handleInputDone('start_date', (0, $57ee609582c542b6$export$443ababd588c81c9)(e.value));
                        },
                        onHide: ()=>{
                            console.log('todo: input done');
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "field col-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        htmlFor: id + '_end_date',
                        children: "Wa\u017Cny od:"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7829c495bb40f01d$export$e1aef45b828286de), {
                        inputId: id + '_end_date',
                        value: (0, $57ee609582c542b6$export$294b5a2c8fb6dbfa)(modifiedValues.end_date),
                        dateFormat: "dd.mm.yy",
                        onChange: (e)=>{
                            let newValues = {
                                ...modifiedValues
                            };
                            newValues['end_date'] = (0, $57ee609582c542b6$export$443ababd588c81c9)(e.value);
                            setModifiedValues(newValues); // tzw. (trochę) optymistyczna aktualizacja...
                            handleInputDone('end_date', (0, $57ee609582c542b6$export$443ababd588c81c9)(e.value));
                        },
                        onHide: ()=>{
                            console.log('todo: input done');
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "field col-12",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        htmlFor: id + '_week_selector',
                        children: "Dni tygodnia, w kt\xf3rych kurs jest wykonywany wg tego kalendarza:"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex justify-content-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3deef212c81ef57f$export$115094ee16241d93), {
                            multiple: true,
                            id: id + '_week_selector',
                            optionLabel: "name",
                            optionValue: "value",
                            options: [
                                {
                                    name: 'PON.',
                                    value: 'monday'
                                },
                                {
                                    name: 'WTO.',
                                    value: 'tuesday'
                                },
                                {
                                    name: "\u015ARO.",
                                    value: 'wednesday'
                                },
                                {
                                    name: 'CZW.',
                                    value: 'thursday'
                                },
                                {
                                    name: "PI\u0104.",
                                    value: 'friday'
                                },
                                {
                                    name: 'SOB.',
                                    value: 'saturday'
                                },
                                {
                                    name: 'NIE.',
                                    value: 'sunday'
                                }
                            ],
                            value: weekSelectorValues,
                            onChange: (e)=>{
                                handleInputDone('weekdays', e.value);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "col-12 mt-5",
                children: "Wyj\u0105tki w kursowaniu (np. \u015Bwi\u0119ta)"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-5",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f597238716a9a994$export$580c22c1b98aae58), {
                    id: id,
                    icon: "fa-solid fa-calendar-plus",
                    propertyName: "exceptions_date_added",
                    options: dateAddedValues,
                    optionLabel: "option",
                    optionValue: "value",
                    label: "Kursuje dodatkowo w dni:",
                    emptyMessage: "(brak wyj\u0105tk\xf3w)",
                    minDate: (0, $57ee609582c542b6$export$294b5a2c8fb6dbfa)(data.inputValues.start_date),
                    maxDate: (0, $57ee609582c542b6$export$294b5a2c8fb6dbfa)(data.inputValues.end_date),
                    onDone: handleInputDone
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-2"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-5",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f597238716a9a994$export$580c22c1b98aae58), {
                    id: id,
                    icon: "fa-solid fa-calendar-minus",
                    propertyName: "exceptions_date_removed",
                    options: dateRemovedValues,
                    optionLabel: "option",
                    optionValue: "value",
                    label: "Nie kursuje w dni:",
                    emptyMessage: "(brak wyj\u0105tk\xf3w)",
                    minDate: (0, $57ee609582c542b6$export$294b5a2c8fb6dbfa)(data.inputValues.start_date),
                    maxDate: (0, $57ee609582c542b6$export$294b5a2c8fb6dbfa)(data.inputValues.end_date),
                    onDone: handleInputDone
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "col-12 mt-5",
                children: "Obja\u015Bnienia kalendarza"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-12",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                    propertyName: "service_description",
                    label: "Pe\u0142ne obja\u015Bnienie kalendarza",
                    id: id,
                    value: modifiedValues.service_description,
                    initialVal: data.inputValues.service_description,
                    onDone: handleInputDone,
                    onChange: handleInput,
                    onCancel: handleInputCancel,
                    pending: isMutationPending
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "field col-12",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7fb0fd4947ad04b9$export$970da85b7539806d), {
                    label: "Obja\u015Bnienie widoczne w legendzie na tabliczkach rozk\u0142adowych",
                    propertyName: "service_description_display",
                    id: id,
                    value: modifiedValues.service_description_display,
                    initialVal: data.inputValues.service_description_display,
                    onDone: handleInputDone,
                    pending: isMutationPending
                })
            }),
            data.inputValues.service_description_display ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "field col-12",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca71958dfa0ca676$export$698e97a3b6a7bb69), {
                            propertyName: "service_description_table",
                            label: "Obja\u015Bnienie kalendarza na tabliczki rozk\u0142adowe",
                            id: id,
                            value: modifiedValues.service_description_table,
                            initialVal: data.inputValues.service_description_table,
                            onDone: handleInputDone,
                            onChange: handleInput,
                            onCalcel: handleInputCancel,
                            pending: isMutationPending
                        })
                    }),
                    Array.isArray(calendarList) && !error && !isPending ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "field col-12",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $193f2811aaebee8a$export$260594f1c0239dfe), {
                            showClear: true,
                            label: "Przy obja\u015Bnieniach traktuj ten kalendarz jako wyj\u0105tek od",
                            id: id,
                            propertyName: "service_parent",
                            options: calendarList,
                            optionValue: "service_id",
                            optionLabel: "service_id",
                            itemTemplate: (option)=>option.service_id + ' - ' + option.service_description,
                            valueTemplate: (option, props)=>option ? option.service_id + ' - ' + option.service_description : props.placeholder,
                            initialVal: data.inputValues.service_parent,
                            onDone: handleInputDone
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
        ]
    });
}


function $91e8377ddaeba4a0$export$5ac8b2b9eee83afb({ GCalendar: GCalendar }) {
    if (!GCalendar) return 'Wybierz kalendarz z listy po lewej';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $23c2db7eed16b3e2$export$d13b21338788fc28), {
                GCalendar: GCalendar
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $028ce6f6ddd144ee$export$9159ebcaf8f42267), {
                style: {
                    height: '84vh'
                },
                className: "col-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9148fdee410b91ec$export$39d78c94fb91ad03), {
                    serviceId: GCalendar.service_id
                })
            })
        ]
    });
}





var $acw62 = parcelRequire("acw62");












var $acw62 = parcelRequire("acw62");





'use client';
function $d4cd4087ef78894c$var$_extends() {
    return $d4cd4087ef78894c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d4cd4087ef78894c$var$_extends.apply(null, arguments);
}
var $d4cd4087ef78894c$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, context = _ref.context;
        return (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)('p-inputmask', {
            'p-filled': props.filled,
            'p-invalid': props.invalid,
            'p-variant-filled': props.variant ? props.variant === 'filled' : context && context.inputStyle === 'filled'
        });
    }
};
var $d4cd4087ef78894c$var$InputMaskBase = (0, $b76d8eda63b3c134$export$425c3e0a21b857e8).extend({
    defaultProps: {
        __TYPE: 'InputMask',
        autoClear: true,
        autoFocus: false,
        className: null,
        disabled: false,
        id: null,
        mask: null,
        maxLength: null,
        invalid: false,
        variant: null,
        name: null,
        onBlur: null,
        onChange: null,
        onComplete: null,
        onFocus: null,
        placeholder: null,
        readOnly: false,
        required: false,
        size: null,
        slotChar: '_',
        style: null,
        tabIndex: null,
        tooltip: null,
        tooltipOptions: null,
        type: 'text',
        unmask: false,
        value: null,
        children: undefined
    },
    css: {
        classes: $d4cd4087ef78894c$var$classes
    }
});
var $d4cd4087ef78894c$export$9f3572e55064b6d2 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(inProps, ref) {
    var context = $acw62.useContext((0, $51b25b42ecc1a0c7$export$43502877ff87a530));
    var props = $d4cd4087ef78894c$var$InputMaskBase.getProps(inProps, context);
    var elementRef = $acw62.useRef(null);
    var firstNonMaskPos = $acw62.useRef(null);
    var lastRequiredNonMaskPos = $acw62.useRef(0);
    var tests = $acw62.useRef([]);
    var buffer = $acw62.useRef([]);
    var len = $acw62.useRef(0);
    var oldVal = $acw62.useRef(null);
    var focus = $acw62.useRef(false);
    var focusText = $acw62.useRef(null);
    var isValueChecked = $acw62.useRef(null);
    var partialPosition = $acw62.useRef(null);
    var defaultBuffer = $acw62.useRef(null);
    var caretTimeoutId = $acw62.useRef(null);
    var androidChrome = $acw62.useRef(false);
    var metaData = {
        props: props
    };
    var _InputMaskBase$setMet = $d4cd4087ef78894c$var$InputMaskBase.setMetaData(metaData), cx = _InputMaskBase$setMet.cx;
    var caret = function caret(first, last) {
        var range;
        var begin;
        var end;
        var inputEl = elementRef.current;
        if (!inputEl || !inputEl.offsetParent || inputEl !== document.activeElement) return null;
        if (typeof first === 'number') {
            begin = first;
            end = typeof last === 'number' ? last : begin;
            if (inputEl.setSelectionRange) inputEl.setSelectionRange(begin, end);
            else if (inputEl.createTextRange) {
                range = inputEl.createTextRange();
                range.collapse(true);
                range.moveEnd('character', end);
                range.moveStart('character', begin);
                range.select();
            }
        } else if (inputEl.setSelectionRange) {
            begin = inputEl.selectionStart;
            end = inputEl.selectionEnd;
        } else if (document.selection && document.selection.createRange) {
            range = document.selection.createRange();
            begin = 0 - range.duplicate().moveStart('character', -100000);
            end = begin + range.text.length;
        }
        return {
            begin: begin,
            end: end
        };
    };
    var isCompleted = function isCompleted() {
        for(var i = firstNonMaskPos.current; i <= lastRequiredNonMaskPos.current; i++){
            if (tests.current[i] && buffer.current[i] === getPlaceholder(i)) return false;
        }
        return true;
    };
    var getPlaceholder = $acw62.useCallback(function(i) {
        if (i < props.slotChar.length) return props.slotChar.charAt(i);
        return props.slotChar.charAt(0);
    }, [
        props.slotChar
    ]);
    var getValue = function getValue() {
        return props.unmask ? getUnmaskedValue() : elementRef.current && elementRef.current.value;
    };
    var seekNext = function seekNext(pos) {
        while(++pos < len.current && !tests.current[pos]);
        return pos;
    };
    var seekPrev = function seekPrev(pos) {
        while(--pos >= 0 && !tests.current[pos]);
        return pos;
    };
    var shiftL = function shiftL(begin, end) {
        var i;
        var j;
        if (begin < 0) return;
        for(i = begin, j = seekNext(end); i < len.current; i++)if (tests.current[i]) {
            if (j < len.current && tests.current[i].test(buffer.current[j])) {
                buffer.current[i] = buffer.current[j];
                buffer.current[j] = getPlaceholder(j);
            } else break;
            j = seekNext(j);
        }
        writeBuffer();
        caret(Math.max(firstNonMaskPos.current, begin));
    };
    var shiftR = function shiftR(pos) {
        var i;
        var c;
        var j;
        var t;
        for(i = pos, c = getPlaceholder(pos); i < len.current; i++)if (tests.current[i]) {
            j = seekNext(i);
            t = buffer.current[i];
            buffer.current[i] = c;
            if (j < len.current && tests.current[j].test(t)) c = t;
            else break;
        }
    };
    var handleAndroidInput = function handleAndroidInput(e) {
        var curVal = elementRef.current.value;
        var pos = caret();
        if (!pos) return;
        if (oldVal.current.length && oldVal.current.length > curVal.length) {
            // a deletion or backspace happened
            checkVal(true);
            while(pos.begin > 0 && !tests.current[pos.begin - 1])pos.begin--;
            if (pos.begin === 0) while(pos.begin < firstNonMaskPos.current && !tests.current[pos.begin])pos.begin++;
            caret(pos.begin, pos.begin);
        } else {
            checkVal(true);
            while(pos.begin < len.current && !tests.current[pos.begin])pos.begin++;
            caret(pos.begin, pos.begin);
        }
        if (props.onComplete && isCompleted()) props.onComplete({
            originalEvent: e,
            value: getValue()
        });
        updateModel(e);
    };
    var onBlur = function onBlur(e) {
        focus.current = false;
        checkVal();
        updateModel(e);
        updateFilledState();
        props.onBlur && props.onBlur(e);
        if (elementRef.current.value !== focusText.current) {
            var event = document.createEvent('HTMLEvents');
            event.initEvent('change', true, false);
            elementRef.current.dispatchEvent(event);
        }
    };
    var onKeyDown = function onKeyDown(e) {
        if (props.readOnly) return;
        var k = e.which || e.keyCode;
        var pos;
        var begin;
        var end;
        oldVal.current = elementRef.current.value;
        //backspace, delete, and escape get special treatment
        if (k === 8 || k === 46 || (0, $a73ce425265b079e$export$ff8ccbac9225de62).isIOS() && k === 127) {
            pos = caret();
            if (!pos) return;
            begin = pos.begin;
            end = pos.end;
            if (end - begin === 0) {
                begin = k !== 46 ? seekPrev(begin) : end = seekNext(begin - 1);
                end = k === 46 ? seekNext(end) : end;
            }
            clearBuffer(begin, end);
            shiftL(begin, end - 1);
            updateModel(e);
            e.preventDefault();
        } else if (k === 13) {
            // enter
            onBlur(e);
            updateModel(e);
        } else if (k === 27) {
            // escape
            elementRef.current.value = focusText.current;
            caret(0, checkVal());
            updateModel(e);
            e.preventDefault();
        }
    };
    var onKeyPress = function onKeyPress(e) {
        if (props.readOnly) return;
        var pos = caret();
        if (!pos) return;
        var k = e.which || e.keyCode;
        var p;
        var c;
        var next;
        var completed;
        if (e.ctrlKey || e.altKey || e.metaKey || k < 32) //Ignore
        return;
        else if (k && k !== 13) {
            if (pos.end - pos.begin !== 0) {
                clearBuffer(pos.begin, pos.end);
                shiftL(pos.begin, pos.end - 1);
            }
            p = seekNext(pos.begin - 1);
            if (p < len.current) {
                c = String.fromCharCode(k);
                if (tests.current[p].test(c)) {
                    shiftR(p);
                    buffer.current[p] = c;
                    writeBuffer();
                    next = seekNext(p);
                    if ((0, $a73ce425265b079e$export$ff8ccbac9225de62).isAndroid()) {
                        //Path for CSP Violation on FireFox OS 1.1
                        var proxy = function proxy() {
                            caret(next);
                        };
                        setTimeout(proxy, 0);
                    } else caret(next);
                    if (pos.begin <= lastRequiredNonMaskPos.current) completed = isCompleted();
                }
            }
            e.preventDefault();
        }
        updateModel(e);
        if (props.onComplete && completed) props.onComplete({
            originalEvent: e,
            value: getValue()
        });
    };
    var clearBuffer = function clearBuffer(start, end) {
        var i;
        for(i = start; i < end && i < len.current; i++)if (tests.current[i]) buffer.current[i] = getPlaceholder(i);
    };
    var writeBuffer = function writeBuffer() {
        if (elementRef.current) elementRef.current.value = buffer.current.join('');
    };
    var checkVal = function checkVal(allow) {
        isValueChecked.current = true;
        //try to place characters where they belong
        var test = elementRef.current && elementRef.current.value;
        var lastMatch = -1;
        var i;
        var c;
        var pos;
        for(i = 0, pos = 0; i < len.current; i++)if (tests.current[i]) {
            buffer.current[i] = getPlaceholder(i);
            while(pos++ < test.length){
                c = test.charAt(pos - 1);
                if (tests.current[i].test(c)) {
                    buffer.current[i] = c;
                    lastMatch = i;
                    break;
                }
            }
            if (pos > test.length) {
                clearBuffer(i + 1, len.current);
                break;
            }
        } else {
            if (buffer.current[i] === test.charAt(pos)) pos++;
            if (i < partialPosition.current) lastMatch = i;
        }
        if (allow) writeBuffer();
        else if (lastMatch + 1 < partialPosition.current) {
            if (props.autoClear || buffer.current.join('') === defaultBuffer.current) {
                // Invalid value. Remove it and replace it with the
                // mask, which is the default behavior.
                if (elementRef.current && elementRef.current.value) elementRef.current.value = '';
                clearBuffer(0, len.current);
            } else // Invalid value, but we opt to show the value to the
            // user and allow them to correct their mistake.
            writeBuffer();
        } else {
            writeBuffer();
            if (elementRef.current) elementRef.current.value = elementRef.current.value.substring(0, lastMatch + 1);
        }
        return partialPosition.current ? i : firstNonMaskPos.current;
    };
    var onFocus = function onFocus(e) {
        if (props.readOnly) return;
        focus.current = true;
        clearTimeout(caretTimeoutId.current);
        var pos;
        if (elementRef.current) focusText.current = elementRef.current.value;
        else focusText.current = '';
        pos = checkVal() || 0;
        caretTimeoutId.current = setTimeout(function() {
            if (elementRef.current !== document.activeElement) return;
            writeBuffer();
            if (pos === props.mask.replace('?', '').length) caret(0, pos);
            else caret(pos);
            updateFilledState();
        }, 100);
        props.onFocus && props.onFocus(e);
    };
    var onInput = function onInput(event) {
        androidChrome.current ? handleAndroidInput(event) : handleInputChange(event);
    };
    var handleInputChange = function handleInputChange(e) {
        var isOnPaste = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (props.readOnly) return;
        if (!isOnPaste) {
            var pos = checkVal(true);
            caret(pos);
        }
        updateModel(e);
        if (props.onComplete && isCompleted()) props.onComplete({
            originalEvent: e,
            value: getValue()
        });
    };
    var getUnmaskedValue = $acw62.useCallback(function() {
        var unmaskedBuffer = [];
        for(var i = 0; i < buffer.current.length; i++){
            var c = buffer.current[i];
            if (tests.current[i] && c !== getPlaceholder(i)) unmaskedBuffer.push(c);
        }
        return unmaskedBuffer.join('');
    }, [
        getPlaceholder
    ]);
    var updateModel = function updateModel(e) {
        if (props.onChange) {
            var val = props.unmask ? getUnmaskedValue() : e && e.target.value;
            props.onChange({
                originalEvent: e,
                value: defaultBuffer.current !== val ? val : '',
                stopPropagation: function stopPropagation() {
                    e.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    e.preventDefault();
                },
                target: {
                    name: props.name,
                    id: props.id,
                    value: defaultBuffer.current !== val ? val : ''
                }
            });
        }
    };
    var updateFilledState = function updateFilledState() {
        if (elementRef.current && elementRef.current.value && elementRef.current.value.length > 0) (0, $a73ce425265b079e$export$ff8ccbac9225de62).addClass(elementRef.current, 'p-filled');
        else (0, $a73ce425265b079e$export$ff8ccbac9225de62).removeClass(elementRef.current, 'p-filled');
    };
    var updateValue = function updateValue(allow) {
        var pos;
        if (elementRef.current) {
            if (props.value == null) elementRef.current.value = '';
            else {
                elementRef.current.value = props.value;
                pos = checkVal(allow);
                setTimeout(function() {
                    if (elementRef.current) {
                        writeBuffer();
                        return checkVal(allow);
                    }
                }, 10);
            }
            focusText.current = elementRef.current.value;
        }
        updateFilledState();
        return pos;
    };
    var isValueUpdated = $acw62.useCallback(function() {
        return props.unmask ? props.value !== getUnmaskedValue() : defaultBuffer.current !== elementRef.current.value && elementRef.current.value !== props.value;
    }, [
        props.unmask,
        props.value,
        getUnmaskedValue
    ]);
    var init = function init() {
        if (props.mask) {
            tests.current = [];
            partialPosition.current = props.mask.length;
            len.current = props.mask.length;
            firstNonMaskPos.current = null;
            var defs = {
                9: '[0-9]',
                a: '[A-Za-z]',
                '*': '[A-Za-z0-9]'
            };
            androidChrome.current = (0, $a73ce425265b079e$export$ff8ccbac9225de62).isChrome() && (0, $a73ce425265b079e$export$ff8ccbac9225de62).isAndroid();
            var maskTokens = props.mask.split('');
            for(var i = 0; i < maskTokens.length; i++){
                var c = maskTokens[i];
                if (c === '?') {
                    len.current--;
                    partialPosition.current = i;
                } else if (defs[c]) {
                    tests.current.push(new RegExp(defs[c]));
                    if (firstNonMaskPos.current === null) firstNonMaskPos.current = tests.current.length - 1;
                    if (i < partialPosition.current) lastRequiredNonMaskPos.current = tests.current.length - 1;
                } else tests.current.push(null);
            }
            buffer.current = [];
            for(var _i = 0; _i < maskTokens.length; _i++){
                var _c = maskTokens[_i];
                if (_c !== '?') {
                    if (defs[_c]) buffer.current.push(getPlaceholder(_i));
                    else buffer.current.push(_c);
                }
            }
            defaultBuffer.current = buffer.current.join('');
        }
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            props: props,
            focus: function focus() {
                return (0, $a73ce425265b079e$export$ff8ccbac9225de62).focus(elementRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    $acw62.useEffect(function() {
        (0, $a73ce425265b079e$export$4855211e6b8ad895).combinedRefs(elementRef, ref);
    }, [
        elementRef,
        ref
    ]);
    (0, $fbdf1e36fa0a01d8$export$51c44cea289ac0f6)(function() {
        init();
        updateValue();
    });
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        init();
        caret(updateValue(true));
        if (props.unmask) updateModel();
    }, [
        props.mask
    ]);
    (0, $fbdf1e36fa0a01d8$export$496315a1608d9602)(function() {
        if (isValueUpdated()) updateValue();
    }, [
        isValueUpdated
    ]);
    var otherProps = $d4cd4087ef78894c$var$InputMaskBase.getOtherProps(props);
    var className = (0, $a73ce425265b079e$export$ce4ab0c55987d1ff)(props.className, cx('root', {
        context: context
    }));
    return /*#__PURE__*/ $acw62.createElement((0, $ab1a721814a59df6$export$7034fcb7d6351061), $d4cd4087ef78894c$var$_extends({
        ref: elementRef,
        autoFocus: props.autoFocus,
        id: props.id,
        type: props.type,
        name: props.name,
        style: props.style,
        className: className,
        value: props.value
    }, otherProps, {
        placeholder: props.placeholder,
        size: props.size,
        maxLength: props.maxLength,
        tabIndex: props.tabIndex,
        disabled: props.disabled,
        invalid: props.invalid,
        readOnly: props.readOnly,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyPress: onKeyPress,
        onInput: onInput,
        onPaste: function onPaste(e) {
            return handleInputChange(e, true);
        },
        required: props.required,
        tooltip: props.tooltip,
        tooltipOptions: props.tooltipOptions,
        pt: props.pt,
        unstyled: props.unstyled,
        __parentMetadata: {
            parent: metaData
        }
    }));
}));
$d4cd4087ef78894c$export$9f3572e55064b6d2.displayName = 'InputMask';








function $8accedb7060b53f0$export$aa396007db7811e2({ routeId: routeId }) {
    const [visibleDialog, setVisibleDialog] = (0, $acw62.useState)(null);
    const [selectedCells, setSelectedCells] = (0, $acw62.useState)(null);
    const [directionId, setDirectionId] = (0, $acw62.useState)(0);
    const { data: data, isPending: isPending, error: error } = (0, $4529664c1ee19d35$export$ac3dd26b67094cc3)('timetables', routeId);
    const bulkMutation = (0, $4529664c1ee19d35$export$79ad15b2529ad27b)();
    const singleMutation = (0, $4529664c1ee19d35$export$5ecbcf6a102ccf18)();
    const handleOverlay = (0, $acw62.useContext)((0, $bdccf6b6a87b04cc$export$a2200b96afd16271));
    const cmst = (0, $acw62.useRef)(null);
    const cms = (0, $acw62.useRef)(null);
    /* Pobieranie danych */ if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: error.message
    });
    if (isPending || !data) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec34a5c615255cb$export$dcc7532e7120780d), {});
    const content = Object.values(data.timetable[directionId]);
    const trips = Object.values(data.trips[directionId]);
    /* Menu kontekstowe postoju */ const stopTimeMenuItems = [
        {
            label: "Dodaj post\xf3j",
            icon: 'fa-solid fa-square-plus',
            command: ()=>{
                let previousKid = $8accedb7060b53f0$var$getPreviousStopTimeKid(content, selectedCells[0].field.replace('trip_deps.', ''), selectedCells[0].rowIndex);
                console.log('prev kid', previousKid);
                setVisibleDialog('stopTime');
            },
            visible: Array.isArray(selectedCells) && selectedCells.length === 1 && $8accedb7060b53f0$var$getSelectedCellStopTimeKids(selectedCells)[0] == undefined
        },
        {
            label: 'Edycja postoju',
            icon: 'fa-solid fa-edit',
            command: ()=>{
                setVisibleDialog('stopTime');
            },
            visible: Array.isArray(selectedCells) && selectedCells.length === 1 && $8accedb7060b53f0$var$getSelectedCellStopTimeKids(selectedCells)[0] != undefined
        },
        {
            label: 'Przesuwanie w czasie',
            icon: 'fa-solid fa-clock-rotate-left',
            items: [
                {
                    label: "Minut\u0119 wcze\u015Bniej",
                    command: ()=>handleBulkShift(-60)
                },
                {
                    label: "Minut\u0119 p\xf3\u017Aniej",
                    command: ()=>handleBulkShift(60)
                },
                {
                    separator: true
                },
                {
                    label: "Godzin\u0119 wcze\u015Bniej",
                    command: ()=>handleBulkShift(-3600)
                },
                {
                    label: "Godzin\u0119 p\xf3\u017Aniej",
                    command: ()=>handleBulkShift(3600)
                },
                {
                    separator: true
                },
                {
                    label: "Okre\u015Bl czas",
                    command: ()=>{
                        setVisibleDialog('bulkShift');
                    }
                }
            ]
        },
        {
            label: 'Kopiowanie',
            icon: 'fa-solid fa-copy',
            items: [
                {
                    label: 'Kopiuj przyjazdy',
                    icon: 'fa-solid fa-right-to-bracket',
                    command: ()=>$8accedb7060b53f0$var$copyTimetable(selectedCells, true)
                },
                {
                    label: 'Kopiuj odjazdy',
                    icon: 'fa-solid fa-right-from-bracket',
                    command: ()=>$8accedb7060b53f0$var$copyTimetable(selectedCells)
                }
            ]
        },
        {
            label: 'Przenoszenie',
            icon: 'fa-solid fa-location-dot',
            items: [
                {
                    label: 'Na inny przystanek',
                    command: ()=>{
                        setVisibleDialog('bulkMoveToStop');
                    }
                }
            ]
        },
        {
            label: Array.isArray(selectedCells) && selectedCells.length === 1 ? "Usu\u0144 post\xf3j" : "Usu\u0144 postoje",
            icon: 'fa-solid fa-trash',
            command: ()=>handleBulkDelete(),
            visible: Array.isArray(selectedCells) && $8accedb7060b53f0$var$getSelectedCellStopTimeKids(selectedCells)[0] != undefined
        }
    ];
    /* Menu kontekstowe przystanku */ const stopMenuItems = [
        {
            label: "Dodaj przystanek",
            icon: 'fa-solid fa-plus',
            items: [
                {
                    label: 'W tym miejscu'
                },
                {
                    label: 'Po tym przystanku'
                }
            ]
        }
    ];
    /* Naprawiamy po tych chujkach, co nie zaimplementowały zaznaczania pojedynczych komórek
    poprzez contextMenu */ const handleCellContextMenu = (e, selection)=>{
        if (cmst.current) cmst.current.show(e);
    };
    /* Różne akcje */ const handleBulkDelete = ()=>{
        const kids = $8accedb7060b53f0$var$getSelectedCellStopTimeKids(selectedCells);
        if (kids.length > 1) /** Komunikat jako zabezpieczenie przed wywaleniem zbyt wielu postojów na raz */ handleOverlay('confirmDialog', {
            message: "Zamieszasz usun\u0105\u0107 " + kids.length + " postoj\xf3w. Czy chcesz kontynuowa\u0107?",
            header: "Masowe usuwanie postoj\xf3w",
            icon: 'pi pi-info-circle',
            style: {
                width: '500px '
            },
            breakpoints: {
                '960px': '100vw'
            },
            defaultFocus: 'reject',
            acceptLabel: "Usu\u0144",
            acceptClassName: 'p-button-danger',
            acceptIcon: 'fa-solid fa-trash',
            rejectLabel: 'Anuluj',
            accept: ()=>{
                bulkMutation.mutate({
                    query: {
                        resourceTable: 'timetables',
                        action: 'delete'
                    },
                    fields: {
                        kids: kids
                    }
                });
            }
        });
        else /** Pojedyncze usuwanie bez pytania */ bulkMutation.mutate({
            query: {
                resourceTable: 'timetables',
                action: 'delete'
            },
            fields: {
                kids: kids
            }
        });
    };
    const handleBulkMoveTo = (stopId)=>{
        bulkMutation.mutate({
            query: {
                resourceTable: 'timetables',
                action: 'move'
            },
            fields: {
                move_to: stopId,
                kids: $8accedb7060b53f0$var$getSelectedCellStopTimeKids(selectedCells)
            }
        });
    };
    const handleBulkShift = (seconds)=>{
        bulkMutation.mutate({
            query: {
                resourceTable: 'timetables',
                action: 'shift'
            },
            fields: {
                time: seconds,
                kids: $8accedb7060b53f0$var$getSelectedCellStopTimeKids(selectedCells)
            }
        });
    };
    const handleBulkUpdate = (newTimes)=>{
        bulkMutation.mutate({
            query: {
                resourceTable: 'timetables',
                action: 'update'
            },
            fields: newTimes
        });
    };
    const handleSingleUpdate = async (newData)=>{
        const payload = {
            query: {
                resourceTable: 'timetables',
                modified_id: newData.kid
            },
            fields: newData.fields
        };
        try {
            const asyncMutation = await singleMutation.mutateAsync(payload);
            setVisibleDialog(null);
        } catch (error) {
            let errorCode = error.message.substring(0, 3);
            handleOverlay('toast', {
                severity: "error",
                summary: "B\u0142\u0105d " + errorCode,
                detail: error.message
            });
        }
    };
    /* Właściwy rendering tabeli */ // Górna część ze strzałkami do wyboru kierunku
    const headerDirectionTemplate = ()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex align-items-center",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                    text: true,
                    icon: "fa-solid fa-repeat",
                    className: "mr-2",
                    style: {
                        height: '.5rem'
                    },
                    onClick: ()=>{
                        setDirectionId(directionId === 1 ? 0 : 1);
                    }
                }),
                directionId ? "Kierunek POWR\xd3T" : 'Kierunek TAM'
            ]
        });
    };
    // Funkcyjka do testowania, czy dana komórka może być zaznaczona. 
    // Przydatne, jeżeli będę chciał zrobić opcję zaznaczania przystanków...
    const isCellSelectable = (event)=>event.data.field === 'stop_name' ? false : true;
    // Pobieranie ciała komórki z przyjazdami/odjazdami z odpowiedniego komponentu
    const stopTimeBodyTemplate = (stopEntry, tripId, cellIndex, handleCellContextMenu)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8accedb7060b53f0$var$StopTimeCell, {
            stopEntry: stopEntry,
            tripId: tripId,
            cellIndex: cellIndex,
            handleCellContextMenu: handleCellContextMenu
        });
    // To pewnie będzie nasz edytor
    const timeEditor = (options)=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d4cd4087ef78894c$export$9f3572e55064b6d2), {
            id: "stopTimeArrivalDeparture",
            mask: "99:99:99",
            placeholder: "hh:mm:ss",
            slotChar: "hh:mm:ss",
            value: options.value,
            onChange: (e)=>options.editorCallback(e.target.value),
            onKeyDown: (e)=>e.stopPropagation(),
            className: "w-full text-center",
            style: {
                minWidth: '7rem'
            }
        });
    };
    const onCellEditComplete = (e)=>{
        let { rowData: rowData, newValue: newValue, field: field, originalEvent: event } = e;
        if (field.startsWith('trip_deps.')) {
            if ((0, $57ee609582c542b6$export$aa15578fa4825bd5)(newValue)) {
                // prawie optymistyczna aktualizacja przyjazdu
                // odjazdami nie musimy się przejmować, tabela robi to automatycznie
                let tripId = field.replace('trip_deps.', '');
                rowData.trip_arvs[tripId] = newValue;
                // przygotowujemy dane do wysyłki do serwera
                let kid = $8accedb7060b53f0$var$getSelectedCellStopTimeKids(selectedCells);
                const updateFields = {};
                updateFields[kid] = [
                    newValue,
                    newValue
                ];
                // i wysyłamy
                handleBulkUpdate(updateFields);
            } else event.preventDefault;
        }
        switch(field){
            case 'quantity':
            case 'price':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;
            default:
                if (newValue.trim().length > 0) rowData[field] = newValue;
                else event.preventDefault();
                break;
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8accedb7060b53f0$var$DialogBulkShift, {
                visible: visibleDialog === 'bulkShift',
                onHide: ()=>setVisibleDialog(null),
                onOk: (value)=>{
                    handleBulkShift(value * 60) //handleBulkShift przyjmuje sekundy, a okno dialogowe jest w minutach
                    ;
                    setVisibleDialog(null);
                }
            }),
            $8accedb7060b53f0$var$getSelectedCellStopTimeData(selectedCells) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8accedb7060b53f0$var$DialogStopTime, {
                visible: visibleDialog === 'stopTime',
                onHide: ()=>setVisibleDialog(null),
                initialVal: Array.isArray(selectedCells) ? $8accedb7060b53f0$var$getSelectedCellStopTimeData(selectedCells)[0] : false,
                onOk: (newValue, shiftTime)=>{
                    // przygotowujemy dane do wysyłki do serwera
                    const kid = $8accedb7060b53f0$var$getSelectedCellStopTimeKids(selectedCells)[0];
                    let fields = {};
                    if (typeof kid === 'undefined') {
                        // dodawanie nowego postoju do sekwencji
                        let tripId = selectedCells[0].field.replace('trip_deps.', '');
                        let previousKid = $8accedb7060b53f0$var$getPreviousStopTimeKid(content, tripId, selectedCells[0].rowIndex);
                        fields = {
                            action_type: 'insertStopTime',
                            previous_kid: previousKid,
                            arrival_time: newValue.arrivalTime,
                            departure_time: newValue.departureTime,
                            stop_id: selectedCells[0].rowData.stop_id,
                            shift_time: shiftTime,
                            trip_id: previousKid ? null : tripId //tripId potrzebny tylko wtedy, kiedy nie znamy kId poprzedniego postoju
                        };
                    } else // edycja istniejącego postoju
                    fields = {
                        action_type: 'updateStopTime',
                        arrival_time: newValue.arrivalTime,
                        departure_time: newValue.departureTime,
                        shift_time: shiftTime
                    };
                    console.log('ok selected cells', selectedCells);
                    // i wysyłamy
                    handleSingleUpdate({
                        kid: kid,
                        fields: fields
                    });
                }
            }, ('dst' + $8accedb7060b53f0$var$getSelectedCellStopTimeKids(selectedCells)[0], $8accedb7060b53f0$var$getSelectedCellStopTimeKids(selectedCells)[0])) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8accedb7060b53f0$var$DialogMoveToStop, {
                visible: visibleDialog === 'bulkMoveToStop',
                onHide: ()=>setVisibleDialog(null),
                onOk: (value)=>{
                    handleBulkMoveTo(value) //handleBulkShift przyjmuje sekundy, a okno dialogowe jest w minutach
                    ;
                    setVisibleDialog(null);
                },
                initialVal: selectedCells && Array.isArray(selectedCells) && selectedCells.length > 0 ? selectedCells[0].rowData.stop_id : ''
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dde48341f3da2113$export$8dc6765e8be191c7), {
                ref: cmst,
                model: stopTimeMenuItems
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $68eba9483912474c$export$df30df7ec97b32b5), {
                cellSelection: true,
                metaKeySelection: true,
                dragSelection: true,
                selectionMode: "multiple",
                selection: selectedCells,
                onSelectionChange: (e)=>{
                    setSelectedCells(e.value);
                    console.log('setSelectedCells e.value', e.value);
                },
                onContextMenu: (e)=>{
                    /* Naprawiamy po tych chujkach, co nie zaimplementowały zaznaczania pojedynczych komórek
                poprzez contextMenu */ let elCellInterior;
                    // Numer zaznaczonej komórki w wierszu (tj. kolumny) pobieramy z elementu data-cellIndex, który sami utworzyliśmy w ciele komórki...
                    if (e.originalEvent.target.hasAttribute("data-cellIndex")) elCellInterior = e.originalEvent.target;
                    else // Jeżeli obiekt, który kliknęliśmy, nie zawiera sam w sobie atrybutu [data-value], to szukamy rodzica, który zawiera
                    elCellInterior = e.originalEvent.target.closest('[data-cellIndex]');
                    if (!elCellInterior) return; // Nie ma takiego obiektu? Albercik, wychodzimy...
                    const cellIndex = parseInt(elCellInterior.getAttribute("data-cellIndex"));
                    // Numer zaznaczonego wiersza na szczęście mamy w pierwotnym evencie...
                    const rowIndex = e.index;
                    // Sorawdzanie, czy kliknięta w tej akcji komórka jest częścią zaznaczenia...
                    const inSelection = Array.isArray(selectedCells) ? selectedCells.some((obj)=>obj.cellIndex === cellIndex && obj.rowIndex === rowIndex) : false;
                    if (!inSelection) // Jeżeli komórka, którą kliknęliśmy PPM nie jest obecna w zaznaczeniu, odznaczamy wszystko by uniknąć nieporozumień
                    // Pierwotnie robiłem po prostu setSelectedCells(null), ale postanowiłeś się porwać na programatyczne zazn. właściwej komórki
                    // W tym celu muszę sztucznie utworzyć obiekt komórki...
                    setSelectedCells([
                        {
                            cellIndex: cellIndex,
                            rowIndex: rowIndex,
                            rowData: e.data,
                            // Muszę sfabrykować pole "field" komórki, żeby odpowiadało formatowi... w tym celu pobieram numer tripa z tablicy bazując na indeksie komórki
                            field: 'trip_deps.' + String(trips[cellIndex - 1].trip_id)
                        }
                    ]);
                    // Właściwe wywoływanie menu konktekstowego dla zazn. komórek
                    handleCellContextMenu(e.originalEvent);
                },
                scrollable: true,
                scrollHeight: "87vh",
                tableStyle: {
                    minWidth: '50rem',
                    userSelect: 'none',
                    fontSize: '.9rem'
                },
                size: "small",
                stripedRows: true,
                editMode: "cell",
                value: content,
                isDataSelectable: isCellSelectable,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8e4d38781145a41$export$816b5d811295e6bc), {
                        frozen: true,
                        header: headerDirectionTemplate,
                        style: {
                            width: '400px',
                            minWidth: '400px',
                            maxWidth: '400px'
                        },
                        field: "stop_name",
                        body: (stopEntry)=>{
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex align-items-center",
                                style: {
                                    width: '400px',
                                    minWidth: '400px',
                                    maxWidth: '400px'
                                },
                                children: [
                                    stopEntry.stop_name,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mx-2",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a79a81cc3b591c5$export$5d8a4b9af9ca5f5b), {
                                            platformCode: stopEntry.platform_code
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-xs text-200",
                                        children: stopEntry.stop_id
                                    })
                                ]
                            });
                        }
                    }),
                    trips.map((trip, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8e4d38781145a41$export$816b5d811295e6bc), {
                            field: "trip_deps." + trip.trip_id,
                            alignHeader: "center",
                            header: ()=>{
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8accedb7060b53f0$var$TripHead, {
                                    GTrip: trip
                                }, 'h' + trip.trip_id);
                            },
                            headerClassName: "p-0",
                            headerStyle: {
                                borderLeft: '1px solid rgba(255, 255, 255, 0.06)',
                                backgroundColor: 'rgba(255, 255, 255, 0.2)'
                            },
                            body: (stopEntry)=>stopTimeBodyTemplate(stopEntry, trip.trip_id, i + 1),
                            bodyStyle: {
                                /* backgroundColor: (i % 2) ? 'rgba(255, 255, 255, 0.05)' : 'transparent'  -- wyklucza się z zaznaczaniem komórek :( */ borderLeft: '1px solid rgba(255, 255, 255, 0.06)',
                                padding: '0',
                                maxWidth: '7rem'
                            },
                            editor: (options)=>timeEditor(options),
                            onCellEditComplete: onCellEditComplete,
                            onContextMenu: (e)=>console.log('ocm column', e)
                        }, trip.trip_id))
                ]
            })
        ]
    });
}
/* Komponent z nagłówkiem kursu */ function $8accedb7060b53f0$var$TripHead({ GTrip: GTrip }) {
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const toolDispatch = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$6bbcf3368996eea5));
    const cmt = (0, $acw62.useRef)(null);
    const menuItems = [
        {
            label: "Edytuj kurs",
            icon: "fa-solid fa-edit",
            command: ()=>{
                toolDispatch({
                    type: 'changed',
                    newTool: {
                        ...(0, $91fa2a3eb54dc801$export$88ae2e76299eaa00).tools['tripsTool'],
                        selection: GTrip,
                        propertyEditor: {
                            edit: GTrip
                        }
                    }
                });
            }
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "p-2 m-0 w-full",
        onContextMenu: (e)=>cmt.current.show(e),
        onDoubleClick: ()=>{
            toolDispatch({
                type: 'changed',
                newTool: {
                    ...(0, $91fa2a3eb54dc801$export$88ae2e76299eaa00).tools['tripsTool'],
                    selection: GTrip,
                    propertyEditor: {
                        edit: GTrip
                    }
                }
            });
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dde48341f3da2113$export$8dc6765e8be191c7), {
                ref: cmt,
                model: menuItems
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                children: GTrip.trip_id
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-xs",
                children: GTrip.service_id
            })
        ]
    });
}
/* Komponent z ciałem komórki z postojem (odjazd, przyjazd) */ function $8accedb7060b53f0$var$StopTimeCell({ stopEntry: stopEntry, tripId: tripId, cellIndex: cellIndex }) {
    let cellContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    if (!stopEntry.trip_deps[tripId]) cellContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: "|"
    });
    else if (stopEntry.trip_deps[tripId] === stopEntry.trip_arvs[tripId]) cellContent = (0, $57ee609582c542b6$export$97f3bd6a84b329eb)(stopEntry.trip_deps[tripId]);
    else cellContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            whiteSpace: 'nowrap'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    borderBottom: '1px solid gray'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        class: "text-xs text-200",
                        children: "p."
                    }),
                    " ",
                    (0, $57ee609582c542b6$export$97f3bd6a84b329eb)(stopEntry.trip_arvs[tripId])
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        class: "text-xs text-200",
                        children: "o."
                    }),
                    " ",
                    (0, $57ee609582c542b6$export$97f3bd6a84b329eb)(stopEntry.trip_deps[tripId])
                ]
            })
        ]
    });
    /**  Przekazany przez cellIndex indeks komórki w wierszu (czyli de fakto numer kolumny) potrzebny nam jest do wywoływania menu kontekstowego przez komponent tabeli.
    * To część hacka wynikającego z tego, że chujki nie zaimplementowały możliwości zaznaczania pojedynczej komórki tabeli prawym przyciskiem myszki (zaznacza się cały wiersz).
    * 
    */ return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-cellindex": cellIndex,
        className: "text-center",
        style: {
            padding: '.5rem',
            margin: '0'
        },
        children: cellContent
    });
}
/**
 * OKIENKA DIALOGOWE  
 */ function $8accedb7060b53f0$var$DialogBulkShift({ visible: visible, onOk: onOk, onHide: onHide }) {
    const [value, setValue] = (0, $acw62.useState)(0);
    const dialogFooterContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                label: "Anuluj",
                icon: "pi pi-times",
                onClick: ()=>onHide(),
                className: "p-button-text"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                label: "OK",
                icon: "pi pi-check",
                onClick: ()=>{
                    onOk(value);
                },
                autoFocus: true
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3c56f96c6f20f77$export$3ddf2d174ce01153), {
        header: "Przesu\u0144 postoje o:",
        footer: dialogFooterContent,
        visible: visible,
        onHide: onHide,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex-auto",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df4bf6c8c7efd937$export$cf9581d419a141cf), {
                showButtons: true,
                buttonLayout: "horizontal",
                incrementButtonIcon: "fa-solid fa-plus",
                decrementButtonIcon: "fa-solid fa-minus",
                value: value,
                onValueChange: (e)=>setValue(e.value),
                inputStyle: {
                    width: '100px'
                },
                suffix: " minut"
            })
        })
    });
}
function $8accedb7060b53f0$var$DialogMoveToStop({ visible: visible, onOk: onOk, onHide: onHide, initialVal: initialVal }) {
    const [value, setValue] = (0, $acw62.useState)(initialVal);
    const { data: stopsList, isPending: isPending } = (0, $4529664c1ee19d35$export$c3a687f3d6e3fb65)('stops');
    const dialogFooterContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                label: "Anuluj",
                icon: "pi pi-times",
                onClick: ()=>onHide(),
                className: "p-button-text"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                label: "OK",
                icon: "pi pi-check",
                onClick: ()=>{
                    onOk(value);
                },
                autoFocus: true
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3c56f96c6f20f77$export$3ddf2d174ce01153), {
        header: "Przesu\u0144 post\xf3j na przystanek:",
        footer: dialogFooterContent,
        visible: visible,
        onHide: onHide,
        style: {
            maxWidth: '470px'
        },
        children: isPending || !stopsList ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec34a5c615255cb$export$dcc7532e7120780d), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1aa42f680c61ccaa$export$f2e335d0f285264e), {
            propertyName: "",
            initialVal: initialVal,
            onDone: (property, value)=>setValue(value),
            options: Object.values(stopsList)
        })
    });
}
function $8accedb7060b53f0$var$DialogAddStop({ visible: visible, onOk: onOk, onHide: onHide, initialVal: initialVal }) {
    const [value, setValue] = (0, $acw62.useState)(initialVal);
    const { data: stopsList, isPending: isPending } = (0, $4529664c1ee19d35$export$c3a687f3d6e3fb65)('stops');
    const dialogFooterContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                label: "Anuluj",
                icon: "pi pi-times",
                onClick: ()=>onHide(),
                className: "p-button-text"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                label: "OK",
                icon: "pi pi-check",
                onClick: ()=>{
                    onOk(value);
                },
                autoFocus: true
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3c56f96c6f20f77$export$3ddf2d174ce01153), {
        header: "Dodaj przystanek:",
        footer: dialogFooterContent,
        visible: visible,
        onHide: onHide,
        style: {
            maxWidth: '470px'
        },
        children: isPending || !stopsList ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec34a5c615255cb$export$dcc7532e7120780d), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1aa42f680c61ccaa$export$f2e335d0f285264e), {
            propertyName: "",
            initialVal: initialVal,
            onDone: (property, value)=>setValue(value),
            options: Object.values(stopsList)
        })
    });
}
function $8accedb7060b53f0$var$DialogStopTime({ visible: visible, onOk: onOk, onHide: onHide, initialVal: initialVal }) {
    const [value, setValue] = (0, $acw62.useState)(initialVal);
    const [shiftValue, setShiftValue] = (0, $acw62.useState)(null);
    if (!value) setValue({
        arrivalTime: "00:00:00",
        departureTime: "00:00:00"
    });
    const dialogFooterContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                label: "Anuluj",
                icon: "pi pi-times",
                onClick: ()=>onHide(),
                className: "p-button-text"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                label: "OK",
                icon: "pi pi-check",
                onClick: ()=>{
                    onOk(value, shiftValue * 60);
                },
                autoFocus: true
            })
        ]
    });
    const handleChangeRestTime = (inputVal)=>{
        const arrivalDate = (0, $57ee609582c542b6$export$b5e0a67a7694b7fe)(value.arrivalTime);
        arrivalDate.setDate(arrivalDate.getDate() + calcAddedDay(value.arrivalTime));
        let departureDate = new Date(arrivalDate.getTime() + inputVal * 60000);
        setValue({
            ...value,
            departureTime: (0, $57ee609582c542b6$export$7ba7d389fd0af3e)(departureDate, calcAddedDay(value.arrivalTime) + (departureDate.getDate() - arrivalDate.getDate()))
        });
    };
    const handleChangeAddedDays = (inputVal, isArrivalTime = false)=>{
        let gtfsTimeString = isArrivalTime ? value.arrivalTime : value.departureTime;
        if (typeof gtfsTimeString !== 'string') return null;
        const [hh, mm, ss = ':00'] = gtfsTimeString.split(':', 3);
        normalizedHour = parseInt(hh) % 24;
        newHour = normalizedHour + inputVal * 24;
        let newGtfsTimeString = newHour.toString().padStart(2, 0) + ":" + mm.toString().padStart(2, 0) + ":" + ss.toString().padStart(2, 0);
        console.log('added days', inputVal, gtfsTimeString, newGtfsTimeString);
        if (isArrivalTime) setValue({
            ...value,
            arrivalTime: newGtfsTimeString
        });
        else setValue({
            ...value,
            departureTime: newGtfsTimeString
        });
    };
    const calcShiftStoptimes = ()=>{
        if (!initialVal) {
            setShiftValue(0);
            return;
        }
        let originalDepartureDate = (0, $57ee609582c542b6$export$b5e0a67a7694b7fe)(initialVal.departureTime, calcAddedDay(initialVal.departureTime));
        let newDepartureDate = (0, $57ee609582c542b6$export$b5e0a67a7694b7fe)(value.departureTime, calcAddedDay(value.departureTime));
        setShiftValue((newDepartureDate - originalDepartureDate) / 1000 / 60);
    };
    const calcAddedDay = (gtfsTimeString)=>{
        if (typeof gtfsTimeString !== 'string') return null;
        let hour = gtfsTimeString.split(':')[0];
        return Math.floor(hour / 24);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a3c56f96c6f20f77$export$3ddf2d174ce01153), {
        header: initialVal ? "Edytuj post\xf3j" : "Dodaj post\xf3j",
        footer: dialogFooterContent,
        visible: visible,
        onHide: onHide,
        style: {
            maxWidth: '470px'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                class: "formgrid grid",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        class: "field col-8",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                htmlFor: "arrival-time",
                                className: "block",
                                children: "Godzina przyjazdu"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7829c495bb40f01d$export$e1aef45b828286de), {
                                inputId: "arrival-time",
                                value: value ? (0, $57ee609582c542b6$export$b5e0a67a7694b7fe)(value.arrivalTime) : '',
                                onChange: (e)=>setValue({
                                        ...value,
                                        arrivalTime: (0, $57ee609582c542b6$export$7ba7d389fd0af3e)(e.value, calcAddedDay(value.arrivalTime))
                                    }),
                                timeOnly: true,
                                showSeconds: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        class: "field col-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                htmlFor: "arrival-day",
                                className: "block",
                                children: "Doba"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df4bf6c8c7efd937$export$cf9581d419a141cf), {
                                inputStyle: {
                                    maxWidth: '5.5rem'
                                },
                                inputId: "arrival-day",
                                value: value ? calcAddedDay(value.arrivalTime) : null,
                                onValueChange: (e)=>handleChangeAddedDays(e.value, true),
                                showButtons: true,
                                min: 0,
                                prefix: "+",
                                suffix: value && calcAddedDay(value.arrivalTime) === 1 ? " dzie\u0144" : " dni"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        class: "field col-12 text-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                htmlFor: "rest-time",
                                className: "block",
                                children: "Czas postoju"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df4bf6c8c7efd937$export$cf9581d419a141cf), {
                                showButtons: true,
                                buttonLayout: "horizontal",
                                incrementButtonIcon: "fa-solid fa-plus",
                                decrementButtonIcon: "fa-solid fa-minus",
                                value: value && (0, $57ee609582c542b6$export$b5e0a67a7694b7fe)(value.departureTime) && (0, $57ee609582c542b6$export$b5e0a67a7694b7fe)(value.arrivalTime) ? ((0, $57ee609582c542b6$export$b5e0a67a7694b7fe)(value.departureTime).getTime() + 86400000 * calcAddedDay(value.departureTime) - (0, $57ee609582c542b6$export$b5e0a67a7694b7fe)(value.arrivalTime).getTime() - 86400000 * calcAddedDay(value.arrivalTime)) / 60000 : 0,
                                onValueChange: (e)=>handleChangeRestTime(e.value),
                                inputStyle: {
                                    width: '100px'
                                },
                                suffix: " minut",
                                inputId: "rest-time",
                                min: 0,
                                useGrouping: false
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        class: "field col-8",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                htmlFor: "departure-time",
                                className: "block",
                                children: "Godzina odjazdu"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7829c495bb40f01d$export$e1aef45b828286de), {
                                inputId: "departure-time",
                                value: value ? (0, $57ee609582c542b6$export$b5e0a67a7694b7fe)(value.departureTime) : '',
                                onChange: (e)=>{
                                    setValue({
                                        ...value,
                                        departureTime: (0, $57ee609582c542b6$export$7ba7d389fd0af3e)(e.value, calcAddedDay(value.departureTime))
                                    });
                                },
                                timeOnly: true,
                                showSeconds: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        class: "field col-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                htmlFor: "departure-day",
                                className: "block",
                                children: "Doba"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df4bf6c8c7efd937$export$cf9581d419a141cf), {
                                inputStyle: {
                                    maxWidth: '5.5rem'
                                },
                                inputId: "departure-day",
                                value: value ? calcAddedDay(value.departureTime) : null,
                                onValueChange: (e)=>handleChangeAddedDays(e.value),
                                showButtons: true,
                                min: 0,
                                prefix: "+",
                                suffix: value && calcAddedDay(value.departureTime) === 1 ? " dzie\u0144" : " dni"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                class: "flex align-items-center mt-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639e87ee01b59761$export$48513f6b9f8ce62d), {
                        checked: shiftValue !== null,
                        onChange: (e)=>{
                            if (e.checked === false) setShiftValue(null);
                            else calcShiftStoptimes();
                        },
                        inputId: "enableShift"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "ml-2",
                        htmlFor: "enableShift",
                        children: "Przesu\u0144 kolejne postoje na tym kursie"
                    })
                ]
            }),
            shiftValue !== null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                class: "formgroup-inline mt-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    class: "field",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            htmlFor: "shift",
                            className: "mr-4 mb-2",
                            children: "Przesu\u0144 o:"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df4bf6c8c7efd937$export$cf9581d419a141cf), {
                            showButtons: true,
                            buttonLayout: "horizontal",
                            incrementButtonIcon: "fa-solid fa-plus",
                            decrementButtonIcon: "fa-solid fa-minus",
                            value: shiftValue,
                            onValueChange: (e)=>setShiftValue(e.value),
                            inputStyle: {
                                width: '100px'
                            },
                            suffix: " minut",
                            inputId: "shift"
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
        ]
    });
}
/** 
 *  FUNKCJE POMOCNICZE
 * */ function $8accedb7060b53f0$var$copyTimetable(cells, copyArrivals = false) {
    console.log(cells);
    // Inicjalizacja zmiennej do przechowywania tekstu, który będzie skopiowany
    let textToCopy = '';
    // Zmienna do przechowywania numeru poprzedniego wiersza
    let previousCellRow = null;
    // Iterujemy po tablicy obiektów z zawartością komórek
    cells.forEach((element, ind)=>{
        // trip_id przechowywane jest w obiekcie kopiowanej komórki jako wartość pola "field", poprzedzona nazwą obiektu, w którym trzymane są odjazdy - trip_deps.
        // (bo to odjazdy stanowią główną wartość pola komórki). Usuwany "trip_deps" z fielda i mamy numer kursu.
        let tripId = String(element.field).replace('trip_deps.', '');
        // Czy jesteśmy w nowym wierszu?
        if (previousCellRow !== null && previousCellRow !== element.rowIndex) textToCopy += '\n'; // dodajemy znak nowej linii
        else if (previousCellRow !== null) textToCopy += '\t'; // dodajemy znak tabulacji (jeżeli to nie jest pierwsza komórka, którą kopiujemy)
        // Z którego zbioru kopiujemy godziny? Odjazdów czy przyjazdów?
        let timeSet = copyArrivals ? 'trip_arvs' : 'trip_deps';
        // Jeśli komóka NIE jest pusta
        if (typeof element.rowData[timeSet][tripId] !== 'undefined') {
            let cellText = element.rowData[timeSet][tripId];
            if (String(cellText).length === 8 && String(cellText).endsWith(':00')) cellText = String(cellText).substring(0, 5);
            textToCopy += cellText;
        } else textToCopy += ''; // w przeciwnym razie nic nie kopiujemy
        // Ustawienie bieżącego wiersza jako poprzedniego wiersza
        previousCellRow = element.rowIndex;
    });
    // Kopiowanie do schowka za pomocą API Clipboard
    navigator.clipboard.writeText(textToCopy).then(function() {
    //
    }, function(err) {
        alert("Nie uda\u0142o si\u0119 skopiowa\u0107 zawarto\u015Bci: ", err);
    });
}
function $8accedb7060b53f0$var$getSelectedCellStopTimeKids(cells) {
    let selectedStopTimeKids = [];
    cells.forEach((element)=>{
        let tripId = String(element.field).replace('trip_deps.', '');
        // Jeśli komóka NIE jest pusta
        if (element.rowData.trip_stoptime_kids[tripId]) selectedStopTimeKids.push(element.rowData.trip_stoptime_kids[tripId]);
    });
    return selectedStopTimeKids;
}
function $8accedb7060b53f0$var$getSelectedCellStopTimeData(cells) {
    let selectedStopTimeData = [];
    if (!cells) return null;
    cells.forEach((element)=>{
        let tripId = String(element.field).replace('trip_deps.', '');
        // Jeśli komóka NIE jest pusta
        if (element.rowData.trip_stoptime_kids[tripId]) selectedStopTimeData.push({
            kid: element.rowData.trip_stoptime_kids[tripId],
            arrivalTime: element.rowData.trip_arvs[tripId],
            departureTime: element.rowData.trip_deps[tripId]
        });
    });
    return selectedStopTimeData;
}
function $8accedb7060b53f0$var$getPreviousStopTimeKid(tableContent, tripId, currentRowIndex) {
    for(let i = currentRowIndex; i >= 0; i--)if (typeof tableContent[i].trip_deps !== "undefined" && Object.hasOwn(tableContent[i].trip_deps, tripId)) {
        console.log('found previous stop time at rowindex', i);
        return tableContent[i].trip_stoptime_kids[tripId];
    }
    console.log('no previous stoptimes');
    return null;
}





var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

function $638a8eb8537cf0f0$export$bd9fef6bf65b4fa8() {
    const { data: data, isPending: isPending, error: error } = (0, $4529664c1ee19d35$export$c3a687f3d6e3fb65)('stops');
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const toolDispatch = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$6bbcf3368996eea5));
    const mutateStop = (0, $4529664c1ee19d35$export$a60c7f0127bb920c)();
    if (!data || isPending || error) return null;
    const handleClick = (e, GStop)=>{
        /* Zaznaczanie w trybie odcinków */ if (tool.name === 'segmentsTool') {
            const newSelection = {
                ...tool.selection
            };
            if (!newSelection.from_stop_id && !newSelection.to_stop_id) newSelection.from_stop_id = GStop.stop_id;
            else if (newSelection.from_stop_id && !newSelection.to_stop_id) newSelection.to_stop_id = GStop.stop_id;
            else {
                newSelection.from_stop_id = GStop.stop_id;
                newSelection.to_stop_id = null;
            }
            toolDispatch({
                type: 'changed',
                newTool: {
                    ...tool,
                    selection: newSelection
                }
            });
            return;
        }
        /** Normalne zaznaczanie */ toolDispatch({
            type: 'changed',
            newTool: {
                ...(0, $91fa2a3eb54dc801$export$88ae2e76299eaa00).tools.stopsTool,
                selection: GStop.stop_id,
                propertyEditor: {
                    edit: GStop,
                    popup: true
                }
            }
        });
    };
    const markerColor = (GStop)=>{
        if (tool.name === "segmentsTool") {
            if (!tool.selection) return "#0000ff"; // normalny
            if (tool.selection.from_stop_id == GStop.stop_id) return "#00ff00"; // zielony
            if (tool.selection.to_stop_id == GStop.stop_id) return "#ff0000"; // czerwony
            return "#0000ff" // normalny
            ;
        }
        return tool.selection === GStop.stop_id ? "#ffff00" : "#0000ff" // żółty lub niebieski
        ;
    };
    const Markers = Object.entries(data).map(([, GStop])=>{
        //key = (tool.selection === GStop.stop_id) ? GStop.stop_id + 'sel' : GStop.stop_id;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67986de690c27df1$export$9c80a1fbd87b52cd), {
            draggable: tool.selection === GStop.stop_id,
            latitude: GStop.stop_lat,
            longitude: GStop.stop_lon,
            color: markerColor(GStop),
            scale: 0.75,
            clickTolerance: 10,
            onClick: (e)=>handleClick(e, GStop),
            onContextMenu: (e)=>console.log('markermeni', e),
            onDragEnd: (e)=>{
                const ll = e.target._lngLat;
                const data = {
                    query: {
                        modified_stop_id: GStop.stop_id
                    },
                    fields: {
                        stop_lat: ll.lat,
                        stop_lon: ll.lng
                    }
                };
                mutateStop.mutate(data);
            }
        }, GStop.stop_id);
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: Markers
    });
}







function $4019cf171336383e$export$386a01e96d121c2e({ GStop: GStop, onClose: onClose }) {
    const routes = typeof GStop.stats.routes !== 'undefined' ? Object.entries(GStop.stats.routes).map(([, GRoute])=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2cd10a5f6773a01$export$bfbea4d618559e4a), {
            GRoute: GRoute
        }, GRoute.route_id);
    }) : [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $67986de690c27df1$export$cc3017644f5b7cfa), {
        longitude: GStop.stop_lon,
        latitude: GStop.stop_lat,
        offset: (0, $67986de690c27df1$export$7ebcd6df36973133),
        /* onMapClick={onClose} */ style: {
            width: '350px'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5297d4b5b893f6cf$export$353f5b6fc5456de1), {
                rounded: true,
                text: true,
                icon: "pi pi-times",
                size: "small",
                severity: "danger",
                "aria-label": "Cancel",
                className: "absolute top-0 right-0",
                onClick: onClose
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                children: [
                    "\uD83D\uDE8F ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontWeight: 'normal'
                        },
                        className: "text-200 text-xs",
                        children: GStop.stop_id
                    }),
                    " ",
                    GStop.stop_name,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a79a81cc3b591c5$export$5d8a4b9af9ca5f5b), {
                        platformCode: GStop.platform_code
                    })
                ]
            }),
            routes.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "p-0 m-0",
                style: {
                    fontSize: '1rem'
                },
                children: routes
            }) : "\u274C Brak linii odje\u017Cd\u017Caj\u0105cych z tego stanowiska."
        ]
    });
}








var $acw62 = parcelRequire("acw62");



function $7dfd7970afb7f4dc$export$754cbeee87f4dd3e() {
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const GRoute = tool.propertyEditor.edit;
    const { isPending: isPending, error: error, data: data } = (0, $4529664c1ee19d35$export$ac3dd26b67094cc3)('shapes/route', GRoute.route_id, 'both');
    const id = (0, $acw62.useId)();
    const map = (0, $67986de690c27df1$export$86f8f9f08863e403)("map-ml");
    const Layers = [];
    (0, $acw62.useEffect)(()=>{
        /** trochę skomplikowana procedura dostosowywania mapy do 
         * kształtu linii komunikacyjnej na mapie, zaczerpnięta
         * z przykładu w dokumentacji maplibre: 
         * 
         * https://maplibre.org/maplibre-gl-js/docs/examples/zoomto-linestring/
         * 
         * */ if (!data) return;
        const coordinates = data.flatMap((obiekt)=>Object.values(obiekt)).flat();
        const bounds = coordinates.reduce((bounds, coord)=>{
            return bounds.extend(coord);
        }, new (0, $0a06c4d6833722ed$exports.LngLatBounds)(coordinates[0], coordinates[0]));
        map.fitBounds(bounds, {
            padding: 20
        });
    }, [
        Layers,
        data
    ]);
    if (isPending || error || !data) return;
    const layout = {
        'line-cap': 'round',
        'line-join': 'round'
    };
    const paintFirst = {
        'line-color': '#' + GRoute.route_color,
        'line-width': 6
    };
    const paint = {
        'line-color': '#' + GRoute.route_color,
        'line-width': 3,
        'line-dasharray': [
            6,
            3
        ]
    };
    data.forEach((element)=>{
        let first = true;
        for (const [key, value] of Object.entries(element)){
            Layers.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67986de690c27df1$export$c556dc2545483cc5), {
                        id: 'S' + id + '_' + key,
                        type: "geojson",
                        data: {
                            "type": "FeatureCollection",
                            "features": [
                                {
                                    "type": "Feature",
                                    "geometry": {
                                        "coordinates": [
                                            ...value
                                        ],
                                        "type": "LineString"
                                    }
                                }
                            ]
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67986de690c27df1$export$436487146afe7e99), {
                        source: 'S' + id + '_' + key,
                        id: 'L' + id + '_' + key,
                        type: "line",
                        paint: first ? paintFirst : paint,
                        layout: layout
                    })
                ]
            }));
            first = false;
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: Layers
    });
}





var $acw62 = parcelRequire("acw62");



function $bf6b2ce76be191ca$export$5308d098215f8506() {
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const GTrip = tool.propertyEditor.edit;
    const { isPending: stopsIsPending, error: stopsError, data: stopsData } = (0, $4529664c1ee19d35$export$ac3dd26b67094cc3)('trips', GTrip.trip_id, 'stop_times');
    const { isPending: shapeIsPending, error: shapeError, data: shapeData } = (0, $4529664c1ee19d35$export$ac3dd26b67094cc3)('shapes', GTrip.shape_id);
    const id = (0, $acw62.useId)();
    const map = (0, $67986de690c27df1$export$86f8f9f08863e403)("map-ml");
    const Layers = [];
    (0, $acw62.useEffect)(()=>{
        /** trochę skomplikowana procedura dostosowywania mapy do 
         * kształtu linii komunikacyjnej na mapie, zaczerpnięta
         * z przykładu w dokumentacji maplibre: 
         * 
         * https://maplibre.org/maplibre-gl-js/docs/examples/zoomto-linestring/
         * 
         * */ if (!shapeData) return;
        const coordinates = shapeData;
        const bounds = coordinates.reduce((bounds, coord)=>{
            return bounds.extend(coord);
        }, new (0, $0a06c4d6833722ed$exports.LngLatBounds)(coordinates[0], coordinates[0]));
        map.fitBounds(bounds, {
            padding: 20
        });
    }, [
        stopsData,
        shapeData
    ]);
    if (shapeIsPending || shapeError || !shapeData || stopsIsPending || stopsError || !stopsData) return;
    const layout = {
        'line-cap': 'round',
        'line-join': 'round'
    };
    const paint = {
        'line-color': '#0000ff',
        'line-width': 4
    };
    const stopPaint = {
        'circle-radius': 4,
        'circle-color': '#ffffff',
        'circle-stroke-width': 2,
        'circle-stroke-color': '#0000ff'
    };
    /** Kształt trasy kursu */ Layers.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67986de690c27df1$export$c556dc2545483cc5), {
                id: 'S' + GTrip.trip_id,
                type: "geojson",
                data: {
                    "type": "FeatureCollection",
                    "features": [
                        {
                            "type": "Feature",
                            "geometry": {
                                "coordinates": [
                                    ...shapeData
                                ],
                                "type": "LineString"
                            }
                        }
                    ]
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67986de690c27df1$export$436487146afe7e99), {
                source: 'S' + GTrip.trip_id,
                id: 'L' + GTrip.trip_id,
                type: "line",
                paint: paint,
                layout: layout
            })
        ]
    }));
    /** Punkty przystanków  */ const stopsFeatures = stopsData.map((stopTime, index)=>{
        return {
            "type": "Feature",
            "properties": {
                "stopIndex": index,
                "stopName": stopTime.stop_name,
                "arrivalTime": stopTime.arrival_time,
                "departureTime": stopTime.departure_time
            },
            "geometry": {
                "coordinates": [
                    stopTime.stop_lon,
                    stopTime.stop_lat
                ],
                "type": "Point"
            }
        };
    });
    Layers.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67986de690c27df1$export$c556dc2545483cc5), {
                id: 'St' + GTrip.trip_id + '_',
                type: "geojson",
                data: {
                    "type": "FeatureCollection",
                    "features": [
                        ...stopsFeatures
                    ]
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bf6b2ce76be191ca$var$StopTimesLayer, {
                source: 'St' + GTrip.trip_id + '_',
                id: 'Lt' + GTrip.trip_id + '_',
                type: "circle",
                paint: stopPaint
            })
        ]
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: Layers
    });
}
/** Warstewa z przystankami + popup/tooltip */ function $bf6b2ce76be191ca$var$StopTimesLayer({ source: source, id: id, type: type, paint: paint }) {
    const [tooltip, setTooltip] = (0, $acw62.useState)(null);
    const popupStopTime = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67986de690c27df1$export$cc3017644f5b7cfa), {
        latitude: tooltip ? tooltip.lat : false,
        longitude: tooltip ? tooltip.lng : false,
        children: tooltip && tooltip.content
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            tooltip ? popupStopTime : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67986de690c27df1$export$436487146afe7e99), {
                source: source,
                id: id,
                type: type,
                paint: paint,
                onMouseEnter: (e)=>{
                    console.log('me', e);
                    setTooltip({
                        lat: e.lngLat.lat,
                        lng: e.lngLat.lng,
                        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                e.features[0].properties.stopIndex,
                                ".)",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("b", {
                                    children: [
                                        " ",
                                        ' ' + (e.features[0].properties.arrivalTime === e.features[0].properties.departureTime ? e.features[0].properties.departureTime : e.features[0].properties.arrivalTime + "\u2014" + e.features[0].properties.departureTime) + ' ',
                                        " "
                                    ]
                                }),
                                e.features[0].properties.stopName
                            ]
                        })
                    });
                },
                onMouseLeave: (e)=>{
                    setTooltip(null);
                }
            })
        ]
    });
}





var $acw62 = parcelRequire("acw62");



function $5058179988c5c989$export$521056d844d0f9a6() {
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const GTrip = tool.selection;
    const { data: segment, isPendingS: isPendingS, errorS: errorS } = (0, $4529664c1ee19d35$export$133314fb4acfa730)(tool.selection ? tool.selection.route_type : 3, tool.selection ? tool.selection.from_stop_id : null, tool.selection ? tool.selection.to_stop_id : null);
    const { isPending: shapeIsPending, error: shapeError, data: shapeData } = (0, $4529664c1ee19d35$export$fc8d7d30ebdb0ba0)(tool.selection.route_type, tool.selection.from_stop_id, tool.selection.to_stop_id);
    const id = (0, $acw62.useId)();
    const map = (0, $67986de690c27df1$export$86f8f9f08863e403)("map-ml");
    const Layers = [];
    (0, $acw62.useEffect)(()=>{
        /** trochę skomplikowana procedura dostosowywania mapy do 
         * kształtu segmentuj na mapie, zaczerpnięta
         * z przykładu w dokumentacji maplibre: 
         * 
         * https://maplibre.org/maplibre-gl-js/docs/examples/zoomto-linestring/
         * 
         * */ if (!shapeData) return;
        const coordinates = shapeData;
        const bounds = coordinates.reduce((bounds, coord)=>{
            return bounds.extend(coord);
        }, new (0, $0a06c4d6833722ed$exports.LngLatBounds)(coordinates[0], coordinates[0]));
        map.fitBounds(bounds, {
            padding: 20
        });
    }, [
        tool.selection,
        shapeData
    ]);
    if (shapeIsPending || shapeError || !shapeData || isPendingS || errorS || !segment) return;
    const layout = {
        'line-cap': 'round',
        'line-join': 'round'
    };
    const paint = {
        'line-color': '#0000ff',
        'line-width': 4
    };
    /** Kształt trasy kursu */ Layers.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67986de690c27df1$export$c556dc2545483cc5), {
                id: 'S' + GTrip.trip_id,
                type: "geojson",
                data: {
                    "type": "FeatureCollection",
                    "features": [
                        {
                            "type": "Feature",
                            "geometry": {
                                "coordinates": [
                                    ...shapeData
                                ],
                                "type": "LineString"
                            }
                        }
                    ]
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67986de690c27df1$export$436487146afe7e99), {
                source: 'S' + GTrip.trip_id,
                id: 'L' + GTrip.trip_id,
                type: "line",
                paint: paint,
                layout: layout
            })
        ]
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: Layers
    });
}


const $fa1399b433f3055b$var$pks = [
    17.01604634508332,
    54.46720643235502
];
function $fa1399b433f3055b$export$f547c1931fab9b61() {
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    const toolDispatch = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$6bbcf3368996eea5));
    const handleOverlay = (0, $acw62.useContext)((0, $bdccf6b6a87b04cc$export$a2200b96afd16271));
    const [selectedLocation, setSelectedLocation] = (0, $acw62.useState)(null);
    const [visibleDialog, setVisibleDialog] = (0, $acw62.useState)(false);
    const map = (0, $67986de690c27df1$export$86f8f9f08863e403)("map-ml");
    const cm = (0, $acw62.useRef)(null);
    let Layers = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    /** HANDLES */ const handlePopupClose = ()=>{
        toolDispatch({
            type: 'changed',
            newTool: {
                ...tool,
                propertyEditor: {
                    ...tool.propertyEditor,
                    popup: false
                }
            }
        });
        return true;
    };
    /** CONTEXT MENU */ const cmItems = [
        {
            label: "Utw\xf3rz przystanek tutaj",
            icon: 'fa-solid fa-location-dot',
            command: ()=>{
                setVisibleDialog('newStopDialog');
            }
        },
        {
            label: 'Skopiuj koordynaty',
            icon: 'fa-solid fa-copy',
            command: async ()=>{
                const locationStr = selectedLocation.lat + ',' + selectedLocation.lng;
                try {
                    await navigator.clipboard.writeText(locationStr);
                    handleOverlay('toast', {
                        severity: "success",
                        summary: 'Pozycja skopiowana do schowka',
                        detail: locationStr
                    });
                } catch (error) {
                    handleOverlay('toast', {
                        severity: "error",
                        summary: "Kopiowanie nie uda\u0142o si\u0119",
                        detail: "Mo\u017Cesz spr\xf3bowa\u0107 skopiowa\u0107 pozycj\u0119 z tego okienka: \r\n " + locationStr + ".\r\n Szczeg\xf3\u0142y b\u0142\u0119du: " + error.message
                    });
                }
            }
        }
    ];
    /** ROUTING */ switch(tool.name){
        case 'stopsTool':
            Layers = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $638a8eb8537cf0f0$export$bd9fef6bf65b4fa8), {}),
                    tool.propertyEditor && tool.propertyEditor.popup && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4019cf171336383e$export$386a01e96d121c2e), {
                        GStop: tool.propertyEditor.edit,
                        onClose: handlePopupClose
                    })
                ]
            });
            break;
        case 'routesTool':
            if (tool.propertyEditor) Layers = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7dfd7970afb7f4dc$export$754cbeee87f4dd3e), {});
            break;
        case 'tripsTool':
            if (tool.propertyEditor) Layers = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bf6b2ce76be191ca$export$5308d098215f8506), {});
            break;
        case 'segmentsTool':
            Layers = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $638a8eb8537cf0f0$export$bd9fef6bf65b4fa8), {}),
                    tool.selection && tool.selection.from_stop_id && tool.selection.to_stop_id && tool.selection.route_type && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5058179988c5c989$export$521056d844d0f9a6), {})
                ]
            });
            break;
    }
    /** RENDER */ return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67986de690c27df1$export$454d0ddbc3d07eed), {
                id: "map-ml",
                minZoom: 6,
                initialCenter: $fa1399b433f3055b$var$pks,
                initialZoom: 17,
                mapStyle: "https://openmaptiles.geo.data.gouv.fr/styles/osm-bright/style.json",
                style: {
                    'minHeight': '85vh'
                },
                initialClickTolerance: 10,
                onContextMenu: (e)=>{
                    console.log('meni', e);
                    if (cm.current) {
                        setSelectedLocation(e.lngLat);
                        cm.current.show(e.originalEvent);
                    }
                },
                children: Layers
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dde48341f3da2113$export$8dc6765e8be191c7), {
                popup: true,
                model: cmItems,
                ref: cm
            }),
            selectedLocation && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $101f013d0aabd6e9$export$3573dc1501de3aa4), {
                stopLocation: selectedLocation,
                visible: visibleDialog === 'newStopDialog',
                onHide: ()=>{
                    setVisibleDialog(false);
                }
            })
        ]
    });
}


function $b72223038ebae7ed$export$1374f173322d64ce() {
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    if (tool.name === 'calendarsTool') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91e8377ddaeba4a0$export$5ac8b2b9eee83afb), {
        GCalendar: tool.propertyEditor
    });
    if (tool.name === 'timetablesTool') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8accedb7060b53f0$export$aa396007db7811e2), {
        routeId: tool.selection
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa1399b433f3055b$export$f547c1931fab9b61), {});
//return ( <MapOl/> );
//return ( <Map/> );
}



var $acw62 = parcelRequire("acw62");

function $4c8cda5d2c6d1d8b$export$86fbec116b87613f() {
    const value = {
        zIndex: {
            modal: 99100,
            overlay: 99000,
            menu: 99000,
            tooltip: 99100,
            toast: 99200 // toast
        },
        autoZIndex: true
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aeeeb04cd6721116$export$45604f0cc8ae667b), {
        client: (0, $4529664c1ee19d35$export$7c07b633a151f9c5),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51b25b42ecc1a0c7$export$6a5b5c2279ff1e8d), {
            value: value,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67986de690c27df1$export$7ee6502f18337a70), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d6297100045faa6$export$989d97b9739a56cc), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91fa2a3eb54dc801$export$dc6be6741310efa6), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bdccf6b6a87b04cc$export$bf688221f59024e5), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4c8cda5d2c6d1d8b$var$MainWindow, {})
                        })
                    })
                })
            })
        })
    });
}
function $4c8cda5d2c6d1d8b$var$MainWindow() {
    const tool = (0, $acw62.useContext)((0, $91fa2a3eb54dc801$export$fbffe46385bd9449));
    if (tool.name === 'timetablesTool') // wyjątkowy (uproszczony) układ okna głównego dla edytora liniówek
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e094d53bc8e9d6c2$export$f7e5e5a2fbd99270), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b72223038ebae7ed$export$1374f173322d64ce), {})
        ]
    });
    //normalne okno
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e094d53bc8e9d6c2$export$f7e5e5a2fbd99270), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2a0f230a4a316e4c$export$980082fdfafd21f8), {
                style: {
                    height: '100%'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a0f230a4a316e4c$export$ac6f1a226cadaf83), {
                        size: 25,
                        minSize: 10,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f41078fe3814b564$export$1ba59dacbcbf90fe), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a0f230a4a316e4c$export$ac6f1a226cadaf83), {
                        size: 75,
                        className: "align-items-center justify-content-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b72223038ebae7ed$export$1374f173322d64ce), {})
                    })
                ]
            })
        ]
    });
}


const $35da740d59af89ba$var$container = document.getElementById("app");
const $35da740d59af89ba$var$root = (0, $7e96a608cb33bf79$exports.createRoot)($35da740d59af89ba$var$container);
$35da740d59af89ba$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c8cda5d2c6d1d8b$export$86fbec116b87613f), {}));


//# sourceMappingURL=index.50fe9fe6.js.map
